'use strict';

/* App Module */

angular.module('swanywhere', [
  'ui.router',
  'pascalprecht.translate',
  'ui.bootstrap',
  'ngCookies',
  'angularSpectrumColorpicker',
  'uiSwitch',
  'angularSpinner',
  'toastr',
  'ngSanitize',
  'ngProgressLite',
  'ui.sortable',
  'stackables',
  'blockUI',
  'rzModule',
  'ngScrollbars',
  'noCAPTCHA',
  'ngDragDrop',
  'contenteditable',
  'ngPassword',
  'ngTagsInput',
  'credit-cards',
  'swa.multirange',
  'swanywhere',
  'nya.bootstrap.select',
  'slickCarousel',
  'images-resizer',
  'ngStorage'
]);

function baseFunction($rootScope, $state, $stateParams, $templateCache, $document) {

  // Prevent backspace from navigating back
  $document.on('keydown', function (event) {
    if (event.which === 8) {
      if ((event.target.nodeName !== 'INPUT') && (event.target.nodeName !== 'TEXTAREA') && !event.target.isContentEditable) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
  });

  $templateCache.put('directives/toast/toast.html',
    '<div class="{{toastClass}} {{toastType}}-container" ng-click="tapToast()">' +
    '<div class="swa-toast-colorbar {{toastType}}"></div>' +
    '<div ng-switch on="allowHtml">' +
    '<div ng-switch-default ng-if="title" class="{{titleClass}}">{{title}}</div>' +
    '<div ng-switch-default class="{{messageClass}}">{{message}}</div>' +
    '<div ng-switch-when="true" ng-if="title" class="{{titleClass}}" ng-bind-html="title"></div>' +
    '<div ng-switch-when="true" class="{{messageClass}}" ng-bind-html="message"></div>' +
    '</div>' +
    '<progress-bar ng-if="progressBar"></progress-bar>' +
    '</div>'
  );

  // It's very handy to add references to $state and $stateParams to the $rootScope
  // so that you can access them from any scope within your applications.For example,
  // <li ng-class="{ active: $state.includes('contacts.list') }"> will set the <li>
  // to active whenever 'contacts.list' or one of its decendents is active.
  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;
}

angular.module('swanywhere').run(['$rootScope', '$state', '$stateParams', '$templateCache', '$document', baseFunction]);

(function () {
  'use strict';

  angular.module('swanywhere').controller('TransferOwnershipPromptController', TransferOwnershipPromptController);

  TransferOwnershipPromptController.$inject = [
    '$uibModalInstance',
    '$timeout',
    'toastr',
    '$translate',
    'DbProductions',
    'transferParams',
  ];

  function TransferOwnershipPromptController($uibModalInstance, $timeout, toastr, $translate, DbProductions, transferParams) {
    var vm = this;

    vm.emailValidated = false;

    vm.transferParams = transferParams;

    vm.transferAction = transferAction;
    vm.cancelAction = cancelAction;
    vm.$onInit = onInit;

    function onInit() {
      if (angular.isUndefined(vm.transferParams.newOwnerEmail)) {
        $timeout(function() {
          angular.element('input#newOwnerEmail').focus();
        }, 500);
      } else {
        vm.emailValidated = true;
      }
    }

    function validateParameters() {
      if (vm.transferOwnershipForm.newOwnerEmail.$error.required) {
        var validationErrorMessage = '<ul>';
        validationErrorMessage = validationErrorMessage + '<li>' + $translate.instant('validationmessages.New owners\'s email address is required') + '</li>';
        validationErrorMessage = validationErrorMessage + '</ul>';

        toastr.warning(
          validationErrorMessage,
          $translate.instant('errormessages.Error transferring ownership!'),
          {allowHtml: true}
        );

        return false;
      }

      return true;
    }

    function transferAction() {
      if (!validateParameters()) {
        return;
      }

      var dbProductions = new DbProductions();

      dbProductions.transferOwnership(vm.transferParams).then(
        function () {
          if (vm.transferParams.addMeAsACollaborator) {
            toastr.success(
              $translate.instant('messages.You have been added as a collaborator'),
              $translate.instant('messages.Production Ownership Transferred!')
            )
          } else {
            toastr.success(
              $translate.instant('messages.Production Ownership Transferred!')
            )            
          }
          $uibModalInstance.close();
        }
      ).catch(
        function (error) {
          handleTransferError(error);
        }
      ).finally(
        function () {
        }
      );
    }

    function handleTransferError(error) {
      var validationErrorMessage = '<ul>';

      if (error.errorType === 'Meteor.Error') {
        validationErrorMessage = validationErrorMessage + '<li>' + error.reason + '</li>';  
        if (error.error === 'user-not-found') {
          validationErrorMessage = validationErrorMessage + '<li>' + $translate.instant('validationmessages.Please check the new owner\'s email address') + '</li>';
        }
      } else {
        validationErrorMessage = validationErrorMessage + '<li>' + error.message + '</li>';
      }

      validationErrorMessage = validationErrorMessage + '</ul>';

      toastr.warning(
        validationErrorMessage,
        $translate.instant('errormessages.Error transferring ownership!'),
        {allowHtml: true}
      );

      $timeout(function() {
        angular.element('input#newOwnerEmail').focus();
      }, 500);
    }

    function cancelAction() {
      $uibModalInstance.dismiss();
    }
  }
}());
(function () {
  'use strict';

  angular.module('swanywhere').controller('StopCollaborationPromptController', StopCollaborationPromptController);

  StopCollaborationPromptController.$inject = [
    '$uibModalInstance',
    'isMasterCollaborator'
  ];

  function StopCollaborationPromptController($uibModalInstance, isMasterCollaborator) {
    var vm = this;

    vm.isMasterCollaborator = isMasterCollaborator;
    
    vm.confirmAction = confirmAction;
    vm.cancelAction = cancelAction;

    function confirmAction() {
      $uibModalInstance.close();
    }

    function cancelAction() {
      $uibModalInstance.dismiss('cancel');
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('StopCollaboratingPromptController', StopCollaboratingPromptController);

  StopCollaboratingPromptController.$inject = [
    '$uibModalInstance',
    'isMasterCollaborator'
  ];

  function StopCollaboratingPromptController($uibModalInstance, isMasterCollaborator) {
    var vm = this;

    vm.isMasterCollaborator = isMasterCollaborator;
    
    vm.confirmAction = confirmAction;
    vm.cancelAction = cancelAction;

    function confirmAction() {
      $uibModalInstance.close();
    }

    function cancelAction() {
      $uibModalInstance.dismiss('cancel');
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('SetMeasurementPromptController', SetMeasurementPromptController);

  SetMeasurementPromptController.$inject = [
    '$scope',
    '$uibModalInstance',
    '$timeout',
    '$window',
    '$log',
    '$document',
    '$translate',
    'setPiece',
    'swaUtils'];

  function SetMeasurementPromptController($scope, $uibModalInstance, $timeout, $window, $log, $document, $translate, setPiece, swaUtils) {
    var vm = this;
    vm.setPiece = setPiece;
    vm.confirmAction = confirmAction;
    vm.cancelAction = cancelAction;

    vm.onMouseDown = onMouseDown;
    vm.onMouseMove = onMouseMove;
    vm.onMouseUp = onMouseUp;
    vm.calculate = calculate;
    vm.scrollZoom = scrollZoom;
    vm.resetMeasurement = resetMeasurement;

    vm.onblurCalculateWH = onblurCalculateWH;

    /** @type HTMLCanvasElement */
    var drawingCanvas = {};
    /** @type CanvasRenderingContext2D */
    var drawingContext = {};
    vm.img = {};
    vm.imgWrapper = {};
    vm.measurements = { width: 0, depth: 0 };
    vm.measurementsWithUnit = {
      width: '0\'\ 0"',
      depth: '0\'\ 0"'
    };
    vm.refMeasurementInput = false;
    vm.refMeasurement = 0;
    vm.refMeasurementUnit = { feet: 0, inch: 0 };

    vm.size = { w: 0, h: 0 };
    vm.pos = { x: 0, y: 0 };
    vm.scale = 1;
    vm.factor = 0.1;

    /** Image pan mode data */
    var panMode = {
      /** Is panning active */
      active: false,
      /** Original image offset */
      originalOffset: { x: 0, y: 0 },
      /** Start offset */
      startOffset: { x: 0, y: 0 },
      /** pan delta */
      delta: { x: 0, y: 0 },
      /** Pan limits */
      limits: { minmaxZoomPanX: 0, minmaxZoomPanY: 0 }
    };

    /** Reference measurement data */
    var refMeasurementData = {
      /** Line in image coordinates */
      imageLine: {
        pt1: { x: 0, y: 0 },
        pt2: { x: 0, y: 0 },
      },
      /** line in canvas coordinates */
      canvasLine: {
        pt1: { x: 0, y: 0 },
        pt2: { x: 0, y: 0 }
      },
      /** is reference data valid */
      valid: false,
      /** Gets the line length from image coordinates */
      imageReferenceLength: function () {
        // eslint-disable-next-line angular/controller-as-vm
        return Math.sqrt(Math.pow(this.imageLine.pt1.x - this.imageLine.pt2.x, 2) + Math.pow(this.imageLine.pt1.y - this.imageLine.pt2.y, 2));
      }
    }

    var baseLineWidth = 2.0;
    var minLineLength = 24;

    /** live line data */
    var liveLineData = {
      /** actively drawing line? */
      active: false,
      /** first point */
      pt1: { x: 0, y: 0 },
      /** last point */
      pt2: { x: 0, y: 0 },
      /** is line (length) valid */
      valid: false,
      /** line length */
      lineLength: 0,
      /** Calculates and updates line length and valid state */
      updateLength: function () {
        // eslint-disable-next-line angular/controller-as-vm
        this.lineLength = Math.sqrt(Math.pow(this.pt1.x - this.pt2.x, 2) + Math.pow(this.pt1.y - this.pt2.y, 2));
        // eslint-disable-next-line angular/controller-as-vm
        this.valid = this.lineLength >= minLineLength;
      }
    };

    $timeout(function () {
      vm.measurementunitname = (vm.setPiece.measurementunit === SWStage.MeasurementUnitType.Feet) ? $translate.instant('labels.Feet') : $translate.instant('labels.Meters');
      vm.measurementunitabbr = (vm.setPiece.measurementunit === SWStage.MeasurementUnitType.Feet) ? $translate.instant('labels.Feet-abbreviation') : $translate.instant('labels.Meters');
      initialize();
      registerMouseUpHandler();
    }, 0);

    // Initialize
    function initialize() {
      vm.target = $document[0].getElementById('slide');
      drawingCanvas = $document[0].getElementById('canvas');
      vm.inputBox = $document[0].getElementById('ref-measurement-wrapper');
      drawingContext = drawingCanvas.getContext('2d');
      setInitialValuesBasedOnUnit();
      canvasResize();
    }

    function setInitialValuesBasedOnUnit() {
      vm.measurementsWithUnit.width = (vm.setPiece.measurementunit === SWStage.MeasurementUnitType.Feet) ? '0\'\ 0"' : '0 ' + $translate.instant('labels.Meters-abbreviation');
      vm.measurementsWithUnit.depth = (vm.setPiece.measurementunit === SWStage.MeasurementUnitType.Feet) ? '0\'\ 0"' : '0 ' + $translate.instant('labels.Meters-abbreviation');
    }

    // Confirmation modal action
    function confirmAction() {
      $uibModalInstance.close(vm.measurements);
    }

    // Cancel modal action
    function cancelAction() {
      $uibModalInstance.dismiss('cancel');
    }

    /**
     * mouse down event handler
     * @param {MouseEvent} e
     */
    function onMouseDown(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.button === 0) {
        if (e.shiftKey) {
          panMode.active = true;
          panMode.startOffset.x = e.offsetX;
          panMode.startOffset.y = e.offsetY;
          panMode.originalOffset.x = vm.pos.x;
          panMode.originalOffset.y = vm.pos.y;
        } else if (!refMeasurementData.valid) {
          liveLineData.pt1.x = e.offsetX;
          liveLineData.pt1.y = e.offsetY;
          liveLineData.pt2.x = e.offsetX;
          liveLineData.pt2.y = e.offsetY;
          liveLineData.active = true;
          liveLineData.valid = false;
        }
      }
    }

    /**
     * mouse move event handler
     * @param {MouseEvent} e
     */
    function onMouseMove(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.button === 0) {
        if (panMode.active) {
          panMode.delta.x = (panMode.startOffset.x - e.offsetX);
          panMode.delta.y = (panMode.startOffset.y - e.offsetY);
          updateForPan();
        } else if (liveLineData.active) {
          liveLineData.pt2.x = e.offsetX;
          liveLineData.pt2.y = e.offsetY;
          liveLineData.updateLength();
          updateCanvasDrawing();
        }
      } else {
        panMode.active = false;
        liveLineData.active = false;
      }
    }

    /**
     * mouse up event handler
     * @param {MouseEvent} e
     */
    function onMouseUp(e) {
      if (panMode.active) {
        panMode.active = false;
        updateForPan();
      } else if (liveLineData.active) {
        liveLineData.active = false;
        updateReferenceFromLive();
        updateCanvasDrawing();
      }
    }

    function updateReferenceFromLive() {
      if (liveLineData.valid) {
        refMeasurementData.canvasLine.pt1.x = liveLineData.pt1.x;
        refMeasurementData.canvasLine.pt1.y = liveLineData.pt1.y;
        refMeasurementData.canvasLine.pt2.x = liveLineData.pt2.x;
        refMeasurementData.canvasLine.pt2.y = liveLineData.pt2.y;
        refMeasurementData.valid = true;

        updateReferenceImageLineFromCanvas();

        vm.refMeasurementInput = true;
        vm.refMeasurement = 0;
        vm.refMeasurementUnit = { feet: 0, inch: 0 };

        $timeout(function () {
          $document[0].getElementById('refMeasurement').focus();
        }, 10);
      }
    }

    function updateReferenceImageLineFromCanvas() {
      refMeasurementData.imageLine.pt1.x = refMeasurementData.canvasLine.pt1.x - vm.pos.x;
      refMeasurementData.imageLine.pt1.y = refMeasurementData.canvasLine.pt1.y - vm.pos.y;

      refMeasurementData.imageLine.pt2.x = refMeasurementData.canvasLine.pt2.x - vm.pos.x;
      refMeasurementData.imageLine.pt2.y = refMeasurementData.canvasLine.pt2.y - vm.pos.y;
    }

    function updateReferenceCanvasLineFromImage() {
      refMeasurementData.canvasLine.pt1.x = (refMeasurementData.imageLine.pt1.x + vm.pos.x);
      refMeasurementData.canvasLine.pt1.y = (refMeasurementData.imageLine.pt1.y + vm.pos.y);

      refMeasurementData.canvasLine.pt2.x = (refMeasurementData.imageLine.pt2.x + vm.pos.x);
      refMeasurementData.canvasLine.pt2.y = (refMeasurementData.imageLine.pt2.y + vm.pos.y);

      updateCanvasDrawing();
    }

    function updateCanvasDrawing() {
      // Clear before updating
      drawingContext.clearRect(0, 0, drawingCanvas.width, drawingCanvas.height);

      // Do we have a reference line to draw?
      if (refMeasurementData.valid) {
        drawLine(refMeasurementData.canvasLine.pt1, refMeasurementData.canvasLine.pt2, true);
      }

      // Do we have an active line to draw?
      if (liveLineData.active) {
        drawLine(liveLineData.pt1, liveLineData.pt2, liveLineData.valid);
      }
    }

    /**
     * Draws a line with perpendicular end lines
     * @param {point} pt1 first point
     * @param {point} pt2 second point
     * @param {boolean} valid is line valid
     */
    function drawLine(pt1, pt2, valid) {
      var strokeWidth = lineStrokeWidth();
      drawingContext.beginPath();
      drawingContext.moveTo(pt1.x, pt1.y);
      drawingContext.lineTo(pt2.x, pt2.y);
      drawEndLines(pt1, pt2, strokeWidth * 2);

      drawingContext.strokeStyle = 'white';
      drawingContext.lineWidth = strokeWidth * 1.5;
      drawingContext.lineJoin = drawingContext.lineCap = 'square';
      drawingContext.shadowColor = 'white';
      drawingContext.shadowBlur = strokeWidth * 4;
      drawingContext.stroke();

      drawingContext.beginPath();
      drawingContext.moveTo(pt1.x, pt1.y);
      drawingContext.lineTo(pt2.x, pt2.y);
      drawEndLines(pt1, pt2, strokeWidth * 2);

      drawingContext.strokeStyle = 'red';
      drawingContext.lineWidth = strokeWidth;
      drawingContext.shadowColor = 'transparent';
      drawingContext.stroke();
    }

    function lineStrokeWidth() {
      var w = baseLineWidth * Math.log(vm.scale * vm.scale);
      return Math.max(baseLineWidth, w);
    }

    // Calculate image height and width
    function calculate() {
      if (vm.setPiece.measurementunit === 0) {
        if ((vm.refMeasurementUnit.feet > 0 || vm.refMeasurementUnit.inch > 0) && refMeasurementData.valid) {
          var imageReferenceLength = refMeasurementData.imageReferenceLength();
          vm.measurements.width = ((vm.img.width / imageReferenceLength) * vm.scale * vm.refMeasurement);
          vm.measurements.depth = ((vm.img.height / imageReferenceLength) * vm.scale * vm.refMeasurement);
        } else {
          vm.measurements.width = 0;
          vm.measurements.depth = 0;
        }
        vm.measurementsWithUnit.width = swaUtils.feetAndInchesText(vm.measurements.width);
        vm.measurementsWithUnit.depth = swaUtils.feetAndInchesText(vm.measurements.depth);
      } else {
        if (vm.refMeasurement > 0 && refMeasurementData.valid) {
          var imageReferenceLength = refMeasurementData.imageReferenceLength();
          vm.measurements.width = (+((vm.img.width / imageReferenceLength) * vm.scale * vm.refMeasurement).toFixed(2));
          vm.measurements.depth = (+((vm.img.height / imageReferenceLength) * vm.scale * vm.refMeasurement).toFixed(2));
        } else {
          vm.measurements.width = 0;
          vm.measurements.depth = 0;
        }
        vm.measurementsWithUnit.width = vm.measurements.width + ' ' + $translate.instant('labels.Meters-abbreviation');
        vm.measurementsWithUnit.depth = vm.measurements.depth + ' ' + $translate.instant('labels.Meters-abbreviation');
      }
    }

    // resize canvas
    function canvasResize() {
      $timeout(function () {
        vm.imgWrapper = $document[0].getElementById('image-wrapper');
        drawingCanvas.width = vm.imgWrapper.clientWidth;
        drawingCanvas.height = vm.imgWrapper.clientHeight;
        vm.img = $document[0].getElementById('image');
        var image = new Image();
        image.src = vm.img.src;
        image.onload = function () {
          var hRatio = drawingCanvas.width / image.width;
          var vRatio = drawingCanvas.height / image.height;
          var ratio = Math.min(hRatio, vRatio);

          // Scale image to fit in canvas
          vm.img.width = image.width * ratio;
          vm.img.height = image.height * ratio;
          vm.size = { w: vm.img.clientWidth, h: vm.img.clientHeight };
        };
      }, 10);
    }

    function onblurCalculateWH() {
      if (vm.setPiece.measurementunit === 0) {
        vm.refMeasurement = swaUtils.getFinalValueInFeet(vm.refMeasurementUnit);
        vm.refMeasurementUnit = swaUtils.getFeetAndInches(vm.refMeasurement);
      }

      calculate();
    }

    // function scrollZoom(e) {
    function scrollZoom(anchor, delta) {
      var zoomPointX = anchor.offsetX;
      var zoomPointY = anchor.offsetY;

      // determine the point on where the slide is zoomed in
      var zoomTargetX = (zoomPointX - vm.pos.x) / vm.scale
      var zoomTargetY = (zoomPointY - vm.pos.y) / vm.scale

      // apply zoom
      var oldScale = vm.scale;
      vm.scale += delta * vm.factor;// * vm.scale
      vm.scale = vm.scale < 1 ? 1 : vm.scale;

      // calculate x and y based on zoom
      vm.pos.x = -zoomTargetX * vm.scale + zoomPointX
      vm.pos.y = -zoomTargetY * vm.scale + zoomPointY

      // Make sure the slide stays in its container area when zooming out
      if (vm.pos.x > 0) {
        vm.pos.x = 0
      }
      if (vm.pos.x + vm.size.w * vm.scale < vm.size.w) {
        vm.pos.x = -vm.size.w * (vm.scale - 1)
      }
      if (vm.pos.y > 0) {
        vm.pos.y = 0
      }
      if (vm.pos.y + vm.size.h * vm.scale < vm.size.h) {
        vm.pos.y = -vm.size.h * (vm.scale - 1)
      }

      // update pan limits
      panMode.limits.minmaxZoomPanX = (vm.scale > 1) ? ((vm.target.clientWidth * vm.scale) - ((vm.target.clientWidth * vm.scale) / vm.scale)) * -1 : 0;
      panMode.limits.minmaxZoomPanY = (vm.scale > 1) ? ((vm.target.clientHeight * vm.scale) - ((vm.target.clientHeight * vm.scale) / vm.scale)) * -1 : 0;

      vm.target.style.transform = 'translate(' + (vm.pos.x) + 'px,' + (vm.pos.y) + 'px) scale(' + vm.scale + ',' + vm.scale + ')';

      refMeasurementData.imageLine.pt1.x = refMeasurementData.imageLine.pt1.x / oldScale * vm.scale;
      refMeasurementData.imageLine.pt1.y = refMeasurementData.imageLine.pt1.y / oldScale * vm.scale;
      refMeasurementData.imageLine.pt2.x = refMeasurementData.imageLine.pt2.x / oldScale * vm.scale;
      refMeasurementData.imageLine.pt2.y = refMeasurementData.imageLine.pt2.y / oldScale * vm.scale;

      updateReferenceCanvasLineFromImage();
    }

    function updateForPan() {
      vm.pos.x = panMode.originalOffset.x - panMode.delta.x;
      vm.pos.y = panMode.originalOffset.y - panMode.delta.y;

      vm.pos.x = Math.min(0, Math.max(vm.pos.x, panMode.limits.minmaxZoomPanX));
      vm.pos.y = Math.min(0, Math.max(vm.pos.y, panMode.limits.minmaxZoomPanY));

      vm.target.style.transform = 'translate(' + (vm.pos.x) + 'px,' + (vm.pos.y) + 'px) scale(' + vm.scale + ',' + vm.scale + ')';

      updateReferenceCanvasLineFromImage();
    }

    function getSlope(pointA, pointB) {
      return (pointB.y - pointA.y) / (pointB.x - pointA.x);
    }

    function getPerpSlope(slope) {
      return -1 / slope;
    }

    function findPointOnLine(startPoint, slope, distance) {
      var newPoint = {};
      if (slope === 0) {
        newPoint.x = startPoint.x + distance;
        newPoint.y = startPoint.y;
      } else if (slope === Infinity || slope === -Infinity) {
        newPoint.x = startPoint.x;
        newPoint.y = startPoint.y + distance;
      } else {
        var dx = (distance / Math.sqrt(1 + (slope * slope)));
        var dy = slope * dx;
        newPoint.x = startPoint.x + dx;
        newPoint.y = startPoint.y + dy;
      }
      return newPoint;
    }

    /**
     * Draws perpendicular end lines of the given length.
     * @param {point} pt1 first point
     * @param {point} pt2 second point
     * @param {number} length length of side lines
     */
    function drawEndLines(pt1, pt2, length) {
      var slope = getSlope(pt1, pt2);
      var perpSlope = getPerpSlope(slope);

      var perpPointOne = findPointOnLine(pt1, perpSlope, length);
      var perpPointTwo = findPointOnLine(pt1, perpSlope, -length);

      drawingContext.moveTo(perpPointOne.x, perpPointOne.y);
      drawingContext.lineTo(perpPointTwo.x, perpPointTwo.y);

      perpPointOne = findPointOnLine(pt2, perpSlope, length);
      perpPointTwo = findPointOnLine(pt2, perpSlope, -length);

      drawingContext.moveTo(perpPointOne.x, perpPointOne.y);
      drawingContext.lineTo(perpPointTwo.x, perpPointTwo.y);
    }

    function registerMouseUpHandler() {
      $log.debug('setMeasurementPrompController: registerMouseUpHandler:');
      $window.addEventListener('mouseup', onMouseUp);
    }

    function resetMeasurement() {
      refMeasurementData.valid = false;
      vm.refMeasurement = 0;
      vm.refMeasurementInput = false;
      calculate();
      updateCanvasDrawing();
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('ExistingCollaboratorsIgnorePromptController', ExistingCollaboratorsIgnorePromptController);

  ExistingCollaboratorsIgnorePromptController.$inject = ['$uibModalInstance', 'existingEmails'];

  function ExistingCollaboratorsIgnorePromptController($uibModalInstance, existingEmails) {
    var vm = this;
    vm.existingEmails = existingEmails;

    vm.confirmAction = confirmAction;
    vm.cancelAction = cancelAction;

    function confirmAction() {
      $uibModalInstance.close();
    }

    function cancelAction() {
      $uibModalInstance.dismiss('cancel');
    }
  }
}());

(function() {
  'use strict';

  angular.module('swanywhere').factory('DbUtility', DbUtilityFactory);

  DbUtilityFactory.$inject = [
    '$q',
    'DbSubMgrService',
  ];

  function DbUtilityFactory($q, DbSubMgrService) {
    function DbUtility() {

      var ceres = DbSubMgrService.getAsteroid();

      this.verifyCaptcha = function (captchaResponse) {
        return $q.resolve(ceres.call('webapi/captcha/verify', captchaResponse).result);
      };

      this.requestPasswordReset = function(email, urlPrefix) {
        return $q.resolve(ceres.call('webapi/accounts/request/passwordreset', email, urlPrefix).result);
      }

      this.resetPasswordWithToken = function (token, newPassword) {
        return $q.resolve(ceres.call('webapi/accounts/reset/password', token, newPassword).result);
      }
    }

    return DbUtility;
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbUserScripts', DbUserScriptsFactory);

  DbUserScriptsFactory.$inject = [
    '$q',
    '$log',
    'DbSubMgrService',
    'swaUi'
  ];

  function DbUserScriptsFactory($q, $log, DbSubMgrService, swaUi) {

    function DbUserScripts() {
      var ceres = DbSubMgrService.getAsteroid();

      /**
       * Gets personal notes of the logged in use for the specified script page.
       * @param {string} scriptId The id of the script page.
       */
      this.getForScript = function (scriptId) {
        return $q.resolve(ceres.call('webapi/userscripts/get/for/script', scriptId).result);
      }

      /**
       * Updates personal notes of the logged in user for the specified script page.
       *
       * @param {string} productionId The id of the production.
       * @param {string} scriptId The id of the script page.
       * @param {Object} userScriptsData The personal notes on the page. - annotationlayers
       */
      this.update = function (productionId, scriptId, userScriptsData) {
        return $q.resolve(ceres.call('webapi/userscripts/update', productionId, scriptId, userScriptsData).result);
      }

      /**
       * Remove or merge the annotation layers for the calloborator
       * @param {*} scriptId
       * @param {*} productionId
       * @param {*} selectedAnnotationLayer
       * @param {*} mergeToLayerId
       * @returns
       */
      this.removeOrMergeAnnotationLayer = function (scriptId, productionId, selectedAnnotationLayer, mergeToLayerId) {
        return $q.resolve(ceres.call('webapi/scripts/removeormergepersonal/annotation/layer', scriptId, productionId, selectedAnnotationLayer, mergeToLayerId).result);
      }
    }

    return DbUserScripts;
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbUserScriptPages', DbUserScriptPagesFactory);

  DbUserScriptPagesFactory.$inject = [
    '$q',
    '$log',
    'DbSubMgrService',
  ];

  function DbUserScriptPagesFactory($q, $log, DbSubMgrService) {

    function DbUserScriptPages() {
      var ceres = DbSubMgrService.getAsteroid();

      /**
       * Gets personal notes of the logged in use for the specified script page.
       * @param {string} scriptPageId The id of the script page.
       */
      this.getForScriptPage = function (scriptPageId) {
        return $q.resolve(ceres.call('webapi/userscriptpages/get/for/scriptpage', scriptPageId).result);
      }

      /**
       * Updates personal notes of the logged in user for the specified script page.
       *
       * @param {string} productionId The id of the production.
       * @param {string} scriptPageId The id of the script page.
       * @param {Object} personalNotes The personal notes on the page.
       * @param {Object[]} personalNotes.leftAnnotations Personal left annotations.
       * @param {Object[]} personalNotes.rightAnnotations Personal right annotations.
       * @param {Object[]} personalNotes.floatingAnnotations Personal floating annotations.
       */
      this.update = function (productionId, scriptPageId, personalNotes) {
        return $q.resolve(ceres.call('webapi/userscriptpages/update', productionId, scriptPageId, personalNotes).result);
      }

      this.updatePersonalAnnotationPosition = function (scriptPage, finalScaleFactor, oldScaleFactor, appliedLeftmargin, leftSideMargin) {
        return $q.resolve(ceres.call('webapi/userscriptpages/update/personal/annotation/position', scriptPage, finalScaleFactor, oldScaleFactor, appliedLeftmargin, leftSideMargin).result);
      }
    }

    return DbUserScriptPages;
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbUserProductions', DbUserProductionsFactory);

  DbUserProductionsFactory.$inject = [
    '$q',
    '$log',
    'DbSubMgrService',
    'swaUi'
  ];

  function DbUserProductionsFactory($q, $log, DbSubMgrService, swaUi) {

    function DbUserProductions() {
      var ceres = DbSubMgrService.getAsteroid();

      /**
       * Gets the user production for the specified production.
       * @param {string} productionId The id of the production.
       */
      this.findByProductionId = function (productionId) {
        return $q.resolve(ceres.call('webapi/userproductions/find/by/production', productionId).result);
      }

      this.getNewUserProduction = function (productionId, userId, productionType) {
        return {
          _id: productionId + '-' + userId,
          productionId: productionId,
          userId: userId,
          contentDefaults: {
            settingsChartText: angular.copy(swaUi.defaultTextStylePreferences),
            settingsScriptAction: angular.copy(swaUi.defaultTextStylePreferences),
            settingsScriptLq: angular.copy(swaUi.defaultTextStylePreferences),
            settingsScriptText: angular.copy(swaUi.defaultTextStylePreferences),
            colorScriptHighlight: swaUi.defaultScriptHighlightColor
          }
        };
      }

      this.update = function (userProduction) {
        return $q.resolve(ceres.call('webapi/userproductions/update', userProduction).result);
      }
    }

    return DbUserProductions;
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbUserCharts', DbUserChartsFactory);

  DbUserChartsFactory.$inject = [
    '$q',
    '$log',
    'DbSubMgrService',
  ];

  function DbUserChartsFactory($q, $log, DbSubMgrService) {

    function DbUserCharts() {
      var ceres = DbSubMgrService.getAsteroid();

      /**
       * Gets the user chart for the specified chart.
       * @param {string} chartId The id of the chart.
       */
      this.findByChart = function (chartId) {
        return $q.resolve(ceres.call('webapi/usercharts/find/by/chart', chartId).result);
      }

      this.getNewUserChart = function (chartId, userId, productionId) {
        return {
          _id: chartId + '-' + userId,
          chartId: chartId,
          userId: userId,
          productionId: productionId
        };
      }

      this.update = function (userChart) {
        return $q.resolve(ceres.call('webapi/usercharts/update', userChart).result);
      }
    }

    return DbUserCharts;
  }
}());

(function() {
  'use strict';

  angular.module('swanywhere').factory('DbUser', DbUserFactory);

  DbUserFactory.$inject = ['$q', 'DbSubMgrService'];

  function DbUserFactory($q, DbSubMgrService) {
    function DbUser() {

      var ceres = DbSubMgrService.getAsteroid();

      this.getLoggedInUserData = function(bypassCached) {
        var deferred = $q.defer();

        bypassCached = bypassCached || false;
        if (bypassCached) {
          deferred.resolve(DbSubMgrService.getLoggedInUserData());
        } else {
          deferred.resolve(ceres.call('webapi/user/getfields', ['profile', 'activesubscription']).result);
        }

        return deferred.promise;
      };

      // SWA-1948 :  Get User Billing Or Stripe Card Data
      this.getPaymentMethodDetails = function() {
        var deferred = $q.defer();
        ceres.call('webapi/user/getfields', ['stripe']).result.then(function(data) {
          deferred.resolve(data);
        }, function(error) {
          deferred.reject(error);
        });
        return deferred.promise;
      };

      this.updateBillingAndPurchasePlan = function(billingInformation, cardInformation, planId, planMonthly, discountAmount) {
        return $q.resolve(ceres.call('webapi/user/updatebillingandpurchaseplan', billingInformation, cardInformation, planId, planMonthly, discountAmount).result);
      };

      this.getUserSubscriptionHistory = function() {
        var deferred = $q.defer();

        ceres.call('webapi/user/getfields', ['subscriptionhistory']).result.then(function(data) {
          deferred.resolve(data.subscriptionhistory);
        }, function(error) {
          deferred.reject(error);
        });

        return deferred.promise;
      };

      this.updateProfile = function(profileData) {
        return $q.resolve(ceres.call('webapi/user/update/profile', profileData).result);
      };

      this.cancelSubscription = function() {
        return $q.resolve(ceres.call('webapi/user/cancelsubscription').result);
      };

      this.clearUpgradePromptFlag = function(userId) {
        return $q.resolve(ceres.call('webapi/user/update/flags/upgradeprompt', false).result);
      }

      this.checkCanPay = function() {
        return $q.resolve(ceres.call('webapi/user/canpay').result);
      }

      this.purchaseSubscription = function(planId, monthly, discountAmount) {
        return $q.resolve(ceres.call('webapi/user/purchasesubscription', planId, monthly, discountAmount).result);
      }

      this.existsWithEmail = function(email) {
        return $q.resolve(ceres.call('webapi/users/check/exists/by/email', email).result);
      }

      this.createUser = function(email, password, profile) {
        return $q.resolve(ceres.createUser(email, password, profile).result);
      }

      this.updatePassword = function(oldPassword, newPassword) {
        return $q.resolve(ceres.call('webapi/user/update/password', oldPassword, newPassword).result);
      }

      /**
       * Gets display name for a user, searching by his ID or email.
       */
      this.getDisplayName = function(idOrEmail) {
        var deferred = $q.defer();

        ceres.call('webapi/users/get/displayname', idOrEmail).result.then(
          function(displayName) {
            if (angular.isDefined(displayName)) {
              deferred.resolve(displayName)
            } else {
              deferred.reject(new Error('user-not-found'));
            }
          }
        ).catch(
          function(error) {
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      /**
       * Gets display name for a user, searching by his ID or email.
       */
      this.getEmailAndDisplayName = function(idOrEmail) {
        var deferred = $q.defer();

        ceres.call('webapi/users/get/email/and/displayname', idOrEmail).result.then(
          function(displayName) {
            if (angular.isDefined(displayName)) {
              deferred.resolve(displayName)
            } else {
              deferred.reject(new Error('user-not-found'));
            }
          }
        ).catch(
          function(error) {
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      this.updateFavoriteProductionsPreference = function(favoriteProductions) {
        return $q.resolve(ceres.call('webapi/user/update/preferences/favoriteproductions', favoriteProductions).result);
      };

      this.updateWebPreference = function(key, value) {
        return $q.resolve(ceres.call('webapi/user/update/preferences/web', key, value).result);
      };

      this.updatePreference = function(key, value) {
        return $q.resolve(ceres.call('webapi/user/update/preferences', key, value).result);
      };

      this.updateEmail = function (newEmail) {
        return $q.resolve(ceres.call('webapi/user/update/email', newEmail).result);
      }

      this.enterpriseFindById = function (accountId) {
        return $q.resolve(ceres.call('webapi/enterprise/find/by/id', accountId).result);
      }

      this.getProratedDiscountDetails = function () {
        return $q.resolve(ceres.call('webapi/user/get/prorated/discount/details').result);
      }

      this.leaveEnterprise = function () {
        return $q.resolve(ceres.call('webapi/user/leave/enterprise').result);
      }

      // SWA-1948 :
      this.cancelCheckoutSession = function(checkoutSessionId) {
        return $q.resolve(ceres.call('webapi/user/cancelCheckoutSession', checkoutSessionId).result);
      };

      // SWA-1993
      this.switchPlanToViewOnly = function() {
        return $q.resolve(ceres.call('webapi/user/switch/to/viewonly').result);
      }

      // webapi/user/get/billing-portal/url
      this.getBillingPortalUrl = function() {
        return $q.resolve(ceres.call('webapi/user/get/billing-portal/url').result);
      }

    }

    return DbUser;
  }
}());

/* global Asteroid, Q */
(function () {
  'use strict';

  // eslint-disable-next-line angular/no-service-method
  angular.module('swanywhere').service('DbSubMgrService', DbSubMgrService);

  DbSubMgrService.$inject = [
    '$rootScope',
    '$q',
    '$log',
    'swaConfig',
    '$interval',
    'swaUtils',
    'swaRouterStateNames',
    '$localStorage',
    'toastr',
    '$translate',
    'SwaRoles'
  ];

  function DbSubMgrService($rootScope, $q, $log, swaConfig, $interval, swaUtils, swaRouterStateNames, $localStorage, toastr, $translate, SwaRoles) {
    patchAsteroid();

    var _ceres;
    if (swaConfig.enableDdpSocketLogging) {
      _ceres = new Asteroid(swaConfig.serverUrl, swaConfig.serverSsl, function (sockMsg) {
        $log.debug(sockMsg.timestamp + ': ' + sockMsg.type + ': ' + sockMsg.message);
      });
    } else {
      _ceres = new Asteroid(swaConfig.serverUrl, swaConfig.serverSsl);
    }

    if ((swaConfig.deploymentConfiguration === 'local') || (swaConfig.deploymentConfiguration === 'localIp')) {
      window._ceres = _ceres; // eslint-disable-line angular/window-service
    }

    // Connection status
    // var connected = false;
    var connected = (angular.isDefined(_ceres.ddp) && (_ceres.ddp.readyState === 1));

    // The logged in user's ID, etc.
    var _loggedInUserId;
    var _loggedInUser;
    var _loggedInUsersPlan;
    var _loggedInUsersEntAcct;

    _ceres.on('connected', function () {
      $log.debug('ceres:event -> connected');
      connected = true;
      updateAppInfo();
    });

    _ceres.on('reconnected', function () {
      $log.debug('ceres:event -> reconnected');
      connected = true;
    });

    _ceres.on('login', function (userId) {
      $log.debug('ceres:event -> login');
      if (_loggedInUserId !== userId) {
        stopAllSubscriptions();
        stopMonitoringLoggedInUser();
        stopMonitoringPdfApprovalRequests();
      }

      _loggedInUserId = userId;
      swaUtils.clarityIdentify(userId);

      startMonitoringLoggedInUser();
      startMonitoringPdfApprovalRequests();
    });

    _ceres.on('loginError', function (error) {
      $log.debug('ceres:event -> loginError: ' + error.reason);
      if (error.errorType === 'Meteor.Error') {
        if (error.reason === 'You\'ve been logged out by the server. Please log in again.') {
          // stopAllSubscriptions();
          // stopMonitoringLoggedInUser();
          // stopMonitoringPdfApprovalRequests();
          // clearUserSession();
          // clearCollections();
          sessionExpiredRedirect('server-logout');
        }
      }
    });

    _ceres.on('logout', function () {
      $log.debug('ceres:event -> logout');
      stopAllSubscriptions();
      stopMonitoringLoggedInUser();
      stopMonitoringPdfApprovalRequests();
      clearUserSession();
      clearCollections();
    });

    _ceres.on('logoutError', function (error) {
      $log.debug('ceres:event -> logoutError: ' + error.reason);
      stopAllSubscriptions();
      stopMonitoringLoggedInUser();
      stopMonitoringPdfApprovalRequests();
      clearUserSession();
      clearCollections();
    });

    _ceres.ddp.on('error', function (data) {
      $log.debug('ceres:ddp:error: ' + data.reason);
      if (data.reason === 'single-session-violation') {
        sessionExpiredRedirect('server-logout');
      }
    });

    var _loggedInUserRq;

    function startMonitoringLoggedInUser() {
      if (angular.isUndefined(_loggedInUserRq)) {
        $log.debug('DbSubMgrService: Will start monitoring for logged in user\'s data');
        var usersSub = _ceres.subscribe('userData');
        usersSub.ready.then(
          function () {
            _loggedInUserRq = _ceres.getCollection('users').reactiveQuery({
              _id: _loggedInUserId,
            });
            _loggedInUserRq.on('change', _loggedInUserRqOnChange);

            _loggedInUserRqOnChange();
          }
        );
      } else {
        $log.debug('DbSubMgrService: Logged in user\'s data already being monitored!');
      }
    }

    function _loggedInUserRqOnChange(id) {
      var changedUser;
      if (angular.isUndefined(id)) {
        changedUser = swaUtils.findInArrayById(_loggedInUserRq.result, _loggedInUserId);
      } else {
        changedUser = swaUtils.findInArrayById(_loggedInUserRq.result, id);
      }

      if (angular.isUndefined(_loggedInUser)) {
        if (angular.isDefined(changedUser)) {
          $log.debug('DbSubMgrService: logged in user\'s data became available');
          _loggedInUser = changedUser;
          _loggedInUsersPlan = undefined;
          _loggedInUsersEntAcct = undefined;
          $rootScope.$broadcast('userDataAvailable', _loggedInUser);
        }
      } else {
        if (angular.isUndefined(changedUser)) {
          $log.debug('DbSubMgrService: Probably logged out, user data was removed');
          _loggedInUser = undefined;
          _loggedInUsersPlan = undefined;
          _loggedInUsersEntAcct = undefined;
        } else {
          if (_loggedInUser._id === changedUser._id) {
            $log.debug('DbSubMgrService: logged in user\'s data has changed');
            _loggedInUser = changedUser;
            _loggedInUsersPlan = undefined;
            _loggedInUsersEntAcct = undefined;
              $rootScope.$broadcast('userDataChanged', _loggedInUser);
          } else {
            $log.warn('DbSubMgrService: got change for a non-logged in user!');
          }
        }
      }
    }

    function stopMonitoringLoggedInUser() {
      if (angular.isDefined(_loggedInUserRq)) {
        _loggedInUserRq.off('change', _loggedInUserRqOnChange);

        _loggedInUserRq = undefined;
      }
    }

    var _pdfApprovalRequests = [];
    var _pdfApprovalRequestsTimer;
    function pdfApprovalRequestsMonitoringTask() {
      _ceres.call('webapi/printjobs/find/pending/approval').result.then(
        function (printJobs) {
          if (printJobs.length === 0) {
            return;
          } else {
            var printJobIds = _.map(printJobs, function (job) { return job._id });
            var newJobIds = _.difference(printJobIds, _pdfApprovalRequests);
            if (newJobIds.length > 0) {
              toastr.info($translate.instant('messages.You have new / pending PDF approval requests'));
            }
            _pdfApprovalRequests = printJobIds;
          }
        }
      ).catch(
        function (error) {
          $log.error('DbSubMgrService.pdfApprovalRequestsMonitoringTask:', error);
        }
      )
    }
    function startMonitoringPdfApprovalRequests() {
      stopMonitoringPdfApprovalRequests();
      pdfApprovalRequestsMonitoringTask();
      _pdfApprovalRequestsTimer = $interval(function () {
        pdfApprovalRequestsMonitoringTask();
      }, 30000);
    }

    function stopMonitoringPdfApprovalRequests() {
      $interval.cancel(_pdfApprovalRequestsTimer);
    }

    function clearUserSession() {
      _loggedInUserId = undefined;
      _loggedInUser = undefined;
      _loggedInUsersPlan = undefined;
      _loggedInUsersEntAcct = undefined;
    }

    function stopAllSubscriptions() {
      stopProductionChildSubscriptions();
      stopUserChildSubscriptions();
    }

    function stopUntrackedSubscriptions() {
      _.each(_ceres.subscriptions, function (subscription) {
        $log.debug('Subscription name: ', subscription._name);
        if (subscription._name.startsWith('Meteor.')) {
          return;
        }
        if (subscription._name === 'userData') {
          return;
        }

        subscription.stop();
      });
    }

    function clearCollections() {
      _.each(_ceres.collections, function (collection) {
        $log.debug('Clearing collection: ', collection);
        collection.clear();
      });
    }

    this.getLoggedInUserId = function () {
      return _loggedInUserId;
    };

    this.isLoggedinUserDataAvailable = function () {
      return (angular.isDefined(_loggedInUser));
    };

    this.onLoggedInUserDataAvailable = function () {
      var deferred = $q.defer();

      var userDataWait = 0;
      if (angular.isDefined(_loggedInUser)) {
        $log.debug('Waiting for logged in user\'s data... already available!');
        deferred.resolve(true);
      } else {
        var iQ1 = $interval(function () {
          $log.debug('Waiting for logged in user\'s data... ' + userDataWait);

          if (angular.isDefined((_loggedInUser)) || (userDataWait > 9)) {
            $interval.cancel(iQ1);

            if (angular.isDefined(_loggedInUser)) {
              $log.debug('Logged in user\'s data... available!');
              deferred.resolve(true);
            } else {
              $log.debug('Logged in user\'s data... timeout waiting for data!');
              deferred.reject(new Error('Timeout getting logged in user\'s data'));
            }
          }

          userDataWait++;

        }, 1000, 0);
      }

      return deferred.promise;
    };

    this.getLoggedInUserData = function () {
      return _loggedInUser;
    };

    this.validateSession = function (redirectIfNone) {
      if (angular.isUndefined(redirectIfNone)) {
        redirectIfNone = true;
      }

      var deferred = $q.defer();

      waitForConnection().then(
        function () {
          return waitForLogin();
        }
      ).then(
        function (value) {
          deferred.resolve(value);
        }
      ).catch(
        function (error) {
          if (error) {
            if (error.reason) {
              $log.debug('validateSession: Error: ' + error.reason);
            } else if (error.message) {
              $log.debug('validateSession: Error: ' + error.message);
            }
          } else {
            $log.debug('validateSession: Error! ');
          }

          if (redirectIfNone) {
            $log.debug('Redirecting to login ...');
            sessionExpiredRedirect();

            deferred.resolve(false);
          } else {
            deferred.reject(error);
          }
        }
      );

      return deferred.promise;
    };

    function sessionExpiredRedirect(redirectreason) {
      redirectreason = redirectreason || 'session-expired';
      if (!swaUtils.isRouterCurrentStateName(swaRouterStateNames.login)) {
        var params = {
          redirectreason: redirectreason,
        };
        swaUtils.stateGoLocationReplace(swaRouterStateNames.login, params);
      }
    }

    this.sessionExpiredRedirect = function () {
      sessionExpiredRedirect();
    };

    this.checkConnection = waitForConnection;

    function waitForConnection() {
      var deferred = $q.defer();

      var connWait = 0;
      if (connected) {
        $log.debug('Waiting for connection... already connected!');
        deferred.resolve(true);
      } else {
        var iQ1 = $interval(function () {
          $log.debug('Waiting for connection... ' + connWait);

          if ((connected) || (connWait > 9)) {
            $interval.cancel(iQ1);

            if (connected) {
              $log.debug('Waiting for connection... connected!');
              deferred.resolve(true);
            } else {
              $log.debug('Waiting for connection... No connection to server!');
              deferred.reject(new Error('No connection to server'));
            }
          }

          connWait++;

        }, 1000, 0);
      }

      return deferred.promise;
    }

    function waitForLogin() {
      $log.debug('waitForLogin(): ceres.userId: ' + _ceres.userId);

      var deferred = $q.defer();

      $log.debug('Waiting for session/login...');
      if (angular.isDefined(_ceres.userId)) {
        $log.debug('Waiting for session/login... already logged in, continuing...');
        deferred.resolve(true);
      } else {
        var loginWait = 0;
        var iQ2 = $interval(function () {
          $log.debug('Waiting for session/login... ' + loginWait);

          if (angular.isUndefined(_ceres.userId)) {
            if (_ceres.resumeLoginPromise.isRejected()) {
              $interval.cancel(iQ2);

              $log.debug('Waiting for session/login... No session to resume!');

              deferred.reject(new Error('Session expired!'));
            }
          } else {
            $log.debug('Waiting for session/login... User logged in, continuing...');

            $interval.cancel(iQ2);

            deferred.resolve(true);
          }

          if (loginWait > 9) {
            $interval.cancel(iQ2);

            if (connected) {
              $log.debug('Waiting for session/login... Timeout waiting for session!');

              deferred.reject(new Error('Timeout waiting for session'));
            } else {
              deferred.reject(new Error('No connection to server!'));
            }
          }

          loginWait++;
        }, 1000, 0);
      }

      return deferred.promise;
    }

    this.validateActivePlan = function () {
      var deferred = $q.defer();

      if (_loggedInUserId) {
        if (angular.isDefined(_loggedInUser)) {
          $log.debug('Waiting for user data ... already available!');
          if (!SwaRoles.checkRole(_loggedInUser.roles, SwaRoles.UserRolesAll)) {
            deferred.reject();
            var params = {
              redirectreason: 'unauthorized',
            };
            swaUtils.stateGoLocationReplace(swaRouterStateNames.login, params);
            return;
          }
          if (_loggedInUser.activesubscription) {
            deferred.resolve(true);
          } else {
            deferred.reject('No active subscription plan');
            swaUtils.stateGoLocationReplace(swaRouterStateNames.subscriptions);
          }
        } else {
          var dataWait = 0;
          var iQ2 = $interval(function () {
            $log.debug('Waiting for user data ... ' + dataWait);

            if (angular.isDefined(_loggedInUser)) {
              $log.debug('Waiting for user data ... got it!');
              $interval.cancel(iQ2);
              if (!SwaRoles.checkRole(_loggedInUser.roles, SwaRoles.UserRolesAll)) {
                deferred.reject();
                var params = {
                  redirectreason: 'unauthorized',
                };
                swaUtils.stateGoLocationReplace(swaRouterStateNames.login, params);
                return;
              }
              if (_loggedInUser.activesubscription) {
                deferred.resolve(true);
              } else {
                deferred.reject('No active subscription plan');
                swaUtils.stateGoLocationReplace(swaRouterStateNames.subscriptions);
              }
            }

            if (dataWait > 9) {
              $interval.cancel(iQ2);
              deferred.reject('Timeout waiting for user data');
              sessionExpiredRedirect();
            }

            dataWait++;
          }, 1000, 0);
        }
      } else {
        deferred.reject('No user logged in');
        sessionExpiredRedirect();
      }

      return deferred.promise;
    };

    this.logout = function () {
      var params = {
        redirectreason: 'logout',
      };

      swaUtils.stateGoLocationReplace(swaRouterStateNames.login, params);
      swaUtils.clarityEvent('logout');
    };

    this.getLoggedInUsersPlan = function () {
      var deferred = $q.defer();
      if (angular.isDefined(_loggedInUser)) {
        if (angular.isDefined(_loggedInUser.activesubscription)) {
          if ((angular.isDefined(_loggedInUsersPlan)) && (_loggedInUser.activesubscription.planid === _loggedInUsersPlan.planid)) {
            deferred.resolve(_loggedInUsersPlan);
          } else {
            _ceres.call('webapi/subscriptionplans/find/by/planid', _loggedInUser.activesubscription.planid).result
              .then(function (plan) {
                _loggedInUsersPlan = plan;
                deferred.resolve(_loggedInUsersPlan);
              }, function (error) {
                deferred.reject(error);
              });
          }
        } else {
          deferred.reject('No active subscription plan');
          swaUtils.stateGoLocationReplace(swaRouterStateNames.subscriptions);
        }
      } else {
        deferred.reject('No user logged in!');
      }

      return deferred.promise;
    };

    this.getLoggedInEntAcct = function () {
      if (angular.isDefined(_loggedInUsersEntAcct)) {
        return _loggedInUsersEntAcct;
      } else {
        var deferred = $q.defer();
        _loggedInUsersEntAcct = deferred.promise;

        if (angular.isDefined(_loggedInUser)) {
          if (angular.isDefined(_loggedInUser.memberOfEntAcct)) {
            _ceres.call('webapi/enterprise/find/by/id', _loggedInUser.memberOfEntAcct).result.then(
              function (account) {
                deferred.resolve(account);
              },

              function (error) {
                deferred.reject(error);
              }
            );
          } else {
            deferred.reject('Not an enterprise account member');
          }
        } else {
          deferred.reject('No user logged in!');
        }

        return _loggedInUsersEntAcct;
      }
    };

    // Production subscriptions handling
    var _selectedProductionId;

    function stopProductionsSubscription() {
      _.each(_ceres.subscriptions, function (subscription) {
        if (subscription._name === 'productions') {
          subscription.stop();
        }
      });

      stopProductionChildSubscriptions();
    }


    this.setSelectedProduction = function (productionOrId) {
      var productionId = angular.isObject(productionOrId) ? productionOrId._id : productionOrId;
      if (_selectedProductionId !== productionId) {
        stopProductionChildSubscriptions();
      }

      _selectedProductionId = productionId;
      swaUtils.claritySet('selectedProductionId', _selectedProductionId);
    };

    this.clearSelectedProduction = function () {
      stopProductionChildSubscriptions();

      _selectedProductionId = undefined;
    };

    function stopUserChildSubscriptions() {
      stopProductionsSubscription();
    }

    function stopProductionChildSubscriptions() {
      _.each(_ceres.subscriptions, function (subscription) {
        if (subscription._name === 'scenes') {
          subscription.stop();
        }
        if (subscription._name === 'setpieces') {
          subscription.stop();
        }
        if (subscription._name === 'performers') {
          subscription.stop();
        }
        if (subscription._name === 'charts') {
          subscription.stop();
        }
        if (subscription._name === 'staffs') {
          subscription.stop();
        }
      });
    }

    function stopScenesSubscription() {
      _.each(_ceres.subscriptions, function (subscription) {
        if (subscription._name === 'scenes') {
          subscription.stop();
        }
      });
    }

    this.getProductionsSubscription = function () {
      return _ceres.subscribe('productions', _loggedInUserId);
    };

    this.getScenesSubscription = function () {
      return _ceres.subscribe('scenes', _selectedProductionId);
    };

    function stopSetPiecesSubscription() {
      _.each(_ceres.subscriptions, function (subscription) {
        if (subscription._name === 'setpieces') {
          subscription.stop();
        }
      });
    }

    this.getSetPiecesSubscription = function () {
      return _ceres.subscribe('setpieces', _selectedProductionId);
    };

    function stopPerformersSubscription() {
      _.each(_ceres.subscriptions, function (subscription) {
        if (subscription._name === 'performers') {
          subscription.stop();
        }
      });
    }

    this.getPerformersSubscription = function () {
      return _ceres.subscribe('performers', _selectedProductionId);
    };

    function stopChartsSubscriptions() {
      _.each(_ceres.subscriptions, function (subscription) {
        if (subscription._name === 'charts') {
          subscription.stop();
        }
      });
    }

    this.getChartsSubscription = function (sceneId) {
      return _ceres.subscribe('charts', sceneId);
    };

    function stopStaffsSubscriptions() {
      _.each(_ceres.subscriptions, function (subscription) {
        if (subscription._name === 'staffs') {
          subscription.stop();
        }
      });
    }

    this.getStaffsSubscription = function (sceneId) {
      return _ceres.subscribe('staffs', sceneId);
    };

    // ceres wrapper methods
    this.getCollection = function (name) {
      return _ceres.getCollection(name);
    };

    this.getAsteroid = function () {
      return _ceres;
    };

    if (connected && _ceres.loggedIn) {
      this.loginUser(_ceres.userId);
    }

    function patchAsteroid() {
      if (!angular.isFunction(Asteroid.Set.prototype.clear)) {
        Asteroid.Set.prototype.clear = function () {
          var keys = _.keys(this._items);
          var _this = this;
          _.each(keys, function (key) {
            _this.del(key);
          });
        }
      }

      if (!angular.isFunction(Asteroid._Collection.prototype.clear)) {
        Asteroid._Collection.prototype.clear = function () {
          this._set.clear();
        }
      }
    }

    function updateAppInfo() {
      _ceres.call('webapi/appinfo/get/module/key', 'Server / API', 'Version').result.then(
        function (result) {
          if (angular.isDefined(result)) {
            $localStorage.serverversion = result;
          }
        }
      );

      _ceres.call('webapi/appinfo/get/module/key', 'Stock Set Pieces', 'Version').result.then(
        function (result) {
          if (angular.isDefined(result)) {
            if ($localStorage.stocksetpiecesversion !== result) {
              delete $localStorage.stockSetPieces;
            }
            $localStorage.stocksetpiecesversion = result;
          }
        }
      );
    }
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbStaffs', DbStaffsFactory);

  DbStaffsFactory.$inject = [
    '$rootScope',
    '$q',
    '$log',
    'DbSubMgrService',
    'swaUtils',
  ];

  function DbStaffsFactory($rootScope, $q, $log, DbSubMgrService, swaUtils) {

    function DbStaffs() {
      // fetch query filter
      var _queryFilter = {};

      // The staffs in the production
      var _staffsRq;

      // Function to call when data is available/changed
      var _dataCallback;

      var ceres = DbSubMgrService.getAsteroid();

      function callDataCallback(id) {
        if (angular.isString(id) && (id.endsWith('__upd__') || id.endsWith('__del__'))) {
          return;
        }

        $rootScope.$applyAsync(function () {
          _dataCallback(_queryFilter, id);
        });
      }

      // Asteroid subscriptions ready handler
      function subscriptionsReady() {
        var StaffCollection = DbSubMgrService.getCollection('staffs');

        _staffsRq = StaffCollection.reactiveQuery(_queryFilter);

        _staffsRq.on('change', callDataCallback);

        callDataCallback();
      }

      this.getEmptyStaffObject = function () {
        return {
          counts: 0,
          customtitle: undefined,
          orderingindex: -1,
          performerrows: [],
          stafftype: -1,
          voicecells: [],
          voicerowcount: 0,
        };
      };

      function fetchWithFilter(filter) {
        var deferred = $q.defer();

        // Unregister any old fetch
        fetchUnregister();

        filter = filter || {};
        _queryFilter = filter;
        var staffSub = DbSubMgrService.getStaffsSubscription(filter.sceneId);
        staffSub.ready.then(
          function () {
            subscriptionsReady();
            deferred.resolve();
          }
        ).catch(
          function (error) {
            deferred.reject(error);
          }
        ).done();

        return deferred.promise;
      }

      function fetchUnregister() {
        if (angular.isDefined(_staffsRq)) {
          $log.debug('DbStaffs: Unregistering fetch callback');
          _staffsRq.off('change', callDataCallback);
          _staffsRq = undefined;
        }
      }

      this.fetchForScene = function (sceneObjectOrId, dataCallback) {
        var refSceneId = angular.isString(sceneObjectOrId) ? sceneObjectOrId : sceneObjectOrId._id;
        _dataCallback = dataCallback;

        return fetchWithFilter({
          sceneId: refSceneId,
        });
      };

      this.getActiveFetchSceneId = function () {
        if (angular.isDefined(_queryFilter) && angular.isDefined(_queryFilter.sceneId)) {
          return _queryFilter.sceneId;
        }
      };

      this.getFetched = function () {
        if (angular.isDefined(_staffsRq)) {
          var allStaffList = _staffsRq.result;
          return swaUtils.sortArrayByNumericKey(allStaffList, 'orderingindex');
        }
      };

      this.getFetchedById = function (id) {
        if (angular.isDefined(_staffsRq)) {
          return swaUtils.findInArrayById(_staffsRq.result, id);
        }
      };

      this.getFetchFilter = function () {
        return _queryFilter;
      };

      this.fetchUnregister = fetchUnregister;

      this.insert = function (newStaff) {
        return $q.resolve(ceres.call('webapi/staffs/insert', newStaff).result);
      };

      this.update = function (staffObject) {
        return $q.resolve(ceres.call('webapi/staffs/update/fields', staffObject._id, staffObject).result);
      };

      this.delete = function (staffIdOrIds) {
        return $q.resolve(ceres.call('webapi/staffs/remove', staffIdOrIds).result);
      };

      this.moveStaffsToScene = function(staffIds, toSceneId) {
        return $q.resolve(ceres.call('webapi/staffs/move/to/scene', staffIds, toSceneId).result);
      };

      this.moveStaffsToSceneAtIndex = function (staffIds, toSceneId, targetIndex) {
        return $q.resolve(ceres.call('webapi/staffs/move/to/sceneAtIndexStaffs', staffIds, toSceneId, targetIndex).result);
      };

      this.copyStaffsToScene = function(staffIds, toSceneId) {
        return $q.resolve(ceres.call('webapi/staffs/copy/to/scene', staffIds, toSceneId).result);
      };

      this.copyStaffsToSceneAtIndex = function (staffIds, toSceneId, targetIndex) {
        return $q.resolve(ceres.call('webapi/staffs/copy/to/sceneAtIndexStaffs', staffIds, toSceneId, targetIndex).result);
      };

      this.getStaffTemplateReferenceCount = function (templateId) {
        return $q.resolve(ceres.call('webapi/staffs/count/by/stafftemplate', templateId).result);
      }

      this.countInScene = function(sceneId) {
        return $q.resolve(ceres.call('webapi/staffs/count/in/scene', sceneId).result);
      };

      this.getStaffsLinkedToChart = function(chartId) {
        return $q.resolve(ceres.call('webapi/staffs/linked/to/chart', chartId).result);
      };
      
      this.getDeletedStaffsFromAllScenes = function(productionId) {
        return $q.resolve(ceres.call('webapi/staffs/get/deleted/from/production', productionId).result);
      };

      this.restoreStaffAtIndexInAnyScene = function(staffVersionId, sceneId, insertIndex) {
        return $q.resolve(ceres.call('webapi/staffs/restore/at/index/inanyscene', staffVersionId, sceneId, insertIndex).result);
      };

    }

    return DbStaffs;
  }
}());

/* global Q */
(function () {
    'use strict';

    angular.module('swanywhere').factory('DbStaffsArchive', DbStaffsArchiveFactory);

    DbStaffsArchiveFactory.$inject = [
        '$q',
        'DbSubMgrService'
    ];

    function DbStaffsArchiveFactory($q, DbSubMgrService) {
        var ceres = DbSubMgrService.getAsteroid();

        function DbStaffsArchive() {
            this.find = function (staffId) {
                return $q.resolve(ceres.call('webapi/staffsarchive/find', staffId).result);
            };
        }

        return DbStaffsArchive;
    }
}());

/* global Q, SWSetPiece */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbSetPieces', DbSetPiecesFactory);

  DbSetPiecesFactory.$inject = [
    '$rootScope',
    '$q',
    '$log',
    'DbSubMgrService',
    'swaUtils',
    '$localStorage',
  ];

  function DbSetPiecesFactory($rootScope, $q, $log, DbSubMgrService, swaUtils, $localStorage) {

    function DbSetPieces() {
      // fetch query filter
      var _queryFilter = {};

      // The setPieces in the production
      var _setPiecesRq;

      // Function to call when data is available/changed
      var _dataCallback;

      var ceres = DbSubMgrService.getAsteroid();

      function callDataCallback(id) {
        if (id && (id.endsWith('__upd__') || id.endsWith('__del__'))) {
          return;
        }

        $rootScope.$applyAsync(function () {
          _dataCallback(id);
        });
      }

      // Asteroid subscriptions ready handler
      function subscriptionsReady() {
        var SetPiecesCollection = DbSubMgrService.getCollection('setpieces');

        _setPiecesRq = SetPiecesCollection.reactiveQuery(_queryFilter);

        _setPiecesRq.on('change', callDataCallback);

        callDataCallback();
      }

      function fetchWithFilter(filter) {
        var deferred = $q.defer();

        // Unregister any old fetch
        fetchUnregister();

        filter = filter || {};
        _queryFilter = filter;
        var setPiecesSub = DbSubMgrService.getSetPiecesSubscription();
        setPiecesSub.ready.then(
          function () {
            subscriptionsReady();
            deferred.resolve();
          }
        ).catch(
          function (error) {
            deferred.reject(error);
          }
        ).done();

        return deferred.promise;
      }

      function fetchUnregister() {
        if (angular.isDefined(_setPiecesRq)) {
          $log.debug('DbSetPieces: Unregistering fetch callback');
          _setPiecesRq.off('change', callDataCallback);
          _setPiecesRq = undefined;
        }
      }

      this.fetchAllInProduction = function (productionObjectOrId, dataCallback) {
        var refProductionId = angular.isString(productionObjectOrId) ? productionObjectOrId : productionObjectOrId._id;

        DbSubMgrService.setSelectedProduction(refProductionId);
        _dataCallback = dataCallback;

        var filter = {
          productionId: refProductionId,
        };

        return fetchWithFilter(filter);
      };

      this.getFetched = function (sorted) {
        if (angular.isDefined(_setPiecesRq)) {
          var allSetPieces = _setPiecesRq.result;
          if (sorted) {
            return swaUtils.sortArrayByNumericKey(allSetPieces, 'orderingindex');
          } else {
            return allSetPieces;
          }
        }
      };

      this.getFetchedById = function (id) {
        if (angular.isDefined(_setPiecesRq)) {
          return swaUtils.findInArrayById(_setPiecesRq.result, id);
        }
      };

      this.fetchUnregister = fetchUnregister;

      this.getEmptySetPieceObject = function () {
        return {
          height: 0.0,
          image: '',
          measurementunit: 0,
          name: '',
          setpiecetype: 0,
          thumbimage: '',
          width: 0.0,
        };
      };

      this.insert = function (newSetPiece) {
        return $q.resolve(ceres.call('webapi/setpieces/insert', newSetPiece).result);
      };

      this.update = function (setPieceObject) {
        return $q.resolve(ceres.call('webapi/setpieces/update/fields', setPieceObject._id, setPieceObject).result);
      };

      this.delete = function (setPieceIdOrIds) {
        return $q.resolve(ceres.call('webapi/setpieces/remove', setPieceIdOrIds).result);
      };

      this.findById = function(setPieceId) {
        return $q.resolve(ceres.call('webapi/setpieces/find/by/id', setPieceId).result);
      };

      this.getStockItems = function () {
        var deferred = $q.defer();
        var stockSetPieces = $localStorage.stockSetPieces;
        if (angular.isUndefined(stockSetPieces)) {
          ceres.call('webapi/setpieces/find/stock').result
            .then(function(items) {
              $localStorage.stockSetPieces = items;
              deferred.resolve(items);
            }).catch(function(error) {
              deferred.reject(error);
            });
        } else {
          deferred.resolve(stockSetPieces);
        }
        // return $q.resolve(ceres.call('webapi/setpieces/find/stock').result);

        return deferred.promise;
      }

      this.findInProduction = function (productionId) {
        return $q.resolve(ceres.call('webapi/setpieces/find/in/production', productionId).result);
      }

      this.getCountInProduction = function (productionId) {
        return $q.resolve(ceres.call('webapi/setpieces/count/in/production', productionId).result);
      }
    }

    return DbSetPieces;
  }

}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbScriptPages', DbScriptPagesFactory);

  DbScriptPagesFactory.$inject = [
    '$q',
    '$log',
    'DbSubMgrService',
  ];

  function DbScriptPagesFactory($q, $log, DbSubMgrService) {

    function DbScriptPages() {

      var ceres = DbSubMgrService.getAsteroid();

      this.insert = function (newScriptPage) {
        return $q.resolve(ceres.call('webapi/scriptpages/insert', newScriptPage).result);
      };

      this.update = function (scriptPageObject) {
        return $q.resolve(ceres.call('webapi/scriptpages/update/fields', scriptPageObject._id, scriptPageObject).result);
      };

      this.remove = function (scriptPageId) {
        return $q.resolve(ceres.call('webapi/scriptpages/remove', scriptPageId).result);
      }

      this.getScriptPageAtIndex = function (scriptId, orderingIndex) {
        return $q.resolve(ceres.call('webapi/scriptpages/find/in/script/by/orderingindex', scriptId, orderingIndex).result);
      }

      this.getScriptPageContentAtIndex = function (scriptId, orderingIndex) {
        return $q.resolve(ceres.call('webapi/scriptpages/find/content/in/script/by/orderingindex', scriptId, orderingIndex).result);
      }

      this.getContentById = function (scriptPageId) {
        return $q.resolve(ceres.call('webapi/scriptpages/get/content/by/id', scriptPageId).result);
      }

      this.getNumberOfPages = function (scriptId) {
        return $q.resolve(ceres.call('webapi/scriptpages/count/in/script', scriptId).result);
      }

      this.getIdsOfPages = function (scriptId) {
        return $q.resolve(ceres.call('webapi/scriptpages/ids/in/script', scriptId).result);
      }

      this.replacePage = function (scriptPageId, newPage) {
        return $q.resolve(ceres.call('webapi/scriptpages/replace/page', scriptPageId, newPage).result);
      }

      this.insertAtIndex = function (newScriptPage, index) {
        return $q.resolve(ceres.call('webapi/scriptpages/insert/at/index', newScriptPage, index).result);
      }

      this.removeAllFromScript = function (scriptId) {
        return $q.resolve(ceres.call('webapi/scriptpages/remove/all/from/script', scriptId).result);
      }

      this.getScriptPagesLinkedToChart = function (chartId) {
        return $q.resolve(ceres.call('webapi/scriptpages/linked/to/chart', chartId).result);
      }

      this.undoPdfImport = function (scriptId) {
        return $q.resolve(ceres.call('webapi/scriptpages/undo/pdf/import', scriptId).result);
      }

      this.getScriptPagesArchiveDate = function (scriptId) {
        return $q.resolve(ceres.call('webapi/scriptpages/get/archive/date', scriptId).result);
      }

      this.removeAllFromScriptPagesArchive = function (scriptId) {
        return $q.resolve(ceres.call('webapi/scriptpages/remove/all/archives', scriptId).result);
      }

      this.reindexAfterMakeCurrentPageFirst = function (scriptId, startingPageNumber) {
        return $q.resolve(ceres.call('webapi/scriptpages/reindex/after/makecurrentpagefirst', scriptId, startingPageNumber).result);
      }

      this.setCustomScriptPageNumber = function (scriptPageId, customScriptPageNumber) {
        return $q.resolve(ceres.call('webapi/scriptpages/set/custom/page/number', scriptPageId, customScriptPageNumber).result);
      }

      this.findInScriptByCustomPageNumber = function (scriptId, customScriptPageNumber, orderingindex) {
        return $q.resolve(ceres.call('webapi/scriptpages/find/in/script/by/customPageNumber', scriptId, customScriptPageNumber, orderingindex).result);
      }

      this.applyMarginToAllPages = function (scriptId, leftmargin, rightmargin, finalScaleFactor) {
        return $q.resolve(ceres.call('webapi/scriptpages/apply/margin/for/all', scriptId, leftmargin, rightmargin, finalScaleFactor).result);
      }

      this.getScriptPagesByScript = function (scriptId) {
        return $q.resolve(ceres.call('webapi/scriptpages/get/script/pages', scriptId).result);
      }

      this.changeActionAnnotationType = function (scriptId) {
        return $q.resolve(ceres.call('webapi/scriptpages/change/annotation/type', scriptId).result);
      }

      this.getScriptPagesByScriptForBookmarks = function (scriptId) {
        return $q.resolve(ceres.call('webapi/scriptpages/get/script/pages/for/bookmarks', scriptId).result);
      }
    }

    return DbScriptPages;
  }
}());

/* global Q */

/**
 * @typedef ScriptBookmarkType
 * @property {String} name The bookmark's title / name.
 * @property {Number} scriptPageNo The reference page number.
 * @property {Number} topOffset The position offset from top of the page.
 */

/**
 * @typedef ScriptType
 * @property {string} _id Identifier.
 * @property {ScriptBookmarkType[]} bookmarks Bookmarks in the script.
 */

(function () {
  'use strict';

  angular.module('swanywhere').factory('DbScripts', DbScriptsFactory);

  DbScriptsFactory.$inject = [
    '$q',
    '$log',
    'DbSubMgrService',
    'swaUtils',
    'DbUserScripts',
    'DbUserProductions'
  ];

  function DbScriptsFactory($q, $log, DbSubMgrService, swaUtils, DbUserScripts, DbUserProductions) {

    function DbScripts() {

      var ceres = DbSubMgrService.getAsteroid();

      var dbUserScripts = new DbUserScripts();
      var dbUserProductions = new DbUserProductions();

      /**
       * Returns a sorted copy of the bookmarks.
       * @param {ScriptBookmarkType[]} bookmarks bookmarks to sort.
       */
      this.sortBookmarks = function (bookmarks) {
        /** @type ScriptBookmarkType[] */
        var sortedBookmarks = [];
        if (angular.isArray(bookmarks)) {
          sortedBookmarks = angular.copy(bookmarks);
        }

        sortedBookmarks.sort(function (a, b) {
          if (a.scriptPageNo === b.scriptPageNo) {
            return a.topOffset - b.topOffset;
          } else {
            return a.scriptPageNo - b.scriptPageNo;
          }
        });

        return sortedBookmarks;
      }

      /**
       * Finds the first bookmark on the given page in the bookmarks list.
       * @param {ScriptBookmarkType[]} sortedBookmarks sorted list of bookmarks.
       * @param {Number} pageOrderingIndex The page's ordering index to find in.
       */
      this.findFirstBookmarkOnPage = function (sortedBookmarks, pageOrderingIndex) {
        return sortedBookmarks.find(function (bookmark) {
          return (bookmark.scriptPageNo === pageOrderingIndex);
        });
      }

      /**
       * Finds a bookmark before the reference bookmark or page ordering index.
       * @param {ScriptBookmarkType[]} sortedBookmarks sorted bookmarks list.
       * @param {ScriptBookmarkType} referenceBookmark the reference bookmark.
       * @param {Number} referencePageorderingIndex the reference page ordering index.
       */
      this.findBookmarkBefore = function (sortedBookmarks, referenceBookmark, referencePageOrderingIndex) {
        /** @type ScriptBookmarkType */
        var prevBookmark = null;


        if (!swaUtils.isUndefinedOrNull(referenceBookmark)) {
          var referenceIndex = sortedBookmarks.indexOf(referenceBookmark);
          if (referenceIndex > 0) {
            prevBookmark = sortedBookmarks[referenceIndex - 1];
          }
        }

        if (swaUtils.isUndefinedOrNull(prevBookmark)) {
          var revSortedBookmarks = sortedBookmarks.slice(0).reverse();
          prevBookmark = revSortedBookmarks.find(function (bookmark) {
            return bookmark.scriptPageNo < referencePageOrderingIndex;
          })
        }

        return prevBookmark;
      }

      /**
       * Finds a bookmark after the reference bookmark or page ordering index.
       * @param {ScriptBookmarkType[]} sortedBookmarks sorted bookmarks list.
       * @param {ScriptBookmarkType} referenceBookmark the reference bookmark.
       * @param {Number} referencePageOrderingIndex the reference page ordering index.
       */
      this.findBookmarkAfter = function (sortedBookmarks, referenceBookmark, referencePageOrderingIndex) {
        /** @type ScriptBookmarkType */
        var nextBookmark = null;
        if (!swaUtils.isUndefinedOrNull(referenceBookmark)) {
          nextBookmark = sortedBookmarks.find(function (bookmark) {
            return ((bookmark.scriptPageNo === referencePageOrderingIndex) && (bookmark.topOffset > referenceBookmark.topOffset));
          });
        }

        if (swaUtils.isUndefinedOrNull(nextBookmark)) {
          nextBookmark = sortedBookmarks.find(function (bookmark) {
            return bookmark.scriptPageNo > referencePageOrderingIndex;
          })
        }

        return nextBookmark;
      }

      this.insert = function (newScript) {
        return $q.resolve(ceres.call('webapi/scripts/insert', newScript).result);
      };

      this.update = function (scriptObject) {
        return $q.resolve(ceres.call('webapi/scripts/update/fields', scriptObject._id, scriptObject).result);
      };

      this.findByProduction = function (productionId) {
        return $q.resolve(ceres.call('webapi/scripts/find/in/production', productionId).result);
      }

      // SWA-1922 - New
      this.removeOrMergeAnnotationLayer = function (scriptId, selectedAnnotationLayer, mergeToLayerId) {
        return $q.resolve(ceres.call('webapi/scripts/removeormerge/annotation/layer', scriptId, selectedAnnotationLayer, mergeToLayerId).result);
      }

      // SWA-T104 - new
      this.uploadScript = function (scriptParams, scriptId, methodType) {
        return $q.resolve(ceres.call('webapi/productions/upload/script', scriptParams, scriptId, methodType).result);
      }

      this.startUploadPdf = function (uploadParams) {
        return $q.resolve(ceres.call('webapi/productions/upload/script/start', uploadParams).result);
      }

      this.uploadPdfChunk = function (uploadParams) {
        return $q.resolve(ceres.call('webapi/productions/upload/script/uploadpdfchunks', uploadParams).result);
      }

      this.runJob = function (jobId, methodType) {
        return $q.resolve(ceres.call('webapi/productions/upload/script/runjob', jobId, methodType).result);
      }

    }

    return DbScripts;
  }
}());

//* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbScenes', DbScenesFactory);

  DbScenesFactory.$inject = [
    '$rootScope',
    '$q',
    '$log',
    'DbSubMgrService',
    'swaUtils',
  ];

  function DbScenesFactory($rootScope, $q, $log, DbSubMgrService, swaUtils) {

    function DbScenes() {
      // fetch query filter
      var _queryFilter = {};

      // The scenes in the production
      var _scenesRq;

      // Function to call when data is available/changed
      var _dataCallback;

      var ceres = DbSubMgrService.getAsteroid();

      function callDataCallback(id) {
        if (id && (id.endsWith('__upd__') || id.endsWith('__del__'))) {
          return;
        }

        $rootScope.$applyAsync(function () {
          _dataCallback(id);
        });
      }

      // Asteroid subscriptions ready handler
      function subscriptionsReady() {
        var ScenesCollection = DbSubMgrService.getCollection('scenes');

        _scenesRq = ScenesCollection.reactiveQuery(_queryFilter);

        _scenesRq.on('change', callDataCallback);

        callDataCallback();
      }

      function fetchWithFilter(filter) {
        var deferred = $q.defer();

        filter = filter || {};
        _queryFilter = filter;
        var scenesSub = DbSubMgrService.getScenesSubscription();
        scenesSub.ready.then(
          function () {
            return subscriptionsReady();
          }
        ).then(
          function () {
            deferred.resolve();
          }
        ).catch(
          function (error) {
            deferred.reject(error);
          }
        ).done();

        return deferred.promise;
      }

      function fetchUnregister() {
        if (angular.isDefined(_scenesRq)) {
          $log.debug('DbScenesFactory: Unregistering fetch callback');
          _scenesRq.off('change', callDataCallback);
          _scenesRq = undefined;
        }
      }

      this.fetchAllInProduction = function (productionObjectOrId, dataCallback) {
        var refProductionId = angular.isString(productionObjectOrId) ? productionObjectOrId :
          productionObjectOrId._id;

        DbSubMgrService.setSelectedProduction(refProductionId);
        _dataCallback = dataCallback;

        var filter = {
          productionId: refProductionId,
        };

        return fetchWithFilter(filter);
      };

      this.getFetched = function (sorted) {
        if (angular.isDefined(_scenesRq)) {
          var allScenes = _scenesRq.result;
          if (sorted) {
            return allScenes.sort(function (a, b) {
              return a.orderingindex - b.orderingindex;
            });
          } else {
            return allScenes;
          }
        }
      };

      this.getFetchedById = function (id) {
        if (angular.isDefined(_scenesRq)) {
          return swaUtils.findInArrayById(_scenesRq.result, id);
        }
      };

      this.fetchUnregister = fetchUnregister;

      this.insert = function (newScene) {
        return $q.resolve(ceres.call('webapi/scenes/insert', newScene).result);
      };

      this.update = function (sceneObject) {
        return $q.resolve(ceres.call('webapi/scenes/update/fields', sceneObject._id, sceneObject).result);
      };

      this.delete = function (sceneIdOrIds) {
        return $q.resolve(ceres.call('webapi/scenes/remove', sceneIdOrIds).result);
      };

      this.findInProduction = function (productionId) {
        return $q.resolve(ceres.call('webapi/scenes/find/in/production', productionId).result);
      }

      this.getCountInProduction = function (productionId) {
        return $q.resolve(ceres.call('webapi/scenes/count/in/production', productionId).result);
      }
    }

    return DbScenes;
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbProductions', DbProductionsFactory);

  DbProductionsFactory.$inject = [
    '$rootScope',
    '$q',
    '$log',
    'DbSubMgrService',
    'swaUtils',
  ];

  function DbProductionsFactory($rootScope, $q, $log, DbSubMgrService, swaUtils) {

    function DbProductions() {

      // query filter
      var _queryFilter = {};

      // the reqctive query
      var _productionsRq;

      // Function to call when data is available/changed
      var _dataCallback;

      var ceres = DbSubMgrService.getAsteroid();

      function callDataCallback(id) {
        if (angular.isString(id) && (id.endsWith('__upd__') || id.endsWith('__del__'))) {
          return;
        }

        $rootScope.$applyAsync(function () {
          _dataCallback(id);
        });
      }

      // Asteroid subscription ready handler.
      function subscriptionsReady() {
        var ProductionsCollection = DbSubMgrService.getCollection('productions');

        _productionsRq = ProductionsCollection.reactiveQuery(_queryFilter);

        _productionsRq.on('change', callDataCallback);

        callDataCallback();
      }

      // Gets an empty production object with necessary defaults.
      this.getNewProductionObject = function () {
        return {
          logo: '',
          details: {
            coverstyle: 0,
          },
          stagesettings: {
            stagemeasurementunit: 0,
            offstagewidth: 0,
            stagewidth: 0,
            stagedepth: 0,
            numberlineMarkerStepValue: 1,
            numberlineZeroAtCenter: true,
            numberlineMultiplier: 1,
          },
          chartsettings: {
            centerlinevisible: true,
            chartnumberautomatic: true,
            horizontallinesvisible: false,
            lineoverlapbreaks: true,
            numberlinevisible: true,
            performernosevisible: false,
            performerpositionvisible: true,
            povaudience: true,
            verticallinesvisible: false,
            performerpositionresolutionfraction: 0,
            chartnotesvisible: false,
          }
        };
      };

      function fetchWithFilter(filter) {
        var deferred = $q.defer();

        filter = filter || {};
        _queryFilter = filter;
        var productionSub = DbSubMgrService.getProductionsSubscription();
        productionSub.ready.then(
          function () {
            return subscriptionsReady();
          }
        ).then(
          function () {
            deferred.resolve();
          }
        ).catch(
          function (error) {
            deferred.reject(error);
          }
        ).done();

        return deferred.promise;
      }

      function fetchUnregister() {
        if (angular.isDefined(_productionsRq)) {
          $log.debug('DbProductions: Unregistering fetch callback');
          _productionsRq.off('change', callDataCallback);
          _productionsRq = undefined;
        }
      }

      this.fetchAll = function (dataCallback) {
        _dataCallback = dataCallback;

        return fetchWithFilter();
      };

      this.fetchById = function (productionId, dataCallback) {
        _dataCallback = dataCallback;

        return fetchWithFilter({
          _id: productionId,
        });
      };

      this.getFetched = function () {
        if (angular.isDefined(_productionsRq)) {
          return _productionsRq.result;
        }
      };

      this.getFirstFetched = function () {
        if (angular.isDefined(_productionsRq)) {
          return _productionsRq.result[0];
        }
      };

      this.getFetchedById = function (id) {
        if (angular.isDefined(_productionsRq)) {
          return swaUtils.findInArrayById(_productionsRq.result, id);
        }
      };

      this.fetchUnregister = fetchUnregister;

      this.sortForUserId = function (productions, userId) {
        var createdDateGet = _.property(['created', '$date']);
        return productions.sort(function (a, b) {
          var compareResult = 0;
          if ((a.ownerId === userId) && (b.ownerId === userId)) {
            compareResult = 0;
          } else if ((a.ownerId === userId) && (b.ownerId !== userId)) {
            compareResult = -1;
          } else if ((a.ownerId !== userId) && (b.ownerId === userId)) {
            compareResult = 1;
          }

          // then by created date
          if (compareResult === 0) {
            var aCreated = createdDateGet(a) || 0;
            var bCreated = createdDateGet(b) || 0;
            compareResult = aCreated - bCreated;
          }
          
          return compareResult;
        });
      };

      this.sortByNameWithFavorites = function (productions, userData) {
        var createdDateGet = _.property(['created', '$date']);
        productions.sort(function (a, b) {
          var compareResult = 0;

          // first by favorite
          if ((a.isFavorite) && (b.isFavorite)) {
            compareResult = 0;
          } else if (a.isFavorite && !b.isFavorite) {
            compareResult = -1;
          } else if (!a.isFavorite && b.isFavorite) {
            compareResult = 1;
          }

          // then by name
          if (compareResult == 0) {
            // compareResult = (a.name > b.name) - (a.name < b.name);
            compareResult = a.name.localeCompare(b.name, {sensitivity: 'base'});
          }

          // then by created date
          if (compareResult === 0) {
            var aCreated = createdDateGet(a) || 0;
            var bCreated = createdDateGet(b) || 0;
            compareResult = aCreated - bCreated;
          }

          return compareResult;
        });
      };

      this.insert = function (newProduction) {
        return $q.resolve(ceres.call('webapi/productions/insert', newProduction).result);
      };

      this.update = function (productionObject) {
        return $q.resolve(ceres.call('webapi/productions/update/fields', productionObject._id, productionObject).result);
      };

      this.delete = function (productionId) {
        return $q.resolve(ceres.call('webapi/productions/remove', productionId).result);
      };

      this.findById = function (productionId) {
        // TODO: try to get the production from earlier subscribed data if possible
        return $q.resolve(ceres.call('webapi/productions/find/by/id', productionId).result);
      };

      this.copyProduction = function (params) {
        return $q.resolve(ceres.call('webapi/productions/copy/with/params', params).result);
      };

      this.addStaffTemplate = function (productionId, templateData) {
        return $q.resolve(ceres.call('webapi/productions/update/stafftemplate/add', productionId, templateData).result);
      };

      this.updateStaffTemplate = function (productionId, updatedTemplateData) {
        return $q.resolve(ceres.call('webapi/productions/update/stafftemplate/update', productionId, updatedTemplateData).result);
      };

      this.addCollaborators = function (productionId, newEmailAddressess, collaborationSettings, addedByMasterCollaborator) {
        return $q.resolve(ceres.call('webapi/productions/update/collaborators/add', productionId, newEmailAddressess, collaborationSettings, addedByMasterCollaborator).result);
      };

      this.updateCollaboratorSettings = function (productionId, collaboratorEmail, udpatedCollaborationSettings) {
        return $q.resolve(ceres.call('webapi/productions/update/collaborator/update', productionId, collaboratorEmail, udpatedCollaborationSettings).result);
      };

      this.removeCollaborator = function (productionId, collaboratorEmail) {
        return $q.resolve(ceres.call('webapi/productions/update/collaborator/remove', productionId, collaboratorEmail).result);
      };

      this.stopCollaborating = function (productionId) {
        return $q.resolve(ceres.call('webapi/productions/update/collaborator/remove/sessionuser', productionId).result);
      };

      this.updateContentModifiedFor = function(productionId, contentName) {
        return $q.resolve(ceres.call('webapi/productions/update/contentmodified/for', productionId, contentName).result);
      }

      this.getUserAccessibleProductionsCount = function (userId) {
        return $q.resolve(ceres.call('webapi/productions/get/count/for/userid', userId).result);
      };

      this.transferOwnership = function (transferParams) {
        return $q.resolve(ceres.call('webapi/productions/transfer/ownership', transferParams).result);
      }
      
      this.createArchive = function (archiveParams) {
        return $q.resolve(ceres.call('webapi/productions/create/archive', archiveParams).result);
      }

    }

    return DbProductions;
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbPerformers', DbPerformersFactory);

  DbPerformersFactory.$inject = [
    '$rootScope',
    '$q',
    '$log',
    'DbSubMgrService',
    'swaUtils',
  ];

  function DbPerformersFactory($rootScope, $q, $log, DbSubMgrService, swaUtils) {

    function DbPerformers() {
      // fetch query filter
      var _queryFilter = {};

      // The performers in the production
      var _performersRq;

      // Function to call when data is available/changed
      var _dataCallback;

      var ceres = DbSubMgrService.getAsteroid();

      function callDataCallback(id) {
        if (id && (id.endsWith('__upd__') || id.endsWith('__del__'))) {
          return;
        }

        $rootScope.$applyAsync(function () {
          _dataCallback(id);
        });
      }

      // Asteroid subscriptions ready handler
      function subscriptionsReady() {
        var PerformersCollection = DbSubMgrService.getCollection('performers');

        _performersRq = PerformersCollection.reactiveQuery(_queryFilter);

        _performersRq.on('change', callDataCallback);

        callDataCallback();
      }

      function fetchWithFilter(filter) {
        var deferred = $q.defer();

        // Unregister any old fetch
        fetchUnregister();

        filter = filter || {};
        _queryFilter = filter;
        var performersSub = DbSubMgrService.getPerformersSubscription();
        performersSub.ready.then(
          function () {
            return subscriptionsReady();
          }
        ).then(
          function () {
            deferred.resolve();
          }
        ).catch(
          function (error) {
            deferred.reject(error);
          }
        ).done();

        return deferred.promise;
      }

      function fetchUnregister() {
        if (angular.isDefined(_performersRq)) {
          $log.debug('DbPerformers: Unregistering fetch callback');
          _performersRq.off('change', callDataCallback);
          _performersRq = undefined;
        }
      }

      this.fetchAllInProduction = function (productionObjectOrId, dataCallback) {
        var refProductionId = angular.isString(productionObjectOrId) ? productionObjectOrId :
          productionObjectOrId._id;

        DbSubMgrService.setSelectedProduction(refProductionId);
        _dataCallback = dataCallback;

        var filter = {
          productionId: refProductionId,
        };

        return fetchWithFilter(filter);
      };

      this.fetchById = function (performerId, dataCallback) {
        _dataCallback = dataCallback;

        var filter = {
          _id: performerId,
        };

        return fetchWithFilter(filter);
      };

      this.getFetched = function (sorted) {
        if (angular.isDefined(_performersRq)) {
          var allPerformers = _performersRq.result;
          if (sorted) {
            return swaUtils.sortArrayByNumericKey(allPerformers, 'orderingindex');
          } else {
            return allPerformers;
          }
        }
      };

      this.getFirstFetched = function () {
        if (angular.isDefined(_performersRq)) {
          return _performersRq.result[0];
        }
      };

      this.getFetchedById = function (id) {
        if (angular.isDefined(_performersRq)) {
          return swaUtils.findInArrayById(_performersRq.result, id);
        }
      };

      this.fetchUnregister = fetchUnregister;

      this.getEmptyPerformerObject = function () {
        return {
          bordercolor: '#000000',
          shape: 1,
          shapecolor: '#0000ff',
          bordervisible: true,
          textsize: 0.9,
          textcolor: '#000000',
          text: '',
          name: '',
          image: '',
          highlightperformer: false,
        };
      };

      this.insert = function (newPerformer) {
        swaUtils.clarityEvent('performer-insert');
        return $q.resolve(ceres.call('webapi/performers/insert', newPerformer).result);
      };

      this.update = function (performerObject) {
        swaUtils.clarityEvent('performer-update');
        return $q.resolve(ceres.call('webapi/performers/update/fields', performerObject._id, performerObject).result);
      };

      this.delete = function (performerIdOrIds) {
        swaUtils.clarityEvent('performer-delete');
        return $q.resolve(ceres.call('webapi/performers/remove', performerIdOrIds).result);
      };

      this.findInProduction = function (productionId) {
        return $q.resolve(ceres.call('webapi/performers/find/in/production', productionId).result);
      }

      this.findById = function(performerId) {
        return $q.resolve(ceres.call('webapi/performers/find/by/id', performerId).result);
      };

    }

    return DbPerformers;
  }
}());

/* global Q */
(function() {
  'use strict';

  angular.module('swanywhere').factory('DbMasters', DbMastersFactory);

  DbMastersFactory.$inject = [
    '$q',
    'DbSubMgrService',
  ];

  function DbMastersFactory($q, DbSubMgrService) {
    function DbMasters() {

      var ceres = DbSubMgrService.getAsteroid();

      this.getSubscriptionPlans = function () {
        return $q.resolve(ceres.call('webapi/subscriptionplans/find/all').result);
      };

      this.getSubscriptionPlan = function (planId) {
        return $q.resolve(ceres.call('webapi/subscriptionplans/find/by/planid', planId).result);
      };

      this.getAppFeatures = function () {
        return $q.resolve(ceres.call('webapi/appfeatures/find').result);
      };
    }

    return DbMasters;
  }
}());

/* global Q */
(function () {
    'use strict';

    angular.module('swanywhere').factory('DbDeletedProductions', DbDeletedProductionsFactory);

    DbDeletedProductionsFactory.$inject = [
        '$rootScope',
        '$q',
        '$log',
        'DbSubMgrService',
        'swaUtils',
    ];
    //  SWA-1236-
    function DbDeletedProductionsFactory($rootScope, $q, $log, DbSubMgrService, swaUtils) {
        function DbDeletedProductions() {

            var ceres = DbSubMgrService.getAsteroid();


            this.restoreBackProduction = function (deletedId) {
                // alert('Call API webapi/deletedproductions/restore '+deletedId)
                return $q.resolve(ceres.call('webapi/deletedproductions/restore', deletedId).result);
            };
            
            this.getDeletedProductionForUser = function () {
                // TODO: try to get the deleted production list if owned by logged user
                return $q.resolve(ceres.call('webapi/deletedproductions/find/ownedby').result);
            };


        }
        return DbDeletedProductions;
    }
}());
/* global Q */
(function () {
  'use strict';
  angular.module('swanywhere').factory('DbCollaborationPrivileges', DbCollaborationPrivilegesFactory);
  DbCollaborationPrivilegesFactory.$inject = [
    '$q',
    'DbSubMgrService',
  ];
  function DbCollaborationPrivilegesFactory($q,DbSubMgrService) {

    function DbCollaborationPrivileges() {

      var ceres = DbSubMgrService.getAsteroid();

      this.getCollaborationPrivileges = function (params) {
        var callParams = {
          statename: params.statename,
          accesslevel: params.accesslevel,
          allowchartediting: (params.allowchartediting || false),
          allowstaffediting: (params.allowstaffediting || false),
          allowscriptediting: (params.allowscriptediting || false),
        };

        return $q.resolve(ceres.call('webapi/collaborationprivileges/find/with/params', params).result);
      };
    }

    return DbCollaborationPrivileges;
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbCharts', DbChartsFactory);

  DbChartsFactory.$inject = [
    '$rootScope',
    '$q',
    '$log',
    'DbSubMgrService',
    'swaUtils',
  ];

  function DbChartsFactory($rootScope, $q, $log, DbSubMgrService, swaUtils) {

    function DbCharts() {
      // fetch query filter
      var _queryFilter = {};

      // the charts in the production
      var _chartsRq;

      // Function to call when data is available/changed
      var _dataCallback;

      var ceres = DbSubMgrService.getAsteroid();

      function callDataCallback(id) {
        if (angular.isString(id) && (id.endsWith('__upd__') || id.endsWith('__del__'))) {
          return;
        }

        $rootScope.$applyAsync(function () {
          _dataCallback(_queryFilter, id);
        });
      }

      // Asteroid subscriptions ready handler
      function subscriptionsReady() {
        var ChartsCollection = DbSubMgrService.getCollection('charts');

        _chartsRq = ChartsCollection.reactiveQuery(_queryFilter);

        _chartsRq.on('change', callDataCallback);

        callDataCallback();
      }

      function fetchWithFilter(filter) {
        var deferred = $q.defer();

        // Unregister any old fetch
        fetchUnregister();

        filter = filter || {};
        _queryFilter = filter;
        var chartsSub = DbSubMgrService.getChartsSubscription(filter.sceneId);
        chartsSub.ready.then(
          function () {
            subscriptionsReady();
            deferred.resolve();
          }
        ).catch(
          function (error) {
            deferred.reject(error);
          }
        ).done();

        return deferred.promise;
      }

      function fetchUnregister() {
        if (angular.isDefined(_chartsRq)) {
          $log.debug('DBCharts: Unregistering fetch callback');
          _chartsRq.off('change', callDataCallback);
          _chartsRq = undefined;
        }
      }

      this.fetchForScene = function (sceneObjectOrId, dataCallback) {
        var refSceneId = angular.isString(sceneObjectOrId) ? sceneObjectOrId : sceneObjectOrId._id;
        _dataCallback = dataCallback;

        return fetchWithFilter({
          sceneId: refSceneId,
        });
      };

      this.getActiveFetchSceneId = function () {
        if (angular.isDefined(_queryFilter) && angular.isDefined(_queryFilter.sceneId)) {
          return _queryFilter.sceneId;
        }
      };

      this.getFetched = function () {
        if (angular.isDefined(_chartsRq)) {
          var allChartList = _chartsRq.result;
          return swaUtils.sortArrayByNumericKey(allChartList, 'orderingindex');
        }
      };

      this.getFetchedById = function (id) {
        if (angular.isDefined(_chartsRq)) {
          return swaUtils.findInArrayById(_chartsRq.result, id);
        }
      };

      this.getFetchFilter = function () {
        return _queryFilter;
      };

      this.fetchUnregister = fetchUnregister;

      this.getEmptyChartObject = function () {
        return {
          cuelinetext: undefined,
          customname: undefined,
          notes: undefined,
          notesheight: 120,
          notesvisible: false,
          orderingindex: -1,
          thumbimage: undefined,
          itemIds: [],
          linkedstaffIds: [],
          deleted: false,
        };
      };

      this.insert = function (newChart) {
        return $q.resolve(ceres.call('webapi/charts/insert', newChart).result);
      };

      this.update = function (chartObject) {
        return $q.resolve(ceres.call('webapi/charts/update/fields', chartObject._id, chartObject).result);
      };

      this.delete = function (chartIdOrIds) {
        return $q.resolve(ceres.call('webapi/charts/remove', chartIdOrIds).result);
      };

      this.getChartForName = function (chartId) {
        return $q.resolve(ceres.call('webapi/charts/find/by/id/select/fields', chartId, ['sceneId', 'orderingindex', 'customname']).result);
      };

      this.moveChartsToScene = function (chartIds, toSceneId) {
        return $q.resolve(ceres.call('webapi/charts/move/to/scene', chartIds, toSceneId).result);
      };
      
      this.moveChartsToSceneAtIndex = function (chartIds, toSceneId, targetIndex) {
        return $q.resolve(ceres.call('webapi/charts/move/to/sceneAtIndex', chartIds, toSceneId, targetIndex).result);
      };

      this.addDuplicateOfChartInSceneAtIndex = function (sourceChartId, destSceneId, insertIndex, asNextChart) {
        return $q.resolve(ceres.call('webapi/charts/add/duplicate/of/chart/in/scene/at/index/asnextchart', sourceChartId, destSceneId, insertIndex, asNextChart).result);
      };

      this.findLastChartInScene = function (sceneId) {
        return $q.resolve(ceres.call('webapi/charts/find/last/in/scene', sceneId).result);
      };

      this.updateThumbnail = function (chartId, thumbimage) {
        return $q.resolve(ceres.call('webapi/charts/update/thumbimage', chartId, thumbimage).result);
      };

      this.countInScene = function (sceneId) {
        return $q.resolve(ceres.call('webapi/charts/count/in/scene', sceneId).result);
      };

      this.getIdsInScene = function (sceneId) {
        return $q.resolve(ceres.call('webapi/charts/get/ids/in/scene', sceneId).result);
      };

      this.getChartsInScene = function (sceneId) {
        return $q.resolve(ceres.call('webapi/charts/get/in/scene', sceneId).result);
      };

      this.archive = function (chartId) {
        return $q.resolve(ceres.call('webapi/charts/archive', chartId).result);
      };

      this.getDeletedChartsFromAllScenes = function (productionId) {
        return $q.resolve(ceres.call('webapi/charts/get/deleted/from/production', productionId).result)
      };

      this.restoreChartAtIndexInAnyScene = function (chartVersionId, sceneId, insertIndex) {
        return $q.resolve(ceres.call('webapi/charts/restore/at/index/inanyscene', chartVersionId, sceneId, insertIndex).result)
      };
    }

    return DbCharts;
  }
}());

/* global Q */
(function() {
  'use strict';

  angular.module('swanywhere').factory('DbChartsArchive', DbChartsArchiveFactory);

  DbChartsArchiveFactory.$inject = [
    '$q',
    'DbSubMgrService'
  ];

  function DbChartsArchiveFactory($q, DbSubMgrService) {
    var ceres = DbSubMgrService.getAsteroid();

    function DbChartsArchive() {
      this.find = function (chartId) {
        return $q.resolve(ceres.call('webapi/chartsarchive/find', chartId).result);
      };
    }

    return DbChartsArchive;
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').factory('DbChartItems', DbChartItemsFactory);

  DbChartItemsFactory.$inject = [
    '$q',
    'DbSubMgrService',
    'swaUtils',
  ];

  function DbChartItemsFactory($q, DbSubMgrService, swaUtils) {

    function DbChartItems() {
      var ceres = DbSubMgrService.getAsteroid();

      this.insert = function (newChartItem) {
        swaUtils.clarityEvent('chartitem-insert');
        return $q.resolve(ceres.call('webapi/chartitems/insert', newChartItem).result);
      };

      this.update = function (chartItemObject) {
        swaUtils.clarityEvent('chartitem-update');
        return $q.resolve(ceres.call('webapi/chartitems/update/fields', chartItemObject._id, chartItemObject).result);
      };

      this.delete = function (chartItemIdOrIds) {
        swaUtils.clarityEvent('chartitem-delete');
        return $q.resolve(ceres.call('webapi/chartitems/remove', chartItemIdOrIds).result);
      };

      this.getItemsOfChart = function (chartId) {
        return $q.resolve(ceres.call('webapi/chartitems/find/ofchart', chartId).result);
      };

      this.getItemIdsOfChart = function (chartId) {
        return $q.resolve(ceres.call('webapi/chartitems/find/ofchart/return/ids', chartId).result);
      };

      this.getPersonalItemsOfChart = function (chartId) {
        return $q.resolve(ceres.call('webapi/chartitems/find/personal/of/chart', chartId).result);
      };

      this.getPersonalItemIdsOfChart = function (chartId) {
        return $q.resolve(ceres.call('webapi/chartitems/find/personal/of/chart/return/ids', chartId).result);
      };

      this.getItemsOfProduction = function (productionId) {
        return $q.resolve(ceres.call('webapi/chartitems/find/ofproduction', productionId).result);
      };

      this.getItemIdsOfProduction = function (productionId) {
        return $q.resolve(ceres.call('webapi/chartitems/find/ofproduction/return/ids', productionId).result);
      };

      this.getItemsOfSetPiece = function (setPieceId) {
        return $q.resolve(ceres.call('webapi/chartitems/find/ofsetpiece', setPieceId).result);
      };

      this.getItemIdsOfSetPiece = function (setPieceId) {
        return $q.resolve(ceres.call('webapi/chartitems/find/ofsetpiece/return/ids', setPieceId).result);
      };

      this.getCountOfProductionPermanentLayer = function (productionId) {
        return $q.resolve(ceres.call('webapi/chartitems/count/ofproduction', productionId).result);
      }

      this.getReferenceCountOfSetPiece = function (setPieceId) {
        return $q.resolve(ceres.call('webapi/chartitems/count/references/of/setpiece', setPieceId).result);
      }

      this.getItemsOfUserChart = function (userChartId) {
        return $q.resolve(ceres.call('webapi/chartitems/find/ofuserchart', userChartId).result);
      };

      this.getItemIdsOfUserChart = function (userChartId) {
        return $q.resolve(ceres.call('webapi/chartitems/find/ofuserchart/return/ids', userChartId).result);
      };

      this.reassignPerformer = function (performerPairsWithIds) {
        swaUtils.clarityEvent('chartitem-reassign-performer');
        return $q.resolve(ceres.call('webapi/chartitems/reassignment/ofperformer', performerPairsWithIds).result);
      };

      this.undoReassignPerformer = function (performerPairsWithIds) {
        swaUtils.clarityEvent('chartitem-undo-reassign-performer');
        return $q.resolve(ceres.call('webapi/chartitems/undo/reassignment/ofperformer', performerPairsWithIds).result);
      };

      this.getChartItemsForPerformer = function (performerId, chartIds) {
        return $q.resolve(ceres.call('webapi/chartitems/find/ofperformer', performerId, chartIds).result);
      };
    }

    return DbChartItems;
  }
}());

(function () {
  'use strict';
  angular.module('swanywhere').controller('VideoSliderController', VideoSliderController);

  VideoSliderController.$inject = [
    '$uibModalInstance',
    '$sce',
    'videos'
  ];

  function VideoSliderController($uibModalInstance, $sce, videos) {
    var vm = this;

    vm.videos = videos;
    vm.modalClose = modalClose;
    vm.trustSrc = trustSrc;

    function trustSrc(src) {
      return $sce.trustAsResourceUrl(src);
    };

    function modalClose() {
      $uibModalInstance.dismiss();
    }
  }
}());

/* global tinymce */
/* eslint-disable */
'use strict';

function placeCaretAtEnd(el) {
  el.focus();
  if (typeof window.getSelection !== 'undefined' &&
    typeof document.createRange !== 'undefined') {
    var range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
  } else if (typeof document.body.createTextRange !== 'undefined') {
    var textRange = document.body.createTextRange();
    textRange.moveToElementText(el);
    textRange.collapse(false);
    textRange.select();
  }
}

function commonEditingShowResizeControls() {
  if (!$('#resizebuttons').is(':visible')) {
    $('#clipboardbuttons').fadeOut(100, function () {
      $('#resizebuttons').fadeIn(200);
    });
  }
}

function commonEditingHideResizeControls() {
  if (!$('#clipboardbuttons').is(':visible')) {

    $('#resizebuttons').fadeOut(100, function () {
      $('#clipboardbuttons').fadeIn(200);
    });
  }
}

function commonEditingUpdateState(controller) {
  var staffCellElement = controller.activeStaffCellElement;
  if (staffCellElement === undefined) {
    controller.staffEditingControlsState.controlsVisible = false;
  } else {
    controller.staffEditingControlsState.controlsVisible = true;
    var isEditing = staffCellElement.hasClass('editing');
    var isSizing = staffCellElement.hasClass('sizing');
    var isNewText = (staffCellElement.attr('data-newcontent') === 'true');
    var isTitle = staffCellElement.hasClass('stafftitlecell');
    var isPerformerHeader = staffCellElement.hasClass('characterheadercell');
    var isText = !(isTitle || isPerformerHeader);
    var hasContent = isText && (staffCellElement.html().length > 0);

    if (isEditing) {
      controller.staffEditingControlsState.clipboardOptionsVisible = true;
      controller.staffEditingControlsState.sizingOptionsVisible = false;
      controller.staffEditingControlsState.editDisabled = true;
      controller.staffEditingControlsState.resizeDisabled = true;
      controller.staffEditingControlsState.deleteDisabled = true;
    } else if (isSizing) {
      controller.staffEditingControlsState.clipboardOptionsVisible = false;
      controller.staffEditingControlsState.sizingOptionsVisible = true;
      controller.staffEditingControlsState.editDisabled = true;
      controller.staffEditingControlsState.resizeDisabled = true;
      controller.staffEditingControlsState.deleteDisabled = true;
    } else {
      controller.staffEditingControlsState.clipboardOptionsVisible = true;
      controller.staffEditingControlsState.sizingOptionsVisible = false;
      if (isTitle) {
        controller.staffEditingControlsState.editDisabled = false;
        controller.staffEditingControlsState.resizeDisabled = true;
        controller.staffEditingControlsState.deleteDisabled = false;
      } else if (isPerformerHeader) {
        controller.staffEditingControlsState.editDisabled = true;
        controller.staffEditingControlsState.resizeDisabled = true;
        controller.staffEditingControlsState.deleteDisabled = false;
      } else {
        controller.staffEditingControlsState.editDisabled = false;
        controller.staffEditingControlsState.resizeDisabled = !hasContent;
        controller.staffEditingControlsState.deleteDisabled = !hasContent;
      }
    }

    controller.staffEditingControlsState.cutDisabled = !(hasContent && !(isNewText || isEditing || isSizing));
    controller.staffEditingControlsState.copyDisabled = !(hasContent && !isNewText && !(isNewText || isEditing || isSizing));
    controller.staffEditingControlsState.pasteDisabled = !(isText && !isSizing);
  }

  controller.updateState();
}

function activateStaffInContainer(controller, staffContainerElement) {

  deactivateActiveStaffContainer(controller);

  controller.activeStaffContainerElement = staffContainerElement;
  controller.activeStaffTableElement = staffContainerElement.find('table.stafftable');

  // Add active class
  staffContainerElement.addClass('activestaff').removeClass('inactivestaff');

  // Attach editing controls
  // staffContainerElement.find('.stafftablecontainer').prepend($('#staffeditingcontrols'));
  var editingControlsContainerJ = $('.staffeditingcontrolscontainer');
  editingControlsContainerJ.css('top', staffContainerElement.position().top - staffContainerElement.parent().position().top + 24);
  editingControlsContainerJ.css('left', staffContainerElement.position().left);
  editingControlsContainerJ.css('width', staffContainerElement.width());
  editingControlsContainerJ.css('height', staffContainerElement.height());
  // editingControlsJ.css('')
  var focusedCell = staffContainerElement.find('.stafftablecontainer td:focus').first();
  if (focusedCell.length === 1) {
    activateCell(controller, focusedCell);
  }

  // Attach handlers
  attachHandlersToActiveStaffElement(controller);

  // Fix borders if required
  fixVoiceRowsBorders(controller);

  // Update editing controls state
  commonEditingUpdateState(controller);
}

function scrollToStaffContainer(controller, staffContainerElement) {
  staffContainerElement = staffContainerElement || controller.activeStaffContainerElement;
  if (staffContainerElement !== undefined) {
    // $('#staffscrollview').parent().scrollTo({left: 0, top: staffContainerElement.position().top}, 200);

    // $('.sw-editorcontent').mCustomScrollbar('scrollTo', staffContainerElement);
    staffContainerElement.get(0).scrollIntoView();
  }
}

function deactivateActiveStaffContainer(controller) {
  endAnyDeleteMoveMode(controller);
  endAnyCellEditingInteraction(controller);

  var staffContainerElement = controller.activeStaffContainerElement;
  if (staffContainerElement === undefined) {
    return;
  }

  clearStaffDirtyFlag(controller, staffContainerElement);

  // detach handlers
  detachHandlersFromActiveStaffElement(controller);

  // remove active class
  staffContainerElement.removeClass('activestaff').addClass('inactivestaff');

  // Move out editing controls
  // $('#templates').prepend($('#staffeditingcontrols'));

  delete controller.activeStaffContainerElement;
  delete controller.activeStaffTableElement;
  delete controller.activeStaffCell;
}

function attachHandlersToActiveStaffElement(controller) {

  var staffContainerElement = controller.activeStaffContainerElement;
  if (staffContainerElement === undefined) {
    return;
  }

  var staffTableElement = controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  // Click handler for staff title cell
  staffTableElement.find('tr.contentrow').on('click', 'th.stafftitlecell, th.characterheadercell', function () {
    var cell = $(this);

    if (cell.is(controller.activeStaffCellElement)) {
      if (cell.hasClass('editing')) {
        cell.children('span').first().focus();
      }

      return;
    }

    endAnyCellEditingInteraction(controller);

    activateCell(controller, cell);
  });

  // Double click handler for staff title cell
  staffTableElement.find('tr.contentrow').on('dblclick', 'th.stafftitlecell', function () {
    var cell = $(this);

    if (cell.hasClass('deletecol')) {
      return;
    }

    if (cell.is(controller.activeStaffCellElement)) {
      if (cell.hasClass('editing')) {
        return;
      } else {
        beginEditingCell(controller, cell);
      }
    } else {
      endAnyCellEditingInteraction(controller);

      activateCell(controller, cell);

      beginEditingCell(controller, cell);
    }
  });

  // Click handler for content cells
  staffTableElement.find('tr.contentrow').on('click', 'td', function () {
    var cell = $(this);

    if (cell.is(controller.activeStaffCellElement)) {
      if (cell.hasClass('editing')) {
        cell.children('div').first().focus();
      }

      return;
    }

    endAnyCellEditingInteraction(controller);

    activateCell(controller, cell);
  });

  // Double click handler for content cells
  staffTableElement.find('tr.contentrow').on('dblclick', 'td', function () {
    var cell = $(this);

    if (cell.hasClass('deletecol')) {
      return;
    }

    if (cell.is(controller.activeStaffCellElement)) {
      if (cell.hasClass('editing')) {
        return;
      } else {
        beginEditingCell(controller, cell);
      }
    } else {
      endAnyCellEditingInteraction(controller);

      activateCell(controller, cell);

      beginEditingCell(controller, cell);
    }
  });

  // keydown handler for content cells
  staffTableElement.find('tr.contentrow').on('keydown', 'td', function (event) {
    var cell = $(this);

    var whichKey = event.which;
    var ctrlKey = event.ctrlKey;
    var metaKey = event.metaKey;
    var shiftKey = event.shiftKey;
    var keyHandled = false;

    if (cell.hasClass('sizing')) {
      if (whichKey === 39) {
        if (shiftKey) {
          sizeActiveCell(controller, 'left', 1);
        } else {
          sizeActiveCell(controller, 'right', 1);
        }
        keyHandled = true;
      } else if (whichKey === 37) {
        if (shiftKey) {
          sizeActiveCell(controller, 'left', -1);
        } else {
          sizeActiveCell(controller, 'right', -1);
        }
        keyHandled = true;
      } else if ((whichKey === 27) || (whichKey === 13) || (whichKey === 69)) {
        endResizing(controller, true);
        keyHandled = true;
      }
    } else {
      // clipboard key check
      if (!keyHandled && (ctrlKey || metaKey)) {
        if ((whichKey === 88) && !controller.staffEditingControlsState.cutDisabled) {
          controller.staffEditingCutCell();
          activateCell(controller, cell);
          keyHandled = true;
        } else if ((whichKey === 67) && !controller.staffEditingControlsState.copyDisabled) {
          controller.staffEditingCopyCell();
          keyHandled = true;
        } else if ((whichKey === 86) && !controller.staffEditingControlsState.pasteDisabled) {
          controller.staffEditingPasteCell();
          keyHandled = true;
        }
      }

      if (!cell.hasClass('editing') && !keyHandled) {
        // movement key check (arrow keys)
        var nextCell;
        if (whichKey === 39) {
          nextCell = cell.nextAll('td:not(.hidden)').first();
        } else if (whichKey === 37) {
          nextCell = cell.prevAll('td:not(.hidden)').first();
        } else if (whichKey === 38) {
          var index = cell.prevAll('td').length + 1;
          var prevRow = cell.parent('tr').prevAll('tr.contentrow').first();
          if ((prevRow.length > 0) && !prevRow.hasClass('layoutrow')) {
            nextCell = prevRow.find('td:nth-of-type(' + index + ')');
            if (nextCell.hasClass('hidden')) {
              nextCell = nextCell.prevAll('td:not(.hidden)').first();
            }
          }
        } else if (whichKey === 40) {
          var index = cell.prevAll('td').length + 1;
          var nextRow = cell.parent('tr').nextAll('tr.contentrow').first();
          if (nextRow.length > 0) {
            nextCell = nextRow.find('td:nth-of-type(' + index + ')');
            if (nextCell.hasClass('hidden')) {
              nextCell = nextCell.prevAll('td:not(.hidden)').first();
            }
          }
        }

        if (nextCell && nextCell.length === 1) {

          keyHandled = true;

          endAnyCellEditingInteraction(controller);

          activateCell(controller, nextCell);
        }

        // editing key check
        if (!keyHandled) {
          if ((whichKey === 13) || (whichKey === 69)) {
            beginEditingCell(controller, cell);
            keyHandled = true;
          } else if (whichKey === 82) {
            beginResizingActiveCell(controller);
            keyHandled = true;
          } else if ((whichKey === 8) || (whichKey === 46)) {
            deleteActiveCell(controller);
            activateCell(controller, cell);
            keyHandled = true;
          } else if (whichKey === 27) {
            deactivateAnyActiveCell(controller);
            keyHandled = true;
          }
        }
      }
    }

    if (keyHandled) {
      event.stopPropagation();
      event.preventDefault();
    }
  });

  // Click handler for character collapse button
  staffTableElement.find('tr.characterrow th.collapsecol').on('click', 'span.staffcollapsebutton', function () {
    if (controller.staffEditorState.deleteMoveCharacterMode) {
      return;
    }

    var btn = $(this);
    var characterRow1 = btn.parents('tr.characterrow');

    var isCollapsed = parseInt(characterRow1.attr('data-charactercollapsed') || '0');
    var rowsPerCharacter = parseInt(staffTableElement.attr('data-rowspercharacter'));

    var detailRowN = characterRow1;
    var fadeTime = 50;
    if (isCollapsed === 1) {
      characterRow1.nextAll('*:lt(' + (rowsPerCharacter - 1) + ')').each(function (index) {
        $(this).fadeIn(fadeTime + (index * 50));
      });

      btn.removeClass('ion-ios-arrow-right').addClass('ion-ios-arrow-down');
      characterRow1.removeAttr('data-charactercollapsed');
      characterRow1.removeClass('collapsedrow');
    } else {
      var rowsToCollapse = characterRow1.nextAll('*:lt(' + (rowsPerCharacter - 1) + ')');
      var activeInCollapsed = (rowsToCollapse.find('td.active').size() > 0);
      var editingInCollapsed = (rowsToCollapse.find('td.editing').size() > 0);
      var sizingInCollapsed = (rowsToCollapse.find('td.sizing').size() > 0);

      if (editingInCollapsed || sizingInCollapsed) {
        endAnyCellEditingInteraction(controller);
      }

      if (activeInCollapsed) {
        deactivateAnyActiveCell(controller);
      }

      characterRow1.nextAll('*:lt(' + (rowsPerCharacter - 1) + ')').each(function (index) {
        $(this).fadeOut(fadeTime + ((rowsPerCharacter - index) * 50));
      });

      btn.removeClass('ion-ios-arrow-down').addClass('ion-ios-arrow-right');
      characterRow1.attr('data-charactercollapsed', 1);
      characterRow1.addClass('collapsedrow');
    }

    markActiveStaffDirty(controller);
  });

  staffContainerElement.find('#buttoncountminus').on('click', function () {
    if (controller.activeAccessRules.allowdeletecount) {
      endAnyCellEditingInteraction(controller);
      endAnyDeleteMoveMode(controller);

      deleteCount(controller);

      markActiveStaffDirty(controller);
    }
  });

  staffContainerElement.find('#buttoncountplus').on('click', function () {
    if (controller.activeAccessRules.allowaddcount) {
      endAnyCellEditingInteraction(controller);
      endAnyDeleteMoveMode(controller);

      addCount(controller);

      markActiveStaffDirty(controller);
    }
  });

  staffContainerElement.find('#buttoncharacteradd').on('click', function () {
    if (controller.activeAccessRules.allowaddcharacterrow) {
      if (controller.performerFilterEnabled) {
        return;
      }

      endAnyCellEditingInteraction(controller);
      endAnyDeleteMoveMode(controller);

      addCharacterRow(controller);

      markActiveStaffDirty(controller);
    }
  });

  staffContainerElement.find('#buttoncharacterdelete').on('click', function () {
    if (controller.activeAccessRules.allowdeletecharacterrow) {
      toggleDeleteMoveCharacterMode(controller);
    }
  });

  staffContainerElement.find('#buttonvoiceadd').on('click', function () {
    if (controller.activeAccessRules.allowaddvoicerow) {
      endAnyCellEditingInteraction(controller);
      endAnyDeleteMoveMode(controller);

      addVoiceRowPairToStaffTable(controller);

      markActiveStaffDirty(controller);
    }
  });

  staffContainerElement.find('#buttonvoicedelete').on('click', function () {
    if (controller.activeAccessRules.allowdeletevoicerow) {
      toggleDeleteMoveVoiceMode(controller);
    }
  });
}

function detachHandlersFromActiveStaffElement(controller) {
  var staffContainerElement = controller.activeStaffContainerElement;
  if (staffContainerElement !== undefined) {
    staffContainerElement.find('#buttoncountminus').off();
    staffContainerElement.find('#buttoncountplus').off();
    staffContainerElement.find('#buttoncharacteradd').off();
    staffContainerElement.find('#buttoncharacterdelete').off();
    staffContainerElement.find('#buttonvoiceadd').off();
    staffContainerElement.find('#buttonvoicedelete').off();
  }

  var staffTableElement = controller.activeStaffTableElement;
  if (staffTableElement !== undefined) {
    staffTableElement.find('tr.contentrow').off();
    staffTableElement.find('tr.characterrow th.collapsecol').off();
  }
}

function activateCell(controller, staffCellElement) {
  if (staffCellElement.hasClass('deletecol')) {
    return;
  }

  if (controller.activeStaffCellElement === undefined) {
    endAnyDeleteMoveMode(controller);
  }

  staffCellElement.addClass('active').focus();

  controller.activeStaffCellElement = staffCellElement;

  if (staffCellElement.hasClass('characterheadercell')) {
    activatePerformerHeaderCell(controller, staffCellElement);
  }

  positionAccessoryButtons(controller, staffCellElement);

  commonEditingUpdateState(controller);
}

function positionAccessoryButtons(controller, staffCellElement) {
  $('.staffeditingcontrols').css('top', ((staffCellElement.position().top / controller.staffViewScale) - 16));
}

function activatePerformerHeaderCell(controller, staffCellElement) {
  var performerId = staffCellElement.children('span').first().attr('data-performerId');
  var staffId = staffCellElement.parents('div.staffcontainer').first().attr('data-staffid');

  staffCellElement.children('span').hide();
  controller.embedPerformerPicker(staffCellElement, performerId);
}

function deactivateAnyActiveCell(controller) {
  if (controller.activeStaffCellElement !== undefined) {
    controller.activeStaffCellElement.removeClass('active').blur();

    if (controller.activeStaffCellElement.hasClass('characterheadercell')) {
      deactivatePerformerHeaderCell(controller, controller.activeStaffCellElement);
    }
  }

  delete controller.activeStaffCellElement;

  commonEditingUpdateState(controller);
}

function deactivatePerformerHeaderCell(controller, staffCellElement) {
  staffCellElement.children('span').show();
  staffCellElement.children('select').remove();
}

function moveCaretToEnd(contentEditableElement) {
  if (document.createRange) {
    var range = document.createRange(); //Create a range (a range is a like the selection but invisible)
    range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
    range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
    var selection = window.getSelection(); //get the selection object (allows you to change selection)
    selection.removeAllRanges(); //remove any selections already made
    selection.addRange(range); //make the range you have just created the visible selection
  }
}

function beginEditingCell(controller, staffCellElement) {
  controller.activeStaffCellElement = controller.activeStaffCellElement || staffCellElement;

  var editingStaffCellElement = controller.activeStaffCellElement;

  if (editingStaffCellElement === undefined) {
    return;
  }

  if (editingStaffCellElement.hasClass('sizing')) {
    return;
  }

  if (editingStaffCellElement.hasClass('editing')) {
    return;
  }

  // activate if not
  if (!editingStaffCellElement.hasClass('active')) {
    editingStaffCellElement.addClass('active');
    positionAccessoryButtons(editingStaffCellElement);
  }

  // show cell as being edited
  editingStaffCellElement.addClass('editing');

  // Handle specific cell case
  if (editingStaffCellElement.hasClass('stafftitlecell')) {
    beginEditingTitleCell(controller, editingStaffCellElement);
  } else {
    beginEditingContentCell(controller, editingStaffCellElement);
  }

  commonEditingUpdateState(controller);
}

function beginEditingTitleCell(controller, editingStaffCellElement) {
  var contentSpanElement = editingStaffCellElement.children('span.stafftitle').first();
  var customTitle = contentSpanElement.attr('data-customtitle');
  contentSpanElement.attr('data-customtitle-old', customTitle);
  if ((customTitle === undefined) || (customTitle === null) || (customTitle.length === 0)) {
    contentSpanElement.text('');
  }

  $(contentSpanElement).on('keydown', function (event) {
    if (event.which === 13) {
      if (event.shiftKey) {
        $(this).focus();
      } else {
        event.stopPropagation();
        event.preventDefault();
        endEditing(controller, false);
      }
    } else if (event.which === 27) {
      event.stopPropagation();
      event.preventDefault();
      endEditing(controller, false);
    }
  });

  contentSpanElement.attr('contenteditable', true);
  contentSpanElement.blur();
  contentSpanElement.focus();
  moveCaretToEnd(contentSpanElement.get(0));
}

function beginEditingContentCell(controller, editingStaffCellElement) {
  // Check if we are adding content
  if (editingStaffCellElement.is(':empty')) {
    // find  max possible colspan
    var maxColSpan = 1; // we will at least have a colspan of 1
    var nextCells = editingStaffCellElement.nextAll();
    $(nextCells).each(function (i) {
      if ($(this).html()) {
        return false;
      } else {
        $(this).addClass('hidden');
        maxColSpan++;
      }
    });

    editingStaffCellElement.attr('colspan', maxColSpan);
    editingStaffCellElement.attr('data-newcontent', true);
    editingStaffCellElement.html('<div class="text" style="display: inline-block;"></div>');
  }

  var editorContainerElement = editingStaffCellElement.children('div.text').first();
  editingStaffCellElement.attr('data-oldcontent', editorContainerElement.text());
  $(editorContainerElement).on('keydown', function (event) {
    if (event.which === 13) {
      if (event.shiftKey) {
        // $(this).focus();
      } else {
        event.stopPropagation();
        event.preventDefault();
        endEditing(controller, true);
      }
    } else if (event.which === 27) {
      event.stopPropagation();
      event.preventDefault();
      endEditing(controller, true);
    }
  });

  editorContainerElement.addClass('richeditingcontentcell');
  initCustomTinyMCE(controller, editorContainerElement, function (editor) {
    editorContainerElement.blur();
    editorContainerElement.focus();
    editor.on('PostProcess', function (e) {
      e.content = e.content.replace('&#65279;', '');
    });
  });
}

function endEditing(controller, keepActive) {
  var staffCellElement = controller.activeStaffCellElement;
  if (staffCellElement === undefined) {
    return false;
  }

  if (!staffCellElement.hasClass('editing')) {
    return false;
  }

  staffCellElement.removeClass('editing');

  // Handle specific cell case
  if (staffCellElement.hasClass('stafftitlecell')) {
    endEditingTitleCell(controller, staffCellElement);
  } else if (staffCellElement.hasClass('characterheadercell')) {
    endEditingPerformerHeaderCell(controller, staffCellElement);
  } else {
    endEditingContentCell(controller, staffCellElement);
  }

  if (keepActive) {
    staffCellElement.addClass('active').focus();
  } else {
    deactivateAnyActiveCell(controller);
  }

  commonEditingUpdateState(controller);
  return keepActive;
}

function endEditingTitleCell(controller, staffCellElement) {
  var contentSpanElement = staffCellElement.children('span.stafftitle').first();
  contentSpanElement.attr('contenteditable', false);
  contentSpanElement.blur();
  $(contentSpanElement).off('keydown');

  var staffId = staffCellElement.parents('div.staffcontainer').first().attr('data-staffid');

  var content = sanitizeText(contentSpanElement.text());
  if (content.length === 0) {
    if (contentSpanElement.attr('data-customtitle-old') !== undefined) {
      markActiveStaffDirty(controller);
    }

    contentSpanElement.removeAttr('data-customtitle');
    contentSpanElement.removeAttr('data-customtitle-old');
    contentSpanElement.text(controller.getDefaultStaffTitleForStaffId(staffId));
  } else {
    contentSpanElement.attr('data-customtitle', content);
    if (contentSpanElement.attr('data-customtitle-old') !== content) {
      markActiveStaffDirty(controller);
    }
  }
}

function endEditingPerformerHeaderCell(controller, staffCellElement) {
  staffCellElement.children('span').show();
  staffCellElement.children('select').remove();
}

function endEditingContentCell(controller, staffCellElement) {
  var editorContainerElement = staffCellElement.children('div').first();
  editorContainerElement.attr('contenteditable', false);
  editorContainerElement.attr('tabindex', null);
  editorContainerElement.blur();
  $(editorContainerElement).off('keydown');
  editorContainerElement.removeClass('richeditingcontentcell');

  var isNewContent = (staffCellElement.attr('data-newcontent') === 'true');
  var content = '';
  var mceEditor = tinyMCE.get(editorContainerElement.attr('id'));
  if (mceEditor) {
    content = mceEditor.getContent();
  } else {
    content = editorContainerElement.html().replace(/(data-mce-.*?=".*?")/ig, '');
    content = content.replace(/(<br.*?>)/ig, '<br/>');
  }
  var contentText = sanitizeText(editorContainerElement.text());

  destroyTinyMCEInstance();
  editorContainerElement.html(content);
  if (contentText.length === 0) {
    staffCellElement.empty();
    var maxColSpan = parseInt(staffCellElement.attr('colspan'));
    var nextCells = staffCellElement.nextAll();
    for (var i = 0; i < maxColSpan; i++) {
      $(nextCells[i]).removeClass('hidden');
    }

    staffCellElement.removeAttr('colspan');

    if (!isNewContent) {
      markActiveStaffDirty(controller);
    }
  } else {
    if (isNewContent) {
      // Get reference cell width
      var refWidth = staffCellElement.width();
      var refColSpan = parseInt(staffCellElement.attr('colspan'));
      if (refColSpan > 1) {
        refWidth = (refWidth - refColSpan + 1) / refColSpan;
      }

      // Get content width
      var contentWidth = editorContainerElement.width() + 1;

      // Find colspans required
      var reqdColSpan = Math.ceil(contentWidth / refWidth);

      // Update if needed
      var colSpan = parseInt(staffCellElement.attr('colspan'));
      var maxColSpan = colSpan;

      if (reqdColSpan < maxColSpan) {
        colSpan = reqdColSpan;
        var nextCells = staffCellElement.nextAll();
        for (var i = (colSpan - 1); i < maxColSpan; i++) {
          $(nextCells[i]).removeClass('hidden');
        }

        staffCellElement.attr('colspan', colSpan);
      }

      markActiveStaffDirty(controller);
    } else {
      var oldContent = staffCellElement.attr('data-oldcontent');
      if (oldContent !== content) {
        markActiveStaffDirty(controller);
      }
    }
  }

  editorContainerElement.css('display', '');

  staffCellElement.removeAttr('data-oldcontent');
  staffCellElement.removeAttr('data-newcontent');

  var containerRow = staffCellElement.parents('tr');
  fixCountBorders(controller, containerRow);
}

function sanitizeText(text) {
  // text = text.trim();

  // TODO: more sanitization when content is HTML

  return text;
}

function deleteActiveCell(controller) {
  var staffCellElement = controller.activeStaffCellElement;
  if (staffCellElement === undefined) {
    return;
  }

  // Handle specific cell case
  if (staffCellElement.hasClass('stafftitlecell')) {
    deleteTitleCell(controller, staffCellElement);
  } else if (staffCellElement.hasClass('characterheadercell')) {
    deletePerformerHeaderCell(controller, staffCellElement);
  } else {
    deleteContentCell(controller, staffCellElement);
  }

  deactivateAnyActiveCell(controller);
}

function deleteTitleCell(controller, staffCellElement) {
  var contentSpanElement = staffCellElement.children('span.stafftitle').first();

  var staffId = staffCellElement.parents('div.staffcontainer').first().attr('data-staffid');

  if (contentSpanElement.attr('data-customtitle') !== undefined) {
    markActiveStaffDirty(controller);
  }

  contentSpanElement.removeAttr('data-customtitle');
  contentSpanElement.text(controller.getDefaultStaffTitleForStaffId(staffId));
}

function deletePerformerHeaderCell(controller, staffCellElement) {
  var spanElement = staffCellElement.children('span').first();

  if (spanElement.attr('data-performerId') !== undefined) {
    markActiveStaffDirty(controller);
  }

  // clear the performer ID
  spanElement.removeAttr('data-performerId');

  restoreDefaultPerformerHeaderContent(controller, staffCellElement);
}

function deleteContentCell(controller, staffCellElement) {
  if (!staffCellElement.is(':empty')) {
    markActiveStaffDirty(controller);
  }

  staffCellElement.attr('colspan', 1);
  staffCellElement.empty();

  var nextCells = staffCellElement.nextAll();
  $(nextCells).each(function () {
    if ($(this).html()) {
      return false;
    } else {
      $(this).removeClass('hidden');
    }
  });

  var containerRow = staffCellElement.parents('tr');
  fixCountBorders(controller, containerRow);
}

function restoreDefaultPerformerHeaderContent(controller, staffCellElement) {
  // Assign default name
  var numPrevCharacterRows = staffCellElement.parent().prevAll('.characterrow').length;
  var rowsPerCharacter = parseInt(staffCellElement.parents('table.stafftable').first().attr('data-rowspercharacter'));
  var defaultPerformerName = '<Character ' + ((numPrevCharacterRows / rowsPerCharacter) + 1) + '>';

  staffCellElement.children('span').text(defaultPerformerName);
}

function beginResizingActiveCell(controller) {
  var staffCellElement = controller.activeStaffCellElement;
  if (staffCellElement === undefined) {
    return;
  }

  if (staffCellElement.hasClass('sizing')) {
    return;
  }

  if (staffCellElement.html().length === 0) {
    return;
  }

  // show cell as being edited
  staffCellElement.removeClass('active').addClass('sizing');

  // add sizing overlay
  staffCellElement.parents('div.stafftablecontainer').append('<div class="sizing-overlay"><div class="left-handle"></div><div class="right-handle"></div></div>');

  // find  max possible colspan
  staffCellElement.attr('data-maxcolspan', staffCellElement.nextUntil('td:not(:empty)').length + 1);

  // find column index and min possible column index
  var colIndex = staffCellElement.prevAll('td').length;
  var minColIndex = colIndex - staffCellElement.prevUntil('td:not(:empty)', 'td:not(.hidden)').length;
  staffCellElement.attr('data-colindex', colIndex);
  staffCellElement.attr('data-mincolindex', minColIndex);

  updateSizingOverlay(controller);
  attachSizingHandlers(controller);

  staffCellElement.focus();

  commonEditingUpdateState(controller);
}

var sizingState = {};

function attachSizingHandlers(controller) {
  var sizingOverlayJ = $('.sizing-overlay');

  $('.sizing-overlay .right-handle').on('mousedown', {
    controller: controller
  }, sizingRightMouseDownHandler);
  $('.sizing-overlay .left-handle').on('mousedown', {
    controller: controller
  }, sizingLeftMouseDownHandler);
}

function detachSizingHandlers(controller) {
  $('.sizing-overlay .right-handle').off();
}

function sizingRightMouseDownHandler(event) {
  event.preventDefault();
  event.stopPropagation();

  var sizingJ = $('td.sizing');

  sizingState.originalColSpan = parseInt(sizingJ.attr('colspan') || 1);
  sizingState.unitCellWidth = sizingJ.width() / sizingState.originalColSpan;
  sizingState.maxColSpan = parseInt(sizingJ.attr('data-maxcolspan') || 1);

  sizingState.mouseDownX = event.screenX;

  $(document).on('mousemove', {
    controller: event.data.controller
  }, sizingRightMouseMoveHandler);
  $(document).on('mouseup', {
    controller: event.data.controller
  }, sizingRightMouseUpHandler);
}

function sizingRightMouseMoveHandler(event) {
  var newWidth = event.screenX - sizingState.mouseDownX;
  var newColSpan = Math.round(sizingState.originalColSpan + (newWidth / sizingState.unitCellWidth));

  if (newColSpan < 1) {
    return;
  }

  if (newColSpan > sizingState.maxColSpan) {
    return;
  }

  var controller = event.data.controller;

  if (newColSpan < sizingState.currentColSpan) {
    sizeActiveCell(controller, 'right', -1);
  } else if (newColSpan > sizingState.currentColSpan) {
    sizeActiveCell(controller, 'right', 1);
  }
}

function sizingRightMouseUpHandler(event) {
  $(document).off('mousemove', sizingRightMouseMoveHandler);
  $(document).off('mouseup', sizingRightMouseUpHandler);
}

function sizingLeftMouseDownHandler(event) {
  event.preventDefault();
  event.stopPropagation();

  var sizingJ = $('td.sizing');

  var colIndex = parseInt(sizingJ.attr('data-colindex'));
  var minColIndex = parseInt(sizingJ.attr('data-mincolindex'));

  sizingState.originalColSpan = parseInt(sizingJ.attr('colspan') || 1);
  sizingState.unitCellWidth = sizingJ.width() / sizingState.originalColSpan;
  sizingState.maxColSpan = parseInt(sizingJ.attr('data-maxcolspan') || 1) + (colIndex - minColIndex);

  sizingState.mouseDownX = event.screenX;

  $(document).on('mousemove', {
    controller: event.data.controller
  }, sizingLeftMouseMoveHandler);
  $(document).on('mouseup', {
    controller: event.data.controller
  }, sizingLeftMouseUpHandler);
}

function sizingLeftMouseMoveHandler(event) {
  var newWidth = sizingState.mouseDownX - event.screenX;
  var newColSpan = Math.round(sizingState.originalColSpan + (newWidth / sizingState.unitCellWidth));

  if (newColSpan < 1) {
    return;
  }

  if (newColSpan > sizingState.maxColSpan) {
    return;
  }

  var controller = event.data.controller;

  if (newColSpan > sizingState.currentColSpan) {
    sizeActiveCell(controller, 'left', -1);
  } else if (newColSpan < sizingState.currentColSpan) {
    sizeActiveCell(controller, 'left', 1);
  }
}

function sizingLeftMouseUpHandler(event) {
  $(document).off('mousemove', sizingLeftMouseMoveHandler);
  $(document).off('mouseup', sizingLeftMouseUpHandler);
}

function updateSizingOverlay(controller) {
  var staffCellElement = controller.activeStaffCellElement;
  if (staffCellElement === undefined) {
    return false;
  }

  var sizingOverlayJ = $('.sizing-overlay');

  var sizingOffset = staffCellElement.offset();
  sizingOverlayJ.offset({
    top: sizingOffset.top,
    left: (sizingOffset.left - 2)
  });
  sizingOverlayJ.width(staffCellElement.width() + 2);
  sizingOverlayJ.height(staffCellElement.height());

  sizingState.currentColSpan = parseInt(staffCellElement.attr('colspan')) || 1;
}

function endResizing(controller, keepActive) {
  var staffCellElement = controller.activeStaffCellElement;
  if (staffCellElement === undefined) {
    return false;
  }

  if (!staffCellElement.hasClass('sizing')) {
    return false;
  }

  // remove overlay
  $('.sizing-overlay').remove();
  detachSizingHandlers();

  staffCellElement.removeClass('sizing');
  staffCellElement.removeAttr('data-mincolindex data-maxcolspan data-colindex');

  var containerRow = staffCellElement.parents('tr');
  fixCountBorders(controller, containerRow);

  if (keepActive) {
    staffCellElement.addClass('active').focus();
  } else {
    deactivateAnyActiveCell(controller);
  }

  commonEditingUpdateState(controller);

  return keepActive;
}

function sizeActiveCell(controller, side, delta) {
  var staffCellElement = controller.activeStaffCellElement;
  if (staffCellElement === undefined) {
    return false;
  }

  var staffTableElement = controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return false;
  }

  var columnsPerCount = parseInt(staffTableElement.attr('data-columnspercount'));

  if (side === 'right') {
    var currentColSpan = parseInt(staffCellElement.attr('colspan') || '1');
    var maxColSpan = parseInt(staffCellElement.attr('data-maxcolspan') || '1');
    if (delta > 0) {
      if (currentColSpan < maxColSpan) {
        markActiveStaffDirty(controller);

        currentColSpan += 1;
        var nextCells = staffCellElement.nextAll();
        $(nextCells[currentColSpan - 2]).addClass('hidden');
      }
    } else {
      if (currentColSpan > 1) {
        markActiveStaffDirty(controller);

        currentColSpan -= 1;
        var nextCells = staffCellElement.nextAll();
        $(nextCells[currentColSpan - 1]).removeClass('hidden');
      }
    }

    staffCellElement.attr('colspan', currentColSpan);
  } else if (side === 'left') {
    if (delta > 0) {
      var colSpan = parseInt(staffCellElement.attr('colspan') || '1');

      if (colSpan > 1) {
        markActiveStaffDirty(controller);

        var content = staffCellElement.html();
        var colIndex = parseInt(staffCellElement.attr('data-colindex'));
        var minColIndex = parseInt(staffCellElement.attr('data-mincolindex'));
        var maxColSpan = parseInt(staffCellElement.attr('data-maxcolspan'));

        staffCellElement.empty();
        staffCellElement.removeAttr('colspan data-maxcolspan data-colindex data-mincolindex');
        staffCellElement.removeClass('sizing');
        if (((colIndex + 1) % columnsPerCount) === 0) {
          staffCellElement.addClass('countborder');
        } else {
          staffCellElement.removeClass('countborder');
        }

        colSpan -= 1;
        maxColSpan -= 1;
        colIndex += 1;

        var nextCell = staffCellElement.next();
        nextCell.html(content);
        nextCell.attr('colspan', colSpan);
        nextCell.attr('data-maxcolspan', maxColSpan);
        nextCell.attr('data-colindex', colIndex);
        nextCell.attr('data-mincolindex', minColIndex);
        nextCell.addClass('sizing');
        nextCell.removeClass('hidden');

        staffCellElement = nextCell;
        controller.activeStaffCellElement = staffCellElement;
      }

    } else {
      var colIndex = parseInt(staffCellElement.attr('data-colindex'));
      var minColIndex = parseInt(staffCellElement.attr('data-mincolindex'));

      if (colIndex > minColIndex) {
        markActiveStaffDirty(controller);

        var content = staffCellElement.html();
        var colSpan = parseInt(staffCellElement.attr('colspan') || '1');
        var maxColSpan = parseInt(staffCellElement.attr('data-maxcolspan'));

        colSpan += 1;
        maxColSpan += 1;
        colIndex -= 1;

        staffCellElement.empty();
        staffCellElement.removeAttr('colspan data-maxcolspan data-colindex data-mincolindex');
        staffCellElement.addClass('hidden').removeClass('sizing');

        var prevCell = staffCellElement.prev();
        prevCell.html(content);
        prevCell.attr('colspan', colSpan);
        prevCell.attr('data-maxcolspan', maxColSpan);
        prevCell.attr('data-colindex', colIndex);
        prevCell.attr('data-mincolindex', minColIndex);
        prevCell.addClass('sizing');

        staffCellElement = prevCell;
        controller.activeStaffCellElement = staffCellElement;
      }
    }
  }

  updateSizingOverlay(controller);
  staffCellElement.focus();
}

function endAnyCellEditingInteraction(controller, keepActive) {
  keepActive = keepActive || false;
  if (!endEditing(controller, keepActive)) {
    if (!endResizing(controller, keepActive)) {
      deactivateAnyActiveCell(controller);
    }
  }
}

function cutActiveCell(controller) {
  var staffCellElement = controller.activeStaffCellElement;
  if (staffCellElement === undefined) {
    return false;
  }

  if (copyActiveCell(controller)) {
    deleteActiveCell(controller);

    staffCellElement.focus();

    return true;
  } else {
    staffCellElement.focus();

    return false;
  }
}

function copyActiveCell(controller) {
  var staffCellElement = controller.activeStaffCellElement;
  if (staffCellElement === undefined) {
    return false;
  }

  var textContent = staffCellElement.children('div').first().text().trim();
  var htmlContent = staffCellElement.children('div').first().html();
  if (textContent.length > 0) {
    var colSpan = parseInt(staffCellElement.attr('colSpan') || 1);

    controller.staffClipboard.hasContent = true;
    //    controller.staffClipboard.textContent = textContent;
    controller.staffClipboard.textContent = htmlContent;
    controller.staffClipboard.colSpan = colSpan;

    staffCellElement.focus();

    return true;
  } else {
    controller.staffClipboard.hasContent = false;

    staffCellElement.focus();

    return false;
  }
}

function pasteInActiveCell(controller) {
  var staffCellElement = controller.activeStaffCellElement;
  if (staffCellElement === undefined) {
    return false;
  }

  if (!controller.staffClipboard.hasContent) {
    return;
  }

  if (staffCellElement.is(':empty')) {
    staffCellElement.html('<div class="text"></div>');
    var targetColSpan = controller.staffClipboard.colSpan;
    staffCellElement.children('div').first().html(controller.staffClipboard.textContent);
    beginResizingActiveCell(controller);
    for (var i = 1; i < targetColSpan; i++) {
      sizeActiveCell(controller, 'right', 1);
    }
    endResizing(controller, true);
  } else {
    var divElement = staffCellElement.children('div.text').first();
    // divElement.text(divElement.text() + controller.staffClipboard.textContent);
    divElement.append($.parseHTML(controller.staffClipboard.textContent));
  }

  staffCellElement.focus();
}

function addCount(controller, staffTableElement) {
  staffTableElement = staffTableElement || controller.activeStaffTableElement;
  // var currCount = staffTableElement.find('tr.staticrow th.countindex').length;
  var currCount = parseInt(staffTableElement.attr('data-currentcount')) || parseInt(staffTableElement.attr('data-defaultcount'));
  if (currCount === 12) {
    return;
  }

  var columnsPerCount = parseInt(staffTableElement.attr('data-columnspercount'));

  // staffTableElement.removeClass('stafftable-' + columnsPerCount + '-' + currCount);
  staffTableElement.removeClass('stafftable-count-' + currCount);

  staffTableElement.find('tr.staticrow').each(function () {
    var cells = $(this).find('th:nth-last-child(-n+' + columnsPerCount + ')').clone();
    var nextCount = currCount + 1;
    $(cells[0]).html(nextCount);
    $(this).append(cells);
  });

  staffTableElement.find('tr.contentrow').each(function () {
    var cells = $(this).find('td:nth-last-child(-n+' + columnsPerCount + ')').clone();
    $(cells).each(function () {
      $(this).empty();
      $(this).removeAttr('colspan');
      $(this).removeClass('hidden').removeClass('countborder');
    });

    cells.last().addClass('countborder');

    $(this).append(cells);
  });

  staffTableElement.attr('data-currentcount', (currCount + 1));
  // staffTableElement.addClass('stafftable-' + columnsPerCount + '-' + (currCount + 1));
  staffTableElement.addClass('stafftable-count-' + (currCount + 1));
}

function deleteCount(controller, staffTableElement) {
  staffTableElement = staffTableElement || controller.activeStaffTableElement;
  // var currCount = staffTableElement.find('tr.staticrow th.countindex').length;
  var currCount = parseInt(staffTableElement.attr('data-currentcount')) || parseInt(staffTableElement.attr('data-defaultcount'));
  if (currCount === 1) {
    return;
  }

  var columnsPerCount = parseInt(staffTableElement.attr('data-columnspercount'));
  var maxCells = (currCount - 1) * columnsPerCount;

  // staffTableElement.removeClass('stafftable-' + columnsPerCount + '-' + currCount);
  staffTableElement.removeClass('stafftable-count-' + currCount);

  // Adjust spans of content cells falling in columns to be deleted
  staffTableElement.find('tr.contentrow td:has(div)').each(function (index, element) {
    var colspan = parseInt($(this).attr('colspan') || '1');
    var column = $(this).prevAll('td').length;
    if ((column + colspan) > maxCells) {
      colspan = maxCells - column;
      $(this).attr('colspan', colspan);
      fixCountBorders(controller, $(this).parent('tr'), columnsPerCount);
    }
  });

  staffTableElement.find('tr.staticrow').each(function () {
    $(this).find('th:nth-last-child(-n+' + columnsPerCount + ')').remove();
  });

  staffTableElement.find('tr.contentrow').each(function () {
    $(this).find('td:nth-last-child(-n+' + columnsPerCount + ')').remove();
  });

  staffTableElement.attr('data-currentcount', (currCount - 1));
  // staffTableElement.addClass('stafftable-' + columnsPerCount + '-' + (currCount - 1));
  staffTableElement.addClass('stafftable-count-' + (currCount - 1));
}

function addCharacterRow(controller, staffTableElement) {
  staffTableElement = staffTableElement || controller.activeStaffTableElement;
  var rowsPerCharacter = parseInt(staffTableElement.attr('data-rowspercharacter'));
  var columnsPerCount = parseInt(staffTableElement.attr('data-columnspercount'));
  var staffType = staffTableElement.attr('data-stafftype');
  var currCount = parseInt(staffTableElement.attr('data-currentcount')) || parseInt(staffTableElement.attr('data-defaultcount'));

  var nextOrderingIndex = (staffTableElement.find('tr.characterrow').length / rowsPerCharacter) + 1;
  // get a copy of the rows to add from the staff's template
  var staffTemplateJ = controller.getStaffTemplateForStaffType(staffType);
  var staffTemplateTableElement = staffTemplateJ.find('table.stafftable');
  // Adjust count columns of new rows to match the staff's current count
  var templateCounts = parseInt(staffTemplateTableElement.attr('data-defaultcount'));
  if (currCount > templateCounts) {
    for (var i = 0; i < (currCount - templateCounts); i++) {
      addCount(controller, staffTemplateTableElement);
    }
  } else {
    for (var i = 0; i < (templateCounts - currCount); i++) {
      deleteCount(controller, staffTemplateTableElement);
    }
  }
  // Get a copy of the rows from the template
  var newRows = staffTemplateTableElement.find('tr:nth-last-child(' + (rowsPerCharacter + 1) + ')').nextAll().clone(true);
  // var newRows = staffTableElement.find('tr:nth-last-child(' + (rowsPerCharacter + 1) + ')').nextAll().clone(true);
  newRows.find('td').empty().removeAttr('colspan').removeClass('hidden');
  newRows.show();
  newRows.first().removeAttr('data-charactercollapsed').removeClass('collapsedrow');
  newRows.first().find('span.staffcollapsebutton').removeClass('ion-chevron-right').addClass('ion-chevron-down');
  var spanElement = newRows.first().find('span.characterheader').first();
  spanElement.removeAttr('data-performerId');
  spanElement.text('<Character ' + nextOrderingIndex + '>');
  spanElement.attr('data-orderingindex', nextOrderingIndex);

  staffTableElement.find('tbody').append(newRows);

  newRows.each(function () {
    fixCountBorders(controller, $(this), columnsPerCount);
  });

  detachHandlersFromActiveStaffElement(controller);
  attachHandlersToActiveStaffElement(controller);
}

function toggleDeleteMoveCharacterMode(controller) {
  var staffContainerElement = controller.activeStaffContainerElement;
  if (staffContainerElement === undefined) {
    return;
  }

  var staffTableElement = controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  var rowsPerCharacter = parseInt(staffTableElement.attr('data-rowspercharacter'));

  var btn = staffContainerElement.find('#buttoncharacterdelete');
  var stateactive = parseInt(btn.attr('data-stateactive') || '0');
  if (stateactive === 1) {
    // deactivate
    btn.removeClass('ion-checkmark-circled').addClass('ion-close-circled');
    btn.removeAttr('data-stateactive');
    controller.staffEditorState.deleteMoveCharacterMode = false;

    staffTableElement.find('.staffrowactionsoverlaycontainer').remove();
    staffTableElement.find('td.deletecol').removeClass('deletecol');

    // fix character index names if needed
    var characterHeaderCells = staffTableElement.find('span.characterheader');
    characterHeaderCells.each(function (index) {
      var elemJ = $(this);
      elemJ.attr('data-orderingindex', (index + 1));
      if (elemJ.attr('data-performerId') === undefined) {
        elemJ.text('<Character ' + (index + 1) + '>');
      }
    });

    hideFilteredOrCollapsedPerformerRows(controller);
  } else {
    endAnyCellEditingInteraction(controller);
    endAnyDeleteMoveMode(controller);

    // activate if needed
    var numcharacters = staffTableElement.find('tr.characterrow').length / rowsPerCharacter;
    if (numcharacters === 0) {
      return;
    }

    revealHiddenCharacterRows(controller);

    btn.removeClass('ion-close-circled').addClass('ion-checkmark-circled');
    btn.attr('data-stateactive', 1);
    controller.staffEditorState.deleteMoveCharacterMode = true;

    var contenthtml = '<div class="staffrowactionsoverlaycontainer">' +
      '<div class="staffrowactionbuttonscontainer">' +
      '<span class="buttonstaffrowaction buttonstaffrowmoveup sw-ionicon sw-ionicon-lg sw-ionicon-fw ion-arrow-up-a"></span>' +
      '<span class="buttonstaffrowaction buttonstaffrowmovedown sw-ionicon-lg sw-ionicon-fw ion-arrow-down-a"></span>' +
      '<span class="buttonstaffrowaction buttonstaffrowdelete sw-ionicon-lg sw-ionicon-fw ion-close"></span>' +
      '</div>' +
      '</div>';

    var overlayContainerCell = staffTableElement.find('tr.characterrow:nth-last-child(' + rowsPerCharacter + 'n)').find('td:last-child');
    overlayContainerCell.append(contenthtml).addClass('deletecol');

    overlayContainerCell.each(function () {
      var cell = $(this);
      var overlayContainer = cell.find('.staffrowactionsoverlaycontainer');
      var nextRow = cell.parents('tr').first();
      var totalHeight = nextRow.height();

      for (var i = 1; i < rowsPerCharacter; i++) {
        nextRow = nextRow.next();
        totalHeight += nextRow.height();
      }

      overlayContainer.height(totalHeight);
    });

    var tablewidth = staffTableElement.width();
    $('.staffrowactionsoverlaycontainer').width(tablewidth - 30);

    $('.buttonstaffrowdelete').hover(function (event) {
        $(this).parents('div.staffrowactionsoverlaycontainer').addClass('staffrowactionsoverlaycontainer-hover');
      },

      function (event) {
        $(this).parents('div.staffrowactionsoverlaycontainer').removeClass('staffrowactionsoverlaycontainer-hover');
      });

    $('.buttonstaffrowdelete').click(function (event) {
      deleteCharacterRows(controller, $(this));
    });

    $('.buttonstaffrowmoveup').click(function (event) {
      moveCharacterRows(controller, $(this), -1);
    });

    $('.buttonstaffrowmovedown').click(function (event) {
      moveCharacterRows(controller, $(this), 1);
    });
  }
}

function deleteCharacterRows(controller, delbutton) {
  var staffTableElement = controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  var rowsPerCharacter = parseInt(staffTableElement.attr('data-rowspercharacter'));

  var rowN;
  var rows = [];
  if (delbutton !== undefined) {
    rowN = delbutton.parents('tr');
    rows.push(rowN);
    for (var i = 1; i < rowsPerCharacter; i++) {
      rowN = rowN.next();
      rows.push(rowN);
    }
  } else {
    rowN = staffTableElement.find('tr.characterrow:nth-last-child(' + rowsPerCharacter + ')');
    if (rowN.length > 0) {
      rows.push(rowN);
      for (var i = 1; i < rowsPerCharacter; i++) {
        rowN = rowN.next();
        rows.push(rowN);
      }
    }
  }

  $.each(rows, function (index, value) {
    if ((index + 1) < rows.length) {
      value.fadeOut(50 + (50 * index), function () {
        value.remove();
      });

    } else {
      value.fadeOut(50 + (50 * index), function () {
        value.remove();
        var numcharacters = staffTableElement.find('tr.characterrow').length / rowsPerCharacter;
        if (numcharacters === 0) {
          toggleDeleteMoveCharacterMode(controller);
        }
      });
    }
  });

  markActiveStaffDirty(controller);
}

function moveCharacterRows(controller, refbutton, direction) {
  var staffTableElement = controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  var rowsPerCharacter = parseInt(staffTableElement.attr('data-rowspercharacter'));

  var srcRow = refbutton.parents('tr');
  var refRow = srcRow;
  if (direction < 0) {
    // Check if we have rows above
    for (var i = 0; i < rowsPerCharacter; i++) {
      refRow = refRow.prev('.characterrow');
    }

    if (refRow.size() === 0) {
      return;
    }
  } else {
    // Check if we have rows below
    for (var i = 0; i < ((2 * rowsPerCharacter) - 1); i++) {
      refRow = refRow.next('.characterrow');
    }

    if (refRow.size() === 0) {
      return;
    }
  }

  var srcRows = [];
  srcRows.push(srcRow);
  for (var i = 1; i < rowsPerCharacter; i++) {
    srcRow = srcRow.next();
    srcRows.push(srcRow);
  }

  if (direction < 0) {
    refRow.before(srcRows);
  } else {
    refRow.after(srcRows);
  }

  markActiveStaffDirty(controller);
}

function revealHiddenCharacterRows(controller) {
  var staffTableElement = controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  staffTableElement.find('tr.collapsedrow').removeClass('collapsedrow');
  staffTableElement.find('tr.characterrow').show();
}

function hideFilteredOrCollapsedPerformerRows(controller, staffTableElement) {
  staffTableElement = staffTableElement || controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  var rowsPerCharacter = parseInt(staffTableElement.attr('data-rowspercharacter'));

  staffTableElement.find('tr.characterrow:nth-last-child(' + rowsPerCharacter + 'n)').each(function (index) {
    var characterRow1 = $(this);

    var isCollapsed = parseInt(characterRow1.attr('data-charactercollapsed') || '0');
    var isFilterVisible = !controller.performerFilterEnabled || (controller.performerFilterEnabled && (characterRow1.attr('filterVisible') === 'true'));
    if (!isFilterVisible) {
      characterRow1.hide().nextAll('*:lt(' + (rowsPerCharacter - 1) + ')').hide();
    } else {
      if (isCollapsed === 1) {
        var btn = characterRow1.find('span.staffcollapsebutton');
        btn.removeClass('ion-ios-arrow-down').addClass('ion-ios-arrow-right');
        characterRow1.addClass('collapsedrow');
        characterRow1.nextAll('*:lt(' + (rowsPerCharacter - 1) + ')').hide();
      }
    }
  });
}

function addVoiceRowPairToStaffTable(controller, staffTableElement) {
  staffTableElement = staffTableElement || controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  var staffTitle = staffTableElement.find('th.stafftitlecell').first().html();
  var columnsPerCount = parseInt(staffTableElement.attr('data-columnspercount'));

  // var newRows = staffTableElement.find('tr.voicerow:nth-child(-n+2)').clone(true);
  var newRows = staffTableElement.find('tr.voicerow:lt(2)').clone(true);
  newRows.find('td').empty().removeAttr('colspan').removeClass('hidden').removeClass('bottomrowcell');

  // staffTableElement.find('tbody').prepend(newRows);
  staffTableElement.find('tr.layoutrow').first().after(newRows);

  newRows.each(function () {
    fixCountBorders(controller, $(this), columnsPerCount);
  });

  var titleCells = staffTableElement.find('th.stafftitlecell');
  titleCells.addClass('hidden');
  titleCells.removeAttr('rowspan');
  titleCells.first().html(staffTitle);
  titleCells.first().removeClass('hidden');
  titleCells.first().attr('rowspan', titleCells.length);

  fixVoiceRowsBorders(controller, staffTableElement);
}

function toggleDeleteMoveVoiceMode(controller) {
  var staffContainerElement = controller.activeStaffContainerElement;
  if (staffContainerElement === undefined) {
    return;
  }

  var staffTableElement = controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  var btn = staffContainerElement.find('#buttonvoicedelete');
  var stateactive = parseInt(btn.attr('data-stateactive') || '0');
  if (stateactive === 1) {
    // deactivate
    btn.removeClass('ion-checkmark-circled').addClass('ion-close-circled');
    btn.removeAttr('data-stateactive');
    controller.staffEditorState.deleteMoveVoiceMode = false;

    staffTableElement.find('.staffrowactionsoverlaycontainer').remove();
    staffTableElement.find('td.deletecol').removeClass('deletecol');
  } else {
    endAnyCellEditingInteraction(controller);
    endAnyDeleteMoveMode(controller);

    // activate if needed
    var numvoicerows = staffTableElement.find('tr.voicerow').length / 2;
    if (numvoicerows === 1) {
      return;
    }

    btn.removeClass('ion-close-circled').addClass('ion-checkmark-circled');
    btn.attr('data-stateactive', 1);
    controller.staffEditorState.deleteMoveVoiceMode = false;

    var rowsInSet = 2;
    var contenthtml = '<div class="staffrowactionsoverlaycontainer">' +
      '<div class="staffrowactionbuttonscontainer">' +
      '<span class="buttonstaffrowaction buttonstaffrowmoveup sw-ionicon sw-ionicon-lg sw-ionicon-fw ion-arrow-up-a"></span>' +
      '<span class="buttonstaffrowaction buttonstaffrowmovedown sw-ionicon-lg sw-ionicon-fw ion-arrow-down-a"></span>' +
      '<span class="buttonstaffrowaction buttonstaffrowdelete sw-ionicon-lg sw-ionicon-fw ion-close"></span>' +
      '</div>' +
      '</div>';
    staffTableElement.find('tr.voicerow').each(function(index) {
      if (index % rowsInSet === 0) {
        $(this).find('td.deletecol').removeClass('hidden').attr('rowspan', 2).html(contenthtml);
      }
    });

    var tablewidth = staffTableElement.width();
    $('.staffrowactionsoverlaycontainer').width(tablewidth - 30);

    var overlayContainerCell = staffTableElement.find('tr.voicerow td:last-child').filter(function(index) {
      return (index % rowsInSet === 0);
    });
    overlayContainerCell.append(contenthtml).addClass('deletecol');

    overlayContainerCell.each(function () {
      var cell = $(this);
      var overlayContainer = cell.find('.staffrowactionsoverlaycontainer');
      var nextRow = cell.parents('tr').first();
      var totalHeight = nextRow.height();

      for (var i = 1; i < rowsInSet; i++) {
        nextRow = nextRow.next();
        totalHeight += nextRow.height();
      }

      overlayContainer.height(totalHeight);
    });

    var tablewidth = staffTableElement.width();
    $('.staffrowactionsoverlaycontainer').width(tablewidth - 30);

    $('.buttonstaffrowdelete').hover(function (event) {
        $(this).parents('div.staffrowactionsoverlaycontainer').addClass('staffrowactionsoverlaycontainer-hover');
      },

      function (event) {
        $(this).parents('div.staffrowactionsoverlaycontainer').removeClass('staffrowactionsoverlaycontainer-hover');
      });

    $('.buttonstaffrowdelete').click(function (event) {
      deleteVoiceRows(controller, $(this));
    });

    $('.buttonstaffrowmoveup').click(function (event) {
      moveVoiceRows(controller, $(this), -1);
    });

    $('.buttonstaffrowmovedown').click(function (event) {
      moveVoiceRows(controller, $(this), 1);
    });
  }
}

function deleteVoiceRows(controller, delbutton) {
  var staffTableElement = controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  var staffTitle = staffTableElement.find('th.stafftitlecell').first().html();

  var voicerow1 = delbutton.parents('tr');
  var voicerow2 = voicerow1.next();
  voicerow1.fadeOut(100);
  voicerow2.fadeOut(50, function () {
    voicerow1.remove();
    voicerow2.remove();

    var titleCells = staffTableElement.find('th.stafftitlecell');
    titleCells.addClass('hidden');
    titleCells.removeAttr('rowspan');
    titleCells.first().html(staffTitle);
    titleCells.first().removeClass('hidden');
    titleCells.first().attr('rowspan', titleCells.length);

    $('.staffrowactionsoverlaycontainer');
    fixVoiceRowsBorders(controller);

    if (titleCells.length === 2) {
      toggleDeleteMoveVoiceMode(controller);
    }
  });

  markActiveStaffDirty(controller);
}

function moveVoiceRows(controller, refbutton, direction) {
  var staffTableElement = controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  var voicerow1 = refbutton.parents('tr');
  var voicerow2 = voicerow1.next();

  var staffTitle = staffTableElement.find('th.stafftitlecell').first().html();

  if (direction < 0) {
    // Check if we have rows above
    var refRow = voicerow1.prev('.voicerow').prev('.voicerow');
    if (refRow.size() === 0) {
      return;
    }

    refRow.before([voicerow1, voicerow2]);
  } else {
    // Check if we have rows below
    var refRow = voicerow2.next('.voicerow').next('.voicerow');
    if (refRow.size() === 0) {
      return;
    }

    refRow.after([voicerow1, voicerow2]);
  }

  var titleCells = staffTableElement.find('th.stafftitlecell');
  titleCells.addClass('hidden');
  titleCells.removeAttr('rowspan');
  titleCells.first().html(staffTitle);
  titleCells.first().removeClass('hidden');
  titleCells.first().attr('rowspan', titleCells.length);

  fixVoiceRowsBorders(controller);

  markActiveStaffDirty(controller);
}

function endAnyDeleteMoveMode(controller) {
  var staffContainerElement = controller.activeStaffContainerElement;
  if (staffContainerElement === undefined) {
    return;
  }

  var btn = staffContainerElement.find('#buttonvoicedelete');
  var stateactive = parseInt(btn.attr('data-stateactive') || '0');
  if (stateactive === 1) {
    toggleDeleteMoveVoiceMode(controller);
  }

  btn = staffContainerElement.find('#buttoncharacterdelete');
  stateactive = parseInt(btn.attr('data-stateactive') || '0');
  if (stateactive === 1) {
    toggleDeleteMoveCharacterMode(controller);
  }
}

function fixVoiceRowsBorders(controller, staffTableElement) {
  staffTableElement = staffTableElement || controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  staffTableElement.find('tr.voicerow td').removeClass('toprowcell').removeClass('bottomrowcell');
  staffTableElement.find('tr.voicerow:first td').addClass('toprowcell');
  staffTableElement.find('tr.voicerow:last td').addClass('bottomrowcell');
}

function fixCountBorders(controller, refrow, columnsPerCount) {
  if (columnsPerCount === undefined) {
    var staffTableElement = refrow.parents('table.stafftable');
    if (staffTableElement === undefined) {
      return;
    }

    columnsPerCount = parseInt(staffTableElement.attr('data-columnspercount'));
  }

  var cells = refrow.find('td');
  var i;
  for (i = 0; i < cells.length; i++) {
    var cell = $(cells[i]);
    var colspan = parseInt(cell.attr('colspan') || '1');
    if (((i + colspan) % columnsPerCount) === 0) {
      cell.addClass('countborder');
    } else {
      cell.removeClass('countborder');
    }
  }
}

function loadStaffContent(controller, staff, staffContainerElement) {
  var staffTableElement = staffContainerElement.find('table.stafftable');
  var rowsPerCharacter = parseInt(staffTableElement.attr('data-rowspercharacter'));
  var columnsPerCount = parseInt(staffTableElement.attr('data-columnspercount'));
  var templateCounts = parseInt(staffTableElement.attr('data-defaultcount'));

  // Add/remove count columns as needed
  var staffCounts = staff.counts;
  if (staffCounts > templateCounts) {
    for (var i = 0; i < (staffCounts - templateCounts); i++) {
      addCount(controller, staffTableElement);
    }
  } else {
    for (var i = 0; i < (templateCounts - staffCounts); i++) {
      deleteCount(controller, staffTableElement);
    }
  }

  // staffTableElement.addClass('stafftable-' + columnsPerCount + '-' + staff.counts);
  staffTableElement.addClass('stafftable-cols-' + columnsPerCount);
  staffTableElement.addClass('stafftable-count-' + staff.counts);


  // Update number of voice rows, there is already one pair in the template
  var voiceRowPairs = (staff.voicerowcount / 2);
  for (var i = 1; i < voiceRowPairs; i++) {
    addVoiceRowPairToStaffTable(controller, staffTableElement);
  }

  // Load voice row content
  if (Array.isArray(staff.voicecells)) {
    var voiceRowElements = staffContainerElement.find('tr.voicerow');
    loadCellsInRows(staff.voicecells, voiceRowElements);

    voiceRowElements.each(function () {
      fixCountBorders(controller, $(this), columnsPerCount);
    });
  }

  // Performer rows
  if ((staff.performerrows !== undefined) && (staff.performerrows.length > 0)) {
    for (var i = 1; i < staff.performerrows.length; i++) {
      addCharacterRow(controller, staffTableElement);
    }

    var performerRowElements = staffContainerElement.find('tr.characterrow');
    for (var i = 0; i < staff.performerrows.length; i++) {
      var performerrow = staff.performerrows[i];
      if (performerrow.cells !== undefined) {
        loadCellsInRows(performerrow.cells, performerRowElements);
      }

      // Fix count borders
      performerRowElements.each(function () {
        fixCountBorders(controller, $(this), columnsPerCount);
      });

      // Performer name
      var performerNameRowElement = $(performerRowElements[(i * rowsPerCharacter)]);
      assignPerformerName(performerrow, performerNameRowElement);

      // collapsed flag
      if (performerrow.collapsed) {
        performerNameRowElement.attr('data-charactercollapsed', 1);
      }

      // Filter visibility flag
      performerNameRowElement.attr('filterVisible', performerrow.filterVisible);
    }

    hideFilteredOrCollapsedPerformerRows(controller, staffTableElement);
  } else {
    staffTableElement.find('tr.characterrow').remove();
    // deleteCharacterRows(controller);
  }

  assignStaffTitle(staff, staffContainerElement);

  fixVoiceRowsBorders(controller, staffTableElement);

  clearStaffDirtyFlag(controller, staffContainerElement);
}

function loadCellsInRows(cells, rowElements) {
  var currentRowIndex = -1;
  var currentRowElement;
  var currentRowCellElements;

  for (var i = 0; i < cells.length; i++) {
    var staffCell = cells[i];
    if (staffCell.row !== currentRowIndex) {
      currentRowIndex = staffCell.row;
      currentRowElement = $(rowElements[currentRowIndex]);
      currentRowCellElements = currentRowElement.children('td');
    }

    // Cell for current data item
    var contentCellElement = $(currentRowCellElements[staffCell.column]);

    // element for content
    var contentCellSpanElement = $('<div></div>').addClass('text');
    if ((staffCell.richtextcontent === undefined) || (staffCell.richtextcontent.length === 0)) {
      contentCellSpanElement.text(staffCell.content);
    } else {
      // contentCellSpanElement.html($.parseHTML(staffCell.richtextcontent));
      contentCellSpanElement.html(staffCell.richtextcontent);
    }

    // Load content
    contentCellElement.append(contentCellSpanElement);

    // set colspan
    contentCellElement.attr('colspan', staffCell.colspan);

    // Hide span overlapped cells
    for (var j = 1; j < staffCell.colspan; j++) {
      $(currentRowCellElements[staffCell.column + j]).addClass('hidden');
    }
  }
}

function assignStaffTitle(staff, staffContainerElement) {
  var staffTitleElement = staffContainerElement.find('div.stafftablecontainer table.stafftable th.stafftitlecell span.stafftitle');
  staffTitleElement.text(staff.assignedName);
  staffTitleElement.attr('data-customtitle', staff.customtitle);
  staffTitleElement.attr('data-defaulttitle', staff.defaultTitle);
}

function assignPerformerName(performerrow, rowElement) {
  var performerName = '<Character ' + (performerrow.orderingindex + 1) + '>';
  if (performerrow.performerName !== undefined) {
    performerName = performerrow.performerName;
  }

  var spanElement = rowElement.find('span.characterheader').first();
  spanElement.text(performerName);
  spanElement.attr('data-performerId', performerrow.performerId);
  spanElement.attr('data-orderingindex', performerrow.orderingindex);
}

// function markActiveStaffElementDirty(controller) {
//   var staffContainerElement = controller.activeStaffContainerElement;
//   if (staffContainerElement === undefined) {
//     return;
//   }

//   staffContainerElement.attr('data-staffdirty', true);
// }

function markActiveStaffDirty(controller) {
  if ((controller !== undefined) && (typeof controller.markActiveStaffDirty === 'function')) {
    controller.markActiveStaffDirty();
  }
}

function clearStaffDirtyFlag(controller, staffContainerElement) {
  // staffContainerElement = controller.activeStaffContainerElement;
  // if (staffContainerElement === undefined) {
  //   return;
  // }

  // staffContainerElement.removeAttr('data-staffdirty');

  // if (controller.selectedStaff) {
  //   controller.selectedStaff.dirty = false;
  // }
}

function getActiveStaffDataForSaving(controller) {
  var staffContainerElement = controller.activeStaffContainerElement;
  if (staffContainerElement === undefined) {
    return;
  }

  var staffTableElement = controller.activeStaffTableElement;
  if (staffTableElement === undefined) {
    return;
  }

  // dirty Check
  // var isDirty = (staffContainerElement.attr('data-staffdirty') === 'true');
  // if (!isDirty) {
  //   return;
  // }

  // staff ID
  var staffId = staffContainerElement.attr('data-staffid');
  if (staffId === undefined) {
    return;
  }

  var rowsPerCharacter = parseInt(staffTableElement.attr('data-rowspercharacter'));
  var columnsPerCount = parseInt(staffTableElement.attr('data-columnspercount'));

  var updatedStaff = {
    _id: staffId,
  };

  // staff custom title/name
  updatedStaff.customtitle = staffTableElement.find('th.stafftitlecell span.stafftitle').attr('data-customtitle');
  if (updatedStaff.customtitle === undefined) {
    updatedStaff.customtitle = null;
  }

  // staff counts
  updatedStaff.counts = parseInt(staffTableElement.attr('data-currentcount'));
  //staffTableElement.find('tr.characterrow').first().find('td').length / columnsPerCount;

  // Voice rows
  var voiceRowElements = staffContainerElement.find('tr.voicerow');
  updatedStaff.voicerowcount = voiceRowElements.length;

  // Voice rows data
  updatedStaff.voicecells = getCellsInRows(voiceRowElements);

  // Performer rows
  updatedStaff.performerrows = [];
  var performerRowElements = staffContainerElement.find('tr.characterrow');
  var numPerformerRowGroups = performerRowElements.length / rowsPerCharacter;
  for (var i = 0; i < numPerformerRowGroups; i++) {
    var performerrow = {};
    performerrow.orderingindex = i;
    performerrow.cells = getCellsInRows(performerRowElements, i, rowsPerCharacter);
    performerrow.performerId = $(performerRowElements.get(i * rowsPerCharacter)).find('span.characterheader').first().attr('data-performerId');
    performerrow.collapsed = ($(performerRowElements.get(i * rowsPerCharacter)).attr('data-charactercollapsed') === '1');
    updatedStaff.performerrows.push(performerrow);
  }

  return updatedStaff;
}

function getCellsInRows(rowElements, index, rowsPerIndex) {
  if (rowElements === undefined) {
    return [];
  }

  index = index || 0;
  rowsPerIndex = rowsPerIndex || rowElements.length;

  var cells = [];
  var startIndex = (index * rowsPerIndex);
  for (var i = startIndex; i < (startIndex + rowsPerIndex); i++) {
    var aRowElement = rowElements[i];
    var cellElements = $(aRowElement).find('td');
    for (var j = 0; j < cellElements.length; j++) {
      var aCellElement = $(cellElements[j]);
      if (aCellElement.html()) {
        var staffCell = {};
        staffCell.row = i;
        staffCell.column = j;
        staffCell.colspan = parseInt(aCellElement.attr('colspan') || 1);
        staffCell.content = aCellElement.find('div.text').first().text();
        staffCell.richtextcontent = aCellElement.find('div.text').first().html();
        cells.push(staffCell);
        j = j + (staffCell.colspan - 1);
      }
    }
  }

  return cells;
}

function initCustomTinyMCE(controller, element, initCallback) {
  /* jshint ignore:start */
  tinymce.init({
    selector: ".richeditingcontentcell",
    init_instance_callback: initCallback,
    inline: true,
    inline_styles: true,
    forced_root_block: 'div',
    invalid_elements: 'strong,em',
    force_hex_style_colors: true,
    // entity_encoding: 'numeric',
    br_in_pre: false,
    height: 100,
    plugins: [
      'textcolor',
      'paste'
    ],
    paste_as_text: true,
    toolbar1: "bold italic underline forecolor",
    toolbar2: "fontselect | fontsizeselect",
    font_formats: 'Liberation Sans=Liberation Sans;Liberation Mono=Liberation Mono;Liberation Serif=Liberation Serif',
    fontsize_formats: '10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 31px 32px 33px 34px 35px 36px 37px 38px 39px 40px 41px 42px 43px 44px 45px 46px 47px 48px 49px 50px 51px 52px 53px 54px 55px 56px 57px 58px 59px 60px 61px 62px 63px 64px 65px 66px 67px 68px 69px 70px 71px 72px',
    menubar: false,
    toolbar_items_size: 'small',
    formats: {
      bold: {
        inline: 'span',
        styles: {
          'font-weight': 'bold'
        }
      },
      italic: {
        inline: 'span',
        styles: {
          'font-style': 'italic'
        }
      },
      underline: {
        inline: 'span',
        styles: {
          'text-decoration': 'underline'
        }
      },
    },
    textcolor_cols: 5,
    textcolor_rows: 6,
    textcolor_map: controller.swaUi.textColorMap,
  });
  //Preventing default action on active editor
  // tinymce.activeEditor.on('keydown', function (e) {
  //   if (e.keyCode === 13) {
  //     e.preventDefault();
  //   }
  // });
  /* jshint ignore:end */
}

function destroyTinyMCEInstance() {
  tinymce.triggerSave();
  tinymce.remove();
}

// jshint maxdepth: false
/* global console, Q, $, jQuery,
 loadStaffContent, getActiveStaffDataForSaving, deactivateActiveStaffContainer,
 activateStaffInContainer, scrollToStaffContainer, assignStaffTitle,
 sizeActiveCell, beginResizingActiveCell, deleteActiveCell, beginEditingCell,
 clearStaffDirtyFlag, endAnyDeleteMoveMode,
 endAnyCellEditingInteraction, _, cutActiveCell, copyActiveCell, pasteInActiveCell */
(function () {
  'use strict';

  angular.module('swanywhere').controller('StaffEditorController', StaffEditorController);

  StaffEditorController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    'toastr',
    'DbStaffs',
    'DbScenes',
    'DbProductions',
    '$log',
    'DbSubMgrService',
    'DbPerformers',
    'ngProgressLite',
    '$compile',
    '$http',
    '$templateCache',
    'blockUI',
    'DbCharts',
    '$translate',
    'staffTemplatesService',
    '$timeout',
    'swaUtils',
    '$sce',
    '$uibModal',
    'swaRouterStateNames',
    'DbCollaborationPrivileges',
    'swaAccess',
    'swaUi',
    'swPdfPrintService',
    '$q',
    '$localStorage',
    '$window',
    '$interval',
    'DbStaffsArchive',
    'DbUser'
  ];

  function StaffEditorController($scope, $cookies, $stateParams, toastr,
    DbStaffs, DbScenes, DbProductions, $log,
    DbSubMgrService, DbPerformers, ngProgressLite, $compile,
    $http, $templateCache, blockUI, DbCharts,
    $translate, staffTemplatesService, $timeout, swaUtils, $sce, $uibModal, swaRouterStateNames,
    DbCollaborationPrivileges, swaAccess, swaUi, swPdfPrintService, $q, $localStorage, $window, $interval, DbStaffsArchive, DbUser) {

    var vm = this;
    var selectedProductionId;

    var dbProductions = new DbProductions();
    var dbPerformers = new DbPerformers();
    var dbScenes = new DbScenes();
    var dbCharts = new DbCharts();
    var dbStaffs = new DbStaffs();
    var dbUser = new DbUser();
    var dbStaffsArchive = new DbStaffsArchive();
    var dbCollaborationPrivileges = new DbCollaborationPrivileges();

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowstaffediting: false,
      allowaddstaff: false,
      allowfilterperformers: false,
      allowaddvoicerow: false,
      allowdeletevoicerow: false,
      allowaddcharacterrow: false,
      allowdeletecharacterrow: false,
      allowaddcount: false,
      allowdeletecount: false,
      allowcopystaffsource: false,
      allowcopystaffdestination: false,
      allowmovestaffsource: false,
      allowmovestaffdestination: false,
      allowdeletestaff: false,
    };

    var defaultViewAccessRules = {
      allowowneraccess: false,
      allowstaffediting: false,
      allowaddstaff: false,
      allowfilterperformers: true,
      allowaddvoicerow: false,
      allowdeletevoicerow: false,
      allowaddcharacterrow: false,
      allowdeletecharacterrow: false,
      allowaddcount: false,
      allowdeletecount: false,
      allowcopystaffsource: false,
      allowcopystaffdestination: false,
      allowmovestaffsource: false,
      allowmovestaffdestination: false,
      allowdeletestaff: false,
    };

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowstaffediting: true,
      allowaddstaff: true,
      allowfilterperformers: true,
      allowaddvoicerow: true,
      allowdeletevoicerow: true,
      allowaddcharacterrow: true,
      allowdeletecharacterrow: true,
      allowaddcount: true,
      allowdeletecount: true,
      allowcopystaffsource: true,
      allowcopystaffdestination: true,
      allowmovestaffsource: true,
      allowmovestaffdestination: true,
      allowdeletestaff: true,
    };

    vm.userData = {};
    vm.userId = '';

    vm.$log = $log;

    vm.swaRouterStateNames = swaRouterStateNames;
    vm.swaUi = swaUi;

    vm.showHelpBar = false;
    vm.helpTourSteps = [];
    vm.helpTourVideos = [];

    vm.selectedProduction = {};
    vm.performers = [];
    vm.scenes = [];
    vm.staffTemplates = [];

    vm.performerFilterEnabled = false;

    vm.selectedScene = undefined;
    vm.selectedSceneId = undefined;

    vm.staffEditorState = {
      deleteMoveVoiceMode: false,
      deleteMoveCharacterMode: false,
      showingStaffContent: false,
      chartNumberAutomatic: false,
      staffAutoFitWidth: false,
    };

    vm.selectedStaff = undefined;
    vm.selectedStaffOrderingIndex = -1;

    vm.sidebarEditState = {
      enabled: false,
      selectionCount: 0,
      destinationSelectVisible: false,
      destinationSelectForCopy: false,
      destinationSelectForMove: false,
      destinationSelectForRestore: false,
      destinationModeTitle: '',
    };

    vm.staffEditingControlsState = {
      visible: false,
    };

    vm.staffClipboard = {
      hasContent: false,
    };

    vm.staffSortableOptions = {
      // handle: '.sortDragHandle',
      // cursor: 'ns-resize',
      handle: '.title',
      axis: 'y',
      opacity: 0.8,
      disabled: true,
      tolerance: "pointer",
      start: hideSideBarDeleteAndMoveOptions,
      stop: staffDragSortStop,
    };

    vm.scrollConfigSidebar = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
      callbacks: {
        // whileScrolling: updateStickySceneHeader,
        whileScrolling: function () {
          updateStickySceneHeader();
          hideSideBarDeleteAndMoveOptions();
        },
        onScroll: updateStickySceneHeader,
      }
    };

    vm.scrollConfigContent = {
      theme: 'dark',
      axis: 'y',
      scrollbarPosition: 'inside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
        deltaFactor: 10,
      },
      keyboard: {
        enable: false,
      },
      autoHideScrollbar: false,
      advanced: {
        updateOnContentResize: false,
      },
    };

    vm.addStaffWorkflow = {
      stackable: {},
      selectedStaffType: -1,
      initialCounts: -1,
      step: 1,
    };

    vm.zoomPicker = {};

    vm.chartIdToChartNameCache = {};

    vm.getStaffTemplateForStaffType = getStaffTemplateForStaffType;
    vm.getDefaultStaffTitleForStaffId = getDefaultStaffTitleForStaffId;
    vm.toggleScene = toggleScene;
    vm.toggleRemovedStaffsScene = toggleRemovedStaffsScene;
    vm.sidebarSelectStaffAtIndex = sidebarSelectStaffAtIndex;
    vm.sidebarSelectDeletedStaffAtIndex = sidebarSelectDeletedStaffAtIndex;
    vm.toggleSidebarEditMode = toggleSidebarEditMode;
    vm.sidebarShowDestinationSceneListForCopy = sidebarShowDestinationSceneListForCopy;
    vm.sidebarShowDestinationSceneListForMove = sidebarShowDestinationSceneListForMove;
    vm.sidebarEditSelectDestinationSceneAtIndex = sidebarEditSelectDestinationSceneAtIndex;
    vm.deleteSelectedStaffs = deleteSelectedStaffs;
    vm.embedPerformerPicker = embedPerformerPicker;
    vm.performerPickerSelectionChange = performerPickerSelectionChange;
    vm.addStaffWorkflowStep1 = addStaffWorkflowStep1;
    vm.addStaffWorkflowSelectStaffType = addStaffWorkflowSelectStaffType;
    vm.addStaffWorkflowSelectAllPerformers = addStaffWorkflowSelectAllPerformers;
    vm.addStaffWorkflowClearPerformersSelection = addStaffWorkflowClearPerformersSelection;
    vm.addStaffWorkflowDone = addStaffWorkflowDone;
    vm.switchEditor = switchEditor;
    vm.showAllPerformers = showAllPerformers;
    vm.applyPerformerFilter = applyPerformerFilter;
    vm.staffEditingEditCell = staffEditingEditCell;
    vm.staffEditingDeleteCell = staffEditingDeleteCell;
    vm.staffEditingResizeCell = staffEditingResizeCell;
    vm.staffEditingDone = staffEditingDone;
    vm.staffEditingResize = staffEditingResize;
    vm.staffEditingCutCell = staffEditingCutCell;
    vm.staffEditingCopyCell = staffEditingCopyCell;
    vm.staffEditingPasteCell = staffEditingPasteCell;
    vm.updateState = updateState;
    vm.onHelpTourStart = onHelpTourStart;
    vm.printPdf = printPdf;
    vm.onSaveClick = onSaveClick;
    vm.markActiveStaffDirty = markActiveStaffDirty;
    vm.setStaffAutoFitWidth = setStaffAutoFitWidth;

    vm.toggleLockModeNavigation = toggleLockModeNavigation;
    vm.lockNavigationPreviousScene = lockNavigationPreviousScene;
    vm.lockNavigationPreviousStaff = lockNavigationPreviousStaff;
    vm.lockNavigationNextStaff = lockNavigationNextStaff;
    vm.lockNavigationNextScene = lockNavigationNextScene;

    vm.showSideBarDeleteAndMoveOptions = showSideBarDeleteAndMoveOptions;
    vm.hideSideBarDeleteAndMoveOptions = hideSideBarDeleteAndMoveOptions;
    vm.toggleSideBarDeleteAndMoveOptions = toggleSideBarDeleteAndMoveOptions;

    vm.showSidebarEditModeOptions = showSidebarEditModeOptions;
    vm.hideSidebarEditModeOptions = hideSidebarEditModeOptions;
    vm.toggleSidebarEditModeOptions = toggleSidebarEditModeOptions;

    vm.deleteSingleStaff = deleteSingleStaff;
    vm.moveSingleStaff = moveSingleStaff;
    vm.copySingleStaff = copySingleStaff;
    vm.restoreStaff = restoreStaff;

    vm.toggleSidebarEditModeForScore = toggleSidebarEditModeForScore;
    vm.deleteStaffPrompt = deleteStaffPrompt;
    vm.copyMoveDeleteOptionHintPrompt = copyMoveDeleteOptionHintPrompt;

    vm.enterDeletedStaffList = enterDeletedStaffList;
    vm.leaveDeletedStaffList = leaveDeletedStaffList;

    vm.staffVersionPrevious = staffVersionPrevious;
    vm.staffVersionNext = staffVersionNext;

    vm.pdfPrintOptionPrompt = pdfPrintOptionPrompt;

    var staffVersionBrowserState = {
      /** Is feature enabled */
      enabled: false,
      /** Is browser currently active */
      active: false,
      /** All available versions of the current staff including current (at index 0) */
      staffVersions: [],
      /** Currently selected staff version */
      selectedVersion: null,
      /** Currently selected version index
       *
       * Versions starts from 1, index 0 is current version
       */
      selectedIndex: 0,
      /** Max index for selection */
      maxIndex: 0,
      /** The total number of versions available */
      totalVersions: 0,
      /** Is a previous (more recent) version available */
      prevEnabled: false,
      /** Is next (more older) version available */
      nextEnabled: false,
    }
    vm.staffVersionBrowserState = staffVersionBrowserState;

    vm.dummyScenesForRemovedStaffs = [{
      productionId: 'dummy-removed-staffs',
      scenename: 'Recent',
      orderingindex: -2,
      open: false,
      _id: 'dummyscene-2',
      staffs: [],
      accessRules: {
        allowowneraccess: true,
        allowstaffediting: false,
        allowaddstaff: false,
        allowfilterperformers: false,
        allowaddvoicerow: false,
        allowdeletevoicerow: false,
        allowaddcharacterrow: false,
        allowdeletecharacterrow: false,
        allowaddcount: false,
        allowdeletecount: false,
        allowcopystaffsource: false,
        allowcopystaffdestination: false,
        allowmovestaffsource: false,
        allowmovestaffdestination: false,
        allowdeletestaff: false,
      }
    }, {
      productionId: 'dummy-removed-staffs',
      scenename: 'Older',
      orderingindex: -1,
      open: false,
      _id: 'dummyscene-1',
      staffs: [],
      accessRules: {
        allowowneraccess: true,
        allowstaffediting: false,
        allowaddstaff: false,
        allowfilterperformers: false,
        allowaddvoicerow: false,
        allowdeletevoicerow: false,
        allowaddcharacterrow: false,
        allowdeletecharacterrow: false,
        allowaddcount: false,
        allowdeletecount: false,
        allowcopystaffsource: false,
        allowcopystaffdestination: false,
        allowmovestaffsource: false,
        allowmovestaffdestination: false,
        allowdeletestaff: false,
      }
    }];


    vm.chartSidebarDeleteAndMoveOptionState = {
      visible: false,
      posX: 0,
      posY: 0
    };

    vm.chartSidebarEditOptionState = {
      visible: false,
    };

    var selectedIndexForDeleteAndMove = null;

    vm.movingSingleScore = undefined;
    vm.copyingSingleScore = undefined;
    vm.movingSingleScoreOperationToggle = undefined;
    vm.sourceSceneId = null;
    vm.sourceSceneForMoveAndCopy = undefined;
    vm.moveScoreAtSpecificIndex = false;
    vm.scoreIdsToMoveAndCopyAtSpecificIndex = [];
    vm.deleteMultipleScores = false;


    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedPerformers: false,
      allowedNumberOfPerformers: 0,
      allowUnlimitedScenes: false,
      allowedNumberOfScenes: 0,
      allowUnlimitedStaffs: false,
      allowedNumberOfStaffs: 0,
    };

    vm.PdfPrintTypes = swPdfPrintService.PdfPrintTypes;

    vm.autoSaveState = {
      timeoutMaxSec: 60,
      timeoutPollIntervalSec: 1,
      timeoutDecaySec: 5,
      timeoutRemainingSec: 0,
      timerActive: false,
      saveActive: false
    };

    vm.deletedStaffListMode = false;
    vm.totalDeletedStaffsInProduction = [];
    vm.restoringSingleStaff = false;
    vm.staffVersionIdToRestore = undefined;

    initialize();

    function initialize() {
      $cookies.put('currentEditorStateName', swaUtils.getRouterCurrentStateName());

      vm.staffEditorPreferences = $localStorage.$default({
        staffAutoFitWidth: vm.staffEditorState.staffAutoFitWidth,
      });

      sessionCheckAndRun();
      registerKeyboardHandler();
      registerResizeHandler();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.validateActivePlan();
        })
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();

          if (angular.isDefined(vm.userData.flags.allowStaffVersionBrowser)) {
            staffVersionBrowserState.enabled = (vm.userData.flags.allowStaffVersionBrowser === true)
          }
        })
        .then(function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        })
        .then(function (plan) {
          updateActivePlanRules(plan);
        })
        .then(function () {
          setupStaffContainerHandlers();
          return getAllData();
        })
        .then(function () {
          loadEditorPreferences();
          showHelpHints();
          initHelpTour();
        })
        .then(function () {
          if (angular.isDefined($stateParams.navParams)) {
            return navigateOpenStaff($stateParams.navParams.sceneId, $stateParams.navParams.staffId);
          } else if (angular.isDefined($stateParams.selectedScene)) {
            var sceneToOpen = vm.scenes.find(function (scene) { return (scene._id === $stateParams.selectedScene._id) })
            return toggleScene(sceneToOpen);
          }
        })
        .then(function () {
          if ($stateParams.lockModeNavigation === true) {
            toggleLockModeNavigation();
          }
        })
        .then(null, null, function (progress) {
          ngProgressLite.set(progress);
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
          $log.error('StaffEditorController.sessionCheckAndRun:', error);
        })
        .finally(function () {
          $scope.$applyAsync(function () {
            ngProgressLite.done();
            blockUI.reset();
          });
        });
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId)
        .then(function (production) {
          deferred.notify(0.1);
          updateDataProduction(production);
        })
        .then(function () {
          // return dbPerformers.findInProduction(selectedProductionId);
          return dbPerformers.fetchAllInProduction(selectedProductionId, updateDataPerformersLive);
        })
        .then(function (performers) {
          deferred.notify(0.33);
          // updateDataPerformers(performers);
        })
        .then(function () {
          return dbScenes.fetchAllInProduction(selectedProductionId, updateDataScenes);
        })
        .then(function () {
          deferred.notify(0.67);
        })
        .then(function () {
          $cookies.put('selectedProductionId', selectedProductionId);
          deferred.notify(1.0);
        })
        .catch(function (error) {
          deferred.reject(error);
        })
        .finally(function () {
          deferred.resolve();
        });

      return deferred.promise;
    }

    function navigateOpenStaff(sceneId, staffId) {
      var deferred = $q.defer();

      $q.when(true)
        .then(function () {
          if (sceneId) {
            return vm.scenes.find(function (scene) {
              return scene._id === sceneId
            });
          }
        })
        .then(function (scene) {
          if (angular.isDefined(scene)) {
            return toggleScene(scene);
          }
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (e) {
          deferred.reject(e);
        });

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;

      vm.activePlanRules.allowUnlimitedPerformers = plan.planfeatures[2].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedPerformers) {
        vm.activePlanRules.allowedNumberOfPerformers = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfPerformers = plan.planfeatures[2].featurevalue;
      }

      vm.activePlanRules.allowUnlimitedScenes = plan.planfeatures[3].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedScenes) {
        vm.activePlanRules.allowedNumberOfScenes = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfScenes = plan.planfeatures[3].featurevalue;
      }

      vm.activePlanRules.allowUnlimitedStaffs = plan.planfeatures[5].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedStaffs) {
        vm.activePlanRules.allowedNumberOfStaffs = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfStaffs = plan.planfeatures[5].featurevalue;
      }
    }

    function updateDataProduction(production) {
      vm.selectedProduction = production;

      if (angular.isUndefined(vm.selectedProduction) || (parseInt(vm.selectedProduction.productiontype) !== 0)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error('Invalid state');
      }

      if (vm.selectedProduction.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(vm.selectedProduction.collaboratorIds) && (vm.selectedProduction.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = vm.selectedProduction.collaborationsettings.find(
            function (element) {
              return (element.collaboratorId === vm.userId);
            });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error(
            $translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          throw new Error('Invalid state');
        }
      }

      DbSubMgrService.setSelectedProduction(vm.selectedProduction);

      try {
        staffTemplatesService.setProduction(vm.selectedProduction);
      } catch (e) {
        toastr.error(
          e.message,
          $translate.instant('errormessages.Error loading score templates!'));
      }

      vm.staffTemplates = angular.copy(vm.selectedProduction.stafftemplates);

      vm.staffEditorState.chartNumberAutomatic = (vm.selectedProduction.chartsettings.chartnumberautomatic === true);

      setupPdfPrintService();
    }

    function setupPdfPrintService() {
      swPdfPrintService.setSelectedProduction(vm.selectedProduction);
      vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
      vm.onPrintJobsChange = onPrintJobsChange;
      swPdfPrintService.registerForChange(vm);
    }

    function onPrintJobsChange(change, id, job) {
      $scope.$applyAsync(function () {
        vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
      });
    }

    function pdfPrintOptionPrompt(type) {
      if (type === vm.PdfPrintTypes.CurrentStaff || type === vm.PdfPrintTypes.CurrentSceneStaffs || type === vm.PdfPrintTypes.AllStaffs) {
        var params = {
          type: type,
        }
        printPdf(params);
      } else {
        vm.pdfOptionsPicker.show = false;
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/chartEditor/pdfPrintOptionPrompt.html',
          controller: 'PdfPrintOptionPromptController',
          controllerAs: 'vm',
          size: '600',
          windowClass: 'sw-modal',
          backdropClass: 'sw-modal-backdrop',
          resolve: {
            params: {
              type: type,
            }
          }
        });
        modalInstance.result
          .then(function (params) {
            printPdf(params);
          });
      }
    }

    function printPdf(parameters) {
      var type = parameters.type;
      vm.pdfOptionsPicker.show = false;

      var params = {};
      params.productionId = selectedProductionId;
      params.optionalIds = {};
      params.options = {};
      params.type = type;
      params.notesPrintOption = parameters.chartNotes;
      params.scaleAllPerformersPrintOption = parameters.scaleAllPerformers;
      params.scaleSelectedPerformersPrintOption = parameters.scaleSelectedPerformers;
      params.sharedLayerAnnotationsPrintOption = parameters.sharedLayerAnnotations;

      if ((type === vm.PdfPrintTypes.CurrentSceneChartsStaffs) || (type === vm.PdfPrintTypes.CurrentSceneCharts) || (type === vm.PdfPrintTypes.CurrentSceneStaffs)) {
        params.optionalIds.sceneId = vm.selectedSceneId;
      } else if (type === vm.PdfPrintTypes.CurrentStaff) {
        params.optionalIds.staffId = vm.selectedStaff._id;
      }

      params.options.printChartPersonalNotes = getPrintChartPersonalNotes();

      swPdfPrintService.printPdf(params)
        .then(function (printJob) {
          if (angular.isDefined(printJob.approvingUserId)) {
            toastr.info(
              $translate.instant('messages.PDF waiting for approval'),
              $translate.instant('messages.Approval Needed!')
            );
          } else {
            toastr.info(
              $translate.instant('messages.Requested PDF is being created')
            );
          }
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error creating PDF!')
          );
        });
    }

    function getPrintChartPersonalNotes() {
      return (!vm.activeCollaborationConfig.isProductionOwner && (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited)) ||
        (vm.activePlanRules.planId === 2);
    }

    function updateDataPerformers(performers) {
      vm.performers = angular.copy(performers);

      loadPerformerFilterSelections();

      updatePerformerVisibility();
    }

    function updateDataPerformersLive(id) {
      if (angular.isUndefined(id)) {
        vm.performers = dbPerformers.getFetched(true);
      } else {
        var existingPerformer = swaUtils.findInArrayById(vm.performers, id);
        var incomingPerformer = dbPerformers.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingPerformer) && !swaUtils.isUndefinedOrNull(incomingPerformer));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingPerformer) && swaUtils.isUndefinedOrNull(incomingPerformer));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingPerformer) && !swaUtils.isUndefinedOrNull(incomingPerformer));

        if (isInsert) {
          vm.performers.push(incomingPerformer);
          swaUtils.sortArrayByNumericKey(vm.performers, 'orderingindex');
        } else if (isDelete) {
          toastr.warning(
            $translate.instant('messages.Performer deleted elsewhere.'),
            $translate.instant('messages.Sync warning!')
          );

          var existingPerformerIndex = vm.performers.indexOf(existingPerformer);
          if (existingPerformerIndex !== -1) {
            vm.performers.splice(existingPerformerIndex, 1);
          }
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming performer update with ID: ' + id);
          angular.extend(existingPerformer, incomingPerformer);
        }
      }

      loadPerformerFilterSelections();
      updatePerformerVisibility();
    }

    function loadPerformerFilterSelections() {
      var filteredPerformerIds = [];
      if (angular.isDefined($cookies.filteredPerformerIds)) {
        filteredPerformerIds = $cookies.filteredPerformerIds.split(',') || [];
      }

      var performerId;
      var thePerformer;
      for (var i = 0; i < filteredPerformerIds.length; i++) {
        performerId = filteredPerformerIds[i];
        thePerformer = swaUtils.findInArrayById(vm.performers, performerId);
        if (angular.isDefined(thePerformer)) {
          thePerformer.filterSelected = true;
        }
      }

      var addStaffSelectedPerformerIds = [];
      if (angular.isDefined($cookies.addStaffSelectedPerformerIds)) {
        addStaffSelectedPerformerIds = $cookies.addStaffSelectedPerformerIds.split(',') || [];
      }

      for (i = 0; i < addStaffSelectedPerformerIds.length; i++) {
        performerId = addStaffSelectedPerformerIds[i];
        thePerformer = swaUtils.findInArrayById(vm.performers, performerId);
        if (angular.isDefined(thePerformer)) {
          thePerformer.addStaffSelected = true;
        }
      }
    }

    function updatePerformerVisibility() {
      var filterSelected = false;
      var aPerformer;
      for (var i = 0; i < vm.performers.length; i++) {
        aPerformer = vm.performers[i];
        if (aPerformer.filterSelected === true) {
          filterSelected = true;
          break;
        }
      }

      for (var j = 0; j < vm.performers.length; j++) {
        aPerformer = vm.performers[j];
        if (filterSelected) {
          aPerformer.filterVisible = aPerformer.filterSelected;
        } else {
          aPerformer.filterVisible = true;
        }
      }

      vm.performerFilterEnabled = filterSelected;
    }

    function updateDataScenes(id) {
      if (angular.isUndefined(id)) {
        vm.scenes = dbScenes.getFetched(true);
        updateSceneCollaborationAccessRules(vm.scenes)
          .then(function () {
            updateActiveAccessRules();
            if (vm.selectedScene && vm.scenes[vm.selectedScene.orderingindex].accessRules.allowmovestaffsource) {
              vm.staffSortableOptions.disabled = false;
            } else {
              vm.staffSortableOptions.disabled = true;
            }
          });
      } else {
        var existingScene = swaUtils.findInArrayById(vm.scenes, id);
        var incomingScene = dbScenes.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingScene) && swaUtils.isUndefinedOrNull(incomingScene));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));

        if (isInsert) {
          updateSceneCollaborationAccessRules([incomingScene]);
          vm.scenes.push(incomingScene);
          swaUtils.sortArrayByNumericKey(vm.scenes, 'orderingindex');
        } else if (isDelete) {
          toastr.warning($translate.instant('messages.Scene deleted elsewhere.'), $translate.instant(
            'messages.Sync warning!'));
          if (existingScene === vm.selectedScene) {
            toggleScene();
          }

          var existingSceneIndex = vm.scenes.indexOf(existingScene);
          if (existingSceneIndex !== -1) {
            vm.scenes.splice(existingSceneIndex, 1);
          }
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming scene update with ID: ' + id);
          angular.extend(existingScene, incomingScene);
        }
      }
    }

    function updateDataStaffs(filter, id) {
      if (angular.isUndefined(vm.selectedScene)) {
        return;
      }

      if (filter) {
        if (filter.sceneId !== vm.selectedScene._id) {
          return;
        }
      }

      if (angular.isUndefined(id)) {
        vm.selectedScene.staffs = dbStaffs.getFetched(true);
        vm.selectedScene.nostaffs = !(angular.isArray(vm.selectedScene.staffs) && (vm.selectedScene.staffs.length > 0));

        vm.staffEditorState.showingStaffContent = !vm.selectedScene.nostaffs;

        if (!vm.sidebarEditState.enabled) {
          loadStaffGrids();

          if (!(vm.sidebarEditState.enabled || vm.staffEditorState.lockModeNavigation)) {
            if (!vm.selectedScene.nostaffs) {
              // var staffIndexToSelect = Math.min(vm.selectedScene.staffs.length, vm.activePlanRules.allowedNumberOfStaffs) - 1;
              // if (staffIndexToSelect > -1) {
              //   selectStaffById(vm.selectedScene.staffs[staffIndexToSelect]._id, true);
              // }

              if (angular.isDefined($stateParams.navParams)) {
                selectStaffById($stateParams.navParams.staffId, true);
                delete $stateParams.navParams;
              } else {
                selectStaffById(vm.selectedScene.staffs[0]._id, true);
              }
            }
          }
        } else {
          for (var i = 0; i < vm.selectedScene.staffs.length; i++) {
            var staff = vm.selectedScene.staffs[i];

            postProcessStaffTitle(staff);
          }

          clearAllStaffEditModeSelections();
        }
      } else {
        vm.selectedScene.staffs = vm.selectedScene.staffs || [];

        var existingStaff = swaUtils.findInArrayById(vm.selectedScene.staffs, id);
        var incomingStaff = dbStaffs.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingStaff) && !swaUtils.isUndefinedOrNull(incomingStaff));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingStaff) && swaUtils.isUndefinedOrNull(incomingStaff));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingStaff) && !swaUtils.isUndefinedOrNull(incomingStaff));

        var staffScrollViewElement = $('#staffscrollview');
        var staffContainerElement;
        var prevElement;

        if (isInsert) {
          // incoming insert
          vm.selectedScene.staffs.push(incomingStaff);
          swaUtils.sortArrayByNumericKey(vm.selectedScene.staffs, 'orderingindex');
          vm.selectedScene.nostaffs = !(angular.isArray(vm.selectedScene.staffs) && (vm.selectedScene.staffs.length > 0));

          vm.staffEditorState.showingStaffContent = !vm.selectedScene.nostaffs;

          // This ia a new staff
          postProcessStaffTitle(incomingStaff);
          postProcessStaffData(incomingStaff);

          var loadedStaffContainerElement = loadedStaffContainerForStaff(incomingStaff);

          var staffOrderingIndex = incomingStaff.orderingindex;
          if (staffOrderingIndex === 0) {
            staffScrollViewElement.prepend(loadedStaffContainerElement);
          } else {
            prevElement = staffScrollViewElement.children('div.staffcontainer[data-orderingindex="' + (staffOrderingIndex - 1) + '"]').first();
            if (prevElement) {
              prevElement.after(loadedStaffContainerElement);
            } else {
              staffScrollViewElement.prepend(loadedStaffContainerElement);
            }
          }

          if (vm.selectedScene.staffs.length > vm.activePlanRules.allowedNumberOfStaffs) {
            if (angular.isDefined(vm.selectedStaff)) {
              var activeStaffIndex = vm.selectedScene.staffs.indexOf(vm.selectedStaff);
              if (activeStaffIndex >= vm.activePlanRules.allowedNumberOfStaffs) {
                deselectStaff();
              }
            }

            staffScrollViewElement.find('.staffcontainer:gt(' + (vm.activePlanRules.allowedNumberOfStaffs - 1) + ')').remove();
          }

          if (vm.staffInsertedFlag) {
            selectStaffById(incomingStaff._id, true);
            // scrollToStaffContainer(vm);
          }

          vm.staffInsertedFlag = false;
        } else if (isDelete) {
          if (angular.isDefined((vm.selectedStaff)) && (id === vm.selectedStaff._id)) {
            deselectStaff();
            toastr.warning(
              $translate.instant('messages.Score deleted elsewhere.'),
              $translate.instant('messages.Sync warning!')
            );
          }

          var existingStaffIndex = vm.selectedScene.staffs.indexOf(existingStaff);
          if (existingStaffIndex !== -1) {
            vm.selectedScene.staffs.splice(existingStaffIndex, 1);
          }

          vm.selectedScene.nostaffs = !(angular.isArray(vm.selectedScene.staffs) && (vm.selectedScene.staffs.length > 0));

          vm.staffEditorState.showingStaffContent = !vm.selectedScene.nostaffs;

          // Staff has gotten deleted
          staffContainerElement = staffScrollViewElement.children('div[data-staffid="' + existingStaff._id + '"]');
          staffContainerElement.remove();

          // TODO: select another staff if active staff got deleted
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming staff update with ID: ' + id);

          // TODO: merge existing and incoming staff intelligently
          if (!staffCompareIfSame(existingStaff, incomingStaff)) {
            angular.extend(existingStaff, incomingStaff);

            swaUtils.sortArrayByNumericKey(vm.selectedScene.staffs, 'orderingindex');

            staffContainerElement = staffScrollViewElement.children('div[data-staffid="' + existingStaff._id + '"]').first();

            if (!vm.selectedScene.accessRules.allowstaffediting || angular.isUndefined(vm.selectedStaff) || (vm.selectedStaff._id !== id) || !(vm.selectedStaff.dirty || vm.selectedStaff.autoSaved)) {
              postProcessStaffTitle(existingStaff);
              postProcessStaffData(existingStaff);

              // Replace container for non-active staffs
              var newStaffContainerElement = loadedStaffContainerForStaff(existingStaff);
              staffContainerElement.replaceWith(newStaffContainerElement);
              staffContainerElement = newStaffContainerElement;

              prevElement = staffScrollViewElement.children('div.staffcontainer[data-orderingindex="' + (existingStaff.orderingindex - 1) + '"]').first();
              if (prevElement) {
                prevElement.after(staffContainerElement);
              } else {
                staffScrollViewElement.prepend(staffContainerElement);
              }
              existingStaff.syncCollision = false;
            } else {
              // Handle orderingindex name changes for active staff
              assignStaffTitle(existingStaff, staffContainerElement);

              vm.selectedStaffOrderingIndex = existingStaff.orderingindex;
              existingStaff.syncCollision = (existingStaff.modifiedBy !== vm.userId);
            }
          }
        }
      }
    }

    function loadStaffGrids() {
      clearStaffsContainer();

      if (swaUtils.isUndefinedOrNull(vm.selectedScene)) {
        return;
      }

      var staffScrollViewElement = $('#staffscrollview');
      var noOfStaffsToLoad = Math.min(vm.selectedScene.staffs.length, vm.activePlanRules.allowedNumberOfStaffs);
      for (var i = 0; i < noOfStaffsToLoad; i++) {
        var staff = vm.selectedScene.staffs[i];

        postProcessStaffTitle(staff);
        postProcessStaffData(staff);

        var loadedStaffContainerElement = loadedStaffContainerForStaff(staff);

        staffScrollViewElement.append(loadedStaffContainerElement);
      }

      updateStaffViewZoom();
    }

    function loadedStaffContainerForStaff(staff) {
      var staffTemplate = staffTemplateForStaff(staff);
      var staffContainerElement = newStaffContainerForStaff(staff);

      if (angular.isDefined(staffTemplate)) {
        staffContainerElement.append(staffTemplate);

        // load content
        loadStaffContent(vm, staff, staffContainerElement);

        updateChartLink(staff, staffContainerElement);
      } else {
        $log.warn('Missing template for staffId:', staff._id);

        staffContainerElement.append('Error loading staff, missing template !');
      }

      return staffContainerElement;
    }

    function refreshStaffViewForStaff(staff) {
      var staffScrollViewElement = $('#staffscrollview');
      var staffContainerElement = staffScrollViewElement.children('div[data-staffid="' + staff._id + '"]').first();

      postProcessStaffTitle(staff);
      postProcessStaffData(staff);

      var newStaffContainerElement = loadedStaffContainerForStaff(staff);
      staffContainerElement.replaceWith(newStaffContainerElement);
    }

    function setStaffAutoFitWidth(autoFit) {
      vm.staffEditorState.staffAutoFitWidth = autoFit;

      updateStaffViewZoom();

      vm.zoomPicker.show = false;

      saveEditorPreferences();
    }

    function updateStaffViewZoom() {
      if (vm.staffEditorState.staffAutoFitWidth) {
        vm.staffViewScale = $('.staffscrollview').outerWidth() / 1000;
        $('.staffscrollview').css('transform', 'scale(' + vm.staffViewScale + ')');
        $('.staffeditingcontrolscontainer').css('transform', 'scale(' + vm.staffViewScale + ')');
      } else {
        vm.staffViewScale = 1.0;
        $('.staffscrollview').css('transform', '');
        $('.staffeditingcontrolscontainer').css('transform', '');
      }
    }

    var staffViewResizeTimer;
    function docOnResize() {
      if (angular.isDefined(staffViewResizeTimer)) {
        $timeout.cancel(staffViewResizeTimer);
        staffViewResizeTimer = undefined;
      } else {
        vm.staffEditorState.resizing = true;
        // chartBlockUI.start();
      }

      staffViewResizeTimer = $timeout(function () {
        updateStaffViewZoom();

        vm.staffEditorState.resizing = false;
        // chartBlockUI.stop();
        $timeout.cancel(staffViewResizeTimer);
        staffViewResizeTimer = undefined;
      }, 500);
    }

    function updateChartLink(staff, staffContainerElement) {
      // chert link if any
      var linkSpan = staffContainerElement.find('span.staffaccessorylabel-link');
      linkSpan.attr('data-linkedchartId', staff.linkedchartId);

      if (angular.isDefined((staff.linkedchartId)) && (staff.linkedchartId !== null)) {
        linkSpan.on('click', function (event) {
          vm.switchEditor(0, { chartId: event.target.dataset.linkedchartid });
        })
        linkSpan.html('<span class="sw-ionicon-fw sw-ionicon-lg sw-ionicon-spin-1s ion-load-d"></span>');
        var linkedChartName = vm.chartIdToChartNameCache[staff.linkedchartId];
        if (angular.isDefined(linkedChartName)) {
          $q.when(linkedChartName)
            .then(function (chartName) {
              linkSpan.text(chartName).removeAttr('disabled');
            });
        } else {
          resolveChartName(staff.linkedchartId)
            .then(function (chartName) {
              linkSpan.text(chartName).removeAttr('disabled');
            });
        }
      } else {
        linkSpan.text('Unlinked').attr('disabled', 'disabled');
      }
    }

    function resolveChartName(chartId) {
      var deferred = $q.defer();

      dbCharts.getChartForName(chartId)
        .then(function (chart) {
          var chartName;
          if (angular.isDefined(chart)) {
            if (vm.staffEditorState.chartNumberAutomatic) {
              var parentScene = swaUtils.findInArrayById(vm.scenes, chart.sceneId);
              if (angular.isDefined(parentScene)) {
                chartName = 'Chart: ' + (parentScene.orderingindex + 1) + '.' + (chart.orderingindex + 1);
              }
            } else {
              chartName = chart.customname || '<unnamed>';
            }
          } else {
            chartName = '<missing>';
          }

          vm.chartIdToChartNameCache[chartId] = chartName;
          deferred.resolve(chartName);
        })
        .catch(function (error) {
          $log.error('Error resolving chart name for chart ID: ' + chartId + ', reason:', error);

          var chartName = '<error>';
          vm.chartIdToChartNameCache[chartId] = chartName;
          deferred.resolve(chartName);
        });

      return deferred.promise;
    }

    function getChartLinkNameFromCache(chartId) {
      if (vm.chartIdToChartNameCache.hasOwnProperty(chartId)) {
        return vm.chartIdToChartNameCache[chartId];
      } else {
        return undefined;
      }
    }

    function getStaffTemplateForStaffType(staffType) {
      return staffTemplatesService.getTemplateForId(staffType);
    }

    function staffTemplateForStaff(staff) {
      return getStaffTemplateForStaffType(staff.stafftype);
    }

    function newStaffContainerForStaff(staff) {
      var staffContainerElement = $('<div class="staffcontainer inactivestaff"></div>');
      staffContainerElement.attr('data-staffid', staff._id);
      staffContainerElement.attr('data-orderingindex', staff.orderingindex);

      return staffContainerElement;
    }

    function postProcessStaffTitle(staff) {
      if (swaUtils.isUndefinedOrNull(staff.customtitle) || (staff.customtitle.length === 0)) {
        staff.assignedName = getDefaultStaffTitle(staff);
      } else {
        staff.assignedName = staff.customtitle;
      }
    }

    function postProcessStaffData(staff) {
      if (!angular.isArray(staff.voicecells)) {
        staff.voicecells = [];
      }
      if (!angular.isArray(staff.performerrows)) {
        staff.performerrows = [];
      }

      for (var i = 0; i < staff.performerrows.length; i++) {
        var performerrow = staff.performerrows[i];
        if (angular.isDefined(performerrow.performerId)) {
          var linkedPerformer = swaUtils.findInArrayById(vm.performers, performerrow.performerId);
          if (angular.isDefined(linkedPerformer)) {
            performerrow.performerName = linkedPerformer.name;
            performerrow.filterVisible = linkedPerformer.filterVisible;
          } else {
            performerrow.filterVisible = false;
          }
        }
      }
    }

    function staffCompareIfSame(staff1, staff2) {
      if (staff1.counts !== staff2.counts) {
        return false;
      }

      if (staff1.customtitle !== staff2.customtitle) {
        return false;
      }

      if (staff1.orderingindex !== staff2.orderingindex) {
        return false;
      }

      if (staff1.voicerowpairscount !== staff2.voicerowpairscount) {
        return false;
      }

      if (staff1.modified && staff2.modified) {
        if (staff1.modified.$date && staff2.modified.$date) {
          if (Math.abs(staff1.modified.$date - staff2.modified.$date) > 5000) {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }

      // TODO: compare voice rows data
      // TODO: compare performer rows data

      return true;
    }

    function clearStaffsContainer() {
      $('#staffscrollview').html('');
    }

    function getDefaultStaffTitleForStaffId(staffOrId) {
      if (angular.isString(staffOrId)) {
        staffOrId = swaUtils.findInArrayById(vm.selectedScene.staffs, staffOrId);
      }

      if (swaUtils.isUndefinedOrNull(staffOrId)) {
        return;
      }

      return getDefaultStaffTitle(staffOrId);
    }

    function getDefaultStaffTitle(staff) {
      var displayIndex = staff.orderingindex + 1;
      var templateDefinition = staffTemplatesService.getTemplateDefinitionForId(staff.stafftype);

      if (angular.isDefined(templateDefinition)) {
        if (templateDefinition.displaycountprefix) {
          return (staff.counts + ' ' + templateDefinition.displayname + ' - ' + displayIndex);
        } else {
          return (templateDefinition.displayname + ' - ' + displayIndex);
        }
      }
    }

    function toggleScene(scene) {
      if (scene._id === vm.sourceSceneId) {
        return $q.resolve;
      }
      if (vm.sidebarEditState.destinationSelectVisible) {
        if (!scene.accessRules.allowstaffediting) {
          return $q.resolve;
        }
      }
      var deferred = $q.defer();

      ngProgressLite.start();
      blockUI.start();

      var firstQ;
      if (vm.restoringSingleStaff) {
        firstQ = $q.when();
      } else {
        firstQ = saveActiveStaff();
      }

      firstQ
        .then(function () {
          hideSideBarDeleteAndMoveOptions();

          // close currently open scene
          if (angular.isDefined(vm.selectedScene)) {
            if (!vm.restoringSingleStaff) {
              deselectStaff();
              clearStaffsContainer();
            }
            vm.selectedScene.staffs = [];
            vm.selectedScene.open = false;
            vm.selectedScene.selected = false;
            vm.movingSingleScoreOperationToggle = false;
          }

          if (vm.sidebarEditState.enabled) {
            clearAllStaffEditModeSelections();
          }
        })
        .then(function () {
          if (vm.selectedScene !== scene) {
            vm.selectedScene = scene;
            vm.selectedSceneId = scene._id;
            vm.selectedScene.selected = true;
            if (!vm.staffEditorState.lockModeNavigation) {
              vm.selectedScene.open = true;
              vm.movingSingleScoreOperationToggle = true;
              if (vm.selectedScene && vm.selectedScene.accessRules && vm.selectedScene.accessRules.allowmovestaffsource) {
                vm.staffSortableOptions.disabled = false;
              } else {
                vm.staffSortableOptions.disabled = true;
              }
            }
            updateActiveAccessRules();
            return dbStaffs.fetchForScene(scene._id, updateDataStaffs);
          } else {
            vm.selectedScene = undefined;
            vm.selectedSceneId = undefined;

            vm.staffEditorState.showingStaffContent = false;
          }
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('StaffEditorController.toggleScene:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error loading score!')
          );
        })
        .finally(function () {
          updateStickySceneHeader();
          ngProgressLite.done();
          blockUI.stop();
        });

      return deferred.promise;
    }

    function toggleRemovedStaffsScene(scene) {
      deselectStaff();
      clearStaffsContainer();

      hideSideBarDeleteAndMoveOptions();

      // close currently open scene
      if (angular.isDefined(vm.selectedScene)) {
        vm.selectedScene.open = false;
        vm.selectedScene.selected = false;
        vm.movingSingleScoreOperationToggle = false;
      }

      if (vm.selectedScene !== scene) {
        vm.selectedScene = scene;
        vm.selectedSceneId = scene._id;
        vm.selectedScene.selected = true;
        vm.selectedScene.open = true;

        if (angular.isUndefined(vm.selectedStaff)) {
          vm.staffEditorState.showingStaffContent = false;
        }

        updateActiveAccessRules();
      } else {
        vm.selectedScene = undefined;
        vm.selectedSceneId = undefined;

        vm.staffEditorState.showingStaffContent = false;
      }

      updateStickySceneHeader();
    }

    function updateStickySceneHeader() {
      $scope.$applyAsync(function () {
        if (vm.selectedScene && vm.selectedScene.open) {
          var sceneGroup = $('#scene-group-' + vm.selectedScene.orderingindex);
          var groupOffsetTop = sceneGroup.offset().top;
          var groupHeight = sceneGroup.outerHeight();
          if ((groupOffsetTop < 106) && ((groupHeight + groupOffsetTop) > 148)) {
            vm.sceneSticky = true;
          } else {
            vm.sceneSticky = false;
          }
        } else {
          vm.sceneSticky = false;
        }
      });
    }

    function sidebarSelectStaffAtIndex(index, event) {
      var staffToSelect = vm.selectedScene.staffs[index];

      if (vm.sidebarEditState.enabled) {
        toggleStaffEditModeSelection(staffToSelect);
      } else {
        selectStaff(staffToSelect, true);
        selectedIndexForDeleteAndMove = index;

        if (vm.activeCollaborationConfig.isProductionOwner || vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel !== swaAccess.accesslevel.limited) {
          if (!vm.sidebarEditState.enabled && event && (event.metaKey || event.ctrlKey)) {
            if (vm.selectedScene.accessRules.allowcopystaffsource || vm.selectedScene.accessRules.allowmovestaffsource || vm.selectedScene.accessRules.allowdeletestaff) {
              deselectStaff();
              vm.sidebarEditState.enabled = true;
              toggleStaffEditModeSelection(staffToSelect);
              hideSideBarDeleteAndMoveOptions();
            }
          }
        }
      }
    }

    function sidebarSelectDeletedStaffAtIndex(index) {
      var staffToSelect = vm.selectedScene.staffs[index];

      selectDeletedStaff(staffToSelect);
    }

    function toggleSidebarEditMode() {
      if (vm.activePlanRules.planId === 2) {
        toastr.error(
          $translate.instant('planprivileges.messages.Your plan does not permit access to this view/feature.'),
          $translate.instant('planprivileges.titles.Plan - Access Denied!')
        );

        return;
      }

      if (vm.sidebarEditState.enabled === true) {
        // Back to normal mode
        vm.sidebarEditState.enabled = false;
        // vm.staffSortableOptions.disabled = true;

        vm.sourceSceneId = null;

        blockUI.start();

        clearAllStaffEditModeSelections();

        loadStaffGrids();

        $timeout(function () {
          if (angular.isDefined((vm.selectedSceneId)) && (vm.selectedScene.staffs.length > 0) && !(vm.deletedStaffListMode)) {
            vm.sidebarSelectStaffAtIndex(0);
          }
          blockUI.stop();
        }, 500);
      } else {
        // Begin edit mode
        if (!vm.restoringSingleStaff) {
          saveActiveStaff();
          deselectStaff();
          clearStaffsContainer();
        }

        // vm.staffSortableOptions.disabled = false;
        vm.sidebarEditState.enabled = true;

        clearAllStaffEditModeSelections();
      }
    }

    function sidebarShowDestinationSceneListForCopy() {
      var scoreIdsToMoveAndCopy = [];
      for (var i = 0; i < vm.selectedScene.staffs.length; i++) {
        var aStaff = vm.selectedScene.staffs[i];
        if (aStaff.editSelected) {
          scoreIdsToMoveAndCopy.push(aStaff._id);
        }
      }
      vm.scoreIdsToMoveAndCopyAtSpecificIndex = scoreIdsToMoveAndCopy;

      if (vm.scenes[vm.selectedScene.orderingindex].accessRules.allowowneraccess || vm.scenes[vm.selectedScene.orderingindex].accessRules.allowcopystaffsource) {
        vm.selectedScene.open = false;
        vm.sourceSceneId = vm.selectedScene._id;
        vm.sourceSceneForMoveAndCopy = vm.selectedScene;
        vm.sidebarEditState.destinationSelectVisible = true;
        vm.sidebarEditState.destinationSelectForCopy = true;
        vm.sidebarEditState.destinationSelectForMove = false;
        vm.sidebarEditState.destinationSelectForRestore = false;
      } else {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to copy score from this scene'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
      }
    }

    function sidebarShowDestinationSceneListForMove() {
      var scoreIdsToMoveAndCopy = [];
      for (var i = 0; i < vm.selectedScene.staffs.length; i++) {
        var aStaff = vm.selectedScene.staffs[i];
        if (aStaff.editSelected) {
          scoreIdsToMoveAndCopy.push(aStaff._id);
        }
      }
      vm.scoreIdsToMoveAndCopyAtSpecificIndex = scoreIdsToMoveAndCopy;

      if (vm.scenes[vm.selectedScene.orderingindex].accessRules.allowowneraccess || vm.scenes[vm.selectedScene.orderingindex].accessRules.allowmovestaffsource) {
        vm.selectedScene.open = false;
        vm.sourceSceneId = vm.selectedScene._id;
        vm.sourceSceneForMoveAndCopy = vm.selectedScene;
        vm.sidebarEditState.destinationSelectVisible = true;
        vm.sidebarEditState.destinationSelectForCopy = false;
        vm.sidebarEditState.destinationSelectForMove = true;
        vm.sidebarEditState.destinationSelectForRestore = false;
      } else {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to move score from this scene'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
      }
    }

    function sidebarShowDestinationSceneListForRestore(staffVersionId) {
      vm.staffVersionIdToRestore = staffVersionId;
      if (vm.activeCollaborationConfig.isProductionOwner) {
        vm.selectedStaffOrderingIndex = undefined;
        vm.selectedScene.open = false;
        vm.sidebarEditState.destinationSelectVisible = true;
        vm.sidebarEditState.destinationSelectForCopy = false;
        vm.sidebarEditState.destinationSelectForMove = false;
        vm.sidebarEditState.destinationSelectForRestore = true;
      } else {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to restore score from this scene'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
      }
    }

    function sidebarEditSelectDestinationSceneAtIndex(index) {
      // var scoreIdsToMoveAndCopy = vm.scoreIdsToMoveAndCopyAtSpecificIndex;
      if (!vm.moveScoreAtSpecificIndex) {
        var destinationScene = vm.scenes[index];
        var targetIndex = -1;
      } else {
        var destinationScene = vm.selectedScene;
        var targetIndex = index;
      }

      // var destinationScene = vm.scenes[index];
      // if (destinationScene === vm.selectedScene) {
      //   return;
      // }

      var sourceSceneForMoveAndCopy = vm.sourceSceneForMoveAndCopy;
      if (vm.sidebarEditState.destinationSelectForCopy) {
        var scoreIdsToMoveAndCopy = vm.scoreIdsToMoveAndCopyAtSpecificIndex;
        if (destinationScene.accessRules.allowowneraccess || destinationScene.accessRules.allowcopystaffdestination) {
          vm.sidebarEditState.destinationSelectVisible = false;
          // copySelectedStaffs(destinationScene);
          copySelectedStaffs(scoreIdsToMoveAndCopy, destinationScene, targetIndex, sourceSceneForMoveAndCopy);
          vm.sourceSceneId = null;
        } else {
          toastr.error(
            $translate.instant(
              'collaborationprivileges.errormessages.You do not have access to copy score to this scene'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
        }
      } else if (vm.sidebarEditState.destinationSelectForMove) {
        var scoreIdsToMoveAndCopy = vm.scoreIdsToMoveAndCopyAtSpecificIndex;
        if (destinationScene.accessRules.allowowneraccess || destinationScene.accessRules.allowmovestaffdestination) {
          vm.sidebarEditState.destinationSelectVisible = false;
          // moveSelectedStaffs(destinationScene);
          moveSelectedStaffs(scoreIdsToMoveAndCopy, destinationScene, targetIndex, sourceSceneForMoveAndCopy);
          vm.sourceSceneId = null;
        } else {
          toastr.error(
            $translate.instant(
              'collaborationprivileges.errormessages.You do not have access to move score to this scene'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
        }
      } else if (vm.sidebarEditState.destinationSelectForRestore) {
        var staffVersionIdToRestore = vm.staffVersionIdToRestore;
        if (vm.activeCollaborationConfig.isProductionOwner) {
          vm.sidebarEditState.destinationSelectVisible = false;
          restoreSelectedStaff(staffVersionIdToRestore, destinationScene, targetIndex);
        } else {
          toastr.error(
            $translate.instant(
              'collaborationprivileges.errormessages.You do not have access to restore score to this scene'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
        }
      }
    }

    function staffDragSortStop(e, ui) {
      hideSideBarDeleteAndMoveOptions();
      var staffsToUpdate = [];
      for (var i = 0, reindex = 0; i < vm.selectedScene.staffs.length; i++) {
        var aStaff = vm.selectedScene.staffs[i];
        if (aStaff.orderingindex !== reindex) {
          staffsToUpdate.push({
            _id: aStaff._id,
            orderingindex: reindex,
          });
        }

        reindex++;
      }

      if (staffsToUpdate.length > 0) {
        blockUI.start();
        updateStaffs(staffsToUpdate)
          .catch(function (error) {
            $log.error('StaffEditorController.sidebarDragSortStop:', error);
            swaUtils.showErrorToast(error, $translate.instant('errormessages.Error updating order!'));
          })
          .finally(function () {
            $scope.$applyAsync(function () {
              blockUI.stop();
            });
          });
      }
      loadStaffGrids();
    }

    function selectStaff(staff, scrollTo) {
      if (angular.isUndefined(staff)) {
        return;
      }

      var oldSelectedStaff = vm.selectedStaff;
      if (angular.isDefined((vm.selectedStaff)) && (vm.selectedStaff._id !== staff._id)) {
        saveActiveStaff();
      }

      scrollTo = scrollTo || false;

      vm.selectedStaff = staff;
      vm.selectedStaffOrderingIndex = staff.orderingindex;

      var staffElementToSelect = $('div#staffscrollview div[data-staffid=\'' + staff._id + '\']');
      if (vm.activeAccessRules.allowowneraccess || (vm.activeAccessRules.allowstaffediting)) {
        // Activate container if not
        if (!staffElementToSelect.hasClass('active')) {
          activateStaffInContainer(vm, staffElementToSelect);
        }
      }

      if (angular.isDefined(oldSelectedStaff) && (oldSelectedStaff.syncCollision)) {
        refreshStaffViewForStaff(oldSelectedStaff);
        oldSelectedStaff.syncCollision = false;
      }

      // Scroll to container if requested
      if (scrollTo) {
        scrollToStaffContainer(vm, staffElementToSelect);
      }
    }

    function selectDeletedStaff(staff) {
      if (angular.isUndefined(staff)) {
        return;
      }

      vm.selectedStaff = staff;
      vm.selectedStaffOrderingIndex = staff.index;
      checkForStaffVersions();
    }

    function clearAllStaffEditModeSelections() {
      if (angular.isDefined(vm.selectedScene)) {
        if (angular.isDefined(vm.selectedScene.staffs)) {
          for (var i = 0; i < vm.selectedScene.staffs.length; i++) {
            vm.selectedScene.staffs[i].editSelected = false;
          }
        }
      }

      vm.sidebarEditState.selectionCount = 0;
    }

    function toggleStaffEditModeSelection(staff) {
      if (angular.isUndefined(staff)) {
        return;
      }

      if (staff.editSelected) {
        vm.sidebarEditState.selectionCount -= 1;
      } else {
        vm.sidebarEditState.selectionCount += 1;
      }

      staff.editSelected = !staff.editSelected;
    }

    function deselectStaff() {
      deactivateActiveStaffContainer(vm);
      vm.selectedStaff = undefined;
      vm.selectedStaffOrderingIndex = -1;
    }

    function onSaveClick() {
      saveActiveStaff();
    }

    function markActiveStaffDirty() {
      $scope.$applyAsync(function () {
        if (angular.isDefined(vm.selectedStaff)) {
          vm.selectedStaff.dirty = true;
          startAutoSaveTimer();
        }
      });
    }

    function saveActiveStaff(autoSave) {
      var deferred = $q.defer();

      killAutoSaveTimer();

      if (!autoSave) {
        endAnyDeleteMoveMode(vm);
        endAnyCellEditingInteraction(vm);
      }

      if (angular.isDefined(vm.selectedStaff) && vm.selectedStaff.dirty) {
        vm.selectedStaff.dirty = false;
        vm.selectedStaff.autoSaved = autoSave;
        var staffData = getActiveStaffDataForSaving(vm);
        if (angular.isDefined(staffData)) {
          $log.debug('Saving staff with ID: ' + staffData._id);

          deferred.resolve(saveStaff(staffData, autoSave));

          vm.selectedStaff.syncCollision = false;
        } else {
          deferred.resolve();
        }
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    function selectStaffById(staffId, scrollTo) {
      var staffToSelect = swaUtils.findInArrayById(vm.selectedScene.staffs, staffId);

      selectStaff(staffToSelect, scrollTo);

      $timeout(function () {
        vm.scrollUpdateSidebar('scrollTo', $('#staff-' + staffId).position().top - 40);
      }, 500);
    }

    function copySelectedStaffs(scoreIdsToMoveAndCopy, destinationScene, targetIndex, sourceSceneForMoveAndCopy) {
      // if (vm.sidebarEditState.selectionCount < 1) {
      //   return;
      // }

      ngProgressLite.start();
      blockUI.start($translate.instant('messages.Copying ...'));

      dbStaffs.countInScene(destinationScene._id)
        .then(function (numDestinationStaffs) {
          if ((numDestinationStaffs + vm.sidebarEditState.selectionCount) > vm.activePlanRules.allowedNumberOfStaffs) {
            toastr.error(
              $translate.instant('planprivileges.messages.Number of score in scene will exceed current plan limit.'),
              $translate.instant('errormessages.Error copying score!')
            );
            throw new Error('break-q-chain');
          }
        })
        .then(function () {
          return dbStaffs.copyStaffsToSceneAtIndex(scoreIdsToMoveAndCopy, destinationScene._id, targetIndex);
        })
        .then(function () {
          clearAllStaffEditModeSelections();
          if (vm.copyingSingleScore) {
            toggleSidebarEditMode();
            vm.copyingSingleScore = false;
          }
          toastr.success($translate.instant('messages.Score(s) copied successfully!'));
        })
        .catch(function (error) {
          if (error.message !== 'break-q-chain') {
            $log.error('StaffEditorController.copySelectedStaffs:', error);
            swaUtils.showErrorToast(
              error,
              $translate.instant('errormessages.Error copying score!')
            );
          }
        })
        .finally(function () {
          $scope.$applyAsync(function () {
            ngProgressLite.done();
            blockUI.stop();
            $timeout(function () {
              toggleScene(sourceSceneForMoveAndCopy);
            }, 500);
          });
        });
    }

    function moveSelectedStaffs(scoreIdsToMoveAndCopy, destinationScene, targetIndex, sourceSceneForMoveAndCopy) {
      // if (vm.sidebarEditState.selectionCount < 1) {
      //   return;
      // }

      ngProgressLite.start();
      blockUI.start($translate.instant('messages.Moving ...'));

      dbStaffs.countInScene(destinationScene._id)
        .then(function (numDestinationStaffs) {
          if ((numDestinationStaffs + vm.sidebarEditState.selectionCount) > vm.activePlanRules.allowedNumberOfStaffs) {
            toastr.error(
              $translate.instant('planprivileges.messages.Number of score in scene will exceed current plan limit.'),
              $translate.instant('errormessages.Error moving score!')
            );
            throw new Error('break-q-chain');
          }
        })
        .then(function () {
          return dbStaffs.moveStaffsToSceneAtIndex(scoreIdsToMoveAndCopy, destinationScene._id, targetIndex);
        })
        .then(function () {
          clearAllStaffEditModeSelections();
          if (vm.movingSingleScore) {
            toggleSidebarEditMode();
            vm.movingSingleScore = false;
          }
          toastr.success($translate.instant('messages.Score(s) moved successfully!'));
        })
        .catch(function (error) {
          if (error.message !== 'break-q-chain') {
            $log.error('StaffEditorController.moveSelectedStaffs:', error);
            swaUtils.showErrorToast(
              error,
              $translate.instant('errormessages.Error moving score!')
            );
          }
        })
        .finally(function () {
          $scope.$applyAsync(function () {
            ngProgressLite.done();
            blockUI.stop();
            $timeout(function () {
              toggleScene(sourceSceneForMoveAndCopy);
            }, 500);
          });
        });
    }

    function deleteSelectedStaffs() {
      if (vm.scenes[vm.selectedScene.orderingindex].accessRules.allowowneraccess || vm.scenes[vm.selectedScene.orderingindex].accessRules.allowdeletestaff) {
        if (vm.sidebarEditState.selectionCount < 1) {
          return;
        }

        blockUI.start($translate.instant('messages.Deleting ...'));

        var staffIdsToDelete = [];
        for (var i = 0; i < vm.selectedScene.staffs.length; i++) {
          var aStaff = vm.selectedScene.staffs[i];
          if (aStaff.editSelected) {
            staffIdsToDelete.push(aStaff._id);
          }
        }

        dbStaffs.delete(staffIdsToDelete)
          .then(function () {
            toastr.success($translate.instant('messages.Score(s) deleted successfully!'));
          })
          .catch(function (error) {
            $log.error('StaffEditorController.deleteSelectedStaffs:', error);
            swaUtils.showErrorToast(error, $translate.instant('errormessages.Error deleting score!'));
          })
          .finally(function () {
            $scope.$applyAsync(function () {
              clearAllStaffEditModeSelections();
              blockUI.stop();
            });
          });
      } else {
        toastr.error(
          $translate.instant(
            'collaborationprivileges.errormessages.You do not have access to delete score from this scene'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
      }
    }

    function restoreSelectedStaff(staffVersionIdToRestore, destinationScene, targetIndex) {
      ngProgressLite.start();
      blockUI.start($translate.instant('messages.Restoring ...'));

      dbStaffs.countInScene(destinationScene._id)
        .then(function (numDestinationStaffs) {
          if ((numDestinationStaffs + vm.sidebarEditState.selectionCount) > vm.activePlanRules.allowedNumberOfStaffs) {
            toastr.error(
              $translate.instant('planprivileges.messages.Number of score in scene will exceed current plan limit.'),
              $translate.instant('errormessages.Error restoring score!')
            );
            throw new Error('break-q-chain');
          }
        })
        .then(function () {
          clearAllStaffEditModeSelections();
          if (vm.restoringSingleStaff) {
            deselectStaff();
            toggleSidebarEditModeForScore();
            vm.restoringSingleStaff = false;
            toastr.success($translate.instant('messages.Score restored successfully!'));
          }
          return dbStaffs.restoreStaffAtIndexInAnyScene(staffVersionIdToRestore, destinationScene._id, targetIndex);
        })
        .catch(function (error) {
          if (error.message !== 'break-q-chain') {
            $log.error('StaffEditorController.restoreSelectedStaff:', error);
            swaUtils.showErrorToast(
              error,
              $translate.instant('errormessages.Error restoring score!')
            );
          }
        })
        .finally(function () {
          $scope.$applyAsync(function () {
            ngProgressLite.done();
            blockUI.stop();
            vm.selectedStaff = undefined;
            vm.selectedStaffOrderingIndex = undefined;
          });
        });
    }

    function updateStaffs(staffsToUpdate) {
      var updateQs = [];
      for (var k = 0; k < staffsToUpdate.length; k++) {
        updateQs.push(dbStaffs.update(staffsToUpdate[k]));
      }

      return $q.all(updateQs);
    }

    function embedPerformerPicker(staffCellElement, performerId) {
      var assignedPerformerIds = [];

      staffCellElement.parents('table.stafftable').first().find(
        'tr.characterrow th.characterheadercell span').each(function () {
          var assignedPerformerId = $(this).attr('data-performerId'); // eslint-disable-line angular/controller-as-vm
          if ((!swaUtils.isUndefinedOrNull(assignedPerformerId)) && (assignedPerformerId.length > 0) && (
            assignedPerformerId !== performerId)) {
            assignedPerformerIds.push(assignedPerformerId);
          }
        });

      vm.filteredPerformers = [];
      for (var j = 0; j < vm.performers.length; j++) {
        var aPerformer = vm.performers[j];
        if (!assignedPerformerIds.includes(aPerformer._id)) {
          vm.filteredPerformers.push(aPerformer);
        }
      }

      vm.selectedPickerPerformer = swaUtils.findInArrayById(vm.performers, performerId);

      var pickerHtml = '<select ng-model="vm.selectedPickerPerformer" ' +
        'ng-options="performer.name for performer in vm.filteredPerformers" ' +
        'ng-change="vm.performerPickerSelectionChange()">' +
        '<option value="">None</option>' +
        '</select>';
      var el = $compile(pickerHtml)($scope);
      staffCellElement.append(el);
    }

    function performerPickerSelectionChange() {
      var staffCellElement = vm.activeStaffCellElement;
      if (swaUtils.isUndefinedOrNull(staffCellElement)) {
        return;
      }

      var spanElement = staffCellElement.children('span').first();
      if (angular.isUndefined(vm.selectedPickerPerformer)) {
        if (angular.isDefined(spanElement.attr('data-performerId'))) {
          markActiveStaffDirty();
        }

        spanElement.removeAttr('data-performerId');
        var orderingIndex = parseInt(spanElement.attr('data-orderingindex'));
        spanElement.text('<character ' + (orderingIndex + 1) + '>');
      } else {
        if (spanElement.attr('data-performerId') !== vm.selectedPickerPerformer._id) {
          markActiveStaffDirty();
        }

        spanElement.attr('data-performerId', vm.selectedPickerPerformer._id);
        spanElement.text(vm.selectedPickerPerformer.name);
      }
    }

    $scope.$watch('vm.addStaffWorkflowPopover.show', function (newValue, oldValue) {
      if (newValue) {
        vm.addStaffWorkflowStep1();
      }
    });

    function addStaffWorkflowStep1() {
      vm.addStaffWorkflow.step = 1;
      vm.addStaffWorkflow.initialCounts = -1;
      vm.addStaffWorkflow.selectedStaffType = -1;
    }

    function addStaffWorkflowSelectStaffType(staffType, initialCounts) {
      vm.addStaffWorkflow.step = 2;
      vm.addStaffWorkflow.initialCounts = initialCounts;
      vm.addStaffWorkflow.selectedStaffType = staffType;
    }

    function addStaffWorkflowSelectAllPerformers() {
      for (var i = 0; i < vm.performers.length; i++) {
        vm.performers[i].addStaffSelected = true;
      }
    }

    function addStaffWorkflowClearPerformersSelection() {
      for (var i = 0; i < vm.performers.length; i++) {
        vm.performers[i].addStaffSelected = false;
      }
    }

    function addStaffWorkflowDone() {
      var initialPerformerIds = [];

      for (var i = 0; i < vm.performers.length; i++) {
        if (vm.performers[i].addStaffSelected === true) {
          initialPerformerIds.push(vm.performers[i]._id);
        }
      }

      $cookies.addStaffSelectedPerformerIds = initialPerformerIds.toString();

      addStaffOfType(vm.addStaffWorkflow.selectedStaffType, vm.addStaffWorkflow.initialCounts, initialPerformerIds);

      vm.addStaffWorkflowPopover.show = false;
    }

    function addStaffOfType(staffType, initialCounts, initialPerformerIds) {
      ngProgressLite.start();
      blockUI.start();

      var templateDefinition = staffTemplatesService.getTemplateDefinitionForId(staffType);
      var newStaff = dbStaffs.getEmptyStaffObject();

      // parent scene
      newStaff.sceneId = vm.selectedScene._id;

      // type
      newStaff.stafftype = templateDefinition.templateId;

      // counts
      newStaff.counts = templateDefinition.defaultcount;

      // voice rows
      newStaff.voicerowcount = (templateDefinition.voicerowcount * 2);

      // voice cells
      newStaff.voicecells = [];

      // performers
      newStaff.performerrows = [];
      if (angular.isDefined(initialPerformerIds)) {
        for (var i = 0; i < initialPerformerIds.length; i++) {
          var performerrow = {};
          performerrow.orderingindex = i;
          performerrow.performerId = initialPerformerIds[i];

          newStaff.performerrows.push(performerrow);
        }
      }

      // ordering
      newStaff.orderingindex = vm.selectedStaffOrderingIndex + 1;

      vm.staffInsertedFlag = true;
      dbStaffs.insert(newStaff)
        .then(function () {
          // TODO: select newly added staff
          toastr.success($translate.instant('messages.Score added.'));
        })
        .catch(function (error) {
          vm.staffInsertedFlag = false;
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error adding score!'));
        })
        .finally(function () {
          $scope.$applyAsync(function () {
            ngProgressLite.done();
            blockUI.stop();
          });
        });
    }

    function saveStaff(staffData, autoSave) {
      var deferred = $q.defer();

      ngProgressLite.start();
      if (!autoSave) {
        blockUI.start();
      }

      var updatedStaff = angular.copy(staffData);

      ngProgressLite.set(0.4);
      dbStaffs.update(updatedStaff)
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('StaffEditorController.saveStaff:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving score!')
          );
          deferred.reject(error);
        })
        .finally(function () {
          ngProgressLite.done();
          if (!autoSave) {
            blockUI.stop();
          }
        });

      return deferred.promise;
    }

    function switchEditor(index, navParams) {
      var params = {
        productionId: selectedProductionId,
        lockModeNavigation: vm.staffEditorState.lockModeNavigation,
        selectedScene: vm.selectedScene,
        navParams: navParams
      };

      if (index === 0) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.charteditor, params);
      } else if (index === 2) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.chartstaffeditor, params);
      }
    }

    function setupStaffContainerHandlers() {
      $('#staffscrollview').on('click', 'div.inactivestaff', function (event) {
        if (!vm.staffEditorState.lockModeNavigation && !vm.deletedStaffListMode) {
          var staffId = $(this).attr('data-staffid'); // eslint-disable-line angular/controller-as-vm
          selectStaffById(staffId);
          $scope.$apply();
        }

        event.preventDefault();
      });
    }

    function showAllPerformers() {
      // Clear filters
      $cookies.filteredPerformerIds = '';
      for (var i = 0; i < vm.performers.length; i++) {
        vm.performers[i].filterSelected = false;
      }

      updatePerformerVisibility();

      saveActiveStaff();
      deselectStaff();
      clearStaffsContainer();

      loadStaffGrids();

      vm.showPerformerFilter.show = false;
    }

    function applyPerformerFilter() {
      var filteredPerformerIds = [];
      for (var i = 0; i < vm.performers.length; i++) {
        if (vm.performers[i].filterSelected === true) {
          filteredPerformerIds.push(vm.performers[i]._id);
        }
      }

      $cookies.filteredPerformerIds = filteredPerformerIds.toString();

      updatePerformerVisibility();

      saveActiveStaff();
      deselectStaff();
      clearStaffsContainer();

      loadStaffGrids();

      vm.showPerformerFilter.show = false;
    }

    function onHelpTourStart() {
      scrollToStaffContainer(vm);
    }

    function updateSceneCollaborationAccessRules(scenes) {
      return scenes.reduce(function (q, scene) {
        return q.then(function () {
          if (vm.activeCollaborationConfig.isProductionOwner === true) {
            if (vm.activePlanRules.planId === 2) {
              scene.accessRules = angular.copy(defaultViewAccessRules);
            } else {
              scene.accessRules = angular.copy(defaultOwnerAccessRules);
            }
            return $q.resolve();
          } else {
            if (vm.activePlanRules.planId === 2) {
              scene.accessRules = angular.copy(defaultViewAccessRules);
            } else {
              scene.accessRules = angular.copy(defaultDenyAccessRules);
              if (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel !== swaAccess.accesslevel.custom) {
                var params = {
                  statename: swaRouterStateNames.staffeditor,
                  accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
                };

                return dbCollaborationPrivileges.getCollaborationPrivileges(params)
                  .then(function (privilegeData) {
                    angular.extend(scene.accessRules, privilegeData.accessrules);
                  })
                  .catch(function (error) {
                    $log.error('StaffEditorController.updateSceneCollaborationAccessRules:', error);
                  })
                  .finally(function () {
                    return $q.resolve();
                  });
              } else {
                var sceneAccess = _.findWhere(vm.activeCollaborationConfig.collaborationSetting.collaborationaccess
                  .sceneaccess, {
                  sceneId: scene._id
                });
                if (angular.isDefined(sceneAccess)) {
                  var params1 = {
                    statename: swaRouterStateNames.staffeditor,
                    accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
                    allowstaffediting: sceneAccess.allowstaffediting,
                  };

                  return dbCollaborationPrivileges.getCollaborationPrivileges(params1)
                    .then(function (privilegeData) {
                      angular.extend(scene.accessRules, privilegeData.accessrules);
                    })
                    .catch(function (error) {
                      $log.error('StaffEditorController.updateSceneCollaborationAccessRules:', error);
                    })
                    .finally(function () {
                      return $q.resolve();
                    });
                }
              }
            }
          }
        });
      }, $q.resolve());
    }

    function updateActiveAccessRules() {
      $scope.$applyAsync(function () {
        var accessRules;
        if (angular.isDefined(vm.selectedScene)) {
          accessRules = vm.selectedScene.accessRules;
        }

        if (accessRules) {
          angular.extend(vm.activeAccessRules, accessRules);
        } else {
          angular.extend(vm.activeAccessRules, defaultDenyAccessRules);
        }
      });
    }

    function loadEditorPreferences() {
      vm.staffEditorState.staffAutoFitWidth = vm.staffEditorPreferences.staffAutoFitWidth;
    }

    function saveEditorPreferences() {
      vm.staffEditorPreferences.staffAutoFitWidth = vm.staffEditorState.staffAutoFitWidth;
    }

    function initHelpTour() {
      vm.showHelpBar = false;
      var profileDisplayHelp = false;
      if (angular.isDefined(vm.userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || vm.userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }

      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function showHelpHints() {
      if (!vm.activeCollaborationConfig.isProductionOwner &&
        (vm.activePlanRules.planId !== 2) &&
        (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited)) {
        toastr.info(
          $translate.instant('messages.score_limited_access_hint'),
          $translate.instant('titles.Limited access')
        );
      }
    }

    function initHelpTourSteps() {
      vm.helpTourSteps = [{
        element: '#menu-locknavigation',
        title: $translate.instant('helptour.editor.titles.menu-locknavigation'),
        content: $translate.instant('helptour.editor.messages.menu-locknavigation'),
        placement: 'bottom',
      }, {
        element: '#menu-switchview',
        title: $translate.instant('helptour.editor.titles.menu-switchview'),
        content: $translate.instant('helptour.editor.messages.menu-switchview'),
        placement: 'bottom',
      }, {
        element: '#menu-addstaff',
        title: $translate.instant('helptour.staffEditor.titles.menu-addstaff'),
        content: $translate.instant('helptour.staffEditor.messages.menu-addstaff'),
        placement: 'bottom',
      }, {
        element: '#menu-filterperformers',
        title: $translate.instant('helptour.staffEditor.titles.menu-filterperformers'),
        content: $translate.instant('helptour.staffEditor.messages.menu-filterperformers'),
        placement: 'bottom',
      }, {
        element: '#menu-staffzoom',
        title: $translate.instant('helptour.editor.titles.menu-staffzoom'),
        content: $translate.instant('helptour.editor.messages.menu-staffzoom'),
        placement: 'bottom',
      }, {
        element: '#menu-savechanges',
        title: $translate.instant('helptour.editor.titles.menu-savechanges'),
        content: $translate.instant('helptour.editor.messages.menu-savechanges'),
        placement: 'left',
      }, {
        element: '#menu-createpdf',
        title: $translate.instant('helptour.editor.titles.menu-createpdf'),
        content: $translate.instant('helptour.editor.messages.menu-createpdf'),
        placement: 'left',
      }, {
        element: '#menu-collaborators',
        title: $translate.instant('helptour.editor.titles.menu-collaborators'),
        content: $translate.instant('helptour.editor.messages.menu-collaborators'),
        placement: 'left',
      }, {
        element: '#menu-settings',
        title: $translate.instant('helptour.editor.titles.menu-settings'),
        content: $translate.instant('helptour.editor.messages.menu-settings'),
        placement: 'left',
      }, {
        element: '#sidebar-scenelist',
        title: $translate.instant('helptour.staffEditor.titles.sidebar-scenelist'),
        content: $translate.instant('helptour.staffEditor.messages.sidebar-scenelist'),
        placement: 'right',
      }, {
        element: '#sidebar-copymovedelete',
        title: $translate.instant('helptour.staffEditor.titles.sidebar-copymovedelete'),
        content: $translate.instant('helptour.staffEditor.messages.sidebar-copymovedelete'),
        placement: 'top',
      }, {
        //   element: '#score-list',
        //   title: $translate.instant('helptour.staffEditor.titles.score-list'),
        //   content: $translate.instant('helptour.staffEditor.messages.score-list'),
        //   placement: 'top',
        //   orphan: true,
        // }, {
        element: '.activestaff .stafftable',
        title: $translate.instant('helptour.staffEditor.titles.score-editing'),
        content: $translate.instant('helptour.staffEditor.messages.score-editing'),
        placement: 'bottom',
      }, {
        element: '.activestaff .stafftable',
        title: $translate.instant('helptour.staffEditor.titles.score-editingkeyboard1'),
        content: $translate.instant('helptour.staffEditor.messages.score-editingkeyboard1'),
        placement: 'bottom',
      }, {
        element: '.activestaff .stafftable',
        title: $translate.instant('helptour.staffEditor.titles.score-editingkeyboard2'),
        content: $translate.instant('helptour.staffEditor.messages.score-editingkeyboard2'),
        placement: 'bottom',
      }, {
        element: '.activestaff #buttonvoiceadd',
        title: $translate.instant('helptour.staffEditor.titles.score-addvoicerow'),
        content: $translate.instant('helptour.staffEditor.messages.score-addvoicerow'),
        placement: 'bottom',
      }, {
        element: '.activestaff #buttonvoicedelete',
        title: $translate.instant('helptour.staffEditor.titles.score-deleteordervoicerow'),
        content: $translate.instant('helptour.staffEditor.messages.score-deleteordervoicerow'),
        placement: 'bottom',
      }, {
        //   element: '.activestaff #buttoncountminus',
        //   title: $translate.instant('helptour.staffEditor.titles.Delete Character'),
        //   content: $translate.instant('helptour.staffEditor.messages.Delete Character Content'),
        //   placement: 'bottom',
        // }, {
        //   element: '.activestaff #buttoncountplus',
        //   title: $translate.instant('helptour.staffEditor.titles.Add Character'),
        //   content: $translate.instant('helptour.staffEditor.messages.Add Character Content'),
        //   placement: 'bottom',
        // }, {
        element: '.activestaff #buttoncharacteradd',
        title: $translate.instant('helptour.staffEditor.titles.score-addperformerrow'),
        content: $translate.instant('helptour.staffEditor.messages.score-addperformerrow'),
        placement: 'top',
      }, {
        element: '.activestaff #buttoncharacterdelete',
        title: $translate.instant('helptour.staffEditor.titles.score-deleteorderperformerrow'),
        content: $translate.instant('helptour.staffEditor.messages.score-deleteorderperformerrow'),
        placement: 'top',
      }, {
        element: '.activestaff .staffcollapsebuttoncontainer:first',
        title: $translate.instant('helptour.staffEditor.titles.score-collapseperformer'),
        content: $translate.instant('helptour.staffEditor.messages.score-collapseperformer'),
        placement: 'bottom',
      }, {
        element: '#button-closeproduction',
        title: $translate.instant('helptour.editor.titles.button-closeproduction'),
        content: $translate.instant('helptour.editor.messages.button-closeproduction'),
        placement: 'right',
      },
      ];

      vm.helpTourVideos = [{
        label: 'Editing Staging Score',
        videoUrl: 'https://www.youtube.com/embed/coNkSb1taRM?si=g8QqZwkqE36sFtxS'
      }];
    }

    function updateState() {
      $timeout(function () {
        $scope.$apply();
      }, 200);
    }

    function unregisterFetches() {
      dbProductions.fetchUnregister();
      dbPerformers.fetchUnregister();
      dbScenes.fetchUnregister();
      dbStaffs.fetchUnregister();
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        saveActiveStaff();
      }
    });

    $scope.$on('$destroy', function () {
      swPdfPrintService.unregisterForChange(vm);
      unregisterFetches();
      unregisterKeyboardHandler();
      unregisterResizeHandler();
    });

    // Staff editing logic functions below
    function staffEditingEditCell() {
      beginEditingCell(vm);
    }

    function staffEditingDeleteCell() {
      deleteActiveCell(vm);
    }

    function staffEditingResizeCell() {
      beginResizingActiveCell(vm);
    }

    function staffEditingDone() {
      endAnyCellEditingInteraction(vm, true);
    }

    function staffEditingResize(edge, amount) {
      sizeActiveCell(vm, edge, amount);
    }

    function staffEditingCutCell() {
      $scope.$applyAsync(function () {
        if (cutActiveCell(vm)) {
          toastr.info($translate.instant('messages.Copied to clipboard'));
        }
      });
    }

    function staffEditingCopyCell() {
      $scope.$applyAsync(function () {
        if (copyActiveCell(vm)) {
          toastr.info($translate.instant('messages.Copied to clipboard'));
        }
      });
    }

    function staffEditingPasteCell() {
      pasteInActiveCell(vm);
    }

    function keyboardHandler(event) {
      if (keyboardHandlerCheckTarget(event)) {
        return;
      }

      // key
      var whichKey = event.which;
      var key = event.key;

      // modifier keys and combos
      var ctrlKey = event.ctrlKey && !(event.altKey || event.shiftKey || event.metaKey);
      var ctrlShiftKey = event.ctrlKey && event.shiftKey && !(event.altKey || event.metaKey);
      var metaKey = event.metaKey && !(event.altKey || event.shiftKey || event.ctrlKey);
      var metaShiftKey = event.metaKey && event.shiftKey && !(event.altKey || event.ctrlKey);
      var noModKey = !(event.ctrlKey || event.altKey || event.shiftKey || event.metaKey);

      // lock mode navigation control
      if (vm.staffEditorState.lockModeNavigation) {
        if (whichKey === 27) {
          toggleLockModeNavigation();
          return;
        }
        if (whichKey === 37) {
          if (ctrlKey) {
            lockNavigationPreviousScene();
          } else {
            lockNavigationPreviousStaff();
          }
          event.stopPropagation();
          event.preventDefault();

          return;
        } else if (whichKey === 39) {
          if (ctrlKey) {
            lockNavigationNextScene();
          } else {
            lockNavigationNextStaff();
          }
          event.stopPropagation();
          event.preventDefault();

          return;
        }
      }
    }

    function keyboardHandlerCheckTarget(event) {
      var target = event.target;

      if (vm.staffEditorState.lockModeNavigation) {
        return false;
      } else if ((target.nodeName === 'INPUT') || (target.nodeName === 'TEXTAREA')) {
        return true;
      } else {
        return target.attributes.contenteditable;
      }
    }

    function registerKeyboardHandler() {
      $log.debug('StaffEditorController: registerKeyboardHandler:');
      $(document).on('keydown', keyboardHandler);

      tryIdentifyPlatform();
    }

    function unregisterKeyboardHandler() {
      $log.debug('StaffEditorController: unregisterKeyboardHandler:');
      $(document).off('keydown', keyboardHandler);
    }

    function registerResizeHandler() {
      $log.debug('StaffEditorController: registerResizeHandler:');
      $window.addEventListener('resize', docOnResize);
    }

    function unregisterResizeHandler() {
      $log.debug('StaffEditorController: unregisterResizeHandler:');
      $window.removeEventListener('resize', docOnResize);
    }

    function tryIdentifyPlatform() {
      vm.platformMac = (navigator.platform && (navigator.platform.match(/mac/i) !== null)) || (navigator.userAgent.match(/Macintosh/i) !== null);
    }

    function toggleLockModeNavigation() {
      hideSideBarDeleteAndMoveOptions();
      if (vm.staffEditorState.lockModeNavigation) {
        blockUI.start('Leaving lock mode ...');
      } else {
        blockUI.start('Enabling lock mode ...');
      }

      if (vm.sidebarEditState.enabled) {
        toggleSidebarEditMode();
      }

      vm.staffEditorState.lockModeNavigation = !vm.staffEditorState.lockModeNavigation;

      saveActiveStaff()
        .then(function () {
          if (vm.staffEditorState.lockModeNavigation) {
            lockNavigationSelectInitialStaff();
          } else {
            $('#staffscrollview > .staffcontainer').removeClass('lockselect');

            if (angular.isDefined(vm.selectedScene)) {
              vm.selectedScene.open = true;
            }

            if (angular.isDefined(vm.selectedStaff)) {
              selectStaffById(vm.selectedStaff._id);
            }
          }
        })
        .then(function () {
          $scope.$applyAsync(function () {
            updateStaffViewZoom();
          });
        })
        .then(function () {
          blockUI.stop();
        });
    }

    function lockNavigationSelectInitialStaff() {
      if (angular.isDefined(vm.selectedStaff) || angular.isDefined(vm.selectedScene)) {
        var staffToSelect = vm.selectedStaff;
        deselectStaff();
        lockModeSelectStaff(staffToSelect);

        return;
      }

      // toggle open the first scene
      lockNavigationPreviousScene();
    }

    function lockNavigationPreviousScene(fromPrevStaff) {
      fromPrevStaff = fromPrevStaff || false;
      toastr.clear();
      if (angular.isDefined(vm.selectedScene)) {
        var previousSceneIndex = vm.selectedScene.orderingindex - 1;
        if (previousSceneIndex > -1) {
          var previousScene = vm.scenes[previousSceneIndex];
          toggleScene(previousScene)
            .then(function () {
              var staffToSelect;
              if (!fromPrevStaff) {
                staffToSelect = _.first(vm.selectedScene.staffs);
              } else {
                staffToSelect = _.last(vm.selectedScene.staffs);
              }
              if (angular.isDefined(staffToSelect)) {
                lockModeSelectStaff(staffToSelect, true);
              }
            });
        } else {
          // try to go to first staff in the scene
          var staffToSelect = _.first(vm.selectedScene.staffs);
          if (angular.isDefined(staffToSelect) && (vm.selectedStaff !== staffToSelect)) {
            lockModeSelectStaff(staffToSelect, true);
          } else {
            toastr.info($translate.instant('messages.At first score/scene'));
          }
        }
      } else {
        var firstScene = _.first(vm.scenes);
        if (angular.isDefined(firstScene)) {
          toggleScene(firstScene)
            .then(function () {
              var staffToSelect = _.first(vm.selectedScene.staffs);
              if (angular.isDefined(staffToSelect)) {
                lockModeSelectStaff(staffToSelect, true);
              }
            });
        }
      }
    }

    function lockNavigationPreviousStaff() {
      toastr.clear();
      if (angular.isDefined(vm.selectedStaff)) {
        var previousOrderingIndex = vm.selectedStaff.orderingindex - 1;

        if (previousOrderingIndex > -1) {
          var previousStaff = vm.selectedScene.staffs[previousOrderingIndex];
          lockModeSelectStaff(previousStaff, true);
        } else {
          lockNavigationPreviousScene(true);
        }
      } else {
        lockNavigationPreviousScene(true);
      }
    }

    function lockNavigationNextStaff() {
      toastr.clear();
      if (angular.isDefined(vm.selectedStaff)) {
        var nextOrderingIndex = vm.selectedStaff.orderingindex + 1;

        if (nextOrderingIndex < vm.selectedScene.staffs.length) {
          var nextStaff = vm.selectedScene.staffs[nextOrderingIndex];
          lockModeSelectStaff(nextStaff, true);
        } else {
          lockNavigationNextScene();
        }
      } else {
        lockNavigationNextScene();
      }
    }

    function lockNavigationNextScene(overflow) {
      toastr.clear();
      if (angular.isDefined(vm.selectedScene)) {
        var nextSceneIndex = vm.selectedScene.orderingindex + 1;
        if (nextSceneIndex < vm.scenes.length) {
          var nextScene = vm.scenes[nextSceneIndex];
          toggleScene(nextScene)
            .then(function () {
              var staffToSelect = _.first(vm.selectedScene.staffs);
              if (angular.isDefined(staffToSelect)) {
                lockModeSelectStaff(staffToSelect);
              }
            });
        } else {
          // try to go to last staff in the scene
          var staffToSelect = _.last(vm.selectedScene.staffs);
          if (angular.isDefined(staffToSelect) && (vm.selectedStaff !== staffToSelect)) {
            lockModeSelectStaff(staffToSelect, true);
          } else {
            toastr.info($translate.instant('messages.At last score/scene'));
          }
        }
      } else {
        var lastScene = _.last(vm.scenes);
        if (angular.isDefined(lastScene)) {
          toggleScene(lastScene)
            .then(function () {
              var staffToSelect = _.last(vm.selectedScene.staffs);
              if (angular.isDefined(staffToSelect)) {
                lockModeSelectStaff(staffToSelect, true);
              }
            });
        }
      }
    }

    function lockModeSelectStaff(staff) {
      vm.selectedStaff = staff;
      vm.selectedStaffOrderingIndex = staff.orderingindex;

      $('#staffscrollview > .staffcontainer').removeClass('lockselect');

      var staffContainerToSelect = $('div#staffscrollview div[data-staffid=\'' + staff._id + '\']');
      staffContainerToSelect.addClass('lockselect');

      // $('.sw-editorcontent').mCustomScrollbar('scrollTo', staffContainerToSelect);
      staffContainerToSelect.get(0).scrollIntoView();
    }

    function killAutoSaveTimer() {
      if (angular.isDefined(vm.autoSaveState.intervalQ)) {
        $interval.cancel(vm.autoSaveState.intervalQ);
        vm.autoSaveState.intervalQ = undefined;
      }
      vm.autoSaveState.timerActive = false;
      vm.autoSaveState.timeoutRemainingSec = 0;
    }

    function startAutoSaveTimer() {
      if (angular.isDefined(vm.autoSaveState.intervalQ)) {
        vm.autoSaveState.timeoutRemainingSec = vm.autoSaveState.timeoutMaxSec;
        return;
      }
      vm.autoSaveState.timeoutRemainingSec = vm.autoSaveState.timeoutMaxSec;
      vm.autoSaveState.intervalQ = $interval(function () {
        vm.autoSaveState.timeoutRemainingSec -= (vm.autoSaveState.timeoutDecaySec);
        if (vm.autoSaveState.timeoutRemainingSec <= 0) {
          killAutoSaveTimer();
          autoSaveHandler();
        }
      }, vm.autoSaveState.timeoutPollIntervalSec * 1000);
      vm.autoSaveState.timerActive = true;
    }

    function autoSaveHandler() {
      if (!vm.autoSaveState.saveActive) {
        $log.info('autoSaveHandler: auto save started!');
        vm.autoSaveState.saveActive = true;
        saveActiveStaff(true)
          .catch(function () {
          })
          .then(function () {
            vm.autoSaveState.saveActive = false;
            $log.info('autoSaveHandler: auto save done!');
          });
      } else {
        $log.info('autoSaveHandler: auto save in progress, ignoring!');
      }
    }

    function showSideBarDeleteAndMoveOptions(event) {
      vm.menuTop = event.clientY - 40;
      vm.menuLeft = 225;
      if (vm.selectedScene.accessRules.allowmovestaffsource || vm.selectedScene.accessRules.allowdeletestaff || vm.selectedScene.accessRules.allowcopystaffsource) {
        vm.chartSidebarDeleteAndMoveOptionState.visible = true;
      }
    }
    function hideSideBarDeleteAndMoveOptions() {
      vm.chartSidebarDeleteAndMoveOptionState.visible = false;
    }
    function toggleSideBarDeleteAndMoveOptions() {
      vm.chartSidebarDeleteAndMoveOptionState.visible = !vm.chartSidebarDeleteAndMoveOptionState.visible;
    }

    function showSidebarEditModeOptions() {
      if (vm.selectedScene.accessRules.allowmovestaffsource || vm.selectedScene.accessRules.allowdeletestaff || vm.selectedScene.accessRules.allowcopystaffsource) {
        vm.chartSidebarEditOptionState.visible = true;
      }
    }
    function hideSidebarEditModeOptions() {
      vm.chartSidebarEditOptionState.visible = false;
    }
    function toggleSidebarEditModeOptions() {
      vm.chartSidebarEditOptionState.visible = !vm.chartSidebarEditOptionState.visible;
    }

    function deleteSingleStaff() {
      toggleSidebarEditMode();
      sidebarSelectStaffAtIndex(selectedIndexForDeleteAndMove);
      deleteSelectedStaffs();
      toggleSidebarEditMode();
    }

    function moveSingleStaff() {
      vm.movingSingleScore = true;
      toggleSidebarEditMode();
      sidebarSelectStaffAtIndex(selectedIndexForDeleteAndMove);
      sidebarShowDestinationSceneListForMove();
    }

    function copySingleStaff() {
      vm.copyingSingleScore = true;
      toggleSidebarEditMode();
      sidebarSelectStaffAtIndex(selectedIndexForDeleteAndMove);
      sidebarShowDestinationSceneListForCopy();
    }

    function restoreSingleStaff() {
      vm.restoringSingleStaff = true;
      var staffVersionId = vm.staffVersionBrowserState.selectedVersion._id;
      toggleSidebarEditMode();
      sidebarSelectStaffAtIndex(selectedIndexForDeleteAndMove);
      sidebarShowDestinationSceneListForRestore(staffVersionId);
    }

    function restoreStaff() {
      if (vm.activeCollaborationConfig.isProductionOwner) {
        restoreSingleStaff();
      } else {
        restoreStaffPermissionAlert();
      }
    }

    function toggleSidebarEditModeForScore() {
      vm.sourceSceneId = null;
      vm.sidebarEditState.destinationSelectVisible = false;
      if (vm.movingSingleScoreOperationToggle) {
        vm.selectedScene.open = true;
      }
      if (vm.movingSingleScore) {
        toggleSidebarEditMode();
        vm.movingSingleScore = false;
      }
      if (vm.copyingSingleScore) {
        toggleSidebarEditMode();
        vm.copyingSingleScore = false;
      }
      if (vm.restoringSingleStaff) {
        toggleSidebarEditMode();
        vm.restoringSingleStaff = false;
        vm.selectedStaff = undefined;
        enterDeletedStaffList();
      }
    }

    // Add click event listener to the document body
    // eslint-disable-next-line angular/document-service
    document.body.addEventListener('click', function (event) {
      var isButtonClick = event.target.closest('#sideBarDeleteAndMoveOptionsMenuButton');
      var isInsidePopup = event.target.closest('#sideBarDeleteAndMoveOptionsMenu');

      if (!isButtonClick && !isInsidePopup) {
        hideSideBarDeleteAndMoveOptions();
      }
    });

    // Chart delete move option hint
    function copyMoveDeleteOptionHintPrompt() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/staffEditor/copyMoveDeleteOptionHintPrompt.html',
        controller: 'DeleteMoveOptionHintController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });
    }

    // Chart restore permission alert
    function restoreStaffPermissionAlert() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/staffEditor/restoreStaffPermissionMessage.html',
        controller: 'RestoreStaffPermissionMessageController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });
    }

    // Chart Delete Warning prompt
    function deleteStaffPrompt() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/staffEditor/deleteStaffPrompt.html',
        controller: 'DeleteStaffController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });
      if (vm.deleteMultipleScores) {
        modalInstance.result.then(deleteSelectedStaffs);
      } else {
        modalInstance.result.then(deleteSingleStaff);
      }
    }

    function getAllDeletedStaffs() {
      blockUI.start('Looking for deleted scores ...');
      dbStaffs.getDeletedStaffsFromAllScenes(vm.selectedProduction._id)
        .then(function (allDeletedStaffsList) {
          vm.totalDeletedStaffsInProduction = allDeletedStaffsList;
          allDeletedStaffsList.forEach(function (staff, index) {
            staff.index = index + 1;
            staff.sceneId = 'dummyscene';
          });

          var currentDate = Date.now();
          var dateBeforeSevenDays = currentDate - 604800000; // 7 days

          vm.dummyScenesForRemovedStaffs[0].staffs = allDeletedStaffsList.filter(function (staff) {
            return staff.deletedDate.$date >= dateBeforeSevenDays;
          });
          vm.dummyScenesForRemovedStaffs[1].staffs = allDeletedStaffsList.filter(function (staff) {
            return staff.deletedDate.$date < dateBeforeSevenDays;
          });
        })
        .catch(function (error) {
          $log.error('Error getting deleted scores:', error);
          toastr.error('Error getting deleted scores!');
        })
        .finally(function () {
          toggleRemovedStaffsScene(vm.dummyScenesForRemovedStaffs[0]);
          // deselectStaff();
          blockUI.stop();
        });
    }

    function enterDeletedStaffList() {
      var staffContainerElement = $('#staffscrollview');
      scrollToStaffContainer(vm, staffContainerElement);

      if (vm.sidebarEditState.enabled) {
        toggleSidebarEditMode();
      }

      var firstQ;
      if (angular.isDefined(vm.selectedScene)) {
        firstQ = toggleScene(vm.selectedScene)
      } else {
        firstQ = $q.resolve();
      }

      firstQ
        .then(function () {
          vm.selectedStaff = undefined;
          vm.selectedStaffOrderingIndex = undefined;

          vm.deletedStaffListMode = true;
          vm.totalDeletedStaffsInProduction = [];
        })
        .then(function () {
          clearStaffsContainer();
          vm.staffEditorState.showingStaffContent = false;
        })
        .then(function () {
          return getAllDeletedStaffs();
        });
    }

    function leaveDeletedStaffList() {
      staffVersionBrowserState.active = false;

      if (vm.selectedScene) {
        toggleRemovedStaffsScene(vm.selectedScene)
      }
      vm.selectedScene = undefined;
      vm.selectedStaff = undefined;
      vm.restoringSingleStaff = false;
      vm.deletedStaffListMode = false;
      vm.staffEditorState.showingStaffContent = false;
    }

    function checkForStaffVersions() {
      toastr.clear();
      blockUI.start('Looking for staff versions ...');
      dbStaffsArchive.find(vm.selectedStaff._id)
        .then(function (archivedStaffs) {
          if (angular.isArray(archivedStaffs) && archivedStaffs.length > 0) {
            staffVersionBrowserState.staffVersions = angular.copy(archivedStaffs);

            enterStaffVersionsBrowser();
          } else {
            toastr.info('No versions found for this score');

            staffVersionBrowserState.staffVersions = [];
            staffVersionBrowserState.active = true;
            vm.staffEditorState.showingStaffContent = false;

            deselectStaff();
            clearStaffsContainer();
          }
        })
        .catch(function (err) {
          $log.error('checkForStaffVersions: err:', err);
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    function enterStaffVersionsBrowser() {
      blockUI.start('Loading staff Versions ...');

      if (vm.sidebarEditState.enabled) {
        toggleSidebarEditMode();
      }

      staffVersionBrowserState.active = true;

      staffVersionBrowserState.selectedIndex = 0;
      staffVersionBrowserState.maxIndex = (staffVersionBrowserState.staffVersions.length - 1);

      vm.staffEditorState.showingStaffContent = true;

      loadVersionedStaff();
      getUserNameById();
      blockUI.stop();
    }

    function loadVersionedStaff() {
      blockUI.start();

      staffVersionBrowserState.prevEnabled = (staffVersionBrowserState.selectedIndex > 0);
      staffVersionBrowserState.nextEnabled = (staffVersionBrowserState.selectedIndex < staffVersionBrowserState.maxIndex);
      staffVersionBrowserState.selectedVersion = staffVersionBrowserState.staffVersions[staffVersionBrowserState.selectedIndex];

      var staff = staffVersionBrowserState.selectedVersion.staff;
      loadStaffGridsForArchivedStaff(staff);

      blockUI.stop();
    }

    function staffVersionPrevious() {
      staffVersionBrowserState.selectedIndex--;
      if (staffVersionBrowserState.selectedIndex < 0) {
        staffVersionBrowserState.selectedIndex = 0;
      } else {
        vm.staffEditorState.showingStaffContent = true;
        loadVersionedStaff();
        getUserNameById();
      }
    }

    function staffVersionNext() {
      staffVersionBrowserState.selectedIndex++;
      if (staffVersionBrowserState.selectedIndex > staffVersionBrowserState.maxIndex) {
        staffVersionBrowserState.selectedIndex = maxIndex;
      } else {
        vm.staffEditorState.showingStaffContent = true;
        loadVersionedStaff();
        getUserNameById();
      }
    }

    function getUserNameById() {
      dbUser.getDisplayName(vm.staffVersionBrowserState.selectedVersion.userId).then(
        function (displayName) {
          if (angular.isDefined(displayName)) {
            vm.staffVersionBrowserState.selectedVersion.displayName = displayName;
          }
        },

        function (error) {
          $log.error(error);
        }
      );
    }

    function loadStaffGridsForArchivedStaff(staff) {
      clearStaffsContainer();

      if (swaUtils.isUndefinedOrNull(vm.selectedScene)) {
        return;
      }

      var staffScrollViewElement = $('#staffscrollview');
      postProcessStaffTitle(staff);
      postProcessStaffData(staff);
      var loadedStaffContainerElement = loadedStaffContainerForStaff(staff);
      staffScrollViewElement.append(loadedStaffContainerElement);

      updateStaffViewZoom();
    }
  }
}());

(function () {
    'use strict';

    angular.module('swanywhere').controller('RestoreStaffPermissionMessageController', RestoreStaffPermissionMessageController);

    RestoreStaffPermissionMessageController.$inject = ['$uibModalInstance'];

    function RestoreStaffPermissionMessageController($uibModalInstance) {
        var vm = this;

        vm.actionOk = actionOk;

        function actionOk() {
            $uibModalInstance.close();
        }
    }
}());

(function () {
    'use strict';
    angular.module('swanywhere').controller('DeleteStaffController', DeleteStaffController);
  
    DeleteStaffController.$inject = [
      '$uibModalInstance'
    ];
  
    function DeleteStaffController($uibModalInstance) {
      var vm = this;
  
      vm.actionYes = actionYes;
      vm.actionNo = actionNo;
  
      function actionYes() {
        $uibModalInstance.close();
      }
  
      function actionNo() {
        $uibModalInstance.dismiss('cancel');
      }
    }
  }());
  
(function () {
    'use strict';

    angular.module('swanywhere').controller('DeleteMoveOptionHintController', DeleteMoveOptionHintController);

    DeleteMoveOptionHintController.$inject = ['$uibModalInstance'];

    function DeleteMoveOptionHintController($uibModalInstance) {
        var vm = this;

        vm.actionOk = actionOk;

        function actionOk() {
            $uibModalInstance.close();
        }
    }
}());

(function () {
    'use strict';
  
    angular.module('swanywhere').controller('UndoPdfImportPromptController', UndoPdfImportPromptController);
  
    UndoPdfImportPromptController.$inject = ['$uibModalInstance'];
  
    function UndoPdfImportPromptController($uibModalInstance) {
      var vm = this;
  
      vm.actionYes = actionYes;
      vm.actionNo = actionNo;
  
      function actionYes() {
        $uibModalInstance.close();
      }
  
      function actionNo() {
        $uibModalInstance.dismiss();
      }
    }
  }());
  
/* global $, PDFJS, TextLayerBuilder */
'use strict';

var ScriptImportPdfProcessor = (function ScriptImportPdfProcessorClosure() {
  function ScriptImportPdfProcessor(options) {
    this.renderScale = parseFloat(options.renderScale) || 1.0;
    this.renderContainer = options.renderContainer;
    this.allowedNumberOfScriptPages = options.allowedNumberOfScriptPages;
    this.progressCallback = options.progressCallback;
    this.completeCallback = options.completeCallback;

    this.initRenderContainer();
  }

  ScriptImportPdfProcessor.prototype = {
    initRenderContainer: function _initRenderContainer() {
      this.renderContainer = $(this.renderContainer);
      this.renderContainer.empty();

      this.renderTextJElement = $('<div class="previewTextLayer"></div>');
      this.renderCanvasJElement = $('<canvas class="previewCanvasLayer"></div>');

      this.renderContainer.append(this.renderTextJElement);
      this.renderContainer.append(this.renderCanvasJElement);

      this.renderTextElement = this.renderTextJElement.get(0);
      this.renderCanvasElement = this.renderCanvasJElement.get(0);
    },

    processPdf: function _processPdf(data) {
      var _this = this; //get context of this for promises

      // PDFJS.disableWorker = true;
      // PDFJS.workerSrc = 'libs/pdfjs/pdf.worker.js'
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.1.81/pdf.worker.min.js'
      pdfjsLib.getDocument(data).promise.then(
        function (pdf) {
          _this.pdfObject = pdf;
          _this.startIterating();
        },
        function (error) {
          _this.completeCallback(undefined, error);
        }
      );
    },

    startIterating: function _startIterating() {
      this.pages = [];
      this.numberOfPages = Math.min(this.pdfObject.numPages, this.allowedNumberOfScriptPages);
      this.currentPageNumber = 0;

      this.processNextPage();
    },

    processNextPage: function _processNextPage() {
      var _this = this;
      this.currentPageNumber++;
      if (this.currentPageNumber <= this.numberOfPages) {
        this.pdfObject.getPage(this.currentPageNumber).then(
          function (page) {
            var viewport = page.getViewport({ scale: 96.0 / 72 });
            var scriptPage = {
              orderingindex: (_this.currentPageNumber - 1),
              pagewidth: viewport.width,
              pageheight: viewport.height,
            };
            _this.pages[(_this.currentPageNumber - 1)] = scriptPage;

            _this.clearRenderContainer();
            _this.renderPage(page, scriptPage);
          },
          function (error) {
            _this.completeCallback(undefined, error);
          }
        );
      } else {
        var scriptObject = {
          numberOfPages: this.numberOfPages,
          pages: this.pages,
        };

        this.completeCallback(scriptObject);
      }
    },

    cancel: function () {
      this.completeCallback(null, new Error('Import cancelled'));
    },

    renderPage: function _renderPage(pdfPage, scriptPage) {
      var _this = this;
      var scaleDownFactor = 1.0;
      // if page width is more than 8.5", scale it down
      if (scriptPage.pagewidth > 816) {
        scaleDownFactor = 816 / scriptPage.pagewidth;
        scriptPage.pagewidth = Math.round(scriptPage.pagewidth * scaleDownFactor);
        scriptPage.pageheight = Math.round(scriptPage.pageheight * scaleDownFactor);
      }

      var viewport = pdfPage.getViewport({ scale: scaleDownFactor * this.renderScale * 96 / 72 });

      this.setRenderContainerSize(viewport.width, viewport.height);

      var context = this.renderCanvasElement.getContext('2d');
      this.renderCanvasElement.height = viewport.height;
      this.renderCanvasElement.width = viewport.width;

      var renderContext = {
        canvasContext: context,
        viewport: viewport
      };
      pdfPage.render(renderContext).promise.then(
        function () {
          // var scriptPage = _this.pages[(_this.currentPageNumber - 1)];
          scriptPage.contentimage = _this.renderCanvasElement.toDataURL('image/png').substring(22);

          _this.progressCallback({
            processed: _this.currentPageNumber,
            total: _this.numberOfPages
          });
        },
        function (error) {
          _this.completeCallback(undefined, error);
        }
      );
      // page.getTextContent().then(
      //   function (textContent) {
      //     var textLayer = new TextLayerBuilder({
      //       textLayerDiv: _this.renderTextElement,
      //       viewport: viewport,
      //     });
      //
      //     textLayer.setTextContent(textContent);
      //     textLayer.render();
      //
      //     var scriptPage = _this.pages[(_this.currentPageNumber - 1)];
      //     scriptPage.pagewidth = viewport.width;
      //     scriptPage.pageheight = viewport.height;
      //     scriptPage.content = _this.renderTextJElement.html();
      //     scriptPage.content = scriptPage.content.replace(/(\r\n|\n|\r)/gm, '');
      //
      //     _this.progressCallback({
      //       processed: _this.currentPageNumber,
      //       total: _this.numberOfPages
      //     });
      //   },
      //   function (error) {
      //     _this.completeCallback(undefined, error);
      //   }
      // );
    },

    clearRenderContainer: function _clearRenderContainer() {
      this.renderTextJElement.empty();
    },

    setRenderContainerSize: function _setRenderContainerSize(width, height) {
      this.renderTextJElement.css('width', width);
      this.renderTextJElement.css('height', height);
    },
  };

  return ScriptImportPdfProcessor;
})();

(function () {
  'use strict';

  angular.module('swanywhere').controller('ScriptFreehandErasePromptController', ScriptFreehandErasePromptController);

  ScriptFreehandErasePromptController.$inject = ['$uibModalInstance'];

  function ScriptFreehandErasePromptController($uibModalInstance) {
    var vm = this;

    vm.actionYes = actionYes;
    vm.actionNo = actionNo;

    function actionYes() {
      $uibModalInstance.close();
    }

    function actionNo() {
      $uibModalInstance.dismiss();
    }
  }
}());

// jshint unused:false
/* global $, ScriptImportPdfProcessor, document, jQuery, Q, tinymce */
(function () {
  'use strict';

  angular.module('swanywhere').controller('ScriptEditorBookViewController', ScriptEditorBookViewController);

  ScriptEditorBookViewController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    'toastr',
    'DbScripts',
    'DbUserScripts',
    'DbScriptPages',
    'DbSubMgrService',
    '$log',
    'ngProgressLite',
    'blockUI',
    'DbProductions',
    '$timeout',
    '$uibModal',
    '$translate',
    'swaUtils',
    'swaRouterStateNames',
    '$interval',
    'DbCollaborationPrivileges',
    'swaAccess',
    '$document',
    'swaUi',
    'swPdfPrintService',
    '$q',
    'swaConfig',
    'DbScenes',
    '$localStorage',
    'DbUserScriptPages',
    'DbUserProductions',
    'DbCharts',
    '$window',
    '$sce',
    'swaPdfToImage'
  ];


  function ScriptEditorBookViewController($scope, $cookies, $stateParams, toastr,
    DbScripts, DbUserScripts, DbScriptPages, DbSubMgrService, $log, ngProgressLite, blockUI,
    DbProductions, $timeout, $uibModal, $translate, swaUtils, swaRouterStateNames, $interval,
    DbCollaborationPrivileges, swaAccess, $document, swaUi, swPdfPrintService, $q, swaConfig, DbScenes, $localStorage,
    dbUserScriptPages, DbUserProductions, DbCharts, $window, $sce, swaPdfToImage) {


    /**
     * @typedef ScriptEditorStateType
     * @property {Number} currentPageNumber
     * @property {ScriptBookmarkType} currentBookmark
     */

    /**
     * @typedef ScriptEditorBookViewController
     * @property {ScriptEditorStateType} scriptEditorState
     */

    /**
     * @type ScriptEditorBookViewController
     */
    var vm = this;
    var selectedProductionId;

    var dbProductions = new DbProductions();
    var dbUserProductions = new DbUserProductions();
    var dbScenes = new DbScenes();
    var dbCharts = new DbCharts();
    var dbScripts = new DbScripts();
    var dbUserScripts = new DbUserScripts();
    var dbScriptPages = new DbScriptPages();
    var dbUserScriptPages = new dbUserScriptPages();
    var dbCollaborationPrivileges = new DbCollaborationPrivileges();

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowscriptediting: false,
      allowscriptimport: false,
      allowaddactionannotation: false,
      allowaddlightcueannotation: false,
      allowaddtextannotation: false,
      allowaddhighlightannotation: false,
      allowtoggleannotation: false,
      allowannotationediting: false,
      allowpagenavigation: false,
      allowpersonalnotes: false,
    };

    var defaultViewAccessRules = {
      allowowneraccess: false,
      allowscriptediting: false,
      allowscriptimport: false,
      allowaddactionannotation: false,
      allowaddlightcueannotation: false,
      allowaddtextannotation: false,
      allowaddhighlightannotation: false,
      allowtoggleannotation: true,
      allowannotationediting: false,
      allowpagenavigation: true,
      allowpersonalnotes: false,
    };

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowscriptediting: true,
      allowscriptimport: true,
      allowaddactionannotation: true,
      allowaddlightcueannotation: true,
      allowaddtextannotation: true,
      allowaddhighlightannotation: true,
      allowtoggleannotation: true,
      allowannotationediting: true,
      allowpagenavigation: true,
      allowpersonalnotes: false,
    };

    vm.highlightColorPickerOption = swaUi.highlightColorPickerOption;

    vm.userData = {};
    vm.userId = '';

    vm.swaRouterStateNames = swaRouterStateNames;

    // All scenes in production
    vm.scenes = [];

    vm.script;
    vm.currentScriptPage = [];
    vm.ownerScriptPage = [];

    /** @type ScriptBookmarkType[] */
    vm.bookmarks = [];
    /** @type ScriptBookmarkType[] */
    vm.sortedBookmarks = [];

    vm.chartIdToChartNameCache = {};

    vm.drawingpad = [undefined, undefined];
    vm.drawingpadPersonal = [undefined, undefined];
    vm.drawingpadForSharedLayer = [undefined, undefined];

    vm.scriptEditorState = [{
      scriptAvailable: false,
      currentPageNumber: -1,
      totalNumberOfPages: -1,
      activeAnnotationType: -1,
      bookmarkEditMode: false,
      masterLayerActive: false,
      personalLayerActive: false,
      bookmarkLayerActive: false,
      annotationsVisible: true,
      annotationsVisiblePersonal: true,
      pageLoaded: false,
      pageLoadError: false,
      chartNumberAutomatic: true,
      currentBookmark: null,
      lockModeNavigation: true,
      selectedColor: 'rgb(0,0,255)',
      customPageNumber: -1,
    }, {
      scriptAvailable: false,
      currentPageNumber: -1,
      totalNumberOfPages: -1,
      activeAnnotationType: -1,
      bookmarkEditMode: false,
      masterLayerActive: false,
      personalLayerActive: false,
      bookmarkLayerActive: false,
      annotationsVisible: true,
      annotationsVisiblePersonal: true,
      pageLoaded: false,
      pageLoadError: false,
      chartNumberAutomatic: true,
      currentBookmark: null,
      lockModeNavigation: true,
      selectedColor: 'rgb(0,0,255)'
    }];

    // vm.scriptEditorState = [];

    vm.scrollConfigContent = {
      theme: 'light',
      axis: 'y',
      scrollbarPosition: 'inside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
      },
      autoHideScrollbar: false,
      advanced: {
        updateOnContentResize: true,
      },
    };

    vm.scrollConfigSidebar = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
      callbacks: {
        // whileScrolling: updateStickySceneHeader,
        // onScroll: updateStickySceneHeader,
      }
    };

    vm.gotoPagePicker = {};
    vm.gotoPagePicker1 = {};

    vm.revealSidebar = false;

    vm.switchEditor = switchEditor;
    vm.gotoPage = gotoPage;
    vm.gotoPageQuick = gotoPageQuick;
    vm.onHelpTourStart = onHelpTourStart;
    vm.onHelpTourEnd = onHelpTourEnd;

    vm.toggleBookmarkListVisibility = toggleBookmarkListVisibility;
    vm.gotoBookmark = gotoBookmark;
    vm.gotoPrevBookmark = gotoPrevBookmark;
    vm.gotoNextBookmark = gotoNextBookmark;
    vm.toggleBookView = toggleBookView;
    vm.activateMasterNotesLayer = activateMasterNotesLayer;
    vm.activatePersonalNotesLayer = activatePersonalNotesLayer;

    vm.loadScriptEditorPage = loadScriptEditorPage;

    vm.findAndGoToPageNoFromCustomPageNumber = findAndGoToPageNoFromCustomPageNumber;


    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedScriptPages: false,
      allowedNumberOfScriptPages: 0,
    };

    vm.PdfPrintTypes = swPdfPrintService.PdfPrintTypes;

    vm.numberOfPagesDisplay = $localStorage.numberOfPagesDisplay || 2;
    vm.pageViewArr = [];

    vm.userProduction = {};
    vm.selectedScene;

    vm.defaultActionTextSettings = {};
    vm.defaultLqTextSettings = {};
    vm.defaultFloatingTextSettings = {};

    vm.bookViewScale = [1.0, 1.0];
    vm.bookViewPageContainerHeight = ['auto', 'auto'];
    vm.annotationlayers = [];
    vm.sharedannotationlayers = [];
    vm.hiddenAnnotationLayersList = [];
    vm.hiddenSharedAnnotationLayersList = [];

    initialize();

    function initialize() {
      $cookies.put('currentEditorStateName', swaUtils.getRouterCurrentStateName());

      sessionCheckAndRun();
      registerKeyboardHandler();
      registerResizeHandler();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();

      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.validateActivePlan();
        })
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        })
        .then(function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        })
        .then(function (plan) {
          updateActivePlanRules(plan);
        })
        .then(function () {
          initPageLayout();
        })
        .then(function () {
          return getAllData();
        })
        .then(function () {
          showHelpHints();
          initHelpTour();
        })
        .then(function () {
          vm.selectedScene = $stateParams.selectedScene;
        })
        .then(function () {
          $cookies.put('selectedProductionId', selectedProductionId);
        })
        .then(null, null, function (progress) {
          ngProgressLite.set(progress);
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    /** Gets production data */
    function getProduction() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId)
        .then(function (production) {
          updateDataProduction(production);
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    /** Gets (and monitors) scenes */
    function getScenes() {
      return dbScenes.fetchAllInProduction(selectedProductionId, updateDataScenes);
    }

    function getScript() {
      $log.debug('ChartScriptEditorController.getScript() -->');

      var deferred = $q.defer();

      dbScripts.findByProduction(selectedProductionId)
        .then(function (script) {
          vm.script = script;
          vm.scriptEditorState[0].scriptAvailable = angular.isDefined(vm.script);
          vm.scriptEditorState[1].scriptAvailable = angular.isDefined(vm.script);

          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function getAllData() {
      var deferred = $q.defer();

      getProduction()
        .then(function () {
          deferred.notify(0.2);
          return setupPdfPrintService();
        })
        .then(function () {
          deferred.notify(0.3);
          return updateCollaborationPrivileges();
        })
        .then(function () {
          deferred.notify(0.4);
          if (vm.activeAccessRules.allowpersonalnotes) {
            activatePersonalNotesLayer();
          } else {
            activateMasterNotesLayer();
          }
        })
        .then(function () {
          deferred.notify(0.6);
          return getScenes();
        })
        .then(function () {
          deferred.notify(0.7);
          return getScript();
        })
        .then(function () {
          deferred.notify(0.9);
          return loadScript();
        })
        .then(function () {
          return loadUserProductionPreferences();
        })
        // .then(function () {
        //   beginPreloadScriptPages();
        // })
        .then(function () {
          deferred.notify(1.0);
        })
        .catch(function (error) {
          deferred.reject(error);
        })
        .finally(function () {
          deferred.resolve();
        });

      return deferred.promise;
    }

    function loadUserProductionPreferences() {
      dbUserProductions.findByProductionId(selectedProductionId)
        .then(function (userProduction) {
          if (angular.isUndefined(userProduction)) {
            vm.defaultActionTextSettings = angular.copy(swaUi.defaultTextStylePreferences);
            vm.defaultLqTextSettings = angular.copy(swaUi.defaultTextStylePreferences);
            vm.defaultFloatingTextSettings = angular.copy(swaUi.defaultTextStylePreferences);
            vm.scriptEditorState[0].highlightColor = swaUi.defaultScriptHighlightColor;
          } else {
            vm.defaultActionTextSettings = angular.copy(userProduction.contentDefaults.settingsScriptAction);
            vm.defaultLqTextSettings = angular.copy(userProduction.contentDefaults.settingsScriptLq);
            vm.defaultFloatingTextSettings = angular.copy(userProduction.contentDefaults.settingsScriptText);
            vm.scriptEditorState[0].highlightColor = userProduction.contentDefaults.colorScriptHighlight;
          }
        })
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;

      vm.activePlanRules.allowUnlimitedScriptPages = plan.planfeatures[6].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedScriptPages) {
        vm.activePlanRules.allowedNumberOfScriptPages = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfScriptPages = plan.planfeatures[6].featurevalue;
      }
    }

    function updateDataProduction(production) {
      vm.selectedProduction = production;

      if (angular.isUndefined(vm.selectedProduction) || (parseInt(vm.selectedProduction.productiontype) !== 1)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error('Invalid state');
      }

      if (vm.selectedProduction.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(vm.selectedProduction.collaboratorIds) && (vm.selectedProduction.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = vm.selectedProduction.collaborationsettings.find(function (element) {
            return (element.collaboratorId === vm.userId);
          });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error(
            $translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          throw new Error('Invalid state');
        }
      }

      DbSubMgrService.setSelectedProduction(vm.selectedProduction);

      vm.scriptEditorState[0].chartNumberAutomatic = (vm.selectedProduction.chartsettings.chartnumberautomatic === true);
    }

    function setupPdfPrintService() {
      swPdfPrintService.setSelectedProduction(vm.selectedProduction);
      vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
      vm.onPrintJobsChange = onPrintJobsChange;
      swPdfPrintService.registerForChange(vm);
    }

    function onPrintJobsChange(change, id, job) {
      vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
    }

    function getPrintChartPersonalNotes() {
      return (!vm.activeCollaborationConfig.isProductionOwner && (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited)) ||
        (vm.activePlanRules.planId === 2);
    }

    function updateDataScenes(id) {
      if (angular.isUndefined(id)) {
        vm.scenes = dbScenes.getFetched(true);
        // vm.scenes.forEach(updateSceneChartIds)
        // updateSceneCollaborationAccessRules(vm.scenes);
      } else {
        var existingScene = swaUtils.findInArrayById(vm.scenes, id);
        var incomingScene = dbScenes.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingScene) && swaUtils.isUndefinedOrNull(incomingScene));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));

        if (isInsert) {
          // updateSceneCollaborationAccessRules([incomingScene]);
          vm.scenes.push(incomingScene);
          swaUtils.sortArrayByNumericKey(vm.scenes, 'orderingindex');
          // updateSceneChartIds(incomingScene);
        } else if (isDelete) {
          toastr.warning($translate.instant('messages.Scene deleted elsewhere.'), $translate.instant(
            'messages.Sync warning!'));
          if (existingScene === vm.selectedScene) {
            toggleScene();
          }

          var existingSceneIndex = vm.scenes.indexOf(existingScene);
          if (existingSceneIndex !== -1) {
            vm.scenes.splice(existingSceneIndex, 1);
          }
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming scene update with ID: ' + id);
          angular.extend(existingScene, incomingScene);
          // updateSceneChartIds(existingScene);
        }
      }
    }

    function switchEditor(index, navParams) {
      var params = {
        productionId: selectedProductionId,
        lockModeNavigation: vm.scriptEditorState[0].lockModeNavigation,
        selectedScene: vm.selectedScene,
        navParams: navParams
      };

      if (index === 0) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.charteditor, params);
      } else if (index === 4) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.chartscripteditor, params);
      }
    }

    function toggleBookmarkListVisibility() {
      vm.scriptEditorState[0].bookmarkListVisible = !vm.scriptEditorState[0].bookmarkListVisible;
    }

    function updateSortedBookmarks() {
      vm.sortedBookmarks = dbScripts.sortBookmarks(vm.bookmarks);
    }

    function loadScript() {
      var deferred = $q.defer();

      if (vm.scriptEditorState[0].scriptAvailable) {
        dbScriptPages.getNumberOfPages(vm.script._id)
          .then(function (numberOfPages) {
            vm.script.numberOfPages = numberOfPages;
            vm.scriptEditorState[0].totalNumberOfPages = numberOfPages;
            vm.scriptEditorState[0].maxLeftPageNo = (vm.numberOfPagesDisplay !== 2) ? numberOfPages : ((numberOfPages % vm.numberOfPagesDisplay === 0) ? (numberOfPages - 1) : numberOfPages);
            vm.scriptEditorState[0].currentPageNumber = -1;
            vm.currentScriptPage = [];
          })
          .then(function () {
            if (vm.script.numberOfPages > 0) {
              if (vm.activeAccessRules.allowpersonalnotes) {
                return dbUserScripts.getForScript(vm.script._id);
              }
            }
          })
          .then(function (userScript) {
            if (vm.script.numberOfPages > 0) {
              if (vm.activeAccessRules.allowpersonalnotes) {
                vm.userScript = userScript;
                if (angular.isUndefined(userScript) || !angular.isArray(userScript.annotationlayers)) {
                  vm.annotationlayers = getDefaultLayers();
                } else {
                  vm.annotationlayers = angular.copy(userScript.annotationlayers);
                }
              } else {
                if (!angular.isArray(vm.script.annotationlayers)) {
                  vm.annotationlayers = getDefaultLayers();
                } else {
                  vm.annotationlayers = angular.copy(vm.script.annotationlayers);
                }
              }

              updateSharedAnnotationLayers();

              resetHiddenLayerList();
              resetHiddenSharedLayerList();
            }
          })
          .then(function () {
            return changeActionAnnotationType();
          })
          .then(function () {
            if (vm.script.numberOfPages > 0) {
              vm.bookmarks = angular.isArray(vm.script.bookmarks) ? angular.copy(vm.script.bookmarks) : [];
              updateSortedBookmarks();
              var lastOpenedIndex = $localStorage.scriptLastOpenedPageIndex || 0;
              if (angular.isDefined($stateParams.navParams)) {
                lastOpenedIndex = parseInt($stateParams.navParams.orderingindex, 10)
                delete $stateParams.navParams;
              }
              lastOpenedIndex = (lastOpenedIndex < vm.script.numberOfPages) ? lastOpenedIndex : 0;

              return loadBookView(lastOpenedIndex);
            }
          })
          .then(function () {
            deferred.resolve();
          })
          .catch(function (error) {
            deferred.reject(error);
          });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    /**
     * Loads pages for the book view.
     * @param {Number} anyPageIndex a left/right page index of the book view
     */
    function loadBookView(anyPageIndex) {
      $log.debug('loadBookView() -->', anyPageIndex);
      var deferred = $q.defer();

      var qLoad = [];

      vm.pageViewArr = [];
      vm.scriptEditorState[0].currentPageNumber = -1;
      vm.scriptEditorState[1].currentPageNumber = -1;
      // 0 - Left side, 1 - Right side

      // load single / left page
      var leftPageIndex = leftPageIndex = (anyPageIndex % vm.numberOfPagesDisplay === 0) ? anyPageIndex : (anyPageIndex - 1);
      var leftPageIndex = (leftPageIndex < vm.script.numberOfPages) ? leftPageIndex : 0;
      if (leftPageIndex < vm.script.numberOfPages) {
        vm.pageViewArr.push(leftPageIndex);
        qLoad.push(loadScriptPageAtIndex(0, leftPageIndex));
      }

      // load right page if needed
      var rightPageIndex = leftPageIndex + 1;
      if ((rightPageIndex < vm.script.numberOfPages) && vm.numberOfPagesDisplay === 2) {
        vm.pageViewArr.push(rightPageIndex);
        qLoad.push(loadScriptPageAtIndex(1, rightPageIndex));
      }

      $q.all(qLoad)
        .then(function () {
          updatePageScale();
          updateScrollbar();
          $log.debug('loadBookView() <-- all loaded');
          deferred.resolve(true);
        })
        .catch(function (err) {
          deferred.reject(err);
        });

      return deferred.promise;
    }

    function updateScrollbar() {
      var scriptContainerToSelect = $('div.sw-maincontentarea-script');
      scriptContainerToSelect.mCustomScrollbar("update");
    }

    function loadScriptPageAtIndex(sideIndex, index) {
      $log.debug('loadScriptPageAtIndex() -->', sideIndex, index);
      var deferred = $q.defer();

      blockUI.start();
      vm.scriptEditorState[sideIndex].currentPageNumber = (index + 1);

      var pageForSharedLayer = undefined;
      dbScriptPages.getScriptPageAtIndex(vm.script._id, index)
        .then(function (scriptPage) {
          pageForSharedLayer = scriptPage;
          if (angular.isUndefined(scriptPage)) {
            throw new Error($translate.instant('errormessages.Page not found'));
          }

          $localStorage.scriptLastOpenedPageIndex = index;
          vm.scriptEditorState[sideIndex].customPageNumber = scriptPage.customPageNumber;
          loadScriptPage(sideIndex, scriptPage);
          return loadScriptPageImage(sideIndex, scriptPage)
        })
        .then(function (scriptPage) {
          if (vm.activeAccessRules.allowpersonalnotes) {
            return dbUserScriptPages.getForScriptPage(scriptPage._id)
          }
        })
        .then(function (personalNotes) {
          if (vm.activeAccessRules.allowpersonalnotes) {
            loadScriptPagePersonal(sideIndex, personalNotes, pageForSharedLayer);
          }
        })
        .then(function () {
          updateMarginCss(sideIndex, index);
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error loading script page!')
          );

          vm.scriptEditorState[sideIndex].pageLoaded = false;
          vm.scriptEditorState[sideIndex].pageLoadError = true;
          vm.currentScriptPage = [];

          deferred.reject(error);
        })
        .finally(function () {
          $log.debug('loadScriptPageAtIndex() <--', sideIndex, index);
          blockUI.stop();
        });

      return deferred.promise;
    }

    function resetHiddenLayerList() {
      vm.hiddenAnnotationLayersList = [];
      angular.forEach(vm.annotationlayers, function (annotationlayer) {
        // SWA-1922 - if isvisible not set the set default true
        if (angular.isUndefined(annotationlayer.isvisible)) {
          annotationlayer.isvisible = true
        }
        if (annotationlayer.isvisible === false) {
          // Visibility false so add to hidden layer list
          vm.hiddenAnnotationLayersList.push(annotationlayer.layerid);
        }
      });
    }

    function resetHiddenSharedLayerList() {
      vm.hiddenSharedAnnotationLayersList = [];
      angular.forEach(vm.sharedannotationlayers, function (annotationlayer) {
        if (angular.isUndefined(annotationlayer.isVisibleToCollaborators)) {
          annotationlayer.isVisibleToCollaborators = true;
        }
        if (annotationlayer.isVisibleToCollaborators === false) {
          vm.hiddenSharedAnnotationLayersList.push(annotationlayer.layerid);
        }
      });
    }

    function loadScriptPage(sideIndex, scriptPage) {
      $log.debug('loadScriptPage() -->', sideIndex);
      vm.currentScriptPage[sideIndex] = angular.copy(scriptPage);

      if (!angular.isArray(vm.currentScriptPage[sideIndex].leftannotations)) {
        vm.currentScriptPage[sideIndex].leftannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage[sideIndex].rightannotations)) {
        vm.currentScriptPage[sideIndex].rightannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage[sideIndex].floatingannotations)) {
        vm.currentScriptPage[sideIndex].floatingannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage[sideIndex].highlightannotations)) {
        vm.currentScriptPage[sideIndex].highlightannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage[sideIndex].chartlinks)) {
        vm.currentScriptPage[sideIndex].chartlinks = [];
      }

      if (!angular.isArray(vm.currentScriptPage[sideIndex].shapepaths)) {
        vm.currentScriptPage[sideIndex].shapepaths = [];
      }

      angular.forEach(vm.currentScriptPage[sideIndex].leftannotations, function (annotation) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;
        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        updateLeftAnnotationConnectorLines(sideIndex, annotation);
      });

      angular.forEach(vm.currentScriptPage[sideIndex].rightannotations, function (annotation) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;
        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        updateRightAnnotationConnectorLines(sideIndex, annotation);
      });

      angular.forEach(vm.currentScriptPage[sideIndex].floatingannotations, function (annotation) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
      });

      angular.forEach(vm.currentScriptPage[sideIndex].highlightannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(annotation.backgroundColor);
      });

      resolveChartLinkNames(sideIndex);

      angular.element('.sw-maincontentarea-script > .mCustomScrollBox').focus();

      if (sideIndex == 0) {
        vm.scriptEditorState[0].currentBookmark = dbScripts.findFirstBookmarkOnPage(vm.sortedBookmarks, vm.currentScriptPage[sideIndex].orderingindex);
      } else {
        if (vm.scriptEditorState[0].currentBookmark === null) {
          vm.scriptEditorState[0].currentBookmark = dbScripts.findFirstBookmarkOnPage(vm.sortedBookmarks, vm.currentScriptPage[sideIndex].orderingindex);
        }
      }

      if (angular.isDefined(vm.drawingpad[sideIndex])) {
        vm.drawingpad[sideIndex].clear();
        delete vm.drawingpad[sideIndex];
      }

      // Clear canvas element before redirecting to any page
      if (vm.scriptEditorState.masterLayerActive) {
        if (angular.isUndefined(vm.drawingpad[sideIndex])) {
          var el = $document[0].getElementById('sketchpad-' + sideIndex);
          vm.drawingpad[sideIndex] = new Sketchpad(el);
        }

        updateForAnnotationLayerOrVisibilityChange(sideIndex);

        vm.drawingpad[sideIndex].clear();
        vm.drawingpad[sideIndex].setCanvasSize(vm.currentScriptPage[sideIndex].pagewidth, vm.currentScriptPage[sideIndex].pageheight);
        if (vm.currentScriptPage[sideIndex].shapepaths.length > 0) {
          vm.currentScriptPage[sideIndex].shapepaths = vm.currentScriptPage[sideIndex].shapepaths.map(function (shapepath) {
            if (angular.isUndefined(shapepath.layerid)) {
              shapepath.layerid = 0
            }

            if (shapepath.isInterpolationDone !== true) {
              return vm.drawingpad[sideIndex].interpolateLegacyShapePath(shapepath)
            }
            return shapepath;
          });

          vm.drawingpad[sideIndex].loadShapePaths(vm.currentScriptPage[sideIndex].shapepaths);
        }
      }
      $log.debug('loadScriptPage() <--', sideIndex, scriptPage.orderingindex);
    }

    function loadScriptPageImage(sideIndex, scriptPage) {
      var deferred = $q.defer();

      vm.scriptEditorState[sideIndex].pageImageLoading = true;
      vm.currentScriptPage[sideIndex].dirty = false;
      vm.scriptEditorState[sideIndex].pageLoaded = true;
      vm.scriptEditorState[sideIndex].pageLoadError = false;

      blockUI.start('Loading page content ...');
      swaPdfToImage.getPageContentImage(scriptPage._id)
        .then(function (imageBase64) {
          vm.currentScriptPage[sideIndex].pageImageSrc = imageBase64;
        })
        .catch(function (err) {
          vm.scriptEditorState[sideIndex].pageImageLoadError = true;
        })
        .finally(function () {
          $log.debug('loadScriptPage() --> image load complete', sideIndex, scriptPage.orderingindex);
          vm.scriptEditorState[sideIndex].pageImageLoading = false;
          blockUI.stop();
          deferred.resolve(scriptPage);
        });

      return deferred.promise;
    }

    /**
     * Loads personal notes.
     * @param {Object} personalNotes The personal notes on this page.
     */
    function loadScriptPagePersonal(sideIndex, personalNotes, pageForSharedLayer) {
      vm.ownerScriptPage[sideIndex] = angular.copy(pageForSharedLayer);
      updateSharedAnnotationLayers();
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage[sideIndex].leftannotations)) {
        vm.ownerScriptPage[sideIndex].leftannotations = vm.ownerScriptPage[sideIndex].leftannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage[sideIndex].rightannotations)) {
        vm.ownerScriptPage[sideIndex].rightannotations = vm.ownerScriptPage[sideIndex].rightannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage[sideIndex].floatingannotations)) {
        vm.ownerScriptPage[sideIndex].floatingannotations = vm.ownerScriptPage[sideIndex].floatingannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage[sideIndex].highlightannotations)) {
        vm.ownerScriptPage[sideIndex].highlightannotations = vm.ownerScriptPage[sideIndex].highlightannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage[sideIndex].shapepaths)) {
        vm.ownerScriptPage[sideIndex].shapepaths = vm.ownerScriptPage[sideIndex].shapepaths.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }

      if (personalNotes) {
        vm.currentScriptPage[sideIndex].leftannotationsPersonal = personalNotes.leftAnnotations;
        vm.currentScriptPage[sideIndex].rightannotationsPersonal = personalNotes.rightAnnotations;
        vm.currentScriptPage[sideIndex].floatingannotationsPersonal = personalNotes.floatingAnnotations;
        vm.currentScriptPage[sideIndex].highlightannotationsPersonal = personalNotes.highlightAnnotations;
        vm.currentScriptPage[sideIndex].shapepathsPersonal = personalNotes.shapepaths;
      }

      if (!angular.isArray(vm.currentScriptPage[sideIndex].leftannotationsPersonal)) {
        vm.currentScriptPage[sideIndex].leftannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage[sideIndex].rightannotationsPersonal)) {
        vm.currentScriptPage[sideIndex].rightannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage[sideIndex].floatingannotationsPersonal)) {
        vm.currentScriptPage[sideIndex].floatingannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage[sideIndex].highlightannotationsPersonal)) {
        vm.currentScriptPage[sideIndex].highlightannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage[sideIndex].shapepathsPersonal)) {
        vm.currentScriptPage[sideIndex].shapepathsPersonal = [];
      }

      if (!angular.isArray(vm.ownerScriptPage[sideIndex].leftannotations)) {
        vm.ownerScriptPage[sideIndex].leftannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage[sideIndex].rightannotations)) {
        vm.ownerScriptPage[sideIndex].rightannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage[sideIndex].floatingannotations)) {
        vm.ownerScriptPage[sideIndex].floatingannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage[sideIndex].highlightannotations)) {
        vm.ownerScriptPage[sideIndex].highlightannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage[sideIndex].shapepaths)) {
        vm.ownerScriptPage[sideIndex].shapepaths = [];
      }

      angular.forEach(vm.ownerScriptPage[sideIndex].leftannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;

        updateLeftAnnotationConnectorLines(sideIndex, annotation);
      });

      angular.forEach(vm.ownerScriptPage[sideIndex].rightannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;

        updateRightAnnotationConnectorLines(sideIndex, annotation);
      });

      angular.forEach(vm.ownerScriptPage[sideIndex].floatingannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
      });
      angular.forEach(vm.ownerScriptPage[sideIndex].highlightannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(annotation.backgroundColor);
      });

      angular.forEach(vm.currentScriptPage[sideIndex].leftannotationsPersonal, function (annotation) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;
        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        updateLeftAnnotationConnectorLines(sideIndex, annotation);
      });

      angular.forEach(vm.currentScriptPage[sideIndex].rightannotationsPersonal, function (annotation) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;
        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        updateRightAnnotationConnectorLines(sideIndex, annotation);
      });

      angular.forEach(vm.currentScriptPage[sideIndex].floatingannotationsPersonal, function (annotation) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
      });

      angular.forEach(vm.currentScriptPage[sideIndex].highlightannotationsPersonal, function (annotation) {
        annotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(annotation.backgroundColor);
      });

      if (angular.isDefined(vm.drawingpadPersonal[sideIndex])) {
        vm.drawingpadPersonal[sideIndex].clear();
        delete vm.drawingpadPersonal[sideIndex];
      }
      if (angular.isDefined(vm.drawingpadForSharedLayer[sideIndex])) {
        vm.drawingpadForSharedLayer[sideIndex].clear();
        delete vm.drawingpadForSharedLayer[sideIndex];
      }

      // Clear canvas element before redirecting to any page
      if (vm.scriptEditorState.personalLayerActive) {
        if (angular.isUndefined(vm.drawingpadPersonal[sideIndex])) {
          var el = $document[0].getElementById('sketchpad-personal-' + sideIndex);
          vm.drawingpadPersonal[sideIndex] = new Sketchpad(el);
        }
        if (angular.isUndefined(vm.drawingpadForSharedLayer[sideIndex])) {
          var el = $document[0].getElementById('sketchpad-shared-' + sideIndex);
          vm.drawingpadForSharedLayer[sideIndex] = new Sketchpad(el);
        }

        updateForAnnotationLayerOrVisibilityChange(sideIndex);
        updateForSharedAnnotationLayerOrVisibilityChange(sideIndex);

        vm.drawingpadPersonal[sideIndex].clear();
        vm.drawingpadPersonal[sideIndex].setCanvasSize(vm.currentScriptPage[sideIndex].pagewidth, vm.currentScriptPage[sideIndex].pageheight);
        if (vm.currentScriptPage[sideIndex].shapepathsPersonal.length > 0) {
          vm.currentScriptPage[sideIndex].shapepathsPersonal = vm.currentScriptPage[sideIndex].shapepathsPersonal.map(function (shapepath) {
            if (angular.isUndefined(shapepath.layerid)) {
              shapepath.layerid = 0
            }

            if (shapepath.isInterpolationDone !== true) {
              return vm.drawingpadPersonal[sideIndex].interpolateLegacyShapePath(shapepath)
            }
            return shapepath;
          });

          vm.drawingpadPersonal[sideIndex].loadShapePaths(vm.currentScriptPage[sideIndex].shapepathsPersonal);
        }

        vm.drawingpadForSharedLayer[sideIndex].clear();
        vm.drawingpadForSharedLayer[sideIndex].setCanvasSize(vm.ownerScriptPage[sideIndex].pagewidth, vm.ownerScriptPage[sideIndex].pageheight);
        if (vm.ownerScriptPage[sideIndex].shapepaths.length > 0) {
          vm.drawingpadForSharedLayer[sideIndex].loadShapePaths(vm.ownerScriptPage[sideIndex].shapepaths);
        }
      }
    };

    function updateForAnnotationLayerOrVisibilityChange(sideIndex) {
      angular.forEach(vm.annotationlayers, function (annotationlayer) {
        if (vm.scriptEditorState.masterLayerActive) {
          vm.drawingpad[sideIndex].setLayerVisibility(annotationlayer.layerid, annotationlayer.isvisible);
        }
        if (vm.scriptEditorState.personalLayerActive) {
          vm.drawingpadPersonal[sideIndex].setLayerVisibility(annotationlayer.layerid, annotationlayer.isvisible);
        }
      });
    }

    function updateForSharedAnnotationLayerOrVisibilityChange(sideIndex) {
      angular.forEach(vm.sharedannotationlayers, function (annotationlayer) {
        if (vm.scriptEditorState.personalLayerActive) {
          vm.drawingpadForSharedLayer[sideIndex].setLayerVisibility(annotationlayer.layerid, annotationlayer.isVisibleToCollaborators);
        }
      });
    }

    function resolveChartLinkNames(sideIndex) {
      angular.forEach(vm.currentScriptPage[sideIndex].chartlinks, function (chartLink) {
        resolveChartLinkName(chartLink);
      });
    }

    function resolveChartLinkName(chartLink) {
      var linkedChartName = vm.chartIdToChartNameCache[chartLink.chartId];
      if (angular.isDefined(linkedChartName)) {
        $q.when(linkedChartName)
          .then(function (chartName) {
            chartLink.chartname = chartName;
          });
      } else {
        resolveChartName(chartLink.chartId)
          .then(function (chartName) {
            chartLink.chartname = chartName;
          });
      }
    }

    function resolveChartName(chartId) {
      var deferred = $q.defer();

      dbCharts.getChartForName(chartId)
        .then(function (chart) {
          var chartName;
          if (angular.isDefined(chart)) {
            if (vm.scriptEditorState[0].chartNumberAutomatic) {
              var parentScene = swaUtils.findInArrayById(vm.scenes, chart.sceneId);
              if (angular.isDefined(parentScene)) {
                chartName = 'Chart: ' + (parentScene.orderingindex + 1) + '.' + (chart.orderingindex + 1);
              }
            } else {
              chartName = chart.customname || '<unnamed>';
            }
          } else {
            chartName = '<missing>';
          }

          vm.chartIdToChartNameCache[chartId] = chartName;
          deferred.resolve(chartName);
        })
        .catch(function (error) {
          $log.error('Error resolving chart name for chart ID: ' + chartId + ', reason:', error);

          var chartName = '<error>';
          vm.chartIdToChartNameCache[chartId] = chartName;
          deferred.resolve(chartName);
        });

      return deferred.promise;
    }

    function markCurrentScriptDirty() {
      vm.script.dirty = true;
    }

    function updateLeftAnnotationConnectorLines(sideIndex, annotation) {
      annotation.linex1 = annotation.selectionrect.left;
      annotation.linex2 = (annotation.positionrect.left + annotation.positionrect.width);
      annotation.liney2 = (annotation.positionrect.top + annotation.positionrect.height);

      if (annotation.annotationtype === 1 && annotation.connectingLineTop) {
        annotation.liney1 = (annotation.selectionrect.top);
      } else {
        annotation.liney1 = (annotation.selectionrect.top + annotation.selectionrect.height);
      }
    }

    function updateRightAnnotationConnectorLines(sideIndex, annotation) {
      if (annotation.annotationtype === 1 && annotation.markerStyle) {
        annotation.linex1 = annotation.selectionrect.left;
      } else {
        annotation.linex1 = (annotation.selectionrect.left + annotation.selectionrect.width);
      }

      annotation.linex2 = (vm.currentScriptPage[sideIndex].pagewidth / 2) + annotation.positionrect.left;
      annotation.liney2 = (annotation.positionrect.top + annotation.positionrect.height);

      if (annotation.annotationtype === 1 && annotation.connectingLineTop) {
        annotation.liney1 = (annotation.selectionrect.top);
      } else {
        annotation.liney1 = (annotation.selectionrect.top + annotation.selectionrect.height);
      }
    }

    var bookmarkToastTimeoutHandle;

    /**
     * 'Go' to the given bookmark.
     * @param {ScriptBookmarkType} bookmark
     */
    function gotoBookmark(bookmark) {
      $q.when(true)
        .then(function () {
          var targetPage = bookmark.scriptPageNo;
          // Add condition to check if we need to goto page
          if ((vm.pageViewArr[0] !== targetPage) && (vm.pageViewArr[1] !== targetPage)) {
            return gotoPage(bookmark.scriptPageNo + 1)
          } else {
            return true;
          }
        })
        .then(function (loaded) {
          if (loaded) {
            scrollToBookmark(bookmark);
            showBookmarkToast(bookmark);

            vm.scriptEditorState[0].currentBookmark = bookmark;
          } else {
            vm.scriptEditorState[0].currentBookmark = undefined;
          }
        });
    }

    function scrollToBookmark(bookmark) {
      var staffContainerToSelect = $('div.sw-maincontentarea-script');
      staffContainerToSelect.mCustomScrollbar("scrollTo", bookmark.topOffset);
    }

    function showBookmarkToast(bookmark) {
      clearBookmarkToasts();

      var html = "<div class='bookmarkToastMsg' style='top:" + bookmark.topOffset + "px'>";
      html += "<div class='bookmarkToastMsg-wrapper'>";
      html += "<span class='swafont swafont-lg swafont-icon-bookmark-fill bookmark-icon'></span>";
      html += bookmark.name;
      html += "</div>";
      html += "</div>";

      $('.sw-script-pageview-container-position-' + bookmark.scriptPageNo).append(html);

      $timeout(function () {
        $('.bookmarkToastMsg').css('opacity', 1);
      }, 100);

      bookmarkToastTimeoutHandle = $timeout(function () {
        $('.bookmarkToastMsg').remove();
      }, 3000);
    }

    function clearBookmarkToasts() {
      $timeout.cancel(bookmarkToastTimeoutHandle);
      $('.bookmarkToastMsg').remove();
    }

    function gotoPrevBookmark() {
      var previousBookmark;
      var currentBookmark = vm.scriptEditorState[0].currentBookmark;
      if (currentBookmark) {
        previousBookmark = dbScripts.findBookmarkBefore(vm.sortedBookmarks, currentBookmark, currentBookmark.scriptPageNo);
      } else {
        previousBookmark = dbScripts.findBookmarkBefore(vm.sortedBookmarks, currentBookmark, (vm.scriptEditorState[0].currentPageNumber - 1));
      }

      if (!swaUtils.isUndefinedOrNull(previousBookmark)) {
        vm.gotoBookmark(previousBookmark);
      } else {
        toastr.warning($translate.instant('messages.no_previous_bookmark'));
      }
    }

    function gotoNextBookmark() {
      var nextBookmark;
      var currentBookmark = vm.scriptEditorState[0].currentBookmark;
      if (currentBookmark) {
        nextBookmark = dbScripts.findBookmarkAfter(vm.sortedBookmarks, currentBookmark, currentBookmark.scriptPageNo);
      } else {
        nextBookmark = dbScripts.findBookmarkAfter(vm.sortedBookmarks, currentBookmark, (vm.scriptEditorState[0].currentPageNumber - 1));
      }

      if (!swaUtils.isUndefinedOrNull(nextBookmark)) {
        vm.gotoBookmark(nextBookmark);
      } else {
        toastr.warning($translate.instant('messages.no_more_bookmarks'));
      }
    }

    function initPageLayout() {
      var deferred = $q.defer();

      $scope.$applyAsync(function () {
        vm.numberOfPagesDisplay = $localStorage.numberOfPagesDisplay || 2;

        $scope.$applyAsync(function () {
          updateScrollbar();

          deferred.resolve();
        });
      });

      return deferred.promise;
    }

    function toggleBookView(pgView) {
      if ($localStorage.numberOfPagesDisplay !== pgView) {
        $localStorage.numberOfPagesDisplay = pgView;
        vm.pageViewArr = [];
        sessionCheckAndRun();
      }
    }

    function gotoPage(pageNo) {
      var newPageNo = vm.scriptEditorState[0].currentPageNumber;
      if (pageNo === 'first') {
        if (vm.scriptEditorState[0].currentPageNumber !== 1) {
          newPageNo = 1;
        } else {
          return $q.resolve(true);
        }
      } else if (pageNo === 'prev') {
        if (vm.scriptEditorState[0].currentPageNumber > vm.numberOfPagesDisplay) {
          newPageNo -= vm.numberOfPagesDisplay;
        } else {
          return $q.resolve(true);
        }
      } else if (pageNo === 'next') {
        if (vm.scriptEditorState[0].currentPageNumber < vm.scriptEditorState[0].totalNumberOfPages) {
          newPageNo += vm.numberOfPagesDisplay;
        } else {
          return $q.resolve(true);
        }
      } else if (pageNo === 'last') {
        if (vm.scriptEditorState[0].currentPageNumber !== vm.scriptEditorState[0].totalNumberOfPages) {
          newPageNo = vm.scriptEditorState[0].totalNumberOfPages;
        } else {
          return $q.resolve(true);
        }
      } else {
        newPageNo = parseInt(pageNo);
      }

      if (isNaN(newPageNo) || (newPageNo < 1) || (newPageNo > vm.scriptEditorState[0].totalNumberOfPages)) {
        return $q.resolve(false);
      }

      var deferred = $q.defer();

      if (newPageNo !== vm.scriptEditorState[0].currentPageNumber) {
        var loaded = false;
        blockUI.start();
        clearBookmarkToasts();
        loadBookView(newPageNo - 1)
          .then(function () {
            loaded = true;
          })
          .finally(function () {
            blockUI.stop();
            deferred.resolve(loaded);
          });
      } else {
        deferred.resolve(true);
      }

      return deferred.promise;
    }

    $scope.$watch('vm.gotoPagePicker.show', function (newValue, oldValue) {
      if (newValue === true) {
        vm.gotoPagePicker.pagenumber = vm.scriptEditorState[0].customPageNumber;
        vm.gotoPagePicker.invalidPageNumber = false;
        $timeout(function () {
          $('input#gotopagequick').focus();
        }, 500);
      }
    });

    $scope.$watch('vm.gotoPagePicker1.show', function (newValue, oldValue) {
      if (newValue === true) {
        vm.gotoPagePicker.pagenumber = vm.scriptEditorState[0].customPageNumber;
        vm.gotoPagePicker.invalidPageNumber = false;
        $timeout(function () {
          $('input#gotopagequick1').focus();
        }, 500);
      }
    });

    function gotoPageQuick() {
      vm.gotoPage(vm.gotoPagePicker.pagenumber)
        .then(function (loaded) {
          if (loaded) {
            vm.gotoPagePicker.show = false;
            vm.gotoPagePicker1.show = false;
          } else {
            vm.gotoPagePicker.invalidPageNumber = true;
          }
        });
    }

    function insertScriptPages(scriptId, scriptPages) {
      var totalPages = scriptPages.length;
      var qAll = _.map(scriptPages, function (scriptPage) {
        scriptPage.scriptId = scriptId;
        var insertQ = dbScriptPages.insert(scriptPage);
        insertQ
          .then(function () {
            blockUI.message('Saved page ' + (scriptPage.orderingindex + 1) + ' of ' + totalPages);
          });

        return insertQ;
      });

      return $q.all(qAll);
    }

    function showHelpHints() {
      if (vm.scriptEditorState[0].personalLayerActive) {
        toastr.info(
          $translate.instant('messages.Markups will not be shared'),
          $translate.instant('titles.Private Script')
        );
      }
    }

    function initHelpTour() {
      vm.showHelpBar = false;
      vm.userData = DbSubMgrService.getLoggedInUserData();
      var profileDisplayHelp = false;
      if (angular.isDefined(vm.userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || vm.userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }

      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function initHelpTourSteps() {
      vm.helpTourSteps = [{
        element: '#menu-locknavigation',
        title: $translate.instant('helptour.editor.titles.menu-locknavigation'),
        content: $translate.instant('helptour.editor.messages.menu-locknavigation'),
        placement: 'bottom',
      }, {
        element: '#menu-switchview',
        title: $translate.instant('helptour.editor.titles.menu-switchview'),
        content: $translate.instant('helptour.editor.messages.menu-switchview'),
        placement: 'bottom',
      }, {
        element: '#menu-script',
        title: $translate.instant('helptour.scriptEditor.titles.menu-script'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-script'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptactionannotation',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptactionannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptactionannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptactionannotation-personal',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptactionannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptactionannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptlightcueannotation',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptlightcueannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptlightcueannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptlightcueannotation-personal',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptlightcueannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptlightcueannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scripttextannotation',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scripttextannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scripttextannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scripttextannotation-personal',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scripttextannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scripttextannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scripthighlightannotation',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scripthighlightannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scripthighlightannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scripthighlightannotation-personal',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scripthighlightannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scripthighlightannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptannotationsvisibility',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptannotationsvisibility'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptannotationsvisibility'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptpagenavigationcontrols',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptpagenavigationcontrols'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptpagenavigationcontrols'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptgotopage',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptgotopage'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptgotopage'),
        placement: 'bottom',
      }, {
        element: '#menu-savechanges',
        title: $translate.instant('helptour.editor.titles.menu-savechanges'),
        content: $translate.instant('helptour.editor.messages.menu-savechanges'),
        placement: 'left',
      }, {
        element: '#menu-createpdf',
        title: $translate.instant('helptour.editor.titles.menu-createpdf'),
        content: $translate.instant('helptour.editor.messages.menu-createpdf'),
        placement: 'left',
      }, {
        element: '#menu-collaborators',
        title: $translate.instant('helptour.editor.titles.menu-collaborators'),
        content: $translate.instant('helptour.editor.messages.menu-collaborators'),
        placement: 'left',
      }, {
        element: '#menu-settings',
        title: $translate.instant('helptour.editor.titles.menu-settings'),
        content: $translate.instant('helptour.editor.messages.menu-settings'),
        placement: 'left',
      }, {
        element: '#button-closeproduction',
        title: $translate.instant('helptour.editor.titles.button-closeproduction'),
        content: $translate.instant('helptour.editor.messages.button-closeproduction'),
        placement: 'right',
      }];

      vm.helpTourVideos = [{
        label: 'Importing and Editing Script',
        videoUrl: 'https://www.youtube.com/embed/sjdWhd24mvg?rel=0&showinfo=0'
      }];
    }

    function onHelpTourStart() {
      vm.helpTourRunning = true;
    }

    function onHelpTourEnd() {
      vm.helpTourRunning = false;
    }

    function unregisterFetches() {
      dbProductions.fetchUnregister();
      dbScenes.fetchUnregister();
    }

    $scope.$on('$destroy', function () {
      swPdfPrintService.unregisterForChange(vm);
      unregisterFetches();
      unregisterKeyboardHandler();
      unregisterResizeHandler();
      $interval.cancel(preloadTimer);
    });

    function updateCollaborationPrivileges() {
      var deferred = $q.defer();
      if (vm.activeCollaborationConfig.isProductionOwner === true) {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultOwnerAccessRules);
        }
        deferred.resolve();
      } else {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultDenyAccessRules);
        }
        var params = {
          accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
          statename: swaRouterStateNames.scripteditor,
        };

        if (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.custom) {
          params.allowscriptediting = vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.allowscriptediting;
        }

        dbCollaborationPrivileges.getCollaborationPrivileges(params)
          .then(function (privilegeData) {
            if (vm.activePlanRules.planId === 2) {
              updateActiveAccessRules({ allowpersonalnotes: privilegeData.accessrules.allowpersonalnotes });
            } else {
              updateActiveAccessRules(privilegeData.accessrules);
            }
          })
          .catch(function (error) {
            $log.error('ChartEditorController.updateCollaborationPrivileges:', error);
          })
          .finally(function () {
            deferred.resolve();
          });
      }

      return deferred.promise;
    }

    function updateActiveAccessRules(accessRules) {
      if (accessRules) {
        angular.extend(vm.activeAccessRules, accessRules);
      }
    }

    function keyboardHandler(event) {
      if (keyboardHandlerCheckTarget(event)) {
        return;
      }

      if (vm.helpTourRunning) {
        return;
      }

      // key
      var whichKey = event.which;
      var key = event.key;

      // modifier keys and combos
      var ctrlKey = event.ctrlKey && !(event.altKey || event.shiftKey || event.metaKey);
      var ctrlShiftKey = event.ctrlKey && event.shiftKey && !(event.altKey || event.metaKey);
      var metaKey = event.metaKey && !(event.altKey || event.shiftKey || event.ctrlKey);
      var metaShiftKey = event.metaKey && event.shiftKey && !(event.altKey || event.ctrlKey);
      var noModKey = !(event.ctrlKey || event.altKey || event.shiftKey || event.metaKey);


      // navigation control
      if (whichKey === 37) {
        if (ctrlKey) {
          gotoPage('first');
        } else {
          gotoPage('prev');
        }
        event.stopPropagation();
        event.preventDefault();

        return;
      } else if (whichKey === 39) {
        if (ctrlKey) {
          gotoPage('last');
        } else {
          gotoPage('next');
        }
        event.stopPropagation();
        event.preventDefault();

        return;
      }

      // Esc key
      // if (whichKey === 27) {
      //     if (vm.scriptEditorState.lockModeNavigation) {
      //         toggleLockModeNavigation();
      //     }
      //     return;
      // }
    }

    function keyboardHandlerCheckTarget(event) {
      var target = event.target;

      if (vm.scriptEditorState[0].lockModeNavigation) {
        return false;
      } else if ((target.nodeName === 'INPUT') || (target.nodeName === 'TEXTAREA')) {
        return true;
      } else {
        return target.attributes.contenteditable;
      }
    }

    function registerKeyboardHandler() {
      $log.debug('ScriptEditorBookViewController: registerKeyboardHandler:');
      $(document).on('keydown', keyboardHandler);

      tryIdentifyPlatform();
    }

    function unregisterKeyboardHandler() {
      $log.debug('ScriptEditorBookViewController: unregisterKeyboardHandler:');
      $(document).off('keydown', keyboardHandler);
    }


    function registerResizeHandler() {
      $log.debug('ScriptEditorBookViewController: registerResizeHandler:');
      $window.addEventListener('resize', docOnResize);
    }

    function unregisterResizeHandler() {
      $log.debug('ScriptEditorBookViewController: unregisterResizeHandler:');
      $window.removeEventListener('resize', docOnResize);
    }

    var bookViewResizeTimer;
    function docOnResize() {
      if (angular.isDefined(bookViewResizeTimer)) {
        $timeout.cancel(bookViewResizeTimer);
        bookViewResizeTimer = undefined;
      } else {
        blockUI.start();
      }

      bookViewResizeTimer = $timeout(function () {
        updatePageScale();

        blockUI.stop();
        $timeout.cancel(bookViewResizeTimer);
        bookViewResizeTimer = undefined;
      }, 500);
    }

    function updatePageScale() {
      if (vm.numberOfPagesDisplay > 1) {
        var viewportWidth = $window.innerWidth;
        var bookviewPageContainerWidth = viewportWidth / 2 - 32;//$('.two-pageview').outerWidth();
        vm.bookviewPageContainerWidth = bookviewPageContainerWidth + 'px';

        if (vm.scriptEditorState[0].currentPageNumber > -1) {
          var scriptContainerPageWidth = vm.currentScriptPage[0].pagewidth + 128 + 48;
          vm.bookViewScale[0] = Math.min((bookviewPageContainerWidth / scriptContainerPageWidth).toFixed(2), 1);
          vm.bookViewPageContainerHeight[0] = '' + ((vm.currentScriptPage[0].pageheight + 40) * vm.bookViewScale[0]) + 'px';
        }

        if (vm.scriptEditorState[1].currentPageNumber > -1) {
          var scriptContainerPageWidth = vm.currentScriptPage[1].pagewidth + 128 + 48;
          vm.bookViewScale[1] = Math.min((bookviewPageContainerWidth / scriptContainerPageWidth).toFixed(2), 1);
          vm.bookViewPageContainerHeight[1] = '' + ((vm.currentScriptPage[1].pageheight + 40) * vm.bookViewScale[1]) + 'px';
        }
      } else {
        vm.bookViewScale[0] = 1.0
        vm.bookViewPageContainerHeight[0] = 'auto';
        vm.bookviewPageContainerWidth = 'auto'
      }

      updateScrollbar();
    }

    function tryIdentifyPlatform() {
      vm.platformMac = (navigator.platform && (navigator.platform.match(/mac/i) !== null)) || (navigator.userAgent.match(/Macintosh/i) !== null);
    }

    function loadScriptEditorPage() {
      swaUtils.stateGo(swaRouterStateNames.scripteditor);
    }

    vm.sideAnnotationTargetEditTracker = {
      isTracking: false,
    };

    function activateMasterNotesLayer() {
      vm.scriptEditorState.personalLayerActive = false;
      vm.scriptEditorState.masterLayerActive = true;
    }

    function activatePersonalNotesLayer() {
      vm.scriptEditorState.masterLayerActive = false;
      vm.scriptEditorState.personalLayerActive = true;
    }

    var preloadTimer = null;
    var preloadIds = [];
    function beginPreloadScriptPages() {
      if (preloadTimer) {
        $interval.cancel(preloadTimer);
      }

      preloadIds = [];
      dbScriptPages.getIdsOfPages(vm.script._id)
        .then(function (pageIds) {
          preloadIds = pageIds;
        })
        .then(function () {
          preloadTimer = $interval(preloadNextScriptPage, 500);
        })
        .catch(function (error) {
          $log.error('ScriptEditorController.beginPreloadScriptPages:', error);
        });
    }

    function preloadNextScriptPage() {
      while (preloadIds.length > 0) {
        var pageId = preloadIds.shift();
        if (!swaPdfToImage.isContentCached(pageId)) {
          $log.debug('Preloading page:', pageId);
          swaPdfToImage.getPageContentImage(pageId);
          break;
        }
      }
    }

    function findAndGoToPageNoFromCustomPageNumber() {
      var deferred = $q.defer();
      var customPageNumber = vm.gotoPagePicker.pagenumber;

      ngProgressLite.start();
      dbScriptPages.findInScriptByCustomPageNumber(vm.script._id, customPageNumber, vm.currentScriptPage[0].orderingindex)
        .then(function (page) {
          if (angular.isDefined(page)) {
            vm.gotoPage(page.orderingindex + 1)
              .then(function (loaded) {
                if (loaded) {
                  vm.gotoPagePicker.show = false;
                  vm.gotoPagePicker1.show = false;
                } else {
                  vm.gotoPagePicker.invalidPageNumber = true;
                }
              });
          } else {
            vm.gotoPagePicker.invalidPageNumber = true;
          }
        })
        .catch(function (error) {
          vm.gotoPagePicker.invalidPageNumber = true;
          deferred.reject(error);
        })
        .finally(function () {
          blockUI.stop();
          ngProgressLite.done();
        });

      return deferred.promise;

    }

    function updateMarginCss(sideIndex, index) {
      var el = $document[0].getElementById('scriptPageImage-' + index);
      el.style.paddingLeft = vm.currentScriptPage[sideIndex].leftmargin + 'px';
      el.style.paddingRight = vm.currentScriptPage[sideIndex].rightmargin + 'px';
    }

    function changeActionAnnotationType() {
      var deferred = $q.defer();
      ngProgressLite.start();

      dbScriptPages.changeActionAnnotationType(vm.script._id)
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('ScriptEditorBookViewController.changeActionAnnotationType:', error);
          deferred.reject(error);
        })
        .finally(function () {
          ngProgressLite.done();
        });

      return deferred.promise;
    }

    function updateSharedAnnotationLayers() {
      if (vm.userScript && angular.isArray(vm.userScript.sharedannotationlayers)) {
        var scriptLayerIds = vm.script.annotationlayers.map(function (layer) { return layer.layerid; });
        vm.userScript.sharedannotationlayers = vm.userScript.sharedannotationlayers.filter(function (layer) {
          return scriptLayerIds.indexOf(layer.layerid) !== -1;
        });

        var sharedIds = vm.userScript.sharedannotationlayers.map(function (layer) { return layer.layerid; });
        var additionalLayers = vm.script.annotationlayers.filter(function (layer) {
          return layer.isShared === true && sharedIds.indexOf(layer.layerid) === -1;
        });

        vm.userScript.sharedannotationlayers.forEach(function (layer) {
          var scriptLayer = vm.script.annotationlayers.find(function (sl) { return sl.layerid === layer.layerid; });
          if (scriptLayer && scriptLayer.isShared === true && angular.isString(scriptLayer.name) && layer.name !== scriptLayer.name) {
            layer.name = scriptLayer.name;
          }
        });

        vm.userScript.sharedannotationlayers = vm.userScript.sharedannotationlayers.filter(function (layer) {
          var scriptLayer = vm.script.annotationlayers.find(function (sl) { return sl.layerid === layer.layerid; });
          return !(scriptLayer && scriptLayer.isShared === false);
        });

        vm.sharedannotationlayers = vm.userScript.sharedannotationlayers.concat(additionalLayers);
      } else {
        if (vm.script && angular.isArray(vm.script.annotationlayers)) {
          vm.sharedannotationlayers = vm.script.annotationlayers.filter(function (layer) {
            return layer.isShared === true;
          });
        }

        vm.sharedannotationlayers.forEach(function (layer) {
          if (angular.isUndefined(layer.isVisibleToCollaborators)) {
            layer.isVisibleToCollaborators = true;
          }
        });
      }

      var scriptLayerOrder = vm.script.annotationlayers.map(function (layer) { return layer.layerid; });
      vm.sharedannotationlayers = vm.sharedannotationlayers.sort(function (a, b) {
        return scriptLayerOrder.indexOf(a.layerid) - scriptLayerOrder.indexOf(b.layerid);
      });
    }
  }
}());

// jshint unused:false
/* global $, ScriptImportPdfProcessor, document, jQuery, Q, tinymce */
(function () {
  'use strict';

  angular.module('swanywhere').controller('ScriptEditorController', ScriptEditorController);

  ScriptEditorController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    'toastr',
    'DbScripts',
    'DbScriptPages',
    'DbSubMgrService',
    '$log',
    'ngProgressLite',
    'blockUI',
    'DbProductions',
    '$timeout',
    '$uibModal',
    '$translate',
    'swaUtils',
    'swaRouterStateNames',
    '$interval',
    'DbCollaborationPrivileges',
    'swaAccess',
    '$document',
    'swaUi',
    'swPdfPrintService',
    '$q',
    'swaConfig',
    'DbScenes',
    '$localStorage',
    'DbUserScriptPages',
    'DbUserProductions',
    'DbCharts',
    'DbUserScripts',
    '$window',
    '$sce',
    'swaPdfToImage'
  ];


  function ScriptEditorController($scope, $cookies, $stateParams, toastr,
    DbScripts, DbScriptPages, DbSubMgrService, $log, ngProgressLite, blockUI,
    DbProductions, $timeout, $uibModal, $translate, swaUtils, swaRouterStateNames, $interval,
    DbCollaborationPrivileges, swaAccess, $document, swaUi, swPdfPrintService, $q, swaConfig, DbScenes, $localStorage,
    dbUserScriptPages, DbUserProductions, DbCharts, DbUserScripts, $window, $sce, swaPdfToImage) {


    /**
     * @typedef ScriptEditorStateType
     * @property {Number} currentPageNumber
     * @property {ScriptBookmarkType} currentBookmark
     */

    /**
     * @typedef ScriptEditorController
     * @property {ScriptEditorStateType} scriptEditorState
     * @property {ScriptBookmarkType[]} bookmarks
     */

    /**
    * @type ScriptEditorController
    */
    var vm = this;
    var selectedProductionId;

    var scriptAnnotationsContainerElement;

    var dbProductions = new DbProductions();
    var dbUserProductions = new DbUserProductions();
    var dbScenes = new DbScenes();
    var dbCharts = new DbCharts();
    var dbScripts = new DbScripts();
    var dbScriptPages = new DbScriptPages();
    var dbUserScriptPages = new dbUserScriptPages();
    var dbUserScripts = new DbUserScripts();
    var dbCollaborationPrivileges = new DbCollaborationPrivileges();

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowscriptediting: false,
      allowscriptimport: false,
      allowaddactionannotation: false,
      allowaddlightcueannotation: false,
      allowaddtextannotation: false,
      allowaddhighlightannotation: false,
      allowaddfreehandannotation: false,
      allowtoggleannotation: false,
      allowannotationediting: false,
      allowpagenavigation: false,
      allowpersonalnotes: false,
    };

    var defaultViewAccessRules = {
      allowowneraccess: false,
      allowscriptediting: false,
      allowscriptimport: false,
      allowaddactionannotation: false,
      allowaddlightcueannotation: false,
      allowaddtextannotation: false,
      allowaddhighlightannotation: false,
      allowaddfreehandannotation: false,
      allowtoggleannotation: true,
      allowannotationediting: false,
      allowpagenavigation: true,
      allowpersonalnotes: false,
    };

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowscriptediting: true,
      allowscriptimport: true,
      allowaddactionannotation: true,
      allowaddlightcueannotation: true,
      allowaddtextannotation: true,
      allowaddhighlightannotation: true,
      allowaddfreehandannotation: true,
      allowtoggleannotation: true,
      allowannotationediting: true,
      allowpagenavigation: true,
      allowpersonalnotes: false,
    };

    vm.highlightColorPickerOption = swaUi.colorPickerOption;

    vm.userData = {};
    vm.userId = '';

    vm.swaRouterStateNames = swaRouterStateNames;

    // All scenes in production
    vm.scenes = [];

    vm.script;
    vm.currentScriptPage;
    vm.ownerScriptPage = undefined;

    /** @type ScriptBookmarkType[] */
    vm.bookmarks = [];
    /** @type ScriptBookmarkType[] */
    vm.sortedBookmarks = [];
    /** @type ScriptAnnotationLayerType[] */
    // SWA-1922 - New setttings
    vm.annotationlayers = [];
    vm.sharedannotationlayers = [];
    vm.maxAnnotationLayers = 15; // @TODO - SET MAX 15
    vm.enableAddAnnotationLayer = false;
    vm.showAddAnnotationLayerStatus = false;
    vm.activeAnnotationElement = false;
    vm.hiddenAnnotationLayersList = [];
    vm.hiddenSharedAnnotationLayersList = [];
    vm.newAnnotationLayerName = '';
    vm.enableMoveAnnotationAction = false;

    vm.chartIdToChartNameCache = {};
    vm.colorPickerOption = swaUi.colorPickerOption;
    vm.drawingpad = undefined;
    vm.drawingpadPersonal = undefined;
    vm.drawingpadForSharedLayer = undefined;

    vm.scriptEditorState = {
      scriptAvailable: false,
      currentPageNumber: -1,
      totalNumberOfPages: -1,
      activeAnnotationType: -1,
      enableTextAnnotations: false,
      bookmarkEditMode: false,
      enableSketchpadDrawing: true,
      startDrawing: false,
      selectedShapeIndex: -1,
      selectedColor: $localStorage.sketchpadSelectedColor || "#000",
      masterLayerActive: false,
      personalLayerActive: false,
      annotationsVisible: false,
      annotationsVisiblePersonal: false,
      pageLoaded: false,
      pageLoadError: false,
      chartNumberAutomatic: true,
      currentBookmark: null,
      currentAnnotationLayerId: 0, // SWA-1922 - New
      annotationLayerListVisible: true, // SWA-1922 - New
      isShowHideAnnotations: true,
      startErasing: false,
      selectionMode: false,
      backgroundColorForAnchor: 'rgba(0, 0, 0, 0)',
      borderColorForAnchor: 'rgb(0, 0, 0)',
      customPageNumber: -1,
    };

    vm.scrollConfigContent = {
      theme: 'light',
      axis: 'yx',
      scrollbarPosition: 'inside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
      },
      autoHideScrollbar: false,
      advanced: {
        updateOnContentResize: true,
      },
    };

    vm.scrollConfigSidebar = {
      theme: 'swa-minimal',
      axis: 'yx',
      scrollbarPosition: 'outside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
      callbacks: {
        // whileScrolling: updateStickySceneHeader,
        // onScroll: updateStickySceneHeader,
      }
    };

    vm.scrollHThumbs = {
      theme: 'swa-minimal',
      axis: 'x',
      scrollbarPosition: 'outside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
      callbacks: {
        // whileScrolling: updateStickySceneHeader,
        // onScroll: updateStickySceneHeader,
      }
    };

    /* jshint ignore:start */
    vm.tinymceOptions = {
      inline: true,
      inline_styles: true,
      forced_root_block: 'div',
      invalid_elements: 'strong,em',
      force_hex_style_colors: true,
      entity_encoding: 'numeric',
      height: 100,
      plugins: [
        'textcolor',
        'paste'
      ],
      paste_as_text: true,
      toolbar1: "bold italic underline forecolor | fillcolor",
      toolbar2: "fontselect | fontsizeselect",
      font_formats: 'Liberation Sans=Liberation Sans;Liberation Mono=Liberation Mono;Liberation Serif=Liberation Serif',
      fontsize_formats: '10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 31px 32px 33px 34px 35px 36px 37px 38px 39px 40px 41px 42px 43px 44px 45px 46px 47px 48px 49px 50px 51px 52px 53px 54px 55px 56px 57px 58px 59px 60px 61px 62px 63px 64px 65px 66px 67px 68px 69px 70px 71px 72px',
      menubar: false,
      toolbar_items_size: 'small',
      formats: {
        bold: {
          inline: 'span',
          styles: {
            'font-weight': 'bold'
          }
        },
        italic: {
          inline: 'span',
          styles: {
            'font-style': 'italic'
          }
        },
        underline: {
          inline: 'span',
          styles: {
            'text-decoration': 'underline'
          }
        },
      },
      textcolor_cols: 5,
      textcolor_rows: 6,
      textcolor_map: swaUi.textColorMap,
    }
    /* jshint ignore:end */

    vm.sketchToolTip = '<div class=\'sketchTooltip\'>' +
      '<p>Tools for drawing, editing freehand markings on a page</p>' +
      '<ul>' +
      '<li><span class=\'swafont swafont-lg icon swafont-icon-mouse-pointer\'></span><span>Select Tool</span></li>' +
      '<li><span class=\'swafont swafont-lg icon swafont-icon-sketch-pencil\'></span><span>Draw / Pen Tool</span></li>' +
      '<li><span class=\'swafont swafont-lg icon swafont-icon-eraser\'></span><span>Erase Tool</span></li>' +
      '<li><span class=\'icon\'><span class=\'sketchTooltipColor\'></span></span><span>Draw / Pen Color</span></li>' +
      '<li><span class=\'swafont swafont-lg icon swafont-icon-trash-21\'></span><span>Erase all markings</span></li>' +
      '</ul>' +
      '</div>';
    vm.currentSelectedPageObject = {
      annotations: [],
    };

    vm.newSideAnnotationTracker = {};

    vm.addSideAnnotationView = {};
    vm.addSideAnnotationViewP = {};

    vm.gotoPagePicker = {};
    vm.gotoPagePicker1 = {};

    vm.importScriptOptions = {};

    vm.revealSidebar = false;

    vm.changeTracker = {
      undoStack: [],
      redoStack: [],

      lastTrackedState: undefined,

      nextStateNumber: 0,

      disableTrackingCount: 0,

      canUndo: false,
      canRedo: false,
      enabled: false,
    };

    vm.sidebarEditState = {
      enabled: false,
    };

    vm.sidebarSortableOptions = {
      handle: '.sortDragHandle',
      cursor: 'ns-resize',
      axis: 'y',
      opacity: 0.8,
      disabled: true,
      stop: sidebarDragSortStop,
    };

    vm.setCustomPageNumberState = {
      enabled: false,
    }

    vm.userPreferences = {};

    vm.newPdfImportDate = undefined;
    vm.fetchedScript = undefined;

    vm.selectedLayer = undefined;

    vm.colorPickerOptionForScriptTools = swaUi.colorPickerOption.palette;

    var CueAnchorStyle = Object.freeze({
      Marker: 'marker',
      ConnectingLineTop: 'top'
    });

    vm.setCustomMarginState = {
      leftSideMargin: 0,
      rightSideMargin: 0,
      isMarginApplied: true,
      leftMarginBeforeApply: 0,
      rightMarginBeforeApply: 0,
      scaleFactor: 1,
      oldScaleFactor: 1,
      scaleFactorBeforeApply: 1,
    }
    vm.appliedLeftmargin;

    vm.scriptPages;
    vm.userScriptPages = [];
    vm.personalNotes;
    vm.revealRightScriptpageThumbnailBar = false;
    vm.revealBottomScriptpageThumbnailBar = false;
    vm.thumbnailBarState = {
      rightSideBar: false,
      bottomSideBar: false,
    }
    vm.loadingThumbnail = false;

    vm.autoSetDefaultAreaState = {
      timeoutMaxSec: 60,
      timeoutPollIntervalSec: 1,
      timeoutDecaySec: 5,
      timeoutRemainingSec: 0,
      timerActive: false,
    };

    vm.switchEditor = switchEditor;
    vm.toggleAddLightCueAnnotation = toggleAddLightCueAnnotation;
    vm.toggleAddFloatingTextAnnotation = toggleAddFloatingTextAnnotation;
    vm.toggleAddHighlightAnnotation = toggleAddHighlightAnnotation;
    vm.toggleAddSketchpadAnnotation = toggleAddSketchpadAnnotation;
    vm.toggleSketchpadDrawingAnnotation = toggleSketchpadDrawingAnnotation;
    vm.selectShape = selectShape;
    vm.resetSelectedShape = resetSelectedShape;
    vm.sketchpadColorChanged = sketchpadColorChanged;
    vm.clearSketchpad = clearSketchpad;
    vm.deleteSelectedSketch = deleteSelectedSketch;
    vm.processSelectedPdfFile = processSelectedPdfFile;
    vm.processSelectedPdfFileToRenderScriptAsPdf = processSelectedPdfFileToRenderScriptAsPdf;
    vm.importScript = importScript;
    vm.markCurrentScriptPageDirty = markCurrentScriptPageDirty;
    vm.onScriptContentMouseDown = onScriptContentMouseDown;
    vm.onScriptContentMouseMove = onScriptContentMouseMove;
    vm.onScriptContentMouseUp = onScriptContentMouseUp;
    vm.addSideAnnotation = addSideAnnotation;
    vm.selectLeftAnnotation = selectLeftAnnotation;
    vm.selectRightAnnotation = selectRightAnnotation;
    vm.deselectLeftAnnotation = deselectLeftAnnotation;
    vm.deselectRightAnnotation = deselectRightAnnotation;
    vm.deleteLeftAnnotation = deleteLeftAnnotation;
    vm.deleteRightAnnotation = deleteRightAnnotation;
    vm.leftAnnotationMoved = leftAnnotationMoved;
    vm.leftAnnotationResized = leftAnnotationResized;
    vm.rightAnnotationMoved = rightAnnotationMoved;
    vm.rightAnnotationResized = rightAnnotationResized;
    vm.selectFloatingAnnotation = selectFloatingAnnotation;
    vm.deleteFloatingAnnotation = deleteFloatingAnnotation;
    vm.floatingAnnotationMoved = floatingAnnotationMoved;
    vm.floatingAnnotationResized = floatingAnnotationResized;
    vm.selectHighlightAnnotation = selectHighlightAnnotation;
    vm.deleteHighlightAnnotation = deleteHighlightAnnotation;
    vm.highlightAnnotationMoved = highlightAnnotationMoved;
    vm.highlightAnnotationResized = highlightAnnotationResized;
    vm.highlightColorChanged = highlightColorChanged;
    vm.toggleAnnotationVisibility = toggleAnnotationVisibility;
    vm.gotoPage = gotoPage;
    vm.gotoPageQuick = gotoPageQuick;
    vm.onSaveClick = onSaveClick;
    vm.printPdf = printPdf;
    vm.deleteCurrentPagePrompt = deleteCurrentPagePrompt;
    vm.onHelpTourStart = onHelpTourStart;
    vm.onHelpTourEnd = onHelpTourEnd;
    vm.activateMasterNotesLayer = activateMasterNotesLayer;
    vm.activatePersonalNotesLayer = activatePersonalNotesLayer;

    vm.scriptNotifyDataDidChange = scriptNotifyDataDidChange;
    vm.scriptNotifyDisableChangeTracking = scriptNotifyDisableChangeTracking;
    vm.scriptNotifyEnableChangeTracking = scriptNotifyEnableChangeTracking;
    vm.undoAction = undoAction;
    vm.redoAction = redoAction;

    vm.beginBookmarkEditing = beginBookmarkEditing;
    vm.toggleBookmarkListVisibility = toggleBookmarkListVisibility;
    vm.endBookmarkEditing = endBookmarkEditing;
    vm.gotoBookmark = gotoBookmark;
    vm.gotoPrevBookmark = gotoPrevBookmark;
    vm.gotoNextBookmark = gotoNextBookmark;
    vm.bookmarkChanged = bookmarkChanged;

    vm.addNewBookmark = addNewBookmark;
    vm.deleteBookmark = deleteBookmark;

    vm.toggleLockModeNavigation = toggleLockModeNavigation;

    vm.leftAnnotationSelectionMoved = leftAnnotationSelectionMoved;
    vm.leftAnnotationSelectionResized = leftAnnotationSelectionResized;
    vm.rightAnnotationSelectionMoved = rightAnnotationSelectionMoved;
    vm.rightAnnotationSelectionResized = rightAnnotationSelectionResized;
    // SWA-1922 - New functions
    vm.selectAnnotationLayer = selectAnnotationLayer;
    vm.toggleAnnotationVisibilityForLayer = toggleAnnotationVisibilityForLayer;
    vm.toggleAnnotationVisibilityForSharedLayer = toggleAnnotationVisibilityForSharedLayer;
    vm.showAddAnnotationLayer = showAddAnnotationLayer;
    vm.showHideEditAnnotationLayer = showHideEditAnnotationLayer;
    vm.addNewAnnotationLayer = addNewAnnotationLayer;
    vm.moveAnnotationToLayer = moveAnnotationToLayer;
    vm.toggleAnnotationLayerListVisibility = toggleAnnotationLayerListVisibility;
    vm.updateAnnotationLayerPrompt = updateAnnotationLayerPrompt;
    vm.deleteAnnotationLayerPrompt = deleteAnnotationLayerPrompt;
    vm.toggleSidebarEditMode = toggleSidebarEditMode;
    vm.onDoubleClick = onDoubleClick;
    vm.onUpdateLayerName = onUpdateLayerName;

    vm.toggleSketchpadEraserMode = toggleSketchpadEraserMode;
    vm.toggleSelectionMode = toggleSelectionMode;

    vm.pdfPrintOptionPrompt = pdfPrintOptionPrompt;

    vm.undoPdfImportPrompt = undoPdfImportPrompt;
    vm.showUndoPdfImport = showUndoPdfImport;

    vm.moveRightAnnotationToLeftSideOfPage = moveRightAnnotationToLeftSideOfPage;
    vm.moveLeftAnnotationToRightSideOfPage = moveLeftAnnotationToRightSideOfPage;
    vm.snapToGridRightAnnotation = snapToGridRightAnnotation;
    vm.snapToGridLeftAnnotation = snapToGridLeftAnnotation;

    vm.updateLeftAnnotationConnectorLines = updateLeftAnnotationConnectorLines;
    vm.updateRightAnnotationConnectorLines = updateRightAnnotationConnectorLines;

    vm.updateToolbarPosition = updateToolbarPosition;

    vm.leftAnnotationAnchorBackgroundColorChanged = leftAnnotationAnchorBackgroundColorChanged;
    vm.leftAnnotationAnchorBorderColorChanged = leftAnnotationAnchorBorderColorChanged;

    vm.rightAnnotationAnchorBackgroundColorChanged = rightAnnotationAnchorBackgroundColorChanged;
    vm.rightAnnotationAnchorBorderColorChanged = rightAnnotationAnchorBorderColorChanged;

    vm.changeAnnotationStyle = changeAnnotationStyle;
    vm.changeAnnotationConnectingLineStyle = changeAnnotationConnectingLineStyle;

    vm.increaseAnnotationLineThickness = increaseAnnotationLineThickness;
    vm.decreaseAnnotationLineThickness = decreaseAnnotationLineThickness;

    vm.makeCurrentPageFirst = makeCurrentPageFirst;
    vm.setCustomPageNumber = setCustomPageNumber;
    vm.showEditCustomPageNumberMenu = showEditCustomPageNumberMenu;
    vm.hideEditCustomPageNumberMenu = hideEditCustomPageNumberMenu;
    vm.findAndGoToPageNoFromCustomPageNumber = findAndGoToPageNoFromCustomPageNumber;

    vm.updateMarginState = updateMarginState;
    vm.addLeftSideMargin = addLeftSideMargin;
    vm.addRightSideMargin = addRightSideMargin;
    vm.removeLeftSideMargin = removeLeftSideMargin;
    vm.removeRightSideMargin = removeRightSideMargin;
    vm.applyMargin = applyMargin;
    vm.applyMarginToAllPagesPrompt = applyMarginToAllPagesPrompt;

    vm.takeSnapshot = takeSnapshot;
    vm.loadScriptPageFromIndex = loadScriptPageFromIndex;
    vm.toggleRightSideBar = toggleRightSideBar;
    vm.toggleBottomSideBar = toggleBottomSideBar;

    vm.deleteAnnotation = deleteAnnotation;
    vm.snapToGridAnnotation = snapToGridAnnotation;
    vm.moveToOtherSide = moveToOtherSide;
    vm.anchorBackgroundColorChanged = anchorBackgroundColorChanged;
    vm.anchorBorderColorChanged = anchorBorderColorChanged;

    vm.deactivateAnyActiveAnnotation = deactivateAnyActiveAnnotation;
    vm.killAutoSetDefaultAreaStateTimer = killAutoSetDefaultAreaStateTimer;
    vm.updateMaincontainerAreaToDefault = updateMaincontainerAreaToDefault;

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedScriptPages: false,
      allowedNumberOfScriptPages: 0,
    };

    vm.PdfPrintTypes = swPdfPrintService.PdfPrintTypes;
    vm.scriptEditorState.masterLayerActive = true;
    vm.scriptEditorState.personalLayerActive = false;
    vm.scriptEditorState.annotationsVisible = true;
    vm.scriptEditorState.annotationsVisiblePersonal = true;
    vm.userProduction = {};
    vm.selectedScene;

    vm.defaultActionTextSettings = {};
    vm.defaultLqTextSettings = {};
    vm.defaultFloatingTextSettings = {};

    initialize();

    function initialize() {
      $cookies.put('currentEditorStateName', swaUtils.getRouterCurrentStateName());

      sessionCheckAndRun();
      registerKeyboardHandler();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();

      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.validateActivePlan();
        })
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        })
        .then(function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        })
        .then(function (plan) {
          updateActivePlanRules(plan);
        })
        .then(function () {
          scriptAnnotationsContainerElement = angular.element('.swa-script-global').get(0);
          return getAllData();
        })
        .then(function () {
          showHelpHints();
          initHelpTour();
        })
        .then(function () {
          if ($stateParams.lockModeNavigation === true) {
            toggleLockModeNavigation();
          }
          vm.selectedScene = $stateParams.selectedScene;
        })
        .then(function () {
          $cookies.put('selectedProductionId', selectedProductionId);
        })
        .then(null, null, function (progress) {
          ngProgressLite.set(progress);
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function getAllData() {
      var deferred = $q.defer();

      getProduction()
        .then(function () {
          deferred.notify(0.2);
          return setupPdfPrintService();
        })
        .then(function () {
          deferred.notify(0.3);
          return updateCollaborationPrivileges();
        })
        .then(function () {
          deferred.notify(0.4);
          if (vm.activeAccessRules.allowpersonalnotes) {
            activatePersonalNotesLayer();
          } else {
            activateMasterNotesLayer();
          }
          return setupSketchpad();
        })
        .then(function () {
          deferred.notify(0.5);
          return getUserProductionPreferences();
        })
        .then(function () {
          deferred.notify(0.6);
          return getScenes();
        })
        .then(function () {
          deferred.notify(0.7);
          return getScript();
        })
        .then(function () {
          deferred.notify(0.9);
          return loadScript();
        })
        .then(function () {
          deferred.notify(1.0);
        })
        .catch(function (error) {
          deferred.reject(error);
        })
        .finally(function () {
          deferred.resolve();
        });

      return deferred.promise;
    }

    /** Gets default layers */
    function getDefaultLayers() {
      var layerLq =
      {
        "layerid": 0,
        "name": "LQ",
        "isvisible": true,
        "orderingindex": 0,
        "contentDefaults": angular.copy(vm.userPreferences.contentDefaults),
        "isShared": false,
        "isVisibleToCollaborators": true,
      };
      layerLq.contentDefaults.settingsScriptLq.defaultText = 'LQ:'

      var layerSq =
      {
        "layerid": 1,
        "name": "SQ",
        "isvisible": true,
        "orderingindex": 1,
        "contentDefaults": angular.copy(vm.userPreferences.contentDefaults),
        "isShared": false,
        "isVisibleToCollaborators": true,
      }
      layerSq.contentDefaults.settingsScriptLq.defaultText = 'SQ:'

      return [layerLq, layerSq];
    }

    /** Gets production data */
    function getProduction() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId)
        .then(function (production) {
          updateDataProduction(production);
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    /** Gets user's production preferences */
    function getUserProductionPreferences() {
      var deferred = $q.defer();

      dbUserProductions.findByProductionId(selectedProductionId)
        .then(function (userProduction) {
          if (angular.isUndefined(userProduction)) {
            vm.userPreferences.contentDefaults = {
              settingsScriptAction: angular.copy(swaUi.defaultTextStylePreferences),
              settingsScriptLq: angular.copy(swaUi.defaultTextStylePreferences),
              settingsScriptText: angular.copy(swaUi.defaultTextStylePreferences),
              colorScriptHighlight: swaUi.defaultScriptHighlightColor,
            };
          } else {
            vm.userPreferences.contentDefaults = angular.copy(userProduction.contentDefaults);
            vm.defaultActionTextSettings = angular.copy(userProduction.contentDefaults.settingsScriptAction);
            vm.defaultLqTextSettings = angular.copy(userProduction.contentDefaults.settingsScriptLq);
            vm.defaultFloatingTextSettings = angular.copy(userProduction.contentDefaults.settingsScriptText);
            vm.scriptEditorState.highlightColor = userProduction.contentDefaults.colorScriptHighlight;
          }

          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function loadAnnotationLayerContentDefaults(annotationLayer) {
      if (angular.isUndefined(annotationLayer) || angular.isUndefined(annotationLayer.contentDefaults)) {
        vm.defaultActionTextSettings = angular.copy(swaUi.defaultTextStylePreferences);
        vm.defaultLqTextSettings = angular.copy(swaUi.defaultTextStylePreferences);
        vm.defaultFloatingTextSettings = angular.copy(swaUi.defaultTextStylePreferences);
        vm.scriptEditorState.highlightColor = swaUi.defaultScriptHighlightColor;
      } else {
        vm.defaultActionTextSettings = angular.copy(annotationLayer.contentDefaults.settingsScriptAction);
        vm.defaultLqTextSettings = angular.copy(annotationLayer.contentDefaults.settingsScriptLq);
        vm.defaultFloatingTextSettings = angular.copy(annotationLayer.contentDefaults.settingsScriptText);
        vm.scriptEditorState.highlightColor = annotationLayer.contentDefaults.colorScriptHighlight;
      }
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;

      vm.activePlanRules.allowUnlimitedScriptPages = plan.planfeatures[6].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedScriptPages) {
        vm.activePlanRules.allowedNumberOfScriptPages = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfScriptPages = plan.planfeatures[6].featurevalue;
      }
    }

    function updateDataProduction(production) {
      vm.selectedProduction = production;

      if (angular.isUndefined(vm.selectedProduction) || (parseInt(vm.selectedProduction.productiontype) !== 1)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error('Invalid state');
      }

      if (vm.selectedProduction.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(vm.selectedProduction.collaboratorIds) && (vm.selectedProduction.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = vm.selectedProduction.collaborationsettings.find(function (element) {
            return (element.collaboratorId === vm.userId);
          });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error(
            $translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          throw new Error('Invalid state');
        }
      }

      DbSubMgrService.setSelectedProduction(vm.selectedProduction);

      vm.scriptEditorState.chartNumberAutomatic = (vm.selectedProduction.chartsettings.chartnumberautomatic === true);
    }

    /** Gets (and monitors) scenes */
    function getScenes() {
      return dbScenes.fetchAllInProduction(selectedProductionId, updateDataScenes);
    }

    /** Gets the script */
    function getScript() {
      $log.debug('scriptEditorController.getScript() -->');

      var deferred = $q.defer();

      dbScripts.findByProduction(selectedProductionId)
        .then(function (script) {
          vm.script = script;
          vm.scriptEditorState.scriptAvailable = angular.isDefined(vm.script);
          // // SWA-1922 - New
          // if (angular.isDefined(vm.script) && !vm.script.annotationlayers) {
          //   vm.script.annotationlayers = getDefaultLayers();
          // }

          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function setupPdfPrintService() {
      swPdfPrintService.setSelectedProduction(vm.selectedProduction);
      vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
      vm.onPrintJobsChange = onPrintJobsChange;
      swPdfPrintService.registerForChange(vm);
    }

    function onPrintJobsChange(change, id, job) {
      vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
    }

    function pdfPrintOptionPrompt(type) {
      vm.pdfOptionsPicker.show = false;
      var permissionToPrintSharedLayers = false;
      if (vm.activeCollaborationConfig.collaborationSetting) {
        permissionToPrintSharedLayers = ((vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.custom) && !vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.allowscriptediting) ||
          (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited);
      }
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/chartEditor/pdfPrintOptionPrompt.html',
        controller: 'PdfPrintOptionPromptController',
        controllerAs: 'vm',
        size: '600',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        resolve: {
          params: {
            type: type,
            permissionToPrintSharedLayers: permissionToPrintSharedLayers,
          }
        }
      });
      modalInstance.result
        .then(function (params) {
          printPdf(params)
        });
    }

    function printPdf(parameters) {
      var type = parameters.type;
      vm.pdfOptionsPicker.show = false;

      var params = {};
      params.productionId = selectedProductionId;
      params.optionalIds = {};
      params.options = {};
      params.type = type;
      params.notesPrintOption = parameters.chartNotes;
      params.chartLinksPrintOption = parameters.chartLinks;
      params.scaleAllPerformersPrintOption = parameters.scaleAllPerformers;
      params.scaleSelectedPerformersPrintOption = parameters.scaleSelectedPerformers;
      params.sharedLayerAnnotationsPrintOption = parameters.sharedLayerAnnotations;

      if ((type === vm.PdfPrintTypes.AllChartsScript) || (type === vm.PdfPrintTypes.Script)) {
        params.optionalIds.scriptId = vm.script._id;
        params.options.printPersonalAnnotations = vm.activeAccessRules.allowpersonalnotes;
      }

      params.options.printChartPersonalNotes = getPrintChartPersonalNotes();

      saveScript()
        .then(function () {
          return swPdfPrintService.printPdf(params)
        })
        .then(function (printJob) {
          if (angular.isDefined(printJob.approvingUserId)) {
            toastr.info(
              $translate.instant('messages.PDF waiting for approval'),
              $translate.instant('messages.Approval Needed!')
            );
          } else {
            toastr.info(
              $translate.instant('messages.Requested PDF is being created')
            );
          }
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error creating PDF!')
          );
        });
    }

    function getPrintChartPersonalNotes() {
      return (!vm.activeCollaborationConfig.isProductionOwner && (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited)) ||
        (vm.activePlanRules.planId === 2);
    }

    function updateDataScenes(id) {
      if (angular.isUndefined(id)) {
        vm.scenes = dbScenes.getFetched(true);
        // vm.scenes.forEach(updateSceneChartIds)
        // updateSceneCollaborationAccessRules(vm.scenes);
      } else {
        var existingScene = swaUtils.findInArrayById(vm.scenes, id);
        var incomingScene = dbScenes.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingScene) && swaUtils.isUndefinedOrNull(incomingScene));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));

        if (isInsert) {
          // updateSceneCollaborationAccessRules([incomingScene]);
          vm.scenes.push(incomingScene);
          swaUtils.sortArrayByNumericKey(vm.scenes, 'orderingindex');
          // updateSceneChartIds(incomingScene);
        } else if (isDelete) {
          toastr.warning($translate.instant('messages.Scene deleted elsewhere.'), $translate.instant(
            'messages.Sync warning!'));
          if (existingScene === vm.selectedScene) {
            toggleScene();
          }

          var existingSceneIndex = vm.scenes.indexOf(existingScene);
          if (existingSceneIndex !== -1) {
            vm.scenes.splice(existingSceneIndex, 1);
          }
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming scene update with ID: ' + id);
          angular.extend(existingScene, incomingScene);
          // updateSceneChartIds(existingScene);
        }
      }
    }

    function switchEditor(index, navParams) {
      var params = {
        productionId: selectedProductionId,
        lockModeNavigation: vm.scriptEditorState.lockModeNavigation,
        selectedScene: vm.selectedScene,
        navParams: navParams
      };

      if (index === 0) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.charteditor, params);
      } else if (index === 4) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.chartscripteditor, params);
      }
    }

    function findLayerById(layers, layerId) {
      return layers.find(function (layer) {
        return layer.layerid === layerId;
      });
    }

    function toggleAddLightCueAnnotation() {
      var layer = findLayerById(vm.annotationlayers, vm.selectedLayer.layerid);
      if (vm.scriptEditorState.activeAnnotationType === 1) {
        deactivateAnyActiveAnnotation();
        resetLayer();
        offEraserMode();
        vm.scriptEditorState.activeAnnotationType = -1;
        layer.activeAnnotationType = -1;
      } else {
        deactivateAnyActiveAnnotation();
        resetLayer();
        offEraserMode();
        vm.scriptEditorState.activeAnnotationType = 1;
        layer.activeAnnotationType = 1;
      }

      markCurrentScriptDirty();
      updateTextAnnotationEditability();
    }

    function toggleAddFloatingTextAnnotation() {
      var layer = findLayerById(vm.annotationlayers, vm.selectedLayer.layerid);
      if (vm.scriptEditorState.activeAnnotationType === 2) {
        deactivateAnyActiveAnnotation();
        resetLayer();
        offEraserMode();
        vm.scriptEditorState.activeAnnotationType = -1;
        layer.activeAnnotationType = -1;
      } else {
        deactivateAnyActiveAnnotation();
        resetLayer();
        offEraserMode();
        vm.scriptEditorState.activeAnnotationType = 2;
        layer.activeAnnotationType = 2;
      }

      markCurrentScriptDirty();
      updateTextAnnotationEditability();
    }

    function toggleAddHighlightAnnotation() {
      var layer = findLayerById(vm.annotationlayers, vm.selectedLayer.layerid);
      if (vm.scriptEditorState.activeAnnotationType === 3) {
        deactivateAnyActiveAnnotation();
        resetLayer();
        offEraserMode();
        vm.scriptEditorState.activeAnnotationType = -1;
        layer.activeAnnotationType = -1;
      } else {
        deactivateAnyActiveAnnotation();
        resetLayer();
        offEraserMode();
        vm.scriptEditorState.activeAnnotationType = 3;
        layer.activeAnnotationType = 3;
      }

      markCurrentScriptDirty();
      updateTextAnnotationEditability();
    }

    function toggleAddSketchpadAnnotation() {
      var layer = findLayerById(vm.annotationlayers, vm.selectedLayer.layerid);
      if (vm.scriptEditorState.activeAnnotationType === 4) {
        deactivateAnyActiveAnnotation();

        setSketchPadMode(true);

        vm.scriptEditorState.activeAnnotationType = -1;
        vm.scriptEditorState.startDrawing = false;
        vm.scriptEditorState.startErasing = false;
        vm.scriptEditorState.selectionMode = false;
        vm.scriptEditorState.selectedShapeIndex = -1;

        offEraserMode();
        resetLayer();
        layer.activeAnnotationType = -1;
      } else {
        deactivateAnyActiveAnnotation();
        resetLayer();

        setSketchPadMode(false);

        vm.scriptEditorState.activeAnnotationType = 4;
        vm.scriptEditorState.startDrawing = true;
        vm.scriptEditorState.startErasing = false;
        vm.scriptEditorState.selectionMode = false;

        layer.activeAnnotationType = 4;

        activateSketchpadLayer();
        updateMaincontainerAreaToDefault();
      }

      markCurrentScriptDirty();
      updateTextAnnotationEditability();
    }

    function updateTextAnnotationEditability() {
      vm.scriptEditorState.enableTextAnnotations = (vm.scriptEditorState.activeAnnotationType < 3)
    }

    function setupSketchpad() {
      if (angular.isUndefined(vm.drawingpad)) {
        var el = $document[0].getElementById('sketchpad');
        vm.drawingpad = new Sketchpad(el, {
          line: {
            size: 1
          },
          onChange: drawingpadMasterOnChange
        });
      }
      if (angular.isUndefined(vm.drawingpadPersonal)) {
        var el = $document[0].getElementById('sketchpad-personal');
        vm.drawingpadPersonal = new Sketchpad(el, {
          line: {
            size: 1
          },
          onChange: drawingpadPersonalOnChange
        });
      }
      if (angular.isUndefined(vm.drawingpadForSharedLayer)) {
        var el = $document[0].getElementById('sketchpad-shared');
        vm.drawingpadForSharedLayer = new Sketchpad(el, {
          line: {
            size: 1
          },
        });
      }
    }

    function setSketchPadMode(flag) {
      if (vm.activeAccessRules.allowpersonalnotes) {
        vm.drawingpadPersonal.setReadOnly(flag);
      } else {
        vm.drawingpad.setReadOnly(flag);
      }
    }

    function toggleSketchpadDrawingAnnotation() {
      deactivateAnyActiveAnnotation();
      resetSelectedShape();

      if (!vm.scriptEditorState.startDrawing) {
        vm.scriptEditorState.startDrawing = true;
        vm.scriptEditorState.startErasing = false;

        offEraserMode();
        setSketchPadMode(false);
      } else {
        vm.scriptEditorState.startDrawing = false;
        vm.scriptEditorState.startErasing = false;

        offEraserMode();
        setSketchPadMode(true);

        vm.scriptEditorState.selectionMode = true;
      }
    }

    function toggleSketchpadEraserMode() {
      if (!vm.scriptEditorState.startErasing) {
        deactivateAnyActiveAnnotation();
        resetLayer();
        setSketchPadMode(false);

        vm.scriptEditorState.activeAnnotationType = 4;
        vm.scriptEditorState.startErasing = true;
        vm.scriptEditorState.startDrawing = false;

        activateSketchpadLayer();
        markCurrentScriptPageDirty();
        onEraserMode();
      } else {
        deactivateAnyActiveAnnotation();
        setSketchPadMode(true);

        vm.scriptEditorState.startDrawing = false;
        vm.scriptEditorState.startErasing = false;
        vm.scriptEditorState.selectedShapeIndex = -1;

        resetLayer();
        offEraserMode();

        vm.scriptEditorState.selectionMode = true;
      }
    }

    function toggleSelectionMode() {
      if (!vm.scriptEditorState.selectionMode) {
        deactivateAnyActiveAnnotation();
        setSketchPadMode(true);

        vm.scriptEditorState.startDrawing = false;
        vm.scriptEditorState.startErasing = false;
        vm.scriptEditorState.selectedShapeIndex = -1;

        offEraserMode();
        resetLayer();

        vm.scriptEditorState.selectionMode = true;
      } else {
        deactivateAnyActiveAnnotation();
        resetSelectedShape();

        vm.scriptEditorState.startDrawing = true;
        vm.scriptEditorState.startErasing = false;
        vm.scriptEditorState.selectedShapeIndex = -1;

        offEraserMode();
        setSketchPadMode(false);

        vm.scriptEditorState.selectionMode = false;
      }
    }

    function selectShape(index) {
      if (vm.scriptEditorState.masterLayerActive) {
        if ((vm.currentScriptPage.shapepaths[index].layerid === vm.scriptEditorState.currentAnnotationLayerId) && (vm.hiddenAnnotationLayersList.indexOf(vm.scriptEditorState.currentAnnotationLayerId) === -1)) {
          vm.scriptEditorState.selectedShapeIndex = index;
          vm.enableMoveAnnotationAction = true;
        }
      }

      if (vm.scriptEditorState.personalLayerActive) {
        if ((vm.currentScriptPage.shapepathsPersonal[index].layerid === vm.scriptEditorState.currentAnnotationLayerId) && (vm.hiddenAnnotationLayersList.indexOf(vm.scriptEditorState.currentAnnotationLayerId) === -1)) {
          vm.scriptEditorState.selectedShapeIndex = index;
          vm.enableMoveAnnotationAction = true;
        }
      }
    };

    function resetSelectedShape() {
      vm.scriptEditorState.selectedShapeIndex = -1;
      vm.enableMoveAnnotationAction = false;
    }

    function resetSelectionMode() {
      vm.scriptEditorState.selectedShapeIndex = -1;
      vm.scriptEditorState.selectionMode = false;
    }

    function offEraserMode() {
      if (vm.activeAccessRules.allowpersonalnotes) {
        vm.drawingpadPersonal.setEraserMode(false);
      } else {
        vm.drawingpad.setEraserMode(false);
      }
    }

    function onEraserMode() {
      if (vm.activeAccessRules.allowpersonalnotes) {
        vm.drawingpadPersonal.setEraserMode(true);
      } else {
        vm.drawingpad.setEraserMode(true);
      }
    }

    function toggleBookmarkListVisibility() {
      vm.scriptEditorState.bookmarkListVisible = !vm.scriptEditorState.bookmarkListVisible;

      // SWA-1922 - New
      if (vm.scriptEditorState.annotationLayerListVisible) {
        // if bookmark is showing then annotation layer hide
        vm.scriptEditorState.annotationLayerListVisible = false;
      }
    }

    function beginBookmarkEditing() {
      deactivateAnyActiveAnnotation();
      killAutoSetDefaultAreaStateTimer();
      updateMaincontainerAreaToDefault();
      if (vm.scriptEditorState.annotationsVisible || vm.scriptEditorState.annotationsVisiblePersonal) {
        toggleAnnotationVisibility();
      }

      vm.scriptEditorState.bookmarkEditMode = true;
      vm.scriptEditorState.bookmarkListVisible = false;

      activateBookmarksLayer();
      toastr.info($translate.instant('messages.add_bookmarks_hint'));
    }

    function endBookmarkEditing() {
      vm.scriptEditorState.bookmarkEditMode = false;
      vm.scriptEditorState.bookmarkListVisible = true;
      vm.scriptEditorState.annotationLayerListVisible = false; // SWA-1922 - New

      // deactivateAnyActiveAnnotation();
      toggleAnnotationVisibility();

      if (vm.activeAccessRules.allowpersonalnotes) {
        activatePersonalNotesLayer();
      } else {
        activateMasterNotesLayer();
      }

      updateSortedBookmarks()
    }

    function updateSortedBookmarks() {
      vm.sortedBookmarks = dbScripts.sortBookmarks(vm.bookmarks);
    }

    function updateBookmarkWithScriptPageIds() {
      dbScriptPages.getScriptPagesByScriptForBookmarks(vm.script._id)
        .then(function (pages) {
          var hasUpdates = false;
          if (angular.isArray(vm.bookmarks) && angular.isArray(pages)) {
            vm.bookmarks.forEach(function (bookmark) {
              if (angular.isUndefined(bookmark.scriptPageId) || !bookmark.scriptPageId) {
                var page = pages.find(function (p) {
                  return p.orderingindex === bookmark.scriptPageNo;
                });
                if (page) {
                  bookmark.scriptPageId = page._id;
                  hasUpdates = true;
                  $log.debug("Updated bookmark '" + bookmark.name + "' with scriptPageId: " + page._id);
                }
              }
            });
          }
          if (hasUpdates) {
            markCurrentScriptDirty(true);
            saveScript();
            $log.debug("Updated " + vm.bookmarks.length + " bookmarks with scriptPageId");
          }
        });
    }

    function loadScript() {
      var deferred = $q.defer();

      if (vm.scriptEditorState.scriptAvailable) {
        dbScriptPages.getNumberOfPages(vm.script._id)
          .then(function (numberOfPages) {
            vm.script.numberOfPages = numberOfPages;
            vm.scriptEditorState.totalNumberOfPages = numberOfPages;
            vm.scriptEditorState.currentPageNumber = -1;
            vm.currentScriptPage = undefined;
          })
          .then(function () {
            if (vm.script.numberOfPages > 0) {
              if (vm.activeAccessRules.allowpersonalnotes) {
                return dbUserScripts.getForScript(vm.script._id);
              }
            }
          })
          .then(function (userScript) {
            if (vm.scriptEditorState.scriptAvailable) {
              if (vm.activeAccessRules.allowpersonalnotes) {
                vm.userScript = userScript;
                if (angular.isUndefined(userScript) || !angular.isArray(userScript.annotationlayers)) {
                  vm.annotationlayers = getDefaultLayers();
                  vm.script.dirtyPersonal = true;
                } else {
                  vm.annotationlayers = angular.copy(userScript.annotationlayers);
                }

                updateSharedAnnotationLayers();
              } else {
                if (!angular.isArray(vm.script.annotationlayers)) {
                  vm.annotationlayers = getDefaultLayers();
                  vm.script.dirty = true;
                } else {
                  vm.annotationlayers = angular.copy(vm.script.annotationlayers);
                }
              }

              resetHiddenLayerList();
              updateForAnnotationLayerOrVisibilityChange();
              resetHiddenSharedLayerList();
              updateForSharedAnnotationLayerOrVisibilityChange();

              // Select the 0th annotation layer
              selectAnnotationLayer(vm.annotationlayers[0]);

              if (vm.annotationlayers.length < vm.maxAnnotationLayers) {
                vm.enableAddAnnotationLayer = true;
              } else {
                vm.enableAddAnnotationLayer = false;
              }
            }
          })
          .then(function () {
            if (vm.scriptEditorState.scriptAvailable) {
              vm.bookmarks = angular.isArray(vm.script.bookmarks) ? angular.copy(vm.script.bookmarks) : [];
              updateSortedBookmarks();
              updateBookmarkWithScriptPageIds();
            }
          })
          .then(function () {
            if (angular.isUndefined(vm.script.startingPageNumber)) {
              vm.script.startingPageNumber = 1;
              dbScripts.update(vm.script);
              dbScriptPages.reindexAfterMakeCurrentPageFirst(vm.script._id, vm.script.startingPageNumber);
            }
          })
          .then(function () {
            return changeActionAnnotationType();
          })
          .then(function () {
            getScriptPagesAndUserScriptPages();
          })
          .then(function () {
            if (vm.script.numberOfPages > 0) {
              var lastOpenedIndex = $localStorage.scriptLastOpenedPageIndex;
              if (angular.isDefined($stateParams.navParams)) {
                lastOpenedIndex = parseInt($stateParams.navParams.orderingindex, 10)
                delete $stateParams.navParams;
              }
              if (lastOpenedIndex < vm.script.numberOfPages) {
                return loadScriptPageAtIndex(lastOpenedIndex);
              } else {
                return loadScriptPageAtIndex(0);
              }
            }
          })
          .then(function () {
            if (vm.script.numberOfPages > 0) {
              changeTrackerInitialize();
            }
          })
          // .then(function () {
          //   beginPreloadScriptPages();
          // })
          .then(function () {
            deferred.resolve();
          })
          .catch(function (error) {
            deferred.reject(error);
          });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    function loadScriptPageAtIndex(index) {
      var deferred = $q.defer();

      blockUI.start();
      vm.scriptEditorState.currentPageNumber = (index + 1);

      var pageForSharedLayer = undefined;
      dbScriptPages.getScriptPageAtIndex(vm.script._id, index)
        .then(function (scriptPage) {
          pageForSharedLayer = scriptPage;
          if (angular.isUndefined(scriptPage)) {
            throw new Error($translate.instant('errormessages.Page not found'));
          } else {
            $localStorage.scriptLastOpenedPageIndex = index;
            vm.scriptEditorState.customPageNumber = scriptPage.customPageNumber;
            loadScriptPage(scriptPage);
            return loadScriptPageImage(scriptPage);
          }
        })
        .then(function (scriptPage) {
          if (vm.activeAccessRules.allowpersonalnotes) {
            return dbUserScriptPages.getForScriptPage(scriptPage._id)
          }
        })
        .then(function (personalNotes) {
          if (vm.activeAccessRules.allowpersonalnotes) {
            loadScriptPagePersonal(personalNotes, pageForSharedLayer);
          }

          updateTextAnnotationEditability();
          deferred.resolve();
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error loading script page!')
          );

          vm.scriptEditorState.pageLoaded = false;
          vm.scriptEditorState.pageLoadError = true;
          vm.currentScriptPage = undefined;

          deferred.reject(error);
        })
        .finally(function () {
          if ($localStorage.showReloadToastr === true) {
            toastr.warning($translate.instant('messages.Script has been updated elsewhere, page reloaded.'));
            delete $localStorage.showReloadToastr;
          }
          blockUI.stop();
        });

      return deferred.promise;
    }

    function loadScriptPage(scriptPage) {
      vm.currentScriptPage = angular.copy(scriptPage);

      vm.currentScriptPage.leftmargin = vm.currentScriptPage.leftmargin || 0;
      vm.currentScriptPage.rightmargin = vm.currentScriptPage.rightmargin || 0;
      vm.appliedLeftmargin = vm.currentScriptPage.leftmargin;
      updateMarginCss();
      updateScaleFactor();

      if (!angular.isArray(vm.currentScriptPage.leftannotations)) {
        vm.currentScriptPage.leftannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage.rightannotations)) {
        vm.currentScriptPage.rightannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage.floatingannotations)) {
        vm.currentScriptPage.floatingannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage.highlightannotations)) {
        vm.currentScriptPage.highlightannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage.chartlinks)) {
        vm.currentScriptPage.chartlinks = [];
      }

      if (!angular.isArray(vm.currentScriptPage.shapepaths)) {
        vm.currentScriptPage.shapepaths = [];
      }

      angular.forEach(vm.currentScriptPage.leftannotations, function (annotation) {
        //  // SWA-1922 - New if for exisitng pages layerid is not there - set default layer 0
        if (angular.isUndefined(annotation.layerid)) {
          annotation.layerid = 0
        }

        // SWA-2765 - LAYERS - Don’t need ACTION Cues
        if (annotation.annotationtype === 0) {
          annotation.annotationtype = 1;
        }

        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);

        annotation.backgroundColorForAnchor = annotation.backgroundColorForAnchor || swaUi.defaultTextStylePreferences.fillColorForAnchor;
        vm.scriptEditorState.backgroundColorForAnchor = annotation.backgroundColorForAnchor;
        annotation.backgroundColorCssForAnchor = swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor);

        annotation.borderColorForAnchor = annotation.borderColorForAnchor || swaUi.defaultTextStylePreferences.borderColorForAnchor;
        vm.scriptEditorState.borderColorForAnchor = annotation.borderColorForAnchor;
        annotation.borderColorCssForAnchor = swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor);

        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        if (annotation.annotationtype === 1) {
          annotation.markerStyle = annotation.markerStyle || swaUi.defaultTextStylePreferences.markerStyle;
          annotation.connectingLineTop = annotation.connectingLineTop || swaUi.defaultTextStylePreferences.connectingLineTop;
        }

        updateLeftAnnotationConnectorLines(annotation);

        // Set side to left annotations
        annotation.side = 'left';
      });

      angular.forEach(vm.currentScriptPage.rightannotations, function (annotation) {
        //  // SWA-1922 - New if for exisitng pages layerid is not there - set default layer 0
        if (angular.isUndefined(annotation.layerid)) {
          annotation.layerid = 0
        }

        // SWA-2765 - LAYERS - Don’t need ACTION Cues
        if (annotation.annotationtype === 0) {
          annotation.annotationtype = 1;
        }

        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);

        annotation.backgroundColorForAnchor = annotation.backgroundColorForAnchor || swaUi.defaultTextStylePreferences.fillColorForAnchor;
        vm.scriptEditorState.backgroundColorForAnchor = annotation.backgroundColorForAnchor;
        annotation.backgroundColorCssForAnchor = swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor);

        annotation.borderColorForAnchor = annotation.borderColorForAnchor || swaUi.defaultTextStylePreferences.borderColorForAnchor;
        vm.scriptEditorState.borderColorForAnchor = annotation.borderColorForAnchor;
        annotation.borderColorCssForAnchor = swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor);

        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        if (annotation.annotationtype === 1) {
          annotation.markerStyle = annotation.markerStyle || swaUi.defaultTextStylePreferences.markerStyle;
          annotation.connectingLineTop = annotation.connectingLineTop || swaUi.defaultTextStylePreferences.connectingLineTop;
        }

        updateRightAnnotationConnectorLines(annotation);

        // Set side to right annotations
        annotation.side = 'right';
      });

      angular.forEach(vm.currentScriptPage.floatingannotations, function (annotation) {
        //  // SWA-1922 - New if for exisitng pages layerid is not there - set default layer 0
        if (angular.isUndefined(annotation.layerid)) {
          annotation.layerid = 0
        }
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
      });

      angular.forEach(vm.currentScriptPage.highlightannotations, function (annotation) {
        //  // SWA-1922 - New if for exisitng pages layerid is not there - set default layer 0
        if (angular.isUndefined(annotation.layerid)) {
          annotation.layerid = 0
        }
        annotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(annotation.backgroundColor);
        vm.scriptEditorState.highlightColor = annotation.backgroundColor;
      });

      vm.drawingpad.clear();

      vm.drawingpad.setCanvasSize(vm.currentScriptPage.pagewidth, vm.currentScriptPage.pageheight);
      vm.drawingpad.lineColor = vm.scriptEditorState.selectedColor;
      vm.drawingpad.setCurrentLayerId(vm.scriptEditorState.currentAnnotationLayerId);

      if (vm.currentScriptPage.shapepaths.length > 0) {
        vm.currentScriptPage.shapepaths = vm.currentScriptPage.shapepaths.map(function (shapepath) {
          if (angular.isUndefined(shapepath.layerid)) {
            shapepath.layerid = 0
          }

          if (shapepath.isInterpolationDone !== true) {
            return vm.drawingpad.interpolateLegacyShapePath(shapepath)
          }
          return shapepath;
        });

        vm.drawingpad.loadShapePaths(vm.currentScriptPage.shapepaths);
        vm.currentScriptPage.shapepaths = vm.drawingpad.getShapePaths();

        resetSelectedShape();
      }

      resolveChartLinkNames();

      // if (vm.scriptEditorState.pageImageLoading === true) {
      //   blockUI.stop();
      // }
      // blockUI.start('Loading content');

      // /** Updated in T104 for script upload - START */

      // swaPdfToImage.loadPDFPage(scriptPage.scriptId, scriptPage._id, scriptPage.orderingindex)
      //   .then(function (imageBase64) {
      //     blockUI.start('Loading page content ...');
      //     vm.currentScriptPage.pageImageSrc = imageBase64;
      //   }).catch(function (err) {
      //     throw err;
      //   }).finally(function () {
      //     blockUI.stop();
      //   });

      // /** Updated in T104 for script upload - END */
      // vm.scriptEditorState.pageImageLoading = true;
      // vm.currentScriptPage.dirty = false;
      // vm.scriptEditorState.pageLoaded = true;
      // vm.scriptEditorState.pageLoadError = false;

      angular.element('.sw-maincontentarea-script > .mCustomScrollBox').focus();
      vm.scriptEditorState.currentBookmark = dbScripts.findFirstBookmarkOnPage(vm.sortedBookmarks, vm.currentScriptPage.orderingindex);

      $timeout(function () {
        vm.scrollUpdateSidebar('scrollTo', $('#pageid-' + vm.currentScriptPage.orderingindex).position().top);
      }, 500);
      $timeout(function () {
        vm.scrollUpdateBottombar('scrollTo', '#pageid-h-' + vm.currentScriptPage.orderingindex);
      }, 500);
    }

    function loadScriptPageImage(scriptPage) {
      var deferred = $q.defer();

      vm.scriptEditorState.pageImageLoading = true;
      vm.currentScriptPage.dirty = false;
      vm.scriptEditorState.pageLoaded = true;
      vm.scriptEditorState.pageLoadError = false;

      blockUI.start('Loading page content ...');
      swaPdfToImage.getPageContentImage(scriptPage._id)
        .then(function (imageBase64) {
          vm.currentScriptPage.pageImageSrc = imageBase64;
        })
        .catch(function (err) {
          vm.scriptEditorState.pageLoadError = true;
        })
        .finally(function () {
          vm.scriptEditorState.pageImageLoading = false;
          blockUI.stop();
          deferred.resolve(scriptPage);
        });

      return deferred.promise;
    }


    /**
     * Loads personal notes.
     * @param {Object} personalNotes The personal notes on this page.
     */
    function loadScriptPagePersonal(personalNotes, pageForSharedLayer) {
      vm.ownerScriptPage = angular.copy(pageForSharedLayer);
      updateSharedAnnotationLayers();
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage.leftannotations)) {
        vm.ownerScriptPage.leftannotations = vm.ownerScriptPage.leftannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage.rightannotations)) {
        vm.ownerScriptPage.rightannotations = vm.ownerScriptPage.rightannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage.floatingannotations)) {
        vm.ownerScriptPage.floatingannotations = vm.ownerScriptPage.floatingannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage.highlightannotations)) {
        vm.ownerScriptPage.highlightannotations = vm.ownerScriptPage.highlightannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage.shapepaths)) {
        vm.ownerScriptPage.shapepaths = vm.ownerScriptPage.shapepaths.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }


      if (personalNotes) {
        vm.currentScriptPage.leftannotationsPersonal = angular.copy(personalNotes.leftAnnotations);
        vm.currentScriptPage.rightannotationsPersonal = angular.copy(personalNotes.rightAnnotations);
        vm.currentScriptPage.floatingannotationsPersonal = angular.copy(personalNotes.floatingAnnotations);
        vm.currentScriptPage.highlightannotationsPersonal = angular.copy(personalNotes.highlightAnnotations);
        vm.currentScriptPage.shapepathsPersonal = angular.copy(personalNotes.shapepaths);
      }
      updateMarginCss();
      updateScaleFactor();

      if (!angular.isArray(vm.currentScriptPage.leftannotationsPersonal)) {
        vm.currentScriptPage.leftannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage.rightannotationsPersonal)) {
        vm.currentScriptPage.rightannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage.floatingannotationsPersonal)) {
        vm.currentScriptPage.floatingannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage.highlightannotationsPersonal)) {
        vm.currentScriptPage.highlightannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage.shapepathsPersonal)) {
        vm.currentScriptPage.shapepathsPersonal = [];
      }

      if (!angular.isArray(vm.ownerScriptPage.leftannotations)) {
        vm.ownerScriptPage.leftannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage.rightannotations)) {
        vm.ownerScriptPage.rightannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage.floatingannotations)) {
        vm.ownerScriptPage.floatingannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage.highlightannotations)) {
        vm.ownerScriptPage.highlightannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage.shapepaths)) {
        vm.ownerScriptPage.shapepaths = [];
      }

      angular.forEach(vm.ownerScriptPage.leftannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);

        annotation.backgroundColorForAnchor = annotation.backgroundColorForAnchor || swaUi.defaultTextStylePreferences.fillColorForAnchor;
        vm.scriptEditorState.backgroundColorForAnchor = annotation.backgroundColorForAnchor;
        annotation.backgroundColorCssForAnchor = swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor);

        annotation.borderColorForAnchor = annotation.borderColorForAnchor || swaUi.defaultTextStylePreferences.borderColorForAnchor;
        vm.scriptEditorState.borderColorForAnchor = annotation.borderColorForAnchor;
        annotation.borderColorCssForAnchor = swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor);

        updateLeftAnnotationConnectorLines(annotation);
      });

      angular.forEach(vm.ownerScriptPage.rightannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);

        annotation.backgroundColorForAnchor = annotation.backgroundColorForAnchor || swaUi.defaultTextStylePreferences.fillColorForAnchor;
        vm.scriptEditorState.backgroundColorForAnchor = annotation.backgroundColorForAnchor;
        annotation.backgroundColorCssForAnchor = swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor);

        annotation.borderColorForAnchor = annotation.borderColorForAnchor || swaUi.defaultTextStylePreferences.borderColorForAnchor;
        vm.scriptEditorState.borderColorForAnchor = annotation.borderColorForAnchor;
        annotation.borderColorCssForAnchor = swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor);

        updateRightAnnotationConnectorLines(annotation);
      });

      angular.forEach(vm.ownerScriptPage.floatingannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
      });
      angular.forEach(vm.ownerScriptPage.highlightannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(annotation.backgroundColor);
      });

      angular.forEach(vm.currentScriptPage.leftannotationsPersonal, function (annotation) {
        // SWA-1922 - New if for exisitng pages layerid is not there - set default layer 0
        if (angular.isUndefined(annotation.layerid)) {
          annotation.layerid = 0
        }

        // SWA-2765 - LAYERS - Don’t need ACTION Cues
        if (annotation.annotationtype === 0) {
          annotation.annotationtype = 1;
        }

        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);

        annotation.backgroundColorForAnchor = annotation.backgroundColorForAnchor || swaUi.defaultTextStylePreferences.fillColorForAnchor;
        vm.scriptEditorState.backgroundColorForAnchor = annotation.backgroundColorForAnchor;
        annotation.backgroundColorCssForAnchor = swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor);

        annotation.borderColorForAnchor = annotation.borderColorForAnchor || swaUi.defaultTextStylePreferences.borderColorForAnchor;
        vm.scriptEditorState.borderColorForAnchor = annotation.borderColorForAnchor;
        annotation.borderColorCssForAnchor = swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor);

        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        if (annotation.annotationtype === 1) {
          annotation.markerStyle = annotation.markerStyle || swaUi.defaultTextStylePreferences.markerStyle;
          annotation.connectingLineTop = annotation.connectingLineTop || swaUi.defaultTextStylePreferences.connectingLineTop;
        }

        updateLeftAnnotationConnectorLines(annotation);

        // Set side to left annotations
        annotation.side = 'left';
      });

      angular.forEach(vm.currentScriptPage.rightannotationsPersonal, function (annotation) {
        // SWA-1922 - New if for exisitng pages layerid is not there - set default layer 0
        if (angular.isUndefined(annotation.layerid)) {
          annotation.layerid = 0
        }

        // SWA-2765 - LAYERS - Don’t need ACTION Cues
        if (annotation.annotationtype === 0) {
          annotation.annotationtype = 1;
        }

        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);

        annotation.backgroundColorForAnchor = annotation.backgroundColorForAnchor || swaUi.defaultTextStylePreferences.fillColorForAnchor;
        vm.scriptEditorState.backgroundColorForAnchor = annotation.backgroundColorForAnchor;
        annotation.backgroundColorCssForAnchor = swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor);

        annotation.borderColorForAnchor = annotation.borderColorForAnchor || swaUi.defaultTextStylePreferences.borderColorForAnchor;
        vm.scriptEditorState.borderColorForAnchor = annotation.borderColorForAnchor;
        annotation.borderColorCssForAnchor = swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor);

        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        if (annotation.annotationtype === 1) {
          annotation.markerStyle = annotation.markerStyle || swaUi.defaultTextStylePreferences.markerStyle;
          annotation.connectingLineTop = annotation.connectingLineTop || swaUi.defaultTextStylePreferences.connectingLineTop;
        }

        updateRightAnnotationConnectorLines(annotation);

        // Set side to right annotations
        annotation.side = 'right';
      });

      angular.forEach(vm.currentScriptPage.floatingannotationsPersonal, function (annotation) {
        // SWA-1922 - New if for exisitng pages layerid is not there - set default layer 0
        if (angular.isUndefined(annotation.layerid)) {
          annotation.layerid = 0
        }

        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
      });

      angular.forEach(vm.currentScriptPage.highlightannotationsPersonal, function (annotation) {
        // SWA-1922 - New if for exisitng pages layerid is not there - set default layer 0
        if (angular.isUndefined(annotation.layerid)) {
          annotation.layerid = 0
        }
        annotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(annotation.backgroundColor);
        vm.scriptEditorState.highlightColor = annotation.backgroundColor;
      });

      vm.drawingpadPersonal.clear();

      vm.drawingpadPersonal.setCanvasSize(vm.currentScriptPage.pagewidth, vm.currentScriptPage.pageheight);
      vm.drawingpadPersonal.lineColor = vm.scriptEditorState.selectedColor;
      vm.drawingpadPersonal.setCurrentLayerId(vm.scriptEditorState.currentAnnotationLayerId);

      if (vm.currentScriptPage.shapepathsPersonal.length > 0) {
        vm.currentScriptPage.shapepathsPersonal = vm.currentScriptPage.shapepathsPersonal.map(function (shapepath) {
          if (angular.isUndefined(shapepath.layerid)) {
            shapepath.layerid = 0
          }

          if (shapepath.isInterpolationDone !== true) {
            return vm.drawingpadPersonal.interpolateLegacyShapePath(shapepath)
          }
          return shapepath;
        });

        vm.drawingpadPersonal.loadShapePaths(vm.currentScriptPage.shapepathsPersonal);
        vm.currentScriptPage.shapepathsPersonal = vm.drawingpadPersonal.getShapePaths();

        resetSelectedShape();
      }

      vm.drawingpadForSharedLayer.clear();
      vm.drawingpadForSharedLayer.setCanvasSize(vm.ownerScriptPage.pagewidth, vm.ownerScriptPage.pageheight);
      if (vm.ownerScriptPage.shapepaths.length > 0) {
        vm.drawingpadForSharedLayer.loadShapePaths(vm.ownerScriptPage.shapepaths);
        vm.ownerScriptPage.shapepaths = vm.drawingpadForSharedLayer.getShapePaths();
      }

      $timeout(function () {
        vm.scrollUpdateSidebar('scrollTo', $('#pageid-' + vm.currentScriptPage.orderingindex).position().top);
      }, 500);
      $timeout(function () {
        vm.scrollUpdateBottombar('scrollTo', '#pageid-h-' + vm.currentScriptPage.orderingindex);
      }, 500);
    };

    function unloadScriptPage() {
      var deferred = $q.defer();

      if (angular.isDefined(vm.currentScriptPage)) {
        saveAllChanges()
          .then(function () {
            vm.currentScriptPage = undefined;
            vm.scriptEditorState.pageLoaded = false;
            vm.scriptEditorState.pageLoadError = false;
            vm.scriptEditorState.pageImageLoadError = false;
            deferred.resolve();
          })
          .catch(function (error) {
            deferred.reject(error);
          });
      } else {
        vm.currentScriptPage = undefined;
        vm.scriptEditorState.pageLoaded = false;
        vm.scriptEditorState.pageLoadError = false;
        vm.scriptEditorState.pageImageLoadError = false;
        deferred.resolve();
      }

      return deferred.promise;
    }

    function resolveChartLinkNames() {
      angular.forEach(vm.currentScriptPage.chartlinks, function (chartLink) {
        resolveChartLinkName(chartLink);
      });
    }

    function resolveChartLinkName(chartLink) {
      var linkedChartName = vm.chartIdToChartNameCache[chartLink.chartId];
      if (angular.isDefined(linkedChartName)) {
        $q.when(linkedChartName)
          .then(function (chartName) {
            chartLink.chartname = chartName;
          });
      } else {
        resolveChartName(chartLink.chartId)
          .then(function (chartName) {
            chartLink.chartname = chartName;
          });
      }
    }

    function resolveChartName(chartId) {
      var deferred = $q.defer();

      dbCharts.getChartForName(chartId)
        .then(function (chart) {
          var chartName;
          if (angular.isDefined(chart)) {
            if (vm.scriptEditorState.chartNumberAutomatic) {
              var parentScene = swaUtils.findInArrayById(vm.scenes, chart.sceneId);
              if (angular.isDefined(parentScene)) {
                chartName = 'Chart: ' + (parentScene.orderingindex + 1) + '.' + (chart.orderingindex + 1);
              }
            } else {
              chartName = chart.customname || '<unnamed>';
            }
          } else {
            chartName = '<missing>';
          }

          vm.chartIdToChartNameCache[chartId] = chartName;
          deferred.resolve(chartName);
        })
        .catch(function (error) {
          $log.error('Error resolving chart name for chart ID: ' + chartId + ', reason:', error);

          var chartName = '<error>';
          vm.chartIdToChartNameCache[chartId] = chartName;
          deferred.resolve(chartName);
        });

      return deferred.promise;
    }

    function markCurrentScriptDirty(forBookmarks) {
      forBookmarks = forBookmarks || false;
      if (vm.scriptEditorState.masterLayerActive || forBookmarks) {
        vm.script.dirty = true;
      }

      if (vm.scriptEditorState.personalLayerActive) {
        vm.script.dirtyPersonal = true;
      }
    }

    function markCurrentScriptPageDirty() {
      // Mark dirty flags depending on active layer
      vm.currentScriptPage.dirty |= vm.scriptEditorState.masterLayerActive;
      vm.currentScriptPage.dirtyPersonal |= vm.scriptEditorState.personalLayerActive;

      // Manage data edited flag
      var dataEdited = false;

      if (vm.scriptEditorState.masterLayerActive) {
        // Check for any data change in left annotations
        if (vm.currentScriptPage && vm.currentScriptPage.leftannotations && vm.currentScriptPage.leftannotations.length) {
          angular.forEach(vm.currentScriptPage.leftannotations, function (annotation) {
            if (annotation.isDataChanged) {
              // Reset data edited flag
              dataEdited = true;

              // Reset data changed flag
              annotation.isDataChanged = false;
            }
          });
        }
      }

      if (vm.scriptEditorState.personalLayerActive) {
        // Check for any data change in left annotations
        if (vm.currentScriptPage && vm.currentScriptPage.leftannotationsPersonal && vm.currentScriptPage.leftannotationsPersonal.length) {
          angular.forEach(vm.currentScriptPage.leftannotationsPersonal, function (annotation) {
            if (annotation.isDataChanged) {
              // Reset data edited flag
              dataEdited = true;

              // Reset data changed flag
              annotation.isDataChanged = false;
            }
          });
        }
      }


      if (vm.scriptEditorState.masterLayerActive) {
        // Check for any data change in right annotations
        if (vm.currentScriptPage && vm.currentScriptPage.rightannotations && vm.currentScriptPage.rightannotations.length) {
          angular.forEach(vm.currentScriptPage.rightannotations, function (annotation) {
            if (annotation.isDataChanged) {
              // Reset data edited flag
              dataEdited = true;

              // Reset data changed flag
              annotation.isDataChanged = false;
            }
          });
        }
      }

      if (vm.scriptEditorState.personalLayerActive) {
        // Check for any data change in right annotations
        if (vm.currentScriptPage && vm.currentScriptPage.rightannotationsPersonal && vm.currentScriptPage.rightannotationsPersonal.length) {
          angular.forEach(vm.currentScriptPage.rightannotationsPersonal, function (annotation) {
            if (annotation.isDataChanged) {
              // Reset data edited flag
              dataEdited = true;

              // Reset data changed flag
              annotation.isDataChanged = false;
            }
          });
        }
      }

      // Check for any data change in floating annotations
      if (vm.scriptEditorState.masterLayerActive) {
        if ((vm.currentScriptPage && vm.currentScriptPage.floatingannotations && vm.currentScriptPage.floatingannotations.length)) {
          angular.forEach(vm.currentScriptPage.floatingannotations, function (annotation) {
            if (annotation.isDataChanged) {
              // Reset data edited flag
              dataEdited = true;

              // Reset data changed flag
              annotation.isDataChanged = false;
            }
          });
        }
      }

      if (vm.scriptEditorState.personalLayerActive) {
        if ((vm.currentScriptPage && vm.currentScriptPage.floatingannotationsPersonal && vm.currentScriptPage.floatingannotationsPersonal.length)) {
          angular.forEach(vm.currentScriptPage.floatingannotationsPersonal, function (annotation) {
            if (annotation.isDataChanged) {
              // Reset data edited flag
              dataEdited = true;

              // Reset data changed flag
              annotation.isDataChanged = false;
            }
          });
        }
      }

      // If data changed then add functionality for undo/redo
      if (dataEdited) {
        if (vm.changeTracker.disableTrackingCount < 1) {
          // Notify script for any change
          scriptNotifyDisableChangeTracking();
        }
      }

    }

    function deactivateAnyActiveAnnotation() {
      deselectHighlightAnnotation()
      deselectFloatingAnnotation();
      deselectLeftAnnotation();
      deselectRightAnnotation();
      resetSelectedShape();
      resetSelectionMode();
      vm.selectedAnnotation = undefined;
    }

    var scriptAnnotationLeftMouseDown;

    function onScriptContentMouseDown(event) {
      scriptAnnotationLeftMouseDown = false;
      vm.newSideAnnotationTracker.activeAnnotationType = vm.scriptEditorState.activeAnnotationType
      vm.newSideAnnotationTracker.isTracking = false;
      vm.newSideAnnotationTracker.valid = false;
      vm.newSideAnnotationTracker.selectionrect = {};

      if ((event.button === 0) && (event.target === scriptAnnotationsContainerElement)) {
        if (vm.scriptEditorState.bookmarkEditMode) {
          scriptAnnotationLeftMouseDown = true;
        } else {
          scriptAnnotationLeftMouseDown = true;
          vm.newSideAnnotationTracker.isTracking = false;
          vm.newSideAnnotationTracker.startX = event.offsetX;
          vm.newSideAnnotationTracker.startY = event.offsetY;

          if (vm.scriptEditorState.activeAnnotationType === 3) {
            vm.newSideAnnotationTracker.backgroundColor = vm.scriptEditorState.highlightColor;
            vm.newSideAnnotationTracker.backgroundColorCss = swaUi.getHighlightBackgroundCss(vm.scriptEditorState.highlightColor);
          } else {
            vm.newSideAnnotationTracker.backgroundColorCss = 'transparent';
          }
        }
      }
    }

    function onScriptContentMouseMove(event) {
      if (scriptAnnotationLeftMouseDown && (vm.scriptEditorState.activeAnnotationType !== -1)) {
        if (vm.autoSetDefaultAreaState && vm.autoSetDefaultAreaState.timerActive) {
          killAutoSetDefaultAreaStateTimer();
        }
        vm.newSideAnnotationTracker.isTracking = true;

        vm.newSideAnnotationTracker.selectionrect.left = Math.min(vm.newSideAnnotationTracker.startX, event.offsetX);
        vm.newSideAnnotationTracker.selectionrect.top = Math.min(vm.newSideAnnotationTracker.startY, event.offsetY);
        vm.newSideAnnotationTracker.selectionrect.width = Math.abs(vm.newSideAnnotationTracker.startX - event.offsetX);
        vm.newSideAnnotationTracker.selectionrect.height = Math.abs(vm.newSideAnnotationTracker.startY - event.offsetY);

        if (vm.scriptEditorState.activeAnnotationType === 2) {
          vm.newSideAnnotationTracker.valid = ((vm.newSideAnnotationTracker.selectionrect.width >= 64) && (vm.newSideAnnotationTracker.selectionrect.height >= 24))
        } else {
          vm.newSideAnnotationTracker.valid = ((vm.newSideAnnotationTracker.selectionrect.width >= 8) && (vm.newSideAnnotationTracker.selectionrect.height >= 16))
        }
      }
    }

    function onScriptContentMouseUp(event) {
      if (!scriptAnnotationLeftMouseDown) {
        return;
      }

      scriptAnnotationLeftMouseDown = false;

      deactivateAnyActiveAnnotation();

      if (vm.scriptEditorState.bookmarkEditMode) {
        addNewBookmark(event.offsetY);
      } else {
        if (vm.newSideAnnotationTracker.isTracking && (vm.scriptEditorState.activeAnnotationType !== -1) && vm.newSideAnnotationTracker.valid) {
          if (vm.scriptEditorState.activeAnnotationType === 3) {
            addHighlightAnnotation(vm.newSideAnnotationTracker);
          } else if (vm.scriptEditorState.activeAnnotationType === 2) {
            addFloatingAnnotation(vm.newSideAnnotationTracker);
          } else {
            vm.newSideAnnotationTracker.shouldAdd = true;
            if (vm.scriptEditorState.activeAnnotationType === 1) {
              vm.newSideAnnotationTracker.content = vm.defaultLqTextSettings.defaultText;
            } else if (vm.scriptEditorState.activeAnnotationType === 0) {
              vm.newSideAnnotationTracker.content = '';
            }
            if (vm.newSideAnnotationTracker.selectionrect.top > (vm.currentScriptPage.pageheight / 2)) {
              vm.newSideAnnotationTracker.popoverplacement = 'top';
            } else {
              vm.newSideAnnotationTracker.popoverplacement = 'bottom';
            }

            $timeout(function () {
              if (vm.scriptEditorState.masterLayerActive) {
                $('.swa-script-annotationpopover-anchor-global').trigger('click');
              } else {
                $('.swa-script-annotationpopover-anchor-personal').trigger('click');
              }
            });
          }
          killAutoSetDefaultAreaStateTimer();
        } else {
          checkForAnnotationToolHint();
        }

        vm.newSideAnnotationTracker.isTracking = false;
      }
    }

    var annotationToolHintTimeoutHandle;
    var annotationToolHintTapCount = 0;

    function checkForAnnotationToolHint() {
      if (vm.scriptEditorState.activeAnnotationType !== -1) {
        $timeout.cancel(annotationToolHintTimeoutHandle);
        annotationToolHintTimeoutHandle = undefined;
        annotationToolHintTapCount = 0;
      }

      annotationToolHintTapCount++;

      if (annotationToolHintTapCount === 1) {
        annotationToolHintTimeoutHandle = $timeout(function () {
          annotationToolHintTapCount = 0;
          annotationToolHintTimeoutHandle = undefined
        }, 10000)
      } else if (annotationToolHintTapCount === 10) {
        toastr.info($translate.instant('messages.script_annotation_tool_use_hint'));
      }
    }

    function addSideAnnotation(side) {
      var newSideAnnotation = {};

      newSideAnnotation.layerid = vm.scriptEditorState.currentAnnotationLayerId;
      newSideAnnotation.content = vm.newSideAnnotationTracker.content;
      newSideAnnotation.richtextcontent = vm.newSideAnnotationTracker.content;
      newSideAnnotation.annotationtype = vm.scriptEditorState.activeAnnotationType;

      newSideAnnotation.selectionrect = vm.newSideAnnotationTracker.selectionrect;
      newSideAnnotation.positionrect = {};
      newSideAnnotation.positionrect.top = (newSideAnnotation.selectionrect.top + newSideAnnotation.selectionrect.height) - 30;
      newSideAnnotation.positionrect.height = 30;

      newSideAnnotation.defaultTextSettings = vm.defaultLqTextSettings;

      newSideAnnotation.backgroundColorForAnchor = vm.defaultLqTextSettings.fillColorForAnchor || vm.userPreferences.contentDefaults.settingsScriptLq.fillColorForAnchor || swaUi.defaultTextStylePreferences.fillColorForAnchor;
      vm.scriptEditorState.backgroundColorForAnchor = newSideAnnotation.backgroundColorForAnchor;
      newSideAnnotation.backgroundColorCssForAnchor = swaUi.getHighlightBackgroundCss(newSideAnnotation.backgroundColorForAnchor);

      newSideAnnotation.borderColorForAnchor = vm.defaultLqTextSettings.borderColorForAnchor || vm.userPreferences.contentDefaults.settingsScriptLq.borderColorForAnchor || swaUi.defaultTextStylePreferences.borderColorForAnchor;
      vm.scriptEditorState.borderColorForAnchor = newSideAnnotation.borderColorForAnchor;
      newSideAnnotation.borderColorCssForAnchor = swaUi.getAnnotationBorderCss(newSideAnnotation.borderColorForAnchor);

      newSideAnnotation.annotationBorderThickness = vm.defaultLqTextSettings.annotationBorderThickness || vm.userPreferences.contentDefaults.settingsScriptLq.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

      newSideAnnotation.markerStyle = vm.defaultLqTextSettings.markerStyle || vm.userPreferences.contentDefaults.settingsScriptLq.markerStyle || swaUi.defaultTextStylePreferences.markerStyle;
      newSideAnnotation.connectingLineTop = vm.defaultLqTextSettings.connectingLineTop || vm.userPreferences.contentDefaults.settingsScriptLq.connectingLineTop || swaUi.defaultTextStylePreferences.connectingLineTop;

      if (newSideAnnotation.annotationtype == 1 && newSideAnnotation.connectingLineTop) {
        newSideAnnotation.positionrect.top = newSideAnnotation.selectionrect.top - newSideAnnotation.positionrect.height;
        if (newSideAnnotation.positionrect.top < 0) {
          newSideAnnotation.positionrect.top = 0;
        }
      }

      if (side === 'left') {
        newSideAnnotation.positionrect.left = 8;
        newSideAnnotation.positionrect.width = 120;
        newSideAnnotation.side = 'left';

        if (vm.scriptEditorState.masterLayerActive) {
          newSideAnnotation.orderingindex = vm.currentScriptPage.leftannotations.length;
          vm.currentScriptPage.leftannotations.push(newSideAnnotation);
        } else if (vm.scriptEditorState.personalLayerActive) {
          newSideAnnotation.orderingindex = vm.currentScriptPage.leftannotationsPersonal.length;
          vm.currentScriptPage.leftannotationsPersonal.push(newSideAnnotation);
        }

        updateLeftAnnotationConnectorLines(newSideAnnotation);

        // Notify script for any change
        if (vm.changeTracker.disableTrackingCount < 1) {
          scriptNotifyDisableChangeTracking();
        }
      } else if (side === 'right') {
        newSideAnnotation.positionrect.left = (vm.currentScriptPage.pagewidth / 2) - 128;
        newSideAnnotation.positionrect.width = 120;
        newSideAnnotation.side = 'right';

        if (vm.scriptEditorState.masterLayerActive) {
          newSideAnnotation.orderingindex = vm.currentScriptPage.rightannotations.length;
          vm.currentScriptPage.rightannotations.push(newSideAnnotation);
        } else if (vm.scriptEditorState.personalLayerActive) {
          newSideAnnotation.orderingindex = vm.currentScriptPage.rightannotationsPersonal.length;
          vm.currentScriptPage.rightannotationsPersonal.push(newSideAnnotation);
        }

        updateRightAnnotationConnectorLines(newSideAnnotation);

        // Notify script for any change
        if (vm.changeTracker.disableTrackingCount < 1) {
          scriptNotifyDisableChangeTracking();
        }
      }

      markCurrentScriptPageDirty();
      vm.addSideAnnotationView.show = false;
      vm.addSideAnnotationViewP.show = false;

      if (side === 'left') {
        if (vm.scriptEditorState.masterLayerActive) {
          selectLeftAnnotation(newSideAnnotation.orderingindex);
        } else if (vm.scriptEditorState.personalLayerActive) {
          selectLeftAnnotation(newSideAnnotation.orderingindex);
        }

      } else if (side === 'right') {
        if (vm.scriptEditorState.masterLayerActive) {
          selectRightAnnotation(newSideAnnotation.orderingindex);
        } else if (vm.scriptEditorState.personalLayerActive) {
          selectRightAnnotation(newSideAnnotation.orderingindex);
        }
      }
    }

    function addNewBookmark(topOffset) {
      var newBookmark = {
        name: '',
        scriptPageNo: vm.currentScriptPage.orderingindex,
        scriptPageId: vm.currentScriptPage._id,
        topOffset: Math.min(Math.max(topOffset, 16), (vm.currentScriptPage.pageheight - 16)),
      };

      vm.bookmarks.push(newBookmark);
      markCurrentScriptDirty(true);
      updateSortedBookmarks();

      vm.scriptEditorState.currentBookmark = newBookmark;

      $timeout(function () {
        $('input#bookmark-name-' + newBookmark.scriptPageNo + '-' + newBookmark.topOffset).trigger('focus');
      }, 100);
    }

    function deleteBookmark(bookmark) {
      vm.bookmarks.splice(vm.bookmarks.indexOf(bookmark), 1);
      markCurrentScriptDirty(true);

      updateSortedBookmarks();
    }

    function bookmarkChanged() {
      markCurrentScriptDirty(true);
    }

    function selectLeftAnnotation(orderingindex) {
      if (vm.scriptEditorState.masterLayerActive) {
        // SWA-1922 - New Checked annotation is on current active layer - then only can select annotation
        if (vm.currentScriptPage.leftannotations[orderingindex].layerid !== vm.scriptEditorState.currentAnnotationLayerId) {
          return;
        }

        if (vm.scriptEditorState.activeLeftAnnotationOrderingIndex === orderingindex) {
          return;
        }
        deactivateAnyActiveAnnotation();
        vm.enableMoveAnnotationAction = true;  // SWA-1922 - New
        if (vm.activeAccessRules.allowannotationediting) {
          vm.scriptEditorState.activeLeftAnnotationOrderingIndex = orderingindex;

          var annotation = vm.currentScriptPage.leftannotations[orderingindex];
          annotation.editingEnabled = true;
          vm.enableMoveAnnotationAction = true;  // SWA-1922 - New
          vm.scriptEditorState.backgroundColorForAnchor = annotation.backgroundColorForAnchor;
          vm.scriptEditorState.borderColorForAnchor = annotation.borderColorForAnchor;
          vm.selectedAnnotation = annotation;
          updateMaincontainerArea();
          killAutoSetDefaultAreaStateTimer();
          angular.element('.sw-maincontentarea-script > .mCustomScrollBox').blur();
        }

      } else if (vm.scriptEditorState.personalLayerActive) {
        // SWA-1922 - New Checked annotation is on current active layer - then only can select annotation
        if (vm.currentScriptPage.leftannotationsPersonal[orderingindex].layerid !== vm.scriptEditorState.currentAnnotationLayerId) {
          return;
        }

        if (vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === orderingindex) {
          return;
        }
        deactivateAnyActiveAnnotation();

        vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex = orderingindex;

        var annotation = vm.currentScriptPage.leftannotationsPersonal[orderingindex];
        annotation.editingEnabled = true;
        vm.enableMoveAnnotationAction = true;  // SWA-1922 - New
        vm.scriptEditorState.backgroundColorForAnchor = annotation.backgroundColorForAnchor;
        vm.scriptEditorState.borderColorForAnchor = annotation.borderColorForAnchor;
        vm.selectedAnnotation = annotation;
        updateMaincontainerArea();
        killAutoSetDefaultAreaStateTimer();
        angular.element('.sw-maincontentarea-script > .mCustomScrollBox').blur();
      }
    }

    function selectRightAnnotation(orderingindex) {
      if (vm.scriptEditorState.masterLayerActive) {
        if (vm.currentScriptPage.rightannotations[orderingindex].layerid !== vm.scriptEditorState.currentAnnotationLayerId) {
          // SWA-1922 - New ert('selected annotation is NOT IN current active layer')
          return;
        }
        if (vm.scriptEditorState.activeRightAnnotationOrderingIndex === orderingindex) {
          return;
        }
        deactivateAnyActiveAnnotation();

        if (vm.activeAccessRules.allowannotationediting) {
          vm.scriptEditorState.activeRightAnnotationOrderingIndex = orderingindex;

          var annotation = vm.currentScriptPage.rightannotations[orderingindex];
          annotation.editingEnabled = true;
          vm.enableMoveAnnotationAction = true;  // SWA-1922 - New
          vm.scriptEditorState.backgroundColorForAnchor = annotation.backgroundColorForAnchor;
          vm.scriptEditorState.borderColorForAnchor = annotation.borderColorForAnchor;
          vm.selectedAnnotation = annotation;
          updateMaincontainerArea();
          killAutoSetDefaultAreaStateTimer();
          angular.element('.sw-maincontentarea-script > .mCustomScrollBox').blur();
        }
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (vm.currentScriptPage.rightannotationsPersonal[orderingindex].layerid !== vm.scriptEditorState.currentAnnotationLayerId) {
          // SWA-1922 - New ert('selected annotation is NOT IN current active layer')
          return;
        }
        if (vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === orderingindex) {
          return;
        }
        deactivateAnyActiveAnnotation();
        vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex = orderingindex;

        var annotation = vm.currentScriptPage.rightannotationsPersonal[orderingindex];
        annotation.editingEnabled = true;
        vm.enableMoveAnnotationAction = true;  // SWA-1922 - New
        vm.scriptEditorState.backgroundColorForAnchor = annotation.backgroundColorForAnchor;
        vm.scriptEditorState.borderColorForAnchor = annotation.borderColorForAnchor;
        vm.selectedAnnotation = annotation;
        updateMaincontainerArea();
        killAutoSetDefaultAreaStateTimer();
        angular.element('.sw-maincontentarea-script > .mCustomScrollBox').blur();
      }
    }

    function deselectLeftAnnotation() {
      if (vm.scriptEditorState.masterLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeLeftAnnotationOrderingIndex) && (vm.scriptEditorState.activeLeftAnnotationOrderingIndex !== -1) && (vm.currentScriptPage && vm.currentScriptPage.leftannotations && vm.currentScriptPage.leftannotations.length)) {

          markCurrentScriptPageDirty();

          var activeAnnotation = vm.currentScriptPage.leftannotations[vm.scriptEditorState.activeLeftAnnotationOrderingIndex];
          delete activeAnnotation.defaultTextSettings;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;  // SWA-1922 - New


          // Script Notify for any change
          if (vm.changeTracker.disableTrackingCount > 0) {
            scriptNotifyEnableChangeTracking();
            scriptNotifyDataDidChange();
          }

        }

        vm.scriptEditorState.activeLeftAnnotationOrderingIndex = -1;
        vm.enableMoveAnnotationAction = false;  // SWA-1922 - New
        vm.selectedAnnotation = undefined;
        startAutoSetDefaultAreaStateTimer();
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex) && (vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex !== -1)) {

          markCurrentScriptPageDirty();

          var activeAnnotation = vm.currentScriptPage.leftannotationsPersonal[vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex];
          delete activeAnnotation.defaultTextSettings;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;  // SWA-1922 - New

          // Notify script for any change
          if (vm.changeTracker.disableTrackingCount > 0) {
            scriptNotifyEnableChangeTracking();
            scriptNotifyDataDidChange();
          }

          vm.selectedAnnotation = undefined;
          startAutoSetDefaultAreaStateTimer();
        }

        vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex = -1;
        vm.enableMoveAnnotationAction = false;  // SWA-1922 - New
      }
    }

    function deselectRightAnnotation() {
      if (vm.scriptEditorState.masterLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeRightAnnotationOrderingIndex) && (vm.scriptEditorState.activeRightAnnotationOrderingIndex !== -1)) {

          markCurrentScriptPageDirty();

          var activeAnnotation = vm.currentScriptPage.rightannotations[vm.scriptEditorState.activeRightAnnotationOrderingIndex];
          delete activeAnnotation.defaultTextSettings;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false; // SWA-1922 - New

          // Script Notify for any change
          if (vm.changeTracker.disableTrackingCount > 0) {
            scriptNotifyEnableChangeTracking();
            scriptNotifyDataDidChange();
          }

        }

        vm.scriptEditorState.activeRightAnnotationOrderingIndex = -1;
        vm.selectedAnnotation = undefined;
        startAutoSetDefaultAreaStateTimer();

      } else if (vm.scriptEditorState.personalLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex) && (vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex !== -1)) {

          markCurrentScriptPageDirty();

          var activeAnnotation = vm.currentScriptPage.rightannotationsPersonal[vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex];
          delete activeAnnotation.defaultTextSettings;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false; // SWA-1922 - New

          // Notify script for any change
          if (vm.changeTracker.disableTrackingCount > 0) {
            scriptNotifyEnableChangeTracking();
            scriptNotifyDataDidChange();
          }
        }

        vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex = -1;
        vm.selectedAnnotation = undefined;
        startAutoSetDefaultAreaStateTimer();
      }
    }

    function deleteLeftAnnotation(indexToRemove) {
      deselectLeftAnnotation();
      if (vm.scriptEditorState.masterLayerActive) {
        vm.currentScriptPage.leftannotations.splice(indexToRemove, 1);
        for (var i = indexToRemove; i < vm.currentScriptPage.leftannotations.length; i++) {
          vm.currentScriptPage.leftannotations[i].orderingindex = i;
        }
      } else if (vm.scriptEditorState.personalLayerActive) {
        vm.currentScriptPage.leftannotationsPersonal.splice(indexToRemove, 1);
        for (var i = indexToRemove; i < vm.currentScriptPage.leftannotationsPersonal.length; i++) {
          vm.currentScriptPage.leftannotationsPersonal[i].orderingindex = i;
        }
      }
      markCurrentScriptPageDirty();

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount > 0) {
        scriptNotifyEnableChangeTracking();
        scriptNotifyDataDidChange();
      }
    }

    function deleteRightAnnotation(indexToRemove) {
      deselectRightAnnotation();
      if (vm.scriptEditorState.masterLayerActive) {
        vm.currentScriptPage.rightannotations.splice(indexToRemove, 1);
        for (var i = indexToRemove; i < vm.currentScriptPage.rightannotations.length; i++) {
          vm.currentScriptPage.rightannotations[i].orderingindex = i;
        }
      } else if (vm.scriptEditorState.personalLayerActive) {
        vm.currentScriptPage.rightannotationsPersonal.splice(indexToRemove, 1);
        for (var i = indexToRemove; i < vm.currentScriptPage.rightannotationsPersonal.length; i++) {
          vm.currentScriptPage.rightannotationsPersonal[i].orderingindex = i;
        }
      }
      markCurrentScriptPageDirty();

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount > 0) {
        scriptNotifyEnableChangeTracking();
        scriptNotifyDataDidChange();
      }
    }

    function leftAnnotationMoved(dragData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotations[vm.scriptEditorState.activeLeftAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.left = dragData.newSizePosition.left;
        activeAnnotation.positionrect.top = dragData.newSizePosition.top;
        activeAnnotation.positionrect.width = dragData.newSizePosition.width;
        activeAnnotation.positionrect.height = dragData.newSizePosition.height;
        activeAnnotation.initialTopOfAnnotation = dragData.newSizePosition.top;

        updateLeftAnnotationConnectorLines(activeAnnotation);
        updateToolbarPosition(activeAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotationsPersonal[vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.left = dragData.newSizePosition.left;
        activeAnnotation.positionrect.top = dragData.newSizePosition.top;
        activeAnnotation.positionrect.width = dragData.newSizePosition.width;
        activeAnnotation.positionrect.height = dragData.newSizePosition.height;
        activeAnnotation.initialTopOfAnnotation = dragData.newSizePosition.top;

        updateLeftAnnotationConnectorLines(activeAnnotation);
        updateToolbarPosition(activeAnnotation);
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function leftAnnotationResized(sizeData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotations[vm.scriptEditorState.activeLeftAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.positionrect.height = sizeData.newSizePosition.height;
        activeAnnotation.minimumHeightOfAnnotation = sizeData.newSizePosition.height;

        updateLeftAnnotationConnectorLines(activeAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotationsPersonal[vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.positionrect.height = sizeData.newSizePosition.height;
        activeAnnotation.minimumHeightOfAnnotation = sizeData.newSizePosition.height;

        updateLeftAnnotationConnectorLines(activeAnnotation);
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function updateLeftAnnotationConnectorLines(annotation) {
      annotation.linex1 = annotation.selectionrect.left;
      annotation.linex2 = (annotation.positionrect.left + annotation.positionrect.width);
      annotation.liney2 = (annotation.positionrect.top + annotation.positionrect.height);

      if (annotation.annotationtype === 1 && annotation.connectingLineTop) {
        annotation.liney1 = (annotation.selectionrect.top);
      } else {
        annotation.liney1 = (annotation.selectionrect.top + annotation.selectionrect.height);
      }
    }

    function leftAnnotationSelectionMoved(dragData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotations[vm.scriptEditorState.activeLeftAnnotationOrderingIndex];

        activeAnnotation.selectionrect.left = dragData.newSizePosition.left;
        activeAnnotation.selectionrect.top = dragData.newSizePosition.top;

        updateLeftAnnotationConnectorLines(activeAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotationsPersonal[vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex];

        activeAnnotation.selectionrect.left = dragData.newSizePosition.left;
        activeAnnotation.selectionrect.top = dragData.newSizePosition.top;

        updateLeftAnnotationConnectorLines(activeAnnotation);
      }
      vm.activeAnnotationElement = activeAnnotation; // SWA-1922 - New

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function leftAnnotationSelectionResized(sizeData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotations[vm.scriptEditorState.activeLeftAnnotationOrderingIndex];

        activeAnnotation.selectionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.selectionrect.height = sizeData.newSizePosition.height;

        updateLeftAnnotationConnectorLines(activeAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotationsPersonal[vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex];

        activeAnnotation.selectionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.selectionrect.height = sizeData.newSizePosition.height;

        updateLeftAnnotationConnectorLines(activeAnnotation);
      }
      vm.activeAnnotationElement = activeAnnotation; // SWA-1922 - New

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function rightAnnotationMoved(dragData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotations[vm.scriptEditorState.activeRightAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.left = dragData.newSizePosition.left;
        activeAnnotation.positionrect.top = dragData.newSizePosition.top;
        activeAnnotation.positionrect.width = dragData.newSizePosition.width;
        activeAnnotation.positionrect.height = dragData.newSizePosition.height;
        activeAnnotation.initialTopOfAnnotation = dragData.newSizePosition.top;

        updateRightAnnotationConnectorLines(activeAnnotation);
        updateToolbarPosition(activeAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotationsPersonal[vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.left = dragData.newSizePosition.left;
        activeAnnotation.positionrect.top = dragData.newSizePosition.top;
        activeAnnotation.positionrect.width = dragData.newSizePosition.width;
        activeAnnotation.positionrect.height = dragData.newSizePosition.height;
        activeAnnotation.initialTopOfAnnotation = dragData.newSizePosition.top;

        updateRightAnnotationConnectorLines(activeAnnotation);
        updateToolbarPosition(activeAnnotation);
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function rightAnnotationResized(sizeData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotations[vm.scriptEditorState.activeRightAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.positionrect.height = sizeData.newSizePosition.height;
        activeAnnotation.minimumHeightOfAnnotation = sizeData.newSizePosition.height;

        updateRightAnnotationConnectorLines(activeAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotationsPersonal[vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.positionrect.height = sizeData.newSizePosition.height;
        activeAnnotation.minimumHeightOfAnnotation = sizeData.newSizePosition.height;

        updateRightAnnotationConnectorLines(activeAnnotation);
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function updateRightAnnotationConnectorLines(annotation) {
      if (annotation.annotationtype === 1 && annotation.markerStyle) {
        annotation.linex1 = annotation.selectionrect.left;
      } else {
        annotation.linex1 = (annotation.selectionrect.left + annotation.selectionrect.width);
      }

      annotation.linex2 = (vm.currentScriptPage.pagewidth / 2) + annotation.positionrect.left;
      annotation.liney2 = (annotation.positionrect.top + annotation.positionrect.height);

      if (annotation.annotationtype === 1 && annotation.connectingLineTop) {
        annotation.liney1 = (annotation.selectionrect.top);
      } else {
        annotation.liney1 = (annotation.selectionrect.top + annotation.selectionrect.height);
      }
    }

    function rightAnnotationSelectionMoved(dragData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotations[vm.scriptEditorState.activeRightAnnotationOrderingIndex];

        activeAnnotation.selectionrect.left = dragData.newSizePosition.left;
        activeAnnotation.selectionrect.top = dragData.newSizePosition.top;

        updateRightAnnotationConnectorLines(activeAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotationsPersonal[vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex];

        activeAnnotation.selectionrect.left = dragData.newSizePosition.left;
        activeAnnotation.selectionrect.top = dragData.newSizePosition.top;

        updateRightAnnotationConnectorLines(activeAnnotation);
      }
      vm.activeAnnotationElement = activeAnnotation;  // SWA-1922 - New

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function rightAnnotationSelectionResized(sizeData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotations[vm.scriptEditorState.activeRightAnnotationOrderingIndex];

        activeAnnotation.selectionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.selectionrect.height = sizeData.newSizePosition.height;

        updateRightAnnotationConnectorLines(activeAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotationsPersonal[vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex];

        activeAnnotation.selectionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.selectionrect.height = sizeData.newSizePosition.height;

        updateRightAnnotationConnectorLines(activeAnnotation);
      }
      vm.activeAnnotationElement = activeAnnotation;  // SWA-1922 - New

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function watchAddSideAnnotationView(property) {
      $scope.$watch('vm.' + property + '.show', function (newValue, oldValue) {
        if (newValue === true) {
          if (!vm.newSideAnnotationTracker.shouldAdd) {
            vm[property].show = false;
          }
        } else {
          vm.newSideAnnotationTracker.shouldAdd = false;
        }
      });
    }
    watchAddSideAnnotationView('addSideAnnotationView');
    watchAddSideAnnotationView('addSideAnnotationViewP');


    function scriptNotifyEnableChangeTracking() {
      $log.debug('scriptNotifyEnableChangeTracking():');
      vm.changeTracker.disableTrackingCount--;

      changeTrackerUpdateState();
    }

    function scriptNotifyDataDidChange() {
      $log.debug('scriptNotifyDataDidChange():', Date.now());

      if (vm.changeTracker.enabled) {
        if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
          vm.changeTracker.undoStack.push(vm.changeTracker.lastTrackedState);
        }

        vm.changeTracker.nextStateNumber++;
        vm.changeTracker.lastTrackedState = getCurrentScriptStateCopy();

        vm.changeTracker.redoStack.length = 0;
      }

      changeTrackerUpdateState();
    }

    function scriptNotifyDisableChangeTracking() {
      $log.debug('scriptNotifyDisableChangeTracking():');
      vm.changeTracker.disableTrackingCount++;

      changeTrackerUpdateState();
    }

    function addFloatingAnnotation(newAnnotationTracker) {
      deselectFloatingAnnotation();
      var newAnnotation = {
        content: '',
        richtextcontent: '',
        annotationtype: 2,
        layerid: vm.scriptEditorState.currentAnnotationLayerId,  // SWA-1922 - New
      };
      newAnnotation.positionrect = angular.copy(newAnnotationTracker.selectionrect);
      newAnnotation.backgroundColor = vm.defaultFloatingTextSettings.fillColor;
      newAnnotation.defaultTextSettings = vm.defaultFloatingTextSettings;
      if (vm.scriptEditorState.masterLayerActive) {
        newAnnotation.orderingindex = vm.currentScriptPage.floatingannotations.length;
        vm.currentScriptPage.floatingannotations.push(newAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        newAnnotation.orderingindex = vm.currentScriptPage.floatingannotationsPersonal.length;
        vm.currentScriptPage.floatingannotationsPersonal.push(newAnnotation);
      }

      markCurrentScriptPageDirty();

      selectFloatingAnnotation(newAnnotation.orderingindex);
    }

    function selectFloatingAnnotation(orderingindex) {
      if (vm.scriptEditorState.masterLayerActive) {
        if (vm.currentScriptPage.floatingannotations[orderingindex].layerid !== vm.scriptEditorState.currentAnnotationLayerId) {
          // SWA-1922 - New alert('selected annotation is NOT IN current active layer')
          return;
        }

        if (vm.scriptEditorState.activeFloatingAnnotationOrderingIndex === orderingindex) {
          return;
        }
        deactivateAnyActiveAnnotation();

        if (vm.activeAccessRules.allowannotationediting) {
          vm.scriptEditorState.activeFloatingAnnotationOrderingIndex = orderingindex;

          var annotation = vm.currentScriptPage.floatingannotations[orderingindex];
          annotation.editingEnabled = true;
          vm.enableMoveAnnotationAction = true;  // SWA-1922 - New
          vm.selectedAnnotation = annotation;
          updateMaincontainerArea();
          killAutoSetDefaultAreaStateTimer();
          angular.element('.sw-maincontentarea-script > .mCustomScrollBox').blur();
        }
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (vm.currentScriptPage.floatingannotationsPersonal[orderingindex].layerid !== vm.scriptEditorState.currentAnnotationLayerId) {
          // SWA-1922 - New alert('selected annotation is NOT IN current active layer')
          return;
        }

        if (vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex === orderingindex) {
          return;
        }
        deactivateAnyActiveAnnotation();

        vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex = orderingindex;

        var annotation = vm.currentScriptPage.floatingannotationsPersonal[orderingindex];
        annotation.editingEnabled = true;
        vm.enableMoveAnnotationAction = true;  // SWA-1922 - New
        vm.selectedAnnotation = annotation;
        updateMaincontainerArea();
        killAutoSetDefaultAreaStateTimer();
        angular.element('.sw-maincontentarea-script > .mCustomScrollBox').blur();
      }
    }

    function deselectFloatingAnnotation() {
      if (vm.scriptEditorState.masterLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeFloatingAnnotationOrderingIndex) && (vm.scriptEditorState.activeFloatingAnnotationOrderingIndex !== -1)) {
          var activeAnnotation = vm.currentScriptPage.floatingannotations[vm.scriptEditorState.activeFloatingAnnotationOrderingIndex];
          delete activeAnnotation.defaultTextSettings;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;  // SWA-1922 - New

          // Notify script for any change
          if (vm.changeTracker.disableTrackingCount > 0) {
            scriptNotifyEnableChangeTracking();
            scriptNotifyDataDidChange();
          }
        }

        vm.scriptEditorState.activeFloatingAnnotationOrderingIndex = -1;
        vm.selectedAnnotation = undefined;
        startAutoSetDefaultAreaStateTimer();
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex) && (vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex !== -1)) {
          var activeAnnotation = vm.currentScriptPage.floatingannotationsPersonal[vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex];
          delete activeAnnotation.defaultTextSettings;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;  // SWA-1922 - New

          // Notify script for any change
          if (vm.changeTracker.disableTrackingCount > 0) {
            scriptNotifyEnableChangeTracking();
            scriptNotifyDataDidChange();
          }
        }

        vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex = -1;
        vm.selectedAnnotation = undefined;
        startAutoSetDefaultAreaStateTimer();
      }
    }

    function deleteFloatingAnnotation(indexToRemove) {
      deselectFloatingAnnotation();

      // $timeout(function () {
      if (vm.scriptEditorState.masterLayerActive) {
        vm.currentScriptPage.floatingannotations.splice(indexToRemove, 1);
        for (var i = indexToRemove; i < vm.currentScriptPage.floatingannotations.length; i++) {
          vm.currentScriptPage.floatingannotations[i].orderingindex = i;
        }
      } else if (vm.scriptEditorState.personalLayerActive) {
        vm.currentScriptPage.floatingannotationsPersonal.splice(indexToRemove, 1);
        for (var i = indexToRemove; i < vm.currentScriptPage.floatingannotationsPersonal.length; i++) {
          vm.currentScriptPage.floatingannotationsPersonal[i].orderingindex = i;
        }
      }
      markCurrentScriptPageDirty();
      // }, 500);

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount > 0) {
        scriptNotifyEnableChangeTracking();
        scriptNotifyDataDidChange();
      }

    }

    function floatingAnnotationMoved(dragData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.floatingannotations[vm.scriptEditorState.activeFloatingAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.left = dragData.newSizePosition.left;
        activeAnnotation.positionrect.top = dragData.newSizePosition.top;
        activeAnnotation.positionrect.width = dragData.newSizePosition.width;
        activeAnnotation.positionrect.height = dragData.newSizePosition.height;
        activeAnnotation.initialTopOfAnnotation = dragData.newSizePosition.top;
        updateToolbarPosition(activeAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.floatingannotationsPersonal[vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.left = dragData.newSizePosition.left;
        activeAnnotation.positionrect.top = dragData.newSizePosition.top;
        activeAnnotation.positionrect.width = dragData.newSizePosition.width;
        activeAnnotation.positionrect.height = dragData.newSizePosition.height;
        activeAnnotation.initialTopOfAnnotation = dragData.newSizePosition.top;
        updateToolbarPosition(activeAnnotation);
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function floatingAnnotationResized(sizeData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.floatingannotations[vm.scriptEditorState.activeFloatingAnnotationOrderingIndex];

        activeAnnotation.sizewidth = sizeData.newSizePosition.width;
        activeAnnotation.sizeheight = sizeData.newSizePosition.height;

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.positionrect.height = sizeData.newSizePosition.height;
        activeAnnotation.minimumHeightOfAnnotation = sizeData.newSizePosition.height;
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.floatingannotationsPersonal[vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex];

        activeAnnotation.sizewidth = sizeData.newSizePosition.width;
        activeAnnotation.sizeheight = sizeData.newSizePosition.height;

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.positionrect.height = sizeData.newSizePosition.height;
        activeAnnotation.minimumHeightOfAnnotation = sizeData.newSizePosition.height;
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function addHighlightAnnotation(newAnnotationTracker) {
      if (vm.scriptEditorState.masterLayerActive) {
        deselectHighlightAnnotation();
        var newAnnotation = {
          orderingindex: vm.currentScriptPage.highlightannotations.length,
          annotationtype: 3,
          layerid: vm.scriptEditorState.currentAnnotationLayerId,  // SWA-1922 - New
        };
        newAnnotation.positionrect = angular.copy(newAnnotationTracker.selectionrect);
        newAnnotation.backgroundColor = newAnnotationTracker.backgroundColor;
        newAnnotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(newAnnotationTracker.backgroundColor);
        vm.currentScriptPage.highlightannotations.push(newAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        deselectHighlightAnnotation();
        var newAnnotation = {
          orderingindex: vm.currentScriptPage.highlightannotationsPersonal.length,
          annotationtype: 3,
          layerid: vm.scriptEditorState.currentAnnotationLayerId,  // SWA-1922 - New
        };
        newAnnotation.positionrect = angular.copy(newAnnotationTracker.selectionrect);
        newAnnotation.backgroundColor = newAnnotationTracker.backgroundColor;
        newAnnotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(newAnnotationTracker.backgroundColor);
        vm.currentScriptPage.highlightannotationsPersonal.push(newAnnotation);
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();

      selectHighlightAnnotation(newAnnotation.orderingindex);

      $timeout(function () {
        if (vm.scriptEditorState.masterLayerActive) {
          $('#mce-editor-text-annotation-' + newAnnotation.orderingindex).focus();
        } else if (vm.scriptEditorState.personalLayerActive) {
          $('#mce-editor-text-annotationP-' + newAnnotation.orderingindex).focus();
        }
      }, 500);
    }

    function selectHighlightAnnotation(orderingindex) {
      if (vm.scriptEditorState.masterLayerActive) {
        if (vm.currentScriptPage.highlightannotations[orderingindex].layerid !== vm.scriptEditorState.currentAnnotationLayerId) {
          // SWA-1922 - New alert('selected annotation is NOT IN current active layer')
          return;
        }

        if (vm.scriptEditorState.activeHighlightAnnotationOrderingIndex === orderingindex) {
          return;
        }
        deactivateAnyActiveAnnotation();

        if (vm.activeAccessRules.allowannotationediting) {
          vm.scriptEditorState.activeHighlightAnnotationOrderingIndex = orderingindex;

          var annotation = vm.currentScriptPage.highlightannotations[orderingindex];
          annotation.editingEnabled = true;
          vm.enableMoveAnnotationAction = true;  // SWA-1922 - New
          vm.selectedAnnotation = annotation;
          vm.scriptEditorState.highlightColor = annotation.backgroundColor;
          updateMaincontainerArea();
          killAutoSetDefaultAreaStateTimer();
          angular.element('.sw-maincontentarea-script > .mCustomScrollBox').blur();
        }
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (vm.currentScriptPage.highlightannotationsPersonal[orderingindex].layerid !== vm.scriptEditorState.currentAnnotationLayerId) {
          // SWA-1922 - New alert('selected annotation is NOT IN current active layer')
          return;
        }

        if (vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex === orderingindex) {
          return;
        }
        deactivateAnyActiveAnnotation();

        vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex = orderingindex;

        var annotation = vm.currentScriptPage.highlightannotationsPersonal[orderingindex];
        annotation.editingEnabled = true;
        vm.enableMoveAnnotationAction = true;  // SWA-1922 - New
        vm.selectedAnnotation = annotation;
        vm.scriptEditorState.highlightColor = annotation.backgroundColor;
        updateMaincontainerArea();
        killAutoSetDefaultAreaStateTimer();
        angular.element('.sw-maincontentarea-script > .mCustomScrollBox').blur();
      }
    }

    function deselectHighlightAnnotation() {
      if (vm.scriptEditorState.masterLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeHighlightAnnotationOrderingIndex) && (vm.scriptEditorState.activeHighlightAnnotationOrderingIndex !== -1)) {

          // Script Notify for any change
          if (vm.changeTracker.disableTrackingCount > 0) {
            scriptNotifyEnableChangeTracking();
            scriptNotifyDataDidChange();
          }

          var activeAnnotation = vm.currentScriptPage.highlightannotations[vm.scriptEditorState.activeHighlightAnnotationOrderingIndex];

          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;  // SWA-1922 - New
        }

        vm.scriptEditorState.activeHighlightAnnotationOrderingIndex = -1;
        vm.selectedAnnotation = undefined;
        startAutoSetDefaultAreaStateTimer();
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex) && (vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex !== -1)) {

          // Script Notify for any change
          if (vm.changeTracker.disableTrackingCount > 0) {
            scriptNotifyEnableChangeTracking();
            scriptNotifyDataDidChange();
          }

          var activeAnnotation = vm.currentScriptPage.highlightannotationsPersonal[vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex];

          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;  // SWA-1922 - New
        }

        vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex = -1;
        vm.selectedAnnotation = undefined;
        startAutoSetDefaultAreaStateTimer();
      }
    }

    function deleteHighlightAnnotation(indexToRemove) {
      deselectHighlightAnnotation();

      // $timeout(function () {
      if (vm.scriptEditorState.masterLayerActive) {
        vm.currentScriptPage.highlightannotations.splice(indexToRemove, 1);
        for (var i = indexToRemove; i < vm.currentScriptPage.highlightannotations.length; i++) {
          vm.currentScriptPage.highlightannotations[i].orderingindex = i;
        }
      } else if (vm.scriptEditorState.personalLayerActive) {
        vm.currentScriptPage.highlightannotationsPersonal.splice(indexToRemove, 1);
        for (var i = indexToRemove; i < vm.currentScriptPage.highlightannotationsPersonal.length; i++) {
          vm.currentScriptPage.highlightannotationsPersonal[i].orderingindex = i;
        }
      }
      markCurrentScriptPageDirty();
      // }, 500);

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount > 0) {
        scriptNotifyEnableChangeTracking();
        scriptNotifyDataDidChange();
      }

    }

    function highlightAnnotationMoved(dragData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.highlightannotations[vm.scriptEditorState.activeHighlightAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.left = dragData.newSizePosition.left;
        activeAnnotation.positionrect.top = dragData.newSizePosition.top;
        activeAnnotation.positionrect.width = dragData.newSizePosition.width;
        activeAnnotation.positionrect.height = dragData.newSizePosition.height;
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.highlightannotationsPersonal[vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex];

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.left = dragData.newSizePosition.left;
        activeAnnotation.positionrect.top = dragData.newSizePosition.top;
        activeAnnotation.positionrect.width = dragData.newSizePosition.width;
        activeAnnotation.positionrect.height = dragData.newSizePosition.height;
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function highlightAnnotationResized(sizeData) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.highlightannotations[vm.scriptEditorState.activeHighlightAnnotationOrderingIndex];

        activeAnnotation.sizewidth = sizeData.newSizePosition.width;
        activeAnnotation.sizeheight = sizeData.newSizePosition.height;

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.positionrect.height = sizeData.newSizePosition.height;

      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.highlightannotationsPersonal[vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex];

        activeAnnotation.sizewidth = sizeData.newSizePosition.width;
        activeAnnotation.sizeheight = sizeData.newSizePosition.height;

        activeAnnotation.positionrect = activeAnnotation.positionrect || {};
        activeAnnotation.positionrect.width = sizeData.newSizePosition.width;
        activeAnnotation.positionrect.height = sizeData.newSizePosition.height;
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function highlightColorChanged(color) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.highlightannotations[vm.scriptEditorState.activeHighlightAnnotationOrderingIndex];

        activeAnnotation.backgroundColor = color;
        activeAnnotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(color);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.highlightannotationsPersonal[vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex];

        activeAnnotation.backgroundColor = color;
        activeAnnotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(color);
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      vm.scriptEditorState.highlightColor = color;

      markCurrentScriptPageDirty();
    }

    function toggleAnnotationVisibility() {
      if (vm.scriptEditorState.masterLayerActive) {
        if (vm.scriptEditorState.annotationsVisible) {
          vm.scriptEditorState.annotationsVisible = false;
          for (var i = 0; i < vm.annotationlayers.length; i++) {
            vm.drawingpad.setLayerVisibility(i, false);
          }
        } else {
          vm.scriptEditorState.annotationsVisible = true;
          for (var i = 0; i < vm.annotationlayers.length; i++) {
            vm.drawingpad.setLayerVisibility(i, true);
          }
        }
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (vm.scriptEditorState.annotationsVisiblePersonal) {
          vm.scriptEditorState.annotationsVisiblePersonal = false;
          for (var i = 0; i < vm.annotationlayers.length; i++) {
            vm.drawingpadPersonal.setLayerVisibility(i, false);
          }
          for (var i = 0; i < vm.sharedannotationlayers.length; i++) {
            vm.drawingpadForSharedLayer.setLayerVisibility(i, false);
          }
        } else {
          vm.scriptEditorState.annotationsVisiblePersonal = true;
          for (var i = 0; i < vm.annotationlayers.length; i++) {
            vm.drawingpadPersonal.setLayerVisibility(i, true);
          }
          for (var i = 0; i < vm.sharedannotationlayers.length; i++) {
            vm.drawingpadForSharedLayer.setLayerVisibility(i, true);
          }
        }
      }

      resetSelectedShape();
      deactivateAnyActiveAnnotation();
    }

    var bookmarkToastTimeoutHandle;

    // SWA-1922 - New
    function toggleAnnotationLayerListVisibility() {
      vm.scriptEditorState.annotationLayerListVisible = !vm.scriptEditorState.annotationLayerListVisible;

      if (vm.scriptEditorState.bookmarkListVisible) {
        // if  annotation layer is showing then  bookmark  hide
        vm.scriptEditorState.bookmarkListVisible = false;
      }
    }

    function resetHiddenLayerList() {
      vm.hiddenAnnotationLayersList = [];
      angular.forEach(vm.annotationlayers, function (annotationlayer) {
        // SWA-1922 - if isvisible not set the set default true
        if (angular.isUndefined(annotationlayer.isvisible)) {
          annotationlayer.isvisible = true
        }
        if (annotationlayer.isvisible === false) {
          if (!(vm.activeAccessRules.allowscriptediting || vm.activeAccessRules.allowpersonalnotes)) {
            annotationlayer.isvisible = true;
          } else {
            // visibility false so add to hidden layer list
            vm.hiddenAnnotationLayersList.push(annotationlayer.layerid);
          }
        }
      });
    }

    function resetHiddenSharedLayerList() {
      vm.hiddenSharedAnnotationLayersList = [];
      angular.forEach(vm.sharedannotationlayers, function (annotationlayer) {
        if (angular.isUndefined(annotationlayer.isVisibleToCollaborators)) {
          annotationlayer.isVisibleToCollaborators = true;
        }
        if (annotationlayer.isVisibleToCollaborators === false) {
          if (!(vm.activeAccessRules.allowscriptediting || vm.activeAccessRules.allowpersonalnotes)) {
            annotationlayer.isVisibleToCollaborators = true;
          } else {
            vm.hiddenSharedAnnotationLayersList.push(annotationlayer.layerid);
          }
        }
      });
    }

    // SWA-1922 - New
    function toggleAnnotationVisibilityForLayer(annotationLayerId) {
      if (!(vm.activeAccessRules.allowscriptediting || vm.activeAccessRules.allowpersonalnotes)) {
        return;
      }

      var existingLayer = _.findWhere(vm.annotationlayers, { layerid: annotationLayerId });

      if (existingLayer.isvisible) {
        existingLayer.isvisible = false;
      } else {
        existingLayer.isvisible = true;
      }

      resetHiddenLayerList();
      updateForAnnotationLayerOrVisibilityChange();

      markCurrentScriptPageDirty();
      markCurrentScriptDirty();

      resetSelectedShape();
      deactivateAnyActiveAnnotation();
    }

    function toggleAnnotationVisibilityForSharedLayer(annotationLayerId) {
      if (!(vm.activeAccessRules.allowscriptediting || vm.activeAccessRules.allowpersonalnotes)) {
        return;
      }

      var existingLayer = _.findWhere(vm.sharedannotationlayers, { layerid: annotationLayerId });
      if (existingLayer.isVisibleToCollaborators) {
        existingLayer.isVisibleToCollaborators = false;
      } else {
        existingLayer.isVisibleToCollaborators = true;
      }

      resetHiddenSharedLayerList();
      updateForSharedAnnotationLayerOrVisibilityChange();

      markCurrentScriptPageDirty();
      markCurrentScriptDirty();

      resetSelectedShape();
      deactivateAnyActiveAnnotation();
    }

    /**
      * SWA-1922 - New 'select' to the given annotationlayer for changes.
      * @param {ScriptAnnotationType} annotationlayer
      */
    function selectAnnotationLayer(annotationlayer) {
      vm.selectedLayer = annotationlayer;
      vm.scriptEditorState.activeAnnotationType = -1;
      // Deactivate all the selected activations
      if (!vm.scriptEditorState.selectionMode) {
        deactivateAnyActiveAnnotation();
      } else {
        resetSelectedShape();
      }

      if (!(vm.activeAccessRules.allowscriptediting || vm.activeAccessRules.allowpersonalnotes)) {
        vm.scriptEditorState.currentAnnotationLayerId = -1;
        return;
      }

      if (annotationlayer && annotationlayer.layerid > 0) {
        vm.scriptEditorState.currentAnnotationLayerId = annotationlayer.layerid;
      } else {
        vm.scriptEditorState.currentAnnotationLayerId = 0;
      }

      updateForAnnotationLayerOrVisibilityChange();

      loadAnnotationLayerContentDefaults(annotationlayer);

      if (annotationlayer) {
        var annotationActions = {
          1: toggleAddLightCueAnnotation,
          2: toggleAddFloatingTextAnnotation,
          3: toggleAddHighlightAnnotation,
          4: toggleAddSketchpadAnnotation,
        };

        var action = annotationActions[annotationlayer.activeAnnotationType];
        if (action) {
          action();
        } else {
          vm.scriptEditorState.activeAnnotationType = -1;
        }
      }

    }

    function updateForAnnotationLayerOrVisibilityChange() {
      angular.forEach(vm.annotationlayers, function (annotationlayer) {
        if (vm.scriptEditorState.masterLayerActive) {
          vm.drawingpad.setLayerVisibility(annotationlayer.layerid, annotationlayer.isvisible);
        }
        if (vm.scriptEditorState.personalLayerActive) {
          vm.drawingpadPersonal.setLayerVisibility(annotationlayer.layerid, annotationlayer.isvisible);
        }

        if (annotationlayer.layerid === vm.scriptEditorState.currentAnnotationLayerId) {
          vm.scriptEditorState.isShowHideAnnotations = (annotationlayer.isvisible === true);
        }
      });

      if (vm.scriptEditorState.masterLayerActive) {
        vm.drawingpad.setCurrentLayerId(vm.scriptEditorState.currentAnnotationLayerId);
      } else if (vm.scriptEditorState.personalLayerActive) {
        vm.drawingpadPersonal.setCurrentLayerId(vm.scriptEditorState.currentAnnotationLayerId);
      }
    }

    function updateForSharedAnnotationLayerOrVisibilityChange() {
      angular.forEach(vm.sharedannotationlayers, function (annotationlayer) {
        if (vm.scriptEditorState.personalLayerActive) {
          vm.drawingpadForSharedLayer.setLayerVisibility(annotationlayer.layerid, annotationlayer.isVisibleToCollaborators);
        }
      });
    }

    // SWA-1922 - New
    function showAddAnnotationLayer() {
      if (!vm.showAddAnnotationLayerStatus) {
        vm.showAddAnnotationLayerStatus = true;

        var inputElementName = '#newAnnoLayer';
        $timeout(function () {
          angular.element(inputElementName).focus();
        }, 100);

        showHideEditAnnotationLayer();
      } else {
        vm.showAddAnnotationLayerStatus = false;
        vm.newAnnotationLayerName = "";
      }
    }

    // SWA-1922 - New
    function showHideEditAnnotationLayer() {
      if (angular.isDefined(vm.inlineEditIndex) && vm.inlineEditIndex !== -1) {
        // Hide edit annotation
        vm.inlineEditIndex = -1;
      }
    }

    function addNewAnnotationLayer() {
      if (vm.newAnnotationLayerName !== '') {
        var maxLayerId = -1;
        vm.annotationlayers.forEach(function (l) {
          if (maxLayerId < l.layerid) {
            maxLayerId = l.layerid;
          }
        });

        if (vm.activeAccessRules.allowpersonalnotes) {
          if (angular.isDefined(vm.userScript)) {
            if (angular.isDefined(vm.userScript.LayerIdMax)) {
              vm.userScript.LayerIdMax = vm.userScript.LayerIdMax + 1;
            } else {
              vm.userScript.LayerIdMax = maxLayerId + 1;
            }
          }
          var newlayer = {
            "layerid": angular.isUndefined(vm.userScript) ? maxLayerId + 1 : (vm.userScript.LayerIdMax),
            "name": vm.newAnnotationLayerName,
            "orderingindex": angular.isUndefined(vm.userScript) ? maxLayerId + 1 : (vm.userScript.LayerIdMax),
            "isvisible": true,
            "contentDefaults": angular.copy(vm.userPreferences.contentDefaults),
          }
        } else {
          if (angular.isDefined(vm.script.LayerIdMax)) {
            vm.script.LayerIdMax = vm.script.LayerIdMax + 1;
          } else {
            vm.script.LayerIdMax = maxLayerId + 1;
          }
          var newlayer = {
            "layerid": (vm.script.LayerIdMax),
            "name": vm.newAnnotationLayerName,
            "orderingindex": (vm.script.LayerIdMax),
            "isvisible": true,
            "contentDefaults": angular.copy(vm.userPreferences.contentDefaults),
            "isShared": false,
            "isVisibleToCollaborators": true
          }
        }

        vm.annotationlayers.push(newlayer);
        vm.newAnnotationLayerName = "";
        if (vm.annotationlayers.length < vm.maxAnnotationLayers) {
          vm.enableAddAnnotationLayer = true
        } else {
          vm.enableAddAnnotationLayer = false
        }
        vm.showAddAnnotationLayerStatus = false;

        markCurrentScriptDirty();
        saveScript()
          .then(function () {
            selectAnnotationLayer(newlayer);
          });
      }
    }

    // SWA-1922 - New
    function moveLeftAnnotationToAnotherLayer(layerid) {
      if (vm.scriptEditorState.masterLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeLeftAnnotationOrderingIndex) && (vm.scriptEditorState.activeLeftAnnotationOrderingIndex !== -1)) {
          var activeAnnotation = vm.currentScriptPage.leftannotations[vm.scriptEditorState.activeLeftAnnotationOrderingIndex];
          activeAnnotation.layerid = layerid;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;
        }

        vm.scriptEditorState.activeLeftAnnotationOrderingIndex = -1;
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex) && (vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex !== -1)) {
          var activeAnnotation = vm.currentScriptPage.leftannotationsPersonal[vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex];
          activeAnnotation.layerid = layerid;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;
        }

        vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex = -1;
      }
    }

    // SWA-1922 - New
    function moveRightAnnotationToAnotherLayer(layerid) {
      if (vm.scriptEditorState.masterLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeRightAnnotationOrderingIndex) && (vm.scriptEditorState.activeRightAnnotationOrderingIndex !== -1)) {
          var activeAnnotation = vm.currentScriptPage.rightannotations[vm.scriptEditorState.activeRightAnnotationOrderingIndex];
          activeAnnotation.layerid = layerid;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;
        }

        vm.scriptEditorState.activeRightAnnotationOrderingIndex = -1;
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex) && (vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex !== -1)) {
          var activeAnnotation = vm.currentScriptPage.rightannotationsPersonal[vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex];
          activeAnnotation.layerid = layerid;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;
        }

        vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex = -1;
      }
    }

    // SWA-1922 - New
    function moveFloatingAnnotationToAnotherLayer(layerid) {
      if (vm.scriptEditorState.masterLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeFloatingAnnotationOrderingIndex) && (vm.scriptEditorState.activeFloatingAnnotationOrderingIndex !== -1)) {
          var activeAnnotation = vm.currentScriptPage.floatingannotations[vm.scriptEditorState.activeFloatingAnnotationOrderingIndex];
          activeAnnotation.layerid = layerid;
          delete activeAnnotation.defaultTextSettings;
          activeAnnotation.editingEnabled = false;
        }

        vm.scriptEditorState.activeFloatingAnnotationOrderingIndex = -1;
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex) && (vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex !== -1)) {
          var activeAnnotation = vm.currentScriptPage.floatingannotationsPersonal[vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex];
          activeAnnotation.layerid = layerid;
          delete activeAnnotation.defaultTextSettings;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;
        }

        vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex = -1;
      }
    }

    // SWA-1922 - New
    function moveHighlightAnnotationToAnotherLayer(layerid) {
      if (vm.scriptEditorState.masterLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeHighlightAnnotationOrderingIndex) && (vm.scriptEditorState.activeHighlightAnnotationOrderingIndex !== -1)) {
          var activeAnnotation = vm.currentScriptPage.highlightannotations[vm.scriptEditorState.activeHighlightAnnotationOrderingIndex];
          activeAnnotation.layerid = layerid;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;
        }

        vm.scriptEditorState.activeHighlightAnnotationOrderingIndex = -1;
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex) && (vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex !== -1)) {
          var activeAnnotation = vm.currentScriptPage.highlightannotationsPersonal[vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex];
          activeAnnotation.layerid = layerid;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;
        }

        vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex = -1;
      }
    }

    // SWA-1922 - New
    function moveFreeHandAnnotationToAnotherLayer(layerid) {
      if (vm.scriptEditorState.masterLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.selectedShapeIndex) && (vm.scriptEditorState.selectedShapeIndex !== -1)) {
          vm.drawingpad.moveShapePathToLayer(vm.scriptEditorState.selectedShapeIndex, layerid);
          var activeAnnotation = vm.currentScriptPage.shapepaths[vm.scriptEditorState.selectedShapeIndex];
          activeAnnotation.layerid = layerid;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;
        }

        vm.scriptEditorState.selectedShapeIndex = -1;
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (angular.isDefined(vm.scriptEditorState.selectedShapeIndex) && (vm.scriptEditorState.selectedShapeIndex !== -1)) {
          vm.drawingpadPersonal.moveShapePathToLayer(vm.scriptEditorState.selectedShapeIndex, layerid);
          var activeAnnotation = vm.currentScriptPage.shapepathsPersonal[vm.scriptEditorState.selectedShapeIndex];
          activeAnnotation.layerid = layerid;
          activeAnnotation.editingEnabled = false;
          vm.enableMoveAnnotationAction = false;
        }

        vm.scriptEditorState.selectedShapeIndex = -1;
      }
    }

    // SWA-1922 - New
    function moveAnnotationToLayer(layerid) {
      vm.moveAnnotationPicker.show = false;
      if (vm.scriptEditorState.masterLayerActive) {
        moveLeftAnnotationToAnotherLayer(layerid);
        moveRightAnnotationToAnotherLayer(layerid);
        moveFloatingAnnotationToAnotherLayer(layerid);
        moveHighlightAnnotationToAnotherLayer(layerid);
        moveFreeHandAnnotationToAnotherLayer(layerid);
      } else if (vm.scriptEditorState.personalLayerActive) {
        moveLeftAnnotationToAnotherLayer(layerid);
        moveRightAnnotationToAnotherLayer(layerid);
        moveFloatingAnnotationToAnotherLayer(layerid);
        moveHighlightAnnotationToAnotherLayer(layerid);
        moveFreeHandAnnotationToAnotherLayer(layerid);
      }
      toastr.success($translate.instant('messages.Annotation moved'));
      markCurrentScriptPageDirty();
      deactivateAnyActiveAnnotation();
      startAutoSetDefaultAreaStateTimer();
    }

    // SWA-1922 - New
    function updateAnnotationLayerPrompt(annotationlayer) {
      if (angular.isUndefined(annotationlayer)) {
        return;
      }

      if (angular.isUndefined(annotationlayer.contentDefaults)) {
        annotationlayer.contentDefaults = angular.copy(vm.userPreferences.contentDefaults);
      }
      var isProductionOwner = vm.activeCollaborationConfig.isProductionOwner;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/scriptEditor/annotationLayerSettingsPrompt.html',
        controller: 'AnnotationLayerSettingsPromptController',
        controllerAs: 'vm',
        size: '960',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        resolve: {
          annotationLayer: annotationlayer,
          isProductionOwner: isProductionOwner,
        }
      });
      modalInstance.result.then(
        function (params) {
          if (angular.isUndefined(params)) {
            deleteAnnotationLayerPrompt(annotationlayer);
          } else {
            updateAnnotationLayerSettings(params);
          }
        }
      );
    }

    // SWA-1922 - New
    function deleteAnnotationLayerPrompt(annotationlayer) {

      if (angular.isUndefined(annotationlayer)) {
        return;
      }
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/scriptEditor/deleteAnnotationLayerPrompt.html',
        controller: 'DeleteAnnotationLayerPromptController',
        controllerAs: 'vm',
        size: '440',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        resolve: {
          params: {
            selectedAnnotationLayer: annotationlayer,
            annotationLayers: vm.annotationlayers
          }
        }
      });
      modalInstance.result
        .then(function (params) {
          deleteOrMergeAnnotationLayer(params)
        });
    }

    // SWA-1922 - New
    function deleteOrMergeAnnotationLayer(params) {
      var deferred = $q.defer();
      blockUI.message($translate.instant('messages.Deleting Layer ...'));

      saveAllChanges()
        .then(function () {
          if (vm.scriptEditorState.personalLayerActive) {
            return dbUserScripts.removeOrMergeAnnotationLayer(vm.script._id, vm.script.productionId, params.selectedAnnotationLayer.layerid, params.mergeToLayerId);
          } else {
            return dbScripts.removeOrMergeAnnotationLayer(vm.script._id, params.selectedAnnotationLayer.layerid, params.mergeToLayerId)
          }
        })
        .then(function () {
          vm.annotationlayers = vm.annotationlayers.filter(function (item) { return item.layerid !== params.selectedAnnotationLayer.layerid });
          return saveScript();
        }).then(function () {
          return getAllData();
        }).then(function () {
          toastr.success($translate.instant('messages.Layer deleted'));
          deferred.resolve();
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error deleting layer')
          )
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });

      return deferred.promise;
    }

    // SWA-1922 - New
    function updateAnnotationLayerSettings(updatedResultData) {
      if (angular.isDefined(updatedResultData)) {
        var idx = vm.annotationlayers.findIndex(function (item) {
          return item.layerid === updatedResultData.layerid
        })
        if (vm.selectedLayer.layerid === updatedResultData.layerid) {
          loadAnnotationLayerContentDefaults(updatedResultData);
        }
        vm.annotationlayers[idx] = angular.copy(updatedResultData);
        markCurrentScriptDirty();
        saveScriptPage()
          .then(function () {
            return saveScript();
          })
          .then(function () {
            return loadScriptPageAtIndex(vm.scriptEditorState.currentPageNumber - 1);
          })
      }
    }

    /**
     * 'Go' to the given bookmark.
     * @param {ScriptBookmarkType} bookmark
     */
    function gotoBookmark(bookmark) {
      gotoPage(bookmark.scriptPageNo + 1)
        .then(function (loaded) {
          if (loaded) {
            scrollToBookmark(bookmark);
            if (!vm.scriptEditorState.bookmarkEditMode) {
              showBookmarkToast(bookmark);
            }
            vm.scriptEditorState.currentBookmark = bookmark;
          } else {
            vm.scriptEditorState.currentBookmark = undefined;
          }
        });
    }

    function scrollToBookmark(bookmark) {
      var staffContainerToSelect = $('div.sw-maincontentarea-script');
      staffContainerToSelect.mCustomScrollbar("scrollTo", bookmark.topOffset);
    }

    function showBookmarkToast(bookmark) {
      clearBookmarkToasts();

      var html = "<div class='bookmarkToastMsg' style='top:" + bookmark.topOffset + "px'>";
      html += "<div class='bookmarkToastMsg-wrapper'>";
      html += "<span class='swafont swafont-lg swafont-icon-bookmark-fill bookmark-icon'></span>";
      html += bookmark.name;
      html += "</div>";
      html += "</div>";

      $('.sw-script-pageview-container').append(html);

      $timeout(function () {
        $('.bookmarkToastMsg').css('opacity', 1);
      }, 100);

      bookmarkToastTimeoutHandle = $timeout(function () {
        $('.bookmarkToastMsg').remove();
      }, 3000);
    }

    function clearBookmarkToasts() {
      $timeout.cancel(bookmarkToastTimeoutHandle);
      $('.bookmarkToastMsg').remove();
    }

    function gotoPrevBookmark() {
      var previousBookmark = dbScripts.findBookmarkBefore(vm.sortedBookmarks, vm.scriptEditorState.currentBookmark, (vm.scriptEditorState.currentPageNumber - 1));
      if (!swaUtils.isUndefinedOrNull(previousBookmark)) {
        vm.gotoBookmark(previousBookmark);
      } else {
        toastr.warning($translate.instant('messages.no_previous_bookmark'));
      }
    }

    function gotoNextBookmark() {
      var nextBookmark = dbScripts.findBookmarkAfter(vm.sortedBookmarks, vm.scriptEditorState.currentBookmark, (vm.scriptEditorState.currentPageNumber - 1));
      if (!swaUtils.isUndefinedOrNull(nextBookmark)) {
        vm.gotoBookmark(nextBookmark);
      } else {
        toastr.warning($translate.instant('messages.no_more_bookmarks'));
      }
    }

    function gotoPage(pageNo) {
      var newPageNo = vm.scriptEditorState.currentPageNumber;
      if (pageNo === 'first') {
        if (vm.scriptEditorState.currentPageNumber !== 1) {
          newPageNo = 1;
        } else {
          return $q.resolve(true);
        }
      } else if (pageNo === 'prev') {
        if (vm.scriptEditorState.currentPageNumber > 1) {
          newPageNo--;
        } else {
          return $q.resolve(true);
        }
      } else if (pageNo === 'next') {
        if (vm.scriptEditorState.currentPageNumber < vm.scriptEditorState.totalNumberOfPages) {
          newPageNo++;
        } else {
          return $q.resolve(true);
        }
      } else if (pageNo === 'last') {
        if (vm.scriptEditorState.currentPageNumber !== vm.scriptEditorState.totalNumberOfPages) {
          newPageNo = vm.scriptEditorState.totalNumberOfPages;
        } else {
          return $q.resolve(true);
        }
      } else {
        newPageNo = parseInt(pageNo);
      }

      if (isNaN(newPageNo) || (newPageNo < 1) || (newPageNo > vm.scriptEditorState.totalNumberOfPages)) {
        return $q.resolve(false);
      }

      var deferred = $q.defer();

      if (newPageNo !== vm.scriptEditorState.currentPageNumber) {
        var loaded = false;
        blockUI.start();
        saveAllChanges()
          .then(function () {
            blockUI.message('Please wait');
            clearBookmarkToasts();
            return loadScriptPageAtIndex(newPageNo - 1);
          })
          .then(function () {
            changeTrackerInitialize();
          })
          .then(function () {
            loaded = true;
          })
          .finally(function () {
            blockUI.stop();
            deferred.resolve(loaded);
          });
      } else {
        deferred.resolve(true);
      }

      return deferred.promise;
    }

    $scope.$watch('vm.gotoPagePicker.show', function (newValue, oldValue) {
      if (newValue === true) {
        vm.gotoPagePicker.pagenumber = vm.scriptEditorState.customPageNumber;
        vm.gotoPagePicker.invalidPageNumber = false;
        $timeout(function () {
          $('input#gotopagequick').focus();
        }, 500);
      } else if (newValue === false) {
        vm.setCustomPageNumberState.enabled = false;
        if (angular.isDefined(vm.currentScriptPage)) {
          vm.scriptEditorState.customPageNumber = vm.currentScriptPage.customPageNumber;
        }
      }
    });

    $scope.$watch('vm.gotoPagePicker1.show', function (newValue, oldValue) {
      if (newValue === true) {
        vm.gotoPagePicker.pagenumber = vm.scriptEditorState.customPageNumber;
        vm.gotoPagePicker.invalidPageNumber = false;
        $timeout(function () {
          $('input#gotopagequick1').focus();
        }, 500);
      }
    });

    function gotoPageQuick() {
      vm.gotoPage(vm.gotoPagePicker.pagenumber)
        .then(function (loaded) {
          if (loaded) {
            vm.gotoPagePicker.show = false;
            vm.gotoPagePicker1.show = false;
          } else {
            vm.gotoPagePicker.invalidPageNumber = true;
          }
        });
    }

    function onSaveClick() {
      saveAllChanges();
      killAutoSetDefaultAreaStateTimer();
      updateMaincontainerAreaToDefault();
    }

    function saveAllChanges() {
      var deferred = $q.defer();

      blockUI.start();

      saveScript()
        .catch(function () {
          // ignore
        })
        .then(function () {
          return saveScriptPage();
        })
        .then(function () {
          changeTrackerInitialize();
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        })
        .finally(function () {
          blockUI.stop();
        });

      return deferred.promise;
    }

    function saveScript() {
      var deferred = $q.defer();

      if (!vm.script.dirty && !vm.script.dirtyPersonal) {
        $log.debug('saveScript: No changes, nothing to save!');
        deferred.resolve(true);
        return deferred.promise;
      }

      blockUI.start();

      // Remove new annotation layer name key from annotationlayers
      vm.annotationlayers = angular.forEach(vm.annotationlayers, function (item) {
        if (item && item.newAnnotationLayerName) {
          delete item.newAnnotationLayerName;
        }
        return item;
      });

      if (vm.activeAccessRules.allowpersonalnotes) {
        var updatedUserScript = {
          productionId: selectedProductionId,
          scriptId: vm.script._id,
          annotationlayers: angular.copy(vm.annotationlayers),
          sharedannotationlayers: angular.copy(vm.sharedannotationlayers),
          LayerIdMax: angular.isUndefined(vm.userScript) ? vm.annotationlayers.length - 1 : vm.userScript.LayerIdMax
        };

        dbUserScripts.update(selectedProductionId, vm.script._id, updatedUserScript)
          .then(function () {
            if (vm.script.dirty) {
              var updatedScript = {
                _id: vm.script._id,
                bookmarks: angular.copy(vm.bookmarks),
              };

              dbScripts.update(updatedScript)
            }
          })
          .then(function () {
            vm.script.dirty = false;
            vm.script.dirtyPersonal = false;
            vm.inlineEditIndex = -1;
            deferred.resolve(true);
          })
          .catch(function (error) {
            $log.error('ScriptEditorController.saveScript:', error);
            swaUtils.showErrorToast(
              error,
              $translate.instant('errormessages.Error saving bookmarks!')
            );

            deferred.reject(error);
          })
          .finally(function () {
            blockUI.stop();
          });
      } else {
        var updatedScript = {
          _id: vm.script._id,
          bookmarks: angular.copy(vm.bookmarks),
          annotationlayers: angular.copy(vm.annotationlayers),
          LayerIdMax: vm.script.LayerIdMax,
          startingPageNumber: vm.script.startingPageNumber ? vm.script.startingPageNumber : 1,
          allThumbnailsUpdated: vm.script.allThumbnailsUpdated,
        };

        dbScripts.update(updatedScript)
          .then(function () {
            return dbScripts.findByProduction(selectedProductionId);
          })
          .then(function (script) {
            vm.script.modified.$date = script.modified.$date;
          })
          .then(function () {
            vm.script.dirty = false;
            vm.inlineEditIndex = -1;
            deferred.resolve(true);
          })
          .catch(function (error) {
            $log.error('ScriptEditorController.saveScript:', error);
            swaUtils.showErrorToast(
              error,
              $translate.instant('errormessages.Error saving bookmarks!')
            );

            deferred.reject(error);
          })
          .finally(function () {
            blockUI.stop();
          });
      }

      return deferred.promise;
    }

    function saveScriptPage() {
      var deferred = $q.defer();

      if (angular.isUndefined(vm.currentScriptPage)) {
        deferred.resolve(true);
        return deferred.promise;
      }

      if (!vm.scriptEditorState.selectionMode) {
        deactivateAnyActiveAnnotation();
      } else {
        resetSelectedShape();
      }

      if (!(vm.script.dirty || vm.script.dirtyPersonal || vm.currentScriptPage.dirty || vm.currentScriptPage.dirtyPersonal)) {
        $log.debug('saveScriptPage: No changes, nothing to save!');
        deferred.resolve(true);
        return deferred.promise;
      }

      blockUI.start();
      ngProgressLite.start();

      var updatedScript = {};
      if (vm.script.dirty) {
        updatedScript._id = vm.script._id;
        updatedScript.bookmarks = angular.copy(vm.bookmarks);
        updatedScript.annotationlayers = angular.copy(vm.annotationlayers)
      }

      var updatedScriptPage = {};
      if (vm.currentScriptPage.dirty) {
        updatedScriptPage.leftannotations = [];
        angular.forEach(vm.currentScriptPage.leftannotations, function (annotation) {
          var textContent = $($.parseHTML(annotation.richtextcontent)).text();
          // if for exisitng pages layerid is not there - set default layer 0
          if (angular.isUndefined(annotation.layerid)) {
            annotation.layerid = 0
          }
          updatedScriptPage.leftannotations.push({
            content: textContent,
            richtextcontent: annotation.richtextcontent,
            annotationtype: annotation.annotationtype,
            orderingindex: annotation.orderingindex,
            positionrect: annotation.positionrect,
            selectionrect: annotation.selectionrect,
            backgroundColor: annotation.backgroundColor,
            backgroundColorForAnchor: annotation.backgroundColorForAnchor,
            borderColorForAnchor: annotation.borderColorForAnchor,
            markerStyle: annotation.markerStyle,
            connectingLineTop: annotation.connectingLineTop,
            annotationBorderThickness: annotation.annotationBorderThickness,
            layerid: annotation.layerid
          });
        });

        updatedScriptPage.rightannotations = [];
        angular.forEach(vm.currentScriptPage.rightannotations, function (annotation) {
          var textContent = $($.parseHTML(annotation.richtextcontent)).text();
          // if for exisitng pages layerid is not there - set default layer 0
          if (angular.isUndefined(annotation.layerid)) {
            annotation.layerid = 0
          }
          updatedScriptPage.rightannotations.push({
            content: textContent,
            richtextcontent: annotation.richtextcontent,
            annotationtype: annotation.annotationtype,
            orderingindex: annotation.orderingindex,
            positionrect: annotation.positionrect,
            selectionrect: annotation.selectionrect,
            backgroundColor: annotation.backgroundColor,
            backgroundColorForAnchor: annotation.backgroundColorForAnchor,
            borderColorForAnchor: annotation.borderColorForAnchor,
            markerStyle: annotation.markerStyle,
            connectingLineTop: annotation.connectingLineTop,
            annotationBorderThickness: annotation.annotationBorderThickness,
            layerid: annotation.layerid
          });
        });

        updatedScriptPage.floatingannotations = [];
        var newOrderingIndex = 0;
        angular.forEach(vm.currentScriptPage.floatingannotations, function (annotation) {
          var textContent = $($.parseHTML(annotation.richtextcontent)).text();
          // if for exisitng pages layerid is not there - set default layer 0
          if (angular.isUndefined(annotation.layerid)) {
            annotation.layerid = 0
          }
          if (textContent.trim().length !== 0) {
            updatedScriptPage.floatingannotations.push({
              content: textContent,
              richtextcontent: annotation.richtextcontent,
              annotationtype: annotation.annotationtype,
              orderingindex: newOrderingIndex,
              positionrect: annotation.positionrect,
              backgroundColor: annotation.backgroundColor,
              layerid: annotation.layerid,
            });
            newOrderingIndex++;
          }
        });

        updatedScriptPage.highlightannotations = [];
        var newOrderingIndex = 0;
        angular.forEach(vm.currentScriptPage.highlightannotations, function (annotation) {
          // if for exisitng pages layerid is not there - set default layer 0
          if (angular.isUndefined(annotation.layerid)) {
            annotation.layerid = 0
          }
          updatedScriptPage.highlightannotations.push({
            annotationtype: annotation.annotationtype,
            orderingindex: newOrderingIndex,
            positionrect: annotation.positionrect,
            backgroundColor: annotation.backgroundColor,
            layerid: annotation.layerid,
          });
          newOrderingIndex++;
        });

        updatedScriptPage.shapepaths = [];
        angular.forEach(vm.currentScriptPage.shapepaths, function (shapePath) {
          if (angular.isUndefined(shapePath.layerid)) {
            shapePath.layerid = 0
          }

          updatedScriptPage.shapepaths.push({
            points: shapePath.points,
            lineColor: shapePath.lineColor,
            layerid: shapePath.layerid,
            isInterpolationDone: shapePath.isInterpolationDone
          });
        });

        updatedScriptPage.chartlinks = [];
        angular.forEach(vm.currentScriptPage.chartlinks, function (link) {
          updatedScriptPage.chartlinks.push({
            selectionrect: link.selectionrect,
            chartId: link.chartId,
          });
        });

        updatedScriptPage.leftmargin = vm.currentScriptPage.leftmargin;
        updatedScriptPage.rightmargin = vm.currentScriptPage.rightmargin;
        updatedScriptPage._id = vm.currentScriptPage._id;
        updatedScriptPage.defaultThumbimage = vm.currentScriptPage.defaultThumbimage;
        updatedScriptPage.markupThumbimage = vm.currentScriptPage.markupThumbimage;
      }

      // Personal annotations layers object
      var updatedPersonalNotes = {};
      if (vm.script.dirtyPersonal) {
        updatedPersonalNotes = {
          _id: vm.script._id,
          bookmarks: angular.copy(vm.bookmarks),
          annotationlayers: angular.copy(vm.annotationlayers)
        };
      }

      // personal annotations array
      var personalNotes = {}; // variable for personal annotations
      if (vm.currentScriptPage.dirtyPersonal) {
        personalNotes.leftAnnotations = [];
        angular.forEach(vm.currentScriptPage.leftannotationsPersonal, function (annotation) {
          // if for exisitng pages layerid is not there - set default layer 0
          if (angular.isUndefined(annotation.layerid)) {
            annotation.layerid = 0
          }
          var textContent = $($.parseHTML(annotation.richtextcontent)).text();
          personalNotes.leftAnnotations.push({
            content: textContent,
            richtextcontent: annotation.richtextcontent,
            annotationtype: annotation.annotationtype,
            orderingindex: annotation.orderingindex,
            positionrect: annotation.positionrect,
            selectionrect: annotation.selectionrect,
            backgroundColor: annotation.backgroundColor,
            backgroundColorForAnchor: annotation.backgroundColorForAnchor,
            borderColorForAnchor: annotation.borderColorForAnchor,
            markerStyle: annotation.markerStyle,
            connectingLineTop: annotation.connectingLineTop,
            annotationBorderThickness: annotation.annotationBorderThickness,
            layerid: annotation.layerid,
          });
        });

        personalNotes.rightAnnotations = [];
        angular.forEach(vm.currentScriptPage.rightannotationsPersonal, function (annotation) {
          var textContent = $($.parseHTML(annotation.richtextcontent)).text();
          // if for exisitng pages layerid is not there
          if (angular.isUndefined(annotation.layerid)) {
            annotation.layerid = 0
          }
          personalNotes.rightAnnotations.push({
            content: textContent,
            richtextcontent: annotation.richtextcontent,
            annotationtype: annotation.annotationtype,
            orderingindex: annotation.orderingindex,
            positionrect: annotation.positionrect,
            selectionrect: annotation.selectionrect,
            backgroundColor: annotation.backgroundColor,
            backgroundColorForAnchor: annotation.backgroundColorForAnchor,
            borderColorForAnchor: annotation.borderColorForAnchor,
            markerStyle: annotation.markerStyle,
            connectingLineTop: annotation.connectingLineTop,
            annotationBorderThickness: annotation.annotationBorderThickness,
            layerid: annotation.layerid,
          });
        });

        personalNotes.floatingAnnotations = [];
        var newOrderingIndex = 0;
        angular.forEach(vm.currentScriptPage.floatingannotationsPersonal, function (annotation) {
          var textContent = $($.parseHTML(annotation.richtextcontent)).text();
          // if for exisitng pages layerid is not there the set default 0
          if (angular.isUndefined(annotation.layerid)) {
            annotation.layerid = 0
          }
          if (textContent.trim().length !== 0) {
            personalNotes.floatingAnnotations.push({
              content: textContent,
              richtextcontent: annotation.richtextcontent,
              annotationtype: annotation.annotationtype,
              orderingindex: newOrderingIndex,
              positionrect: annotation.positionrect,
              backgroundColor: annotation.backgroundColor,
              layerid: annotation.layerid,
            });
            newOrderingIndex++;
          }
        });

        personalNotes.highlightAnnotations = [];
        var newOrderingIndex = 0;
        angular.forEach(vm.currentScriptPage.highlightannotationsPersonal, function (annotation) {
          // if for exisitng pages layerid is not there
          if (angular.isUndefined(annotation.layerid)) {
            annotation.layerid = 0
          }
          personalNotes.highlightAnnotations.push({
            annotationtype: annotation.annotationtype,
            orderingindex: newOrderingIndex,
            positionrect: annotation.positionrect,
            backgroundColor: annotation.backgroundColor,
            layerid: annotation.layerid,
          });
          newOrderingIndex++;
        });

        personalNotes.shapepaths = [];
        angular.forEach(vm.currentScriptPage.shapepathsPersonal, function (shapePath) {
          if (angular.isUndefined(shapePath.layerid)) {
            shapePath.layerid = 0
          }
          personalNotes.shapepaths.push({
            points: shapePath.points,
            lineColor: shapePath.lineColor,
            layerid: shapePath.layerid,
            isInterpolationDone: shapePath.isInterpolationDone
          });
        });

        personalNotes._id = vm.currentScriptPage._id;
        personalNotes.markupThumbimagePersonal = vm.currentScriptPage.markupThumbimagePersonal;
        vm.personalNotes = personalNotes;
      }

      var updateCalls = [];
      if (vm.script.dirty) {
        updateCalls.push(dbScripts.update(updatedScript));
      }
      if (vm.script.dirtyPersonal) {
        updateCalls.push(dbUserScripts.update(selectedProductionId, vm.script._id, updatedPersonalNotes))
      }
      if (vm.currentScriptPage.dirty) {
        updateCalls.push(takeSnapshot());
        updateCalls.push(dbScriptPages.update(updatedScriptPage))
      }
      if (vm.currentScriptPage.dirtyPersonal) {
        updateCalls.push(takeSnapshot());
        updateCalls.push(dbUserScriptPages.update(selectedProductionId, vm.currentScriptPage._id, personalNotes))
      }
      $q.all(updateCalls)
        .then(function () {
          vm.script.dirty = false;
          vm.script.dirtyPersonal = false;
          vm.currentScriptPage.dirty = false;
          vm.currentScriptPage.dirtyPersonal = false;
          vm.setCustomMarginState.isMarginApplied = true;
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('ScriptEditorController.saveScriptPage:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving changes!')
          );

          deferred.reject(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.stop();
        });

      return deferred.promise;
    }

    function processSelectedPdfFile(filename, arrayBuffer, error) {
      if (error) {
        toastr.error(error);
        return;
      }

      vm.scriptEditorState.cancelImport = false;

      var scriptImportPdfProcessorOptions = {
        renderScale: 2.0,
        renderContainer: $('.scriptImportPreviewContainer'),
        allowedNumberOfScriptPages: vm.activePlanRules.allowedNumberOfScriptPages,
        progressCallback: onImportPdfProcessorProgress,
        completeCallback: onImportPdfProcessorComplete,
      };

      // Single page import for replace option
      if (vm.importScriptOptions.type === 1) {
        scriptImportPdfProcessorOptions.allowedNumberOfScriptPages = 1;
      }

      vm.scriptImportPdfProcessor = new ScriptImportPdfProcessor(scriptImportPdfProcessorOptions);

      ngProgressLite.start();
      blockUI.start('Processing ...');

      vm.scriptEditorState.isImporting = true;

      vm.scriptImportPdfProcessor.processPdf(arrayBuffer);
    }

    function onImportPdfProcessorProgress(progressData) {
      var processProgress = 0.7 * progressData.processed / progressData.total;
      ngProgressLite.set(0.2 + processProgress);

      blockUI.message('Processed page ' + progressData.processed + ' of ' + progressData.total);

      $timeout(function () {
        if (vm.scriptEditorState.cancelImport) {
          vm.scriptImportPdfProcessor.cancel();
        } else {
          vm.scriptImportPdfProcessor.processNextPage();
        }
      });
    }

    function onImportPdfProcessorComplete(importData, error) {
      vm.scriptEditorState.isImporting = false;

      delete vm.scriptImportPdfProcessor;

      if (vm.scriptEditorState.cancelImport) {
        toastr.warning($translate.instant('messages.Script import cancelled.'));
        return;
      }

      if (error) {
        $scope.$applyAsync(function () {
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error importing script!'));
          ngProgressLite.done();
          blockUI.reset();
        });

        return;
      }

      // saveImportedScriptData(importData);
    }

    function importScript(importType) {
      vm.importPicker.show = false;
      vm.importScriptOptions.type = importType;

      startScriptImportWorkflow();
    }

    var fetchScriptFromDbTimer;

    $scope.$watch('vm.importPicker.show', function (newVal, oldVal) {
      if (newVal === true && oldVal !== newVal) {
        fetchScriptFromDbTimer = $interval(fetchScriptFromDB, 200);
      } else if (newVal === false && fetchScriptFromDbTimer) {
        $interval.cancel(fetchScriptFromDbTimer);
        fetchScriptFromDbTimer = null;
      }
    });

    function fetchScriptFromDB() {
      var deferred = $q.defer();

      dbScripts.findByProduction(selectedProductionId)
        .then(function (script) {
          vm.fetchedScript = script;
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function startScriptImportWorkflow() {
      if (!vm.activePlanRules.allowUnlimitedScriptPages && (vm.importScriptOptions.type === 0)) {
        toastr.warning(
          $translate.instant('planprivileges.messages.A maximum of {{maxPages}} page(s) will be imported.', { maxPages: vm.activePlanRules.allowedNumberOfScriptPages }),
          $translate.instant('planprivileges.titles.Subscription Plan Limit!')
        );
      }
      if (angular.isUndefined(vm.script)) {
        blockUI.start();
        $timeout(function () {
          blockUI.stop();
          $('#scriptFileSelect').click();
        }, 500);
      } else {
        $q.when(true)
          .then(function () {
            if (vm.importScriptOptions.type === 0) {
              return showImportNewScriptConfirmationStep();
            } else if (vm.importScriptOptions.type === 1) {
              return showReplaceCurrentPageConfirmationStep();
            } else if (vm.importScriptOptions.type === 2) {
              return showInsertScriptPagesConfirmationStep();
            } else {
              throw new Error('Invalid import option');
            }
          })
          .then(function () {
            $('#scriptFileSelect').click();
          });
      }
    }

    function showImportNewScriptConfirmationStep() {
      if (vm.fetchedScript.modified.$date > vm.script.modified.$date) {
        $window.location.reload();
        $localStorage.showReloadToastr = true;
      } else {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/scriptEditor/importNewScriptConfirmationPrompt.html',
          controller: 'ImportNewScriptConfirmationPromptController',
          controllerAs: 'vm',
          size: 'sm',
          windowClass: 'sw-modal',
          backdropClass: 'sw-modal-backdrop',
        });

        return modalInstance.result;
      }

    }

    function showReplaceCurrentPageConfirmationStep() {
      if (vm.fetchedScript.modified.$date > vm.script.modified.$date) {
        $window.location.reload();
        $localStorage.showReloadToastr = true;
      } else {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/scriptEditor/replaceCurrentPageConfirmationPrompt.html',
          controller: 'ReplaceCurrentPageConfirmationPromptController',
          controllerAs: 'vm',
          size: 'sm',
          windowClass: 'sw-modal',
          backdropClass: 'sw-modal-backdrop',
        });

        return modalInstance.result;
      }

    }

    function showInsertScriptPagesConfirmationStep() {
      if (vm.fetchedScript.modified.$date > vm.script.modified.$date) {
        $window.location.reload();
        $localStorage.showReloadToastr = true;
      } else {
        var deferred = $q.defer();

        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/scriptEditor/insertScriptPagesConfirmationPrompt.html',
          controller: 'InsertScriptPagesConfirmationPromptController',
          controllerAs: 'vm',
          size: 'sm',
          windowClass: 'sw-modal',
          backdropClass: 'sw-modal-backdrop',
        });

        modalInstance.result
          .then(function (option) {
            angular.extend(vm.importScriptOptions, option);

            deferred.resolve();
          })
          .catch(function (error) {
            deferred.reject(error);
          });

        return deferred.promise;
      }
    }

    function saveImportedScriptData(importData) {
      if (angular.isUndefined(importData) || (importData.numberOfPages === 0)) {
        toastr.error($translate.instant('errormessages.No pages to import!'));
        ngProgressLite.done();
        blockUI.reset();

        return;
      }

      if (vm.importScriptOptions.type === 0) {
        importSaveNewScript(importData);
      } else if (vm.importScriptOptions.type === 1) {
        importReplaceCurrentPage(importData);
      } else if (vm.importScriptOptions.type === 2) {
        importInsertNewScriptPages(importData);
      }
    }

    function importSaveNewScript(importData) {
      toastr.info($translate.instant('messages.PDF processed'));
      ngProgressLite.done();

      blockUI.message('Saving ...');

      var newScript = angular.isUndefined(vm.script);

      unloadScriptPage()
        .then(function () {
          if (newScript) {
            var scriptObject = {
              productionId: selectedProductionId,
              numberofpages: importData.numberOfPages,
              annotationlayers: getDefaultLayers()
            }
            return dbScripts.insert(scriptObject);
          } else {
            blockUI.message('Removing old script ...');
            dbScriptPages.removeAllFromScript(vm.script._id);

            // Clear out bookmarks
            vm.bookmarks = [];
            markCurrentScriptDirty(true);

            return vm.script._id;
          }
        })
        .then(function (scriptId) {
          return insertScriptPages(scriptId, importData.pages)
        })
        .then(function () {
          if (!newScript) {
            // Save script to get rid of the bookmarks
            return saveScript();
          }
        })
        .then(function () {
          return getAllData();
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving script!')
          );
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function insertScriptPages(scriptId, scriptPages) {
      var totalPages = scriptPages.length;
      return scriptPages.reduce(function (q, scriptPage) {
        return q.then(function () {
          scriptPage.scriptId = scriptId;
          var insertQ = dbScriptPages.insert(scriptPage);
          insertQ.then(function () {
            blockUI.message('Saved page ' + (scriptPage.orderingindex + 1) + ' of ' + totalPages);
          });
          return insertQ;
        });
      }, $q.resolve());
    }

    function importReplaceCurrentPage(importData) {
      toastr.info($translate.instant('messages.PDF processed'));
      ngProgressLite.done();

      blockUI.message('Replacing ...');

      var newPage = importData.pages[0];
      newPage.scriptId = vm.script._id;

      var currentPageIndex = vm.currentScriptPage.orderingindex;
      var currentPageId = vm.currentScriptPage._id;

      unloadScriptPage()
        .then(function () {
          return dbScriptPages.replacePage(currentPageId, newPage);
        })
        .then(function () {
          return loadScriptPageAtIndex(currentPageIndex);
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error replacing page!')
          );
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function importInsertNewScriptPages(importData) {
      toastr.info($translate.instant('messages.PDF processed'));
      ngProgressLite.done();

      blockUI.message('Preparing to insert ...');

      var scriptPages = importData.pages;

      var insertAtIndex = vm.currentScriptPage.orderingindex;
      if (!vm.importScriptOptions.before) {
        insertAtIndex++;
      }

      var bookmarkPushIndex = insertAtIndex;
      var pageToOpenIndex = insertAtIndex;
      var totalPages = scriptPages.length;

      unloadScriptPage()
        .then(function () {
          var insertedPageIds = [];
          return scriptPages.reduce(function (q, scriptPage) {
            return q.then(function () {
              scriptPage.scriptId = vm.script._id;
              var insertQ = dbScriptPages.insertAtIndex(scriptPage, insertAtIndex);
              insertQ.then(function (id) {
                insertedPageIds.push(id);
                blockUI.message('Inserted page ' + insertedPageIds.length + ' of ' + totalPages);
              });
              insertAtIndex++;
              return insertQ;
            });
          }, $q.resolve());
        })
        .then(function () {
          // Update bookmark references and save script
          vm.bookmarks.forEach(function (bookmark) {
            if (bookmark.scriptPageNo >= bookmarkPushIndex) {
              bookmark.scriptPageNo += totalPages;
            }
          });
          markCurrentScriptDirty(true);

          return saveScript();
        })
        .then(function () {
          return getAllData();
        })
        .then(function () {
          return loadScriptPageAtIndex(pageToOpenIndex);
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error inserting page(s)!')
          );
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function chunkScriptUpload(dataUrl) {
      var bytes = new Uint8Array(dataUrl);

      var chunkSize = 1048576;
      var totalBytes = bytes.byteLength;

      var chunkOffsetSizes = [];
      var lastChunkOffsetSize = {
        offset: 0,
        size: chunkSize
      }
      while (true) {
        var thisChunkSize = Math.min(chunkSize, totalBytes - lastChunkOffsetSize.offset);
        if (thisChunkSize > 0) {
          lastChunkOffsetSize.size = thisChunkSize;
          chunkOffsetSizes.push(lastChunkOffsetSize);
        } else {
          break;
        }

        lastChunkOffsetSize = {
          offset: lastChunkOffsetSize.offset + lastChunkOffsetSize.size,
          size: chunkSize
        }
      };

      var totalChunks = chunkOffsetSizes.length;

      return { chunkSize: chunkSize, totalChunks: totalChunks, totalBytes: totalBytes, chunkOffsetSizes: chunkOffsetSizes };
    }

    function processPdfForUpload(scriptId, dataUrl) {
      blockUI.start('Processing PDF ...');
      var chunksData = chunkScriptUpload(dataUrl);

      // Initialize restore params
      var uploadParams = {
        chunkSize: chunksData.chunkSize,
        totalBytes: chunksData.totalBytes,
        totalchunks: chunksData.totalChunks,
        scriptId: scriptId,
      };

      return dbScripts.startUploadPdf(uploadParams)
        .then(function (jobId) {
          if (angular.isUndefined(jobId)) {
            throw new Error('Error creating upload pdf job!');
          } else {
            return { jobId: jobId, chunksData: chunksData };
          }
        })
        .then(function (data) {
          var jobId = data.jobId;
          var chunksData = data.chunksData;

          return chunksData.chunkOffsetSizes.reduce(function (q, chunkOffsetSize, i) {
            return q.then(function () {
              var fileChunk = new Uint8Array(dataUrl, chunkOffsetSize.offset, chunkOffsetSize.size);
              var chunkPayload = {
                jobId: jobId,
                chunkNumber: i,
                chunkSizeBytes: fileChunk.byteLength,
                chunkData64: bytesToBase64(fileChunk),
              }
              var uploadQ = dbScripts.uploadPdfChunk(chunkPayload)
              uploadQ.then(function (job) {
                if (job.jobStatus === 'error') {
                  throw new Error(job.error);
                } else if (job.jobStep === 'uploading') {
                  blockUI.message('Uploading ...' + Math.round(i / chunksData.totalChunks * 100) + '%');
                } else if (job.jobStep === 'uploaded') {
                  blockUI.message('Uploading ... done');
                }
              });
              return uploadQ;
            });
          }, $q.resolve());
        });
    }

    function bytesToBase64(bytes) {
      var binary = '';
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return $window.btoa(binary);
    }

    /**
    * Process selected file
    * @param {*} filename
    * @param {*} dataUrl
    * @param {*} error
    * @returns
    */
    function processSelectedPdfFileToRenderScriptAsPdf(filename, dataUrl, error) {
      var bytes = new Uint8Array(dataUrl);
      var totalBytes = bytes.byteLength;

      if (totalBytes === 0) {
        return swaUtils.showErrorToast($translate.instant('errormessages.File is Invalid'));
      }

      cancelPreloadScriptPages();
      if (error) {
        toastr.error(error);
        return;
      }

      if (vm.importScriptOptions.type === 0) {
        importSaveNewScriptAsPdf(dataUrl);
      }
      else if (vm.importScriptOptions.type === 1) {
        importReplaceCurrentPageAsPdf(dataUrl);
      }
      else if (vm.importScriptOptions.type === 2) {
        importInsertNewScriptPagesAsPdf(dataUrl);
      }

    }

    /**
     * new-> T-104
     * Save new script
     * @param {*} dataUrl
     */
    function importSaveNewScriptAsPdf(dataUrl) {
      ngProgressLite.done();

      blockUI.message('Saving ...');

      var productionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      var newScript = angular.isUndefined(vm.script);

      unloadScriptPage()
        .then(function () {
          if (newScript) {
            var scriptObject = {
              productionId: productionId,
              annotationlayers: getDefaultLayers(),
              LayerIdMax: getDefaultLayers().length - 1,
              startingPageNumber: 1,
            }
            return dbScripts.insert(scriptObject);
          } else {
            blockUI.message('Removing old script ...');
            dbScriptPages.removeAllFromScript(vm.script._id);
            vm.script.startingPageNumber = 1;

            // Clear out bookmarks
            vm.bookmarks = [];
            vm.script.allThumbnailsUpdated = false;
            markCurrentScriptDirty(true);

            return vm.script._id;
          }
        })
        .then(function (scriptId) {
          return processPdfForUpload(scriptId, dataUrl);
        })
        .then(function (uploadPromises) {
          blockUI.message('Importing new PDF ...');
          return dbScripts.runJob(uploadPromises._id);
        })
        .then(function () {
          blockUI.stop();
          if (!newScript) {
            // Save script to get rid of the bookmarks
            return saveScript();
          }
        })
        .then(function () {
          return getAllData();
        })
        .then(function () {
          return getNewPdfImportDate();
        })
        .catch(function (error) {
          loadScript();
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving script!')
          );
        })
        .finally(function () {
          toastr.info($translate.instant('messages.PDF processed'));
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function undoPdfImportPrompt() {
      if (!vm.script.allThumbnailsUpdated) {
        toastr.warning('Please wait. Thumbnails are being generated for all pages in the background.');
      } else {
        if (vm.fetchedScript.modified.$date > vm.script.modified.$date) {
          $window.location.reload();
          $localStorage.showReloadToastr = true;
        } else {
          vm.importPicker.show = false;

          var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'app/components/scriptEditor/undoPdfImportPrompt.html',
            controller: 'UndoPdfImportPromptController',
            controllerAs: 'vm',
            size: 'sm',
            windowClass: 'sw-modal sw-modal-400',
            backdropClass: 'sw-modal-backdrop',
          });
          modalInstance.result.then(undoPdfImport);
        }
      }
    }

    function undoPdfImport() {
      blockUI.start('Undo PDF Import ...');

      unloadScriptPage()
        .then(function () {
          return dbScriptPages.undoPdfImport(vm.script._id);
        })
        .then(function () {
          return saveScript();
        })
        .then(function () {
          return getAllData();
        })
        .then(function () {
          return loadScript();
        })
        .then(function () {
          blockUI.stop();
          return fetchScriptFromDB();
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error restoring PDF!')
          );
        })
        .finally(function () {
          vm.newPdfImportDate = undefined;
          toastr.info($translate.instant('messages.Previous PDF restored!'));
          blockUI.reset();
        });
    }

    function showUndoPdfImport(newPdfImportDate) {
      var currentDate = new Date();
      var savedDateObj = new Date(newPdfImportDate);
      var tenMinutesInMilliseconds = 10 * 60 * 1000;

      return (currentDate - savedDateObj) <= tenMinutesInMilliseconds;
    }

    function getNewPdfImportDate() {
      dbScriptPages.getScriptPagesArchiveDate(vm.script._id)
        .then(function (archiveDate) {
          if (angular.isDefined(archiveDate.$date)) {
            vm.newPdfImportDate = new Date(archiveDate.$date);
          }
        })
        .catch(function (error) {
        })
    }

    /**
     * new-> T-104
     * Replace script pages
     * @param {*} dataUrl
     */
    function importReplaceCurrentPageAsPdf(dataUrl) {
      ngProgressLite.done();

      blockUI.message('Replacing ...');

      var currentPageIndex = vm.currentScriptPage.orderingindex;
      var currentPageId = vm.currentScriptPage._id;

      unloadScriptPage()
        .then(function () {
          return processPdfForUpload(vm.script._id, dataUrl);
        })
        .then(function (uploadPromises) {
          blockUI.message('Replacing current page ...');
          var methodType = {
            type: 1,
            currentPageId: currentPageId,
            scriptId: vm.script._id
          }
          return dbScripts.runJob(uploadPromises._id, methodType);
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error replacing page!')
          );
        })
        .finally(function () {
          loadScriptPageAtIndex(currentPageIndex);
          toastr.info($translate.instant('messages.PDF processed'));
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    /**
     * new-> T-104
     * Insert new script pages
     * @param {*} dataUrl
     */
    function importInsertNewScriptPagesAsPdf(dataUrl) {
      ngProgressLite.done();

      blockUI.message('Preparing to insert ...');

      var customPageNumber;
      var insertAtIndex = vm.currentScriptPage.orderingindex;
      if (!vm.importScriptOptions.before) {
        var customPageNumberForAfter = vm.currentScriptPage.customPageNumber;
        insertAtIndex++;
      }

      var bookmarkPushIndex = insertAtIndex;
      var pageToOpenIndex = insertAtIndex;

      unloadScriptPage()
        .then(function () {
          return dbScriptPages.getScriptPageAtIndex(vm.script._id, insertAtIndex - 1)
        })
        .then(function (page) {
          if (vm.importScriptOptions.before) {
            if (page && page.customPageNumber) {
              customPageNumber = page.customPageNumber;
            } else {
              customPageNumber = '';
            }
          } else {
            customPageNumber = customPageNumberForAfter;
          }
          return processPdfForUpload(vm.script._id, dataUrl);
        })
        .then(function (uploadPromises) {
          blockUI.message('Inserting PDF pages ...');
          var methodType = {
            type: 2,
            // currentPageId: currentPageId,
            scriptId: vm.script._id,
            insertAtIndex: insertAtIndex,
            customPageNumber: customPageNumber,
          }
          return dbScripts.runJob(uploadPromises._id, methodType);
        })
        .then(function (totalPages) {
          // Update bookmark references and save script
          vm.bookmarks.forEach(function (bookmark) {
            if (bookmark.scriptPageNo >= bookmarkPushIndex) {
              bookmark.scriptPageNo += totalPages;
            }
          });
          markCurrentScriptDirty(true);
          vm.script.allThumbnailsUpdated = false;
          return saveScript();
        })
        .then(function () {
          return getAllData();
        })
        .then(function () {
          return loadScriptPageAtIndex(pageToOpenIndex);
        })
        .catch(function (error) {
          if (!vm.importScriptOptions.before) {
            loadScriptPageAtIndex(pageToOpenIndex - 1);
          } else {
            loadScriptPageAtIndex(pageToOpenIndex);
          }
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error inserting page(s)!')
          );
        })
        .finally(function () {
          toastr.info($translate.instant('messages.PDF processed'));
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function deleteCurrentPagePrompt() {
      if (vm.fetchedScript.modified.$date > vm.script.modified.$date) {
        $window.location.reload();
        $localStorage.showReloadToastr = true;
      } else {
        vm.importPicker.show = false;

        if (angular.isUndefined(vm.currentScriptPage)) {
          return;
        }

        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/scriptEditor/deleteScriptPagePrompt.html',
          controller: 'DeleteScriptPagePromptController',
          controllerAs: 'vm',
          size: 'sm',
          windowClass: 'sw-modal sw-modal-400',
          backdropClass: 'sw-modal-backdrop',
        });
        modalInstance.result.then(deleteCurrentScriptPage);
      }
    }

    function deleteCurrentScriptPage() {
      blockUI.start();

      var currentPageId = vm.currentScriptPage._id;
      var currentPageIndex = vm.currentScriptPage.orderingindex;
      var nextPageIndex = vm.currentScriptPage.orderingindex;
      if (nextPageIndex >= (vm.script.numberOfPages - 1)) {
        nextPageIndex--;
      }

      unloadScriptPage()
        .then(function () {
          return dbScriptPages.remove(currentPageId);
        })
        .then(function () {
          // Update bookmark references and save script
          vm.bookmarks = vm.bookmarks.filter(function (bookmark) {
            return (bookmark.scriptPageNo !== currentPageIndex);
          });

          vm.bookmarks.forEach(function (bookmark) {
            if (bookmark.scriptPageNo >= currentPageIndex) {
              bookmark.scriptPageNo -= 1;
            }
          });

          markCurrentScriptDirty(true);

          return saveScript();
        })
        .then(function () {
          return getAllData();
        })
        .then(function () {
          toastr.success($translate.instant('messages.Page deleted'));
          if (nextPageIndex > -1) {
            return loadScriptPageAtIndex(nextPageIndex);
          }
        })
        .finally(function () {
          blockUI.reset();
        });
    }

    function showHelpHints() {
      if (vm.scriptEditorState.personalLayerActive) {
        toastr.info(
          $translate.instant('messages.Markups will not be shared'),
          $translate.instant('titles.Private Script')
        );
      }
    }

    function initHelpTour() {
      vm.showHelpBar = false;
      vm.userData = DbSubMgrService.getLoggedInUserData();
      var profileDisplayHelp = false;
      if (angular.isDefined(vm.userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || vm.userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }

      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function initHelpTourSteps() {
      vm.helpTourSteps = [{
        element: '#menu-locknavigation',
        title: $translate.instant('helptour.editor.titles.menu-locknavigation'),
        content: $translate.instant('helptour.editor.messages.menu-locknavigation'),
        placement: 'bottom',
      }, {
        element: '#menu-switchview',
        title: $translate.instant('helptour.editor.titles.menu-switchview'),
        content: $translate.instant('helptour.editor.messages.menu-switchview'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptbookmarknavigationcontrols',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptbookmarknavigationcontrols'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptbookmarknavigationcontrols'),
        placement: 'bottom',
      }, {
        element: '#menu-togglebookmarklist',
        title: $translate.instant('helptour.scriptEditor.titles.menu-togglebookmarklist'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-togglebookmarklist'),
        placement: 'bottom',
      }, {
        element: '#menu-script',
        title: $translate.instant('helptour.scriptEditor.titles.menu-script'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-script'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptannotationvisibility',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptannotationsvisibility'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptannotationsvisibility'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptannotationmovelist',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptannotationmovelist'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptannotationmovelist'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptactionannotation',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptactionannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptactionannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptactionannotation-personal',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptactionannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptactionannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptlightcueannotation',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptlightcueannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptlightcueannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptlightcueannotation-personal',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptlightcueannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptlightcueannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scripttextannotation',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scripttextannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scripttextannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scripttextannotation-personal',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scripttextannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scripttextannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scripthighlightannotation',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scripthighlightannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scripthighlightannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scripthighlightannotation-personal',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scripthighlightannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scripthighlightannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptsketchpadannotation',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptsketchpadannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptsketchpadannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptsketchpadannotation-personal',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptsketchpadannotation'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptsketchpadannotation'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptundo',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptundo'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptundo'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptredo',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptredo'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptredo'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptpagenavigationcontrols',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptpagenavigationcontrols'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptpagenavigationcontrols'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptgotopage',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptgotopage'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptgotopage'),
        placement: 'bottom',
      }, {
        element: '#menu-savechanges',
        title: $translate.instant('helptour.editor.titles.menu-savechanges'),
        content: $translate.instant('helptour.editor.messages.menu-savechanges'),
        placement: 'left',
      }, {
        element: '#menu-createpdf',
        title: $translate.instant('helptour.editor.titles.menu-createpdf'),
        content: $translate.instant('helptour.editor.messages.menu-createpdf'),
        placement: 'left',
      }, {
        element: '#menu-collaborators',
        title: $translate.instant('helptour.editor.titles.menu-collaborators'),
        content: $translate.instant('helptour.editor.messages.menu-collaborators'),
        placement: 'left',
      }, {
        element: '#menu-settings',
        title: $translate.instant('helptour.editor.titles.menu-settings'),
        content: $translate.instant('helptour.editor.messages.menu-settings'),
        placement: 'left',
      }, {
        element: '#sidebar-annotationlayerlist',
        title: $translate.instant('helptour.scriptEditor.titles.sidebar-annotationlayerlist'),
        content: $translate.instant('helptour.scriptEditor.messages.sidebar-annotationlayerlist'),
        placement: 'right',
      }, {
        element: '#sidebar-scriptannotationlayersvisibility',
        title: $translate.instant('helptour.scriptEditor.titles.sidebar-scriptannotationlayersvisibility'),
        content: $translate.instant('helptour.scriptEditor.messages.sidebar-scriptannotationlayersvisibility'),
        placement: 'bottom',
      }, {
        element: '#sidebar-scriptannotationlayeradd',
        title: $translate.instant('helptour.scriptEditor.titles.sidebar-scriptannotationlayeradd'),
        content: $translate.instant('helptour.scriptEditor.messages.sidebar-scriptannotationlayeradd'),
        placement: 'bottom',
      }, {
        element: '#sidebar-layername_0_true',
        title: $translate.instant('helptour.scriptEditor.titles.sidebar-layername_0_true'),
        content: $translate.instant('helptour.scriptEditor.messages.sidebar-layername_0_true'),
        placement: 'right',
      }, {
        element: '#sidebar-scriptannotationlayervisibility_0',
        title: $translate.instant('helptour.scriptEditor.titles.sidebar-scriptannotationlayervisibility_0'),
        content: $translate.instant('helptour.scriptEditor.messages.sidebar-scriptannotationlayervisibility_0'),
        placement: 'bottom',
      }, {
        element: '#sidebar-scriptannotationlayersettings_0',
        title: $translate.instant('helptour.scriptEditor.titles.sidebar-scriptannotationlayersettings_0'),
        content: $translate.instant('helptour.scriptEditor.messages.sidebar-scriptannotationlayersettings_0'),
        placement: 'bottom',
      }, {
        element: '#sidebar-movedelete',
        title: $translate.instant('helptour.scriptEditor.titles.sidebar-movedelete'),
        content: $translate.instant('helptour.scriptEditor.messages.sidebar-movedelete'),
        placement: 'top',
      }, {
        element: '#sidebar-move_0',
        title: $translate.instant('helptour.scriptEditor.titles.sidebar-move_0'),
        content: $translate.instant('helptour.scriptEditor.messages.sidebar-move_0'),
        placement: 'right',
      }, {
        element: '#sidebar-delete_0',
        title: $translate.instant('helptour.scriptEditor.titles.sidebar-delete_0'),
        content: $translate.instant('helptour.scriptEditor.messages.sidebar-delete_0'),
        placement: 'right',
      }, {
        element: '#sidebar-done',
        title: $translate.instant('helptour.scriptEditor.titles.sidebar-done'),
        content: $translate.instant('helptour.scriptEditor.messages.sidebar-done'),
        placement: 'right',
      }, {
        element: '#button-closeproduction',
        title: $translate.instant('helptour.editor.titles.button-closeproduction'),
        content: $translate.instant('helptour.editor.messages.button-closeproduction'),
        placement: 'right',
      }, {
        element: '#button-closeproduction-layer',
        title: $translate.instant('helptour.editor.titles.button-closeproduction-layer'),
        content: $translate.instant('helptour.editor.messages.button-closeproduction-layer'),
        placement: 'right',
      }];

      vm.helpTourVideos = [{
        label: 'Importing and Editing Script',
        videoUrl: 'https://www.youtube.com/embed/_ANet-92uMc?si=IrtfWBG-TdujYw3R'
      }];
    }

    function onHelpTourStart() {
      vm.helpTourRunning = true;
    }

    function onHelpTourEnd() {
      vm.helpTourRunning = false;
    }

    function unregisterFetches() {
      dbProductions.fetchUnregister();
      dbScenes.fetchUnregister();
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        if (vm.scriptEditorState.isImporting) {
          vm.scriptEditorState.cancelImport = true;
        } else {
          deactivateAnyActiveAnnotation();
          saveAllChanges();
        }
      }
    });

    $scope.$on('$destroy', function () {
      swPdfPrintService.unregisterForChange(vm);
      unregisterFetches();
      unregisterKeyboardHandler();
      $interval.cancel(preloadTimer);
      $interval.cancel(fetchScriptFromDbTimer);
      $interval.cancel(vm.autoSetDefaultAreaState.intervalQ);
    });

    function updateCollaborationPrivileges() {
      var deferred = $q.defer();
      if (vm.activeCollaborationConfig.isProductionOwner === true) {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultOwnerAccessRules);
        }
        deferred.resolve();
      } else {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultDenyAccessRules);
        }
        var params = {
          accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
          statename: swaRouterStateNames.scripteditor,
        };

        if (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.custom) {
          params.allowscriptediting = vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.allowscriptediting;
        }

        dbCollaborationPrivileges.getCollaborationPrivileges(params)
          .then(function (privilegeData) {
            if (vm.activePlanRules.planId === 2) {
              updateActiveAccessRules({ allowpersonalnotes: privilegeData.accessrules.allowpersonalnotes });
            } else {
              updateActiveAccessRules(privilegeData.accessrules);
            }
          })
          .catch(function (error) {
            $log.error('ChartEditorController.updateCollaborationPrivileges:', error);
          })
          .finally(function () {
            deferred.resolve();
          });
      }

      return deferred.promise;
    }

    function updateActiveAccessRules(accessRules) {
      if (accessRules) {
        angular.extend(vm.activeAccessRules, accessRules);
      }
    }

    function keyboardHandler(event) {
      if (keyboardHandlerCheckTarget(event)) {
        return;
      }

      if (vm.helpTourRunning) {
        return;
      }

      // key
      var whichKey = event.which;

      // modifier keys and combos
      var ctrlKey = event.ctrlKey && !(event.altKey || event.shiftKey || event.metaKey);
      var metaKey = event.metaKey && !(event.altKey || event.shiftKey || event.ctrlKey);
      var metaShiftKey = event.metaKey && event.shiftKey && !(event.altKey || event.ctrlKey);
      var noModKey = !(event.ctrlKey || event.altKey || event.shiftKey || event.metaKey);

      // Delete or backspace, without any modifier key
      if (noModKey && ((whichKey === 8) || (whichKey === 46))) {
        keyboardHandlerHandleDelete(event);
        return;
      }

      // navigation control
      if (whichKey === 37) {
        if (ctrlKey) {
          gotoPage('first');
        } else {
          gotoPage('prev');
        }
        event.stopPropagation();
        event.preventDefault();

        return;
      } else if (whichKey === 39) {
        if (ctrlKey) {
          gotoPage('last');
        } else {
          gotoPage('next');
        }
        event.stopPropagation();
        event.preventDefault();

        return;
      }

      // Esc key
      if (whichKey === 27) {
        if (vm.scriptEditorState.lockModeNavigation) {
          toggleLockModeNavigation();
        }
        return;
      }

      // Undo/Redo
      if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
        if (whichKey === 90) {
          keyboardHandlerHandleUndo();
          return;
        } else if (whichKey === 89) {
          keyboardHandlerHandleRedo();
          return;
        }
      }

      // Redo (Mac)
      if (vm.platformMac && metaShiftKey) {
        if (whichKey === 90) {
          keyboardHandlerHandleRedo();
          return;
        }
      }
    }

    function keyboardHandlerCheckTarget(event) {
      var target = event.target;

      if (vm.scriptEditorState.lockModeNavigation) {
        return false;
      } else if ((target.nodeName === 'INPUT') || (target.nodeName === 'TEXTAREA')) {
        return true;
      } else if (vm.scriptEditorState.selectedShapeIndex > -1) {
        return false;
      } else {
        return target.attributes.contenteditable;
      }
    }

    function keyboardHandlerHandleDelete(event) {
      $log.debug('Keyboard - Delete');
      var handled = false;

      if (vm.scriptEditorState.masterLayerActive) {
        if (vm.scriptEditorState.activeLeftAnnotationOrderingIndex > -1) {
          deleteLeftAnnotation(vm.scriptEditorState.activeLeftAnnotationOrderingIndex);
          handled = true;
        } else if (vm.scriptEditorState.activeRightAnnotationOrderingIndex > -1) {
          deleteRightAnnotation(vm.scriptEditorState.activeRightAnnotationOrderingIndex);
          handled = true;
        } else if (vm.scriptEditorState.activeFloatingAnnotationOrderingIndex > -1) {
          deleteFloatingAnnotation(vm.scriptEditorState.activeFloatingAnnotationOrderingIndex);
          handled = true;
        } else if (vm.scriptEditorState.activeHighlightAnnotationOrderingIndex > -1) {
          deleteHighlightAnnotation(vm.scriptEditorState.activeHighlightAnnotationOrderingIndex);
          handled = true;
        } else if (vm.scriptEditorState.selectedShapeIndex > -1) {
          deleteSelectedSketch();
          handled = true;
        }
      } else if (vm.scriptEditorState.personalLayerActive) {
        if (vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex > -1) {
          deleteLeftAnnotation(vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex);
          handled = true;
        } else if (vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex > -1) {
          deleteRightAnnotation(vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex);
          handled = true;
        } else if (vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex > -1) {
          deleteFloatingAnnotation(vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex);
          handled = true;
        } else if (vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex > -1) {
          deleteHighlightAnnotation(vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex);
          handled = true;
        } else if (vm.scriptEditorState.selectedShapeIndex > -1) {
          deleteSelectedSketch();
          handled = true;
        }
      }

      if (handled) {
        vm.selectedAnnotation = undefined;
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Annotation deleted')
        );
      }
    }

    function keyboardHandlerHandleUndo(event) {
      if (vm.changeTracker.enabled && vm.changeTracker.canUndo) {
        $log.debug('Keyboard - Undo');
        undoAction();
      }
    }

    function keyboardHandlerHandleRedo(event) {
      if (vm.changeTracker.enabled && vm.changeTracker.canRedo) {
        $log.debug('Keyboard - Redo');
        redoAction();
      }
    }

    function registerKeyboardHandler() {
      $log.debug('ScriptEditorController: registerKeyboardHandler:');
      $(document).on('keydown', keyboardHandler);

      tryIdentifyPlatform();
    }

    function unregisterKeyboardHandler() {
      $log.debug('ScriptEditorController: unregisterKeyboardHandler:');
      $(document).off('keydown', keyboardHandler);
    }

    function tryIdentifyPlatform() {
      vm.platformMac = (navigator.platform && (navigator.platform.match(/mac/i) !== null)) || (navigator.userAgent.match(/Macintosh/i) !== null);
    }

    function toggleLockModeNavigation() {
      killAutoSetDefaultAreaStateTimer();
      updateMaincontainerAreaToDefault();
      if (vm.scriptEditorState.lockModeNavigation) {
        blockUI.start('Leaving lock mode ...');
      } else {
        blockUI.start('Enabling lock mode ...');
      }

      saveAllChanges()
        .then(function () {
          vm.scriptEditorState.lockModeNavigation = !vm.scriptEditorState.lockModeNavigation;

          if (vm.scriptEditorState.lockModeNavigation) {
            vm.scriptEditorState.activeAnnotationType = -1;
            if (vm.scriptEditorState.masterLayerActive) {
              vm.scriptEditorState.annotationsVisible = true;
            }

            if (vm.scriptEditorState.personalLayerActive) {
              vm.scriptEditorState.annotationsVisiblePersonal = true;
            }

            if (vm.scriptEditorState.bookmarkEditMode) {
              deactivateAnyActiveAnnotation();
              vm.scriptEditorState.bookmarkListVisible = true;

              vm.scriptEditorState.bookmarkEditMode = false;
              if (vm.activeAccessRules.allowpersonalnotes) {
                activatePersonalNotesLayer();
              } else {
                activateMasterNotesLayer();
              }
            }
          }

          angular.element('.sw-maincontentarea-script > .mCustomScrollBox').focus();
        })
        .finally(function () {
          blockUI.stop();
          swaUtils.stateGo(swaRouterStateNames.scripteditorbookview);
        });
    }

    vm.sideAnnotationTargetEditTracker = {
      isTracking: false,
    };

    function activateMasterNotesLayer() {
      deactivateAnyActiveAnnotation();

      scriptAnnotationsContainerElement = angular.element('.swa-script-global').get(0);

      vm.scriptEditorState.personalLayerActive = false;
      vm.scriptEditorState.masterLayerActive = true;
    }

    function activatePersonalNotesLayer() {
      deactivateAnyActiveAnnotation();

      scriptAnnotationsContainerElement = angular.element('.swa-script-personal').get(0);

      vm.scriptEditorState.masterLayerActive = false;
      vm.scriptEditorState.personalLayerActive = true;
    }

    function activateBookmarksLayer() {
      deactivateAnyActiveAnnotation();

      scriptAnnotationsContainerElement = angular.element('.swa-script-bookmark').get(0);
    }

    function activateSketchpadLayer() {
      deactivateAnyActiveAnnotation();

      scriptAnnotationsContainerElement = angular.element('.swa-script-sketchpad').get(0);
    }

    function resetLayer() {
      if (vm.activeAccessRules.allowpersonalnotes) {
        activatePersonalNotesLayer();
      } else {
        activateMasterNotesLayer();
      }
    }

    function drawingpadMasterOnChange() {
      vm.currentScriptPage.shapepaths = vm.drawingpad.getShapePaths();
      markCurrentScriptDirty();
      markCurrentScriptPageDirty();

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount > 0) {
        scriptNotifyEnableChangeTracking();
      }
      scriptNotifyDataDidChange();
    }

    function drawingpadPersonalOnChange() {
      vm.currentScriptPage.shapepathsPersonal = vm.drawingpadPersonal.getShapePaths();
      markCurrentScriptDirty();
      markCurrentScriptPageDirty();

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount > 0) {
        scriptNotifyEnableChangeTracking();
      }
      scriptNotifyDataDidChange();
    }

    function sketchpadColorChanged(color) {
      $localStorage.sketchpadSelectedColor = vm.scriptEditorState.selectedColor = color;

      if (vm.activeAccessRules.allowpersonalnotes) {
        if (angular.isDefined(vm.drawingpadPersonal)) {
          vm.drawingpadPersonal.setLineColor(color);
        }
      } else {
        if (angular.isDefined(vm.drawingpad)) {
          vm.drawingpad.setLineColor(color);
        }
      }
    }

    function clearSketchpad() {
      scriptFreehandErasePrompt();
    }

    function deleteSelectedSketch() {
      if (vm.activeAccessRules.allowpersonalnotes) {
        vm.drawingpadPersonal.removeShapePathAtIndex(vm.scriptEditorState.selectedShapeIndex);
      } else {
        vm.drawingpad.removeShapePathAtIndex(vm.scriptEditorState.selectedShapeIndex);
      }
      vm.scriptEditorState.selectedShapeIndex = -1;
      markCurrentScriptDirty();
    }

    function scriptFreehandErasePrompt() {
      if (angular.isUndefined(vm.currentScriptPage)) {
        return;
      }

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/scriptEditor/scriptFreehandErasePrompt.html',
        controller: 'ScriptFreehandErasePromptController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });
      modalInstance.result.then(scriptFreehandEraseSelectedLayer);
    }

    function scriptFreehandEraseSelectedLayer() {
      if (vm.activeAccessRules.allowpersonalnotes) {
        vm.drawingpadPersonal.clearLayer(vm.scriptEditorState.currentAnnotationLayerId);
      } else {
        vm.drawingpad.clearLayer(vm.scriptEditorState.currentAnnotationLayerId);
      }

      vm.scriptEditorState.selectedShapeIndex = -1;
      markCurrentScriptDirty();
    }

    function changeTrackerReset() {
      $log.debug('changeTrackerReset():');
      vm.changeTracker.undoStack.length = 0;
      vm.changeTracker.redoStack.length = 0;
      vm.changeTracker.lastTrackedState = undefined;
      vm.changeTracker.nextStateNumber = 0;
      vm.changeTracker.disableTrackingCount = 0;

      changeTrackerUpdateState();
    }

    function changeTrackerInitialize() {
      $log.debug('changeTrackerInitialize():');
      changeTrackerReset();

      vm.changeTracker.lastTrackedState = getCurrentScriptStateCopy();

      changeTrackerUpdateState();
    }

    function changeTrackerUpdateState() {
      $log.debug('changeTrackerUpdateState(): disable count: ', vm.changeTracker.disableTrackingCount);
      vm.changeTracker.enabled = (vm.changeTracker.disableTrackingCount === 0);

      // Trim entries if needed
      if (vm.changeTracker.undoStack.length > 50) {
        vm.changeTracker.undoStack.splice(0, vm.changeTracker.undoStack.length - 50);
      }

      $scope.$applyAsync(function () {
        vm.changeTracker.canUndo = (vm.changeTracker.undoStack.length > 0);
        vm.changeTracker.canRedo = (vm.changeTracker.redoStack.length > 0);
      });
    }

    function getCurrentScriptStateCopy() {
      var state = {
        scriptItems: [],
      };

      if (vm.scriptEditorState.masterLayerActive) {
        if (vm && vm.currentScriptPage && vm.currentScriptPage.floatingannotations) {
          state.scriptItems = state.scriptItems.concat(vm.currentScriptPage.floatingannotations);
        }
        if (vm && vm.currentScriptPage && vm.currentScriptPage.highlightannotations) {
          state.scriptItems = state.scriptItems.concat(vm.currentScriptPage.highlightannotations);
        }
        if (vm && vm.currentScriptPage && vm.currentScriptPage.leftannotations) {
          state.scriptItems = state.scriptItems.concat(vm.currentScriptPage.leftannotations);
        }
        if (vm && vm.currentScriptPage && vm.currentScriptPage.rightannotations) {
          state.scriptItems = state.scriptItems.concat(vm.currentScriptPage.rightannotations);
        }

        if (vm && vm.currentScriptPage && vm.currentScriptPage.shapepaths) {
          state.scriptItems = state.scriptItems.concat(vm.currentScriptPage.shapepaths);
        }
      }

      if (vm.scriptEditorState.personalLayerActive) {
        if (vm && vm.currentScriptPage && vm.currentScriptPage.floatingannotationsPersonal) {
          state.scriptItems = state.scriptItems.concat(vm.currentScriptPage.floatingannotationsPersonal);
        }
        if (vm && vm.currentScriptPage && vm.currentScriptPage.highlightannotationsPersonal) {
          state.scriptItems = state.scriptItems.concat(vm.currentScriptPage.highlightannotationsPersonal);
        }
        if (vm && vm.currentScriptPage && vm.currentScriptPage.leftannotationsPersonal) {
          state.scriptItems = state.scriptItems.concat(vm.currentScriptPage.leftannotationsPersonal);
        }
        if (vm && vm.currentScriptPage && vm.currentScriptPage.rightannotationsPersonal) {
          state.scriptItems = state.scriptItems.concat(vm.currentScriptPage.rightannotationsPersonal);
        }

        if (vm && vm.currentScriptPage && vm.currentScriptPage.shapepathsPersonal) {
          state.scriptItems = state.scriptItems.concat(vm.currentScriptPage.shapepathsPersonal);
        }
      }

      state.stateNumber = vm.changeTracker.nextStateNumber;

      return angular.copy(state);
    }

    function restoreScriptStateFrom(state) {
      if (vm.scriptEditorState.masterLayerActive) {
        var tempFloatingAnnotations = [];
        var tempHighlightAnnotations = [];
        var tempLeftLightCueAnnotations = [];
        var tempRightLightCueAnnotations = [];
        var tempShapepaths = [];

        state.scriptItems.forEach(function (item) {
          if (item.annotationtype == 0) {
            // Set temp left/right annotations
            if (item.side == 'right') {
              tempRightLightCueAnnotations = tempRightLightCueAnnotations.concat(item);
            } else if (item.side == 'left') {
              tempLeftLightCueAnnotations = tempLeftLightCueAnnotations.concat(item);
            }
          } else if (item.annotationtype == 1) {
            // Set temp left/right annotations
            if (item.side == 'right') {
              tempRightLightCueAnnotations = tempRightLightCueAnnotations.concat(item);
              updateRightAnnotationConnectorLines(item);
            } else if (item.side == 'left') {
              tempLeftLightCueAnnotations = tempLeftLightCueAnnotations.concat(item);
              updateLeftAnnotationConnectorLines(item);
            }
          } else if (item.annotationtype == 2) {
            // Set temp floating annotations
            tempFloatingAnnotations = tempFloatingAnnotations.concat(item);
          } else if (item.annotationtype == 3) {
            // Set temp highlight annotations
            tempHighlightAnnotations = tempHighlightAnnotations.concat(item);
          } else if (vm && vm.currentScriptPage && vm.currentScriptPage.shapepaths) {
            // Set temp shape paths
            tempShapepaths = tempShapepaths.concat(item);
          }
        });

        // Reset original annotations
        vm.currentScriptPage.floatingannotations = angular.copy(tempFloatingAnnotations);
        vm.currentScriptPage.highlightannotations = angular.copy(tempHighlightAnnotations);
        vm.currentScriptPage.leftannotations = angular.copy(tempLeftLightCueAnnotations);
        vm.currentScriptPage.rightannotations = angular.copy(tempRightLightCueAnnotations);
        vm.currentScriptPage.shapepaths = angular.copy(tempShapepaths);

        vm.drawingpad.loadShapePaths(vm.currentScriptPage.shapepaths);
      }

      if (vm.scriptEditorState.personalLayerActive) {
        var tempFloatingAnnotationsPersonal = [];
        var tempHighlightAnnotationsPersonal = [];
        var tempLeftLightCueAnnotationsPersonal = [];
        var tempRightLightCueAnnotationsPersonal = [];
        var tempShapepathsPersonal = [];

        state.scriptItems.forEach(function (item) {
          if (item.annotationtype == 0) {
            // Set temp left/right annotations
            if (item.side == 'right') {
              tempRightLightCueAnnotationsPersonal = tempRightLightCueAnnotationsPersonal.concat(item);
            } else if (item.side == 'left') {
              tempLeftLightCueAnnotationsPersonal = tempLeftLightCueAnnotationsPersonal.concat(item);
            }
          } else if (item.annotationtype == 1) {
            // Set temp left/right annotations
            if (item.side == 'right') {
              tempRightLightCueAnnotationsPersonal = tempRightLightCueAnnotationsPersonal.concat(item);
            } else if (item.side == 'left') {
              tempLeftLightCueAnnotationsPersonal = tempLeftLightCueAnnotationsPersonal.concat(item);
            }
          } else if (item.annotationtype == 2) {
            // Set temp floating annotations
            tempFloatingAnnotationsPersonal = tempFloatingAnnotationsPersonal.concat(item);
          } else if (item.annotationtype == 3) {
            // Set temp highlight annotations
            tempHighlightAnnotationsPersonal = tempHighlightAnnotationsPersonal.concat(item);
          } else if (vm && vm.currentScriptPage && vm.currentScriptPage.shapepathsPersonal) {
            // Set temp shape paths
            tempShapepathsPersonal = tempShapepathsPersonal.concat(item);
          }
        });

        // Reset original annotations
        vm.currentScriptPage.floatingannotationsPersonal = angular.copy(tempFloatingAnnotationsPersonal);
        vm.currentScriptPage.highlightannotationsPersonal = angular.copy(tempHighlightAnnotationsPersonal);
        vm.currentScriptPage.leftannotationsPersonal = angular.copy(tempLeftLightCueAnnotationsPersonal);
        vm.currentScriptPage.rightannotationsPersonal = angular.copy(tempRightLightCueAnnotationsPersonal);
        vm.currentScriptPage.shapepathsPersonal = angular.copy(tempShapepathsPersonal);

        vm.drawingpadPersonal.loadShapePaths(vm.currentScriptPage.shapepathsPersonal);
      }
    }

    /**
     * Get difference in values between 2 object
     * @param {*} obj1
     * @param {*} obj2
     * @returns
     */
    function checkDifferenceBetweenObjects(obj1, obj2) {
      var differentValues = [];
      var selectedObj = {};
      var secondObj = {};

      // Set first & second objects
      if (Object.keys(obj1).length > Object.keys(obj2).length) {
        selectedObj = obj1;
        secondObj = obj2;
      } else {
        selectedObj = obj2;
        secondObj = obj1;
      }

      // Generate different key & values between 2 objects
      Object.keys(selectedObj).forEach(function (key) {
        if (!_.isEqual(selectedObj[key], secondObj[key])) {
          if (!(key === 'editingEnabled' || key === 'isDataChanged' || key === 'side')) {
            differentValues.push(key);
          }
        } else {
          if (!Object.keys(secondObj).find(function (item) { return item === key })) {
            differentValues.push(key);
          }
        }
      });
      return differentValues;
    }

    /**
     * Get the item which is changed while undo redo
     * @param {*} objArray1
     * @param {*} objArray2
     * @returns
     */
    function getSelectedLayer(objArray1, objArray2) {

      var firstArray = [], secondArray = [];

      firstArray = angular.copy(objArray1);
      secondArray = angular.copy(objArray2);

      var layerNumberItem = undefined;
      var max = 0;
      if (firstArray.length === secondArray.length) {
        angular.forEach(firstArray, function (item, index) {
          if (checkDifferenceBetweenObjects(item, secondArray[index]).length > max) {
            max = checkDifferenceBetweenObjects(item, secondArray[index]).length;
            layerNumberItem = item;
          }
        });
      } else if (firstArray.length > secondArray.length) {
        angular.forEach(firstArray, function (item, index) {
          // For first four annotations
          if (!secondArray.find(function (annotationF) { return ((annotationF.annotationtype === item.annotationtype) && (item.orderingindex === annotationF.orderingindex)) })) {
            layerNumberItem = item;
          }
          // For free hand draw annotations
          if (angular.isDefined(item.points) && angular.isDefined(item.positionx) && angular.isDefined(item.positiony)) {
            if (!secondArray.find(function (annotationF) { return (annotationF.positionx === item.positionx) && (annotationF.positiony === item.positiony) })) {
              layerNumberItem = item;
            }
          }
        });
      } else {
        angular.forEach(secondArray, function (item, index) {

          // For first four annotations
          if (!firstArray.find(function (annotationF) { return ((annotationF.annotationtype === item.annotationtype) && (item.orderingindex === annotationF.orderingindex)) })) {
            layerNumberItem = item;
          }
          // For free hand draw annotations
          if (angular.isDefined(item.points) && angular.isDefined(item.positionx) && angular.isDefined(item.positiony)) {
            if (!firstArray.find(function (annotationF) { return (annotationF.positionx === item.positionx) && (annotationF.positiony === item.positiony) })) {
              layerNumberItem = item;
            }
          }
        });
      }

      return layerNumberItem;
    }

    function undoAction() {
      var undoState = vm.changeTracker.undoStack.pop();

      // Get updated item
      var updatedItem = getSelectedLayer(undoState.scriptItems, vm.changeTracker.lastTrackedState.scriptItems);

      if (angular.isDefined(updatedItem) && angular.isDefined(vm.hiddenAnnotationLayersList.find(function (item) { return item === updatedItem.layerid }))) {
        // Get hidden layer object which want to update
        var updatedLayer = vm.annotationlayers.find(function (item) { return item.layerid === updatedItem.layerid });

        toastr.info(
          'Changes on \'' + updatedLayer.name + '\' layer',
          'Undo - Hidden layer updated'
        );
      }

      if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
        vm.changeTracker.redoStack.push(vm.changeTracker.lastTrackedState);
      }

      vm.changeTracker.lastTrackedState = angular.copy(undoState);

      restoreScriptStateFrom(undoState);

      changeTrackerUpdateState();

    }

    function redoAction() {
      var redoState = vm.changeTracker.redoStack.pop();

      // Get updated item
      var updatedItem = getSelectedLayer(redoState.scriptItems, vm.changeTracker.lastTrackedState.scriptItems);

      if (angular.isDefined(updatedItem) && angular.isDefined(vm.hiddenAnnotationLayersList.find(function (item) { return item === updatedItem.layerid }))) {
        // Get hidden layer object which want to update
        var updatedLayer = vm.annotationlayers.find(function (item) { return item.layerid === updatedItem.layerid });

        toastr.info(
          'Changes on \'' + updatedLayer.name + '\' layer',
          'Redo - Hidden layer updated'
          // $translate.instant('messages.Updated hidden layer')
        );
      }

      if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
        vm.changeTracker.undoStack.push(vm.changeTracker.lastTrackedState);
      }

      vm.changeTracker.lastTrackedState = angular.copy(redoState);

      restoreScriptStateFrom(redoState);

      changeTrackerUpdateState();

    }

    /**
     * Toggle sidebar edit mode
     */
    function toggleSidebarEditMode() {

      if (vm.sidebarEditState.enabled === true) {
        // Back to normal mode
        vm.sidebarEditState.enabled = false;
        vm.sidebarSortableOptions.disabled = true;

        $timeout(function () {
          if ((angular.isDefined(vm.annotationlayers)) && (vm.annotationlayers.length > 0)) {
            selectAnnotationLayer(vm.annotationlayers[0]);
          }
          blockUI.stop();
        }, 0);

        if (vm.script.dirty || vm.script.dirtyPersonal) {
          return saveScript();
        }
      } else {

        vm.sidebarSortableOptions.disabled = false;
        vm.sidebarEditState.enabled = true;

        // Deselect inline edit layer
        vm.inlineEditIndex = -1;

        // Deselect inline add layer
        vm.showAddAnnotationLayerStatus = false;
        vm.newAnnotationLayerName = "";

        if (vm.script.dirty || vm.script.dirtyPersonal) {
          return saveScript();
        }
      }
    }

    /**
     * Stop the dragging of sidebar layers
     * @param {*} e
     * @param {*} ui
     */
    function sidebarDragSortStop(e, ui) {
      markCurrentScriptDirty();
    }

    /**
     * Double click on layer
     * @param {*} index
     */
    function onDoubleClick(index) {
      if (vm.activeAccessRules.allowscriptediting || vm.activeAccessRules.allowpersonalnotes) {
        vm.inlineEditIndex = index;
        vm.annotationlayers[index].newAnnotationLayerName = vm.annotationlayers[index].name;
        var inputElementName = '#editlayername_' + index;
        $timeout(function () {
          angular.element(inputElementName).focus();
        }, 100);

        // Hide add annotation
        vm.showAddAnnotationLayerStatus = false;
      }
    }

    /**
     * Update layer name
     * @param {*} annotationlayer
     * @returns
     */
    function onUpdateLayerName(annotationlayer) {
      var newAnnotationLayerName = annotationlayer.newAnnotationLayerName;
      if (newAnnotationLayerName.length === 0) {
        toastr.error($translate.instant('validationmessages.Layer name cannot be empty'));
        annotationlayer.newAnnotationLayerName = annotationlayer.name;
        return;
      }

      if (vm.scriptEditorState.masterLayerActive) {
        vm.script.dirty = true;
      }

      if (vm.scriptEditorState.personalLayerActive) {
        vm.script.dirtyPersonal = true;
      }

      vm.inlineEditIndex = -1;
      annotationlayer.name = annotationlayer.newAnnotationLayerName;

      return saveScript();
    }

    var preloadTimer = null;
    var preloadIds = [];
    function beginPreloadScriptPages() {
      if (preloadTimer) {
        $interval.cancel(preloadTimer);
      }

      preloadIds = [];
      dbScriptPages.getIdsOfPages(vm.script._id)
        .then(function (pageIds) {
          preloadIds = pageIds;
        })
        .then(function () {
          preloadTimer = $interval(preloadNextScriptPage, 500);
        })
        .catch(function (error) {
          $log.error('ScriptEditorController.beginPreloadScriptPages:', error);
        });
    }

    function preloadNextScriptPage() {
      while (preloadIds.length > 0) {
        var pageId = preloadIds.shift();
        if (!swaPdfToImage.isContentCached(pageId)) {
          $log.debug('Preloading page:', pageId);
          swaPdfToImage.getPageContentImage(pageId);
          break;
        }
      }
    }

    function cancelPreloadScriptPages() {
      if (preloadTimer) {
        $interval.cancel(preloadTimer);
        preloadTimer = null;
      }
      preloadIds = [];
      $log.debug('Preloading process cancelled.');
    }

    function moveRightAnnotationToLeftSideOfPage(indexOfAnnotation) {
      deactivateAnyActiveAnnotation();
      if (vm.scriptEditorState.masterLayerActive) {
        var annotation = vm.currentScriptPage.rightannotations[indexOfAnnotation];
        vm.currentScriptPage.rightannotations.splice(indexOfAnnotation, 1);
        reindexAnnotations(vm.currentScriptPage.rightannotations);
        annotation.side = "left";
        annotation.positionrect.left = (vm.currentScriptPage.pagewidth / 2) - (annotation.positionrect.left + annotation.positionrect.width);
        vm.currentScriptPage.leftannotations.push(annotation);
        reindexAnnotations(vm.currentScriptPage.leftannotations);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var annotation = vm.currentScriptPage.rightannotationsPersonal[indexOfAnnotation];
        vm.currentScriptPage.rightannotationsPersonal.splice(indexOfAnnotation, 1);
        reindexAnnotations(vm.currentScriptPage.rightannotationsPersonal);
        annotation.side = "left";
        annotation.positionrect.left = (vm.currentScriptPage.pagewidth / 2) - (annotation.positionrect.left + annotation.positionrect.width);
        vm.currentScriptPage.leftannotationsPersonal.push(annotation);
        reindexAnnotations(vm.currentScriptPage.leftannotationsPersonal);
      }

      updateLeftAnnotationConnectorLines(annotation);
      markCurrentScriptPageDirty();

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount > 0) {
        scriptNotifyEnableChangeTracking();
        scriptNotifyDataDidChange();
      }
    }

    function moveLeftAnnotationToRightSideOfPage(indexOfAnnotation) {
      deactivateAnyActiveAnnotation();
      if (vm.scriptEditorState.masterLayerActive) {
        var annotation = vm.currentScriptPage.leftannotations[indexOfAnnotation];
        vm.currentScriptPage.leftannotations.splice(indexOfAnnotation, 1);
        reindexAnnotations(vm.currentScriptPage.leftannotations);
        annotation.side = "right";
        annotation.positionrect.left = (vm.currentScriptPage.pagewidth / 2) - (annotation.positionrect.left + annotation.positionrect.width);
        vm.currentScriptPage.rightannotations.push(annotation);
        reindexAnnotations(vm.currentScriptPage.rightannotations);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var annotation = vm.currentScriptPage.leftannotationsPersonal[indexOfAnnotation];
        vm.currentScriptPage.leftannotationsPersonal.splice(indexOfAnnotation, 1);
        reindexAnnotations(vm.currentScriptPage.leftannotationsPersonal);
        annotation.side = "right";
        annotation.positionrect.left = (vm.currentScriptPage.pagewidth / 2) - (annotation.positionrect.left + annotation.positionrect.width);
        vm.currentScriptPage.rightannotationsPersonal.push(annotation);
        reindexAnnotations(vm.currentScriptPage.rightannotationsPersonal);
      }

      updateRightAnnotationConnectorLines(annotation);
      markCurrentScriptPageDirty();

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount > 0) {
        scriptNotifyEnableChangeTracking();
        scriptNotifyDataDidChange();
      }
    }

    function reindexAnnotations(annotations) {
      angular.forEach(annotations, function (annotation, index) {
        annotation.orderingindex = index;
      });
    }

    function snapToGridRightAnnotation(indexOfAnnotation) {
      var annotation;
      var el;

      if (vm.scriptEditorState.masterLayerActive) {
        annotation = vm.currentScriptPage.rightannotations[indexOfAnnotation];
        el = $document[0].getElementById('swa-script-annotation-right-' + indexOfAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        annotation = vm.currentScriptPage.rightannotationsPersonal[indexOfAnnotation];
        el = $document[0].getElementById('swa-script-annotation-right-personal-' + indexOfAnnotation);
      }

      var parentEl = el.parentNode;
      var bottomValue = parentEl.offsetHeight - (annotation.positionrect.top + annotation.positionrect.height);
      var initialTop = annotation.positionrect.top;
      if (annotation.annotationtype === 1) {
        if (annotation.connectingLineTop) {
          annotation.positionrect.top = annotation.selectionrect.top - annotation.positionrect.height;
        } else {
          annotation.positionrect.top = annotation.selectionrect.top + (annotation.selectionrect.height - annotation.positionrect.height);
        }
      }

      if (annotation.positionrect.top < 0) {
        annotation.positionrect.top = 0;
        toastr.warning($translate.instant('messages.Cannot move beyond page boundary.'));
      }

      bottomValue = parentEl.offsetHeight - (annotation.positionrect.top + annotation.positionrect.height);
      el.style.bottom = bottomValue + 'px';
      if (bottomValue < 0) {
        annotation.positionrect.top += bottomValue;
        el.style.bottom = 0;
        toastr.warning($translate.instant('messages.Cannot move beyond page boundary.'));
      }

      if (annotation.positionrect.top !== initialTop) {
        updateRightAnnotationConnectorLines(annotation);

        // Notify script for any change
        if (vm.changeTracker.disableTrackingCount < 1) {
          scriptNotifyDisableChangeTracking();
        }

        markCurrentScriptPageDirty();
      }
    }

    function snapToGridLeftAnnotation(indexOfAnnotation) {
      var annotation;
      var el;

      if (vm.scriptEditorState.masterLayerActive) {
        annotation = vm.currentScriptPage.leftannotations[indexOfAnnotation];
        el = $document[0].getElementById('swa-script-annotation-left-' + indexOfAnnotation);
      } else if (vm.scriptEditorState.personalLayerActive) {
        annotation = vm.currentScriptPage.leftannotationsPersonal[indexOfAnnotation];
        el = $document[0].getElementById('swa-script-annotation-left-personal-' + indexOfAnnotation);
      }

      var initialTop = annotation.positionrect.top;
      var parentEl = el.parentNode;
      var bottomValue = parentEl.offsetHeight - (annotation.positionrect.top + annotation.positionrect.height);
      if (annotation.annotationtype === 1) {
        if (annotation.connectingLineTop) {
          annotation.positionrect.top = annotation.selectionrect.top - annotation.positionrect.height;
        } else {
          annotation.positionrect.top = annotation.selectionrect.top + (annotation.selectionrect.height - annotation.positionrect.height);
        }
      }

      if (annotation.positionrect.top < 0) {
        annotation.positionrect.top = 0;
        toastr.warning($translate.instant('messages.Cannot move beyond page boundary.'));
      }

      bottomValue = parentEl.offsetHeight - (annotation.positionrect.top + annotation.positionrect.height);
      el.style.bottom = bottomValue + 'px';
      if (bottomValue < 0) {
        annotation.positionrect.top += bottomValue;
        el.style.bottom = 0;
        toastr.warning($translate.instant('messages.Cannot move beyond page boundary.'));
      }

      if (annotation.positionrect.top !== initialTop) {
        updateLeftAnnotationConnectorLines(annotation);

        // Notify script for any change
        if (vm.changeTracker.disableTrackingCount < 1) {
          scriptNotifyDisableChangeTracking();
        }

        markCurrentScriptPageDirty();
      }
    }

    function updateToolbarPosition(annotation) {
      var toolbar = $document[0].getElementById('toolbar-container');
      if (toolbar) {
        toolbar.style.position = 'absolute';
        toolbar.style.zIndex = 9999;
        toolbar.style.top = (annotation.positionrect.top - 50) + 'px';
        if (parseInt(toolbar.style.top, 10) < 0) {
          toolbar.style.top = (annotation.positionrect.top + annotation.positionrect.height + 20) + 'px';
        }
        if (annotation.side === 'right') {
          toolbar.style.left = (((vm.currentScriptPage.pagewidth / 2) + annotation.positionrect.left) + 24) + 'px';
        } else {
          toolbar.style.left = (annotation.positionrect.left + 24) + 'px';
        }
      }
    }

    function leftAnnotationAnchorBackgroundColorChanged(color) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotations[vm.scriptEditorState.activeLeftAnnotationOrderingIndex];

        activeAnnotation.backgroundColorForAnchor = swaUi.colorToRgb(color);
        vm.scriptEditorState.backgroundColorForAnchor = activeAnnotation.backgroundColorForAnchor;
        activeAnnotation.backgroundColorCssForAnchor = swaUi.getHighlightBackgroundCss(activeAnnotation.backgroundColorForAnchor);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotationsPersonal[vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex];

        activeAnnotation.backgroundColorForAnchor = swaUi.colorToRgb(color);
        vm.scriptEditorState.backgroundColorForAnchor = activeAnnotation.backgroundColorForAnchor;
        activeAnnotation.backgroundColorCssForAnchor = swaUi.getHighlightBackgroundCss(activeAnnotation.backgroundColorForAnchor);
      }


      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function leftAnnotationAnchorBorderColorChanged(color) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotations[vm.scriptEditorState.activeLeftAnnotationOrderingIndex];

        activeAnnotation.borderColorForAnchor = swaUi.colorToRgb(color);
        vm.scriptEditorState.borderColorForAnchor = activeAnnotation.borderColorForAnchor;
        if (activeAnnotation.borderColorForAnchor === 'rgba(0, 0, 0, 0)') {
          activeAnnotation.borderColorCssForAnchor = 'rgba(0, 0, 0, 0)';
        } else {
          activeAnnotation.borderColorCssForAnchor = swaUi.getAnnotationBorderCss(activeAnnotation.borderColorForAnchor);
        }
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.leftannotationsPersonal[vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex];

        activeAnnotation.borderColorForAnchor = swaUi.colorToRgb(color);
        vm.scriptEditorState.borderColorForAnchor = activeAnnotation.borderColorForAnchor;
        if (activeAnnotation.borderColorForAnchor === 'rgba(0, 0, 0, 0)') {
          activeAnnotation.borderColorCssForAnchor = 'rgba(0, 0, 0, 0)';
        } else {
          activeAnnotation.borderColorCssForAnchor = swaUi.getAnnotationBorderCss(activeAnnotation.borderColorForAnchor);
        }
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function rightAnnotationAnchorBackgroundColorChanged(color) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotations[vm.scriptEditorState.activeRightAnnotationOrderingIndex];

        activeAnnotation.backgroundColorForAnchor = swaUi.colorToRgb(color);
        vm.scriptEditorState.backgroundColorForAnchor = activeAnnotation.backgroundColorForAnchor;
        activeAnnotation.backgroundColorCssForAnchor = swaUi.getHighlightBackgroundCss(activeAnnotation.backgroundColorForAnchor);
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotationsPersonal[vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex];

        activeAnnotation.backgroundColorForAnchor = swaUi.colorToRgb(color);
        vm.scriptEditorState.backgroundColorForAnchor = activeAnnotation.backgroundColorForAnchor;
        activeAnnotation.backgroundColorCssForAnchor = swaUi.getHighlightBackgroundCss(activeAnnotation.backgroundColorForAnchor);
      }


      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function rightAnnotationAnchorBorderColorChanged(color) {
      if (vm.scriptEditorState.masterLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotations[vm.scriptEditorState.activeRightAnnotationOrderingIndex];

        activeAnnotation.borderColorForAnchor = swaUi.colorToRgb(color);
        vm.scriptEditorState.borderColorForAnchor = activeAnnotation.borderColorForAnchor;
        if (activeAnnotation.borderColorForAnchor === 'rgba(0, 0, 0, 0)') {
          activeAnnotation.borderColorCssForAnchor = 'rgba(0, 0, 0, 0)';
        } else {
          activeAnnotation.borderColorCssForAnchor = swaUi.getAnnotationBorderCss(activeAnnotation.borderColorForAnchor);
        }
      } else if (vm.scriptEditorState.personalLayerActive) {
        var activeAnnotation = vm.currentScriptPage.rightannotationsPersonal[vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex];

        activeAnnotation.borderColorForAnchor = swaUi.colorToRgb(color);
        vm.scriptEditorState.borderColorForAnchor = activeAnnotation.borderColorForAnchor;
        if (activeAnnotation.borderColorForAnchor === 'rgba(0, 0, 0, 0)') {
          activeAnnotation.borderColorCssForAnchor = 'rgba(0, 0, 0, 0)';
        } else {
          activeAnnotation.borderColorCssForAnchor = swaUi.getAnnotationBorderCss(activeAnnotation.borderColorForAnchor);
        }
      }


      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function changeAnnotationStyle(option) {
      var activeAnnotation = vm.selectedAnnotation;
      activeAnnotation.markerStyle = option === CueAnchorStyle.Marker;

      if (activeAnnotation.side === 'left') {
        updateLeftAnnotationConnectorLines(activeAnnotation);
      } else {
        updateRightAnnotationConnectorLines(activeAnnotation);
      }

      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function changeAnnotationConnectingLineStyle(option) {
      var activeAnnotation = vm.selectedAnnotation;
      activeAnnotation.connectingLineTop = option === CueAnchorStyle.ConnectingLineTop;

      if (activeAnnotation.side === 'left') {
        updateLeftAnnotationConnectorLines(activeAnnotation);
      } else {
        updateRightAnnotationConnectorLines(activeAnnotation);
      }
      // Notify script for any change
      if (vm.changeTracker.disableTrackingCount < 1) {
        scriptNotifyDisableChangeTracking();
      }

      markCurrentScriptPageDirty();
    }

    function increaseAnnotationLineThickness() {
      var activeAnnotation = vm.selectedAnnotation;
      var initialThickness = activeAnnotation.annotationBorderThickness;
      activeAnnotation.annotationBorderThickness += 1;
      if (activeAnnotation.annotationBorderThickness > 4) {
        activeAnnotation.annotationBorderThickness = 4;
      }
      if (initialThickness !== activeAnnotation.annotationBorderThickness) {
        if (activeAnnotation.side === 'left') {
          updateLeftAnnotationConnectorLines(activeAnnotation);
        } else {
          updateRightAnnotationConnectorLines(activeAnnotation);
        }

        // Notify script for any change
        if (vm.changeTracker.disableTrackingCount < 1) {
          scriptNotifyDisableChangeTracking();
        }

        markCurrentScriptPageDirty();
      }
    }

    function decreaseAnnotationLineThickness() {
      var activeAnnotation = vm.selectedAnnotation;
      var initialThickness = activeAnnotation.annotationBorderThickness;
      activeAnnotation.annotationBorderThickness -= 1;
      if (activeAnnotation.annotationBorderThickness < 1) {
        activeAnnotation.annotationBorderThickness = 1;
      }
      if (initialThickness !== activeAnnotation.annotationBorderThickness) {
        if (activeAnnotation.side === 'left') {
          updateLeftAnnotationConnectorLines(activeAnnotation);
        } else {
          updateRightAnnotationConnectorLines(activeAnnotation);
        }

        // Notify script for any change
        if (vm.changeTracker.disableTrackingCount < 1) {
          scriptNotifyDisableChangeTracking();
        }

        markCurrentScriptPageDirty();
      }
    }

    function makeCurrentPageFirst() {
      var deferred = $q.defer();

      vm.script.startingPageNumber = vm.currentScriptPage.orderingindex + 1;
      vm.gotoPagePicker.pagenumber = vm.scriptEditorState.currentPageNumber - vm.script.startingPageNumber + 1;
      vm.scriptEditorState.customPageNumber = vm.gotoPagePicker.pagenumber;
      markCurrentScriptDirty();

      blockUI.start('Making Current Page First ...');
      ngProgressLite.start();
      saveAllChanges()
        .then(function () {
          return dbScriptPages.reindexAfterMakeCurrentPageFirst(vm.script._id, vm.script.startingPageNumber);
        })
        .catch(function (error) {
          deferred.reject(error);
        })
        .finally(function () {
          vm.currentScriptPage.customPageNumber = vm.scriptEditorState.customPageNumber;
          blockUI.stop();
          ngProgressLite.done();
        });

      return deferred.promise;
    }

    function setCustomPageNumber() {
      var deferred = $q.defer();
      ngProgressLite.start();
      dbScriptPages.setCustomScriptPageNumber(vm.currentScriptPage._id, vm.scriptEditorState.customPageNumber)
        .catch(function (error) {
          deferred.reject(error);
        })
        .finally(function () {
          vm.setCustomPageNumberState.enabled = false;
          vm.gotoPagePicker.pagenumber = vm.scriptEditorState.customPageNumber;
          vm.currentScriptPage.customPageNumber = vm.scriptEditorState.customPageNumber;
          blockUI.stop();
          ngProgressLite.done();
        });

      return deferred.promise;
    }

    function showEditCustomPageNumberMenu() {
      vm.setCustomPageNumberState.enabled = true;
    }

    function hideEditCustomPageNumberMenu() {
      vm.setCustomPageNumberState.enabled = false;
      vm.scriptEditorState.customPageNumber = vm.currentScriptPage.customPageNumber;
    }

    function findAndGoToPageNoFromCustomPageNumber() {
      var deferred = $q.defer();
      var customPageNumber = vm.gotoPagePicker.pagenumber;

      ngProgressLite.start();
      dbScriptPages.findInScriptByCustomPageNumber(vm.script._id, customPageNumber, vm.currentScriptPage.orderingindex)
        .then(function (page) {
          if (angular.isDefined(page)) {
            vm.gotoPage(page.orderingindex + 1)
              .then(function (loaded) {
                if (loaded) {
                  vm.gotoPagePicker.show = false;
                  vm.gotoPagePicker1.show = false;
                } else {
                  vm.gotoPagePicker.invalidPageNumber = true;
                }
              });
          } else {
            vm.gotoPagePicker.invalidPageNumber = true;
          }
        })
        .catch(function (error) {
          vm.gotoPagePicker.invalidPageNumber = true;
          deferred.reject(error);
        })
        .finally(function () {
          blockUI.stop();
          ngProgressLite.done();
        });

      return deferred.promise;

    }

    var marginStepper = 0.25;
    var oneInchInPixels = 96;

    function updateMarginState() {
      deactivateAnyActiveAnnotation();
      killAutoSetDefaultAreaStateTimer();
      updateMaincontainerAreaToDefault();
      updateScaleFactor();
      vm.setCustomMarginState.leftSideMargin = vm.currentScriptPage.leftmargin / oneInchInPixels;
      vm.setCustomMarginState.rightSideMargin = vm.currentScriptPage.rightmargin / oneInchInPixels;
      vm.setCustomMarginState.leftMarginBeforeApply = vm.setCustomMarginState.leftSideMargin;
      vm.setCustomMarginState.rightMarginBeforeApply = vm.setCustomMarginState.rightSideMargin;
      vm.setCustomMarginState.scaleFactorBeforeApply = vm.setCustomMarginState.scaleFactor;
      vm.setCustomMarginState.oldScaleFactor = vm.setCustomMarginState.scaleFactor;
    }

    function updateScaleFactor() {
      vm.setCustomMarginState.scaleFactor = (vm.currentScriptPage.pagewidth - (vm.currentScriptPage.leftmargin + vm.currentScriptPage.rightmargin)) / vm.currentScriptPage.pagewidth;
    }

    function addLeftSideMargin() {
      scriptNotifyDisableChangeTracking();
      vm.setCustomMarginState.leftSideMargin += marginStepper;
      if (vm.setCustomMarginState.leftSideMargin > 2) {
        vm.setCustomMarginState.leftSideMargin = 2;
      }
      vm.currentScriptPage.leftmargin = vm.setCustomMarginState.leftSideMargin * oneInchInPixels;
      vm.setCustomMarginState.isMarginApplied = false;
      updateMarginCss();
      updateScaleFactor();
      markCurrentScriptPageDirty();
      scriptNotifyEnableChangeTracking();
    }

    function addRightSideMargin() {
      scriptNotifyDisableChangeTracking();
      vm.setCustomMarginState.rightSideMargin += marginStepper;
      if (vm.setCustomMarginState.rightSideMargin > 2) {
        vm.setCustomMarginState.rightSideMargin = 2;
      }
      vm.currentScriptPage.rightmargin = vm.setCustomMarginState.rightSideMargin * oneInchInPixels;
      vm.setCustomMarginState.isMarginApplied = false;
      updateMarginCss();
      updateScaleFactor();
      markCurrentScriptPageDirty();
      scriptNotifyEnableChangeTracking();
    }

    function removeLeftSideMargin() {
      scriptNotifyDisableChangeTracking();
      vm.setCustomMarginState.leftSideMargin -= marginStepper;
      if (vm.setCustomMarginState.leftSideMargin < 0) {
        vm.setCustomMarginState.leftSideMargin = 0;
      }
      vm.currentScriptPage.leftmargin = vm.setCustomMarginState.leftSideMargin * oneInchInPixels;
      vm.setCustomMarginState.isMarginApplied = false;
      updateMarginCss();
      updateScaleFactor();
      markCurrentScriptPageDirty();
      scriptNotifyEnableChangeTracking();
    }

    function removeRightSideMargin() {
      scriptNotifyDisableChangeTracking();
      vm.setCustomMarginState.rightSideMargin -= marginStepper;
      if (vm.setCustomMarginState.rightSideMargin < 0) {
        vm.setCustomMarginState.rightSideMargin = 0;
      }
      vm.currentScriptPage.rightmargin = vm.setCustomMarginState.rightSideMargin * oneInchInPixels;
      vm.setCustomMarginState.isMarginApplied = false;
      updateMarginCss();
      updateScaleFactor();
      markCurrentScriptPageDirty();
      scriptNotifyEnableChangeTracking();
    }

    function updateMarginCss() {
      var el = $document[0].getElementById('scriptPageImage');
      el.style.paddingLeft = vm.currentScriptPage.leftmargin + 'px';
      el.style.paddingRight = vm.currentScriptPage.rightmargin + 'px';
    }

    function resetMargin() {
      vm.currentScriptPage.leftmargin = vm.setCustomMarginState.leftMarginBeforeApply * oneInchInPixels;
      vm.currentScriptPage.rightmargin = vm.setCustomMarginState.rightMarginBeforeApply * oneInchInPixels;
      vm.setCustomMarginState.scaleFactor = vm.setCustomMarginState.scaleFactorBeforeApply;
      vm.setCustomMarginState.isMarginApplied = true;
      updateMarginCss();
    }

    $scope.$watch('vm.gotoMarginSetter.show', function (newVal, oldVal) {
      if (newVal === false) {
        showAllAnnotations();
        if (vm.setCustomMarginState.isMarginApplied === false) {
          toastr.warning($translate.instant('messages.apply page margin warning'));
          resetMargin();
        }
      }
      if (newVal === true) {
        hideAllAnnotations();
      }
    });

    function showAllAnnotations() {
      if (vm.scriptEditorState.masterLayerActive) {
        vm.scriptEditorState.annotationsVisible = true;
        for (var i = 0; i < vm.annotationlayers.length; i++) {
          if (vm.annotationlayers[i].isvisible) {
            vm.drawingpad.setLayerVisibility(i, true);
          } else {
            vm.drawingpad.setLayerVisibility(i, false);
          }
        }
      } else {
        vm.scriptEditorState.annotationsVisiblePersonal = true;
        for (var i = 0; i < vm.annotationlayers.length; i++) {
          if (vm.annotationlayers[i].isvisible) {
            vm.drawingpadPersonal.setLayerVisibility(i, true);
          } else {
            vm.drawingpadPersonal.setLayerVisibility(i, false);
          }
        }
      }
    }

    function hideAllAnnotations() {
      if (vm.scriptEditorState.masterLayerActive) {
        vm.scriptEditorState.annotationsVisible = false;
        for (var i = 0; i < vm.annotationlayers.length; i++) {
          vm.drawingpad.setLayerVisibility(i, false);
        }
      } else {
        vm.scriptEditorState.annotationsVisiblePersonal = false;
        for (var i = 0; i < vm.annotationlayers.length; i++) {
          vm.drawingpadPersonal.setLayerVisibility(i, false);
        }
      }
    }


    function applyMargin() {
      if (vm.setCustomMarginState.leftSideMargin === vm.setCustomMarginState.leftMarginBeforeApply && vm.setCustomMarginState.rightSideMargin === vm.setCustomMarginState.rightMarginBeforeApply) {
        return;
      }

      blockUI.start('Updating Margin ...');

      vm.currentScriptPage.leftmargin = vm.setCustomMarginState.leftSideMargin * oneInchInPixels;
      vm.currentScriptPage.rightmargin = vm.setCustomMarginState.rightSideMargin * oneInchInPixels;
      var finalScaleFactor = vm.setCustomMarginState.scaleFactor;
      var oldScaleFactor = vm.setCustomMarginState.oldScaleFactor;
      var appliedLeftmargin = vm.appliedLeftmargin;
      var leftSideMargin = vm.setCustomMarginState.leftSideMargin;

      updateMarginCss();
      updateAnnotationPosition(finalScaleFactor, oldScaleFactor, appliedLeftmargin, leftSideMargin);
      markCurrentScriptPageDirty();
      saveScriptPage()
        .then(function () {
          vm.gotoMarginSetter.show = false;
          return dbUserScriptPages.updatePersonalAnnotationPosition(vm.currentScriptPage, finalScaleFactor, oldScaleFactor, appliedLeftmargin, leftSideMargin);
        })
        .then(function () {
          vm.setCustomMarginState.isMarginApplied = true;
        })
        .catch(function (error) {
          $log.error('ScriptEditorController.applyMargin:', error);
        })
        .finally(function () {
          loadScriptPageAtIndex(vm.currentScriptPage.orderingindex);
          changeTrackerInitialize();
          vm.appliedLeftmargin = vm.currentScriptPage.leftmargin;
          toastr.success($translate.instant('messages.Margins updated.'));
          createThumbimageFromBase64(vm.currentScriptPage, true, true);
          blockUI.stop();
        });
    }

    function applyMarginToAllPages() {
      blockUI.start('Updating Margin ...');

      vm.setCustomMarginState.isMarginApplied = true;
      var leftSideMargin = vm.setCustomMarginState.leftSideMargin;
      var rightSideMargin = vm.setCustomMarginState.rightSideMargin;
      var finalScaleFactor = vm.setCustomMarginState.scaleFactor;

      dbScriptPages.applyMarginToAllPages(vm.script._id, leftSideMargin, rightSideMargin, finalScaleFactor)
        .catch(function (error) {
          $log.error('ScriptEditorController.applyMarginToAllPages:', error);
        })
        .finally(function () {
          loadScriptPageAtIndex(vm.currentScriptPage.orderingindex);
          changeTrackerInitialize();
          toastr.success($translate.instant('messages.Margins updated for all pages.'));
          blockUI.stop();
        });
    }

    function applyMarginToAllPagesPrompt() {
      vm.setCustomMarginState.isMarginApplied = true;
      vm.gotoMarginSetter.show = false;

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/scriptEditor/applyMarginToAllPagesPrompt.html',
        controller: 'ApplyMarginToAllPagesController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });
      modalInstance.result
        .then(applyMarginToAllPages)
        .catch(function () {
          if (vm.currentScriptPage.dirty) {
            vm.setCustomMarginState.isMarginApplied = false;
            toastr.warning($translate.instant('messages.apply page margin warning'));
            resetMargin();
          }
        })
    }

    function updateAnnotationPosition(finalScaleFactor, oldScaleFactor, appliedLeftmargin, leftSideMargin) {
      function scaleAnchorBox(rect) {
        rect.width = (finalScaleFactor * rect.width) / oldScaleFactor;
        rect.height = (finalScaleFactor * rect.height) / oldScaleFactor;
        rect.top = (finalScaleFactor * rect.top) / oldScaleFactor;
        rect.left = (finalScaleFactor * (rect.left - appliedLeftmargin)) / oldScaleFactor + (leftSideMargin * oneInchInPixels);
      }

      function scaleTextBoxPosition(rect) {
        rect.top = (finalScaleFactor * rect.top) / oldScaleFactor;
      }

      angular.forEach(vm.currentScriptPage.leftannotations, function (annotation) {
        scaleAnchorBox(annotation.selectionrect);
        scaleTextBoxPosition(annotation.positionrect);
        var widthLimit = (vm.currentScriptPage.pagewidth - annotation.selectionrect.width);
        var heightLimit = (vm.currentScriptPage.pageheight - annotation.selectionrect.height);
        annotation.selectionrect.left = Math.max(0, Math.min(annotation.selectionrect.left, widthLimit));
        annotation.selectionrect.top = Math.min(annotation.selectionrect.top, heightLimit);
        var heightLimitForTextbox = (vm.currentScriptPage.pageheight - annotation.positionrect.height);
        annotation.positionrect.top = Math.min(annotation.positionrect.top, heightLimitForTextbox);
        updateLeftAnnotationConnectorLines(annotation);
      });

      angular.forEach(vm.currentScriptPage.rightannotations, function (annotation) {
        scaleAnchorBox(annotation.selectionrect);
        scaleTextBoxPosition(annotation.positionrect);
        var widthLimit = (vm.currentScriptPage.pagewidth - annotation.selectionrect.width);
        var heightLimit = (vm.currentScriptPage.pageheight - annotation.selectionrect.height);
        annotation.selectionrect.left = Math.max(0, Math.min(annotation.selectionrect.left, widthLimit));
        annotation.selectionrect.top = Math.min(annotation.selectionrect.top, heightLimit);
        var heightLimitForTextbox = (vm.currentScriptPage.pageheight - annotation.positionrect.height);
        annotation.positionrect.top = Math.min(annotation.positionrect.top, heightLimitForTextbox);
        updateRightAnnotationConnectorLines(annotation);
      });

      angular.forEach(vm.currentScriptPage.floatingannotations, function (annotation) {
        scaleAnchorBox(annotation.positionrect);
        var widthLimit = (vm.currentScriptPage.pagewidth - annotation.positionrect.width);
        var heightLimit = (vm.currentScriptPage.pageheight - annotation.positionrect.height);
        annotation.positionrect.left = Math.max(0, Math.min(annotation.positionrect.left, widthLimit));
        annotation.positionrect.top = Math.min(annotation.positionrect.top, heightLimit);
      });

      angular.forEach(vm.currentScriptPage.highlightannotations, function (annotation) {
        scaleAnchorBox(annotation.positionrect);
        var widthLimit = (vm.currentScriptPage.pagewidth - annotation.positionrect.width);
        var heightLimit = (vm.currentScriptPage.pageheight - annotation.positionrect.height);
        annotation.positionrect.left = Math.max(0, Math.min(annotation.positionrect.left, widthLimit));
        annotation.positionrect.top = Math.min(annotation.positionrect.top, heightLimit);
      });

      angular.forEach(vm.currentScriptPage.shapepaths, function (shapepath) {
        angular.forEach(shapepath.points, function (point) {
          point.x = (finalScaleFactor * (point.x - appliedLeftmargin)) / oldScaleFactor + (leftSideMargin * oneInchInPixels);
          point.y = (finalScaleFactor * point.y) / oldScaleFactor;
          point.x = Math.max(0, Math.min(point.x, vm.currentScriptPage.pagewidth));
          point.y = Math.min(point.y, vm.currentScriptPage.pageheight);
        });
      });

      angular.forEach(vm.currentScriptPage.chartlinks, function (link) {
        link.selectionrect.top = (finalScaleFactor * link.selectionrect.top) / oldScaleFactor;
        link.selectionrect.height = (finalScaleFactor * link.selectionrect.height) / oldScaleFactor;
      })
    }

    function loadScriptPageFromIndex(index) {
      saveAllChanges()
        .then(function () {
          return loadScriptPageAtIndex(index);
        })
        .then(function () {
          changeTrackerInitialize();
        })
    }

    function toggleRightSideBar() {
      if (vm.thumbnailBarState.rightSideBar) {
        vm.thumbnailBarState.rightSideBar = false;
      } else {
        vm.thumbnailBarState.rightSideBar = true;
        vm.thumbnailBarState.bottomSideBar = false;
        $timeout(function () {
          vm.scrollUpdateSidebar('scrollTo', $('#pageid-' + vm.currentScriptPage.orderingindex).position().top);
        }, 500);
      }
    }

    function toggleBottomSideBar() {
      if (vm.thumbnailBarState.bottomSideBar) {
        vm.thumbnailBarState.bottomSideBar = false;
      } else {
        vm.thumbnailBarState.bottomSideBar = true;
        vm.thumbnailBarState.rightSideBar = false;

        $timeout(function () {
          vm.scrollUpdateBottombar('scrollTo', '#pageid-h-' + vm.currentScriptPage.orderingindex);
        });
      }
    }

    function getScriptPagesAndUserScriptPages() {
      dbScriptPages.getScriptPagesByScript(vm.script._id)
        .then(function (pages) {
          vm.scriptPages = pages;

          if (!vm.script.allThumbnailsUpdated && (vm.script.numberOfPages > 0)) {
            toastr.info('Thumbnails are being generated for all pages in the background.');
            var pagesToUpdate = vm.scriptPages.filter(function (page) {
              return angular.isUndefined(page.defaultThumbimage);
            });

            pagesToUpdate.reduce(function (promiseChain, page) {
              return promiseChain.then(function () {
                return createThumbimageFromBase64(page);
              });
            }, $q.resolve())
              .then(function () {
                vm.script.allThumbnailsUpdated = true;
                // dbScripts.update(vm.script);
              })
              .catch(function (error) {
                $log.error('Error during sequential thumbnail creation:', error);
              })
              .finally(function () {
                toastr.success('Successfully generated thumbnails for all pages.');
                blockUI.stop();
              })
          }

          if (vm.activeAccessRules.allowpersonalnotes) {
            angular.forEach(vm.scriptPages, function (page) {
              dbUserScriptPages.getForScriptPage(page._id)
                .then(function (personalNotes) {
                  if (angular.isDefined(personalNotes)) {
                    var scriptPage = _.findWhere(vm.scriptPages, { _id: personalNotes.scriptPageId });
                    scriptPage.markupThumbimagePersonal = personalNotes.markupThumbimagePersonal;
                  }
                })
            });
          }
        })
        .catch(function (error) {
          $log.error('ScriptEditorController.getScriptPagesByScript:', error);
        });
    }

    function takeSnapshot() {
      var deferred = $q.defer();
      var sourceDiv = $document[0].getElementById('swScriptPageviewContainer');
      var computedStyle = $window.getComputedStyle(sourceDiv);

      var paddingLeft = parseInt(computedStyle.paddingLeft, 10);
      var paddingTop = parseInt(computedStyle.paddingTop, 10);
      var paddingRight = parseInt(computedStyle.paddingRight, 10);
      var paddingBottom = parseInt(computedStyle.paddingBottom, 10);

      var contentWidth = sourceDiv.offsetWidth - paddingLeft - paddingRight;
      var contentHeight = sourceDiv.offsetHeight - paddingTop - paddingBottom;

      vm.loadingThumbnail = true;

      html2canvas(sourceDiv, {
        scale: 0.5,
        useCORS: true,
        allowTaint: false,
        x: paddingLeft,
        y: paddingTop,
        width: contentWidth,
        height: contentHeight,
        backgroundColor: null,
        removeContainer: true,
        ignoreElements: function (element) {
          return element.id === 'swaScriptPageContent' || element.id === 'lockedOrStalkerIcon';
        }
      }).then(function (canvas) {
        var imageBase64 = canvas.toDataURL('image/png').substring(22);
        if (angular.isDefined(vm.currentScriptPage)) {
          if (vm.scriptEditorState.masterLayerActive) {
            vm.currentScriptPage.markupThumbimage = imageBase64;
            var existingPage = _.findWhere(vm.scriptPages, { orderingindex: vm.currentScriptPage.orderingindex });
            if (existingPage) existingPage.markupThumbimage = imageBase64;
            var cleanScriptPage = angular.copy(vm.currentScriptPage);
            dbScriptPages.update(cleanScriptPage).then(function () {
              deferred.resolve();
            }).catch(function (error) {
              $log.error('ScriptEditorController.takeSnapshot (dbScriptPages.update):', error);
              deferred.reject(error);
            });
          } else {
            vm.currentScriptPage.markupThumbimagePersonal = imageBase64;
            var existingPage = _.findWhere(vm.scriptPages, { _id: vm.currentScriptPage._id });
            if (existingPage) existingPage.markupThumbimagePersonal = imageBase64;
            if (vm.personalNotes) vm.personalNotes.markupThumbimagePersonal = imageBase64;
            var cleanPersonalNotes = angular.copy(vm.personalNotes);
            dbUserScriptPages.update(selectedProductionId, vm.currentScriptPage._id, cleanPersonalNotes).then(function () {
              deferred.resolve();
            }).catch(function (error) {
              $log.error('ScriptEditorController.takeSnapshot (dbUserScriptPages.update):', error);
              deferred.reject(error);
            });
          }
        } else {
          deferred.resolve();
        }
      }).catch(function (error) {
        $log.error('ScriptEditorController.takeSnapshot:', error);
        deferred.reject(error);
      }).finally(function () {
        vm.loadingThumbnail = false;
      });
      return deferred.promise;
    }


    function createThumbimageFromBase64(page, updateAfterApplyMargin, takeSnapshotApplyMargin) {
      var deferred = $q.defer();
      var updateAfterApplyMargin = updateAfterApplyMargin || false;
      var takeSnapshotApplyMargin = takeSnapshotApplyMargin || false;
      swaPdfToImage.getPageContentImage(page._id)
        .then(function (imageBase64) {
          return loadImage(imageBase64);
        })
        .then(function (img) {
          var scaleFactor = vm.setCustomMarginState.scaleFactor;
          var left = page.leftmargin ? page.leftmargin : 0;
          var tmpCanvas = $document[0].createElement('canvas');
          tmpCanvas.width = page.pagewidth / 4;
          tmpCanvas.height = page.pageheight / 4;

          var ctx = tmpCanvas.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.mozImageSmoothingEnabled = true;
          ctx.webkitImageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.fillStyle = 'rgba(255, 255, 255, 1)';
          ctx.fillRect(0, 0, tmpCanvas.width, tmpCanvas.height);
          var width = tmpCanvas.width * scaleFactor;
          var height = tmpCanvas.height * scaleFactor;
          ctx.drawImage(img, left / 4, 0, width, height);

          var base64Thumb = tmpCanvas.toDataURL('image/png').substring(22);
          page.defaultThumbimage = base64Thumb;
          if (updateAfterApplyMargin) {
            vm.currentScriptPage.defaultThumbimage = base64Thumb;

            var existingPage = _.findWhere(vm.scriptPages, {
              orderingindex: vm.currentScriptPage.orderingindex
            });

            if (existingPage) {
              existingPage.defaultThumbimage = base64Thumb;
            }

            if (takeSnapshotApplyMargin) {
              takeSnapshot();
            }
          }
          var cleanScriptPage = angular.copy(page);
          dbScriptPages.update(cleanScriptPage);
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('ScriptEditorController.createThumbimageFromBase64:', error);
          deferred.reject(error);
        })
      return deferred.promise;
    }

    function loadImage(base64) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          resolve(img);
        };
        img.onerror = function (err) {
          reject('Failed to load base64 image: ' + err);
        };
        img.src = 'data:image/png;base64,' + base64.substring(22);
      });
    }

    function changeActionAnnotationType() {
      var deferred = $q.defer();
      ngProgressLite.start();

      dbScriptPages.changeActionAnnotationType(vm.script._id)
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('ScriptEditorController.changeActionAnnotationType:', error);
          deferred.reject(error);
        })
        .finally(function () {
          ngProgressLite.done();
        });

      return deferred.promise;
    }

    function deleteAnnotation() {
      var fakeEvent = {
        stopPropagation: function () { },
        preventDefault: function () { }
      };

      keyboardHandlerHandleDelete(fakeEvent);
    }

    function snapToGridAnnotation() {
      var isMaster = vm.scriptEditorState.masterLayerActive;
      var side = vm.selectedAnnotation.side;

      if (side === 'left') {
        snapToGridLeftAnnotation(isMaster ? vm.scriptEditorState.activeLeftAnnotationOrderingIndex : vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex);
      } else if (side === 'right') {
        snapToGridRightAnnotation(isMaster ? vm.scriptEditorState.activeRightAnnotationOrderingIndex : vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex);
      }
    }

    function moveToOtherSide() {
      var isMaster = vm.scriptEditorState.masterLayerActive;
      var side = vm.selectedAnnotation.side;

      if (side === 'left') {
        moveLeftAnnotationToRightSideOfPage(isMaster ? vm.scriptEditorState.activeLeftAnnotationOrderingIndex : vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex);
      } else if (side === 'right') {
        moveRightAnnotationToLeftSideOfPage(isMaster ? vm.scriptEditorState.activeRightAnnotationOrderingIndex : vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex);
      }
    }

    function anchorBackgroundColorChanged(color) {
      if (vm.selectedAnnotation.side === 'left') {
        leftAnnotationAnchorBackgroundColorChanged(color);
      } else if (vm.selectedAnnotation.side === 'right') {
        rightAnnotationAnchorBackgroundColorChanged(color);
      }
    }

    function anchorBorderColorChanged(color) {
      if (vm.selectedAnnotation.side === 'left') {
        leftAnnotationAnchorBorderColorChanged(color);
      } else if (vm.selectedAnnotation.side === 'right') {
        rightAnnotationAnchorBorderColorChanged(color);
      }
    }

    function updateMaincontainerArea() {
      var el = $document[0].getElementById('swMaincontentAreaScript');
      el.style.transition = 'all 0.3s ease 0s';
      if (angular.isDefined(vm.selectedAnnotation)) {
        el.style.top = '102px';
        el.style.height = 'calc(100% - 104px)';
      }
    }

    function updateMaincontainerAreaToDefault() {
      var el = $document[0].getElementById('swMaincontentAreaScript');
      el.style.transition = 'all 0.3s ease 0s';
      el.style.top = '52px';
      el.style.height = 'calc(100% - 54px)';
    }

    function killAutoSetDefaultAreaStateTimer() {
      $interval.cancel(vm.autoSetDefaultAreaState.intervalQ);
      vm.autoSetDefaultAreaState.intervalQ = undefined;

      vm.autoSetDefaultAreaState.timerActive = false;
      vm.autoSetDefaultAreaState.timeoutRemainingSec = 0;
    }

    function startAutoSetDefaultAreaStateTimer() {
      if (angular.isDefined(vm.autoSetDefaultAreaState.intervalQ)) {
        vm.autoSetDefaultAreaState.timeoutRemainingSec = vm.autoSetDefaultAreaState.timeoutMaxSec;
        return;
      }
      vm.autoSetDefaultAreaState.timeoutRemainingSec = vm.autoSetDefaultAreaState.timeoutMaxSec;
      vm.autoSetDefaultAreaState.intervalQ = $interval(function () {
        if (angular.isDefined(vm.selectedAnnotation)) {
          killAutoSetDefaultAreaStateTimer();
        }
        vm.autoSetDefaultAreaState.timeoutRemainingSec -= (vm.autoSetDefaultAreaState.timeoutDecaySec);
        if (vm.autoSetDefaultAreaState.timeoutRemainingSec <= 0) {
          killAutoSetDefaultAreaStateTimer();
          updateMaincontainerAreaToDefault();
        }
      }, vm.autoSetDefaultAreaState.timeoutPollIntervalSec * 1000);
      vm.autoSetDefaultAreaState.timerActive = true;
    }

    function updateSharedAnnotationLayers() {
      if (vm.userScript && angular.isArray(vm.userScript.sharedannotationlayers)) {
        if (vm.script && angular.isArray(vm.script.annotationlayers)) {
          var scriptLayerIds = vm.script.annotationlayers.map(function (layer) { return layer.layerid; });
          vm.userScript.sharedannotationlayers = vm.userScript.sharedannotationlayers.filter(function (layer) {
            return scriptLayerIds.indexOf(layer.layerid) !== -1;
          });

          var sharedIds = vm.userScript.sharedannotationlayers.map(function (layer) { return layer.layerid; });
          var additionalLayers = vm.script.annotationlayers.filter(function (layer) {
            return layer.isShared === true && sharedIds.indexOf(layer.layerid) === -1;
          });

          vm.userScript.sharedannotationlayers.forEach(function (layer) {
            var scriptLayer = vm.script.annotationlayers.find(function (sl) { return sl.layerid === layer.layerid; });
            if (scriptLayer && scriptLayer.isShared === true && angular.isString(scriptLayer.name) && layer.name !== scriptLayer.name) {
              layer.name = scriptLayer.name;
            }
          });

          vm.userScript.sharedannotationlayers = vm.userScript.sharedannotationlayers.filter(function (layer) {
            var scriptLayer = vm.script.annotationlayers.find(function (sl) { return sl.layerid === layer.layerid; });
            return !(scriptLayer && scriptLayer.isShared === false);
          });

          vm.sharedannotationlayers = vm.userScript.sharedannotationlayers.concat(additionalLayers);
        }
      } else {
        if (vm.script && angular.isArray(vm.script.annotationlayers)) {
          vm.sharedannotationlayers = vm.script.annotationlayers.filter(function (layer) {
            return layer.isShared === true;
          });
        }

        vm.sharedannotationlayers.forEach(function (layer) {
          if (angular.isUndefined(layer.isVisibleToCollaborators)) {
            layer.isVisibleToCollaborators = true;
          }
        });
      }

      var scriptLayerOrder = vm.script.annotationlayers.map(function (layer) { return layer.layerid; });
      vm.sharedannotationlayers = vm.sharedannotationlayers.sort(function (a, b) {
        return scriptLayerOrder.indexOf(a.layerid) - scriptLayerOrder.indexOf(b.layerid);
      });
    }
  }
}());

/* global tinymce */
(function () {
  'use strict';

  angular
    .module('swanywhere')
    .directive('swaAnnotationEditor', ['swaUi', '$timeout', SwaAnnotationEditor]);

  function SwaAnnotationEditor(swaUi, $timeout) {
    var directive = {
      restrict: 'A',
      scope: {
        dataAnnotation: '=swaAnnotation',
        triggerChange: '&onChange',
        dataScriptEditor: '=swaScriptEditor'
      },
      link: linkFunction
    };

    return directive;

    function linkFunction(scope, element, attrs) {
      scope.tinymceEditor = undefined;

      scope.$watch('dataAnnotation.editingEnabled', function (newVal, oldVal) {
        if (angular.isUndefined(newVal)) {
          return;
        }

        if (newVal) {
          initRichTextEditor();
        } else if (oldVal) {
          updateDataRichText();
          deinitRichTextEditor();
        }
      });

      scope.$on('$destroy', function () {
        deinitRichTextEditor();
      });

      function updateDataRichText() {

        // Reset data changed flag
        scope.dataAnnotation.isDataChanged = false;

        if (angular.isDefined(scope.tinymceEditor)) {
          if (scope.tinymceEditor.isDirty()) {
            var newContent = scope.tinymceEditor.getContent();

            newContent = newContent.replaceAll('&#65279;', '');

            if (scope.dataAnnotation.richtextcontent !== newContent) {
              scope.dataAnnotation.richtextcontent = newContent;

              // Set data changed flag
              scope.dataAnnotation.isDataChanged = true;
            }
          }
        } else {
          scope.dataAnnotation.richtextcontent = element.html();
        }
        scope.triggerChange();
        adjustContainerHeight();
      }

      // scope.$watch('dataAnnotation', function(newVal, oldVal) {
      //   if (angular.isUndefined(newVal)) {
      //     return;
      //   }

      //   if (newVal) {
      //     element.html(newVal.richtextcontent || '');
      //   }
      // });

      element.html(scope.dataAnnotation.richtextcontent || '');

      function initRichTextEditor() {
        var id = element.attr('id');
        var existingEditor = tinymce.get(id);
        if (existingEditor !== null) { // eslint-disable-line angular/definedundefined
          return true;
        }

        var initOptions = {
          selector: '#' + id,
          inline: true,
          inline_styles: true,
          forced_root_block: 'div',
          invalid_elements: 'strong,em',
          force_hex_style_colors: true,
          entity_encoding: 'numeric',
          height: 100,
          plugins: [
            'textcolor',
            'paste'
          ],
          paste_as_text: false,
          fixed_toolbar_container: '#toolbar-container',
          toolbar1: "bold italic underline forecolor | fillcolor | arrowup | arrowdown ",
          toolbar2: "fontselect | fontsizeselect",
          font_formats: 'Liberation Sans=Liberation Sans;Liberation Mono=Liberation Mono;Liberation Serif=Liberation Serif',
          fontsize_formats: '10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 31px 32px 33px 34px 35px 36px 37px 38px 39px 40px 41px 42px 43px 44px 45px 46px 47px 48px 49px 50px 51px 52px 53px 54px 55px 56px 57px 58px 59px 60px 61px 62px 63px 64px 65px 66px 67px 68px 69px 70px 71px 72px',
          menubar: false,
          // toolbar_items_size: 'small',
          formats: {
            bold: {
              inline: 'span',
              styles: {
                'font-weight': 'bold'
              }
            },
            italic: {
              inline: 'span',
              styles: {
                'font-style': 'italic'
              }
            },
            underline: {
              inline: 'span',
              styles: {
                'text-decoration': 'underline'
              }
            },
          },
          textcolor_cols: 5,
          textcolor_rows: 6,
          textcolor_map: swaUi.textColorMap,
          setup: function (editor) {
            editor.on('blur', function (e) {
              updateDataRichText();
            });
            editor.on('init', function (e) {
              scope.dataAnnotation.minimumHeightOfAnnotation = scope.dataAnnotation.positionrect.height;
              scope.dataAnnotation.initialTopOfAnnotation = scope.dataAnnotation.positionrect.top;
              scope.tinymceEditor = e.target;
              updateToolbarPosition();
              adjustContainerHeight();
              if (angular.isDefined(scope.dataAnnotation.defaultTextSettings)) {
                scope.tinymceEditor.selection.select(scope.tinymceEditor.getBody(), true);
                var defaultTextSettings = scope.dataAnnotation.defaultTextSettings;
                if (defaultTextSettings.bold) {
                  scope.tinymceEditor.execCommand('Bold');
                }
                if (defaultTextSettings.italic) {
                  scope.tinymceEditor.execCommand('Italic');
                }
                if (defaultTextSettings.underline) {
                  scope.tinymceEditor.execCommand('Underline');
                }
                scope.tinymceEditor.execCommand('ForeColor', false, defaultTextSettings.fontColor);
                scope.tinymceEditor.execCommand('FontSize', false, defaultTextSettings.fontSize + 'px');
                scope.tinymceEditor.execCommand('FontName', false, defaultTextSettings.fontFamily);
                scope.tinymceEditor.selection.collapse(false);

                backgroundColorChanged(defaultTextSettings.fillColor)

                $timeout(function () {
                  scope.tinymceEditor.focus();
                }, 200);
              }
            });
            editor.on('PostProcess', function (e) {
              e.content = e.content.replace('&#65279;', '');
            });
            editor.addButton('fillcolor', {
              icon: 'fill',
              tooltip: 'Fill Color',
              onpostrender: setupEditorFillColorButton
            });
            editor.addButton('arrowup', {
              text: '↑',
              tooltip: 'Arrow up icon',
              onclick: function () {
                editor.insertContent('<span>↑</span>');
                adjustContainerHeight();
              }
            });
            editor.addButton('arrowdown', {
              text: '↓',
              tooltip: 'Arrow down icon',
              onclick: function () {
                editor.insertContent('<span>↓</span>');
                adjustContainerHeight();
              }
            });
            editor.on('input', function () {
              adjustContainerHeight();
              updateToolbarPosition();
            });

            editor.on('keyup', function () {
              adjustContainerHeight();
              updateToolbarPosition();
            });
            editor.on('execCommand', function (e) {
              if (e.command === 'FontSize' || e.command === 'Underline' || e.command === 'Italic' || e.command === 'Bold' || e.command === 'FontName') {
                adjustContainerHeight();
              }
            });
            editor.on('paste', function (e) {
              adjustContainerHeight();
            });
          }
        };

        tinymce.init(initOptions);
      }

      function setupEditorFillColorButton() {
        var buttonEl = this.getEl();
        var options = angular.copy(swaUi.colorPickerOption);
        options.change = function (color) {
          backgroundColorChanged(color.toRgbString());
        };
        options.hide = function () {
          scope.tinymceEditor.focus();
        };
        $(buttonEl).spectrum(options);
        $(buttonEl).spectrum("set", scope.dataAnnotation.backgroundColor);
      }

      function deinitRichTextEditor() {
        tinymce.remove(scope.tinymceEditor);
        scope.tinymceEditor = undefined;
      }

      function backgroundColorChanged(color) {
        scope.dataAnnotation.isDataChanged = false;
        scope.$applyAsync(function () {
          scope.dataAnnotation.backgroundColor = color;
          scope.dataAnnotation.backgroundColorCss = color;
          scope.dataAnnotation.isDataChanged = true;
          scope.triggerChange();
        });
      }

      function adjustContainerHeight() {
        if (scope.tinymceEditor) {
          var editorContentHeight = scope.tinymceEditor.getBody().scrollHeight;
          if (scope.dataAnnotation.annotationtype === 0 || scope.dataAnnotation.annotationtype === 1) {
            var heightDifference = editorContentHeight - scope.dataAnnotation.positionrect.height;
            if (heightDifference > 0) {
              if (scope.dataAnnotation.positionrect.top - heightDifference < 0) {
                scope.dataAnnotation.positionrect.height = editorContentHeight;
              } else {
                scope.dataAnnotation.positionrect.top -= heightDifference;
                scope.dataAnnotation.positionrect.height = editorContentHeight;
              }
            } else if (heightDifference < 0) {
              var newHeight = Math.max(editorContentHeight, scope.dataAnnotation.minimumHeightOfAnnotation);
              var topAdjustment = scope.dataAnnotation.positionrect.height - newHeight;
              var initialBottom = scope.dataAnnotation.initialTopOfAnnotation + scope.dataAnnotation.minimumHeightOfAnnotation;
              if (initialBottom < (scope.dataAnnotation.positionrect.top + scope.dataAnnotation.positionrect.height)) {
                scope.dataAnnotation.positionrect.height = newHeight;
              } else {
                scope.dataAnnotation.positionrect.top += topAdjustment;
                scope.dataAnnotation.positionrect.height = newHeight;
              }
            }
            if (scope.dataAnnotation.side === 'left') {
              scope.dataScriptEditor.updateLeftAnnotationConnectorLines(scope.dataAnnotation);
            } else {
              scope.dataScriptEditor.updateRightAnnotationConnectorLines(scope.dataAnnotation);
            }
          } else if (scope.dataAnnotation.annotationtype === 2) {
            var heightOfParent = element.parent().parent().height();
            var heightDifference = scope.dataAnnotation.positionrect.height - editorContentHeight;
            var bottomValue = heightOfParent - (scope.dataAnnotation.positionrect.top + scope.dataAnnotation.positionrect.height);

            if (heightDifference < 0) {
              scope.dataAnnotation.positionrect.height = editorContentHeight;
              bottomValue = heightOfParent - (scope.dataAnnotation.positionrect.top + scope.dataAnnotation.positionrect.height);

              if (bottomValue <= 0) {
                scope.dataAnnotation.positionrect.top += bottomValue;
              }
            }

            if (bottomValue > 0) {
              scope.dataAnnotation.positionrect.height = editorContentHeight;
              bottomValue = heightOfParent - (scope.dataAnnotation.positionrect.top + scope.dataAnnotation.positionrect.height);
            }

            if (heightDifference > 0) {
              scope.dataAnnotation.positionrect.height = Math.max(editorContentHeight, scope.dataAnnotation.minimumHeightOfAnnotation);
              bottomValue = heightOfParent - (scope.dataAnnotation.positionrect.top + scope.dataAnnotation.positionrect.height);
              if (scope.dataAnnotation.positionrect.top < scope.dataAnnotation.initialTopOfAnnotation) {
                scope.dataAnnotation.positionrect.top = Math.min(
                  scope.dataAnnotation.initialTopOfAnnotation,
                  scope.dataAnnotation.positionrect.top + heightDifference
                );
              }
            }
          }
        }
      }

      function updateToolbarPosition() {
        scope.$parent.$parent.vm.updateToolbarPosition(scope.dataAnnotation);
      }
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('ReplaceCurrentPageConfirmationPromptController', ReplaceCurrentPageConfirmationPromptController);

  ReplaceCurrentPageConfirmationPromptController.$inject = ['$uibModalInstance'];

  function ReplaceCurrentPageConfirmationPromptController($uibModalInstance) {
    var vm = this;

    vm.actionYes = actionYes;
    vm.actionNo = actionNo;

    function actionYes() {
      $uibModalInstance.close();
    }

    function actionNo() {
      $uibModalInstance.dismiss();
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('InsertScriptPagesConfirmationPromptController', InsertScriptPagesConfirmationPromptController);

  InsertScriptPagesConfirmationPromptController.$inject = ['$uibModalInstance'];

  function InsertScriptPagesConfirmationPromptController($uibModalInstance) {
    var vm = this;

    vm.actionBefore = actionBefore;
    vm.actionAfter = actionAfter;
    vm.actionCancel = actionCancel

    function actionBefore() {
      $uibModalInstance.close({before: true});
    }

    function actionAfter() {
      $uibModalInstance.close({before: false});
    }

    function actionCancel() {
      $uibModalInstance.dismiss();
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('ImportNewScriptConfirmationPromptController',
    ImportNewScriptConfirmationPromptController);

  ImportNewScriptConfirmationPromptController.$inject = [
    '$uibModalInstance',
  ];

  function ImportNewScriptConfirmationPromptController($uibModalInstance) {
    var vm = this;

    vm.actionYes = actionYes;
    vm.actionNo = actionNo;

    function actionYes() {
      $uibModalInstance.close();
    }

    function actionNo() {
      $uibModalInstance.dismiss('cancel');
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('DeleteScriptPagePromptController', DeleteScriptPagePromptController);

  DeleteScriptPagePromptController.$inject = ['$uibModalInstance'];

  function DeleteScriptPagePromptController($uibModalInstance) {
    var vm = this;

    vm.actionYes = actionYes;
    vm.actionNo = actionNo;

    function actionYes() {
      $uibModalInstance.close();
    }

    function actionNo() {
      $uibModalInstance.dismiss();
    }
  }
}());

(function () {
  'use strict';
  // SWA-1922 - New File
  angular.module('swanywhere').controller('DeleteAnnotationLayerPromptController', DeleteAnnotationLayerPromptController);

  DeleteAnnotationLayerPromptController.$inject = ['$uibModalInstance', 'params'];

  function DeleteAnnotationLayerPromptController($uibModalInstance, params) {
    var vm = this;

    vm.selectedAnnotationLayer = params.selectedAnnotationLayer;
    vm.annotationLayers = params.annotationLayers.filter(function (item) {
      return (item.layerid !== vm.selectedAnnotationLayer.layerid);
    })

    vm.selectedLayerId = params.selectedAnnotationLayer.layerid;
    vm.showMergeOptions = angular.isArray(vm.annotationLayers) && vm.annotationLayers.length > 0;

    vm.deleteAnnotationParam = {};
    vm.deleteAnnotationParam.isMerge = false;
    vm.deleteAnnotationParam.mergeToLayerId = undefined;
    vm.deleteAnnotationParam.selectedAnnotationLayer = params.selectedAnnotationLayer;

    vm.actionYes = actionYes;
    vm.actionNo = actionNo;


    function actionYes() {
      if (!vm.deleteAnnotationParam.isMerge) {
        vm.deleteAnnotationParam.mergeToLayerId = -1;
      }
      $uibModalInstance.close(vm.deleteAnnotationParam);
    }

    function actionNo() {
      $uibModalInstance.dismiss();
    }
  }
}());

(function () {
    'use strict';
  
    angular.module('swanywhere').controller('ApplyMarginToAllPagesController', ApplyMarginToAllPagesController);
  
    ApplyMarginToAllPagesController.$inject = ['$uibModalInstance'];
  
    function ApplyMarginToAllPagesController($uibModalInstance) {
      var vm = this;
  
      vm.actionYes = actionYes;
      vm.actionNo = actionNo;
  
      function actionYes() {
        $uibModalInstance.close();
      }
  
      function actionNo() {
        $uibModalInstance.dismiss();
      }
    }
  }());
  
(function () {
  'use strict';
  // SWA-1922 - New File
  angular.module('swanywhere').controller('AnnotationLayerSettingsPromptController', AnnotationLayerSettingsPromptController);

  AnnotationLayerSettingsPromptController.$inject = [
    '$uibModalInstance',
    'toastr',
    'annotationLayer',
    'swaUi',
    '$translate',
    '$scope',
    'isProductionOwner'
  ];

  function AnnotationLayerSettingsPromptController($uibModalInstance, toastr, annotationLayer, swaUi, $translate, $scope, isProductionOwner) {
    var vm = this;

    vm.annotationLayer = angular.copy(annotationLayer);
    vm.annotationLayer.isShared = vm.annotationLayer.isShared || false;
    vm.isProductionOwner = isProductionOwner;

    vm.highlightColorPickerOption = swaUi.highlightColorPickerOption;
    vm.colorPickerOption = swaUi.colorPickerOption;
    vm.fontFamilies = swaUi.fontFamilies;
    vm.fontSizeRange = swaUi.fontSizeRange;
    vm.borderThicknessRange = swaUi.borderThicknessRange;
    vm.personalContentDefaults = {
      selectedType: 'settingsScriptAction',
      fillColor: null,
      fontColor: null,
      fontFamily: null,
      fontSize: null,
      bold: false,
      italic: false,
      underline: false
    };

    var CueAnchorStyle = Object.freeze({
      Marker: 'marker',
      ConnectingLineTop: 'top'
    });

    vm.saveSettings = saveSettings;
    vm.deleteSettings = deleteSettings;
    vm.cancel = cancel;
    vm.viewSettings = viewSettings;
    vm.editSettings = editSettings;
    vm.fontSizeStepper = fontSizeStepper;
    vm.borderThicknessStepper = borderThicknessStepper;
    vm.preview = preview;
    vm.reset = reset;
    vm.updateCueAnchorStyle = updateCueAnchorStyle;
    vm.updateCueAnchorConnectingLine = updateCueAnchorConnectingLine;
    vm.colorToRgb = swaUi.colorToRgb;

    var scriptLq = vm.annotationLayer.contentDefaults.settingsScriptLq;
    var scriptAction = vm.annotationLayer.contentDefaults.settingsScriptAction;
    var scriptText = vm.annotationLayer.contentDefaults.settingsScriptText;
    var defaultStyles = swaUi.defaultTextStylePreferences;
    vm.annotationLayerColors = {
      fillColorAction: scriptAction.fillColor || defaultStyles.fillColor,
      fontColorAction: scriptAction.fontColor || defaultStyles.fontColor,
      fillColorForAnchorAction: scriptAction.fillColorForAnchor || defaultStyles.fillColorForAnchor,
      borderColorForAnchorAction: scriptAction.borderColorForAnchor || defaultStyles.borderColorForAnchor,
      fillColorCue: scriptLq.fillColor || defaultStyles.fillColor,
      fontColorCue: scriptLq.fontColor || defaultStyles.fontColor,
      fillColorForAnchorCue: scriptLq.fillColorForAnchor || defaultStyles.fillColorForAnchor,
      borderColorForAnchorCue: scriptLq.borderColorForAnchor || defaultStyles.borderColorForAnchor,
      fillColorText: scriptText.fillColor || defaultStyles.fillColor,
      fontColorText: scriptText.fontColor || defaultStyles.fontColor,
    }

    $scope.$watch('', function () {
      viewSettings('settingsScriptAction');
      viewSettings('settingsScriptLq');
      viewSettings('settingsScriptText');
      viewSettings('colorScriptHighlight');
    });

    function updateContentDefaults(annotationLayer) {
      var scriptLq = annotationLayer.contentDefaults.settingsScriptLq;
      var scriptAction = annotationLayer.contentDefaults.settingsScriptAction;
      var scriptText = annotationLayer.contentDefaults.settingsScriptText;
      var defaultStyles = swaUi.defaultTextStylePreferences;
      scriptLq.fillColorForAnchor = scriptLq.fillColorForAnchor || defaultStyles.fillColorForAnchor;
      scriptLq.borderColorForAnchor = scriptLq.borderColorForAnchor || defaultStyles.borderColorForAnchor;
      scriptLq.markerStyle = scriptLq.markerStyle || defaultStyles.markerStyle;
      scriptLq.connectingLineTop = scriptLq.connectingLineTop || defaultStyles.connectingLineTop;
      scriptLq.annotationBorderThickness = scriptLq.annotationBorderThickness || defaultStyles.annotationBorderThickness;
      scriptAction.fillColorForAnchor = scriptAction.fillColorForAnchor || defaultStyles.fillColorForAnchor;
      scriptAction.borderColorForAnchor = scriptAction.borderColorForAnchor || defaultStyles.borderColorForAnchor;
      scriptAction.annotationBorderThickness = scriptAction.annotationBorderThickness || defaultStyles.annotationBorderThickness;
      scriptText.fillColor = scriptText.fillColor || defaultStyles.fillColor;
      scriptText.fontColor = scriptText.fontColor || defaultStyles.fontColor;
    }
    updateContentDefaults(vm.annotationLayer)
    /**
     * Save Settings
     * @returns
     */
    function saveSettings() {

      if ((angular.isDefined(vm.annotationLayer) && vm.annotationLayer.name && vm.annotationLayer.name.trim().length === 0) || angular.isUndefined(vm.annotationLayer.name)) {
        showValidationErrors();
        return;
      }

      // TODO: logic for saving
      $uibModalInstance.close(vm.annotationLayer);
    }

    /**
     * Delete settings
     */
    function deleteSettings() {
      // TODO: logic for saving
      $uibModalInstance.close();
    }

    /**
     * Cancel settings
     */
    function cancel() {
      // Reset original annotation layer settings
      vm.annotationLayer = angular.copy(annotationLayer);

      $uibModalInstance.dismiss();
    }

    /**
     * View settings
     * @param {*} type
     */
    function viewSettings(type) {
      vm.preview(type, vm.annotationLayer.contentDefaults[type])
    }

    /**
     * Reset the settings
     * @param {*} setting
     * @param {*} type
     */
    function reset(setting, type) {
      if (type === 'colorScriptHighlight') {
        vm.annotationLayer.contentDefaults[type] = swaUi.defaultScriptHighlightColor;
        vm.viewSettings(type);
      } else {
        vm.annotationLayer.contentDefaults[type] = angular.copy(swaUi.defaultTextStylePreferences);
        if (type === 'settingsScriptLq') {
          vm.annotationLayerColors.fillColorCue = swaUi.defaultTextStylePreferences.fillColor;
          vm.annotationLayerColors.fontColorCue = swaUi.defaultTextStylePreferences.fontColor;
          vm.annotationLayerColors.fillColorForAnchorCue = swaUi.defaultTextStylePreferences.fillColorForAnchor;
          vm.annotationLayerColors.borderColorForAnchorCue = swaUi.defaultTextStylePreferences.borderColorForAnchor;
        } else if (type === 'settingsScriptAction') {
          vm.annotationLayerColors.fillColorAction = swaUi.defaultTextStylePreferences.fillColor;
          vm.annotationLayerColors.fontColorAction = swaUi.defaultTextStylePreferences.fontColor;
          vm.annotationLayerColors.fillColorForAnchorAction = swaUi.defaultTextStylePreferences.fillColorForAnchor;
          vm.annotationLayerColors.borderColorForAnchorAction = swaUi.defaultTextStylePreferences.borderColorForAnchor;
        } else {
          vm.annotationLayerColors.fillColorText = swaUi.defaultTextStylePreferences.fillColor;
          vm.annotationLayerColors.fontColorText = swaUi.defaultTextStylePreferences.fontColor;
        }
        vm.viewSettings(type);
      }
    }

    /**
     * Edit the settings
     * @param {*} type
     * @param {*} data
     */
    function editSettings(type, data) {
      if (type === 'colorScriptHighlight') {
        vm.annotationLayer.contentDefaults[type] = data;
      } else {
        angular.forEach(data, function (value, key) {
          vm.annotationLayer.contentDefaults[type][key] = value;
        });
      }
      vm.preview(type, vm.annotationLayer.contentDefaults[type]);
    }

    /**
     * Preview the text
     * @param {*} type
     * @param {*} data
     */
    function preview(type, data) {
      if (type === 'colorScriptHighlight') {
        $('#settings-preview-colorScriptHighlight').css({
          'background-color': '',
          'height': '80px',
          'width': '206px',
        });
        $('#preview-content-colorScriptHighlight').css({
          'color': '#000000',
          'background-color': swaUi.getHighlightBackgroundCss(data),
          'font-family': 'Liberation Sans',
          'font-size': '36px',
          'font-weight': 'normal',
          'font-style': 'normal',
          'text-decoration': 'none'
        }).text('Highlight');
      } else if (type === 'settingsScriptAction') {
        $('#settings-preview-' + type).css({
          'background-color': swaUi.colorReplaceIfTransparent('rgb(255, 255, 255'),
          'height': 80 + 'px',
          'width': 206 + 'px',
          'display': 'flex',
          'position': 'relative',
        });
        $('#preview-content-anchor-border-' + type).css({
          'height': '48px',
          'left': '36px',
          'top': '30px',
          'width': '60px',
          'position': 'absolute',
          'border': '1px solid black',
          'border-color': data.borderColorForAnchor,
          'border-width': data.annotationBorderThickness,
          'opacity': '0.5'
        });
        $('#preview-content-anchor-background-' + type).css({
          'background-color': swaUi.colorReplaceIfTransparent(data.fillColorForAnchor, 'rgb(255, 255, 255'),
          'height': '46px',
          'left': '36px',
          'top': '30px',
          'width': '58px',
          'position': 'absolute',
          'opacity': '0.2',
        });
        $('#preview-content-textbox-' + type).css({
          'background-color': swaUi.colorReplaceIfTransparent(data.fillColor, 'rgb(255, 255, 255'),
          'display': 'flex',
          'align-items': 'center',
          'justify-content': 'center',
          'height': '32px',
          'width': '98px',
          'top': '53px',
          'left': '146px',
          'position': 'absolute',
          'color': data.fontColor,
          'font-family': data.fontFamily,
          'font-size': data.fontSize + vm.fontSizeRange.unit,
          'font-weight': data.bold ? 'bold' : 'normal',
          'font-style': data.italic ? 'italic' : 'normal',
          'text-decoration': data.underline ? 'underline' : 'none',
        }).text('AaBb');

        $('#preview-content-text-border-' + type).css({
          'height': '34px',
          'width': '100px',
          'top': '53px',
          'left': '146px',
          'position': 'absolute',
          'border': '1px solid black',
          'border-color': data.borderColorForAnchor,
          'border-width': data.annotationBorderThickness,
          'opacity': '0.5'
        });

        $('#preview-content-line-' + type).css({
          'background-color': data.borderColorForAnchor,
          'width': '31px',
          'position': 'absolute',
          'top': '53px',
          'left': '81px',
          'height': data.annotationBorderThickness,
          'opacity': '0.5',
        });
      } else if (type === 'settingsScriptLq') {
        $('#settings-preview-' + type).css({
          'background-color': swaUi.colorReplaceIfTransparent('rgb(255, 255, 255'),
          'height': 120 + 'px',
          'width': 206 + 'px',
          'display': 'flex',
          'position': 'relative',
        });

        var topValueForAnchor = vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop
          ? '76px'
          : '59px';
        var stylesForAnchorBorder = vm.annotationLayer.contentDefaults.settingsScriptLq.markerStyle
          ? (vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop
            ? { 'border-right-style': 'none', 'border-bottom-style': 'none' }
            : { 'border-right-style': 'none', 'border-top-style': 'none' }
          )
          : {};
        $('#preview-content-anchor-border-' + type).css({
          'height': '48px',
          'left': '36px',
          'top': topValueForAnchor,
          'width': '60px',
          'position': 'absolute',
          'border': '1px solid black',
          'border-color': data.borderColorForAnchor,
          'border-width': data.annotationBorderThickness,
          'opacity': '0.5',
        }).css(stylesForAnchorBorder);
        $('#preview-content-anchor-background-' + type).css({
          'background-color': vm.annotationLayer.contentDefaults.settingsScriptLq.markerStyle
            ? ''
            : swaUi.colorReplaceIfTransparent(data.fillColorForAnchor, 'rgb(255, 255, 255'),
          'height': '46px',
          'left': '36px',
          'top': topValueForAnchor,
          'width': '58px',
          'position': 'absolute',
          'opacity': '0.2',
        });

        var topValueForTextBox = vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop
          ? '36px'
          : '66px';
        $('#preview-content-textbox-' + type).css({
          'background-color': swaUi.colorReplaceIfTransparent(data.fillColor, 'rgb(255, 255, 255'),
          'display': 'flex',
          'align-items': 'center',
          'justify-content': 'center',
          'height': '32px',
          'width': '98px',
          'top': topValueForTextBox,
          'left': '146px',
          'position': 'absolute',
          'color': data.fontColor,
          'font-family': data.fontFamily,
          'font-size': data.fontSize + vm.fontSizeRange.unit,
          'font-weight': data.bold ? 'bold' : 'normal',
          'font-style': data.italic ? 'italic' : 'normal',
          'text-decoration': data.underline ? 'underline' : 'none',
        }).text('AaBb');

        $('#preview-content-text-border-' + type).css({
          'height': '34px',
          'width': '100px',
          'top': topValueForTextBox,
          'left': '146px',
          'position': 'absolute',
          'border': '1px solid black',
          'border-color': data.borderColorForAnchor,
          'border-width': data.annotationBorderThickness,
          'opacity': '0.5'
        });

        var topValueForConnectingLine = vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop
          ? '53px'
          : '82px';
        $('#preview-content-line-' + type).css({
          'background-color': data.borderColorForAnchor,
          'width': '31px',
          'position': 'absolute',
          'top': topValueForConnectingLine,
          'left': '81px',
          'height': data.annotationBorderThickness,
          'opacity': '0.5'
        });
      } else {
        $('#settings-preview-' + type).css({
          'height': '80px',
          'width': '206px',
        });
        $('#preview-content-textbox-' + type).css({
          'color': data.fontColor,
          'background-color': swaUi.colorReplaceIfTransparent(data.fillColor, 'rgb(255, 255, 255'),
          'font-family': data.fontFamily,
          'font-size': data.fontSize + vm.fontSizeRange.unit,
          'font-weight': data.bold ? 'bold' : 'normal',
          'font-style': data.italic ? 'italic' : 'normal',
          'text-decoration': data.underline ? 'underline' : 'none',
          'width': '150px',
          'height': '50px',
          'display': 'flex',
          'align-items': 'center',
          'justify-content': 'center',
        }).text('AaBb');
      }
    }

    /**
     * Font size updation
     * @param {*} type
     * @param {*} action
     */
    function fontSizeStepper(type, action) {
      var fontSize = vm.annotationLayer.contentDefaults[type].fontSize;
      fontSize = parseInt(fontSize);
      if (action === '-') {
        if (fontSize - vm.fontSizeRange.incremental >= vm.fontSizeRange.min) {
          fontSize -= vm.fontSizeRange.incremental;
        }
      } else if (action === '+') {
        if (fontSize + vm.fontSizeRange.incremental <= vm.fontSizeRange.max) {
          fontSize += vm.fontSizeRange.incremental;
        }
      }
      vm.editSettings(type, { fontSize: fontSize });
    }

    /**
     * Font size updation
     * @param {*} type
     * @param {*} action
     */
    function borderThicknessStepper(type, action) {
      var borderThickness = vm.annotationLayer.contentDefaults[type].annotationBorderThickness;
      borderThickness = parseInt(borderThickness);
      if (action === '-') {
        if (borderThickness - vm.borderThicknessRange.incremental >= vm.borderThicknessRange.min) {
          borderThickness -= vm.borderThicknessRange.incremental;
        }
      } else if (action === '+') {
        if (borderThickness + vm.borderThicknessRange.incremental <= vm.borderThicknessRange.max) {
          borderThickness += vm.borderThicknessRange.incremental;
        }
      }
      vm.editSettings(type, { annotationBorderThickness: borderThickness });
    }

    /**
     * Show validation error
     */
    function showValidationErrors() {
      var validationErrorMessage = '<ul>';
      if (angular.isUndefined(vm.annotationLayer.name)) {
        validationErrorMessage = validationErrorMessage + '<li>' + $translate.instant('messages.Name is required');
      }

      validationErrorMessage = validationErrorMessage + '</ul>';
      toastr.warning(
        validationErrorMessage,
        $translate.instant('errormessages.Error updating annotation layer!'),
        { allowHtml: true }
      );
    }

    function updateCueAnchorStyle(type, option) {
      vm.annotationLayer.contentDefaults.settingsScriptLq.markerStyle = option === CueAnchorStyle.Marker;
      vm.editSettings(type, { markerStyle: vm.annotationLayer.contentDefaults.settingsScriptLq.markerStyle });
      vm.preview(type, vm.annotationLayer.contentDefaults[type]);
    }

    function updateCueAnchorConnectingLine(type, option) {
      vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop = option === CueAnchorStyle.ConnectingLineTop;
      vm.editSettings(type, { connectingLineTop: vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop });
      vm.preview(type, vm.annotationLayer.contentDefaults[type]);
    }
  }
}());

(function () {
  'use strict';
  angular.module('swanywhere').controller('SwitchToViewOnlyPromptController', SwitchToViewOnlyPromptController);

  SwitchToViewOnlyPromptController.$inject = ['$uibModalInstance', 'newPlan'];

  function SwitchToViewOnlyPromptController($uibModalInstance, newPlan) {
    var vm = this;

    vm.newPlan = newPlan;

    vm.cancelSwitch = cancelSwitch;
    vm.confirmSwitch = confirmSwitch;

    function cancelSwitch() {
      $uibModalInstance.dismiss('cancel');
    }

    function confirmSwitch() {
      $uibModalInstance.close();
    }
  }
})();

// jshint maxparams: false
/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SubscriptionsController', SubscriptionsController);

  SubscriptionsController.$inject = [
    '$scope',
    '$log',
    '$uibModal',
    'DbSubMgrService',
    'ngProgressLite',
    'toastr',
    '$timeout',
    'blockUI',
    '$translate',
    'swaUtils',
    'swaRouterStateNames',
    'DbMasters',
    '$q',
    'DbUser',
    '$window'
  ];

  function SubscriptionsController($scope, $log, $uibModal,
    DbSubMgrService, ngProgressLite, toastr, $timeout, blockUI,
    $translate, swaUtils, swaRouterStateNames, DbMasters, $q, DbUser, $window) {
    var vm = this;

    var dbUser = new DbUser();

    vm.swaRouterStateNames = swaRouterStateNames;

    vm.appFeatures = {};
    vm.allPlans = [];
    vm.webPlans = [];
    vm.userData = {};
    vm.isEntAcctMember = false,
      vm.entAcctName = '';
    vm.logout = logout;
    vm.selectPlan = selectPlan;
    vm.scrollConfig = {};
    vm.showHelpBar = false;
    vm.helpTourVideos = [];
    initialize();

    function initialize() {
      vm.scrollConfig = {
        theme: 'swa-minimal',
        axis: 'y',
        scrollbarPosition: 'outside',
        scrollButtons: {
          enable: false,
        },
        autoHideScrollbar: true,
        advanced: {
          updateOnContentResize: true,
        },
      };

      sessionCheckAndRun();
    }

    function logout() {
      DbSubMgrService.logout();
    }

    function sessionCheckAndRun() {
      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          return getAllData();
        })
        .then(function () {
          updateUserData();
        })
        .then(function () {
          initHelpTour();
        })
        .then(function () {
          monitorUserDataChanges();
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.stop();
        });
    }

    function getAllData() {
      var deferred = $q.defer();

      var dbMasters = new DbMasters();

      dbMasters.getAppFeatures()
        .then(function (features) {
          vm.appFeatures = angular.copy(features);
        })
        .then(function () {
          return dbMasters.getSubscriptionPlans();
        })
        .then(function (plans) {
          vm.allPlans = angular.copy(plans);
          vm.webPlans = _.filter(vm.allPlans, function (plan) {
            return (plan.webPlan === true);
          })
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function monitorUserDataChanges() {
      $scope.$on('userDataChanged', function () {
        updateUserData();
      });
    }

    function updateUserData() {
      vm.userData = angular.copy(DbSubMgrService.getLoggedInUserData());
      vm.userId = DbSubMgrService.getLoggedInUserId();

      vm.username = swaUtils.getUserNameForDisplay(vm.userData);

      if (angular.isDefined(vm.allPlans)) {
        if (angular.isDefined(vm.userData.activesubscription)) {
          var planId = vm.userData.activesubscription.planid;

          if (angular.isDefined(planId)) {
            vm.userData.activePlan = vm.allPlans.find(function (element) {
              return (element.hasOwnProperty('planid') && element.planid === planId);
            });
          }
        }
      }

      getEntAcctDetails();
    }

    function getEntAcctDetails() {
      DbSubMgrService.getLoggedInEntAcct()
        .then(function (account) {
          vm.isEntAcctMember = true;
          vm.entAcctName = account.name;
        });
    }

    function selectPlan(plan, monthly) {
      if (plan.planid === 2) {
        // SWA-1993 -  SET VIEW ONLY FREE PLAN
        selectViewOnlyPlan(plan);
      } else {
        selectPaidPlan(plan, monthly);
      }
    }

    // SWA-1993 -  SET VIEW ONLY FREE PLAN
    function selectViewOnlyPlan(plan) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/profile/switchToViewOnlyPrompt.html',
        controller: 'SwitchToViewOnlyPromptController',
        controllerAs: 'vm',
        size: '480',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
        resolve: {
          newPlan: function () {
            return plan;
          },
        },
      });

      modalInstance.result.then(
        function () {
          switchToViewOnlyPlan();
        }
      );
    }

    // SWA-1993 -  SET VIEW ONLY FREE PLAN
    function switchToViewOnlyPlan() {
      ngProgressLite.start();
      blockUI.start();
      // @TODO - change it
      dbUser.switchPlanToViewOnly()
        .then(function () {
          toastr.success(
            $translate.instant('messages.You are now on the \'View Only\' plan'),
            $translate.instant('titles.Plan changed')
          );

          swaUtils.stateGo(swaRouterStateNames.productionlist);
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error switching Plan!')
          );
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.stop();
        });
    }

    function selectPaidPlan(plan, monthly) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/profile/purchasePlanPrompt.html',
        controller: 'PurchasePlanPromptController',
        controllerAs: 'vm',
        size: '480',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
        resolve: {
          newPlan: function () {
            return plan;
          },
          monthly: function () {
            return monthly;
          },
          activeSubscriptionId: function () {
            return vm.userData.activesubscription.subscriptionId;
          }
        },
      });

      modalInstance.result
        .then(function (discountAmount) {
          checkAndPurchase(plan.planid, monthly, discountAmount);
        });
    }

    function checkAndPurchase(planId, monthly, discountAmount) {

      ngProgressLite.start();
      blockUI.start();
      // Check if user can purchase or needs to provide billing/card information
      dbUser.checkCanPay()
        .then(function (canpay) {
          if (canpay) {
            // SWA-1948 : Payment Gateway Switch
            // SWA-1948 : UPDATE getHostedPageForpurchaseNow plan "+planId)
            return getHostedPageForpurchaseNow(planId, monthly, discountAmount);
          } else {
            // SWA-1948 : FRIST getHostedPageForPurchaseFirst plan "+planId)
            // SWA-1948 : Get Hosted URL
            return getHostedPageForPurchaseFirst(planId, monthly, discountAmount);
          }
        })
        .catch(function (error) {
          swaUtils.showErrorToast(error, 'Error purchasing subscription');
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.stop();
        });
    }

    // SWA-1948 : Get Hosted URL for Frist Time payment
    function getHostedPageForPurchaseFirst(planId, monthly, discountAmount) {
      blockUI.start();
      ngProgressLite.start();
      var success = false;
      dbUser.updateBillingAndPurchasePlan(
        {},
        {},
        planId,
        monthly,
        discountAmount
      )
        .then(function (resultData) {
          success = true;
          ngProgressLite.done();
          $window.open(resultData.url, "_self");

          // $window.open(resultData.url, '_blank');
          // toastr.success(
          //   $translate.instant('messages.Your selected plan is now active.'),
          //   $translate.instant('messages.Payment successful')
          // );

        })
        .catch(function (error) {
          $log.error('saveBillingInformationAndPurchase: error:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Payment failed!')
          );
        })
        .finally(function () {
          if (success) {
            $timeout(function () {
              swaUtils.stateGoLocationReplace(swaRouterStateNames.productionlist);
            }, 1500);
          } else {
            blockUI.stop();
            ngProgressLite.done();
          }
        });
    }

    // SWA-1948 : Get Hosted URL for subscription purchase (upgrade /downgrade)
    function getHostedPageForpurchaseNow(planId, monthly, discountAmount) {
      var deferred = $q.defer();
      dbUser.purchaseSubscription(planId, monthly, discountAmount)
        .then(function (resultData) {
          ngProgressLite.done();
          $window.open(resultData.url, "_self");
          // toastr.success(
          //   $translate.instant('messages.Your selected plan is now active.'),
          //   $translate.instant('messages.Payment successful')
          // );

          // $timeout(function () {
          //   // swaUtils.stateGo(swaRouterStateNames.productionlist);
          // }, 1500);

          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('purchaseNow: error:', error);

          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Payment failed!')
          );

          deferred.reject(new Error($translate.instant('errormessages.Payment failed!')));
        });

      return deferred.promise;
    }

    // @TODO : if getHostedPageForpurchaseNow works then remove below
    function purchaseNow(planId, monthly, discountAmount) {
      var deferred = $q.defer();

      dbUser.purchaseSubscription(planId, monthly, discountAmount)
        .then(function () {
          toastr.success(
            $translate.instant('messages.Your selected plan is now active.'),
            $translate.instant('messages.Payment successful')
          );

          $timeout(function () {
            swaUtils.stateGo(swaRouterStateNames.productionlist);
          }, 1500);

          deferred.resolve();
        })
        .catch(
          function (error) {
            $log.error('purchaseNow: error:', error);

            swaUtils.showErrorToast(
              error,
              $translate.instant('errormessages.Payment failed!')
            );

            deferred.reject(new Error($translate.instant('errormessages.Payment failed!')));
          });

      return deferred.promise;
    }

    function initHelpTour() {
      var userData = DbSubMgrService.getLoggedInUserData();
      var profileDisplayHelp = false;
      if (angular.isDefined(userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }

      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function initHelpTourSteps() {
      // vm.helpTourSteps = [
      //   //        {
      //   //          element: '#subscription-plans',
      //   //          title: $translate.instant('helptour.subscriptions.titles.Subscription Plans'),
      //   //          placement: 'left',
      //   //          content: $translate.instant('helptour.subscriptions.messages.Subscription Plans Content'),
      //   //        },
      //   {
      //     element: '#thead-subscription-plans',
      //     title: $translate.instant('helptour.subscriptions.titles.Subscription Plans'),
      //     placement: 'bottom',
      //     content: $translate.instant('helptour.subscriptions.messages.Subscription Plans Content'),
      //   }, {
      //     element: '#tbody-subscription-plans',
      //     title: $translate.instant('helptour.subscriptions.titles.Features'),
      //     placement: 'top',
      //     content: $translate.instant('helptour.subscriptions.messages.Features Content'),
      //   }
      // ];

      vm.helpTourVideos = [{
        label: 'Subscriptions',
        videoUrl: 'https://www.youtube.com/embed/FcdcQg-qyI0?si=SiSRJ95FbdGo--cz&amp;start=40'
      }];
    }
  }
})();

(function () {
  'use strict';
  angular.module('swanywhere').controller('PurchasePlanPromptController', PurchasePlanPromptController);

  PurchasePlanPromptController.$inject = [
    '$uibModalInstance',
    'DbUser',
    'toastr',
    'newPlan',
    'monthly',
    'activeSubscriptionId'
  ];

  function PurchasePlanPromptController($uibModalInstance, DbUser, toastr, newPlan, monthly, activeSubscriptionId) {
    var vm = this;

    var dbUser = new DbUser();

    vm.newPlan = newPlan;
    vm.monthly = monthly;
    vm.discountDetails = {};
    vm.discountApplicable = false;
    vm.discountAmount = 0;

    vm.cancelPurchase = cancelPurchase;
    vm.confirmPurchase = confirmPurchase;
    vm.$onInit = onInit;

    function onInit() {
      getDiscountDetails();
    }

    function getDiscountDetails() {
      dbUser.getProratedDiscountDetails()
        .then(function (discountDetails) {
          calculateDiscount(discountDetails);
        })
        .catch(function (error) {
          toastr.error('', 'Error getting subscription purchase details');
          $uibModalInstance.dismiss('cancel');
        });
    }

    function calculateDiscount(discountDetails) {
      vm.discountDetails = discountDetails;
      var recurringCost = 0;
      if (vm.monthly) {
        recurringCost = vm.newPlan.monthlycost;
      } else {
        recurringCost = vm.newPlan.yearlycost;
      }

      if ((discountDetails.proratedBalance > 0) && (discountDetails.proratedBalance < recurringCost)) {
        vm.discountApplicable = true;
        vm.discountAmount = discountDetails.proratedBalance;
      }
    }

    function cancelPurchase() {
      $uibModalInstance.dismiss('cancel');
    }

    function confirmPurchase() {
      $uibModalInstance.close(vm.discountAmount);
    }
  }
})();

// jshint maxparams: false
/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').controller('MyAccountController', MyAccountController);

  MyAccountController.$inject = [
    '$state',
    '$log',
    '$uibModal',
    'DbSubMgrService',
    'DbUser',
    'DbMasters',
    'ngProgressLite',
    'toastr',
    'blockUI',
    '$translate',
    '$filter',
    'swaUtils',
    'swaRouterStateNames',
    '$q',
    '$window', // SWA-1948 :,
    '$localStorage' // SWA-1948 : Payment Gateway Switch
  ];

  function MyAccountController($state, $log, $uibModal, DbSubMgrService,
    DbUser, DbMasters, ngProgressLite, toastr, blockUI, $translate, $filter, swaUtils, swaRouterStateNames, $q, $window, $localStorage) {
    var vm = this;
    var dbUser = new DbUser();

    vm.swaRouterStateNames = swaRouterStateNames;

    vm.userData = {};
    vm.managedAccount = false;
    vm.username = '';
    vm.paymentMethodDetails = {
      hasPaymentMethod: false
    };
    vm.userSubscriptionHistory = [];
    vm.fullNameChanged = false;
    vm.helpTourVideos = [];

    vm.scrollConfig = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollButtons: {
        enable: false,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
    };

    vm.logout = logout;
    vm.updateFullName = updateFullName;
    vm.updateDisplayHelp = updateDisplayHelp;
    vm.promptCancelSubscription = promptCancelSubscription;
    vm.promptChangePassword = promptChangePassword;
    vm.promptChangeEmail = promptChangeEmail;
    vm.updatePovOverride = updatePovOverride;
    vm.updatePrintScriptChartLinksPreference = updatePrintScriptChartLinksPreference;
    vm.managePaymentMethod = managePaymentMethod;

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function logout() {
      DbSubMgrService.logout();
    }

    function sessionCheckAndRun() {
      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          return getAllData();
        })
        .then(function () {
          initHelpTour();
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function getAllData() {
      var deferred = $q.defer();

      updateUserData()
        .then(function () {
          // SWA-1948 : Stripe - removed old method called new
          return getPaymentMethodDetails();
        })
        .then(function () {
          return getUserSubscriptionHistory();
        })
        .then(function () {
          return processSubscriptionHistory();
        })
        .then(function () {
          return getEnterpriseAccountDetails();
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function updateUserData() {
      var deferred = $q.defer();

      dbUser.getLoggedInUserData(true)
        .then(function (userData) {
          vm.userData = angular.copy(userData);
          vm.userData.preferences.povOverride = vm.userData.preferences.povOverride || false;
          vm.userData.preferences.printScriptChartLinks = vm.userData.preferences.printScriptChartLinks || false;
          vm.username = swaUtils.getUserNameForDisplay(vm.userData);

          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('MyAccountController.updateUserData:', error);
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function getPaymentMethodDetails() {
      var deferred = $q.defer();
      dbUser.getPaymentMethodDetails()
        .then(function (paymentMethodDetails) {
          if (paymentMethodDetails.stripe) {
            vm.paymentMethodDetails.hasPaymentMethod = true;
            vm.paymentMethodDetails.hasStripePaymentMethod = true;
            vm.paymentMethodDetails.stripe = paymentMethodDetails.stripe;
            if (paymentMethodDetails.stripe.maskedcardnumber) {
              vm.paymentMethodDetails.hasStripeCardDetails = true;
            } else {
              vm.paymentMethodDetails.hasStripeCardDetails = false;
            }
          }

          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function getUserSubscriptionHistory() {
      var deferred = $q.defer();

      dbUser.getUserSubscriptionHistory()
        .then(function (subscriptionHistory) {
          vm.userSubscriptionHistory = angular.copy(subscriptionHistory);
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function processSubscriptionHistory() {
      if (angular.isUndefined(vm.userSubscriptionHistory) || (vm.userSubscriptionHistory.length === 0)) {
        return;
      }

      if (vm.userData.activesubscription.status !== 0) {
        var activeHistoryEntry = vm.userSubscriptionHistory.find(function (entry) {
          return (entry.hasOwnProperty('subscriptionId') && (vm.userData.activesubscription.subscriptionId ===
            entry.subscriptionId));
        });

        if (angular.isDefined(activeHistoryEntry)) {
          if (activeHistoryEntry.status === 1) {
            activeHistoryEntry.tooltip = 'Auto renewal cancelled, plan will remain active till ' + $filter('date')(
              activeHistoryEntry.validtill.$date, 'MMM dd, yyyy');
          } else if (activeHistoryEntry.status === 2) {
            activeHistoryEntry.tooltip = 'Auto renewal payment failed, click on the status for details';
          }
        }
      }
    }

    function getEnterpriseAccountDetails() {
      var deferred = $q.defer();

      if (angular.isDefined(vm.userData.memberOfEntAcct)) {
        vm.managedAccount = true;

        deferred.resolve();
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    function updateFullName() {
      var updatedProfile = {
        firstName: vm.userData.profile.firstName,
        lastName: vm.userData.profile.lastName,
      };

      blockUI.start();

      dbUser.updateProfile(updatedProfile)
        .then(function () {
          toastr.success($translate.instant('messages.Changes saved.'));
          vm.fullNameChanged = false;
        })
        .catch(function (error) {
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error saving changes!'));
        })
        .finally(function () {
          updateUserData();
          blockUI.stop();
        });
    }

    function updateDisplayHelp() {
      blockUI.start();

      dbUser.updateWebPreference('displayHelp', vm.userData.preferences.web.displayHelp)
        .then(function () {
          initHelpTour();
          toastr.success($translate.instant('messages.Preferences updated.'));
        })
        .catch(function (error) {
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error saving changes!'));
          updateUserData();
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    function managePaymentMethod() {
      blockUI.start();
      ngProgressLite.start();
      dbUser.getBillingPortalUrl()
        .then(function (portalUrl) {
          $window.open(portalUrl, "_self");
        })
        .catch(function (error) {
          $log.error('managePaymentMethod: error:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Something went wrong!')
          );
        })
        .finally(function () {
          blockUI.stop();
          ngProgressLite.done();
        });
    }

    function promptCancelSubscription() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/profile/cancelSubscriptionPrompt.html',
        controller: 'CancelSubscriptionPromptController',
        controllerAs: 'vm',
        size: '480',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
      });

      modalInstance.result
        .then(function () {
          cancelSubscriptionPlan();
        });
    }

    function cancelSubscriptionPlan() {
      blockUI.start();
      ngProgressLite.start();

      var success = false;
      dbUser.cancelSubscription()
        .then(function () {
          toastr.success($translate.instant('messages.Subscription auto-renewal cancelled.'));
          ngProgressLite.done();
          success = true;
        })
        .catch(function (error) {
          $log.error('cancelSubscriptionPlan: error: ', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Cancellation failed!'));
        })
        .finally(function () {
          if (success) {
            updateAfterCancel();
          } else {
            ngProgressLite.done();
            blockUI.stop();
          }
        });
    }

    function updateAfterCancel() {
      updateUserData()
        .then(function () {
          return getUserSubscriptionHistory();
        })
        .then(function () {
          processSubscriptionHistory();
        })
        .catch(function (error) {
          toastr.warning($translate.instant('errormessages.Error loading subscription data!'));
        })
        .finally(function () {
          blockUI.stop();
          ngProgressLite.done();
        });
    }

    function promptChangePassword() {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/profile/changePasswordPrompt.html',
        controller: 'ChangePasswordPromptController',
        controllerAs: 'vm',
        size: '480',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
      });
    }

    function promptChangeEmail() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/profile/changeEmailPrompt.html',
        controller: 'ChangeEmailPromptController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
      });

      modalInstance.rendered
        .then(function () {
          $('input#newemail').focus();
        });
      modalInstance.result
        .then(function (result) {
          if (result) {
            toastr.success('Email changed');
            updateUserData();
          }
        });
    }

    function updatePovOverride(povOverride) {
      if (vm.userData.preferences.povOverride === povOverride) {
        return;
      }

      vm.userData.preferences.povOverride = povOverride;

      blockUI.start();

      dbUser.updatePreference('povOverride', vm.userData.preferences.povOverride)
        .then(function () {
          toastr.success($translate.instant('messages.Preferences updated.'));
        })
        .catch(function (error) {
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error saving changes!'));
          updateUserData();
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    function updatePrintScriptChartLinksPreference() {
      blockUI.start();

      dbUser.updatePreference('printScriptChartLinks', vm.userData.preferences.printScriptChartLinks)
        .then(function () {
          toastr.success($translate.instant('messages.Preferences updated.'));
        })
        .catch(function (error) {
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error saving changes!'));
          updateUserData();
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    function initHelpTour() {
      vm.showHelpBar = false;

      var userData = DbSubMgrService.getLoggedInUserData();
      var profileDisplayHelp = false;
      if (angular.isDefined(userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }

      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function initHelpTourSteps() {
      vm.helpTourSteps = [
        //                {element: '#my-account-productions',
        //                    title: $translate.instant('titles.View Productions'),
        //                    placement: 'left',
        //                    content: $translate.instant('messages.View Productions Content'),
        //                },
        //                {element: '#my-account-subscriptions',
        //                    title: $translate.instant('titles.Subscriptions'),
        //                    placement: 'left',
        //                    content: $translate.instant('messages.Subscriptions Content'),
        //                },
        //                {element: '#my-account-logout',
        //                    title: $translate.instant('titles.Logout'),
        //                    placement: 'left',
        //                    content: $translate.instant('messages.Logout Content'),
        //                },
        {
          element: '#my-account-cancel-plan',
          title: $translate.instant('helptour.myAccount.titles.Cancel Plan'),
          placement: 'right',
          content: $translate.instant('helptour.myAccount.messages.Cancel Plan Content'),
        }, {
          element: '#my-account-change-plan',
          title: $translate.instant('helptour.myAccount.titles.Change Plan'),
          placement: 'right',
          content: $translate.instant('helptour.myAccount.messages.Change Plan Content'),
        }, {
          element: '#my-account-update-plan',
          title: $translate.instant('helptour.myAccount.titles.Update Billing Information'),
          placement: 'right',
          content: $translate.instant('helptour.myAccount.messages.Update Billing Information Content'),
        }, {
          element: '#my-account-display-help',
          title: $translate.instant('helptour.myAccount.titles.Display Help'),
          placement: 'right',
          content: $translate.instant('helptour.myAccount.messages.Display Help Content'),
        }, {
          element: '#my-account-change-password',
          title: $translate.instant('helptour.myAccount.titles.Change Password'),
          placement: 'right',
          content: $translate.instant('helptour.myAccount.messages.Change Password Content'),
        },
      ];

      vm.helpTourVideos = [{
        label: 'My Account',
        videoUrl: 'https://www.youtube.com/embed/FcdcQg-qyI0?si=HX77du2ODLyikFqL&amp;start=59'
      }];
    }
  }
})();

(function () {
  'use strict';

  angular.module('swanywhere').controller('ChangePasswordPromptController', ChangePasswordPromptController);

  ChangePasswordPromptController.$inject = [
    '$uibModalInstance',
    '$timeout',
    'DbUser',
    'toastr',
    'swaUtils'
  ];

  function ChangePasswordPromptController($uibModalInstance, $timeout, DbUser, toastr, swaUtils) {
    var vm = this;

    vm.formParams = {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    };
    vm.serverError = false;
    vm.errorIncorrectPassword = false;
    vm.errorMessage = '';

    vm.submitForm = submitForm;
    vm.cancel = cancel;
    vm.$onInit = onInit;

    function onInit() {
      $timeout(function() {
        angular.element('input#currentPassword').focus();
      }, 500);
    }

    function submitForm(form) {
      if (form.$invalid) {
        return;
      }

      var dbUser = new DbUser();
      vm.serverError = false;
      vm.errorIncorrectPassword = false;

      dbUser.updatePassword(vm.formParams.currentPassword, vm.formParams.newPassword)
        .then(function () {
          $uibModalInstance.close(true);
          toastr.success('Password changed');
        })
        .catch(function (error) {
          form.$setPristine();
          form.$setUntouched();

          vm.errorMessage = swaUtils.getSanitizedErrorMessage(error);
          if (error.error === 'ESWA:UserIncorrectPassword') {
            vm.errorIncorrectPassword = true;
          } else {
            vm.serverError = true;
          }
        }
      );
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();

(function () {
  'use strict';

  angular.module('swanywhere').controller('ChangeEmailPromptController', ChangeEmailPromptController);

  ChangeEmailPromptController.$inject = [
    '$uibModalInstance',
    '$timeout',
    'DbUser'
  ];

  function ChangeEmailPromptController($uibModalInstance, $timeout, DbUser) {
    var vm = this;

    vm.changeEmailForm = {};
    vm.formParams = {
      newEmail: '',
    };
    vm.serverError = {};

    vm.save = save;
    vm.cancel = cancel;
    vm.$onInit = onInit;

    function onInit() {
      $timeout(function() {
        angular.element('input#newEmail').focus();
      }, 500);
    }

    function save(form) {
      if (form.$invalid) {
        return;
      }

      var dbUser = new DbUser();
      vm.serverError.emailAlreadyUsed = false;
      vm.serverError.message = undefined;

      dbUser.updateEmail(vm.formParams.newEmail).then(
        function () {
          $uibModalInstance.close(true);
        }
      ).catch(
        function (error) {
          form.$setPristine();
          form.$setUntouched();

          if (error.errorType === 'Meteor.Error') {
            if (error.message === 'Email already exists. [403]') {
              vm.serverError.emailAlreadyUsed = true;
            } else {
              vm.serverError.message = 'Server Error: ' + error.reason;
            }
          } else {
            vm.serverError.message = error.message;
          }
        }
      );
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();

(function () {
  'use strict';

  angular.module('swanywhere').controller('CancelSubscriptionPromptController', CancelSubscriptionPromptController);

  CancelSubscriptionPromptController.$inject = ['$uibModalInstance'];

  function CancelSubscriptionPromptController($uibModalInstance) {
    var vm = this;

    vm.onCancel = onCancel;
    vm.onConfirm = onConfirm;

    function onCancel() {
      $uibModalInstance.dismiss();
    }

    function onConfirm() {
      $uibModalInstance.close(true);
    }
  }
})();

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsStageDimensionsController', SettingsStageDimensionsController);

  SettingsStageDimensionsController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$log',
    '$translate',
    'ngProgressLite',
    'toastr',
    'DbProductions',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    'DbCollaborationPrivileges',
    '$q',
    'DbScenes',
    'DbSetPieces',
    'DbChartItems',
  ];

  function SettingsStageDimensionsController($scope, $cookies, $stateParams, $log,
    $translate, ngProgressLite, toastr,
    DbProductions, DbSubMgrService, blockUI, swaUtils, swaRouterStateNames,
    DbCollaborationPrivileges, $q, DbScenes, DbSetPieces, DbChartItems) {

    var vm = this;
    var selectedProductionId;
    var dbProductions = new DbProductions();

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      alloweditdimensions: false,
      alloweditpermanentstage: false,
      alloweditcustomnumberline: false,
    };

    var defaultViewAccessRules = angular.copy(defaultDenyAccessRules);

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      alloweditdimensions: true,
      alloweditpermanentstage: true,
      alloweditcustomnumberline: true,
    };

    vm.userData = {};
    vm.userId = '';

    vm.canEditDimensions = false;
    vm.originalProduction = {};
    vm.production = {};

    vm.setStageWidth = {
      feet: 0,
      inch: 0
    }

    vm.setStageDepth = {
      feet: 0,
      inch: 0
    }

    vm.setOffStageWidth = {
      feet: 0,
      inch: 0
    }

    vm.canEditPermanentStage = canEditPermanentStage;
    vm.canEditCustomNumberline = canEditCustomNumberline;
    vm.blurValidateNumber = blurValidateNumber;
    vm.editPermanentStage = editPermanentStage;
    vm.editCustomNumberline = editCustomNumberline;
    vm.saveUpdate = saveUpdate;
    vm.getStageWidthInFeet = getStageWidthInFeet;
    vm.getStageDepthInFeet = getStageDepthInFeet;
    vm.getOffStageWidthInFeet = getOffStageWidthInFeet;

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
    };

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        $log.warn('SettingsStageDimensionsController.sessionCheckAndRun: No production, bailing out!');
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.validateActivePlan();
        }
      ).then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        }
      ).then(
        function (plan) {
          updateActivePlanRules(plan);
        }
      ).then(
        function () {
          return getAllData();
        }
      ).catch(
        function (error) {
          swaUtils.sessionErrorInterceptor(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
        }
      );
    }

    function getAllData() {
      var deferred = $q.defer();

      var dbScenes = new DbScenes();
      var dbSetPieces = new DbSetPieces();
      var dbChartItems = new DbChartItems();

      dbProductions.findById(selectedProductionId).then(
        function (production) {
          updateDataProduction(production);
        }
      ).then(
        function () {
          return dbScenes.getCountInProduction(selectedProductionId);
        }
      ).then(
        function (numScenes) {
          vm.sceneCount = numScenes;
        }
      ).then(
        function () {
          return dbSetPieces.getCountInProduction(selectedProductionId);
        }
      ).then(
        function (numSetPieces) {
          vm.setPieceCount = numSetPieces;
        }
      ).then(
        function () {
          return dbChartItems.getCountOfProductionPermanentLayer(selectedProductionId);
        }
      ).then(
        function (numChartItems) {
          vm.numPermanentLayerChartItems = numChartItems;
        }
      ).then(
        function () {
          updateEditability();
        }
      ).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function () {
          deferred.reject();
        }
      );

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;
    }

    function updateDataProduction(production) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      vm.originalProduction = angular.copy(production)
      vm.production = angular.copy(production);

      vm.setStageWidth = swaUtils.getFeetAndInches(vm.production.stagesettings.stagewidth);
      vm.setStageDepth = swaUtils.getFeetAndInches(vm.production.stagesettings.stagedepth);
      vm.setOffStageWidth = swaUtils.getFeetAndInches(vm.production.stagesettings.offstagewidth);

      if (vm.production.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(vm.production.collaboratorIds) && (vm.production.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = vm.production.collaborationsettings.find(function (element) {
            return (element.collaboratorId === vm.userId);
          });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error($translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'), $translate.instant('collaborationprivileges.titles.Collaboration Access'));
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          return;
        }
      }

      vm.measurementunitname = (vm.production.stagesettings.stagemeasurementunit === 0) ? 'Feet' : 'Meters';

      updateCollaborationPrivileges();
    }

    function updateEditability() {
      vm.canEditDimensions = (vm.sceneCount === 0);
      vm.canEditDimensions = vm.canEditDimensions && (vm.setPieceCount === 0);
      vm.canEditDimensions = vm.canEditDimensions && !(angular.isArray(vm.production.permanentlayeritemIds) && (vm.production.permanentlayeritemIds.length > 0));
    }

    function blurValidateNumber(event) {
      var value = parseFloat(event.target.value);
      if (Number.isNaN(value) || (value < 0)) {
        event.target.value = 0.0;
      } else {
        event.target.value = value;
      }
    }

    function canEditPermanentStage() {
      return isStageDimensionSet();
    }

    function editPermanentStage() {
      if (!vm.activeAccessRules.alloweditpermanentstage) {
        return;
      }

      $q.when(saveUpdate(true)).then(
        function (validated) {
          if (validated) {
            var params = {
              productionId: selectedProductionId,
            };
            swaUtils.stateGo(swaRouterStateNames.permanentstageeditor, params);
          }
        }
      ).catch(
        function (error) {
          $log.warn('Cannot edit due to:', error);
        }
      );
    }

    function canEditCustomNumberline() {
      return isStageDimensionSet();
    }

    function editCustomNumberline() {
      if (!vm.activeAccessRules.alloweditcustomnumberline) {
        return;
      }

      $q.when(saveUpdate(true)).then(
        function (validated) {
          if (validated) {
            var params = {
              productionId: selectedProductionId,
            };
            swaUtils.stateGo(swaRouterStateNames.productionsettings.customnumberline, params);
          }
        }
      ).catch(
        function (error) {
          $log.warn('Cannot edit due to:', error);
        }
      );
    }

    function isStageDimensionSet() {
      if (angular.isDefined(vm.production) && angular.isDefined(vm.production.stagesettings)) {
        var updatedDepth = parseFloat(vm.production.stagesettings.stagedepth) || 0.0;
        var updatedWidth = parseFloat(vm.production.stagesettings.stagewidth) || 0.0;
        var updatedOffstageWidth = parseFloat(vm.production.stagesettings.offstagewidth) || 0.0;

        return !((vm.production.stagesettings.stagedepth <= 0.0) || (vm.production.stagesettings.stagewidth <= 0.0) || (vm.production.stagesettings.offstagewidth < 0.0));
      } else {
        return false;
      }
    }

    function saveUpdate(noRefresh) {
      if (!vm.activeAccessRules.alloweditdimensions) {
        return true;
      }

      noRefresh = (noRefresh === true) || false;

      var updatedProduction = {};
      var shouldUpdate = false;
      if (vm.canEditDimensions) {
        vm.production.stagesettings.stagedepth = parseFloat(vm.production.stagesettings.stagedepth) || 0.0;
        vm.production.stagesettings.stagewidth = parseFloat(vm.production.stagesettings.stagewidth) || 0.0;
        vm.production.stagesettings.offstagewidth = parseFloat(vm.production.stagesettings.offstagewidth) || 0.0;

        if (!angular.equals(vm.originalProduction.stagesettings, vm.production.stagesettings)) {
          var validationMessages = [];
          if ((vm.production.stagesettings.stagedepth <= 0.0) || (vm.production.stagesettings.stagewidth <= 0.0)) {
            validationMessages.push($translate.instant('validationmessages.Stage dimensions should be greater than 0.0'));
          }

          if (vm.production.stagesettings.offstagewidth < 0.0) {
            validationMessages.push($translate.instant('validationmessages.Off-stage width cannot be less than 0.0'));
          }

          if (validationMessages.length > 0) {
            var validationMessage = validationMessages.join('</br>');
            toastr.clear();
            toastr.error(
              validationMessage,
              $translate.instant('validationmessages.Please fix the following -'),
              { allowHtml: true }
            );

            return false;
          }

          updatedProduction.stagesettings = angular.copy(vm.production.stagesettings);
          shouldUpdate = true;
        }
      }

      if (!shouldUpdate) {
        $log.info('saveUpdate(): Nothing to save/update.');
        return true;
      }

      var deferred = $q.defer();

      ngProgressLite.start();
      blockUI.start();
      updatedProduction._id = vm.originalProduction._id;
      dbProductions.update(updatedProduction).then(
        function () {
          var message = $translate.instant('messages.Stage Dimensions updated');
          toastr.success(message);
          deferred.resolve(message);
          if (!noRefresh) {
            return getAllData();
          }
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving Stage Dimensions!')
          );
          deferred.reject(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );

      return deferred.promise;
    }

    function updateCollaborationPrivileges() {
      if (vm.activeCollaborationConfig.isProductionOwner === true) {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultOwnerAccessRules);
        }
      } else {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultDenyAccessRules);
          var params = {
            accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
            statename: swaRouterStateNames.productionsettings.stagedimensions,
          };
          var dbCollaborationPrivileges = new DbCollaborationPrivileges();

          dbCollaborationPrivileges.getCollaborationPrivileges(params).then(
            function (privilegeData) {
              if (vm.activeCollaborationConfig.collaborationSetting.isMasterCollaborator) {
                if (vm.activePlanRules.planId === 2) {
                  updateActiveAccessRules(defaultViewAccessRules);
                } else {
                  updateActiveAccessRules(defaultOwnerAccessRules);
                }
              } else {
                updateActiveAccessRules(privilegeData.accessrules);
              }
            }
          ).catch(
            function (error) {
              $log.error('SettingsProductionDetailsController.updateCollaborationPrivileges:', error);
            }
          );
        }
      }
    }

    function updateActiveAccessRules(accessRules) {
      if (angular.isDefined(vm.activeCollaborationConfig.isProductionOwner)) {
        angular.extend(vm.activeAccessRules, accessRules);
      } else {
        angular.extend(vm.activeAccessRules, defaultDenyAccessRules);
      }
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toParams.skipValidation) {
        return;
      }

      if (!swaUtils.isRouterCurrentStateName(toState.name) && vm.canEditDimensions) {

        if (saveUpdate() === false) {
          event.preventDefault();
        }
      }
    });

    function getStageWidthInFeet() {
      vm.production.stagesettings.stagewidth = swaUtils.getFinalValueInFeet(vm.setStageWidth);
      vm.setStageWidth = swaUtils.getFeetAndInches(vm.production.stagesettings.stagewidth);
    }

    function getStageDepthInFeet() {
      vm.production.stagesettings.stagedepth = swaUtils.getFinalValueInFeet(vm.setStageDepth);
      vm.setStageDepth = swaUtils.getFeetAndInches(vm.production.stagesettings.stagedepth);
    }

    function getOffStageWidthInFeet() {
      vm.production.stagesettings.offstagewidth = swaUtils.getFinalValueInFeet(vm.setOffStageWidth);
      vm.setOffStageWidth = swaUtils.getFeetAndInches(vm.production.stagesettings.offstagewidth);
    }
  }

}());

/* global Q */
(function () {
  'use strict';

  angular
    .module('swanywhere')
    .controller('SettingsStaffTemplatesListController', SettingsStaffTemplatesListController);

  SettingsStaffTemplatesListController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$translate',
    '$log',
    'ngProgressLite',
    'toastr',
    'DbProductions',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    'DbCollaborationPrivileges',
    '$q',
    'DbStaffs',
  ];

  function SettingsStaffTemplatesListController($scope, $cookies, $stateParams, $translate,
    $log, ngProgressLite, toastr, DbProductions,
    DbSubMgrService, blockUI, swaUtils, swaRouterStateNames,
    DbCollaborationPrivileges, $q, DbStaffs) {

    var vm = this;

    var selectedProductionId = $stateParams.productionId || $cookies.selectedProductionId;
    var dbProductions = new DbProductions();

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowaddtemplates: false,
      allowedittemplates: false,
      allowdeletetemplates: false,
      allowreordertemplates: false,
    };

    var defaultViewAccessRules = angular.extend(defaultDenyAccessRules, {
      planAccessDenied: true,
    });

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowaddtemplates: true,
      allowedittemplates: true,
      allowdeletetemplates: true,
      allowreordertemplates: true,
    };

    vm.userData = {};
    vm.userId = '';

    vm.staffTemplates = [];
    vm.listEditMode = false;

    vm.sortableOptions = {
      handle: '.sortDragHandle',
      cursor: 'ns-resize',
      axis: 'y',
      opacity: 0.8,
      disabled: true,
      stop: sortableDragSortStop,
    };

    vm.onAddTemplate = onAddTemplate;
    vm.onEditToggle = onEditToggle;
    vm.selectStaffTemplateAtIndex = selectStaffTemplateAtIndex;
    vm.deleteStaffTemplateAtIndex = deleteStaffTemplateAtIndex;

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
    };

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.validateActivePlan();
        }
      ).then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        }
      ).then(
        function (plan) {
          updateActivePlanRules(plan);
        }
      ).then(
        function () {
          return getAllData();
        }
      ).catch(
        function (error) {
          $log.error('SettingsStaffTemplatesListController.initialize():', error);
          swaUtils.sessionErrorInterceptor(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
        }
      );
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.fetchById(selectedProductionId, updateDataProduction).catch(
        function (error) {
          deferred.reject(error);
        }
      ).finally(
        function () {
          deferred.resolve();
        }
      );

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;
    }

    function updateDataProduction(id) {
      $log.debug('SettingsStaffTemplatesListController.updateDataProduction(): ' + id + ' -->');

      var selectedProduction = dbProductions.getFetchedById(selectedProductionId);

      if (angular.isUndefined(selectedProduction)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      if (selectedProduction.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(selectedProduction.collaboratorIds) && (selectedProduction.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = selectedProduction.collaborationsettings.find(function (element) {
            return (element.collaboratorId === vm.userId);
          });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error($translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'), $translate.instant('collaborationprivileges.titles.Collaboration Access'));
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          throw new Error('Invalid state');
        }
      }

      vm.staffTemplates = angular.copy(selectedProduction.stafftemplates) || [];

      if ((vm.staffTemplates.length === 0) && vm.listEditMode) {
        onEditToggle();
      }

      updateCollaborationPrivileges();
    }

    function selectStaffTemplateAtIndex(index) {
      if (vm.listEditMode) {
        return;
      }

      if (!(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowedittemplates)) {
        var toastTitle = $translate.instant('collaborationprivileges.titles.Collaboration Access');
        if (vm.activeAccessRules.planAccessDenied) {
          toastTitle = $translate.instant('planprivileges.titles.Plan - Access Denied!');
        }
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to edit score templates'),
          toastTitle
        );

        return;
      }

      var selectedStaffTemplate = vm.staffTemplates[index];
      var params = {
        productionId: selectedProductionId,
        addTemplate: false,
        templateId: selectedStaffTemplate.templateId,
      };

      swaUtils.stateGo(swaRouterStateNames.productionsettings.editstafftemplate, params);
    }

    function onAddTemplate() {
      var params = {
        productionId: selectedProductionId,
        addTemplate: true,
      };

      swaUtils.stateGo(swaRouterStateNames.productionsettings.editstafftemplate, params);
    }

    function onEditToggle() {
      vm.listEditMode = !vm.listEditMode;

      vm.sortableOptions.disabled = !vm.listEditMode;
    }

    function deleteStaffTemplateAtIndex(index) {
      blockUI.start();
      var dbStaffs = new DbStaffs();
      var staffTemplateToDelete = vm.staffTemplates[index];

      dbStaffs.getStaffTemplateReferenceCount(staffTemplateToDelete.templateId).then(
        function (count) {
          if (count > 0) {
            throw new Error($translate.instant('messages.Template is in use'));
          } else {
            return true;
          }
        }
      ).then(
        function () {
          vm.staffTemplates.splice(index, 1);
          for (var i = index, reindex = (index - 1); i < vm.staffTemplates.length; i++) {
            vm.staffTemplates[i].orderingindex = reindex;
            reindex++;
          }

          var updatedProduction = {
            _id: selectedProductionId,
            stafftemplates: angular.copy(vm.staffTemplates),
          };

          return dbProductions.update(updatedProduction);
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error deleting template!')
          );
        }
      ).finally(
        function () {
          if ((vm.staffTemplates.length === 0) && vm.listEditMode) {
            onEditToggle();
          }
          blockUI.stop();
        }
      );
    }

    function sortableDragSortStop(e, ui) {
      var needsUpdate = false;
      for (var i = 0, reindex = 0; i < vm.staffTemplates.length; i++) {
        var aStaffTemplate = vm.staffTemplates[i];
        if (aStaffTemplate.orderingindex !== reindex) {
          aStaffTemplate.orderingindex = reindex;
          needsUpdate = true;
        }

        reindex++;
      }

      if (needsUpdate) {
        ngProgressLite.start();
        blockUI.start();

        var updatedProduction = {
          _id: selectedProductionId,
          stafftemplates: angular.copy(vm.staffTemplates),
        };

        dbProductions.update(updatedProduction).catch(
          function (error) {
            toastr.error('Error saving changes');
          }
        ).finally(
          function () {
            ngProgressLite.done();
            blockUI.stop();
          }
        );
      }
    }

    function updateCollaborationPrivileges() {
      if (vm.activeCollaborationConfig.isProductionOwner === true) {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultOwnerAccessRules);
        }
      } else {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultDenyAccessRules);
          var params = {
            accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
            statename: swaRouterStateNames.productionsettings.stafftemplates,
          };
          var dbCollaborationPrivileges = new DbCollaborationPrivileges();

          dbCollaborationPrivileges.getCollaborationPrivileges(params).then(
            function (privilegeData) {
              updateActiveAccessRules(privilegeData.accessrules);
            }
          ).catch(
            function (error) {
              $log.error('SettingsPerformersListController.updateCollaborationPrivileges:', error);
            }
          );
        }
      }
    }

    function updateActiveAccessRules(accessRules) {
      if (angular.isDefined(vm.activeCollaborationConfig.isProductionOwner)) {
        angular.extend(vm.activeAccessRules, accessRules);
      } else {
        angular.extend(vm.activeAccessRules, defaultDenyAccessRules);
      }

      vm.sortableOptions.disabled = !vm.activeAccessRules.allowreorderperformers;
    }

    $scope.$on('$destroy', function () {
      $log.debug('SettingsStaffTemplatesListController.$destroy -->');
      dbProductions.fetchUnregister();
    });
  }
}());

/* global Q */
(function () {
  'use strict';

  angular
    .module('swanywhere')
    .controller('SettingsStaffTemplateDetailsController', SettingsStaffTemplateDetailsController);

  SettingsStaffTemplateDetailsController.$inject = [
    '$scope',
    '$cookies',
    '$state',
    '$stateParams',
    '$translate',
    'ngProgressLite',
    'toastr',
    'DbProductions',
    'DbSubMgrService',
    'blockUI',
    '$log',
    'swaUtils',
    'swaRouterStateNames',
    '$q',
    'DbStaffs',
  ];

  function SettingsStaffTemplateDetailsController($scope, $cookies, $state, $stateParams,
    $translate, ngProgressLite, toastr, DbProductions,
    DbSubMgrService, blockUI, $log, swaUtils,
    swaRouterStateNames, $q, DbStaffs) {

    var vm = this;
    var ceres = DbSubMgrService.getAsteroid();
    var dbProductions = new DbProductions();

    var selectedProductionId;
    var selectedTemplateId;

    vm.addTemplateMode = false;
    vm.template = getBlankTemplate();
    vm.canEditTemplate = true;

    vm.columnsPerCountsSteps = [3, 4, 6, 32];

    vm.onChangeColumnsPerCount = onChangeColumnsPerCount;
    vm.onChangeDetailRowCount = onChangeDetailRowCount;
    vm.onHasColumnHeaderRowChange = onHasColumnHeaderRowChange;
    vm.onCancel = onCancel;
    vm.saveUpdate = saveUpdate;

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      vm.addTemplateMode = $stateParams.addTemplate || false;
      selectedTemplateId = $stateParams.templateId;

      if (!vm.addTemplateMode) {
        if (angular.isUndefined(selectedTemplateId)) {
          var params = {productionId: selectedProductionId};
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.stafftemplates, params, true);
          return;
        }
      }

      ngProgressLite.start();
      blockUI.start();

      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return getAllData();
        }
      ).catch(
        function (error) {
          swaUtils.sessionErrorInterceptor(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
          if (vm.addTemplateMode) {
            angular.element('input#templateName').focus();
          }
        }
      );
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId).then(
        function (production) {
          if (vm.addTemplateMode) {
              return getBlankTemplate();
          } else {
            return getTemplateFromProduction(production, selectedTemplateId);
          }
        }
      ).then(
        function (template) {
          if (angular.isUndefined(template)) {
            var params = {productionId: selectedProductionId};
            swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.stafftemplates, params, true);

            throw new Error('Template not found!');
          } else {
            vm.template = angular.copy(template);
          }
        }
      ).then(
        function() {
          if (!vm.addTemplateMode) {
            return checkTemplateEditability(vm.template.templateId);
          } else {
            return true;
          }
        }
      ).then(
        function (editability) {
          vm.canEditTemplate = editability;
        }
      ).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function (error) {
          deferred.reject(error);
        }
      ).finally(
        function () {
          deferred.resolve();
        }
      );

      return deferred.promise;
    }

    function getTemplateFromProduction(production, templateId) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      var staffTemplates = angular.copy(production.stafftemplates) || [];
      var template = _.findWhere(staffTemplates, {templateId: templateId});

      return template;
    }

    function checkTemplateEditability(templateId) {
      var deferred = $q.defer();
      var dbStaffs = new DbStaffs();

      dbStaffs.getStaffTemplateReferenceCount(templateId).then(
        function (count) {
          deferred.resolve((count === 0));
        }
      ).catch(
        function (error) {
          deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    function getBlankTemplate() {
      var templ = {
        templatename: '',
        displayname: '',
        displaycountprefix: false,
        defaultcount: 8,
        columnspercount: 4,
        allowadddeletecount: true,
        hascolumnheaderrow: true,
        countindexcolumn: 0,
        voicerowcount: 1,
        detailrowcount: 3,
        columnlabels: ['', '', '', '',],
        detailrowlabels: ['', '', '',],
      };

      return templ;
    }

    function onChangeColumnsPerCount(value) {
      if (value === 32) {
        vm.template.allowadddeletecount = false;
        vm.template.hascolumnheaderrow = false;
        vm.template.defaultcount = 1;

        vm.dialogueMode = true;
        return;
      }

      vm.dialogueMode = false;

      var diff = vm.template.columnlabels.length - value;
      if (diff === 0) {
        return;
      }

      if (diff < 0) {
        // Increment
        for (var i = diff; i < 0; i++) {
          vm.template.columnlabels.push('');
        }
      } else {
        vm.template.columnlabels.splice(value);
      }
    }

    function onHasColumnHeaderRowChange() {
      onChangeColumnsPerCount(vm.template.columnspercount);
    }

    function onChangeDetailRowCount(value) {
      var diff = vm.template.detailrowlabels.length - value;
      if (diff === 0) {
        return;
      }

      if (diff < 0) {
        // Increment
        for (var i = diff; i < 0; i++) {
          vm.template.detailrowlabels.push('');
        }
      } else {
        vm.template.detailrowlabels.splice(value);
      }
    }

    function saveUpdate() {
      var validationMessages = [];

      if (vm.template.templatename.length === 0) {
        validationMessages.push($translate.instant('validationmessages.Template name is required'));
      }

      if (validationMessages.length > 0) {
        toastr.clear();
        toastr.warning(
          '<ul><li>' + validationMessages.join('</li><li>') + '</li></ul>',
          $translate.instant('validationmessages.Please fix the following -'),
          {allowHtml: true}
        );

        return false;
      }

      var templateData = angular.copy(vm.template);
      if (angular.isUndefined(templateData.displayname) || (templateData.displayname === null) || (templateData.displayname.length === 0)) {
        templateData.displayname = templateData.templatename;
      }
      if (templateData.hascolumnheaderrow === false) {
        templateData.columnlabels = [];
      }

      if (angular.isUndefined(templateData.templateId)) {
        saveTemplate(templateData);
      } else {
        updateTemplate(templateData);
      }
    }

    function saveTemplate(templateData) {
      ngProgressLite.start();
      blockUI.start();

      dbProductions.addStaffTemplate(selectedProductionId, templateData).then(
        function () {
          if (vm.addTemplateMode) {
            toastr.success('Template saved');
          } else {
            toastr.success('Template updated');
          }

          var params = {productionId: selectedProductionId};
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.stafftemplates, params, true);
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving template!')
          );
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );
    }

    function updateTemplate(templateData) {
      ngProgressLite.start();
      blockUI.start();

      dbProductions.updateStaffTemplate(selectedProductionId, templateData).then(
        function () {
          if (vm.addTemplateMode) {
            toastr.success('Template saved');
          } else {
            toastr.success('Template updated');
          }

          var params = {productionId: selectedProductionId};
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.stafftemplates, params, true);
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error updating template!')
          );
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );
    }

    function onCancel() {
      var params = {productionId: selectedProductionId};
      swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.stafftemplates, params, true);
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toParams.skipValidation) {
        return;
      }

      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        toastr.clear();
        toastr.warning($translate.instant('messages.Please \'Save\' or \'Cancel\' your changes to this Score Template.'));
        event.preventDefault();
      }
    });
  }
})();

/* global SWChartItem, Q */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsSetPiecesListController', SettingsSetPiecesListController);

  SettingsSetPiecesListController.$inject = [
    '$scope',
    '$cookies',
    '$state',
    '$stateParams',
    '$translate',
    '$log',
    'ngProgressLite',
    'toastr',
    'DbProductions',
    'DbSetPieces',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    'DbCollaborationPrivileges',
    '$q',
  ];

  function SettingsSetPiecesListController($scope, $cookies, $state, $stateParams, $translate, $log, ngProgressLite, toastr,
    DbProductions, DbSetPieces, DbSubMgrService, blockUI, swaUtils, swaRouterStateNames, DbCollaborationPrivileges, $q) {

    var vm = this;
    var selectedProductionId;
    var canImportOrCreate = false;

    var dbProductions = new DbProductions();
    var dbSetPieces = new DbSetPieces();

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowimportsetpieces: false,
      allowcreatesetpieces: false,
      alloweditsetpieces: false,
      allowdeletesetpieces: false,
      allowreordersetpieces: false
    };

    var defaultViewAccessRules = angular.extend(defaultDenyAccessRules, {
      planAccessDenied: true,
    });

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowimportsetpieces: true,
      allowcreatesetpieces: true,
      alloweditsetpieces: true,
      allowdeletesetpieces: true,
      allowreordersetpieces: true
    };

    vm.userData = {};
    vm.userId = '';

    vm.setPieces = [];
    vm.listEditMode = false;

    vm.searchStringUpperForSetpice = '';
    vm.searchpersetpiece = '';

    vm.sortableOptions = {
      handle: '.sortDragHandle',
      cursor: 'ns-resize',
      axis: 'y',
      opacity: 0.8,
      disabled: true,
      stop: sortableDragSortStop,
    };

    vm.onSetPieceClick = onSetPieceClick;
    vm.onCreate = onCreate;
    vm.onImport = onImport;
    vm.onEditToggle = onEditToggle;
    vm.deleteSetPieceAtIndex = deleteSetPieceAtIndex;

    vm.searchStringChangedForSetpice = searchStringChangedForSetpice;
    vm.clearSearchForSetpice = clearSearchForSetpice;
    vm.setpieceSearchFilter = setpieceSearchFilter;

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedSetPieces: false,
      allowedNumberOfSetPieces: 0,
    };

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.validateActivePlan();
        }
      ).then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        }
      ).then(
        function (plan) {
          updateActivePlanRules(plan);
        }
      ).then(
        function () {
          return getAllData();
        }
      ).catch(
        function (error) {
          swaUtils.sessionErrorInterceptor(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
        }
      );
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId).then(
        function (production) {
          updateDataProduction(production);
        }
      ).then(
        function () {
          return dbSetPieces.fetchAllInProduction(selectedProductionId, updateDataSetPieces);
        }
      ).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function () {
          deferred.reject();
        }
      );

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;

      vm.activePlanRules.allowUnlimitedSetPieces = plan.planfeatures[18].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedSetPieces) {
        vm.activePlanRules.allowedNumberOfSetPieces = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfSetPieces = plan.planfeatures[18].featurevalue;
      }
    }

    function updateDataProduction(production) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist);
        throw new Error('Invalid state');
      }

      vm.production = angular.copy(production);

      if (production.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(production.collaboratorIds) && (production.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = production.collaborationsettings.find(function (element) {
            return (element.collaboratorId === vm.userId);
          });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error(
            $translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          throw new Error('Invalid state');
        }
      }

      DbSubMgrService.setSelectedProduction(production);

      var stageWidth = parseInt(production.stagesettings.stagewidth);
      var stageDepth = parseInt(production.stagesettings.stagedepth);
      canImportOrCreate = ((stageWidth > 0) && (stageDepth > 0));

      updateCollaborationPrivileges();
    }

    function updateDataSetPieces(id) {
      $log.debug('SettingsSetPiecesListController.updateDataSetPieces(): ' + id + ' -->');

      if (angular.isUndefined(id)) {
        vm.setPieces = dbSetPieces.getFetched(true);
      } else {
        vm.setPieces = vm.setPieces || [];

        var existingSetPiece = swaUtils.findInArrayById(vm.setPieces, id);
        var incomingSetPiece = dbSetPieces.getFetchedById(id);

        var isInsert = (angular.isUndefined(existingSetPiece) && angular.isDefined(incomingSetPiece));
        var isDelete = (angular.isDefined(existingSetPiece) && angular.isUndefined(incomingSetPiece));
        var isUpdate = (angular.isDefined(existingSetPiece) && angular.isDefined(incomingSetPiece));

        if (isInsert) {
          vm.setPieces.push(incomingSetPiece);
          swaUtils.sortArrayByNumericKey(vm.setPieces, 'orderingindex');
        } else if (isDelete) {
          var existingSetPieceIndex = vm.setPieces.indexOf(existingSetPiece);
          if (existingSetPieceIndex !== -1) {
            vm.setPieces.splice(existingSetPieceIndex, 1);
          }
        } else if (isUpdate) {
          // incoming change/update
          var needsReordering = (existingSetPiece.orderingindex !== incomingSetPiece.orderingindex);

          angular.extend(existingSetPiece, incomingSetPiece);
          if (needsReordering) {
            swaUtils.sortArrayByNumericKey(vm.setPieces, 'orderingindex');
          }
        }
      }

      if ((vm.setPieces.length === 0) && vm.listEditMode) {
        onEditToggle();
      }
    }

    function onSetPieceClick(setPiece) {
      if (vm.listEditMode) {
        return;
      }

      if (!(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.alloweditsetpieces)) {
        var toastTitle = $translate.instant('collaborationprivileges.titles.Collaboration Access');
        if (vm.activeAccessRules.planAccessDenied) {
          toastTitle = $translate.instant('planprivileges.titles.Plan - Access Denied!');
        }
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to edit set pieces'),
          toastTitle
        );
        return;
      }

      var params = {
        productionId: selectedProductionId,
        setPieceId: setPiece._id,
      };
      if (setPiece.setpiecetype === SWChartItem.SetPieceType.Imported) {
        swaUtils.stateGo(swaRouterStateNames.productionsettings.importsetpiece, params);
      } else {
        swaUtils.stateGo(swaRouterStateNames.setpieceeditor, params);
      }
    }

    function onCreate() {
      if (!canImportOrCreate) {
        toastr.clear();
        toastr.warning($translate.instant('messages.Setup stage dimensions before creating or importing a set piece'));
        return;
      }

      var params = {
        productionId: selectedProductionId,
      };
      swaUtils.stateGo(swaRouterStateNames.setpieceeditor, params);
    }

    function onImport() {
      if (!canImportOrCreate) {
        toastr.clear();
        toastr.warning($translate.instant('messages.Setup stage dimensions before creating or importing a set piece'));
        return;
      }

      var params = {
        productionId: selectedProductionId,
      };
      swaUtils.stateGo(swaRouterStateNames.productionsettings.importsetpiece, params);
    }

    function onEditToggle() {
      vm.listEditMode = !vm.listEditMode;

      vm.sortableOptions.disabled = !vm.listEditMode;
    }

    function deleteSetPieceAtIndex(index) {
      blockUI.start();

      var setPieceToDelete = vm.setPieces[index];

      dbSetPieces.delete(setPieceToDelete._id).catch(
        function (error) {
          $log.error('SettingsSetPiecesListController.deleteSetPieceAtIndex:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error deleting set piece!')
          );
        }
      ).finally(
        function () {
          $scope.$applyAsync(function () {
            blockUI.stop();
          });
        }
      );
    }

    function updateSetPieces(setPiecesToUpdate) {
      var updateQs = [];
      for (var k = 0; k < setPiecesToUpdate.length; k++) {
        updateQs.push(dbSetPieces.update(setPiecesToUpdate[k]));
      }

      return $q.all(updateQs);
    }

    function sortableDragSortStop(e, ui) {
      var setPiecesToUpdate = [];
      for (var i = 0, reindex = 0; i < vm.setPieces.length; i++) {
        var aSetPiece = vm.setPieces[i];
        if (aSetPiece.orderingindex !== reindex) {
          setPiecesToUpdate.push({
            _id: aSetPiece._id,
            orderingindex: reindex,
          });
        }

        reindex++;
      }

      if (setPiecesToUpdate.length > 0) {
        blockUI.start();
        updateSetPieces(setPiecesToUpdate).catch(
          function (error) {
            $log.error('SettingsSetPiecesListController.sidebarDragSortStop:', error);
            swaUtils.showErrorToast(error, $translate.instant('errormessages.Error updating order!'));
          }
        ).finally(
          function () {
            $scope.$applyAsync(function () {
              blockUI.stop();
            });
          }
        );
      }
    }

    function updateCollaborationPrivileges() {
      if (vm.activeCollaborationConfig.isProductionOwner === true) {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultOwnerAccessRules);
        }
      } else {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultDenyAccessRules);
          var params = {
            accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
            statename: swaRouterStateNames.productionsettings.setpieces,
          };
          var dbCollaborationPrivileges = new DbCollaborationPrivileges();

          dbCollaborationPrivileges.getCollaborationPrivileges(params).then(
            function (privilegeData) {
              updateActiveAccessRules(privilegeData.accessrules);
            }
          ).catch(
            function (error) {
              $log.error('SettingsSetPiecesListController.updateCollaborationPrivileges:', error);
            }
          );
        }
      }
    }

    function updateActiveAccessRules(accessRules) {
      $scope.$applyAsync(function () {
        if (angular.isDefined(vm.activeCollaborationConfig.isProductionOwner)) {
          angular.extend(vm.activeAccessRules, accessRules);
        } else {
          angular.extend(vm.activeAccessRules, defaultDenyAccessRules);
        }

        vm.sortableOptions.disabled = !vm.activeAccessRules.allowreorderperformers;
      });
    }

    $scope.$on('$destroy', function () {
      dbSetPieces.fetchUnregister();
    });

    function searchStringChangedForSetpice() {
      vm.searchStringUpperForSetpice = vm.searchpersetpiece.toUpperCase();
    }

    function clearSearchForSetpice() {
      vm.searchStringUpperForSetpice = '';
      vm.searchpersetpiece = '';
    }

    function setpieceSearchFilter(setpiece) {
      return setpiece.name.toUpperCase().indexOf(vm.searchStringUpperForSetpice) > -1;
    }
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsScenesListController', SettingsScenesListController);

  SettingsScenesListController.$inject = [
    '$scope',
    '$cookies',
    '$state',
    '$stateParams',
    '$translate',
    '$log',
    '$timeout',
    'ngProgressLite',
    'toastr',
    'DbScenes',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    'DbCollaborationPrivileges',
    'DbProductions',
    '$q'
  ];

  function SettingsScenesListController($scope, $cookies, $state, $stateParams, $translate, $log,
    $timeout, ngProgressLite, toastr, DbScenes, DbSubMgrService, blockUI, swaUtils, swaRouterStateNames,
    DbCollaborationPrivileges, DbProductions, $q) {
    var vm = this;
    var pvm = $scope.$parent;

    var selectedProductionId;
    var canAddScenes = false;

    var dbScenes = new DbScenes();
    var dbProductions = new DbProductions();

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowaddscenes: false,
      alloweditscenename: false,
      allowdeletescenes: false,
      allowreorderscenes: false
    };

    var defaultViewAccessRules = angular.copy(defaultDenyAccessRules);

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowaddscenes: true,
      alloweditscenename: true,
      allowdeletescenes: true,
      allowreorderscenes: true
    };

    vm.userData = {};
    vm.production = {};
    vm.userId = '';

    vm.scenes = [];
    vm.continuousAddMode = false;
    vm.inlineEditMode = false;
    vm.inlineEditIndex = -1;
    vm.listEditMode = false;

    vm.sortableOptions = {
      handle: '.sortDragHandle',
      cursor: 'ns-resize',
      axis: 'y',
      opacity: 0.8,
      disabled: true,
      stop: sortableDragSortStop,
    };

    vm.onUpdateSceneName = onUpdateSceneName;
    vm.onNewSceneNameEntered = onNewSceneNameEntered;
    vm.onDoubleClick = onDoubleClick;
    vm.onAdd = onAdd;
    vm.onEditToggle = onEditToggle;
    vm.endAnyAddEdit = endAnyAddEdit;
    vm.deleteSceneAtIndex = deleteSceneAtIndex;

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedScenes: false,
      allowedNumberOfScenes: 0,
    };

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.validateActivePlan();
        }
      ).then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        }
      ).then(
        function (plan) {
          updateActivePlanRules(plan);
        }
      ).then(
        function () {
          return getAllData();
        }
      ).catch(
        function (error) {
          $log.error('SettingsScenesListController.sessionCheckAndRun: Error:', error);
          swaUtils.sessionErrorInterceptor(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
        }
      );
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId).then(
        function (production) {
          updateDataProduction(production);
        }
      ).then(
        function () {
          return dbScenes.fetchAllInProduction(selectedProductionId, updateDataScenes);
        }
      ).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function (error) {
          deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;

      vm.activePlanRules.allowUnlimitedScenes = plan.planfeatures[3].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedScenes) {
        vm.activePlanRules.allowedNumberOfScenes = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfScenes = plan.planfeatures[3].featurevalue;
      }
    }

    function updateDataProduction(production) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error('Invalid state');
      }

      vm.production = angular.copy(production);

      if (production.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(production.collaboratorIds) && (production.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = production.collaborationsettings.find(function (element) {
            return (element.collaboratorId === vm.userId);
          });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error($translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access'));
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          throw new Error('Invalid state');
        }
      }

      var stageWidth = parseInt(production.stagesettings.stagewidth);
      var stageDepth = parseInt(production.stagesettings.stagedepth);
      canAddScenes = ((stageWidth > 0) && (stageDepth > 0));

      updateCollaborationPrivileges();
    }

    function updateDataScenes(id) {
      $log.debug('SettingsScenesListController.updateDataScenes(): ' + id + ' -->');

      if (angular.isUndefined(id)) {
        vm.scenes = dbScenes.getFetched(true);
      } else {
        vm.scenes = vm.scenes || [];

        var existingScene = swaUtils.findInArrayById(vm.scenes, id);
        var incomingScene = dbScenes.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingScene) && swaUtils.isUndefinedOrNull(incomingScene));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));

        if (isInsert) {
          vm.scenes.push(incomingScene);
          swaUtils.sortArrayByNumericKey(vm.scenes, 'orderingindex');
        } else if (isDelete) {
          var existingSceneIndex = vm.scenes.indexOf(existingScene);
          if (existingSceneIndex !== -1) {
            vm.scenes.splice(existingSceneIndex, 1);
          }
        } else if (isUpdate) {
          var needsReordering = (existingScene.orderingindex !== incomingScene.orderingindex);

          angular.extend(existingScene, incomingScene);
          if (needsReordering) {
            swaUtils.sortArrayByNumericKey(vm.scenes, 'orderingindex');
          }
        }
      }

      if (vm.scenes.length >= vm.activePlanRules.allowedNumberOfScenes) {
        endAnyAddEdit();
      }

      if ((vm.scenes.length === 0) && vm.listEditMode) {
        vm.onEditToggle();
      }
    }

    function onUpdateSceneName(sceneObject) {
      var newSceneName = sceneObject.newSceneName;
      if (newSceneName.length === 0) {
        toastr.error($translate.instant('validationmessages.Scene name cannot be empty.'));
        sceneObject.newSceneName = sceneObject.scenename;
        return;
      }

      blockUI.start();
      var updatedSceneObject = {
        _id: sceneObject._id,
        scenename: newSceneName,
      };

      var success = false;
      dbScenes.update(updatedSceneObject).then(
        function () {
          success = true;
        }
      ).catch(
        function (error) {
          $log.error('SettingsScenesListController.onUpdateSceneName:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error updating scene!'));
        }
      ).finally(
        function () {
          if (success) {
            vm.endAnyAddEdit();
          }
          blockUI.stop();
        }
      );
    }

    function onNewSceneNameEntered() {
      if (vm.newSceneName.length === 0) {
        vm.endAnyAddEdit();
      } else {
        blockUI.start();

        var newScene = {
          productionId: selectedProductionId,
          scenename: vm.newSceneName,
        };

        var success = false;
        dbScenes.insert(newScene).then(
          function () {
            success = true;
          }
        ).catch(
          function (error) {
            $log.error('SettingsScenesListController.onNewSceneNameEntered(): error: ', error);
            swaUtils.showErrorToast(error, $translate.instant('errormessages.Error adding scene!'));
          }
        ).finally(
          function () {
            if (success) {
              vm.newSceneName = '';
              $('.settingsDetailPanel').parent().scrollTo($('#newscenename'));
            }
            blockUI.stop();
          }
        );
      }
    }

    function onDoubleClick(index) {
      if (!vm.activeAccessRules.alloweditscenename) {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to edit scene names'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
        return;
      }

      vm.listEditMode = false;

      if (vm.inlineEditMode || vm.continuousAddMode) {
        vm.endAnyAddEdit();
      }

      vm.inlineEditMode = true;
      vm.inlineEditIndex = index;
      vm.scenes[index].newSceneName = vm.scenes[index].scenename;
      var inputElementName = '#editscenename_' + index;
      $timeout(function () {
        angular.element(inputElementName).focus();
      }, 100);
    }

    function onAdd() {
      if (!canAddScenes) {
        toastr.clear();
        toastr.warning($translate.instant('messages.Setup stage dimensions before adding scenes'));
        return;
      }

      if (vm.listEditMode) {
        vm.onEditToggle();
      }

      if (vm.inlineEditMode || vm.continuousAddMode) {
        vm.endAnyAddEdit();
      }

      vm.newSceneName = '';
      vm.continuousAddMode = true;
      $timeout(function () {
        angular.element('#newscenename').focus();
        $('.settingsDetailPanel').parent().scrollTo($('#newscenename'));
      }, 100);
    }

    function onEditToggle() {
      if (vm.listEditMode) {
        vm.listEditMode = false;
      } else {
        if (vm.inlineEditMode || vm.continuousAddMode) {
          vm.endAnyAddEdit();
        }

        vm.listEditMode = true;
      }

      vm.sortableOptions.disabled = !vm.listEditMode;
    }

    function endAnyAddEdit() {
      vm.continuousAddMode = false;
      vm.inlineEditMode = false;
      vm.inlineEditIndex = -1;
    }

    function deleteSceneAtIndex(index) {
      blockUI.start();

      var sceneToDelete = vm.scenes[index];

      dbScenes.delete(sceneToDelete._id).catch(
        function (error) {
          $log.error('SettingsScenesListController.deleteSceneAtIndex:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error deleting scene!'));
        }
      ).finally(
        function () {
          blockUI.stop();
        }
      );
    }

    function updateScenes(scenesToUpdate) {
      var updateQs = [];
      for (var k = 0; k < scenesToUpdate.length; k++) {
        updateQs.push(dbScenes.update(scenesToUpdate[k]));
      }

      return $q.all(updateQs);
    }

    function sortableDragSortStop(e, ui) {
      var scenesToUpdate = [];
      for (var i = 0, reindex = 0; i < vm.scenes.length; i++) {
        var aScene = vm.scenes[i];
        if (aScene.orderingindex !== reindex) {
          scenesToUpdate.push({
            _id: aScene._id,
            orderingindex: reindex,
          });
        }

        reindex++;
      }

      if (scenesToUpdate.length > 0) {
        blockUI.start();
        updateScenes(scenesToUpdate).catch(
          function (error) {
            $log.error('SettingsScenesListController.sidebarDragSortStop:', error);
            swaUtils.showErrorToast(error, $translate.instant('errormessages.Error updating order!'));
          }
        ).finally(
          function () {
            blockUI.stop();
          }
        );
      }
    }

    function updateCollaborationPrivileges() {
      if (vm.activeCollaborationConfig.isProductionOwner === true) {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultOwnerAccessRules);
        }
      } else {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultDenyAccessRules);
          var params = {
            accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
            statename: swaRouterStateNames.productionsettings.scenes,
          };
          var dbCollaborationPrivileges = new DbCollaborationPrivileges();

          dbCollaborationPrivileges.getCollaborationPrivileges(params).then(
            function (privilegeData) {
              updateActiveAccessRules(privilegeData.accessrules);
            }
          ).catch(
            function (error) {
              $log.error('SettingsPerformersListController.updateCollaborationPrivileges:', error);
            }
          );
        }
      }
    }

    function updateActiveAccessRules(accessRules) {
      if (angular.isDefined(vm.activeCollaborationConfig.isProductionOwner)) {
        angular.extend(vm.activeAccessRules, accessRules);
      } else {
        angular.extend(vm.activeAccessRules, defaultDenyAccessRules);
      }

      vm.sortableOptions.disabled = !vm.activeAccessRules.allowreorderperformers;
    }

    $scope.$on('$destroy', function () {
      dbScenes.fetchUnregister();
    });
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsProductionDetailsController', SettingsProductionDetailsController);

  SettingsProductionDetailsController.$inject = [
    '$scope',
    '$cookies',
    '$translate',
    '$state',
    '$stateParams',
    '$log',
    'swaUtils',
    'DbProductions',
    'resizeService',
    'usSpinnerService',
    'ngProgressLite',
    'toastr',
    'DbSubMgrService',
    'blockUI',
    'swaRouterStateNames',
    'DbCollaborationPrivileges',
    '$q',
  ];

  function SettingsProductionDetailsController($scope, $cookies, $translate, $state, $stateParams, $log,
    swaUtils, DbProductions, resizeService, usSpinnerService, ngProgressLite, toastr, DbSubMgrService, blockUI, swaRouterStateNames, DbCollaborationPrivileges, $q) {

    var vm = this;
    var selectedProductionId;
    var dbProductions = new DbProductions();

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowsavechanges: false,
      alloweditproductionname: false,
      alloweditbookname: false,
      alloweditmusicianname: false,
      alloweditlyricistname: false,
      alloweditdirectorname: false,
      alloweditchoreographername: false,
      alloweditlogo: false,
      allowedittheatername: false,
      alloweditproductiondate: false,
    };

    var defaultViewAccessRules = angular.copy(defaultDenyAccessRules);

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowsavechanges: true,
      alloweditproductionname: true,
      alloweditbookname: true,
      alloweditmusicianname: true,
      alloweditlyricistname: true,
      alloweditdirectorname: true,
      alloweditchoreographername: true,
      alloweditlogo: true,
      allowedittheatername: true,
      alloweditproductiondate: true,
    };

    vm.userData = {};
    vm.userId = '';

    vm.originalProduction = {};
    vm.production = {};

    vm.processFile = processFile;
    vm.openDatePicker = openDatePicker;
    vm.clearProductionDate = clearProductionDate;
    vm.clearLogo = clearLogo;
    vm.saveUpdate = saveUpdate;

    // Datepicker Configuration
    vm.datePickerConfig = {
      minMode: 'day',
      maxMode: 'day',
      open: false,
      format: 'MMM dd, yyyy',
      options: {
        showWeeks: false,
      }
    };

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
    };

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.validateActivePlan();
        }
      ).then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        }
      ).then(
        function (plan) {
          updateActivePlanRules(plan);
        }
      ).then(
        function () {
          return getAllData();
        }
      ).catch(
        function (error) {
          swaUtils.sessionErrorInterceptor(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
        }
      );
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId).then(
        function (production) {
          updateDataProduction(production);
        }
      ).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function () {
          deferred.reject();
        }
      );

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;
    }

    function updateDataProduction(production) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      vm.originalProduction = angular.copy(production)
      vm.production = angular.copy(production);

      if (vm.production.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(vm.production.collaboratorIds) && (vm.production.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = vm.production.collaborationsettings.find(function (element) {
            return (element.collaboratorId === vm.userId);
          });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error($translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'), $translate.instant('collaborationprivileges.titles.Collaboration Access'));
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          return;
        }
      }

      updateCollaborationPrivileges();
    }

    function saveUpdate(noRefresh) {
      if (!vm.activeAccessRules.allowsavechanges) {
        return true;
      }

      noRefresh = (noRefresh === true) || false;

      var updatedProduction = {};
      var shouldUpdate = false;

      if (!angular.isString(vm.production.name) || (vm.production.name.length === 0)) {
        toastr.error('Production name is required!');
        return false;
      }

      if (!angular.equals(vm.production.name, vm.originalProduction.name)) {
        updatedProduction.name = vm.production.name;
        shouldUpdate = true;
      }

      if (!angular.equals(vm.production.logo, vm.originalProduction.logo)) {
        updatedProduction.logo = vm.production.logo;
        shouldUpdate = true;
      }

      if (!angular.equals(vm.production.details, vm.originalProduction.details)) {
        updatedProduction.details = angular.copy(vm.production.details);
        shouldUpdate = true;

        if (angular.isUndefined(vm.production.details.productiondate)) {
          updatedProduction.details.productiondate = '$unset';
        }
      }

      if (!shouldUpdate) {
        $log.info('saveUpdate(): Nothing to save/update.');
        return true;
      }

      ngProgressLite.start();
      blockUI.start();
      updatedProduction._id = vm.originalProduction._id;
      dbProductions.update(updatedProduction).then(
        function () {
          toastr.success('Production details updated.');
          if (!noRefresh) {
            return getAllData();
          }
        }
      ).catch(
        function (reason) {
          $log.error('dbProduction.update - error:', reason);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error saving changes!'));
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );

      return true;
    }

    function processFile(dataUrl, error) {
      if (error) {
        swaUtils.showErrorToast(
          error,
          'Error assigning logo image'
        );
        return;
      }

      usSpinnerService.spin('spinner-img');
      var resizeOptions = {
        height: 110,
        outputFormat: 'image/png',
      };
      resizeService.resizeImage(dataUrl, resizeOptions).then(
        function (image) {
          vm.production.logo = image.substring(22);
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(error, $translate.instant('messages.Error assigning logo image'));
        }
      ).finally(
        function () {
          usSpinnerService.stop('spinner-img');
        }
      );
    }

    function openDatePicker($event) {
      $event.preventDefault();
      $event.stopPropagation();
      vm.datePickerConfig.open = true;
    }

    function clearProductionDate() {
      delete vm.production.details.productiondate;
    }

    function clearLogo() {
      vm.production.logo = '';
    }

    function updateCollaborationPrivileges() {
      if (vm.activeCollaborationConfig.isProductionOwner === true) {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultOwnerAccessRules);
        }
      } else {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultDenyAccessRules);
          var params = {
            accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
            statename: swaRouterStateNames.productionsettings.details,
          };
          var dbCollaborationPrivileges = new DbCollaborationPrivileges();

          dbCollaborationPrivileges.getCollaborationPrivileges(params).then(
            function (privilegeData) {
              if (vm.activeCollaborationConfig.collaborationSetting.isMasterCollaborator) {
                if (vm.activePlanRules.planId === 2) {
                  updateActiveAccessRules(defaultViewAccessRules);
                } else {
                  updateActiveAccessRules(defaultOwnerAccessRules);
                  vm.activeAccessRules.alloweditproductionname = false;
                }
              } else {
                updateActiveAccessRules(privilegeData.accessrules);
              }
            }
          ).catch(
            function (error) {
              $log.error('SettingsProductionDetailsController.updateCollaborationPrivileges:', error);
            }
          );
        }
      }
    }

    function updateActiveAccessRules(accessRules) {
      if (angular.isDefined(vm.activeCollaborationConfig.isProductionOwner)) {
        angular.extend(vm.activeAccessRules, accessRules);
      } else {
        angular.extend(vm.activeAccessRules, defaultDenyAccessRules);
      }
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toState.name === 'productionlist') {
        return;
      }

      if (toState.name !== $state.current.name) {
        if (!saveUpdate(true)) {
          event.preventDefault();
        }
      }
    });

  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsPreferencesController', SettingsPreferencesController);

  SettingsPreferencesController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$log',
    '$timeout',
    'ngProgressLite',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    'DbProductions',
    'DbUserProductions',
    '$q',
    'swaUi',
  ];

  function SettingsPreferencesController($scope, $cookies, $stateParams, $log,
    $timeout, ngProgressLite, DbSubMgrService, blockUI, swaUtils, swaRouterStateNames, DbProductions, DbUserProductions, $q, swaUi) {
    var vm = this;

    var selectedProductionId;

    var dbProductions = new DbProductions();
    var dbUserProductions = new DbUserProductions();

    vm.originalProductionPreferences = {};
    vm.userData = {};
    vm.productionPreferences = {};
    vm.userId = '';
    vm.highlightColorPickerOption = swaUi.highlightColorPickerOption;
    vm.colorPickerOption = swaUi.colorPickerOption.palette;
    vm.fontFamilies = swaUi.fontFamilies;
    vm.fontSizeRange = swaUi.fontSizeRange;
    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedScenes: false,
      allowedNumberOfScenes: 0,
    };
    vm.personalContentDefaults = {
      selectedType: 'settingsChartText',
      fillColor: null,
      fontColor: null,
      fontFamily: null,
      fontSize: null,
      bold: false,
      italic: false,
      underline: false
    };

    vm.scrollConfigGenericPopover = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollButtons: {
        enable: false,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
    };

    vm.production = {};
    vm.settingsOptions = {};
    vm.fontSizePicker = {};
    vm.viewSettings = viewSettings;
    vm.editSettings = editSettings;
    vm.fontSizeStepper = fontSizeStepper;
    vm.preview = preview;
    vm.reset = reset;
    vm.colorToRgb = swaUi.colorToRgb;

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.validateActivePlan();
        })
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          vm.userId = DbSubMgrService.getLoggedInUserId();
        })
        .then(function () {
          return getAllData();
        })
        .catch(function (error) {
          $log.error('SettingsPreferencesController.sessionCheckAndRun: Error:', error);
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function getAllData() {
      var deferred = $q.defer();
      dbProductions.findById(selectedProductionId)
        .then(function (production) {
          vm.production = production
        })
        .then(function () {
          getUserProductionPreferences();
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function () {
          deferred.reject();
        });

      return deferred.promise;
    }

    function getUserProductionPreferences() {
      var deferred = $q.defer();
      dbUserProductions.findByProductionId(selectedProductionId)
        .then(function (userProduction) {
          updateDataUserProduction(userProduction);
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function () {
          deferred.reject();
        });

        return deferred.promise;
    }

    $scope.$watch('vm.fontSizePicker.show', function (newValue, oldValue) {
      if (newValue === true) {
        $timeout(function () {
          $('.sw-fontsize-picker .menu-group').mCustomScrollbar(vm.scrollConfigGenericPopover);
        }, 500);
      }
    });

    function viewSettings(type) {
      vm.personalContentDefaults.selectedType = type;
      vm.preview(type, vm.productionPreferences.contentDefaults[type])
    }

    function reset(setting) {
      if (vm.personalContentDefaults.selectedType === 'colorScriptHighlight') {
        vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType] = swaUi.defaultScriptHighlightColor;
      } else {
        vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType] = angular.copy(swaUi.defaultTextStylePreferences);
        vm.viewSettings(vm.personalContentDefaults.selectedType);
      }
    }

    function editSettings(type, data) {
      if (type === 'colorScriptHighlight') {
        vm.productionPreferences.contentDefaults[type] = data;
      } else {
        angular.forEach(data, function (value, key) {
          vm.productionPreferences.contentDefaults[type][key] = value;
        });
      }
      vm.preview(type, vm.productionPreferences.contentDefaults[type]);
    }

    function preview(type, data) {
      if (type === 'colorScriptHighlight') {
        $('#settings-preview').css({
          'background-color': '',
        });
        $('#preview-content').css({
          'color': '#000000',
          'background-color': swaUi.getHighlightBackgroundCss(data),
          'font-family': 'Liberation Sans',
          'font-size': '12px',
          'font-weight': 'normal',
          'font-style': 'normal',
          'text-decoration': 'none'
        }).text('Highlight');
      } else {
        $('#settings-preview').css({
          'background-color': swaUi.colorReplaceIfTransparent(data.fillColor, 'rgb(255, 255, 255')
        });
        $('#preview-content').css({
          'color': data.fontColor,
          'background-color': '',
          'font-family': data.fontFamily,
          'font-size': data.fontSize + vm.fontSizeRange.unit,
          'font-weight': data.bold ? 'bold' : 'normal',
          'font-style': data.italic ? 'italic' : 'normal',
          'text-decoration': data.underline ? 'underline' : 'none'
        }).text('AaBb');
      }
    }

    function fontSizeStepper(type, action) {
      var fontSize = vm.productionPreferences.contentDefaults[type].fontSize;
      fontSize = parseInt(fontSize);
      if (action === '-') {
        if (fontSize - vm.fontSizeRange.incremental >= vm.fontSizeRange.min) {
          fontSize -= vm.fontSizeRange.incremental;
        }
      } else if (action === '+') {
        if (fontSize + vm.fontSizeRange.incremental <= vm.fontSizeRange.max) {
          fontSize += vm.fontSizeRange.incremental;
        }
      }
      vm.editSettings(type, { fontSize: fontSize });
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        savePreferences();
      }
    });

    function savePreferences() {
      var deferred = $q.defer();
      ngProgressLite.start();
      blockUI.start('Saving');
      var preferences = angular.copy(vm.productionPreferences);
      dbUserProductions.update(preferences).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function () {
          deferred.reject();
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );
    }

    function updateDataUserProduction(userProduction) {
      if (angular.isUndefined(userProduction) || angular.isUndefined(userProduction.contentDefaults)) {
        userProduction = dbUserProductions.getNewUserProduction(selectedProductionId, vm.userId, vm.production.productiontype);
      }
      vm.originalProductionPreferences = angular.copy(userProduction);
      vm.productionPreferences = angular.copy(userProduction);

      vm.viewSettings(vm.personalContentDefaults.selectedType);
    }
  }

}());

// jshint maxparams: false
/* global Q, cc, ChartGridView, ChartLayerPermanentEditable, ChartItemViewFactory, SWChartUI, SWChartLayer, ChartEditorScene, ChartShapeVectorEditorView, _, ChartShapeFreehandToolView, SWChartItem */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsPermanentStageEditorController',
    SettingsPermanentStageEditorController);

  SettingsPermanentStageEditorController.$inject = [
    '$scope',
    '$cookies',
    '$state',
    '$stateParams',
    '$rootScope',
    'swaUtils',
    'toastr',
    'DbProductions',
    '$log',
    'DbSubMgrService',
    'ngProgressLite',
    'blockUI',
    '$timeout',
    'DbSetPieces',
    'DbChartItems',
    '$translate',
    '$uibModal',
    '$interval',
    '$document',
    'swaRouterStateNames',
    '$q',
    'swaConfig',
    'swaUi',
    '$localStorage',
  ];

  function SettingsPermanentStageEditorController($scope, $cookies, $state, $stateParams, $rootScope, swaUtils, toastr,
    DbProductions, $log, DbSubMgrService, ngProgressLite, blockUI,
    $timeout, DbSetPieces, DbChartItems, $translate, $uibModal, $interval, $document, swaRouterStateNames, $q, swaConfig, swaUi, $localStorage) {

    var vm = this;
    vm.userData = {};
    vm.scrollConfig = {};
    vm.showHelpBar = false;
    var selectedProductionId;

    var dbProductions = new DbProductions();
    var dbSetPieces = new DbSetPieces();
    var dbChartItems = new DbChartItems();

    var ccRootScene;
    var ccChartEditorLayer;
    var chartBlockUI = blockUI.instances.get('block-ui-chart');

    vm.SWChartItem = SWChartItem;
    vm.selectedProduction = {};
    vm.setPieces = [];

    vm.zoomSliderOptions = {
      floor: 1,
      ceil: 1,
      step: 1,
      showTicks: true,
      onChange: onZoomSliderChange,
    }

    vm.chartTextEditorState = {
      editorPosX: 0,
      editorPosY: 0,
      editorHeight: 0,
      editorWidth: 0,
      rotationAngle: 0,
      editorScale: 0
    }

    vm.chartEditorState = {
      ccInitializationPending: true,
      zoomFactor: 1,
      maxZoomFactor: 1,
      minHZoomOffset: 0,
      maxHZoomOffset: 100,
      hZoomOffset: 0,
      povAudience: true,
    };

    vm.chartInspectorState = {
      selectionCount: -1,
      selectionGrouped: false,
      selectionRotatable: false,
      rotationRad: 0,
      selectionOrderingMode: false,
      selectionEditable: false,
      zIndex: -1,
      selectionColorable: false,
      selectionColor: undefined,
      selectionFillColorable: false,
      selectionFillColor: undefined,
      vectorEditorActive: false,
      vectorEditorNodeSelected: false,
      freehandToolActive: false,
      layerEditorActive: false,
      selectionFlipAble: false,
      selectionRotationMode: false,
      alignMenu: false,
      selectionSnapToGrid: false,
      isContextMenuPinned: $localStorage.isContextMenuPinnedPermanentStage || false,
      textEditorActive: false,
      setPieceSelected: false,
      shapesSelected: false,
      lineThickness: 0,
      lineThicknessForFreehand: chartBaseLineWidth + 2,
      showLineThicknessForFreehand: ((chartBaseLineWidth + 2) / 2) + 1,
    };

    vm.scrollConfigSetPieceList = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollButtons: {
        enable: false,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
    };

    vm.scrollConfigChartPanV = {
      theme: 'swa-chart',
      axis: 'y',
      scrollbarPosition: 'inside',
      scrollButtons: {
        enable: false,
        scrollAmount: 50,
        scrollType: 'stepped',
      },
      autoHideScrollbar: false,
      advanced: {
        updateOnContentResize: false,
      },
      callbacks: {
        whileScrolling: function () {
          onChartPanVScroll(this.mcs.topPct); // eslint-disable-line angular/controller-as-vm
        },
        onScroll: function () {
          onChartPanVScroll(this.mcs.topPct); // eslint-disable-line angular/controller-as-vm
        },
      },
    };

    vm.scrollConfigChartPanH = {
      theme: 'swa-chart',
      axis: 'x',
      scrollbarPosition: 'inside',
      scrollButtons: {
        enable: false,
        scrollAmount: 50,
        scrollType: 'stepped',
      },
      autoHideScrollbar: false,
      advanced: {
        updateOnContentResize: false,
        autoExpandHorizontalScroll: 3,
      },
      callbacks: {
        whileScrolling: function () {
          onChartPanHScroll(this.mcs.leftPct); // eslint-disable-line angular/controller-as-vm
        },
        onScroll: function () {
          onChartPanHScroll(this.mcs.leftPct); // eslint-disable-line angular/controller-as-vm
        },
      },
    };

    vm.chartPanScrollParams = {
      vertical: {
        containerTopOffset: 0,
        containerHeight: 0,
        contentHeight: 0,
      },
      horizontal: {
        containerLeftOffset: 0,
        containerWidth: 0,
        contentWidth: 0,
      },
    };
    /** Position and visibility state of the chart context menu */
    vm.chartContextMenuState = {
      visible: false,
      posX: 0,
      posY: 0
    };

    vm.pinnedPosXOfContextMenuPermanentStage =
      $localStorage.pinnedPosXOfContextMenuPermanentStage !== null && angular.isDefined($localStorage.pinnedPosXOfContextMenuPermanentStage)
        ? $localStorage.pinnedPosXOfContextMenuPermanentStage
        : undefined;

    vm.pinnedPosYOfContextMenuPermanentStage =
      $localStorage.pinnedPosYOfContextMenuPermanentStage !== null && angular.isDefined($localStorage.pinnedPosYOfContextMenuPermanentStage)
        ? $localStorage.pinnedPosYOfContextMenuPermanentStage
        : undefined;

    vm.searchStringUpperForSetpice = '';
    vm.searchpersetpiece = '';

    vm.zoomPicker = {};
    vm.shapePicker = {};
    vm.setPiecePicker = {};
    vm.helpTourVideos = [];

    vm.saveAndClose = saveAndClose;

    vm.shapePickerDidPickShape = shapePickerDidPickShape;
    vm.setPiecePickerDidPickSetPiece = setPiecePickerDidPickSetPiece;
    vm.importSetDesign = importSetDesign;
    vm.addChartText = addChartText;
    vm.onInspectorAction = onInspectorAction;
    vm.onZoomChangeEnd = onZoomChangeEnd;
    vm.updateInspectorState = updateInspectorState;
    vm.editVectorShape = editVectorShape;
    vm.endEditVectorShape = endEditVectorShape;
    vm.shapeEditorSelectedNode = shapeEditorSelectedNode;
    vm.editTextBox = editTextBox;
    vm.endEditTextBox = endEditTextBox;
    vm.markChartDirty = markChartDirty;
    vm.handleChartPanBegin = handleChartPanBegin;
    vm.handleChartPanPan = handleChartPanPan;
    vm.handleChartPanEnd = handleChartPanEnd;
    vm.chartNotifyDataDidChange = chartNotifyDataDidChange;
    vm.chartNotifyDisableChangeTracking = chartNotifyDisableChangeTracking;
    vm.chartNotifyEnableChangeTracking = chartNotifyEnableChangeTracking;
    vm.undoAction = undoAction;
    vm.redoAction = redoAction;

    vm.ccChartPauseUpdates = ccChartPauseUpdates;
    vm.ccChartQuickUpdates = ccChartQuickUpdates;
    vm.ccForceSizeUpdate = ccForceSizeUpdate;

    vm.canvasContainerClick = canvasContainerClick;
    vm.canvasContainerClickDown = canvasContainerClickDown;
    vm.hideChartContextMenu = hideChartContextMenu;
    vm.onContextMenuDragStop = onContextMenuDragStop;

    vm.clearSearchForSetpice = clearSearchForSetpice;
    vm.searchStringChangedForSetpice = searchStringChangedForSetpice;
    vm.setpieceSearchFilter = setpieceSearchFilter;

    initialize();

    function initialize() {
      vm.chartEditorState.ccInitializationPending = true;
      sessionCheckAndRun();
      registerKeyboardHandler();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        })
        .then(function () {
          return getAllData();
        })
        .then(function () {
          initHelpTour();
        })
        .then(null, null, function (progress) {
          ngProgressLite.set(progress);
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId)
        .then(function (production) {
          deferred.notify(0.25);
          updateDataProduction(production);
        })
        .then(function () {
          return dbSetPieces.getStockItems();
        })
        .then(function (setPieces) {
          deferred.notify(0.5);
          updateDataSetPiecesStock(setPieces);
        })
        .then(function () {
          return dbSetPieces.findInProduction(selectedProductionId);
        })
        .then(function (setPieces) {
          deferred.notify(0.75);
          updateDataSetPieces(setPieces);
        })
        .then(function () {
          return loadPermanentStage();
        })
        .then(function () {
          $cookies.put('selectedProductionId', selectedProductionId);
          deferred.notify(1.0);
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function setupLayerViews() {
      vm.chartGridView = new ChartGridView();
      vm.chartGridView.setShowFullGrid(true);
      vm.permanentChartLayerView = new ChartLayerPermanentEditable();
      vm.permanentChartLayerView.delegate = vm;
    }

    function updateDataProduction(production) {
      vm.selectedProduction = angular.copy(production);

      if (angular.isUndefined(vm.selectedProduction)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      DbSubMgrService.setSelectedProduction(vm.selectedProduction);

      vm.chartEditorState.povAudience = true;

      setupCocos();

      dbProductions.fetchUnregister();
    }

    function updateDataProductionPostCocosInit() {
      vm.chartGridView.setProduction(vm.selectedProduction);

      updateChartItemViewFactory();

      vm.permanentChartLayerView.setShowLineOverlapBreaks((vm.selectedProduction.chartsettings.lineoverlapbreaks === true));
      vm.permanentChartLayerView.setPovAudience(true);

      vm.chartEditorState.maxZoomFactor = vm.chartGridView.getMaxStageZoom();
      vm.zoomSliderOptions.ceil = vm.chartGridView.getMaxStageZoom();
      vm.chartEditorState.zoomFactor = vm.chartGridView.getZoomFactor();

      onZoomChangeEnd(true);
    }

    function updateDataSetPiecesStock(setPieces) {
      vm.setPieces = vm.setPieces.concat(setPieces);
      vm.chartItemViewFactory.setPieces = vm.setPieces;
    }

    function updateDataSetPieces(setPieces) {
      vm.setPieces = vm.setPieces.concat(setPieces);
      vm.chartItemViewFactory.setPieces = vm.setPieces;
    }


    function loadPermanentStage() {
      var deferred = $q.defer();

      var iQ1 = $interval(function () {
        if (vm.chartEditorState.ccInitializationPending === false) {
          $interval.cancel(iQ1);
        }
      }, 500, 10);

      iQ1.then(
        function () {
          if (vm.chartEditorState.ccInitializationPending === false) {
            return loadChartItems();
          } else {
            throw new Error('Timeout waiting for editor initialization');
          }
        },
        function () {
          return loadChartItems();
        }
      ).then(
        function () {
          deferred.resolve();
        },
        function (error) {
          deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    function loadChartItems() {
      if (angular.isUndefined(vm.selectedProduction)) {
        return;
      }

      blockUI.start();
      ccChartQuickUpdates();
      dbChartItems.getItemsOfProduction(vm.selectedProduction._id).then(
        function (items) {
          vm.permanentChartLayerView.setChartItems(items);
          vm.permanentChartLayerView.activate(true);
          vm.chartEditorState.layerActive = true;
          vm.chartEditorState.chartOpen = true;

          changeTrackerReset();
          changeTrackerInitialize();
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error loading Permanent Stage!'));
          $log.error('SettingsPermanentStageEditorController.loadChartItems():', error);
          vm.chartEditorState.chartOpen = false;
        }
      ).finally(
        function () {
          blockUI.stop();

          ccChartPauseUpdates();
        }
      );
    }

    function saveAndClose() {
      savePermanentStage().then(
        function () {
          var params = { productionId: selectedProductionId };
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.stagedimensions, params, true);
          delete $localStorage.pinnedPosXOfContextMenuPermanentStage;
          delete $localStorage.pinnedPosYOfContextMenuPermanentStage;
          delete $localStorage.isContextMenuPinnedPermanentStage;
        }
      ).catch(
        function (error) {
          $log.error('SettingsPermanentStageEditorController.saveAndClose:', error);
        }
      );
    }

    function savePermanentStage() {
      var deferred = $q.defer();
      if (angular.isUndefined(vm.selectedProduction)) {
        deferred.resolve();
        return deferred.promise;
      }

      // End any editing
      endEditVectorShape();
      endEditTextBox();

      vm.permanentChartLayerView.clearTransientState();
      vm.permanentChartLayerView.validateData();

      if (vm.selectedProduction.dirty !== true) {
        $log.debug('savePermanentStage: No changes on permanent stage, nothing to save!');
        deferred.resolve();
        return deferred.promise;
      }

      var newChartItems = vm.permanentChartLayerView.getChartItems();

      ngProgressLite.set(0.4);
      dbChartItems.getItemIdsOfProduction(vm.selectedProduction._id).then(
        function (existingChartItemIds) {
          return saveChartItems(newChartItems, existingChartItemIds);
        }
      ).then(
        function () {
          return dbProductions.updateContentModifiedFor(vm.selectedProduction._id, 'permanentLayer');
        }
      ).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function (error) {
          $log.error('SettingsPermanentStageEditorController.savePermanentStage:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error saving chart!'));

          deferred.reject(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );

      return deferred.promise;
    }

    function saveChartItems(newChartItems, existingChartItemIds) {
      var existingItemIds = existingChartItemIds;
      var updatedItemIds = [];
      var updatedItems = [];
      var insertedItems = [];
      var productionId = vm.selectedProduction._id;

      newChartItems.forEach(function (chartItem) {
        var id = chartItem._id;
        if (!id.startsWith('__tmp__')) {
          chartItem.ofproductionId = productionId;
          updatedItemIds.push(id);
          updatedItems.push(chartItem);
        } else {
          delete chartItem._id;
          chartItem.ofproductionId = productionId;
          insertedItems.push(chartItem);
        }
      });
      var deletedItemIds = _.difference(existingItemIds, updatedItemIds);

      var allQ = [];
      insertedItems.forEach(function (insertedItem) {
        allQ.push(dbChartItems.insert(insertedItem));
      });
      updatedItems.forEach(function (updatedItem) {
        allQ.push(dbChartItems.update(updatedItem));
      });
      allQ.push(dbChartItems.delete(deletedItemIds));

      return $q.all(allQ);
    }

    function updateChartItemViewFactory() {
      if (angular.isUndefined(vm.chartItemViewFactory)) {
        vm.chartItemViewFactory = new ChartItemViewFactory();
        vm.chartItemViewFactory.imageDataPrefixUrl = swaConfig.imageDataPrefixUrl;

        vm.permanentChartLayerView.setChartItemViewFactory(vm.chartItemViewFactory);
      }

      if (angular.isDefined(vm.selectedProduction)) {
        vm.chartItemViewFactory.stageUnitWidth = vm.selectedProduction.stagesettings.stagewidth;
        vm.chartItemViewFactory.stageUnitDepth = vm.selectedProduction.stagesettings.stagedepth;
        vm.chartItemViewFactory.offstageUnitWidth = vm.selectedProduction.stagesettings.offstagewidth;
        vm.chartItemViewFactory.swMeasurementUnit = vm.selectedProduction.stagesettings.stagemeasurementunit;
        vm.chartItemViewFactory.numberlineMarkerStepValue = vm.selectedProduction.stagesettings.numberlineMarkerStepValue;
        vm.chartItemViewFactory.numberlineZeroAtCenter = vm.selectedProduction.stagesettings.numberlineZeroAtCenter;
        vm.chartItemViewFactory.numberlineMultiplier = vm.selectedProduction.stagesettings.numberlineMultiplier;
        vm.chartItemViewFactory.verticalNumberlineMarkerStepValue = vm.selectedProduction.stagesettings.verticalNumberlineMarkerStepValue;
        vm.chartItemViewFactory.verticalNumberlineMultiplier = vm.selectedProduction.stagesettings.verticalNumberlineMultiplier;
        vm.chartItemViewFactory.verticalNumberlineZeroOffsetValue = vm.selectedProduction.stagesettings.verticalNumberlineZeroOffsetValue;
      }
    }

    function markChartDirty() {
      vm.selectedProduction.dirty = true;
    }

    $scope.$on('$destroy', function () {
      dbProductions.fetchUnregister();
      dbSetPieces.fetchUnregister();
      unregisterKeyboardHandler();
    });

    function shapePickerDidPickShape(shapeType) {
      vm.shapePicker.show = false;

      if (shapeType === SWChartItem.ShapeType.Freehand) {
        showFreehandTool();
        return;
      }

      vm.permanentChartLayerView.addNewShapeOfType(shapeType);
    }

    function setPiecePickerDidPickSetPiece(setPiece) {
      vm.setPiecePicker.show = false;

      vm.permanentChartLayerView.addNewSetPiece(setPiece);
    }

    function importSetDesign() {
      var modalInstance = $uibModal.open({
        scope: $scope,
        animation: true,
        templateUrl: 'app/components/productionSettings/settingsImportSetDesign.html',
        controller: 'SettingsImportSetDesignController',
        controllerAs: 'vm',
        size: 'lg',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          selectedProduction: function () {
            return vm.selectedProduction;
          },
        },
      });

      modalInstance.result.then(
        function (setPiece) {
          vm.setPieces.push(setPiece);
          vm.permanentChartLayerView.addNewSetPiece(setPiece, true);
          ngProgressLite.done();
          blockUI.reset();
        }
      );
      if (!vm.chartInspectorState.isContextMenuPinned) {
        hideChartContextMenu();
      }
    }

    function addChartText() {
      vm.permanentChartLayerView.addNewTextItem(swaUi.defaultTextStylePreferences);
    }

    $scope.$watch('vm.zoomPicker.show', function (newValue, oldValue) {
      if (newValue === true) {
        $timeout(function () {
          $scope.$broadcast('reCalcViewDimensions');
          $scope.$broadcast('rzSliderForceRender');
        }, 500);
      }
    });

    $scope.$watch('vm.setPiecePicker.show', function (newValue, oldValue) {
      if (newValue === false) {
        clearSearchForSetpice();
        angular.element($document[0].body).removeClass('setpiece-or-performer-picker-active');
      }
      if (newValue === true) {
        $timeout(function () {
          $('.sw-popover-setpiece-picker').mCustomScrollbar(vm.scrollConfigSetPieceList);
          angular.element($document[0].body).addClass('setpiece-or-performer-picker-active');
        }, 500);
      }
    });

    function onZoomSliderChange() {
      onZoomChangeEnd();
    }

    function onZoomChangeEnd(updateInstantly) {
      updateInstantly = updateInstantly || false;

      var oldZoomFactor = Math.round(vm.chartGridView.getZoomFactor());
      if (oldZoomFactor === 1) {
        vm.chartPanScrollParams.vertical.scrollPercent = 50;
        vm.chartPanScrollParams.horizontal.scrollPercent = 50;
      }

      var targetZoomFactor = vm.chartEditorState.zoomFactor;

      ccChartEditorLayer.enablePanGestures((targetZoomFactor !== 1));

      if (updateInstantly) {
        _setZoomFactor(targetZoomFactor);
        // updateChartPanScrollbars();

        return;
      }

      chartBlockUI.start();

      var changeSteps = 10;
      var changeTimeMs = 300;
      var zoomStepDelta = (targetZoomFactor - oldZoomFactor) / changeSteps;
      var zoomFactor = oldZoomFactor;
      var zoomChangeInterval = $interval(function () {
        zoomFactor = zoomFactor + zoomStepDelta;
        _setZoomFactor(zoomFactor);
      }, (changeTimeMs / changeSteps), changeSteps);

      zoomChangeInterval.finally(
        function () {
          updateChartPanScrollbars();
          var updateTimeout = $timeout(function () {
            chartBlockUI.stop();
            $timeout.cancel(updateTimeout);
            updateTimeout = undefined;
          }, 200);
        }
      );
    }

    function _setZoomFactor(zoomFactor) {
      vm.chartGridView.setZoomFactor(zoomFactor);

      // TODO: Not sure if we need to update layer positions
      var stageViewPosition = vm.chartGridView.getStageViewPosition();
      var stageViewSize = vm.chartGridView.getStageViewSize();

      vm.permanentChartLayerView.setPosition(stageViewPosition);
      vm.permanentChartLayerView.setContentSize(stageViewSize);

      vm.permanentChartLayerView.willChangeZoom();

      vm.chartItemViewFactory.scalePxPerUnitX = vm.chartGridView.getScalePxPerUnitX();
      vm.chartItemViewFactory.scalePxPerUnitY = vm.chartGridView.getScalePxPerUnitY();
      vm.chartItemViewFactory.scaledStagePxWidth = vm.chartGridView.getScaledStageBounds().width;
      vm.chartItemViewFactory.scaledStagePxHeight = vm.chartGridView.getScaledStageBounds().height;
      vm.chartItemViewFactory.scaledStagePxOffset = vm.chartGridView.getZoomOffset();
      vm.chartItemViewFactory.stageViewSize = vm.chartGridView.getStageViewSize();
      vm.chartItemViewFactory.zoomFactor = vm.chartGridView.getZoomFactor();

      vm.permanentChartLayerView.refresh();

      var stageViewBounds = vm.chartGridView.getStageViewBounds();
      var scaledStageBounds = vm.chartGridView.getScaledStageBounds();

      vm.chartPanScrollParams.vertical.maxOffset = scaledStageBounds.height - stageViewBounds.height;
      vm.chartPanScrollParams.horizontal.maxOffset = scaledStageBounds.width - stageViewBounds.width;

      updateChartZoomOffset();

      vm.permanentChartLayerView.didChangeZoom();

      ccChartUpdateNow();
    }

    function onChartPanVScroll(scrollPercent) {
      if (!vm.chartPanScrollParams.ignorePan && (vm.chartPanScrollParams.vertical.scrollPercent !== scrollPercent)) {
        vm.chartPanScrollParams.vertical.scrollPercent = scrollPercent;
        updateChartZoomOffset();
      }
    }

    function onChartPanHScroll(scrollPercent) {
      if (!vm.chartPanScrollParams.ignorePan && (vm.chartPanScrollParams.horizontal.scrollPercent !== scrollPercent)) {
        vm.chartPanScrollParams.horizontal.scrollPercent = scrollPercent;
        updateChartZoomOffset();
      }
    }

    function updateChartZoomOffset() {
      var newOffset = {};
      newOffset.x = -vm.chartPanScrollParams.horizontal.maxOffset * vm.chartPanScrollParams.horizontal.scrollPercent / 100;
      newOffset.y = -vm.chartPanScrollParams.vertical.maxOffset * vm.chartPanScrollParams.vertical.scrollPercent / 100;

      vm.chartGridView.setZoomOffset(newOffset);

      vm.chartItemViewFactory.scaledStagePxOffset = vm.chartGridView.getZoomOffset();

      vm.permanentChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());

      ccChartUpdateNow();
    }

    var panRefZoomOffset = {};
    function handleChartPanBegin() {
      panRefZoomOffset = vm.chartGridView.getZoomOffset();
    }

    function handleChartPanPan(beginPoint, point) {
      var panDeltaX = beginPoint.x - point.x;
      var panDeltaY = beginPoint.y - point.y;

      var newOffset = {}
      newOffset.x = panRefZoomOffset.x - panDeltaX;
      newOffset.y = panRefZoomOffset.y - panDeltaY;

      if (vm.chartPanScrollParams.horizontal.maxOffset > 0) {
        vm.chartPanScrollParams.horizontal.scrollPercent = newOffset.x * 100 / -vm.chartPanScrollParams.horizontal.maxOffset;
      }
      if (vm.chartPanScrollParams.vertical.maxOffset > 0) {
        vm.chartPanScrollParams.vertical.scrollPercent = newOffset.y * 100 / -vm.chartPanScrollParams.vertical.maxOffset;
      }

      vm.chartGridView.setZoomOffset(newOffset);

      vm.chartItemViewFactory.scaledStagePxOffset = vm.chartGridView.getZoomOffset();

      vm.permanentChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());

      ccChartUpdateNow();
      // updateChartPanScrollbars();
    }

    function handleChartPanEnd() {
      updateChartPanScrollbars();
    }

    function fitChartToView() {
      if (cc && cc.view) {
        cc.view.setDesignResolutionSize(SWChartUI.DesignWidth, SWChartUI.DesignHeight, cc.ResolutionPolicy.SHOW_ALL);
        ccUpdateViewScale();
        updateChartPanScrollbars();
      }
    }

    function updateInspectorState(caller) {
      if (angular.isUndefined(caller)) {
        if (vm.permanentChartLayerView.getIsActive()) {
          caller = vm.permanentChartLayerView;
        }
      }

      if (angular.isUndefined(caller)) {
        vm.chartInspectorState.selectionCount = 0;
        vm.chartInspectorState.setPieceSelected = false;
        vm.chartInspectorState.shapesSelected = false;
        return;
      }

      var hasGroup = (angular.isDefined(caller.chartItemGroupView));
      var selectionCount = (hasGroup ? 0 : caller.selectedChartItemViews.length);

      vm.chartInspectorState.selectionCount = selectionCount;
      vm.chartInspectorState.selectionGrouped = hasGroup;
      vm.chartInspectorState.canPaste = (angular.isArray(vm.clipboardItems) && (vm.clipboardItems.length > 0));

      if (selectionCount === 1) {
        var activeChartItemView = caller.activeChartItemView;

        vm.chartInspectorState.selectionRotateable = activeChartItemView.getIsRotatable();
        vm.chartInspectorState.rotationDeg = Math.round(activeChartItemView.getViewRotationDeg());

        vm.chartInspectorState.selectionOrderingMode = activeChartItemView.getIsZOrdering();

        vm.chartInspectorState.selectionEditable = activeChartItemView.getIsEditable();

        vm.chartInspectorState.zIndex = activeChartItemView.getZIndex();

        if (activeChartItemView.getItemType() === SWChartItem.Type.Shape) {
          vm.chartInspectorState.selectionColorable = activeChartItemView.getSupportsLineColor();
          vm.chartInspectorState.selectionColor = activeChartItemView.getLineColorCss();

          vm.chartInspectorState.selectionFillColorable = activeChartItemView.getSupportsFillColor();
          vm.chartInspectorState.selectionFillColor = activeChartItemView.getFillColorCss();
        } else {
          vm.chartInspectorState.selectionColorable = false;
          vm.chartInspectorState.selectionFillColorable = false;
        }

        vm.chartInspectorState.selectionFlipAble = activeChartItemView.getIsFlippable();

        if (activeChartItemView.getItemType() === SWChartItem.Type.SetPiece) {
          vm.chartInspectorState.setPieceSelected = true;
        } else {
          vm.chartInspectorState.setPieceSelected = false;
        }
      }

      var selectedChartItemViews = caller.selectedChartItemViews;

      if (vm.chartInspectorState.selectionCount === 0) {
        vm.chartInspectorState.setPieceSelected = false;
        vm.chartInspectorState.shapesSelected = false;
      } else {
        var allShapes = true;
        selectedChartItemViews.forEach(function (chartItemView) {
          var itemType = chartItemView.getItemType();
          if (itemType === SWChartItem.Type.Shape) {
            // do nothing
          } else {
            allShapes = false;
          }
        });

        vm.chartInspectorState.shapesSelected = allShapes;
      }

      if (selectionCount > 1) {
        vm.chartInspectorState.setPieceSelected = false;
      }

      $timeout(function () {
        $scope.$apply();
      });
    }

    function editVectorShape(chartItemShapeView) {
      vm.chartEditorState.zoomFactor = 1.0;
      onZoomChangeEnd(true);

      vm.chartShapeVectorEditorView = new ChartShapeVectorEditorView();
      vm.chartShapeVectorEditorView.delegate = vm;
      vm.chartShapeVectorEditorView.chartItemViewFactory = vm.chartItemViewFactory;
      vm.chartShapeVectorEditorView.setPosition(vm.chartGridView.getStageViewPosition());
      vm.chartShapeVectorEditorView.setContentSize(vm.chartGridView.getStageViewSize());
      ccChartEditorLayer.addChild(vm.chartShapeVectorEditorView);
      ccChartEditorLayer.bringChildToFront(vm.chartShapeVectorEditorView);
      vm.chartShapeVectorEditorView.beginEditingShapeInView(chartItemShapeView);

      vm.chartEditorState.inspectorVisible = true;
      vm.chartInspectorState.vectorEditorActive = true;
      vm.chartInspectorState.vectorEditorNodeSelected = false;
      vm.chartInspectorState.layerEditorActive = true;
      vm.chartInspectorState.lineThickness = (chartItemShapeView.chartItemShape.linethickness / 2) + 1;

      chartItemShapeView.parent.setUserInteractionEnabled(false);

      chartNotifyDisableChangeTracking();
    }

    function endEditVectorShape() {
      if (angular.isDefined(vm.chartShapeVectorEditorView)) {
        var chartItemShapeView = vm.chartShapeVectorEditorView.endEditing();
        ccChartEditorLayer.removeChild(vm.chartShapeVectorEditorView);
        vm.chartShapeVectorEditorView = undefined;

        vm.chartInspectorState.vectorEditorActive = false;
        vm.chartInspectorState.vectorEditorNodeSelected = false;
        vm.chartInspectorState.layerEditorActive = false;

        chartItemShapeView.parent.setUserInteractionEnabled(true);
        chartItemShapeView.refresh();

        chartNotifyEnableChangeTracking();
        chartNotifyDataDidChange();
      }
    }

    function showFreehandTool() {
      vm.chartEditorState.zoomFactor = 1.0;
      onZoomChangeEnd(true);

      vm.chartShapeFreehandToolView = new ChartShapeFreehandToolView();
      vm.chartShapeFreehandToolView.delegate = vm;
      vm.chartShapeFreehandToolView.chartItemViewFactory = vm.chartItemViewFactory;
      vm.chartShapeFreehandToolView.setPosition(vm.chartGridView.getStageViewPosition());
      vm.chartShapeFreehandToolView.setContentSize(vm.chartGridView.getStageViewSize());
      vm.chartShapeFreehandToolView.setHasArrowhead(vm.chartInspectorState.freehandHasArrowhead);
      vm.chartShapeFreehandToolView.setLineColorCss(vm.chartInspectorState.selectionColor);
      ccChartEditorLayer.addChild(vm.chartShapeFreehandToolView);
      ccChartEditorLayer.bringChildToFront(vm.chartShapeFreehandToolView);

      vm.chartShapeFreehandToolView.initializeTool();

      vm.chartEditorState.inspectorVisible = true;
      vm.chartInspectorState.freehandToolActive = true;
      vm.chartInspectorState.layerEditorActive = true;
    }

    function closeFreehandTool() {
      if (angular.isDefined(vm.chartShapeFreehandToolView)) {
        ccChartEditorLayer.removeChild(vm.chartShapeFreehandToolView);
        vm.chartShapeFreehandToolView = undefined;

        vm.chartInspectorState.freehandToolActive = false;
        vm.chartInspectorState.layerEditorActive = false;
      }
    }

    function editTextBox(chartItemTextView) {
      chartItemTextView.setEditing(true);

      vm.chartEditorState.inspectorVisible = true;
      vm.chartInspectorState.textBoxText = '';
      vm.chartInspectorState.textBoxRichText = '';
      vm.chartInspectorState.layerEditorActive = true;

      vm.chartInspectorState.editingChartItemTextView = chartItemTextView;
      // chartItemTextView.parent.setUserInteractionEnabled(false);

      chartNotifyDisableChangeTracking();

      $timeout(function () {
        var canvas = $document[0].getElementById('chartCanvas');
        var canvasContainer = $document[0].getElementById('chartCanvasContainer');

        var canvasContainerWidth = canvasContainer.offsetWidth;
        var canvasContainerHeight = canvasContainer.offsetHeight;
        var canvasWidth = canvas.offsetWidth;
        var canvasHeight = canvas.offsetHeight;

        var element = angular.element('.inspector-texteditor-textarea');
        element.trigger('focus');
        vm.chartInspectorState.textBoxText = chartItemTextView.chartItemText.textcontent;
        if (angular.isUndefined(chartItemTextView.chartItemText.richtextcontent)) {
          vm.chartInspectorState.textBoxRichText = vm.chartInspectorState.textBoxText;
        } else {
          vm.chartInspectorState.textBoxRichText = chartItemTextView.chartItemText.richtextcontent;
        }

        vm.chartInspectorState.selectionBackgroundColor = chartItemTextView.chartItemText.backgroundcolor;

        var startPointX = ((canvasContainerWidth - canvasWidth) / 2) + ((canvasWidth - (chartItemTextView.chartItemViewFactory._stageViewSize.width * vm.ccScaleX)) / 2) + (12 * vm.ccScaleX);
        var startPointY = ((canvasContainerHeight - canvasHeight) / 2) + ((canvasHeight - (chartItemTextView.chartItemViewFactory._stageViewSize.height * vm.ccScaleY)) / 2) - (8 * vm.ccScaleY);

        vm.chartTextEditorState.editorPosX = startPointX + (chartItemTextView.chartItemText.positionx * chartItemTextView.chartItemViewFactory._scalePxPerUnitX * vm.ccScaleX) + (chartItemTextView.chartItemViewFactory._scaledStagePxOffset.x * vm.ccScaleX);
        vm.chartTextEditorState.editorPosY = startPointY + (chartItemTextView.chartItemText.positiony * chartItemTextView.chartItemViewFactory._scalePxPerUnitY * vm.ccScaleY) + (chartItemTextView.chartItemViewFactory._scaledStagePxOffset.y * vm.ccScaleY);

        vm.chartTextEditorState.editorWidth = chartItemTextView.chartItemText.sizewidth * 20 / chartItemTextView.chartItemViewFactory._measurementConversionMultiplier;
        vm.chartTextEditorState.editorHeight = chartItemTextView.chartItemText.sizeheight * 20 / chartItemTextView.chartItemViewFactory._measurementConversionMultiplier;

        vm.chartTextEditorState.rotationAngle = chartItemTextView.chartItemText.rotation * (-180 / Math.PI);
        vm.chartTextEditorState.editorScale = (chartItemTextView.chartItemViewFactory._scalePxPerUnitX * vm.ccScaleX) / 20 * chartItemTextView.chartItemViewFactory._measurementConversionMultiplier;

        vm.chartInspectorState.textEditorActive = true;
      }, 100);
    }

    function endEditTextBox() {
      if (angular.isDefined(vm.chartInspectorState.editingChartItemTextView)) {
        var chartItemTextView = vm.chartInspectorState.editingChartItemTextView;
        vm.chartInspectorState.textEditorActive = false;
        vm.chartInspectorState.editingChartItemTextView = undefined;
        vm.chartInspectorState.layerEditorActive = false;

        chartItemTextView.parent.setUserInteractionEnabled(true);
        chartItemTextView.setEditing(false);
        chartItemTextView.refresh();

        chartNotifyEnableChangeTracking();
        chartNotifyDataDidChange();
      }
    }

    function shapeEditorSelectedNode(selected) {
      $scope.$applyAsync(function () {
        vm.chartInspectorState.vectorEditorNodeSelected = (selected === true);
      });
    }

    function onInspectorAction(action) {
      if (vm.chartEditorState.ccInitializationPending) {
        return;
      }

      var targetLayer;

      if (vm.permanentChartLayerView.getIsActive()) {
        targetLayer = vm.permanentChartLayerView;
      }

      if (angular.isUndefined(targetLayer)) {
        return;
      }

      if (action.type === 'angle') {
        var angle = parseInt(action.value);
        targetLayer.chartInspectorRotationChangedTo(angle);
      } else if (action.type === 'resetAngle') {
        var resetAngle = parseInt(action.value);
        targetLayer.selectedItemRotationReset(resetAngle);
      } else if (action.type === 'increaseThickness') {
        targetLayer.selectedItemIncreaseLineThickness();
      } else if (action.type === 'decreaseThickness') {
        targetLayer.selectedItemDecreaseLineThickness();
      } else if (action.type === 'resetThickness') {
        targetLayer.selectedItemResetLineThickness();
      } else if (action.type === 'increaseThicknessForFreehand') {
        targetLayer.increaseLineThicknessForFreehand();
      } else if (action.type === 'decreaseThicknessForFreehand') {
        targetLayer.decreaseLineThicknessForFreehand();
      } else if (action.type === 'resetThicknessForFreehand') {
        targetLayer.resetLineThicknessForFreehand();
      }
      else if (action.type === 'alignLeft') {
        targetLayer.selectedItemAlignLeft();
      } else if (action.type === 'alignCenter') {
        targetLayer.selectedItemAlignCenter();
      } else if (action.type === 'alignRight') {
        targetLayer.selectedItemAlignRight();
      } else if (action.type === 'alignTop') {
        targetLayer.selectedItemAlignTop();
      } else if (action.type === 'alignMiddle') {
        targetLayer.selectedItemAlignMiddle();
      } else if (action.type === 'alignBottom') {
        targetLayer.selectedItemAlignBottom();
      }
      else if (action.type === 'horizontalSpacing') {
        targetLayer.selectedItemHorizontalSpacing();
      }
      else if (action.type === 'verticalSpacing') {
        targetLayer.selectedItemVerticalSpacing();
      }
      else if (action.type === 'layer') {
        if (action.value === 'begin') {
          targetLayer.chartInspectorBeginOrderingEdit();
        } else if (action.value === 'top') {
          targetLayer.chartInspectorSendItemToTop();
        } else if (action.value === 'up') {
          targetLayer.chartInspectorSendItemUp();
        } else if (action.value === 'down') {
          targetLayer.chartInspectorSendItemDown();
        } else if (action.value === 'bottom') {
          targetLayer.chartInspectorSendItemToBottom();
        } else if (action.value === 'end') {
          targetLayer.chartInspectorEndOrderingEdit();
        }
      } else if (action.type === 'rotation') {
        if (action.value === 'begin') {
          vm.chartInspectorState.selectionRotationMode = true;
        } else if (action.value === 'end') {
          vm.chartInspectorState.selectionRotationMode = false;
        }
        targetLayer.setSelectionRotationMode(vm.chartInspectorState.selectionRotationMode);
      }
      else if (action.type === 'snapToGridMode') {
        if (action.value === 'begin') {
          vm.chartInspectorState.selectionSnapToGrid = true;
        } else if (action.value === 'end') {
          vm.chartInspectorState.selectionSnapToGrid = false;
        }
        targetLayer.setSelectionSnapToGridMode(vm.chartInspectorState.selectionSnapToGrid);
      }
      else if (action.type === 'alignToGrid') {
        targetLayer.selectedItemSnapToGrid();
      }
      else if (action.type === 'color') {
        if (action.value.border) {
          if (vm.chartShapeFreehandToolView) {
            vm.chartShapeFreehandToolView.setLineColorCss(action.value.border);
          } else if (vm.chartShapeVectorEditorView) {
            vm.chartShapeVectorEditorView.setLineColorCss(action.value.border);
          } else {
            targetLayer.chartInspectorSelectionChoseColor(action.value.border);
          }
        } else if (action.value.fill) {
          targetLayer.chartInspectorSelectionChooseFillColor(action.value.fill);
        } else if (action.value.background) {
          targetLayer.chartInspectorSelectionChooseBackgroundColor(action.value.background);
        }
      } else if (action.type === 'clipboard') {
        if (action.value === 'cut') {
          vm.clipboardItems = targetLayer.chartInspectorSelectionCut();
          updateInspectorState();
        } else if (action.value === 'copy') {
          vm.clipboardItems = targetLayer.chartInspectorSelectionCopy();
          updateInspectorState();
        } else if (action.value === 'duplicate') {
          vm.clipboardItems = targetLayer.chartInspectorSelectionDuplicate(); // SWA-ST1-T58 keyboard shortcut for duplicate
        } else if (action.value === 'paste') {
          clipboardPaste(targetLayer);
        }
      } else if (action.type === 'group') {
        targetLayer.chartInspectorSelectionGroupToggle();
      } else if (action.type === 'groups') {
        targetLayer.chartInspectorSelectionGroup(); // SWA-ST1-T58 keyboard shortcut for group
      } else if (action.type === 'ungroups') {
        targetLayer.chartInspectorSelectionUnGroup(); // SWA-ST1-T58 keyboard shortcut for ungroup
      } else if (action.type === 'edit') {
        targetLayer.chartInspectorSelectionEdit();
      } else if (action.type === 'delete') {
        targetLayer.chartInspectorSelectionDelete();
      } else if (action.type === 'clear') {
        if (!targetLayer.chartInspectorSelectionClear()) {
          vm.clipboardItems = [];
          updateInspectorState();
        }
      }
      else if (action.type === 'fliphorizontally') {
        targetLayer.chartInspectorFlipHorizontally();
      } else if (action.type === 'flipvertically') {
        targetLayer.chartInspectorFlipVertically();
      }
      else if (action.type === 'vectorEditor') {
        if (action.value === 'deleteNode') {
          if (vm.chartShapeVectorEditorView) {
            vm.chartShapeVectorEditorView.deleteSelectedNode();
          }
        } else if (action.value === 'done') {
          endEditVectorShape();
          if (vm.chartInspectorState.selectionSnapToGrid) {
            targetLayer.selectedItemSnapToGrid();
          }
        }
      } else if (action.type === 'freehandTool') {
        if (action.value === 'clear') {
          if (vm.chartShapeFreehandToolView) {
            vm.chartShapeFreehandToolView.clearShape();
          }
        } else if (action.value === 'arrowheadChange') {
          if (vm.chartShapeFreehandToolView) {
            vm.chartShapeFreehandToolView.setHasArrowhead(vm.chartInspectorState.freehandHasArrowhead);
          }
        } else if (action.value === 'save') {
          if (vm.chartShapeFreehandToolView) {
            var newShapeItem = vm.chartShapeFreehandToolView.getCurrentShapeItem();
            if (angular.isDefined(newShapeItem)) {
              targetLayer.addNewFreehandShape(newShapeItem);
            }

            closeFreehandTool();
          }
        } else if (action.value === 'close') {
          closeFreehandTool();
        }
      } else if (action.type === 'textEditor') {
        if (action.value === 'textChange') {
          vm.chartInspectorState.editingChartItemTextView.chartItemText.richtextcontent = vm.chartInspectorState.textBoxRichText;
          vm.chartInspectorState.editingChartItemTextView.chartItemText.textcontent = vm.chartInspectorState.textBoxText;
          vm.chartInspectorState.editingChartItemTextView.refresh();
        } else if (action.value === 'done') {
          endEditTextBox();
        }
      }
      else if (action.type === 'closeContextMenu') {
        if (action.value === 'closeMenu') {
          vm.chartContextMenuState.visible = false;
          vm.chartInspectorState.alignMenu = false;
        }
      }
      else if (action.type === 'togglepinstatus') {
        if (action.value === 'togglepinstatus') {
          toggleContextMenuPinStatus();
        }
      }
      else if (action.type === 'showAlignMenu') {
        if (action.value === 'alignMenuShow') {
          vm.chartInspectorState.alignMenu = true;
        }
      }
      else if (action.type === 'hideAlignMenu') {
        if (action.value === 'alignMenuHide') {
          vm.chartInspectorState.alignMenu = false;
        }
      }

      $timeout(function () {
        $scope.$apply();
      });
    }

    function clipboardPaste(targetLayer) {
      targetLayer.chartInspectorSelectionPaste(vm.clipboardItems);
    }

    // Cocos logic below
    function setupCocos() {
      $document[0]['ccConfig'] = {
        id: 'chartCanvas',
        frameRate: 10,
        renderMode: 1,
        showFPS: false,
        debugMode: 4,
        jsList: []
      };

      cc.game.onStart = function () {

        cc.view.resizeWithBrowserSize(true);
        cc.view.setResizeCallback(ccOnResize);

        // Root cc Scene and layer
        ccRootScene = new ChartEditorScene();
        ccChartEditorLayer = ccRootScene.chartEditorLayer;
        ccChartEditorLayer.delegate = vm;

        setupLayerViews();

        ccChartEditorLayer.addChild(vm.chartGridView);
        ccChartEditorLayer.addChild(vm.permanentChartLayerView);

        cc.director.runScene(ccRootScene);

        updateDataProductionPostCocosInit();

        updateChartPanScrollbars();

        fitChartToView();

        vm.chartEditorState.ccInitializationPending = false;
      };

      cc.fullReset();
      cc.game.run('chartCanvas'); // eslint-disable-line angular/module-getter
    }

    function stopCocos() {
      cc.director.end();
    }

    var _chartPauseTimeout;
    var _pauseFps = 2;
    var _lastFps = -1;

    function ccChartPauseUpdates() {
      $log.debug('ccChartPauseUpdates: Will start pausing chart updates ...');
      _lastFps = parseFloat(cc.game.config.frameRate);
      _ccChartHalfLifePause();
    }

    function _ccChartHalfLifePause() {
      var fr = parseFloat(cc.game.config.frameRate);
      if (fr > _lastFps) {
        $log.debug('_ccChartHalfLifePause: FPS bumped by other call!');
        return;
      }

      if (fr > _pauseFps) {
        fr = fr / 2;
        if (fr < _pauseFps) {
          fr = _pauseFps;
        }

        cc.game.setFrameRate(fr);
      }

      if (fr === _pauseFps) {
        $log.debug('_ccChartHalfLifePause: Chart updates now paused (' + _pauseFps + ' FPS)');
      } else {
        $log.debug('_ccChartHalfLifePause: Chart updates now @ ' + fr + ' FPS)');

        $timeout.cancel(_chartPauseTimeout);
        _chartPauseTimeout = $timeout(function () {
          _ccChartHalfLifePause();
        }, 2000);
      }
    }

    function _ccChartKillPause() {
      $timeout.cancel(_chartPauseTimeout);
      _chartPauseTimeout = undefined;
    }

    function ccChartNormalUpdates() {
      $log.debug('ccChartNormalUpdates: Chart updates now normal @ 10 FPS');
      cc.game.setFrameRate(10);
    }

    function ccChartQuickUpdates() {
      $log.debug('ccChartQuickUpdates: Chart updates now quick @ 60 FPS');
      _ccChartKillPause();
      cc.game.setFrameRate(60);
    }

    function ccChartUpdateNow() {
      cc.director.drawScene();
    }

    var ccResizeTimer;

    function ccOnResize() {
      if (angular.isDefined(ccResizeTimer)) {
        $timeout.cancel(ccResizeTimer);
        ccResizeTimer = undefined;
      } else {
        vm.chartEditorState.resizing = true;
        chartBlockUI.start();
      }

      ccResizeTimer = $timeout(function () {
        ccUpdateViewScale();
        updateChartPanScrollbars();
        endEditTextBox();

        vm.chartEditorState.resizing = false;
        chartBlockUI.stop();
        $timeout.cancel(ccResizeTimer);
        ccResizeTimer = undefined;
      }, 500);
    }

    function ccForceSizeUpdate() {
      $window.dispatchEvent(new Event('resize'));
    }

    function ccUpdateViewScale() {
      vm.ccScaleX = cc.view.getScaleX() / cc.view.getDevicePixelRatio();
      vm.ccScaleY = cc.view.getScaleY() / cc.view.getDevicePixelRatio();
    }

    function updateChartPanScrollbars() {
      return;
      // update scrollbar range
      var stageViewBounds = vm.chartGridView.getStageViewBounds();
      var scaledStageBounds = vm.chartGridView.getScaledStageBounds();
      var cocosContainerJ = $('#Cocos2dGameContainer');
      var cocosContainerMarginTop = parseInt(cocosContainerJ.css('margin-top'));
      var cocosContainerMarginLeft = parseInt(cocosContainerJ.css('margin-left'));
      var cocosContainerMarginRight = parseInt(cocosContainerJ.css('margin-right'));

      vm.chartPanScrollParams.ignorePan = true;
      $scope.$applyAsync(function () {
        vm.chartPanScrollParams.vertical.marginLeft = (-cocosContainerMarginLeft);
        vm.chartPanScrollParams.vertical.contentHeight = (scaledStageBounds.height) * vm.ccScaleY;
        vm.chartPanScrollParams.vertical.containerHeight = (stageViewBounds.height * vm.ccScaleY);
        vm.chartPanScrollParams.vertical.containerTopOffset = cocosContainerMarginTop + (stageViewBounds.y * vm.ccScaleY);

        vm.chartPanScrollParams.horizontal.marginTop = (-cocosContainerMarginTop);
        vm.chartPanScrollParams.horizontal.contentWidth = (scaledStageBounds.width) * vm.ccScaleX;
        vm.chartPanScrollParams.horizontal.containerWidth = (stageViewBounds.width * vm.ccScaleX);
        vm.chartPanScrollParams.horizontal.containerLeftOffset = cocosContainerMarginLeft + (stageViewBounds.x * vm.ccScaleX);
      });

      var to1 = $timeout(
        function () {
          vm.chartPanVScrollbarsCallUpdate('update');
          vm.chartPanHScrollbarsCallUpdate('update');
        }, 100
      )
        .then(
          function () {
            return $timeout(
              function () {
                vm.chartPanVScrollbarsCallUpdate('scrollTo', vm.chartPanScrollParams.vertical.scrollPercent + '%', { scrollInertia: 0 });
                vm.chartPanHScrollbarsCallUpdate('scrollTo', vm.chartPanScrollParams.horizontal.scrollPercent + '%', { scrollInertia: 0 });
              }, 100);
          }
        ).then(
          function () {
            $timeout(function () {
              vm.chartPanScrollParams.ignorePan = false;
            }, 100);
          }
        );

      // Update other layer positions
      // onZoomChangeEnd();

      // TODO: update chartitemviewfactory params
    }

    function initHelpTour() {
      var userData = DbSubMgrService.getLoggedInUserData();
      var profileDisplayHelp = false;
      if (angular.isDefined(userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }
      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function initHelpTourSteps() {
      vm.helpTourSteps = [{
        element: '#zoom-picker',
        title: $translate.instant('helptour.permanentStageEditor.titles.Zoom Picker'),
        placement: 'bottom',
        content: $translate.instant('helptour.permanentStageEditor.messages.Zoom Picker Content'),
      }, {
        element: '#shape-picker',
        title: $translate.instant('helptour.permanentStageEditor.titles.Add Shapes'),
        placement: 'bottom',
        content: $translate.instant('helptour.permanentStageEditor.messages.Add Shapes Content'),
      }, {
        element: '#set-piece-picker',
        title: $translate.instant('helptour.permanentStageEditor.titles.Add Set Pieces'),
        placement: 'bottom',
        content: $translate.instant('helptour.permanentStageEditor.messages.Add Set Pieces Content'),
      }, {
        element: '#import-set-design',
        title: $translate.instant('helptour.permanentStageEditor.titles.Import Set Design'),
        placement: 'bottom',
        content: $translate.instant('helptour.permanentStageEditor.messages.Import Set Design Content'),
      }, {
        element: '#add-chart-text',
        title: $translate.instant('helptour.permanentStageEditor.titles.Add Chart Text'),
        placement: 'bottom',
        content: $translate.instant('helptour.permanentStageEditor.messages.Add Chart Text Content'),
      }, {
        element: '#undo',
        title: $translate.instant('helptour.permanentStageEditor.titles.Undo'),
        placement: 'left',
        content: $translate.instant('helptour.permanentStageEditor.messages.Undo Content'),
      }, {
        element: '#redo',
        title: $translate.instant('helptour.permanentStageEditor.titles.Redo'),
        placement: 'left',
        content: $translate.instant('helptour.permanentStageEditor.messages.Redo Content'),
      }];

      vm.helpTourVideos = [
        {
          label: 'Settings: Stage Dimensions/Draw Your Stage',
          videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=217'
        }
      ];
    }

    var isAltKeyDown = false;

    function keyboardHandler(event) {
      if (keyboardHandlerCheckTarget(event)) {
        return;
      }

      // key
      var whichKey = event.which;
      var key = event.key;

      // event types
      var keydown = event.type === 'keydown';
      var keyup = event.type === 'keyup';

      // modifier keys and combos
      var ctrlKey = event.ctrlKey && !(event.altKey || event.shiftKey || event.metaKey);
      var ctrlShiftKey = event.ctrlKey && event.shiftKey && !(event.altKey || event.metaKey);
      var metaKey = event.metaKey && !(event.altKey || event.shiftKey || event.ctrlKey);
      var metaShiftKey = event.metaKey && event.shiftKey && !(event.altKey || event.ctrlKey);
      var noModKey = !(event.ctrlKey || event.altKey || event.shiftKey || event.metaKey);
      var altKey = (event.altKey || (event.key === 'Alt')) && !(event.metaKey || event.shiftKey || event.ctrlKey);

      if (keyup) {
        // STA-I195 keyboard shortcut for rotation mode
        if (altKey) {
          isAltKeyDown = false;
          event.preventDefault();
          event.stopPropagation();
          if (vm.chartInspectorState.selectionRotationMode) {
            keyboardHandlerHandleRotationModeEnd();
          } else {
            keyboardHandlerHandleRotationModeBegin();
          }
        }
      } else {
        // clipboard shortcuts check
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          if (whichKey === 88) {
            keyboardHandlerHandleCut(event);
            return;
          } else if (whichKey === 67) {
            keyboardHandlerHandleCopy(event);
            return;
          } else if (whichKey === 86) {
            keyboardHandlerHandlePaste(event);
            return;
          }
        }

        // Delete or backspace, without any modifier key
        if (noModKey && ((whichKey === 8) || (whichKey === 46))) {
          keyboardHandlerHandleDelete(event);
          return;
        }

        // Undo/Redo
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          if (whichKey === 90) {
            keyboardHandlerHandleUndo();
            return;
          } else if (whichKey === 89) {
            keyboardHandlerHandleRedo();
            return;
          }
        }

        // Redo (Mac)
        if (vm.platformMac && metaShiftKey) {
          if (whichKey === 90) {
            keyboardHandlerHandleRedo();
            return;
          }
        }

        // SWA-ST1-T58 keyboard shortcut for group
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          event.stopPropagation();
          event.preventDefault();
          if (whichKey === 71) {
            keyboardHandlerHandleGroup();
            return;
          }
        }

        // SWA-ST1-T58 keyboard shortcut for ungroup
        if ((vm.platformMac && metaShiftKey) || (!vm.platformMac && ctrlShiftKey)) {
          event.stopPropagation();
          event.preventDefault();
          if (whichKey === 71) {
            keyboardHandlerHandleUnGroup();
            return;
          }
        }

        // SWA-ST1-T58 keyboard shortcut for duplicate
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          event.stopPropagation();
          event.preventDefault();
          if (whichKey === 68) {
            keyboardHandlerHandleDuplicate();
            return;
          }
        }

        // STA-I195 keyboard shortcut for rotation mode
        if (altKey && !isAltKeyDown) {
          isAltKeyDown = true;
          event.preventDefault();
          event.stopPropagation();
          if (vm.chartInspectorState.selectionRotationMode) {
            keyboardHandlerHandleRotationModeEnd();
          } else {
            keyboardHandlerHandleRotationModeBegin();
          }
        }

        // zoom control
        // if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
        //   if (whichKey === 219) {
        //     keyboardHandlerHandleZoomIn(event);
        //     return;
        //   } else if (whichKey === 221) {
        //     keyboardHandlerHandleZoomOut(event);
        //     return;
        //   } else if (whichKey === 48){
        //     keyboardHandlerHandleZoomReset(event);
        //     return;
        //   }
        // }
      }
    }

    function keyboardHandlerCheckTarget(event) {
      var target = event.target;

      if ((target.nodeName === 'INPUT') || (target.nodeName === 'TEXTAREA')) {
        return true;
      } else {
        return target.attributes.contenteditable
      }
    }

    function keyboardHandlerHandleCut(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.selectionCount > 0)) {
        $log.debug('Keyboard - Cut');

        onInspectorAction({ type: 'clipboard', value: 'cut' });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Selection cut'),
          $translate.instant('titles.Clipboard')
        );
      }
    }

    function keyboardHandlerHandleCopy(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.selectionCount > 0)) {
        $log.debug('Keyboard - Copy');

        onInspectorAction({ type: 'clipboard', value: 'copy' });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Selection copied'),
          $translate.instant('titles.Clipboard')
        );
      }
    }

    function keyboardHandlerHandlePaste(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.canPaste)) {
        $log.debug('Keyboard - Paste');

        onInspectorAction({ type: 'clipboard', value: 'paste' });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Content pasted'),
          $translate.instant('titles.Clipboard')
        );
      }
    }

    function keyboardHandlerHandleDelete(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.selectionCount > 0)) {
        $log.debug('Keyboard - Delete');

        onInspectorAction({ type: 'delete' });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Selection deleted')
        );
      }
    }

    // SWA-ST1-T58 keyboard shortcut for group
    function keyboardHandlerHandleGroup(event) {
      if ((vm.chartEditorState.layerActive) && ((vm.chartInspectorState.selectionCount > 1) || vm.chartInspectorState.selectionGrouped)) {
        $log.debug('Keyboard - Group');
        onInspectorAction({
          type: 'groups',
        });

      }
    }

    // SWA-ST1-T58 keyboard shortcut for ungroup
    function keyboardHandlerHandleUnGroup(event) {
      if ((vm.chartEditorState.layerActive) && ((vm.chartInspectorState.selectionCount > 1) || vm.chartInspectorState.selectionGrouped)) {
        $log.debug('Keyboard - UnGroup');
        onInspectorAction({
          type: 'ungroups',
        });

      }
    }

    // SWA-ST1-T58 keyboard shortcut for duplicate
    function keyboardHandlerHandleDuplicate(event) {
      if (vm.chartEditorState.layerActive && !vm.chartInspectorState.selectionGrouped) {
        $log.debug('Keyboard - Duplicate');
        onInspectorAction({
          type: 'clipboard',
          value: 'duplicate'
        });

        toastr.info(
          $translate.instant('messages.Selection Duplicated')
        );
      }
    }

    function keyboardHandlerHandleUndo(event) {
      if (vm.changeTracker.enabled && vm.changeTracker.canUndo) {
        $log.debug('Keyboard - Undo');
        undoAction();
      }
    }

    function keyboardHandlerHandleRedo(event) {
      if (vm.changeTracker.enabled && vm.changeTracker.canRedo) {
        $log.debug('Keyboard - Redo');
        redoAction();
      }
    }

    // STA-I195 keyboard shortcut for rotation mode
    function keyboardHandlerHandleRotationModeBegin(event) {
      if (vm.chartEditorState.layerActive) {
        onInspectorAction({
          type: 'rotation',
          value: 'begin'
        });
        if ((vm.chartInspectorState.selectionCount > 0) || vm.chartInspectorState.selectionGrouped) {
          toastr.clear();
          toastr.info(
            $translate.instant('messages.Rotation mode enabled')
          );
        }
      }
    }

    // STA-I195 keyboard shortcut for rotation mode
    function keyboardHandlerHandleRotationModeEnd(event) {
      if (vm.chartEditorState.layerActive) {
        onInspectorAction({
          type: 'rotation',
          value: 'end'
        });
        if ((vm.chartInspectorState.selectionCount > 0) || vm.chartInspectorState.selectionGrouped) {
          toastr.clear();
          toastr.info(
            $translate.instant('messages.Rotation mode disabled')
          );
        }
      }
    }

    function keyboardHandlerHandleZoomIn(event) {
      if (vm.chartEditorState.chartOpen) {
        if (vm.chartEditorState.zoomFactor < vm.chartEditorState.maxZoomFactor) {
          vm.chartEditorState.zoomFactor++;
          onZoomChangeEnd();
        }

        event.stopPropagation();
        event.preventDefault();
      }
    }

    function keyboardHandlerHandleZoomOut(event) {
      if (vm.chartEditorState.chartOpen) {
        if (vm.chartEditorState.zoomFactor > 1) {
          vm.chartEditorState.zoomFactor--;
          onZoomChangeEnd();
        }

        event.stopPropagation();
        event.preventDefault();
      }
    }

    function keyboardHandlerHandleZoomReset(event) {
      if (vm.chartEditorState.chartOpen) {
        if (vm.chartEditorState.zoomFactor !== 1) {
          vm.chartEditorState.zoomFactor = 1;
          onZoomChangeEnd();
        }

        event.stopPropagation();
        event.preventDefault();
      }
    }

    function registerKeyboardHandler() {
      $log.debug('ChartEditorController: registerKeyboardHandler:');
      $(document).on('keydown', keyboardHandler);
      $(document).on('keyup', keyboardHandler);

      tryIdentifyPlatform();
    }

    function unregisterKeyboardHandler() {
      $log.debug('ChartEditorController: unregisterKeyboardHandler:');
      $(document).off('keydown', keyboardHandler);
      $(document).off('keyup', keyboardHandler);
    }

    function tryIdentifyPlatform() {
      vm.platformMac = (navigator.platform && (navigator.platform.match(/mac/i) !== null)) || (navigator.userAgent.match(/Macintosh/i) !== null);
    }

    vm.changeTracker = {
      undoStack: [],
      redoStack: [],

      lastTrackedState: undefined,

      nextStateNumber: 0,

      disableTrackingCount: 0,

      canUndo: false,
      canRedo: false,
      enabled: false,
    };

    function changeTrackerReset() {
      $log.debug('changeTrackerReset():');
      vm.changeTracker.undoStack.length = 0;
      vm.changeTracker.redoStack.length = 0;
      vm.changeTracker.lastTrackedState = undefined;
      vm.changeTracker.nextStateNumber = 0;
      vm.changeTracker.disableTrackingCount = 0;

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function changeTrackerInitialize() {
      $log.debug('changeTrackerInitialize():');
      changeTrackerReset();

      vm.changeTracker.lastTrackedState = getCurrentChartStateCopy();

      changeTrackerUpdateState();
    }

    function changeTrackerUpdateState() {
      vm.changeTracker.enabled = (vm.changeTracker.disableTrackingCount === 0);

      // Trim entries if needed
      if (vm.changeTracker.undoStack.length > 50) {
        vm.changeTracker.undoStack.splice(0, vm.changeTracker.undoStack.length - 50);
      }

      $scope.$applyAsync(function () {
        vm.changeTracker.canUndo = (vm.changeTracker.undoStack.length > 0);
        vm.changeTracker.canRedo = (vm.changeTracker.redoStack.length > 0);
      });
    }

    function getCurrentChartStateCopy() {
      var state = {
        chartItems: [],
      };
      state.chartItems = vm.permanentChartLayerView.getChartItems();

      state.stateNumber = vm.changeTracker.nextStateNumber;

      return angular.copy(state);
    }

    function restoreChartStateFrom(state) {
      vm.permanentChartLayerView.setChartItems(state.chartItems);
      vm.permanentChartLayerView.refreshForUndoRedo();
      ccChartUpdateNow();
    }

    function chartNotifyDataDidChange() {
      $log.debug('chartNotifyDataDidChange():', Date.now());
      markChartDirty();

      if (vm.changeTracker.enabled) {
        if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
          vm.changeTracker.undoStack.push(vm.changeTracker.lastTrackedState);
        }

        vm.changeTracker.nextStateNumber++;
        vm.changeTracker.lastTrackedState = getCurrentChartStateCopy();

        vm.changeTracker.redoStack.length = 0;
      }

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function chartNotifyDisableChangeTracking() {
      $log.debug('chartNotifyDisableChangeTracking():');
      vm.changeTracker.disableTrackingCount++;

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function chartNotifyEnableChangeTracking() {
      $log.debug('chartNotifyEnableChangeTracking():');
      vm.changeTracker.disableTrackingCount--;

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function undoAction() {
      $log.debug('undoAction():');
      var undoState = vm.changeTracker.undoStack.pop();

      if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
        vm.changeTracker.redoStack.push(vm.changeTracker.lastTrackedState);
      }

      vm.changeTracker.lastTrackedState = angular.copy(undoState);

      restoreChartStateFrom(undoState);

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function redoAction() {
      $log.debug('redoAction():');
      var redoState = vm.changeTracker.redoStack.pop();

      if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
        vm.changeTracker.undoStack.push(vm.changeTracker.lastTrackedState);
      }

      vm.changeTracker.lastTrackedState = angular.copy(redoState);

      restoreChartStateFrom(redoState);

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function logChangeTrackerState() {
      $log.debug('Change Tracker - nextStateNumber:', vm.changeTracker.nextStateNumber);

      $log.debug('Change Tracker - undoStack:', _.map(vm.changeTracker.undoStack, function (item) { return item.stateNumber; }));

      $log.debug('Change Tracker - redoStack top:', _.map(vm.changeTracker.redoStack, function (item) { return item.stateNumber; }));

      if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
        $log.debug('Change Tracker - lastTrackedState:', vm.changeTracker.lastTrackedState.stateNumber);
      } else {
        $log.debug('Change Tracker - lastTrackedState: --');
      }

      $log.debug('Change Tracker - disableTrackingCount:', vm.changeTracker.disableTrackingCount);
      $log.debug('Change Tracker ---------------');
    }

    // To handle show/hide context menu based on mousedown point and mouseup point. 
    var clickDownPosX = 0;
    var clickDownPosY = 0;
    function canvasContainerClickDown(event) {
      clickDownPosX = event.offsetX;
      clickDownPosY = event.offsetY;

      var canvasWidth = event.target.offsetWidth;
      var canvasHeight = event.target.offsetHeight;
      var menuWidth = CHART_CTX_MNU_WIDTH;
      var menuHeight = CHART_CTX_MNU_HEIGHT;

      var maxX = canvasWidth - menuWidth;
      var maxY = canvasHeight - menuHeight;

      if (clickDownPosX > maxX) {
        clickDownPosX = clickDownPosX - menuWidth;
      }

      if (clickDownPosY > maxY) {
        clickDownPosY = maxY;
      }

      clickDownPosX += event.target.parentElement.offsetLeft;
      clickDownPosY += event.target.parentElement.offsetTop;
    }

    function canvasContainerClick(event) {
      if (!vm.chartEditorState.layerActive) {
        return;
      }

      var posX = event.offsetX;
      var posY = event.offsetY;

      // Ensure the context menu stays within the canvas
      var canvasWidth = event.target.offsetWidth;
      var canvasHeight = event.target.offsetHeight;
      var menuWidth = CHART_CTX_MNU_WIDTH;
      var menuHeight = CHART_CTX_MNU_HEIGHT;
      // Calculate the maximum allowed positions
      var maxX = canvasWidth - menuWidth;
      var maxY = canvasHeight - menuHeight;

      // Adjust the position if it goes outside the canvas
      if (posX > maxX) {
        posX = posX - menuWidth;
      }

      if (posY > maxY) {
        posY = maxY;
      }

      posX += event.target.parentElement.offsetLeft;
      posY += event.target.parentElement.offsetTop;

      // Show context menu based on the mouse button and platform
      var isRightClick = event.button === cc.EventMouse.BUTTON_RIGHT;
      var isCtrlLeftClick = event.button === cc.EventMouse.BUTTON_LEFT && (vm.platformMac && event.ctrlKey);

      if ((isRightClick || isCtrlLeftClick) && ((posX === clickDownPosX) && (posY === clickDownPosY))) {
        if (angular.isDefined(vm.pinnedPosXOfContextMenuPermanentStage) && angular.isDefined(vm.pinnedPosYOfContextMenuPermanentStage)) {
          posX = vm.pinnedPosXOfContextMenuPermanentStage;
          posY = vm.pinnedPosYOfContextMenuPermanentStage;
        }
        showChartContextMenu(posX, posY);
      }
    }

    function showChartContextMenu(posX, posY) {
      vm.chartContextMenuState.visible = true;
      vm.chartContextMenuState.posX = posX;
      vm.chartContextMenuState.posY = posY;
    }

    function hideChartContextMenu() {
      vm.chartContextMenuState.visible = false;
      vm.chartInspectorState.alignMenu = false;
    }

    function toggleContextMenuPinStatus() {
      vm.chartInspectorState.isContextMenuPinned = !vm.chartInspectorState.isContextMenuPinned;
      if (vm.chartInspectorState.isContextMenuPinned) {
        setPinnedContextMenuPosition();
      } else {
        clearPinnedContextMenuPosition();
      }
      $localStorage.isContextMenuPinnedPermanentStage = vm.chartInspectorState.isContextMenuPinned;
    }

    function setPinnedContextMenuPosition() {
      var contextMenu = $document[0].getElementById('contextMenu');
      if (contextMenu) {
        var newPosX = parseInt(contextMenu.style.left, 10);
        var newPosY = parseInt(contextMenu.style.top, 10);

        vm.pinnedPosXOfContextMenuPermanentStage = newPosX;
        vm.pinnedPosYOfContextMenuPermanentStage = newPosY;
        $localStorage.pinnedPosXOfContextMenuPermanentStage = newPosX;
        $localStorage.pinnedPosYOfContextMenuPermanentStage = newPosY;
      }
    }

    function clearPinnedContextMenuPosition() {
      vm.pinnedPosXOfContextMenuPermanentStage = undefined;
      vm.pinnedPosYOfContextMenuPermanentStage = undefined;
      $localStorage.pinnedPosXOfContextMenuPermanentStage = undefined;
      $localStorage.pinnedPosYOfContextMenuPermanentStage = undefined;
    }

    function onContextMenuDragStop(event, ui) {
      if (vm.chartInspectorState.isContextMenuPinned) {
        updatePinnedContextMenuPosition(ui.position);
      } else {
        clearPinnedContextMenuPosition();
      }
    }

    function updatePinnedContextMenuPosition(position) {
      var newPosX = parseInt(position.left, 10);
      var newPosY = parseInt(position.top, 10);

      vm.pinnedPosXOfContextMenuPermanentStage = newPosX;
      vm.pinnedPosYOfContextMenuPermanentStage = newPosY;
      $localStorage.pinnedPosXOfContextMenuPermanentStage = newPosX;
      $localStorage.pinnedPosYOfContextMenuPermanentStage = newPosY;
    }

    function clearPinnedContextMenuPosition() {
      vm.pinnedPosXOfContextMenuPermanentStage = undefined;
      vm.pinnedPosYOfContextMenuPermanentStage = undefined;
      $localStorage.pinnedPosXOfContextMenuPermanentStage = undefined;
      $localStorage.pinnedPosYOfContextMenuPermanentStage = undefined;
    }

    function searchStringChangedForSetpice() {
      vm.searchStringUpperForSetpice = vm.searchpersetpiece.toUpperCase();
    }

    function clearSearchForSetpice() {
      vm.searchStringUpperForSetpice = '';
      vm.searchpersetpiece = '';
    }

    function setpieceSearchFilter(setpiece) {
      return setpiece.name.toUpperCase().indexOf(vm.searchStringUpperForSetpice) > -1;
    }
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsPerformersListController', SettingsPerformersListController);

  SettingsPerformersListController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$translate',
    '$log',
    'ngProgressLite',
    'toastr',
    'DbPerformers',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    'DbCollaborationPrivileges',
    'DbProductions',
    '$q',
    '$uibModal',
    'DbScenes',
    'DbChartItems',
    '$localStorage',
  ];

  function SettingsPerformersListController($scope, $cookies, $stateParams, $translate, $log, ngProgressLite,
    toastr, DbPerformers, DbSubMgrService, blockUI, swaUtils, swaRouterStateNames, DbCollaborationPrivileges,
    DbProductions, $q, $uibModal, DbScenes, DbChartItems, $localStorage) {

    var vm = this;
    var selectedProductionId;

    var dbProductions = new DbProductions();
    var dbPerformers = new DbPerformers();
    var dbScenes = new DbScenes();
    var dbChartItems = new DbChartItems();

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowimportperformers: false,
      allowaddperformers: false,
      alloweditperformers: false,
      allowdeleteperformers: false,
      allowreorderperformers: false
    };

    var defaultViewAccessRules = angular.extend(defaultDenyAccessRules, {
      planAccessDenied: true,
    });

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowimportperformers: true,
      allowaddperformers: true,
      alloweditperformers: true,
      allowdeleteperformers: true,
      allowreorderperformers: true
    };

    vm.userData = {};
    vm.selectedProduciton = {};
    vm.userId = '';

    vm.performers = [];
    vm.listEditMode = false;
    vm.scenes;
    vm.performerPairsWithIdsForUndo = $localStorage.performerPairsWithIdsForUndo || undefined;

    vm.searchStringUpper = '';
    vm.searchperformername = '';

    vm.performersSortableOptions = {
      handle: '.sortDragHandle',
      cursor: 'ns-resize',
      axis: 'y',
      opacity: 0.8,
      disabled: true,
      stop: performersDragSortStop,
    };

    vm.onPerformerClick = onPerformerClick;
    vm.onCreate = onCreate;
    vm.onImport = onImport;
    vm.onEditToggle = onEditToggle;
    vm.deletePerformerAtIndexPrompt = deletePerformerAtIndexPrompt;
    vm.performerTrackReassignmentPrompt = performerTrackReassignmentPrompt;
    vm.undoReassignmentPrompt = undoReassignmentPrompt;

    vm.performerSearchFilter = performerSearchFilter;
    vm.searchStringChanged = searchStringChanged;
    vm.clearSearch = clearSearch;

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedPerformers: false,
      allowedNumberOfPerformers: 0,
    };

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.validateActivePlan();
        }
      ).then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        }
      ).then(
        function (plan) {
          updateActivePlanRules(plan);
        }
      ).then(
        function () {
          return getAllData();
        }
      ).then(
        function () {
          return fetchScenes();
        }
      ).catch(
        function (error) {
          swaUtils.sessionErrorInterceptor(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
        }
      );
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId).then(
        function (production) {
          updateDataProduction(production);
        }
      ).then(
        function () {
          return dbPerformers.fetchAllInProduction(selectedProductionId, updateDataPerformers);
        }
      ).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function () {
          deferred.reject();
        }
      );

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;

      vm.activePlanRules.allowUnlimitedPerformers = plan.planfeatures[2].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedPerformers) {
        vm.activePlanRules.allowedNumberOfPerformers = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfPerformers = plan.planfeatures[2].featurevalue;
      }
    }

    function updateDataProduction(production) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error('Invalid state');
      }

      vm.production = angular.copy(production);

      if (production.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(production.collaboratorIds) && (production.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = production.collaborationsettings.find(function (element) {
            return (element.collaboratorId === vm.userId);
          });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error(
            $translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          throw new Error('Invalid state');
        }
      }

      DbSubMgrService.setSelectedProduction(production);

      updateCollaborationPrivileges();
    }

    function updateDataPerformers(id) {
      $log.debug('SettingsPerformersListController.updateDataPerformers(): ' + id + ' -->');

      if (angular.isUndefined(id)) {
        vm.performers = dbPerformers.getFetched(true);
      } else {
        vm.performers = vm.performers || [];

        var existingPerformer = swaUtils.findInArrayById(vm.performers, id);
        var incomingPerformer = dbPerformers.getFetchedById(id);

        var isInsert = (angular.isUndefined(existingPerformer) && angular.isDefined(incomingPerformer));
        var isDelete = (angular.isDefined(existingPerformer) && angular.isUndefined(incomingPerformer));
        var isUpdate = (angular.isDefined(existingPerformer) && angular.isDefined(incomingPerformer));

        if (isInsert) {
          vm.performers.push(incomingPerformer);
          swaUtils.sortArrayByNumericKey(vm.performers, 'orderingindex');
        } else if (isDelete) {
          var existingPerformerIndex = vm.performers.indexOf(existingPerformer);
          if (existingPerformerIndex !== -1) {
            vm.performers.splice(existingPerformerIndex, 1);
          }
        } else if (isUpdate) {
          // incoming change/update
          var needsReordering = (existingPerformer.orderingindex !== incomingPerformer.orderingindex);

          angular.extend(existingPerformer, incomingPerformer);
          if (needsReordering) {
            swaUtils.sortArrayByNumericKey(vm.performers, 'orderingindex');
          }
        }
      }

      if ((vm.performers.length === 0) && vm.listEditMode) {
        onEditToggle();
      }
    }

    function onPerformerClick(performer) {
      if (vm.listEditMode) {
        return;
      }

      if (!(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.alloweditperformers)) {
        var toastTitle = $translate.instant('collaborationprivileges.titles.Collaboration Access');
        if (vm.activeAccessRules.planAccessDenied) {
          toastTitle = $translate.instant('planprivileges.titles.Plan - Access Denied!');
        }
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to edit performers'),
          toastTitle
        );

        return;
      }

      var params = {
        productionId: selectedProductionId,
        performerId: performer._id,
      };

      if (performer.textsize === -1) {
        swaUtils.stateGo(swaRouterStateNames.productionsettings.importperformer, params);
      } else {
        swaUtils.stateGo(swaRouterStateNames.productionsettings.createperformer, params);
      }
    }

    function onCreate() {
      var params = {
        productionId: selectedProductionId,
      };

      swaUtils.stateGo(swaRouterStateNames.productionsettings.createperformer, params);
    }

    function onImport() {
      var params = {
        productionId: selectedProductionId,
      };

      swaUtils.stateGo(swaRouterStateNames.productionsettings.importperformer, params);
    }

    function onEditToggle() {
      vm.listEditMode = !vm.listEditMode;

      vm.performersSortableOptions.disabled = !vm.listEditMode;
    }

    function deletePerformerAtIndexPrompt(index) {
      var performerToDelete = vm.performers[index];
      var performersPairInUndoReassignment = $localStorage.performerPairsWithIdsForUndo;
      var isPerformerFound = false;

      if (angular.isDefined(performersPairInUndoReassignment)) {
        isPerformerFound = performersPairInUndoReassignment.some(function (pair) {
          return pair.performerToBeChangedId === performerToDelete._id ||
            pair.performerToBeChangedWithId === performerToDelete._id;
        });
      }

      if (isPerformerFound) {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/productionSettings/settingsDeletePerformerPrompt.html',
          controller: 'DeletePerformerController',
          controllerAs: 'vm',
          size: 'sm',
          windowClass: 'sw-modal sw-modal-400',
          backdropClass: 'sw-modal-backdrop',
        });

        modalInstance.result.then(function () {
          deletePerformerAtIndex(performerToDelete);
          $localStorage.performerPairsWithIdsForUndo = undefined;
          vm.performerPairsWithIdsForUndo = undefined;
        })
      } else {
        deletePerformerAtIndex(performerToDelete);
      }
    }

    function deletePerformerAtIndex(performerToDelete) {
      blockUI.start();

      dbPerformers.delete(performerToDelete._id).catch(
        function (error) {
          $log.error('SettingsPerformersListController.deletePerformerAtIndex:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error deleting performer!')
          );
        }
      ).finally(
        function () {
          $scope.$applyAsync(function () {
            blockUI.stop();
          });
        }
      );
    }

    function updatePerformers(performersToUpdate) {
      var updateQs = [];
      for (var k = 0; k < performersToUpdate.length; k++) {
        updateQs.push(dbPerformers.update(performersToUpdate[k]));
      }

      return $q.all(updateQs);
    }

    function performersDragSortStop(e, ui) {
      var performersToUpdate = [];
      for (var i = 0, reindex = 0; i < vm.performers.length; i++) {
        var aPerformer = vm.performers[i];
        if (aPerformer.orderingindex !== reindex) {
          performersToUpdate.push({
            _id: aPerformer._id,
            orderingindex: reindex,
          });
        }

        reindex++;
      }

      if (performersToUpdate.length > 0) {
        blockUI.start();
        updatePerformers(performersToUpdate).catch(
          function (error) {
            $log.error('SettingsPerformersListController.sidebarDragSortStop:', error);
            swaUtils.showErrorToast(error, $translate.instant('errormessages.Error updating order!'));
          }
        ).finally(
          function () {
            $scope.$applyAsync(function () {
              blockUI.stop();
            });
          }
        );
      }
    }

    function updateCollaborationPrivileges() {
      if (vm.activeCollaborationConfig.isProductionOwner === true) {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultOwnerAccessRules);
        }
      } else {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultDenyAccessRules);
          var params = {
            accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
            statename: swaRouterStateNames.productionsettings.performers,
          };
          var dbCollaborationPrivileges = new DbCollaborationPrivileges();

          dbCollaborationPrivileges.getCollaborationPrivileges(params).then(
            function (privilegeData) {
              updateActiveAccessRules(privilegeData.accessrules);
            }
          ).catch(
            function (error) {
              $log.error('SettingsPerformersListController.updateCollaborationPrivileges:', error);
            }
          );
        }
      }
    }

    function updateActiveAccessRules(accessRules) {
      $scope.$applyAsync(function () {
        if (angular.isDefined(vm.activeCollaborationConfig.isProductionOwner)) {
          angular.extend(vm.activeAccessRules, accessRules);
        } else {
          angular.extend(vm.activeAccessRules, defaultDenyAccessRules);
        }

        vm.performersSortableOptions.disabled = !vm.activeAccessRules.allowreorderperformers;
      });
    }

    $scope.$on('$destroy', function () {
      dbPerformers.fetchUnregister();
    });

    function fetchScenes() {
      var deferred = $q.defer();

      dbScenes.findInProduction(vm.production._id)
        .then(function (scenes) {
          vm.scenes = scenes;
          deferred.resolve();
        })
        .catch(function (e) {
          deferred.reject(e);
        })

      return deferred.promise;
    }

    function performerTrackReassignmentPrompt() {
      vm.reassignPopover.show = false;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/chartEditor/performerTrackReassignmentPrompt.html',
        controller: 'PerformerTrackReassignmentController',
        controllerAs: 'vm',
        size: '960',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
        resolve: {
          params: {
            performers: vm.performers,
            scenes: vm.scenes,
            activePlanRules: vm.activePlanRules,
            production: vm.production,
          }
        }
      });
      modalInstance.result
        .then(function (performerPairsWithIds) {
          $localStorage.performerPairsWithIdsForUndo = performerPairsWithIds;
          vm.performerPairsWithIdsForUndo = $localStorage.performerPairsWithIdsForUndo;
          swapPerformer(performerPairsWithIds);
        });
    }

    function swapPerformer(performerPairsWithIds) {
      blockUI.start($translate.instant('messages.Swapping ...'));
      dbChartItems.reassignPerformer(performerPairsWithIds)
        .then(function () {
          toastr.success($translate.instant('messages.Performer(s) reassigned!'));
        })
        .catch(function (error) {
          $log.error('SettingsPerformersListController.swapPerformer:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error swapping performers!')
          );
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    // Undo Reassignment Warning prompt
    function undoReassignmentPrompt() {
      vm.reassignPopover.show = false;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/chartEditor/undoReassignmentPrompt.html',
        controller: 'UndoReassignmentController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });

      modalInstance.result.then(undoSwapPerformer);
    }

    function undoSwapPerformer() {
      blockUI.start($translate.instant('messages.Swapping ...'));
      dbChartItems.undoReassignPerformer(vm.performerPairsWithIdsForUndo)
        .then(function () {
          $localStorage.performerPairsWithIdsForUndo = undefined;
          vm.performerPairsWithIdsForUndo = undefined;
          toastr.success($translate.instant('messages.Reassignment reversed!'));
        })
        .catch(function (error) {
          $log.error('SettingsPerformersListController.swapPerformer:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error undo reassignment performers!')
          );
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    function performerSearchFilter(performer) {
      return performer.name.toUpperCase().indexOf(vm.searchStringUpper) > -1 || performer.text.toUpperCase().indexOf(vm.searchStringUpper) > -1;
    }

    function searchStringChanged() {
      vm.searchStringUpper = vm.searchperformername.toUpperCase();
    }

    function clearSearch() {
      vm.searchStringUpper = '';
      vm.searchperformername = '';
    }
  }
}());

/* global SWStage, Q, SWChartItem */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsImportSetPieceController', SettingsImportSetPieceController);

  SettingsImportSetPieceController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$translate',
    '$log',
    '$uibModal',
    '$timeout',
    'usSpinnerService',
    'ngProgressLite',
    'toastr',
    'resizeService',
    'DbProductions',
    'DbSetPieces',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    'swaConfig',
    '$q',
  ];

  function SettingsImportSetPieceController($scope, $cookies, $stateParams, $translate, $log, $uibModal, $timeout,
    usSpinnerService, ngProgressLite, toastr, resizeService, DbProductions, DbSetPieces,
    DbSubMgrService, blockUI, swaUtils, swaRouterStateNames, swaConfig, $q) {
    var vm = this;
    var selectedProductionId;
    var selectedSetPieceId;

    var dbProductions = new DbProductions();
    var dbSetPieces = new DbSetPieces();

    vm.stageSettings = {};
    vm.isNew = true;
    vm.setPiece = {};
    vm.setPieceWidth = {
      feet: 0,
      inch: 0
    }

    vm.setPieceHeight = {
      feet: 0,
      inch: 0
    }

    vm.blurValidateNumber = blurValidateNumber;
    vm.saveUpdate = saveUpdate;
    vm.processFile = processFile;
    vm.onBack = onBack;
    vm.onCancel = onCancel;
    vm.setMeasurement = setMeasurement;
    vm.getSetPieceWidthInFeet = getSetPieceWidthInFeet;
    vm.getSetPieceHeightInFeet = getSetPieceHeightInFeet;

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      selectedSetPieceId = $stateParams.setPieceId;
      vm.isNew = angular.isUndefined(selectedSetPieceId);

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        })
        .then(function () {
          return getAllData();
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId)
        .then(function (production) {
          updateDataProduction(production);
        })
        .then(function () {
          if (vm.isNew) {
            var newSetPiece = dbSetPieces.getEmptySetPieceObject();
            newSetPiece.productionId = selectedProductionId;
            newSetPiece.setpiecetype = SWSetPiece.Type.Imported;
            newSetPiece.measurementunit = vm.stageSettings.stagemeasurementunit;

            return newSetPiece;
          } else {
            return dbSetPieces.findById(selectedSetPieceId);
          }
        })
        .then(function (setPiece) {
          updateDataSetPiece(setPiece);
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function updateDataProduction(production) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error($translate('errormessages.Error loading production!'));
      }

      vm.stageSettings = angular.copy(production.stagesettings);
    }

    function updateDataSetPiece(setPiece) {
      if (angular.isUndefined(setPiece)) {
        var params = { productionId: selectedProductionId };
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.setpieces, params, true);
        return;
      }

      vm.setPiece = angular.copy(setPiece);
      vm.setPiece.width = (parseFloat(vm.setPiece.width) || 0.0);
      vm.setPiece.height = (parseFloat(vm.setPiece.height) || 0.0);
      vm.measurementunitname = (vm.setPiece.measurementunit === SWStage.MeasurementUnitType.Feet) ? $translate.instant('labels.Feet-abbreviation') : $translate.instant('labels.Meters');

      vm.setPieceWidth = swaUtils.getFeetAndInches(vm.setPiece.width);
      vm.setPieceHeight = swaUtils.getFeetAndInches(vm.setPiece.height);

      if (angular.isDefined(vm.setPiece._id)) {
        vm.setPieceImageUrl = swaConfig.imageDataPrefixUrl + '/setpiece/image/' + vm.setPiece._id;
      }
    }

    function blurValidateNumber(event) {
      var value = parseFloat(event.target.value);
      if (Number.isNaN(value) || (value < 0)) {
        event.target.value = 0.0;
      } else {
        event.target.value = value;
      }
    }

    function saveUpdate() {
      if (!vm.isNew) {
        return true;
      }

      var validationMessages = [];
      if (!angular.isString(vm.setPiece.image) || (vm.setPiece.image.length === 0)) {
        validationMessages.push($translate.instant('validationmessages.Image is required'));
      }

      if (angular.isUndefined(vm.setPiece.name) || (vm.setPiece.name.length === 0)) {
        validationMessages.push($translate.instant('validationmessages.Name is required'));
      }

      if ((vm.setPiece.width <= 0.0) || (vm.setPiece.height <= 0.0)) {
        validationMessages.push($translate.instant('validationmessages.Width and depth should be greater than 0'));
      }

      if (validationMessages.length > 0) {
        toastr.clear();
        toastr.warning(
          '<ul><li>' + validationMessages.join('</li><li>') + '</li></ul>',
          $translate.instant('validationmessages.Please fix the following -'),
          { allowHtml: true }
        );

        return false;
      }

      ngProgressLite.start();
      blockUI.start();
      var newSetPiece = angular.copy(vm.setPiece);
      processImage()
        .then(function (processedImage) {
          delete newSetPiece.imageDataUrl;
          newSetPiece.image = processedImage;
          dbSetPieces.insert(newSetPiece)
        })
        .then(function () {
          ngProgressLite.set(0.8);
          toastr.clear();
          toastr.success($translate.instant('messages.Set Piece added.'));
          var params = { productionId: selectedProductionId };
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.setpieces, params, true);
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving set piece!')
          );
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.stop();
        });
    }

    function processFile(dataUrl, error) {
      if (error) {
        swaUtils.showErrorToast(
          error,
          'Error assigning set piece image'
        );
        return;
      }

      usSpinnerService.spin('spinner-setpiece-img');
      var resizeOptions = {
        height: 1536,
        outputFormat: 'image/png',
      };
      var resizeThumbOptions = {
        height: 48,
        width: 48,
        outputFormat: 'image/png',
      };
      resizeService.resizeImage(dataUrl, resizeOptions)
        .then(function (image) {
          vm.setPiece.imageDataUrl = dataUrl;
          vm.setPiece.image = image.substring(22);
        })
        .then(function () {
          return resizeService.resizeImage(dataUrl, resizeThumbOptions);
        })
        .then(function (image) {
          vm.setPiece.thumbimage = image.substring(22);
        })
        .catch(function (error) {
          swaUtils.showErrorToast(error, $translate.instant('messages.Error assigning set piece image'));
        })
        .finally(function () {
          usSpinnerService.stop('spinner-setpiece-img');
        });
    }

    function determineImageDimensions(dataUrl) {
      var deferred = $q.defer();

      var tempImage = new Image();
      tempImage.src = dataUrl;
      tempImage.onload = function (event) {
        var size = {
          width: tempImage.width,
          height: tempImage.height,
        };

        deferred.resolve(size);

      }
      tempImage.onerror = function (event) {
        deferred.reject(event.error);
      }

      return deferred.promise;

    }

    function processImage() {
      var originalImageSize = resizeService.calulateImageSize(vm.setPiece.imageDataUrl, 'image/png');
      return determineImageDimensions(vm.setPiece.imageDataUrl)
        .then(function (size) {
          var resizeOptions = {
            outputFormat: 'image/png',
          };
          if (originalImageSize > (2 * 1024 * 1024)) {
            resizeOptions.size = 2.66;
            resizeOptions.sizeScale = 'mo';
            resizeOptions.step = 10;
          }

          if (size.height > 1536) {
            resizeOptions.height = 1536 * vm.setPiece.height / vm.stageSettings.stagedepth;
          } else {
            resizeOptions.height = size.height;
          }
          return resizeService.resizeImage(vm.setPiece.imageDataUrl, resizeOptions);
        })
        .then(function (image) {
          return image.substring(22);
        })
    }

    function onBack() {
      var params = { productionId: selectedProductionId };
      swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.setpieces, params, true);
    }

    function onCancel() {
      var params = { productionId: selectedProductionId };
      swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.setpieces, params, true);
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toParams.skipValidation) {
        return;
      }

      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        if (vm.isNew) {
          toastr.clear();
          toastr.warning($translate.instant('messages.Please \'Save\' or \'Cancel\' importing this Set Piece.'));
          event.preventDefault();
        }
      }
    });

    function setMeasurement() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionSettings/collaboration/setMeasurementPrompt.html',
        controller: 'SetMeasurementPromptController',
        size: 'lg',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        controllerAs: 'vm',
        backdrop: 'static',
        resolve: {
          setPiece: function () {
            return vm.setPiece;
          },
        },
      });

      modalInstance.result.then(
        function (measurements) {
          vm.setPiece.width = measurements.width;
          vm.setPiece.height = measurements.depth;
          vm.setPieceWidth = swaUtils.getFeetAndInches(vm.setPiece.width);
          vm.setPieceHeight = swaUtils.getFeetAndInches(vm.setPiece.height);
        }
      );
    }

    function getSetPieceWidthInFeet() {
      vm.setPiece.width = swaUtils.getFinalValueInFeet(vm.setPieceWidth);
      vm.setPieceWidth = swaUtils.getFeetAndInches(vm.setPiece.width);
    }

    function getSetPieceHeightInFeet() {
      vm.setPiece.height = swaUtils.getFinalValueInFeet(vm.setPieceHeight);
      vm.setPieceHeight = swaUtils.getFeetAndInches(vm.setPiece.height);
    }
  }
}());

(function () {
  angular.module('swanywhere').controller('SettingsImportSetDesignController', SettingsImportSetDesignController);

  SettingsImportSetDesignController.$inject = [
    '$uibModalInstance',
    'selectedProduction',
    '$translate',
    'usSpinnerService',
    'toastr',
    'resizeService',
    'DbSetPieces',
    'ngProgressLite',
    'blockUI',
    '$log',
    'swaUtils',
    '$q',
    '$uibModal'
  ];

  function SettingsImportSetDesignController($uibModalInstance,
    selectedProduction, $translate, usSpinnerService, toastr, resizeService, DbSetPieces,
    ngProgressLite, blockUI, $log, swaUtils, $q, $uibModal) {

    var vm = this;

    vm.isNew = true;
    vm.setPiece = {};
    vm.setPieceWidth = {
      feet: 0,
      inch: 0
    }

    vm.setPieceHeight = {
      feet: 0,
      inch: 0
    }

    vm.footerMessage = '';

    vm.processImage = processImage;
    vm.onCancel = onCancel;
    vm.onSave = onSave;
    vm.setMeasurement = setMeasurement;
    vm.getSetPieceWidthInFeet = getSetPieceWidthInFeet;
    vm.getSetPieceHeightInFeet = getSetPieceHeightInFeet;

    var selectedProductionId = selectedProduction._id;

    initialize();

    function initialize() {
      vm.setPiece = {};
      vm.setPiece.productionId = selectedProductionId;
      vm.setPiece.setpiecetype = SWChartItem.SetPieceType.Imported;
      vm.setPiece.width = parseFloat(selectedProduction.stagesettings.stagewidth);
      vm.setPiece.height = parseFloat(selectedProduction.stagesettings.stagedepth);

      vm.setPieceWidth = swaUtils.getFeetAndInches(vm.setPiece.width);
      vm.setPieceHeight = swaUtils.getFeetAndInches(vm.setPiece.height);

      vm.setPiece.measurementunit = selectedProduction.stagesettings.stagemeasurementunit;
      vm.setPiece.thumbimage = '';
      vm.setPiece.image = '';
      vm.setPiece.name = $translate.instant('labels.Set Design');

      vm.measurementunitname = (vm.setPiece.measurementunit === SWStage.MeasurementUnitType.Feet) ? $translate.instant('labels.Feet-abbreviation') : $translate.instant('labels.Meters');

      initFooterMessage();
    }

    function initFooterMessage() {
      var enMeasurementUnitNameAbbreviation = (vm.setPiece.measurementunit === SWStage.MeasurementUnitType.Feet) ? $translate.instant('labels.Feet-abbreviation') : $translate.instant('labels.Meters-abbreviation');
      if (vm.setPiece.measurementunit === SWStage.MeasurementUnitType.Feet) {
        vm.footerMessage = "Stage dimensions are " + swaUtils.feetAndInchesText(selectedProduction.stagesettings.stagewidth) + " x " + swaUtils.feetAndInchesText(selectedProduction.stagesettings.stagedepth) + ", offstage width is " + swaUtils.feetAndInchesText(selectedProduction.stagesettings.offstagewidth) + ". Imported set design will also be added to your set piece library.";
      } else {
        vm.footerMessage = $translate.instant('messages.import_setpiece_footer', {
          stagewidth: selectedProduction.stagesettings.stagewidth,
          stagedepth: selectedProduction.stagesettings.stagedepth,
          offstagewidth: selectedProduction.stagesettings.offstagewidth,
          measurementunitnameabbreviation: enMeasurementUnitNameAbbreviation,
        });
      }
    }

    function processImage(dataUrl, error) {
      if (error) {
        swaUtils.showErrorToast(
          error,
          'Error assigning set piece image'
        );
        return;
      }

      usSpinnerService.spin('spinner-setpiece-img');
      var originalImageSize = resizeService.calulateImageSize(dataUrl, 'image/png');
      $log.debug('Original Image Size: ', originalImageSize);
      determineImageDimensions(dataUrl)
        .then(function (size) {
          var resizeOptions = {
            outputFormat: 'image/png',
          };
          if (originalImageSize > (2 * 1024 * 1024)) {
            resizeOptions.size = 2.66;
            resizeOptions.sizeScale = 'mo';
            resizeOptions.step = 10;
          }

          if (size.height > 1536) {
            resizeOptions.height = 1536;
          } else {
            resizeOptions.height = size.height;
          }
          return resizeService.resizeImage(dataUrl, resizeOptions);
        })
        .then(function (image) {
          var newImageSize = resizeService.calulateImageSize(image, 'image/png');
          $log.debug('New Image Size: ', newImageSize);
          vm.setPiece.image = image.substring(22);
        })
        .then(function () {
          var resizeThumbOptions = {
            height: 48,
            width: 48,
            outputFormat: 'image/png',
          };

          return resizeService.resizeImage(dataUrl, resizeThumbOptions);
        })
        .then(function (image) {
          vm.setPiece.thumbimage = image.substring(22);
        })
        .catch(function (error) {
          swaUtils.showErrorToast(error, $translate.instant('messages.Error assigning set piece image'));
        })
        .finally(function () {
          usSpinnerService.stop('spinner-setpiece-img');
        });
    }

    function determineImageDimensions(dataUrl) {
      var deferred = $q.defer();

      var tempImage = new Image();
      tempImage.src = dataUrl;
      tempImage.onload = function (event) {
        var size = {
          width: tempImage.width,
          height: tempImage.height,
        };

        deferred.resolve(size);

      }
      tempImage.onerror = function (event) {
        deferred.reject(event.error);
      }

      return deferred.promise;

    }

    function onCancel() {
      $uibModalInstance.dismiss('cancel');
    }

    function onSave() {
      var validationMessages = [];
      if (!angular.isString(vm.setPiece.image) || (vm.setPiece.image.length === 0)) {
        validationMessages.push($translate.instant('validationmessages.Image is required'));
      }

      if (angular.isUndefined(vm.setPiece.name) || (vm.setPiece.name.length === 0)) {
        validationMessages.push($translate.instant('validationmessages.Name is required'));
      }

      if ((vm.setPiece.width <= 0.0) || (vm.setPiece.height <= 0.0)) {
        validationMessages.push($translate.instant('validationmessages.Width and depth should be greater than 0'));
      }

      if (validationMessages.length > 0) {
        toastr.clear();
        toastr.warning(
          '<ul><li>' + validationMessages.join('</li><li>') + '</li></ul>',
          $translate.instant('validationmessages.Please fix the following -'),
          { allowHtml: true }
        );

        return false;
      }

      var dbSetPieces = new DbSetPieces();
      var newSetPiece = angular.copy(vm.setPiece);

      ngProgressLite.start();
      blockUI.start();
      dbSetPieces.insert(newSetPiece).then(
        function (id) {
          newSetPiece._id = id;
          ngProgressLite.set(0.8);
          toastr.success($translate.instant('messages.Set Design added.'));
          $uibModalInstance.close(newSetPiece);
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving set design!')
          );
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );
    }

    function setMeasurement() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionSettings/collaboration/setMeasurementPrompt.html',
        controller: 'SetMeasurementPromptController',
        size: 'lg',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        controllerAs: 'vm',
        backdrop: 'static',
        resolve: {
          setPiece: function () {
            return vm.setPiece;
          },
        },
      });

      modalInstance.result.then(
        function (measurementFt) {
          vm.setPiece.width = measurementFt.width;
          vm.setPiece.height = measurementFt.depth;

          vm.setPieceWidth = swaUtils.getFeetAndInches(vm.setPiece.width);
          vm.setPieceHeight = swaUtils.getFeetAndInches(vm.setPiece.height);
        }
      );
    }

    function getSetPieceWidthInFeet() {
      vm.setPiece.width = swaUtils.getFinalValueInFeet(vm.setPieceWidth);
      vm.setPieceWidth = swaUtils.getFeetAndInches(vm.setPiece.width);
    }

    function getSetPieceHeightInFeet() {
      vm.setPiece.height = swaUtils.getFinalValueInFeet(vm.setPieceHeight);
      vm.setPieceHeight = swaUtils.getFeetAndInches(vm.setPiece.height);
    }
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsImportPerformerController', SettingsImportPerformerController);

  SettingsImportPerformerController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$translate',
    '$log',
    '$timeout',
    'usSpinnerService',
    'ngProgressLite',
    'toastr',
    'resizeService',
    'DbSubMgrService',
    'DbPerformers',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    '$q',
    'DbProductions'
  ];

  function SettingsImportPerformerController($scope, $cookies, $stateParams, $translate, $log, $timeout,
    usSpinnerService, ngProgressLite, toastr, resizeService, DbSubMgrService, DbPerformers, blockUI, swaUtils, swaRouterStateNames, $q, DbProductions) {

    var vm = this;
    var selectedProductionId;
    var selectedPerformerId;

    var dbProductions = new DbProductions();
    var dbPerformers = new DbPerformers();

    vm.isNew = true;
    vm.originalPerformer = {}
    vm.performer = {};

    vm.saveUpdate = saveUpdate;
    vm.processFile = processFile;
    vm.onCancel = onCancel;

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      selectedPerformerId = $stateParams.performerId;
      vm.isNew = angular.isUndefined(selectedPerformerId);

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return getAllData();
        }
      ).catch(
        function (error) {
          swaUtils.sessionErrorInterceptor(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
        }
      );
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId).then(
        function (production) {
          updateDataProduction(production);
        }
      ).then(
        function () {
          if (vm.isNew) {
            var newPerformer = dbPerformers.getEmptyPerformerObject();
            newPerformer.textsize = -1;
            newPerformer.text = '*** IMPORTED ***';
            newPerformer.productionId = selectedProductionId;

            return newPerformer;
          } else {
            return dbPerformers.findById(selectedPerformerId);
          }
        }
      ).then(
        function (performer) {
          updateDataPerformer(performer);
        }
      ).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function (error) {
          deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    function updateDataProduction(production) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error($translate('errormessages.Error loading production!'));
      }
    }

    function updateDataPerformer(performer) {
      if (angular.isUndefined(performer)) {
        var params = {productionId: selectedProductionId};
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.performers, params, true);
        return;
      }

      vm.originalPerformer = angular.copy(performer);
      vm.performer = angular.copy(performer);
    }

    function saveUpdate() {
      var validationMessages = [];

      if (!angular.isString(vm.performer.image) || (vm.performer.image.length === 0)) {
        validationMessages.push($translate.instant('validationmessages.Icon Image is required'));
      }

      if (vm.performer.name.length === 0) {
        validationMessages.push($translate.instant('validationmessages.Name is required'));
      }

      if (validationMessages.length > 0) {
        toastr.clear();
        toastr.warning(
          '<ul><li>' + validationMessages.join('</li><li>') + '</li></ul>',
          $translate.instant('validationmessages.Please fix the following -'),
          {allowHtml: true}
        );

        return false;
      }

      if(angular.equals(vm.originalPerformer, vm.performer)) {
        onCancel();
        return true;
      }

      var updatedPerformer = angular.copy(vm.performer);

      if (vm.isNew) {
        insertPerformer(updatedPerformer);
      } else {
        updatePerformer(updatedPerformer);
      }
    }

    function insertPerformer(newPerformer) {
      ngProgressLite.start();
      blockUI.start();
      dbPerformers.insert(newPerformer).then(
        function () {
          ngProgressLite.set(0.8);
          toastr.success($translate.instant('messages.Performer added.'));
          var params = {productionId: selectedProductionId};
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.performers, params, true);
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving performer!')
          );
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );
    }

    function updatePerformer(performerObject) {
      ngProgressLite.start();
      blockUI.start();
      dbPerformers.update(performerObject).then(
        function () {
          ngProgressLite.set(0.8);
          toastr.success($translate.instant('messages.Performer updated.'));
          var params = {productionId: selectedProductionId};
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.performers, params, true);
        }
      ).catch(
        function (error) {
          $log.error('SettingsImportPerformerController.updatePerformer:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error updating performer!')
          );
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );
    }

    function processFile(dataUrl, error) {
      if (error) {
        swaUtils.showErrorToast(
          error,
          'Error assigning performer image'
        );
        return;
      }

      usSpinnerService.spin('spinner-performer-img');
      var resizeOptions = {
        height: 60,
        width: 60,
        outputFormat: 'image/png',
      };
      resizeService.resizeImage(dataUrl, resizeOptions).then(
        function (image) {
          vm.performer.image = image.substring(22);
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(error, $translate.instant('messages.Error assigning performer image'));
        }
      ).finally(
        function () {
          usSpinnerService.stop('spinner-performer-img');
        }
      );
    }

    function onCancel() {
      var params = {productionId: selectedProductionId};
      swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.performers, params, true);
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toParams.skipValidation) {
        return;
      }

      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        toastr.clear();
        toastr.warning($translate.instant('messages.Please \'Save\' or \'Cancel\' importing this Performer.'));
        event.preventDefault();
      }
    });

    $scope.$on('$destroy', function () {
      dbPerformers.fetchUnregister();
    });
  }
}());

(function () {
    'use strict';
    angular.module('swanywhere').controller('DeletePerformerController', DeletePerformerController);
  
    DeletePerformerController.$inject = [
      '$uibModalInstance'
    ];
  
    function DeletePerformerController($uibModalInstance) {
      var vm = this;
  
      vm.actionYes = actionYes;
      vm.actionNo = actionNo;
  
      function actionYes() {
        $uibModalInstance.close();
      }
  
      function actionNo() {
        $uibModalInstance.dismiss('cancel');
      }
    }
  }());
  
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsCustomNumberlineController', SettingsCustomNumberlineController);

  SettingsCustomNumberlineController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$translate',
    '$log',
    '$timeout',
    'DbProductions',
    'ngProgressLite',
    'toastr',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    '$document',
  ];

  function SettingsCustomNumberlineController($scope, $cookies, $stateParams, $translate, $log,
    $timeout, DbProductions, ngProgressLite, toastr,
    DbSubMgrService, blockUI, swaUtils, swaRouterStateNames, $document) {

    var vm = this;
    var selectedProductionId;
    var dbProductions = new DbProductions();

    var kMinLeftMargin = 20;
    var kMinRightMargin = 20;

    vm.stageSettings = {};
    vm.newNumberlineSettings = {
      numberlineMarkerStepValue: 1,
      numberlineMarkerStepUserValue: 1,
      numberlineZeroAtCenter: true,
      numberlineMultiplier: 1,
      ftIn: {
        feet: 1,
        inch: 0
      }
    };
    vm.numberLineNumbersVisibilitySettings = {
      numberlineNumbersVisibility: 0,
    }
    vm.verticalNumberLineSettings = {
      verticalNumberlineNumbersVisibility: 0,
      verticalNumberlineMarkerStepValue: 1,
      verticalNumberlineMarkerStepUserValue: 1,
      verticalNumberlineMultiplier: 1,
    }
    vm.verticalNumberLineOffsetSettings = {
      verticalNumberlineZeroOffsetValue: 0,
      verticalNumberlineOffsetUserValue: 0,
      ftIn: {
        feet: 1,
        inch: 0
      }
    }
    vm.numberlineMarkerStepUserValueMultiplier = 1;

    vm.zoomSliderOptions = {
      floor: 1,
      ceil: 1,
      step: 1,
      showTicks: true,
      onChange: onZoomChangeEnd,
    }

    vm.validationResult = {
      hasErrors: false,
      errors: {},
    };

    vm.previewSettings = {
      maxZoomFactor: 1,
      zoomFactor: 1
    };

    vm.scrollConfigPreview = {
      axis: 'x',
      scrollbarPosition: 'inside',
      scrollButtons: {
        enable: false,
      },
      autoHideScrollbar: false,
      advanced: {
        updateOnContentResize: false,
        autoExpandHorizontalScroll: 3,
      },
    };

    vm.stageSizeHintMessage = '';

    vm.resetSettings = resetSettings;
    vm.resetSettingsVertical = resetSettingsVertical;
    vm.onZoomChangeEnd = onZoomChangeEnd;
    vm.onSaveUpdate = onSaveUpdate;
    vm.onCancel = onCancel;
    vm.validateSettings = validateSettings;
    vm.validateSettingsVertical = validateSettingsVertical;
    vm.updateNumberlineMarkerStepUserValue = updateNumberlineMarkerStepUserValue;
    vm.updateVerticalNumberlineMarkerStepUserValue = updateVerticalNumberlineMarkerStepUserValue;
    vm.updateVerticalNumberlineOffsetUserValue = updateVerticalNumberlineOffsetUserValue;

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession()
        .then(function () {
          return dbProductions.fetchById(selectedProductionId, updateDataProduction);
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function updateDataProduction() {
      var selectedProduction = dbProductions.getFetchedById(selectedProductionId);

      if (angular.isUndefined(selectedProduction)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      dbProductions.fetchUnregister();

      vm.stageSettings = angular.copy(selectedProduction.stagesettings);

      if (vm.stageSettings.stagemeasurementunit === SWStage.MeasurementUnitType.Feet) {
        vm.numberlineMarkerStepUserValueMultiplier = 1;
      } else {
        vm.numberlineMarkerStepUserValueMultiplier = 100;
      }

      if (angular.isUndefined(vm.stageSettings.numberlineMarkerStepValue)) {
        vm.stageSettings.numberlineMarkerStepValue = 1;
        vm.stageSettings.numberlineZeroAtCenter = true;
        vm.stageSettings.numberlineMultiplier = 1;
      }
      if (angular.isUndefined(vm.stageSettings.verticalNumberlineMarkerStepValue)) {
        vm.stageSettings.verticalNumberlineMarkerStepValue = 1;
        vm.stageSettings.verticalNumberlineMultiplier = 1;
      }
      if (angular.isUndefined(vm.stageSettings.verticalNumberlineZeroOffsetValue)) {
        vm.stageSettings.verticalNumberlineZeroOffsetValue = 0;
      }

      vm.newNumberlineSettings.numberlineMarkerStepValue = vm.stageSettings.numberlineMarkerStepValue;
      vm.newNumberlineSettings.numberlineMarkerStepUserValue = vm.stageSettings.numberlineMarkerStepValue * vm.numberlineMarkerStepUserValueMultiplier;

      vm.verticalNumberLineSettings.verticalNumberlineMarkerStepValue = vm.stageSettings.verticalNumberlineMarkerStepValue;
      vm.verticalNumberLineSettings.verticalNumberlineMarkerStepUserValue = vm.stageSettings.verticalNumberlineMarkerStepValue * vm.numberlineMarkerStepUserValueMultiplier;
      vm.verticalNumberLineSettings.verticalNumberlineMultiplier = vm.stageSettings.verticalNumberlineMultiplier;

      vm.verticalNumberLineOffsetSettings.verticalNumberlineZeroOffsetValue = vm.stageSettings.verticalNumberlineZeroOffsetValue;
      vm.verticalNumberLineOffsetSettings.verticalNumberlineOffsetUserValue = vm.stageSettings.verticalNumberlineZeroOffsetValue * vm.numberlineMarkerStepUserValueMultiplier;

      if (vm.stageSettings.stagemeasurementunit === SWStage.MeasurementUnitType.Feet) {
        vm.newNumberlineSettings.ftIn = swaUtils.getFeetAndInches(vm.newNumberlineSettings.numberlineMarkerStepUserValue);
      }
      if (vm.stageSettings.stagemeasurementunit === SWStage.MeasurementUnitType.Feet) {
        vm.verticalNumberLineSettings.ftIn = swaUtils.getFeetAndInches(vm.verticalNumberLineSettings.verticalNumberlineMarkerStepUserValue);
      }
      if (vm.stageSettings.stagemeasurementunit === SWStage.MeasurementUnitType.Feet) {
        vm.verticalNumberLineOffsetSettings.ftIn = swaUtils.getFeetAndInches(vm.verticalNumberLineOffsetSettings.verticalNumberlineOffsetUserValue);
      }

      vm.newNumberlineSettings.numberlineZeroAtCenter = vm.stageSettings.numberlineZeroAtCenter;
      vm.newNumberlineSettings.numberlineMultiplier = vm.stageSettings.numberlineMultiplier;


      vm.previewSettings.maxZoomFactor = (Math.floor(scaleUnitReferencePixels / (1000 - kMinLeftMargin - kMinRightMargin) * (vm.stageSettings.stagewidth + (2 * vm.stageSettings.offstagewidth))) + 2);
      vm.zoomSliderOptions.ceil = vm.previewSettings.maxZoomFactor;

      if (angular.isUndefined(vm.stageSettings.numberlineNumbersVisibility)) {
        vm.stageSettings.numberlineNumbersVisibility = 0;
      }
      if (angular.isUndefined(vm.stageSettings.verticalNumberlineNumbersVisibility)) {
        vm.stageSettings.verticalNumberlineNumbersVisibility = 0;
      }

      vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility = vm.stageSettings.numberlineNumbersVisibility;
      vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility = vm.stageSettings.verticalNumberlineNumbersVisibility;

      initStageSizeHint();
      validateSettings();
      validateSettingsVertical();
    }

    function initStageSizeHint() {
      var enMeasurementUnitNameAbbreviation = (vm.stageSettings.stagemeasurementunit === SWStage.MeasurementUnitType.Feet) ? '' : $translate.instant('labels.Meters-abbreviation');
      if (vm.stageSettings.stagemeasurementunit === SWStage.MeasurementUnitType.Feet) {
        vm.stageSizeHintMessage = "Stage dimensions are " + swaUtils.feetAndInchesText(vm.stageSettings.stagewidth) + " x " + swaUtils.feetAndInchesText(vm.stageSettings.stagedepth) + ", offstage width is " + swaUtils.feetAndInchesText(vm.stageSettings.offstagewidth) + ".";
      } else {
        vm.stageSizeHintMessage = $translate.instant('messages.customnumberlinehintline3', {
          stagewidth: vm.stageSettings.stagewidth,
          stagedepth: vm.stageSettings.stagedepth,
          offstagewidth: vm.stageSettings.offstagewidth,
          measurementunitnameabbreviation: enMeasurementUnitNameAbbreviation,
        });
      }
    }

    function resetSettings() {
      vm.newNumberlineSettings.numberlineMarkerStepValue = 1;
      vm.newNumberlineSettings.numberlineZeroAtCenter = true;
      vm.newNumberlineSettings.numberlineMultiplier = 1;

      vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility = 0;

      vm.newNumberlineSettings.numberlineMarkerStepUserValue = vm.newNumberlineSettings.numberlineMarkerStepValue * vm.numberlineMarkerStepUserValueMultiplier;

      if (vm.stageSettings.stagemeasurementunit === SWStage.MeasurementUnitType.Feet) {
        vm.newNumberlineSettings.ftIn = swaUtils.getFeetAndInches(vm.newNumberlineSettings.numberlineMarkerStepUserValue);
      }

      validateSettings();
    }

    function resetSettingsVertical() {
      vm.verticalNumberLineSettings.verticalNumberlineMarkerStepValue = 1;
      vm.verticalNumberLineSettings.verticalNumberlineMultiplier = 1;

      vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility = 0;

      vm.verticalNumberLineSettings.verticalNumberlineMarkerStepUserValue = vm.verticalNumberLineSettings.verticalNumberlineMarkerStepValue * vm.numberlineMarkerStepUserValueMultiplier;

      vm.verticalNumberLineOffsetSettings.verticalNumberlineZeroOffsetValue = 0;
      vm.verticalNumberLineOffsetSettings.verticalNumberlineOffsetUserValue = vm.verticalNumberLineOffsetSettings.verticalNumberlineZeroOffsetValue;

      if (vm.stageSettings.stagemeasurementunit === SWStage.MeasurementUnitType.Feet) {
        vm.verticalNumberLineSettings.ftIn = swaUtils.getFeetAndInches(vm.verticalNumberLineSettings.verticalNumberlineMarkerStepUserValue);
      }
      if (vm.stageSettings.stagemeasurementunit === SWStage.MeasurementUnitType.Feet) {
        vm.verticalNumberLineOffsetSettings.ftIn = swaUtils.getFeetAndInches(vm.verticalNumberLineOffsetSettings.verticalNumberlineOffsetUserValue);
      }
      validateSettingsVertical();
    }

    function validateSettings() {
      vm.validationResult.invalidMarkerStep = false;
      vm.validationResult.hasErrors = false;

      var markerStepUserValue = parseFloat(vm.newNumberlineSettings.numberlineMarkerStepUserValue);
      vm.newNumberlineSettings.numberlineMarkerStepValue = markerStepUserValue / vm.numberlineMarkerStepUserValueMultiplier;
      if (isNaN(vm.newNumberlineSettings.numberlineMarkerStepValue)
        || (vm.newNumberlineSettings.numberlineMarkerStepValue <= 0)
        || (vm.newNumberlineSettings.numberlineMarkerStepValue > vm.stageSettings.stagewidth)) {
        vm.validationResult.hasErrors = true;
        vm.validationResult.invalidMarkerStep = true;
        return;
      }

      vm.newNumberlineSettings.numberlineMultiplier = (1 / vm.newNumberlineSettings.numberlineMarkerStepValue);

      updatePreview();
    }

    function validateSettingsVertical() {
      vm.validationResult.hasErrorsVertical = false;
      vm.validationResult.invalidMarkerStepVertical = false;
      vm.validationResult.invalidZeroOffsetVertical = false;

      var verticalmarkerStepUserValue = parseFloat(vm.verticalNumberLineSettings.verticalNumberlineMarkerStepUserValue);
      vm.verticalNumberLineSettings.verticalNumberlineMarkerStepValue = verticalmarkerStepUserValue / vm.numberlineMarkerStepUserValueMultiplier;
      if (isNaN(vm.verticalNumberLineSettings.verticalNumberlineMarkerStepValue)
        || (vm.verticalNumberLineSettings.verticalNumberlineMarkerStepValue <= 0)
        || (vm.verticalNumberLineSettings.verticalNumberlineMarkerStepValue > vm.stageSettings.stagedepth)) {
        vm.validationResult.hasErrorsVertical = true;
        vm.validationResult.invalidMarkerStepVertical = true;
      }

      var verticalOffsetmarkerStepUserValue = parseFloat(vm.verticalNumberLineOffsetSettings.verticalNumberlineOffsetUserValue);
      vm.verticalNumberLineOffsetSettings.verticalNumberlineZeroOffsetValue = verticalOffsetmarkerStepUserValue / vm.numberlineMarkerStepUserValueMultiplier;
      if (isNaN(vm.verticalNumberLineOffsetSettings.verticalNumberlineZeroOffsetValue)
        || (vm.verticalNumberLineOffsetSettings.verticalNumberlineZeroOffsetValue < 0)
        || (vm.verticalNumberLineOffsetSettings.verticalNumberlineZeroOffsetValue > vm.stageSettings.stagedepth)) {
        vm.validationResult.hasErrorsVertical = true;
        vm.validationResult.invalidZeroOffsetVertical = true;
      }

      vm.verticalNumberLineSettings.verticalNumberlineMultiplier = (1 / vm.verticalNumberLineSettings.verticalNumberlineMarkerStepValue);
    }

    function updatePreview() {
      if (!vm.validationResult.hasErrors) {

        $timeout(function () {
          $scope.$broadcast('reCalcViewDimensions');
          $scope.$broadcast('rzSliderForceRender');
        }, 500);

        drawPreviewCanvas();
      }
    }

    function drawPreviewCanvas() {
      var c = $document[0].getElementById('myCanvas');
      var context = c.getContext('2d');

      var viewWidth = 1000 * vm.previewSettings.zoomFactor;
      var viewHeight = c.height;

      c.width = viewWidth;

      var stageWidth = vm.stageSettings.stagewidth;
      var stageWidthWithOffstage = stageWidth + (2 * vm.stageSettings.offstagewidth);

      var stageSwaUnitWidth = stageWidth * vm.newNumberlineSettings.numberlineMultiplier;
      var stageSwaUnitWidthWithOffstage = stageWidthWithOffstage * vm.newNumberlineSettings.numberlineMultiplier;

      context.clearRect(0, 0, viewWidth, viewHeight);

      var pxPerUnitX = (viewWidth - (kMinLeftMargin + kMinRightMargin)) / stageWidthWithOffstage;
      var pxPerSwaUnitX = (viewWidth - (kMinLeftMargin + kMinRightMargin)) / stageSwaUnitWidthWithOffstage;

      var stepX = Math.floor(scaleUnitReferencePixels / pxPerUnitX) + 1.0;
      stepX = Math.pow(2, Math.ceil(Math.log2(stepX)));

      var stepSwaUnitX = Math.floor(scaleUnitReferencePixels / pxPerSwaUnitX) + 1.0;
      stepSwaUnitX = Math.pow(2, Math.ceil(Math.log2(stepSwaUnitX)));

      var offsetForNoCenterZeroPx = 0;
      if (!vm.newNumberlineSettings.numberlineZeroAtCenter) {
        offsetForNoCenterZeroPx = pxPerSwaUnitX / 2 * stepSwaUnitX;
      }

      var stageMidX = viewWidth / 2;
      var axislineY = viewHeight / 2;

      // Ruler
      if (true) {
        // Major marks
        context.strokeStyle = '#e0e0e0';
        context.lineWidth = 1.0;

        context.beginPath();
        for (var i = 0; i <= (parseInt(stageWidth) / 2); i += stepX) {
          context.moveTo(stageMidX + i * pxPerUnitX, axislineY - 15);
          context.lineTo(stageMidX + i * pxPerUnitX, axislineY);

          context.moveTo(stageMidX - i * pxPerUnitX, axislineY - 15);
          context.lineTo(stageMidX - i * pxPerUnitX, axislineY);
        }
        context.stroke();

        context.beginPath();
        for (var i = 0; i <= (parseInt(stageSwaUnitWidth) / 2); i += stepSwaUnitX) {
          if ((i === 0) && (!vm.newNumberlineSettings.numberlineZeroAtCenter)) {
            continue;
          }

          context.moveTo(stageMidX + i * pxPerSwaUnitX - offsetForNoCenterZeroPx, axislineY);
          context.lineTo(stageMidX + i * pxPerSwaUnitX - offsetForNoCenterZeroPx, axislineY + 15);

          context.moveTo(stageMidX - i * pxPerSwaUnitX + offsetForNoCenterZeroPx, axislineY);
          context.lineTo(stageMidX - i * pxPerSwaUnitX + offsetForNoCenterZeroPx, axislineY + 15);
        }
        context.stroke();

        // Legend labels
        context.lineWidth = 0.5;

        var axisLabel;
        var offsetForCenter;

        // x-axis labels - original unit
        context.font = '13px SourceSansPro-Light';
        context.fillStyle = '#999';
        for (i = 0; i <= (parseInt(stageWidth) / 2); i += stepX) {
          axisLabel = i;

          offsetForCenter = context.measureText(axisLabel).width / 2;

          context.fillText(axisLabel, stageMidX + i * pxPerUnitX - offsetForCenter, axislineY - 25);
          context.fillText(axisLabel, stageMidX - i * pxPerUnitX - offsetForCenter, axislineY - 25);
        }

        // x-axis labels - SW unit
        context.font = '16px SourceSansPro-Light';
        context.fillStyle = '#e0e0e0';
        for (i = 0; i <= (parseInt(stageSwaUnitWidth) / 2); i += 1) {
          if ((i === 0) && (!vm.newNumberlineSettings.numberlineZeroAtCenter)) {
            continue;
          }
          if (vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility == 0) {
            if (i % 2 != 0) {
              continue;
            }
          } else if (vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility == 1) {
            if (i % 2 == 0) {
              continue;
            }
          } else { }
          axisLabel = i;
          if (!Number.isInteger(axisLabel)) {
            axisLabel = axisLabel.toFixed(1);
          }

          offsetForCenter = context.measureText(axisLabel).width / 2;

          context.fillText(axisLabel, stageMidX + i * pxPerSwaUnitX - offsetForCenter - offsetForNoCenterZeroPx, axislineY + 35);
          context.fillText(axisLabel, stageMidX - i * pxPerSwaUnitX - offsetForCenter + offsetForNoCenterZeroPx, axislineY + 35);
        }

        // axis line
        context.strokeStyle = '#e0e0e0';
        context.lineWidth = 1.0;
        context.beginPath();
        context.moveTo(stageMidX - (parseInt(stageWidth) / 2) * pxPerUnitX, axislineY);
        context.lineTo(stageMidX + (parseInt(stageWidth) / 2) * pxPerUnitX, axislineY);
        context.stroke();
      }
    }

    function onZoomChangeEnd() {
      updatePreview();
      vm.updatePreviewScrollbar('update');
    }

    function onSaveUpdate() {
      if (vm.validationResult.hasErrors || vm.validationResult.hasErrorsVertical) {
        toastr.warning('Please fix the Markers and Labels');
        return;
      }

      var updatedProduction = {
        _id: selectedProductionId,
        stagesettings: {}
      };

      updatedProduction.stagesettings.numberlineMarkerStepValue = vm.newNumberlineSettings.numberlineMarkerStepValue;
      updatedProduction.stagesettings.numberlineMultiplier = vm.newNumberlineSettings.numberlineMultiplier;
      updatedProduction.stagesettings.numberlineZeroAtCenter = vm.newNumberlineSettings.numberlineZeroAtCenter;
      updatedProduction.stagesettings.numberlineNumbersVisibility = vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility;

      updatedProduction.stagesettings.verticalNumberlineMarkerStepValue = vm.verticalNumberLineSettings.verticalNumberlineMarkerStepValue;
      updatedProduction.stagesettings.verticalNumberlineMultiplier = vm.verticalNumberLineSettings.verticalNumberlineMultiplier;
      updatedProduction.stagesettings.verticalNumberlineZeroOffsetValue = vm.verticalNumberLineOffsetSettings.verticalNumberlineZeroOffsetValue;
      updatedProduction.stagesettings.verticalNumberlineNumbersVisibility = vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility;

      ngProgressLite.start();
      blockUI.start();
      var updateQ = dbProductions.update(updatedProduction);
      updateQ.then(
        function () {
          toastr.success('Numberline settings updated.');

          $timeout(function () {
            ngProgressLite.done();
            // blockUI.stop();
            var params = { productionId: selectedProductionId };
            swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.stagedimensions, params, true);
          }, 500);
        },

        function (reason) {
          ngProgressLite.done();
          blockUI.stop();
          $log.error('dbProduction.update - error: ' + reason.reason);
          toastr.error('Error saving changes!');
        });
    }

    function onCancel() {
      var params = { productionId: selectedProductionId };
      swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.stagedimensions, params, true);
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toParams.skipValidation) {
        return;
      }

      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        toastr.clear();
        toastr.warning($translate.instant('messages.Please \'Save\' or \'Cancel\' numberline customizations.'));
        event.preventDefault();
      }
    });

    function updateNumberlineMarkerStepUserValue() {
      vm.newNumberlineSettings.numberlineMarkerStepUserValue = swaUtils.getFinalValueInFeet(vm.newNumberlineSettings.ftIn);
      vm.newNumberlineSettings.numberlineMarkerStepUserValue = Math.max(vm.newNumberlineSettings.numberlineMarkerStepUserValue, 1 / 12);
      vm.newNumberlineSettings.ftIn = swaUtils.getFeetAndInches(vm.newNumberlineSettings.numberlineMarkerStepUserValue);

      validateSettings();
    }

    function updateVerticalNumberlineMarkerStepUserValue() {
      vm.verticalNumberLineSettings.verticalNumberlineMarkerStepUserValue = swaUtils.getFinalValueInFeet(vm.verticalNumberLineSettings.ftIn);
      vm.verticalNumberLineSettings.verticalNumberlineMarkerStepUserValue = Math.max(vm.verticalNumberLineSettings.verticalNumberlineMarkerStepUserValue, 1 / 12);
      vm.verticalNumberLineSettings.ftIn = swaUtils.getFeetAndInches(vm.verticalNumberLineSettings.verticalNumberlineMarkerStepUserValue);

      validateSettingsVertical();
    }

    function updateVerticalNumberlineOffsetUserValue() {
      vm.verticalNumberLineOffsetSettings.verticalNumberlineOffsetUserValue = swaUtils.getFinalValueInFeet(vm.verticalNumberLineOffsetSettings.ftIn);
      vm.verticalNumberLineOffsetSettings.verticalNumberlineOffsetUserValue = Math.max(vm.verticalNumberLineOffsetSettings.verticalNumberlineOffsetUserValue, 0);
      vm.verticalNumberLineOffsetSettings.ftIn = swaUtils.getFeetAndInches(vm.verticalNumberLineOffsetSettings.verticalNumberlineOffsetUserValue);

      validateSettingsVertical();
    }
  }
}());

// jshint maxparams: false
/* global Q, cc, SetPieceEditorGridView, ChartLayerSetPiece,
ChartItemViewFactory, SWChartUI, SWChartLayer,
SetPieceEditorScene, ChartShapeVectorEditorView, _,
ChartShapeFreehandToolView, SWChartItem, SWSetPiece, SWStage, SWSetPieceUI */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsCreateSetPieceController', SettingsCreateSetPieceController);

  SettingsCreateSetPieceController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    'swaUtils',
    'toastr',
    'DbProductions',
    '$log',
    'DbSubMgrService',
    'ngProgressLite',
    'blockUI',
    '$timeout',
    'DbSetPieces',
    'DbChartItems',
    '$translate',
    '$uibModal',
    '$interval',
    '$document',
    'swaRouterStateNames',
    '$q',
    'swaConfig',
    'swaUi',
    '$localStorage',
  ];

  function SettingsCreateSetPieceController($scope, $cookies, $stateParams, swaUtils, toastr,
    DbProductions, $log, DbSubMgrService, ngProgressLite, blockUI,
    $timeout, DbSetPieces, DbChartItems, $translate, $uibModal, $interval, $document, swaRouterStateNames, $q, swaConfig, swaUi, $localStorage) {

    var vm = this;
    var selectedProductionId;
    var selectedSetPieceId;

    var dbProductions = new DbProductions();
    var dbSetPieces = new DbSetPieces();
    var dbChartItems = new DbChartItems();

    var ccRootScene;
    var ccChartEditorLayer;

    var chartBlockUI = blockUI.instances.get('block-ui-chart');

    var maxUnitWidth = 0;
    var maxUnitDepth = 0;

    vm.SWChartItem = SWChartItem;

    vm.isNew = false;
    vm.selectedProduction = {};
    vm.setPieces = [];

    vm.setPieceWidth = {
      feet: 0,
      inch: 0
    }

    vm.setPieceHeight = {
      feet: 0,
      inch: 0
    }
    vm.isReferenced = false;

    vm.chartTextEditorState = {
      editorPosX: 0,
      editorPosY: 0,
      editorHeight: 0,
      editorWidth: 0,
      rotationAngle: 0,
      editorScale: 0
    }

    vm.chartEditorState = {
      ccInitializationPending: true,
      zoomFactor: 1,
      maxZoomFactor: 1,
      minHZoomOffset: 0,
      maxHZoomOffset: 100,
      hZoomOffset: 0,
      povAudience: true,
    };

    vm.chartInspectorState = {
      selectionCount: -1,
      selectionGrouped: false,
      selectionRotatable: false,
      rotationRad: 0,
      selectionOrderingMode: false,
      selectionEditable: false,
      zIndex: -1,
      selectionColorable: false,
      selectionColor: undefined,
      selectionFillColorable: false,
      selectionFillColor: undefined,
      vectorEditorActive: false,
      vectorEditorNodeSelected: false,
      freehandToolActive: false,
      layerEditorActive: false,
      selectionFlipAble: false,
      selectionRotationMode: false,
      alignMenu: false,
      selectionSnapToGrid: false,
      isContextMenuPinned: $localStorage.isContextMenuPinnedSetpieceStage || false,
      textEditorActive: false,
      setPieceSelected: false,
      shapesSelected: false,
      lineThickness: 0,
      lineThicknessForFreehand: chartBaseLineWidth + 2,
      showLineThicknessForFreehand: ((chartBaseLineWidth + 2) / 2) + 1,
    };

    vm.defaultMinimalVScrollConfig = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollButtons: {
        enable: false,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
    };

    /** Position and visibility state of the chart context menu */
    vm.chartContextMenuState = {
      visible: false,
      posX: 0,
      posY: 0
    };

    vm.pinnedPosXOfContextMenuSetpieceStage =
      $localStorage.pinnedPosXOfContextMenuSetpieceStage !== null && angular.isDefined($localStorage.pinnedPosXOfContextMenuSetpieceStage)
        ? $localStorage.pinnedPosXOfContextMenuSetpieceStage
        : undefined;

    vm.pinnedPosYOfContextMenuSetpieceStage =
      $localStorage.pinnedPosYOfContextMenuSetpieceStage !== null && angular.isDefined($localStorage.pinnedPosYOfContextMenuSetpieceStage)
        ? $localStorage.pinnedPosYOfContextMenuSetpieceStage
        : undefined;

    vm.searchStringUpperForSetpice = '';
    vm.searchpersetpiece = '';

    vm.cancelSave = cancelSave;
    vm.saveAndClose = saveAndClose;

    vm.showHelpBar = false;
    vm.shapePickerDidPickShape = shapePickerDidPickShape;
    vm.setPiecePickerDidPickSetPiece = setPiecePickerDidPickSetPiece;
    vm.addChartText = addChartText;
    vm.onInspectorAction = onInspectorAction;
    vm.onZoomChangeEnd = onZoomChangeEnd;
    vm.updateInspectorState = updateInspectorState;
    vm.editVectorShape = editVectorShape;
    vm.endEditVectorShape = endEditVectorShape;
    vm.shapeEditorSelectedNode = shapeEditorSelectedNode;
    vm.editTextBox = editTextBox;
    vm.endEditTextBox = endEditTextBox;
    vm.markChartDirty = markChartDirty;
    vm.chartNotifyDataDidChange = chartNotifyDataDidChange;
    vm.chartNotifyDisableChangeTracking = chartNotifyDisableChangeTracking;
    vm.chartNotifyEnableChangeTracking = chartNotifyEnableChangeTracking;
    vm.undoAction = undoAction;
    vm.redoAction = redoAction;
    vm.getSetPieceWidthInFeet = getSetPieceWidthInFeet;
    vm.getSetPieceHeightInFeet = getSetPieceHeightInFeet;


    vm.ccChartPauseUpdates = ccChartPauseUpdates;
    vm.ccChartQuickUpdates = ccChartQuickUpdates;

    // Temp
    vm.updatePreview = updatePreview;

    vm.canvasContainerClick = canvasContainerClick;
    vm.canvasContainerClickDown = canvasContainerClickDown;
    vm.hideChartContextMenu = hideChartContextMenu;
    vm.onContextMenuDragStop = onContextMenuDragStop;

    vm.clearSearchForSetpice = clearSearchForSetpice;
    vm.searchStringChangedForSetpice = searchStringChangedForSetpice;
    vm.setpieceSearchFilter = setpieceSearchFilter;

    initialize();

    function initialize() {
      vm.chartEditorState.ccInitializationPending = true;

      sessionCheckAndRun();
      registerKeyboardHandler();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      selectedSetPieceId = $stateParams.setPieceId;
      vm.isNew = (angular.isUndefined(selectedSetPieceId));

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return getAllData();
        }
      ).then(
        function () {
          initHelpTour();
        }
      ).then(null, null,
        function (progress) {
          ngProgressLite.set(progress);
        }
      ).catch(
        function (error) {
          swaUtils.sessionErrorInterceptor(error);
          $log.error('SettingsCreateSetPieceController.sessionCheckAndRun:', error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
        }
      );
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId).then(
        function (production) {
          deferred.notify(0.2);
          updateDataProduction(production);
        }
      ).then(
        function () {
          return dbSetPieces.getStockItems();
        }
      ).then(
        function (setPieces) {
          deferred.notify(0.4);
          updateDataSetPiecesStock(setPieces);
        }
      ).then(
        function () {
          return dbSetPieces.findInProduction(selectedProductionId);
        }
      ).then(
        function (setPieces) {
          deferred.notify(0.6);
          updateDataSetPieces(setPieces);
        }
      ).then(
        function () {
          if (vm.isNew) {
            var newSetPiece = dbSetPieces.getEmptySetPieceObject();
            newSetPiece.productionId = selectedProductionId;
            newSetPiece.setpiecetype = SWSetPiece.Type.Created;
            newSetPiece.measurementunit = vm.selectedProduction.stagesettings.stagemeasurementunit;
            newSetPiece.dirty = true;

            return newSetPiece;
          } else {
            return dbSetPieces.findById(selectedSetPieceId);
          }
        }
      ).then(
        function (setPiece) {
          deferred.notify(0.8);
          updateLabSetPiece(setPiece);
        }
      ).then(
        function () {
          return loadSetPiece();
        }
      ).then(
        function () {
          $cookies.put('selectedProductionId', selectedProductionId);
          deferred.notify(1.0);
        }
      ).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function (error) {
          deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    function setupLayerViews() {
      vm.chartGridView = new SetPieceEditorGridView();
      vm.setPieceChartLayerView = new ChartLayerSetPiece();
      vm.setPieceChartLayerView.delegate = vm;
    }

    function updateDataProduction(production) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error($translate('errormessages.Error loading production!'));
      }

      vm.selectedProduction = production;
      DbSubMgrService.setSelectedProduction(vm.selectedProduction);

      setupCocos();
    }

    function updateDataProductionPostCocosInit() {
      if (vm.selectedProduction.stagesettings.stagemeasurementunit === SWStage.MeasurementUnitType.Feet) {
        maxUnitWidth = SWSetPiece.CustomSetPiece.MaxWidthFeet;
        maxUnitDepth = SWSetPiece.CustomSetPiece.MaxDepthFeet;
      } else {
        maxUnitWidth = SWSetPiece.CustomSetPiece.MaxWidthFeet * 0.3048;
        maxUnitDepth = SWSetPiece.CustomSetPiece.MaxDepthFeet * 0.3048;
      }

      vm.chartGridView.setMaxWidth(maxUnitWidth);
      vm.chartGridView.setMaxDepth(maxUnitDepth);

      vm.chartGridView.updateStageViewParameters();

      updateChartItemViewFactory();

      vm.setPieceChartLayerView.setShowLineOverlapBreaks((vm.selectedProduction.chartsettings.lineoverlapbreaks === true));

      onZoomChangeEnd();
    }

    function updateDataSetPiecesStock(setPieces) {
      vm.setPieces = vm.setPieces.concat(setPieces);
      vm.chartItemViewFactory.setPieces = vm.setPieces;
    }

    function updateDataSetPieces(setPieces) {
      var filteredSetPieces = _.reject(setPieces, function (setPiece) {
        return (setPiece._id === selectedSetPieceId);
      });
      // vm.setPieces = vm.setPieces.concat(filteredSetPieces);
      vm.setPieces = filteredSetPieces.concat(vm.setPieces);
      vm.chartItemViewFactory.setPieces = vm.setPieces;
    }

    function updateLabSetPiece(setPiece) {
      if (angular.isUndefined(setPiece)) {
        throw new Error($translate.instant('errormessages.Error loading Set Piece!'));
      } else {
        vm.setPiece = angular.copy(setPiece);
        vm.setPiece.width = (parseFloat(vm.setPiece.width) || 0.0);
        vm.setPiece.height = (parseFloat(vm.setPiece.height) || 0.0);
        vm.measurementunitname = (vm.setPiece.measurementunit === SWStage.MeasurementUnitType.Feet) ? $translate.instant('labels.Feet') : $translate.instant('labels.Meters');

        vm.setPieceWidth = swaUtils.getFeetAndInches(vm.setPiece.width);
        vm.setPieceHeight = swaUtils.getFeetAndInches(vm.setPiece.height);

        if (!vm.isNew) {
          dbChartItems.getReferenceCountOfSetPiece(vm.setPiece._id).then(
            function (count) {
              vm.isReferenced = (count > 0);
            }
          ).catch(
            function (error) {
              $log.error('Error getting reference count', error);
              vm.isReferenced = false;
            }
          );
        }
      }
    }

    function loadSetPiece() {
      var deferred = $q.defer();

      var iQ1 = $interval(function () {
        if (vm.chartEditorState.ccInitializationPending === false) {
          $interval.cancel(iQ1);
        }
      }, 500, 10);

      iQ1.then(
        function () {
          if (vm.chartEditorState.ccInitializationPending === false) {
            return loadChartItems();
          } else {
            throw new Error('Timeout waiting for editor initialization');
          }
        },
        function () {
          return loadChartItems();
        }
      ).then(
        function () {
          deferred.resolve();
        },
        function (error) {
          deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    function loadChartItems() {
      if (vm.isNew) {
        vm.setPieceChartLayerView.activate(true);
        vm.chartEditorState.layerActive = true;
        vm.chartEditorState.chartOpen = true;

        changeTrackerInitialize();

        ccChartPauseUpdates();

        return;
      }

      if (angular.isUndefined(vm.setPiece)) {
        return;
      }

      blockUI.start();
      ccChartQuickUpdates();
      dbChartItems.getItemsOfSetPiece(vm.setPiece._id).then(
        function (items) {
          vm.setPieceChartLayerView.setChartItems(items);
          vm.setPieceChartLayerView.activate(true);
          vm.chartEditorState.layerActive = true;
          vm.chartEditorState.chartOpen = true;

          changeTrackerInitialize();
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error loading Set Piece!'));
          $log.error('SettingsCreateSetPieceController.loadChartItems():', error);
          vm.chartEditorState.chartOpen = false;
        }
      ).finally(
        function () {
          blockUI.stop();

          ccChartPauseUpdates();
        }
      );
    }

    function cancelSave() {
      var params = { productionId: selectedProductionId };
      swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.setpieces, params, true);
      delete $localStorage.pinnedPosXOfContextMenuSetpieceStage;
      delete $localStorage.pinnedPosYOfContextMenuSetpieceStage;
      delete $localStorage.isContextMenuPinnedSetpieceStage;
    }

    function saveAndClose() {
      if (angular.isUndefined(vm.setPiece)) {
        $log.debug('saveAndClose: No set piece, nothing to save!');
        var params = { productionId: selectedProductionId };
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.setpieces, params, true);
        return;
      }

      if (vm.setPiece.dirty !== true) {
        $log.debug('saveAndClose: No changes in set piece, nothing to save!');
        var params = { productionId: selectedProductionId };
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.setpieces, params, true);
        return;
      }

      var validationMessages = [];

      if (angular.isUndefined(vm.setPiece.name) || (vm.setPiece.name.length === 0)) {
        validationMessages.push($translate.instant('validationmessages.Name is required'));
      }

      var newWidth = parseFloat(vm.setPiece.width) || 0.0;
      var newHeight = parseFloat(vm.setPiece.height) || 0.0;

      if ((newWidth <= 0.0) || (newHeight <= 0.0)) {
        validationMessages.push($translate.instant('validationmessages.Width and depth should be greater than 0'));
      }

      if ((newWidth > maxUnitWidth) || (newHeight > maxUnitDepth)) {
        validationMessages.push($translate.instant('validationmessages.Width or depth cannot exceed maximum size'));
      }

      if (validationMessages.length > 0) {
        toastr.warning(
          '<ul><li>' + validationMessages.join('</li><li>') + '</li></ul>',
          $translate.instant('validationmessages.Please fix the following -'),
          { allowHtml: true }
        );

        return;
      }

      saveSetPiece().then(
        function () {
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.setpieces, true);
          delete $localStorage.pinnedPosXOfContextMenuSetpieceStage;
          delete $localStorage.pinnedPosYOfContextMenuSetpieceStage;
          delete $localStorage.isContextMenuPinnedSetpieceStage;
        }
      );
    }

    function saveSetPiece() {
      var deferred = $q.defer();

      // End any editing
      endEditVectorShape();
      endEditTextBox();

      vm.setPieceChartLayerView.clearTransientState();
      vm.setPieceChartLayerView.validateData();

      var newChartItems = vm.setPieceChartLayerView.getChartItems();

      ngProgressLite.start();
      blockUI.start();

      var newOrUpdatedSetPiece = {};
      if (vm.isNew) {
        newOrUpdatedSetPiece.name = vm.setPiece.name;
        newOrUpdatedSetPiece.height = parseFloat(vm.setPiece.height) || 0.0;
        newOrUpdatedSetPiece.width = parseFloat(vm.setPiece.width) || 0.0;
        newOrUpdatedSetPiece.measurementunit = vm.setPiece.measurementunit;
        newOrUpdatedSetPiece.setpiecetype = vm.setPiece.setpiecetype;
        newOrUpdatedSetPiece.productionId = vm.selectedProduction._id;
      } else {
        newOrUpdatedSetPiece.name = vm.setPiece.name;
        if (!vm.isReferenced) {
          newOrUpdatedSetPiece.height = parseFloat(vm.setPiece.height) || 0.0;
          newOrUpdatedSetPiece.width = parseFloat(vm.setPiece.width) || 0.0;
        }
        newOrUpdatedSetPiece._id = vm.setPiece._id;
      }

      ngProgressLite.set(0.4);
      updateSetPieceImages(newOrUpdatedSetPiece).then(
        function () {
          if (vm.isNew) {
            return dbSetPieces.insert(newOrUpdatedSetPiece);
          } else {
            return dbSetPieces.update(newOrUpdatedSetPiece);
          }
        }
      ).then(
        function (newSetPieceId) {
          if (vm.isNew) {
            selectedSetPieceId = newSetPieceId;
            return dbChartItems.getItemIdsOfSetPiece(newSetPieceId);
          } else {
            return dbChartItems.getItemIdsOfSetPiece(newOrUpdatedSetPiece._id);
          }
        }
      ).then(
        function (existingChartItemIds) {
          return saveChartItems(newChartItems, existingChartItemIds);
        }
      ).then(
        function () {
          if (vm.isNew) {
            toastr.success($translate.instant('messages.Set Piece added.'));
          } else {
            toastr.success($translate.instant('messages.Set Piece updated.'));
          }
          deferred.resolve();
        }
      ).catch(
        function (error) {
          $log.error('SettingsCreateSetPieceController.saveSetPiece:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving set piece!')
          );

          deferred.reject(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );

      return deferred.promise;
    }

    function updateSetPieceImages(setPiece) {
      var deferred = $q.defer();

      vm.chartGridView.setVisible(false);
      ccChartUpdateNow();

      var ccScaleX = cc.view.getScaleX(); // / cc.view.getDevicePixelRatio();
      var ccScaleY = cc.view.getScaleY(); // / cc.view.getDevicePixelRatio();
      var newWidth = parseFloat(vm.setPiece.width) || 0.0;
      var newHeight = parseFloat(vm.setPiece.height) || 0.0;
      var srcCanvas = $('#chartCanvas').get(0);
      var tmpCanvas = $document[0].createElement('canvas');

      tmpCanvas.width = newWidth * vm.chartItemViewFactory.scalePxPerUnitX;
      tmpCanvas.height = newHeight * vm.chartItemViewFactory.scalePxPerUnitY;

      var stageViewBounds = vm.chartGridView.getStageViewBounds();
      var srcX = stageViewBounds.x * ccScaleX;
      var srcWidth = newWidth * vm.chartItemViewFactory.scalePxPerUnitX * ccScaleX;
      var srcHeight = newHeight * vm.chartItemViewFactory.scalePxPerUnitY * ccScaleY;
      var srcY = ((stageViewBounds.y + stageViewBounds.height) * ccScaleY) - srcHeight;

      var ctx = tmpCanvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.mozImageSmoothingEnabled = true;
      ctx.webkitImageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(srcCanvas, srcX, srcY, srcWidth, srcHeight, 0, 0, tmpCanvas.width, tmpCanvas.height);

      setPiece.image = tmpCanvas.toDataURL('image/png').substring(22);
      setPiece.thumbimage = tmpCanvas.toDataURL('image/png').substring(22);

      vm.chartGridView.setVisible(true);

      deferred.resolve();

      return deferred.promise;
    }

    function updatePreview() {
      var newWidth = parseFloat(vm.setPiece.width) || 0.0;
      var newHeight = parseFloat(vm.setPiece.height) || 0.0;

      if ((newWidth <= 0.0) || (newHeight <= 0.0)) {
        return;
      }

      updateSetPieceImages(vm.setPiece);
    }

    function saveChartItems(newChartItems, existingChartItemIds) {
      var existingItemIds = existingChartItemIds;
      var updatedItemIds = [];
      var updatedItems = [];
      var insertedItems = [];

      newChartItems.forEach(function (chartItem) {
        var id = chartItem._id;
        if (!id.startsWith('__tmp__')) {
          chartItem.ofsetpieceId = selectedSetPieceId;
          updatedItemIds.push(id);
          updatedItems.push(chartItem);
        } else {
          delete chartItem._id;
          chartItem.ofsetpieceId = selectedSetPieceId;
          insertedItems.push(chartItem);
        }
      });
      var deletedItemIds = _.difference(existingItemIds, updatedItemIds);

      var allQ = [];
      insertedItems.forEach(function (insertedItem) {
        allQ.push(dbChartItems.insert(insertedItem));
      });
      updatedItems.forEach(function (updatedItem) {
        allQ.push(dbChartItems.update(updatedItem));
      });
      allQ.push(dbChartItems.delete(deletedItemIds));

      return $q.all(allQ);
    }

    function updateChartItemViewFactory() {
      if (angular.isUndefined(vm.chartItemViewFactory)) {
        vm.chartItemViewFactory = new ChartItemViewFactory();
        vm.chartItemViewFactory.imageDataPrefixUrl = swaConfig.imageDataPrefixUrl;

        vm.setPieceChartLayerView.setChartItemViewFactory(vm.chartItemViewFactory);
      }

      if (angular.isDefined(vm.selectedProduction)) {
        vm.chartItemViewFactory.stageUnitWidth = setPieceEditorMaxWidthFeet;
        vm.chartItemViewFactory.stageUnitDepth = setPieceEditorMaxDepthFeet;
        vm.chartItemViewFactory.offstageUnitWidth = vm.selectedProduction.stagesettings.offstagewidth;
        vm.chartItemViewFactory.swMeasurementUnit = vm.selectedProduction.stagesettings.stagemeasurementunit;
        vm.chartItemViewFactory.numberlineMarkerStepValue = vm.selectedProduction.stagesettings.numberlineMarkerStepValue;
        vm.chartItemViewFactory.numberlineZeroAtCenter = vm.selectedProduction.stagesettings.numberlineZeroAtCenter;
        vm.chartItemViewFactory.numberlineMultiplier = vm.selectedProduction.stagesettings.numberlineMultiplier;
        vm.chartItemViewFactory.verticalNumberlineMarkerStepValue = vm.selectedProduction.stagesettings.verticalNumberlineMarkerStepValue;
        vm.chartItemViewFactory.verticalNumberlineMultiplier = vm.selectedProduction.stagesettings.verticalNumberlineMultiplier;
        vm.chartItemViewFactory.verticalNumberlineZeroOffsetValue = vm.selectedProduction.stagesettings.verticalNumberlineZeroOffsetValue;
      }
    }

    function markChartDirty() {
      vm.setPiece.dirty = true;
    }

    $scope.$on('$destroy', function () {
      dbProductions.fetchUnregister();
      dbSetPieces.fetchUnregister();
      unregisterKeyboardHandler();
    });

    function shapePickerDidPickShape(shapeType) {
      if (shapeType === SWChartItem.ShapeType.Freehand) {
        showFreehandTool();
        return;
      }

      vm.setPieceChartLayerView.addNewShapeOfType(shapeType);
    }

    function setPiecePickerDidPickSetPiece(setPiece) {
      vm.setPieceChartLayerView.addNewSetPiece(setPiece);
    }

    function addChartText() {
      chartNotifyDisableChangeTracking();

      vm.setPieceChartLayerView.addNewTextItem(swaUi.defaultTextStylePreferences);

      chartNotifyEnableChangeTracking();
    }

    function onZoomChangeEnd() {
      vm.chartGridView.setZoomFactor(vm.chartEditorState.zoomFactor);

      // TODO: Not sure if we need to update layer positions
      var stageViewPosition = vm.chartGridView.getStageViewPosition();
      var stageViewSize = vm.chartGridView.getStageViewSize();

      vm.setPieceChartLayerView.setPosition(stageViewPosition);
      vm.setPieceChartLayerView.setContentSize(stageViewSize);

      vm.setPieceChartLayerView.willChangeZoom();

      vm.chartItemViewFactory.scalePxPerUnitX = vm.chartGridView.getScalePxPerUnitX();
      vm.chartItemViewFactory.scalePxPerUnitY = vm.chartGridView.getScalePxPerUnitY();
      vm.chartItemViewFactory.scaledStagePxWidth = vm.chartGridView.getScaledStageBounds().width;
      vm.chartItemViewFactory.scaledStagePxHeight = vm.chartGridView.getScaledStageBounds().height;
      vm.chartItemViewFactory.scaledStagePxOffset = vm.chartGridView.getZoomOffset();
      vm.chartItemViewFactory.stageViewSize = vm.chartGridView.getStageViewSize();
      vm.chartItemViewFactory.zoomFactor = vm.chartGridView.getZoomFactor();

      vm.setPieceChartLayerView.refresh();

      vm.setPieceChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());

      vm.setPieceChartLayerView.didChangeZoom();
    }

    function fitChartToView() {
      if (cc && cc.view) {
        cc.view.setDesignResolutionSize(SWSetPieceUI.DesignWidth, SWSetPieceUI.DesignHeight, cc.ResolutionPolicy.SHOW_ALL);
        ccOnResize();
      }
    }

    function updateInspectorState(caller) {
      if (angular.isUndefined(caller)) {
        if (vm.setPieceChartLayerView.getIsActive()) {
          caller = vm.setPieceChartLayerView;
        }
      }

      if (angular.isUndefined(caller)) {
        vm.chartInspectorState.selectionCount = 0;
        vm.chartInspectorState.setPieceSelected = false;
        vm.chartInspectorState.shapesSelected = false;
        return;
      }

      var hasGroup = (angular.isDefined(caller.chartItemGroupView));
      var selectionCount = (hasGroup ? 0 : caller.selectedChartItemViews.length);

      vm.chartInspectorState.selectionCount = selectionCount;
      vm.chartInspectorState.selectionGrouped = hasGroup;
      vm.chartInspectorState.canPaste = (angular.isArray(vm.clipboardItems) && (vm.clipboardItems.length > 0));

      if (selectionCount === 1) {
        var activeChartItemView = caller.activeChartItemView;

        vm.chartInspectorState.selectionRotateable = activeChartItemView.getIsRotatable();
        vm.chartInspectorState.rotationDeg = Math.round(activeChartItemView.getViewRotationDeg());

        vm.chartInspectorState.selectionOrderingMode = activeChartItemView.getIsZOrdering();

        vm.chartInspectorState.selectionEditable = activeChartItemView.getIsEditable();

        vm.chartInspectorState.zIndex = activeChartItemView.getZIndex();

        if (activeChartItemView.getItemType() === SWChartItem.Type.Shape) {
          vm.chartInspectorState.selectionColorable = activeChartItemView.getSupportsLineColor();
          vm.chartInspectorState.selectionColor = activeChartItemView.getLineColorCss();

          vm.chartInspectorState.selectionFillColorable = activeChartItemView.getSupportsFillColor();
          vm.chartInspectorState.selectionFillColor = activeChartItemView.getFillColorCss();
        } else {
          vm.chartInspectorState.selectionColorable = false;
          vm.chartInspectorState.selectionFillColorable = false;
        }

        vm.chartInspectorState.selectionFlipAble = activeChartItemView.getIsFlippable();

        if (activeChartItemView.getItemType() === SWChartItem.Type.SetPiece) {
          vm.chartInspectorState.setPieceSelected = true;
        } else {
          vm.chartInspectorState.setPieceSelected = false;
        }
      }

      var selectedChartItemViews = caller.selectedChartItemViews;

      if (vm.chartInspectorState.selectionCount === 0) {
        vm.chartInspectorState.setPieceSelected = false;
        vm.chartInspectorState.shapesSelected = false;
      } else {
        var allShapes = true;
        selectedChartItemViews.forEach(function (chartItemView) {
          var itemType = chartItemView.getItemType();
          if (itemType === SWChartItem.Type.Shape) {
            // do nothing
          } else {
            allShapes = false;
          }
        });

        vm.chartInspectorState.shapesSelected = allShapes;
      }

      if (selectionCount > 1) {
        vm.chartInspectorState.setPieceSelected = false;
      }

      $timeout(function () {
        $scope.$apply();
      });
    }

    function editVectorShape(chartItemShapeView) {
      vm.chartShapeVectorEditorView = new ChartShapeVectorEditorView();
      vm.chartShapeVectorEditorView.delegate = vm;
      vm.chartShapeVectorEditorView.chartItemViewFactory = vm.chartItemViewFactory;
      vm.chartShapeVectorEditorView.setPosition(vm.chartGridView.getStageViewPosition());
      vm.chartShapeVectorEditorView.setContentSize(vm.chartGridView.getStageViewSize());
      ccChartEditorLayer.addChild(vm.chartShapeVectorEditorView);
      ccChartEditorLayer.bringChildToFront(vm.chartShapeVectorEditorView);
      vm.chartShapeVectorEditorView.beginEditingShapeInView(chartItemShapeView);

      vm.chartEditorState.inspectorVisible = true;
      vm.chartInspectorState.vectorEditorActive = true;
      vm.chartInspectorState.vectorEditorNodeSelected = false;
      vm.chartInspectorState.layerEditorActive = true;
      vm.chartInspectorState.lineThickness = (chartItemShapeView.chartItemShape.linethickness / 2) + 1;

      chartItemShapeView.parent.setUserInteractionEnabled(false);

      chartNotifyDisableChangeTracking();
    }

    function endEditVectorShape() {
      if (angular.isDefined(vm.chartShapeVectorEditorView)) {
        var chartItemShapeView = vm.chartShapeVectorEditorView.endEditing();
        ccChartEditorLayer.removeChild(vm.chartShapeVectorEditorView);
        vm.chartShapeVectorEditorView = undefined;

        vm.chartInspectorState.vectorEditorActive = false;
        vm.chartInspectorState.vectorEditorNodeSelected = false;
        vm.chartInspectorState.layerEditorActive = false;

        chartItemShapeView.parent.setUserInteractionEnabled(true);
        chartItemShapeView.refresh();

        chartNotifyEnableChangeTracking();
        chartNotifyDataDidChange();
      }
    }

    function showFreehandTool() {
      vm.chartShapeFreehandToolView = new ChartShapeFreehandToolView();
      vm.chartShapeFreehandToolView.delegate = vm;
      vm.chartShapeFreehandToolView.chartItemViewFactory = vm.chartItemViewFactory;
      vm.chartShapeFreehandToolView.setPosition(vm.chartGridView.getStageViewPosition());
      vm.chartShapeFreehandToolView.setContentSize(vm.chartGridView.getStageViewSize());
      vm.chartShapeFreehandToolView.setHasArrowhead(vm.chartInspectorState.freehandHasArrowhead);
      vm.chartShapeFreehandToolView.setLineColorCss(vm.chartInspectorState.selectionColor);
      ccChartEditorLayer.addChild(vm.chartShapeFreehandToolView);
      ccChartEditorLayer.bringChildToFront(vm.chartShapeFreehandToolView);

      vm.chartShapeFreehandToolView.initializeTool();

      vm.chartEditorState.inspectorVisible = true;
      vm.chartInspectorState.freehandToolActive = true;
      vm.chartInspectorState.layerEditorActive = true;
    }

    function closeFreehandTool() {
      if (angular.isDefined(vm.chartShapeFreehandToolView)) {
        ccChartEditorLayer.removeChild(vm.chartShapeFreehandToolView);
        vm.chartShapeFreehandToolView = undefined;

        vm.chartInspectorState.freehandToolActive = false;
        vm.chartInspectorState.layerEditorActive = false;
      }
    }

    function editTextBox(chartItemTextView) {
      chartItemTextView.setEditing(true);

      vm.chartEditorState.inspectorVisible = true;
      vm.chartInspectorState.textBoxText = '';
      vm.chartInspectorState.textBoxRichText = '';
      vm.chartInspectorState.layerEditorActive = true;

      vm.chartInspectorState.editingChartItemTextView = chartItemTextView;
      // chartItemTextView.parent.setUserInteractionEnabled(false);

      chartNotifyDisableChangeTracking();

      $timeout(function () {
        var canvas = $document[0].getElementById('chartCanvas');
        var canvasContainer = $document[0].getElementById('chartCanvasContainer');

        var canvasContainerWidth = canvasContainer.offsetWidth;
        var canvasContainerHeight = canvasContainer.offsetHeight;
        var canvasWidth = canvas.offsetWidth;
        var canvasHeight = canvas.offsetHeight;

        var element = angular.element('.inspector-texteditor-textarea');
        element.trigger('focus');
        vm.chartInspectorState.textBoxText = chartItemTextView.chartItemText.textcontent;
        if (angular.isUndefined(chartItemTextView.chartItemText.richtextcontent)) {
          vm.chartInspectorState.textBoxRichText = vm.chartInspectorState.textBoxText;
        } else {
          vm.chartInspectorState.textBoxRichText = chartItemTextView.chartItemText.richtextcontent;
        }

        vm.chartInspectorState.selectionBackgroundColor = chartItemTextView.chartItemText.backgroundcolor;

        var startPointX = ((canvasContainerWidth - canvasWidth) / 2) + ((canvasWidth - (chartItemTextView.chartItemViewFactory._stageViewSize.width * vm.ccScaleX)) / 2) + (5 * vm.ccScaleX);
        var startPointY = ((canvasContainerHeight - canvasHeight) / 2) + ((canvasHeight - (chartItemTextView.chartItemViewFactory._stageViewSize.height * vm.ccScaleY)) / 2) - (12 * vm.ccScaleY);

        vm.chartTextEditorState.editorPosX = startPointX + (chartItemTextView.chartItemText.positionx * chartItemTextView.chartItemViewFactory._scalePxPerUnitX * vm.ccScaleX) + (chartItemTextView.chartItemViewFactory._scaledStagePxOffset.x * vm.ccScaleX);
        vm.chartTextEditorState.editorPosY = startPointY + (chartItemTextView.chartItemText.positiony * chartItemTextView.chartItemViewFactory._scalePxPerUnitY * vm.ccScaleY) + (chartItemTextView.chartItemViewFactory._scaledStagePxOffset.y * vm.ccScaleY);

        vm.chartTextEditorState.editorWidth = chartItemTextView.chartItemText.sizewidth * 20 / chartItemTextView.chartItemViewFactory._measurementConversionMultiplier;
        vm.chartTextEditorState.editorHeight = chartItemTextView.chartItemText.sizeheight * 20 / chartItemTextView.chartItemViewFactory._measurementConversionMultiplier;

        vm.chartTextEditorState.rotationAngle = chartItemTextView.chartItemText.rotation * (-180 / Math.PI);
        vm.chartTextEditorState.editorScale = (chartItemTextView.chartItemViewFactory._scalePxPerUnitX * vm.ccScaleX) / 20 * chartItemTextView.chartItemViewFactory._measurementConversionMultiplier;

        vm.chartInspectorState.textEditorActive = true;
      }, 100);
    }

    function endEditTextBox() {
      if (angular.isDefined(vm.chartInspectorState.editingChartItemTextView)) {
        var chartItemTextView = vm.chartInspectorState.editingChartItemTextView;
        vm.chartInspectorState.textEditorActive = false;
        vm.chartInspectorState.editingChartItemTextView = undefined;
        vm.chartInspectorState.layerEditorActive = false;

        chartItemTextView.parent.setUserInteractionEnabled(true);
        chartItemTextView.setEditing(false);
        chartItemTextView.refresh();

        chartNotifyEnableChangeTracking();
        chartNotifyDataDidChange();
      }
    }

    function shapeEditorSelectedNode(selected) {
      $scope.$applyAsync(function () {
        vm.chartInspectorState.vectorEditorNodeSelected = (selected === true);
      });
    }

    function onInspectorAction(action) {
      if (vm.chartEditorState.ccInitializationPending) {
        return;
      }

      var targetLayer;

      if (vm.setPieceChartLayerView.getIsActive()) {
        targetLayer = vm.setPieceChartLayerView;
      }

      if (angular.isUndefined(targetLayer)) {
        return;
      }

      if (action.type === 'angle') {
        var angle = parseInt(action.value);
        targetLayer.chartInspectorRotationChangedTo(angle);
      } else if (action.type === 'resetAngle') {
        var resetAngle = parseInt(action.value);
        targetLayer.selectedItemRotationReset(resetAngle);
      } else if (action.type === 'increaseThickness') {
        targetLayer.selectedItemIncreaseLineThickness();
      } else if (action.type === 'decreaseThickness') {
        targetLayer.selectedItemDecreaseLineThickness();
      } else if (action.type === 'resetThickness') {
        targetLayer.selectedItemResetLineThickness();
      } else if (action.type === 'increaseThicknessForFreehand') {
        targetLayer.increaseLineThicknessForFreehand();
      } else if (action.type === 'decreaseThicknessForFreehand') {
        targetLayer.decreaseLineThicknessForFreehand();
      } else if (action.type === 'resetThicknessForFreehand') {
        targetLayer.resetLineThicknessForFreehand();
      }
      else if (action.type === 'alignLeft') {
        targetLayer.selectedItemAlignLeft();
      } else if (action.type === 'alignCenter') {
        targetLayer.selectedItemAlignCenter();
      } else if (action.type === 'alignRight') {
        targetLayer.selectedItemAlignRight();
      } else if (action.type === 'alignTop') {
        targetLayer.selectedItemAlignTop();
      } else if (action.type === 'alignMiddle') {
        targetLayer.selectedItemAlignMiddle();
      } else if (action.type === 'alignBottom') {
        targetLayer.selectedItemAlignBottom();
      }
      else if (action.type === 'horizontalSpacing') {
        targetLayer.selectedItemHorizontalSpacing();
      }
      else if (action.type === 'verticalSpacing') {
        targetLayer.selectedItemVerticalSpacing();
      }
      else if (action.type === 'layer') {
        if (action.value === 'begin') {
          targetLayer.chartInspectorBeginOrderingEdit();
        } else if (action.value === 'top') {
          targetLayer.chartInspectorSendItemToTop();
        } else if (action.value === 'up') {
          targetLayer.chartInspectorSendItemUp();
        } else if (action.value === 'down') {
          targetLayer.chartInspectorSendItemDown();
        } else if (action.value === 'bottom') {
          targetLayer.chartInspectorSendItemToBottom();
        } else if (action.value === 'end') {
          targetLayer.chartInspectorEndOrderingEdit();
        }
      } else if (action.type === 'rotation') {
        if (action.value === 'begin') {
          vm.chartInspectorState.selectionRotationMode = true;
        } else if (action.value === 'end') {
          vm.chartInspectorState.selectionRotationMode = false;
        }
        targetLayer.setSelectionRotationMode(vm.chartInspectorState.selectionRotationMode);
      }
      else if (action.type === 'snapToGridMode') {
        if (action.value === 'begin') {
          vm.chartInspectorState.selectionSnapToGrid = true;
        } else if (action.value === 'end') {
          vm.chartInspectorState.selectionSnapToGrid = false;
        }
        targetLayer.setSelectionSnapToGridMode(vm.chartInspectorState.selectionSnapToGrid);
      }
      else if (action.type === 'alignToGrid') {
        targetLayer.selectedItemSnapToGrid();
      }
      else if (action.type === 'color') {
        if (action.value.border) {
          if (vm.chartShapeFreehandToolView) {
            vm.chartShapeFreehandToolView.setLineColorCss(action.value.border);
          } else if (vm.chartShapeVectorEditorView) {
            vm.chartShapeVectorEditorView.setLineColorCss(action.value.border);
          } else {
            targetLayer.chartInspectorSelectionChoseColor(action.value.border);
          }
        } else if (action.value.fill) {
          targetLayer.chartInspectorSelectionChooseFillColor(action.value.fill);
        } else if (action.value.background) {
          targetLayer.chartInspectorSelectionChooseBackgroundColor(action.value.background);
        }
      } else if (action.type === 'clipboard') {
        if (action.value === 'cut') {
          vm.clipboardItems = targetLayer.chartInspectorSelectionCut();
          updateInspectorState();
        } else if (action.value === 'copy') {
          vm.clipboardItems = targetLayer.chartInspectorSelectionCopy();
          updateInspectorState();
        } else if (action.value === 'duplicate') {
          vm.clipboardItems = targetLayer.chartInspectorSelectionDuplicate(); // SWA-ST1-T58 keyboard shortcut for duplicate
        } else if (action.value === 'paste') {
          clipboardPaste(targetLayer);
        }
      } else if (action.type === 'group') {
        targetLayer.chartInspectorSelectionGroupToggle();
      } else if (action.type === 'groups') {
        targetLayer.chartInspectorSelectionGroup(); // SWA-ST1-T58 keyboard shortcut for group
      } else if (action.type === 'ungroups') {
        targetLayer.chartInspectorSelectionUnGroup(); // SWA-ST1-T58 keyboard shortcut for ungroup
      } else if (action.type === 'edit') {
        targetLayer.chartInspectorSelectionEdit();
      } else if (action.type === 'delete') {
        targetLayer.chartInspectorSelectionDelete();
      } else if (action.type === 'clear') {
        if (!targetLayer.chartInspectorSelectionClear()) {
          vm.clipboardItems = [];
          updateInspectorState();
        }
      }
      else if (action.type === 'fliphorizontally') {
        targetLayer.chartInspectorFlipHorizontally();
      } else if (action.type === 'flipvertically') {
        targetLayer.chartInspectorFlipVertically();
      }
      else if (action.type === 'vectorEditor') {
        if (action.value === 'deleteNode') {
          if (vm.chartShapeVectorEditorView) {
            vm.chartShapeVectorEditorView.deleteSelectedNode();
          }
        } else if (action.value === 'done') {
          endEditVectorShape();
          if (vm.chartInspectorState.selectionSnapToGrid) {
            targetLayer.selectedItemSnapToGrid();
          }
        }
      } else if (action.type === 'freehandTool') {
        if (action.value === 'clear') {
          if (vm.chartShapeFreehandToolView) {
            vm.chartShapeFreehandToolView.clearShape();
          }
        } else if (action.value === 'arrowheadChange') {
          if (vm.chartShapeFreehandToolView) {
            vm.chartShapeFreehandToolView.setHasArrowhead(vm.chartInspectorState.freehandHasArrowhead);
          }
        } else if (action.value === 'save') {
          if (vm.chartShapeFreehandToolView) {
            var newShapeItem = vm.chartShapeFreehandToolView.getCurrentShapeItem();
            if (angular.isDefined(newShapeItem)) {
              targetLayer.addNewFreehandShape(newShapeItem);
            }

            closeFreehandTool();
          }
        } else if (action.value === 'close') {
          closeFreehandTool();
        }
      } else if (action.type === 'textEditor') {
        if (action.value === 'textChange') {
          vm.chartInspectorState.editingChartItemTextView.chartItemText.richtextcontent = vm.chartInspectorState.textBoxRichText;
          vm.chartInspectorState.editingChartItemTextView.chartItemText.textcontent = vm.chartInspectorState.textBoxText;
          vm.chartInspectorState.editingChartItemTextView.refresh();
        } else if (action.value === 'done') {
          endEditTextBox();
        }
      }
      else if (action.type === 'closeContextMenu') {
        if (action.value === 'closeMenu') {
          vm.chartContextMenuState.visible = false;
          vm.chartInspectorState.alignMenu = false;
        }
      }
      else if (action.type === 'togglepinstatus') {
        if (action.value === 'togglepinstatus') {
          toggleContextMenuPinStatus();
        }
      }
      else if (action.type === 'showAlignMenu') {
        if (action.value === 'alignMenuShow') {
          vm.chartInspectorState.alignMenu = true;
        }
      }
      else if (action.type === 'hideAlignMenu') {
        if (action.value === 'alignMenuHide') {
          vm.chartInspectorState.alignMenu = false;
        }
      }

      $timeout(function () {
        $scope.$apply();
      });
    }

    function clipboardPaste(targetLayer) {
      targetLayer.chartInspectorSelectionPaste(vm.clipboardItems);
    }

    // Cocos logic below
    function setupCocos() {
      $document[0]['ccConfig'] = {
        id: 'chartCanvas',
        frameRate: 10,
        renderMode: 1,
        showFPS: false,
        debugMode: 4,
        jsList: []
      };

      cc.game.onStart = function () {

        cc.view.resizeWithBrowserSize(true);
        cc.view.setResizeCallback(ccOnResize);

        // Root cc Scene and layer
        ccRootScene = new SetPieceEditorScene();
        ccChartEditorLayer = ccRootScene.setPieceEditorLayer;

        setupLayerViews();

        ccChartEditorLayer.addChild(vm.chartGridView);
        ccChartEditorLayer.addChild(vm.setPieceChartLayerView);

        cc.director.runScene(ccRootScene);

        updateDataProductionPostCocosInit();

        fitChartToView();

        vm.chartEditorState.ccInitializationPending = false;
      };

      cc.fullReset();
      cc.game.run('chartCanvas'); // eslint-disable-line angular/module-getter
    }

    function stopCocos() {
      cc.director.end();
    }

    var _chartPauseTimeout;
    var _pauseFps = 2;
    var _lastFps = -1;

    function ccChartPauseUpdates() {
      $log.debug('ccChartPauseUpdates: Will start pausing chart updates ...');
      _lastFps = parseFloat(cc.game.config.frameRate);
      _ccChartHalfLifePause();
    }

    function _ccChartHalfLifePause() {
      var fr = parseFloat(cc.game.config.frameRate);
      if (fr > _lastFps) {
        $log.debug('_ccChartHalfLifePause: FPS bumped by other call!');
        return;
      }

      if (fr > _pauseFps) {
        fr = fr / 2;
        if (fr < _pauseFps) {
          fr = _pauseFps;
        }

        cc.game.setFrameRate(fr);
      }

      if (fr === _pauseFps) {
        $log.debug('_ccChartHalfLifePause: Chart updates now paused (' + _pauseFps + ' FPS)');
      } else {
        $log.debug('_ccChartHalfLifePause: Chart updates now @ ' + fr + ' FPS)');

        $timeout.cancel(_chartPauseTimeout);
        _chartPauseTimeout = $timeout(function () {
          _ccChartHalfLifePause();
        }, 2000);
      }
    }

    function _ccChartKillPause() {
      $timeout.cancel(_chartPauseTimeout);
      _chartPauseTimeout = undefined;
    }

    function ccChartNormalUpdates() {
      $log.debug('ccChartNormalUpdates: Chart updates now normal @ 10 FPS');
      cc.game.setFrameRate(10);
    }

    function ccChartQuickUpdates() {
      $log.debug('ccChartQuickUpdates: Chart updates now quick @ 60 FPS');
      _ccChartKillPause();
      cc.game.setFrameRate(60);
    }

    function ccChartUpdateNow() {
      cc.director.drawScene();
    }

    var ccResizeTimer;

    function ccOnResize() {
      if (angular.isDefined(ccResizeTimer)) {
        $timeout.cancel(ccResizeTimer);
        ccResizeTimer = undefined;
      } else {
        chartBlockUI.start();
      }

      ccResizeTimer = $timeout(function () {
        ccUpdateViewScale();
        endEditTextBox();

        chartBlockUI.stop();
        $timeout.cancel(ccResizeTimer);
        ccResizeTimer = undefined;
        $('.sw-toolbar-setpiecechart').width($('#Cocos2dGameContainer').width());
      }, 500);
    }

    function ccUpdateViewScale() {
      vm.ccScaleX = cc.view.getScaleX() / cc.view.getDevicePixelRatio();
      vm.ccScaleY = cc.view.getScaleY() / cc.view.getDevicePixelRatio();
    }

    function initHelpTour() {
      vm.showHelpBar = false;

      var userData = DbSubMgrService.getLoggedInUserData();
      var profileDisplayHelp = false;
      if (angular.isDefined(userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }

      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function initHelpTourSteps() {
      vm.helpTourSteps = [{
        element: '#name-size',
        title: $translate.instant('helptour.settingsSetPieceEditor.titles.Name & Size'),
        content: $translate.instant('helptour.settingsSetPieceEditor.messages.Name & Size Content'),
        placement: 'bottom',
      }, {
        element: '#preview',
        title: $translate.instant('helptour.settingsSetPieceEditor.titles.Preview'),
        content: $translate.instant('helptour.settingsSetPieceEditor.messages.Preview Content'),
        placement: 'left',
      }, {
        element: '#shape-text',
        title: $translate.instant('helptour.settingsSetPieceEditor.titles.Shape & Text'),
        content: $translate.instant('helptour.settingsSetPieceEditor.messages.Shape & Text Content'),
        placement: 'bottom',
      }, {
        element: '#set-pieces',
        title: $translate.instant('helptour.settingsSetPieceEditor.titles.Add Set Pieces'),
        content: $translate.instant('helptour.settingsSetPieceEditor.messages.Add Set Pieces Content'),
        placement: 'left',
      }];

      vm.helpTourVideos = [{
        label: 'Settings: Set Pieces',
        videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=534'
      }];
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toParams.skipValidation) {
        return;
      }

      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        toastr.clear();
        toastr.warning($translate.instant('messages.Please \'Save\' or \'Cancel\' your Set Piece Lab creation.'));
        event.preventDefault();
      }
    });

    var isAltKeyDown = false;

    function keyboardHandler(event) {
      if (keyboardHandlerCheckTarget(event)) {
        return;
      }

      // key
      var whichKey = event.which;
      var key = event.key;

      // event types
      var keydown = event.type === 'keydown';
      var keyup = event.type === 'keyup';

      // modifier keys and combos
      var ctrlKey = event.ctrlKey && !(event.altKey || event.shiftKey || event.metaKey);
      var ctrlShiftKey = event.ctrlKey && event.shiftKey && !(event.altKey || event.metaKey);
      var metaKey = event.metaKey && !(event.altKey || event.shiftKey || event.ctrlKey);
      var metaShiftKey = event.metaKey && event.shiftKey && !(event.altKey || event.ctrlKey);
      var noModKey = !(event.ctrlKey || event.altKey || event.shiftKey || event.metaKey);
      var altKey = (event.altKey || (event.key === 'Alt')) && !(event.metaKey || event.shiftKey || event.ctrlKey);

      if (keyup) {
        // STA-I195 keyboard shortcut for rotation mode
        if (altKey) {
          isAltKeyDown = false;
          event.preventDefault();
          event.stopPropagation();
          if (vm.chartInspectorState.selectionRotationMode) {
            keyboardHandlerHandleRotationModeEnd();
          } else {
            keyboardHandlerHandleRotationModeBegin();
          }
        }
      } else {
        // clipboard shortcuts check
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          if (whichKey === 88) {
            keyboardHandlerHandleCut(event);
            return;
          } else if (whichKey === 67) {
            keyboardHandlerHandleCopy(event);
            return;
          } else if (whichKey === 86) {
            keyboardHandlerHandlePaste(event);
            return;
          }
        }

        // Delete or backspace, without any modifier key
        if (noModKey && ((whichKey === 8) || (whichKey === 46))) {
          keyboardHandlerHandleDelete(event);
          return;
        }

        // Undo/Redo
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          if (whichKey === 90) {
            keyboardHandlerHandleUndo();
            return;
          } else if (whichKey === 89) {
            keyboardHandlerHandleRedo();
            return;
          }
        }

        // Redo (Mac)
        if (vm.platformMac && metaShiftKey) {
          if (whichKey === 90) {
            keyboardHandlerHandleRedo();
            return;
          }
        }

        // SWA-ST1-T58 keyboard shortcut for group
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          event.stopPropagation();
          event.preventDefault();
          if (whichKey === 71) {
            keyboardHandlerHandleGroup();
            return;
          }
        }

        // SWA-ST1-T58 keyboard shortcut for ungroup
        if ((vm.platformMac && metaShiftKey) || (!vm.platformMac && ctrlShiftKey)) {
          event.stopPropagation();
          event.preventDefault();
          if (whichKey === 71) {
            keyboardHandlerHandleUnGroup();
            return;
          }
        }

        // SWA-ST1-T58 keyboard shortcut for duplicate
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          event.stopPropagation();
          event.preventDefault();
          if (whichKey === 68) {
            keyboardHandlerHandleDuplicate();
            return;
          }
        }

        // STA-I195 keyboard shortcut for rotation mode
        if (altKey && !isAltKeyDown) {
          isAltKeyDown = true;
          event.preventDefault();
          event.stopPropagation();
          if (vm.chartInspectorState.selectionRotationMode) {
            keyboardHandlerHandleRotationModeEnd();
          } else {
            keyboardHandlerHandleRotationModeBegin();
          }
        }

        // zoom control
        // if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
        //   if (whichKey === 219) {
        //     keyboardHandlerHandleZoomIn(event);
        //     return;
        //   } else if (whichKey === 221) {
        //     keyboardHandlerHandleZoomOut(event);
        //     return;
        //   } else if (whichKey === 48){
        //     keyboardHandlerHandleZoomReset(event);
        //     return;
        //   }
        // }
      }
    }

    function keyboardHandlerCheckTarget(event) {
      var target = event.target;

      if ((target.nodeName === 'INPUT') || (target.nodeName === 'TEXTAREA')) {
        return true;
      } else {
        return target.attributes.contenteditable
      }
    }

    function keyboardHandlerHandleCut(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.selectionCount > 0)) {
        $log.debug('Keyboard - Cut');

        onInspectorAction({ type: 'clipboard', value: 'cut' });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Selection cut'),
          $translate.instant('titles.Clipboard')
        );
      }
    }

    function keyboardHandlerHandleCopy(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.selectionCount > 0)) {
        $log.debug('Keyboard - Copy');

        onInspectorAction({ type: 'clipboard', value: 'copy' });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Selection copied'),
          $translate.instant('titles.Clipboard')
        );
      }
    }

    function keyboardHandlerHandlePaste(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.canPaste)) {
        $log.debug('Keyboard - Paste');

        onInspectorAction({ type: 'clipboard', value: 'paste' });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Content pasted'),
          $translate.instant('titles.Clipboard')
        );
      }
    }

    function keyboardHandlerHandleDelete(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.selectionCount > 0)) {
        $log.debug('Keyboard - Delete');

        onInspectorAction({ type: 'delete' });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Selection deleted')
        );
      }
    }

    // SWA-ST1-T58 keyboard shortcut for group
    function keyboardHandlerHandleGroup(event) {
      if ((vm.chartEditorState.layerActive) && ((vm.chartInspectorState.selectionCount > 1) || vm.chartInspectorState.selectionGrouped)) {
        $log.debug('Keyboard - Group');
        onInspectorAction({
          type: 'groups',
        });

      }
    }

    // SWA-ST1-T58 keyboard shortcut for ungroup
    function keyboardHandlerHandleUnGroup(event) {
      if ((vm.chartEditorState.layerActive) && ((vm.chartInspectorState.selectionCount > 1) || vm.chartInspectorState.selectionGrouped)) {
        $log.debug('Keyboard - UnGroup');
        onInspectorAction({
          type: 'ungroups',
        });

      }
    }

    // SWA-ST1-T58 keyboard shortcut for duplicate
    function keyboardHandlerHandleDuplicate(event) {
      if (vm.chartEditorState.layerActive && !vm.chartInspectorState.selectionGrouped) {
        $log.debug('Keyboard - Duplicate');
        onInspectorAction({
          type: 'clipboard',
          value: 'duplicate'
        });

        toastr.info(
          $translate.instant('messages.Selection Duplicated')
        );
      }
    }

    function keyboardHandlerHandleUndo(event) {
      if (vm.changeTracker.enabled && vm.changeTracker.canUndo) {
        $log.debug('Keyboard - Undo');
        undoAction();
      }
    }

    function keyboardHandlerHandleRedo(event) {
      if (vm.changeTracker.enabled && vm.changeTracker.canRedo) {
        $log.debug('Keyboard - Redo');
        redoAction();
      }
    }

    // STA-I195 keyboard shortcut for rotation mode
    function keyboardHandlerHandleRotationModeBegin(event) {
      if (vm.chartEditorState.layerActive) {
        onInspectorAction({
          type: 'rotation',
          value: 'begin'
        });
        if ((vm.chartInspectorState.selectionCount > 0) || vm.chartInspectorState.selectionGrouped) {
          toastr.clear();
          toastr.info(
            $translate.instant('messages.Rotation mode enabled')
          );
        }
      }
    }

    // STA-I195 keyboard shortcut for rotation mode
    function keyboardHandlerHandleRotationModeEnd(event) {
      if (vm.chartEditorState.layerActive) {
        onInspectorAction({
          type: 'rotation',
          value: 'end'
        });
        if ((vm.chartInspectorState.selectionCount > 0) || vm.chartInspectorState.selectionGrouped) {
          toastr.clear();
          toastr.info(
            $translate.instant('messages.Rotation mode disabled')
          );
        }
      }
    }

    function keyboardHandlerHandleZoomIn(event) {
      if (vm.chartEditorState.chartOpen) {
        if (vm.chartEditorState.zoomFactor < vm.chartEditorState.maxZoomFactor) {
          vm.chartEditorState.zoomFactor++;
          onZoomChangeEnd();
        }

        event.stopPropagation();
        event.preventDefault();
      }
    }

    function keyboardHandlerHandleZoomOut(event) {
      if (vm.chartEditorState.chartOpen) {
        if (vm.chartEditorState.zoomFactor > 1) {
          vm.chartEditorState.zoomFactor--;
          onZoomChangeEnd();
        }

        event.stopPropagation();
        event.preventDefault();
      }
    }

    function keyboardHandlerHandleZoomReset(event) {
      if (vm.chartEditorState.chartOpen) {
        if (vm.chartEditorState.zoomFactor !== 1) {
          vm.chartEditorState.zoomFactor = 1;
          onZoomChangeEnd();
        }

        event.stopPropagation();
        event.preventDefault();
      }
    }

    function registerKeyboardHandler() {
      $log.debug('ChartEditorController: registerKeyboardHandler:');
      $(document).on('keydown', keyboardHandler);
      $(document).on('keyup', keyboardHandler);

      tryIdentifyPlatform();
    }

    function unregisterKeyboardHandler() {
      $log.debug('ChartEditorController: unregisterKeyboardHandler:');
      $(document).off('keydown', keyboardHandler);
      $(document).on('keyup', keyboardHandler);
    }

    function tryIdentifyPlatform() {
      vm.platformMac = (navigator.platform && (navigator.platform.match(/mac/i) !== null)) || (navigator.userAgent.match(/Macintosh/i) !== null);
    }

    vm.changeTracker = {
      undoStack: [],
      redoStack: [],

      lastTrackedState: undefined,

      nextStateNumber: 0,

      disableTrackingCount: 0,

      canUndo: false,
      canRedo: false,
      enabled: false,
    };

    function changeTrackerReset() {
      $log.debug('changeTrackerReset():');
      vm.changeTracker.undoStack.length = 0;
      vm.changeTracker.redoStack.length = 0;
      vm.changeTracker.lastTrackedState = undefined;
      vm.changeTracker.nextStateNumber = 0;
      vm.changeTracker.disableTrackingCount = 0;

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function changeTrackerInitialize() {
      $log.debug('changeTrackerInitialize():');
      changeTrackerReset();

      vm.changeTracker.lastTrackedState = getCurrentChartStateCopy();

      changeTrackerUpdateState();
    }

    function changeTrackerUpdateState() {
      vm.changeTracker.enabled = (vm.changeTracker.disableTrackingCount === 0);

      // Trim entries if needed
      if (vm.changeTracker.undoStack.length > 50) {
        vm.changeTracker.undoStack.splice(0, vm.changeTracker.undoStack.length - 50);
      }

      $scope.$applyAsync(function () {
        vm.changeTracker.canUndo = (vm.changeTracker.undoStack.length > 0);
        vm.changeTracker.canRedo = (vm.changeTracker.redoStack.length > 0);
      });
    }

    function getCurrentChartStateCopy() {
      var state = {
        chartItems: [],
      };
      state.chartItems = vm.setPieceChartLayerView.getChartItems();

      state.stateNumber = vm.changeTracker.nextStateNumber;

      return angular.copy(state);
    }

    function restoreChartStateFrom(state) {
      vm.setPieceChartLayerView.setChartItems(state.chartItems);
      vm.setPieceChartLayerView.refreshForUndoRedo();
      ccChartUpdateNow();
    }

    function chartNotifyDataDidChange() {
      $log.debug('chartNotifyDataDidChange():', Date.now());
      markChartDirty();

      if (vm.changeTracker.enabled) {
        if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
          vm.changeTracker.undoStack.push(vm.changeTracker.lastTrackedState);
        }

        vm.changeTracker.nextStateNumber++;
        vm.changeTracker.lastTrackedState = getCurrentChartStateCopy();

        vm.changeTracker.redoStack.length = 0;
      }

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function chartNotifyDisableChangeTracking() {
      $log.debug('chartNotifyDisableChangeTracking():');
      vm.changeTracker.disableTrackingCount++;

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function chartNotifyEnableChangeTracking() {
      $log.debug('chartNotifyEnableChangeTracking():');
      vm.changeTracker.disableTrackingCount--;

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function undoAction() {
      $log.debug('undoAction():');
      var undoState = vm.changeTracker.undoStack.pop();

      if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
        vm.changeTracker.redoStack.push(vm.changeTracker.lastTrackedState);
      }

      vm.changeTracker.lastTrackedState = angular.copy(undoState);

      restoreChartStateFrom(undoState);

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function redoAction() {
      $log.debug('redoAction():');
      var redoState = vm.changeTracker.redoStack.pop();

      if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
        vm.changeTracker.undoStack.push(vm.changeTracker.lastTrackedState);
      }

      vm.changeTracker.lastTrackedState = angular.copy(redoState);

      restoreChartStateFrom(redoState);

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function logChangeTrackerState() {
      $log.debug('Change Tracker - nextStateNumber:', vm.changeTracker.nextStateNumber);

      $log.debug('Change Tracker - undoStack:', _.map(vm.changeTracker.undoStack, function (item) { return item.stateNumber; }));

      $log.debug('Change Tracker - redoStack top:', _.map(vm.changeTracker.redoStack, function (item) { return item.stateNumber; }));

      if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
        $log.debug('Change Tracker - lastTrackedState:', vm.changeTracker.lastTrackedState.stateNumber);
      } else {
        $log.debug('Change Tracker - lastTrackedState: --');
      }

      $log.debug('Change Tracker - disableTrackingCount:', vm.changeTracker.disableTrackingCount);
      $log.debug('Change Tracker ---------------');
    }

    function getSetPieceWidthInFeet() {
      vm.setPiece.width = swaUtils.getFinalValueInFeet(vm.setPieceWidth);
      vm.setPieceWidth = swaUtils.getFeetAndInches(vm.setPiece.width);
    }

    function getSetPieceHeightInFeet() {
      vm.setPiece.height = swaUtils.getFinalValueInFeet(vm.setPieceHeight);
      vm.setPieceHeight = swaUtils.getFeetAndInches(vm.setPiece.height);
    }

    // To handle show/hide context menu based on mousedown point and mouseup point. 
    var clickDownPosX = 0;
    var clickDownPosY = 0;
    function canvasContainerClickDown(event) {
      clickDownPosX = event.offsetX;
      clickDownPosY = event.offsetY;

      var canvasWidth = event.target.offsetWidth;
      var canvasHeight = event.target.offsetHeight;
      var menuWidth = CHART_CTX_MNU_WIDTH;
      var menuHeight = CHART_CTX_MNU_HEIGHT;

      var maxX = canvasWidth - menuWidth;
      var maxY = canvasHeight - menuHeight;

      if (clickDownPosX > maxX) {
        clickDownPosX = clickDownPosX - menuWidth;
      }

      if (clickDownPosY > maxY) {
        clickDownPosY = maxY;
      }

      clickDownPosX += event.target.parentElement.offsetLeft;
      clickDownPosY += event.target.parentElement.offsetTop;
    }

    function canvasContainerClick(event) {
      // TODO: need to check if we can invoke the context menu
      // check - plan, access rules, layer active, etc.
      if (!vm.chartEditorState.layerActive) {
        return;
      }

      var posX = event.offsetX;
      var posY = event.offsetY;

      // Ensure the context menu stays within the canvas
      var canvasWidth = event.target.offsetWidth;
      var canvasHeight = event.target.offsetHeight;
      var menuWidth = CHART_CTX_MNU_WIDTH;
      var menuHeight = CHART_CTX_MNU_HEIGHT;
      // Calculate the maximum allowed positions
      var maxX = canvasWidth - menuWidth;
      var maxY = canvasHeight - menuHeight;

      // Adjust the position if it goes outside the canvas
      if (posX > maxX) {
        posX = posX - menuWidth;
      }

      if (posY > maxY) {
        posY = maxY;
      }

      posX += event.target.parentElement.offsetLeft;
      posY += event.target.parentElement.offsetTop;

      // Show context menu based on the mouse button and platform
      var isRightClick = event.button === cc.EventMouse.BUTTON_RIGHT;
      var isCtrlLeftClick = event.button === cc.EventMouse.BUTTON_LEFT && (vm.platformMac && event.ctrlKey);

      if ((isRightClick || isCtrlLeftClick) && ((posX === clickDownPosX) && (posY === clickDownPosY))) {
        if (angular.isDefined(vm.pinnedPosXOfContextMenuSetpieceStage) && angular.isDefined(vm.pinnedPosYOfContextMenuSetpieceStage)) {
          posX = vm.pinnedPosXOfContextMenuSetpieceStage;
          posY = vm.pinnedPosYOfContextMenuSetpieceStage;
        }
        showChartContextMenu(posX, posY);
      }
    }

    function showChartContextMenu(posX, posY) {
      vm.chartContextMenuState.visible = true;
      vm.chartContextMenuState.posX = posX;
      vm.chartContextMenuState.posY = posY;
    }

    function hideChartContextMenu() {
      vm.chartContextMenuState.visible = false;
      vm.chartInspectorState.alignMenu = false;
    }

    function toggleContextMenuPinStatus() {
      vm.chartInspectorState.isContextMenuPinned = !vm.chartInspectorState.isContextMenuPinned;
      if (vm.chartInspectorState.isContextMenuPinned) {
        setPinnedContextMenuPosition();
      } else {
        clearPinnedContextMenuPosition();
      }
      $localStorage.isContextMenuPinnedSetpieceStage = vm.chartInspectorState.isContextMenuPinned;
    }

    function setPinnedContextMenuPosition() {
      var contextMenu = $document[0].getElementById('contextMenu');
      if (contextMenu) {
        var newPosX = parseInt(contextMenu.style.left, 10);
        var newPosY = parseInt(contextMenu.style.top, 10);

        vm.pinnedPosXOfContextMenuSetpieceStage = newPosX;
        vm.pinnedPosYOfContextMenuSetpieceStage = newPosY;
        $localStorage.pinnedPosXOfContextMenuSetpieceStage = newPosX;
        $localStorage.pinnedPosYOfContextMenuSetpieceStage = newPosY;
      }
    }

    function clearPinnedContextMenuPosition() {
      vm.pinnedPosXOfContextMenuSetpieceStage = undefined;
      vm.pinnedPosYOfContextMenuSetpieceStage = undefined;
      $localStorage.pinnedPosXOfContextMenuSetpieceStage = undefined;
      $localStorage.pinnedPosYOfContextMenuSetpieceStage = undefined;
    }

    function onContextMenuDragStop(event, ui) {
      if (vm.chartInspectorState.isContextMenuPinned) {
        updatePinnedContextMenuPosition(ui.position);
      } else {
        clearPinnedContextMenuPosition();
      }
    }

    function updatePinnedContextMenuPosition(position) {
      var newPosX = parseInt(position.left, 10);
      var newPosY = parseInt(position.top, 10);

      vm.pinnedPosXOfContextMenuSetpieceStage = newPosX;
      vm.pinnedPosYOfContextMenuSetpieceStage = newPosY;
      $localStorage.pinnedPosXOfContextMenuSetpieceStage = newPosX;
      $localStorage.pinnedPosYOfContextMenuSetpieceStage = newPosY;
    }

    function clearPinnedContextMenuPosition() {
      vm.pinnedPosXOfContextMenuSetpieceStage = undefined;
      vm.pinnedPosYOfContextMenuSetpieceStage = undefined;
      $localStorage.pinnedPosXOfContextMenuSetpieceStage = undefined;
      $localStorage.pinnedPosYOfContextMenuSetpieceStage = undefined;
    }

    function searchStringChangedForSetpice() {
      vm.searchStringUpperForSetpice = vm.searchpersetpiece.toUpperCase();
    }

    function clearSearchForSetpice() {
      vm.searchStringUpperForSetpice = '';
      vm.searchpersetpiece = '';
    }

    function setpieceSearchFilter(setpiece) {
      return setpiece.name.toUpperCase().indexOf(vm.searchStringUpperForSetpice) > -1;
    }
  }

}());

/* global Q, svg2png */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsCreatePerformerController', SettingsCreatePerformerController);

  SettingsCreatePerformerController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$translate',
    '$log',
    '$timeout',
    'ngProgressLite',
    'toastr',
    'DbPerformers',
    'swaUi',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    '$q',
    'DbProductions'
  ];

  function SettingsCreatePerformerController($scope, $cookies, $stateParams, $translate, $log, $timeout, ngProgressLite, toastr,
    DbPerformers, swaUi, DbSubMgrService, blockUI, swaUtils, swaRouterStateNames, $q, DbProductions) {

    var vm = this;
    var selectedProductionId;
    var selectedPerformerId;

    var dbProductions = new DbProductions();
    var dbPerformers = new DbPerformers();

    vm.isNew = false;
    vm.originalPerformer = {}
    vm.performer = {};

    vm.colorpickeroption = swaUi.colorPickerOption;
    vm.textScaleSliderOptions = {
      floor: 0.5,
      ceil: 1.5,
      step: 0.01,
      precision: 2,
      hidePointerLabels: true,
      hideLimitLabels: true,
      onChange: onTextScaleSliderChange,
    }

    vm.selectIconShape = selectIconShape;
    vm.onBorderColorChange = onBorderColorChange;
    vm.saveUpdate = saveUpdate;
    vm.onCancel = onCancel;

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      selectedPerformerId = $stateParams.performerId;
      vm.isNew = angular.isUndefined(selectedPerformerId);

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return getAllData();
        }
      ).catch(
        function (error) {
          swaUtils.sessionErrorInterceptor(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
        }
      );
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId).then(
        function (production) {
          updateDataProduction(production);
        }
      ).then(
        function () {
          if (vm.isNew) {
            var newPerformer = dbPerformers.getEmptyPerformerObject();
            newPerformer.productionId = selectedProductionId;

            return newPerformer;
          } else {
            return dbPerformers.findById(selectedPerformerId);
          }
        }
      ).then(
        function (performer) {
          updateDataPerformer(performer);
        }
      ).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function (error) {
          deferred.reject(error);
        }
      );

      return deferred.promise;
    }

    function updateDataProduction(production) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error($translate('errormessages.Error loading production!'));
      }
    }

    function updateDataPerformer(performer) {
      if (angular.isUndefined(performer)) {
        var params = {productionId: selectedProductionId};
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.performers, params, true);
        return;
      }

      vm.originalPerformer = angular.copy(performer);
      vm.performer = angular.copy(performer);

      vm.textSizeInPercent = vm.performer.textsize * 100;
      vm.performer.bordervisible = true;
    }

    function selectIconShape(valueType) {
      vm.performer.shape = valueType;
    }

    function onTextScaleSliderChange(sliderId, modelValue, highValue, pointerType) {
      vm.textSizeInPercent = modelValue * 100;
    }

    function onBorderColorChange(color) {
      if (swaUtils.isUndefinedOrNull(color)) {
        return;
      }
      
      vm.performer.bordercolor = color;
    }

    function generateIconImage(performerObject) {
      var deferred = $q.defer();

      var svg = $('#iconLarge svg').first().clone().get(0);

      // hacky fix for IE
      $(svg).removeAttr('xmlns');

      svg2png(svg, function (err, dataURL) {
        if (err === null) {
          performerObject.image = dataURL.substring(22);
          deferred.resolve();
        } else {
          deferred.reject(new Error($translate.instant('messages.Error generating performer icon image.')));
        }

      });

      return deferred.promise;
    }

    function saveUpdate() {
      var scopePerformer = vm.performer;
      var validationMessages = [];

      if (vm.performer.name.length === 0) {
        validationMessages.push($translate.instant('validationmessages.Name is required'));
      }

      if (vm.performer.text.length === 0) {
        validationMessages.push($translate.instant('validationmessages.Icon text is required'));
      }

      if (validationMessages.length > 0) {
        toastr.clear();
        toastr.warning(
          '<ul><li>' + validationMessages.join('</li><li>') + '</li></ul>',
          $translate.instant('validationmessages.Please fix the following -'),
          {allowHtml: true}
        );

        return false;
      }

      if(angular.equals(vm.originalPerformer, vm.performer)) {
        onCancel();
        return true;
      }

      var updatedPerformer = angular.copy(vm.performer);

      if (vm.isNew) {
        insertPerformer(updatedPerformer);
      } else {
        updatePerformer(updatedPerformer);
      }
    }

    function insertPerformer(newPerformer) {
      ngProgressLite.start();
      blockUI.start();
      generateIconImage(newPerformer).then(
        function () {
          ngProgressLite.set(0.4);
          return dbPerformers.insert(newPerformer);
        }
      ).then(
        function () {
          ngProgressLite.set(0.8);
          toastr.success($translate.instant('messages.Performer added.'));
          var params = {productionId: selectedProductionId};
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.performers, params, true);
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving performer!')
          );
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );
    }

    function updatePerformer(performerObject) {
      ngProgressLite.start();
      blockUI.start();
      generateIconImage(performerObject).then(
        function () {
          ngProgressLite.set(0.4);
          return dbPerformers.update(performerObject);
        }
      ).then(
        function () {
          ngProgressLite.set(0.8);
          toastr.success($translate.instant('messages.Performer updated.'));
          var params = {productionId: selectedProductionId};
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.performers, params, true);
        }
      ).catch(
        function (error) {
          $log.error('SettingsCreatePerformerController.updatePerformer:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error updating performer!')
          );
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );
    }

    function onCancel() {
      var params = {productionId: selectedProductionId};
      swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.performers, params, true);
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toParams.skipValidation) {
        return;
      }

      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        toastr.clear();
        toastr.warning($translate.instant('messages.Please \'Save\' or \'Cancel\' adding this Performer.'));
        event.preventDefault();
      }
    });
  }
}());

/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsCollaboratorsListController', SettingsCollaboratorsListController);

  SettingsCollaboratorsListController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$translate',
    '$log',
    '$uibModal',
    'DbProductions',
    'ngProgressLite',
    'toastr',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
  ];

  function SettingsCollaboratorsListController($scope, $cookies, $stateParams, $translate, $log, $uibModal,
    DbProductions, ngProgressLite, toastr, DbSubMgrService, blockUI, swaUtils, swaRouterStateNames) {
    var vm = this;
    var selectedProductionId;
    var dbProductions = new DbProductions();
    var transferPromptActive = false;

    vm.userData = {};
    vm.userId = '';
    vm.userIsProductionOwner = false;
    vm.userIsMasterCollaborator = false;

    vm.collaborationSettings = [];

    vm.listEditMode = false;

    vm.onAdd = onAdd;
    vm.onEditToggle = onEditToggle;
    vm.stopUserCollaboration = stopUserCollaboration;
    vm.onCollaborateUserClick = onCollaborateUserClick;
    vm.promptTransferOwnership = promptTransferOwnership;

    vm.activePlanRules = {
      planId: -1,
    };

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.validateActivePlan();
        }
      ).then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();

          return DbSubMgrService.getLoggedInUsersPlan();
        }
      ).then(
        function (plan) {
          updateActivePlanRules(plan);
        }
      ).then(
        function () {
          return dbProductions.fetchById(selectedProductionId, updateDataProduction);
        }
      ).catch(
        function (error) {
          swaUtils.sessionErrorInterceptor(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
        }
      );
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;
    }

    function updateDataProduction() {
      if (vm.activePlanRules.planId === 2) {
        toastr.error(
          $translate.instant('planprivileges.messages.Your plan does not permit access to this view/feature.'),
          $translate.instant('planprivileges.titles.Plan - Access Denied!')
        );
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.details, true);
        return;
      }

      var selectedProduction = dbProductions.getFetchedById(selectedProductionId);

      vm.userIsProductionOwner = (selectedProduction.ownerId === vm.userId);
      var userCollaborationSettings = _.findWhere(selectedProduction.collaborationsettings, { "collaboratorId": vm.userId });
      vm.userIsMasterCollaborator = angular.isDefined(userCollaborationSettings) && (userCollaborationSettings.isMasterCollaborator === true);
      if (!(vm.userIsProductionOwner || vm.userIsMasterCollaborator)) {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      processCollaborationSettings(selectedProduction.collaborationsettings)

      if (vm.collaborationSettings.length === 0) {
        vm.listEditMode = false;
      }
    }

    function processCollaborationSettings(collaborationSettings) {
      vm.yourCollaborators = [];
      vm.otherCollaboratorBuckets = {};

      function pushInBucket(bucketName, item) {
        var bucket = vm.otherCollaboratorBuckets[bucketName];
        if (angular.isUndefined(bucket)) {
          bucket = []
          vm.otherCollaboratorBuckets[bucketName] = bucket;
        }

        bucket.push(item);
      }

      vm.collaborationSettings = collaborationSettings || [];
      vm.collaborationSettings.forEach(function (collaborationSetting) {
        if (collaborationSetting.addedById) {
          var masterCollaboratorSettings = _.findWhere(collaborationSettings, { "collaboratorId": collaborationSetting.addedById });
          collaborationSetting.unrestrictedPrinting = !masterCollaboratorSettings.restrictPrinting || (masterCollaboratorSettings.restrictPrinting && _.contains(masterCollaboratorSettings.masterBypassPrintApprovalEmails, collaborationSetting.collaboratorEmailLower));
          if (collaborationSetting.addedById === vm.userId) {
            vm.yourCollaborators.push(collaborationSetting);
          } else {
            pushInBucket(collaborationSetting.addedByEmail, collaborationSetting);
          }
        } else {
          collaborationSetting.unrestrictedPrinting = !collaborationSetting.restrictPrinting || (collaborationSetting.restrictPrinting && _.contains(collaborationSetting.masterBypassPrintApprovalEmails, collaborationSetting.collaboratorEmailLower));
          if (vm.userIsProductionOwner) {
            vm.yourCollaborators.push(collaborationSetting);
          } else {
            pushInBucket('Owner', collaborationSetting);
          }
        }
      });
    }

    function onAdd() {
      var params = {
        productionId: selectedProductionId,
      };
      swaUtils.stateGo(swaRouterStateNames.productionsettings.editcollaborator, params);
    }

    function onEditToggle() {
      vm.listEditMode = !vm.listEditMode;
    }

    function stopUserCollaboration(userSetting) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionSettings/collaboration/stopCollaborationPrompt.html',
        controller: 'StopCollaborationPromptController',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
        controllerAs: 'vm',
        resolve: {
          isMasterCollaborator: userSetting.isMasterCollaborator,
        }
      });

      modalInstance.result.then(
        function () {
          removeCollaborator(userSetting.collaboratoremail);
        }
      );
    }

    function removeCollaborator(email) {
      blockUI.start();
      ngProgressLite.start();

      dbProductions.removeCollaborator(selectedProductionId, email).then(
        function () {
          toastr.success($translate.instant('messages.Collaborator removed'));
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error removing collaborator!')
          );
        }
      ).finally(
        function () {
          blockUI.stop();
          ngProgressLite.done();
        }
      );
    }

    function onCollaborateUserClick(userSetting) {
      var params = {
        productionId: selectedProductionId,
        collaboratorEmail: userSetting.collaboratoremail,
      };

      swaUtils.stateGo(swaRouterStateNames.productionsettings.editcollaborator, params);
    }

    function promptTransferOwnership(userSetting) {
      transferPromptActive = true;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionSettings/collaboration/transferOwnershipPrompt.html',
        controller: 'TransferOwnershipPromptController',
        size: '440',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
        controllerAs: 'vm',
        resolve: {
          transferParams: function () {
            return {
              productionId: selectedProductionId,
              newOwnerEmail: userSetting.collaboratoremail,
              removeAllCollaborators: true,
              addMeAsACollaborator: false,
            };
          },
        }
      });

      modalInstance.result.then(
        function () {
          transferPromptActive = false;
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        }
      ).catch(
        function () {
          transferPromptActive = false;
        }
      );
    }

    $scope.$on('$destroy', function () {
      dbProductions.fetchUnregister();
    });
  }
}());

/* global _ */
(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsCollaboratorEditController', SettingsCollaboratorEditController);

  SettingsCollaboratorEditController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$translate',
    '$log',
    '$uibModal',
    'DbProductions',
    'DbScenes',
    'ngProgressLite',
    'toastr',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    'DbUser',
    '$q',
  ];

  function SettingsCollaboratorEditController($scope, $cookies, $stateParams, $translate, $log,
    $uibModal, DbProductions, DbScenes, ngProgressLite, toastr, DbSubMgrService,
    blockUI, swaUtils, swaRouterStateNames, DbUser, $q) {

    var vm = this;
    var selectedProductionId;
    var selectedCollaboratorEmail;

    var dbProductions = new DbProductions();
    var dbScenes = new DbScenes();
    var dbUser = new DbUser();

    // existing collaborator's emails if any
    var existingCollaboratorEmails = [];

    vm.userData = {};
    vm.userId = '';
    vm.userIsProductionOwner = false;
    vm.userIsMasterCollaborator = false;
    vm.masterRestrictPrinting = false;
    vm.masterCanBypassRestrictPrinting = false;
    vm.masterBypassPrintApprovalCount = 0;
    vm.masterBypassPrintApprovalEmails = [];

    vm.forms = {};

    vm.selectedProduction = {};
    vm.scenes = [];

    // To hold new collaborators
    vm.newCollaborators = [];

    // default collaboration settings
    vm.collaborationSettings = {
      collaborationaccess: {
        accesslevel: 2,
      },
    };
    vm.isEditMode = false;

    vm.checkExistingCollaborator = checkExistingCollaborator;
    vm.checkIfSwaUser = checkIfSwaUser;
    vm.updateCollaborationLevel = updateCollaborationLevel;
    vm.selectAllCharts = selectAllCharts;
    vm.selectAllStaffs = selectAllStaffs;
    vm.clearAllChartsStaffs = clearAllChartsStaffs;
    vm.saveUpdate = saveUpdate;
    vm.stopCollaboration = stopCollaboration;
    vm.onCancel = onCancel;
    vm.masterCollaboratorChange = masterCollaboratorChange;

    vm.activePlanRules = {
      planId: -1,
    };

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      selectedCollaboratorEmail = $stateParams.collaboratorEmail;
      vm.isEditMode = angular.isDefined(selectedCollaboratorEmail);

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.validateActivePlan();
        })
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();

          return DbSubMgrService.getLoggedInUsersPlan();
        })
        .then(function (plan) {
          updateActivePlanRules(plan);
        })
        .then(function () {
          return getAllData();
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
          if (!vm.isEditMode) {
            angular.element('#newCollaborators input').focus();
          }
        });
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId)
        .then(function (production) {
          updateDataProduction(production);
        })
        .then(function () {
          return dbScenes.findInProduction(selectedProductionId);
        })
        .then(function (scenes) {
          updateDataScenes(scenes);
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (e) {
          deferred.reject(e);
        });

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;
    }

    function updateDataProduction(production) {
      vm.selectedProduction = angular.copy(production);

      if (angular.isUndefined(vm.selectedProduction)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      if (vm.activePlanRules.planId === 2) {
        toastr.error(
          $translate.instant('planprivileges.messages.Your plan does not permit access to this view/feature.'),
          $translate.instant('planprivileges.titles.Plan - Access Denied!')
        );
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.details, true);
        return;
      }

      // Logged in user needs to be owner or a master collaborator
      var userIsProductionOwner = (vm.selectedProduction.ownerId === vm.userId);
      var userCollaborationSettings = _.findWhere(vm.selectedProduction.collaborationsettings, { "collaboratorId": vm.userId });
      var userIsMasterCollaborator = angular.isDefined(userCollaborationSettings) && (userCollaborationSettings.isMasterCollaborator === true);
      if (!(userIsProductionOwner || userIsMasterCollaborator)) {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      vm.userIsProductionOwner = userIsProductionOwner;
      vm.userIsMasterCollaborator = userIsMasterCollaborator;

      var allCollaborationSettings = vm.selectedProduction.collaborationsettings || [];
      if (angular.isDefined(selectedCollaboratorEmail)) {
        vm.collaborationSettings = _.findWhere(allCollaborationSettings, { "collaboratoremail": selectedCollaboratorEmail });
        if (angular.isUndefined(vm.collaborationSettings)) {
          var params = { productionId: selectedProductionId };
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionSettings.collaborators, params, true);
          return;
        }
        vm.collaboratorAddedByOwner = angular.isUndefined(vm.collaborationSettings.addedById) || (vm.collaborationSettings.addedById === vm.selectedProduction.ownerId);
        vm.collaborationSettings.wasMasterCollaborator = (vm.collaborationSettings.isMasterCollaborator === true);
        vm.collaborationSettings.masterBypassPrintApprovalCount = vm.collaborationSettings.masterBypassPrintApprovalCount || 0;
        vm.collaborationSettings.masterBypassPrintApprovalEmails = vm.collaborationSettings.masterBypassPrintApprovalEmails || [];
        if (!vm.collaboratorAddedByOwner) {
          var masterCollaboratorSettings = _.findWhere(allCollaborationSettings, { "collaboratorId": vm.collaborationSettings.addedById });
          vm.masterRestrictPrinting = (masterCollaboratorSettings.restrictPrinting === true);
          vm.masterBypassPrintApprovalCount = masterCollaboratorSettings.masterBypassPrintApprovalCount || 0;
          vm.masterCanBypassRestrictPrinting = vm.masterRestrictPrinting && (vm.masterBypassPrintApprovalCount > 0);
          vm.masterBypassPrintApprovalEmails = masterCollaboratorSettings.masterBypassPrintApprovalEmails || [];
          vm.collaborationSettings.bypassPrintApproval = _.contains(vm.masterBypassPrintApprovalEmails, vm.collaborationSettings.collaboratorEmailLower);
        }
      } else {
        existingCollaboratorEmails = _.pluck(allCollaborationSettings, 'collaboratoremail');

        vm.collaboratorAddedByOwner = vm.userIsProductionOwner;
        vm.collaborationSettings.wasMasterCollaborator = false;
        vm.collaborationSettings.masterBypassPrintApprovalCount = 0;
        vm.collaborationSettings.masterCanApprovePrinting = false;
        vm.collaborationSettings.bypassPrintApproval = false;
        if (!vm.collaboratorAddedByOwner) {
          vm.masterRestrictPrinting = (userCollaborationSettings.restrictPrinting === true);
          vm.masterBypassPrintApprovalCount = userCollaborationSettings.masterBypassPrintApprovalCount || 0;
          vm.masterCanBypassRestrictPrinting = false;
        } else {
          vm.masterRestrictPrinting = false;
        }
        vm.collaborationSettings.restrictPrinting = vm.masterRestrictPrinting;
      }
    }

    function updateDataScenes(scenes) {
      vm.scenes = angular.copy(scenes);

      if (vm.collaborationSettings.collaborationaccess.accesslevel === 1) {
        var sceneAccessCopy = {};

        for (var i = 0; i < vm.collaborationSettings.collaborationaccess.sceneaccess.length; i++) {
          var sceneAccess = vm.collaborationSettings.collaborationaccess.sceneaccess[i];
          sceneAccessCopy[sceneAccess.sceneId] = sceneAccess;
        }

        vm.collaborationSettings.collaborationaccess.sceneaccess = [];
        for (var j = 0; j < vm.scenes.length; j++) {
          var sceneId = vm.scenes[j]._id;
          var scenename = vm.scenes[j].scenename;
          var allowchartediting = false;
          var allowstaffediting = false;

          var exisitingSceneAccess = sceneAccessCopy[sceneId];
          if (exisitingSceneAccess) {
            allowchartediting = exisitingSceneAccess.allowchartediting;
            allowstaffediting = exisitingSceneAccess.allowstaffediting || false;
          }

          vm.collaborationSettings.collaborationaccess.sceneaccess.push({
            sceneId: sceneId,
            scenename: scenename,
            allowchartediting: allowchartediting,
            allowstaffediting: allowstaffediting,
          });
        }
      }
    }

    function checkExistingCollaborator($tag) {
      var email = $tag.text;

      if (angular.isDefined(vm.userData) && angular.isArray(vm.userData.emails)) {
        var found = _.findWhere(vm.userData.emails, { address: email });
        if (angular.isDefined(found)) {
          toastr.warning($translate.instant('validationmessages.You cannot add yourself as a collaborator') + ' - \'' + email + '\'');
          return false;
        }
      }

      $tag.alreadyCollaborator = existingCollaboratorEmails.includes(email);

      return true;
    }

    function checkIfSwaUser($tag) {
      // Save entered text as email
      $tag.email = $tag.text;

      if ($tag.alreadyCollaborator) {
        return;
      }

      dbUser.getDisplayName($tag.email)
        .then(function (fullname) {
          if (angular.isDefined(fullname)) {
            $tag.text = fullname + ' (' + $tag.email + ')';
          }
        })
        .catch(function (error) {
          // Ignore the error
          $log.error('error: ' + error.reason);
        });
    }

    function updateCollaborationLevel(level) {
      if (vm.collaborationSettings.collaborationaccess.accesslevel === level) {
        return;
      }

      vm.collaborationSettings.collaborationaccess.accesslevel = level;

      if (level === 0) {
        vm.collaborationSettings.collaborationaccess.allowscriptediting = undefined;
        vm.collaborationSettings.collaborationaccess.sceneaccess = [];
      } else if (level === 1) {
        vm.collaborationSettings.collaborationaccess.allowscriptediting = false;
        vm.collaborationSettings.collaborationaccess.sceneaccess = [];

        for (var i = 0; i < vm.scenes.length; i++) {
          var scene = vm.scenes[i];
          vm.collaborationSettings.collaborationaccess.sceneaccess.push({
            sceneId: scene._id,
            scenename: scene.scenename,
            allowchartediting: false,
            allowstaffediting: false,
          });
        }
      } else if (level === 2) {
        vm.collaborationSettings.collaborationaccess.allowscriptediting = undefined;
        vm.collaborationSettings.collaborationaccess.sceneaccess = [];
      }
    }

    function selectAllCharts() {
      angular.forEach(vm.collaborationSettings.collaborationaccess.sceneaccess, function (value) {
        value.allowchartediting = true;
      });
    }

    function selectAllStaffs() {
      angular.forEach(vm.collaborationSettings.collaborationaccess.sceneaccess, function (value) {
        value.allowstaffediting = true;
      });
    }

    function clearAllChartsStaffs() {
      angular.forEach(vm.collaborationSettings.collaborationaccess.sceneaccess, function (value) {
        value.allowchartediting = false;
        value.allowstaffediting = false;
      });
    }

    function saveUpdate() {
      if (vm.collaborationSettings.collaboratoremail) {
        updateCollaboratorSettings();
      } else {
        addCollaborators();
      }
    }

    function addCollaborators() {
      if (vm.forms.addCollaborators.$invalid) {
        return;
      }

      if (angular.isUndefined(vm.newCollaborators) || (vm.newCollaborators.length === 0)) {
        toastr.warning($translate.instant('validationmessages.Enter email(s) of users to collaborate with'));;
        return;
      }

      var newEmailAddressess = [];
      var alreadyCollaboratedEmailAddressess = [];
      for (var i = 0; i < vm.newCollaborators.length; i++) {
        var tag = vm.newCollaborators[i];
        if (tag.alreadyCollaborator) {
          alreadyCollaboratedEmailAddressess.push(tag.email);
        } else {
          newEmailAddressess.push(tag.email);
        }
      }

      if (alreadyCollaboratedEmailAddressess.length > 0) {
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/productionSettings/collaboration/existingCollaboratorsIgnorePrompt.html',
          controller: 'ExistingCollaboratorsIgnorePromptController',
          size: 'sm',
          windowClass: 'sw-modal sw-modal-400',
          backdropClass: 'sw-modal-backdrop',
          controllerAs: 'vm',
          resolve: {
            existingEmails: function () {
              return alreadyCollaboratedEmailAddressess;
            },
          },
        });

        modalInstance.result
          .then(function () {
            addNewCollaborators(newEmailAddressess);
          });
      } else {
        addNewCollaborators(newEmailAddressess);
      }
    }

    function addNewCollaborators(newEmailAddressess) {
      var collaborationSettings = angular.copy(vm.collaborationSettings);
      blockUI.start();
      dbProductions.addCollaborators(selectedProductionId, newEmailAddressess, collaborationSettings, vm.userIsMasterCollaborator)
        .then(function () {
          toastr.success($translate.instant('messages.Collaborator(s) added'));
          var params = { productionId: selectedProductionId };
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.collaborators, params, true);
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error adding collaborator(s)!')
          );
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    function updateCollaboratorSettings() {
      var updatedCollaborationSettings = {
        isMasterCollaborator: vm.collaborationSettings.isMasterCollaborator,
        wasMasterCollaborator: vm.collaborationSettings.wasMasterCollaborator,
        restrictPrinting: vm.collaborationSettings.restrictPrinting,
        collaborationaccess: angular.copy(vm.collaborationSettings.collaborationaccess),
      };

      if (vm.collaborationSettings.isMasterCollaborator) {
        updatedCollaborationSettings.masterCanApprovePrinting = vm.collaborationSettings.masterCanApprovePrinting;
        if (updatedCollaborationSettings.masterCanApprovePrinting) {
          updatedCollaborationSettings.masterBypassPrintApprovalCount = vm.collaborationSettings.masterBypassPrintApprovalCount;
        } else {
          updatedCollaborationSettings.masterBypassPrintApprovalCount = 0;
        }
      }
      if (!vm.collaboratorAddedByOwner && vm.masterCanBypassRestrictPrinting) {
        updatedCollaborationSettings.bypassPrintApproval = vm.collaborationSettings.bypassPrintApproval;        
      }

      if (((vm.collaborationSettings.wasMasterCollaborator === true) && (vm.collaborationSettings.isMasterCollaborator === false)) ||
        (vm.collaborationSettings.restrictPrinting === false)) {
        updatedCollaborationSettings.masterBypassPrintApprovalCount = 0;
      }

      blockUI.start();
      dbProductions.updateCollaboratorSettings(selectedProductionId, vm.collaborationSettings.collaboratoremail, updatedCollaborationSettings)
        .then(function () {
          toastr.success($translate.instant('messages.Collaboration settings updated'));
          var params = { productionId: selectedProductionId };
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.collaborators, params, true);
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error updating collaboration settings!')
          );
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    function stopCollaboration() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionSettings/collaboration/stopCollaborationPrompt.html',
        controller: 'StopCollaborationPromptController',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
        controllerAs: 'vm',
        resolve: {
          isMasterCollaborator: vm.collaborationSettings.isMasterCollaborator,
        }
      });

      modalInstance.result
        .then(function () {
          removeCollaborator();
        });
    }

    function removeCollaborator() {
      blockUI.start();
      ngProgressLite.start();
      dbProductions.removeCollaborator(selectedProductionId, vm.collaborationSettings.collaboratoremail)
        .then(function () {
          toastr.success($translate.instant('messages.Collaborator removed'));

          var params = { productionId: selectedProductionId };
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.collaborators, params, true);
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error removing collaborator!')
          );
        })
        .finally(function () {
          blockUI.stop();
          ngProgressLite.done();
        });
    }

    function onCancel() {
      var params = { productionId: selectedProductionId };
      swaUtils.stateGoSkipValidation(swaRouterStateNames.productionsettings.collaborators, params, true);
    }

    function masterCollaboratorChange() {
      if (vm.collaborationSettings.isMasterCollaborator) {
        updateCollaborationLevel(0);
      }
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toParams.skipValidation) {
        return;
      }

      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        toastr.clear();
        toastr.warning($translate.instant('messages.Please \'Save\' or \'Cancel\' collaboration changes.'));
        event.preventDefault();
      }
    });
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('SettingsChartSettingsController', SettingsChartSettingsController);

  SettingsChartSettingsController.$inject = [
    '$scope',
    '$cookies',
    '$state',
    '$stateParams',
    '$log',
    '$translate',
    'ngProgressLite',
    'toastr',
    'DbProductions',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    'DbCollaborationPrivileges',
    'DbUserProductions',
    '$q',
    'swaUi',
    '$timeout',
  ];

  function SettingsChartSettingsController($scope, $cookies, $state, $stateParams, $log, $translate, ngProgressLite, toastr,
    DbProductions, DbSubMgrService, blockUI, swaUtils, swaRouterStateNames, DbCollaborationPrivileges, DbUserProductions, $q, swaUi, $timeout) {

    var vm = this;
    var selectedProductionId;
    var dbProductions = new DbProductions();
    var dbUserProductions = new DbUserProductions();
    vm.productionPreferences = {};
    vm.originalProductionPreferences = {};

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowsavechanges: false,
      alloweditsettings: false,
      alloweditpov: false,
    };

    var defaultViewAccessRules = angular.copy(defaultDenyAccessRules);

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowsavechanges: true,
      alloweditsettings: true,
      alloweditpov: true,
    };
    vm.personalContentDefaults = {
      selectedType: 'settingsChartText',
      fillColor: null,
      fontColor: null,
      fontFamily: null,
      fontSize: null,
      bold: false,
      italic: false,
      underline: false
    };
    vm.scrollConfigGenericPopover = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollButtons: {
        enable: false,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
    };
    vm.highlightColorPickerOption = swaUi.highlightColorPickerOption;
    vm.colorPickerOption = swaUi.colorPickerOption.palette;
    vm.fontFamilies = swaUi.fontFamilies;
    vm.fontSizeRange = swaUi.fontSizeRange;

    vm.settingsOptions = {};
    vm.fontSizePicker = {};
    vm.viewSettings = viewSettings;
    vm.editSettings = editSettings;
    vm.fontSizeStepper = fontSizeStepper;
    vm.preview = preview;
    vm.reset = reset;
    vm.colorToRgb = swaUi.colorToRgb;

    vm.userData = {};
    vm.userId = '';

    vm.originalProduction = {};
    vm.production = {};

    vm.placementResolutionOptions = [{
      label: '1',
      hint: 'No Fractions',
      value: 0,
    }, {
      label: '1/2',
      hint: '(1.5 2.0 2.5 ...)',
      value: 0.5,
    }, {
      label: '1/4',
      hint: '(1.25 1.50 1.75 ...)',
      value: 0.25,
    },];

    vm.showHorizontalLineChanged = showHorizontalLineChanged;
    vm.saveUpdate = saveUpdate;

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
    };

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.validateActivePlan();
        }
      ).then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        }
      ).then(
        function (plan) {
          updateActivePlanRules(plan);
        }
      ).then(
        function () {
          return getAllData();
        }
      ).catch(
        function (error) {
          swaUtils.sessionErrorInterceptor(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.reset();
        }
      );
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId).then(
        function (production) {
          updateDataProduction(production);
        }
      )
        .then(function () {
          getUserProductionPreferences();
        })
        .then(
          function () {
            deferred.resolve();
          }
        ).catch(
          function () {
            deferred.reject();
          }
        );

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;
    }

    function updateDataProduction(production) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      vm.originalProduction = angular.copy(production)
      vm.production = angular.copy(production);

      if (vm.production.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(vm.production.collaboratorIds) && (vm.production.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = vm.production.collaborationsettings.find(function (element) {
            return (element.collaboratorId === vm.userId);
          });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error($translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'), $translate.instant('collaborationprivileges.titles.Collaboration Access'));
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          return;
        }
      }

      vm.production.chartsettings.performernosevisible = (vm.production.chartsettings.performernosevisible || false);
      vm.production.chartsettings.performerpositionresolutionfraction = (vm.production.chartsettings.performerpositionresolutionfraction || 0);
      if (angular.isUndefined(vm.production.chartsettings.horizontallinesnumbersvisible)) {
        vm.production.chartsettings.horizontallinesnumbersvisible = (vm.production.chartsettings.horizontallinesvisible === true);
      }

      updateCollaborationPrivileges();
    }

    function showHorizontalLineChanged() {
      if (vm.production.chartsettings.horizontallinesvisible === false) {
        vm.production.chartsettings.horizontallinesnumbersvisible = false;
      }
    }

    function saveUpdate(noRefresh) {
      if (!vm.activeAccessRules.allowsavechanges) {
        return;
      }

      noRefresh = (noRefresh === true) || false;

      var updatedProduction = {};
      var shouldUpdate = false;

      if (!angular.equals(vm.production.chartsettings, vm.originalProduction.chartsettings) || !angular.equals(vm.productionPreferences.contentDefaults, vm.originalProductionPreferences.contentDefaults)) {
        updatedProduction.chartsettings = angular.copy(vm.production.chartsettings);
        shouldUpdate = true;
      }

      if (!shouldUpdate) {
        $log.info('saveUpdate(): Nothing to save/update.');
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      updatedProduction._id = vm.originalProduction._id;
      dbProductions.update(updatedProduction).then(
        function () {
          return savePreferences();
        }
      ).then(
        function () {
          toastr.success('Chart Settings updated.');
          if (!noRefresh) {
            return getAllData();
          }
        }
      ).catch(
        function (error) {
          $log.error('SettingsChartSettingsController.saveUpdate:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error saving changes!'));
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );
    }

    function updateCollaborationPrivileges() {
      if (vm.activeCollaborationConfig.isProductionOwner === true) {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultOwnerAccessRules);
        }
      } else {
        if (vm.activePlanRules.planId === 2) {
          updateActiveAccessRules(defaultViewAccessRules);
        } else {
          updateActiveAccessRules(defaultDenyAccessRules);
          var params = {
            accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
            statename: swaRouterStateNames.productionsettings.chartsettings,
          };
          var dbCollaborationPrivileges = new DbCollaborationPrivileges();

          dbCollaborationPrivileges.getCollaborationPrivileges(params).then(
            function (privilegeData) {
              updateActiveAccessRules(privilegeData.accessrules);
            }
          ).catch(
            function (error) {
              $log.error('SettingsProductionDetailsController.updateCollaborationPrivileges:', error);
            }
          );
        }
      }
    }

    function updateActiveAccessRules(accessRules) {
      if (angular.isDefined(vm.activeCollaborationConfig.isProductionOwner)) {
        angular.extend(vm.activeAccessRules, accessRules);
      } else {
        angular.extend(vm.activeAccessRules, defaultDenyAccessRules);
      }
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toState.name !== $state.current.name) {
        saveUpdate(true);
      }
    });

    function getUserProductionPreferences() {
      var deferred = $q.defer();
      dbUserProductions.findByProductionId(selectedProductionId)
        .then(function (userProduction) {
          updateDataUserProduction(userProduction);
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function () {
          deferred.reject();
        });

      return deferred.promise;
    }

    $scope.$watch('vm.fontSizePicker.show', function (newValue, oldValue) {
      if (newValue === true) {
        $timeout(function () {
          $('.sw-fontsize-picker .menu-group').mCustomScrollbar(vm.scrollConfigGenericPopover);
        }, 500);
      }
    });

    function viewSettings(type) {
      vm.personalContentDefaults.selectedType = type;
      preview(type, vm.productionPreferences.contentDefaults[type])
    }

    function reset(setting) {
      vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType] = angular.copy(swaUi.defaultTextStylePreferences);
      viewSettings(vm.personalContentDefaults.selectedType);
    }

    function editSettings(type, data) {
      angular.forEach(data, function (value, key) {
        vm.productionPreferences.contentDefaults[type][key] = value;
      });
      preview(type, vm.productionPreferences.contentDefaults[type]);
    }

    function preview(type, data) {
      $('#settings-preview').css({
        'background-color': swaUi.colorReplaceIfTransparent(data.fillColor, 'rgb(255, 255, 255')
      });
      $('#preview-content').css({
        'color': data.fontColor,
        'background-color': '',
        'font-family': data.fontFamily,
        'font-size': data.fontSize + vm.fontSizeRange.unit,
        'font-weight': data.bold ? 'bold' : 'normal',
        'font-style': data.italic ? 'italic' : 'normal',
        'text-decoration': data.underline ? 'underline' : 'none'
      }).text('AaBb');
    }

    function fontSizeStepper(type, action) {
      var fontSize = vm.productionPreferences.contentDefaults[type].fontSize;
      fontSize = parseInt(fontSize);
      if (action === '-') {
        if (fontSize - vm.fontSizeRange.incremental >= vm.fontSizeRange.min) {
          fontSize -= vm.fontSizeRange.incremental;
        }
      } else if (action === '+') {
        if (fontSize + vm.fontSizeRange.incremental <= vm.fontSizeRange.max) {
          fontSize += vm.fontSizeRange.incremental;
        }
      }
      editSettings(type, { fontSize: fontSize });
    }

    function savePreferences() {
      var deferred = $q.defer();

      var preferences = angular.copy(vm.productionPreferences);
      dbUserProductions.update(preferences).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function () {
          deferred.reject();
        }
      );

      return deferred.promise;
    }

    function updateDataUserProduction(userProduction) {
      if (angular.isUndefined(userProduction) || angular.isUndefined(userProduction.contentDefaults)) {
        userProduction = dbUserProductions.getNewUserProduction(selectedProductionId, vm.userId, vm.production.productiontype);
      }
      vm.originalProductionPreferences = angular.copy(userProduction);
      vm.productionPreferences = angular.copy(userProduction);

      viewSettings(vm.personalContentDefaults.selectedType);
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (toState.name !== $state.current.name) {
        savePreferences();
      }
    });
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('ProductionSettingsController', ProductionSettingsController);

  ProductionSettingsController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$log',
    '$timeout',
    '$uibModal',
    'DbProductions',
    'ngProgressLite',
    'toastr',
    'DbSubMgrService',
    'blockUI',
    '$translate',
    'swaUtils',
    'swaRouterStateNames',
    '$q',
  ];

  function ProductionSettingsController($scope, $cookies, $stateParams, $log,
    $timeout, $uibModal, DbProductions, ngProgressLite, toastr,
    DbSubMgrService, blockUI, $translate, swaUtils, swaRouterStateNames, $q) {

    var vm = this;
    var selectedProductionId;

    var dbProductions = new DbProductions();

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowcopyproductions: false,
    };

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowcopyproductions: true,
    };

    vm.userData = {};
    vm.userId = '';

    vm.showHelpBar = false;
    vm.helpTourSteps = [];

    vm.selectedProduction = {};
    vm.selectedTabIndex = -1;

    vm.showDetailView = showDetailView;
    vm.settingsDone = settingsDone;
    vm.deleteProductionPrompt = deleteProductionPrompt;
    vm.copyProductionPrompt = copyProductionPrompt;
    vm.stopCollaboratingPrompt = stopCollaboratingPrompt;
    vm.promptTransferOwnership = promptTransferOwnership;

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedProductions: false,
      allowedNumberOfProductions: 0,
      allowTransferOwnership: false,
    };

    initialize();

    function initialize() {
      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');
      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession().then(
        function () {
          return DbSubMgrService.validateActivePlan();
        }
      ).then(
        function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        }
      ).then(
        function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        }
      ).then(
        function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        }
      ).then(
        function (plan) {
          updateActivePlanRules(plan);
        }
      ).then(
        function () {
          return dbProductions.findById(selectedProductionId);
        }
      ).then(
        function (production) {
          updateDataProduction(production);
        }
      ).then(
        function () {
          initHelpTour();
          updateSelectedTabIndex();
        }
      ).catch(
        function (error) {
          $log.error('ProductionSettingsController.sessionCheckAndRun: Error:', error);
          swaUtils.sessionErrorInterceptor(error);
        }
      );
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;

      vm.activePlanRules.allowUnlimitedProductions = plan.planfeatures[1].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedProductions) {
        vm.activePlanRules.allowedNumberOfProductions = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfProductions = plan.planfeatures[1].featurevalue;
      }

      vm.activePlanRules.allowTransferOwnership = plan.planfeatures[19].featurevalue;
    }

    // Data update callback
    function updateDataProduction(production) {
      if (angular.isUndefined(production)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error($translate('errormessages.Error loading production!'));
      }

      vm.selectedProduction = angular.copy(production);

      if (vm.selectedProduction.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(vm.selectedProduction.collaboratorIds) && (vm.selectedProduction.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = vm.selectedProduction.collaborationsettings.find(
            function (element) {
              return (element.collaboratorId === vm.userId);
            });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error(
            $translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          throw new Error('Invalid state');
        } else {
          vm.activeCollaborationConfig.isMasterCollaborator = angular.isDefined(vm.activeCollaborationConfig.collaborationSetting) && (vm.activeCollaborationConfig.collaborationSetting.isMasterCollaborator === true);
        }
      }

      DbSubMgrService.setSelectedProduction(vm.selectedProduction);

      updateActiveAccessRules();
    }

    function settingsDone() {
      var editorRouteName = $cookies.get('currentEditorStateName');
      var params = {
        productionId: selectedProductionId,
      };
      var prevEditorStateName = $cookies.get('currentEditorStateName') || swaRouterStateNames.charteditor;
      swaUtils.stateGo(prevEditorStateName, params);
    }

    function showDetailView(tabIndex) {
      if (vm.selectedTabIndex === tabIndex) {
        return;
      }

      var viewStateName;
      if (tabIndex === 0) {
        viewStateName = swaRouterStateNames.productionsettings.details;
      } else if (tabIndex === 1) {
        viewStateName = swaRouterStateNames.productionsettings.stagedimensions;
      } else if (tabIndex === 2) {
        viewStateName = swaRouterStateNames.productionsettings.setpieces;
      } else if (tabIndex === 3) {
        viewStateName = swaRouterStateNames.productionsettings.performers;
      } else if (tabIndex === 4) {
        viewStateName = swaRouterStateNames.productionsettings.scenes;
      } else if (tabIndex === 5) {
        viewStateName = swaRouterStateNames.productionsettings.chartsettings;
      } else if (tabIndex === 6) {
        viewStateName = swaRouterStateNames.productionsettings.stafftemplates;
      } else if (tabIndex === 7) {
        if ((vm.activePlanRules.planId !== 1) || (vm.activeCollaborationConfig.masterCollaborator)) {
          viewStateName = swaRouterStateNames.productionsettings.collaborators;
        } else {
          toastr.error(
            $translate.instant('collaborationprivileges.errormessages.You do not have access to add collaborators'),
            $translate.instant('planprivileges.titles.Plan - Access Denied!')
          );
        }
      } else if (tabIndex === 9) {
        viewStateName = swaRouterStateNames.productionsettings.preferences;
      }

      if (angular.isUndefined(viewStateName)) {
        return;
      }

      if (!swaUtils.isRouterCurrentStateName(viewStateName)) {
        var params = {
          productionId: selectedProductionId,
        };

        swaUtils.stateGoLocationReplace(viewStateName, params);
      }
    }

    // Production delete prompt
    function deleteProductionPrompt() {
      if (angular.isUndefined(selectedProductionId)) {
        return;
      }

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionSettings/deleteProductionPrompt.html',
        controller: 'DeleteProductionPromptController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });
      modalInstance.result.then(deleteCurrentProduction);
    }

    // Production delete prompt
    function copyProductionPrompt() {
      if (angular.isUndefined(selectedProductionId)) {
        return;
      }

      dbProductions.getUserAccessibleProductionsCount(vm.userId).then(
        function (count) {
          if ((vm.activePlanRules.planId === 2) || ((count + 1) > vm.activePlanRules.allowedNumberOfProductions)) {
            toastr.error(
              $translate.instant('planprivileges.messages.You cannot add (any more) productions in your current plan.'),
              $translate.instant('planprivileges.titles.Subscription Plan Limit!')
            );
          } else {
            showCopyProductionPrompt();
          }
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error copying production!')
          );
        }
      );
    }

    function showCopyProductionPrompt() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionSettings/copyProductionPrompt.html',
        controller: 'CopyProductionPromptController',
        controllerAs: 'vm',
        size: '600',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        resolve: {
          productionCopyParams: function () {
            return {
              sourceProductionId: selectedProductionId,
              originalType: vm.selectedProduction.productiontype,
              originalMeasurementUnit: vm.selectedProduction.stagesettings.stagemeasurementunit,
              originalStageWidth: vm.selectedProduction.stagesettings.stagewidth,
              originalStageDepth: vm.selectedProduction.stagesettings.stagedepth,
              originalOffstageWidth: vm.selectedProduction.stagesettings.offstagewidth,
              newType: vm.selectedProduction.productiontype,
            };
          }
        }
      });
      modalInstance.result.then(
        function (params) {
          copyProductionWithParams(params);
        }
      );
    }

    function copyProductionWithParams(productionCopyParams) {
      blockUI.start();
      blockUI.message($translate.instant('messages.Copying ...'));
      dbProductions.copyProduction(productionCopyParams).then(
        function () {
          toastr.success($translate.instant('messages.Production copied'));
        }
      ).catch(
        function (error) {
          $log.error('ProductionSettingsController.copyProductionWithParams:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error copying production!'));
        }
      ).finally(
        function () {
          blockUI.stop();
        }
      );
    }

    function deleteCurrentProduction() {
      ngProgressLite.start();
      blockUI.start();

      var params = {
        deleteProductionId: selectedProductionId,
      };

      swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, params, true);
    }

    function stopCollaboratingPrompt() {
      if (angular.isUndefined(selectedProductionId)) {
        return;
      }

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionSettings/collaboration/stopCollaboratingPrompt.html',
        controller: 'StopCollaboratingPromptController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
        resolve: {
          isMasterCollaborator: vm.activeCollaborationConfig.isMasterCollaborator,
        }
      });
      modalInstance.result.then(stopCollaborating);
    }

    function stopCollaborating() {
      blockUI.start();

      dbProductions.stopCollaborating(selectedProductionId).then(
        function () {
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        }
      ).catch(
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error updating collaboration settings!')
          );
        }
      ).finally(
        function () {
          blockUI.stop();
        }
      );
    }

    function promptTransferOwnership(userSetting) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionSettings/collaboration/transferOwnershipPrompt.html',
        controller: 'TransferOwnershipPromptController',
        size: '440',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
        controllerAs: 'vm',
        resolve: {
          transferParams: function () {
            return {
              productionId: selectedProductionId,
              removeAllCollaborators: true,
              addMeAsACollaborator: false,
            };
          },
        }
      });

      modalInstance.result.then(
        function () {
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, {}, true);
        }
      );
    }

    function updateSelectedTabIndex() {
      var currentStateName = swaUtils.getRouterCurrentStateName();
      if (currentStateName === swaRouterStateNames.productionsettings.details) {
        vm.selectedTabIndex = 0;
      } else if (currentStateName === swaRouterStateNames.productionsettings.stagedimensions) {
        vm.selectedTabIndex = 1;
      } else if (currentStateName === swaRouterStateNames.productionsettings.customnumberline) {
        vm.selectedTabIndex = 1;
      } else if (currentStateName === swaRouterStateNames.productionsettings.setpieces) {
        vm.selectedTabIndex = 2;
      } else if (currentStateName === swaRouterStateNames.productionsettings.importsetpiece) {
        vm.selectedTabIndex = 2;
      } else if (currentStateName === swaRouterStateNames.productionsettings.performers) {
        vm.selectedTabIndex = 3;
      } else if (currentStateName === swaRouterStateNames.productionsettings.importperformer) {
        vm.selectedTabIndex = 3;
      } else if (currentStateName === swaRouterStateNames.productionsettings.createperformer) {
        vm.selectedTabIndex = 3;
      } else if (currentStateName === swaRouterStateNames.productionsettings.scenes) {
        vm.selectedTabIndex = 4;
      } else if (currentStateName === swaRouterStateNames.productionsettings.chartsettings) {
        vm.selectedTabIndex = 5;
      } else if (currentStateName === swaRouterStateNames.productionsettings.stafftemplates) {
        vm.selectedTabIndex = 6;
      } else if (currentStateName === swaRouterStateNames.productionsettings.editstafftemplate) {
        vm.selectedTabIndex = 6;
      } else if (currentStateName === swaRouterStateNames.productionsettings.collaborators) {
        vm.selectedTabIndex = 7;
      } else if (currentStateName === swaRouterStateNames.productionsettings.editcollaborator) {
        vm.selectedTabIndex = 7;
      } else if (currentStateName === swaRouterStateNames.productionsettings.preferences) {
        vm.selectedTabIndex = 9;
      } else {
        vm.selectedTabIndex = -1;
      }
    }

    function updateActiveAccessRules() {
      if (vm.activeCollaborationConfig.isProductionOwner) {
        angular.extend(vm.activeAccessRules, defaultOwnerAccessRules);
        if (vm.activePlanRules.planId === 2) {
          vm.activeAccessRules.allowcopyproductions = false;
        }
      } else {
        angular.extend(vm.activeAccessRules, defaultDenyAccessRules);
      }
    }

    function initHelpTour() {
      var userData = DbSubMgrService.getLoggedInUserData();
      vm.userData = userData;
      var profileDisplayHelp = false;
      if (angular.isDefined(userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }

      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function initHelpTourSteps() {
      var currentStateName = swaUtils.getRouterCurrentStateName();
      vm.helpTourSteps = [];

      vm.helpTourVideos = [];

      var commonTourSteps = [{
        //Production Details Help
        element: '#prodsettings',
        title: $translate.instant('helptour.productionSettings.titles.Production Details'),
        placement: 'right',
        content: $translate.instant('helptour.productionSettings.messages.Production Details Content'),
      }, {
        //Stage Dimensions Help
        element: '#stagedimensions',
        title: $translate.instant('helptour.productionSettings.titles.Stage Dimensions'),
        content: $translate.instant('helptour.productionSettings.messages.Stage Dimensions Content'),
        placement: 'right',
      }, {
        //Set Pieces Help
        element: '#setpieces',
        title: $translate.instant('helptour.productionSettings.titles.Set Pieces'),
        content: $translate.instant('helptour.productionSettings.messages.Set Pieces Content'),
        placement: 'right',
      }, {
        //Performers Help
        element: '#performers',
        title: $translate.instant('helptour.productionSettings.titles.Performers'),
        content: $translate.instant('helptour.productionSettings.messages.Performers Content'),
        placement: 'right',
      }, {
        //Scenes Help
        element: '#scenes',
        title: $translate.instant('helptour.productionSettings.titles.Scenes'),
        content: $translate.instant('helptour.productionSettings.messages.Scenes Content'),
        placement: 'right',
      }, {
        //Chart Settings Help
        element: '#chartsettings',
        title: $translate.instant('helptour.productionSettings.titles.Chart Settings'),
        content: $translate.instant('helptour.productionSettings.messages.Chart Settings Content'),
        placement: 'right',
      }, {
        //Score Templates Help
        element: '#stafftemplates',
        title: $translate.instant('helptour.productionSettings.titles.Score Templates'),
        content: $translate.instant('helptour.productionSettings.messages.Score Templates Content'),
        placement: 'right',
      }, {
        //Collaborate Users Help
        element: '#collaborators',
        title: $translate.instant('helptour.productionSettings.titles.Collaborate'),
        content: $translate.instant('helptour.productionSettings.messages.Collaborate Content'),
        placement: 'right',
      }, {
        //Delete Production Help
        element: '#deleteproduction',
        title: $translate.instant('helptour.productionSettings.titles.Delete Production'),
        content: $translate.instant('helptour.productionSettings.messages.Delete Production Content'),
        placement: 'right',
      }, {
        // Preferences
        element: '#preferences',
        title: $translate.instant('helptour.productionSettings.titles.Preferences'),
        content: $translate.instant('helptour.productionSettings.messages.Preferences Content'),
        placement: 'right',
      }, {
        // Close settings
        element: '#close-settings',
        title: $translate.instant('helptour.productionSettings.titles.Close Settings'),
        placement: 'right',
        content: $translate.instant(
          'helptour.productionSettings.messages.Close settings and get back to editing.'),
      }];

      // Route specific steps
      var routeSpecificTourSteps = [];
      if (currentStateName === swaRouterStateNames.productionsettings.details) {
        //HELP TOUR FOR PRODUCTION DETAILS SECTION
        routeSpecificTourSteps = [{
          element: '#select-image',
          title: $translate.instant('helptour.productionSettings.titles.Select Image'),
          placement: 'right',
          content: $translate.instant('helptour.productionSettings.messages.Select Image Content'),
        }, {
          element: '#clear-logo',
          title: $translate.instant('helptour.productionSettings.titles.Clear Logo'),
          placement: 'right',
          content: $translate.instant('helptour.productionSettings.messages.Clear Logo Content'),
        }, {
          element: '#select-production-date',
          title: $translate.instant('helptour.productionSettings.titles.Select Production Date'),
          placement: 'right',
          content: $translate.instant('helptour.productionSettings.messages.Select Production Date Content'),
        }, {
          element: '#clear-production-date',
          title: $translate.instant('helptour.productionSettings.titles.Clear Production Date'),
          placement: 'right',
          content: $translate.instant('helptour.productionSettings.messages.Clear Production Date Content'),
        }];

        vm.helpTourVideos = [
          {
            label: 'Settings: Production Details',
            videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=116'
          },
          {
            label: 'Settings: Copying Productions',
            videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=955'
          }
        ];

      } else if (currentStateName === swaRouterStateNames.productionsettings.stagedimensions) {
        //HELP TOUR FOR STAGE DIMENSIONS SECTION
        routeSpecificTourSteps = [{
          element: '#edit-permanent-stage',
          title: $translate.instant('helptour.productionSettings.titles.Edit Permanent Stage'),
          content: $translate.instant('helptour.productionSettings.messages.Edit Permanent Stage Content'),
          placement: 'right',
        }, {
          element: '#custom-numberline',
          title: $translate.instant('helptour.productionSettings.titles.Custom Numberline'),
          content: $translate.instant('helptour.productionSettings.messages.Custom Numberline Content'),
          placement: 'right',
        }];

        vm.helpTourVideos = [
          {
            label: 'Settings: Stage Dimensions',
            videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=148'
          }
        ];
      } else if (currentStateName === swaRouterStateNames.productionsettings.customnumberline) {
        routeSpecificTourSteps = [{
          element: '#custom-numberline-markers',
          title: $translate.instant('helptour.productionSettings.titles.Custom Numberline Markers'),
          content: $translate.instant('helptour.productionSettings.messages.Custom Numberline Markers Content'),
          placement: 'bottom',
        }, {
          element: '#custom-numberline-preview',
          title: $translate.instant('helptour.productionSettings.titles.Custom Numberline Preview'),
          content: $translate.instant('helptour.productionSettings.messages.Custom Numberline Preview Content'),
          placement: 'bottom',
        }];

        vm.helpTourVideos = [
          {
            label: 'Settings: Stage Dimensions/Customize the Number Lines',
            videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=368'
          },
        ];
      } else if (currentStateName === swaRouterStateNames.productionsettings.setpieces) {
        //HELP TOUR FOR SET PIECES SECTION
        routeSpecificTourSteps = [{
          element: '#import-set-piece',
          title: $translate.instant('helptour.productionSettings.titles.Import Set Pieces'),
          content: $translate.instant('helptour.productionSettings.messages.Import Set Pieces Content'),
          placement: 'bottom',
        }, {
          element: '#create-set-piece',
          title: $translate.instant('helptour.productionSettings.titles.Create Set Pieces'),
          content: $translate.instant('helptour.productionSettings.messages.Create Set Pieces Content'),
          placement: 'bottom',
        }, {
          element: '#editdone-set-piece',
          title: $translate.instant('helptour.productionSettings.titles.Edit Set Pieces'),
          content: $translate.instant('helptour.productionSettings.messages.Edit Set Pieces Content'),
          placement: 'left',
        }, {
          element: '#set-piece-0',
          title: $translate.instant('helptour.productionSettings.titles.Update Set Piece'),
          content: $translate.instant('helptour.productionSettings.messages.Update Set Piece Content'),
          placement: 'bottom',
        }];

        vm.helpTourVideos = [{
          label: 'Settings: Set Pieces',
          videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=480'
        }];
      } else if (currentStateName === swaRouterStateNames.productionsettings.importsetpiece) {
        routeSpecificTourSteps = [{
          element: '#import-set-piece-image',
          title: $translate.instant('helptour.productionSettings.titles.Import Set Piece Image'),
          content: $translate.instant('helptour.productionSettings.messages.Import Set Piece Image Content'),
          placement: 'right',
        }];
        vm.helpTourVideos = [{
          label: 'Settings: Set Pieces/Import Set Piece',
          videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=480'
        }];
      } else if (currentStateName === swaRouterStateNames.productionsettings.performers) {
        //HELP TOUR FOR PERFORMERS SECTION
        routeSpecificTourSteps = [{
          element: '#import-performer',
          title: $translate.instant('helptour.productionSettings.titles.Import Performer'),
          content: $translate.instant('helptour.productionSettings.messages.Import Performer Content'),
          placement: 'bottom',
        }, {
          element: '#add-performer',
          title: $translate.instant('helptour.productionSettings.titles.Add Performer'),
          content: $translate.instant('helptour.productionSettings.messages.Add Performer Content'),
          placement: 'bottom',
        }, {
          element: '#editdone-performer',
          title: $translate.instant('helptour.productionSettings.titles.Edit Performer'),
          content: $translate.instant('helptour.productionSettings.messages.Edit Performer Content'),
          placement: 'left',
        }, {
          element: '#performer-0',
          title: $translate.instant('helptour.productionSettings.titles.Update Performer'),
          content: $translate.instant('helptour.productionSettings.messages.Update Performer Content'),
          placement: 'bottom',
        }];

        vm.helpTourVideos = [{
          label: 'Settings: Editing Performers',
          videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=628'
        }];
      } else if (currentStateName === swaRouterStateNames.productionsettings.importperformer) {
        routeSpecificTourSteps = [{
          element: '#import-performer-image',
          title: $translate.instant('helptour.productionSettings.titles.Import Performer Image'),
          content: $translate.instant('helptour.productionSettings.messages.Import Performer Image Content'),
          placement: 'right',
        }];

        vm.helpTourVideos = [{
          label: 'Settings: Editing Performers/Import Performer',
          videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=662'
        }];
      } else if (currentStateName === swaRouterStateNames.productionsettings.createperformer) {
        routeSpecificTourSteps = [{
          element: '#performer-text-color',
          title: $translate.instant('helptour.productionSettings.titles.Performer Text Color'),
          content: $translate.instant('helptour.productionSettings.messages.Performer Text Color Content'),
          placement: 'right',
        }, {
          element: '#performer-text-scale',
          title: $translate.instant('helptour.productionSettings.titles.Performer Text Scale'),
          content: $translate.instant('helptour.productionSettings.messages.Performer Text Scale Content'),
          placement: 'right',
        }, {
          element: '#performer-icon-shape',
          title: $translate.instant('helptour.productionSettings.titles.Performer Icon Shape'),
          content: $translate.instant('helptour.productionSettings.messages.Performer Icon Shape Content'),
          placement: 'right',
        }, {
          element: '#performer-shape-color',
          title: $translate.instant('helptour.productionSettings.titles.Performer Icon Shape Color'),
          content: $translate.instant('helptour.productionSettings.messages.Performer Icon Shape Color Content'),
          placement: 'right',
        }, {
          element: '#performer-border-color',
          title: $translate.instant('helptour.productionSettings.titles.Performer Icon Border Color'),
          content: $translate.instant('helptour.productionSettings.messages.Performer Icon Border Color Content'),
          placement: 'right',
        }];

        vm.helpTourVideos = [{
          label: 'Settings: Editing Performers/Create Performers',
          videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=628'
        }];
      } else if (currentStateName === swaRouterStateNames.productionsettings.scenes) {
        //HELP TOUR FOR SCENES SECTION
        routeSpecificTourSteps = [{
          element: '#add-scene',
          title: $translate.instant('helptour.productionSettings.titles.Add Scene'),
          content: $translate.instant('helptour.productionSettings.messages.Add Scene Content'),
          placement: 'bottom',
        }, {
          element: '#editdone-scene',
          title: $translate.instant('helptour.productionSettings.titles.Edit Scene'),
          content: $translate.instant('helptour.productionSettings.messages.Edit Scene Content'),
          placement: 'left',
        }, {
          element: '#scene-name-0',
          title: $translate.instant('helptour.productionSettings.titles.Edit Scene Name'),
          content: $translate.instant('helptour.productionSettings.messages.Edit Scene Name Content'),
          placement: 'bottom',
        }];

        vm.helpTourVideos = [{
          label: 'Settings: Scenes',
          videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=684'
        }];
      } else if (currentStateName === swaRouterStateNames.productionsettings.chartsettings) {
        //HELP TOUR FOR CHART SETTINGS SECTION
        routeSpecificTourSteps = [{
          element: '#chart-line-settings',
          title: $translate.instant('helptour.productionSettings.titles.Chart Line Settings'),
          content: $translate.instant('helptour.productionSettings.messages.Chart Line Settings Content'),
          placement: 'bottom',
        }, {
          element: '#chart-numbering-mode',
          title: $translate.instant('helptour.productionSettings.titles.Chart Numbering'),
          content: $translate.instant('helptour.productionSettings.messages.Chart Numbering Content'),
          placement: 'right',
        }, {
          element: '#point-of-view',
          title: $translate.instant('helptour.productionSettings.titles.Point of View'),
          content: $translate.instant('helptour.productionSettings.messages.Point of View Content'),
          placement: 'right',
        }, {
          element: '#showActorPlace',
          title: $translate.instant('helptour.productionSettings.titles.Performer Placement'),
          content: $translate.instant('helptour.productionSettings.messages.Performer Placement Content'),
          placement: 'right',
        }, {
          element: '#performer-placement-resolution',
          title: $translate.instant('helptour.productionSettings.titles.Performer Placement Detail'),
          content: $translate.instant(
            'helptour.productionSettings.messages.Performer Placement Detail Content'),
          placement: 'right',
        }, {
          element: '#showPerformerNose',
          title: $translate.instant('helptour.productionSettings.titles.Performer Body Direction'),
          content: $translate.instant('helptour.productionSettings.messages.Performer Body Direction Content'),
          placement: 'right',
        }, {
          element: '#showBreakLine',
          title: $translate.instant('helptour.productionSettings.titles.Line Shape Overlap'),
          content: $translate.instant('helptour.productionSettings.messages.Line Shape Overlap Content'),
          placement: 'right',
        }];

        vm.helpTourVideos = [{
          label: 'Settings: Chart Settings',
          videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=703'
        }];
      } else if (currentStateName === swaRouterStateNames.productionsettings.stafftemplates) {
        //HELP TOUR FOR STAFF TEMPLATES SECTION
        routeSpecificTourSteps = [{
          element: '#add-staff',
          title: $translate.instant('helptour.productionSettings.titles.Add Score'),
          content: $translate.instant('helptour.productionSettings.messages.Add Score Content'),
          placement: 'bottom',
        }, {
          element: '#editdone-staff',
          title: $translate.instant('helptour.productionSettings.titles.Edit Staff'),
          content: $translate.instant('helptour.productionSettings.messages.Edit Staff Content'),
          placement: 'left',
        }, {
          element: '#staff-template-0',
          title: $translate.instant('helptour.productionSettings.titles.Update Staff'),
          content: $translate.instant('helptour.productionSettings.messages.Update Staff Content'),
          placement: 'bottom',
        }];

        vm.helpTourVideos = [{
          label: 'Settings: Score Templates',
          videoUrl: 'https://www.youtube.com/embed/coNkSb1taRM?si=hFyFjvDpuOcSRHzt&amp;start=741'
        }];
      } else if (currentStateName === swaRouterStateNames.productionsettings.editstafftemplate) {
        routeSpecificTourSteps = [{
          element: '#displaycountprefix',
          title: $translate.instant('helptour.productionSettings.titles.Display Count Prefix'),
          content: $translate.instant('helptour.productionSettings.messages.Display Count Prefix Content'),
          placement: 'right',
        }, {
          element: '#allowadddeletecount',
          title: $translate.instant('helptour.productionSettings.titles.Add/Delete Count'),
          content: $translate.instant('helptour.productionSettings.messages.Add/Delete Count Content'),
          placement: 'right',
        }, {
          element: '#countColumnHeaderRow',
          title: $translate.instant('helptour.productionSettings.titles.Has Count Column Headers'),
          content: $translate.instant('helptour.productionSettings.messages.Has Count Column Headers Content'),
          placement: 'right',
        }];

        vm.helpTourVideos = [{
          label: 'Settings: Score Templates',
          videoUrl: 'https://www.youtube.com/embed/coNkSb1taRM?si=hFyFjvDpuOcSRHzt&amp;start=741'
        }];
      } else if (currentStateName === swaRouterStateNames.productionsettings.collaborators) {
        routeSpecificTourSteps = [{
          element: '#add-collaborator',
          title: $translate.instant('helptour.productionSettings.titles.Add Collaborator'),
          content: $translate.instant('helptour.productionSettings.messages.Add Collaborator Content'),
          placement: 'bottom',
        }, {
          element: '#editdone-collaborator',
          title: $translate.instant('helptour.productionSettings.titles.Edit Collaborator'),
          content: $translate.instant('helptour.productionSettings.messages.Edit Collaborator Content'),
          placement: 'left',
        }, {
          element: '#collaborated-user-0',
          title: $translate.instant('helptour.productionSettings.titles.Edit Single Collaborator'),
          content: $translate.instant('helptour.productionSettings.messages.Edit Single Collaborator Content'),
          placement: 'bottom',
        }];

        vm.helpTourVideos = [{
          label: 'Settings: Collaborators',
          videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=JSev5c3kJGsSgwG3&amp;start=820'
        }];
      } else if (currentStateName === swaRouterStateNames.productionsettings.editcollaborator) {
        routeSpecificTourSteps = [{
          element: '#stop-collaboration',
          title: $translate.instant('helptour.productionSettings.titles.Stop Collaboration'),
          content: $translate.instant('helptour.productionSettings.messages.Stop Collaboration Content'),
          placement: 'right',
        }, {
          element: '#collaboration-access',
          title: $translate.instant('helptour.productionSettings.titles.Collaboration Access'),
          content: $translate.instant('helptour.productionSettings.messages.Collaboration Access Content'),
          placement: 'right',
        }];
      }
      vm.helpTourSteps = routeSpecificTourSteps.concat(commonTourSteps);
    }

    $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      updateSelectedTabIndex();
      if (vm.showHelpBar) {
        initHelpTourSteps();
      }
    });
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('DeleteProductionPromptController', DeleteProductionPromptController);

  DeleteProductionPromptController.$inject = ['$uibModalInstance'];

  function DeleteProductionPromptController($uibModalInstance) {
    var vm = this;

    vm.actionYes = actionYes;
    vm.actionNo = actionNo;

    function actionYes() {
      $uibModalInstance.close();
    }

    function actionNo() {
      $uibModalInstance.dismiss();
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('CopyProductionPromptController', CopyProductionPromptController);

  CopyProductionPromptController.$inject = [
    '$uibModalInstance',
    '$timeout',
    'toastr',
    '$translate',
    'productionCopyParams',
  ];

  function CopyProductionPromptController($uibModalInstance, $timeout, toastr, $translate, productionCopyParams) {

    var vm = this;

    vm.productionCopyParams = productionCopyParams;

    vm.keepSameAction = keepSameAction;
    vm.copyProduction = copyProduction;
    vm.actionNo = actionNo;
    vm.$onInit = onInit;

    keepSameAction();

    function onInit() {
      $timeout(function() {
        angular.element('input#newProductionName').focus();
      }, 500);
    }

    function keepSameAction() {
      vm.productionCopyParams.newMeasurementUnit = vm.productionCopyParams.originalMeasurementUnit;
      vm.productionCopyParams.newStageWidth = vm.productionCopyParams.originalStageWidth;
      vm.productionCopyParams.newStageDepth = vm.productionCopyParams.originalStageDepth;
      vm.productionCopyParams.newOffstageWidth = vm.productionCopyParams.originalOffstageWidth;
    }

    function validateParameters() {
      var validationErrorMessage = '<ul>';

      var invalidName = false;
      if (vm.copyProductionForm.newProductionName.$error.required) {
        invalidName = true;
        validationErrorMessage = validationErrorMessage + '<li>' + $translate.instant('validationmessages.Production Name is required') + '</li>';
      }

      var invalidDimensions = false;
      var updatedWidth = parseFloat(vm.productionCopyParams.newStageWidth);
      var updatedDepth = parseFloat(vm.productionCopyParams.newStageDepth);

      var invalidOffstage = false;
      var updatedOffstageWidth = parseFloat(vm.productionCopyParams.newOffstageWidth);

      invalidDimensions = invalidDimensions || (vm.copyProductionForm.newStageWidth.$error.required || vm.copyProductionForm.newStageWidth.$error.min);
      invalidDimensions = invalidDimensions || (updatedWidth <= 0.0);
      invalidDimensions = invalidDimensions || (vm.copyProductionForm.newStageDepth.$error.required || vm.copyProductionForm.newStageDepth.$error.min);
      invalidDimensions = invalidDimensions || (updatedDepth <= 0.0);
      if (invalidDimensions) {
        validationErrorMessage = validationErrorMessage + '<li>' + $translate.instant('validationmessages.Stage dimensions should be greater than 0.0') + '</li>';
      }

      invalidOffstage = invalidOffstage || (vm.copyProductionForm.newOffstageWidth.$error.required || vm.copyProductionForm.newOffstageWidth.$error.min);
      invalidOffstage = invalidOffstage || (updatedOffstageWidth < 0.0);
      if (invalidOffstage) {
        validationErrorMessage = validationErrorMessage + '<li>' + $translate.instant('validationmessages.Off-stage width cannot be less than 0.0') + '</li>';
      }

      if (invalidName || invalidDimensions || invalidOffstage) {
        validationErrorMessage = validationErrorMessage + '</ul>';
        toastr.warning(
          validationErrorMessage,
          $translate.instant('errormessages.Error copying production!'),
          {allowHtml: true}
        );

        return false;
      }

      return true;
    }

    // function validateParameters() {
    //   var validationErrorMessage = '<ul>';
    //
    //   var invalidName = (angular.isUndefined(vm.productionCopyParams.newProductionName) || (vm.productionCopyParams.newProductionName.trim().length === 0));
    //   if (invalidName) {
    //     validationErrorMessage = validationErrorMessage + '<li>' + $translate.instant('validationmessages.Production Name is required.') + '</li>';
    //   }
    //
    //   var invalidDimensions = false;
    //   var updatedWidth = vm.productionCopyParams.originalStageWidth;
    //   var updatedDepth = vm.productionCopyParams.originalStageDepth;
    //   var updatedOffstageWidth = vm.productionCopyParams.originalMeasurementUnit;
    //
    //   if (vm.productionCopyParams.newStageWidth.length > 0) {
    //     updatedWidth = parseFloat(vm.productionCopyParams.newStageWidth);
    //     if (isNaN(updatedWidth)) {
    //       updatedWidth = 0;
    //     }
    //   } else {
    //     updatedWidth = vm.productionCopyParams.originalStageWidth;
    //   }
    //
    //   if (vm.productionCopyParams.newStageDepth.length > 0) {
    //     updatedDepth = parseFloat(vm.productionCopyParams.newStageDepth);
    //     if (isNaN(updatedDepth)) {
    //       updatedDepth = 0;
    //     }
    //   } else {
    //     updatedDepth = vm.productionCopyParams.originalStageWidth;
    //   }
    //
    //   if (vm.productionCopyParams.newOffstageWidth.length > 0) {
    //     updatedOffstageWidth = parseFloat(vm.productionCopyParams.newOffstageWidth);
    //     if (isNaN(updatedOffstageWidth)) {
    //       updatedOffstageWidth = 0;
    //     }
    //   } else {
    //     updatedOffstageWidth = vm.productionCopyParams.originalStageWidth;
    //   }
    //
    //   invalidDimensions = invalidDimensions || (updatedWidth <= 0.0);
    //   invalidDimensions = invalidDimensions || (updatedDepth <= 0.0);
    //   invalidDimensions = invalidDimensions || (updatedOffstageWidth < 0.0);
    //
    //   if (invalidDimensions) {
    //     if ((updatedDepth <= 0.0) || (updatedWidth <= 0.0)) {
    //       validationErrorMessage = validationErrorMessage + '<li>' + $translate.instant('validationmessages.Stage dimensions should be greater than 0.0.') + '</li>';
    //     }
    //
    //     if (updatedOffstageWidth < 0.0) {
    //       validationErrorMessage = validationErrorMessage + '<li>' + $translate.instant('validationmessages.Off-stage width cannot be less than 0.0.') + '</li>';
    //     }
    //   }
    //
    //   if (invalidName || invalidDimensions) {
    //     validationErrorMessage = validationErrorMessage + '</ul>';
    //     toastr.warning(validationErrorMessage, $translate.instant('validationmessages.Please fix the following -'), {allowHtml: true});
    //   }
    //
    //   return !(invalidName || invalidDimensions);
    // }

    function copyProduction() {
      if (!validateParameters()) {
        return;
      }

      // vm.productionCopyParams.newStageWidth = parseFloat(vm.productionCopyParams.newStageWidth);
      // if (isNaN(vm.productionCopyParams.newStageWidth)) {
      //   vm.productionCopyParams.newStageWidth = vm.productionCopyParams.originalStageWidth;
      // }
      // vm.productionCopyParams.newStageDepth = parseFloat(vm.productionCopyParams.newStageDepth);
      // if (isNaN(vm.productionCopyParams.newStageDepth)) {
      //   vm.productionCopyParams.newStageDepth = vm.productionCopyParams.originalStageDepth;
      // }
      // vm.productionCopyParams.newOffstageWidth = parseFloat(vm.productionCopyParams.newOffstageWidth);
      // if (isNaN(vm.productionCopyParams.newOffstageWidth)) {
      //   vm.productionCopyParams.newOffstageWidth = vm.productionCopyParams.originalOffstageWidth;
      // }

      var resizeStage = false;
      resizeStage = resizeStage || (vm.productionCopyParams.newMeasurementUnit !== vm.productionCopyParams.originalMeasurementUnit);
      resizeStage = resizeStage || (vm.productionCopyParams.newStageWidth !== vm.productionCopyParams.originalStageWidth);
      resizeStage = resizeStage || (vm.productionCopyParams.newStageDepth !== vm.productionCopyParams.originalStageDepth);
      resizeStage = resizeStage || (vm.productionCopyParams.newOffstageWidth !== vm.productionCopyParams.originalOffstageWidth);
      vm.productionCopyParams.resizeStage = resizeStage;

      $uibModalInstance.close(vm.productionCopyParams);
    }

    function actionNo() {
      $uibModalInstance.dismiss();
    }
  }
}());

// SWA-1948 - Move To stripe popup
(function () {
    'use strict';
    angular.module('swanywhere').controller('SwitchToStripeConfirmationPromptController', SwitchToStripeConfirmationPromptController);
  
    SwitchToStripeConfirmationPromptController.$inject = ['$uibModalInstance'];
  
    function SwitchToStripeConfirmationPromptController($uibModalInstance) {
      var vm = this;
  
     
  
      vm.cancelSwitch = cancelSwitch;
      vm.confirmSwitch = confirmSwitch;
  
      function cancelSwitch() {
        $uibModalInstance.dismiss('cancel');
      }
  
      function confirmSwitch() {
        $uibModalInstance.close();
      }
    }
  })();
  
(function () {
  'use strict';
  angular.module('swanywhere').controller('SubscriptionExpiredUpgradePromptController', SubscriptionExpiredUpgradePromptController);

  SubscriptionExpiredUpgradePromptController.$inject = [
    '$uibModalInstance',
    'swaUtils',
    'swaRouterStateNames'];

  function SubscriptionExpiredUpgradePromptController($uibModalInstance, swaUtils, swaRouterStateNames) {
    var vm = this;

    vm.continueSwitch = continueSwitch;
    vm.upgradePlan = upgradePlan;

    function continueSwitch() {
      $uibModalInstance.close();
    }

    function upgradePlan() {
      $uibModalInstance.dismiss('cancel');
      var params = {
        redirectReason: 'purchase',
      };
      swaUtils.stateGo(swaRouterStateNames.subscriptions, params);
    }
  }
})();

(function () {
  'use strict';
  angular.module('swanywhere').controller('ShowWelcomeScreenController', ShowWelcomeScreenController);

  ShowWelcomeScreenController.$inject = [
    '$uibModalInstance',
    'swaUtils',
    'swaRouterStateNames'];

  function ShowWelcomeScreenController($uibModalInstance, swaUtils, swaRouterStateNames) {
    var vm = this;

    vm.startTour = startTour;
    vm.close = close;

    function startTour() {
      $uibModalInstance.close({getStarted: true});
    }

    function close() {
      $uibModalInstance.close();
    }
  }
})();

(function () {
  'use strict';
  angular.module('swanywhere').controller('ShowPlanHintController', ShowPlanHintController);

  ShowPlanHintController.$inject = [
    '$uibModalInstance',
    'activePlanRules'];

  function ShowPlanHintController($uibModalInstance, activePlanRules) {
    var vm = this;

    vm.close = close;
    vm.activePlanRules = activePlanRules;

    function close() {
      $uibModalInstance.close();
    }
  }
})();

(function () {
  'use strict';
  angular.module('swanywhere').controller('ShowBrowserHintController', ShowBrowserHintController);

  ShowBrowserHintController.$inject = ['$uibModalInstance'];

  function ShowBrowserHintController($uibModalInstance) {
    var vm = this;

    vm.close = close;

    function close() {
      $uibModalInstance.close();
    }
  }
})();

(function () {
  'use strict';

  angular.module('swanywhere').controller('RestoreProductionPromptController', RestoreProductionPromptController);

  RestoreProductionPromptController.$inject = ['$uibModalInstance'];
  //  SWA-1236-
  function RestoreProductionPromptController($uibModalInstance) {
    var vm = this;

    vm.actionYes = actionYes;
    vm.actionNo = actionNo;

    function actionYes() {
      $uibModalInstance.close();
    }

    function actionNo() {
      $uibModalInstance.dismiss();
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('ProductionListController', ProductionListController);

  ProductionListController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    '$log',
    '$uibModal',
    'DbSubMgrService',
    'DbProductions',
    'DbDeletedProductions',
    'swaConfig',
    'ngProgressLite',
    'toastr',
    '$timeout',
    'blockUI',
    '$translate',
    'swaUtils',
    'swaRouterStateNames',
    'DbUser',
    '$q',
    '$window',
    'swPdfPrintService',
    '$localStorage',
    '$sessionStorage',
    'swRestoreProductionService'
  ];

  function ProductionListController($scope, $cookies, $stateParams, $log,
    $uibModal, DbSubMgrService, DbProductions, DbDeletedProductions, swaConfig,
    ngProgressLite, toastr, $timeout, blockUI, $translate,
    swaUtils, swaRouterStateNames, DbUser, $q, $window, swPdfPrintService,
    $localStorage, $sessionStorage, swRestoreProductionService) {

    var vm = this;
    var dbProductions = new DbProductions();
    //  SWA-1236-
    var dbDeletedProductions = new DbDeletedProductions();
    vm.swaRouterStateNames = swaRouterStateNames;

    vm.userData = {};
    vm.productions = [];
    vm.originalProductions = [];
    vm.deletedproductions = [];
    vm.quickAccountInfo = {
      isEntAcctMember: false,
      entAcctName: '',
      onPromoPlan: false,
      recurringActive: true,
    };
    vm.versionString = '';
    vm.showHelpBar = false;
    vm.hideBrowserHint = ((typeof InstallTrigger !== 'undefined') || !!window.chrome); // eslint-disable-line
    vm.editFavoritesMode = false;
    vm.showEditFavoritesModeTooltip = false;
    vm.favoriteProductions = [];
    vm.showFontInstallHint = false;

    vm.scrollConfigProductions = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollButtons: {
        enable: false,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
    };

    vm.selectProduction = selectProduction;
    vm.selectProductionSettings = selectProductionSettings;
    vm.toggleEditFavoritesMode = toggleEditFavoritesMode;
    vm.promptAddProduction = promptAddProduction;
    vm.logout = logout;
    vm.installRequiredFonts = installRequiredFonts;
    vm.showPdfRequests = showPdfRequests;
    vm.downloadArchivePrompt = downloadArchivePrompt;
    //  SWA-1236-
    vm.deletedProductionListMode = false;
    vm.toggleDeletedProductionList = toggleDeletedProductionList;
    vm.restoreProductionPrompt = restoreProductionPrompt;

    vm.searchStringChanged = searchStringChanged;
    vm.clearSearch = clearSearch;
    vm.productionSearchFilter = productionSearchFilter;

    // SWA-1948 - Move To stripe popup - date condition
    vm.today = new Date() // current date
    vm.switchLimitDate = new Date("Dec 08, 2022");
    vm.showSwitchStripePopup = false
    if (vm.today > vm.switchLimitDate) {
      vm.showSwitchStripePopup = true;
    }
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedProductions: false,
      allowedNumberOfProductions: 0,
      allowFavoriteProductions: false,
    };

    vm.searchproductionname = '';
    /** Uppercase search string for case-insensitive matching */
    vm.searchStringUpper = '';

    initialize();

    function initialize() {
      updateVersionInfo();
      sessionCheckAndRun();
      checkInstalledFonts();

      clearPreviousEditingState();

      setupProductionRestoreService();
    }

    function updateVersionInfo() {
      var versionInfo = swaConfig.versionInfo;
      vm.versionString = '' + versionInfo.major + '.' + versionInfo.minor + '.' + versionInfo.patch;
    }

    function setupProductionRestoreService() {
      swRestoreProductionService.setProductionRestoration();
    }

    function sessionCheckAndRun() {
      var deleteProductionId = $stateParams.deleteProductionId;
      var restoreDeletedProductionId = $stateParams.restoreDeletedProductionId;

      var redirectReason = $stateParams.redirectreason;
      $cookies.remove('selectedProductionId');

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession()
        .then(function () {
          ngProgressLite.set(0.1);
          return DbSubMgrService.validateActivePlan();
        })
        .then(function () {
          ngProgressLite.set(0.2);
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          ngProgressLite.set(0.3);
          updateUserData();
        })
        .then(function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        })
        .then(function (plan) {
          ngProgressLite.set(0.4);
          updateActivePlanRules(plan);
        })
        .then(function () {
          ngProgressLite.set(0.5);
          DbSubMgrService.clearSelectedProduction();
          return dbProductions.fetchAll(updateDataProductions);
        })
        .then(function () {
          ngProgressLite.set(0.7);
          initHelpTour();
        })
        .then(function () {
          if (angular.isDefined(deleteProductionId)) {
            return deleteProduction(deleteProductionId);
          } else if (redirectReason === 'post-registration') {
            showWelcomeScreen();
          }
        })
        .then(function () {
          //  SWA-1236-
          if (angular.isDefined(restoreDeletedProductionId)) {
            return restoreProduction(restoreDeletedProductionId);
          } else if (redirectReason === 'post-registration') {
            showWelcomeScreen();
          }
        })
        .then(function () {
          ngProgressLite.set(0.8);
          checkUserFlags();
        })
        .then(function () {
          monitorUserDataChanges();
        })
        .then(function () {
          if (!vm.hideBrowserHint) {
            showBrowserHint()
          }
        })
        .then(function () {
          checkForSessionChartLink();
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function searchStringChanged() {
      vm.searchStringUpper = vm.searchproductionname.toUpperCase();
    }

    function clearSearch() {
      vm.searchStringUpper = '';
      vm.searchproductionname = '';
    }

    function productionSearchFilter(item) {
      return item.name.toUpperCase().indexOf(vm.searchStringUpper) > -1;
    }

    function updateUserData() {
      vm.userData = DbSubMgrService.getLoggedInUserData();
      vm.userId = DbSubMgrService.getLoggedInUserId();
      vm.username = swaUtils.getUserNameForDisplay(vm.userData);

      if (angular.isDefined(vm.userData.preferences) && angular.isArray(vm.userData.preferences.favoriteProductions)) {
        vm.favoriteProductions = angular.copy(vm.userData.preferences.favoriteProductions);
      } else {
        vm.favoriteProductions = [];
      }

      vm.quickAccountInfo.onPromoPlan = (vm.userData.activesubscription.promoPlan === true);
      vm.quickAccountInfo.isStripeSubscription = (vm.userData.stripe && vm.userData.stripe.subId); // SWA-1948 : Stripe
      // stripe.subId
      vm.quickAccountInfo.recurringActive = !_.isEmpty(_.property(['stripe', 'subId'])(vm.userData));
      flagFavoriteProductions();
      getEntAcctDetails()
        .then(function () {
          return updateActivePlan();
        })
        .then(function () {
          return sortProductionList();
        });
    }

    function updateActivePlan() {
      var deferred = $q.defer();

      DbSubMgrService.getLoggedInUsersPlan()
        .then(function (plan) {
          updateActivePlanRules(plan);
        })
        .finally(function () {
          deferred.resolve()
        });

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      if (plan.planid === vm.activePlanRules.planId) {
        return;
      }

      vm.activePlanRules.planId = plan.planid;
      vm.activePlanRules.planName = plan.planname;

      vm.activePlanRules.allowBackupProductions = plan.planfeatures[20].featurevalue;
      vm.activePlanRules.allowUnlimitedProductions = plan.planfeatures[1].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedProductions) {
        vm.activePlanRules.allowedNumberOfProductions = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfProductions = plan.planfeatures[1].featurevalue;
      }
      vm.activePlanRules.allowFavoriteProductions = plan.planfeatures[21].featurevalue;

      updateProductionPlanAccess();

      if (!vm.activePlanRules.allowUnlimitedProductions) {
        clearSearch();
      }
    }

    // Data update callback
    function updateDataProductions(id) {
      $log.debug('ProductionListController.updateDataProductions():', id);
      if (angular.isUndefined(id)) {
        var allProductions = dbProductions.getFetched();
        if (angular.isUndefined(allProductions)) {
          toastr.error('Error getting data from server', 'Error');
          vm.productions = [];
        } else {
          vm.productions = allProductions;
          flagFavoriteProductions();
          sortProductionList();

          updateProductionPlanAccess();
        }
      } else {
        vm.productions = vm.productions || [];

        var existingProduction = swaUtils.findInArrayById(vm.productions, id);
        var incomingProduction = dbProductions.getFetchedById(id);

        if (angular.isUndefined(existingProduction)) {
          if (angular.isUndefined(incomingProduction)) {
            $log.warn('no exisitng and  incoming production for ID: ' + id);
            return;
          }

          // incoming insert
          vm.productions.push(incomingProduction);
          flagFavoriteProduction(incomingProduction);
          sortProductionList();
          updateProductionPlanAccess();
        } else {
          if (angular.isUndefined(incomingProduction)) {
            // incoming delete
            var existingProductionIndex = vm.productions.indexOf(existingProduction);
            if (existingProductionIndex !== -1) {
              vm.productions.splice(existingProductionIndex, 1);
            }
            sortProductionList();
            updateProductionPlanAccess();
          } else {
            angular.copy(incomingProduction, existingProduction);
            flagFavoriteProduction(existingProduction);
            sortProductionList();
          }
        }
      }
    }

    function updateProductionPlanAccess() {
      if (angular.isArray(vm.productions)) {
        vm.productions.forEach(function (production, index) {
          production.denyAccess = (production.oIndex >= vm.activePlanRules.allowedNumberOfProductions);
        });
      }
    }

    function toggleEditFavoritesMode() {
      vm.editFavoritesMode = !vm.editFavoritesMode;

      if (!vm.editFavoritesMode) {
        vm.showEditFavoritesModeTooltip = false;

        blockUI.start();
        updateFavoriteProductionsPreference()
          .catch(function (error) {
            swaUtils.showErrorToast(error, $translate.instant('errormessages.Error saving favorite productions'));
          }
          )
          .finally(function () {
            flagFavoriteProductions();
            sortProductionList();

            blockUI.reset();
          }
          );
      } else {
        vm.showEditFavoritesModeTooltip = true;
      }
    }

    function flagFavoriteProductions() {
      _.each(vm.productions, function (production) {
        flagFavoriteProduction(production);
      });
    }

    function flagFavoriteProduction(production) {
      production.isFavorite = _.contains(vm.favoriteProductions, production._id);
    }

    function getEntAcctDetails() {
      var deferred = $q.defer();

      DbSubMgrService.getLoggedInEntAcct()
        .then(function (account) {
          vm.quickAccountInfo.isEntAcctMember = true;
          vm.quickAccountInfo.entAcctName = account.name;
        })
        .catch(function () {
          vm.quickAccountInfo.isEntAcctMember = false;
          vm.quickAccountInfo.entAcctName = undefined;
        })
        .finally(function () {
          deferred.resolve();
        });

      return deferred.promise;
    }

    function sortProductionList() {
      if (!angular.isArray(vm.productions) || vm.editFavoritesMode) {
        return;
      }

      $scope.$applyAsync(function () {
        if (vm.activePlanRules.allowFavoriteProductions) {
          dbProductions.sortByNameWithFavorites(vm.productions, vm.userData);
        } else {
          dbProductions.sortForUserId(vm.productions, vm.userId);
        }

        vm.productions.forEach(function (production, index) {
          production.oIndex = index;
          production.denyAccess = (index >= vm.activePlanRules.allowedNumberOfProductions);
        });
      });
    }

    //  SWA-1236-
    function toggleDeletedProductionList() {
      vm.deletedProductionListMode = !vm.deletedProductionListMode;

      vm.deletedproductions = [];

      if (vm.deletedProductionListMode) {
        blockUI.start();
        dbDeletedProductions.getDeletedProductionForUser()
          .then(function (deletedProductionList) {
            if (angular.isUndefined(deletedProductionList)) {
              toastr.error('Error getting deleted production data from server', 'Error');
              vm.deletedproductions = [];
            } else {
              vm.deletedproductions = deletedProductionList;
            }
          })
          .catch(function (error) {
            toastr.error('Error getting deleted production data from server', 'Error');
            $log.error('ProductionListController.toggleDeletedProductionList():', error);
          })
          .finally(function () {
            blockUI.stop();
          });
      }
    }

    /**
     * Checks if the given production is accessible in the active subscription plan.
     * @param {object} production The production to check.
     * @returns true if accessible else false
     */
    function checkProductionPlanAccess(production) {
      if (production.denyAccess) {
        var messageLine1 = $translate.instant('planprivileges.messages.You don\'t have access to this production - to gain access, please change your subscription settings.');
        toastr.error(
          messageLine1 + '<br/><br/>Click here for more details',
          $translate.instant('planprivileges.titles.Subscription Plan Limit!'),
          { allowHtml: true, timeOut: 10000, onTap: showPlanHint }
        );

        return false;
      }

      if (vm.activePlanRules.planId === 2 && production.ownerId === vm.userId) {
        toastr.info(
          $translate.instant('planprivileges.messages.Production is read-only'),
          $translate.instant('planprivileges.titles.View Only Plan!')
        );
      }

      return true;
    }

    function selectProduction(productionId) {
      $log.debug('ProductionListController.selectProduction:', productionId);

      if (vm.editFavoritesMode) {
        toggleFavoriteFlag(productionId);
        return;
      }

      var production = _.findWhere(vm.productions, { _id: productionId });
      if (angular.isUndefined(production)) {
        return;
      }

      if (!checkProductionPlanAccess(production)) {
        return;
      }

      DbSubMgrService.setSelectedProduction(productionId);

      $cookies.put('selectedProductionId', productionId);

      var params = {
        productionId: productionId,
      };
      if (production.productiontype === 1) {
        swaUtils.stateGo(swaRouterStateNames.scripteditor, params);
      } else {
        swaUtils.stateGo(swaRouterStateNames.charteditor, params);
      }
    }

    function selectProductionSettings(productionId) {
      $log.debug('ProductionListController.selectProductionSettings:', productionId);

      var production = _.findWhere(vm.productions, { _id: productionId });
      if (angular.isUndefined(production)) {
        return;
      }

      if (!checkProductionPlanAccess(production)) {
        return;
      }

      DbSubMgrService.setSelectedProduction(productionId);

      $cookies.remove('currentEditorStateName');
      $cookies.put('selectedProductionId', productionId);

      var params = {
        productionId: productionId,
      };
      if (production.productiontype === 1) {
        $cookies.put('currentEditorStateName', swaRouterStateNames.scripteditor);
      }
      swaUtils.stateGo(swaRouterStateNames.productionsettings.details, params);
    }

    function clearPreviousEditingState() {
      delete $localStorage.currentEditorStateName;
      delete $localStorage.selectedProductionId;
      delete $localStorage.scriptLastOpenedPageIndex;
      delete $localStorage.performerPairsWithIdsForUndo;
      delete $localStorage.scaleAllPerformers;
      delete $localStorage.scaleSelectedPerformers;
      delete $localStorage.pinnedPosXOfContextMenu;
      delete $localStorage.pinnedPosYOfContextMenu;
      delete $localStorage.isContextMenuPinned;
    }

    function toggleFavoriteFlag(productionId) {
      var existingIndex = _.indexOf(vm.favoriteProductions, productionId);
      if (existingIndex > -1) {
        vm.favoriteProductions.splice(existingIndex, 1);
      } else {
        vm.favoriteProductions.push(productionId);
      }

      flagFavoriteProductions();
    }

    function updateFavoriteProductionsPreference() {
      var dbUser = new DbUser();
      return dbUser.updateFavoriteProductionsPreference(vm.favoriteProductions);
    }

    // Add production prompt and handler
    function promptAddProduction() {
      if ((vm.activePlanRules.planId === 2) || (vm.productions.length >= vm.activePlanRules.allowedNumberOfProductions)) {
        toastr.error(
          $translate.instant('planprivileges.messages.You cannot add (any more) productions in your current plan.'),
          $translate.instant('planprivileges.titles.Subscription Plan Limit!')
        );

        return;
      }

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionList/addProductionPrompt.html',
        controller: 'AddProductionPromptController',
        controllerAs: 'vm',
        size: '600',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
      });

      // modalInstance.rendered.then(
      //   function () {
      //     angular.element('input#productionname').focus();
      //   }
      // );

      modalInstance.result
        .then(function (newProduction) {
          addProduction(newProduction);
        });
    }

    function addProduction(newProduction) {
      ngProgressLite.start();
      blockUI.start();

      var productionObject = dbProductions.getNewProductionObject();
      productionObject.name = newProduction.name;
      productionObject.productiontype = (newProduction.type || 0);
      dbProductions.insert(productionObject)
        .then(function (id) {
          ngProgressLite.set(0.5);
          toastr.success('Opening settings ...', 'Production added!');
          $timeout(function () {
            ngProgressLite.done();
            toastr.clear();

            $cookies.remove('currentEditorStateName');
            var params = {
              productionId: id,
            };
            if (productionObject.productiontype === 1) {
              $cookies.put('currentEditorStateName', swaRouterStateNames.scripteditor);
            }
            swaUtils.stateGo(swaRouterStateNames.productionsettings.details, params);
          }, 500);
        })
        .catch(function (error) {
          ngProgressLite.done();
          blockUI.stop();
          $log.error('ProductionListController.addProduction:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error adding new production!'));
        });
    }

    function deleteProduction(productionId) {
      var deferred = $q.defer();

      blockUI.message($translate.instant('messages.Deleting Production ...'));
      dbProductions.delete(productionId)
        .then(function () {
          toastr.success($translate.instant('messages.Production deleted.'));
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('ProductionListController.deleteProduction:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error deleting production!'));

          deferred.resolve();
        });

      return deferred.promise;
    }

    function doEnterpriseSwitchToOwnAccount() {
      ngProgressLite.start();
      blockUI.start();

      var dbUser = new DbUser();
      dbUser.leaveEnterprise()
        .catch(function (error) {
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Something went wrong!'));
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    // Logout handler
    function logout() {
      DbSubMgrService.logout();
    }

    function monitorUserDataChanges() {
      $scope.$on('userDataChanged', function () {
        updateUserData();
      });
    }

    // Event handler for scope destroy
    $scope.$on('$destroy', function () {
      dbProductions.fetchUnregister();
    });

    function promptSubscriptionExpiredUpgrade() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionList/subscriptionExpiredUpgradePrompt.html',
        controller: 'SubscriptionExpiredUpgradePromptController',
        controllerAs: 'vm',
        size: '480',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
      });

      modalInstance.result.then(
        function () {
          var dbUser = new DbUser();
          dbUser.clearUpgradePromptFlag();
        }
      );
    }

    function promptConfirmEnterpriseSwitchToOwnAccount() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionList/enterpriseExpireSwitchPrompt.html',
        controller: 'EnterpriseExpireSwitchPromptController',
        controllerAs: 'vm',
        size: '480',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
      });

      modalInstance.result
        .then(function () {
          doEnterpriseSwitchToOwnAccount();
        })
        .catch(function () {
          DbSubMgrService.logout();
        });
    }

    function showWelcomeScreen() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionList/showWelcomeScreen.html',
        controller: 'ShowWelcomeScreenController',
        controllerAs: 'vm',
        size: 'lg',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
      });

      modalInstance.result.then(
        function (data) {
          if (angular.isDefined(data) && data.getStarted) {
            vm.helpTourStartTrigger = 'video';
          }
        }
      );
    }

    function showBrowserHint() {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionList/showBrowserHint.html',
        controller: 'ShowBrowserHintController',
        controllerAs: 'vm',
        size: 'md',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
      });
    }

    function showPlanHint() {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionList/showPlanHint.html',
        controller: 'ShowPlanHintController',
        controllerAs: 'vm',
        size: 'md',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
        resolve: {
          activePlanRules: vm.activePlanRules,
        }
      });
    }

    function showPdfRequests() {
      swPdfPrintService.getApprovalPendingRequests()
        .then(function (printJobs) {
          return showPdfRequestsPopup(printJobs);
        })
        .catch(function (error) {
          $log.error('ProductionListController.showPdfRequests:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error getting print jobs!'));
        });
    }

    function showPdfRequestsPopup(printJobs) {
      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionList/pendingPdfRequests.html',
        controller: 'PendingPdfRequestsController',
        controllerAs: 'vm',
        size: 'lg',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
        resolve: {
          printJobs: function () { return printJobs },
          productions: function () { return vm.productions }
        }
      });
    }

    function downloadArchivePrompt(productionId) {
      var production = _.findWhere(vm.productions, { _id: productionId });
      if (angular.isUndefined(production)) {
        return;
      }

      if (!checkProductionPlanAccess(production)) {
        return;
      }

      $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionList/downloadArchivePrompt.html',
        controller: 'DownloadArchivePromptController',
        controllerAs: 'vm',
        size: '480',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
        resolve: {
          production: function () { return production }
        }
      });
    }

    // ---- --- --- SWA-1236-Changes : Confirm Restore Production Prompt --- --- --- ---
    // Restore Production prompt
    function restoreProductionPrompt(deletedProductionId) {
      if (angular.isUndefined(deletedProductionId)) {
        return;
      }
      var deletedProduction = _.findWhere(vm.deletedproductions, { _id: deletedProductionId });
      if (angular.isUndefined(deletedProduction)) {
        return;
      }

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionList/restoreProductionPrompt.html',
        controller: 'RestoreProductionPromptController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });
      modalInstance.result
        .then(function () {
          restoreProduction(deletedProductionId);
        });
    }

    //  SWA-1236-
    function restoreProduction(restoreDeletedProductionId) {
      blockUI.start();
      blockUI.message($translate.instant('messages.Restoring Production ...'));
      dbDeletedProductions.restoreBackProduction(restoreDeletedProductionId)
        // dbProductions.trash(productionId)
        .then(function () {
          toastr.success($translate.instant('messages.Production restored.'));
        })
        .catch(function (error) {
          $log.error('ProductionListController.restoreProduction:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error restoring production!'));
        })
        .finally(function () {
          toggleDeletedProductionList();
          blockUI.stop();
        });
    }

    // -----------------------------------------------
    function checkUserFlags() {
      if (angular.isDefined(vm.userData.flags)) {
        if (vm.userData.flags.upgradePrompt === true) {
          promptSubscriptionExpiredUpgrade();
        } else if (vm.userData.flags.enterpriseInactiveSwitchPrompt === true) {
          promptConfirmEnterpriseSwitchToOwnAccount();
        }
      }
    }

    /**
     * Checks session for chartlink data and opens that chart if possible.
     */
    function checkForSessionChartLink() {
      var clProductionId = $sessionStorage.clSelectedProductionId;
      var clChartId = $sessionStorage.clSelectedChartId;
      delete $sessionStorage.clSelectedProductionId;
      delete $sessionStorage.clSelectedChartId;

      if (!angular.isString(clProductionId) || !angular.isString(clChartId)) {
        return;
      }

      var production = _.findWhere(vm.productions, { _id: clProductionId });

      if (angular.isUndefined(production)) {
        toastr.error('You do not have access to the production referred in the link you followed');
        return;
      }

      if (!checkProductionPlanAccess(production)) {
        return;
      }

      var params = {
        lockModeNavigation: undefined,
        navParams: { chartId: clChartId },
        productionId: clProductionId,
        selectedScene: undefined
      }
      swaUtils.stateGo(swaRouterStateNames.charteditor, params);
    }

    function initHelpTour() {
      vm.editFavoritesModeTooltipHtml = $translate.instant('messages.Select/unselect your favorite productions<br/><br/>Favorites will always appear at the top.');

      var profileDisplayHelp = false;
      if (angular.isDefined(vm.userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || vm.userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }

      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function initHelpTourSteps() {
      vm.helpTourSteps = [{
        element: '#user-account',
        title: $translate.instant('helptour.productionList.titles.Account Settings'),
        placement: 'left',
        content: $translate.instant('helptour.productionList.messages.Account Settings Content'),
      }, {
        element: '#production-list-my-account',
        title: $translate.instant('helptour.productionList.titles.My Account'),
        placement: 'left',
        content: $translate.instant('helptour.productionList.messages.My Account Content'),
      }, {
        element: '#production-list-subscription',
        title: $translate.instant('helptour.productionList.titles.Subscriptions'),
        placement: 'left',
        content: $translate.instant('helptour.productionList.messages.Subscriptions Content'),
      }, {
        element: '#production-list-logout',
        title: $translate.instant('helptour.productionList.titles.Logout'),
        placement: 'left',
        content: $translate.instant('helptour.productionList.messages.Logout Content'),
      }, {
        element: '#add-production',
        title: $translate.instant('helptour.productionList.titles.Add Production'),
        placement: 'right',
        content: $translate.instant('helptour.productionList.messages.Add Production Content'),
      }, {
        element: '#edit-favorites',
        title: $translate.instant('helptour.productionList.titles.Edit Favorites'),
        placement: 'right',
        content: $translate.instant('helptour.productionList.messages.Edit Favorites Content'),
      }, {
        element: '#show-trash',
        title: $translate.instant('helptour.productionList.titles.Show Trash'),
        placement: 'right',
        content: $translate.instant('helptour.productionList.messages.Show Trash Content'),
      }, {
        element: '#searchproductionname',
        title: $translate.instant('helptour.productionList.titles.Search Box'),
        placement: 'right',
        content: $translate.instant('helptour.productionList.messages.Search Box Content'),
      }, {
        element: '#production-0',
        title: $translate.instant('helptour.productionList.titles.Production'),
        placement: 'right',
        content: $translate.instant('helptour.productionList.messages.Production Content'),
      }];

      vm.helpTourVideos = [{
        label: 'Getting Started with Stage Write',
        videoUrl: 'https://www.youtube.com/embed/3k6iMC1umjw?si=gCewHy95Qk5rkSPF'
      }];
    }

    function checkInstalledFonts() {
      vm.showFontInstallHint = !(isFontAvailable('LiberationSans') && isFontAvailable('LiberationMono') && isFontAvailable('LiberationSerif'));
    }

    function installRequiredFonts() {
      $window.open('/installfonts', '_blank');
    }

    function isFontAvailable(font) {
      var testString = '~iomwIOMW';
      var containerId = 'is-font-available-container';

      var fontArray = font instanceof Array;

      if (!fontArray) {
        font = [font];
      }

      var fontAvailability = [];

      var containerSel = '#' + containerId;
      var spanSel = containerSel + ' span';

      var familySansSerif = 'sans-serif';
      var familyMonospace = 'monospace, monospace';
      // Why monospace twice? It's a bug in the Mozilla and Webkit rendering engines:
      // http://www.undermyhat.org/blog/2009/09/css-font-family-monospace-renders-inconsistently-in-firefox-and-chrome/

      // DOM:
      $('body').append('<div id="' + containerId + '"></div>');
      $(containerSel).append('<span></span>');
      $(spanSel).append(document.createTextNode(testString)); // eslint-disable-line

      // CSS:
      $(containerSel).css('visibility', 'hidden');
      $(containerSel).css('position', 'absolute');
      $(containerSel).css('left', '-9999px');
      $(containerSel).css('top', '0');
      $(containerSel).css('font-weight', 'bold');
      $(containerSel).css('font-size', '200px !important');

      jQuery.each(font, function (i, v) {
        $(spanSel).css('font-family', v + ',' + familyMonospace);
        var monospaceFallbackWidth = $(spanSel).width();
        var monospaceFallbackHeight = $(spanSel).height();

        $(spanSel).css('font-family', v + ',' + familySansSerif);
        var sansSerifFallbackWidth = $(spanSel).width();
        var sansSerifFallbackHeight = $(spanSel).height();

        fontAvailability[i] = true
          && monospaceFallbackWidth == sansSerifFallbackWidth
          && monospaceFallbackHeight == sansSerifFallbackHeight;
      });

      $(containerSel).remove();

      if (!fontArray && fontAvailability.length == 1) {
        fontAvailability = fontAvailability[0];
      }

      return fontAvailability;
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('PendingPdfRequestsController', PendingPdfRequestsController);

  PendingPdfRequestsController.$inject = [
    '$uibModalInstance',
    'swPdfPrintService',
    'toastr',
    'blockUI',
    'DbUser',
    'printJobs',
    'productions',
    '$log'
  ];

  function PendingPdfRequestsController($uibModalInstance, swPdfPrintService, toastr, blockUI, DbUser, printJobs, productions, $log) {
    var vm = this;
    var dbUser = new DbUser();

    vm.printJobs = angular.copy(printJobs);
    vm.productions = angular.copy(productions);

    vm.requesterNameCache = {};
    vm.productionNameCache = {};

    vm.refreshJobList = refreshJobList;
    vm.approveJob = approveJob;
    vm.rejectJob = rejectJob;
    vm.close = close;
    vm.$onInit = onInit;

    function onInit() {
      resolveJobDetails();
    }

    function approveJob(jobIndex) {
      approveOrRejectJob(jobIndex, true);
    }

    function rejectJob(jobIndex) {
      approveOrRejectJob(jobIndex, false);
    }

    function refreshJobList() {
      swPdfPrintService.getApprovalPendingRequests()
        .then(function (printJobs) {
          if (printJobs.length === 0) {
            toastr.info('No pending PDF jobs to approve!');
            vm.printJobs = [];
          } else {
            vm.printJobs = angular.copy(printJobs);
            resolveJobDetails();
          }
        })
        .catch(function (error) {
          $log.error('PendingPdfRequests.showPdfRequests:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error getting print jobs!'));
        });
    }

    function close() {
      $uibModalInstance.close();
    }

    function approveOrRejectJob(jobIndex, approve) {
      blockUI.start();
      var printJob = vm.printJobs[jobIndex];
      var jobId = printJob._id;
      var watermarkText = printJob.watermarkText;
      swPdfPrintService.approveOrRejectJob(jobId, approve, watermarkText)
        .then(function() {
          var printJob = _.findWhere(vm.printJobs, {_id: jobId});
          if (angular.isDefined(printJob)) {
            vm.printJobs = _.without(vm.printJobs, printJob);
          }
        })
        .catch(function (error) {
          toastr.error('There was an error approving/rejecting the print job!');
        })
        .finally(function () {
          blockUI.reset();
        });
    }

    function resolveJobDetails() {
      vm.printJobs.forEach(function(printJob) {
        swPdfPrintService.updateDisplayDetailsForJob(printJob);
        resolveRequesterName(printJob);
        resolveProductionName(printJob);
      });
    }

    function resolveRequesterName(printJob) {
      var requesterName = vm.requesterNameCache[printJob.userId];
      if (angular.isUndefined(requesterName)) {
        dbUser.getDisplayName(printJob.userId).then(
          function (displayName) {
            vm.requesterNameCache[printJob.userId] = displayName;
            printJob.requesterName = displayName;
          }
        ).catch(
          function () {
            vm.requesterNameCache[printJob.userId] = '<unknown>';
            printJob.requesterName = '<unknown>';
          }
        )
      } else {
        printJob.requesterName = requesterName;
      }
    }

    function resolveProductionName(printJob) {
      var production = _.findWhere(vm.productions, { _id: printJob.productionId });
      if (angular.isUndefined(production)) {
        printJob.productionName = '<unknown>';
      } else {
        printJob.productionName = production.name;
      }
    }
  }
}());

(function () {
  'use strict';
  angular.module('swanywhere').controller('EnterpriseExpireSwitchPromptController', EnterpriseExpireSwitchPromptController);

  EnterpriseExpireSwitchPromptController.$inject = [
    '$uibModalInstance'
  ];

  function EnterpriseExpireSwitchPromptController($uibModalInstance) {
    var vm = this;

    vm.actionYes = actionYes;
    vm.actionNo = actionNo;

    function actionYes() {
      $uibModalInstance.close();
    }

    function actionNo() {
      $uibModalInstance.dismiss('cancel');
    }
  }
}());

(function () {
  'use strict';
  angular.module('swanywhere').controller('DownloadArchivePromptController', DownloadArchivePrompt);

  DownloadArchivePrompt.$inject = [
    '$uibModalInstance',
    '$translate',
    '$window',
    '$log',
    '$timeout',
    'blockUI',
    'DbProductions',
    'swaConfig',
    'toastr',
    'production'];

  function DownloadArchivePrompt($uibModalInstance, $translate, $window, $log, $timeout, blockUI, DbProductions, swaConfig, toastr, production) {
    var vm = this;

    vm.archiveDetails = {
      created: false,
      downloadUrl: '',
      productionName: production.name,
      name: production.name,
    }
    vm.createArchive = createArchive;
    vm.downloadArchive = downloadArchive;
    vm.close = close;
    vm.$onInit = onInit;

    function onInit() {
      $timeout(function() {
        angular.element('#archivefilename').focus();
      }, 500);
    }
    
    function createArchive() {
      var archiveName = vm.archiveDetails.name;
      if (!angular.isString(archiveName) || (archiveName.trim().length === 0)) {
        toastr.error('Please provide a \'Name\' for the backup');
        angular.element('#archivefilename').focus();
        return;
      }
      var dbProductions = new DbProductions();

      blockUI.start();
      blockUI.message($translate.instant('messages.Creating backup ...'))
      var archiveParams = {
        productionId: production._id,
        name: vm.archiveDetails.name,
        note: vm.archiveDetails.note,
      };

      dbProductions.createArchive(archiveParams).then(
        function (archiveFilename) {
          vm.archiveDetails.downloadUrl = swaConfig.archiveDownloadPrefixUrl + '/' + archiveFilename + '?filename=' + encodeURIComponent(vm.archiveDetails.name);
          vm.archiveDetails.created = true;
        }
      ).catch(
        function (error) {
          $log.error('DownloadArchivePrompt.createArchive:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error creating backup!'));
        }
      ).finally(
        function () {
          blockUI.reset();
        }
      )
    }

    function downloadArchive() {
      $window.open(vm.archiveDetails.downloadUrl, '_blank');
    }

    function close() {
      $uibModalInstance.close();
    }
  }
})();

//  SWA-1948 : Created to handle the checkout session return urls navigations
// jshint maxparams: false
/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').controller('CheckoutReturnController', CheckoutReturnController);

  CheckoutReturnController.$inject = [
    '$scope',
    '$stateParams',
    'swaUtils',
    '$log',
    'DbSubMgrService',
    'ngProgressLite',
    'blockUI',
    '$translate',
    'swaRouterStateNames',
    '$sessionStorage',
    '$q',
    'toastr',
    'DbUser',
  ];

  function CheckoutReturnController($scope, $stateParams, swaUtils, $log, DbSubMgrService,
    ngProgressLite, blockUI, $translate, swaRouterStateNames, $sessionStorage, $q, toastr, DbUser) {
    var vm = this;
    var checkoutState;
    var checkoutSessionId;
    var checkoutMode;

    initialize();

    function initialize() {
      try {
        checkoutState = $stateParams.checkoutState;
        checkoutSessionId = $stateParams.checkoutSessionId;
        checkoutMode = $stateParams.checkoutMode;
        // return;
      } catch (error) {
        swaUtils.stateGoLocationReplace(swaRouterStateNames.login);
        return;
      }

      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      blockUI.start();

      DbSubMgrService.validateSession()
        .then(function (valid) {
          if (valid) {
            if (checkoutState === 'checkout_cancel') {
              var dbUser = new DbUser();
              dbUser.cancelCheckoutSession(checkoutSessionId)
                .then(function () {
                  if (checkoutMode === 'setup') {
                    // checkout mode is setup i.e for card update & pay later
                    toastr.error(
                      'Card Update operation is cancelled.',
                      $translate.instant('errormessages.Checkout Cancelled!')
                    );
                  } else {
                    // checkout mode is subscription or payment
                    toastr.error(
                      'Your subscription payment flow is cancelled.',
                      $translate.instant('errormessages.Payment cancelled!')
                    );
                  }
                  swaUtils.stateGo(swaRouterStateNames.productionlist);
                })
                .catch(function (error) {
                  swaUtils.stateGoLocationReplace(swaRouterStateNames.login);
                  return;
                });
            } else {
              if (checkoutMode === 'setup') {
                // checkout mode is setup i.e for card update & pay later
                toastr.success(
                  // Your card is updated successfully
                  $translate.instant('messages.Your card updated successfully.'),
                  $translate.instant('messages.Card Updated!')
                );
              } else {
                // checkout mode is subscription or payment
                toastr.success(
                  $translate.instant('messages.Your selected plan is now active.'),
                  $translate.instant('messages.Payment successful')
                );
              }
              swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
            }
            //
          } else {
            toastr.info(
              $translate.instant('messages.Please login to view the chart.'),
              $translate.instant('messages.No Session!')
            );
          }
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Something went wrong!')
          );
          $log.error('CheckoutReturnController.sessionCheckAndRun:', error);
        })
        .finally(function () {
          blockUI.reset();
        });
    }


  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('AddRestoreBackupProductionPromptController', AddRestoreBackupProductionPromptController);

  AddRestoreBackupProductionPromptController.$inject = [
    '$uibModalInstance',
    '$translate',
    'swaUtils',
    'toastr',
    '$scope',
    'swRestoreProductionService',
    '$window',
    'blockUI',
    '$log',
    '$q'
  ];

  function AddRestoreBackupProductionPromptController(
    $uibModalInstance,
    $translate,
    swaUtils,
    toastr,
    $scope,
    swRestoreProductionService,
    $window,
    blockUI,
    $log,
    $q
  ) {
    var vm = this;

    // state
    vm.restoreBackupState = {
      filename: undefined,
      fileArrayBuffer: undefined,
      restoreMetadata: {},
      error: false,
      errorMessage: '',
      canRestore: false
    };

    vm.processSelectedBackupFile = processSelectedBackupFile;

    // Set method declarations
    vm.restore = restore;
    vm.cancel = cancel;

    // Show validation error method
    function showValidationErrors() {
      var validationErrorMessage = '<ul>';

      if (angular.isUndefined(vm.restoreBackupState.restoreMetadata.productionName) || (angular.isDefined(vm.restoreBackupState.restoreMetadata.productionName) && !vm.restoreBackupState.restoreMetadata.productionName.trim().length)) {
        validationErrorMessage = validationErrorMessage + '<li>' + $translate.instant('validationmessages.Production Name is required');
      }

      validationErrorMessage = validationErrorMessage + '</ul>';
      toastr.warning(
        validationErrorMessage,
        $translate.instant('errormessages.Error restoring from backup!'),
        { allowHtml: true }
      );

      blockUI.reset();
    }

    // Upload the file
    function restore() {
      blockUI.start();

      // Show errors if name is empty
      if (angular.isUndefined(vm.restoreBackupState.restoreMetadata.productionName) || (angular.isDefined(vm.restoreBackupState.restoreMetadata.productionName) && !vm.restoreBackupState.restoreMetadata.productionName.trim().length)) {
        showValidationErrors();
        return;
      }

      var chunkSize = 1048576;
      var totalBytes = vm.restoreBackupState.fileArrayBuffer.byteLength;

      var chunkOffsetSizes = [];
      var lastChunkOffsetSize = {
        offset: 0,
        size: chunkSize
      }
      while (true) {
        var thisChunkSize = Math.min(chunkSize, totalBytes - lastChunkOffsetSize.offset);
        if (thisChunkSize > 0) {
          lastChunkOffsetSize.size = thisChunkSize;
          chunkOffsetSizes.push(lastChunkOffsetSize);
        } else {
          break;
        }

        lastChunkOffsetSize = {
          offset: lastChunkOffsetSize.offset + lastChunkOffsetSize.size,
          size: chunkSize
        }
      };

      var totalChunks = chunkOffsetSizes.length;

      // Initialize restore params
      var restoreParams = {
        filename: vm.restoreBackupState.filename,
        restoreMetadata: vm.restoreBackupState.restoreMetadata,
        chunkSize: chunkSize,
        totalBytes: totalBytes,
        totalchunks: totalChunks,
      };

      // Restore production api call
      swRestoreProductionService.startRestoreProduction(restoreParams)
        .then(function (jobId) {
          // Close the restore file selection popup after restore the production
          if (angular.isUndefined(jobId)) {
            throw new Error('Error creating restore job!');
          } else {
            return jobId;
          }
        })
        .then(function (jobId) {
          return chunkOffsetSizes.reduce(function (q, chunkOffsetSize, i) {
            return q.then(function () {
              var fileChunk = new Uint8Array(vm.restoreBackupState.fileArrayBuffer, chunkOffsetSize.offset, chunkOffsetSize.size);
              var chunkPayload = {
                jobId: jobId,
                chunkNumber: i,
                chunkSizeBytes: fileChunk.byteLength,
                chunkData64: _arrayBufferToBase64(fileChunk),
              }
              var uploadQ = swRestoreProductionService.uploadChunk(chunkPayload);
              uploadQ.then(function (job) {
                if (job.jobStatus === 'error') {
                  throw new Error(job.error);
                } else if (job.jobStep === 'uploading') {
                  blockUI.message('Uploading ...' + Math.round(i / totalChunks * 100) + '%');
                } else if (job.jobStep === 'uploaded') {
                  blockUI.message('Uploading ... done');
                }
              });
              return uploadQ;
            });
          }, $q.resolve());
        })
        .then(function () {
          toastr.info(
            $translate.instant('messages.Production is being restored'),
            { allowHtml: true }
          );
          cancel();
        })
        .catch(function (error) {
          $log.error('AddRestoreBackupProductionPromptController.restore:', error);
          swaUtils.showErrorToast(error, $translate.instant('errormessages.Error restoring from backup!'));
        })
        .finally(function () {
          blockUI.reset();
        });
    }

    // Cancel the modal instance
    function cancel() {
      $uibModalInstance.dismiss();
    }

    function _arrayBufferToBase64(bytes) {
      var binary = '';
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return $window.btoa(binary);
    }

    function processSelectedBackupFile(filename, arrayBuffer, error) {
      vm.restoreBackupState.canRestore = false;
      if (error) {
        vm.restoreBackupState.errorMessage = error.message;
        vm.restoreBackupState.error = true;
        return;
      }

      vm.restoreBackupState.error = false;
      vm.restoreBackupState.filename = filename;

      blockUI.start();
      getBackupMetadata(arrayBuffer)
        .then(function (metadataJsons) {
          var backupMetadata = metadataJsons[0];
          var productionData = metadataJsons[1];
          vm.restoreBackupState.restoreMetadata = {
            archiveVersion: backupMetadata[0].archiveVersion,
            created: new Date(backupMetadata[0].created),
            productionName: productionData[0].name,
            productionType: productionData[0].productiontype,
            newProductionName: productionData[0].name,
          }
          vm.restoreBackupState.errorMessage = undefined;
          vm.restoreBackupState.error = false;
          vm.restoreBackupState.canRestore = true;
          vm.restoreBackupState.fileArrayBuffer = arrayBuffer;
        })
        .catch(function (error) {
          vm.restoreBackupState.errorMessage = error.message;
          vm.restoreBackupState.error = true;
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    function getBackupMetadata(fileArrayBuffer) {
      var deferred = $q.defer();
      var zip = $window.zip;
      var fileArray = new Uint8Array(fileArrayBuffer);

      var zr = new zip.ZipReader(new zip.Uint8ArrayReader(fileArray));

      zr.getEntries()
        .catch(function (error) {
          $log.error('zip.getEntries(): error', error);
          throw new Error('Not a valid StageWrite backup file!');
        })
        .then(function (entries) {
          if (angular.isArray(entries)) {
            var metadataEntry = entries.find(function (entry) {
              return entry.filename === '__metadata__.json';
            });
            var productionsEntry = entries.find(function (entry) {
              return entry.filename === 'productions.json';
            });

            if (angular.isUndefined(metadataEntry) || angular.isUndefined(productionsEntry)) {
              throw new Error('Not a valid StageWrite backup file!');
            }

            return [metadataEntry, productionsEntry];
          } else {
            throw new Error('Not a valid StageWrite backup file!');
          }
        })
        .then(function (metadataEntries) {
          return $q.all([
            metadataEntries[0].getData(new zip.TextWriter()),
            metadataEntries[1].getData(new zip.TextWriter())
          ]);
        })
        .then(function (metadataTexts) {
          var metadataJson = angular.fromJson(metadataTexts[0]);
          var productionsJson = angular.fromJson(metadataTexts[1]);

          deferred.resolve([metadataJson, productionsJson]);
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular.module('swanywhere').controller('AddProductionPromptController', AddProductionPromptController);

  AddProductionPromptController.$inject = [
    '$uibModalInstance',
    '$timeout',
    '$translate',
    'toastr',
    '$uibModal'
  ];

  function AddProductionPromptController($uibModalInstance, $timeout, $translate, toastr, $uibModal) {
    var vm = this;

    vm.addProductionForm = {};
    vm.newProduction = {
      name: '',
      type: 1,
    };

    vm.add = add;
    vm.cancel = cancel;
    vm.promptRestoreBackupProduction = promptRestoreBackupProduction;
    vm.$onInit = onInit;

    function onInit() {
      $timeout(function() {
        angular.element('input#productionname').focus();
      }, 500);
    }

    function add() {
      if (vm.addProductionForm.$invalid) {
        showValidationErrors();
        return;
      }

      $uibModalInstance.close(vm.newProduction);
    }

    function showValidationErrors() {
      var validationErrorMessage = '<ul>';
      if (vm.addProductionForm.productionname.$error.required) {
        validationErrorMessage = validationErrorMessage + '<li>' + $translate.instant('messages.Name is required');
      }

      validationErrorMessage = validationErrorMessage + '</ul>';
      toastr.warning(
        validationErrorMessage,
        $translate.instant('errormessages.Error adding new production!'),
        {allowHtml: true}
      );
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }

    // Restore backup production prompt and handler
    function promptRestoreBackupProduction() {

      // Cancel the add new production popup
      cancel();

      // Open popup for upload new production
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/productionList/addRestoreBackupProductionPrompt.html',
        controller: 'AddRestoreBackupProductionPromptController',
        controllerAs: 'vm',
        size: '480',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
      });

      // modalInstance.result.then(
      //   function (newProduction) {
      //     addProduction(newProduction);
      //   }
      // );
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('ResetPasswordController', ResetPasswordController);

  ResetPasswordController.$inject = [
    'DbSubMgrService',
    '$stateParams',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    'DbUtility',
  ];

  function ResetPasswordController(DbSubMgrService, $stateParams, blockUI, swaUtils, swaRouterStateNames, DbUtility) {
    var vm = this;
    var resetBlockUI = blockUI.instances.get('block-ui-reset');
    var token = $stateParams.token;

    vm.swaRouterStateNames = swaRouterStateNames;

    vm.resetPasswordForm = {};
    vm.resetPasswordParams = {
      resetPending: true,
      tokenError: false,
      resetSuccess: false,
    };

    vm.validationErrors = {};

    vm.resetPassword = resetPassword;

    initialize();

    function initialize() {
      if (angular.isUndefined(token)) {
        swaUtils.stateGoLocationReplace(swaRouterStateNames.login);
      }

      angular.element('input#password').focus();
    }

    function resetPassword() {
      if (vm.resetPasswordForm.$invalid) {
        return;
      }

      var dbUtility = new DbUtility();
      var newPassword = vm.resetPasswordParams.newPassword;

      resetBlockUI.start();
      DbSubMgrService.checkConnection().then(
        function () {
          return dbUtility.resetPasswordWithToken(token, newPassword);
        }
      ).then(
        function () {
          vm.resetPasswordParams.resetPending = false;
          vm.resetPasswordParams.resetSuccess = true;
        }
      ).catch(
        function (error) {
          vm.resetPasswordForm.$setPristine();
          vm.resetPasswordForm.$setUntouched();
          if (error.errorType === 'Meteor.Error') {
            if (error.reason === 'Token expired') {
              vm.resetPasswordParams.resetPending = false;
              vm.resetPasswordParams.tokenError = true;
            } else {
              vm.validationErrors.serverErrorMessage = error.reason;
              vm.validationErrors.serverError = true;
            }
          } else {
            vm.validationErrors.serverErrorMessage = error.message;
            vm.validationErrors.serverError = true;

          }
        }
      ).finally(
        function () {
          resetBlockUI.stop();
        }
      );
    }
  }
}());

(function() {
  'use strict';

  angular.module('swanywhere').controller('RegistrationController', RegistrationController);

  RegistrationController.$inject = [
    '$scope',
    'DbSubMgrService',
    'blockUI',
    '$uibModal',
    '$timeout',
    'swaUtils',
    'swaRouterStateNames',
    'swaConfig',
    'DbUser',
    'DbUtility',
    'toastr',
    '$translate',
  ];

  function RegistrationController($scope, DbSubMgrService, blockUI, $uibModal, $timeout, swaUtils, swaRouterStateNames, swaConfig, DbUser, DbUtility, toastr, $translate) {
    var vm = this;
    var dbUser = new DbUser();
    var regBlockUI = blockUI.instances.get('block-ui-reg');

    vm.swaRouterStateNames = swaRouterStateNames;

    vm.registrationForm = {};
    vm.registrationParams = {};
    vm.validationErrors = {};
    vm.noCaptchaControl = {};

    vm.captchaExpiredHandler = captchaExpiredHandler;
    vm.createUser = createUser;
    vm.showTermsOfServices = showTermsOfServices;
    vm.showPrivacyPolicy = showPrivacyPolicy;

    initialize();

    function initialize() {
      blockUI.reset();
      if (!swaConfig.registrationInviteOnly) {
        regBlockUI.start();
        waitForCaptchaInit();
      }

      angular.element('input#firstname').focus();
    }

    function waitForCaptchaInit() {
      var captchaLoadTimeout = $timeout(function() {
        regBlockUI.stop();
        if (!angular.isFunction(vm.noCaptchaControl.reset)) {
          vm.validationErrors.recaptchaLoadError = true;
        }
      }, 10000);

      var unWatchCaptchaControl = $scope.$watch(function() {
        return vm.noCaptchaControl.reset;
      }, function(newValue, oldValue) {
        if ((newValue !== oldValue) && angular.isFunction(newValue)) {
          regBlockUI.stop();
          unWatchCaptchaControl();
          $timeout.cancel(captchaLoadTimeout);
        }
      });
    }

    function captchaExpiredHandler() {
      vm.registrationParams.gRecaptchaResponse = undefined;
      vm.registrationForm.reCaptchaResponse.$setViewValue(vm.registrationParams.gRecaptchaResponse);
    }

    function createUser() {
      if (vm.registrationForm.$invalid) {
        return;
      }

      if (vm.registrationParams.gRecaptchaResponse.length <= 0) {
        vm.noCaptchaControl.reset();
        vm.registrationForm.reCaptchaResponse.$setViewValue(vm.registrationParams.gRecaptchaResponse);
        vm.registrationForm.reCaptchaResponse.$setUntouched();
        return;
      }

      var firstName = vm.registrationParams.firstName;
      var lastName = vm.registrationParams.lastName;
      var email = vm.registrationParams.email;
      var password = vm.registrationParams.password;
      var dbUtility = new DbUtility();

      regBlockUI.start();
      DbSubMgrService.checkConnection().then(function() {
        return dbUser.existsWithEmail(email);
      }).then(function(exists) {
        if (exists) {
          vm.registrationForm.email.$setPristine();
          vm.registrationForm.email.$setUntouched();
          vm.validationErrors.emailAlreadyUsed = true;

          var err = new Error('validationFail-email-unique');
          err.validationFail = 'email-unique';
          throw err;
        }
      }).then(function() {
        return dbUtility.verifyCaptcha(vm.registrationParams.gRecaptchaResponse);
      }).then(function(success) {
        if (!success) {
          vm.noCaptchaControl.reset();
          vm.registrationForm.reCaptchaResponse.$setViewValue(vm.registrationParams.gRecaptchaResponse);
          vm.registrationForm.reCaptchaResponse.$setUntouched();
          vm.validationErrors.recaptchaVerificationFailed = true;

          var err = new Error('validationFail-captcha');
          err.validationFail = 'captcha';
          throw err;
        }
      }).then(function() {
        var profile = {
          firstName: firstName,
          lastName: lastName,
        };

        return dbUser.createUser(email, password, profile);
      }).then(function() {
        toastr.success(
          $translate.instant('messages.Logging in'),
          $translate.instant('titles.Account Created')
        );
        return $timeout(function() {
          var params = {
            redirectreason: 'post-registration',
          };
    
          swaUtils.stateGoLocationReplace(swaRouterStateNames.productionlist, params);
        }, 3000);
      }).catch(function(error) {
        vm.registrationForm.$setPristine();
        vm.registrationForm.$setUntouched();
        if (angular.isUndefined(error.validationFail)) {
          vm.validationErrors.serverError = true;
          if (error.error === 'captcha-verify-call-error') {
            vm.validationErrors.serverErrorMessage = 'Could not verify captcha, the service may be unavailable';
          } else {
            if (angular.isDefined(error.reason)) {
              vm.validationErrors.serverErrorMessage = error.reason;
            } else {
              vm.validationErrors.serverErrorMessage = error.message;
            }
          }
        }
      }).finally(function() {
        regBlockUI.stop();
      });
    }

    function showTermsOfServices() {
      $uibModal.open({
        animation: true,
        templateUrl: 'termsofservicesModal.html',
        controller: 'TosPrivacyModalController',
        controllerAs: 'vm',
        size: 'lg',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static'
      });
    }

    function showPrivacyPolicy() {
      $uibModal.open({
        animation: true,
        templateUrl: 'privacypolicyModal.html',
        controller: 'TosPrivacyModalController',
        controllerAs: 'vm',
        size: 'lg',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static'
      });
    }
  }
}());

/**
* Modal controller for 'Terms and Services' and 'Privacy Policy' prompt
*/
(function() {
  'use strict';
  angular.module('swanywhere').controller('TosPrivacyModalController', TosPrivacyModalController);

  TosPrivacyModalController.$inject = ['$uibModalInstance'];

  function TosPrivacyModalController($uibModalInstance) {
    var vm = this;

    vm.okAction = okAction;

    function okAction() {
      $uibModalInstance.dismiss('ok');
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('LoginController', LoginController);

  LoginController.$inject = [
    '$stateParams',
    '$interval',
    'DbSubMgrService',
    'blockUI',
    'swaUtils',
    'swaRouterStateNames',
    'toastr',
    '$translate',
    '$timeout',
    '$uibModal'
  ];

  function LoginController($stateParams, $interval, DbSubMgrService, blockUI, swaUtils, swaRouterStateNames, toastr, $translate, $timeout, $uibModal) {
    var vm = this;
    var ceres = DbSubMgrService.getAsteroid();
    var loginBlockUI = blockUI.instances.get('block-ui-login');

    vm.swaRouterStateNames = swaRouterStateNames;

    vm.loginParams = {};
    vm.validationErrors = {};

    vm.focusNext = focusNext;
    vm.login = login;

    initialize();

    function initialize() {
      var redirectReason = $stateParams.redirectreason;
      if ((angular.isUndefined(redirectReason)) || (redirectReason === 'none')) {
        blockUI.reset();
        loginBlockUI.start();
        DbSubMgrService.validateSession(false)
          .then(function () {
            swaUtils.stateGoLocationReplace(swaRouterStateNames.productionlist);
          })
          .catch(function () {
            delayedFocusUsername();
          })
          .finally(function () {
            loginBlockUI.stop();
          });
      } else if (redirectReason === 'logout') {
        blockUI.reset();
        loginBlockUI.start('Logging out ...');
        ceres.logout();
        var to1 = $interval(function () {
          if (angular.isUndefined(DbSubMgrService.getLoggedInUserId())) {
            $interval.cancel(to1);
          }
        }, 1000, 5);

        to1.finally(
          function () {
            loginBlockUI.stop();
            delayedFocusUsername();
          }
        );
      } else if (redirectReason === 'server-logout') {
        ceres.logout();
        blockUI.reset();
        toastr.clear();
        toastr.error(
          $translate.instant('messages.Your session has expired or you have logged in from a different browser.'),
          $translate.instant('titles.Session Expired!')
        );
        delayedFocusUsername();
      } else if (redirectReason === 'unauthorized') {
        ceres.logout();
        blockUI.reset();
        toastr.clear();
        toastr.error(
          $translate.instant('messages.You are not authorized to access this site.'),
          $translate.instant('titles.Unauthorized!')
        );
        delayedFocusUsername();
      } else {
        blockUI.reset();
        delayedFocusUsername();
      }
    }

    function delayedFocusUsername() {
      $timeout(function () {
        angular.element('#username').focus();
      }, 500);

    }
    function focusNext(id) {
      angular.element('#' + id).focus();
    }

    function login(form) {
      if (form.$invalid) {
        return;
      }

      toastr.clear();

      // clear out any old validation errors
      vm.validationErrors = {};

      var username = vm.loginParams.username;
      var password = vm.loginParams.password;

      loginBlockUI.start();
      DbSubMgrService.checkConnection()
        .then(function () {
          return ceres.loginWithPassword(username, password);
        })
        .then(function () {
          swaUtils.stateGoLocationReplace(swaRouterStateNames.productionlist);
        })
        .catch(function (error) {
          form.$setPristine();
          form.$setUntouched();
          if ((error.error === 403) && ((error.reason === 'Incorrect password') || (error.reason === 'User not found'))) {
            vm.validationErrors.authenticationError = true;
          } else {
            vm.validationErrors.serverError = true;
            vm.validationErrors.serverErrorMessage = swaUtils.getSanitizedErrorMessage(error);
          }
        }).
        finally(function () {
          loginBlockUI.stop();
        });
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('ForgotPasswordController', ForgotPasswordController);

  ForgotPasswordController.$inject = [
    'DbSubMgrService',
    '$log',
    'swaConfig',
    'blockUI',
    'swaRouterStateNames',
    'DbUtility',
    '$stateParams',
  ];

  function ForgotPasswordController(DbSubMgrService, $log, swaConfig, blockUI, swaRouterStateNames, DbUtility, $stateParams) {
    var vm = this;

    var forgotpasswordBlockUI = blockUI.instances.get('block-ui-forgotpassword');

    vm.swaRouterStateNames = swaRouterStateNames;

    vm.forgotPasswordParams = {
      email: '',
      emailSent: false,
    };

    vm.validationErrors = {};

    vm.resetMyPassword = resetMyPassword;

    vm.embedded = ($stateParams.embedded === 'embedded');
    
    blockUI.reset();
    angular.element('input#email').focus();

    function resetMyPassword(form) {
      if (form.$invalid) {
        return;
      }

      var dbUtility = new DbUtility();

      vm.validationErrors = {};

      forgotpasswordBlockUI.start();
      DbSubMgrService.checkConnection().then(
        function () {
          var email = vm.forgotPasswordParams.email;
          var urlPrefix = swaConfig.clientUrl + '/#/resetpassword/';

          return dbUtility.requestPasswordReset(email, urlPrefix);
        }
      ).then(
        function () {
          vm.forgotPasswordParams.emailSent = true;
        }
      ).catch(
        function (error) {
          form.$setPristine();
          form.$setUntouched();
          if (error.errorType === 'Meteor.Error') {
            if (error.error === 'no-such-user') {
              vm.validationErrors.emailUnknown = true;
            } else {
              vm.validationErrors.serverErrorMessage = error.reason;
              vm.validationErrors.serverError = true;
            }
          } else {
            vm.validationErrors.serverErrorMessage = error.message;
            vm.validationErrors.serverError = true;
          }
        }
      ).finally(
        function () {
          forgotpasswordBlockUI.stop();
        }
      );
    }
  }
}());

(function () {
  'use strict';
  angular.module('swanywhere').controller('CollaboratorListController', CollaboratorListController);

  CollaboratorListController.$inject = [
    '$scope',
    '$uibModalInstance',
    'DbUser',
    'collaboratorData',
    '$log',
    '$state',
    'swaRouterStateNames',
  ];

  function CollaboratorListController($scope, $uibModalInstance, DbUser, collaboratorData, $log, $state, swaRouterStateNames) {
    var vm = this;
    var dbUser = new DbUser();

    vm.userIsProductionOwner = false;

    vm.collaboratorData = collaboratorData;
    vm.editCollaborators = editCollaborators;
    vm.modalClose = modalClose;

    initialize();

    function initialize() {

      vm.collaboratorData.forEach(function (data) {
        vm.userIsProductionOwner = vm.userIsProductionOwner || (data.isOwner && data.isCurrentUser);
        if (angular.isDefined(data.id)) {
          dbUser.getDisplayName(data.id).then(
            function (displayName) {
              if (angular.isDefined(displayName)) {
                data.displayName = displayName;
              } else {
                data.displayName = '<unknown>';
                data.displayNameError = true;
              }
            },

            function (error) {
              $log.error(error);
              data.displayName = '<unknown>';
              data.displayNameError = true;
            }
          );
        } else if (angular.isDefined(data.email)) {
          data.displayName = data.email;
          dbUser.getDisplayName(data.email).then(
            function (displayName) {
              if (angular.isDefined(displayName)) {
                data.displayName = displayName;
              }
            },

            function (error) {
              $log.error(error);
            }
          );
        } else {
          data.displayName = '<unknown>';
          data.displayNameError = true;
        }
      });
    }

    function editCollaborators() {
      $uibModalInstance.dismiss();
      $state.go(swaRouterStateNames.productionsettings.collaborators)
    }

    function modalClose() {
      $uibModalInstance.dismiss();
    }
  }
}());

(function () {
  'use strict';
  angular.module('swanywhere').controller('ChartVideoController', ChartVideoController);

  ChartVideoController.$inject = [
    '$uibModalInstance',
    '$sce',
    'videoDetails'
  ];

  function ChartVideoController($uibModalInstance, $sce, videoDetails) {
    var vm = this;

    vm.videoDetails = videoDetails;
    vm.embedUrl = '';
    
    vm.modalClose = modalClose;

    initialize();

    function initialize() {
      if (angular.isDefined(vm.videoDetails)) {
        vm.embedUrl = $sce.trustAsResourceUrl('https://www.youtube.com/embed/' + vm.videoDetails.videoId + '?rel=0&showinfo=0');
      }
    }

    function modalClose() {
      $uibModalInstance.dismiss();
    }
  }
}());

// jshint maxparams: false
/* global Q, cc, selectStaffById, scrollToStaffContainer, loadStaffContent, _ */
(function () {
  'use strict';

  angular.module('swanywhere').controller('ChartStaffController', ChartStaffController);

  ChartStaffController.$inject = [
    '$scope',
    '$cookies',
    '$stateParams',
    'toastr',
    'DbCharts',
    'DbScenes',
    'DbProductions',
    '$log',
    'DbSubMgrService',
    'DbStaffs',
    'blockUI',
    'ngProgressLite',
    'staffTemplatesService',
    'DbPerformers',
    '$timeout',
    '$translate',
    '$filter',
    'swaUtils',
    'swaRouterStateNames',
    'DbCollaborationPrivileges',
    'swaAccess',
    '$document',
    'swPdfPrintService',
    '$q',
    '$localStorage',
    '$window',
    '$uibModal',
  ];

  function ChartStaffController($scope, $cookies, $stateParams, toastr, DbCharts,
    DbScenes, DbProductions, $log, DbSubMgrService, DbStaffs, blockUI, ngProgressLite,
    staffTemplatesService, DbPerformers, $timeout, $translate, $filter, swaUtils, swaRouterStateNames,
    DbCollaborationPrivileges, swaAccess, $document, swPdfPrintService, $q, $localStorage, $window, $uibModal) {

    var vm = this;
    var selectedProductionId;

    var dbProductions = new DbProductions();
    var dbPerformers = new DbPerformers();
    var dbScenes = new DbScenes();
    var dbCharts = new DbCharts();
    var dbStaffs = new DbStaffs();
    var dbCollaborationPrivileges = new DbCollaborationPrivileges();

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowchartstafflinking: false,
      allowchartstaffunlinking: false,
    };

    var defaultViewAccessRules = angular.copy(defaultDenyAccessRules);

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowchartstafflinking: true,
      allowchartstaffunlinking: true,
    };

    vm.userData = {};
    vm.userId = '';

    vm.swaRouterStateNames = swaRouterStateNames;

    vm.showHelpBar = false;
    vm.helpTourSteps = [];

    vm.selectedProduction = {};
    vm.performers = [];
    vm.staffs = [];
    vm.scenes = [];

    vm.performerFilterEnabled = false;

    // selected scene
    vm.selectedSceneId = undefined;
    vm.selectedScene = undefined;

    vm.chartStaffEditorState = {
      showingStaffContent: false,
      chartNumberAutomatic: false,
      staffAutoFitWidth: false,
      staffViewScale: 1,
    };

    vm.chartIdToChartNameCache = {};

    vm.newChartLinkTracker = {
      showTarget: false,
    };

    vm.scrollConfigSidebar = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
      callbacks: {
        whileScrolling: updateStickySceneHeader,
        onScroll: updateStickySceneHeader,
      }
    };

    vm.scrollConfigContent = {
      theme: 'dark',
      axis: 'yx',
      scrollbarPosition: 'inside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
      },
      autoHideScrollbar: false,
      advanced: {
        updateOnContentResize: true,
      },
    };

    vm.droppableConfig = {
      multiple: false,
      onDrop: 'onDropLinkTarget()',
    };

    vm.zoomPicker = {};

    vm.toggleScene = toggleScene;
    vm.onDragStart = onDragStart;
    vm.onDragDrag = onDragDrag;
    vm.onDragStop = onDragStop;
    vm.onDropLinkTarget = onDropLinkTarget;
    vm.switchEditor = switchEditor;
    vm.getStaffTemplateForStaffType = getStaffTemplateForStaffType;
    vm.printPdf = printPdf;
    vm.setStaffAutoFitWidth = setStaffAutoFitWidth;

    vm.toggleLockModeNavigation = toggleLockModeNavigation;
    vm.lockNavigationPreviousScene = lockNavigationPreviousScene;
    vm.lockNavigationPreviousStaff = lockNavigationPreviousStaff;
    vm.lockNavigationNextStaff = lockNavigationNextStaff;
    vm.lockNavigationNextScene = lockNavigationNextScene;

    vm.pdfPrintOptionPrompt = pdfPrintOptionPrompt;

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedScenes: false,
      allowedNumberOfScenes: 0,
      allowUnlimitedCharts: false,
      allowedNumberOfCharts: 0,
      allowUnlimitedStaffs: false,
      allowedNumberOfStaffs: 0,
    };

    vm.PdfPrintTypes = swPdfPrintService.PdfPrintTypes;

    initialize();

    function initialize() {
      $cookies.put('currentEditorStateName', swaUtils.getRouterCurrentStateName());

      $('#staffscrollview').on('click', 'span.buttonunlinkchart', unlinkChartFromStaff);

      vm.chartStaffEditorPreferences = $localStorage.$default({
        staffAutoFitWidth: vm.chartStaffEditorState.staffAutoFitWidth,
      });

      sessionCheckAndRun();
      registerKeyboardHandler();
      registerResizeHandler();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();
      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        })
        .then(function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        })
        .then(function (plan) {
          updateActivePlanRules(plan);
        })
        .then(function () {
          return getAllData();
        })
        .then(function () {
          loadEditorPreferences();
          initHelpTour();
        })
        .then(function () {
          if (angular.isDefined($stateParams.selectedScene)) {
            var sceneToOpen = vm.scenes.find(function (scene) { return (scene._id === $stateParams.selectedScene._id) })
            return toggleScene(sceneToOpen);
          }
        })
        .then(function () {
          if ($stateParams.lockModeNavigation === true) {
            toggleLockModeNavigation();
          }
        })
        .then(null, null, function (progress) {
          ngProgressLite.set(progress);
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function getAllData() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId)
        .then(function (production) {
          deferred.notify(0.33);
          updateDataProduction(production);
        })
        .then(function () {
          return dbPerformers.findInProduction(selectedProductionId);
        })
        .then(function (performers) {
          deferred.notify(0.66);
          updateDataPerformers(performers);
        })
        .then(function () {
          return dbScenes.fetchAllInProduction(selectedProductionId, updateDataScenes);
        })
        .then(function () {
          $cookies.put('selectedProductionId', selectedProductionId);
          deferred.notify(1.0);
        })
        .catch(function (error) {
          deferred.reject(error);
        })
        .finally(function () {
          deferred.resolve();
        });

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;

      if (plan.planid === 2) {
        vm.newChartLinkTracker.enableLinking = false;
      } else {
        vm.newChartLinkTracker.enableLinking = true;
      }

      vm.activePlanRules.allowUnlimitedScenes = plan.planfeatures[3].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedScenes) {
        vm.activePlanRules.allowedNumberOfScenes = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfScenes = plan.planfeatures[3].featurevalue;
      }

      vm.activePlanRules.allowUnlimitedCharts = plan.planfeatures[4].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedCharts) {
        vm.activePlanRules.allowedNumberOfCharts = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfCharts = plan.planfeatures[4].featurevalue;
      }

      vm.activePlanRules.allowUnlimitedStaffs = plan.planfeatures[5].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedStaffs) {
        vm.activePlanRules.allowedNumberOfStaffs = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfStaffs = plan.planfeatures[5].featurevalue;
      }
    }

    function updateDataProduction(production) {
      vm.selectedProduction = production;

      if (angular.isUndefined(vm.selectedProduction) || (parseInt(vm.selectedProduction.productiontype) !== 0)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error('Invalid state');
      }

      if (vm.selectedProduction.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(vm.selectedProduction.collaboratorIds) && (vm.selectedProduction.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = vm.selectedProduction.collaborationsettings.find(function (element) {
            return (element.collaboratorId === vm.userId);
          });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error(
            $translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          throw new Error('Invalid state');
        }
      }

      DbSubMgrService.setSelectedProduction(vm.selectedProduction);

      try {
        staffTemplatesService.setProduction(vm.selectedProduction);
      } catch (e) {
        toastr.error(
          e.message,
          $translate.instant('errormessages.Error loading score templates!')
        );
      }

      vm.staffTemplates = angular.copy(vm.selectedProduction.stafftemplates);

      vm.chartStaffEditorState.chartNumberAutomatic = (vm.selectedProduction.chartsettings.chartnumberautomatic === true);

      setupPdfPrintService();
    }

    function setupPdfPrintService() {
      swPdfPrintService.setSelectedProduction(vm.selectedProduction);
      vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
      vm.onPrintJobsChange = onPrintJobsChange;
      swPdfPrintService.registerForChange(vm);
    }

    function onPrintJobsChange(change, id, job) {
      vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
    }

    function pdfPrintOptionPrompt(type) {
      if (type === vm.PdfPrintTypes.CurrentStaff || type === vm.PdfPrintTypes.CurrentSceneStaffs || type === vm.PdfPrintTypes.AllStaffs) {
        var params = {
          type: type,
        }
        printPdf(params);
      } else {
        vm.pdfOptionsPicker.show = false;
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/chartEditor/pdfPrintOptionPrompt.html',
          controller: 'PdfPrintOptionPromptController',
          controllerAs: 'vm',
          size: '600',
          windowClass: 'sw-modal',
          backdropClass: 'sw-modal-backdrop',
          resolve: {
            params: {
              type: type,
            }
          }
        });
        modalInstance.result
          .then(function (params) {
            printPdf(params);
          });
      }
    }

    function printPdf(parameters) {
      var type = parameters.type;
      vm.pdfOptionsPicker.show = false;

      var params = {};
      params.productionId = selectedProductionId;
      params.optionalIds = {};
      params.options = {};
      params.type = type;
      params.notesPrintOption = parameters.chartNotes;
      params.scaleAllPerformersPrintOption = parameters.scaleAllPerformers;
      params.scaleSelectedPerformersPrintOption = parameters.scaleSelectedPerformers;
      params.sharedLayerAnnotationsPrintOption = parameters.sharedLayerAnnotations;

      if ((type === vm.PdfPrintTypes.CurrentSceneChartsStaffs) || (type === vm.PdfPrintTypes.CurrentSceneCharts) || (type === vm.PdfPrintTypes.CurrentSceneStaffs)) {
        params.optionalIds.sceneId = vm.selectedSceneId;
      }

      params.options.printChartPersonalNotes = getPrintChartPersonalNotes();

      swPdfPrintService.printPdf(params).then(
        function (printJob) {
          if (angular.isDefined(printJob.approvingUserId)) {
            toastr.info(
              $translate.instant('messages.PDF waiting for approval'),
              $translate.instant('messages.Approval Needed!')
            );
          } else {
            toastr.info(
              $translate.instant('messages.Requested PDF is being created')
            );
          }
        },
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error creating PDF!')
          );
        }
      );
    }

    function getPrintChartPersonalNotes() {
      return (!vm.activeCollaborationConfig.isProductionOwner && (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited)) ||
        (vm.activePlanRules.planId === 2);
    }

    function updateDataPerformers(performers) {
      vm.performers = angular.copy(performers);
    }

    function updateDataScenes(id) {
      if (angular.isUndefined(id)) {
        vm.scenes = dbScenes.getFetched(true);
        updateSceneCollaborationAccessRules(vm.scenes)
          .then(function () {
            updateActiveAccessRules();
          });
      } else {
        var existingScene = swaUtils.findInArrayById(vm.scenes, id);
        var incomingScene = dbScenes.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingScene) && swaUtils.isUndefinedOrNull(incomingScene));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));

        if (isInsert) {
          updateSceneCollaborationAccessRules([incomingScene]);
          vm.scenes.push(incomingScene);
          swaUtils.sortArrayByNumericKey(vm.scenes, 'orderingindex');
        } else if (isDelete) {
          toastr.warning($translate.instant('messages.Scene deleted elsewhere.'), $translate.instant(
            'messages.Sync warning!'));
          if (existingScene === vm.selectedScene) {
            toggleScene();
          }

          var existingSceneIndex = vm.scenes.indexOf(existingScene);
          if (existingSceneIndex !== -1) {
            vm.scenes.splice(existingSceneIndex, 1);
          }
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming scene update with ID: ' + id);
          angular.extend(existingScene, incomingScene);
        }
      }
    }

    function updateDataCharts(filter, id) {
      if (angular.isUndefined(vm.selectedScene)) {
        return;
      }

      if (filter) {
        if (filter.sceneId !== vm.selectedScene._id) {
          return;
        }
      }

      if (angular.isUndefined(id)) {
        vm.selectedScene.charts = dbCharts.getFetched(true);
        vm.selectedScene.noCharts = !(angular.isArray(vm.selectedScene.charts) && (vm.selectedScene.charts.length > 0));

        // vm.showingChartContent = !vm.selectedScene.nocharts;
      } else {
        vm.selectedScene.charts = vm.selectedScene.charts || [];

        var existingChart = swaUtils.findInArrayById(vm.selectedScene.charts, id);
        var incomingChart = dbCharts.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingChart) && !swaUtils.isUndefinedOrNull(incomingChart));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingChart) && swaUtils.isUndefinedOrNull(incomingChart));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingChart) && !swaUtils.isUndefinedOrNull(incomingChart));
        if (isInsert) {
          // incoming insert
          $log.debug('incoming chart insert with ID: ', id);

          vm.selectedScene.charts.push(incomingChart);
          swaUtils.sortArrayByNumericKey(vm.selectedScene.charts, 'orderingindex');
          vm.selectedScene.noCharts = !(angular.isArray(vm.selectedScene.charts) && (vm.selectedScene.charts.length > 0));
        } else if (isDelete) {
          // incoming delete
          $log.debug('incoming chart delete with ID: ' + id);

          var existingChartIndex = vm.selectedScene.charts.indexOf(existingChart);
          if (existingChartIndex !== -1) {
            vm.selectedScene.charts.splice(existingChartIndex, 1);
          }

          vm.selectedScene.noCharts = !(angular.isArray(vm.selectedScene.charts) && (vm.selectedScene.charts.length > 0));
        } else {
          // incoming change/update
          $log.debug('incoming chart update with ID: ' + id);

          var needsReordering = (existingChart.orderingindex !== incomingChart.orderingindex);

          angular.extend(existingChart, incomingChart);

          if (needsReordering) {
            swaUtils.sortArrayByNumericKey(vm.selectedScene.charts, 'orderingindex');
          }
        }
      }
    }

    function updateDataStaff(filter, id) {
      if (angular.isUndefined(vm.selectedScene)) {
        return;
      }

      if (filter) {
        if (filter.sceneId !== vm.selectedScene._id) {
          return;
        }
      }

      if (angular.isUndefined(id)) {
        vm.selectedScene.staffs = dbStaffs.getFetched(true);
        vm.selectedScene.nostaffs = !(angular.isArray(vm.selectedScene.staffs) && (vm.selectedScene.staffs.length > 0));

        vm.chartStaffEditorState.showingStaffContent = !vm.selectedScene.nostaffs;

        if (!vm.selectedScene.nostaffs) {
          loadStaffGrids();
        }
      } else {
        vm.selectedScene.staffs = vm.selectedScene.staffs || [];

        var existingStaff = swaUtils.findInArrayById(vm.selectedScene.staffs, id);
        var incomingStaff = dbStaffs.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingStaff) && !swaUtils.isUndefinedOrNull(incomingStaff));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingStaff) && swaUtils.isUndefinedOrNull(incomingStaff));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingStaff) && !swaUtils.isUndefinedOrNull(incomingStaff));

        var staffScrollViewElement = $('#staffscrollview');
        var staffContainerElement;
        var prevElement;

        if (isInsert) {
          // incoming insert
          vm.selectedScene.staffs.push(incomingStaff);
          swaUtils.sortArrayByNumericKey(vm.selectedScene.staffs, 'orderingindex');
          vm.selectedScene.nostaffs = !(angular.isArray(vm.selectedScene.staffs) && (vm.selectedScene.staffs.length > 0));

          vm.chartStaffEditorState.showingStaffContent = !vm.selectedScene.nostaffs;

          // This ia a new staff
          postProcessStaffTitle(incomingStaff);
          postProcessStaffData(incomingStaff);
          var loadedStaffContainerElement = loadedStaffContainerForStaff(incomingStaff);

          var staffOrderingIndex = incomingStaff.orderingindex;
          if (staffOrderingIndex === 0) {
            staffScrollViewElement.prepend(loadedStaffContainerElement);
          } else {
            prevElement = staffScrollViewElement.children('div.staffcontainer[data-orderingindex="' + (
              staffOrderingIndex - 1) + '"]').first();
            if (prevElement) {
              prevElement.after(loadedStaffContainerElement);
            } else {
              staffScrollViewElement.prepend(loadedStaffContainerElement);
            }
          }

          selectStaffById(incomingStaff._id);
          scrollToStaffContainer(vm);
        } else if (isDelete) {
          // incoming delete

          var existingStaffIndex = vm.selectedScene.staffs.indexOf(existingStaff);
          if (existingStaffIndex !== -1) {
            vm.selectedScene.staffs.splice(existingStaffIndex, 1);
          }

          vm.selectedScene.nostaffs = !(angular.isArray(vm.selectedScene.staffs) && (vm.selectedScene.staffs.length > 0));

          vm.chartStaffEditorState.showingStaffContent = !vm.selectedScene.nostaffs;

          // Staff has gotten deleted
          staffContainerElement = staffScrollViewElement.children('div[data-staffid="' + existingStaff._id + '"]');
          staffContainerElement.remove();

        } else if (isUpdate) {
          // incoming change/update
          existingStaff.linkedchartId = incomingStaff.linkedchartId;

          staffContainerElement = staffScrollViewElement.children('div[data-staffid="' + existingStaff._id + '"]');
          updateChartLink(existingStaff, staffContainerElement);
        }
      }
    }

    function toggleScene(scene) {
      var deferred = $q.defer();

      $q.when()
        .then(function () {
          // close currently open scene
          if (angular.isDefined(vm.selectedScene)) {
            clearStaffsContainer();
            vm.selectedScene.charts = [];
            vm.selectedScene.staffs = [];
            vm.selectedScene.open = false;
            vm.selectedScene.selected = false;
          }
        })
        .then(function () {
          if (vm.selectedScene !== scene) {
            ngProgressLite.start();
            blockUI.start();
            vm.selectedScene = scene;
            vm.selectedSceneId = scene._id;
            vm.selectedScene.selected = true;
            vm.selectedScene.open = true;
            updateActiveAccessRules();
            var q1 = dbCharts.fetchForScene(scene._id, updateDataCharts);
            var q2 = dbStaffs.fetchForScene(scene._id, updateDataStaff);
            return $q.all([q1, q2]);
          } else {
            vm.selectedScene = undefined;
            vm.selectedSceneId = undefined;

            vm.chartStaffEditorState.showingStaffContent = false;
          }
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('StaffEditorController.toggleScene:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error loading charts/staffs!')
          );
        })
        .finally(function () {
          updateStickySceneHeader();
          ngProgressLite.done();
          blockUI.stop();
        });

      return deferred.promise;
    }

    function updateStickySceneHeader() {
      $scope.$applyAsync(function () {
        if (vm.selectedScene && vm.selectedScene.open) {
          var sceneGroup = $('#scene-group-' + vm.selectedScene.orderingindex);
          var groupOffsetTop = sceneGroup.offset().top;
          var groupHeight = sceneGroup.outerHeight();
          if ((groupOffsetTop < 106) && ((groupHeight + groupOffsetTop) > 148)) {
            vm.sceneSticky = true;
          } else {
            vm.sceneSticky = false;
          }
        } else {
          vm.sceneSticky = false;
        }
      });
    }

    function loadStaffGrids() {
      clearStaffsContainer();

      if (swaUtils.isUndefinedOrNull(vm.selectedScene)) {
        return;
      }

      var staffScrollViewElement = $('#staffscrollview');

      var noOfStaffsToLoad = Math.min(vm.selectedScene.staffs.length, vm.activePlanRules.allowedNumberOfStaffs);
      for (var i = 0; i < noOfStaffsToLoad; i++) {
        var staff = vm.selectedScene.staffs[i];

        postProcessStaffTitle(staff);
        postProcessStaffData(staff);

        var loadedStaffContainerElement = loadedStaffContainerForStaff(staff);

        staffScrollViewElement.append(loadedStaffContainerElement);
      }

      updateStaffViewZoom();
    }

    function loadedStaffContainerForStaff(staff) {
      var staffTemplate = staffTemplateForStaff(staff);
      var staffContainerElement = newStaffContainerForStaff(staff);

      if (angular.isDefined(staffTemplate)) {
        staffContainerElement.append(staffTemplate);

        // load content
        loadStaffContent(vm, staff, staffContainerElement);

        updateChartLink(staff, staffContainerElement);
      } else {
        $log.warn('Missing template for staffId:', staff._id);

        staffContainerElement.append('Error loading staff, missing template!');
      }

      return staffContainerElement;
    }

    function setStaffAutoFitWidth(autoFit) {
      vm.chartStaffEditorState.staffAutoFitWidth = autoFit;

      updateStaffViewZoom();

      vm.zoomPicker.show = false;

      saveEditorPreferences();
    }

    function updateStaffViewZoom() {
      if (vm.chartStaffEditorState.staffAutoFitWidth) {
        var scale = $('.staffscrollview').outerWidth() / 1000;
        $('.staffscrollview').css('transform', 'scale(' + scale + ')');
        vm.staffViewScale = scale;
      } else {
        $('.staffscrollview').css('transform', '');
        vm.staffViewScale = 1;
      }
    }

    var staffViewResizeTimer;
    function docOnResize() {
      if (angular.isDefined(staffViewResizeTimer)) {
        $timeout.cancel(staffViewResizeTimer);
        staffViewResizeTimer = undefined;
      } else {
        vm.chartStaffEditorState.resizing = true;
        // chartBlockUI.start();
      }

      staffViewResizeTimer = $timeout(function () {
        updateStaffViewZoom();

        vm.chartStaffEditorState.resizing = false;
        // chartBlockUI.stop();
        $timeout.cancel(staffViewResizeTimer);
        staffViewResizeTimer = undefined;
      }, 500);
    }

    function updateChartLink(staff, staffContainerElement) {
      // chert link if any
      var linkSpan = staffContainerElement.find('span.staffaccessorylabel-link');
      var unlinkSpan = staffContainerElement.find('span.buttonunlinkchart');
      var linkedChart = swaUtils.findInArrayById(vm.selectedScene.charts, staff.linkedchartId);
      linkSpan.attr('data-linkedchartId', staff.linkedchartId);

      if (angular.isDefined(linkedChart)) {
        linkSpan.on('click', function (event) {
          vm.switchEditor(0, { sceneId: staff.sceneId, chartId: event.target.dataset.linkedchartid });
        });
        if (vm.chartStaffEditorState.chartNumberAutomatic) {
          linkSpan.html('Chart: ' + (vm.selectedScene.orderingindex + 1) + '.' + (linkedChart.orderingindex + 1)).removeAttr('disabled');
        } else {
          if (angular.isString(linkedChart.customname) && (linkedChart.customname.length > 0)) {
            linkSpan.html(linkedChart.customname).removeAttr('disabled');
          } else {
            linkSpan.text('<unnamed>').removeAttr('disabled');
          }
        }
        if (vm.activeAccessRules.allowchartstaffunlinking) {
          unlinkSpan.css('display', '');
        }
      } else {
        linkSpan.html('Unlinked').attr('disabled', 'disabled');
        unlinkSpan.css('display', 'none');
      }
    }

    function getStaffTemplateForStaffType(staffType) {
      return staffTemplatesService.getTemplateForId(staffType);
    }

    function staffTemplateForStaff(staff) {
      return getStaffTemplateForStaffType(staff.stafftype);
    }

    function newStaffContainerForStaff(staff) {
      var staffContainerElement = $('<div class="staffcontainer inactivestaff"></div>');
      staffContainerElement.attr('data-staffid', staff._id);
      staffContainerElement.attr('data-orderingindex', staff.orderingindex);

      return staffContainerElement;
    }

    function postProcessStaffTitle(staff) {
      if (swaUtils.isUndefinedOrNull(staff.customtitle) || (staff.customtitle.length === 0)) {
        staff.assignedName = getDefaultStaffTitle(staff);
      } else {
        staff.assignedName = staff.customtitle;
      }
    }

    function postProcessStaffData(staff) {
      if (!angular.isArray(staff.voicecells)) {
        staff.voicecells = [];
      }
      if (!angular.isArray(staff.performerrows)) {
        staff.performerrows = [];
      }

      for (var i = 0; i < staff.performerrows.length; i++) {
        var performerrow = staff.performerrows[i];
        if (angular.isDefined(performerrow.performerId)) {
          var linkedPerformer = swaUtils.findInArrayById(vm.performers, performerrow.performerId);
          if (angular.isDefined(linkedPerformer)) {
            performerrow.performerName = linkedPerformer.name;
            performerrow.filterVisible = linkedPerformer.filterVisible;
          } else {
            performerrow.filterVisible = false;
          }
        }
      }
    }

    function clearStaffsContainer() {
      $('#staffscrollview').html('');
    }

    function getDefaultStaffTitle(staff) {
      var displayIndex = staff.orderingindex + 1;
      var templateDefinition = staffTemplatesService.getTemplateDefinitionForId(staff.stafftype);

      if (angular.isDefined(templateDefinition)) {
        if (templateDefinition.displaycountprefix) {
          return (staff.counts + ' ' + templateDefinition.displayname + ' - ' + displayIndex);
        } else {
          return (templateDefinition.displayname + ' - ' + displayIndex);
        }
      }
    }

    function onDragStart() {
      //do nothing
    }

    var hoverTimeout;

    function onDragDrag(event, ui) {
      $timeout.cancel(hoverTimeout);

      hoverTimeout = $timeout(function () {
        var staffContainer = $.touching({
          x: ui.offset.left + 100,
          y: ui.offset.top + 70,
        }, '.stafftablecontainer', {
          container: '#staffscrollview'
        });

        // var staffContainer = $(document.elementFromPoint(ui.offset.left, ui.offset.top)).parents('.staffcontainer');
        if (staffContainer.length) {
          if (!staffContainer.hasClass('stafftablecontainer-hover')) {
            $('#staffscrollview .stafftablecontainer').removeClass('stafftablecontainer-hover');
            staffContainer.addClass('stafftablecontainer-hover');
          }
        } else {
          $('#staffscrollview .stafftablecontainer').removeClass('stafftablecontainer-hover');
        }

        $timeout.cancel(hoverTimeout);
      }, 200);
    }

    function onDragStop() {
      if (vm.activeAccessRules.allowchartstafflinking) {
        $timeout.cancel(hoverTimeout);
        $('#staffscrollview .stafftablecontainer').removeClass('stafftablecontainer-hover');
      } else {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to link/unlink charts and score in this scene'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
      }
    }

    function onDropLinkTarget(event, ui) {
      if (vm.activeAccessRules.allowchartstafflinking) {
        $timeout.cancel(hoverTimeout);
        $('#staffscrollview .stafftablecontainer').removeClass('stafftablecontainer-hover');

        var draggableId = ui.draggable.attr('data-swa-chartid');

        var droppableId = $($document[0].elementFromPoint((ui.offset.left + 100), (ui.offset.top + 70))).parents('.staffcontainer').attr('data-staffid');

        if (angular.isDefined(draggableId) && angular.isDefined(droppableId)) {
          $log.debug('will link chart: ' + draggableId + ' to staff: ' + droppableId);

          var ceres = DbSubMgrService.getAsteroid();

          // check if staff has a chart linked
          var targetStaff = swaUtils.findInArrayById(vm.selectedScene.staffs, droppableId);
          var oldLinkedChartId = targetStaff.linkedchartId;
          if (draggableId === oldLinkedChartId) {
            return;
          }

          blockUI.start();
          var updatedStaff = {
            _id: droppableId,
            linkedchartId: draggableId,
          };
          dbStaffs.update(updatedStaff)
            .catch(function (error) {
              $log.error('ChartStaffEditorController.onDropLinkTarget:', error);
              swaUtils.showErrorToast(error, $translate.instant('errormessages.Error linking chart and staff!'));
            })
            .finally(function () {
              blockUI.stop();
            });
        }
      }
    }

    function unlinkChartFromStaff(event) {
      if (vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowchartstaffunlinking) {
        var unlinkSpan = $(this); // eslint-disable-line angular/controller-as-vm
        var staffId = unlinkSpan.parents('.staffcontainer').attr('data-staffid');

        var staff = swaUtils.findInArrayById(vm.selectedScene.staffs, staffId);

        if (staff) {
          blockUI.start();

          var updatedStaff = {
            _id: staffId,
            linkedchartId: null,
          };
          dbStaffs.update(updatedStaff)
            .catch(function (error) {
              $log.error('ChartStaffEditorController.unlinkChartFromStaff:', error);
              swaUtils.showErrorToast(error, $translate.instant('errormessages.Error unlinking chart and staff!'));
            })
            .finally(function () {
              blockUI.stop();
            });
        }
      } else {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to link/unlink charts and score in this scene'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
      }
    }

    function switchEditor(index, navParams) {
      var params = {
        productionId: selectedProductionId,
        lockModeNavigation: vm.chartStaffEditorState.lockModeNavigation,
        selectedScene: vm.selectedScene,
        navParams: navParams
      };

      if (index === 0) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.charteditor, params);
      } else if (index === 1) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.staffeditor, params);
      }
    }

    function updateSceneCollaborationAccessRules(scenes) {
      return scenes.reduce(function (q, scene) {
        return q.then(function () {
          if (vm.activeCollaborationConfig.isProductionOwner === true) {
            if (vm.activePlanRules.planId === 2) {
              scene.accessRules = angular.copy(defaultViewAccessRules);
            } else {
              scene.accessRules = angular.copy(defaultOwnerAccessRules);
            }
            return $q.resolve();
          } else {
            if (vm.activePlanRules.planId === 2) {
              scene.accessRules = angular.copy(defaultViewAccessRules);
            } else {
              scene.accessRules = angular.copy(defaultDenyAccessRules);
              if (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel !== swaAccess.accesslevel.custom) {
                var params = {
                  statename: swaRouterStateNames.chartstaffeditor,
                  accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
                };

                return dbCollaborationPrivileges.getCollaborationPrivileges(params)
                  .then(function (privilegeData) {
                    angular.extend(scene.accessRules, privilegeData.accessrules);
                  })
                  .catch(function (error) {
                    $log.error('ChartStaffEditorController.updateSceneCollaborationAccessRules:', error);
                  })
                  .finally(function () {
                    return $q.resolve();
                  });
              } else {
                var sceneAccess = _.findWhere(vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.sceneaccess, {
                  sceneId: scene._id
                });
                if (angular.isDefined(sceneAccess)) {
                  var params1 = {
                    statename: swaRouterStateNames.chartstaffeditor,
                    accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
                    allowchartediting: sceneAccess.allowchartediting,
                    allowstaffediting: sceneAccess.allowstaffediting,
                  };

                  return dbCollaborationPrivileges.getCollaborationPrivileges(params1)
                    .then(function (privilegeData) {
                      angular.extend(scene.accessRules, privilegeData.accessrules);
                    })
                    .catch(function (error) {
                      $log.error('ChartStaffEditorController.updateSceneCollaborationAccessRules:', error);
                    })
                    .finally(function () {
                      return $q.resolve();
                    });
                }
              }
            }
          }
        });
      }, $q.resolve());
    }

    function updateActiveAccessRules() {
      var accessRules;
      if (angular.isDefined(vm.selectedScene)) {
        accessRules = vm.selectedScene.accessRules;
      }

      if (accessRules) {
        angular.extend(vm.activeAccessRules, accessRules);
      } else {
        angular.extend(vm.activeAccessRules, defaultDenyAccessRules);
      }
    }

    function initHelpTour() {
      vm.showHelpBar = false;
      var profileDisplayHelp = false;
      if (angular.isDefined(vm.userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || vm.userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }

      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function loadEditorPreferences() {
      vm.chartStaffEditorState.staffAutoFitWidth = vm.chartStaffEditorPreferences.staffAutoFitWidth;
    }

    function saveEditorPreferences() {
      vm.chartStaffEditorPreferences.staffAutoFitWidth = vm.chartStaffEditorState.staffAutoFitWidth;
    }

    function initHelpTourSteps() {
      vm.helpTourSteps = [{
        element: '#menu-locknavigation',
        title: $translate.instant('helptour.editor.titles.menu-locknavigation'),
        content: $translate.instant('helptour.editor.messages.menu-locknavigation'),
        placement: 'bottom',
      }, {
        element: '#menu-switchview',
        title: $translate.instant('helptour.editor.titles.menu-switchview'),
        content: $translate.instant('helptour.editor.messages.menu-switchview'),
        placement: 'bottom',
      }, {
        element: '#menu-staffzoom',
        title: $translate.instant('helptour.editor.titles.menu-staffzoom'),
        content: $translate.instant('helptour.editor.messages.menu-staffzoom'),
        placement: 'bottom',
      }, {
        element: '#menu-createpdf',
        title: $translate.instant('helptour.editor.titles.menu-createpdf'),
        content: $translate.instant('helptour.editor.messages.menu-createpdf'),
        placement: 'left',
      }, {
        element: '#menu-collaborators',
        title: $translate.instant('helptour.editor.titles.menu-collaborators'),
        content: $translate.instant('helptour.editor.messages.menu-collaborators'),
        placement: 'left',
      }, {
        element: '#menu-settings',
        title: $translate.instant('helptour.editor.titles.menu-settings'),
        content: $translate.instant('helptour.editor.messages.menu-settings'),
        placement: 'left',
      }, {
        element: '#sidebar-scenelist',
        title: $translate.instant('helptour.chartStaffEditor.titles.sidebar-scenelist'),
        content: $translate.instant('helptour.chartStaffEditor.messages.sidebar-scenelist'),
        placement: 'right',
      },
      ];

      vm.helpTourVideos = [{
        label: 'Link Charts & Score',
        videoUrl: 'https://www.youtube.com/embed/coNkSb1taRM?si=9pDjokKkYnpZwxvA&amp;start=711'
      }];
    }

    $scope.$on('$destroy', function () {
      $('#staffscrollview').off('click');

      dbProductions.fetchUnregister();
      dbScenes.fetchUnregister();
      dbCharts.fetchUnregister();
      dbStaffs.fetchUnregister();
      unregisterKeyboardHandler();
      unregisterResizeHandler();
    });

    function keyboardHandler(event) {
      if (keyboardHandlerCheckTarget(event)) {
        return;
      }

      // key
      var whichKey = event.which;
      var key = event.key;

      // modifier keys and combos
      var ctrlKey = event.ctrlKey && !(event.altKey || event.shiftKey || event.metaKey);
      var ctrlShiftKey = event.ctrlKey && event.shiftKey && !(event.altKey || event.metaKey);
      var metaKey = event.metaKey && !(event.altKey || event.shiftKey || event.ctrlKey);
      var metaShiftKey = event.metaKey && event.shiftKey && !(event.altKey || event.ctrlKey);
      var noModKey = !(event.ctrlKey || event.altKey || event.shiftKey || event.metaKey);

      // lock mode navigation control
      if (vm.chartStaffEditorState.lockModeNavigation) {
        if (whichKey === 27) {
          toggleLockModeNavigation();
          return;
        }
        if (whichKey === 37) {
          if (ctrlKey) {
            lockNavigationPreviousScene();
          } else {
            lockNavigationPreviousStaff();
          }
          event.stopPropagation();
          event.preventDefault();

          return;
        } else if (whichKey === 39) {
          if (ctrlKey) {
            lockNavigationNextScene();
          } else {
            lockNavigationNextStaff();
          }
          event.stopPropagation();
          event.preventDefault();

          return;
        }
      }
    }

    function keyboardHandlerCheckTarget(event) {
      var target = event.target;

      if (vm.chartStaffEditorState.lockModeNavigation) {
        return false;
      } else if ((target.nodeName === 'INPUT') || (target.nodeName === 'TEXTAREA')) {
        return true;
      } else {
        return target.attributes.contenteditable;
      }
    }

    function registerKeyboardHandler() {
      $log.debug('ChartStaffEditorController: registerKeyboardHandler:');
      $(document).on('keydown', keyboardHandler);

      tryIdentifyPlatform();
    }

    function unregisterKeyboardHandler() {
      $log.debug('ChartStaffEditorController: unregisterKeyboardHandler:');
      $(document).off('keydown', keyboardHandler);
    }

    function registerResizeHandler() {
      $log.debug('ChartStaffEditorController: registerResizeHandler:');
      $window.addEventListener('resize', docOnResize);
    }

    function unregisterResizeHandler() {
      $log.debug('ChartStaffEditorController: unregisterResizeHandler:');
      $window.removeEventListener('resize', docOnResize);
    }

    function tryIdentifyPlatform() {
      vm.platformMac = (navigator.platform && (navigator.platform.match(/mac/i) !== null)) || (navigator.userAgent.match(/Macintosh/i) !== null);
    }

    function toggleLockModeNavigation() {
      if (vm.chartStaffEditorState.lockModeNavigation) {
        blockUI.start('Leaving lock mode ...');
      } else {
        blockUI.start('Enabling lock mode ...');
      }

      vm.chartStaffEditorState.lockModeNavigation = !vm.chartStaffEditorState.lockModeNavigation;

      $q.when()
        .then(function () {
          if (vm.chartStaffEditorState.lockModeNavigation) {
            lockNavigationSelectInitialStaff();
          } else {
            $('#staffscrollview > .staffcontainer').removeClass('lockselect');
          }
        })
        .then(function () {
          blockUI.stop();
        });
    }

    function lockNavigationSelectInitialStaff() {
      if (angular.isDefined(vm.selectedScene)) {
        var staffToSelect = _.first(vm.selectedScene.staffs);
        lockModeSelectStaff(staffToSelect);

        return;
      }

      // toggle open the first scene
      lockNavigationPreviousScene();
    }

    function lockNavigationPreviousScene() {
      toastr.clear();
      if (angular.isDefined(vm.selectedScene)) {
        var previousSceneIndex = vm.selectedScene.orderingindex - 1;
        if (previousSceneIndex > -1) {
          var previousScene = vm.scenes[previousSceneIndex];
          toggleScene(previousScene).then(
            function () {
              var staffToSelect = _.last(vm.selectedScene.staffs);
              if (angular.isDefined(staffToSelect)) {
                lockModeSelectStaff(staffToSelect, true);
              }
            }
          );
        } else {
          // try to go to last staff in the scene
          var staffToSelect = _.first(vm.selectedScene.staffs);
          if (angular.isDefined(staffToSelect) && (vm.selectedStaff !== staffToSelect)) {
            lockModeSelectStaff(staffToSelect, true);
          } else {
            toastr.info($translate.instant('messages.At first score/scene'));
          }
        }
      } else {
        var firstScene = _.first(vm.scenes);
        if (angular.isDefined(firstScene)) {
          toggleScene(firstScene).then(
            function () {
              var staffToSelect = _.first(vm.selectedScene.staffs);
              if (angular.isDefined(staffToSelect)) {
                lockModeSelectStaff(staffToSelect, true);
              }
            }
          );
        }
      }
    }

    function lockNavigationPreviousStaff() {
      toastr.clear();
      if (angular.isDefined(vm.selectedStaff)) {
        var previousOrderingIndex = vm.selectedStaff.orderingindex - 1;

        if (previousOrderingIndex > -1) {
          var previousStaff = vm.selectedScene.staffs[previousOrderingIndex];
          lockModeSelectStaff(previousStaff, true);
        } else {
          lockNavigationPreviousScene();
        }
      } else {
        lockNavigationPreviousScene();
      }
    }

    function lockNavigationNextStaff() {
      toastr.clear();
      if (angular.isDefined(vm.selectedStaff)) {
        var nextOrderingIndex = vm.selectedStaff.orderingindex + 1;

        if (nextOrderingIndex < vm.selectedScene.staffs.length) {
          var nextStaff = vm.selectedScene.staffs[nextOrderingIndex];
          lockModeSelectStaff(nextStaff, true);
        } else {
          lockNavigationNextScene();
        }
      } else {
        lockNavigationNextScene();
      }
    }

    function lockNavigationNextScene(overflow) {
      toastr.clear();
      if (angular.isDefined(vm.selectedScene)) {
        var nextSceneIndex = vm.selectedScene.orderingindex + 1;
        if (nextSceneIndex < vm.scenes.length) {
          var nextScene = vm.scenes[nextSceneIndex];
          toggleScene(nextScene).then(
            function () {
              var staffToSelect = _.first(vm.selectedScene.staffs);
              if (angular.isDefined(staffToSelect)) {
                lockModeSelectStaff(staffToSelect);
              }
            }
          );
        } else {
          // try to go to last staff in the scene
          var staffToSelect = _.last(vm.selectedScene.staffs);
          if (angular.isDefined(staffToSelect) && (vm.selectedStaff !== staffToSelect)) {
            lockModeSelectStaff(staffToSelect, true);
          } else {
            toastr.info($translate.instant('messages.At last score/scene'));
          }
        }
      } else {
        var lastScene = _.last(vm.scenes);
        if (angular.isDefined(lastScene)) {
          toggleScene(lastScene).then(
            function () {
              var staffToSelect = _.last(vm.selectedScene.staffs);
              if (angular.isDefined(staffToSelect)) {
                lockModeSelectStaff(staffToSelect, true);
              }
            }
          );
        }
      }
    }

    function lockModeSelectStaff(staff) {
      vm.selectedStaff = staff;
      vm.selectedStaffOrderingIndex = staff.orderingindex;

      $('#staffscrollview > .staffcontainer').removeClass('lockselect');

      var staffContainerToSelect = $('div#staffscrollview div[data-staffid=\'' + staff._id + '\']');
      staffContainerToSelect.addClass('lockselect');

      // $('.sw-editorcontent').mCustomScrollbar('scrollTo', staffContainerToSelect);
      staffContainerToSelect.get(0).scrollIntoView();

      if (angular.isDefined(staff.linkedchartId)) {
        vm.chartStaffEditorState.lockHighlightChartId = staff.linkedchartId;
        return $timeout(function () {
          vm.scrollUpdateSidebar('scrollTo', $('#chart-' + staff.linkedchartId).position().top - 40);
        }, 500);
      } else {
        $scope.$applyAsync(function () {
          vm.chartStaffEditorState.lockHighlightChartId = undefined;
        });
      }
    }
  }
}());

/* global window, document, $, Q, _ */
(function () {
  'use strict';

  angular.module('swanywhere').controller('ChartScriptEditorController', ChartScriptEditorController);

  ChartScriptEditorController.$inject = [
    '$scope',
    '$cookies',
    '$state',
    '$stateParams',
    'DbCharts',
    'DbScenes',
    'DbProductions',
    'DbSubMgrService',
    'DbScripts',
    'DbUserScripts',
    'DbScriptPages',
    'ngProgressLite',
    'blockUI',
    'toastr',
    '$timeout',
    '$log',
    '$translate',
    'swaUtils',
    'swaRouterStateNames',
    'DbCollaborationPrivileges',
    'swaAccess',
    '$document',
    'swPdfPrintService',
    '$q',
    'swaConfig',
    'DbUser',
    '$localStorage',
    'DbUserScriptPages',
    'swaUi',
    '$window',
    '$sce',
    'swaPdfToImage',
    '$interval',
    '$uibModal'
  ];

  function ChartScriptEditorController($scope, $cookies, $state, $stateParams,
    DbCharts, DbScenes, DbProductions, DbSubMgrService, DbScripts, DbUserScripts, DbScriptPages,
    ngProgressLite, blockUI, toastr, $timeout, $log, $translate, swaUtils,
    swaRouterStateNames, DbCollaborationPrivileges, swaAccess, $document,
    swPdfPrintService, $q, swaConfig, DbUser, $localStorage, dbUserScriptPages, swaUi, $window, $sce, swaPdfToImage, $interval, $uibModal) {
    var vm = this;
    var selectedProductionId;

    var chartlinksContentElement;

    var dbProductions = new DbProductions();
    var dbScenes = new DbScenes();
    var dbCharts = new DbCharts();
    var dbScripts = new DbScripts();
    var dbUserScripts = new DbUserScripts();
    var dbScriptPages = new DbScriptPages();
    var dbUserScriptPages = new dbUserScriptPages();
    var dbCollaborationPrivileges = new DbCollaborationPrivileges();

    var defaultDenyScriptAccessRules = {
      allowowneraccess: false,
      allowscriptaslinktarget: false,
      allowchartscriptlinking: false,
      allowpersonalnotes: false,
    };

    var defaultDenySceneAccessRules = {
      allowowneraccess: false,
      allowchartaslinksource: false,
      allowchartscriptlinking: false,
    };

    var defaultViewScriptAccessRules = angular.copy(defaultDenyScriptAccessRules);

    var defaultViewSceneAccessRules = angular.copy(defaultDenySceneAccessRules);

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowchartaslinksource: true,
      allowscriptaslinktarget: true,
      allowchartscriptlinking: true,
      allowpersonalnotes: false,
    };

    vm.userData = {};
    vm.userId = '';

    vm.bookmarkPicker = {};
    vm.bookmarkPickerL = {};

    vm.document = $document.get(0);

    vm.swaRouterStateNames = swaRouterStateNames;

    // All scenes in production
    vm.scenes = [];

    // selected scene
    vm.selectedSceneId = undefined;
    vm.selectedScene = undefined;

    vm.script = {};
    vm.currentScriptPage = {};
    vm.ownerScriptPage = undefined;

    /** @type ScriptBookmarkType[] */
    vm.bookmarks = [];
    /** @type ScriptBookmarkType[] */
    vm.sortedBookmarks = [];

    vm.chartIdToChartNameCache = {};

    vm.sharedannotationlayers = [];
    vm.hiddenSharedAnnotationLayersList = [];

    vm.chartScriptEditorState = {
      scriptAvailable: false,
      scriptLoaded: false,
      currentPageNumber: -1,
      totalNumberOfPages: -1,
      masterLayerActive: false,
      personalLayerActive: false,
      annotationsVisible: true,
      annotationsVisiblePersonal: false,
      chartNumberAutomatic: true,
      currentBookmark: null,
      customPageNumber: -1,
    };

    vm.newChartLinkTracker = {
      showTarget: false,
    };

    vm.scrollConfigContent = {
      theme: 'light',
      axis: 'yx',
      scrollbarPosition: 'inside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
      },
      autoHideScrollbar: false,
      advanced: {
        updateOnContentResize: true,
      },
    };

    vm.scrollConfigSidebar = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
    };

    vm.gotoPagePicker = {};
    vm.gotoPagePicker1 = {};

    vm.toggleScene = toggleScene;
    vm.switchEditor = switchEditor;
    vm.toggleAnnotationVisibility = toggleAnnotationVisibility;
    vm.gotoPage = gotoPage;
    vm.gotoPageQuick = gotoPageQuick;
    vm.onOverLinkTarget = onOverLinkTarget;
    vm.onOutLinkTarget = onOutLinkTarget;
    vm.onDropLinkTarget = onDropLinkTarget;
    vm.onDragStart = onDragStart;
    vm.onChartlinksContentMouseDown = onChartlinksContentMouseDown;
    vm.onChartlinksContentMouseMove = onChartlinksContentMouseMove;
    vm.onChartlinksContentMouseUp = onChartlinksContentMouseUp;
    vm.cancelNewChartLink = cancelNewChartLink;
    vm.deleteChartLink = deleteChartLink;
    vm.shouldAllowChartLinkEdit = shouldAllowChartLinkEdit;
    vm.onSaveClick = onSaveClick;
    vm.printPdf = printPdf;
    vm.onHelpTourStart = onHelpTourStart;
    vm.onHelpTourEnd = onHelpTourEnd;
    vm.activateMasterNotesLayer = activateMasterNotesLayer;
    vm.activatePersonalNotesLayer = activatePersonalNotesLayer;

    vm.gotoBookmark = gotoBookmark;
    vm.gotoPrevBookmark = gotoPrevBookmark;
    vm.gotoNextBookmark = gotoNextBookmark;

    vm.toggleLockModeNavigation = toggleLockModeNavigation;

    vm.chartlinkMoved = chartlinkMoved;
    vm.chartlinkResized = chartlinkResized;

    vm.pdfPrintOptionPrompt = pdfPrintOptionPrompt;

    vm.findAndGoToPageNoFromCustomPageNumber = findAndGoToPageNoFromCustomPageNumber;

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedScenes: false,
      allowedNumberOfScenes: 0,
      allowUnlimitedCharts: false,
      allowedNumberOfCharts: 0,
      allowUnlimitedScriptPages: false,
      allowedNumberOfScriptPages: 0,
    };

    vm.PdfPrintTypes = swPdfPrintService.PdfPrintTypes;
    vm.chartScriptEditorState.masterLayerActive = true;
    vm.chartScriptEditorState.personalLayerActive = false;
    vm.chartScriptEditorState.annotationsVisible = true;
    vm.chartScriptEditorState.annotationsVisiblePersonal = true;
    vm.hiddenAnnotationLayersList = [];

    vm.drawingpad = undefined;
    vm.drawingpadPersonal = undefined;
    vm.drawingpadForSharedLayer = undefined;

    initialize();

    function initialize() {
      $cookies.put('currentEditorStateName', swaUtils.getRouterCurrentStateName());

      sessionCheckAndRun();
      registerKeyboardHandler();
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');
      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();

      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.validateActivePlan();
        })
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        })
        .then(function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        })
        .then(function (plan) {
          updateActivePlanRules(plan);
        })
        .then(function () {
          chartlinksContentElement = angular.element('.swa-script-chartlinks-container').get(0);
          return getAllData();
        })
        .then(function () {
          showHelpHints();
          initHelpTour();
        })
        .then(function () {
          if (angular.isDefined($stateParams.selectedScene)) {
            var sceneToOpen = vm.scenes.find(function (scene) { return (scene._id === $stateParams.selectedScene._id) })
            return toggleScene(sceneToOpen);
          }
          if (angular.isDefined($stateParams.selectedScene) && angular.isUndefined($stateParams.navParams)) {
            var scene = vm.scenes.find(function (scene) { return scene._id === $stateParams.selectedScene._id })
            if (angular.isDefined(scene)) {
              return vm.toggleScene(scene)
            }
          }
        })
        .then(function () {
          if ($stateParams.lockModeNavigation === true) {
            toggleLockModeNavigation();
          }
        })
        .then(function () {
          $cookies.put('selectedProductionId', selectedProductionId);
        })
        .then(null, null, function (progress) {
          ngProgressLite.set(progress);
        })
        .catch(function (error) {
          $log.error('ChartScriptEditorController.sessionCheckAndRun:', error);
          swaUtils.sessionErrorInterceptor(error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function getAllData() {
      var deferred = $q.defer();

      getProduction()
        .then(function () {
          deferred.notify(0.2);
          return setupPdfPrintService();
        })
        .then(function () {
          deferred.notify(0.3);
          return updateScriptCollaborationPrivileges();
        })
        .then(function () {
          deferred.notify(0.4);
          if (vm.activeAccessRules.allowpersonalnotes) {
            activatePersonalNotesLayer();
          } else {
            activateMasterNotesLayer();
          }
          return setupSketchpad();
        })
        .then(function () {
          deferred.notify(0.6);
          return getScenes();
        })
        .then(function () {
          deferred.notify(0.7);
          return getScript();
        })
        .then(function () {
          deferred.notify(0.9);
          return loadScript();
        })
        // .then(function () {
        //   beginPreloadScriptPages();
        // })
        .then(function () {
          deferred.notify(1.0);
        })
        .catch(function (error) {
          deferred.reject(error);
        })
        .finally(function () {
          deferred.resolve();
        });

      return deferred.promise;
    }

    /** Gets production data */
    function getProduction() {
      var deferred = $q.defer();

      dbProductions.findById(selectedProductionId)
        .then(function (production) {
          updateDataProduction(production);
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;

      vm.activePlanRules.allowUnlimitedScenes = plan.planfeatures[3].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedScenes) {
        vm.activePlanRules.allowedNumberOfScenes = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfScenes = plan.planfeatures[3].featurevalue;
      }

      vm.activePlanRules.allowUnlimitedCharts = plan.planfeatures[4].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedCharts) {
        vm.activePlanRules.allowedNumberOfCharts = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfCharts = plan.planfeatures[4].featurevalue;
      }

      vm.activePlanRules.allowUnlimitedScriptPages = plan.planfeatures[6].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedScriptPages) {
        vm.activePlanRules.allowedNumberOfScriptPages = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfScriptPages = plan.planfeatures[6].featurevalue;
      }
    }

    function updateDataProduction(production) {
      vm.selectedProduction = production;

      if (angular.isUndefined(vm.selectedProduction) || (parseInt(vm.selectedProduction.productiontype) !== 1)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error('Invalid state');
      }

      if (vm.selectedProduction.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
      } else {
        if (angular.isArray(vm.selectedProduction.collaboratorIds) && (vm.selectedProduction.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = vm.selectedProduction.collaborationsettings.find(function (element) {
            return (element.collaboratorId === vm.userId);
          });
        }

        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error(
            $translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          throw new Error('Invalid state');
        }
      }

      DbSubMgrService.setSelectedProduction(vm.selectedProduction);

      vm.selectedProductionName = vm.selectedProduction.name;
      vm.chartScriptEditorState.chartNumberAutomatic = (vm.selectedProduction.chartsettings.chartnumberautomatic === true);

      vm.chartScriptEditorState.scriptAvailable = angular.isDefined(vm.selectedProduction.scriptId);
    }

    /** Gets (and monitors) scenes */
    function getScenes() {
      return dbScenes.fetchAllInProduction(selectedProductionId, updateDataScenes);
    }

    function getScript() {
      $log.debug('ChartScriptEditorController.getScript() -->');

      var deferred = $q.defer();

      dbScripts.findByProduction(selectedProductionId)
        .then(function (script) {
          vm.script = script;
          vm.chartScriptEditorState.scriptAvailable = angular.isDefined(vm.script);

          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function setupPdfPrintService() {
      swPdfPrintService.setSelectedProduction(vm.selectedProduction);
      vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
      vm.onPrintJobsChange = onPrintJobsChange;
      swPdfPrintService.registerForChange(vm);
    }

    function onPrintJobsChange(change, id, job) {
      vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
    }

    function pdfPrintOptionPrompt(type) {
      vm.pdfOptionsPicker.show = false;
      var permissionToPrintSharedLayers = false;
      if (vm.activeCollaborationConfig.collaborationSetting) {
        permissionToPrintSharedLayers = ((vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.custom) && !vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.allowscriptediting) ||
          (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited);
      }
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/chartEditor/pdfPrintOptionPrompt.html',
        controller: 'PdfPrintOptionPromptController',
        controllerAs: 'vm',
        size: '600',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        resolve: {
          params: {
            type: type,
            permissionToPrintSharedLayers: permissionToPrintSharedLayers,
          }
        }
      });
      modalInstance.result
        .then(function (params) {
          printPdf(params)
        });
    }

    function printPdf(parameters) {
      var type = parameters.type;
      vm.pdfOptionsPicker.show = false;

      var params = {};
      params.productionId = selectedProductionId;
      params.optionalIds = {};
      params.options = {};
      params.type = type;
      params.notesPrintOption = parameters.chartNotes;
      params.chartLinksPrintOption = parameters.chartLinks;
      params.scaleAllPerformersPrintOption = parameters.scaleAllPerformers;
      params.scaleSelectedPerformersPrintOption = parameters.scaleSelectedPerformers;
      params.sharedLayerAnnotationsPrintOption = parameters.sharedLayerAnnotations;

      if ((type === vm.PdfPrintTypes.AllChartsScript) || (type === vm.PdfPrintTypes.Script)) {
        params.optionalIds.scriptId = vm.script._id;
        params.options.printPersonalAnnotations = vm.activeAccessRules.allowpersonalnotes;
      } else if (type === vm.PdfPrintTypes.CurrentSceneCharts) {
        params.optionalIds.sceneId = vm.selectedSceneId;
      }

      params.options.printChartPersonalNotes = getPrintChartPersonalNotes();

      swPdfPrintService.printPdf(params).then(
        function (printJob) {
          if (angular.isDefined(printJob.approvingUserId)) {
            toastr.info(
              $translate.instant('messages.PDF waiting for approval'),
              $translate.instant('messages.Approval Needed!')
            );
          } else {
            toastr.info(
              $translate.instant('messages.Requested PDF is being created')
            );
          }
        },
        function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error creating PDF!')
          );
        }
      );
    }

    function getPrintChartPersonalNotes() {
      return (!vm.activeCollaborationConfig.isProductionOwner && (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited)) ||
        (vm.activePlanRules.planId === 2);
    }

    function updateDataScenes(id) {
      if (angular.isUndefined(id)) {
        vm.scenes = dbScenes.getFetched(true);
        vm.scenes.forEach(updateSceneChartIds)
        updateSceneCollaborationAccessRules(vm.scenes);
      } else {
        var existingScene = swaUtils.findInArrayById(vm.scenes, id);
        var incomingScene = dbScenes.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingScene) && swaUtils.isUndefinedOrNull(incomingScene));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));

        if (isInsert) {
          updateSceneCollaborationAccessRules([incomingScene]);
          vm.scenes.push(incomingScene);
          swaUtils.sortArrayByNumericKey(vm.scenes, 'orderingindex');
          updateSceneChartIds(incomingScene);
        } else if (isDelete) {
          toastr.warning($translate.instant('messages.Scene deleted elsewhere.'), $translate.instant(
            'messages.Sync warning!'));
          if (existingScene === vm.selectedScene) {
            toggleScene();
          }

          var existingSceneIndex = vm.scenes.indexOf(existingScene);
          if (existingSceneIndex !== -1) {
            vm.scenes.splice(existingSceneIndex, 1);
          }
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming scene update with ID: ' + id);
          angular.extend(existingScene, incomingScene);
          updateSceneChartIds(existingScene);
        }
      }
    }

    function updateSceneChartIds(scene) {
      if (angular.isDefined(scene) && angular.isDefined(scene._id)) {
        dbCharts.getIdsInScene(scene._id)
          .then(function (result) {
            scene.chartIds = _.map(result, _.property('_id'));
          })
          .catch(function (err) {
            $log.error('updateSceneChartIds:', scene._id, err);
          })
      }
    }

    function updateDataCharts(filter, id) {
      if (angular.isUndefined(vm.selectedScene)) {
        return;
      }

      if (filter) {
        if (filter.sceneId !== vm.selectedScene._id) {
          return;
        }
      }

      if (angular.isUndefined(id)) {
        vm.selectedScene.charts = dbCharts.getFetched(true);
        vm.selectedScene.noCharts = !(angular.isArray(vm.selectedScene.charts) && (vm.selectedScene.charts.length > 0));
      } else {
        vm.selectedScene.charts = vm.selectedScene.charts || [];

        var existingChart = swaUtils.findInArrayById(vm.selectedScene.charts, id);
        var incomingChart = dbCharts.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingChart) && !swaUtils.isUndefinedOrNull(incomingChart));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingChart) && swaUtils.isUndefinedOrNull(incomingChart));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingChart) && !swaUtils.isUndefinedOrNull(incomingChart));
        if (isInsert) {
          // incoming insert
          $log.debug('incoming chart insert with ID: ', id);

          vm.selectedScene.charts.push(incomingChart);
          swaUtils.sortArrayByNumericKey(vm.selectedScene.charts, 'orderingindex');
          vm.selectedScene.noCharts = !(angular.isArray(vm.selectedScene.charts) && (vm.selectedScene.charts.length > 0));

          vm.chartEditorState.showingChartContent = !vm.selectedScene.noCharts;
        } else if (isDelete) {
          // incoming delete
          $log.debug('incoming chart delete with ID: ' + id);

          var existingChartIndex = vm.selectedScene.charts.indexOf(existingChart);
          if (existingChartIndex !== -1) {
            vm.selectedScene.charts.splice(existingChartIndex, 1);
          }

          vm.selectedScene.noCharts = !(angular.isArray(vm.selectedScene.charts) && (vm.selectedScene.charts.length > 0));
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming chart update with ID: ' + id);

          // TODO: merge existing and incoming chart intelligently
          if (!chartCompareIfSame(existingChart, incomingChart)) {
            angular.extend(existingChart, incomingChart);

            swaUtils.sortArrayByNumericKey(vm.selectedScene.charts, 'orderingindex');
          }
        }
      }
    }

    function chartCompareIfSame(chart1, chart2) {
      if (chart1.orderingindex !== chart2.orderingindex) {
        return false;
      }

      if (chart1.modified && chart2.modified) {
        if (chart1.modified.$date && chart2.modified.$date) {
          if (Math.abs(chart1.modified.$date - chart2.modified.$date) > 5000) {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }

      // TODO: more logic if any

      return true;
    }

    function toggleScene(scene) {
      var deferred = $q.defer();

      $q.when().then(
        function () {
          if (angular.isDefined(vm.selectedScene)) {
            vm.selectedScene.charts = [];
            vm.selectedScene.open = false;
            vm.selectedScene.selected = false;
          }
        }
      ).then(
        function () {
          if (vm.selectedScene !== scene) {
            ngProgressLite.start();
            blockUI.start();
            vm.selectedScene = scene;
            vm.selectedSceneId = scene._id;
            vm.selectedScene.selected = true;
            vm.selectedScene.open = true;
            updateActiveAccessRules();
            return dbCharts.fetchForScene(scene._id, updateDataCharts);
          } else {
            vm.selectedScene = undefined;
            vm.selectedSceneId = undefined;
          }
        }
      ).then(
        function () {
          deferred.resolve();
        }
      ).catch(
        function (error) {
          $log.error('ChartEditorController.toggleScene:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error loading charts!')
          );
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );

      return deferred.promise;
    }

    function switchEditor(index, navParams) {
      var params = {
        productionId: selectedProductionId,
        lockModeNavigation: vm.chartScriptEditorState.lockModeNavigation,
        selectedScene: vm.selectedScene,
        navParams: navParams
      };

      if (index === 0) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.charteditor, params);
      } else if (index === 3) {
        blockUI.start();
        if (vm.chartScriptEditorState.lockModeNavigation) {
          swaUtils.stateGo(swaRouterStateNames.scripteditorbookview, params);
        } else {
          swaUtils.stateGo(swaRouterStateNames.scripteditor, params);
        }
      }
    }

    function resetHiddenLayerList() {
      vm.hiddenAnnotationLayersList = [];
      angular.forEach(vm.annotationlayers, function (annotationlayer) {
        // SWA-1922 - if isvisible not set the set default true
        if (angular.isUndefined(annotationlayer.isvisible)) {
          annotationlayer.isvisible = true
        }
        if (annotationlayer.isvisible === false) {
          // Visibility false so add to hidden layer list
          vm.hiddenAnnotationLayersList.push(annotationlayer.layerid);
        }
      });
    }

    function resetHiddenSharedLayerList() {
      vm.hiddenSharedAnnotationLayersList = [];
      angular.forEach(vm.sharedannotationlayers, function (annotationlayer) {
        if (angular.isUndefined(annotationlayer.isVisibleToCollaborators)) {
          annotationlayer.isVisibleToCollaborators = true;
        }
        if (annotationlayer.isVisibleToCollaborators === false) {
          vm.hiddenSharedAnnotationLayersList.push(annotationlayer.layerid);
        }
      });
    }

    function updateSortedBookmarks() {
      vm.sortedBookmarks = dbScripts.sortBookmarks(vm.bookmarks);
    }

    function loadScript(navParams) {
      var deferred = $q.defer();

      if (vm.chartScriptEditorState.scriptAvailable) {
        dbScriptPages.getNumberOfPages(vm.script._id)
          .then(function (numberOfPages) {
            vm.script.numberOfPages = numberOfPages;
            vm.chartScriptEditorState.totalNumberOfPages = numberOfPages;
            vm.chartScriptEditorState.currentPageNumber = -1;
            vm.currentScriptPage = undefined;
          })
          .then(function () {
            if (vm.script.numberOfPages > 0) {
              if (vm.activeAccessRules.allowpersonalnotes) {
                return dbUserScripts.getForScript(vm.script._id);
              }
            }
          })
          .then(function (userScript) {
            if (vm.script.numberOfPages > 0) {
              if (vm.activeAccessRules.allowpersonalnotes) {
                vm.userScript = userScript;
                if (angular.isUndefined(userScript) || !angular.isArray(userScript.annotationlayers)) {
                  vm.annotationlayers = getDefaultLayers();
                } else {
                  vm.annotationlayers = angular.copy(userScript.annotationlayers);
                }

                updateSharedAnnotationLayers();
              } else {
                if (!angular.isArray(vm.script.annotationlayers)) {
                  vm.annotationlayers = getDefaultLayers();
                } else {
                  vm.annotationlayers = angular.copy(vm.script.annotationlayers);
                }
              }

              resetHiddenLayerList();
              updateForAnnotationLayerOrVisibilityChange();
              resetHiddenSharedLayerList();
              updateForSharedAnnotationLayerOrVisibilityChange();
            }
          })
          .then(function () {
            if (vm.script.numberOfPages > 0) {
              vm.bookmarks = angular.isArray(vm.script.bookmarks) ? angular.copy(vm.script.bookmarks) : [];
              updateSortedBookmarks();
            }
          })
          .then(function () {
            return changeActionAnnotationType();
          })
          .then(function () {
            if (vm.script.numberOfPages > 0) {
              var lastOpenedIndex = $localStorage.scriptLastOpenedPageIndex || 0;
              if (angular.isDefined($stateParams.navParams)) {
                lastOpenedIndex = parseInt($stateParams.navParams.orderingindex, 10)
                delete $stateParams.navParams;
              }
              if (lastOpenedIndex < vm.script.numberOfPages) {
                return loadScriptPageAtIndex(lastOpenedIndex);
              } else {
                return loadScriptPageAtIndex(0);
              }
            }
          })
          .then(function () {
            deferred.resolve();
          })
          .catch(function (error) {
            deferred.reject(error);
          });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    function loadScriptPageAtIndex(index) {
      var deferred = $q.defer();

      blockUI.start('Loading page');

      vm.newChartLinkTracker.enableLinking = false;

      vm.chartScriptEditorState.currentPageNumber = (index + 1);

      var pageForSharedLayer = undefined;
      dbScriptPages.getScriptPageAtIndex(vm.script._id, index)
        .then(function (scriptPage) {
          pageForSharedLayer = scriptPage;
          if (angular.isUndefined(scriptPage)) {
            throw new Error($translate.instant('errormessages.Page not found'));
          } else {
            $localStorage.scriptLastOpenedPageIndex = index;
            vm.chartScriptEditorState.customPageNumber = scriptPage.customPageNumber;
            loadScriptPage(scriptPage);
            return loadScriptPageImage(scriptPage);
          }
        })
        .then(function (scriptPage) {
          if (vm.activeAccessRules.allowpersonalnotes) {
            return dbUserScriptPages.getForScriptPage(scriptPage._id)
          }
        })
        .then(function (personalNotes) {
          if (vm.activeAccessRules.allowpersonalnotes) {
            loadScriptPagePersonal(personalNotes, pageForSharedLayer);
          }
          deferred.resolve();
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error loading script page!')
          );

          vm.chartScriptEditorState.pageLoaded = false;
          vm.chartScriptEditorState.pageLoadError = true;
          vm.currentScriptPage = undefined;

          deferred.reject(error);
        })
        .finally(function () {
          blockUI.stop();
        });

      return deferred.promise;
    }

    function setupSketchpad() {
      if (angular.isUndefined(vm.drawingpad)) {
        var el = $document[0].getElementById('sketchpad');
        vm.drawingpad = new Sketchpad(el);
      }
      if (angular.isUndefined(vm.drawingpadPersonal)) {
        var el = $document[0].getElementById('sketchpad-personal');
        vm.drawingpadPersonal = new Sketchpad(el);
      }
      if (angular.isUndefined(vm.drawingpadForSharedLayer)) {
        var el = $document[0].getElementById('sketchpad-shared');
        vm.drawingpadForSharedLayer = new Sketchpad(el);
      }
    }

    function loadScriptPage(scriptPage) {
      vm.currentScriptPage = angular.copy(scriptPage);
      updateMarginCss();

      if (!angular.isArray(vm.currentScriptPage.leftannotations)) {
        vm.currentScriptPage.leftannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage.rightannotations)) {
        vm.currentScriptPage.rightannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage.floatingannotations)) {
        vm.currentScriptPage.floatingannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage.highlightannotations)) {
        vm.currentScriptPage.highlightannotations = [];
      }

      if (!angular.isArray(vm.currentScriptPage.chartlinks)) {
        vm.currentScriptPage.chartlinks = [];
      }

      if (!angular.isArray(vm.currentScriptPage.shapepaths)) {
        vm.currentScriptPage.shapepaths = [];
      }

      angular.forEach(vm.currentScriptPage.leftannotations, function (annotation) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;
        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        updateLeftAnnotationConnectorLines(annotation);
      });

      angular.forEach(vm.currentScriptPage.rightannotations, function (annotation) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;
        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        updateRightAnnotationConnectorLines(annotation);
      });

      angular.forEach(vm.currentScriptPage.floatingannotations, function (annotation, key) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
      });

      angular.forEach(vm.currentScriptPage.highlightannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(annotation.backgroundColor);
      });

      vm.drawingpad.clear();
      vm.drawingpad.setCanvasSize(vm.currentScriptPage.pagewidth, vm.currentScriptPage.pageheight);
      if (vm.currentScriptPage.shapepaths.length > 0) {
        vm.currentScriptPage.shapepaths = vm.currentScriptPage.shapepaths.map(function (shapepath) {
          if (angular.isUndefined(shapepath.layerid)) {
            shapepath.layerid = 0
          }

          if (shapepath.isInterpolationDone !== true) {
            return vm.drawingpad.interpolateLegacyShapePath(shapepath)
          }
          return shapepath;
        });

        vm.drawingpad.loadShapePaths(vm.currentScriptPage.shapepaths);
      }

      resolveChartLinkNames();

      // blockUI.start('Loading content');

      // swaPdfToImage.loadPDFPage(scriptPage.scriptId, scriptPage._id, scriptPage.orderingindex)
      //   .then(function (imageBase64) {
      //     blockUI.start('Loading page content ...');
      //     vm.currentScriptPage.pageImageSrc = imageBase64;
      //   }).catch(function (err) {
      //     throw err;
      //   }).finally(function () {
      //     blockUI.stop();
      //   });

      // vm.currentScriptPage.dirty = false;
      // vm.chartScriptEditorState.pageLoaded = true;
      // vm.chartScriptEditorState.pageLoadError = false;

      angular.element('.sw-maincontentarea-chartscript > .mCustomScrollBox').focus();

      vm.chartScriptEditorState.currentBookmark = dbScripts.findFirstBookmarkOnPage(vm.sortedBookmarks, vm.currentScriptPage.orderingindex);
    }

    function loadScriptPageImage(scriptPage) {
      var deferred = $q.defer();

      vm.currentScriptPage.dirty = false;
      vm.chartScriptEditorState.pageLoaded = true;
      vm.chartScriptEditorState.pageLoadError = false;

      blockUI.start('Loading page content ...');
      swaPdfToImage.getPageContentImage(scriptPage._id)
        .then(function (imageBase64) {
          vm.currentScriptPage.pageImageSrc = imageBase64;
        })
        .catch(function (err) {
          vm.chartScriptEditorState.pageLoadError = false;
        })
        .finally(function () {
          blockUI.stop();
          deferred.resolve(scriptPage);
        });

      return deferred.promise;
    }

    /**
     * Loads personal notes.
     * @param {Object} personalNotes The personal notes on this page.
     */
    function loadScriptPagePersonal(personalNotes, pageForSharedLayer) {
      vm.ownerScriptPage = angular.copy(pageForSharedLayer);
      updateSharedAnnotationLayers();
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage.leftannotations)) {
        vm.ownerScriptPage.leftannotations = vm.ownerScriptPage.leftannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage.rightannotations)) {
        vm.ownerScriptPage.rightannotations = vm.ownerScriptPage.rightannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage.floatingannotations)) {
        vm.ownerScriptPage.floatingannotations = vm.ownerScriptPage.floatingannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage.highlightannotations)) {
        vm.ownerScriptPage.highlightannotations = vm.ownerScriptPage.highlightannotations.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }
      if (vm.ownerScriptPage && angular.isArray(vm.ownerScriptPage.shapepaths)) {
        vm.ownerScriptPage.shapepaths = vm.ownerScriptPage.shapepaths.filter(function (annotation) {
          return vm.sharedannotationlayers.some(function (layer) {
            return layer.isShared === true && layer.layerid === annotation.layerid;
          });
        });
      }


      if (personalNotes) {
        vm.currentScriptPage.leftannotationsPersonal = personalNotes.leftAnnotations;
        vm.currentScriptPage.rightannotationsPersonal = personalNotes.rightAnnotations;
        vm.currentScriptPage.floatingannotationsPersonal = personalNotes.floatingAnnotations;
        vm.currentScriptPage.highlightannotationsPersonal = personalNotes.highlightAnnotations;
        vm.currentScriptPage.shapepathsPersonal = personalNotes.shapepaths;
      }
      updateMarginCss();

      if (!angular.isArray(vm.currentScriptPage.leftannotationsPersonal)) {
        vm.currentScriptPage.leftannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage.rightannotationsPersonal)) {
        vm.currentScriptPage.rightannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage.floatingannotationsPersonal)) {
        vm.currentScriptPage.floatingannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage.highlightannotationsPersonal)) {
        vm.currentScriptPage.highlightannotationsPersonal = [];
      }

      if (!angular.isArray(vm.currentScriptPage.shapepathsPersonal)) {
        vm.currentScriptPage.shapepathsPersonal = [];
      }

      if (!angular.isArray(vm.ownerScriptPage.leftannotations)) {
        vm.ownerScriptPage.leftannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage.rightannotations)) {
        vm.ownerScriptPage.rightannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage.floatingannotations)) {
        vm.ownerScriptPage.floatingannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage.highlightannotations)) {
        vm.ownerScriptPage.highlightannotations = [];
      }

      if (!angular.isArray(vm.ownerScriptPage.shapepaths)) {
        vm.ownerScriptPage.shapepaths = [];
      }

      angular.forEach(vm.ownerScriptPage.leftannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;

        updateLeftAnnotationConnectorLines(annotation);
      });

      angular.forEach(vm.ownerScriptPage.rightannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;

        updateRightAnnotationConnectorLines(annotation);
      });

      angular.forEach(vm.ownerScriptPage.floatingannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
      });
      angular.forEach(vm.ownerScriptPage.highlightannotations, function (annotation) {
        annotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(annotation.backgroundColor);
      });

      angular.forEach(vm.currentScriptPage.leftannotationsPersonal, function (annotation) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;
        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        updateLeftAnnotationConnectorLines(annotation);
      });

      angular.forEach(vm.currentScriptPage.rightannotationsPersonal, function (annotation) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
        annotation.backgroundColorCssForAnchor = annotation.backgroundColorForAnchor ? swaUi.getHighlightBackgroundCss(annotation.backgroundColorForAnchor) : swaUi.defaultTextStylePreferences.fillColorForAnchor;
        annotation.borderColorCssForAnchor = annotation.borderColorForAnchor ? swaUi.getAnnotationBorderCss(annotation.borderColorForAnchor) : swaUi.defaultTextStylePreferences.borderColorForAnchor;
        annotation.annotationBorderThickness = annotation.annotationBorderThickness || swaUi.defaultTextStylePreferences.annotationBorderThickness;

        updateRightAnnotationConnectorLines(annotation);
      });

      angular.forEach(vm.currentScriptPage.floatingannotationsPersonal, function (annotation) {
        if ((annotation.richtextcontent === null) || angular.isUndefined(annotation.richtextcontent) || annotation.richtextcontent.length === 0) {
          annotation.richtextcontent = annotation.content;
        }
        annotation.backgroundColorCss = swaUi.getAnnotationBackgroundCss(annotation.backgroundColor);
      });

      angular.forEach(vm.currentScriptPage.highlightannotationsPersonal, function (annotation) {
        annotation.backgroundColorCss = swaUi.getHighlightBackgroundCss(annotation.backgroundColor);
      });

      vm.drawingpadPersonal.clear();
      vm.drawingpadPersonal.setCanvasSize(vm.currentScriptPage.pagewidth, vm.currentScriptPage.pageheight);
      if (vm.currentScriptPage.shapepathsPersonal.length > 0) {
        vm.currentScriptPage.shapepathsPersonal = vm.currentScriptPage.shapepathsPersonal.map(function (shapepath) {
          if (angular.isUndefined(shapepath.layerid)) {
            shapepath.layerid = 0
          }

          if (shapepath.isInterpolationDone !== true) {
            return vm.drawingpadPersonal.interpolateLegacyShapePath(shapepath)
          }
          return shapepath;
        });

        vm.drawingpadPersonal.loadShapePaths(vm.currentScriptPage.shapepathsPersonal);
      }

      vm.drawingpadForSharedLayer.clear();
      vm.drawingpadForSharedLayer.setCanvasSize(vm.ownerScriptPage.pagewidth, vm.ownerScriptPage.pageheight);
      if (vm.ownerScriptPage.shapepaths.length > 0) {
        vm.drawingpadForSharedLayer.loadShapePaths(vm.ownerScriptPage.shapepaths);
        vm.ownerScriptPage.shapepaths = vm.drawingpadForSharedLayer.getShapePaths();
      }
    };

    function resolveChartLinkNames() {
      angular.forEach(vm.currentScriptPage.chartlinks, function (chartLink) {
        resolveChartLinkName(chartLink);
      });
    }

    function resolveChartLinkName(chartLink) {
      var linkedChartName = vm.chartIdToChartNameCache[chartLink.chartId];
      if (angular.isDefined(linkedChartName)) {
        $q.when(linkedChartName).then(
          function (chartName) {
            chartLink.chartname = chartName;
          }
        );
      } else {
        resolveChartName(chartLink.chartId).then(
          function (chartName) {
            chartLink.chartname = chartName;
          }
        );
      }
    }

    function resolveChartName(chartId) {
      var deferred = $q.defer();

      dbCharts.getChartForName(chartId).then(
        function (chart) {
          var chartName;
          if (angular.isDefined(chart)) {
            if (vm.chartScriptEditorState.chartNumberAutomatic) {
              var parentScene = swaUtils.findInArrayById(vm.scenes, chart.sceneId);
              if (angular.isDefined(parentScene)) {
                chartName = 'Chart: ' + (parentScene.orderingindex + 1) + '.' + (chart.orderingindex + 1);
              }
            } else {
              chartName = chart.customname || '<unnamed>';
            }
          } else {
            chartName = '<missing>';
          }

          vm.chartIdToChartNameCache[chartId] = chartName;
          deferred.resolve(chartName);
        }
      ).catch(
        function (error) {
          $log.error('Error resolving chart name for chart ID: ' + chartId + ', reason:', error);

          var chartName = '<error>';
          vm.chartIdToChartNameCache[chartId] = chartName;
          deferred.resolve(chartName);
        }
      );

      return deferred.promise;
    }

    function toggleAnnotationVisibility() {
      if (vm.chartScriptEditorState.masterLayerActive) {
        if (vm.chartScriptEditorState.annotationsVisible) {
          vm.chartScriptEditorState.annotationsVisible = false;
          for (var i = 0; i < vm.annotationlayers.length; i++) {
            vm.drawingpad.setLayerVisibility(i, false);
          }
        } else {
          vm.chartScriptEditorState.annotationsVisible = true;
          for (var i = 0; i < vm.annotationlayers.length; i++) {
            vm.drawingpad.setLayerVisibility(i, true);
          }
        }
      } else if (vm.chartScriptEditorState.personalLayerActive) {
        if (vm.chartScriptEditorState.annotationsVisiblePersonal) {
          vm.chartScriptEditorState.annotationsVisiblePersonal = false;
          for (var i = 0; i < vm.annotationlayers.length; i++) {
            vm.drawingpadPersonal.setLayerVisibility(i, false);
          }
          for (var i = 0; i < vm.sharedannotationlayers.length; i++) {
            vm.drawingpadForSharedLayer.setLayerVisibility(i, false);
          }
        } else {
          vm.chartScriptEditorState.annotationsVisiblePersonal = true;
          for (var i = 0; i < vm.annotationlayers.length; i++) {
            vm.drawingpadPersonal.setLayerVisibility(i, true);
          }
          for (var i = 0; i < vm.sharedannotationlayers.length; i++) {
            vm.drawingpadForSharedLayer.setLayerVisibility(i, true);
          }
        }
      }
      updateForAnnotationLayerOrVisibilityChange();
    }

    function updateForAnnotationLayerOrVisibilityChange() {
      angular.forEach(vm.annotationlayers, function (annotationlayer) {
        if (vm.chartScriptEditorState.masterLayerActive) {
          vm.drawingpad.setLayerVisibility(annotationlayer.layerid, annotationlayer.isvisible);
        }
        if (vm.chartScriptEditorState.personalLayerActive) {
          vm.drawingpadPersonal.setLayerVisibility(annotationlayer.layerid, annotationlayer.isvisible);
        }
      });
    }

    function updateForSharedAnnotationLayerOrVisibilityChange() {
      angular.forEach(vm.sharedannotationlayers, function (annotationlayer) {
        if (vm.chartScriptEditorState.personalLayerActive) {
          vm.drawingpadForSharedLayer.setLayerVisibility(annotationlayer.layerid, annotationlayer.isVisibleToCollaborators);
        }
      });
    }

    var bookmarkToastTimeoutHandle;

    /**
     * 'Go' to the given bookmark.
     * @param {ScriptBookmarkType} bookmark
     */
    function gotoBookmark(bookmark) {
      gotoPage(bookmark.scriptPageNo + 1)
        .then(function (loaded) {
          if (loaded) {
            scrollToBookmark(bookmark);
            showBookmarkToast(bookmark);
            vm.chartScriptEditorState.currentBookmark = bookmark;
          } else {
            vm.chartScriptEditorState.currentBookmark = undefined;
          }
        });

      vm.bookmarkPicker.show = false;
      vm.bookmarkPickerL.show = false;
    }

    function scrollToBookmark(bookmark) {
      var staffContainerToSelect = $('div.sw-maincontentarea-script');
      staffContainerToSelect.mCustomScrollbar("scrollTo", bookmark.topOffset);
    }

    function showBookmarkToast(bookmark) {
      clearBookmarkToasts();

      var html = "<div class='bookmarkToastMsg' style='top:" + bookmark.topOffset + "px'>";
      html += "<div class='bookmarkToastMsg-wrapper'>";
      html += "<span class='swafont swafont-lg swafont-icon-bookmark-fill bookmark-icon'></span>";
      html += bookmark.name;
      html += "</div>";
      html += "</div>";

      $('.sw-script-pageview-container').append(html);

      $timeout(function () {
        $('.bookmarkToastMsg').css('opacity', 1);
      }, 100);

      bookmarkToastTimeoutHandle = $timeout(function () {
        $('.bookmarkToastMsg').remove();
      }, 3000);
    }

    function clearBookmarkToasts() {
      $timeout.cancel(bookmarkToastTimeoutHandle);
      $('.bookmarkToastMsg').remove();
    }

    function gotoPrevBookmark() {
      var previousBookmark = dbScripts.findBookmarkBefore(vm.sortedBookmarks, vm.chartScriptEditorState.currentBookmark, (vm.chartScriptEditorState.currentPageNumber - 1));
      if (!swaUtils.isUndefinedOrNull(previousBookmark)) {
        vm.gotoBookmark(previousBookmark);
      } else {
        toastr.warning($translate.instant('messages.no_previous_bookmark'));
      }
    }

    function gotoNextBookmark() {
      var nextBookmark = dbScripts.findBookmarkAfter(vm.sortedBookmarks, vm.chartScriptEditorState.currentBookmark, (vm.chartScriptEditorState.currentPageNumber - 1));
      if (!swaUtils.isUndefinedOrNull(nextBookmark)) {
        vm.gotoBookmark(nextBookmark);
      } else {
        toastr.warning($translate.instant('messages.no_more_bookmarks'));
      }
    }

    function gotoPage(pageNo) {
      var newPageNo = vm.chartScriptEditorState.currentPageNumber;
      if (pageNo === 'first') {
        if (vm.chartScriptEditorState.currentPageNumber !== 1) {
          newPageNo = 1;
        } else {
          return $q.resolve(true);
        }
      } else if (pageNo === 'prev') {
        if (vm.chartScriptEditorState.currentPageNumber > 1) {
          newPageNo--;
        } else {
          return $q.resolve(true);
        }
      } else if (pageNo === 'next') {
        if (vm.chartScriptEditorState.currentPageNumber < vm.chartScriptEditorState.totalNumberOfPages) {
          newPageNo++;
        } else {
          return $q.resolve(true);
        }
      } else if (pageNo === 'last') {
        if (vm.chartScriptEditorState.currentPageNumber !== vm.chartScriptEditorState.totalNumberOfPages) {
          newPageNo = vm.chartScriptEditorState.totalNumberOfPages;
        } else {
          return $q.resolve(true);
        }
      } else {
        newPageNo = parseInt(pageNo);
      }

      if (isNaN(newPageNo) || (newPageNo < 1) || (newPageNo > vm.chartScriptEditorState.totalNumberOfPages)) {
        return $q.resolve(false);
      }

      var deferred = $q.defer();

      if (newPageNo !== vm.chartScriptEditorState.currentPageNumber) {
        var loaded = false;
        blockUI.start();
        cancelNewChartLink();
        saveScriptPage()
          .then(function () {
            blockUI.message('Please wait');
            return loadScriptPageAtIndex(newPageNo - 1);
          })
          .then(function () {
            lockModeHighlightChart();
            loaded = true;
          })
          .finally(function () {
            blockUI.stop();
            deferred.resolve(loaded);
          });
      } else {
        deferred.resolve(true);
      }

      return deferred.promise;
    }

    function lockModeHighlightChart() {
      if (vm.chartScriptEditorState.lockModeNavigation) {
        var chartlink = _.first(vm.currentScriptPage.chartlinks);
        if (angular.isDefined(chartlink)) {
          vm.chartScriptEditorState.lockHighlightChartId = chartlink.chartId;
          return openLinkedChart(chartlink.chartId);
        } else {
          vm.chartScriptEditorState.lockHighlightChartId = undefined;
        }
      }
    }

    function openLinkedChart(chartId) {
      var deferred = $q.defer();

      $q.when().then(
        function () {
          if (angular.isDefined(vm.selectedScene)) {
            return _.contains(vm.selectedScene.chartIds, chartId);
          } else {
            return false;
          }
        }
      ).then(
        function (found) {
          if (found) {
            return;
          }

          var parentScene = _.find(vm.scenes, function (scene) {
            return _.contains(scene.chartIds, chartId);
          });
          if (angular.isDefined(parentScene)) {
            return toggleScene(parentScene);
          }
        }
      ).then(
        function () {
          return $timeout(function () {
            vm.scrollUpdateSidebar('scrollTo', $('#chart-' + chartId).position().top - 40);
          }, 500);
        }
      ).finally(
        function () {
          deferred.resolve();
        }
      );

      return deferred.promise;
    }

    $scope.$watch('vm.gotoPagePicker.show', function (newValue, oldValue) {
      if (newValue === true) {
        vm.gotoPagePicker.pagenumber = vm.chartScriptEditorState.customPageNumber;
        vm.gotoPagePicker.invalidPageNumber = false;
        $timeout(function () {
          $('input#gotopagequick').focus();
        }, 500);
      }
    });

    $scope.$watch('vm.gotoPagePicker1.show', function (newValue, oldValue) {
      if (newValue === true) {
        vm.gotoPagePicker.pagenumber = vm.chartScriptEditorState.customPageNumber;
        vm.gotoPagePicker.invalidPageNumber = false;
        $timeout(function () {
          $('input#gotopagequick1').focus();
        }, 500);
      }
    });

    function gotoPageQuick() {
      var success = vm.gotoPage(vm.gotoPagePicker.pagenumber);
      if (success) {
        vm.gotoPagePicker.show = false;
        vm.gotoPagePicker1.show = false;
      } else {
        vm.gotoPagePicker.invalidPageNumber = true;
      }
    }

    function onOverLinkTarget(event, ui) {
      $timeout(function () {
        vm.newChartLinkTracker.dragOnTarget = true;
      });
    }

    function onOutLinkTarget(event, ui) {
      $timeout(function () {
        vm.newChartLinkTracker.dragOnTarget = false;
      });
    }

    function onDropLinkTarget(event, ui) {
      if (vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowchartaslinksource) {
        var draggableId = ui.draggable.attr('data-swa-chartid');

        if (vm.newChartLinkTracker.enableLinking) {
          var chartLink = {};
          chartLink.selectionrect = vm.newChartLinkTracker.selectionRect;
          chartLink.chartId = draggableId;

          vm.currentScriptPage.chartlinks.push(chartLink);
          markCurrentScriptPageDirty();

          resolveChartLinkName(chartLink);
        }

        vm.newChartLinkTracker.enableLinking = false;
        vm.newChartLinkTracker.dragOnTarget = false;

        saveScriptPage();
      } else {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to link charts form this scene'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
      }
    }

    function onDragStart() {
      //do nothing
    }

    var chartlinksLeftMouseDown = false;

    function onChartlinksContentMouseDown(event) {
      chartlinksLeftMouseDown = false;
      vm.newChartLinkTracker.isTracking = false;
      vm.newChartLinkTracker.enableLinking = false;
      vm.newChartLinkTracker.dragOnTarget = false;
      vm.newChartLinkTracker.selectionRect = {};

      if ((event.button === 0) && (event.target === chartlinksContentElement) && vm.activeAccessRules.allowscriptaslinktarget) {
        chartlinksLeftMouseDown = true;
        vm.newChartLinkTracker.isTracking = false;
        vm.newChartLinkTracker.startY = event.offsetY;
        vm.newChartLinkTracker.selectionRect.left = 0;
        vm.newChartLinkTracker.selectionRect.top = event.offsetY;
        vm.newChartLinkTracker.selectionRect.width = vm.currentScriptPage.pagewidth;
        vm.newChartLinkTracker.selectionRect.height = 1;
        vm.newChartLinkTracker.selectionRect.right = 0;
      }
    }

    function onChartlinksContentMouseMove(event) {
      if (chartlinksLeftMouseDown) {
        vm.newChartLinkTracker.isTracking = true;

        vm.newChartLinkTracker.selectionRect.top = Math.min(vm.newChartLinkTracker.startY, event.offsetY)
        vm.newChartLinkTracker.selectionRect.height = Math.abs(vm.newChartLinkTracker.startY - event.offsetY);
      }
    }

    function onChartlinksContentMouseUp(event) {
      if (!chartlinksLeftMouseDown) {
        return;
      }

      chartlinksLeftMouseDown = false;
      vm.newChartLinkTracker.isTracking = false;
      vm.newChartLinkTracker.enableLinking = false;

      if (vm.newChartLinkTracker.selectionRect.height < 32) {
        return;
      }

      if (!vm.activeAccessRules.allowscriptaslinktarget) {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access create links on this script'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );

        return;
      }

      var selectionRect = vm.newChartLinkTracker.selectionRect;
      if (selectionRect.top < 0) {
        selectionRect.height -= (-selectionRect.top);
        selectionRect.top = 0;
      }

      vm.newChartLinkTracker.enableLinking = true;
      vm.newChartLinkTracker.dragOnTarget = false;
    }

    function cancelNewChartLink() {
      vm.newChartLinkTracker.enableLinking = false;
    }

    function deleteChartLink(index) {
      vm.currentScriptPage.chartlinks.splice(index, 1);
      markCurrentScriptPageDirty();
      saveScriptPage();
    }

    function chartlinkMoved(index, dragData) {
      var chartLink = vm.currentScriptPage.chartlinks[index];

      chartLink.selectionrect.top = dragData.newSizePosition.top;

      markCurrentScriptPageDirty();
      // saveScriptPage();
    }

    function chartlinkResized(index, sizeData) {
      var chartLink = vm.currentScriptPage.chartlinks[index];

      chartLink.selectionrect.height = sizeData.newSizePosition.height;

      markCurrentScriptPageDirty();
      // saveScriptPage();
    }

    function shouldAllowChartLinkEdit(index) {
      if (vm.activeAccessRules.allowowneraccess) {
        return true;
      }

      if (!vm.activeAccessRules.allowscriptaslinktarget) {
        return false;
      }

      var chartLink = vm.currentScriptPage.chartlinks[index];
      var chartId = chartLink.chartId;
      var scene = _.find(vm.scenes, function (scene) {
        return _.contains(scene.chartIds, chartId);
      });

      if (angular.isDefined(scene)) {
        return scene.accessRules.allowchartaslinksource;
      } else {
        return false;
      }
    }

    function markCurrentScriptPageDirty() {
      vm.currentScriptPage.dirty = true;
    }

    function onSaveClick() {
      saveScriptPage();
    }

    function saveScriptPage() {
      var deferred = $q.defer();

      if (!angular.isObject(vm.currentScriptPage)) {
        deferred.resolve(true);
        return deferred.promise;
      }

      if (!vm.currentScriptPage.dirty) {
        $log.debug('saveScriptPage: No changes, nothing to save!');
        deferred.resolve(true);
        return deferred.promise;
      }

      ngProgressLite.start();
      blockUI.start('Saving');

      var updatedScriptPage = {};
      updatedScriptPage.chartlinks = [];
      angular.forEach(vm.currentScriptPage.chartlinks, function (link) {
        updatedScriptPage.chartlinks.push({
          selectionrect: link.selectionrect,
          chartId: link.chartId,
        });
      });
      updatedScriptPage._id = vm.currentScriptPage._id;

      dbScriptPages.update(updatedScriptPage).then(
        function () {
          vm.currentScriptPage.dirty = false;
          deferred.resolve();
        }
      ).catch(
        function (error) {
          $log.error('ChartScriptEditorController.saveScriptPage:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving changes!')
          );

          deferred.reject(error);
        }
      ).finally(
        function () {
          ngProgressLite.done();
          blockUI.stop();
        }
      );

      return deferred.promise;
    }

    function updateLeftAnnotationConnectorLines(annotation) {
      annotation.linex1 = annotation.selectionrect.left;
      annotation.linex2 = (annotation.positionrect.left + annotation.positionrect.width);
      annotation.liney2 = (annotation.positionrect.top + annotation.positionrect.height);

      if (annotation.annotationtype === 1 && annotation.connectingLineTop) {
        annotation.liney1 = (annotation.selectionrect.top);
      } else {
        annotation.liney1 = (annotation.selectionrect.top + annotation.selectionrect.height);
      }
    }

    function updateRightAnnotationConnectorLines(annotation) {
      if (annotation.annotationtype === 1 && annotation.markerStyle) {
        annotation.linex1 = annotation.selectionrect.left;
      } else {
        annotation.linex1 = (annotation.selectionrect.left + annotation.selectionrect.width);
      }

      annotation.linex2 = (vm.currentScriptPage.pagewidth / 2) + annotation.positionrect.left;
      annotation.liney2 = (annotation.positionrect.top + annotation.positionrect.height);

      if (annotation.annotationtype === 1 && annotation.connectingLineTop) {
        annotation.liney1 = (annotation.selectionrect.top);
      } else {
        annotation.liney1 = (annotation.selectionrect.top + annotation.selectionrect.height);
      }
    }

    function updateScriptCollaborationPrivileges() {
      var deferred = $q.defer();
      if (vm.activeCollaborationConfig.isProductionOwner === true) {
        if (vm.activePlanRules.planId === 2) {
          vm.activeAccessRules = angular.copy(defaultViewScriptAccessRules);
        } else {
          vm.activeAccessRules = angular.copy(defaultOwnerAccessRules);
        }
        deferred.resolve();
      } else {
        if (vm.activePlanRules.planId === 2) {
          vm.activeAccessRules = angular.copy(defaultViewScriptAccessRules);
        } else {
          vm.activeAccessRules = angular.copy(defaultDenyScriptAccessRules);
        }
        var params = {
          accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
          statename: swaRouterStateNames.chartscripteditor,
        };

        if (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel !== swaAccess.accesslevel.production) {
          params.allowscriptediting = vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.allowscriptediting;
        }

        dbCollaborationPrivileges.getCollaborationPrivileges(params)
          .then(function (privilegeData) {
            if (vm.activePlanRules.planId === 2) {
              vm.activeAccessRules.allowpersonalnotes = privilegeData.accessrules.allowpersonalnotes;
            } else {
              angular.extend(vm.activeAccessRules, privilegeData.accessrules);
            }
          })
          .catch(function (error) {
            $log.error('ChartScriptEditorController.updateScriptCollaborationPrivileges:', error);
          })
          .finally(function () {
            updateActiveAccessRules();
            deferred.resolve();
          });
      }

      return deferred.promise;
    }

    function updateSceneCollaborationAccessRules(scenes) {
      scenes.forEach(function (scene) {
        if (vm.activeCollaborationConfig.isProductionOwner === true) {
          if (vm.activePlanRules.planId === 2) {
            scene.accessRules = angular.copy(defaultViewSceneAccessRules);
          } else {
            scene.accessRules = angular.copy(defaultOwnerAccessRules);
          }
        } else {
          if (vm.activePlanRules.planId === 2) {
            scene.accessRules = angular.copy(defaultViewSceneAccessRules);
          } else {
            scene.accessRules = angular.copy(defaultDenySceneAccessRules);
            if (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel !== swaAccess.accesslevel.custom) {
              var params = {
                statename: swaRouterStateNames.chartscripteditor,
                accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
              };

              dbCollaborationPrivileges.getCollaborationPrivileges(params).then(
                function (privilegeData) {
                  angular.extend(scene.accessRules, privilegeData.accessrules);
                },
                function (error) {
                  $log.error('ChartScriptEditorController.updateSceneCollaborationAccessRules:', error);
                }
              );
            } else {
              var sceneAccess = _.findWhere(vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.sceneaccess, {
                sceneId: scene._id
              });
              if (angular.isDefined(sceneAccess)) {
                var params1 = {
                  statename: swaRouterStateNames.chartscripteditor,
                  accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
                  allowchartediting: sceneAccess.allowchartediting,
                };

                dbCollaborationPrivileges.getCollaborationPrivileges(params1).then(
                  function (privilegeData) {
                    angular.extend(scene.accessRules, privilegeData.accessrules);
                  },
                  function (error) {
                    $log.error('ChartScriptEditorController.updateSceneCollaborationAccessRules:', error);
                  }
                );
              }
            }
          }
        }
      });
    }

    function updateActiveAccessRules() {
      if (angular.isDefined(vm.selectedScene)) {
        angular.extend(vm.activeAccessRules, vm.selectedScene.accessRules);
      } else {
        angular.extend(vm.activeAccessRules, defaultDenySceneAccessRules);
      }

      vm.activeAccessRules.allowchartscriptlinking = vm.activeAccessRules.allowowneraccess || (vm.activeAccessRules.allowchartaslinksource && vm.activeAccessRules.allowscriptaslinktarget);
    }

    function showHelpHints() {
      var showHowToLinkChartScript = true;
      if (angular.isDefined(vm.userData.preferences) && angular.isDefined(vm.userData.preferences.web)) {
        showHowToLinkChartScript = !(vm.userData.preferences.web.showHowToLinkChartScript === false);
      }

      if (showHowToLinkChartScript && vm.activeAccessRules.allowscriptaslinktarget) {
        toastr.info(
          $translate.instant('messages.Create a selection on the page and drag over a chart to link that area with the chart<br/><br/>Click if you don\'t want to see this hint again'),
          $translate.instant('titles.Hint - How to Link'), {
          allowHtml: true,
          onTap: dontShowAgainHowToLinkChartScript,
        }
        );
      }
    }

    function dontShowAgainHowToLinkChartScript() {
      var dbUser = new DbUser();
      dbUser.updateWebPreference('showHowToLinkChartScript', false);
    }

    function initHelpTour() {
      vm.showHelpBar = false;
      var profileDisplayHelp = false;
      if (angular.isDefined(vm.userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || vm.userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }

      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function initHelpTourSteps() {
      vm.helpTourSteps = [{
        element: '#menu-locknavigation',
        title: $translate.instant('helptour.editor.titles.menu-locknavigation'),
        content: $translate.instant('helptour.editor.messages.menu-locknavigation'),
        placement: 'bottom',
      }, {
        element: '#menu-switchview',
        title: $translate.instant('helptour.editor.titles.menu-switchview'),
        content: $translate.instant('helptour.editor.messages.menu-switchview'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptbookmarknavigationcontrols',
        title: $translate.instant('helptour.scriptEditor.titles.menu-scriptbookmarknavigationcontrols'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-scriptbookmarknavigationcontrols'),
        placement: 'bottom',
      }, {
        element: '#menu-togglebookmarklist',
        title: $translate.instant('helptour.scriptEditor.titles.menu-togglebookmarklist'),
        content: $translate.instant('helptour.scriptEditor.messages.menu-togglebookmarklist'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptannotationsvisibility',
        title: $translate.instant('helptour.chartScriptEditor.titles.menu-scriptannotationsvisibility'),
        content: $translate.instant('helptour.chartScriptEditor.messages.menu-scriptannotationsvisibility'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptpagenavigationcontrols',
        title: $translate.instant('helptour.chartScriptEditor.titles.menu-scriptpagenavigationcontrols'),
        content: $translate.instant('helptour.chartScriptEditor.messages.menu-scriptpagenavigationcontrols'),
        placement: 'bottom',
      }, {
        element: '#menu-scriptgotopage',
        title: $translate.instant('helptour.chartScriptEditor.titles.menu-scriptgotopage'),
        content: $translate.instant('helptour.chartScriptEditor.messages.menu-scriptgotopage'),
        placement: 'bottom',
      }, {
        element: '#menu-savechanges',
        title: $translate.instant('helptour.editor.titles.menu-savechanges'),
        content: $translate.instant('helptour.editor.messages.menu-savechanges'),
        placement: 'left',
      }, {
        element: '#menu-createpdf',
        title: $translate.instant('helptour.editor.titles.menu-createpdf'),
        content: $translate.instant('helptour.editor.messages.menu-createpdf'),
        placement: 'left',
      }, {
        element: '#menu-collaborators',
        title: $translate.instant('helptour.editor.titles.menu-collaborators'),
        content: $translate.instant('helptour.editor.messages.menu-collaborators'),
        placement: 'left',
      }, {
        element: '#menu-settings',
        title: $translate.instant('helptour.editor.titles.menu-settings'),
        content: $translate.instant('helptour.editor.messages.menu-settings'),
        placement: 'left',
      }, {
        element: '#sidebar-scenelist',
        title: $translate.instant('helptour.chartScriptEditor.titles.sidebar-scenelist'),
        content: $translate.instant('helptour.chartScriptEditor.messages.sidebar-scenelist'),
        placement: 'right',
      }, {
        element: '#button-closeproduction',
        title: $translate.instant('helptour.editor.titles.button-closeproduction'),
        content: $translate.instant('helptour.editor.messages.button-closeproduction'),
        placement: 'right',
      },];

      vm.helpTourVideos = [
        {
          label: 'Link Charts & Script',
          videoUrl: 'https://www.youtube.com/embed/_ANet-92uMc?si=QKNcpvSRXYlJvTfS&amp;start=471'
        }
      ];
    }

    function onHelpTourStart() {
      vm.helpTourRunning = true;
    }

    function onHelpTourEnd() {
      vm.helpTourRunning = false;
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        saveScriptPage();
      }
    });

    $scope.$on('$destroy', function () {
      swPdfPrintService.unregisterForChange(vm);
      dbProductions.fetchUnregister();
      dbScenes.fetchUnregister();
      dbCharts.fetchUnregister();
      $interval.cancel(preloadTimer);
      unregisterKeyboardHandler();
    });

    function keyboardHandler(event) {
      if (keyboardHandlerCheckTarget(event)) {
        return;
      }

      if (vm.helpTourRunning) {
        return;
      }

      // key
      var whichKey = event.which;
      var key = event.key;

      // modifier keys and combos
      var ctrlKey = event.ctrlKey && !(event.altKey || event.shiftKey || event.metaKey);
      var ctrlShiftKey = event.ctrlKey && event.shiftKey && !(event.altKey || event.metaKey);
      var metaKey = event.metaKey && !(event.altKey || event.shiftKey || event.ctrlKey);
      var metaShiftKey = event.metaKey && event.shiftKey && !(event.altKey || event.ctrlKey);
      var noModKey = !(event.ctrlKey || event.altKey || event.shiftKey || event.metaKey);

      // navigation control
      if (whichKey === 37) {
        if (ctrlKey) {
          gotoPage('first');
        } else {
          gotoPage('prev');
        }
        event.stopPropagation();
        event.preventDefault();

        return;
      } else if (whichKey === 39) {
        if (ctrlKey) {
          gotoPage('last');
        } else {
          gotoPage('next');
        }
        event.stopPropagation();
        event.preventDefault();

        return;
      }

      // Esc key
      if (whichKey === 27) {
        if (vm.chartScriptEditorState.lockModeNavigation) {
          toggleLockModeNavigation();
        }
        return;
      }
    }

    function keyboardHandlerCheckTarget(event) {
      var target = event.target;

      if (vm.chartScriptEditorState.lockModeNavigation) {
        return false;
      } else if ((target.nodeName === 'INPUT') || (target.nodeName === 'TEXTAREA')) {
        return true;
      } else {
        return target.attributes.contenteditable;
      }
    }

    function registerKeyboardHandler() {
      $log.debug('ChartScriptEditorController: registerKeyboardHandler:');
      $(document).on('keydown', keyboardHandler);

      tryIdentifyPlatform();
    }

    function unregisterKeyboardHandler() {
      $log.debug('ChartScriptEditorController: unregisterKeyboardHandler:');
      $(document).off('keydown', keyboardHandler);
    }

    function tryIdentifyPlatform() {
      vm.platformMac = (navigator.platform && (navigator.platform.match(/mac/i) !== null)) || (navigator.userAgent.match(/Macintosh/i) !== null);
    }

    function toggleLockModeNavigation() {
      if (vm.chartScriptEditorState.lockModeNavigation) {
        blockUI.start('Leaving lock mode');
      } else {
        blockUI.start('Enabling lock mode');
      }

      saveScriptPage().then(
        function () {
          vm.chartScriptEditorState.lockModeNavigation = !vm.chartScriptEditorState.lockModeNavigation;

          if (vm.chartScriptEditorState.lockModeNavigation) {
            vm.chartScriptEditorState.activeAnnotationType = -1;
            vm.chartScriptEditorState.annotationsVisible = true;
            lockModeHighlightChart();
          }

          angular.element('.sw-maincontentarea-chartscript > .mCustomScrollBox').focus();
        }
      ).finally(
        function () {
          blockUI.stop();
        }
      )
    }

    function activateMasterNotesLayer() {
      vm.chartScriptEditorState.personalLayerActive = false;
      vm.chartScriptEditorState.masterLayerActive = true;
    }

    function activatePersonalNotesLayer() {
      vm.chartScriptEditorState.masterLayerActive = false;
      vm.chartScriptEditorState.personalLayerActive = true;
    }

    var preloadTimer = null;
    var preloadIds = [];
    function beginPreloadScriptPages() {
      if (preloadTimer) {
        $interval.cancel(preloadTimer);
      }

      preloadIds = [];
      dbScriptPages.getIdsOfPages(vm.script._id)
        .then(function (pageIds) {
          preloadIds = pageIds;
        })
        .then(function () {
          preloadTimer = $interval(preloadNextScriptPage, 500);
        })
        .catch(function (error) {
          $log.error('ScriptEditorController.beginPreloadScriptPages:', error);
        });
    }

    function preloadNextScriptPage() {
      while (preloadIds.length > 0) {
        var pageId = preloadIds.shift();
        if (!swaPdfToImage.isContentCached(pageId)) {
          $log.debug('Preloading page:', pageId);
          swaPdfToImage.getPageContentImage(pageId);
          break;
        }
      }
    }

    function findAndGoToPageNoFromCustomPageNumber() {
      var deferred = $q.defer();
      var customPageNumber = vm.gotoPagePicker.pagenumber;

      ngProgressLite.start();
      dbScriptPages.findInScriptByCustomPageNumber(vm.script._id, customPageNumber, vm.currentScriptPage.orderingindex)
        .then(function (page) {
          if (angular.isDefined(page)) {
            vm.gotoPage(page.orderingindex + 1)
              .then(function (loaded) {
                if (loaded) {
                  vm.gotoPagePicker.show = false;
                  vm.gotoPagePicker1.show = false;
                } else {
                  vm.gotoPagePicker.invalidPageNumber = true;
                }
              });
          } else {
            vm.gotoPagePicker.invalidPageNumber = true;
          }
        })
        .catch(function (error) {
          vm.gotoPagePicker.invalidPageNumber = true;
          deferred.reject(error);
        })
        .finally(function () {
          blockUI.stop();
          ngProgressLite.done();
        });

      return deferred.promise;

    }

    function updateMarginCss() {
      var el = $document[0].getElementById('scriptPageImage');
      el.style.paddingLeft = vm.currentScriptPage.leftmargin + 'px';
      el.style.paddingRight = vm.currentScriptPage.rightmargin + 'px';
    }

    function changeActionAnnotationType() {
      var deferred = $q.defer();
      ngProgressLite.start();

      dbScriptPages.changeActionAnnotationType(vm.script._id)
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('ChartScriptEditorController.changeActionAnnotationType:', error);
          deferred.reject(error);
        })
        .finally(function () {
          ngProgressLite.done();
        });

      return deferred.promise;
    }

    function updateSharedAnnotationLayers() {
      if (vm.userScript && angular.isArray(vm.userScript.sharedannotationlayers)) {
        if (vm.script && angular.isArray(vm.script.annotationlayers)) {
          var scriptLayerIds = vm.script.annotationlayers.map(function (layer) { return layer.layerid; });
          vm.userScript.sharedannotationlayers = vm.userScript.sharedannotationlayers.filter(function (layer) {
            return scriptLayerIds.indexOf(layer.layerid) !== -1;
          });

          var sharedIds = vm.userScript.sharedannotationlayers.map(function (layer) { return layer.layerid; });
          var additionalLayers = vm.script.annotationlayers.filter(function (layer) {
            return layer.isShared === true && sharedIds.indexOf(layer.layerid) === -1;
          });

          vm.userScript.sharedannotationlayers.forEach(function (layer) {
            var scriptLayer = vm.script.annotationlayers.find(function (sl) { return sl.layerid === layer.layerid; });
            if (scriptLayer && scriptLayer.isShared === true && angular.isString(scriptLayer.name) && layer.name !== scriptLayer.name) {
              layer.name = scriptLayer.name;
            }
          });

          vm.userScript.sharedannotationlayers = vm.userScript.sharedannotationlayers.filter(function (layer) {
            var scriptLayer = vm.script.annotationlayers.find(function (sl) { return sl.layerid === layer.layerid; });
            return !(scriptLayer && scriptLayer.isShared === false);
          });

          vm.sharedannotationlayers = vm.userScript.sharedannotationlayers.concat(additionalLayers);
        }
      } else {
        if (vm.script && angular.isArray(vm.script.annotationlayers)) {
          vm.sharedannotationlayers = vm.script.annotationlayers.filter(function (layer) {
            return layer.isShared === true;
          });
        }

        vm.sharedannotationlayers.forEach(function (layer) {
          if (angular.isUndefined(layer.isVisibleToCollaborators)) {
            layer.isVisibleToCollaborators = true;
          }
        });
      }

      var scriptLayerOrder = vm.script.annotationlayers.map(function (layer) { return layer.layerid; });
      vm.sharedannotationlayers = vm.sharedannotationlayers.sort(function (a, b) {
        return scriptLayerOrder.indexOf(a.layerid) - scriptLayerOrder.indexOf(b.layerid);
      });
    }
  }
}());

(function () {
    'use strict';
    angular.module('swanywhere').controller('UndoReassignmentController', UndoReassignmentController);
  
    UndoReassignmentController.$inject = [
      '$uibModalInstance'
    ];
  
    function UndoReassignmentController($uibModalInstance) {
      var vm = this;
  
      vm.actionYes = actionYes;
      vm.actionNo = actionNo;
  
      function actionYes() {
        $uibModalInstance.close();
      }
  
      function actionNo() {
        $uibModalInstance.dismiss('cancel');
      }
    }
  }());
  
(function () {
    'use strict';

    angular.module('swanywhere').controller('ToggleToolbarVisibilityController', ToggleToolbarVisibilityController);

    ToggleToolbarVisibilityController.$inject = ['$uibModalInstance'];

    function ToggleToolbarVisibilityController($uibModalInstance) {
        var vm = this;

        vm.actionOk = actionOk;

        function actionOk() {
            $uibModalInstance.close();
        }
    }
}());

(function () {
    'use strict';

    angular.module('swanywhere').controller('RestoreChartPermissionMessageController', RestoreChartPermissionMessageController);

    RestoreChartPermissionMessageController.$inject = ['$uibModalInstance'];

    function RestoreChartPermissionMessageController($uibModalInstance) {
        var vm = this;

        vm.actionOk = actionOk;

        function actionOk() {
            $uibModalInstance.close();
        }
    }
}());

(function () {
    'use strict';
    angular.module('swanywhere').controller('PerformerTrackReassignmentController', PerformerTrackReassignmentController);

    PerformerTrackReassignmentController.$inject = [
        '$uibModalInstance',
        'params',
        'DbCharts',
        '$timeout',
        'DbPerformers',
        'DbChartItems',
        '$q',
        'ngProgressLite',
        'blockUI',
    ];

    function PerformerTrackReassignmentController($uibModalInstance, params, DbCharts, $timeout, DbPerformers, DbChartItems, $q, ngProgressLite, blockUI) {

        var dbCharts = new DbCharts();
        var dbPerformers = new DbPerformers();
        var dbChartItems = new DbChartItems();

        var vm = this;
        vm.performers = params.performers;
        vm.activePlanRules = params.activePlanRules;
        vm.scenes = params.scenes;
        vm.selectedPerformers = params.selectedPerformers;
        vm.selectedScene = params.selectedScene;
        vm.chartEditorState = params.chartEditorState;
        vm.production = params.production;
        vm.selectedChart = params.selectedChart;

        vm.reassignmentState = {
            selectTargetSceneOrCharts: false,
            selectionCountForCharts: 0,
            selectionCountForScenes: 0,
        }

        vm.deleteOrReorderState = {
            enabled: false,
        }

        vm.performerDropTargetTracker = false;

        vm.performersPairsForSwapping = [];
        vm.finalPerformersPairsForSwapping;
        vm.performersPairsForSwappingBackup;

        vm.searchperformername = '';
        vm.searchStringUpper = '';

        vm.scrollConfigSidebar = {
            theme: 'swa-minimal',
            axis: 'y',
            scrollbarPosition: 'outside',
            scrollInertia: 0,
            scrollButtons: {
                enable: false,
            },
            mouseWheel: {
                scrollAmount: 50,
            },
            autoHideScrollbar: true,
            advanced: {
                updateOnContentResize: true,
            },
        };

        vm.pairSortableOptions = {
            handle: '.swafont-icon-menu',
            cursor: 'ns-resize',
            axis: 'y',
            opacity: 0.8,
            disabled: true,
            tolerance: "pointer",
            stop: pairDragSortStop,
        };


        vm.actionYes = actionYes;
        vm.actionNo = actionNo;
        vm.searchStringChanged = searchStringChanged;
        vm.clearSearch = clearSearch;
        vm.performerSearchFilter = performerSearchFilter;
        vm.showTargetSceneOrChartList = showTargetSceneOrChartList;
        vm.showPerformersList = showPerformersList;
        vm.toggleSelectedScene = toggleSelectedScene;
        vm.enableDeleteOrReorderState = enableDeleteOrReorderState;
        vm.disableDeleteOrReorderState = disableDeleteOrReorderState;
        vm.deletePerformerPair = deletePerformerPair;
        vm.onDragStart = onDragStart;
        vm.onDragStop = onDragStop;
        vm.onDropTarget = onDropTarget;
        vm.toggleChartSelection = toggleChartSelection;
        vm.toggleSceneSelection = toggleSceneSelection;
        vm.clearAllChartAndSceneSelections = clearAllChartAndSceneSelections;
        vm.selectEntireProduction = selectEntireProduction;

        initialize();

        function initialize() {
            findChartsForAllScenes(vm.scenes);
            addSelectedPerformersInPerformerPair(vm.selectedPerformers);

            if (vm.selectedScene) {
                vm.selectedScene.openForModal = true;
            }
        }

        function findChartsForAllScenes(scenes) {
            var deferred = $q.defer();
            ngProgressLite.start();
            blockUI.start('Please wait ...');
            scenes.forEach(function (scene) {
                if (angular.isDefined(scene) && angular.isDefined(scene._id)) {
                    dbCharts.getChartsInScene(scene._id)
                        .then(function (result) {
                            scene.charts = result;
                            deferred.resolve();
                        })
                        .catch(function (e) {
                            deferred.reject(e);
                        })
                        .finally(function () {
                            selectCurrentSelectedChartForSwap(vm.selectedChart);
                            ngProgressLite.done();
                            blockUI.stop();
                        });
                }
            });

            return deferred.promise;
        }

        function addSelectedPerformersInPerformerPair(performers) {
            if (angular.isDefined(performers) && performers.length > 0) {
                performers.forEach(function (performer) {
                    vm.performersPairsForSwapping.push({
                        performerToBeChanged: performer,
                        performerToBeChangedWith: null,
                        index: vm.performersPairsForSwapping.length,
                    });
                })

            }

            vm.finalPerformersPairsForSwapping = vm.performersPairsForSwapping.filter(isValidPerformerPair);
        }

        function isValidPerformerPair(pair) {
            return angular.isDefined(pair.performerToBeChanged) && pair.performerToBeChanged !== null &&
                angular.isDefined(pair.performerToBeChangedWith) && pair.performerToBeChangedWith !== null;
        }

        function checkPerformersSameById(pair) {
            return pair.performerToBeChanged._id !== pair.performerToBeChangedWith._id;
        }

        function showPerformersList() {
            clearSearch();
            vm.reassignmentState.selectTargetSceneOrCharts = false;
            vm.performersPairsForSwapping = vm.performersPairsForSwappingBackup;
            vm.finalPerformersPairsForSwapping = vm.performersPairsForSwapping.filter(isValidPerformerPair);
        }

        function showTargetSceneOrChartList() {
            vm.reassignmentState.selectTargetSceneOrCharts = true;
            vm.performersPairsForSwappingBackup = angular.copy(vm.performersPairsForSwapping);

            vm.performersPairsForSwapping = vm.performersPairsForSwapping.filter(isValidPerformerPair);
            vm.performersPairsForSwapping = vm.performersPairsForSwapping.filter(checkPerformersSameById);

            $timeout(function () {
                vm.scrollUpdateChartList('scrollTo', $('#chart-' + vm.selectedChart._id).position().top - 50);
                if (vm.reassignmentState.selectionCountForCharts > 1) {
                    vm.selectedChart = null;
                }
            });
        }

        function actionYes() {
            var chartIdsToSwap = [];
            vm.scenes.forEach(function (scene) {
                scene.charts.forEach(function (chart) {
                    if (chart.editSelectedForReassignment) {
                        chartIdsToSwap.push(chart._id);
                    }
                });
            });

            var performerPairsWithIds = vm.performersPairsForSwapping.map(function (pair) {
                return {
                    performerToBeChangedId: pair.performerToBeChanged._id,
                    performerToBeChangedWithId: pair.performerToBeChangedWith._id
                };
            });

            var promises = performerPairsWithIds.map(function (pair) {
                return dbChartItems.getChartItemsForPerformer(pair.performerToBeChangedId, chartIdsToSwap)
                    .then(function (result) {
                        pair.chartItemsForPerformerToBeChanged = result;
                    })
                    .catch(function (err) {
                        $log.error('reassignPerformer:', err);
                    });
            });

            $q.all(promises).then(function () {
                clearAllChartAndSceneSelections();
                $uibModalInstance.close(performerPairsWithIds);
            });
        }

        function actionNo() {
            $uibModalInstance.dismiss('cancel');
            vm.reassignmentState.selectTargetSceneOrCharts = false;
        }

        function searchStringChanged() {
            vm.searchStringUpper = vm.searchperformername.toUpperCase();
        }

        function clearSearch() {
            vm.searchStringUpper = '';
            vm.searchperformername = '';
        }

        function performerSearchFilter(performer) {
            return performer.name.toUpperCase().indexOf(vm.searchStringUpper) > -1 || performer.text.toUpperCase().indexOf(vm.searchStringUpper) > -1;
        }

        function toggleSelectedScene(scene) {
            if (vm.selectedScene === scene) {
                vm.selectedScene.openForModal = false;
                vm.selectedScene = null;
            } else {
                vm.selectedScene = scene;
                vm.selectedScene.openForModal = true;
                $timeout(function () {
                    vm.scrollUpdateChartList('scrollTo', $('#chart-' + vm.selectedScene.charts[0]._id).position().top - 50);
                });
            }
        };

        function enableDeleteOrReorderState() {
            vm.deleteOrReorderState.enabled = true;
            vm.pairSortableOptions.disabled = false;
        }

        function disableDeleteOrReorderState() {
            vm.finalPerformersPairsForSwapping = vm.performersPairsForSwapping.filter(isValidPerformerPair);
            vm.deleteOrReorderState.enabled = false;
            vm.pairSortableOptions.disabled = true;
        }

        function deletePerformerPair(index) {
            vm.performersPairsForSwapping.splice(index, 1);
        }

        function pairDragSortStop(e, ui) {
            var pairsToUpdate = angular.copy(vm.performersPairsForSwapping);

            for (var i = 0; i < pairsToUpdate.length; i++) {
                pairsToUpdate[i].index = i;
            }
            vm.performersPairsForSwapping = pairsToUpdate;
        }

        function onDragStart() {
            $timeout(function () {
                vm.performerDropTargetTracker = true;
            });
        }

        function onDragStop() {
            $timeout(function () {
                vm.performerDropTargetTracker = false;
            });
        }

        function onDropTarget(event, ui) {
            var draggablePerformer = JSON.parse(ui.draggable.attr('data-swa-performer'));
            var dropTargetId = $(event.target).attr('id');

            if (dropTargetId === "performerToBeChanged") {
                vm.performersPairsForSwapping.push(
                    {
                        performerToBeChanged: draggablePerformer,
                        performerToBeChangedWith: null,
                        index: vm.performersPairsForSwapping.length,
                    }
                )
            }
            else if (dropTargetId.startsWith("with-")) {
                var index = parseInt(dropTargetId.replace('with-', ''), 10);

                if (index >= 0 && index < vm.performersPairsForSwapping.length) {
                    var pair = vm.performersPairsForSwapping[index];
                    if (pair.performerToBeChanged !== null) {
                        pair.performerToBeChangedWith = draggablePerformer;
                    }
                    if (index === vm.performersPairsForSwapping.length - 1) {
                        vm.performersPairsForSwapping.push(
                            {
                                performerToBeChanged: draggablePerformer,
                                performerToBeChangedWith: null,
                                index: vm.performersPairsForSwapping.length,
                            }
                        )
                    }
                }
            }
            else if (dropTargetId.startsWith("toBe-")) {
                var index = parseInt(dropTargetId.replace('toBe-', ''), 10);

                if (index >= 0 && index < vm.performersPairsForSwapping.length) {
                    var pair = vm.performersPairsForSwapping[index];
                    pair.performerToBeChanged = draggablePerformer;
                }
            }

            vm.finalPerformersPairsForSwapping = vm.performersPairsForSwapping.filter(isValidPerformerPair);
            vm.performerDropTargetTracker = false;
        }

        function selectCurrentSelectedChartForSwap(chart) {
            if (angular.isDefined(chart)) {
                vm.scenes.forEach(function (scene) {
                    scene.charts.forEach(function (checkChart) {
                        if (checkChart._id === chart._id) {
                            vm.reassignmentState.selectionCountForCharts += 1;
                            checkChart.editSelectedForReassignment = true;
                        }
                    });
                });
            }
        }

        function toggleChartSelection(chart, scene) {
            if (chart.editSelectedForReassignment) {
                vm.reassignmentState.selectionCountForCharts -= 1;
                chart.editSelectedForReassignment = false;
                vm.selectedChart = chart;
            } else {
                vm.reassignmentState.selectionCountForCharts += 1;
                chart.editSelectedForReassignment = true;
                vm.selectedChart = chart;
            }

            var allChartsSelected = true;
            for (var i = 0; i < scene.charts.length; i++) {
                if (!scene.charts[i].editSelectedForReassignment) {
                    allChartsSelected = false;
                    break;
                }
            }

            scene.editSelectedForReassignment = allChartsSelected;

            vm.scenes.forEach(function (checkScene) {
                if (checkScene !== scene) {
                    checkScene.editSelectedForReassignment = false;
                    checkScene.charts.forEach(function (chart) {
                        chart.editSelectedForReassignment = false;
                    })
                }
            });
        }

        function toggleSceneSelection(scene) {
            var allFalse = vm.scenes.every(function (scene) {
                return !scene.editSelectedForReassignment;
            });
            if (allFalse) {
                clearAllChartAndSceneSelections();
            }

            if (scene.editSelectedForReassignment) {
                vm.reassignmentState.selectionCountForScenes -= 1;
                scene.editSelectedForReassignment = false;
                scene.charts.forEach(function (chart) {
                    vm.reassignmentState.selectionCountForCharts -= 1;
                    chart.editSelectedForReassignment = false;
                })
            } else {
                vm.reassignmentState.selectionCountForScenes += 1;
                scene.editSelectedForReassignment = true;
                scene.charts.forEach(function (chart) {
                    vm.reassignmentState.selectionCountForCharts += 1;
                    chart.editSelectedForReassignment = true;
                })
            }
        }

        function clearAllChartAndSceneSelections() {
            vm.scenes.forEach(function (scene) {
                scene.editSelectedForReassignment = false;
                scene.charts.forEach(function (chart) {
                    chart.editSelectedForReassignment = false;
                })
            })
            vm.reassignmentState.selectionCountForScenes = 0;
            vm.reassignmentState.selectionCountForCharts = 0;
        }

        function selectEntireProduction() {
            vm.scenes.forEach(function (scene) {
                vm.reassignmentState.selectionCountForScenes += 1;
                scene.editSelectedForReassignment = true;
                scene.charts.forEach(function (chart) {
                    vm.reassignmentState.selectionCountForCharts += 1;
                    chart.editSelectedForReassignment = true;
                })
            })
        }
    }
}());

(function () {
    'use strict';
    angular.module('swanywhere').controller('PdfPrintOptionPromptController', PdfPrintOptionPromptController);

    PdfPrintOptionPromptController.$inject = ['$uibModalInstance', 'params', '$scope'];

    function PdfPrintOptionPromptController($uibModalInstance, params, $scope) {
        var vm = this;

        vm.printOptionsParams = {};

        vm.printOptionsParams.chartNotes = false;
        vm.printOptionsParams.chartLinks = false;
        vm.printOptionsParams.scaleAllPerformers = false;
        vm.printOptionsParams.scaleSelectedPerformers = false;
        vm.printOptionsParams.sharedLayerAnnotations = false;
        vm.printOptionsParams.type = params.type;
        vm.printOptionsParams.permissionToPrintSharedLayers = params.permissionToPrintSharedLayers;

        vm.actionYes = actionYes;
        vm.actionNo = actionNo;

        function actionYes() {
            $uibModalInstance.close(vm.printOptionsParams);
        }

        function actionNo() {
            $uibModalInstance.dismiss();
        }

        $scope.$watch('vm.printOptionsParams.scaleAllPerformers', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if (newValue === true) {
                    vm.printOptionsParams.scaleSelectedPerformers = false;
                }
            }
        }, true);

        $scope.$watch('vm.printOptionsParams.scaleSelectedPerformers', function (newValue, oldValue) {
            if (newValue !== oldValue) {
                if (newValue === true) {
                    vm.printOptionsParams.scaleAllPerformers = false;
                }
            }
        }, true);
    }
}());

(function () {
  'use strict';
  angular.module('swanywhere').controller('PasteFilteredClipboardPromptController', PasteFilteredClipboardPromptController);

  PasteFilteredClipboardPromptController.$inject = [
    '$uibModalInstance'
  ];

  function PasteFilteredClipboardPromptController($uibModalInstance) {
    var vm = this;

    vm.actionYes = actionYes;
    vm.actionNo = actionNo;

    function actionYes() {
      $uibModalInstance.close();
    }

    function actionNo() {
      $uibModalInstance.dismiss('cancel');
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').controller('EditMediaPromptController', EditMediaPromptController);

  EditMediaPromptController.$inject = [
    '$uibModalInstance',
    '$timeout',
    'mediaDetails',
  ];

  /**
   * The Controller.
   * @param {*} $uibModalInstance 
   * @param {*} $timeout 
   * @param {ChartItemMediaDetails} mediaDetails The media details, resolved by the caller
   */
  function EditMediaPromptController($uibModalInstance, $timeout, mediaDetails) {
    var vm = this;

    vm.mediaDetails = mediaDetails;

    vm.updateMode = false;
    vm.submit = submit;
    vm.cancel = cancel;

    vm.$onInit = onInit;

    function onInit() {
      if (angular.isDefined(mediaDetails)) {
        vm.updateMode = true;
      } else {
        vm.mediaDetails = { title: '', url: ''};
      }
      $timeout(function () {
        angular.element('input#videoTitle').focus();
      }, 500);
    }

    function submit(form) {
      if (form.$invalid) {
        return;
      }

      $uibModalInstance.close(vm.mediaDetails);
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
}());

(function () {
    'use strict';

    angular.module('swanywhere').controller('DeleteMoveOptionHintController', DeleteMoveOptionHintController);

    DeleteMoveOptionHintController.$inject = ['$uibModalInstance'];

    function DeleteMoveOptionHintController($uibModalInstance) {
        var vm = this;

        vm.actionOk = actionOk;

        function actionOk() {
            $uibModalInstance.close();
        }
    }
}());

(function () {
    'use strict';
    angular.module('swanywhere').controller('DeleteChartController', DeleteChartController);
  
    DeleteChartController.$inject = [
      '$uibModalInstance'
    ];
  
    function DeleteChartController($uibModalInstance) {
      var vm = this;
  
      vm.actionYes = actionYes;
      vm.actionNo = actionNo;
  
      function actionYes() {
        $uibModalInstance.close();
      }
  
      function actionNo() {
        $uibModalInstance.dismiss('cancel');
      }
    }
  }());
  
/* jshint bitwise: false, strict: false */
/* global cc, _ */
/* eslint-disable  */
'use strict';


/**
 * @typedef ChartItem
 * @type {object}
 * @property {string} _id - the object ID.
 */

/**
 * @typedef ChartItemMediaDetails
 * @type {object}
 * @property {string} title - media title.
 * @property {string} url - media URL.
 */

/**
 * @typedef {object} ChartItemMediaExt
 * @property {ChartItemMediaDetails} mediadetails - media details.
 */

/**
 * @typedef {ChartItem & ChartItemMediaExt} ChartItemMedia
 */

function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

var SWChartLayer = {
  Type: {
    Permanent: 0,
    SemiPermanent: 1,
    Dynamic: 2,
    SetPiece: 3,
    User: 4,
    None: 999,
  },
};

var SWChartUI = {
  ItemDynamicMode: {
    None: 0,
    Move: 1,
    Resize: 2,
    Rotation: 3
  },
  DesignWidth: 1000,
  DesignHeight: 600,
};

var SWSetPieceUI = {
  DesignWidth: 744,
  DesignHeight: 604,
};

var SWSetPiece = {
  Type: {
    Imported: 0,
    Created: 1,
    Stock: 2,
  },
  CustomSetPiece: {
    MaxWidthFeet: 16,
    MaxDepthFeet: 13,
  },
};

var SWChartItem = {
  // Chart - layer types
  LayerType: {
    Permanent: 0,
    SemiPermanent: 1,
    Dynamic: 2,
    SetPiece: 3,
    User: 4,
    None: 999,
  },

  // Chart - item types
  Type: {
    Performer: 0,
    SetPiece: 1,
    Shape: 2,
    Text: 3,
    TextPersonal: 4,
    /**
     * @deprecated - Use Media instead
     */
    Video: 5,
    Media: 6,
    Group: 99,
  },

  // Chart - shape types
  ShapeType: {
    Square: 0,
    Circle: 1,
    Triangle: 2,
    Arc: 3,
    SolidLine: 4,
    DottedLine: 5,
    ThinDottedLine: 6,
    ThickLine: 7,
    CurtainLine: 8,
    SolidLineArrow: 9,
    DottedLineArrow: 10,
    JoinedLine: 11,
    JoinedLineArrow: 12,
    Curve: 13,
    CurveArrow: 14,
    Freehand: 15,
  },

  SetPieceType: {
    Imported: 0,
    Created: 1,
    Stock: 2,
  },
};

var SWStage = {
  MeasurementUnitType: {
    Feet: 0,
    Meter: 1,
  },
};

var scaleUnitReferencePixels = 24.0;
var sizeHandleSize = scaleUnitReferencePixels * 2 / 3;
var chartBaseLineWidth = 4.0;

var setPieceEditorMaxWidthFeet = 16.0;
var setPieceEditorMaxDepthFeet = 13.0;

/////////////////////////////////////////////////
// ChartItemBaseView
//
// Base class for all chart layer items
var ChartItemBaseView = cc.Node.extend({

  _dynamicMode: SWChartUI.ItemDynamicMode.None,

  _offsetTransform: undefined,

  _selectionState: undefined,

  chartItemViewFactory: undefined,

  _viewRotation: 0.0,

  _zoomOffset: cc.p(),

  _povAudience: false,

  _zIndex: 0,

  _editabilityFlags: undefined,

  _touchState: undefined,

  isFlippable: false,

  ctor: function (chartItemViewFactory) {
    this._super();

    this._selectionState = {
      none: true,
      active: false,
      dynamic: false,
      zOrdering: false,
      inGroup: false,
      editing: false,
      rotationMode: false,
      snapToGridMode: false
    };

    this._editabilityFlags = {
      sizeable: false,
      rotatable: false,
      editable: false,
    };

    this._touchState = {};

    this.chartItemViewFactory = chartItemViewFactory;

    this._offsetTransform = cc.affineTransformMakeIdentity();
    this.setAdditionalTransform(this._offsetTransform);

    this._renderCmd.setChartZoom(this.chartItemViewFactory.zoomFactor);

    this.updateHandleSize();
  },

  updateHandleSize: function () {
    var zoomFactor = this.chartItemViewFactory.zoomFactor;
    if (zoomFactor > 2) {
      zoomFactor = 2;
    }

    this._touchState.handleSize = sizeHandleSize * zoomFactor;
  },

  refresh: function () {
    // To be overridden in child classes
    this.updateHandleSize();
    this.setNodeDirty();

    this._renderCmd.setChartZoom(this.chartItemViewFactory.zoomFactor);
  },

  updateEntity: function () {
    // To be overridden in child classes
  },

  getBackingEntity: function () {
    // To be overridden in child classes
  },

  setZoomOffset: function (zoomOffset, y) {
    if (y !== undefined) {
      zoomOffset = cc.p(zoomOffset, y);
    }

    if (!cc.pointEqualToPoint(zoomOffset, this._zoomOffset)) {
      this._zoomOffset = cc.p(zoomOffset);

      this._offsetTransform.tx = zoomOffset.x;
      this._offsetTransform.ty = zoomOffset.y;

      this.setNodeDirty();
    }
  },

  getZoomOffset: function () {
    return this._zoomOffset;
  },

  // Sets the rotation for this item, in radians
  setViewRotation: function (viewRotation) {
    this._viewRotation = viewRotation || 0.0;

    while (this._viewRotation > cc.TWOPI) {
      this._viewRotation -= cc.TWOPI;
    }
    while (this._viewRotation < 0) {
      this._viewRotation += cc.TWOPI;
    }

    this.rotation = this._viewRotation * cc.RADTODEG;

    this.ensureOnStage();
  },

  // gets the rotation for this item, in radians
  getViewRotation: function () {
    return this._viewRotation;
  },

  // Sets the view rotation, in degrees
  setViewRotationDeg: function (viewRotation) {
    this.setViewRotation(viewRotation * cc.DEGTORAD);
  },

  // gets the rotation for this item, in degrees
  getViewRotationDeg: function () {
    return (this._viewRotation * cc.RADTODEG);
  },

  moveAnchorPointKeepPosition: function (x, y) {
    var currAnchorPoint = this.getAnchorPoint();

    var currPosition = this.getPosition();
    var newPosition = cc.p();
    newPosition.x = currPosition.x + (x - currAnchorPoint.x) * this.width;
    newPosition.y = currPosition.y + (y - currAnchorPoint.y) * this.height;

    newPosition = cc.pRotateByAngle(newPosition, currPosition, -this.getViewRotation());

    this.setPosition(newPosition);
    this.setAnchorPoint(x, y);
  },

  // Touch begin handler
  onTouchBegan: function (touch, event) {
    if (this._selectionState.active) {
      this._touchState.activeBeforeTouch = true;
      this._touchState.touchBeginTimestamp = Date.now();
    } else {
      this._touchState.activeBeforeTouch = false;
      this._touchState.touchBeginTimestamp = 0;
      if (this.delegate && this.delegate.chartItemTouchToggle) {
        this.delegate.chartItemTouchToggle(this);
      }
    }

    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {

  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    if ((this._touchState.touchBeginTimestamp > 0) && this._selectionState.active) {
      var tapTime = Date.now() - this._touchState.touchBeginTimestamp;

      if (tapTime < 100) {
        if (this.delegate && this.delegate.chartItemTouchToggle) {
          this.delegate.chartItemTouchToggle(this);
        }
      }
    }

    if (this._selectionState.zOrdering) {
      this._selectionState.zOrdering = false;

      if (this.delegate && this.delegate.chartItemLayerModeEnded) {
        this.delegate.chartItemLayerModeEnded();
      }
    }

    this._touchState.activeAfterTouch = this._selectionState.active;
    this._touchState.activeChangedAfterTouch = (this._selectionState.active !== this._touchState.activeBeforeTouch);
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    if (this._selectionState.zOrdering) {
      this._selectionState.zOrdering = false;
    }
  },

  // Stage out of bounds check and adjust
  ensureOnStage: function () {
    // should be implemented in sub-classes if needed
  },

  // set active state of the item
  setActive: function (active) {
    this._selectionState.active = (active === true);

    this.setZOrdering(false);
    // this.setIsInRotationMode(false);

    if (this._selectionState.active === false) {
      this.updateEntity();
    }
  },

  // check if this item is active
  getIsActive: function () {
    return this._selectionState.active;
  },

  // sets the dynamic/moving state of this item
  setDynamic: function (dynamic) {
    this._selectionState.dynamic = (dynamic === true);
  },

  // gets if this item is dynamic/moving
  getIsDynamic: function () {
    return this._selectionState.dynamic;
  },

  setDynamicMode: function (dynamicMode) {
    this._dynamicMode = dynamicMode;
    if (this._dynamicMode == SWChartUI.ItemDynamicMode.Rotation) {
      this.delegate.setRotatingChartItemView(this);
    } else {
      this.delegate.setRotatingChartItemView(undefined);
    }
  },

  getDynamicMode: function () {
    return this._dynamicMode;
  },

  // sets if this item is being z-ordered
  setZOrdering: function (zOrdering) {
    this._selectionState.zOrdering = (zOrdering === true);
  },

  // gets if this item is being z-ordered
  getIsZOrdering: function () {
    return this._selectionState.zOrdering;
  },

  setIsInRotationMode: function (rotationMode) {
    this._selectionState.rotationMode = (rotationMode === true);
  },
  setIsInSnapToGridMode: function (snapToGridMode) {
    this._selectionState.snapToGridMode = (snapToGridMode === true);
  },

  getIsInRotationMode: function () {
    return this._selectionState.rotationMode;
  },
  getIsInSnapToGridMode: function () {
    return this._selectionState.snapToGridMode;
  },

  setPovAudience: function (povAudience) {
    this._povAudience = (povAudience === true);
  },

  isPovAudience: function () {
    return this._povAudience;
  },

  setZIndex: function (zIndex) {
    this._zIndex = zIndex || 0;
  },

  getZIndex: function () {
    return this._zIndex;
  },

  setInGroup: function (inGroup) {
    this._selectionState.inGroup = (inGroup === true);
  },

  getIsInGroup: function () {
    return this._selectionState.inGroup;
  },

  // gets if this item is rotatable
  getIsRotatable: function () {
    return this._editabilityFlags.rotatable;
  },

  // gets if this item is editable
  getIsEditable: function () {
    return this._editabilityFlags.editable;
  },
  // gets if this item is editable
  getIsFlippable: function () {
    return this.isFlippable;
  },

  setEditing: function (editing) {
    this._selectionState.editing = (editing === true);
  },

  // gets if this item is being edited
  getIsEditing: function () {
    return this._selectionState.editing;
  },

  // gets if this item is sizable
  getIsSizeable: function () {
    return this._editabilityFlags.sizeable;
  },

  getItemType: function () {
    // To be overridden in child classes
  },

  // hit-test for beginning sizing operation
  shouldBeginSizing: function (location) {
    return false;
  },

  // Override as needed
  isEmpty: function () {
    return false;
  },

  normalStyle: function () { },

  activeStyle: function () { },

  dynamicStyle: function () { },

  orderingStyle: function () { },

  flipView: function (isVertical) {

  },

  _createRenderCmd: function () {
    return new ChartItemBaseView.CanvasRenderCmd(this);
  },

});

(function () {
  ChartItemBaseView.CanvasRenderCmd = function (renderable) {
    cc.Node.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;

    this.chartZoom = 1.0;
  };

  var proto = ChartItemBaseView.CanvasRenderCmd.prototype = Object.create(cc.Node.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemBaseView.CanvasRenderCmd;

  proto.setBaseStyleFlag = function (baseStyleFlag) {
    this._baseStyleFlags = this._baseStyleFlags | baseStyleFlag;
  };

  proto.clearBaseStyleFlag = function (baseStyleFlag) {
    this._baseStyleFlags = this._baseStyleFlags & (~baseStyleFlag);
  };

  proto.rendering = function (ctx, scaleX, scaleY) {
    var node = this._node;
    var wrapper = ctx || cc._renderContext;
    var drawingUtil = cc._drawingUtil;
    var context = wrapper.getContext();

    wrapper.save();
    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    var margin = this.getChartItemViewMargin();

    var selectionStateFlags = node._selectionState;
    if (selectionStateFlags.editing) {
      drawingUtil.setLineWidth(this.getStrokeWidthWithBase(2));
      drawingUtil.drawRectangle(cc.p(-1, -1), cc.p(node.width + 1, node.height + 1), cc.color(44, 91, 249, 255));
    } else if (selectionStateFlags.zOrdering) {
      drawingUtil.setDrawColor(249, 44, 91, 255);
      drawingUtil.setLineWidth(this.getStrokeWidthWithBase(2));
      drawingUtil.drawRectangle(cc.p(-1, -1), cc.p(node.width + 1, node.height + 1));
    } else if (selectionStateFlags.dynamic) {
      drawingUtil.drawSolidRectangle(cc.p(-margin, -margin), cc.p(node.width + margin, node.height + margin), cc.color(128, 128, 128, 63));
    } else if (selectionStateFlags.active) {
      drawingUtil.drawSolidRectangle(cc.p(-margin, -margin), cc.p(node.width + margin, node.height + margin), cc.color(128, 128, 128, 127));
    }

    wrapper.restore();
  };

  proto.setChartZoom = function (zoom) {
    this.chartZoom = zoom;
  };

  proto.getStrokeWidthWithBase = function (baseWidth) {
    var strokeWidth = (baseWidth / 40 * this._node.chartItemViewFactory.scalePxPerUnitX * this._node.chartItemViewFactory.measurementConversionMultiplier);
    if (strokeWidth < 1) {
      strokeWidth = 1;
    }

    return strokeWidth;
  };

  proto.getChartItemViewMargin = function () {
    var margin = (this.getStrokeWidthWithBase(chartBaseLineWidth) * 4);
    if (margin < 4) {
      margin = 4;
    }

    if (angular.isDefined(this._node.chartItemShape) && angular.isDefined(this._node.chartItemShape.linethickness)) {
      var shapeType = this._node.chartItemShape.shapetype;
      var linethickness = this._node.chartItemShape.linethickness;
      var factor;

      if ([SWChartItem.ShapeType.Triangle, SWChartItem.ShapeType.JoinedLine, SWChartItem.ShapeType.JoinedLineArrow,
      SWChartItem.ShapeType.Curve, SWChartItem.ShapeType.CurveArrow, SWChartItem.ShapeType.SolidLine,
      SWChartItem.ShapeType.DottedLine, SWChartItem.ShapeType.ThinDottedLine].includes(shapeType)) {
        factor = linethickness / 4;
      } else if ([SWChartItem.ShapeType.ThickLine, SWChartItem.ShapeType.Freehand].includes(shapeType)) {
        factor = linethickness / 2;
      } else if ([SWChartItem.ShapeType.SolidLineArrow, SWChartItem.ShapeType.DottedLineArrow].includes(shapeType)) {
        factor = (linethickness * 4) / 4;
      } else {
        factor = linethickness / 8;
      }

      var addMargin = this.getStrokeWidthWithBase(factor) * 4;
      margin += addMargin;
    }

    return margin;
  };

  proto.drawDiagonalSizeHandle = function (ctx, scaleX, scaleY) {
    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext()
    var drawingUtil = cc._drawingUtil;

    var zoomFactor = node.chartItemViewFactory.zoomFactor;
    if (zoomFactor > 2) {
      zoomFactor = 2;
    }
    var handleSize = sizeHandleSize * zoomFactor;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    var leftOffset = node.width - handleSize;
    var topOffset = 0;
    drawingUtil.drawSolidRectangle(cc.p(leftOffset, topOffset), cc.p(leftOffset + handleSize, topOffset + handleSize), cc.color(255, 255, 255, 192));

    drawingUtil.setDrawColor(249, 44, 91, 255);
    drawingUtil.setLineWidth(1 * zoomFactor);
    topOffset += (handleSize / 2);
    context.translate((leftOffset + handleSize / 2) * scaleX, topOffset * scaleY);
    context.rotate(-cc.PI / 4);
    context.translate(-(leftOffset + handleSize / 2) * scaleX, -topOffset * scaleY);

    var sizeFactor = zoomFactor * sizeHandleSize / 24;
    var vertices = [];
    vertices.push(cc.p(leftOffset + 2 * sizeFactor, topOffset));
    vertices.push(cc.p(leftOffset + 8 * sizeFactor, topOffset - 6 * sizeFactor));
    vertices.push(cc.p(leftOffset + 8 * sizeFactor, topOffset - 2 * sizeFactor));
    vertices.push(cc.p(leftOffset + 16 * sizeFactor, topOffset - 2 * sizeFactor));
    vertices.push(cc.p(leftOffset + 16 * sizeFactor, topOffset - 6 * sizeFactor));
    vertices.push(cc.p(leftOffset + 22 * sizeFactor, topOffset));
    vertices.push(cc.p(leftOffset + 16 * sizeFactor, topOffset + 6 * sizeFactor));
    vertices.push(cc.p(leftOffset + 16 * sizeFactor, topOffset + 2 * sizeFactor));
    vertices.push(cc.p(leftOffset + 8 * sizeFactor, topOffset + 2 * sizeFactor));
    vertices.push(cc.p(leftOffset + 8 * sizeFactor, topOffset + 6 * sizeFactor));
    drawingUtil.drawPolygon(vertices, true, true);
  };

  proto.drawDiagonalRotationHandle = function (ctx, scaleX, scaleY) {
    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext()
    var drawingUtil = cc._drawingUtil;

    var zoomFactor = node.chartItemViewFactory.zoomFactor;
    if (zoomFactor > 2) {
      zoomFactor = 2;
    }
    var handleSize = sizeHandleSize * zoomFactor;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    var leftOffset = node.width - handleSize;
    var topOffset = 0;
    drawingUtil.drawSolidRectangle(cc.p(leftOffset, topOffset), cc.p(leftOffset + handleSize, topOffset + handleSize), cc.color(255, 255, 255, 192));

    drawingUtil.setDrawColor(249, 44, 91, 255);
    drawingUtil.setLineWidth(0.1 * zoomFactor);

    var sizeFactor = zoomFactor * sizeHandleSize / 24;
    var vertices = [];
    vertices.push(cc.p(leftOffset + 12 * sizeFactor, topOffset + 10 * sizeFactor));
    vertices.push(cc.p(leftOffset + 1 * sizeFactor, topOffset + 7 * sizeFactor));
    vertices.push(cc.p(leftOffset + 5 * sizeFactor, topOffset + 15 * sizeFactor));
    drawingUtil.drawPolygon(vertices, true, true);

    vertices = [];
    vertices.push(cc.p(leftOffset + 14 * sizeFactor, topOffset + 12 * sizeFactor));
    vertices.push(cc.p(leftOffset + 17 * sizeFactor, topOffset + 23 * sizeFactor));
    vertices.push(cc.p(leftOffset + 9 * sizeFactor, topOffset + 19 * sizeFactor));
    drawingUtil.drawPolygon(vertices, true, true);

    drawingUtil.setLineWidth(3 * sizeFactor);
    context.beginPath();
    context.arc((leftOffset + 12 * sizeFactor) * scaleX, (topOffset + 12 * sizeFactor) * scaleY, 7.5 * sizeFactor * scaleX, Math.PI + Math.PI / 16, 5 * Math.PI / 2 - Math.PI / 16);
    context.stroke();
    drawingUtil.setLineWidth(1);
  };

  proto.drawHorizontalRotationHandle = function (ctx, scaleX, scaleY) {
    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext()
    var drawingUtil = cc._drawingUtil;

    var zoomFactor = node.chartItemViewFactory.zoomFactor;
    if (zoomFactor > 2) {
      zoomFactor = 2;
    }
    var handleSize = sizeHandleSize * zoomFactor;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    var leftOffset = node.width - handleSize;
    var topOffset = (node.height - handleSize) / 2;
    drawingUtil.drawSolidRectangle(cc.p(leftOffset, topOffset), cc.p(leftOffset + handleSize, topOffset + handleSize), cc.color(255, 255, 255, 192));

    drawingUtil.setDrawColor(249, 44, 91, 255);
    drawingUtil.setLineWidth(0.1 * zoomFactor);

    context.translate((leftOffset + handleSize / 2) * scaleX, (topOffset + handleSize / 2) * scaleY);
    context.rotate(Math.PI * 3 / 4);
    context.translate(-(leftOffset + handleSize / 2) * scaleX, -(topOffset + handleSize / 2) * scaleY);

    var sizeFactor = zoomFactor * sizeHandleSize / 24;
    var vertices = [];
    vertices.push(cc.p(leftOffset + 12 * sizeFactor, topOffset + 10 * sizeFactor));
    vertices.push(cc.p(leftOffset + 23 * sizeFactor, topOffset + 7 * sizeFactor));
    vertices.push(cc.p(leftOffset + 19 * sizeFactor, topOffset + 15 * sizeFactor));
    drawingUtil.drawPolygon(vertices, true, true);

    vertices = [];
    vertices.push(cc.p(leftOffset + 10 * sizeFactor, topOffset + 12 * sizeFactor));
    vertices.push(cc.p(leftOffset + 7 * sizeFactor, topOffset + 23 * sizeFactor));
    vertices.push(cc.p(leftOffset + 15 * sizeFactor, topOffset + 19 * sizeFactor));
    drawingUtil.drawPolygon(vertices, true, true);

    drawingUtil.setLineWidth(3 * sizeFactor);
    context.beginPath();
    context.arc((leftOffset + 12 * sizeFactor) * scaleX, (topOffset + 12 * sizeFactor) * scaleY, 7.5 * sizeFactor * scaleX, Math.PI / 2 + Math.PI / 16, 2 * Math.PI - Math.PI / 16);
    context.stroke();
    drawingUtil.setLineWidth(1);
  };

  proto.drawHorizontalSizeHandle = function (ctx, scaleX, scaleY) {
    var node = this._node;

    var wrapper = ctx || cc._renderContext;

    var drawingUtil = cc._drawingUtil;

    var zoomFactor = node.chartItemViewFactory.zoomFactor;
    if (zoomFactor > 2) {
      zoomFactor = 2;
    }
    var handleSize = sizeHandleSize * zoomFactor;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    var leftOffset = node.width - handleSize;
    var topOffset = (node.height - handleSize) / 2;
    drawingUtil.drawSolidRectangle(cc.p(leftOffset, topOffset), cc.p(leftOffset + handleSize, topOffset + handleSize), cc.color(255, 255, 255, 192));

    drawingUtil.setDrawColor(249, 44, 91, 255);
    drawingUtil.setLineWidth(1 * zoomFactor);
    topOffset += (handleSize / 2);
    var sizeFactor = zoomFactor * sizeHandleSize / 24;
    var vertices = [];
    vertices.push(cc.p(leftOffset + 2 * sizeFactor, topOffset));
    vertices.push(cc.p(leftOffset + 8 * sizeFactor, topOffset - 6 * sizeFactor));
    vertices.push(cc.p(leftOffset + 8 * sizeFactor, topOffset - 2 * sizeFactor));
    vertices.push(cc.p(leftOffset + 16 * sizeFactor, topOffset - 2 * sizeFactor));
    vertices.push(cc.p(leftOffset + 16 * sizeFactor, topOffset - 6 * sizeFactor));
    vertices.push(cc.p(leftOffset + 22 * sizeFactor, topOffset));
    vertices.push(cc.p(leftOffset + 16 * sizeFactor, topOffset + 6 * sizeFactor));
    vertices.push(cc.p(leftOffset + 16 * sizeFactor, topOffset + 2 * sizeFactor));
    vertices.push(cc.p(leftOffset + 8 * sizeFactor, topOffset + 2 * sizeFactor));
    vertices.push(cc.p(leftOffset + 8 * sizeFactor, topOffset + 6 * sizeFactor));
    drawingUtil.drawPolygon(vertices, true, true);
  };
})();

/////////////////////////////////////////////////
// ChartItemPerformerView
//
// Represents a 'Performer' on a chart layer.
var ChartItemPerformerView = ChartItemBaseView.extend({

  _showPositionLabel: false,
  _showNose: false,

  _headRotation: 0,

  _positionResolutionFraction: 0,
  _positionValueDecimals: 0,

  stageUnitCenter: 0,

  // @override
  ctor: function (chartItem, chartItemViewFactory) {
    this._super(chartItemViewFactory);

    this._editabilityFlags.rotatable = true;

    this.setAnchorPoint(0.5, 0.5);

    this.chartItemPerformer = chartItem;

    this.stageUnitCenter = this.chartItemViewFactory.stageUnitWidth / 2;

    var initX = parseFloat(chartItem.positionx) || 0;
    var initY = parseFloat(chartItem.positiony) || 0;
    var initWidth = parseFloat(chartItem.sizewidth) || 0;
    var initHeight = parseFloat(chartItem.sizeheight) || 0;

    if ((initWidth === 0) && (initHeight === 0)) {
      // initial position is center of visible statge
      initX = (-this.chartItemViewFactory.scaledStagePxOffset.x + this.chartItemViewFactory.stageViewSize.width / 2) / this.chartItemViewFactory.scalePxPerUnitX;
      initY = (-this.chartItemViewFactory.scaledStagePxOffset.y + this.chartItemViewFactory.stageViewSize.height / 2) / this.chartItemViewFactory.scalePxPerUnitY;

      // Performer icons are always 2x2 feet
      initWidth = 2 * this.chartItemViewFactory.measurementConversionMultiplier;
      initHeight = 2 * this.chartItemViewFactory.measurementConversionMultiplier;

      // Set the initial values on the entity
      this.chartItemPerformer.positionx = initX;
      this.chartItemPerformer.positiony = initY;
      this.chartItemPerformer.sizewidth = initWidth;
      this.chartItemPerformer.sizeheight = initHeight;
      this.chartItemPerformer.rotation = 0;
    }


    var performer = this.chartItemViewFactory.findPerformerById(chartItem.referencedperformerId);
    if (performer !== undefined) {
      this.setName('ChartItemPerformerView - ' + performer.name);
    }

    this.chartItemPerformer.highlightperformer = performer.highlightperformer || false;

    this._renderCmd.performerImage = this.chartItemViewFactory.getPerformerImage(chartItem.referencedperformerId);

    this.refresh();
    // // Initial view position and size
    // this.x = initX * this.chartItemViewFactory.scalePxPerUnitX;
    // this.y = initY * this.chartItemViewFactory.scalePxPerUnitY;
    // this.width = initWidth * this.chartItemViewFactory.scalePxPerUnitX;
    // this.height = initHeight * this.chartItemViewFactory.scalePxPerUnitY;
    // // Initial rotation
    // var viewRotation = parseFloat(this.chartItemPerformer.rotation) || 0.0;
    // this.chartItemPerformer.rotation = viewRotation;
    // this.setViewRotation(viewRotation);
    //
    //
    // this.updatePositionValue();

    return true;
  },

  // Touch begin handler
  onTouchBegan: function (touch, event) {
    this._super(touch, event);

    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (((touchPoint.x > (this.width - this._touchState.handleSize)) && (touchPoint.y <
      this._touchState.handleSize)) && this.getIsInRotationMode()) {
      this.setDynamic(true)
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Rotation);
      this._touchState.originalAngle = Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this.getViewRotation();
    } else {
      this.setDynamic(true);
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Move);

      this._touchState.touchStartOffsetX = this.x - touchPointSuper.x;
      this._touchState.touchStartOffsetY = this.y - touchPointSuper.y;

      this._touchState.touchLimitX1 = 0 - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitX2 = this.chartItemViewFactory.scaledStagePxWidth - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitY1 = 0 - this._touchState.touchStartOffsetY;
      this._touchState.touchLimitY2 = this.chartItemViewFactory.scaledStagePxHeight - this._touchState.touchStartOffsetY;
    }
    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Rotation) {
      // Calculate the angle between the start point and the current touch point
      var angle = -Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this._touchState.originalAngle;

      // Rotate the item
      this.setViewRotation(angle);
    } else {
      if (this.delegate && this.delegate.delegate && this.delegate.delegate.killAutoSaveTimer) {
        this.delegate.delegate.killAutoSaveTimer();
      }

      if (touchPointSuper.x < this._touchState.touchLimitX1) {
        touchPointSuper.x = this._touchState.touchLimitX1;
      } else if (touchPointSuper.x > this._touchState.touchLimitX2) {
        touchPointSuper.x = this._touchState.touchLimitX2;
      }

      if (touchPointSuper.y < this._touchState.touchLimitY1) {
        touchPointSuper.y = this._touchState.touchLimitY1;
      } else if (touchPointSuper.y > this._touchState.touchLimitY2) {
        touchPointSuper.y = this._touchState.touchLimitY2;
      }

      this.x = touchPointSuper.x + this._touchState.touchStartOffsetX;
      this.y = touchPointSuper.y + this._touchState.touchStartOffsetY;

      this.updatePositionValue();
    }
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);

    this.updatePositionValue();
    this.updateEntity();
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);

    this.refresh();
  },

  // @override
  setActive: function (active) {
    this._super(active);
  },

  refresh: function () {
    this._super();

    if (!this.getIsInGroup()) {
      this.x = this.chartItemPerformer.positionx * this.chartItemViewFactory.scalePxPerUnitX;
      this.y = this.chartItemPerformer.positiony * this.chartItemViewFactory.scalePxPerUnitY;
    }

    this.width = this.chartItemPerformer.sizewidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = this.chartItemPerformer.sizeheight * this.chartItemViewFactory.scalePxPerUnitY;

    var viewRotation = parseFloat(this.chartItemPerformer.rotation) || 0.0;
    this.setViewRotation(viewRotation);

    var scalePerformerSize = { width: 45, height: 45 };
    var shouldScale = (this.width < 40 && this.height < 40);

    if (shouldScale && (this.chartItemViewFactory._scaleAllPerformers || (this.chartItemViewFactory._scaleSelectedPerformers && this.chartItemPerformer.highlightperformer))) {
      this.width = scalePerformerSize.width;
      this.height = scalePerformerSize.height;
    } else {
      this.width = this.chartItemPerformer.sizewidth * this.chartItemViewFactory.scalePxPerUnitX;
      this.height = this.chartItemPerformer.sizeheight * this.chartItemViewFactory.scalePxPerUnitY;
    }

    // var headRotation = parseFloat(this.chartItemPerformer.headrotation) || 0.0;
    // this.setHeadRotation(headRotation);

    this.updatePositionValue();
  },

  updateEntity: function () {
    if (this.getIsInGroup()) {
      return;
    }

    var changed = false;
    var newPositionX = this.x / this.chartItemViewFactory.scalePxPerUnitX;
    var newPositionY = this.y / this.chartItemViewFactory.scalePxPerUnitY;
    var newRotation = this.getViewRotation();
    var newHeadRotation = this.getHeadRotation();

    if (Math.abs(this.chartItemPerformer.positionx - newPositionX) > 0.000001) {
      this.chartItemPerformer.positionx = newPositionX;
      changed = true;
    }

    if (Math.abs(this.chartItemPerformer.positiony - newPositionY) > 0.000001) {
      this.chartItemPerformer.positiony = newPositionY;
      changed = true;
    }

    if (Math.abs(this.chartItemPerformer.rotation - newRotation) > 0.000001) {
      this.chartItemPerformer.rotation = newRotation;
      changed = true;
    }

    // if (Math.abs(this.chartItemPerformer.headrotation - newHeadRotation) > 0.000001) {
    //   this.chartItemPerformer.headrotation = newHeadRotation;
    //   changed = true;
    // }

    if (changed) {
      this.delegate.chartItemNotifyDidChange();
    }

    return changed;
  },

  getBackingEntity: function () {
    return this.chartItemPerformer;
  },

  getItemType: function () {
    return SWChartItem.Type.Performer;
  },

  setShowPositionLabel: function (show) {
    this._showPositionLabel = show;

    this.updatePositionValue();
    this.setNodeDirty();
  },

  setPositionResolutionFraction: function (fraction) {
    this._positionResolutionFraction = fraction;

    if ((this._positionResolutionFraction > 0) && (this._positionResolutionFraction < 1)) {
      this._positionValueDecimals = this._positionResolutionFraction.toString().length - 2;
    } else {
      this._positionValueDecimals = 0;
    }
    this.updatePositionValue();
  },

  setShowNose: function (show) {
    this._showNose = show;

    this._renderCmd.showNose = show;

    this.setNodeDirty();
  },

  getShowNose: function () {
    return this._showNose;
  },

  setHeadRotation: function (angle) {
    this._headRotation = angle;

    this._renderCmd.headRotation = angle;

    this.setNodeDirty();
  },

  getHeadRotation: function () {
    return this._headRotation;
  },

  setHeadRotationDeg: function (headRotation) {
    this.setHeadRotation(headRotation * cc.DEGTORAD);
  },

  getHeadRotationDeg: function () {
    return (this._headRotation * cc.RADTODEG);
  },

  setZIndex: function (newZIndex) {
    if (this.chartItemPerformer.zindex !== newZIndex) {
      this.chartItemPerformer.zindex = newZIndex;
    }
  },

  getZIndex: function () {
    return this.chartItemPerformer.zindex;
  },

  updatePositionValue: function () {
    if (!this._showPositionLabel) {
      this._renderCmd.showPosition = false;
      return;
    }

    var positionUnit = Math.abs((this.x / this.chartItemViewFactory.scalePxPerUnitX) - this.stageUnitCenter - this.chartItemViewFactory.offstageUnitWidth);

    if (positionUnit < this.stageUnitCenter) {
      if (!this.chartItemViewFactory.numberlineZeroAtCenter) {
        if (positionUnit < (this.chartItemViewFactory.numberlineMarkerStepValue / 4)) {
          positionUnit = 0;
        } else {
          positionUnit = positionUnit + (this.chartItemViewFactory.numberlineMarkerStepValue / 2);
        }
      }
      positionUnit = positionUnit * this.chartItemViewFactory.numberlineMultiplier;

      if (this._positionResolutionFraction !== 0) {
        positionUnit = Math.round(positionUnit / this._positionResolutionFraction) * this._positionResolutionFraction;
      }
      this._renderCmd.positionString = '(' + positionUnit.toFixed(this._positionValueDecimals) + ')';
      this._renderCmd.showPosition = true;
    } else {
      this._renderCmd.showPosition = false;
    }
  },

  _createRenderCmd: function () {
    return new ChartItemPerformerView.CanvasRenderCmd(this);
  },

  onEnter: function () {
    this._super();

    this.updatePositionValue();
  }

});

(function () {
  ChartItemPerformerView.CanvasRenderCmd = function (renderable) {
    ChartItemBaseView.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;

    this.performerImage = undefined;

    this.showNose = false;
    this.headRotation = 0;

    this.showPosition = false;
    this.positionString = '';
  };

  var proto = ChartItemPerformerView.CanvasRenderCmd.prototype = Object.create(ChartItemBaseView.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemPerformerView.CanvasRenderCmd;

  proto.setChartZoom = function (zoom) {
    ChartItemBaseView.CanvasRenderCmd.prototype.setChartZoom.call(this, zoom);

    var fontSize = this._node.chartItemViewFactory.scalePxPerUnitX * this._node.chartItemViewFactory.measurementConversionMultiplier;
    if (fontSize < 14) {
      fontSize = 14;
    }
    this.positionLabelFontStyle = (fontSize).toFixed(1) + 'px Source Sans Pro';
  };

  proto.rendering = function (ctx, scaleX, scaleY) {

    ChartItemBaseView.CanvasRenderCmd.prototype.rendering.call(this, ctx, scaleX, scaleY);

    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext();
    var drawingUtil = cc._drawingUtil;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    wrapper.save();
    if (!node._povAudience) {
      context.translate(node.width * scaleX, node.height * scaleY);
      context.rotate(cc.PI);
    }
    drawingUtil.drawImageScaled(this.performerImage, 0, 0, node.width, node.height);
    wrapper.restore();

    // Draw nose if enabled
    if (this.showNose && !node.getIsInGroup()) {
      wrapper.save();
      var noseLineWidth = this.getStrokeWidthWithBase(4);
      var cx = node.width / 2;
      var cy = node.height / 2;
      var r1 = node.height * 0.6;
      var r2 = r1 + (node.height * 0.15);

      // vertical line
      var x1 = cx;
      var y1 = cy + r1;
      var x2 = cx;
      var y2 = cy + r2;

      // horizontal line
      var x3 = x1 - (r2 - r1);
      var y3 = y1;
      var x4 = x1 + (r2 - r1);
      var y4 = y1;

      context.translate(node.width * scaleX / 2, node.height * scaleY / 2);
      context.rotate(this.headRotation);
      context.translate(-node.width * scaleX / 2, -node.height * scaleY / 2);

      // CGContextSetLineCap(context, kCGLineCapRound);
      drawingUtil.setLineWidth(noseLineWidth * 1.3);
      drawingUtil.setStrokeColorCss('rgb(255, 255, 255)');
      drawingUtil.drawLine(cc.p(x1, y1), cc.p(x2, y2));
      drawingUtil.drawLine(cc.p(x3, y3), cc.p(x4, y4));

      drawingUtil.setLineWidth(noseLineWidth);
      drawingUtil.setStrokeColorCss('rgb(0, 0, 0)');
      drawingUtil.drawLine(cc.p(x1, y1), cc.p(x2, y2));
      drawingUtil.drawLine(cc.p(x3, y3), cc.p(x4, y4));

      wrapper.restore();
    }

    if (node._selectionState.rotationMode && node._selectionState.active && node.getIsRotatable()) {
      this.drawDiagonalRotationHandle(ctx, scaleX, scaleY);
    }

    // Show position if enabled
    if (this.showPosition && !node.getIsInGroup()) {
      wrapper.save();
      context.scale(scaleX, scaleY);

      drawingUtil.setDrawColor(0, 0, 0, 255);

      context.font = this.positionLabelFontStyle;

      var textWidth = context.measureText(this.positionString).width;

      if (!node._povAudience) {
        context.translate(node.width, node.height);
        context.rotate(cc.PI);
        context.fillText(this.positionString, (node.width - textWidth) / 2, node.height + 14 * this.chartZoom);
      } else {
        context.fillText(this.positionString, (node.width - textWidth) / 2, -7 * this.chartZoom);
      }

      wrapper.restore();
    }
  };
}());

/////////////////////////////////////////////////
// ChartItemSetPieceView
//
// Represents a set piece on a chart layer
var ChartItemSetPieceView = ChartItemBaseView.extend({

  setPieceImage: undefined,
  isFlippable: true,
  fliphorizontalValue: false,
  flipverticalValue: false,

  ctor: function (chartItem, chartItemViewFactory) {
    this._super(chartItemViewFactory);

    this._editabilityFlags.rotatable = true;

    this.setAnchorPoint(0.5, 0.5);

    this.chartItemSetPiece = chartItem;

    var setPiece = this.chartItemViewFactory.findSetPieceById(chartItem.referencedsetpieceId);
    if (setPiece !== undefined) {
      this.setName('ChartItemSetPieceView - ' + setPiece.name);
    }

    var initX = parseFloat(this.chartItemSetPiece.positionx) || 0;
    var initY = parseFloat(this.chartItemSetPiece.positiony) || 0;
    var initWidth = parseFloat(this.chartItemSetPiece.sizewidth) || 0;
    var initHeight = parseFloat(this.chartItemSetPiece.sizeheight) || 0;

    if ((initWidth === 0) && (initHeight === 0)) {
      // initial position is center of visible statge
      initX = (-this.chartItemViewFactory.scaledStagePxOffset.x + this.chartItemViewFactory.stageViewSize.width / 2) / this.chartItemViewFactory.scalePxPerUnitX;
      initY = (-this.chartItemViewFactory.scaledStagePxOffset.y + this.chartItemViewFactory.stageViewSize.height / 2) / this.chartItemViewFactory.scalePxPerUnitY;

      // initial size is the set piece size
      initWidth = setPiece.width;
      initHeight = setPiece.height;

      // Adjust size of stock set piece items if needed
      if (setPiece.setpiecetype === SWSetPiece.Type.Stock) {
        initWidth = setPiece.width * this.chartItemViewFactory.measurementConversionMultiplier;
        initHeight = setPiece.height * this.chartItemViewFactory.measurementConversionMultiplier;
      }

      // Set the initial values on the entity
      this.chartItemSetPiece.positionx = initX;
      this.chartItemSetPiece.positiony = initY;
      this.chartItemSetPiece.sizewidth = initWidth;
      this.chartItemSetPiece.sizeheight = initHeight;
      this.chartItemSetPiece.rotation = 0;
    }

    // Initial view position and size
    this.x = initX * this.chartItemViewFactory.scalePxPerUnitX;
    this.y = initY * this.chartItemViewFactory.scalePxPerUnitY;
    this.width = initWidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = initHeight * this.chartItemViewFactory.scalePxPerUnitY;

    // Initial rotation
    var viewRotation = parseFloat(this.chartItemSetPiece.rotation) || 0.0;
    this.setViewRotation(viewRotation);

    // The SetPiece image
    this.setPieceImage = this.chartItemViewFactory.getSetPieceImage(chartItem.referencedsetpieceId);

    this.flipverticalValue = this.chartItemSetPiece.flipverticalValue;
    this.fliphorizontalValue = this.chartItemSetPiece.fliphorizontalValue;
    this.flipTransformImage();

    // TODO: create and position the resize handle

    return true;
  },

  flipTransformImage: function () {
    var sy = this.flipverticalValue ? -1 : 1;
    var sx = this.fliphorizontalValue ? -1 : 1;

    // Use AngularJS to get the element and apply the transformation
    var setPieceImageView = angular.element(document.querySelector('#setPieceImageView'));
    setPieceImageView.css('transform', 'scale(' + sx + ',' + sy + ')');
  },

  setSizeable: function (sizeable) {
    this._editabilityFlags.sizeable = (sizeable === true);
  },

  // Touch begin handler
  onTouchBegan: function (touch, event) {
    this._super(touch, event);

    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    this.setDynamic(true);

    if (this.getIsSizeable() && ((touchPoint.x > (this.width - this._touchState.handleSize)) && (touchPoint.y <
      this._touchState.handleSize)) && !this.getIsInRotationMode()) {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Resize);

      // Shift anchor to bottom left
      this.moveAnchorPointKeepPosition(0, 1);

      this._touchState.touchStartOffsetX = this.width - touchPoint.x;
      this._touchState.touchStartOffsetY = touchPoint.y + this.height;
    } else if (((touchPoint.x > (this.width - this._touchState.handleSize)) && (touchPoint.y <
      this._touchState.handleSize)) && this.getIsInRotationMode()) {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Rotation);

      this._touchState.originalAngle = Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this.getViewRotation();
    } else {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Move);

      this._touchState.touchStartOffsetX = this.x - touchPointSuper.x;
      this._touchState.touchStartOffsetY = this.y - touchPointSuper.y;

      this._touchState.touchLimitX1 = 0 - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitX2 = this.chartItemViewFactory.scaledStagePxWidth - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitY1 = 0 - this._touchState.touchStartOffsetY;
      this._touchState.touchLimitY2 = this.chartItemViewFactory.scaledStagePxHeight - this._touchState.touchStartOffsetY;
    }

    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Resize) {
      var contentSize = this.getContentSize();
      contentSize.width = touchPoint.x + this._touchState.touchStartOffsetX;
      if (contentSize.width < 40) {
        contentSize.width = 40;
      }

      var newHeight = this._touchState.touchStartOffsetY - touchPoint.y;
      if (newHeight < 40) {
        newHeight = 40;
      }
      var heightDelta = contentSize.height - newHeight;
      contentSize.height = newHeight;

      this.setContentSize(contentSize);
      this._touchState.touchStartOffsetY -= heightDelta;
    } else if (this._dynamicMode === SWChartUI.ItemDynamicMode.Move) {
      if (this.delegate && this.delegate.delegate && this.delegate.delegate.killAutoSaveTimer) {
        this.delegate.delegate.killAutoSaveTimer();
      }

      if (touchPointSuper.x < this._touchState.touchLimitX1) {
        touchPointSuper.x = this._touchState.touchLimitX1;
      } else if (touchPointSuper.x > this._touchState.touchLimitX2) {
        touchPointSuper.x = this._touchState.touchLimitX2;
      }

      if (touchPointSuper.y < this._touchState.touchLimitY1) {
        touchPointSuper.y = this._touchState.touchLimitY1;
      } else if (touchPointSuper.y > this._touchState.touchLimitY2) {
        touchPointSuper.y = this._touchState.touchLimitY2;
      }

      this.x = touchPointSuper.x + this._touchState.touchStartOffsetX;
      this.y = touchPointSuper.y + this._touchState.touchStartOffsetY;
    } else if (this._dynamicMode === SWChartUI.ItemDynamicMode.Rotation) {
      // Calculate the angle between the start point and the current touch point
      var angle = -Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this._touchState.originalAngle;

      // Rotate the item
      this.setViewRotation(angle);
    }
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    this._super(touch, event);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Resize) {
      this.moveAnchorPointKeepPosition(0.5, 0.5);
    }

    this.setDynamic(false);

    if (this._dynamicMode !== SWChartUI.ItemDynamicMode.None) {
      this.updateEntity();
    }
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    this._super(touch, event);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Resize) {
      this.moveAnchorPointKeepPosition(0.5, 0.5);
    }

    this.setDynamic(false);
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);

    this.refresh();
  },

  setActive: function (active) {
    this._super(active);
  },

  refresh: function () {
    this._super();

    if (!this.getIsInGroup()) {
      this.x = this.chartItemSetPiece.positionx * this.chartItemViewFactory.scalePxPerUnitX;
      this.y = this.chartItemSetPiece.positiony * this.chartItemViewFactory.scalePxPerUnitY;
    }

    this.width = this.chartItemSetPiece.sizewidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = this.chartItemSetPiece.sizeheight * this.chartItemViewFactory.scalePxPerUnitY;

    var viewRotation = parseFloat(this.chartItemSetPiece.rotation) || 0.0;
    this.chartItemSetPiece.rotation = viewRotation;
    this.setViewRotation(viewRotation);

    this.flipverticalValue = this.chartItemSetPiece.flipverticalValue;
    this.fliphorizontalValue = this.chartItemSetPiece.fliphorizontalValue;
    this.flipTransformImage();

  },

  updateEntity: function () {
    if (this.getIsInGroup()) {
      return;
    }

    var changed = false;
    var newPositionX = this.x / this.chartItemViewFactory.scalePxPerUnitX;
    var newPositionY = this.y / this.chartItemViewFactory.scalePxPerUnitY;
    var newSizeWidth = this.chartItemSetPiece.sizewidth;
    var newSizeHeight = this.chartItemSetPiece.sizeheight;
    var newRotation = this.getViewRotation();

    if (this.getIsSizeable()) {
      newSizeWidth = this.width / this.chartItemViewFactory.scalePxPerUnitX;
      newSizeHeight = this.height / this.chartItemViewFactory.scalePxPerUnitY;
    }

    if (Math.abs(this.chartItemSetPiece.positionx - newPositionX) > 0.000001) {
      this.chartItemSetPiece.positionx = newPositionX;
      changed = true;
    }

    if (Math.abs(this.chartItemSetPiece.positiony - newPositionY) > 0.000001) {
      this.chartItemSetPiece.positiony = newPositionY;
      changed = true;
    }

    if (Math.abs(this.chartItemSetPiece.sizewidth - newSizeWidth) > 0.000001) {
      this.chartItemSetPiece.sizewidth = newSizeWidth;
      changed = true;
    }

    if (Math.abs(this.chartItemSetPiece.sizeheight - newSizeHeight) > 0.000001) {
      this.chartItemSetPiece.sizeheight = newSizeHeight;
      changed = true;
    }

    if (Math.abs(this.chartItemSetPiece.rotation - newRotation) > 0.000001) {
      this.chartItemSetPiece.rotation = newRotation;
      changed = true;
    }

    if (this.flipverticalValue != this.chartItemSetPiece.flipverticalValue || this.fliphorizontalValue != this.chartItemSetPiece.fliphorizontalValue) {
      this.chartItemSetPiece.flipverticalValue = this.flipverticalValue;
      this.chartItemSetPiece.fliphorizontalValue = this.fliphorizontalValue;
      changed = true;
    }

    if (changed) {
      this.delegate.chartItemNotifyDidChange();
    }

    return changed;
  },

  flipView: function (isVertical) {
    if (isVertical) {
      this.flipverticalValue = !this.flipverticalValue;
    } else {
      this.fliphorizontalValue = !this.fliphorizontalValue;
    }
    this.flipTransformImage();
  },

  getBackingEntity: function () {
    return this.chartItemSetPiece;
  },

  getItemType: function () {
    return SWChartItem.Type.SetPiece;
  },

  setZIndex: function (newZIndex) {
    if (this.chartItemSetPiece.zindex !== newZIndex) {
      this.chartItemSetPiece.zindex = newZIndex;
    }
  },

  getZIndex: function () {
    return this.chartItemSetPiece.zindex;
  },

  _createRenderCmd: function () {
    return new ChartItemSetPieceView.CanvasRenderCmd(this);
  },
});

(function () {
  ChartItemSetPieceView.CanvasRenderCmd = function (renderable) {
    ChartItemBaseView.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
  };

  var proto = ChartItemSetPieceView.CanvasRenderCmd.prototype = Object.create(ChartItemBaseView.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemSetPieceView.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {

    ChartItemBaseView.CanvasRenderCmd.prototype.rendering.call(this, ctx, scaleX, scaleY);

    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext();
    var drawingUtil = cc._drawingUtil;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    var sy = node.flipverticalValue ? -1 : 1;
    var sx = node.fliphorizontalValue ? -1 : 1;

    var ty = node.flipverticalValue ? node.height * scaleY : 0;
    var tx = node.fliphorizontalValue ? node.width * scaleX : 0;

    context.translate(tx, ty);
    context.scale(sx, sy);
    drawingUtil.drawImageScaled(node.setPieceImage, 0, 0, node.width, node.height);

    if (!node._selectionState.rotationMode && node._selectionState.active && node.getIsSizeable()) {
      this.drawDiagonalSizeHandle(ctx, scaleX, scaleY);
    }
    if (node._selectionState.rotationMode && node._selectionState.active && node.getIsRotatable()) {
      this.drawDiagonalRotationHandle(ctx, scaleX, scaleY);
    }
  };
}());

/////////////////////////////////////////////////
// ChartItemShapeView
//
var ChartItemShapeView = ChartItemBaseView.extend({
  _showOutline: false,

  _defaultLineColorCss: 'rgb(0,0,0)',
  _defaultFillColorCss: 'rgba(0,0,0,0)',

  _lineColorCss: 'rgb(0,0,0)',
  _fillColorCss: 'rgba(0,0,0,0)',

  shapeType: undefined,

  _lineThickness: chartBaseLineWidth,
  _defaultLineThickness: chartBaseLineWidth,

  // @override
  ctor: function (chartItem, chartItemViewFactory) {
    this._super(chartItemViewFactory);

    this._editabilityFlags.rotatable = true;
    this._editabilityFlags.sizeable = true;

    this.setAnchorPoint(0.5, 0.5);

    this.chartItemShape = chartItem;
    this.shapeType = chartItem.shapetype;

    this.setLineColorCss(this.chartItemShape.linecolor);
    this.setFillColorCss(this.chartItemShape.fillcolor);
    this.setLineThickness(this.chartItemShape.linethickness);
  },

  getSupportsLineColor: function () {
    return true;
  },

  getSupportsFillColor: function () {
    return false;
  },

  getShowOutline: function () {
    return this._showOutline;
  },

  setShowOutline: function (showOutline) {
    this._showOutline = (showOutline === true);

    this._renderCmd.showOutline = this._showOutline;
  },

  getLineColorCss: function () {
    return this._lineColorCss;
  },

  setLineColorCss: function (colorCss) {
    if ((colorCss === null) || (colorCss === undefined)) {
      colorCss = this._defaultLineColorCss;
    }

    this._lineColorCss = colorCss;
    this._renderCmd.lineColorCss = colorCss;
  },

  getLineThickness: function () {
    return this._lineThickness;
  },

  setLineThickness: function (lineThickness) {
    if ((lineThickness === null) || (lineThickness === undefined)) {
      lineThickness = this._defaultLineThickness;
    }

    this._lineThickness = lineThickness;
    this._renderCmd.lineThickness = lineThickness;
  },

  getFillColorCss: function () {
    return this._fillColorCss;
  },

  setFillColorCss: function (colorCss) {
    if ((colorCss === null) || (colorCss === undefined)) {
      colorCss = this._defaultFillColorCss;
    }

    this._fillColorCss = colorCss;
    this._renderCmd.fillColorCss = colorCss;
  },

  setZIndex: function (newZIndex) {
    if (this.chartItemShape.zindex !== newZIndex) {
      this.chartItemShape.zindex = newZIndex;
    }
  },

  getZIndex: function () {
    return this.chartItemShape.zindex;
  },

  refresh: function () {
    this._super();

    this.setLineColorCss(this.chartItemShape.linecolor);
    this.setFillColorCss(this.chartItemShape.fillcolor);
    this.setLineThickness(this.chartItemShape.linethickness);
  },

  updateEntity: function () {
    var changed = false;

    if (this.chartItemShape.linecolor !== this.getLineColorCss()) {
      this.chartItemShape.linecolor = this.getLineColorCss();
      changed = true;
    };

    if (this.chartItemShape.fillcolor !== this.getFillColorCss()) {
      this.chartItemShape.fillcolor = this.getFillColorCss();
      changed = true;
    }

    if (this.chartItemShape.linethickness !== this.getLineThickness()) {
      this.chartItemShape.linethickness = this.getLineThickness();
      changed = true;
    }

    return changed;
  },

  getBackingEntity: function () {
    return this.chartItemShape;
  },

  getItemType: function () {
    return SWChartItem.Type.Shape;
  },
});

(function () {
  ChartItemShapeView.CanvasRenderCmd = function (renderable) {
    ChartItemBaseView.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
    this.lineColorCss = '#000000';
    this.fillColorCss = 'rgba(0,0,0,0)';
    this.outlineColorCss = '#ffffff';
    this.showOutline = false;
    this.lineThickness = chartBaseLineWidth;
  };

  var proto = ChartItemShapeView.CanvasRenderCmd.prototype = Object.create(ChartItemBaseView.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemShapeView.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {
    ChartItemBaseView.CanvasRenderCmd.prototype.rendering.call(this, ctx, scaleX, scaleY);
  };
})();

/////////////////////////////////////////////////
// ChartItemShape1View
//
var ChartItemShape1View = ChartItemShapeView.extend({
  ctor: function (chartItem, chartItemViewFactory) {
    this._super(chartItem, chartItemViewFactory);

    var initX = parseFloat(this.chartItemShape.positionx) || 0;
    var initY = parseFloat(this.chartItemShape.positiony) || 0;
    var initWidth = parseFloat(this.chartItemShape.sizewidth) || 0;
    var initHeight = parseFloat(this.chartItemShape.sizeheight) || 0;
    var initLineThickness = parseFloat(this.chartItemShape.linethickness) || chartBaseLineWidth;

    if ((initWidth === 0) && (initHeight === 0)) {
      // initial position is center of visible statge
      initX = (-this.chartItemViewFactory.scaledStagePxOffset.x + this.chartItemViewFactory.stageViewSize.width / 2) / this.chartItemViewFactory.scalePxPerUnitX;
      initY = (-this.chartItemViewFactory.scaledStagePxOffset.y + this.chartItemViewFactory.stageViewSize.height / 2) / this.chartItemViewFactory.scalePxPerUnitY;

      // Initial size
      if ((this.shapeType === SWChartItem.ShapeType.Square) || (this.shapeType === SWChartItem.ShapeType.Circle)) {
        // Size is 4x4 ft
        initWidth = 4;
        initHeight = 4;
      } else if (this.shapeType === SWChartItem.ShapeType.Triangle) {
        // base is 4ft
        initWidth = 4;
        initHeight = Math.sqrt(3.0) * initWidth / 2.0;
      } else if (this.shapeType === SWChartItem.ShapeType.Arc) {
        // size is 4x2 ft
        initWidth = 4;
        initHeight = 2;
      }

      // Account for measurement units
      initWidth = initWidth * this.chartItemViewFactory.measurementConversionMultiplier;
      initHeight = initHeight * this.chartItemViewFactory.measurementConversionMultiplier;

      // Set the initial values on the entity
      this.chartItemShape.positionx = initX;
      this.chartItemShape.positiony = initY;
      this.chartItemShape.sizewidth = initWidth;
      this.chartItemShape.sizeheight = initHeight;
      this.chartItemShape.rotation = 0;
      this.chartItemShape.linethickness = initLineThickness;
    }

    // Initial view position and size
    this.x = initX * this.chartItemViewFactory.scalePxPerUnitX;
    this.y = initY * this.chartItemViewFactory.scalePxPerUnitY;
    this.width = initWidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = initHeight * this.chartItemViewFactory.scalePxPerUnitY;

    // Initial rotation
    var viewRotation = parseFloat(this.chartItemShape.rotation) || 0.0;
    this.chartItemShape.rotation = viewRotation;
    this.setViewRotation(viewRotation);
  },

  // Touch begin handler
  onTouchBegan: function (touch, event) {
    this._super(touch, event);

    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    this.setDynamic(true);

    if ((touchPoint.x > (this.width - this._touchState.handleSize)) && (touchPoint.y < this._touchState.handleSize) && !this.getIsInRotationMode()) {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Resize);

      // Shift anchor to bottom left
      this.moveAnchorPointKeepPosition(0, 1);

      this._touchState.touchStartOffsetX = this.width - touchPoint.x;
      this._touchState.touchStartOffsetY = touchPoint.y + this.height;
    } else if ((touchPoint.x > (this.width - this._touchState.handleSize)) && (touchPoint.y < this._touchState.handleSize) && this.getIsInRotationMode()) {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Rotation);

      this._touchState.originalAngle = Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this.getViewRotation();
    } else {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Move);

      this._touchState.touchStartOffsetX = this.x - touchPointSuper.x;
      this._touchState.touchStartOffsetY = this.y - touchPointSuper.y;

      this._touchState.touchLimitX1 = 0 - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitX2 = this.chartItemViewFactory.scaledStagePxWidth - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitY1 = 0 - this._touchState.touchStartOffsetY;
      this._touchState.touchLimitY2 = this.chartItemViewFactory.scaledStagePxHeight - this._touchState.touchStartOffsetY;
    }

    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Resize) {
      var contentSize = this.getContentSize();
      contentSize.width = touchPoint.x + this._touchState.touchStartOffsetX;
      if (contentSize.width < 40) {
        contentSize.width = 40;
      }

      var newHeight = this._touchState.touchStartOffsetY - touchPoint.y;
      if (newHeight < 40) {
        newHeight = 40;
      }
      var heightDelta = contentSize.height - newHeight;
      contentSize.height = newHeight;

      this.setContentSize(contentSize);
      this._touchState.touchStartOffsetY -= heightDelta;
    } else if (this._dynamicMode === SWChartUI.ItemDynamicMode.Move) {
      if (this.delegate && this.delegate.delegate && this.delegate.delegate.killAutoSaveTimer) {
        this.delegate.delegate.killAutoSaveTimer();
      }

      if (touchPointSuper.x < this._touchState.touchLimitX1) {
        touchPointSuper.x = this._touchState.touchLimitX1;
      } else if (touchPointSuper.x > this._touchState.touchLimitX2) {
        touchPointSuper.x = this._touchState.touchLimitX2;
      }

      if (touchPointSuper.y < this._touchState.touchLimitY1) {
        touchPointSuper.y = this._touchState.touchLimitY1;
      } else if (touchPointSuper.y > this._touchState.touchLimitY2) {
        touchPointSuper.y = this._touchState.touchLimitY2;
      }

      this.x = touchPointSuper.x + this._touchState.touchStartOffsetX;
      this.y = touchPointSuper.y + this._touchState.touchStartOffsetY;
    } else if (this._dynamicMode === SWChartUI.ItemDynamicMode.Rotation) {
      // Calculate the angle between the start point and the current touch point
      var angle = -Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this._touchState.originalAngle;

      // Rotate the item
      this.setViewRotation(angle);
    }
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    this._super(touch, event);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Resize) {
      this.moveAnchorPointKeepPosition(0.5, 0.5);
    }

    this.setDynamic(false);

    if (this._dynamicMode !== SWChartUI.ItemDynamicMode.None) {
      this.updateEntity();
    }
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    this._super(touch, event);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Resize) {
      this.moveAnchorPointKeepPosition(0.5, 0.5);
    }

    this.setDynamic(false);
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);

    this.refresh();
  },

  refresh: function () {
    this._super();

    if (!this.getIsInGroup()) {
      this.x = this.chartItemShape.positionx * this.chartItemViewFactory.scalePxPerUnitX;
      this.y = this.chartItemShape.positiony * this.chartItemViewFactory.scalePxPerUnitY;
    }

    this.width = this.chartItemShape.sizewidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = this.chartItemShape.sizeheight * this.chartItemViewFactory.scalePxPerUnitY;

    var viewRotation = parseFloat(this.chartItemShape.rotation) || 0.0;
    this.setViewRotation(viewRotation);
  },

  updateEntity: function () {
    if (this.getIsInGroup()) {
      return;
    }

    var changed = this._super();

    var newPositionX = this.x / this.chartItemViewFactory.scalePxPerUnitX;
    var newPositionY = this.y / this.chartItemViewFactory.scalePxPerUnitY;
    var newSizeWidth = this.width / this.chartItemViewFactory.scalePxPerUnitX;
    var newSizeHeight = this.height / this.chartItemViewFactory.scalePxPerUnitY;
    var newRotation = this.getViewRotation();

    if (Math.abs(this.chartItemShape.positionx - newPositionX) > 0.000001) {
      this.chartItemShape.positionx = newPositionX;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.positiony - newPositionY) > 0.000001) {
      this.chartItemShape.positiony = newPositionY;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.sizewidth - newSizeWidth) > 0.000001) {
      this.chartItemShape.sizewidth = newSizeWidth;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.sizeheight - newSizeHeight) > 0.000001) {
      this.chartItemShape.sizeheight = newSizeHeight;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.rotation - newRotation) > 0.000001) {
      this.chartItemShape.rotation = newRotation;
      changed = true;
    }

    if (changed) {
      this.delegate.chartItemNotifyDidChange();
    }

    return changed;
  },

  getSupportsFillColor: function () {
    return (this.shapeType !== SWChartItem.ShapeType.Arc);
  },

  _createRenderCmd: function () {
    return new ChartItemShape1View.CanvasRenderCmd(this);
  },
});

(function () {
  ChartItemShape1View.CanvasRenderCmd = function (renderable) {
    ChartItemShapeView.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
    // this.lineColorCss = '#000000';
    // this.fillColorCss = 'rgba(0,0,0,0)';
  };

  var proto = ChartItemShape1View.CanvasRenderCmd.prototype = Object.create(ChartItemShapeView.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemShape1View.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {

    ChartItemShapeView.CanvasRenderCmd.prototype.rendering.call(this, ctx, scaleX, scaleY);

    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var drawingUtil = cc._drawingUtil;

    var shouldFill = node.getSupportsFillColor();

    var strokeWidth;
    if (angular.isDefined(node.chartItemShape.linethickness)) {
      strokeWidth = this.getStrokeWidthWithBase(node.chartItemShape.linethickness);
    } else {
      strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
    }

    var vertices = [];

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    drawingUtil.setStrokeColorCss(this.lineColorCss);
    drawingUtil.setFillColorCss(this.fillColorCss);
    drawingUtil.setLineWidth(strokeWidth);

    if (node.shapeType === SWChartItem.ShapeType.Square) {
      vertices = [];
      vertices.push(cc.p(0, 0));
      vertices.push(cc.p(0, node.height));
      vertices.push(cc.p(node.width, node.height));
      vertices.push(cc.p(node.width, 0));
      drawingUtil.drawPolygon(vertices, true, true);
    } else if (node.shapeType === SWChartItem.ShapeType.Circle) {
      var radiusX = node.width / 2;
      var radiusY = node.height / 2;
      drawingUtil.drawEllipse(cc.p(radiusX, radiusY), radiusX, radiusY, true, shouldFill);
    } else if (node.shapeType === SWChartItem.ShapeType.Triangle) {
      vertices = [];
      vertices.push(cc.p(0, node.height));
      vertices.push(cc.p(node.width / 2, 0));
      vertices.push(cc.p(node.width, node.height));
      drawingUtil.drawPolygon(vertices, true, shouldFill);
    } else if (node.shapeType === SWChartItem.ShapeType.Arc) {
      var xDis = node.width / 2;
      var yDis = node.height;
      var xs = xDis;
      var ys = node.height;

      var kappa = 0.5522848; // 4 * ((√(2) - 1) / 3)
      var ox = xDis * kappa; // control point offset horizontal
      var oy = yDis * kappa; // control point offset vertical
      var xe = xs + xDis; // x-end
      var ye = 0; // y-end

      drawingUtil.drawBezierCurve(cc.p(xe, ys), cc.p(xe, ys - oy), cc.p(xs + ox, ye), cc.p(xs, ye));
      drawingUtil.drawBezierCurve(cc.p(xs, ye), cc.p(xs - ox, ye), cc.p(xs - xDis, ys - oy), cc.p(xs - xDis, ys));
    }

    if (node._selectionState.active && !node._selectionState.rotationMode) {
      this.drawDiagonalSizeHandle(ctx, scaleX, scaleY);
    }
    if (node._selectionState.rotationMode && node._selectionState.active) {
      this.drawDiagonalRotationHandle(ctx, scaleX, scaleY);
    }
  };
})();

var ChartItemShape2View = ChartItemShapeView.extend({
  ctor: function (chartItem, chartItemViewFactory) {
    this._super(chartItem, chartItemViewFactory);

    this.setAnchorPoint(0, 0.5);

    this.hasArrowHead = (this.shapeType === SWChartItem.ShapeType.SolidLineArrow) || (this.shapeType ===
      SWChartItem.ShapeType.DottedLineArrow);

    var initX = parseFloat(this.chartItemShape.positionx) || 0;
    var initY = parseFloat(this.chartItemShape.positiony) || 0;
    var initWidth = parseFloat(this.chartItemShape.sizewidth) || 0;
    var initHeight = parseFloat(this.chartItemShape.sizeheight) || 0;
    var initLineThickness = parseFloat(this.chartItemShape.linethickness) || chartBaseLineWidth;

    if ((initWidth === 0) && (initHeight === 0)) {
      // initial position is center of visible statge
      initX = (-this.chartItemViewFactory.scaledStagePxOffset.x + this.chartItemViewFactory.stageViewSize.width /
        2) / this.chartItemViewFactory.scalePxPerUnitX;
      initY = (-this.chartItemViewFactory.scaledStagePxOffset.y + this.chartItemViewFactory.stageViewSize.height /
        2) / this.chartItemViewFactory.scalePxPerUnitY;

      // Initial size is 4x0.5 ft or 1x0.15 m
      if (this.chartItemViewFactory.swMeasurementUnit === SWStage.MeasurementUnitType.Feet) {
        initWidth = 4;
        initHeight = 1;
      } else {
        initWidth = 1;
        initHeight = 0.3;
      }

      initX -= (initWidth / 2);

      // Set the initial values on the entity
      this.chartItemShape.positionx = initX;
      this.chartItemShape.positiony = initY;
      this.chartItemShape.sizewidth = initWidth;
      this.chartItemShape.sizeheight = initHeight;
      this.chartItemShape.rotation = 0;
      this.chartItemShape.linethickness = initLineThickness;
    }

    // Initial view position and size
    this.x = initX * this.chartItemViewFactory.scalePxPerUnitX;
    this.y = initY * this.chartItemViewFactory.scalePxPerUnitY;
    this.width = initWidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = initHeight * this.chartItemViewFactory.scalePxPerUnitY;

    // Initial rotation
    var viewRotation = parseFloat(this.chartItemShape.rotation) || 0.0;
    this.chartItemShape.rotation = viewRotation;
    this.setViewRotation(viewRotation);
  },

  // Touch begin handler
  onTouchBegan: function (touch, event) {
    this._super(touch, event);

    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    this.setDynamic(true);

    if (touchPoint.x > (this.width - this._touchState.handleSize) && !this.getIsInRotationMode()) {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Resize);

      this._touchState.touchStartOffsetX = this.width - touchPoint.x;
    }
    else if (touchPoint.x > (this.width - this._touchState.handleSize) && this.getIsInRotationMode()) {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Rotation);

      this._touchState.originalAngle = Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this.getViewRotation();
    }
    else {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Move);

      this._touchState.touchStartOffsetX = this.x - touchPointSuper.x;
      this._touchState.touchStartOffsetY = this.y - touchPointSuper.y;

      this._touchState.touchLimitX1 = 0 - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitX2 = this.chartItemViewFactory.scaledStagePxWidth - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitY1 = 0 - this._touchState.touchStartOffsetY;
      this._touchState.touchLimitY2 = this.chartItemViewFactory.scaledStagePxHeight - this._touchState.touchStartOffsetY;
    }

    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Resize) {
      var contentSize = this.getContentSize();
      contentSize.width = touchPoint.x + this._touchState.touchStartOffsetX;
      if (contentSize.width < 40) {
        contentSize.width = 40;
      }

      this.setContentSize(contentSize);
    } else if (this._dynamicMode === SWChartUI.ItemDynamicMode.Move) {
      if (this.delegate && this.delegate.delegate && this.delegate.delegate.killAutoSaveTimer) {
        this.delegate.delegate.killAutoSaveTimer();
      }

      if (touchPointSuper.x < this._touchState.touchLimitX1) {
        touchPointSuper.x = this._touchState.touchLimitX1;
      } else if (touchPointSuper.x > this._touchState.touchLimitX2) {
        touchPointSuper.x = this._touchState.touchLimitX2;
      }

      if (touchPointSuper.y < this._touchState.touchLimitY1) {
        touchPointSuper.y = this._touchState.touchLimitY1;
      } else if (touchPointSuper.y > this._touchState.touchLimitY2) {
        touchPointSuper.y = this._touchState.touchLimitY2;
      }

      this.x = touchPointSuper.x + this._touchState.touchStartOffsetX;
      this.y = touchPointSuper.y + this._touchState.touchStartOffsetY;
    } else if (this._dynamicMode === SWChartUI.ItemDynamicMode.Rotation) {
      // Calculate the angle between the start point and the current touch point
      var angle = -Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this._touchState.originalAngle;

      // Rotate the item
      this.setViewRotation(angle);
    }
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);

    if (this._dynamicMode !== SWChartUI.ItemDynamicMode.None) {
      this.updateEntity();
    }
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);

    this.refresh();
  },

  refresh: function () {
    this._super();

    if (!this.getIsInGroup()) {
      this.x = this.chartItemShape.positionx * this.chartItemViewFactory.scalePxPerUnitX;
      this.y = this.chartItemShape.positiony * this.chartItemViewFactory.scalePxPerUnitY;
    }

    this.width = this.chartItemShape.sizewidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = this.chartItemShape.sizeheight * this.chartItemViewFactory.scalePxPerUnitY;

    var viewRotation = parseFloat(this.chartItemShape.rotation) || 0.0;
    this.setViewRotation(viewRotation);
  },

  updateEntity: function () {
    if (this.getIsInGroup()) {
      return;
    }

    var changed = this._super();

    var newPositionX = this.x / this.chartItemViewFactory.scalePxPerUnitX;
    var newPositionY = this.y / this.chartItemViewFactory.scalePxPerUnitY;
    var newSizeWidth = this.width / this.chartItemViewFactory.scalePxPerUnitX;
    var newSizeHeight = this.height / this.chartItemViewFactory.scalePxPerUnitY;
    var newRotation = this.getViewRotation();

    if (Math.abs(this.chartItemShape.positionx - newPositionX) > 0.000001) {
      this.chartItemShape.positionx = newPositionX;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.positiony - newPositionY) > 0.000001) {
      this.chartItemShape.positiony = newPositionY;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.sizewidth - newSizeWidth) > 0.000001) {
      this.chartItemShape.sizewidth = newSizeWidth;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.sizeheight - newSizeHeight) > 0.000001) {
      this.chartItemShape.sizeheight = newSizeHeight;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.rotation - newRotation) > 0.000001) {
      this.chartItemShape.rotation = newRotation;
      changed = true;
    }

    if (changed) {
      this.delegate.chartItemNotifyDidChange();
    }

    return changed;
  },

  _createRenderCmd: function () {
    return new ChartItemShape2View.CanvasRenderCmd(this);
  },
});

(function () {
  ChartItemShape2View.CanvasRenderCmd = function (renderable) {
    ChartItemShapeView.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
    // this.lineColorCss = '#000000';
    // this.fillColorCss = 'rgba(0,0,0,0)';
  };

  var proto = ChartItemShape2View.CanvasRenderCmd.prototype = Object.create(ChartItemShapeView.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemShape2View.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {

    ChartItemShapeView.CanvasRenderCmd.prototype.rendering.call(this, ctx, scaleX, scaleY);

    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext();
    var drawingUtil = cc._drawingUtil;

    var x1 = 0;
    var x2 = node.width;
    var y = node.height / 2;

    var strokeWidth;
    if (angular.isDefined(node.chartItemShape.linethickness)) {
      strokeWidth = this.getStrokeWidthWithBase(node.chartItemShape.linethickness);
      var outlineStrokeWidth = strokeWidth;
      if (node.shapeType === SWChartItem.ShapeType.ThickLine) {
        strokeWidth = this.getStrokeWidthWithBase(node.chartItemShape.linethickness * 2.5);
      }
    } else {
      strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
      var outlineStrokeWidth = strokeWidth;
      if (node.shapeType === SWChartItem.ShapeType.ThickLine) {
        strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth * 2.5);
      }
    }

    if (node.hasArrowHead) {
      x2 -= (6 * strokeWidth);

      if (node.getShowOutline()) {
        x2 -= 3;
      }
    }

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    wrapper.save();
    wrapper.setLineCap('round');
    wrapper.setLineJoin('round');

    // Draw outline if enabled
    if (this.showOutline) {
      drawingUtil.setStrokeColorCss(this.outlineColorCss);
      drawingUtil.setFillColorCss(this.outlineColorCss);
      drawingUtil.setLineWidth(strokeWidth + outlineStrokeWidth);

      drawingUtil.drawLine(cc.p(x1, y), cc.p(x2, y));

      if (node.hasArrowHead) {
        drawingUtil.setLineWidth(strokeWidth);
        var vertices = [];
        vertices.push(cc.p(x2 + (6 * strokeWidth), y));
        vertices.push(cc.p(x2, y - (3 * strokeWidth)));
        vertices.push(cc.p(x2, y + (3 * strokeWidth)));

        drawingUtil.drawPolygon(vertices);
      }
    }

    drawingUtil.setStrokeColorCss(this.lineColorCss);
    drawingUtil.setFillColorCss(this.lineColorCss);

    drawingUtil.setLineWidth(strokeWidth);
    if (node.shapeType === SWChartItem.ShapeType.ThinDottedLine) {
      context.setLineDash([strokeWidth * 2 * scaleX, strokeWidth * 2 * scaleX]);
    } else if ((node.shapeType === SWChartItem.ShapeType.DottedLine) || (node.shapeType === SWChartItem.ShapeType.DottedLineArrow)) {
      context.setLineDash([strokeWidth * 4 * scaleX, strokeWidth * 2 * scaleX]);
    }

    drawingUtil.drawLine(cc.p(x1, y), cc.p(x2, y));

    if (node.hasArrowHead) {
      var vertices = [];
      vertices.push(cc.p(x2 + (6 * strokeWidth), y));
      vertices.push(cc.p(x2, y - (3 * strokeWidth)));
      vertices.push(cc.p(x2, y + (3 * strokeWidth)));

      drawingUtil.drawPolygon(vertices, false, true);
    }

    wrapper.restore();

    if (node._selectionState.active && !node._selectionState.rotationMode) {
      this.drawHorizontalSizeHandle(ctx, scaleX, scaleY);
    }
    if (node._selectionState.rotationMode && node._selectionState.active) {
      this.drawHorizontalRotationHandle(ctx, scaleX, scaleY);
    }
  };
})();

var ChartItemShapeCurtainView = ChartItemShapeView.extend({
  ctor: function (chartItem, chartItemViewFactory) {
    this._super(chartItem, chartItemViewFactory);

    this.setAnchorPoint(0, 0.5);

    var initX = parseFloat(this.chartItemShape.positionx) || 0;
    var initY = parseFloat(this.chartItemShape.positiony) || 0;
    var initWidth = parseFloat(this.chartItemShape.sizewidth) || 0;
    var initHeight = parseFloat(this.chartItemShape.sizeheight) || 0;
    var initLineThickness = parseFloat(this.chartItemShape.linethickness) || chartBaseLineWidth;

    if ((initWidth === 0) && (initHeight === 0)) {
      // initial position is center of visible statge
      initX = (-this.chartItemViewFactory.scaledStagePxOffset.x + this.chartItemViewFactory.stageViewSize.width / 2) / this.chartItemViewFactory.scalePxPerUnitX;
      initY = (-this.chartItemViewFactory.scaledStagePxOffset.y + this.chartItemViewFactory.stageViewSize.height / 2) / this.chartItemViewFactory.scalePxPerUnitY;

      // Initial size is 4x1 ft
      initWidth = 4 * this.chartItemViewFactory.measurementConversionMultiplier;
      initHeight = 1 * this.chartItemViewFactory.measurementConversionMultiplier;

      // Adjust to center on visible stage
      initX -= (initWidth / 2);

      // Set the initial values on the entity
      this.chartItemShape.positionx = initX;
      this.chartItemShape.positiony = initY;
      this.chartItemShape.sizewidth = initWidth;
      this.chartItemShape.sizeheight = initHeight;
      this.chartItemShape.rotation = 0;
      this.chartItemShape.linethickness = initLineThickness;
    }

    // Initial view position and size
    this.x = initX * this.chartItemViewFactory.scalePxPerUnitX;
    this.y = initY * this.chartItemViewFactory.scalePxPerUnitY;
    this.width = initWidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = initHeight * this.chartItemViewFactory.scalePxPerUnitY;

    // Initial rotation
    var viewRotation = parseFloat(this.chartItemShape.rotation) || 0.0;
    this.chartItemShape.rotation = viewRotation;
    this.setViewRotation(viewRotation);
  },

  // Touch begin handler
  onTouchBegan: function (touch, event) {
    this._super(touch, event);

    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    this.setDynamic(true);

    if (touchPoint.x > (this.width - this._touchState.handleSize) && !this.getIsInRotationMode()) {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Resize);

      this._touchState.touchStartOffsetX = this.width - touchPoint.x;
    } else if (touchPoint.x > (this.width - this._touchState.handleSize) && this.getIsInRotationMode()) {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Rotation);

      this._touchState.originalAngle = Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this.getViewRotation();
    } else {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Move);

      this._touchState.touchStartOffsetX = this.x - touchPointSuper.x;
      this._touchState.touchStartOffsetY = this.y - touchPointSuper.y;

      this._touchState.touchLimitX1 = 0 - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitX2 = this.chartItemViewFactory.scaledStagePxWidth - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitY1 = 0 - this._touchState.touchStartOffsetY;
      this._touchState.touchLimitY2 = this.chartItemViewFactory.scaledStagePxHeight - this._touchState.handleSize -
        this._touchState.touchStartOffsetY;
    }

    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Resize) {
      var contentSize = this.getContentSize();
      contentSize.width = touchPoint.x + this._touchState.touchStartOffsetX;
      if (contentSize.width < this._touchState.handleSize) {
        contentSize.width = this._touchState.handleSize;
      }

      this.setContentSize(contentSize);
    } else if (this._dynamicMode === SWChartUI.ItemDynamicMode.Move) {
      if (this.delegate && this.delegate.delegate && this.delegate.delegate.killAutoSaveTimer) {
        this.delegate.delegate.killAutoSaveTimer();
      }

      if (touchPointSuper.x < this._touchState.touchLimitX1) {
        touchPointSuper.x = this._touchState.touchLimitX1;
      } else if (touchPointSuper.x > this._touchState.touchLimitX2) {
        touchPointSuper.x = this._touchState.touchLimitX2;
      }

      if (touchPointSuper.y < this._touchState.touchLimitY1) {
        touchPointSuper.y = this._touchState.touchLimitY1;
      } else if (touchPointSuper.y > this._touchState.touchLimitY2) {
        touchPointSuper.y = this._touchState.touchLimitY2;
      }

      this.x = touchPointSuper.x + this._touchState.touchStartOffsetX;
      this.y = touchPointSuper.y + this._touchState.touchStartOffsetY;
    } else if (this._dynamicMode === SWChartUI.ItemDynamicMode.Rotation) {
      // Calculate the angle between the start point and the current touch point
      var angle = -Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this._touchState.originalAngle;

      // Rotate the item
      this.setViewRotation(angle);
    }
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);

    if (this._dynamicMode !== SWChartUI.ItemDynamicMode.None) {
      this.ensureOnStage();
      this.updateEntity();
    }

    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);

    this.refresh();

    this.ensureOnStage();
  },

  ensureOnStage: function () {
    return;
    // var boundingBox = this.getBoundingBox();
    // var itemTop = cc.rectGetMinY(boundingBox);
    // var itemBott = cc.rectGetMaxY(boundingBox);
    // var itemLeft = cc.rectGetMinX(boundingBox);
    // var itemRight = cc.rectGetMaxX(boundingBox);
    //
    // var minVisibleSize = this.height;
    // var viewRotation = this.getViewRotation();
    // var sinMarginAdjust = Math.abs(minVisibleSize * Math.sin(cc.TWOPI - viewRotation));
    // var cosMarginAdjust = Math.abs(minVisibleSize * Math.cos(cc.TWOPI - viewRotation));
    //
    // if ((this.chartItemViewFactory.scaledStagePxWidth - itemLeft) < minVisibleSize) {
    //   this.x -= minVisibleSize - (this.chartItemViewFactory.scaledStagePxWidth - itemLeft);
    // }
    //
    // if (itemRight < minVisibleSize) {
    //   this.x += minVisibleSize - itemRight;
    // }
    //
    // if ((this.chartItemViewFactory.scaledStagePxHeight - itemTop) < minVisibleSize) {
    //   this.y -= minVisibleSize - (this.chartItemViewFactory.scaledStagePxHeight - itemTop);
    // }
    //
    // if (itemBott < minVisibleSize) {
    //   this.y += minVisibleSize - itemBott;
    // }
  },

  refresh: function () {
    this._super();

    if (!this.getIsInGroup()) {
      this.x = this.chartItemShape.positionx * this.chartItemViewFactory.scalePxPerUnitX;
      this.y = this.chartItemShape.positiony * this.chartItemViewFactory.scalePxPerUnitY;
    }

    this.width = this.chartItemShape.sizewidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = this.chartItemShape.sizeheight * this.chartItemViewFactory.scalePxPerUnitY;

    var viewRotation = parseFloat(this.chartItemShape.rotation) || 0.0;
    this.setViewRotation(viewRotation);
  },

  updateEntity: function () {
    if (this.getIsInGroup()) {
      return;
    }

    var changed = this._super();

    var newPositionX = this.x / this.chartItemViewFactory.scalePxPerUnitX;
    var newPositionY = this.y / this.chartItemViewFactory.scalePxPerUnitY;
    var newSizeWidth = this.width / this.chartItemViewFactory.scalePxPerUnitX;
    var newSizeHeight = this.height / this.chartItemViewFactory.scalePxPerUnitY;
    var newRotation = this.getViewRotation();

    if (Math.abs(this.chartItemShape.positionx - newPositionX) > 0.000001) {
      this.chartItemShape.positionx = newPositionX;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.positiony - newPositionY) > 0.000001) {
      this.chartItemShape.positiony = newPositionY;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.sizewidth - newSizeWidth) > 0.000001) {
      this.chartItemShape.sizewidth = newSizeWidth;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.sizeheight - newSizeHeight) > 0.000001) {
      this.chartItemShape.sizeheight = newSizeHeight;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.rotation - newRotation) > 0.000001) {
      this.chartItemShape.rotation = newRotation;
      changed = true;
    }

    if (changed) {
      this.delegate.chartItemNotifyDidChange();
    }

    return changed;
  },

  _createRenderCmd: function () {
    return new ChartItemShapeCurtainView.CanvasRenderCmd(this);
  },
});

(function () {
  ChartItemShapeCurtainView.CanvasRenderCmd = function (renderable) {
    ChartItemShapeView.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
  };

  var proto = ChartItemShapeCurtainView.CanvasRenderCmd.prototype = Object.create(ChartItemShapeView.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemShapeCurtainView.CanvasRenderCmd;
  proto.rendering = function (ctx, scaleX, scaleY) {
    ChartItemShapeView.CanvasRenderCmd.prototype.rendering.call(this, ctx, scaleX, scaleY);

    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var drawingUtil = cc._drawingUtil;

    var strokeWidth;
    if (angular.isDefined(node.chartItemShape.linethickness)) {
      strokeWidth = this.getStrokeWidthWithBase(node.chartItemShape.linethickness);
    } else {
      strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
    }

    var x1 = 0;
    var x2 = node.width;
    var h = node.height - (2 * strokeWidth);
    var hByTwo = (h / 2) + strokeWidth;
    var deltaX = Math.round((h / 2) * 0.7);

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    wrapper.save();
    drawingUtil.setStrokeColorCss(this.lineColorCss);
    drawingUtil.setLineWidth(strokeWidth);
    drawingUtil.clipToNode(node);

    for (var offset = x1; offset < x2; offset += (deltaX * 4)) {
      drawingUtil.drawQuadraticCurve(cc.p(offset + 0, h), cc.p(offset + deltaX, h), cc.p(offset + deltaX, hByTwo));
      drawingUtil.drawQuadraticCurve(cc.p(offset + deltaX, hByTwo), cc.p(offset + deltaX, strokeWidth), cc.p(offset + (2 * deltaX), strokeWidth));
      drawingUtil.drawQuadraticCurve(cc.p(offset + (2 * deltaX), strokeWidth), cc.p(offset + (3 * deltaX), strokeWidth), cc.p(offset + (3 * deltaX), hByTwo));
      drawingUtil.drawQuadraticCurve(cc.p(offset + (3 * deltaX), hByTwo), cc.p(offset + (3 * deltaX), h), cc.p(offset + (4 * deltaX), h));
    }
    wrapper.restore();

    if (node._selectionState.active && !node._selectionState.rotationMode) {
      this.drawHorizontalSizeHandle(ctx, scaleX, scaleY);
    }
    if (node._selectionState.rotationMode && node._selectionState.active) {
      this.drawHorizontalRotationHandle(ctx, scaleX, scaleY);
    }

    // temp draw the bounding box
    // wrapper.save();
    // var boundingBox = node.getBoundingBox();
    // drawingUtil.setStrokeColorCss('rgb(0, 0, 255)');
    // drawingUtil.setLineWidth(1);
    // drawingUtil.drawRectangle(cc.p(boundingBox.x, boundingBox.y), cc.p(boundingBox.x + boundingBox.width, boundingBox.y + boundingBox.height), cc.color(0, 0, 255, 255));
    // wrapper.restore();
  };
})();

/////////////////////////////////////////////////
// ChartItemShapeVectorView
//
var ChartItemShapeVectorView = ChartItemShapeView.extend({
  points: [],

  ctor: function (chartItem, chartItemViewFactory) {
    this._super(chartItem, chartItemViewFactory);

    this._editabilityFlags.editable = true;
    this._editabilityFlags.sizeable = false;

    this._renderCmd.drawWithCurves = ((this.shapeType === SWChartItem.ShapeType.Curve) || (this.shapeType === SWChartItem.ShapeType.CurveArrow));
    this._renderCmd.hasArrowHead = ((this.shapeType === SWChartItem.ShapeType.JoinedLineArrow) || (this.shapeType === SWChartItem.ShapeType.CurveArrow));

    var initX = parseFloat(this.chartItemShape.positionx) || 0;
    var initY = parseFloat(this.chartItemShape.positiony) || 0;
    var initWidth = parseFloat(this.chartItemShape.sizewidth) || 0;
    var initHeight = parseFloat(this.chartItemShape.sizeheight) || 0;
    var initLineThickness = parseFloat(this.chartItemShape.linethickness) || chartBaseLineWidth;

    if ((initWidth === 0) && (initHeight === 0)) {
      // initial position is center of visible statge
      initX = (-this.chartItemViewFactory.scaledStagePxOffset.x + this.chartItemViewFactory.stageViewSize.width / 2) / this.chartItemViewFactory.scalePxPerUnitX;
      initY = (-this.chartItemViewFactory.scaledStagePxOffset.y + this.chartItemViewFactory.stageViewSize.height / 2) / this.chartItemViewFactory.scalePxPerUnitY;

      // Initial size
      initWidth = this.chartItemViewFactory.stageUnitWidth / 4;
      initHeight = this.chartItemViewFactory.stageUnitDepth / 4;

      // Set the initial values on the entity
      this.chartItemShape.positionx = initX;
      this.chartItemShape.positiony = initY;
      this.chartItemShape.sizewidth = initWidth;
      this.chartItemShape.sizeheight = initHeight;
      this.chartItemShape.shapepaths = [
        {
          lineColor: this._defaultLineColorCss,
          points: [cc.p(0, 1.0), cc.p(0.5, 0), cc.p(1.0, 1.0)],
          hasArrowHead: this._renderCmd.hasArrowHead,
        }
      ];
      this.chartItemShape.rotation = 0;
      this.chartItemShape.linethickness = initLineThickness;
    }

    // Initial view position and size
    this.x = initX * this.chartItemViewFactory.scalePxPerUnitX;
    this.y = initY * this.chartItemViewFactory.scalePxPerUnitY;
    this.width = initWidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = initHeight * this.chartItemViewFactory.scalePxPerUnitY;

    // Initial rotation
    var viewRotation = parseFloat(this.chartItemShape.rotation) || 0.0;
    this.chartItemShape.rotation = viewRotation;
    this.setViewRotation(viewRotation);

    // Initial data
    var shapePath = this.chartItemShape.shapepaths[0];
    this._renderCmd.shapePath = deepClone(shapePath);//_.clone(shapePath);
    this.setLineColorCss(shapePath.lineColor);
  },

  // Touch begin handler
  onTouchBegan: function (touch, event) {
    this._super(touch, event);

    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (((touchPoint.x > (this.width - this._touchState.handleSize)) && (touchPoint.y < this._touchState.handleSize)) && this.getIsInRotationMode()) {
      this.setDynamic(true);
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Rotation);

      this._touchState.originalAngle = Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this.getViewRotation();
    } else {
      this.setDynamic(true);

      this.setDynamicMode(SWChartUI.ItemDynamicMode.Move);

      this._touchState.touchStartOffsetX = this.x - touchPointSuper.x;
      this._touchState.touchStartOffsetY = this.y - touchPointSuper.y;

      this._touchState.touchLimitX1 = 0 - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitX2 = this.chartItemViewFactory.scaledStagePxWidth - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitY1 = 0 - this._touchState.touchStartOffsetY;
      this._touchState.touchLimitY2 = this.chartItemViewFactory.scaledStagePxHeight - this._touchState.touchStartOffsetY;
    }
    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Rotation) {
      // Calculate the angle between the start point and the current touch point
      var angle = -Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this._touchState.originalAngle;

      // Rotate the item
      this.setViewRotation(angle);
    } else {
      if (this.delegate && this.delegate.delegate && this.delegate.delegate.killAutoSaveTimer) {
        this.delegate.delegate.killAutoSaveTimer();
      }

      if (touchPointSuper.x < this._touchState.touchLimitX1) {
        touchPointSuper.x = this._touchState.touchLimitX1;
      } else if (touchPointSuper.x > this._touchState.touchLimitX2) {
        touchPointSuper.x = this._touchState.touchLimitX2;
      }

      if (touchPointSuper.y < this._touchState.touchLimitY1) {
        touchPointSuper.y = this._touchState.touchLimitY1;
      } else if (touchPointSuper.y > this._touchState.touchLimitY2) {
        touchPointSuper.y = this._touchState.touchLimitY2;
      }

      this.x = touchPointSuper.x + this._touchState.touchStartOffsetX;
      this.y = touchPointSuper.y + this._touchState.touchStartOffsetY;
    }
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);

    if (this._dynamicMode !== SWChartUI.ItemDynamicMode.None) {
      this.updateEntity();
    }
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);

    this.refresh();
  },

  refresh: function () {
    this._super();

    if (!this.getIsInGroup()) {
      this.x = this.chartItemShape.positionx * this.chartItemViewFactory.scalePxPerUnitX;
      this.y = this.chartItemShape.positiony * this.chartItemViewFactory.scalePxPerUnitY;
    }

    this.width = this.chartItemShape.sizewidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = this.chartItemShape.sizeheight * this.chartItemViewFactory.scalePxPerUnitY;

    var viewRotation = parseFloat(this.chartItemShape.rotation) || 0.0;
    this.setViewRotation(viewRotation);

    var shapePath = this.chartItemShape.shapepaths[0];
    this._renderCmd.shapePath = deepClone(shapePath);//_.clone(shapePath);
    this.setLineColorCss(shapePath.lineColor);
  },

  updateEntity: function () {
    if (this.getIsInGroup()) {
      return;
    }

    var changed = this._super();

    var newPositionX = this.x / this.chartItemViewFactory.scalePxPerUnitX;
    var newPositionY = this.y / this.chartItemViewFactory.scalePxPerUnitY;
    var newSizeWidth = this.width / this.chartItemViewFactory.scalePxPerUnitX;
    var newSizeHeight = this.height / this.chartItemViewFactory.scalePxPerUnitY;
    var newLineColorCss = this.getLineColorCss();
    var newRotation = this.getViewRotation();

    if (Math.abs(this.chartItemShape.positionx - newPositionX) > 0.000001) {
      this.chartItemShape.positionx = newPositionX;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.positiony - newPositionY) > 0.000001) {
      this.chartItemShape.positiony = newPositionY;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.sizewidth - newSizeWidth) > 0.000001) {
      this.chartItemShape.sizewidth = newSizeWidth;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.sizeheight - newSizeHeight) > 0.000001) {
      this.chartItemShape.sizeheight = newSizeHeight;
      changed = true;
    }

    if (this.chartItemShape.shapepaths[0].lineColor !== newLineColorCss) {
      this.chartItemShape.shapepaths[0].lineColor = newLineColorCss;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.rotation - newRotation) > 0.000001) {
      this.chartItemShape.rotation = newRotation;
      changed = true;
    }

    if (changed) {
      this.delegate.chartItemNotifyDidChange();
    }

    return changed;
  },

  isEmpty: function () {
    return (this.chartItemShape.shapepaths[0].points.length < 2)
  },

  _createRenderCmd: function () {
    return new ChartItemShapeVectorView.CanvasRenderCmd(this);
  },
});

(function () {
  ChartItemShapeVectorView.CanvasRenderCmd = function (renderable) {
    ChartItemShapeView.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
    this.drawWithCurves = false;
    this.hasArrowHead = false;
    this.shapePath = {};
  };
  var proto = ChartItemShapeVectorView.CanvasRenderCmd.prototype = Object.create(ChartItemShapeView.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemShapeVectorView.CanvasRenderCmd;
  proto.rendering = function (ctx, scaleX, scaleY) {
    var node = this._node;

    if (node.getIsEditing()) {
      return;
    }

    ChartItemShapeView.CanvasRenderCmd.prototype.rendering.call(this, ctx, scaleX, scaleY);

    if ((!Array.isArray(this.shapePath.points)) || (this.shapePath.points.length < 2)) {
      return;
    }

    var wrapper = ctx || cc._renderContext;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    wrapper.save();
    wrapper.setLineCap('round');
    wrapper.setLineJoin('round');

    if (this.drawWithCurves) {
      if (this.showOutline) {
        this.renderingDrawCurvesOutline();
      }
      this.renderingDrawCurves();
    } else {
      if (this.showOutline) {
        this.renderingDrawLinesOutline();
      }
      this.renderingDrawLines();
    }

    wrapper.restore();

    if (node._selectionState.rotationMode && node._selectionState.active && node.getIsRotatable()) {
      this.drawDiagonalRotationHandle(ctx, scaleX, scaleY);
    }
  };

  // drawing implementation for lines outline
  proto.renderingDrawLinesOutline = function () {
    var node = this._node;
    var drawingUtil = cc._drawingUtil;

    var strokeWidth;
    if (angular.isDefined(node.chartItemShape.linethickness)) {
      strokeWidth = this.getStrokeWidthWithBase(node.chartItemShape.linethickness);
    } else {
      strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
    }
    var outlineStrokeWidth = strokeWidth * 2;

    var w = node.width;
    var h = node.height;
    var numPoints = this.shapePath.points.length;

    drawingUtil.setStrokeColorCss(this.outlineColorCss);
    drawingUtil.setFillColorCss(this.outlineColorCss);
    drawingUtil.setLineWidth(outlineStrokeWidth);

    var vertices = [];
    var currentPoint;
    for (var i = 0; i < (numPoints - 1); i++) {
      currentPoint = this.shapePath.points[i];
      vertices.push(cc.p(currentPoint.x * w, currentPoint.y * h));
    }

    var lastPoint = this.shapePath.points[numPoints - 1];
    if (!this.shapePath.hasArrowHead) {
      vertices.push(cc.p(lastPoint.x * w, lastPoint.y * h));
      drawingUtil.drawPolyline(vertices);
    } else {
      var mx = currentPoint.x * w;
      var my = currentPoint.y * h;

      var nx = lastPoint.x * w;
      var ny = lastPoint.y * h;

      var length = 6 * strokeWidth;
      var width = 3 * strokeWidth;

      var r = Math.atan2(ny - my, nx - mx);
      var bx = nx;
      var by = ny;
      var dx = bx - Math.cos(r) * length;
      var dy = by - Math.sin(r) * length;
      r += Math.PI / 2; // perpendicular to path
      var ax = dx + Math.cos(r) * width;
      var ay = dy + Math.sin(r) * width;
      var cx = dx - Math.cos(r) * width;
      var cy = dy - Math.sin(r) * width;

      vertices.push(cc.p(dx, dy));
      drawingUtil.drawPolyline(vertices);

      drawingUtil.setLineWidth(strokeWidth);
      var arrowVertices = [];
      arrowVertices.push(cc.p(ax, ay));
      arrowVertices.push(cc.p(bx, by));
      arrowVertices.push(cc.p(cx, cy));
      drawingUtil.drawPolygon(arrowVertices);
    }

  };

  // drawing implementation for lines
  proto.renderingDrawLines = function () {
    var node = this._node;
    var drawingUtil = cc._drawingUtil;

    var strokeWidth;
    if (angular.isDefined(node.chartItemShape.linethickness)) {
      strokeWidth = this.getStrokeWidthWithBase(node.chartItemShape.linethickness);
    } else {
      strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
    }

    var w = node.width;
    var h = node.height;
    var numPoints = this.shapePath.points.length;

    drawingUtil.setStrokeColorCss(this.lineColorCss);
    drawingUtil.setFillColorCss(this.lineColorCss);
    drawingUtil.setLineWidth(strokeWidth);

    var vertices = [];
    var currentPoint;
    for (var i = 0; i < (numPoints - 1); i++) {
      currentPoint = this.shapePath.points[i];
      vertices.push(cc.p(currentPoint.x * w, currentPoint.y * h));
    }

    var lastPoint = this.shapePath.points[numPoints - 1];
    if (!this.shapePath.hasArrowHead) {
      vertices.push(cc.p(lastPoint.x * w, lastPoint.y * h));
      drawingUtil.drawPolyline(vertices);
    } else {
      var mx = currentPoint.x * w;
      var my = currentPoint.y * h;

      var nx = lastPoint.x * w;
      var ny = lastPoint.y * h;

      var length = 6 * strokeWidth;
      var width = 3 * strokeWidth;

      var r = Math.atan2(ny - my, nx - mx);
      var bx = nx;
      var by = ny;
      var dx = bx - Math.cos(r) * length;
      var dy = by - Math.sin(r) * length;
      r += Math.PI / 2; // perpendicular to path
      var ax = dx + Math.cos(r) * width;
      var ay = dy + Math.sin(r) * width;
      var cx = dx - Math.cos(r) * width;
      var cy = dy - Math.sin(r) * width;

      vertices.push(cc.p(dx, dy));
      drawingUtil.drawPolyline(vertices);

      var arrowVertices = [];
      arrowVertices.push(cc.p(ax, ay));
      arrowVertices.push(cc.p(bx, by));
      arrowVertices.push(cc.p(cx, cy));
      drawingUtil.drawPolygon(arrowVertices, false, true);
    }
  };

  // drawing implementation for curves outline
  proto.renderingDrawCurvesOutline = function () {
    var node = this._node;
    var drawingUtil = cc._drawingUtil;

    var strokeWidth;
    if (angular.isDefined(node.chartItemShape.linethickness)) {
      strokeWidth = this.getStrokeWidthWithBase(node.chartItemShape.linethickness);
    } else {
      strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
    }
    var outlineStrokeWidth = strokeWidth * 2;

    var w = node.width;
    var h = node.height;
    var numPoints = this.shapePath.points.length;

    drawingUtil.setStrokeColorCss(this.outlineColorCss);
    drawingUtil.setFillColorCss(this.outlineColorCss);
    drawingUtil.setLineWidth(outlineStrokeWidth);

    var prevPoint;
    var midPoint = cc.p(this.shapePath.points[0].x * w, this.shapePath.points[0].y * h);
    var nextPoint = cc.p(this.shapePath.points[1].x * w, this.shapePath.points[1].y * h);
    var currPoint = cc.p((midPoint.x + nextPoint.x) / 2, (midPoint.y + nextPoint.y) / 2);
    drawingUtil.drawLine(midPoint, currPoint);
    for (var i = 2; i < numPoints; i++) {
      prevPoint = currPoint;
      midPoint = nextPoint;

      nextPoint = cc.p(this.shapePath.points[i].x * w, this.shapePath.points[i].y * h);
      currPoint = cc.p((midPoint.x + nextPoint.x) / 2, (midPoint.y + nextPoint.y) / 2);

      drawingUtil.drawQuadraticCurve(prevPoint, midPoint, currPoint);
    }
    if (!this.shapePath.hasArrowHead) {
      drawingUtil.drawLine(currPoint, nextPoint);
    } else {
      var mx = currPoint.x;
      var my = currPoint.y;

      var nx = nextPoint.x;
      var ny = nextPoint.y;

      var length = 6 * strokeWidth;
      var width = 3 * strokeWidth;

      var r = Math.atan2(ny - my, nx - mx);
      var bx = nx;
      var by = ny;
      var dx = bx - Math.cos(r) * length;
      var dy = by - Math.sin(r) * length;
      r += Math.PI / 2; // perpendicular to path
      var ax = dx + Math.cos(r) * width;
      var ay = dy + Math.sin(r) * width;
      var cx = dx - Math.cos(r) * width;
      var cy = dy - Math.sin(r) * width;

      drawingUtil.drawLine(cc.p(mx, my), cc.p(dx, dy));

      drawingUtil.setLineWidth(strokeWidth);
      var arrowVertices = [];
      arrowVertices.push(cc.p(ax, ay));
      arrowVertices.push(cc.p(bx, by));
      arrowVertices.push(cc.p(cx, cy));
      drawingUtil.drawPolygon(arrowVertices);
    }
  };

  // drawing implementation for curves
  proto.renderingDrawCurves = function () {
    var node = this._node;
    var drawingUtil = cc._drawingUtil;

    var strokeWidth;
    if (angular.isDefined(node.chartItemShape.linethickness)) {
      strokeWidth = this.getStrokeWidthWithBase(node.chartItemShape.linethickness);
    } else {
      strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
    }

    var w = node.width;
    var h = node.height;
    var numPoints = this.shapePath.points.length;

    drawingUtil.setStrokeColorCss(this.lineColorCss);
    drawingUtil.setFillColorCss(this.lineColorCss);
    drawingUtil.setLineWidth(strokeWidth);

    var prevPoint;
    var midPoint = cc.p(this.shapePath.points[0].x * w, this.shapePath.points[0].y * h);
    var nextPoint = cc.p(this.shapePath.points[1].x * w, this.shapePath.points[1].y * h);
    var currPoint = cc.p((midPoint.x + nextPoint.x) / 2, (midPoint.y + nextPoint.y) / 2);
    drawingUtil.drawLine(midPoint, currPoint);
    for (var i = 2; i < numPoints; i++) {
      prevPoint = currPoint;
      midPoint = nextPoint;

      nextPoint = cc.p(this.shapePath.points[i].x * w, this.shapePath.points[i].y * h);
      currPoint = cc.p((midPoint.x + nextPoint.x) / 2, (midPoint.y + nextPoint.y) / 2);

      drawingUtil.drawQuadraticCurve(prevPoint, midPoint, currPoint);
    }

    if (!this.shapePath.hasArrowHead) {
      drawingUtil.drawLine(currPoint, nextPoint);
    } else {
      var mx = currPoint.x;
      var my = currPoint.y;

      var nx = nextPoint.x;
      var ny = nextPoint.y;

      var length = 6 * strokeWidth;
      var width = 3 * strokeWidth;

      var r = Math.atan2(ny - my, nx - mx);
      var bx = nx;
      var by = ny;
      var dx = bx - Math.cos(r) * length;
      var dy = by - Math.sin(r) * length;
      r += Math.PI / 2; // perpendicular to path
      var ax = dx + Math.cos(r) * width;
      var ay = dy + Math.sin(r) * width;
      var cx = dx - Math.cos(r) * width;
      var cy = dy - Math.sin(r) * width;

      drawingUtil.drawLine(cc.p(mx, my), cc.p(dx, dy));

      var arrowVertices = [];
      arrowVertices.push(cc.p(ax, ay));
      arrowVertices.push(cc.p(bx, by));
      arrowVertices.push(cc.p(cx, cy));
      drawingUtil.drawPolygon(arrowVertices, false, true);
    }
  };
})();

/////////////////////////////////////////////////
// ChartItemShapeFreehandView
//
var ChartItemShapeFreehandView = ChartItemShapeView.extend({
  points: [],

  ctor: function (chartItem, chartItemViewFactory) {
    this._super(chartItem, chartItemViewFactory);

    this._editabilityFlags.sizeable = false;

    this._renderCmd.hasArrowHead = this.chartItemShape.hasArrowHead;

    var initX = parseFloat(this.chartItemShape.positionx) || 0;
    var initY = parseFloat(this.chartItemShape.positiony) || 0;
    var initWidth = parseFloat(this.chartItemShape.sizewidth) || 0;
    var initHeight = parseFloat(this.chartItemShape.sizeheight) || 0;
    var initLineThickness = parseFloat(this.chartItemShape.linethickness) || this.chartBaseLineWidth;

    if ((initWidth === 0) && (initHeight === 0)) {
      // initial position is center of visible statge
      initX = (-this.chartItemViewFactory.scaledStagePxOffset.x + this.chartItemViewFactory.stageViewSize.width / 2) / this.chartItemViewFactory.scalePxPerUnitX;
      initY = (-this.chartItemViewFactory.scaledStagePxOffset.y + this.chartItemViewFactory.stageViewSize.height / 2) / this.chartItemViewFactory.scalePxPerUnitY;

      // Initial size
      initWidth = this.chartItemViewFactory.stageUnitWidth / 4;
      initHeight = this.chartItemViewFactory.stageUnitDepth / 4;

      // Set the initial values on the entity
      this.chartItemShape.positionx = initX;
      this.chartItemShape.positiony = initY;
      this.chartItemShape.sizewidth = initWidth;
      this.chartItemShape.sizeheight = initHeight;
      this.chartItemShape.shapepaths = [];
      this.chartItemShape.rotation = 0;
      this.chartItemShape.linethickness = initLineThickness;
    }

    // Initial view position and size
    this.x = initX * this.chartItemViewFactory.scalePxPerUnitX;
    this.y = initY * this.chartItemViewFactory.scalePxPerUnitY;
    this.width = initWidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = initHeight * this.chartItemViewFactory.scalePxPerUnitY;

    // Initial rotation
    var viewRotation = parseFloat(this.chartItemShape.rotation) || 0.0;
    this.chartItemShape.rotation = viewRotation;
    this.setViewRotation(viewRotation);

    // Initial data
    this._renderCmd.shapePaths = deepClone(this.chartItemShape.shapepaths) || [];//_.clone(this.chartItemShape.shapepaths) || [];
  },

  // Touch begin handler
  onTouchBegan: function (touch, event) {
    this._super(touch, event);

    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (((touchPoint.x > (this.width - this._touchState.handleSize)) && (touchPoint.y < this._touchState.handleSize)) && this.getIsInRotationMode()) {
      this.setDynamic(true);
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Rotation);

      this._touchState.originalAngle = Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this.getViewRotation();
    } else {
      this.setDynamic(true);

      this.setDynamicMode(SWChartUI.ItemDynamicMode.Move);

      this._touchState.touchStartOffsetX = this.x - touchPointSuper.x;
      this._touchState.touchStartOffsetY = this.y - touchPointSuper.y;

      this._touchState.touchLimitX1 = 0 - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitX2 = this.chartItemViewFactory.scaledStagePxWidth - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitY1 = 0 - this._touchState.touchStartOffsetY;
      this._touchState.touchLimitY2 = this.chartItemViewFactory.scaledStagePxHeight - this._touchState.touchStartOffsetY;
    }
    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);
    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Rotation) {
      // Calculate the angle between the start point and the current touch point
      var angle = -Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this._touchState.originalAngle;

      // Rotate the item
      this.setViewRotation(angle);
    } else {
      if (this.delegate && this.delegate.delegate && this.delegate.delegate.killAutoSaveTimer) {
        this.delegate.delegate.killAutoSaveTimer();
      }

      if (touchPointSuper.x < this._touchState.touchLimitX1) {
        touchPointSuper.x = this._touchState.touchLimitX1;
      } else if (touchPointSuper.x > this._touchState.touchLimitX2) {
        touchPointSuper.x = this._touchState.touchLimitX2;
      }

      if (touchPointSuper.y < this._touchState.touchLimitY1) {
        touchPointSuper.y = this._touchState.touchLimitY1;
      } else if (touchPointSuper.y > this._touchState.touchLimitY2) {
        touchPointSuper.y = this._touchState.touchLimitY2;
      }

      this.x = touchPointSuper.x + this._touchState.touchStartOffsetX;
      this.y = touchPointSuper.y + this._touchState.touchStartOffsetY;
    }
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);

    if (this._dynamicMode !== SWChartUI.ItemDynamicMode.None) {
      this.updateEntity();
    }
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);

    this.refresh();
  },

  getSupportsLineColor: function () {
    return false;
  },

  refresh: function () {
    this._super();

    if (!this.getIsInGroup()) {
      this.x = this.chartItemShape.positionx * this.chartItemViewFactory.scalePxPerUnitX;
      this.y = this.chartItemShape.positiony * this.chartItemViewFactory.scalePxPerUnitY;
    }

    this.width = this.chartItemShape.sizewidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = this.chartItemShape.sizeheight * this.chartItemViewFactory.scalePxPerUnitY;

    var viewRotation = parseFloat(this.chartItemShape.rotation) || 0.0;
    this.setViewRotation(viewRotation);

    this._renderCmd.shapePaths = deepClone(this.chartItemShape.shapepaths) || [];//_.clone(this.chartItemShape.shapepaths) || [];
  },

  updateEntity: function () {
    if (this.getIsInGroup()) {
      return;
    }

    var changed = this._super();

    var newPositionX = this.x / this.chartItemViewFactory.scalePxPerUnitX;
    var newPositionY = this.y / this.chartItemViewFactory.scalePxPerUnitY;
    var newSizeWidth = this.width / this.chartItemViewFactory.scalePxPerUnitX;
    var newSizeHeight = this.height / this.chartItemViewFactory.scalePxPerUnitY;
    var newRotation = this.getViewRotation();

    if (Math.abs(this.chartItemShape.positionx - newPositionX) > 0.000001) {
      this.chartItemShape.positionx = newPositionX;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.positiony - newPositionY) > 0.000001) {
      this.chartItemShape.positiony = newPositionY;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.sizewidth - newSizeWidth) > 0.000001) {
      this.chartItemShape.sizewidth = newSizeWidth;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.sizeheight - newSizeHeight) > 0.000001) {
      this.chartItemShape.sizeheight = newSizeHeight;
      changed = true;
    }

    if (Math.abs(this.chartItemShape.rotation - newRotation) > 0.000001) {
      this.chartItemShape.rotation = newRotation;
      changed = true;
    }

    if (changed) {
      this.delegate.chartItemNotifyDidChange();
    }

    return changed;
  },

  isEmpty: function () {
    return (!Array.isArray(this.chartItemShape.shapepaths) || this.chartItemShape.shapepaths.length === 0);
  },

  _createRenderCmd: function () {
    return new ChartItemShapeFreehandView.CanvasRenderCmd(this);
  },
});

(function () {
  ChartItemShapeFreehandView.CanvasRenderCmd = function (renderable) {
    ChartItemShapeView.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
    this.hasArrowHead = false;
    this.shapePaths = [];
  };

  var proto = ChartItemShapeFreehandView.CanvasRenderCmd.prototype = Object.create(ChartItemShapeView.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemShapeFreehandView.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {
    var node = this._node;
    var _this = this;

    ChartItemShapeView.CanvasRenderCmd.prototype.rendering.call(this, ctx, scaleX, scaleY);

    if (this.shapePaths.length === 0) {
      return;
    }

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext();

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    wrapper.save();
    wrapper.setLineCap('round');
    wrapper.setLineJoin('round');

    if (this.shapePaths.length > 0) {
      this.shapePaths.forEach(function (shapePath) {
        if (_this.showOutline) {
          _this.renderingDrawCurvesOutline(shapePath);
        }
        _this.drawShapePath(shapePath);
      });
    }

    if (node._selectionState.rotationMode && node._selectionState.active) {
      this.drawDiagonalRotationHandle(ctx, scaleX, scaleY);
    }

    wrapper.restore();
  };

  // drawing implementation for curves outline
  proto.renderingDrawCurvesOutline = function (shapePath) {
    var node = this._node;
    var drawingUtil = cc._drawingUtil;

    var strokeWidth;
    if (angular.isDefined(shapePath.linethickness)) {
      strokeWidth = this.getStrokeWidthWithBase(shapePath.linethickness);
    } else {
      strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
    }
    var outlineStrokeWidth = strokeWidth * 2;

    var w = node.width;
    var h = node.height;
    var numPoints = shapePath.points.length;

    drawingUtil.setStrokeColorCss(this.outlineColorCss);
    drawingUtil.setFillColorCss(this.outlineColorCss);
    drawingUtil.setLineWidth(outlineStrokeWidth);

    var originPoint = cc.p(shapePath.points[0].x * w, shapePath.points[0].y * h);
    var controlPoint = cc.p(shapePath.points[0].x * w, shapePath.points[0].y * h);
    var destPoint = cc.p((shapePath.points[0].x + shapePath.points[1].x) * w / 2, (shapePath.points[0].y + shapePath.points[1].y) * h / 2);
    drawingUtil.drawLine(originPoint, destPoint);
    for (var i = 1; i < (numPoints - 1); i++) {
      originPoint = destPoint;
      controlPoint = cc.p(shapePath.points[i].x * w, shapePath.points[i].y * h);
      destPoint = cc.p((shapePath.points[i].x + shapePath.points[i + 1].x) * w / 2, (shapePath.points[i].y + shapePath.points[i + 1].y) * h / 2);

      drawingUtil.drawQuadraticCurve(originPoint, controlPoint, destPoint);
    }
    if (!shapePath.hasArrowHead) {
      drawingUtil.drawLine(destPoint, cc.p(shapePath.points[numPoints - 1].x * w, shapePath.points[numPoints - 1].y * h));
    } else {
      var currentPoint = shapePath.points[numPoints - 1];

      var mx = destPoint.x;
      var my = destPoint.y;

      var nx = currentPoint.x * w;
      var ny = currentPoint.y * h;

      var length = 6 * strokeWidth;
      var width = 3 * strokeWidth;

      var r = Math.atan2(ny - my, nx - mx);
      var bx = nx;
      var by = ny;
      var dx = bx - Math.cos(r) * length;
      var dy = by - Math.sin(r) * length;
      r += Math.PI / 2; // perpendicular to path
      var ax = dx + Math.cos(r) * width;
      var ay = dy + Math.sin(r) * width;
      var cx = dx - Math.cos(r) * width;
      var cy = dy - Math.sin(r) * width;

      drawingUtil.drawLine(cc.p(mx, my), cc.p(dx, dy));

      drawingUtil.setLineWidth(strokeWidth);
      var arrowVertices = [];
      arrowVertices.push(cc.p(ax, ay));
      arrowVertices.push(cc.p(bx, by));
      arrowVertices.push(cc.p(cx, cy));
      drawingUtil.drawPolygon(arrowVertices);
    }
  };

  // drawing implementation for curves
  proto.drawShapePath = function (shapePath) {
    var node = this._node;
    var drawingUtil = cc._drawingUtil;

    var strokeWidth;
    if (angular.isDefined(shapePath.linethickness)) {
      strokeWidth = this.getStrokeWidthWithBase(shapePath.linethickness);
    } else {
      strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
    }

    var w = node.width;
    var h = node.height;
    var numPoints = shapePath.points.length;

    drawingUtil.setStrokeColorCss(shapePath.lineColor);
    drawingUtil.setFillColorCss(shapePath.lineColor);
    drawingUtil.setLineWidth(strokeWidth);

    var originPoint = cc.p(shapePath.points[0].x * w, shapePath.points[0].y * h);
    var controlPoint = cc.p(shapePath.points[0].x * w, shapePath.points[0].y * h);
    var destPoint = cc.p((shapePath.points[0].x + shapePath.points[1].x) * w / 2, (shapePath.points[0].y + shapePath.points[1].y) * h / 2);
    drawingUtil.drawLine(originPoint, destPoint);
    for (var i = 1; i < (numPoints - 1); i++) {
      originPoint = destPoint;
      controlPoint = cc.p(shapePath.points[i].x * w, shapePath.points[i].y * h);
      destPoint = cc.p((shapePath.points[i].x + shapePath.points[i + 1].x) * w / 2, (shapePath.points[i].y + shapePath.points[i + 1].y) * h / 2);

      drawingUtil.drawQuadraticCurve(originPoint, controlPoint, destPoint);
    }
    if (!shapePath.hasArrowHead) {
      drawingUtil.drawLine(destPoint, cc.p(shapePath.points[numPoints - 1].x * w, shapePath.points[numPoints - 1].y * h));
    } else {
      var currentPoint = shapePath.points[numPoints - 1];

      var mx = destPoint.x;
      var my = destPoint.y;

      var nx = currentPoint.x * w;
      var ny = currentPoint.y * h;

      var length = 6 * strokeWidth;
      var width = 3 * strokeWidth;

      var r = Math.atan2(ny - my, nx - mx);
      var bx = nx;
      var by = ny;
      var dx = bx - Math.cos(r) * length;
      var dy = by - Math.sin(r) * length;
      r += Math.PI / 2; // perpendicular to path
      var ax = dx + Math.cos(r) * width;
      var ay = dy + Math.sin(r) * width;
      var cx = dx - Math.cos(r) * width;
      var cy = dy - Math.sin(r) * width;

      drawingUtil.drawLine(cc.p(mx, my), cc.p(dx, dy));

      var arrowVertices = [];
      arrowVertices.push(cc.p(ax, ay));
      arrowVertices.push(cc.p(bx, by));
      arrowVertices.push(cc.p(cx, cy));
      drawingUtil.drawPolygon(arrowVertices, false, true);
    }
  };
})();

/////////////////////////////////////////////////
// ChartItemTextView
//
var ChartItemTextView = ChartItemBaseView.extend({
  _defaultBackgroundColorCss: 'rgba(0,0,0,0)',

  _backgroundColorCss: 'rgba(0,0,0,0)',

  ctor: function (chartItem, chartItemViewFactory) {
    this._super(chartItemViewFactory);

    this._editabilityFlags.rotatable = true;
    this._editabilityFlags.editable = true;
    this._editabilityFlags.sizeable = true;

    this.setAnchorPoint(0.5, 0.5);

    this.chartItemText = chartItem;

    var initX = parseFloat(this.chartItemText.positionx) || 0;
    var initY = parseFloat(this.chartItemText.positiony) || 0;
    var initWidth = parseFloat(this.chartItemText.sizewidth) || 0;
    var initHeight = parseFloat(this.chartItemText.sizeheight) || 0;

    if ((initWidth === 0) && (initHeight === 0)) {
      // initial position is center of visible stage
      initX = (-this.chartItemViewFactory.scaledStagePxOffset.x + this.chartItemViewFactory.stageViewSize.width / 2) / this.chartItemViewFactory.scalePxPerUnitX;
      initY = (-this.chartItemViewFactory.scaledStagePxOffset.y + this.chartItemViewFactory.stageViewSize.height / 2) / this.chartItemViewFactory.scalePxPerUnitY;

      initWidth = 6;
      initHeight = 1.5;

      // initial size  adjusted for measurement unit
      initWidth = initWidth * this.chartItemViewFactory.measurementConversionMultiplier;
      initHeight = initHeight * this.chartItemViewFactory.measurementConversionMultiplier;

      // Set the initial values on the entity
      this.chartItemText.positionx = initX;
      this.chartItemText.positiony = initY;
      this.chartItemText.sizewidth = initWidth;
      this.chartItemText.sizeheight = initHeight;

      // Initial text
      this.chartItemText.textcontent = '';
      this.chartItemText.richtextcontent = '';
      this.chartItemText.rotation = 0;
    }

    // Initial view position and size
    this.x = initX * this.chartItemViewFactory.scalePxPerUnitX;
    this.y = initY * this.chartItemViewFactory.scalePxPerUnitY;
    this.width = initWidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = initHeight * this.chartItemViewFactory.scalePxPerUnitY;

    // Initial rotation
    var viewRotation = parseFloat(this.chartItemText.rotation) || 0.0;
    this.chartItemText.rotation = viewRotation;
    this.setViewRotation(viewRotation);

    this.setBackgroundColorCss(this.chartItemText.backgroundcolor);

    this._renderCmd.text = this.chartItemText.textcontent;
    this._renderCmd.richtext = this.chartItemText.richtextcontent;
    this._renderCmd.textImageDirty = true;

    return true;
  },

  // Touch begin handler
  onTouchBegan: function (touch, event) {
    this._super(touch, event);

    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    this.setDynamic(true);

    if (this.getIsSizeable() && ((touchPoint.x > (this.width - this._touchState.handleSize)) && (touchPoint.y < this._touchState.handleSize)) && !this.getIsInRotationMode()) {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Resize);

      // Shift anchor to bottom left
      this.moveAnchorPointKeepPosition(0, 1);

      this._touchState.touchStartOffsetX = this.width - touchPoint.x;
      this._touchState.touchStartOffsetY = this.height + touchPoint.y;

      // compute size limits
      var minSize = this.chartItemViewFactory.zoomFactor * scaleUnitReferencePixels;
      this._touchState.touchLimitX1 = minSize - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitX2 = this.chartItemViewFactory.scaledStagePxWidth - (minSize - this._touchState.touchStartOffsetX);
      this._touchState.touchLimitY1 = touchPoint.y;
      this._touchState.touchLimitY2 = this.y - minSize + touchPoint.y;
    } else if (((touchPoint.x > (this.width - this._touchState.handleSize)) && (touchPoint.y < this._touchState.handleSize)) && this.getIsInRotationMode()) {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Rotation);

      this._touchState.originalAngle = Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this.getViewRotation();
    } else {
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Move);

      this._touchState.touchStartOffsetX = this.x - touchPointSuper.x;
      this._touchState.touchStartOffsetY = this.y - touchPointSuper.y;

      this._touchState.touchLimitX1 = 20 - this._touchState.touchStartOffsetX;
      this._touchState.touchLimitX2 = this.chartItemViewFactory.scaledStagePxWidth - (20 - this._touchState.touchStartOffsetX);
      this._touchState.touchLimitY1 = 20 - this._touchState.touchStartOffsetY;
      this._touchState.touchLimitY2 = this.chartItemViewFactory.scaledStagePxHeight - (20 - this._touchState.touchStartOffsetXY);
    }

    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Resize) {
      var contentSize = this.getContentSize();
      var minSize = this.chartItemViewFactory.zoomFactor * scaleUnitReferencePixels;
      contentSize.width = touchPoint.x + this._touchState.touchStartOffsetX;
      if (contentSize.width < minSize) {
        contentSize.width = minSize;
      }

      var newHeight = this._touchState.touchStartOffsetY - touchPoint.y;
      if (newHeight < minSize) {
        newHeight = minSize;
      }
      var heightDelta = contentSize.height - newHeight;
      contentSize.height = newHeight;

      this.setContentSize(contentSize);
      this._touchState.touchStartOffsetY -= heightDelta;

      this._renderCmd.textImageDirty = true;
    } else if (this._dynamicMode === SWChartUI.ItemDynamicMode.Move) {
      if (this.delegate && this.delegate.delegate && this.delegate.delegate.killAutoSaveTimer) {
        this.delegate.delegate.killAutoSaveTimer();
      }

      if (touchPointSuper.x < this._touchState.touchLimitX1) {
        touchPointSuper.x = this._touchState.touchLimitX1;
      } else if (touchPointSuper.x > this._touchState.touchLimitX2) {
        touchPointSuper.x = this._touchState.touchLimitX2;
      }

      if (touchPointSuper.y < this._touchState.touchLimitY1) {
        touchPointSuper.y = this._touchState.touchLimitY1;
      } else if (touchPointSuper.y > this._touchState.touchLimitY2) {
        touchPointSuper.y = this._touchState.touchLimitY2;
      }

      this.x = touchPointSuper.x + this._touchState.touchStartOffsetX;
      this.y = touchPointSuper.y + this._touchState.touchStartOffsetY;
    } else if (this._dynamicMode === SWChartUI.ItemDynamicMode.Rotation) {
      // Calculate the angle between the start point and the current touch point
      var angle = -Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this._touchState.originalAngle;

      // Rotate the item
      this.setViewRotation(angle);
    }
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    this._super(touch, event);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Resize) {
      this.moveAnchorPointKeepPosition(0.5, 0.5);
      this._renderCmd.textImageDirty = true;
    }

    this.setDynamic(false);

    if (this._dynamicMode !== SWChartUI.ItemDynamicMode.None) {
      this.updateEntity();
    }
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    this._super(touch, event);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Resize) {
      this.moveAnchorPointKeepPosition(0.5, 0.5);
    }

    this.setDynamic(false);
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);

    this.refresh();
  },

  setActive: function (active) {
    this._super(active);
  },

  refresh: function () {
    this._super();

    if (!this.getIsInGroup()) {
      this.x = this.chartItemText.positionx * this.chartItemViewFactory.scalePxPerUnitX;
      this.y = this.chartItemText.positiony * this.chartItemViewFactory.scalePxPerUnitY;
    }

    this.width = this.chartItemText.sizewidth * this.chartItemViewFactory.scalePxPerUnitX;
    this.height = this.chartItemText.sizeheight * this.chartItemViewFactory.scalePxPerUnitY;

    var viewRotation = parseFloat(this.chartItemText.rotation) || 0.0;
    this.setViewRotation(viewRotation);

    this.setBackgroundColorCss(this.chartItemText.backgroundcolor);

    this._renderCmd.text = this.chartItemText.textcontent;
    this._renderCmd.richtext = this.chartItemText.richtextcontent;
    this._renderCmd.textImageDirty = true;
  },

  updateEntity: function () {
    if (this.getIsInGroup()) {
      return;
    }

    var changed = this._super();

    var newPositionX = this.x / this.chartItemViewFactory.scalePxPerUnitX;
    var newPositionY = this.y / this.chartItemViewFactory.scalePxPerUnitY;
    var newSizeWidth = this.width / this.chartItemViewFactory.scalePxPerUnitX;
    var newSizeHeight = this.height / this.chartItemViewFactory.scalePxPerUnitY;
    var newRotation = this.getViewRotation();

    if (Math.abs(this.chartItemText.positionx - newPositionX) > 0.000001) {
      this.chartItemText.positionx = newPositionX;
      changed = true;
    }

    if (Math.abs(this.chartItemText.positiony - newPositionY) > 0.000001) {
      this.chartItemText.positiony = newPositionY;
      changed = true;
    }

    if (Math.abs(this.chartItemText.sizewidth - newSizeWidth) > 0.000001) {
      this.chartItemText.sizewidth = newSizeWidth;
      changed = true;
    }

    if (Math.abs(this.chartItemText.sizeheight - newSizeHeight) > 0.000001) {
      this.chartItemText.sizeheight = newSizeHeight;
      changed = true;
    }

    if (Math.abs(this.chartItemText.rotation - newRotation) > 0.000001) {
      this.chartItemText.rotation = newRotation;
      changed = true;
    }

    if (this.chartItemText.backgroundcolor !== this.getBackgroundColorCss()) {
      this.chartItemText.backgroundcolor = this.getBackgroundColorCss();
      changed = true;
    }

    if (changed) {
      this.delegate.chartItemNotifyDidChange();
    }

    return changed;
  },

  getBackingEntity: function () {
    return this.chartItemText;
  },

  getItemType: function () {
    // return SWChartItem.Type.Text;
    return this.chartItemText.itemtype;
  },

  getBackgroundColorCss: function () {
    return this._backgroundColorCss;
  },

  setBackgroundColorCss: function (colorCss) {
    if ((colorCss === null) || (colorCss === undefined)) {
      colorCss = this._defaultBackgroundColorCss;
    }

    this._backgroundColorCss = colorCss;
    this._renderCmd.backgroundColorCss = colorCss;
  },

  setZIndex: function (newZIndex) {
    if (this.chartItemText.zindex !== newZIndex) {
      this.chartItemText.zindex = newZIndex;
    }
  },

  getZIndex: function () {
    return this.chartItemText.zindex;
  },

  isEmpty: function () {
    return ((this.chartItemText.textcontent === undefined) || (this.chartItemText.textcontent.trim().length === 0));
  },

  _createRenderCmd: function () {
    return new ChartItemTextView.CanvasRenderCmd(this);
  },
});

(function () {
  ChartItemTextView.CanvasRenderCmd = function (renderable) {
    ChartItemBaseView.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;

    this.backgroundColorCss = 'rgba(0,0,0,0)';

    this.text = '';
    this.richtext = '';

    this.textImage = undefined;
    this.textImageDirty = true;
    this.textImageProcessing = false;
    this.textImageError = false;
  };

  var proto = ChartItemTextView.CanvasRenderCmd.prototype = Object.create(ChartItemBaseView.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemTextView.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {

    ChartItemBaseView.CanvasRenderCmd.prototype.rendering.call(this, ctx, scaleX, scaleY);

    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext();
    var drawingUtil = cc._drawingUtil;
    var fontSize = this.chartZoom * 14;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    if (!this.textImageProcessing) {
      this.updateTextImage();
    }

    if (this.textImage !== undefined) {
      wrapper.save();

      drawingUtil.setFillColorCss(this.backgroundColorCss);
      var vertices = [];
      vertices.push(cc.p(0, 0));
      vertices.push(cc.p(0, node.height));
      vertices.push(cc.p(node.width, node.height));
      vertices.push(cc.p(node.width, 0));
      drawingUtil.drawPolygon(vertices, false, true);

      if (!node._povAudience) {
        context.translate(node.width * scaleX, node.height * scaleY);
        context.rotate(cc.PI);
      }
      // drawingUtil.drawImage(this.textImage, cc.p(0, 0));
      drawingUtil.drawImageScaled(this.textImage, 0, 0, node.width, node.height);
      wrapper.restore()
    } else if (this.textImageError) {
      drawingUtil.setFillColorCss('rgba(0,0,0,1)');

      wrapper.save();
      drawingUtil.clipToNode(node);
      if (!node._povAudience) {
        context.translate(node.width * scaleX, node.height * scaleY);
        context.scale(-scaleX, -scaleY);
      } else {
        context.scale(scaleX, scaleY);
      }
      context.font = fontSize.toFixed(1) + 'px Arial';
      this.wrapText(context, this.text, 0, fontSize, node.width, fontSize);
      wrapper.restore();
    }

    if (node._selectionState.active) {
      drawingUtil.setLineWidth(1);
      drawingUtil.drawRectangle(cc.p(0, 0), cc.p(node.width, node.height), cc.color(0, 0, 0, 64));
    }

    if (!node._selectionState.rotationMode && !node.getIsEditing() && node._selectionState.active && node.getIsSizeable() && node.getIsRotatable()) {
      this.drawDiagonalSizeHandle(ctx, scaleX, scaleY);
    }
    if (node._selectionState.rotationMode && !node.getIsEditing() && node._selectionState.active && node.getIsSizeable() && node.getIsRotatable()) {
      this.drawDiagonalRotationHandle(ctx, scaleX, scaleY);
    }
  };

  proto.wrapText = function (context, text, x, y, maxWidth, lineHeight) {
    if (text === undefined || text.length === 0) {
      return;
    }

    var words = text.split(' '),
      line = '',
      lineCount = 0,
      i,
      test,
      metrics;

    for (i = 0; i < words.length; i++) {
      test = words[i];
      metrics = context.measureText(test);
      while (metrics.width > maxWidth) {
        // Determine how much of the word will fit
        test = test.substring(0, test.length - 1);
        metrics = context.measureText(test);
      }
      if (words[i] !== test) {
        words.splice(i + 1, 0, words[i].substr(test.length));
        words[i] = test;
      }

      test = line + words[i] + ' ';
      metrics = context.measureText(test);

      if (metrics.width > maxWidth && i > 0) {
        context.fillText(line, x, y);
        line = words[i] + ' ';
        y += lineHeight;
        lineCount++;
      } else {
        line = test;
      }
    }

    context.fillText(line, x, y);
  };

  proto.updateTextImage = function () {
    var _this = this;
    var node = this._node;

    if (node._selectionState && node._selectionState.editing) {
      _this.textImage = new Image();
      _this.textImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
      _this.textImageDirty = false;
      _this.textImageProcessing = false;
      _this.textImageError = false;
      return;
    }

    if ((this.richtext === undefined) || (this.richtext.length === 0)) {
      this.textImage = undefined;
      this.textImageDirty = false;
      this.textImageProcessing = false;
      this.textImageError = false;

      return;
    }

    this.textImageProcessing = true;

    var containerWidth = node.width;
    var containerHeight = node.height;
    var contentScale = this._node.chartItemViewFactory.textContainerScale;
    var foreignObjectWidth = containerWidth / contentScale;
    var foreignObjectHeight = containerHeight / contentScale;
    // var replacedString = this.richtext.replace(/<div[^>]*?[^>]*?>(\s*|&nbsp;|&)<\/div>/g, '<br/>');
    var replacedString = this.richtext.replace('&nbsp;', ' ');
    replacedString = replacedString.replace(/(<([\w]+)[^>]*?>)(\s*)(<\/\2>)/gi, function (match, pre, elem, content, post) {
      return pre + content + '<br/>' + post;
    });
    // var replacedString = this.richtext;
    var data = '<svg xmlns="http://www.w3.org/2000/svg" width="' + containerWidth + '" height="' + containerHeight + '">' +
      '<foreignObject transform="scale(' + contentScale + ')" width="' + foreignObjectWidth + '" height="' + foreignObjectHeight + '">' +
      '<div xmlns="http://www.w3.org/1999/xhtml" style="font-size:12px;font-family:Liberation Sans;line-height:1.2;letter-spacing:normal;font-kerning:none;word-break:break-word;">' +
      replacedString +
      '</div>' +
      '</foreignObject>' +
      '</svg>';

    // var DOMURL = window.URL || window.webkitURL || window;
    // var svg = new Blob([data], {
    //   type: 'image/svg+xml;charset=utf-8'
    // });
    // var url = DOMURL.createObjectURL(svg);
    var url = 'data:image/svg+xml;base64,' + btoa(data);
    var image = new Image();
    image.crossOrigin = 'Anonymous';
    image.src = url;
    image.onload = function () {
      _this.textImage = image;
      _this.textImageDirty = false;
      _this.textImageProcessing = false;
      _this.textImageError = false;
      // DOMURL.revokeObjectURL(url);
    };
    image.onerror = function () {
      _this.textImage = undefined;
      _this.textImageDirty = false;
      _this.textImageProcessing = false;
      _this.textImageError = true;
    };
  };

}());

/////////////////////////////////////////////////
// ChartItemGroupView
//
var ChartItemGroupView = ChartItemBaseView.extend({

  _groupItemViews: undefined,

  _originalPosition: cc.p(0, 0),

  ctor: function (chartItemViews, chartItemViewFactory) {
    this._super(chartItemViewFactory);

    this._editabilityFlags.rotatable = true;

    this.setAnchorPoint(0.5, 0.5);

    this._groupItemViews = chartItemViews;

    this.setLocalZOrder(-1);

    this.setup();
  },

  // Touch begin handler
  onTouchBegan: function (touch, event) {
    this._super(touch, event);

    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (((touchPoint.x > (this.width - this._touchState.handleSize)) && (touchPoint.y < this._touchState.handleSize)) && this.getIsInRotationMode()) {
      this.setDynamic(true);
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Rotation);

      this._touchState.originalAngle = Math.atan2(touchPointSuper.y - this.y - this._zoomOffset.y, touchPointSuper.x - this.x - this._zoomOffset.x) + this.getViewRotation();
    } else {
      this.setDynamic(true);
      this.setDynamicMode(SWChartUI.ItemDynamicMode.Move);

      this._touchState.touchStartOffsetX = this.x - touchPointSuper.x;
      this._touchState.touchStartOffsetY = this.y - touchPointSuper.y;

      this._touchState.touchLimitX1 = touchPoint.x;
      this._touchState.touchLimitX2 = this.chartItemViewFactory.scaledStagePxWidth - (this.width - this._touchState.touchLimitX1);
      this._touchState.touchLimitY1 = touchPoint.y;
      this._touchState.touchLimitY2 = this.chartItemViewFactory.scaledStagePxHeight - (this.height - this._touchState.touchLimitY1);
    }
    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    if (this._dynamicMode === SWChartUI.ItemDynamicMode.Rotation) {
      // Calculate the angle between the start point and the current touch point
      var angle = -Math.atan2(touchPointSuper.y - this.y, touchPointSuper.x - this.x) + this._touchState.originalAngle;

      // Rotate the item
      this.setViewRotation(angle);
    } else {
      if (this.delegate && this.delegate.delegate && this.delegate.delegate.killAutoSaveTimer) {
        this.delegate.delegate.killAutoSaveTimer();
      }
      
      if (touchPointSuper.x < this._touchState.touchLimitX1) {
        touchPointSuper.x = this._touchState.touchLimitX1;
      } else if (touchPointSuper.x > this._touchState.touchLimitX2) {
        touchPointSuper.x = this._touchState.touchLimitX2;
      }

      if (touchPointSuper.y < this._touchState.touchLimitY1) {
        touchPointSuper.y = this._touchState.touchLimitY1;
      } else if (touchPointSuper.y > this._touchState.touchLimitY2) {
        touchPointSuper.y = this._touchState.touchLimitY2;
      }

      this.x = touchPointSuper.x + this._touchState.touchStartOffsetX;
      this.y = touchPointSuper.y + this._touchState.touchStartOffsetY;
    }
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    this._super(touch, event);

    this.setDynamic(false);
    this.setDynamicMode(SWChartUI.ItemDynamicMode.None);
  },

  getItemType: function () {
    return SWChartItem.Type.Group;
  },

  setup: function () {
    var _this = this;
    var calcFrame;
    _.each(this._groupItemViews, function (groupItemView) {
      var bBox = groupItemView.getBoundingBox();
      if (calcFrame === undefined) {
        calcFrame = cc.rect(bBox);
      } else {
        calcFrame = cc.rectUnion(calcFrame, bBox);
      }
    });

    this.x = cc.rectGetMidX(calcFrame);
    this.y = cc.rectGetMidY(calcFrame);
    this.width = calcFrame.width;
    this.height = calcFrame.height;

    var groupBoundingBox = this.getBoundingBox();

    _.each(this._groupItemViews, function (groupItemView) {
      groupItemView.setInGroup(true);
      groupItemView.x -= groupBoundingBox.x;
      groupItemView.y -= groupBoundingBox.y;

      _this.addChild(groupItemView);
    });

    this._originalPosition = cc.p(this.x, this.y);
  },

  getChartItemViews: function () {
    return this._groupItemViews;
  },

  ungroupOnView: function (chartLayerView) {
    var _this = this;

    // Compute the transform to be applied to the grouped items
    var xForm = cc.affineTransformTranslate(cc.affineTransformIdentity(), this.width / 2 - chartLayerView._stageViewOffset.x, this.height / 2 - chartLayerView._stageViewOffset.y);
    xForm = cc.affineTransformRotate(xForm, -this.getViewRotation());
    xForm = cc.affineTransformTranslate(xForm, -(this.width / 2) + chartLayerView._stageViewOffset.x, -(this.height / 2) + chartLayerView._stageViewOffset.y);

    // Apply transform and offsets to put items back on the layer
    _.each(this._groupItemViews, function (groupItemView) {
      groupItemView.setInGroup(false);
      var pos = groupItemView.getPosition();
      pos = cc.pointApplyAffineTransform(pos, xForm);
      groupItemView.x = pos.x + (_this.x - (_this.width / 2));
      groupItemView.y = pos.y + (_this.y - (_this.height / 2));
      groupItemView.setViewRotation(groupItemView.getViewRotation() + _this.getViewRotation());

      chartLayerView.addChild(groupItemView);
    });

    return this._groupItemViews;
  },

  hasChanged: function () {
    return (this._originalPosition.x !== this.x || this._originalPosition.y !== this.y || this.getViewRotationDeg() != 0);
  },

  _createRenderCmd: function () {
    this._renderPostCmd = new ChartItemGroupView.CanvasRenderPostCmd(this);
    return new ChartItemGroupView.CanvasRenderCmd(this);
  },
});

(function () {
  ChartItemGroupView.CanvasRenderCmd = function (renderable) {
    ChartItemBaseView.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
  };

  var proto = ChartItemGroupView.CanvasRenderCmd.prototype = Object.create(ChartItemBaseView.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemGroupView.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {
    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext();
    var drawingUtil = cc._drawingUtil;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    var selectionStateFlags = node._selectionState;
    if (selectionStateFlags.dynamic) {
      drawingUtil.drawSolidRectangle(cc.p(-4, -4), cc.p(node.width + 4, node.height + 4), cc.color(91, 249, 44, 63));
    } else if (selectionStateFlags.active) {
      drawingUtil.drawSolidRectangle(cc.p(-2, -2), cc.p(node.width + 2, node.height + 2), cc.color(91, 249, 44, 127));
    }
    wrapper.save();
    context.setLineDash([this.getStrokeWidthWithBase(10), this.getStrokeWidthWithBase(5)]);
    drawingUtil.setLineWidth(this.getStrokeWidthWithBase(2));
    drawingUtil.drawRectangle(cc.p(-1, -1), cc.p(node.width + 1, node.height + 1), cc.color(91, 249, 44, 255));
    wrapper.restore();
  };
}());

(function () {
  ChartItemGroupView.CanvasRenderPostCmd = function (renderable) {
    ChartItemBaseView.CanvasRenderCmd.call(this, renderable);
    this._isPostCmd = true;
    this._needDraw = true;
  };

  var proto = ChartItemGroupView.CanvasRenderPostCmd.prototype = Object.create(ChartItemBaseView.CanvasRenderCmd.prototype);
  proto.constructor = ChartItemGroupView.CanvasRenderPostCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {
    var node = this._node;

    var wrapper = ctx || cc._renderContext;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    if (node._selectionState.rotationMode && node.getIsRotatable()) {
      this.drawDiagonalRotationHandle(ctx, scaleX, scaleY);
    }
  };
}());

var ChartItemViewFactory = (function () {

  function ChartItemViewFactory() {
    this._stageUnitWidth = 0.0;
    this._stageUnitDepth = 0.0;
    this._offstageUnitWidth = 0;

    this._numberlineMarkerStepValue = 1;
    this._numberlineZeroAtCenter = true;
    this._numberlineMultiplier = 1;
    this._verticalNumberlineMultiplier = 1;
    this._verticalNumberlineZeroOffsetValue = 0;
    this._verticalNumberlineMarkerStepValue = 1;

    this._scaleAllPerformers = false;
    this._scaleSelectedPerformers = false;

    // Stage scaling factor px/selected unit
    this._scalePxPerUnitX = 0.0;
    this._scalePxPerUnitY = 0.0;

    // Stage dimensions in px
    this._scaledStagePxWidth = 0.0;
    this._scaledStagePxHeight = 0.0;

    // Stage offset in px
    this._scaledStagePxOffset = cc.p(0, 0);

    // Stage view size in px
    this._stageViewSize = cc.size(0.0);

    // Measurement unit in use
    this._swMeasurementUnit = 0;
    this._measurementConversionMultiplier = 0;

    // Zoom factor
    this._zoomFactor = 0.0;

    // Performers
    this._performers = [];

    // Set Pieces
    this._setPieces = [];

    // stock set pieces
    this._stockSetPieces = [];

    // Performers image cache
    this._performerImageCache = {};

    // Set Pieces image cache
    this._setPieceImageCache = {};
  }

  function viewForChartItem(chartItem) {
    if (chartItem.itemtype === SWChartItem.Type.Performer) {
      return viewForChartItemPerformer(chartItem, this);
    } else if (chartItem.itemtype === SWChartItem.Type.SetPiece) {
      return viewForChartItemSetPiece(chartItem, this);
    } else if (chartItem.itemtype === SWChartItem.Type.Shape) {
      return viewForChartItemShape(chartItem, this);
    } else if ((chartItem.itemtype === SWChartItem.Type.Text) || (chartItem.itemtype === SWChartItem.Type.TextPersonal)) {
      return viewForChartItemText(chartItem, this);
    }
  }

  function viewForChartItemPerformer(chartItem, factory) {
    return new ChartItemPerformerView(chartItem, factory);
  }

  function viewForChartItemSetPiece(chartItem, factory) {
    return new ChartItemSetPieceView(chartItem, factory);
  }

  function viewForChartItemShape(chartItem, factory) {
    var view;
    switch (chartItem.shapetype) {
      case SWChartItem.ShapeType.Square:
      case SWChartItem.ShapeType.Circle:
      case SWChartItem.ShapeType.Triangle:
      case SWChartItem.ShapeType.Arc:
        view = new ChartItemShape1View(chartItem, factory);
        break;

      case SWChartItem.ShapeType.SolidLine:
      case SWChartItem.ShapeType.DottedLine:
      case SWChartItem.ShapeType.ThinDottedLine:
      case SWChartItem.ShapeType.ThickLine:
      case SWChartItem.ShapeType.SolidLineArrow:
      case SWChartItem.ShapeType.DottedLineArrow:
        view = new ChartItemShape2View(chartItem, factory);
        break;

      case SWChartItem.ShapeType.CurtainLine:
        view = new ChartItemShapeCurtainView(chartItem, factory);
        break;

      case SWChartItem.ShapeType.JoinedLine:
      case SWChartItem.ShapeType.JoinedLineArrow:
      case SWChartItem.ShapeType.Curve:
      case SWChartItem.ShapeType.CurveArrow:
        view = new ChartItemShapeVectorView(chartItem, factory);
        break;

      case SWChartItem.ShapeType.Freehand:
        view = new ChartItemShapeFreehandView(chartItem, factory);
        break;
    }

    return view;
  }

  function viewForChartItemText(chartItem, factory) {
    return new ChartItemTextView(chartItem, factory);
  }

  function findPerformerById(performerId) {
    if (this.performers !== undefined) {
      return this.performers.find(function (item) {
        return (item.hasOwnProperty('_id') && (item._id === performerId));
      });
    }
  }

  function findSetPieceById(setPieceId) {
    var setPiece;

    if (this.stockSetPieces !== undefined) {
      setPiece = this.stockSetPieces.find(function (item) {
        return (item.hasOwnProperty('_id') && (item._id === setPieceId));
      });
    }

    if ((setPiece === undefined) && (this.setPieces !== undefined)) {
      setPiece = this.setPieces.find(function (item) {
        return (item.hasOwnProperty('_id') && (item._id === setPieceId));
      });
    }

    return setPiece;
  }

  function getPerformerImage(performerId) {
    if (this._performerImageCache.hasOwnProperty(performerId)) {
      return this._performerImageCache[performerId];
    } else {
      return _cachePerformerImage(performerId, this);
    }
  }

  function _cachePerformerImage(performerId, factory) {
    var performerImage = new Image();

    var performer = factory.findPerformerById(performerId);
    if (performer !== undefined) {
      performerImage.src = 'data:image/png;base64,' + performer.image;
    }

    factory._performerImageCache[performerId] = performerImage;

    return performerImage;
  }

  function updateCachedPerformerImage(performerId) {
    if (this._performerImageCache.hasOwnProperty(performerId)) {
      var performer = this.findPerformerById(performerId);
      this._performerImageCache[performerId].src = 'data:image/png;base64,' + performer.image;
    }
  }

  function getSetPieceImage(setPieceId) {
    if (this._setPieceImageCache.hasOwnProperty(setPieceId)) {
      return this._setPieceImageCache[setPieceId];
    } else {
      return _cacheSetPieceImage(setPieceId, this);
    }
  }

  function _cacheSetPieceImage(setPieceId, factory) {
    var setPieceImage = new Image();

    setPieceImage.crossOrigin = 'Anonymous';
    var setPiece = factory.findSetPieceById(setPieceId);
    if (setPiece !== undefined) {
      // setPieceImage.src = 'data:image/png;base64,' + setPiece.image;
      setPieceImage.src = factory.imageDataPrefixUrl + '/setpiece/image/' + setPiece._id + '?rev=' + setPiece.rev;
    } else {
      setPieceImage.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=';
    }

    factory._setPieceImageCache[setPieceId] = setPieceImage;

    return setPieceImage;
  }

  function updateCachedSetPieceImage(setPieceId) {
    if (this._setPieceImageCache.hasOwnProperty(setPieceId)) {
      var setPiece = this.findSetPieceById(setPieceId);
      this._setPieceImageCache[setPieceId].src = this.imageDataPrefixUrl + '/setpiece/image/' + setPiece._id + '?rev=' + setPiece.rev;
    }
  }

  function getImageFromDataUrl(dataUrl) {
    var img = new Image();

    img.crossOrigin = 'Anonymous';
    if (dataUrl !== undefined) {
      img.src = 'data:image/png;base64,' + dataUrl;
    } else {
      img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=';
    }

    return img;
  }

  ChartItemViewFactory.prototype.constructor = ChartItemViewFactory;

  ChartItemViewFactory.prototype.viewForChartItem = viewForChartItem;
  ChartItemViewFactory.prototype.findPerformerById = findPerformerById;
  ChartItemViewFactory.prototype.findSetPieceById = findSetPieceById;
  ChartItemViewFactory.prototype.getPerformerImage = getPerformerImage;
  ChartItemViewFactory.prototype.updateCachedPerformerImage = updateCachedPerformerImage;
  ChartItemViewFactory.prototype.getSetPieceImage = getSetPieceImage;
  ChartItemViewFactory.prototype.updateCachedSetPieceImage = updateCachedSetPieceImage;
  ChartItemViewFactory.prototype.getImageFromDataUrl = getImageFromDataUrl
  Object.defineProperty(ChartItemViewFactory.prototype, 'stageUnitWidth', {
    get: function () {
      return this._stageUnitWidth;
    },

    set: function (value) {
      this._stageUnitWidth = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'stageUnitDepth', {
    get: function () {
      return this._stageUnitDepth;
    },

    set: function (value) {
      this._stageUnitDepth = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'offstageUnitWidth', {
    get: function () {
      return this._offstageUnitWidth;
    },

    set: function (value) {
      this._offstageUnitWidth = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'numberlineMarkerStepValue', {
    get: function () {
      return this._numberlineMarkerStepValue;
    },

    set: function (value) {
      this._numberlineMarkerStepValue = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'numberlineZeroAtCenter', {
    get: function () {
      return this._numberlineZeroAtCenter;
    },

    set: function (value) {
      this._numberlineZeroAtCenter = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'numberlineMultiplier', {
    get: function () {
      return this._numberlineMultiplier;
    },

    set: function (value) {
      this._numberlineMultiplier = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'scaleAllPerformers', {
    get: function () {
      return this._scaleAllPerformers;
    },

    set: function (value) {
      this._scaleAllPerformers = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'scaleSelectedPerformers', {
    get: function () {
      return this._scaleSelectedPerformers;
    },

    set: function (value) {
      this._scaleSelectedPerformers = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'verticalNumberlineMultiplier', {
    get: function () {
      return this._verticalNumberlineMultiplier;
    },

    set: function (value) {
      this._verticalNumberlineMultiplier = value;
    }
  });
  Object.defineProperty(ChartItemViewFactory.prototype, 'verticalNumberlineZeroOffsetValue', {
    get: function () {
      return this._verticalNumberlineZeroOffsetValue;
    },

    set: function (value) {
      this._verticalNumberlineZeroOffsetValue = value;
    }
  });
  Object.defineProperty(ChartItemViewFactory.prototype, 'verticalNumberlineMarkerStepValue', {
    get: function () {
      return this._verticalNumberlineMarkerStepValue;
    },

    set: function (value) {
      this._verticalNumberlineMarkerStepValue = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'scalePxPerUnitX', {
    get: function () {
      return this._scalePxPerUnitX;
    },

    set: function (value) {
      this._scalePxPerUnitX = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'scalePxPerUnitY', {
    get: function () {
      return this._scalePxPerUnitY;
    },

    set: function (value) {
      this._scalePxPerUnitY = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'scaledStagePxWidth', {
    get: function () {
      return this._scaledStagePxWidth;
    },

    set: function (value) {
      this._scaledStagePxWidth = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'scaledStagePxHeight', {
    get: function () {
      return this._scaledStagePxHeight;
    },

    set: function (value) {
      this._scaledStagePxHeight = value;
    }
  });

  function setScaledStagePxOffset(offset, y) {
    if (y !== undefined) {
      this._scaledStagePxOffset = cc.p(offset, y);
    } else {
      this._scaledStagePxOffset = cc.p(offset);
    }
  }

  ChartItemViewFactory.prototype.setScaledStagePxOffset = setScaledStagePxOffset;
  Object.defineProperty(ChartItemViewFactory.prototype, 'scaledStagePxOffset', {
    get: function () {
      return this._scaledStagePxOffset;
    },

    set: setScaledStagePxOffset
  });

  function setStageViewSize(size, height) {
    if (height !== undefined) {
      this._stageViewSize = cc.size(size, height);
    } else {
      this._stageViewSize = cc.size(size);
    }
  }

  ChartItemViewFactory.prototype.setStageViewSize = setStageViewSize;
  Object.defineProperty(ChartItemViewFactory.prototype, 'stageViewSize', {
    get: function () {
      return this._stageViewSize;
    },

    set: setStageViewSize
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'swMeasurementUnit', {
    get: function () {
      return this._swMeasurementUnit;
    },
    set: function (value) {
      this._swMeasurementUnit = value;

      if (value === SWStage.MeasurementUnitType.Feet) {
        this._measurementConversionMultiplier = 1.0;
      } else {
        this._measurementConversionMultiplier = 0.3048;
      }
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'measurementConversionMultiplier', {
    get: function () {
      return this._measurementConversionMultiplier;
    },
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'zoomFactor', {
    get: function () {
      return this._zoomFactor;
    },

    set: function (value) {
      this._zoomFactor = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'performers', {
    get: function () {
      return this._performers;
    },

    set: function (value) {
      this._performers = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'setPieces', {
    get: function () {
      return this._setPieces;
    },

    set: function (value) {
      this._setPieces = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'stockSetPieces', {
    get: function () {
      return this._stockSetPieces;
    },

    set: function (value) {
      this._stockSetPieces = value;
    }
  });

  Object.defineProperty(ChartItemViewFactory.prototype, 'textContainerScale', {
    get: function () {
      return this._scalePxPerUnitX / (20 / this.measurementConversionMultiplier);
    }
  });

  return ChartItemViewFactory;
})();

var ChartLayerBase = cc.Layer.extend({

  // the chart items on this layer
  chartItems: undefined,

  // The chart items views on this layer
  allChartItemViews: undefined,

  // selcted chart item views on this layer
  selectedChartItemViews: undefined,

  // the active chart item if any
  _activeChartItem: undefined,

  // active chart item view
  activeChartItemView: undefined,

  // rotating chart item view
  rotatingChartItemView: undefined,

  // is this layer active
  _layerActive: false,

  _chartItemViewFactory: undefined,

  _stageViewOffset: undefined,

  _povAudience: true,

  _showLineOverlapBreaks: true,

  groupExistedBeforeZoomChange: false,
  chartItemGroupView: undefined,

  _touchListener: undefined,
  _mouseListener: undefined,

  _rubberBandSelectionPt1: cc.p(0, 0),
  _rubberBandSelectionPt2: cc.p(0, 0),
  _rubberBandSelectionRect: cc.rect(0, 0, 0, 0),
  _rubberBandSelectionStarted: false,
  _rubberBandSelectionMode: false,

  selectionRotationMode: undefined,
  selectionSnapToGrid: undefined,

  performersOnChart: undefined,

  // override
  ctor: function () {
    this._super();

    this._localZOrder = -1;

    this.chartItems = [];
    this.allChartItemViews = [];
    this.selectedChartItemViews = [];

    this.performersOnChart = [];

    this._stageViewOffset = cc.p();

    // Size ourself
    this.width = SWChartUI.DesignWidth;
    this.height = SWChartUI.DesignHeight;
  },

  onEnter: function () {
    this._super();

    // Re-register our touch listener if needed
    if ((this._touchListener !== undefined) && !this._touchListener._isRegistered()) {
      cc.eventManager.addListener(this._touchListener, this);
    }
  },

  // Child node that has captured touch
  touchCapturedChildNode: undefined,

  setupTouchHandling: function () {
    var _this = this;

    this._touchListener = cc.EventListener.create({
      event: cc.EventListener.TOUCH_ONE_BY_ONE,
      swallowTouches: true,

      // Touch begin handler
      onTouchBegan: function (touch, event) {
        if (_this.delegate && _this.delegate.ccChartQuickUpdates) {
          _this.delegate.ccChartQuickUpdates();
        }
        return _this.onTouchBegan(touch, event);
      },

      // Touch move handler
      onTouchMoved: function (touch, event) {
        _this.onTouchMoved(touch, event);
      },

      // Touch ended handler
      onTouchEnded: function (touch, event) {
        _this.onTouchEnded(touch, event);

        if (_this.delegate && _this.delegate.ccChartPauseUpdates) {
          _this.delegate.ccChartPauseUpdates();
        }
      },

      // Touch cancelled handler
      onTouchCancelled: function (touch, event) {
        _this.onTouchCancelled(touch, event);

        if (_this.delegate && _this.delegate.ccChartPauseUpdates) {
          _this.delegate.ccChartPauseUpdates();
        }
      },
    });

    // Register touch listener
    cc.eventManager.addListener(this._touchListener, this);

    // Touch handling is disabled by default
    this._touchListener.setEnabled(false);
  },

  onTouchBegan: function (touch, event) {
    var _this = this;
    var i;
    var chartItemView;
    _this.touchCapturedChildNode = undefined;

    if (touch.originalEvent.button == cc.EventMouse.BUTTON_LEFT) {
      // Check if we hit any selected items
      for (i = _this.selectedChartItemViews.length - 1; i >= 0; i--) {
        chartItemView = _this.selectedChartItemViews[i];
        if (chartItemView.isTouchInNode(touch)) {
          _this.touchCapturedChildNode = chartItemView;
          break;
        }
      }

      if (_this.chartItemGroupView !== undefined) {
        if (_this.chartItemGroupView.isTouchInNode(touch)) {
          _this.touchCapturedChildNode = _this.chartItemGroupView;
        }
      }

      if (_this.touchCapturedChildNode === undefined) {
        // Check if we hit any unselected items on the layer
        for (i = _this.allChartItemViews.length - 1; i >= 0; i--) {
          chartItemView = _this.allChartItemViews[i];
          if (chartItemView.isTouchInNode(touch)) {
            _this.touchCapturedChildNode = chartItemView;
            break;
          }
        }
      }

      if (_this.touchCapturedChildNode !== undefined) {
        if (_this.shouldSendTouchToChild(_this.touchCapturedChildNode)) {
          var handled = _this.touchCapturedChildNode.onTouchBegan(touch, event);
          if (!handled) {
            _this.touchCapturedChildNode = undefined;
          }
        } else {
          _this.touchCapturedChildNode = undefined;
        }
      }

      // rubber-band selection
      if (_this.touchCapturedChildNode === undefined) {
        var touchPoint = this.convertTouchToNodeSpace(touch);
        this._rubberBandSelectionPt1 = cc.p(touchPoint.x, touchPoint.y);
        this._rubberBandSelectionPt2 = cc.p(touchPoint.x, touchPoint.y);
        this.updateRubberBandSelectionRect();
        this._rubberBandSelectionStarted = true;
      }
    }

    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var _this = this;
    if (this._rubberBandSelectionStarted) {
      var touchPoint = this.convertTouchToNodeSpace(touch);
      this._rubberBandSelectionPt2.x = touchPoint.x;
      this._rubberBandSelectionPt2.y = touchPoint.y;
      this.updateRubberBandSelectionRect();
    } else if (_this.touchCapturedChildNode !== undefined) {
      return _this.touchCapturedChildNode.onTouchMoved(touch, event);
    }
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    if (touch.originalEvent.button == cc.EventMouse.BUTTON_LEFT) {
      var _this = this;
      this._rubberBandSelectionStarted = false;
      if (_this.touchCapturedChildNode !== undefined) {
        var handled = _this.touchCapturedChildNode.onTouchEnded(touch, event);

        // _this.setChartDirty();

        if (this.selectionSnapToGrid) {
          if (this.chartItemGroupView == undefined) {
            this.snapToGridChartItem();
          }
        }
        _this.touchCapturedChildNode = undefined;
        return handled;
      } else {
        if (_this.chartItemGroupView !== undefined) {
          _this.ungroupSelections();
        }
        if (this._rubberBandSelectionMode) {
          this._rubberBandSelectionMode = false;

          var isAnyItemInRubberband = false;
          // Check if chart item center point is contained in rubberBandSelectionRect
          for (var i = 0; i < this.allChartItemViews.length; i++) {
            var chartItemView = this.allChartItemViews[i];
            var point = {
              x: chartItemView.x + this._stageViewOffset.x,
              y: chartItemView.y + this._stageViewOffset.y
            };

            if (cc.rectContainsPoint(this._rubberBandSelectionRect, point)) {
              if (!chartItemView.getIsActive()) {
                this.addOrRemoveSelectedChartItemView(chartItemView);
              }
              isAnyItemInRubberband = true;
            }
          }

          if (!isAnyItemInRubberband) {
            _this.clearSelections();
            if (this.delegate && this.delegate.hideChartContextMenu && !this.delegate.chartInspectorState.isContextMenuPinned) {
              this.delegate.hideChartContextMenu();
            }
          }
        } else {
          if (this.delegate && this.delegate.hideChartContextMenu && !touch.originalEvent.ctrlKey) {
            _this.clearSelections();
            _this.visuallyOrderChartItems();
            this.delegate.endEditTextBox();

            if (!this.delegate.chartInspectorState.isContextMenuPinned) {
              this.delegate.hideChartContextMenu();
            }
          }
        }
      }
    }
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    var _this = this;
    if (this._rubberBandSelectionMode) {
      this._rubberBandSelectionMode = false;
    }
    if (_this.touchCapturedChildNode !== undefined) {
      var handled = _this.touchCapturedChildNode.onTouchCancelled(touch, event);
      _this.touchCapturedChildNode = undefined;

      return handled;
    }
  },

  updateRubberBandSelectionRect: function () {
    this._rubberBandSelectionRect.x = Math.min(this._rubberBandSelectionPt1.x, this._rubberBandSelectionPt2.x);
    this._rubberBandSelectionRect.y = Math.min(this._rubberBandSelectionPt1.y, this._rubberBandSelectionPt2.y);
    this._rubberBandSelectionRect.width = Math.abs(this._rubberBandSelectionPt1.x - this._rubberBandSelectionPt2.x);
    this._rubberBandSelectionRect.height = Math.abs(this._rubberBandSelectionPt1.y - this._rubberBandSelectionPt2.y);

    this._rubberBandSelectionMode = (this._rubberBandSelectionRect.width > 10) && (this._rubberBandSelectionRect.height > 10);
  },

  shouldSendTouchToChild: function (childChartItemView) {
    return true;
  },

  activate: function (makeActive) {
    this.setLayerActive(makeActive);

    // TODO: end any shape editing

    this.setUserInteractionEnabled(makeActive);

    this.updateInspectorView();

    this.pasteCount = 0;
    this.pasteDirection = 0;
  },

  setLayerActive: function (active) {
    if (this._layerActive !== active) {
      this._layerActive = active;

      this.clearTransientState();

      // TODO: notify delegate
      // this.chartLayerDelegate.layerDidChangeActiveState(this, this._layerActive);
    }
  },

  getIsActive: function () {
    return this._layerActive;
  },

  setChartItemViewFactory: function (chartItemViewFactory) {
    this._chartItemViewFactory = chartItemViewFactory;
  },

  getChartItemViewFactory: function () {
    return this._chartItemViewFactory;
  },

  setStageViewOffset: function (stageViewOffset, y) {
    if (y !== undefined) {
      stageViewOffset = cc.p(stageViewOffset, y);
    }

    if (!cc.pointEqualToPoint(stageViewOffset, this._stageViewOffset)) {
      this._stageViewOffset = cc.p(stageViewOffset);

      this.handleZoomOffsetTransformChange();
    }
  },

  getStageViewOffset: function () {
    return this._stageViewOffset;
  },

  setPovAudience: function (povAudience) {
    if (this._povAudience !== povAudience) {
      this._povAudience = povAudience;

      var povTransform;
      if (this._povAudience) {
        povTransform = cc.affineTransformMakeIdentity();
        this.setAdditionalTransform(povTransform);
      } else {
        povTransform = cc.affineTransformMakeIdentity();
        povTransform = cc.affineTransformTranslate(povTransform, this.width, this.height);
        povTransform = cc.affineTransformScale(povTransform, -1, -1);
        this.setAdditionalTransform(povTransform);
      }
    }
  },

  getPovAudience: function () {
    return this._povAudience;
  },

  setShowLineOverlapBreaks: function (showLineOverlapBreaks) {
    this._showLineOverlapBreaks = showLineOverlapBreaks;

    for (var i = 0; i < this.allChartItemViews.length; i++) {
      var chartItemView = this.allChartItemViews[i];

      if (chartItemView.getItemType() === SWChartItem.Type.Shape) {
        chartItemView.setShowOutline(this._showLineOverlapBreaks);
      }
    }
  },

  getShowLineOverlapBreaks: function () {
    return this._showLineOverlapBreaks;
  },

  loadData: function () {
    this.cleanupData();

    this.loadChartItems(this.chartItems);
  },

  loadChartItems: function (chartItems) {
    var _this = this;
    var firstZIndex = this.allChartItemViews.length;
    var loadedChartItemViews = [];

    _.each(chartItems, function (chartItem, index) {
      var chartItemView = _this.getChartItemViewFactory().viewForChartItem(chartItem);
      if (chartItemView) {
        chartItemView.delegate = _this;

        if (chartItem.itemtype === SWChartItem.Type.Shape) {
          chartItemView.setShowOutline(_this.getShowLineOverlapBreaks());
        }

        if (chartItem.itemtype === SWChartItem.Type.SetPiece) {
          chartItemView.setSizeable(false);
        }

        if (chartItem.itemtype === SWChartItem.Type.Performer) {
          chartItemView.setShowPositionLabel(_this.getPositionVisible());
          chartItemView.setPositionResolutionFraction(_this.getPositionResolutionFraction());
          chartItemView.setShowNose(_this.getNoseVisible());
        }

        chartItemView.setPovAudience(_this.getPovAudience());
        chartItemView.setZoomOffset(_this.getStageViewOffset());
        chartItemView.setZIndex(firstZIndex + index);

        _this.postLoadChartItemViewHandler(chartItemView);

        _this.addChild(chartItemView);

        _this.allChartItemViews.push(chartItemView);

        loadedChartItemViews.push(chartItemView);
      }
    });

    this.refreshPerformersOnTheChart();

    return loadedChartItemViews;
  },

  refreshPerformersOnTheChart: function () {
    var referencedPerformerIdsSet = new Set();
    this.chartItems.forEach(function (item) {
      if (item.referencedperformerId) {
        referencedPerformerIdsSet.add(item.referencedperformerId);
      }
    });
    if (this.delegate && this.delegate.refreshPerformersOnTheChart) {
      this.delegate.refreshPerformersOnTheChart(referencedPerformerIdsSet);
    }
  },

  postLoadChartItemViewHandler: function (chartItem) {
    // Do nothing
  },

  visuallyOrderChartItems: function () {
    var zeroIndexCount = 0;
    var allSubViews = this.allChartItemViews.sort(function (val1, val2) {
      return (val1.getZIndex() - val2.getZIndex());
    });
    allSubViews.forEach(function (chartItemView) {
      if (chartItemView.getZIndex() === 0) {
        zeroIndexCount++;
      }

      chartItemView.setLocalZOrder(chartItemView.getZIndex());
    });

    if (zeroIndexCount > 1) {
      this.updateZindexByCurrentVisualOrder();
    }
  },

  updateZindexByCurrentVisualOrder: function () {
    var _this = this;
    this.sortAllChildren();
    var allSubViews = this.getChildren();

    allSubViews.forEach(function (chartItemView, index) {
      if (chartItemView.getZIndex() != index) {
        chartItemView.setZIndex(index);
        _this.notifyDidChange();
      }
    });
  },

  refresh: function () {
    // subclasses should override and refresh all item views
  },

  cleanupData: function () {
    this.removeAllChildren();
    this.allChartItemViews = [];

    this.selectedChartItemViews = [];
  },

  validateData: function () {
    var _this = this;

    this.allChartItemViews.forEach(function (chartItemView) {
      if (chartItemView.isEmpty()) {
        _this.deleteChartItemView(chartItemView);
      }
    });

    this.updateZindexByCurrentVisualOrder();
  },

  handleZoomOffsetTransformChange: function () {
    var _this = this;
    this.allChartItemViews.forEach(function (chartItemView) {
      chartItemView.setZoomOffset(_this.getStageViewOffset());
    });

    if (this.chartItemGroupView !== undefined) {
      this.chartItemGroupView.setZoomOffset(this.getStageViewOffset());
    }
  },

  willChangeZoom: function () {
    // Deactivate any group if present
    this.groupExistedBeforeZoomChange = (this.chartItemGroupView !== undefined);
    this.ungroupSelections();
  },

  didChangeZoom: function () {
    if (this.groupExistedBeforeZoomChange) {
      this.groupSelections();
    }
  },

  editActiveItem: function () {
    if (this.activeChartItemView !== undefined) {
      if (this.activeChartItemView.getItemType() === SWChartItem.Type.Shape) {
        if ((this.activeChartItemView.shapeType === SWChartItem.ShapeType.Curve) ||
          (this.activeChartItemView.shapeType === SWChartItem.ShapeType.CurveArrow) ||
          (this.activeChartItemView.shapeType === SWChartItem.ShapeType.JoinedLine) ||
          (this.activeChartItemView.shapeType === SWChartItem.ShapeType.JoinedLineArrow)) {
          this.activeChartItemView.updateEntity();
          if (this.delegate && this.delegate.editVectorShape) {
            this.delegate.editVectorShape(this.activeChartItemView);
          }

          // if (this.delegate && this.delegate.hideChartContextMenu) {
          //   this.delegate.hideChartContextMenu();
          // }

          // this.clearSelections();
        }
      } else if ((this.activeChartItemView.getItemType() === SWChartItem.Type.Text) || (this.activeChartItemView.getItemType() === SWChartItem.Type.TextPersonal)) {
        this.activeChartItemView.updateEntity();
        if (this.delegate && this.delegate.editTextBox) {
          this.delegate.editTextBox(this.activeChartItemView);
        }

        // if (this.delegate && this.delegate.hideChartContextMenu) {
        //   this.delegate.hideChartContextMenu();
        // }
      }
    }
  },

  endEditingActiveItem: function () {
    if ((this.activeChartItemView !== undefined) && this.activeChartItemView.getIsEditing()) {
      if (this.activeChartItemView.getItemType() === SWChartItem.Type.Shape) {
        if (this.delegate && this.delegate.endEditVectorShape) {
          this.delegate.endEditVectorShape();
        }
      }
    }
  },

  clearTransientState: function () {
    this.ungroupSelections();
    this.clearSelections();
    this.visuallyOrderChartItems();
  },

  refreshForUndoRedo: function () {
    this.refresh();

    this.updateInspectorView();
  },

  chartItemNotifyDidChange: function () {
    this.notifyDidChange()
  },

  addOrRemoveSelectedChartItemView: function (chartItemView) {
    var itemIndex = this.selectedChartItemViews.indexOf(chartItemView);
    if (itemIndex !== -1) {
      // De-activate  item and restore it at its zindex
      chartItemView.setLocalZOrder(chartItemView.getZIndex());
      chartItemView.setActive(false);
      this.selectedChartItemViews.splice(itemIndex, 1);
      for (var i = itemIndex; i < this.selectedChartItemViews.length; i++) {
        var tempView = this.selectedChartItemViews[i];
        tempView.setLocalZOrder(1000 + i);
      }
    } else {
      // ungroup first before selecting
      if (this.chartItemGroupView !== undefined) {
        this.ungroupSelections();
      } else {
        // End any ordering
        if (this.activeChartItemView && this.activeChartItemView.getIsZOrdering()) {
          this.chartInspectorEndOrderingEdit();
        }

        chartItemView.setLocalZOrder(1000 + this.selectedChartItemViews.length);
        this.selectedChartItemViews.push(chartItemView);
        chartItemView.setActive(true);
        chartItemView.setIsInRotationMode(this.selectionRotationMode);
        chartItemView.setIsInSnapToGridMode(this.selectionSnapToGrid);
      }
    }

    if (this.selectedChartItemViews.length > 0) {
      this.activeChartItemView = this.selectedChartItemViews[this.selectedChartItemViews.length - 1];
    } else {
      this.activeChartItemView = undefined;
    }

    this.updateInspectorView();
  },

  deleteSelectedItems: function () {
    var _this = this;

    this.disableChangeTracking();

    this.selectedChartItemViews.forEach(function (chartItemView) {
      _this.deleteChartItemView(chartItemView);
    });
    this.refreshPerformersOnTheChart();

    this.enableChangeTracking();
    this.notifyDidChange();

    this.selectedChartItemViews = [];

    this.setChartDirty();
    this.updateInspectorView();
  },

  deleteChartItemView: function (chartItemView) {
    if (chartItemView === this.activeChartItemView) {
      this.activeChartItemView = undefined;
    }

    this.removeChild(chartItemView);
    cc.arrayRemoveObject(this.chartItems, chartItemView.getBackingEntity());

    cc.arrayRemoveObject(this.allChartItemViews, chartItemView);

    this.validateData();
  },

  clearSelections: function () {
    if (this.activeChartItemView && this.activeChartItemView.getIsZOrdering()) {
      this.chartInspectorEndOrderingEdit();
    }

    this.selectedChartItemViews.forEach(function (chartItemView) {
      chartItemView.setActive(false);
    });

    this.selectedChartItemViews = [];
    this.activeChartItemView = undefined;

    this.updateInspectorView();
  },

  updateInspectorView: function () {
    if (this.delegate && this.delegate.updateInspectorState) {
      this.delegate.updateInspectorState(this);
    }
  },

  groupSelections: function () {
    var _this = this;
    if (this.chartItemGroupView !== undefined) {
      this.ungroupSelections();
    } else {
      this.disableChangeTracking();

      if (this.selectedChartItemViews.length === 0) {
        return;
      }

      this.chartItemGroupView = new ChartItemGroupView(this.selectedChartItemViews, this.getChartItemViewFactory());
      this.chartItemGroupView.delegate = this;
      this.clearSelections();

      this.allChartItemViews = _.difference(this.allChartItemViews, this.chartItemGroupView.getChartItemViews());

      this.addChild(this.chartItemGroupView);
      this.selectedChartItemViews.push(this.chartItemGroupView);
      this.activeChartItemView = this.chartItemGroupView;
      this.chartItemGroupView.setIsInRotationMode(this.selectionRotationMode);
      this.chartItemGroupView.setActive(true);
      this.updateInspectorView();

      this.enableChangeTracking();

      // [self.delegate chartLayerItemsGrouped:YES];
      if (_this.delegate && _this.delegate.ccChartUpdateNow) {
        _this.delegate.ccChartUpdateNow();
      }
      if (_this.delegate && _this.delegate.killAutoSaveTimer) {
        _this.delegate.killAutoSaveTimer();
      }
    }
  },

  ungroupSelections: function () {
    var _this = this;
    if (this.chartItemGroupView !== undefined) {
      this.clearSelections();

      this.disableChangeTracking();

      var groupHasChanged = _this.chartItemGroupView.hasChanged();
      var ungroupedItemViews = this.chartItemGroupView.ungroupOnView(this);
      this.allChartItemViews = this.allChartItemViews.concat(ungroupedItemViews);
      this.removeChild(this.chartItemGroupView);
      this.chartItemGroupView = undefined;

      ungroupedItemViews.forEach(function (itemView) {
        itemView.updateEntity();
        _this.addOrRemoveSelectedChartItemView(itemView);
      });
      this.enableChangeTracking();
      if (groupHasChanged) {
        this.notifyDidChange();
      }
      // [self.delegate chartLayerItemsGrouped:NO];

      if (_this.delegate && _this.delegate.ccChartUpdateNow) {
        _this.delegate.ccChartUpdateNow();
      }
      if (_this.delegate && _this.delegate.startAutoSaveTimer) {
        _this.delegate.startAutoSaveTimer();
      }
    }
  },

  getSelectedAsClipboardItems: function () {
    var clipboardItems = [];
    this.selectedChartItemViews.forEach(function (item) {
      // clipboardItems.push(_.clone(item.getBackingEntity()));
      clipboardItems.push(deepClone(item.getBackingEntity()));
    });

    return clipboardItems;
  },

  pasteClipboardItems: function (clipboardItems) {
    var _this = this;

    var copiedClipboardItems = [];
    _.each(clipboardItems, function (clipboardItem) {
      var clone = deepClone(clipboardItem);//_.clone(clipboardItem);
      clone._id = '__tmp__' + Date.now();
      clone.layer = _this.getChartItemLayerType();
      copiedClipboardItems.push(clone);

      _this.chartItems.push(clone);
    });

    var loadedChartItemViews = this.loadChartItems(copiedClipboardItems);
    _.each(loadedChartItemViews, function (loadedChartItemView) {
      _this.addOrRemoveSelectedChartItemView(loadedChartItemView);
    });
    this.refreshPerformersOnTheChart();

    this.groupSelections();

    this.setChartDirty();
  },

  adjustPastedGroup: function () {
    // TODO: Implement this
  },

  chartItemTouchToggle: function (chartItemView) {
    if (chartItemView !== this.chartItemGroupView) {
      this.addOrRemoveSelectedChartItemView(chartItemView);
    }
  },

  chartItemLayerModeEnded: function () {
    this.updateInspectorView();
  },

  chartItemEditingEnded: function () {
    // [self.delegate chartLayerEditorActive:NO];
  },

  // ChartItemInspectorDelegate

  chartInspectorRotationChangedTo: function (newRotation) {
    if ((this.activeChartItemView !== undefined) && this.activeChartItemView.getIsRotatable()) {
      this.activeChartItemView.setViewRotationDeg(newRotation);
      this.activeChartItemView.updateEntity();

      return this.activeChartItemView.getViewRotationDeg();
    }
  },

  chartInspectorHeadRotationChangedTo: function (newRotation) {
    if ((this.activeChartItemView !== undefined) && (this.activeChartItemView.getItemType() == SWChartItem.Type.Performer)) {
      this.activeChartItemView.setHeadRotationDeg(newRotation);
      this.activeChartItemView.updateEntity();

      return this.activeChartItemView.getHeadRotationDeg();
    }
  },

  chartInspectorSendItemToTop: function () {
    if ((this.activeChartItemView !== undefined) && this.activeChartItemView.getIsZOrdering()) {
      this.bringChildToFront(this.activeChartItemView);
      this.updateZindexByCurrentVisualOrder();
      this.activeChartItemView.updateEntity();

      this.updateInspectorView();
    }
  },

  chartInspectorSendItemUp: function () {
    if ((this.activeChartItemView !== undefined) && this.activeChartItemView.getIsZOrdering()) {

      var children = this.getChildren();
      var maxIndex = children.length - 1;
      var oldIndex = this.activeChartItemView.getLocalZOrder();
      if (oldIndex < maxIndex) {
        var swapItem = children[oldIndex + 1];
        children[oldIndex + 1] = this.activeChartItemView;
        children[oldIndex] = swapItem;

        swapItem.setLocalZOrder(oldIndex);
        this.activeChartItemView.setLocalZOrder(oldIndex + 1);

        this.updateZindexByCurrentVisualOrder();
        this.activeChartItemView.updateEntity();

        this.updateInspectorView();
      }
    }
  },

  chartInspectorSendItemDown: function () {
    if ((this.activeChartItemView !== undefined) && this.activeChartItemView.getIsZOrdering()) {

      var children = this.getChildren();
      var oldIndex = this.activeChartItemView.getLocalZOrder();
      if (oldIndex > 0) {
        var swapItem = children[oldIndex - 1];
        children[oldIndex - 1] = this.activeChartItemView;
        children[oldIndex] = swapItem;

        swapItem.setLocalZOrder(oldIndex);
        this.activeChartItemView.setLocalZOrder(oldIndex - 1);

        this.updateZindexByCurrentVisualOrder();
        this.activeChartItemView.updateEntity();

        this.updateInspectorView();
      }
    }
  },

  chartInspectorSendItemToBottom: function () {
    if ((this.activeChartItemView !== undefined) && this.activeChartItemView.getIsZOrdering()) {
      this.sendChildToBack(this.activeChartItemView);
      this.updateZindexByCurrentVisualOrder();
      this.activeChartItemView.updateEntity();

      this.updateInspectorView();
    }
  },

  chartInspectorBeginOrderingEdit: function () {
    if (this.activeChartItemView !== undefined) {
      this.activeChartItemView.setLocalZOrder(this.activeChartItemView.getZIndex());
      this.activeChartItemView.setZOrdering(true);

      //     [self.chartItemViewsContainer insertSubview:self.activeChartItemView atIndex:self.activeChartItemView.zIndex];
      //     self.chartItemInspector.selectionOrderingMode = self.activeChartItemView.zOrdering;
      //     self.chartItemInspector.zIndex = self.activeChartItemView.zIndex;
    }

    this.disableChangeTracking();

    this.updateInspectorView();
  },

  chartInspectorEndOrderingEdit: function () {
    if (this.activeChartItemView !== undefined) {
      this.activeChartItemView.setZOrdering(false);

      //     [self.chartItemViewsContainer insertSubview:self.activeChartItemView atIndex:self.activeChartItemView.zIndex];
      //     self.chartItemInspector.selectionOrderingMode = self.activeChartItemView.zOrdering;
      //     self.chartItemInspector.zIndex = self.activeChartItemView.zIndex;
    }

    this.enableChangeTracking();

    this.updateInspectorView();
  },

  chartInspectorSelectionCut: function () {
    var items = this.getSelectedAsClipboardItems();

    this.deleteSelectedItems();

    this.pasteCount = 0;
    this.pasteDirection = 0;

    return items;
  },

  chartInspectorSelectionCopy: function () {
    var items = this.getSelectedAsClipboardItems();

    this.updateInspectorView();

    this.pasteCount = 1;
    this.pasteDirection = 0;

    return items;
  },

  chartInspectorSelectionPaste: function (clipboardItems) {
    this.ungroupSelections();
    this.clearSelections();

    this.pasteClipboardItems(clipboardItems);
  },

  // SWA-ST1-T58 keyboard shortcut for duplicate
  chartInspectorSelectionDuplicate: function () {
    var items = this.getSelectedAsClipboardItems();

    this.updateInspectorView();

    this.pasteCount = 1;
    this.pasteDirection = 0;

    this.ungroupSelections();
    this.clearSelections();

    this.pasteClipboardItems(items);
  },

  chartInspectorSelectionEdit: function () {
    this.editActiveItem();
  },

  chartInspectorSelectionDelete: function () {
    this.deleteSelectedItems();
  },

  chartInspectorSelectionChoseColor: function (color) {
    if ((this.activeChartItemView !== undefined) && (this.activeChartItemView.getItemType() === SWChartItem.Type.Shape)) {
      this.activeChartItemView.setLineColorCss(color);
      this.activeChartItemView.updateEntity();
      // this.activeChartItemView.getBackingEntity().linecolor = color;
      //
      // this.activeChartItemView.refresh();
    }
  },

  chartInspectorSelectionChooseFillColor: function (color) {
    if ((this.activeChartItemView !== undefined) && (this.activeChartItemView.getItemType() === SWChartItem.Type.Shape)) {
      this.activeChartItemView.setFillColorCss(color);
      this.activeChartItemView.updateEntity();
      // this.activeChartItemView.getBackingEntity().fillcolor = color;
      //
      // this.activeChartItemView.refresh();
    }
  },

  chartInspectorSelectionChooseBackgroundColor: function (color) {
    if ((this.activeChartItemView !== undefined) && (
      (this.activeChartItemView.getItemType() === SWChartItem.Type.Text) ||
      (this.activeChartItemView.getItemType() === SWChartItem.Type.TextPersonal))) {
      this.activeChartItemView.setBackgroundColorCss(color);
      this.activeChartItemView.updateEntity();
      // this.activeChartItemView.getBackingEntity().fillcolor = color;
      //
      // this.activeChartItemView.refresh();
    }
  },

  chartInspectorSelectionClear: function () {
    // clear layer selections first
    if ((this.chartItemGroupView === undefined) && (this.selectedChartItemViews.length > 0)) {
      this.clearSelections();
      this.visuallyOrderChartItems();
      this.updateInspectorView();

      return true;
    } else {
      // then clear clipboard items if any
      return false;
    }
  },

  chartInspectorSelectionGroupToggle: function () {
    if (this.chartItemGroupView !== undefined) {
      this.ungroupSelections();
    } else {
      this.groupSelections();
    }
  },

  // SWA-ST1-T58 keyboard shortcut for group
  chartInspectorSelectionGroup: function () {
    if (this.chartItemGroupView == undefined) {
      this.groupSelections();
    }
  },
  // SWA-ST1-T58 keyboard shortcut for ungroup
  chartInspectorSelectionUnGroup: function () {
    if (this.chartItemGroupView !== undefined) {
      this.ungroupSelections();
    }
  },

  addNewTextItem: function (defaultTextSettings) {
    this.clearSelections();

    var newTextItem = {};
    newTextItem._id = '__tmp__' + Date.now();
    newTextItem.itemtype = SWChartItem.Type.Text;
    newTextItem.layer = this.getChartItemLayerType();
    newTextItem.backgroundcolor = defaultTextSettings.fillColor;
    newTextItem.defaultTextSettings = defaultTextSettings;

    this.chartItems.push(newTextItem);

    var loadedChartItemViews = this.loadChartItems([newTextItem]);
    if (loadedChartItemViews.length > 0) {
      var loadedChartItemView = loadedChartItemViews[0];

      this.addOrRemoveSelectedChartItemView(loadedChartItemView);

      loadedChartItemView.updateEntity();

      this.editActiveItem();
    }

    this.setChartDirty();
  },

  addNewTextPersonalItem: function (userId, defaultTextSettings) {
    this.clearSelections();

    var newTextItem = {};
    newTextItem._id = '__tmp__' + Date.now();
    newTextItem.itemtype = SWChartItem.Type.TextPersonal;
    newTextItem.layer = this.getChartItemLayerType();
    newTextItem.backgroundcolor = defaultTextSettings.fillColor;
    newTextItem.defaultTextSettings = defaultTextSettings;
    newTextItem.ofUserId = userId;

    this.chartItems.push(newTextItem);

    var loadedChartItemViews = this.loadChartItems([newTextItem]);
    if (loadedChartItemViews.length > 0) {
      var loadedChartItemView = loadedChartItemViews[0];

      this.addOrRemoveSelectedChartItemView(loadedChartItemView);

      loadedChartItemView.updateEntity();

      this.editActiveItem();
    }

    this.setChartDirty();
  },

  addNewShapeOfType: function (shapeType) {
    this.clearSelections();

    var newShapeItem = {};
    newShapeItem._id = '__tmp__' + Date.now();
    newShapeItem.itemtype = SWChartItem.Type.Shape;
    newShapeItem.layer = this.getChartItemLayerType();

    newShapeItem.positionx = this.getChartItemViewFactory().stageUnitWidth / 2;
    newShapeItem.positiony = this.getChartItemViewFactory().stageUnitDepth / 2;
    newShapeItem.shapetype = shapeType;
    newShapeItem.linethickness = chartBaseLineWidth + 2;

    this.chartItems.push(newShapeItem);

    var loadedChartItemViews = this.loadChartItems([newShapeItem]);
    if (loadedChartItemViews.length > 0) {
      var loadedChartItemView = loadedChartItemViews[0];

      this.addOrRemoveSelectedChartItemView(loadedChartItemView);

      loadedChartItemView.updateEntity();

      this.editActiveItem();
    }

    this.setChartDirty();
  },

  addNewFreehandShape: function (shapeItem) {
    this.clearSelections();

    shapeItem._id = '__tmp__' + Date.now();
    shapeItem.layer = this.getChartItemLayerType();

    this.chartItems.push(shapeItem);

    var loadedChartItemViews = this.loadChartItems([shapeItem]);
    if (loadedChartItemViews.length > 0) {
      var loadedChartItemView = loadedChartItemViews[0];

      loadedChartItemView.updateEntity();
    }

    this.setChartDirty();
  },

  addNewSetPiece: function (setPiece, asSetDesign) {
    asSetDesign = asSetDesign || false;
    this.clearSelections();

    var newSetPieceItem = {};
    newSetPieceItem._id = '__tmp__' + Date.now();
    newSetPieceItem.itemtype = SWChartItem.Type.SetPiece;
    newSetPieceItem.layer = this.getChartItemLayerType();

    newSetPieceItem.referencedsetpieceId = setPiece._id;

    this.chartItems.push(newSetPieceItem);

    var loadedChartItemViews = this.loadChartItems([newSetPieceItem]);
    if (loadedChartItemViews.length > 0) {
      var loadedChartItemView = loadedChartItemViews[0];

      this.addOrRemoveSelectedChartItemView(loadedChartItemView);

      if (asSetDesign) {
        this.chartInspectorBeginOrderingEdit();
        this.chartInspectorSendItemToBottom();
        this.chartInspectorEndOrderingEdit();
        this.addOrRemoveSelectedChartItemView(loadedChartItemView);
      }

      loadedChartItemView.updateEntity();
    }

    this.notifyDidChange();

    this.setChartDirty();
  },

  addNewPerformer: function (performer) {
    this.clearSelections();

    var newPerformerItem = {};
    newPerformerItem._id = '__tmp__' + Date.now();
    newPerformerItem.itemtype = SWChartItem.Type.Performer;
    newPerformerItem.layer = this.getChartItemLayerType();

    newPerformerItem.referencedperformerId = performer._id;
    newPerformerItem.positionx = this.getChartItemViewFactory().stageUnitWidth / 2;
    newPerformerItem.positiony = this.getChartItemViewFactory().stageUnitDepth / 2;

    this.chartItems.push(newPerformerItem);
    this.refreshPerformersOnTheChart();

    var loadedChartItemViews = this.loadChartItems([newPerformerItem]);
    if (loadedChartItemViews.length > 0) {
      var loadedChartItemView = loadedChartItemViews[0];

      this.addOrRemoveSelectedChartItemView(loadedChartItemView);

      loadedChartItemView.updateEntity();
    }

    this.notifyDidChange();

    this.setChartDirty();
  },

  setChartItems: function (chartItems) {
    var _this = this;
    this.chartItems = [];
    if (Array.isArray(chartItems)) {
      // Filter out items for this layer only
      _.each(chartItems, function (chartItem) {
        // if (chartItem.layer === _this.getChartItemLayerType()) {
        if ((chartItem.layer === _this.getChartItemLayerType()) && (chartItem.itemtype !== SWChartItem.Type.Video)) {
          _this.chartItems.push(chartItem);
        }
      });

      this.chartItems = _.sortBy(this.chartItems, 'zindex');
      this.clearTransientState();
      this.loadData();
      this.visuallyOrderChartItems();
    } else {
      this.clearTransientState();
      this.cleanupData();
    }
  },

  getChartItems: function () {
    var chartItems = [];
    _.each(this.allChartItemViews, function (chartItemView) {
      chartItems.push(chartItemView.getBackingEntity());
    });

    return chartItems;
  },

  getChartLayerType: function () {
    return SWChartLayer.Type.None;
  },

  getChartItemLayerType: function () {
    return SWChartItem.LayerType.None;
  },

  setUserInteractionEnabled: function (enabled) {
    if (this._touchListener !== undefined) {
      this._touchListener.setEnabled((enabled === true));
    }
  },

  setChartDirty: function () {
    if (this.delegate && this.delegate.markChartDirty) {
      this.delegate.markChartDirty();
    }
  },

  notifyDidChange: function () {
    if (this.delegate && this.delegate.chartNotifyDataDidChange) {
      this.delegate.chartNotifyDataDidChange();
    }
  },

  disableChangeTracking: function () {
    if (this.delegate && this.delegate.chartNotifyDisableChangeTracking) {
      this.delegate.chartNotifyDisableChangeTracking();
    }
  },

  enableChangeTracking: function () {
    if (this.delegate && this.delegate.chartNotifyEnableChangeTracking) {
      this.delegate.chartNotifyEnableChangeTracking();
    }
  },

  _createRenderCmd: function () {
    this._renderPostCmd = new ChartLayerBase.CanvasRenderPostCmd(this);
    return new ChartLayerBase.CanvasRenderCmd(this);
  },

  chartInspectorFlipHorizontally: function () {
    this.activeChartItemView.flipView(false);
  },

  chartInspectorFlipVertically: function () {
    this.activeChartItemView.flipView(true);
  },

  setRotatingChartItemView: function (chartItemView) {
    this.rotatingChartItemView = chartItemView;
  },

  setSelectionRotationMode: function (selectionRotationMode) {
    this.selectionRotationMode = (selectionRotationMode === true);
    if (this.chartItemGroupView) {
      this.chartItemGroupView.setIsInRotationMode(this.selectionRotationMode);
    } else {
      for (var i = 0; i < this.allChartItemViews.length; i++) {
        var chartItemView = this.allChartItemViews[i];

        chartItemView.setIsInRotationMode(this.selectionRotationMode);
      }
    }
    this.updateInspectorView();
  },
  setSelectionSnapToGridMode: function (selectionSnapToGrid) {
    this.selectionSnapToGrid = (selectionSnapToGrid === true);

    for (var i = 0; i < this.allChartItemViews.length; i++) {
      var chartItemView = this.allChartItemViews[i];

      chartItemView.setIsInSnapToGridMode(this.selectionSnapToGrid);
    }

    this.updateInspectorView();
  },

  increaseLineThicknessForFreehand: function () {
    this.delegate.chartInspectorState.lineThicknessForFreehand += 2;
    this.delegate.chartInspectorState.showLineThicknessForFreehand = (this.delegate.chartInspectorState.lineThicknessForFreehand / 2) + 1;
  },

  decreaseLineThicknessForFreehand: function () {
    this.delegate.chartInspectorState.lineThicknessForFreehand -= 2;
    if (this.delegate.chartInspectorState.lineThicknessForFreehand < 0) {
      this.delegate.chartInspectorState.lineThicknessForFreehand = 0;
    }
    this.delegate.chartInspectorState.showLineThicknessForFreehand = (this.delegate.chartInspectorState.lineThicknessForFreehand / 2) + 1;
  },

  resetLineThicknessForFreehand: function () {
    this.delegate.chartInspectorState.lineThicknessForFreehand = chartBaseLineWidth + 2;
    this.delegate.chartInspectorState.showLineThicknessForFreehand = ((chartBaseLineWidth + 2) / 2) + 1;
  },

  selectedItemIncreaseLineThickness: function () {
    for (var i = 0; i < this.selectedChartItemViews.length; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      if (chartItemView.chartItemShape.shapetype === SWChartItem.ShapeType.Freehand) {
        var updatedShapePaths = [];
        var highestLineThickness = 0;
        chartItemView.chartItemShape.shapepaths.forEach(function (shapePath) {
          shapePath.linethickness += 2;
          var updatedPath = Object.assign({}, shapePath);
          updatedShapePaths.push(updatedPath);

          if (shapePath.linethickness > highestLineThickness) {
            highestLineThickness = shapePath.linethickness;
          }
        });
        chartItemView.chartItemShape.shapepaths = updatedShapePaths;
        chartItemView.refresh();
        chartItemView.setLineThickness(highestLineThickness);
        chartItemView.updateEntity();
      } else if (chartItemView.chartItemShape.shapetype === SWChartItem.ShapeType.CurtainLine) {
        var newThickness = chartItemView.chartItemShape.linethickness + 2;
        if (newThickness > (chartBaseLineWidth + 2)) {
          chartItemView.chartItemShape.sizeheight += 0.5;
        }
        chartItemView.refresh();
        chartItemView.setLineThickness(newThickness);
        chartItemView.updateEntity();
      } else {
        var newThickness = chartItemView.chartItemShape.linethickness + 2;

        if (this.delegate.chartInspectorState.vectorEditorActive) {
          chartItemView.setLineColorCss(this.delegate.chartInspectorState.selectionColor);
          this.delegate.chartInspectorState.lineThickness = (newThickness / 2) + 1;
        }
        chartItemView.setLineThickness(newThickness);
        chartItemView.updateEntity();
      }
    }
    this.updateInspectorView();
    this.delegate.killAutoSaveTimer();
  },

  selectedItemDecreaseLineThickness: function () {
    for (var i = 0; i < this.selectedChartItemViews.length; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      if (chartItemView.chartItemShape.shapetype === SWChartItem.ShapeType.Freehand) {
        var updatedShapePaths = [];
        var highestLineThickness = 0;
        chartItemView.chartItemShape.shapepaths.forEach(function (shapePath) {
          shapePath.linethickness -= 2;
          var updatedPath = Object.assign({}, shapePath);
          updatedShapePaths.push(updatedPath);

          if (shapePath.linethickness > highestLineThickness) {
            highestLineThickness = shapePath.linethickness;
          }
        });
        chartItemView.chartItemShape.shapepaths = updatedShapePaths;
        chartItemView.refresh();
        chartItemView.setLineThickness(highestLineThickness);
        chartItemView.updateEntity();
      } else if (chartItemView.chartItemShape.shapetype === SWChartItem.ShapeType.CurtainLine) {
        var curtainHeight = chartItemView.chartItemShape.sizeheight - 0.5;
        if (curtainHeight < 1) {
          curtainHeight = 1;
        }
        chartItemView.chartItemShape.sizeheight = curtainHeight;

        var newThickness = chartItemView.chartItemShape.linethickness - 2;
        if (newThickness < 0) {
          newThickness = 0;
        }
        chartItemView.refresh();
        chartItemView.setLineThickness(newThickness);
        chartItemView.updateEntity();
      } else {
        var newThickness = chartItemView.chartItemShape.linethickness - 2;

        if (newThickness < 0) {
          newThickness = 0;
        }

        if (this.delegate.chartInspectorState.vectorEditorActive) {
          chartItemView.setLineColorCss(this.delegate.chartInspectorState.selectionColor);
          this.delegate.chartInspectorState.lineThickness = (newThickness / 2) + 1;
        }
        chartItemView.setLineThickness(newThickness);
        chartItemView.updateEntity();
      }
    }
    this.updateInspectorView();
    this.delegate.killAutoSaveTimer();
  },

  selectedItemResetLineThickness: function () {
    for (var i = 0; i < this.selectedChartItemViews.length; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      if (chartItemView.chartItemShape.shapetype === SWChartItem.ShapeType.Freehand) {
        var updatedShapePaths = [];
        chartItemView.chartItemShape.shapepaths.forEach(function (shapePath) {
          shapePath.linethickness = chartBaseLineWidth + 2;
          var updatedPath = Object.assign({}, shapePath);
          updatedShapePaths.push(updatedPath);

        });
        chartItemView.chartItemShape.shapepaths = updatedShapePaths;
        chartItemView.refresh();
        chartItemView.setLineThickness(chartBaseLineWidth + 2);
        chartItemView.updateEntity();
      } else if (chartItemView.chartItemShape.shapetype === SWChartItem.ShapeType.CurtainLine) {
        chartItemView.chartItemShape.sizeheight = 1;
        chartItemView.refresh();
        chartItemView.setLineThickness(chartBaseLineWidth + 2);
        chartItemView.updateEntity();
      } else {
        if (this.delegate.chartInspectorState.vectorEditorActive) {
          chartItemView.setLineColorCss(this.delegate.chartInspectorState.selectionColor);
          this.delegate.chartInspectorState.lineThickness = ((chartBaseLineWidth + 2) / 2) + 1;
        }
        chartItemView.setLineThickness(chartBaseLineWidth + 2);
        chartItemView.updateEntity();
      }
    }
    this.updateInspectorView();
    this.delegate.killAutoSaveTimer();
  },

  selectedItemRotationReset: function (resetAngle) {
    for (var i = 0; i < this.selectedChartItemViews.length; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      chartItemView.setViewRotationDeg(resetAngle);
      chartItemView.updateEntity();
    }
    this.updateInspectorView();
  },

  selectedItemSnapToGrid: function () {
    for (var i = 0; i < this.selectedChartItemViews.length; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      var ignoreShapeTypes = [11, 12, 13, 14, 15];
      if (!ignoreShapeTypes.includes(chartItemView.shapeType)) {
        this.snapToGrid(chartItemView);
      }
    }
  },

  snapToGridChartItem: function () {
    var chartItemView = this.touchCapturedChildNode;
    var ignoreShapeTypes = [11, 12, 13, 14, 15];
    if (!ignoreShapeTypes.includes(chartItemView.shapeType)) {
      this.snapToGrid(chartItemView);
    }
  },

  snapToGrid: function (chartItemView) {
    this.disableChangeTracking();
    var unit = 0

    if (!this._chartItemViewFactory._numberlineZeroAtCenter) {
      unit = this._chartItemViewFactory._numberlineMarkerStepValue;
    }

    var centerX = ((this._chartItemViewFactory._stageUnitWidth + (this._chartItemViewFactory._offstageUnitWidth * 2) - unit) / 2) - chartItemView.getBackingEntity().positionx;
    var centerY = this._chartItemViewFactory._stageUnitDepth - chartItemView.getBackingEntity().positiony;

    var newX = (Math.round(centerX / (this._chartItemViewFactory._numberlineMarkerStepValue / 2))) * (this._chartItemViewFactory._numberlineMarkerStepValue / 2);
    var newY = (((Math.round((centerY - this._chartItemViewFactory._verticalNumberlineZeroOffsetValue) / (this._chartItemViewFactory._verticalNumberlineMarkerStepValue / 2))) *
      (this._chartItemViewFactory._verticalNumberlineMarkerStepValue / 2)) + this._chartItemViewFactory._verticalNumberlineZeroOffsetValue);

    var finalNewX = ((this._chartItemViewFactory._stageUnitWidth - unit) / 2) - newX + (this._chartItemViewFactory._offstageUnitWidth);
    var finalNewY = this._chartItemViewFactory._stageUnitDepth - newY;

    chartItemView.getBackingEntity().positionx = finalNewX;
    chartItemView.getBackingEntity().positiony = finalNewY;
    chartItemView.refresh();

    this.enableChangeTracking();
    this.notifyDidChange();
  },

  selectedItemHorizontalSpacing: function () {
    this.disableChangeTracking();
    var lineShapeTypes = [4, 5, 6, 7, 8, 9, 10];
    this.selectedChartItemViews.sort(function (a, b) {
      var rightEdgeA = a.getBoundingBox().x + a.getBoundingBox().width / 2;
      var rightEdgeB = b.getBoundingBox().x + b.getBoundingBox().width / 2;
      return rightEdgeA - rightEdgeB;
    });
    var leftmostObject = this.selectedChartItemViews[0];
    var rightmostObject = this.selectedChartItemViews[this.selectedChartItemViews.length - 1];
    var leftmostEdge = leftmostObject.getBoundingBox().x + leftmostObject.getBoundingBox().width;
    var rightmostEdge = rightmostObject.getBoundingBox().x;
    var totalBoundingBoxWidth = 0;
    for (var i = 1; i < this.selectedChartItemViews.length - 1; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      totalBoundingBoxWidth += chartItemView.getBoundingBox().width;
    }
    var spacing = (rightmostEdge - leftmostEdge - totalBoundingBoxWidth) / (this.selectedChartItemViews.length - 1);
    var newX = leftmostEdge - (this._chartItemViewFactory._scaledStagePxOffset.x);
    for (var i = 1; i < this.selectedChartItemViews.length - 1; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      if (lineShapeTypes.includes(chartItemView.shapeType)) {
        newX += spacing;
        var extraW = Math.abs(chartItemView.getBoundingBox().x - chartItemView.x - (this._chartItemViewFactory._scaledStagePxOffset.x));
        chartItemView.setPosition(newX + extraW, chartItemView._position.y);
        newX += chartItemView.getBoundingBox().width;
      } else {
        newX += spacing + chartItemView.getBoundingBox().width / 2;
        chartItemView.setPosition(newX, chartItemView._position.y);
        newX += chartItemView.getBoundingBox().width / 2;
      }
      chartItemView.updateEntity();
    }
    this.enableChangeTracking();
    this.notifyDidChange();
  },

  selectedItemVerticalSpacing: function () {
    this.disableChangeTracking();
    var lineShapeTypes = [4, 5, 6, 7, 8, 9, 10];
    this.selectedChartItemViews.sort(function (a, b) {
      var bottomEdgeA = a.getBoundingBox().y + a.getBoundingBox().height / 2;
      var bottomEdgeB = b.getBoundingBox().y + b.getBoundingBox().height / 2;
      return bottomEdgeA - bottomEdgeB;
    });
    var topmostObject = this.selectedChartItemViews[0];
    var bottommostObject = this.selectedChartItemViews[this.selectedChartItemViews.length - 1];
    var topmostEdge = topmostObject.getBoundingBox().y + topmostObject.getBoundingBox().height;
    var bottommostEdge = bottommostObject.getBoundingBox().y;
    var totalBoundingBoxHeight = 0;
    for (var i = 1; i < this.selectedChartItemViews.length - 1; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      totalBoundingBoxHeight += chartItemView.getBoundingBox().height;
    }
    var spacing = (bottommostEdge - topmostEdge - totalBoundingBoxHeight) / (this.selectedChartItemViews.length - 1);
    var newY = topmostEdge - (this._chartItemViewFactory._scaledStagePxOffset.y);
    for (var i = 1; i < this.selectedChartItemViews.length - 1; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      if (lineShapeTypes.includes(chartItemView.shapeType)) {
        newY += spacing;
        var extraH = Math.abs(chartItemView.getBoundingBox().y - chartItemView.y - (this._chartItemViewFactory._scaledStagePxOffset.y));
        chartItemView.setPosition(chartItemView._position.x, newY + extraH);
        newY += chartItemView.getBoundingBox().height;
      } else {
        newY += spacing + chartItemView.getBoundingBox().height / 2;
        chartItemView.setPosition(chartItemView._position.x, newY);
        newY += chartItemView.getBoundingBox().height / 2;
      }
      chartItemView.updateEntity();
    }
    this.enableChangeTracking();
    this.notifyDidChange();
  },

  selectedItemAlignLeft: function () {
    this.disableChangeTracking();
    var lineShapeTypes = [4, 5, 6, 7, 8, 9, 10];
    var leftmostObject = this.selectedChartItemViews[0];
    for (var i = 1; i < this.selectedChartItemViews.length; i++) {
      var currentObject = this.selectedChartItemViews[i];
      if (currentObject.getBoundingBox().x < leftmostObject.getBoundingBox().x) {
        leftmostObject = currentObject;
      }
    }
    for (var i = 0; i < this.selectedChartItemViews.length; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      var adjustment = leftmostObject.getBoundingBox().x - chartItemView.getBoundingBox().x;
      if (lineShapeTypes.includes(chartItemView.shapeType)) {
        chartItemView.setPosition(chartItemView.x + adjustment, chartItemView._position.y);
      } else {
        chartItemView.setPosition(chartItemView.x + adjustment, chartItemView._position.y);
      }
      chartItemView.updateEntity();
    }
    this.enableChangeTracking();
    this.notifyDidChange();
  },

  selectedItemAlignCenter: function () {
    this.disableChangeTracking();
    var lineShapeTypes = [4, 5, 6, 7, 8, 9, 10];
    var leftmostObject = this.selectedChartItemViews[0];
    var rightmostObject = this.selectedChartItemViews[0];
    for (var i = 1; i < this.selectedChartItemViews.length; i++) {
      var currentObject = this.selectedChartItemViews[i];
      if (currentObject.getBoundingBox().x < leftmostObject.getBoundingBox().x) {
        leftmostObject = currentObject;
      }
      if ((currentObject.getBoundingBox().x + currentObject.getBoundingBox().width) > (rightmostObject.getBoundingBox().x + rightmostObject.getBoundingBox().width)) {
        rightmostObject = currentObject;
      }
    }
    var totalDistance = (rightmostObject.getBoundingBox().x + rightmostObject.getBoundingBox().width) - leftmostObject.getBoundingBox().x;
    var center = leftmostObject.getBoundingBox().x + totalDistance / 2;
    for (var i = 0; i < this.selectedChartItemViews.length; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      var adjustment = center - (chartItemView.getBoundingBox().x + chartItemView.getBoundingBox().width / 2);
      if (lineShapeTypes.includes(chartItemView.shapeType)) {
        chartItemView.setPosition(chartItemView.x + adjustment, chartItemView._position.y);
      } else {
        chartItemView.setPosition(chartItemView.x + adjustment, chartItemView._position.y);
      }
      chartItemView.updateEntity();
    }
    this.enableChangeTracking();
    this.notifyDidChange();
  },

  selectedItemAlignRight: function () {
    this.disableChangeTracking();
    var lineShapeTypes = [4, 5, 6, 7, 8, 9, 10];
    var rightmostObject = this.selectedChartItemViews[0];
    for (var i = 1; i < this.selectedChartItemViews.length; i++) {
      var currentObject = this.selectedChartItemViews[i];
      if (currentObject.getBoundingBox().x + currentObject.getBoundingBox().width > rightmostObject.getBoundingBox().x + rightmostObject.getBoundingBox().width) {
        rightmostObject = currentObject;
      }
    }
    for (var i = 0; i < this.selectedChartItemViews.length; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      var adjustment = (rightmostObject.getBoundingBox().x + rightmostObject.getBoundingBox().width) - (chartItemView.getBoundingBox().x + chartItemView.getBoundingBox().width);
      if (lineShapeTypes.includes(chartItemView.shapeType)) {
        chartItemView.setPosition(chartItemView.x + adjustment, chartItemView._position.y);
      } else {
        chartItemView.setPosition(chartItemView.x + adjustment, chartItemView._position.y);
      }
      chartItemView.updateEntity();
    }
    this.enableChangeTracking();
    this.notifyDidChange();
  },

  selectedItemAlignTop: function () {
    this.disableChangeTracking();
    var lineShapeTypes = [4, 5, 6, 7, 8, 9, 10];
    var topmostObject = this.selectedChartItemViews[0];
    for (var i = 1; i < this.selectedChartItemViews.length; i++) {
      var currentObject = this.selectedChartItemViews[i];
      if (currentObject.getBoundingBox().y < topmostObject.getBoundingBox().y) {
        topmostObject = currentObject;
      }
    }
    for (var i = 0; i < this.selectedChartItemViews.length; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      var adjustment = topmostObject.getBoundingBox().y - chartItemView.getBoundingBox().y;
      if (lineShapeTypes.includes(chartItemView.shapeType)) {
        chartItemView.setPosition(chartItemView._position.x, chartItemView.y + adjustment);
      } else {
        chartItemView.setPosition(chartItemView._position.x, chartItemView.y + adjustment);
      }
      chartItemView.updateEntity();
    }
    this.enableChangeTracking();
    this.notifyDidChange();
  },

  selectedItemAlignMiddle: function () {
    this.disableChangeTracking();
    var lineShapeTypes = [4, 5, 6, 7, 8, 9, 10];
    var topmostObject = this.selectedChartItemViews[0];
    var bottommostObject = this.selectedChartItemViews[0];
    for (var i = 1; i < this.selectedChartItemViews.length; i++) {
      var currentObject = this.selectedChartItemViews[i];
      if (currentObject.getBoundingBox().y < topmostObject.getBoundingBox().y) {
        topmostObject = currentObject;
      }
      if ((currentObject.getBoundingBox().y + currentObject.getBoundingBox().height) > (bottommostObject.getBoundingBox().y + bottommostObject.getBoundingBox().height)) {
        bottommostObject = currentObject;
      }
    }
    var totalDistance = (bottommostObject.getBoundingBox().y + bottommostObject.getBoundingBox().height) - topmostObject.getBoundingBox().y;
    var middle = topmostObject.getBoundingBox().y + totalDistance / 2;
    for (var i = 0; i < this.selectedChartItemViews.length; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      var adjustment = middle - (chartItemView.getBoundingBox().y + chartItemView.getBoundingBox().height / 2);
      if (lineShapeTypes.includes(chartItemView.shapeType)) {
        chartItemView.setPosition(chartItemView._position.x, chartItemView.y + adjustment);
      } else {
        chartItemView.setPosition(chartItemView._position.x, chartItemView.y + adjustment);
      }
      chartItemView.updateEntity();
    }
    this.enableChangeTracking();
    this.notifyDidChange();
  },

  selectedItemAlignBottom: function () {
    this.disableChangeTracking();
    var lineShapeTypes = [4, 5, 6, 7, 8, 9, 10];
    var bottommostObject = this.selectedChartItemViews[0];
    for (var i = 1; i < this.selectedChartItemViews.length; i++) {
      var currentObject = this.selectedChartItemViews[i];
      if ((currentObject.getBoundingBox().y + currentObject.getBoundingBox().height) > (bottommostObject.getBoundingBox().y + bottommostObject.getBoundingBox().height)) {
        bottommostObject = currentObject;
      }
    }
    for (var i = 0; i < this.selectedChartItemViews.length; i++) {
      var chartItemView = this.selectedChartItemViews[i];
      var adjustment = (bottommostObject.getBoundingBox().y + bottommostObject.getBoundingBox().height) - (chartItemView.getBoundingBox().y + chartItemView.getBoundingBox().height);
      if (lineShapeTypes.includes(chartItemView.shapeType)) {
        chartItemView.setPosition(chartItemView._position.x, chartItemView.y + adjustment);
      } else {
        chartItemView.setPosition(chartItemView._position.x, chartItemView.y + adjustment);
      }
      chartItemView.updateEntity();
    }
    this.enableChangeTracking();
    this.notifyDidChange();
  },

});

(function () {
  ChartLayerBase.CanvasRenderCmd = function (renderable) {
    cc.Layer.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
  };

  var proto = ChartLayerBase.CanvasRenderCmd.prototype = Object.create(cc.Layer.CanvasRenderCmd.prototype);
  proto.constructor = ChartLayerBase.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {
    var wrapper = ctx || cc._renderContext;
    var drawingUtil = cc._drawingUtil;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    drawingUtil.renderClipToNode(this._node);
  };
}());

(function () {
  ChartLayerBase.CanvasRenderPostCmd = function (renderable) {
    cc.Layer.CanvasRenderCmd.call(this, renderable);
    this._isPostCmd = true;
    this._needDraw = true;
    this._dashOffset = 0;
    this._dashOffsetFpsCounter = 0;
  };

  var proto = ChartLayerBase.CanvasRenderPostCmd.prototype = Object.create(cc.Layer.CanvasRenderCmd.prototype);
  proto.constructor = ChartLayerBase.CanvasRenderPostCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {
    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext();

    var drawingUtil = cc._drawingUtil;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    if (node._rubberBandSelectionMode) {
      wrapper.save();

      drawingUtil.setLineWidth(2);

      context.setLineDash([8, 6]);
      context.lineDashOffset = this._dashOffset;

      drawingUtil.drawSolidRectangle(
        cc.p(node._rubberBandSelectionRect.x, node._rubberBandSelectionRect.y),
        cc.p(node._rubberBandSelectionRect.x + node._rubberBandSelectionRect.width, node._rubberBandSelectionRect.y + node._rubberBandSelectionRect.height),
        true,
        cc.color(91, 249, 44, 255),
        cc.color(91, 249, 44, 63)
      );

      this._dashOffsetFpsCounter++;
      if (this._dashOffsetFpsCounter > (120 / cc.game._frameTime)) {
        this._dashOffsetFpsCounter = 0;
        this._dashOffset++;

        if (this._dashOffset > 13) {
          this._dashOffset = 0;
        }
      }

      wrapper.restore();
    }

    drawingUtil.resetRenderClip();

    if (node.rotatingChartItemView) {
      wrapper.save();
      if (!node._povAudience) {
        context.translate(0.5 * node.width * scaleX, node.height * scaleY);
        context.scale(-1, -1);
        context.translate(-0.5 * node.width * scaleX, 0);
      }

      var angle = Math.round(node.rotatingChartItemView.getViewRotationDeg()) + '°';
      context.font = 24 * scaleX + 'px Arial';
      context.textBaseline = 'middle'
      var maxAngleTextSize = context.measureText('999°');
      var maxTextWidth = maxAngleTextSize.width * 1.5;
      var maxTextHeight = (maxAngleTextSize.fontBoundingBoxAscent + maxAngleTextSize.fontBoundingBoxDescent) * 1.5;
      var textWidth = context.measureText(angle).width;
      context.fillStyle = 'rgba(128, 128, 128, 0.8)'
      context.beginPath();
      context.roundRect((node.width * scaleX - maxTextWidth) / 2, 12 - maxTextHeight / 2, maxTextWidth, maxTextHeight, 4);
      context.fill();
      context.fillStyle = 'black'
      context.fillText(angle, (node.width * scaleX - textWidth) / 2, 12);

      wrapper.restore();
    }
  };
}());

var ChartLayerPermanent = ChartLayerBase.extend({
  chartItems: undefined,

  ctor: function () {
    this._super();

    this.chartItems = [];
    this.setName('ChartLayerPermanent');
  },

  handleZoomOffsetTransformChange: function () {
    this._super();
  },

  refresh: function () {
    // TODO: implement refresh logic

    this.allChartItemViews.forEach(function (chartItemView) {
      chartItemView.refresh();
    });
  },

  getChartLayerType: function () {
    return SWChartLayer.Type.Permanent;
  },

  getChartItemLayerType: function () {
    return SWChartItem.LayerType.Permanent;
  },
});

var ChartLayerSemiPermanent = ChartLayerBase.extend({
  ctor: function () {
    this._super();

    this.setName('ChartLayerSemiPermanent');

    this.setupTouchHandling();
  },

  handleZoomOffsetTransformChange: function () {
    this._super();
  },

  refresh: function () {
    // TODO: implement refresh logic

    this.allChartItemViews.forEach(function (chartItemView) {
      chartItemView.refresh();
    });
  },

  cleanupData: function () {
    this.removeAllChildren();
    this.allChartItemViews = [];

    this.selectedChartItemViews = [];
  },

  validateData: function () {
    // TODO: implement validation logic

    this._super();
  },

  deleteChartItemView: function (chartItemView) {
    this._super(chartItemView);
  },

  pasteClipboardItems: function (clipboardItems) {
    this._super(clipboardItems);
  },

  getChartLayerType: function () {
    return SWChartLayer.Type.SemiPermanent;
  },

  getChartItemLayerType: function () {
    return SWChartItem.LayerType.SemiPermanent;
  },
});

var ChartLayerPermanentEditable = ChartLayerSemiPermanent.extend({
  ctor: function () {
    this._super();

    this.setName('ChartLayerPermanentEditable');
  },

  getChartLayerType: function () {
    return SWChartLayer.Type.Permanent;
  },

  getChartItemLayerType: function () {
    return SWChartItem.LayerType.Permanent;
  },
});

var ChartLayerDynamic = ChartLayerBase.extend({
  _positionVisible: true,
  _positionResolutionFraction: 0,
  _noseVisible: false,

  ctor: function () {
    this._super();

    this.setName('ChartLayerDynamic');

    this.setupTouchHandling();
  },

  handleZoomOffsetTransformChange: function () {
    this._super();
  },

  setPositionVisible: function (positionVisible) {
    if (this._positionVisible !== positionVisible) {
      this._positionVisible = positionVisible;

      this.allChartItemViews.forEach(function (chartItemView) {
        if (chartItemView.getItemType() === SWChartItem.Type.Performer) {
          chartItemView.setShowPositionLabel(this._positionVisible);
        }
      });
    }
  },

  getPositionVisible: function () {
    return this._positionVisible;
  },

  setPositionResolutionFraction: function (fraction) {
    if (this._positionResolutionFraction !== fraction) {
      this._positionResolutionFraction = fraction;

      var _this = this;
      this.allChartItemViews.forEach(function (chartItemView) {
        if (chartItemView.getItemType() === SWChartItem.Type.Performer) {
          chartItemView.setPositionResolutionFraction(_this._positionResolutionFraction);
        }
      });
    }
  },

  getPositionResolutionFraction: function () {
    return this._positionResolutionFraction;
  },

  setNoseVisible: function (noseVisible) {
    if (this._noseVisible !== noseVisible) {
      this._noseVisible = noseVisible;

      var _this = this;
      this.allChartItemViews.forEach(function (chartItemView) {
        if (chartItemView.getItemType() === SWChartItem.Type.Performer) {
          chartItemView.setShowNose(_this._noseVisible);
        }
      });
    }
  },

  getNoseVisible: function () {
    return this._noseVisible;
  },

  refresh: function () {
    // TODO: implement refresh logic

    this.allChartItemViews.forEach(function (chartItemView) {
      chartItemView.refresh();
    });
  },

  cleanupData: function () {
    this.removeAllChildren();
    this.allChartItemViews = [];

    this.selectedChartItemViews = [];
  },

  setPersonalChartItems: function (chartItems) {
    var _this = this;
    if (Array.isArray(chartItems)) {
      // Filter out items for this layer only
      _.each(chartItems, function (chartItem) {
        if ((chartItem.layer === _this.getChartItemLayerType()) && (chartItem.itemtype === SWChartItem.Type.TextPersonal)) {
          _this.chartItems.push(chartItem);

          _this.loadChartItems([chartItem]);
        }
      });
    }
  },

  getPersonalChartItems: function () {
    var chartItems = [];
    _.each(this.allChartItemViews, function (chartItemView) {
      if (chartItemView.getItemType() == SWChartItem.Type.TextPersonal) {
        chartItems.push(chartItemView.getBackingEntity());
      }
    });

    return chartItems;
  },

  validateData: function () {
    // TODO: implement validation logic

    this._super();
  },

  deleteChartItemView: function (chartItemView) {
    this._super(chartItemView);
  },

  pasteClipboardItems: function (clipboardItems) {
    this._super(clipboardItems);
  },

  getChartLayerType: function () {
    return SWChartLayer.Type.Dynamic;
  },

  getChartItemLayerType: function () {
    return SWChartItem.LayerType.Dynamic;
  },
});

var ChartLayerUser = ChartLayerBase.extend({
  _positionVisible: true,
  _positionResolutionFraction: 0,
  _noseVisible: false,

  ctor: function () {
    this._super();

    this.setName('ChartLayerUser');

    this.setupTouchHandling();
  },

  handleZoomOffsetTransformChange: function () {
    this._super();
  },

  setPositionVisible: function (positionVisible) {
    if (this._positionVisible !== positionVisible) {
      this._positionVisible = positionVisible;

      this.allChartItemViews.forEach(function (chartItemView) {
        if (chartItemView.getItemType() === SWChartItem.Type.Performer) {
          chartItemView.setShowPositionLabel(this._positionVisible);
        }
      });
    }
  },

  getPositionVisible: function () {
    return this._positionVisible;
  },

  setPositionResolutionFraction: function (fraction) {
    if (this._positionResolutionFraction !== fraction) {
      this._positionResolutionFraction = fraction;

      var _this = this;
      this.allChartItemViews.forEach(function (chartItemView) {
        if (chartItemView.getItemType() === SWChartItem.Type.Performer) {
          chartItemView.setPositionResolutionFraction(_this._positionResolutionFraction);
        }
      });
    }
  },

  getPositionResolutionFraction: function () {
    return this._positionResolutionFraction;
  },

  setNoseVisible: function (noseVisible) {
    if (this._noseVisible !== noseVisible) {
      this._noseVisible = noseVisible;

      var _this = this;
      this.allChartItemViews.forEach(function (chartItemView) {
        if (chartItemView.getItemType() === SWChartItem.Type.Performer) {
          chartItemView.setShowNose(_this._noseVisible);
        }
      });
    }
  },

  getNoseVisible: function () {
    return this._noseVisible;
  },

  refresh: function () {
    // TODO: implement refresh logic

    this.allChartItemViews.forEach(function (chartItemView) {
      chartItemView.refresh();
    });
  },

  cleanupData: function () {
    this.removeAllChildren();
    this.allChartItemViews = [];

    this.selectedChartItemViews = [];
  },

  setPersonalChartItems: function (chartItems) {
    var _this = this;
    if (Array.isArray(chartItems)) {
      // Filter out items for this layer only
      _.each(chartItems, function (chartItem) {
        if ((chartItem.layer === _this.getChartItemLayerType()) && (chartItem.itemtype === SWChartItem.Type.TextPersonal)) {
          _this.chartItems.push(chartItem);

          _this.loadChartItems([chartItem]);
        }
      });
    }
  },

  getPersonalChartItems: function () {
    var chartItems = [];
    _.each(this.allChartItemViews, function (chartItemView) {
      if (chartItemView.getItemType() == SWChartItem.Type.TextPersonal) {
        chartItems.push(chartItemView.getBackingEntity());
      }
    });

    return chartItems;
  },

  validateData: function () {
    // TODO: implement validation logic

    this._super();
  },

  deleteChartItemView: function (chartItemView) {
    this._super(chartItemView);
  },

  pasteClipboardItems: function (clipboardItems) {
    this._super(clipboardItems);
  },

  getChartLayerType: function () {
    return SWChartLayer.Type.User;
  },

  getChartItemLayerType: function () {
    return SWChartItem.LayerType.User;
  },
});

var ChartGridView = cc.Node.extend({
  kMinTopMargin: 24,
  kMinBottMargin: 40,
  kMinLeftMargin: 32,
  kMinRightMargin: 8,

  _production: undefined,
  _showFullGrid: true,

  _scalePxPerUnitX: 1.0,
  _scalePxPerUnitY: 1.0,

  _stageViewBounds: cc.rect(),
  _scaledStageBounds: cc.rect(),

  _zoomFactor: 1.0,
  _zoomOffset: cc.p(),

  _numberLineVisible: true,
  _evenNumbersVisible: true,
  _verticalevenNumbersVisible: true,
  _verticaloddNumbersVisible: true,
  _oddNumbersVisible: true,
  _centerLineVisible: true,
  _verticalLinesVisible: true,
  _horizontalLinesVisible: true,
  _povAudience: true,

  _numberlineZeroAtCenter: true,
  _numberlineMultiplier: 1,
  _numberlineMarkerStepValue: 1,
  _verticalNumberlineMultiplier: 1,
  _verticalNumberlineMarkerStepValue: 1,
  _verticalNumberlineZeroOffsetValue: 0,

  _chartNotesVisible: true,

  ctor: function () {
    this._super();

    this._localZOrder = -1;

    this.width = SWChartUI.DesignWidth;
    this.height = SWChartUI.DesignHeight;

    this._showFullGrid = false;
    this._zoomFactor = 1.0;
    this._zoomOffset = cc.p(0, 0);

    this.setName('ChartGridView');

    return true;
  },

  setProduction: function (production) {
    if (this._production !== production) {
      this._production = production;

      this._zoomFactor = 1.0;
    }

    if (this._production !== undefined) {
      // this._numberLineVisible = (this._production.chartsettings.numberlinevisible === true);
      // this._centerLineVisible = (this._production.chartsettings.centerlinevisible === true);
      // this._verticalLinesVisible = (this._production.chartsettings.verticallinesvisible === true);
      // this._horizontalLinesVisible = (this._production.chartsettings.horizontallinesvisible === true);
      // this._povAudience = (this._production.chartsettings.povaudience === true);

      if (this._production.chartsettings.horizontallinesnumbersvisible === undefined) {
        this._production.chartsettings.horizontallinesnumbersvisible = (this._production.chartsettings.horizontallinesvisible === true);
      }
      if (this._production.chartsettings.chartnotesvisible === undefined) {
        this._production.chartsettings.chartnotesvisible = (this._production.chartsettings.chartnotesvisible === true);
      }

      if (angular.isUndefined(this._production.stagesettings.numberlineNumbersVisibility)) {
        this._production.stagesettings.numberlineNumbersVisibility = 0;
      }
      if (angular.isUndefined(this._production.stagesettings.verticalNumberlineNumbersVisibility)) {
        this._production.stagesettings.verticalNumberlineNumbersVisibility = 0;
      }
      if (angular.isUndefined(this._production.stagesettings.verticalNumberlineZeroOffsetValue)) {
        this._production.stagesettings.verticalNumberlineZeroOffsetValue = 0;
      }
      if (angular.isUndefined(this._production.stagesettings.verticalNumberlineMarkerStepValue)) {
        this._production.stagesettings.verticalNumberlineMarkerStepValue = 1;
      }
      if (angular.isUndefined(this._production.stagesettings.numberlineMarkerStepValue)) {
        this._production.stagesettings.numberlineMarkerStepValue = 1;
      }

      this._numberLineVisible = (this._production.chartsettings.numberlinevisible === true) || (this._showFullGrid === true);
      this._evenNumbersVisible = (this._production.stagesettings.numberlineNumbersVisibility === -1) || (this._production.stagesettings.numberlineNumbersVisibility === 0);
      this._oddNumbersVisible = (this._production.stagesettings.numberlineNumbersVisibility === -1) || (this._production.stagesettings.numberlineNumbersVisibility === 1);
      this._verticalEvenNumbersVisible = (this._production.stagesettings.verticalNumberlineNumbersVisibility === -1) || (this._production.stagesettings.verticalNumberlineNumbersVisibility === 0);
      this._verticalOddNumbersVisible = (this._production.stagesettings.verticalNumberlineNumbersVisibility === -1) || (this._production.stagesettings.verticalNumberlineNumbersVisibility === 1);
      this._centerLineVisible = (this._production.chartsettings.centerlinevisible === true) || (this._showFullGrid === true);
      this._verticalLinesVisible = (this._production.chartsettings.verticallinesvisible === true) || (this._showFullGrid === true);
      this._horizontalLinesVisible = (this._production.chartsettings.horizontallinesvisible === true) || (this._showFullGrid === true);
      this._chartNotesVisible = (this._production.chartsettings.chartnotesvisible === true);
      this._povAudience = (this._production.chartsettings.povaudience === true) || (this._showFullGrid === true);
      this._numberlineZeroAtCenter = this._production.stagesettings.numberlineZeroAtCenter;
      this._numberlineMultiplier = this._production.stagesettings.numberlineMultiplier || 1;
      this._verticalNumberlineMultiplier = this._production.stagesettings.verticalNumberlineMultiplier || 1;
      this._horizontalLinesNumbersVisible = (this._production.chartsettings.horizontallinesnumbersvisible === true) || (this._showFullGrid === true);
      this._verticalNumberlineZeroOffsetValue = this._production.stagesettings.verticalNumberlineZeroOffsetValue;
      this._verticalNumberlineMarkerStepValue = this._production.stagesettings.verticalNumberlineMarkerStepValue;
      this._numberlineMarkerStepValue = this._production.stagesettings.numberlineMarkerStepValue;
    } else {
      this._numberLineVisible = true;
      this._evenNumbersVisible = true;
      this._oddNumbersVisible = true;
      this._centerLineVisible = true;
      this._verticalLinesVisible = true;
      this._horizontalLinesVisible = true;
      this._horizontalLinesNumbersVisible = true;
      this._povAudience = true;
      this._verticalevenNumbersVisible = true;
      this._verticaloddNumbersVisible = true;

      this._numberlineZeroAtCenter = true;
      this._numberlineMultiplier = 1;
      this._numberlineMarkerStepValue = 1;
      this._verticalNumberlineMultiplier = 1;
      this._verticalNumberlineMarkerStepValue = 1;
      this._verticalNumberlineZeroOffsetValue = 0;

      this._chartNotesVisible = true;
    }

    this.updateStageViewParameters();

    this.setNodeDirty();
  },

  setShowFullGrid: function (showFullGrid) {
    this._showFullGrid = (showFullGrid === true);
  },

  setPovAudience: function (povAudience) {
    this._povAudience = povAudience;
  },

  getScalePxPerUnitX: function () {
    return this._scalePxPerUnitX;
  },

  getScalePxPerUnitY: function () {
    return this._scalePxPerUnitY;
  },

  getStageViewBounds: function () {
    return this._stageViewBounds;
  },

  getStageViewPosition: function () {
    return cc.p(this._stageViewBounds.x, this._stageViewBounds.y);
  },

  getStageViewSize: function () {
    return cc.size(this._stageViewBounds.width, this._stageViewBounds.height);
  },

  getScaledStageBounds: function () {
    return this._scaledStageBounds;
  },

  getZoomFactor: function () {
    return this._zoomFactor;
  },

  setZoomFactor: function (zoomFactor) {
    if (zoomFactor < 1.0) {
      zoomFactor = 1.0;
    } else if (zoomFactor > 20.0) {
      zoomFactor = 20.0;
    }

    if (this._zoomFactor !== zoomFactor) {
      this._zoomFactor = zoomFactor;

      this.updateStageViewParameters();

      this.setNodeDirty();
    }
  },

  getZoomOffset: function () {
    return this._zoomOffset;
  },

  setZoomOffset: function (zoomOffset, y) {
    if (y !== undefined) {
      zoomOffset = cc.p(zoomOffset, y);
    }

    var viewWidth = this._stageViewBounds.width;
    var viewHeight = this._stageViewBounds.height;

    var zoomWidth = this._scaledStageBounds.width;
    var zoomHeight = this._scaledStageBounds.height;

    if (zoomOffset.x > 0) {
      zoomOffset.x = 0;
    } else if (zoomOffset.x < (viewWidth - zoomWidth)) {
      zoomOffset.x = viewWidth - zoomWidth;
    }

    if (zoomOffset.y > 0) {
      zoomOffset.y = 0;
    } else if (zoomOffset.y < (viewHeight - zoomHeight)) {
      zoomOffset.y = viewHeight - zoomHeight;
    }

    if (!cc.pointEqualToPoint(this._zoomOffset, zoomOffset)) {
      this._zoomOffset = cc.p(zoomOffset);

      this.setNodeDirty();
    }
  },

  getMaxStageZoom: function () {
    return (Math.floor(scaleUnitReferencePixels / this._scalePxPerUnitX * this._zoomFactor) + 2);
  },

  updateStageViewParameters: function () {
    if (!((parseFloat(this._production.stagesettings.stagewidth) > 0.0) && (parseFloat(this._production.stagesettings.stagedepth) > 0.0))) {
      this._scalePxPerUnitX = 1;
      this._scalePxPerSwaUnitX = 1;
      this._scalePxPerSwaUnitY = 1;
      this._scalePxPerUnitY = 1;
      this._stageViewBounds = cc.rect();
      this._scaledStageBounds = cc.rect();
      this._zoomOffset = cc.p();

      return;
    }

    var viewSize = this.getContentSize();

    var stageWidthWithOffstage = (parseFloat(this._production.stagesettings.stagewidth) + (2 * parseFloat(this._production.stagesettings.offstagewidth)));
    var stageSwaUnitWidthWithOffstage = stageWidthWithOffstage * this._numberlineMultiplier;

    // 30px on left and 10px margin on right
    var pxPerUnitX = (viewSize.width - (this.kMinLeftMargin + this.kMinRightMargin)) / stageWidthWithOffstage;
    this._scalePxPerUnitX = pxPerUnitX * this._zoomFactor;

    // 40px bottom margin for scale and labels + 20px top margin
    var pxPerUnitY = (viewSize.height - (this.kMinTopMargin + this.kMinBottMargin)) / parseFloat(this._production.stagesettings.stagedepth);
    this._scalePxPerUnitY = pxPerUnitY * this._zoomFactor;

    if (this._scalePxPerUnitX < this._scalePxPerUnitY) {
      this._scalePxPerUnitY = this._scalePxPerUnitX;
    } else {
      this._scalePxPerUnitX = this._scalePxPerUnitY;
    }

    var pxPerSwaUnitX = (viewSize.width - (this.kMinLeftMargin + this.kMinRightMargin)) / stageSwaUnitWidthWithOffstage;
    // this._scalePxPerSwaUnitX = pxPerSwaUnitX * this._zoomFactor;
    this._scalePxPerSwaUnitX = this._scalePxPerUnitX / this._numberlineMultiplier;
    this._scalePxPerSwaUnitY = this._scalePxPerUnitY / this._verticalNumberlineMultiplier;

    var scaledStageSize = cc.size(this._scalePxPerUnitX * stageWidthWithOffstage, this._scalePxPerUnitY * parseFloat(this._production.stagesettings.stagedepth));

    this.productionStageOffsetPx = this._verticalNumberlineZeroOffsetValue * this._scalePxPerUnitY;
    this.productionStageVerticalOffsetUnits = Math.floor(this.productionStageOffsetPx / this._scalePxPerSwaUnitY);

    this._stageViewBounds.x = this.kMinLeftMargin;
    this._stageViewBounds.y = this.kMinTopMargin;
    this._stageViewBounds.width = viewSize.width - (this.kMinLeftMargin + this.kMinRightMargin);
    this._stageViewBounds.height = viewSize.height - (this.kMinTopMargin + this.kMinBottMargin);

    this._scaledStageBounds = cc.rect(0, 0, scaledStageSize.width, scaledStageSize.height);

    if (scaledStageSize.width < this._stageViewBounds.width) {
      this._stageViewBounds.x += (this._stageViewBounds.width - scaledStageSize.width) / 2;
      this._stageViewBounds.width = scaledStageSize.width;
    }

    if (scaledStageSize.height < this._stageViewBounds.height) {
      this._stageViewBounds.y += (this._stageViewBounds.height - scaledStageSize.height) / 2;
      this._stageViewBounds.height = scaledStageSize.height;
    }

    // trigger a zoom offset correction if needed
    this.setZoomOffset(this._zoomOffset);
  },

  _createRenderCmd: function () {
    return new ChartGridView.CanvasRenderCmd(this);
  },

});

(function () {
  ChartGridView.CanvasRenderCmd = function (renderable) {
    cc.Node.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
  };

  var proto = ChartGridView.CanvasRenderCmd.prototype = Object.create(cc.Node.CanvasRenderCmd.prototype);
  proto.constructor = ChartGridView.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {
    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext();

    var drawingUtil = cc._drawingUtil;

    var i;

    if (node._production === undefined) {
      return;
    }

    if (!((parseFloat(node._production.stagesettings.stagewidth) > 0.0) && (parseFloat(node._production.stagesettings.stagedepth) > 0.0))) {
      return;
    }

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    context.scale(scaleX, scaleY);
    // context.translate(0, -node.height);

    if (!node._povAudience) {
      context.translate(node.width, node.height);
      context.scale(-1, -1);
    }

    // Calculate marker steps, ensure its a power of 2
    var stepX = Math.floor(scaleUnitReferencePixels / node._scalePxPerUnitX) + 1.0;
    stepX = Math.pow(2, Math.ceil(Math.log2(stepX)));

    var stepY = Math.floor(scaleUnitReferencePixels / node._scalePxPerUnitY) + 1.0;
    stepY = Math.pow(2, Math.ceil(Math.log2(stepY)));

    var stageSwaUnitDepth = parseFloat(node._production.stagesettings.stagedepth) * node._verticalNumberlineMultiplier;

    var stageSwaUnitWidth = parseFloat(node._production.stagesettings.stagewidth) * node._numberlineMultiplier;

    var stepSwaUnitX = Math.floor(scaleUnitReferencePixels / node._scalePxPerSwaUnitX) + 1.0;
    stepSwaUnitX = Math.pow(2, Math.ceil(Math.log2(stepSwaUnitX)));

    var stepSwaUnitY = Math.floor(scaleUnitReferencePixels / node._scalePxPerSwaUnitY) + 1.0;
    stepSwaUnitY = Math.pow(2, Math.ceil(Math.log2(stepSwaUnitY)));

    // numbering offset
    var verticalNumberOffsetPx = node.productionStageOffsetPx - (node.productionStageVerticalOffsetUnits * node._scalePxPerSwaUnitY);

    // logic to have a grid line at 0
    var gridStepPxY = stepSwaUnitY * node._scalePxPerSwaUnitY;
    var verticalGridOffsetPx = node.productionStageOffsetPx % gridStepPxY;

    var offsetForNoCenterZeroPx = 0;
    if (!node._production.stagesettings.numberlineZeroAtCenter) {
      offsetForNoCenterZeroPx = node._scalePxPerSwaUnitX / 2;// * stepSwaUnitX;
    }

    var stageTop = cc.rectGetMinY(node._scaledStageBounds);
    var stageBott = cc.rectGetMaxY(node._scaledStageBounds);
    var stageLeft = cc.rectGetMinX(node._scaledStageBounds);
    var stageRight = cc.rectGetMaxX(node._scaledStageBounds);
    var stageMidX = cc.rectGetMidX(node._scaledStageBounds);

    // Clip to scrollable stage area
    wrapper.save();
    context.beginPath();
    context.rect(node._stageViewBounds.x, node._stageViewBounds.y, node._stageViewBounds.width, node._stageViewBounds.height);
    context.closePath();
    context.clip();

    context.translate(node._zoomOffset.x + node._stageViewBounds.x, node._zoomOffset.y + node._stageViewBounds.y);

    // Vertical grid
    drawingUtil.setDrawColor(170, 170, 170, 255);
    drawingUtil.setLineWidth(0.5 / scaleX);
    if (node._verticalLinesVisible) {
      context.beginPath();
      for (var i = stepSwaUnitX; i <= (parseInt(stageSwaUnitWidth) / 2); i += stepSwaUnitX) {
        context.moveTo(stageMidX + i * node._scalePxPerSwaUnitX - offsetForNoCenterZeroPx, stageTop - 10);
        context.lineTo(stageMidX + i * node._scalePxPerSwaUnitX - offsetForNoCenterZeroPx, stageBott + 15);

        context.moveTo(stageMidX - i * node._scalePxPerSwaUnitX + offsetForNoCenterZeroPx, stageTop - 10);
        context.lineTo(stageMidX - i * node._scalePxPerSwaUnitX + offsetForNoCenterZeroPx, stageBott + 15);
      }
      context.stroke();
    }

    // Horizontal grid
    if (node._horizontalLinesVisible) {
      context.beginPath();
      for (i = 0; i <= parseInt(stageSwaUnitDepth); i += stepSwaUnitY) {
        context.moveTo(stageLeft, (stageBott - i * node._scalePxPerSwaUnitY) - verticalGridOffsetPx);
        context.lineTo(stageRight + 15, (stageBott - i * node._scalePxPerSwaUnitY) - verticalGridOffsetPx);
      }

      context.stroke();
    }

    // Center line
    if (node._centerLineVisible) {
      drawingUtil.setDrawColor(0, 0, 0, 255);
      context.setLineDash([3, 5]);
      drawingUtil.setLineWidth(2.0 / scaleX);
      context.beginPath();
      context.moveTo(stageMidX, stageTop - 10);
      context.lineTo(stageMidX, stageBott + 15);
      context.stroke();
    } else if (node._verticalLinesVisible) {
      context.beginPath();
      context.moveTo(stageMidX, stageTop - 10);
      context.lineTo(stageMidX, stageBott + 15);
      context.stroke();
    }

    wrapper.restore();

    // Fixed position rulers
    var stageTopReal = cc.rectGetMinY(node._stageViewBounds);
    var stageBottReal = cc.rectGetMaxY(node._stageViewBounds);
    var stageLeftReal = cc.rectGetMinX(node._stageViewBounds);

    // Ruler
    wrapper.save();
    context.beginPath();
    context.rect(stageLeftReal - 10, stageBottReal - 5, node._stageViewBounds.width + 20, 45);
    context.closePath();
    context.clip();

    context.translate(node._zoomOffset.x + node._stageViewBounds.x, 0);

    if (node._numberLineVisible) {
      // Major marks
      drawingUtil.setDrawColor(84, 84, 84, 255);
      drawingUtil.setLineWidth(1.0 / scaleX);
      context.setLineDash([]);

      context.beginPath();
      for (var i = 0; i <= (parseInt(stageSwaUnitWidth) / 2); i += stepSwaUnitX) {
        if ((i === 0) && (!node._numberlineZeroAtCenter)) {
          continue;
        }
        context.moveTo(stageMidX + i * node._scalePxPerSwaUnitX - offsetForNoCenterZeroPx, stageBottReal - 5);
        context.lineTo(stageMidX + i * node._scalePxPerSwaUnitX - offsetForNoCenterZeroPx, stageBottReal + 15);

        context.moveTo(stageMidX - i * node._scalePxPerSwaUnitX + offsetForNoCenterZeroPx, stageBottReal - 5);
        context.lineTo(stageMidX - i * node._scalePxPerSwaUnitX + offsetForNoCenterZeroPx, stageBottReal + 15);
      }
      context.stroke();

      // Legend labels
      drawingUtil.setDrawColor(0, 0, 0, 255);
      drawingUtil.setLineWidth(0.5 / scaleX);

      wrapper.save();
      if (!node._povAudience) {
        context.scale(-1.0, -1.0);
        context.translate(-stageRight + stageLeft, -stageBottReal * 2 - 46);
      }

      context.font = '14px Arial';

      // x-axis labels
      for (i = 0; i <= (parseInt(stageSwaUnitWidth) / 2); i += 1) {
        if ((i === 0) && (!node._numberlineZeroAtCenter)) {
          continue;
        }

        var numberIsEven = i % 2 == 0;
        if ((numberIsEven && !node._evenNumbersVisible) || (!numberIsEven && !node._oddNumbersVisible)) {
          continue;
        }

        var axisLabelX = i;

        var offsetForCenter = context.measureText(axisLabelX).width / 2;

        context.fillText(axisLabelX, stageMidX + i * node._scalePxPerSwaUnitX - offsetForCenter - offsetForNoCenterZeroPx, stageBottReal + 29);
        context.fillText(axisLabelX, stageMidX - i * node._scalePxPerSwaUnitX - offsetForCenter + offsetForNoCenterZeroPx, stageBottReal + 29);
      }

      wrapper.restore();

      // Hard stage edge line
      drawingUtil.setDrawColor(170, 170, 170, 255);
      drawingUtil.setLineWidth(2.0 / scaleX);
      context.setLineDash([]);
      context.beginPath();
      context.moveTo(stageMidX - (parseInt(node._production.stagesettings.stagewidth) / 2) * node._scalePxPerUnitX, stageBottReal);
      context.lineTo(stageMidX + (parseInt(node._production.stagesettings.stagewidth) / 2) * node._scalePxPerUnitX, stageBottReal);
      context.stroke();
    }

    wrapper.restore();

    // y-axis labels
    wrapper.save();
    context.beginPath();
    context.rect(stageLeftReal - 30, stageTopReal - 15, 30, node._stageViewBounds.height + 30);
    context.closePath();
    context.clip();

    context.translate(0, node._zoomOffset.y + node._stageViewBounds.y);

    if (node._horizontalLinesNumbersVisible && node._horizontalLinesVisible) {
      drawingUtil.setDrawColor(0, 0, 0, 255);
      drawingUtil.setLineWidth(0.5 / scaleX);

      context.font = '14px Arial';

      var yAdjust;
      var axisLabelY;

      var maxDepth = parseInt(stageSwaUnitDepth);
      if (node._povAudience) {
        yAdjust = 14 / 4;
        for (i = 0; i <= maxDepth; i += 1) {
          var calculatedValue = (i - node.productionStageVerticalOffsetUnits);
          var numberIsEven = calculatedValue % 2 == 0;
          var yPos = stageBott - Math.round((i * node._scalePxPerSwaUnitY) + verticalNumberOffsetPx);
          if ((numberIsEven && !node._verticalEvenNumbersVisible) || (!numberIsEven && !node._verticalOddNumbersVisible) || (yPos < stageTop)) {
            continue;
          }

          axisLabelY = calculatedValue;
          var textWidth = context.measureText(axisLabelY).width;
          context.fillText(axisLabelY, stageLeftReal - 3 - textWidth, yPos + yAdjust);
        }
      } else {
        // x flip
        context.scale(-1.0, 1.0);
        context.translate(-2 * stageLeftReal, 0);

        yAdjust = 14 / 4;
        for (i = 0; i <= maxDepth; i += 1) {
          var calculatedValue = (i - node.productionStageVerticalOffsetUnits);
          var numberIsEven = calculatedValue % 2 == 0;
          var yPos = stageBott - Math.round((i * node._scalePxPerSwaUnitY) - verticalNumberOffsetPx);
          if ((numberIsEven && !node._verticalEvenNumbersVisible) || (!numberIsEven && !node._verticalOddNumbersVisible) || (yPos < stageTop)) {
            continue;
          }

          axisLabelY = calculatedValue;
          // y flip
          wrapper.save();
          context.scale(1.0, -1.0);
          context.translate(0, -2 * (stageBott - i * node._scalePxPerSwaUnitY));
          context.fillText(axisLabelY, stageLeftReal + 3, yPos + yAdjust);
          wrapper.restore();
        }
      }
    }

    wrapper.restore();

    cc.g_NumberOfDraws++;
  };

})();

var ChartEditorLayer = cc.Layer.extend({
  delegate: undefined,

  _touchListener: undefined,

  ctor: function () {
    this._super();

    this.width = SWChartUI.DesignWidth;
    this.height = SWChartUI.DesignHeight;

    this.setupTouchHandling();

    return true;
  },

  setupTouchHandling: function () {
    var _this = this;

    this._touchListener = cc.EventListener.create({
      event: cc.EventListener.TOUCH_ONE_BY_ONE,
      swallowTouches: true,

      // Touch begin handler
      onTouchBegan: function (touch, event) {
        if (touch.originalEvent.ctrlKey) {
          _this.panMode = true;
          _this.panBeginPoint = _this.convertTouchToNodeSpace(touch);
          if (_this.delegate && _this.delegate.handleChartPanBegin) {
            _this.delegate.handleChartPanBegin();
          }
          return true;
        }

        return false;
      },

      // Touch move handler
      onTouchMoved: function (touch, event) {
        if (_this.panMode) {
          if (_this.delegate && _this.delegate.handleChartPanPan) {
            _this.delegate.handleChartPanPan(_this.panBeginPoint, _this.convertTouchToNodeSpace(touch));
          }
        }
      },

      // Touch ended handler
      onTouchEnded: function (touch, event) {
        if (_this.panMode) {
          _this.panMode = false;
          if (_this.delegate && _this.delegate.handleChartPanEnd) {
            _this.delegate.handleChartPanEnd();
          }
        }
      },

      // Touch cancelled handler
      onTouchCancelled: function (touch, event) {
        if (_this.panMode) {
          _this.panMode = false;
          if (_this.delegate && _this.delegate.handleChartPanEnd) {
            _this.delegate.handleChartPanEnd();
          }
        }
      },
    });

    // Register touch listener
    cc.eventManager.addListener(this._touchListener, -10);

    // Touch handling is disabled by default
    this._touchListener.setEnabled(false);
  },

  enablePanGestures: function (enable) {
    this._touchListener.setEnabled(enable);
  },

  onExit: function () {
    if (this._touchListener) {
      cc.eventManager.removeListener(this._touchListener);
      this._touchListener = undefined;
    }
  }
});

var ChartEditorScene = cc.Scene.extend({
  chartEditorLayer: null,

  ctor: function () {
    this._super();

    this.chartEditorLayer = new ChartEditorLayer();
  },

  onEnter: function () {
    this._super();

    // var layerBack = new cc.LayerColor(cc.color(255, 255, 255, 255), SWChartUI.DesignWidth, SWChartUI.DesignHeight);
    // this.addChild(layerBack);

    this.chartEditorLayer.setLocalZOrder(-1);
    this.addChild(this.chartEditorLayer);
  },
});

var ChartShapeVectorNodeView = cc.Node.extend({
  _selected: false,

  chartItemViewFactory: undefined,

  _shapePoint: undefined,

  _touchState: undefined,

  ctor: function () {
    this._super();

    this.setAnchorPoint(0.5, 0.5);

    this.width = 24;
    this.height = 24;

    this.shapePoint = cc.p();

    this._touchState = {};

    return true;
  },

  // Touch begin handler
  onTouchBegan: function (touch, event) {
    var touchPoint = this.convertTouchToNodeSpace(touch);
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);

    this._touchState.touchStartOffsetX = this.x - touchPointSuper.x;
    this._touchState.touchStartOffsetY = this.y - touchPointSuper.y;

    this._touchState.touchLimitX1 = touchPoint.x;
    this._touchState.touchLimitX2 = this.chartItemViewFactory.scaledStagePxWidth - (this.width - this._touchState
      .touchLimitX1);
    this._touchState.touchLimitY1 = touchPoint.y;
    this._touchState.touchLimitY2 = this.chartItemViewFactory.scaledStagePxHeight - (this.height - this._touchState
      .touchLimitY1);

    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var touchPointSuper = this.parent.convertTouchToNodeSpace(touch);
    if (touchPointSuper.x < this._touchState.touchLimitX1) {
      touchPointSuper.x = this._touchState.touchLimitX1;
    } else if (touchPointSuper.x > this._touchState.touchLimitX2) {
      touchPointSuper.x = this._touchState.touchLimitX2;
    }

    if (touchPointSuper.y < this._touchState.touchLimitY1) {
      touchPointSuper.y = this._touchState.touchLimitY1;
    } else if (touchPointSuper.y > this._touchState.touchLimitY2) {
      touchPointSuper.y = this._touchState.touchLimitY2;
    }

    this.x = touchPointSuper.x + this._touchState.touchStartOffsetX;
    this.y = touchPointSuper.y + this._touchState.touchStartOffsetY;
    // this.setPosition(touchPointSuper.x + this._touchState.touchStartOffsetX, touchPointSuper.y + this._touchState.touchStartOffsetY);

    var normalizedPosition = this.getNormalizedPosition();
    this._shapePoint.x = normalizedPosition.x;
    this._shapePoint.y = normalizedPosition.y;
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) { },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) { },

  setShapePoint: function (shapePoint) {
    this._shapePoint = shapePoint;
    this.setNormalizedPosition(shapePoint);
  },

  setSelected: function (selected) {
    this._selected = selected;
  },

  _createRenderCmd: function () {
    return new ChartShapeVectorNodeView.CanvasRenderCmd(this);
  },
});

(function () {
  ChartShapeVectorNodeView.CanvasRenderCmd = function (renderable) {
    cc.Node.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
  };

  var proto = ChartShapeVectorNodeView.CanvasRenderCmd.prototype = Object.create(cc.Node.CanvasRenderCmd.prototype);
  proto.constructor = ChartShapeVectorNodeView.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {
    // cc.Node.CanvasRenderCmd.prototype.rendering.call(this, ctx, scaleX, scaleY);

    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var drawingUtil = cc._drawingUtil;

    var strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
    drawingUtil.setLineWidth(strokeWidth);

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    var nodeCenter = cc.p(node.width / 2, node.height / 2);
    // drawingUtil.setDrawColor(0, 0, 0, 255);
    // drawingUtil.drawPoint(nodeCenter, 8);
    // drawingUtil.setDrawColor(255, 255, 255, 255);
    // drawingUtil.drawPoint(nodeCenter, 7);
    if (node._selected) {
      drawingUtil.setFillColorCss('rgba(255, 0, 0, 0.3)');
    } else {
      drawingUtil.setFillColorCss('rgba(0, 0, 0, 0)');
    }
    // drawingUtil.drawPoint(nodeCenter, 12);

    drawingUtil.setStrokeColorCss('rgba(0, 0, 0, 1)');
    drawingUtil.drawEllipse(nodeCenter, 12, 12, true, true);
  };

  proto.getStrokeWidthWithBase = function (baseWidth) {
    var strokeWidth = Math.round(baseWidth / 40 * this._node.chartItemViewFactory.scalePxPerUnitX * this._node.chartItemViewFactory.measurementConversionMultiplier);
    if (strokeWidth < 1) {
      strokeWidth = 1;
    }

    return strokeWidth;
  };
})();

var ChartShapeVectorEditorView = cc.Node.extend({
  // the active chart item if any
  _chartItemShapeView: undefined,

  _povAudience: true,

  chartItemViewFactory: undefined,
  shapeNodeViews: [],
  selectedNodeView: undefined,

  _touchListener: undefined,
  _touchCapturedNode: undefined,

  ctor: function () {
    this._super();

    this.width = SWChartUI.DesignWidth;
    this.height = SWChartUI.DesignHeight;

    this.setupTouchHandling();

    return true;
  },

  setupTouchHandling: function () {
    var _this = this;

    this._touchListener = cc.EventListener.create({
      event: cc.EventListener.TOUCH_ONE_BY_ONE,
      swallowTouches: true,

      // Touch begin handler
      onTouchBegan: function (touch, event) {
        if (_this.delegate && _this.delegate.ccChartQuickUpdates) {
          _this.delegate.ccChartQuickUpdates();
        }
        return _this.onTouchBegan(touch, event);
      },

      // Touch move handler
      onTouchMoved: function (touch, event) {
        _this.onTouchMoved(touch, event);
      },

      // Touch ended handler
      onTouchEnded: function (touch, event) {
        _this.onTouchEnded(touch, event);

        if (_this.delegate && _this.delegate.ccChartPauseUpdates) {
          _this.delegate.ccChartPauseUpdates();
        }
      },

      // Touch cancelled handler
      onTouchCancelled: function (touch, event) {
        _this.onTouchCancelled(touch, event);

        if (_this.delegate && _this.delegate.ccChartPauseUpdates) {
          _this.delegate.ccChartPauseUpdates();
        }
      },
    });
  },

  onTouchBegan: function (touch, event) {
    var _this = this;
    var i;
    var touchedShapeNodeView;

    if (_this.selectedNodeView !== undefined) {
      if (_this.selectedNodeView.isTouchInNode(touch)) {
        touchedShapeNodeView = _this.selectedNodeView;
      }
    }

    // Check if we hit any selected items
    if (touchedShapeNodeView === undefined) {
      for (i = _this.shapeNodeViews.length - 1; i >= 0; i--) {
        var shapeNodeView = _this.shapeNodeViews[i];
        if (shapeNodeView.isTouchInNode(touch)) {
          touchedShapeNodeView = shapeNodeView;
          break;
        }
      }
    }

    if (touchedShapeNodeView !== _this.selectedNodeView) {
      if (_this.selectedNodeView !== undefined) {
        _this.selectedNodeView.setSelected(false);
      }

      _this.selectedNodeView = touchedShapeNodeView;

      if (touchedShapeNodeView !== undefined) {
        _this.selectedNodeView.setSelected(true);
      }
    }

    // check for add node action
    if ((_this.selectedNodeView === undefined) && (touch.originalEvent.ctrlKey)) {
      var touchPoint = this.convertTouchToNodeSpace(touch);
      _this.selectedNodeView = this.addNewNodeAt(touchPoint);
      _this.selectedNodeView.setSelected(true);
    }

    if (_this.selectedNodeView !== undefined) {
      var handled = _this.selectedNodeView.onTouchBegan(touch, event);
      if (!handled) {
        _this.selectedNodeView = undefined;
      }
    }

    _this.setNodeDirty();

    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var _this = this;
    if (_this.selectedNodeView !== undefined) {
      _this.selectedNodeView.onTouchMoved(touch, event);
      _this.setNodeDirty();
    }
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    var _this = this;
    if (_this.selectedNodeView !== undefined) {
      if (this.delegate && this.delegate.shapeEditorSelectedNode) {
        this.delegate.shapeEditorSelectedNode(true);
      }

      _this.selectedNodeView.onTouchEnded(touch, event);
    } else {
      if (this.delegate && this.delegate.shapeEditorSelectedNode) {
        this.delegate.shapeEditorSelectedNode(false);
      }
    }

    _this.setNodeDirty();
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    var _this = this;
    if (_this.selectedNodeView !== undefined) {
      _this.selectedNodeView.onTouchCancelled(touch, event);
    } else {
      if (this.delegate && this.delegate.shapeEditorSelectedNode) {
        this.delegate.shapeEditorSelectedNode(false);
      }
    }

    _this.setNodeDirty();
  },

  setPovAudience: function (povAudience) {
    if (this._povAudience !== povAudience) {
      this._povAudience = povAudience;

      var povTransform;
      if (this._povAudience) {
        povTransform = cc.affineTransformMakeIdentity();
        this.setAdditionalTransform(povTransform);
      } else {
        povTransform = cc.affineTransformMakeIdentity();
        povTransform = cc.affineTransformTranslate(povTransform, this.width, this.height);
        povTransform = cc.affineTransformScale(povTransform, -1, -1);
        this.setAdditionalTransform(povTransform);
      }
    }
  },

  beginEditingShapeInView: function (chartItemShapeView) {
    var _this = this;
    this._chartItemShapeView = chartItemShapeView;
    this._chartItemShapeView.setEditing(true);

    var shapePath = this._chartItemShapeView.chartItemShape.shapepaths[0];

    this._renderCmd.drawWithCurves = ((this._chartItemShapeView.shapeType === SWChartItem.ShapeType.Curve) || (this._chartItemShapeView.shapeType === SWChartItem.ShapeType.CurveArrow));
    this._renderCmd.hasArrowHead = ((this._chartItemShapeView.shapeType === SWChartItem.ShapeType.JoinedLineArrow) || (this._chartItemShapeView.shapeType === SWChartItem.ShapeType.CurveArrow));
    this._renderCmd.lineColorCss = shapePath.lineColor;

    var shapeWidth = chartItemShapeView.width;
    var shapeHeight = chartItemShapeView.height;
    var shapeLeft = chartItemShapeView.x - (shapeWidth / 2);
    var shapeTop = chartItemShapeView.y - (shapeHeight / 2);

    var xForm = cc.affineTransformTranslate(cc.affineTransformIdentity(), chartItemShapeView.x, chartItemShapeView.y);
    xForm = cc.affineTransformRotate(xForm, -chartItemShapeView.chartItemShape.rotation);
    xForm = cc.affineTransformTranslate(xForm, -chartItemShapeView.x, -chartItemShapeView.y);
    var adjustedShapePoints = [];
    var adjustedShapePoint = cc.p();

    _.each(shapePath.points, function (shapePoint) {
      adjustedShapePoint = cc.p();
      adjustedShapePoint.x = ((shapePoint.x * shapeWidth) + shapeLeft + _this.chartItemViewFactory.scaledStagePxOffset.x);
      adjustedShapePoint.y = ((shapePoint.y * shapeHeight) + shapeTop + _this.chartItemViewFactory.scaledStagePxOffset.y);

      adjustedShapePoint = cc.pointApplyAffineTransform(adjustedShapePoint, xForm);

      adjustedShapePoint.x /= _this.width;
      adjustedShapePoint.y /= _this.height;
      adjustedShapePoints.push(cc.p(adjustedShapePoint));
    });

    // TODO: Create vector node handles from existing points
    this.shapeNodeViews = [];
    _.each(adjustedShapePoints, function (shapePoint, index) {
      var shapeNodeView = new ChartShapeVectorNodeView();
      _this.addChild(shapeNodeView);
      _this.shapeNodeViews.push(shapeNodeView);
      shapeNodeView.chartItemViewFactory = _this.chartItemViewFactory;
      shapeNodeView.setShapePoint(shapePoint);
    });

    this._renderCmd.points = adjustedShapePoints;

    // Register touch listener
    cc.eventManager.addListener(this._touchListener, this);

    // Touch handling is disabled by default
    this._touchListener.setEnabled(true);
  },

  endEditing: function () {
    var points = this._renderCmd.points;
    var minX = Number.MAX_VALUE;
    var maxX = -Number.MAX_VALUE;
    var minY = Number.MAX_VALUE;
    var maxY = -Number.MAX_VALUE;

    // Find bound of all points
    _.each(points, function (pointInArray) {
      if (pointInArray.x < minX) {
        minX = pointInArray.x;
      }
      if (pointInArray.x > maxX) {
        maxX = pointInArray.x;
      }
      if (pointInArray.y < minY) {
        minY = pointInArray.y;
      }
      if (pointInArray.y > maxY) {
        maxY = pointInArray.y;
      }
    });

    // ensure min width and height for touchability
    var minW = 20 / this.width;
    var minH = 20 / this.height;
    if ((maxX - minX) < minW) {
      minX -= minW / 2;
      maxX += minW / 2;
    }
    if ((maxY - minY) < minH) {
      minY -= minH / 2;
      maxY += minH / 2;
    }
    // Offset to 0,0
    _.each(points, function (pointInArray) {
      pointInArray.x = (pointInArray.x - minX) / (maxX - minX);
      pointInArray.y = (pointInArray.y - minY) / (maxY - minY);
    });

    // Update shape position and size
    this._chartItemShapeView.chartItemShape.positionx = (((minX + ((maxX - minX) / 2)) * this.width) - this.chartItemViewFactory.scaledStagePxOffset.x) / this.chartItemViewFactory.scalePxPerUnitX;
    this._chartItemShapeView.chartItemShape.positiony = (((minY + ((maxY - minY) / 2)) * this.height) - this.chartItemViewFactory.scaledStagePxOffset.y) / this.chartItemViewFactory.scalePxPerUnitY;
    this._chartItemShapeView.chartItemShape.sizewidth = (((maxX - minX) * this.width) - this.chartItemViewFactory.scaledStagePxOffset.x) / this.chartItemViewFactory.scalePxPerUnitX;
    this._chartItemShapeView.chartItemShape.sizeheight = (((maxY - minY) * this.height) - this.chartItemViewFactory.scaledStagePxOffset.y) / this.chartItemViewFactory.scalePxPerUnitY;

    // reset rotation to 0
    this._chartItemShapeView.chartItemShape.rotation = 0;

    // store back (update) vector nodes in the shape item
    this._chartItemShapeView.chartItemShape.shapepaths[0].points = deepClone(this._renderCmd.points);//_.clone(this._renderCmd.points);

    // stroke color
    this._chartItemShapeView.chartItemShape.shapepaths[0].lineColor = this._renderCmd.lineColorCss;

    this._chartItemShapeView.setEditing(false);

    return this._chartItemShapeView;
  },

  addNewNodeAt: function (point) {
    var shapeNodeView = new ChartShapeVectorNodeView();
    this.addChild(shapeNodeView);
    this.shapeNodeViews.push(shapeNodeView);
    shapeNodeView.chartItemViewFactory = this.chartItemViewFactory;

    var shapePoint = cc.p();
    shapePoint.x = point.x / this.width;
    shapePoint.y = point.y / this.height;
    shapeNodeView.setShapePoint(shapePoint);

    this._renderCmd.points.push(shapePoint);

    return shapeNodeView;
  },

  deleteSelectedNode: function () {
    if (this.selectedNodeView !== undefined) {
      this.removeChild(this.selectedNodeView);

      var indexToDelete = this.shapeNodeViews.indexOf(this.selectedNodeView);
      this.shapeNodeViews.splice(indexToDelete, 1);

      this._renderCmd.points.splice(indexToDelete, 1);

      var nextIndexToSelect = indexToDelete;
      if (nextIndexToSelect >= this.shapeNodeViews.length) {
        nextIndexToSelect = (this.shapeNodeViews.length - 1);
      }

      if (nextIndexToSelect > -1) {
        this.selectedNodeView = this.shapeNodeViews[nextIndexToSelect];
        this.selectedNodeView.setSelected(true);
      } else {
        this.delegate.shapeEditorSelectedNode(false);
      }
    }
  },

  setLineColorCss: function (colorCss) {
    if ((colorCss === null) || (colorCss === undefined)) {
      colorCss = this._defaultLineColorCss;
    }

    this._renderCmd.lineColorCss = colorCss;
  },

  _createRenderCmd: function () {
    return new ChartShapeVectorEditorView.CanvasRenderCmd(this);
  },
});

(function () {
  ChartShapeVectorEditorView.CanvasRenderCmd = function (renderable) {
    cc.Node.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
    this.drawWithCurves = false;
    this.hasArrowHead = false;
    this.points = [];
  };

  var proto = ChartShapeVectorEditorView.CanvasRenderCmd.prototype = Object.create(cc.Node.CanvasRenderCmd.prototype);
  proto.constructor = ChartShapeVectorEditorView.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {
    var node = this._node;

    if (this.points.length < 2) {
      return;
    }

    var wrapper = ctx || cc._renderContext;
    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    if (this.drawWithCurves) {
      this.renderingDrawConnections();
      this.renderingDrawCurves();
    } else {
      this.renderingDrawLines();
    }
  };

  proto.getStrokeWidthWithBase = function (baseWidth) {
    var strokeWidth = Math.round(baseWidth / 40 * this._node.chartItemViewFactory.scalePxPerUnitX * this._node.chartItemViewFactory.measurementConversionMultiplier);
    if (strokeWidth < 1) {
      strokeWidth = 1;
    }

    return strokeWidth;
  };

  // drawing implementation for lines
  proto.renderingDrawConnections = function () {
    var drawingUtil = cc._drawingUtil;

    var strokeWidth = this.getStrokeWidthWithBase(1);

    var node = this._node;
    var w = node.width;
    var h = node.height;
    var numPoints = this.points.length;

    drawingUtil.setStrokeColorCss('rgb(192, 192, 192)');
    drawingUtil.setLineWidth(strokeWidth);

    var vertices = [];
    for (var i = 0; i < numPoints; i++) {
      var currPoint = this.points[i];
      vertices.push(cc.p(currPoint.x * w, currPoint.y * h));
    }

    drawingUtil.drawPolyline(vertices);
  };

  // drawing implementation for lines
  proto.renderingDrawLines = function () {
    var node = this._node;
    var drawingUtil = cc._drawingUtil;

    var strokeWidth;
    if (angular.isDefined(node._chartItemShapeView.chartItemShape.linethickness)) {
      strokeWidth = this.getStrokeWidthWithBase(node._chartItemShapeView.chartItemShape.linethickness);
    } else {
      strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
    }

    var w = node.width;
    var h = node.height;
    var numPoints = this.points.length;

    drawingUtil.setStrokeColorCss(this.lineColorCss);
    drawingUtil.setFillColorCss(this.lineColorCss);
    drawingUtil.setLineWidth(strokeWidth);

    var vertices = [];
    var currentPoint;
    for (var i = 0; i < (numPoints - 1); i++) {
      currentPoint = this.points[i];
      vertices.push(cc.p(currentPoint.x * w, currentPoint.y * h));
    }

    var lastPoint = this.points[numPoints - 1];
    if (!this.hasArrowHead) {
      vertices.push(cc.p(lastPoint.x * w, lastPoint.y * h));
      drawingUtil.drawPolyline(vertices);
    } else {
      var mx = currentPoint.x * w;
      var my = currentPoint.y * h;

      var nx = lastPoint.x * w;
      var ny = lastPoint.y * h;

      var length = 6 * strokeWidth;
      var width = 3 * strokeWidth;

      var r = Math.atan2(ny - my, nx - mx);
      var bx = nx;
      var by = ny;
      var dx = bx - Math.cos(r) * length;
      var dy = by - Math.sin(r) * length;
      r += Math.PI / 2; // perpendicular to path
      var ax = dx + Math.cos(r) * width;
      var ay = dy + Math.sin(r) * width;
      var cx = dx - Math.cos(r) * width;
      var cy = dy - Math.sin(r) * width;

      vertices.push(cc.p(dx, dy));
      drawingUtil.drawPolyline(vertices);

      var arrowVertices = [];
      arrowVertices.push(cc.p(ax, ay));
      arrowVertices.push(cc.p(bx, by));
      arrowVertices.push(cc.p(cx, cy));
      drawingUtil.drawPolygon(arrowVertices, false, true);
    }
  };

  // drawing implementation for curves
  proto.renderingDrawCurves = function () {
    var node = this._node;
    var drawingUtil = cc._drawingUtil;

    var strokeWidth;
    if (angular.isDefined(node._chartItemShapeView.chartItemShape.linethickness)) {
      strokeWidth = this.getStrokeWidthWithBase(node._chartItemShapeView.chartItemShape.linethickness);
    } else {
      strokeWidth = this.getStrokeWidthWithBase(chartBaseLineWidth);
    }

    var w = node.width;
    var h = node.height;
    var numPoints = this.points.length;

    drawingUtil.setStrokeColorCss(this.lineColorCss);
    drawingUtil.setFillColorCss(this.lineColorCss);
    drawingUtil.setLineWidth(strokeWidth);

    var prevPoint;
    var midPoint = cc.p(this.points[0].x * w, this.points[0].y * h);
    var nextPoint = cc.p(this.points[1].x * w, this.points[1].y * h);
    var currPoint = cc.p((midPoint.x + nextPoint.x) / 2, (midPoint.y + nextPoint.y) / 2);
    drawingUtil.drawLine(midPoint, currPoint);
    for (var i = 2; i < numPoints; i++) {
      prevPoint = currPoint;
      midPoint = nextPoint;

      nextPoint = cc.p(this.points[i].x * w, this.points[i].y * h);
      currPoint = cc.p((midPoint.x + nextPoint.x) / 2, (midPoint.y + nextPoint.y) / 2);

      drawingUtil.drawQuadraticCurve(prevPoint, midPoint, currPoint);
    }

    if (!this.hasArrowHead) {
      drawingUtil.drawLine(currPoint, nextPoint);
    } else {
      var mx = currPoint.x;
      var my = currPoint.y;

      var nx = nextPoint.x;
      var ny = nextPoint.y;

      var length = 6 * strokeWidth;
      var width = 3 * strokeWidth;

      var r = Math.atan2(ny - my, nx - mx);
      var bx = nx;
      var by = ny;
      var dx = bx - Math.cos(r) * length;
      var dy = by - Math.sin(r) * length;
      r += Math.PI / 2; // perpendicular to path
      var ax = dx + Math.cos(r) * width;
      var ay = dy + Math.sin(r) * width;
      var cx = dx - Math.cos(r) * width;
      var cy = dy - Math.sin(r) * width;

      drawingUtil.drawLine(cc.p(mx, my), cc.p(dx, dy));

      var arrowVertices = [];
      arrowVertices.push(cc.p(ax, ay));
      arrowVertices.push(cc.p(bx, by));
      arrowVertices.push(cc.p(cx, cy));
      drawingUtil.drawPolygon(arrowVertices, false, true);
    }
  };
})();

var ChartShapeFreehandToolView = cc.Node.extend({

  _povAudience: true,

  _defaultLineColorCss: 'rgb(0,0,0)',

  chartItemViewFactory: undefined,
  shapeNodeViews: [],
  selectedNodeView: undefined,

  _touchListener: undefined,
  _touchCapturedNode: undefined,

  ctor: function () {
    this._super();

    this.width = SWChartUI.DesignWidth;
    this.height = SWChartUI.DesignHeight;

    this.setupTouchHandling();
    return true;
  },

  setupTouchHandling: function () {
    var _this = this;

    this._touchListener = cc.EventListener.create({
      event: cc.EventListener.TOUCH_ONE_BY_ONE,
      swallowTouches: true,

      // Touch begin handler
      onTouchBegan: function (touch, event) {
        if (_this.delegate && _this.delegate.ccChartQuickUpdates) {
          _this.delegate.ccChartQuickUpdates();
        }
        return _this.onTouchBegan(touch, event);
      },

      // Touch move handler
      onTouchMoved: function (touch, event) {
        _this.onTouchMoved(touch, event);
      },

      // Touch ended handler
      onTouchEnded: function (touch, event) {
        _this.onTouchEnded(touch, event);

        if (_this.delegate && _this.delegate.ccChartPauseUpdates) {
          _this.delegate.ccChartPauseUpdates();
        }
      },

      // Touch cancelled handler
      onTouchCancelled: function (touch, event) {
        _this.onTouchCancelled(touch, event);

        if (_this.delegate && _this.delegate.ccChartPauseUpdates) {
          _this.delegate.ccChartPauseUpdates();
        }
      },
    });
  },

  onTouchBegan: function (touch, event) {
    var _this = this;

    _this._renderCmd.clearLastShapePath();

    var ptInNode = _this.convertTouchToNodeSpace(touch);

    _this._renderCmd.addLastShapePathPoint(ptInNode);

    _this.setNodeDirty();

    return true;
  },

  // Touch move handler
  onTouchMoved: function (touch, event) {
    var _this = this;

    var ptInNode = _this.convertTouchToNodeSpace(touch);

    _this._renderCmd.addLastShapePathPoint(ptInNode);

    _this.setNodeDirty();
  },

  // Touch ended handler
  onTouchEnded: function (touch, event) {
    var _this = this;

    var ptInNode = _this.convertTouchToNodeSpace(touch);

    _this._renderCmd.pushAndClearLastShapePath(ptInNode);

    _this.setNodeDirty();
  },

  // Touch cancelled handler
  onTouchCancelled: function (touch, event) {
    var _this = this;

    this._renderCmd.clearLastShapePath();

    _this.setNodeDirty();
  },

  setPovAudience: function (povAudience) {
    if (this._povAudience !== povAudience) {
      this._povAudience = povAudience;

      var povTransform;
      if (this._povAudience) {
        povTransform = cc.affineTransformMakeIdentity();
        this.setAdditionalTransform(povTransform);
      } else {
        povTransform = cc.affineTransformMakeIdentity();
        povTransform = cc.affineTransformTranslate(povTransform, this.width, this.height);
        povTransform = cc.affineTransformScale(povTransform, -1, -1);
        this.setAdditionalTransform(povTransform);
      }
    }
  },

  initializeTool: function () {
    var _this = this;

    this._renderCmd.clearShapePaths();
    // this.setLineColorCss();

    // Register touch listener
    cc.eventManager.addListener(this._touchListener, this);

    // Touch handling is disabled by default
    this._touchListener.setEnabled(true);
  },

  setLineColorCss: function (colorCss) {
    if ((colorCss === null) || (colorCss === undefined)) {
      colorCss = this._defaultLineColorCss;
    }

    this._renderCmd.lineColorCss = colorCss;
  },

  getCurrentShapeItem: function () {
    var shapePaths = this._renderCmd.shapePaths;

    if (shapePaths.length === 0) {
      return;
    }

    var minX = Number.MAX_VALUE;
    var maxX = -Number.MAX_VALUE;
    var minY = Number.MAX_VALUE;
    var maxY = -Number.MAX_VALUE;

    var width = this.width;
    var height = this.height;

    _.each(shapePaths, function (shapePath) {
      // Find bound of all points
      _.each(shapePath.points, function (pointInArray) {
        // normalize point
        pointInArray.x /= width;
        pointInArray.y /= height;

        if (pointInArray.x < minX) {
          minX = pointInArray.x;
        }
        if (pointInArray.x > maxX) {
          maxX = pointInArray.x;
        }
        if (pointInArray.y < minY) {
          minY = pointInArray.y;
        }
        if (pointInArray.y > maxY) {
          maxY = pointInArray.y;
        }
      });
    });

    // Offset to 0,0
    _.each(shapePaths, function (shapePath) {
      _.each(shapePath.points, function (pointInArray) {
        pointInArray.x = (pointInArray.x - minX) / (maxX - minX);
        pointInArray.y = (pointInArray.y - minY) / (maxY - minY);
      });
    });

    // Create a new chartItemShape
    var newShapeItem = {};
    newShapeItem.itemtype = SWChartItem.Type.Shape;
    newShapeItem.shapetype = SWChartItem.ShapeType.Freehand;

    // arrowhead
    newShapeItem.hasarrowhead = this.getHasArrowhead();

    // color
    newShapeItem.linecolor = this._renderCmd.lineColorCss;

    // Update shape position and size
    newShapeItem.positionx = (((minX + ((maxX - minX) / 2)) * this.width) - this.chartItemViewFactory.scaledStagePxOffset.x) / this.chartItemViewFactory.scalePxPerUnitX;
    newShapeItem.positiony = (((minY + ((maxY - minY) / 2)) * this.height) - this.chartItemViewFactory.scaledStagePxOffset.y) / this.chartItemViewFactory.scalePxPerUnitY;
    newShapeItem.sizewidth = (((maxX - minX) * this.width) - this.chartItemViewFactory.scaledStagePxOffset.x) / this.chartItemViewFactory.scalePxPerUnitX;
    newShapeItem.sizeheight = (((maxY - minY) * this.height) - this.chartItemViewFactory.scaledStagePxOffset.y) / this.chartItemViewFactory.scalePxPerUnitY;

    // reset rotation to 0
    newShapeItem.rotation = 0;

    // store back (update) vector nodes in the shape item
    newShapeItem.shapepaths = deepClone(shapePaths);//_.clone(shapePaths);

    return newShapeItem;
  },

  clearShape: function () {
    this._renderCmd.clearShapePaths();
  },

  getHasArrowhead: function () {
    return this._renderCmd.hasArrowHead;
  },

  setHasArrowhead: function (hasArrowhead) {
    this._renderCmd.hasArrowHead = (hasArrowhead === true);
  },

  _createRenderCmd: function () {
    return new ChartShapeFreehandToolView.CanvasRenderCmd(this);
  },
});

(function () {
  ChartShapeFreehandToolView.CanvasRenderCmd = function (renderable) {
    cc.Node.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
    this.lineColorCss = '#000000';
    this.hasArrowHead = true;
    this.linethickness = chartBaseLineWidth + 2;
    this.shapePaths = [];
    this.lastShapePath = {};

    this.lastAddedPoint = {};
    this.lastProcessedPoint = {};

    this.clearShapePaths();
  };

  var proto = ChartShapeFreehandToolView.CanvasRenderCmd.prototype = Object.create(cc.Node.CanvasRenderCmd.prototype);
  proto.constructor = ChartShapeFreehandToolView.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {
    var node = this._node;
    var _this = this;

    var wrapper = ctx || cc._renderContext;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    if (this.shapePaths.length > 0) {
      this.shapePaths.forEach(function (shapePath) {
        _this.drawShapePath(shapePath);
      });
    }

    if (this.lastShapePath.points.length < 2) {
      return;
    }

    this.drawShapePath(this.lastShapePath);
  };

  proto.drawShapePath = function (shapePath) {

    var drawingUtil = cc._drawingUtil;
    var strokeWidth = this.getShapePathWidthWithBase(shapePath.linethickness);

    var numPoints = shapePath.points.length;

    drawingUtil.setStrokeColorCss(shapePath.lineColor);
    drawingUtil.setFillColorCss(shapePath.lineColor);
    drawingUtil.setLineWidth(strokeWidth);

    var originPoint = shapePath.points[0];
    var controlPoint = shapePath.points[0];
    var destPoint = cc.p((shapePath.points[0].x + shapePath.points[1].x) / 2, (shapePath.points[0].y +
      shapePath.points[1].y) / 2);
    drawingUtil.drawLine(originPoint, destPoint);
    for (var i = 1; i < (numPoints - 1); i++) {
      originPoint = destPoint;
      controlPoint = cc.p(shapePath.points[i].x, shapePath.points[i].y);
      destPoint = cc.p((shapePath.points[i].x + shapePath.points[i + 1].x) / 2, (shapePath.points[i].y +
        shapePath.points[i + 1].y) / 2);

      drawingUtil.drawQuadraticCurve(originPoint, controlPoint, destPoint);
    }
    // drawingUtil.drawLine(destPoint, shapePath.points[numPoints - 1]);

    if (!shapePath.hasArrowHead) {
      drawingUtil.drawLine(destPoint, shapePath.points[numPoints - 1]);
    } else {
      var previousPoint1 = destPoint;
      var currentPoint = shapePath.points[numPoints - 1];

      var mx = previousPoint1.x;
      var my = previousPoint1.y;

      var nx = currentPoint.x;
      var ny = currentPoint.y;

      var length = 6 * strokeWidth;
      var width = 3 * strokeWidth;

      var r = Math.atan2(ny - my, nx - mx);
      var bx = nx;
      var by = ny;
      var dx = bx - Math.cos(r) * length;
      var dy = by - Math.sin(r) * length;
      r += Math.PI / 2; // perpendicular to path
      var ax = dx + Math.cos(r) * width;
      var ay = dy + Math.sin(r) * width;
      var cx = dx - Math.cos(r) * width;
      var cy = dy - Math.sin(r) * width;

      drawingUtil.drawLine(cc.p(mx, my), cc.p(dx, dy));

      var arrowVertices = [];
      arrowVertices.push(cc.p(ax, ay));
      arrowVertices.push(cc.p(bx, by));
      arrowVertices.push(cc.p(cx, cy));
      drawingUtil.drawPolygon(arrowVertices, false, true);
    }
  };

  proto.getShapePathWidthWithBase = function (baseWidth) {
    var strokeWidth = Math.round(baseWidth / 40 * this._node.chartItemViewFactory.scalePxPerUnitX * this._node.chartItemViewFactory.measurementConversionMultiplier);
    if (strokeWidth < 1) {
      strokeWidth = 1;
    }

    return strokeWidth;
  };

  proto.pushAndClearLastShapePath = function (point) {
    if (this.lastShapePath.points.length > 2) {
      this.shapePaths.push(this.lastShapePath);
    }

    this.clearLastShapePath();
  };

  proto.clearLastShapePath = function () {
    this.lastShapePath = {
      lineColor: this.lineColorCss,
      hasArrowHead: this.hasArrowHead,
      linethickness: this._node.delegate.chartInspectorState.lineThicknessForFreehand,
      points: []
    };
    this.lastAddedPoint = {};
    this.lastProcessedPoint = {};
  };

  proto.clearShapePaths = function () {
    this.shapePaths = [];
    this.lastShapePath = {
      lineColor: this.lineColorCss,
      hasArrowHead: this.hasArrowHead,
      linethickness: this.linethickness,
      points: []
    };
  };

  proto.addLastShapePathPoint = function (point) {
    if (this.lastShapePath.points.length < 1) {
      this.lastShapePath.points.push(cc.p(point));
      this.lastAddedPoint = point;
    } else {
      var prevSegmentLength = cc.pDistance(this.lastAddedPoint, this.lastProcessedPoint);
      var currentSegmentLength = cc.pDistance(this.lastProcessedPoint, point);
      var directLength = cc.pDistance(this.lastAddedPoint, point);

      var deviation = ((prevSegmentLength + currentSegmentLength) * (prevSegmentLength + currentSegmentLength)) / (
        directLength * directLength);

      if (deviation > 1.02 || directLength > 15.0) {
        this.lastShapePath.points.push(cc.p(point));
        this.lastAddedPoint = point;
      }
    }

    this.lastProcessedPoint = point;

  };
})();

var ChartLayerSetPiece = ChartLayerBase.extend({
  ctor: function () {
    this._super();

    this.setName('ChartLayerSetPiece');

    this.setupTouchHandling();
  },

  postLoadChartItemViewHandler: function (chartItemView) {
    if (chartItemView.getBackingEntity().itemtype === SWChartItem.Type.SetPiece) {
      chartItemView.setSizeable(true);
    }
  },

  getChartLayerType: function () {
    return SWChartLayer.Type.SetPiece;
  },

  getChartItemLayerType: function () {
    return SWChartItem.LayerType.SetPiece;
  },

  snapToGrid: function (chartItemView) {
    this.disableChangeTracking();

    var centerX = chartItemView.getBackingEntity().positionx;
    var centerY = chartItemView.getBackingEntity().positiony;

    chartItemView.getBackingEntity().positionx = (Math.round(centerX / (1 / 2))) * (1 / 2);
    chartItemView.getBackingEntity().positiony = (Math.round(centerY / (1 / 2))) * (1 / 2);
    chartItemView.refresh();

    this.enableChangeTracking();
    this.notifyDidChange();
  },
});

var SetPieceEditorGridView = cc.Node.extend({
  kMinTopMargin: 16,
  kMinBottMargin: 40,
  kMinLeftMargin: 40,
  kMinRightMargin: 16,

  _maxWidth: 0,
  _maxDepth: 0,

  _scalePxPerUnitX: 1.0,
  _scalePxPerUnitY: 1.0,

  _stageViewBounds: cc.rect(),
  _scaledStageBounds: cc.rect(),

  _zoomFactor: 1.0,
  _zoomOffset: cc.p(),

  ctor: function () {
    this._super();

    this._localZOrder = -1;

    this.width = SWSetPieceUI.DesignWidth;
    this.height = SWSetPieceUI.DesignHeight;

    this._zoomFactor = 1.0;
    this._zoomOffset = cc.p(0, 0);

    this.setName('SetPieceEditorGridView');

    return true;
  },

  setMaxWidth: function (maxWidth) {
    this._maxWidth = maxWidth;
  },

  setMaxDepth: function (maxDepth) {
    this._maxDepth = maxDepth;
  },

  getScalePxPerUnitX: function () {
    return this._scalePxPerUnitX;
  },

  getScalePxPerUnitY: function () {
    return this._scalePxPerUnitY;
  },

  getStageViewBounds: function () {
    return this._stageViewBounds;
  },

  getStageViewPosition: function () {
    return cc.p(this._stageViewBounds.x, this._stageViewBounds.y);
  },

  getStageViewSize: function () {
    return cc.size(this._stageViewBounds.width, this._stageViewBounds.height);
  },

  getScaledStageBounds: function () {
    return this._scaledStageBounds;
  },

  getZoomFactor: function () {
    return this._zoomFactor;
  },

  setZoomFactor: function (zoomFactor) {
    if (zoomFactor < 1.0) {
      zoomFactor = 1.0;
    } else if (zoomFactor > 20.0) {
      zoomFactor = 20.0;
    }

    if (this._zoomFactor !== zoomFactor) {
      this._zoomFactor = zoomFactor;

      this.updateStageViewParameters();

      this.setNodeDirty();
    }
  },

  getZoomOffset: function () {
    return this._zoomOffset;
  },

  setZoomOffset: function (zoomOffset, y) {
    if (y !== undefined) {
      zoomOffset = cc.p(zoomOffset, y);
    }

    var viewWidth = this._stageViewBounds.width;
    var viewHeight = this._stageViewBounds.height;

    var zoomWidth = this._scaledStageBounds.width;
    var zoomHeight = this._scaledStageBounds.height;

    if (zoomOffset.x > 0) {
      zoomOffset.x = 0;
    } else if (zoomOffset.x < (viewWidth - zoomWidth)) {
      zoomOffset.x = viewWidth - zoomWidth;
    }

    if (zoomOffset.y > 0) {
      zoomOffset.y = 0;
    } else if (zoomOffset.y < (viewHeight - zoomHeight)) {
      zoomOffset.y = viewHeight - zoomHeight;
    }

    if (!cc.pointEqualToPoint(this._zoomOffset, zoomOffset)) {
      this._zoomOffset = cc.p(zoomOffset);

      this.setNodeDirty();
    }
  },

  getMaxStageZoom: function () {
    return (Math.floor(scaleUnitReferencePixels / this._scalePxPerUnitX * this._zoomFactor) + 2);
  },

  updateStageViewParameters: function () {
    var viewSize = this.getContentSize();

    var pxPerUnitX = (viewSize.width - (this.kMinLeftMargin + this.kMinRightMargin)) / this._maxWidth;
    this._scalePxPerUnitX = pxPerUnitX * this._zoomFactor;

    var pxPerUnitY = (viewSize.height - (this.kMinTopMargin + this.kMinBottMargin)) / this._maxDepth;
    this._scalePxPerUnitY = pxPerUnitY * this._zoomFactor;

    if (this._scalePxPerUnitX < this._scalePxPerUnitY) {
      this._scalePxPerUnitY = this._scalePxPerUnitX;
    } else {
      this._scalePxPerUnitX = this._scalePxPerUnitY;
    }

    var scaledStageSize = cc.size(this._scalePxPerUnitX * this._maxWidth, this._scalePxPerUnitY * this._maxDepth);

    this._stageViewBounds.x = this.kMinLeftMargin;
    this._stageViewBounds.y = viewSize.height - this.kMinBottMargin - scaledStageSize.height;
    this._stageViewBounds.width = scaledStageSize.width;
    this._stageViewBounds.height = scaledStageSize.height;

    this._scaledStageBounds = cc.rect(0, 0, scaledStageSize.width, scaledStageSize.height);

    // trigger a zoom offset correction if needed
    this.setZoomOffset(this._zoomOffset);
  },

  _createRenderCmd: function () {
    return new SetPieceEditorGridView.CanvasRenderCmd(this);
  },

});

(function () {
  SetPieceEditorGridView.CanvasRenderCmd = function (renderable) {
    cc.Node.CanvasRenderCmd.call(this, renderable);
    this._needDraw = true;
  };

  var proto = SetPieceEditorGridView.CanvasRenderCmd.prototype = Object.create(cc.Node.CanvasRenderCmd.prototype);
  proto.constructor = SetPieceEditorGridView.CanvasRenderCmd;

  proto.rendering = function (ctx, scaleX, scaleY) {
    var node = this._node;

    var wrapper = ctx || cc._renderContext;
    var context = wrapper.getContext();

    var drawingUtil = cc._drawingUtil;

    var i;

    wrapper.setTransform(this._worldTransform, scaleX, scaleY);

    context.scale(scaleX, scaleY);

    var stepX = 1;
    if (node._scalePxPerUnitX < 20) {
      stepX = Math.floor(20.0 / node._scalePxPerUnitX) + 1.0;
      if (((stepX / 2) * 2) !== stepX) {
        stepX++;
      }
    } else {
      stepX = Math.floor(40.0 / node._scalePxPerUnitX) + 1.0;
      if (((stepX / 2) * 2) !== stepX) {
        stepX++;
      }
    }

    var stepY = 1;
    if (node._scalePxPerUnitY < 20) {
      stepY = Math.floor(20.0 / node._scalePxPerUnitY) + 1.0;
      if (((stepY / 2) * 2) !== stepY) {
        stepY++;
      }
    } else {
      stepY = Math.floor(40.0 / node._scalePxPerUnitY) + 1.0;
      if (((stepY / 2) * 2) !== stepY) {
        stepY++;
      }
    }

    var stageTop = cc.rectGetMinY(node._stageViewBounds);
    var stageBott = cc.rectGetMaxY(node._stageViewBounds);
    var stageLeft = cc.rectGetMinX(node._stageViewBounds);
    var stageRight = cc.rectGetMaxX(node._stageViewBounds);
    var stageMidX = cc.rectGetMidX(node._stageViewBounds);

    // Clip to scrollable stage area
    wrapper.save();

    // Vertical grid
    drawingUtil.setDrawColor(170, 170, 170, 255);
    drawingUtil.setLineWidth(0.5 / scaleX);
    context.beginPath();
    for (i = stepX; i <= parseInt(node._maxWidth); i += stepX) {
      context.moveTo(stageLeft + i * node._scalePxPerUnitX, stageTop);
      context.lineTo(stageLeft + i * node._scalePxPerUnitX, stageBott);
    }
    context.stroke();

    // Horizontal grid
    context.beginPath();
    for (i = 0; i <= parseInt(node._maxDepth); i += stepY) {
      context.moveTo(stageLeft, stageBott - i * node._scalePxPerUnitY);
      context.lineTo(stageRight, stageBott - i * node._scalePxPerUnitY);
    }
    context.stroke();

    // Ruler
    // Major marks
    drawingUtil.setDrawColor(84, 84, 84, 255);
    drawingUtil.setLineWidth(2.0 / scaleX);
    context.beginPath();
    for (i = 0; i <= parseInt(node._maxWidth); i += stepX) {
      context.moveTo(stageLeft + i * node._scalePxPerUnitX, stageBott - 5);
      context.lineTo(stageLeft + i * node._scalePxPerUnitX, stageBott + 15);
    }
    for (i = 0; i <= parseInt(node._maxDepth); i += stepY) {
      context.moveTo(stageLeft - 5, stageBott - i * node._scalePxPerUnitY);
      context.lineTo(stageLeft + 5, stageBott - i * node._scalePxPerUnitY);
    }
    context.stroke();

    // Minor marks on ruler
    drawingUtil.setDrawColor(170, 170, 170, 255);
    drawingUtil.setLineWidth(2.0 / scaleX);
    context.beginPath();
    for (i = (stepX / 2); i <= node._maxWidth; i += stepX) {
      context.moveTo(stageLeft + i * node._scalePxPerUnitX, stageBott - 5);
      context.lineTo(stageLeft + i * node._scalePxPerUnitX, stageBott + 10);
    }
    for (i = (stepY / 2); i <= node._maxDepth; i += stepY) {
      context.moveTo(stageLeft - 5, stageBott - i * node._scalePxPerUnitY);
      context.lineTo(stageLeft + 2, stageBott - i * node._scalePxPerUnitY);
    }
    context.stroke();

    // Legend labels
    drawingUtil.setDrawColor(0, 0, 0, 255);
    drawingUtil.setLineWidth(0.5 / scaleX);

    context.font = '14px Arial';

    // x-axis labels
    for (i = 0; i <= node._maxWidth; i += stepX) {
      var axisLabelX = '' + i;
      var offsetForCenter = context.measureText(axisLabelX).width / 2;

      context.fillText(axisLabelX, stageLeft + i * node._scalePxPerUnitX - offsetForCenter, stageBott + 29);
    }

    // y-axis labels
    var yAdjust = 14 / 4;
    for (i = 0; i <= node._maxDepth; i += stepY) {
      var axisLabelY = i;
      var textWidth = context.measureText(axisLabelY).width;

      context.fillText(axisLabelY, stageLeft - 8 - textWidth, stageBott - i * node._scalePxPerUnitY + yAdjust);
    }

    // Hard stage edge lines
    drawingUtil.setDrawColor(84, 84, 84, 255);
    drawingUtil.setLineWidth(2.0 / scaleX);
    context.beginPath();
    context.moveTo(stageLeft, stageBott);
    context.lineTo(stageRight, stageBott);
    context.moveTo(stageLeft, stageTop);
    context.lineTo(stageLeft, stageBott);
    context.stroke();

    wrapper.restore();

    cc.g_NumberOfDraws++;
  };

})();

var SetPieceEditorLayer = cc.Layer.extend({
  ctor: function () {
    this._super();

    this.width = SWChartUI.DesignWidth;
    this.height = SWChartUI.DesignHeight;

    return true;
  },
});

var SetPieceEditorScene = cc.Scene.extend({
  setPieceEditorLayer: null,

  ctor: function () {
    this._super();

    this.setPieceEditorLayer = new SetPieceEditorLayer();
  },

  onEnter: function () {
    this._super();

    // var layerBack = new cc.LayerColor(cc.color(255, 255, 255, 255), SWChartUI.DesignWidth, SWChartUI.DesignHeight);
    // this.addChild(layerBack);

    this.setPieceEditorLayer.setLocalZOrder(-1);
    this.addChild(this.setPieceEditorLayer);
  },
});

/* global tinymce */
(function () {
  'use strict';

  angular.module('swanywhere').directive('swChartInspector', swChartInspector);

  function swChartInspector() {
    var directive = {
      restrict: 'A',
      scope: {
        state: '=',
        triggerAction: '&onAction',
        preferences: '='
      },
      controller: ChartInspectorController,
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: 'app/components/chartEditor/chartInspector.html',
    };

    return directive;
  }

  ChartInspectorController.$inject = [
    '$scope',
    'swaUi',
    '$log',
  ];

  function ChartInspectorController($scope, swaUi, $log) {
    var vm = this;

    vm.colorPickerOption = swaUi.colorPickerOption;

    vm.rotateBy = rotateBy;
    vm.resetRotation = resetRotation;

    vm.rotateHeadBy = rotateHeadBy;
    vm.resetHeadRotation = resetHeadRotation;

    vm.layerAction = layerAction;
    vm.layerToggleAction = layerToggleAction;

    vm.borderColorChanged = borderColorChanged;
    vm.fillColorChanged = fillColorChanged;
    vm.backgroundColorChanged = backgroundColorChanged;

    vm.clipboardAction = clipboardAction;

    vm.groupToggleAction = groupToggleAction;
    vm.editAction = editAction;
    vm.deleteAction = deleteAction;
    vm.clearAction = clearAction;

    vm.vectorEditorDeleteNodeAction = vectorEditorDeleteNodeAction;
    vm.vectorEditorDoneAction = vectorEditorDoneAction;

    vm.freehandToolCloseAction = freehandToolCloseAction;
    vm.freehandHasArrowheadChange = freehandHasArrowheadChange;
    vm.freehandToolSaveAction = freehandToolSaveAction;
    vm.freehandToolClearAction = freehandToolClearAction;

    vm.textEditorTextChanged = textEditorTextChanged;
    vm.textEditorDoneAction = textEditorDoneAction;

    vm.increaseLineThickness = increaseLineThickness;
    vm.decreaseLineThickness = decreaseLineThickness;
    vm.resetLineThickness = resetLineThickness;

    vm.increaseLineThicknessForFreehand = increaseLineThicknessForFreehand;
    vm.decreaseLineThicknessForFreehand = decreaseLineThicknessForFreehand;
    vm.resetLineThicknessForFreehand = resetLineThicknessForFreehand;

    vm.tinymceEditor = undefined;

    $scope.$watch('vm.state.textEditorActive', function (newVal, oldVal) {
      if (oldVal === newVal) {
        return;
      }

      if (newVal === true) {
        $scope.$applyAsync(function () {
          initRichTextEditor();
        });
      } else {
        deinitRichTextEditor();
      }
    });

    $scope.$watch('vm.state.headRotateable', function (newVal, oldVal) {
      if (newVal === true) {
        fixHeadAngle(vm.state.headRotationDeg);
      }
    });

    function invokeTriggerAction(actionData) {
      vm.triggerAction({
        action: actionData,
      });
    }

    function fixAngle(angle) {
      while (angle < 0) {
        angle += 360;
      }

      if (angle > 359) {
        angle = angle % 360;
      }

      return angle;
    }

    function rotateBy(angle) {
      vm.state.rotationDeg = fixAngle(vm.state.rotationDeg + angle);
      invokeTriggerAction({
        type: 'angle',
        value: vm.state.rotationDeg,
      });
    }

    function resetRotation() {
      vm.state.rotationDeg = 0;
      invokeTriggerAction({
        type: 'angle',
        value: vm.state.rotationDeg,
      });
    }

    function fixHeadAngle(angle) {
      if (angle < -90) {
        angle = -90;
      }

      if (angle > 90) {
        angle = 90;
      }

      if (angle === 0) {
        vm.headRotationDisplay = '0';
      } else if (angle === -90) {
        vm.headRotationDisplay = 'L';
      } else if (angle === 90) {
        vm.headRotationDisplay = 'R';
      } else if (angle < 0) {
        vm.headRotationDisplay = '' + Math.round(-angle) + 'L';
      } else if (angle > 0) {
        vm.headRotationDisplay = '' + Math.round(angle) + 'R';
      } else {
        vm.headRotationDisplay = '--';
      }

      return angle;
    }

    function rotateHeadBy(angle) {
      vm.state.headRotationDeg = fixHeadAngle(vm.state.headRotationDeg + angle);
      invokeTriggerAction({
        type: 'headangle',
        value: vm.state.headRotationDeg,
      });
    }

    function resetHeadRotation() {
      vm.state.headRotationDeg = fixHeadAngle(0);
      invokeTriggerAction({
        type: 'headangle',
        value: vm.state.headRotationDeg,
      });
    }

    function layerAction(action) {
      invokeTriggerAction({
        type: 'layer',
        value: action,
      });
    }

    var currentAction = 'begin';

    function toggleAction() {
      if (currentAction === 'begin') {
        currentAction = 'end';
      } else {
        currentAction = 'begin';
      }
    }

    function layerToggleAction() {
      toggleAction(); // Toggle the action
      invokeTriggerAction({
        type: 'layer',
        value: currentAction,
      });
    }

    function borderColorChanged(color) {
      invokeTriggerAction({
        type: 'color',
        value: {
          border: color,
        },
      });
    }

    function fillColorChanged(color) {
      invokeTriggerAction({
        type: 'color',
        value: {
          fill: color,
        },
      });
    }

    function backgroundColorChanged(color) {
      $('.inspector-texteditor-textarea').css({ 'background-color': swaUi.colorReplaceIfTransparent(color, 'rgb(255, 255, 255)') });
      invokeTriggerAction({
        type: 'color',
        value: {
          background: color,
        },
      });
    }

    function clipboardAction(action) {
      invokeTriggerAction({
        type: 'clipboard',
        value: action,
      });
    }

    function groupToggleAction() {
      invokeTriggerAction({
        type: 'group',
      });
    }

    function editAction() {
      invokeTriggerAction({
        type: 'edit',
      });
    }

    function deleteAction() {
      invokeTriggerAction({
        type: 'delete',
      });
    }

    function clearAction() {
      invokeTriggerAction({
        type: 'clear',
      });
    }

    function vectorEditorDeleteNodeAction() {
      invokeTriggerAction({
        type: 'vectorEditor',
        value: 'deleteNode',
      });
    }

    function vectorEditorDoneAction() {
      invokeTriggerAction({
        type: 'vectorEditor',
        value: 'done',
      });
    }

    function freehandToolCloseAction() {
      invokeTriggerAction({
        type: 'freehandTool',
        value: 'close',
      });
    }

    function freehandHasArrowheadChange() {
      invokeTriggerAction({
        type: 'freehandTool',
        value: 'arrowheadChange',
      });
    }

    function freehandToolSaveAction() {
      invokeTriggerAction({
        type: 'freehandTool',
        value: 'save',
      });
    }

    function freehandToolClearAction() {
      invokeTriggerAction({
        type: 'freehandTool',
        value: 'clear',
      });
    }

    function increaseLineThickness() {
      invokeTriggerAction({
        type: 'increaseThickness',
      });
    }

    function decreaseLineThickness() {
      invokeTriggerAction({
        type: 'decreaseThickness',
      });
    }

    function resetLineThickness() {
      invokeTriggerAction({
        type: 'resetThickness',
      });
    }

    function increaseLineThicknessForFreehand() {
      invokeTriggerAction({
        type: 'increaseThicknessForFreehand',
      });
    }

    function decreaseLineThicknessForFreehand() {
      invokeTriggerAction({
        type: 'decreaseThicknessForFreehand',
      });
    }

    function resetLineThicknessForFreehand() {
      invokeTriggerAction({
        type: 'resetThicknessForFreehand',
      });
    }

    function textEditorTextChanged() {
      vm.state.textBoxText = angular.element('#mce-editor-inspector-text').text();
      vm.state.textBoxRichText = cleanedTextEditorRichText(); //angular.element('#mce-editor-inspector-text').html();
      invokeTriggerAction({
        type: 'textEditor',
        value: 'textChange',
      });
    }

    function textEditorDoneAction() {
      vm.state.textBoxText = angular.element('#mce-editor-inspector-text').text();
      vm.state.textBoxRichText = cleanedTextEditorRichText(); //angular.element('#mce-editor-inspector-text').html();
      invokeTriggerAction({
        type: 'textEditor',
        value: 'done',
      });
    }

    function cleanedTextEditorRichText() {
      if (angular.isDefined(vm.tinymceEditor)) {
        return vm.tinymceEditor.getContent();
      }

      var html = angular.element('#mce-editor-inspector-text').html();
      html = html.replace(/(data-mce-.*?=.*?".*")/ig, '');
      html = html.replace(/(<br.*?>)/ig, '<br/>');

      return html;
    }

    function initRichTextEditor() {
      var id = 'mce-editor-inspector-text';
      var existingEditor = tinymce.get(id);
      if (existingEditor !== null) { // eslint-disable-line angular/definedundefined
        $log.warn('Rich editor already initialized for:', id);
        return true;
      }

      tinymce.init({
        selector: '#' + id,
        inline: true,
        inline_styles: true,
        content_editable: true,
        forced_root_block: 'div',
        invalid_elements: 'strong,em',
        force_hex_style_colors: true,
        entity_encoding: 'numeric',
        height: 100,
        plugins: [
          'textcolor',
          'paste'
        ],
        paste_as_text: true,
        toolbar1: "bold italic underline forecolor | fillcolor",
        toolbar2: "fontselect | fontsizeselect",
        font_formats: 'Liberation Sans=Liberation Sans;Liberation Mono=Liberation Mono;Liberation Serif=Liberation Serif',
        fontsize_formats: '10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 31px 32px 33px 34px 35px 36px 37px 38px 39px 40px 41px 42px 43px 44px 45px 46px 47px 48px 49px 50px 51px 52px 53px 54px 55px 56px 57px 58px 59px 60px 61px 62px 63px 64px 65px 66px 67px 68px 69px 70px 71px 72px',
        menubar: false,
        // toolbar_items_size: 'small',
        formats: {
          bold: {
            inline: 'span',
            styles: {
              'font-weight': 'bold'
            }
          },
          italic: {
            inline: 'span',
            styles: {
              'font-style': 'italic'
            }
          },
          underline: {
            inline: 'span',
            styles: {
              'text-decoration': 'underline'
            }
          },
          unbold: {
            inline: 'span',
            styles: {
              'font-weight': 'normal'
            }
          },
          unitalic: {
            inline: 'span',
            styles: {
              'font-style': 'normal'
            }
          },
          ununderline: {
            inline: 'span',
            styles: {
              'text-decoration': 'none'
            }
          },
        },
        textcolor_cols: 5,
        textcolor_rows: 6,
        textcolor_map: swaUi.textColorMap,
        setup: function (editor) {
          editor.on('Change', function (e) {
            vm.textEditorTextChanged();
          });
          editor.on('KeyUp', function (e) {
            vm.textEditorTextChanged();
          });
          editor.on('init', function (e) {
            vm.tinymceEditor = e.target;
            vm.tinymceEditor.setContent(vm.state.textBoxRichText);
            vm.tinymceEditor.focus();
            vm.tinymceEditor.selection.select(vm.tinymceEditor.getBody(), true);
            vm.tinymceEditor.selection.collapse(false);
            if (angular.isDefined(vm.state.defaultTextSettings)) {
              var defaultTextSettings = vm.state.defaultTextSettings;
              if (defaultTextSettings.bold) {
                vm.tinymceEditor.formatter.apply('bold');
              }
              if (defaultTextSettings.italic) {
                vm.tinymceEditor.formatter.apply('italic');
              }
              if (defaultTextSettings.underline) {
                vm.tinymceEditor.formatter.apply('underline');
              }
              if (defaultTextSettings.fontColor) {
                vm.tinymceEditor.formatter.apply('forecolor', { value: defaultTextSettings.fontColor });
              }
              if (defaultTextSettings.fontSize) {
                vm.tinymceEditor.formatter.apply('fontsize', { value: defaultTextSettings.fontSize + 'px' });
              }
              if (defaultTextSettings.fontFamily) {
                vm.tinymceEditor.formatter.apply('fontname', { value: defaultTextSettings.fontFamily });
              }
            }
            if (angular.isDefined(vm.state.selectionBackgroundColor)) {
              $('.inspector-texteditor-textarea').css({ 'background-color': swaUi.colorReplaceIfTransparent(vm.state.selectionBackgroundColor, 'rgb(255, 255, 255)') });
            }
          });
          editor.on('PostProcess', function (e) {
            e.content = e.content.replace('&#65279;', '');
          });
          editor.addButton('fillcolor', {
            icon: 'fill',
            tooltip: 'Fill Color',
            onpostrender: setupEditorFillColorButton
          });
        },
      });
    }

    function setupEditorFillColorButton() {
      var buttonEl = this.getEl();
      var options = angular.copy(swaUi.colorPickerOption);
      options.change = function (color) {
        backgroundColorChanged(color.toRgbString());
      };
      options.hide = function () {
        tinyMCE.activeEditor.focus();
      };
      $(buttonEl).spectrum(options);
      $(buttonEl).spectrum("set", vm.state.selectionBackgroundColor);
    }

    function deinitRichTextEditor() {
      tinymce.remove(vm.tinymceEditor);
      vm.tinymceEditor = undefined;
    }
  }
}());

(function () {
  'use strict';

  angular.module('swanywhere').directive('swChartFooter', swChartFooter);

  function swChartFooter() {
    var directive = {
      restrict: 'EA',
      scope: {
        access: '=',
        production: '=',
        scene: '=',
        chart: '=',
        activeAccessRules: '=',
        xReadOnly: '=',
        chartEditorState: '=',
        deletedChartListMode: '=',
        startAutoSaveTimer: '&',
        killAutoSaveTimer: '&',
      },
      controller: ChartFooterController,
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: 'app/components/chartEditor/chartFooter.html',
    };

    return directive;
  }

  ChartFooterController.$inject = ['$scope', 'swaUi', '$log'];

  function ChartFooterController($scope, swaUi, $log) {
    var vm = this;

    vm.chartEditorState.notesEditorActive = false;

    vm.chartNumberAutomatic = true;
    vm.activateNotesEditor = activateNotesEditor;
    vm.updateChartNotes = updateChartNotes;

    initChartNotesRichTextEditor();

    function activateNotesEditor($event) {
      if (vm.chartEditorState.notesEditorActive || !vm.scene.accessRules.allowchartediting || vm.xReadOnly) {
        return;
      }

      $event.preventDefault();
      $event.stopPropagation();

      var id = 'mce-editor-chart-notes-text';
      var existingEditor = tinymce.get(id);

      if (existingEditor !== null) {
        existingEditor.show();
        existingEditor.focus();
        vm.chartEditorState.notesEditorActive = true;
      }
    }

    // chart notes rich text logic
    function initChartNotesRichTextEditor() {
      var id = 'mce-editor-chart-notes-text';
      var existingEditor = tinymce.get(id);
      if (existingEditor !== null) { // eslint-disable-line angular/definedundefined
        $log.warn('Rich editor already initialized for:', id);
        return true;
      }

      /* jshint ignore:start */
      tinymce.init({
        selector: '#' + id,
        inline: true,
        inline_styles: true,
        content_editable: true,
        forced_root_block: 'div',
        invalid_elements: 'strong,em',
        force_hex_style_colors: true,
        entity_encoding: 'numeric',
        height: 100,
        plugins: [
          'textcolor',
          'paste'
        ],
        paste_as_text: true,
        toolbar: 'bold italic underline forecolor | fontselect | fontsizeselect',
        font_formats: 'Liberation Sans=Liberation Sans;Liberation Mono=Liberation Mono;Liberation Serif=Liberation Serif',
        fontsize_formats: '10px 11px 12px 13px 14px 15px 16px 17px 18px 19px 20px 21px 22px 23px 24px 25px 26px 27px 28px 29px 30px 31px 32px 33px 34px 35px 36px 37px 38px 39px 40px 41px 42px 43px 44px 45px 46px 47px 48px 49px 50px 51px 52px 53px 54px 55px 56px 57px 58px 59px 60px 61px 62px 63px 64px 65px 66px 67px 68px 69px 70px 71px 72px',
        menubar: false,
        toolbar_items_size: 'small',
        formats: {
          bold: {
            inline: 'span',
            styles: {
              'font-weight': 'bold'
            }
          },
          italic: {
            inline: 'span',
            styles: {
              'font-style': 'italic'
            }
          },
          underline: {
            inline: 'span',
            styles: {
              'text-decoration': 'underline'
            }
          },
        },
        setup: function (editor) {
          editor.on('Change', function (e) {
            $scope.$applyAsync(function () {
              updateChartNotes(editor);
            });
          });
          editor.on('KeyUp', function (e) {
            $scope.$applyAsync(function () {
              updateChartNotes(editor);
            });
          });
          editor.on('Blur', function (e) {
            $scope.$applyAsync(function () {
              deactivateChartNotesEditor(editor);
              vm.startAutoSaveTimer();
            });
          });
          editor.on('init', function (e) {
            $scope.$applyAsync(function () {
              updateChartNotesRichTextEditor();
            });
            // vm.tinymceEditor = e.target;
            // e.target.setContent(vm.state.textBoxRichText, {format: 'raw'});
            // e.target.focus();
          })
        },
        textcolor_cols: 5,
        textcolor_rows: 6,
        textcolor_map: swaUi.textColorMap,
      });
      /* jshint ignore:end */
    }

    function updateChartNotesRichTextEditor() {
      var id = 'mce-editor-chart-notes-text';
      var existingEditor = tinymce.get(id);

      if (existingEditor !== null) {
        if (angular.isDefined(vm.chart)) {
          if (angular.isString(vm.chart.notes)) {
            $(existingEditor.targetElm).html(vm.chart.notes);
            existingEditor.load();
            // existingEditor.setContent(vm.chart.notes, {
            //   format: 'raw'
            // });
          } else {
            existingEditor.setContent('');
          }

          if (vm.activeAccessRules.allowchartediting) {
            existingEditor.setMode('code');
          } else {
            existingEditor.setMode('readonly');
          }
        } else {
          existingEditor.setMode('readonly');
        }

        deactivateChartNotesEditor(existingEditor);
        vm.chartEditorState.notesEditorActive = false;
        // existingEditor.hide();
        // $(existingEditor.targetElm).blur();
      } else {
        initChartNotesRichTextEditor();
      }
    }

    function updateChartNotes(editor) {
      if (angular.isDefined(vm.chart)) {
        // $scope.$applyAsync(function () {
        vm.chart.notes = editor.getContent();
        vm.chart.dirty = true;
        // markChartDirty();
        // });
      }
    }

    function deactivateChartNotesEditor(editor) {
      if (angular.isUndefined(editor)) {
        var id = 'mce-editor-chart-notes-text';
        editor = tinymce.get(id);
      }

      if ((editor !== null) && !editor.isHidden()) {
        editor.hide();
        vm.chartEditorState.notesEditorActive = false;
      }

      $('#mce-editor-chart-notes-text').blur();
    }

    function destroyChartNotesRichTextEditor() {
      var id = 'mce-editor-chart-notes-text';
      var existingEditor = tinymce.get(id);
      if (existingEditor !== null) { // eslint-disable-line angular/definedundefined
        tinymce.remove(existingEditor);
      }
    }

    $scope.$watch('vm.production', function (newValue, oldValue) {
        if ((oldValue !== newValue) && angular.isDefined(newValue)) {
          vm.productionLogoSet = (angular.isString(newValue.logo) && (newValue.logo.length > 0));
          vm.chartNumberAutomatic = (newValue.chartnumberautomatic === true);
        }
      }, true);

    $scope.$on('chartEditor.chartChanged', function () {
      if (angular.isDefined(vm.chart)) {
        updateChartNotesRichTextEditor()
      } else {
        deactivateChartNotesEditor();
      }
    });

    $scope.$on('$destroy', function () {
      destroyChartNotesRichTextEditor();
    });
  }
}());

// jshint maxparams: false
/* global Q */
(function () {
  'use strict';

  angular.module('swanywhere').controller('ChartEditorLinkController', ChartEditorLinkController);

  ChartEditorLinkController.$inject = [
    '$scope',
    '$stateParams',
    'swaUtils',
    '$log',
    'DbSubMgrService',
    'ngProgressLite',
    'blockUI',
    '$translate',
    'swaRouterStateNames',
    '$sessionStorage',
    '$q',
    'toastr'
  ];

  function ChartEditorLinkController($scope, $stateParams, swaUtils, $log, DbSubMgrService,
    ngProgressLite, blockUI, $translate, swaRouterStateNames, $sessionStorage, $q, toastr) {
    var vm = this;
    var selectedProductionId;
    var chartId;
    var productionId;


    initialize();

    function initialize() {
      $sessionStorage.clSelectedProductionId = null;
      $sessionStorage.clSelectedChartId = null;

      try {
        $sessionStorage.clSelectedProductionId = atob($stateParams.productionId);
        $sessionStorage.clSelectedChartId = atob($stateParams.chartId);
      } catch (error) {
        swUtils.stateGoLocationReplace(swaRouterStateNames.login);
        return;
      }

      sessionCheckAndRun();
    }

    function sessionCheckAndRun() {
      blockUI.start();

      DbSubMgrService.validateSession()
        .then(function (valid) {
          if (valid) {
            // run();
            swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          } else {
            toastr.info(
              $translate.instant('messages.Please login to view the chart.'),
              $translate.instant('messages.No Session!')
            );
          }
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Something went wrong!')
          );
          $log.error('ChartEditorLinkController.sessionCheckAndRun:', error);
        })
        .finally(function () {
          blockUI.reset();
        });
    }

    function run() {
      ngProgressLite.start();
      blockUI.start();

      DbSubMgrService.validateActivePlan()
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();
        })
        .then(function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        })
        .then(function () {
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          return;
        })
        .then(null, null, function (progress) {
          ngProgressLite.set(progress);
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
          $log.error('ChartEditorLinkController.sessionCheckAndRun:', error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }
    function isBase64(str) {
      try {
        return btoa(atob(str)) == str;
      } catch (err) {
        return false;
      }
    }
  }
}());

// jshint maxparams: false
/* global Q, cc, ChartGridView, ChartLayerPermanent, ChartLayerSemiPermanent,
 ChartLayerDynamic, ChartLayerUser, ChartItemViewFactory, SWChartUI, SWChartLayer, ChartEditorScene,
 ChartShapeVectorEditorView, _, ChartShapeFreehandToolView, SWChartItem, tinymce */
(function () {
  'use strict';

  angular.module('swanywhere').controller('ChartEditorController', ChartEditorController);

  ChartEditorController.$inject = [
    '$window',
    '$scope',
    '$cookies',
    '$stateParams',
    'swaUtils',
    'toastr',
    'DbCharts',
    'DbScenes',
    'DbProductions',
    '$log',
    'DbSubMgrService',
    'ngProgressLite',
    'blockUI',
    'DbPerformers',
    '$timeout',
    'DbSetPieces',
    'DbChartItems',
    '$translate',
    '$uibModal',
    '$interval',
    '$document',
    'swaRouterStateNames',
    'DbCollaborationPrivileges',
    'swaAccess',
    'swaConfig',
    'swaUi',
    '$localStorage',
    'swPdfPrintService',
    '$q',
    'DbScripts',
    'DbUserCharts',
    'DbUserProductions',
    'DbStaffs',
    'DbScriptPages',
    'staffTemplatesService',
    'DbChartsArchive',
    '$location',
    'DbUser'
  ];

  function ChartEditorController($window, $scope, $cookies, $stateParams, swaUtils, toastr,
    DbCharts, DbScenes, DbProductions, $log, DbSubMgrService, ngProgressLite, blockUI,
    DbPerformers, $timeout, DbSetPieces, DbChartItems, $translate,
    $uibModal, $interval, $document, swaRouterStateNames, DbCollaborationPrivileges,
    swaAccess, swaConfig, swaUi, $localStorage, swPdfPrintService, $q, DbScripts, DbUserCharts, DbUserProductions, DbStaffs, DbScriptPages, staffTemplatesService,
    DbChartsArchive, $location, DbUser) {
    var vm = this;
    var selectedProductionId;

    var dbProductions = new DbProductions();
    var dbPerformers = new DbPerformers();
    var dbSetPieces = new DbSetPieces();
    var dbScenes = new DbScenes();
    var dbCharts = new DbCharts();
    var dbChartItems = new DbChartItems();
    var dbUserCharts = new DbUserCharts();
    var dbUser = new DbUser();
    var dbUserProductions = new DbUserProductions();
    var dbChartsArchive = new DbChartsArchive();
    var dbCollaborationPrivileges = new DbCollaborationPrivileges();
    var dbStaffs = new DbStaffs();
    var dbScriptPages = new DbScriptPages();
    var dbScripts = new DbScripts();
    var ccRootScene;
    var ccChartEditorLayer;

    var chartBlockUI = blockUI.instances.get('block-ui-chart');

    var defaultDenyAccessRules = {
      allowowneraccess: false,
      allowchartediting: false,
      allowaddchart: false,
      allowzoomchange: false,
      allowsceniclayerselect: false,
      allowperformerlayerselect: false,
      allowaddshapes: false,
      allowaddsetpieces: false,
      allowaddcharttext: false,
      allowaddcharttextpersonal: false,
      allowaddperformers: false,
      allowaddvideos: false,
      allowaddchartnotes: false,
      allowundo: false,
      allowredo: false,
      allowcharttoolsselect: false,
      allowmovechartsource: false,
      allowdeletechart: false,
      allowmovechartdestination: false,
    };

    var defaultViewAccessRules = {
      allowowneraccess: false,
      allowchartediting: false,
      allowaddchart: false,
      allowzoomchange: true,
      allowsceniclayerselect: false,
      allowperformerlayerselect: false,
      allowaddshapes: false,
      allowaddsetpieces: false,
      allowaddcharttext: false,
      allowaddcharttextpersonal: false,
      allowaddperformers: false,
      allowaddvideos: false,
      allowaddchartnotes: false,
      allowundo: false,
      allowredo: false,
      allowcharttoolsselect: false,
      allowmovechartsource: false,
      allowdeletechart: false,
      allowmovechartdestination: false,
    };

    var defaultOwnerAccessRules = {
      allowowneraccess: true,
      allowchartediting: true,
      allowaddchart: true,
      allowzoomchange: true,
      allowsceniclayerselect: true,
      allowperformerlayerselect: true,
      allowaddshapes: true,
      allowaddsetpieces: true,
      allowaddcharttext: true,
      allowaddcharttextpersonal: false,
      allowaddperformers: true,
      allowaddvideos: true,
      allowaddchartnotes: true,
      allowundo: true,
      allowredo: true,
      allowcharttoolsselect: true,
      allowmovechartsource: true,
      allowdeletechart: true,
      allowmovechartdestination: true,
    };

    var selectedIndexForDeleteAndMove = null;

    vm.movingSingleChart = undefined;
    vm.movingSingleChartOperationToggle = undefined;
    vm.sourceSceneId = null;
    vm.sourceSceneForMove = undefined;
    vm.moveChartAtSpecificIndex = false;
    vm.chartIdsToMoveAtSpecificIndex = [];
    vm.deleteMultipleCharts = false;

    vm.userData = {};
    vm.userId = '';

    vm.swaRouterStateNames = swaRouterStateNames;

    vm.showHelpBar = false;
    vm.helpTourSteps = [];
    vm.helpTourVideos = [];

    vm.SWChartItem = SWChartItem;

    vm.selectedProduction = {};
    vm.performers = [];
    vm.setPieces = [];
    vm.stockSetPieces = [];
    vm.scenes = undefined;

    vm.deletedChartListMode = false;
    vm.restoringSingleChart = false;
    vm.chartVersionIdToRestore = undefined;

    // selected scene
    vm.selectedSceneId = undefined;
    vm.selectedScene = undefined;

    // Selected chart
    vm.selectedChart = undefined;
    vm.selectedChartIndex = -1;

    vm.selectedUserChart = undefined;

    vm.selectedPerformers = [];
    vm.performerPairsWithIdsForUndo = $localStorage.performerPairsWithIdsForUndo || undefined;

    vm.sidebarEditState = {
      enabled: false,
      selectionCount: 0,
      destinationSelectVisible: false,
      destinationSelectForMove: false,
      destinationSelectForRestore: false,
      destinationModeTitle: '',
    };

    vm.sidebarSortableOptions = {
      // handle: '.sortDragHandle',
      // cursor: 'ns-resize',
      handle: '.chart-item-block',
      axis: 'y',
      opacity: 0.8,
      disabled: true,
      tolerance: "pointer",
      start: hideSideBarDeleteAndMoveOptions,
      stop: sidebarDragSortStop,
    };

    vm.zoomSliderOptions = {
      floor: 1,
      ceil: 1,
      step: 1,
      showTicks: true,
      onChange: onZoomSliderChange,
    }

    vm.chartTextEditorState = {
      editorPosX: 0,
      editorPosY: 0,
      editorHeight: 0,
      editorWidth: 0,
      rotationAngle: 0,
      editorScale: 0
    }

    vm.chartEditorState = {
      ccInitializationPending: true,
      chartOpen: false,
      layerActive: false,
      semiLayerActive: false,
      dynLayerActive: false,
      userLayerActive: false,
      zoomFactor: 1,
      maxZoomFactor: 1,
      minHZoomOffset: 0,
      maxHZoomOffset: 100,
      hZoomOffset: 0,
      chartNumberAutomatic: true,
      povAudience: true,
      povOverride: false,
      performerPickerDocked: false,
      performerPickerDockedOpen: false,
      inspectorVisible: true,
      lockModeNavigation: false,
      justOpened: true,
      notesEditorActive: false,
      mediaDrawerOpen: false,
      versionsBrowserActive: false,
    };

    /** Position and visibility state of the chart context menu */
    vm.chartContextMenuState = {
      visible: false,
      posX: 0,
      posY: 0
    };

    vm.pinnedPosXOfContextMenu =
      $localStorage.pinnedPosXOfContextMenu !== null && angular.isDefined($localStorage.pinnedPosXOfContextMenu)
        ? $localStorage.pinnedPosXOfContextMenu
        : undefined;

    vm.pinnedPosYOfContextMenu =
      $localStorage.pinnedPosYOfContextMenu !== null && angular.isDefined($localStorage.pinnedPosYOfContextMenu)
        ? $localStorage.pinnedPosYOfContextMenu
        : undefined;

    vm.chartSidebarDeleteAndMoveOptionState = {
      visible: false,
      posX: 0,
      posY: 0
    };

    vm.chartSidebarEditOptionState = {
      visible: false,
    };

    vm.chartInspectorState = {
      selectionCount: -1,
      selectionGrouped: false,
      selectionRotatable: false,
      rotationRad: 0,
      rotationDeg: 0,
      selectionOrderingMode: false,
      selectionEditable: false,
      zIndex: -1,
      selectionColorable: false,
      selectionColor: undefined,
      selectionFillColorable: false,
      selectionFillColor: undefined,
      selectionRotateable: false,
      vectorEditorActive: false,
      vectorEditorNodeSelected: false,
      freehandToolActive: false,
      layerEditorActive: false,
      freehandHasArrowhead: true,
      selectionFlipAble: false,
      selectionRotationMode: false,
      alignMenu: false,
      selectionSnapToGrid: false,
      isContextMenuPinned: $localStorage.isContextMenuPinned || false,
      textEditorActive: false,
      performerSelected: false,
      performersCount: 0,
      setPieceSelected: false,
      shapesSelected: false,
      lineThickness: 0,
      lineThicknessForFreehand: chartBaseLineWidth + 2,
      showLineThicknessForFreehand: ((chartBaseLineWidth + 2) / 2) + 1,
    };

    vm.scrollConfigSidebar = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollInertia: 0,
      scrollButtons: {
        enable: false,
      },
      mouseWheel: {
        scrollAmount: 50,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
      callbacks: {
        // whileScrolling: updateStickySceneHeader,
        whileScrolling: function () {
          updateStickySceneHeader();
          hideSideBarDeleteAndMoveOptions();
        },
        onScroll: updateStickySceneHeader,
      }
    };

    vm.scrollConfigGenericPopover = {
      theme: 'swa-minimal',
      axis: 'y',
      scrollbarPosition: 'outside',
      scrollButtons: {
        enable: false,
      },
      autoHideScrollbar: true,
      advanced: {
        updateOnContentResize: true,
      },
    };

    vm.scrollConfigChartPanV = {
      theme: 'swa-chart',
      axis: 'y',
      scrollbarPosition: 'inside',
      scrollButtons: {
        enable: false,
        scrollAmount: 50,
        scrollType: 'stepped',
      },
      autoHideScrollbar: false,
      advanced: {
        updateOnContentResize: false,
      },
      callbacks: {
        whileScrolling: function () {
          onChartPanVScroll(this.mcs.topPct); // eslint-disable-line angular/controller-as-vm
        },
        onScroll: function () {
          onChartPanVScroll(this.mcs.topPct); // eslint-disable-line angular/controller-as-vm
        },
      },
    };

    vm.scrollConfigChartPanH = {
      theme: 'swa-chart',
      axis: 'x',
      scrollbarPosition: 'inside',
      scrollButtons: {
        enable: false,
        scrollAmount: 50,
        scrollType: 'stepped',
      },
      autoHideScrollbar: false,
      advanced: {
        updateOnContentResize: false,
        autoExpandHorizontalScroll: 3,
      },
      callbacks: {
        whileScrolling: function () {
          onChartPanHScroll(this.mcs.leftPct); // eslint-disable-line angular/controller-as-vm
        },
        onScroll: function () {
          onChartPanHScroll(this.mcs.leftPct); // eslint-disable-line angular/controller-as-vm
        },
      },
    };

    vm.chartPanScrollParams = {
      vertical: {
        containerTopOffset: 0,
        containerHeight: 0,
        contentHeight: 0,
      },
      horizontal: {
        containerLeftOffset: 0,
        containerWidth: 0,
        contentWidth: 0,
      },
    };

    vm.activeCollaborationConfig = {};
    vm.activeAccessRules = {};
    vm.activePlanRules = {
      planId: -1,
      allowUnlimitedPerformers: false,
      allowedNumberOfPerformers: 0,
      allowUnlimitedScenes: false,
      allowedNumberOfScenes: 0,
      allowUnlimitedCharts: false,
      allowedNumberOfCharts: 0,
    };

    vm.defaultChartTextSettings = {};

    var chartVersionBrowserState = {
      /** Is feature enabled */
      enabled: false,
      /** Is browser currently active */
      active: false,
      /** All available versions of the current chart including current (at index 0) */
      chartVersions: [],
      /** Currently selected Chart version */
      selectedVersion: null,
      /** Currently selected version index
       *
       * Versions starts from 1, index 0 is current version
       */
      selectedIndex: 0,
      /** Max index for selection */
      maxIndex: 0,
      /** The total number of versions available */
      totalVersions: 0,
      /** Is a previous (more recent) version available */
      prevEnabled: false,
      /** Is next (more older) version available */
      nextEnabled: false,
    }
    vm.chartVersionBrowserState = chartVersionBrowserState;

    vm.dummyScenesForRemovedCharts = [{
      productionId: 'dummy-removed-charts',
      scenename: 'Recent',
      orderingindex: -2,
      open: false,
      _id: 'dummyscene-2',
      charts: [],
      accessRules: {
        allowowneraccess: true,
        allowchartediting: false,
        allowaddchart: false,
        allowzoomchange: true,
        allowsceniclayerselect: false,
        allowperformerlayerselect: false,
        allowaddshapes: false,
        allowaddsetpieces: false,
        allowaddcharttext: false,
        allowaddcharttextpersonal: false,
        allowaddperformers: false,
        allowaddvideos: false,
        allowaddchartnotes: false,
        allowundo: false,
        allowredo: false,
        allowcharttoolsselect: false,
        allowmovechartsource: false,
        allowdeletechart: false,
        allowmovechartdestination: false,
      }
    }, {
      productionId: 'dummy-removed-charts',
      scenename: 'Older',
      orderingindex: -1,
      open: false,
      _id: 'dummyscene-1',
      charts: [],
      accessRules: {
        allowowneraccess: true,
        allowchartediting: false,
        allowaddchart: false,
        allowzoomchange: true,
        allowsceniclayerselect: false,
        allowperformerlayerselect: false,
        allowaddshapes: false,
        allowaddsetpieces: false,
        allowaddcharttext: false,
        allowaddcharttextpersonal: false,
        allowaddperformers: false,
        allowaddvideos: false,
        allowaddchartnotes: false,
        allowundo: false,
        allowredo: false,
        allowcharttoolsselect: false,
        allowmovechartsource: false,
        allowdeletechart: false,
        allowmovechartdestination: false,
      }
    }];

    vm.scalePerformers = {
      allPerformers: (angular.isDefined($localStorage.scaleAllPerformers)) ? $localStorage.scaleAllPerformers : false,
      selectedPerformers: (angular.isDefined($localStorage.scaleSelectedPerformers)) ? $localStorage.scaleSelectedPerformers : true,
    }

    vm.searchStringUpperForSetpice = '';
    vm.searchpersetpiece = '';
    vm.searchStringUpperForPerformer = '';
    vm.searchperformername = '';

    vm.zoomPicker = {};
    vm.shapePicker = {};
    vm.setPiecePicker = {};
    vm.performerPicker = {};
    vm.notesPicker = {};

    vm.canAddChartCopy = canAddChartCopy;
    vm.toggleScene = toggleScene;
    vm.toggleRemovedChartsScene = toggleRemovedChartsScene;
    vm.sidebarSelectChartAtIndex = sidebarSelectChartAtIndex;
    vm.sidebarSelectDeletedChartAtIndex = sidebarSelectDeletedChartAtIndex;
    vm.toggleSidebarEditMode = toggleSidebarEditMode;
    vm.sidebarShowDestinationSceneListForMove = sidebarShowDestinationSceneListForMove;
    vm.sidebarShowDestinationSceneListForRestore = sidebarShowDestinationSceneListForRestore;
    vm.sidebarEditSelectDestinationSceneAtIndex = sidebarEditSelectDestinationSceneAtIndex;
    vm.selectChart = selectChart;
    vm.selectChartById = selectChartById;
    vm.deleteSelectedCharts = deleteSelectedCharts;
    vm.addNewChart = addNewChart;
    vm.switchEditor = switchEditor;
    vm.toggleSemiLayer = toggleSemiLayer;
    vm.toggleDynLayer = toggleDynLayer;
    vm.toggleToolbarVisibility = toggleToolbarVisibility;
    vm.shapePickerDidPickShape = shapePickerDidPickShape;
    vm.showPerformerPicker = showPerformerPicker;
    vm.showMediaEditPrompt = showMediaEditPrompt;
    vm.dockPerformerPicker = dockPerformerPicker;
    vm.floatPerformerPicker = floatPerformerPicker;
    vm.performerPickerDidPickPerformer = performerPickerDidPickPerformer;
    vm.setPiecePickerDidPickSetPiece = setPiecePickerDidPickSetPiece;
    vm.addChartText = addChartText;
    vm.addChartTextPersonal = addChartTextPersonal;
    vm.onInspectorAction = onInspectorAction;
    vm.toggleChartNotes = toggleChartNotes;
    vm.onZoomChangeEnd = onZoomChangeEnd;
    vm.updateInspectorState = updateInspectorState;
    vm.editVectorShape = editVectorShape;
    vm.endEditVectorShape = endEditVectorShape;
    vm.shapeEditorSelectedNode = shapeEditorSelectedNode;
    vm.editTextBox = editTextBox;
    vm.openMedia = openMedia;
    vm.endEditTextBox = endEditTextBox;
    vm.markChartDirty = markChartDirty;
    vm.printPdf = printPdf;
    vm.handleChartPanBegin = handleChartPanBegin;
    vm.handleChartPanPan = handleChartPanPan;
    vm.handleChartPanEnd = handleChartPanEnd;
    vm.chartNotifyDataDidChange = chartNotifyDataDidChange;
    vm.chartNotifyDisableChangeTracking = chartNotifyDisableChangeTracking;
    vm.chartNotifyEnableChangeTracking = chartNotifyEnableChangeTracking;
    vm.undoAction = undoAction;
    vm.redoAction = redoAction;
    vm.onSaveClick = onSaveClick;

    vm.toggleLockModeNavigation = toggleLockModeNavigation;
    vm.lockNavigationPreviousScene = lockNavigationPreviousScene;
    vm.lockNavigationPreviousChart = lockNavigationPreviousChart;
    vm.lockNavigationNextChart = lockNavigationNextChart;
    vm.lockNavigationNextScene = lockNavigationNextScene;

    vm.chartVersionPrevious = chartVersionPrevious;
    vm.chartVersionNext = chartVersionNext;
    vm.selectChartVersionToPreview = selectChartVersionToPreview;

    vm.enterDeletedChartList = enterDeletedChartList;
    vm.leaveDeletedChartList = leaveDeletedChartList;

    vm.ccChartPauseUpdates = ccChartPauseUpdates;
    vm.ccChartQuickUpdates = ccChartQuickUpdates;
    vm.ccChartUpdateNow = ccChartUpdateNow;
    vm.ccForceSizeUpdate = ccForceSizeUpdate;
    vm.toggleMediaDock = toggleMediaDock;
    vm.mediaDockState = {
      viewState: true
    };
    vm.deleteMedia = deleteMedia;
    vm.toggleEditMediaState = toggleEditMediaState;
    vm.resetMediaDockState = resetMediaDockState;
    // vm.copyLink = copyLink;
    vm.copyChartImageToClipboard = copyChartImageToClipboard;
    vm.PdfPrintTypes = swPdfPrintService.PdfPrintTypes;
    vm.userProductionPreferences = {};
    vm.navigationLinksOptions = {};
    vm.navigationLockedModeLinksOptions = {};
    vm.defaultChartTextSettings = {};

    vm.canvasContainerClick = canvasContainerClick;
    vm.canvasContainerClickDown = canvasContainerClickDown;
    vm.hideChartContextMenu = hideChartContextMenu;
    vm.onContextMenuDragStop = onContextMenuDragStop;

    vm.showSideBarDeleteAndMoveOptions = showSideBarDeleteAndMoveOptions;
    vm.hideSideBarDeleteAndMoveOptions = hideSideBarDeleteAndMoveOptions;
    vm.toggleSideBarDeleteAndMoveOptions = toggleSideBarDeleteAndMoveOptions;

    vm.showSidebarEditModeOptions = showSidebarEditModeOptions;
    vm.hideSidebarEditModeOptions = hideSidebarEditModeOptions;
    vm.toggleSidebarEditModeOptions = toggleSidebarEditModeOptions;

    // vm.clearAllChartEditModeSelections = clearAllChartEditModeSelections;

    vm.moveSingleChart = moveSingleChart;
    vm.deleteSingleChart = deleteSingleChart;

    vm.restoreSingleChart = restoreSingleChart;
    vm.restoreChart = restoreChart;

    vm.toggleSidebarEditModeForChart = toggleSidebarEditModeForChart;

    vm.toggleToolbarVisibilityPromt = toggleToolbarVisibilityPromt;
    vm.deleteChartPrompt = deleteChartPrompt;
    vm.deleteMoveOptionHintPrompt = deleteMoveOptionHintPrompt;

    vm.pdfPrintOptionPrompt = pdfPrintOptionPrompt;
    vm.performerTrackReassignmentPrompt = performerTrackReassignmentPrompt;
    vm.undoReassignmentPrompt = undoReassignmentPrompt;

    vm.updateScalePerformers = updateScalePerformers;

    vm.clearSearchForSetpice = clearSearchForSetpice;
    vm.searchStringChangedForSetpice = searchStringChangedForSetpice;
    vm.setpieceSearchFilter = setpieceSearchFilter;
    vm.clearSearchForPerformer = clearSearchForPerformer;
    vm.searchStringChangedForPerformer = searchStringChangedForPerformer;
    vm.performerSearchFilter = performerSearchFilter;

    vm.refreshPerformersOnTheChart = refreshPerformersOnTheChart;

    vm.startAutoSaveTimer = startAutoSaveTimer;
    vm.killAutoSaveTimer = killAutoSaveTimer;

    vm.autoSaveState = {
      timeoutMaxSec: 60,
      timeoutPollIntervalSec: 1,
      timeoutDecaySec: 5,
      timeoutRemainingSec: 0,
      timerActive: false,
      saveActive: false
    };

    var PerformerOptions = Object.freeze({
      All: 'all',
      Selected: 'selected',
      None: 'none'
    });

    initialize();

    function initialize() {
      $cookies.put('currentEditorStateName', swaUtils.getRouterCurrentStateName());
      vm.chartEditorState.ccInitializationPending = true;
      vm.chartEditorPreferences = $localStorage.$default({
        mediaDrawerOpen: vm.chartEditorState.mediaDrawerOpen,
        performerPickerDocked: vm.chartEditorState.performerPickerDocked,
        performerPickerDockedOpen: vm.chartEditorState.performerPickerDockedOpen,
        inspectorVisible: vm.chartEditorState.inspectorVisible,
        scaleAllPerformers: vm.scalePerformers.allPerformers,
        scaleSelectedPerformers: vm.scalePerformers.selectedPerformers,
      });

      sessionCheckAndRun();
      registerKeyboardHandler();
    }

    $scope.$watch('vm.navigationLinksOptions.show', function (newValue, oldValue) {
      if (newValue === true) {
        $timeout(function () {
          $('.linked-scores-list.unlocked .menu-group').mCustomScrollbar(vm.scrollConfigGenericPopover);
        }, 0);
      }
    });

    $scope.$watch('vm.navigationLockedModeLinksOptions.show', function (newValue, oldValue) {
      if (newValue === true) {
        $timeout(function () {
          $('.linked-scores-list.locked .menu-group').mCustomScrollbar(vm.scrollConfigGenericPopover);
        }, 0);
      }
    });

    function getSelectedChartLinkedStaffs() {
      var deferred = $q.defer();

      dbStaffs.getStaffsLinkedToChart(vm.selectedChart._id)
        .then(function (linkedStaffs) {
          vm.selectedChart.navigationLinks = linkedStaffs;
          angular.forEach(vm.selectedChart.navigationLinks, function (staff) {
            if (swaUtils.isUndefinedOrNull(staff.customtitle) || (staff.customtitle.length === 0)) {
              staff.assignedName = getDefaultStaffTitle(staff);
            } else {
              staff.assignedName = staff.customtitle;
            }
          })

          deferred.resolve();
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error loading linked Scores!')
          );
          $log.error('ChartEditorController.getChartStaffs():', error);

          deferred.reject(error);
        });

      return deferred.promise;
    }

    function getSelectedChartLinkedScriptPages() {
      var deferred = $q.defer();

      dbScriptPages.getScriptPagesLinkedToChart(vm.selectedChart._id)
        .then(function (linkedScriptPages) {
          vm.selectedChart.navigationLinks = linkedScriptPages;
          angular.forEach(vm.selectedChart.navigationLinks, function (scriptPage) {
            scriptPage.assignedName = angular.isDefined(scriptPage.customPageNumber)
              ? (scriptPage.customPageNumber.trim() === '' ? 'Page _' : 'Page ' + scriptPage.customPageNumber)
              : 'Page ' + (scriptPage.orderingindex + 1);
          });

          deferred.resolve();
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error loading linked Pages!')
          );
          $log.error('ChartEditorController.getChartScriptPages():', error);

          deferred.reject(error);
        });

      return deferred.promise;
    }

    function getDefaultStaffTitle(staff) {
      var displayIndex = staff.orderingindex + 1;
      var templateDefinition = staffTemplatesService.getTemplateDefinitionForId(staff.stafftype);

      if (angular.isDefined(templateDefinition)) {
        if (templateDefinition.displaycountprefix) {
          return (staff.counts + ' ' + templateDefinition.displayname + ' - ' + displayIndex);
        } else {
          return (templateDefinition.displayname + ' - ' + displayIndex);
        }
      }
    }

    function sessionCheckAndRun() {
      selectedProductionId = $stateParams.productionId || $cookies.get('selectedProductionId');

      if (angular.isUndefined(selectedProductionId)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        return;
      }

      ngProgressLite.start();
      blockUI.start();

      DbSubMgrService.validateSession()
        .then(function () {
          return DbSubMgrService.validateActivePlan();
        })
        .then(function () {
          return DbSubMgrService.onLoggedInUserDataAvailable();
        })
        .then(function () {
          vm.userData = DbSubMgrService.getLoggedInUserData();
          vm.userId = DbSubMgrService.getLoggedInUserId();

          if (angular.isDefined(vm.userData.preferences)) {
            vm.chartEditorState.povOverride = vm.userData.preferences.povOverride || false;
          }

          if (angular.isDefined(vm.userData.flags.allowChartVersionBrowser)) {
            chartVersionBrowserState.enabled = (vm.userData.flags.allowChartVersionBrowser === true)
          }
        })
        .then(function () {
          return DbSubMgrService.getLoggedInUsersPlan();
        })
        .then(function (plan) {
          updateActivePlanRules(plan);
        })
        .then(function () {
          return getAllData();
        })
        .then(function () {
          loadEditorPreferences();
          showHelpHints();
          initHelpTour();
        })
        .then(function () {
          if (angular.isDefined($stateParams.navParams)) {
            return navigateOpenChart($stateParams.navParams.chartId);
          } else if (angular.isDefined($stateParams.selectedScene)) {
            var sceneToOpen = vm.scenes.find(function (scene) { return (scene._id === $stateParams.selectedScene._id) })
            return toggleScene(sceneToOpen);
          } else if (angular.isDefined($stateParams.chartId)) {
            return navigateOpenChart($stateParams.chartId);
          }
        })
        .then(function () {
          if ($stateParams.lockModeNavigation === true) {
            toggleLockModeNavigation();
          }
        })
        .then(null, null, function (progress) {
          ngProgressLite.set(progress);
        })
        .catch(function (error) {
          swaUtils.sessionErrorInterceptor(error);
          $log.error('ChartEditorController.sessionCheckAndRun:', error);
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.reset();
        });
    }

    function getAllData() {
      var deferred = $q.defer();

      var dbScripts = new DbScripts();

      dbProductions.findById(selectedProductionId)
        .then(function (production) {
          deferred.notify(0.1);
          updateDataProduction(production);
        })
        .then(function () {
          if (vm.selectedProduction.productiontype === 1) {
            return dbScripts.findByProduction(selectedProductionId);
          }
        })
        .then(function (script) {
          vm.script = script;
        })
        .then(function () {
          return dbPerformers.fetchAllInProduction(selectedProductionId, updateDataPerformersLive);
        })
        .then(function (performers) {
          deferred.notify(0.2);
        })
        .then(function () {
          return dbSetPieces.getStockItems();
        })
        .then(function (setPieces) {
          deferred.notify(0.3);
          updateDataSetPiecesStock(setPieces);
        })
        .then(function () {
          return dbSetPieces.fetchAllInProduction(selectedProductionId, updateDataSetPiecesLive);
        })
        .then(function (setPieces) {
          deferred.notify(0.5);
        })
        .then(function () {
          return dbScenes.fetchAllInProduction(selectedProductionId, updateDataScenes);
        })
        .then(function () {
          deferred.notify(0.7);
        })
        .then(function () {
          return loadPermanentStage();
        })
        .then(function () {
          $cookies.put('selectedProductionId', selectedProductionId);
          deferred.notify(1.0);
        })
        .then(function () {
          return dbProductions.fetchById(selectedProductionId, updateDataProductionLive);
        })
        .then(function () {
          return loadUserProductionPreferences();
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function navigateOpenChart(chartId) {
      var deferred = $q.defer();

      dbCharts.getChartForName(chartId)
        .then(function (chart) {
          if (angular.isDefined(chart)) {
            return chart.sceneId
          }
        })
        .then(function (sceneId) {
          if (sceneId) {
            return vm.scenes.find(function (scene) {
              return scene._id === sceneId
            });
          }
        })
        .then(function (scene) {
          if (angular.isDefined(scene)) {
            return toggleScene(scene);
          }
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (e) {
          deferred.reject(e);
        });

      return deferred.promise;
    }

    function loadUserProductionPreferences() {
      dbUserProductions.findByProductionId(selectedProductionId)
        .then(function (userProduction) {
          if (angular.isUndefined(userProduction)) {
            vm.defaultChartTextSettings = angular.copy(swaUi.defaultTextStylePreferences);
          } else {
            vm.defaultChartTextSettings = angular.copy(userProduction.contentDefaults.settingsChartText);
          }
        });
    }

    function updateActivePlanRules(plan) {
      vm.activePlanRules.planId = plan.planid;

      vm.activePlanRules.allowUnlimitedPerformers = plan.planfeatures[2].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedPerformers) {
        vm.activePlanRules.allowedNumberOfPerformers = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfPerformers = plan.planfeatures[2].featurevalue;
      }

      vm.activePlanRules.allowUnlimitedScenes = plan.planfeatures[3].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedScenes) {
        vm.activePlanRules.allowedNumberOfScenes = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfScenes = plan.planfeatures[3].featurevalue;
      }

      vm.activePlanRules.allowUnlimitedCharts = plan.planfeatures[4].valueisunlimited;
      if (vm.activePlanRules.allowUnlimitedCharts) {
        vm.activePlanRules.allowedNumberOfCharts = Number.MAX_SAFE_INTEGER;
      } else {
        vm.activePlanRules.allowedNumberOfCharts = plan.planfeatures[4].featurevalue;
      }
    }

    function setupLayerViews() {
      vm.chartGridView = new ChartGridView();
      vm.permanentChartLayerView = new ChartLayerPermanent();
      vm.semiChartLayerView = new ChartLayerSemiPermanent();
      vm.semiChartLayerView.delegate = vm;
      vm.dynamicChartLayerView = new ChartLayerDynamic();
      vm.dynamicChartLayerView.delegate = vm;
      vm.userChartLayerView = new ChartLayerUser();
      vm.userChartLayerView.delegate = vm;
    }

    function updateDataProduction(production) {
      vm.selectedProduction = production;

      if (angular.isUndefined(vm.selectedProduction)) {
        swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
        throw new Error('Invalid state');
      }

      if (vm.selectedProduction.productiontype === 0) {
        try {
          staffTemplatesService.setProduction(vm.selectedProduction);
        } catch (e) {
          toastr.error(
            e.message,
            $translate.instant('errormessages.Error loading score templates!')
          );
        }
      }

      if (vm.selectedProduction.ownerId === vm.userId) {
        vm.activeCollaborationConfig.isProductionOwner = true;
        if (vm.activePlanRules.planId === 2) {
          showPovOverrideHint();
        }
      } else {
        if (angular.isArray(vm.selectedProduction.collaboratorIds) && (vm.selectedProduction.collaboratorIds.indexOf(vm.userId) > -1)) {
          vm.activeCollaborationConfig.isProductionOwner = false;
          vm.activeCollaborationConfig.collaborationSetting = vm.selectedProduction.collaborationsettings.find(
            function (element) {
              return (element.collaboratorId === vm.userId);
            });
        }
        if (angular.isUndefined(vm.activeCollaborationConfig.collaborationSetting)) {
          toastr.error(
            $translate.instant('collaborationprivileges.errormessages.Production access revoked/denied'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
          swaUtils.stateGoSkipValidation(swaRouterStateNames.productionlist, true);
          throw new Error('Invalid state');
        }
        showPovOverrideHint();
      }

      DbSubMgrService.setSelectedProduction(vm.selectedProduction);

      vm.chartEditorState.chartNumberAutomatic = (vm.selectedProduction.chartsettings.chartnumberautomatic === true);
      vm.chartEditorState.povAudience = checkPovOverrideAudience(vm.selectedProduction.chartsettings.povaudience === true);
      setupCocos();
      setupPdfPrintService();
    }

    function updateDataProductionLive(id) {
      if (angular.isUndefined(id)) {
        return;
      }

      var updatedProduction = dbProductions.getFetchedById(id);

      if (!_.isEqual(vm.selectedProduction.chartsettings, updatedProduction.chartsettings)) {
        $log.debug('updateDataProductionLive: chart settings changed...');

        angular.extend(vm.selectedProduction.chartsettings, updatedProduction.chartsettings);

        vm.chartEditorState.chartNumberAutomatic = (vm.selectedProduction.chartsettings.chartnumberautomatic === true);
        vm.chartEditorState.povAudience = checkPovOverrideAudience(vm.selectedProduction.chartsettings.povaudience === true);
        updateDataProductionPostCocosInit();

        toastr.info(
          $translate.instant('messages.Chart settings updated.'),
          $translate.instant('messages.Sync update!')
        );
      }

      if (!_.isEqual(vm.selectedProduction.stagesettings, updatedProduction.stagesettings)) {
        $log.debug('updateDataProductionLive: stage settings changed...');

        angular.extend(vm.selectedProduction.stagesettings, updatedProduction.stagesettings);

        updateDataProductionPostCocosInit();

        toastr.info(
          $translate.instant('messages.Stage settings updated.'),
          $translate.instant('messages.Sync update!')
        );
      }

      if (!_.isEqual(vm.selectedProduction.contentModified, updatedProduction.contentModified)) {
        $log.debug('updateDataProductionLive: permanent layer changed...');

        vm.selectedProduction.contentModified = updatedProduction.contentModified;

        loadPermanentStage();

        toastr.info(
          $translate.instant('messages.Permanent stage updated.'),
          $translate.instant('messages.Sync update!')
        );
      }
    }

    function setupPdfPrintService() {
      swPdfPrintService.setSelectedProduction(vm.selectedProduction);
      vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
      vm.onPrintJobsChange = onPrintJobsChange;
      swPdfPrintService.registerForChange(vm);
    }

    function onPrintJobsChange(change, id, job) {
      $scope.$applyAsync(function () {
        vm.printJobs = swPdfPrintService.getSelectedProductionPrintJobs();
      });
    }

    function pdfPrintOptionPrompt(type) {
      if (type === vm.PdfPrintTypes.CurrentStaff || type === vm.PdfPrintTypes.CurrentSceneStaffs || type === vm.PdfPrintTypes.AllStaffs) {
        var params = {
          type: type,
        }
        printPdf(params);
      } else {
        vm.pdfOptionsPicker.show = false;
        var permissionToPrintSharedLayers = false;
        if (vm.activeCollaborationConfig.collaborationSetting) {
          permissionToPrintSharedLayers = ((vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.custom) && !vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.allowscriptediting) ||
            (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited);
        }
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/chartEditor/pdfPrintOptionPrompt.html',
          controller: 'PdfPrintOptionPromptController',
          controllerAs: 'vm',
          size: '600',
          windowClass: 'sw-modal',
          backdropClass: 'sw-modal-backdrop',
          resolve: {
            params: {
              type: type,
              permissionToPrintSharedLayers: permissionToPrintSharedLayers,
            }
          }
        });
        modalInstance.result
          .then(function (params) {
            printPdf(params);
          });
      }
    }

    function printPdf(parameters) {
      var type = parameters.type;
      vm.pdfOptionsPicker.show = false;

      var params = {};
      params.productionId = selectedProductionId;
      params.optionalIds = {};
      params.options = {};
      params.type = type;
      params.notesPrintOption = parameters.chartNotes;
      params.chartLinksPrintOption = parameters.chartLinks;
      params.scaleAllPerformersPrintOption = parameters.scaleAllPerformers;
      params.scaleSelectedPerformersPrintOption = parameters.scaleSelectedPerformers;
      params.sharedLayerAnnotationsPrintOption = parameters.sharedLayerAnnotations;

      if ((type === vm.PdfPrintTypes.AllChartsScript) || (type === vm.PdfPrintTypes.Script)) {
        params.optionalIds.scriptId = vm.script._id;
      } else if ((type === vm.PdfPrintTypes.CurrentSceneChartsStaffs) || (type === vm.PdfPrintTypes.CurrentSceneCharts) || (type === vm.PdfPrintTypes.CurrentSceneStaffs)) {
        params.optionalIds.sceneId = vm.selectedSceneId;
      } else if (type === vm.PdfPrintTypes.CurrentChart) {
        params.optionalIds.chartId = vm.selectedChart._id;
      }

      params.options.printChartPersonalNotes = getPrintChartPersonalNotes();

      saveActiveChart()
        .then(function () {
          if ((type === vm.PdfPrintTypes.AllChartsScript) || (type === vm.PdfPrintTypes.Script)) {
            return getAllowScriptPersonalNotes();
          } else {
            return false;
          }
        })
        .then(function (allowPersonalNotes) {
          params.options.printPersonalAnnotations = allowPersonalNotes;
        })
        .then(function () {
          return swPdfPrintService.printPdf(params);
        })
        .then(function (printJob) {
          if (angular.isDefined(printJob.approvingUserId)) {
            toastr.info(
              $translate.instant('messages.PDF waiting for approval'),
              $translate.instant('messages.Approval Needed!')
            );
          } else {
            toastr.info(
              $translate.instant('messages.Requested PDF is being created')
            );
          }
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error creating PDF!')
          );
        });
    }

    function getAllowScriptPersonalNotes() {
      var deferred = $q.defer();

      if (vm.activeCollaborationConfig.isProductionOwner) {
        deferred.resolve(false);
      } else {
        var params = {
          accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
          statename: swaRouterStateNames.scripteditor,
        };

        if (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.scene) {
          params.allowscriptediting = vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.allowscriptediting;
        }

        dbCollaborationPrivileges.getCollaborationPrivileges(params)
          .then(function (privilegeData) {
            deferred.resolve(privilegeData.accessrules.allowpersonalnotes);
          })
          .catch(function (error) {
            deferred.resolve(false);
          });
      }

      return deferred.promise;
    }

    function getPrintChartPersonalNotes() {
      return (!vm.activeCollaborationConfig.isProductionOwner && (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited)) ||
        (vm.activePlanRules.planId === 2);
    }

    function checkPovOverrideAudience(productionPov) {
      if ((vm.activeCollaborationConfig.isProductionOwner && (vm.activePlanRules.planId !== 2)) || (vm.chartEditorState.povOverride === false)) {
        return productionPov;
      } else {
        return (vm.chartEditorState.povOverride === 'audience');
      }
    }

    function showPovOverrideHint() {
      if (vm.chartEditorState.povOverride === 'audience') {
        toastr.info('Viewing in \'Audience\' POV');
      } else if (vm.chartEditorState.povOverride === 'performer') {
        toastr.info('Viewing in \'Peformer\' POV');
      }
    }

    function updateDataProductionPostCocosInit() {
      vm.chartGridView.setProduction(vm.selectedProduction);
      vm.chartGridView.setPovAudience(vm.chartEditorState.povAudience);

      updateChartItemViewFactory();

      vm.permanentChartLayerView.setShowLineOverlapBreaks((vm.selectedProduction.chartsettings.lineoverlapbreaks === true));
      vm.semiChartLayerView.setShowLineOverlapBreaks((vm.selectedProduction.chartsettings.lineoverlapbreaks === true));
      vm.dynamicChartLayerView.setShowLineOverlapBreaks((vm.selectedProduction.chartsettings.lineoverlapbreaks === true));
      vm.userChartLayerView.setShowLineOverlapBreaks((vm.selectedProduction.chartsettings.lineoverlapbreaks === true));

      vm.dynamicChartLayerView.setPositionVisible((vm.selectedProduction.chartsettings.performerpositionvisible === true));
      vm.dynamicChartLayerView.setPositionResolutionFraction((vm.selectedProduction.chartsettings.performerpositionresolutionfraction || 0));
      vm.dynamicChartLayerView.setNoseVisible((vm.selectedProduction.chartsettings.performernosevisible === true));

      vm.permanentChartLayerView.setPovAudience(vm.chartEditorState.povAudience);
      vm.semiChartLayerView.setPovAudience(vm.chartEditorState.povAudience);
      vm.dynamicChartLayerView.setPovAudience(vm.chartEditorState.povAudience);
      vm.userChartLayerView.setPovAudience(vm.chartEditorState.povAudience);

      vm.chartEditorState.maxZoomFactor = vm.chartGridView.getMaxStageZoom();
      vm.zoomSliderOptions.ceil = vm.chartGridView.getMaxStageZoom();
      vm.chartEditorState.zoomFactor = vm.chartGridView.getZoomFactor();

      onZoomChangeEnd(true);
    }

    function updateDataPerformers(performers) {
      vm.performers = angular.copy(performers);
      vm.chartItemViewFactory.performers = vm.performers;
    }

    function updateDataPerformersLive(id) {
      if (angular.isUndefined(id)) {
        vm.performers = dbPerformers.getFetched(true);
        vm.chartItemViewFactory.performers = vm.performers;
      } else {
        var existingPerformer = swaUtils.findInArrayById(vm.performers, id);
        var incomingPerformer = dbPerformers.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingPerformer) && !swaUtils.isUndefinedOrNull(incomingPerformer));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingPerformer) && swaUtils.isUndefinedOrNull(incomingPerformer));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingPerformer) && !swaUtils.isUndefinedOrNull(incomingPerformer));

        if (isInsert) {
          vm.performers.push(incomingPerformer);
          swaUtils.sortArrayByNumericKey(vm.performers, 'orderingindex');
          vm.chartItemViewFactory.performers = vm.performers;
        } else if (isDelete) {
          toastr.warning(
            $translate.instant('messages.Performer deleted elsewhere.'),
            $translate.instant('messages.Sync warning!')
          );

          var existingPerformerIndex = vm.performers.indexOf(existingPerformer);
          if (existingPerformerIndex !== -1) {
            vm.performers.splice(existingPerformerIndex, 1);
          }
          vm.chartItemViewFactory.performers = vm.performers;
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming performer update with ID: ' + id);
          angular.extend(existingPerformer, incomingPerformer);

          vm.chartItemViewFactory.updateCachedPerformerImage(id);
        }
      }
    }

    function updateDataSetPiecesStock(setPieces) {
      vm.stockSetPieces = [].concat(setPieces);
      vm.chartItemViewFactory.stockSetPieces = vm.stockSetPieces;
    }

    function updateDataSetPieces(setPieces) {
      vm.setPieces = setPieces.concat(vm.setPieces);
      vm.chartItemViewFactory.setPieces = vm.setPieces;
    }

    function updateDataSetPiecesLive(id) {
      if (angular.isUndefined(id)) {
        vm.setPieces = dbSetPieces.getFetched(true);
        vm.chartItemViewFactory.setPieces = vm.setPieces;
      } else {
        var existingSetPiece = swaUtils.findInArrayById(vm.setPieces, id);
        var incomingSetPiece = dbSetPieces.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingSetPiece) && !swaUtils.isUndefinedOrNull(incomingSetPiece));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingSetPiece) && swaUtils.isUndefinedOrNull(incomingSetPiece));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingSetPiece) && !swaUtils.isUndefinedOrNull(incomingSetPiece));

        if (isInsert) {
          vm.setPieces.push(incomingSetPiece);
          swaUtils.sortArrayByNumericKey(vm.setPieces, 'orderingindex');
          vm.chartItemViewFactory.setPieces = vm.setPieces;
        } else if (isDelete) {
          toastr.warning(
            $translate.instant('messages.SetPiece deleted elsewhere.'),
            $translate.instant('messages.Sync warning!')
          );

          var existingSetPieceIndex = vm.setPieces.indexOf(existingSetPiece);
          if (existingSetPieceIndex !== -1) {
            vm.setPieces.splice(existingSetPieceIndex, 1);
          }
          vm.chartItemViewFactory.setPieces = vm.setPieces;
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming setPiece update with ID: ' + id);
          angular.extend(existingSetPiece, incomingSetPiece);

          vm.chartItemViewFactory.updateCachedSetPieceImage(id);
        }
      }
    }

    function updateDataScenes(id) {
      if (angular.isUndefined(id)) {
        vm.scenes = dbScenes.getFetched(true);
        updateSceneCollaborationAccessRules(vm.scenes);
      } else {
        var existingScene = swaUtils.findInArrayById(vm.scenes, id);
        var incomingScene = dbScenes.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingScene) && swaUtils.isUndefinedOrNull(incomingScene));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingScene) && !swaUtils.isUndefinedOrNull(incomingScene));

        if (isInsert) {
          updateSceneCollaborationAccessRules([incomingScene]);
          vm.scenes.push(incomingScene);
          swaUtils.sortArrayByNumericKey(vm.scenes, 'orderingindex');
        } else if (isDelete) {
          toastr.warning(
            $translate.instant('messages.Scene deleted elsewhere.'),
            $translate.instant('messages.Sync warning!')
          );
          if (existingScene === vm.selectedScene) {
            toggleScene();
          }

          var existingSceneIndex = vm.scenes.indexOf(existingScene);
          if (existingSceneIndex !== -1) {
            vm.scenes.splice(existingSceneIndex, 1);
          }
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming scene update with ID: ' + id);
          angular.extend(existingScene, incomingScene);
        }
      }
    }

    function updateDataCharts(filter, id) {
      if (angular.isUndefined(vm.selectedScene)) {
        return;
      }

      if (filter) {
        if (filter.sceneId !== vm.selectedScene._id) {
          return;
        }
      }

      if (angular.isUndefined(id)) {
        if (vm.deletedChartListMode && vm.restoringSingleChart) {
          vm.selectedScene.charts = dbCharts.getFetched(true);
        } else {
          vm.selectedScene.charts = dbCharts.getFetched(true);
        }
        vm.selectedScene.noCharts = !(angular.isArray(vm.selectedScene.charts) && (vm.selectedScene.charts.length > 0));

        vm.chartEditorState.showingChartContent = !vm.selectedScene.noCharts;

        if (!(vm.sidebarEditState.enabled || vm.chartEditorState.lockModeNavigation)) {
          if (!vm.selectedScene.noCharts) {
            // var chartIndexToSelect = Math.min(vm.selectedScene.charts.length, vm.activePlanRules.allowedNumberOfCharts) - 1;
            // if (chartIndexToSelect > -1) {
            //   selectChartById(vm.selectedScene.charts[chartIndexToSelect]._id);
            // }
            if (angular.isDefined($stateParams.navParams)) {
              selectChartById($stateParams.navParams.chartId);
              delete $stateParams.navParams;
            } else {
              selectChartById(vm.selectedScene.charts[0]._id)
            }
          }
        }
      } else {
        vm.selectedScene.charts = vm.selectedScene.charts || [];

        var existingChart = swaUtils.findInArrayById(vm.selectedScene.charts, id);
        var incomingChart = dbCharts.getFetchedById(id);

        var isInsert = (swaUtils.isUndefinedOrNull(existingChart) && !swaUtils.isUndefinedOrNull(incomingChart));
        var isDelete = (!swaUtils.isUndefinedOrNull(existingChart) && swaUtils.isUndefinedOrNull(incomingChart));
        var isUpdate = (!swaUtils.isUndefinedOrNull(existingChart) && !swaUtils.isUndefinedOrNull(incomingChart));
        if (isInsert) {
          // incoming insert
          $log.debug('incoming chart insert with ID: ', id);

          vm.selectedScene.charts.push(incomingChart);
          swaUtils.sortArrayByNumericKey(vm.selectedScene.charts, 'orderingindex');
          vm.selectedScene.noCharts = !(angular.isArray(vm.selectedScene.charts) && (vm.selectedScene.charts.length > 0));

          vm.chartEditorState.showingChartContent = !vm.selectedScene.noCharts;
          if (vm.insertedChartId === incomingChart._id) {
            selectChartById(incomingChart._id);
            vm.insertedChartId = undefined;
          } else {
            vm.insertedChartId = incomingChart._id;
          }
        } else if (isDelete) {
          // incoming delete
          $log.debug('incoming chart delete with ID: ' + id);

          if ((angular.isDefined(vm.selectedChart)) && (id === vm.selectedChart._id)) {
            unloadChart();
          }

          var existingChartIndex = vm.selectedScene.charts.indexOf(existingChart);
          if (existingChartIndex !== -1) {
            vm.selectedScene.charts.splice(existingChartIndex, 1);
          }

          vm.selectedScene.noCharts = !(angular.isArray(vm.selectedScene.charts) && (vm.selectedScene.charts.length > 0));

          vm.chartEditorState.showingChartContent = !vm.selectedScene.noCharts;

          // TODO: select another chart if active chart got deleted
        } else if (isUpdate) {
          // incoming change/update
          $log.debug('incoming chart update with ID: ' + id);

          // TODO: merge existing and incoming chart intelligently
          if (!angular.equals(existingChart, incomingChart)) {
            angular.extend(existingChart, incomingChart);

            swaUtils.sortArrayByNumericKey(vm.selectedScene.charts, 'orderingindex');

            if (angular.isDefined(vm.selectedChart) && (vm.selectedChart._id === id)) {
              vm.selectedChartOrderingIndex = existingChart.orderingindex;

              if (vm.selectedChart.modifiedBy === vm.userId) {
                loadChartItems();
              } else {
                if (!vm.selectedScene.accessRules.allowchartediting) {
                  if (vm.selectedScene.accessRules.allowaddcharttextpersonal) {
                    existingChart.syncCollision = true;
                  } else {
                    loadChartItems();
                  }
                } else {
                  existingChart.syncCollision = true;
                }
              }
            }
          }
        }
      }
    }

    function chartCompareIfSame(chart1, chart2) {
      if (chart1.orderingindex !== chart2.orderingindex) {
        return false;
      }

      if (chart1.modified && chart2.modified) {
        if (chart1.modified.$date && chart2.modified.$date) {
          if (Math.abs(chart1.modified.$date - chart2.modified.$date) > 5000) {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }

      // TODO: more logic if any

      return true;
    }

    function toggleScene(scene) {
      if (scene._id === vm.sourceSceneId) {
        return $q.resolve;
      }
      if (vm.sidebarEditState.destinationSelectVisible) {
        if (!scene.accessRules.allowchartediting) {
          return $q.resolve;
        }
      }
      var deferred = $q.defer();

      ngProgressLite.start();
      blockUI.start();

      var firstQ;
      if (vm.restoringSingleChart) {
        firstQ = $q.when();
      } else {
        firstQ = unloadChart();
      }

      firstQ
        .then(function () {
          changeTrackerReset();

          hideSideBarDeleteAndMoveOptions();

          // close currently open scene
          if (angular.isDefined(vm.selectedScene)) {
            vm.selectedScene.charts = [];
            vm.selectedScene.open = false;
            vm.selectedScene.selected = false;
            vm.movingSingleChartOperationToggle = false;
          }

          if (vm.sidebarEditState.enabled) {
            clearAllChartEditModeSelections();
          }
        })
        .then(function () {
          if (vm.selectedScene !== scene) {
            vm.selectedScene = scene;
            vm.selectedSceneId = scene._id;
            vm.selectedScene.selected = true;
            if (!vm.chartEditorState.lockModeNavigation) {
              vm.selectedScene.open = true;
              vm.movingSingleChartOperationToggle = true;
              if (vm.selectedScene && vm.selectedScene.accessRules && vm.selectedScene.accessRules.allowmovechartsource) {
                vm.sidebarSortableOptions.disabled = false;
              } else {
                vm.sidebarSortableOptions.disabled = true;
              }
            }
            updateActiveAccessRules();
            return dbCharts.fetchForScene(scene._id, updateDataCharts);
          } else {
            vm.selectedScene = undefined;
            vm.selectedSceneId = undefined;

            vm.chartEditorState.showingChartContent = false;
          }
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('ChartEditorController.toggleScene:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error loading charts!')
          );
        })
        .finally(function () {
          updateStickySceneHeader();
          ngProgressLite.done();
          blockUI.stop();
        });

      return deferred.promise;
    }

    function toggleRemovedChartsScene(scene) {
      unloadChartNoSave();
      changeTrackerReset();

      hideSideBarDeleteAndMoveOptions();

      // close currently open scene
      if (angular.isDefined(vm.selectedScene)) {
        vm.selectedScene.open = false;
        vm.selectedScene.selected = false;
        vm.movingSingleChartOperationToggle = false;
      }

      if (vm.selectedScene !== scene) {
        vm.selectedScene = scene;
        vm.selectedSceneId = scene._id;
        vm.selectedScene.selected = true;
        vm.selectedScene.open = true;

        updateActiveAccessRules();
      } else {
        vm.selectedScene = undefined;
        vm.selectedSceneId = undefined;

        vm.chartEditorState.showingChartContent = false;
      }

      updateStickySceneHeader();
    }

    function updateStickySceneHeader() {
      $scope.$applyAsync(function () {
        if (vm.selectedScene && vm.selectedScene.open) {
          var sceneGroup = $('#scene-group-' + vm.selectedScene.orderingindex);
          var groupOffsetTop = sceneGroup.offset().top;
          var groupHeight = sceneGroup.outerHeight();
          if ((groupOffsetTop < 106) && ((groupHeight + groupOffsetTop) > 148)) {
            vm.sceneSticky = true;
          } else {
            vm.sceneSticky = false;
          }
        } else {
          vm.sceneSticky = false;
        }
      });
    }

    function loadPermanentStage() {
      var deferred = $q.defer();

      var iQ1 = $interval(function () {
        if (vm.chartEditorState.ccInitializationPending === false) {
          $interval.cancel(iQ1);
        }
      }, 500, 10);

      iQ1
        .then(function () {
          if (vm.chartEditorState.ccInitializationPending === false) {
            return loadChartItems();
          } else {
            throw new Error('Timeout waiting for editor initialization');
          }
        }, function () {
          return loadPermanentStageChartItems();
        })
        .then(function () {
          deferred.resolve();
        }, function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function loadPermanentStageChartItems() {
      if (angular.isUndefined(vm.selectedProduction)) {
        return;
      }

      ccChartQuickUpdates();
      dbChartItems.getItemsOfProduction(vm.selectedProduction._id)
        .then(function (items) {
          vm.permanentChartLayerView.setChartItems(items);
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error loading Permanent Stage!')
          );
          $log.error('ChartEditorController.loadPermanentStageChartItems():', error);
        })
        .finally(function () {
          ccChartPauseUpdates();
        });
    }

    function sidebarSelectChartAtIndex(index, event) {
      var chartToSelect = vm.selectedScene.charts[index];
      if (vm.sidebarEditState.enabled) {
        if (vm.selectedScene.accessRules.allowowneraccess || vm.selectedScene.accessRules.allowmovechartsource || vm.selectedScene.accessRules.allowdeletechart) {
          toggleChartEditModeSelection(chartToSelect);
        } else {
          toastr.error(
            $translate.instant('collaborationprivileges.errormessages.You do not have access to move/delete charts from this scene'),
            $translate.instant('collaborationprivileges.titles.Collaboration Access')
          );
        }
      } else {
        if (!vm.sidebarEditState.enabled && event && (event.metaKey || event.ctrlKey)) {
          if (vm.selectedScene.accessRules.allowmovechartsource || vm.selectedScene.accessRules.allowdeletechart) {
            vm.sidebarEditState.enabled = true;
            vm.chartEditorState.chartOpen = false;
            toggleChartEditModeSelection(chartToSelect);
            hideSideBarDeleteAndMoveOptions();
          }
        } else {
          selectedIndexForDeleteAndMove = index;
          selectChart(chartToSelect);
        }
      }
    }

    function sidebarSelectDeletedChartAtIndex(index) {
      var chartToSelect = vm.selectedScene.charts[index];

      selectDeletedChart(chartToSelect);
    }

    function toggleSidebarEditMode() {
      if (vm.activePlanRules.planId === 2) {
        toastr.error(
          $translate.instant('planprivileges.messages.Your plan does not permit access to this view/feature.'),
          $translate.instant('planprivileges.titles.Plan - Access Denied!')
        );

        return;
      }

      if (vm.sidebarEditState.enabled === true) {
        // Back to normal mode
        vm.sidebarEditState.enabled = false;
        vm.sourceSceneId = null;
        // vm.sidebarSortableOptions.disabled = true;

        blockUI.start();

        clearAllChartEditModeSelections();

        $timeout(function () {
          if ((angular.isDefined(vm.selectedSceneId)) && (vm.selectedScene.charts.length > 0) && !(vm.deletedChartListMode)) {
            sidebarSelectChartAtIndex(0);
          }
          blockUI.stop();
        }, 500);
      } else {
        // Begin edit mode
        if (!vm.restoringSingleChart) {
          unloadChart();
        }

        // vm.sidebarSortableOptions.disabled = false;
        vm.sidebarEditState.enabled = true;

        clearAllChartEditModeSelections();
      }
    }

    // Add click event listener to the document body
    // eslint-disable-next-line angular/document-service
    document.body.addEventListener('click', function (event) {
      var isButtonClick = event.target.closest('#sideBarDeleteAndMoveOptionsMenuButton');
      var isInsidePopup = event.target.closest('#sideBarDeleteAndMoveOptionsMenu');

      if (!isButtonClick && !isInsidePopup) {
        hideSideBarDeleteAndMoveOptions();
      }
    });

    function sidebarShowDestinationSceneListForMove() {
      var chartIdsToMove = [];
      for (var i = 0; i < vm.selectedScene.charts.length; i++) {
        var aChart = vm.selectedScene.charts[i];
        if (aChart.editSelected) {
          chartIdsToMove.push(aChart._id);
        }
      }
      vm.chartIdsToMoveAtSpecificIndex = chartIdsToMove;

      if (vm.scenes[vm.selectedScene.orderingindex].accessRules.allowowneraccess || vm.scenes[vm.selectedScene.orderingindex].accessRules.allowmovechartsource) {
        vm.selectedScene.open = false;
        vm.sourceSceneId = vm.selectedScene._id;
        vm.sourceSceneForMove = vm.selectedScene;
        vm.sidebarEditState.destinationSelectVisible = true;
        vm.sidebarEditState.destinationSelectForMove = true;
        vm.sidebarEditState.destinationSelectForRestore = false;
      } else {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to move charts from this scene'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
      }
    }

    function sidebarShowDestinationSceneListForRestore(chartVersionId) {
      vm.chartVersionIdToRestore = chartVersionId;
      if (vm.activeCollaborationConfig.isProductionOwner) {
        vm.selectedScene.open = false;
        vm.sidebarEditState.destinationSelectVisible = true;
        vm.sidebarEditState.destinationSelectForMove = false;
        vm.sidebarEditState.destinationSelectForRestore = true;
      } else {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to restore charts from this scene'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
      }
    }

    function sidebarEditSelectDestinationSceneAtIndex(index) {
      // var chartIdsToMove = vm.chartIdsToMoveAtSpecificIndex;
      var destinationScene = vm.selectedScene;
      if (!vm.moveChartAtSpecificIndex) {
        var targetIndex = -1;
      } else {
        var targetIndex = index;
      }
      // if (destinationScene === vm.selectedScene) {
      //   return;
      // }

      toggleScene(destinationScene)
        .then(function () {
          var sourceSceneForMove = vm.sourceSceneForMove;
          if (vm.sidebarEditState.destinationSelectForMove) {
            var chartIdsToMove = vm.chartIdsToMoveAtSpecificIndex;
            if (destinationScene.accessRules.allowowneraccess || destinationScene.accessRules.allowmovechartdestination) {
              vm.sidebarEditState.destinationSelectVisible = false;
              vm.sourceSceneId = null;
              moveSelectedCharts(chartIdsToMove, destinationScene, targetIndex, sourceSceneForMove);
            }
          } else if (vm.sidebarEditState.destinationSelectForRestore) {
            var chartVersionIdToRestore = vm.chartVersionIdToRestore;
            if (vm.activeCollaborationConfig.isProductionOwner) {
              vm.sidebarEditState.destinationSelectVisible = false;
              restoreSelectedChart(chartVersionIdToRestore, destinationScene, targetIndex);
            }
          }
        })
    }

    function sidebarDragSortStop(e, ui) {
      hideSideBarDeleteAndMoveOptions();
      if (vm.selectedScene.accessRules.allowmovechartsource || vm.selectedScene.accessRules.allowdeletechart) {
        var chartsToUpdate = [];
        for (var i = 0, reindex = 0; i < vm.selectedScene.charts.length; i++) {
          var aChart = vm.selectedScene.charts[i];
          if (aChart.orderingindex !== reindex) {
            chartsToUpdate.push({
              _id: aChart._id,
              orderingindex: reindex,
            });
          }

          reindex++;
        }

        if (chartsToUpdate.length > 0) {
          blockUI.start();
          updateCharts(chartsToUpdate)
            .catch(function (error) {
              $log.error('ChartEditorController.sidebarDragSortStop:', error);
              swaUtils.showErrorToast(
                error,
                $translate.instant('errormessages.Error updating order!')
              );
            })
            .finally(function () {
              blockUI.stop();
            });
        }
      }
    }

    function selectChart(chart) {
      vm.navigationLinksOptions.show = false;
      vm.navigationLockedModeLinksOptions.show = false;
      if (angular.isUndefined(chart)) {
        return;
      }

      if (!vm.selectedScene.accessRules.allowchartediting) {
        deactivateSemiPermanentLayer();
        deactivateDynamicLayer();
        if (vm.selectedScene.accessRules.allowaddcharttextpersonal) {
          activateUserLayer();
        }
      } else {
        if (!vm.chartEditorState.layerActive) {
          activateDynamicLayer();
        }
        // if (vm.chartEditorState.justOpened) {
        //   vm.chartEditorState.justOpened = false;
        //   if (vm.selectedScene.accessRules.allowperformerlayerselect) {
        //     activateDynamicLayer();
        //   }
        // }
      }

      if (vm.chartEditorState.mediaDrawerOpen && !vm.mediaDockState.viewState) {
        toggleEditMediaState();
      }

      unloadChart()
        .then(function () {
          vm.selectedChart = chart;
          vm.selectedChartOrderingIndex = chart.orderingindex;

          changeTrackerReset();

          return loadChartItems();
        })
        .then(function () {
          if (angular.isDefined(vm.selectedChart) && (angular.isUndefined(vm.selectedChart.thumbimage) || (vm.selectedChart.thumbInvalid === true)) && vm.activeAccessRules.allowchartediting) {
            delete vm.selectedChart.thumbInvalid;

            updateChartThumbnailAt1x();
            dbCharts.updateThumbnail(vm.selectedChart._id, vm.selectedChart.thumbimage);
            // markChartDirty();
          }
        })
        .then(function () {
          if (vm.selectedProduction.productiontype === 0) {
            return getSelectedChartLinkedStaffs();
          } else if (vm.selectedProduction.productiontype === 1) {
            return getSelectedChartLinkedScriptPages();
          }
        })
        .then(function () {
        })
        .finally(function () {
          $scope.$applyAsync(function () {
            $scope.$broadcast('chartEditor.chartChanged');
          });
        });
    }

    function selectDeletedChart(chart) {
      vm.navigationLinksOptions.show = false;
      vm.navigationLockedModeLinksOptions.show = false;
      if (angular.isUndefined(chart)) {
        return;
      }

      unloadChartNoSave();
      // unloadChart()
      // .then(function () {
      vm.selectedChart = chart;
      vm.selectedChartOrderingIndex = chart.index;
      // loadChartItems();
      checkForChartVersions();

      changeTrackerReset();
      // return;
      // })
      // .finally(function () {
      $scope.$applyAsync(function () {
        $scope.$broadcast('chartEditor.chartChanged');
      });
      // });
    }

    function clearAllChartEditModeSelections() {
      if (angular.isDefined(vm.selectedScene)) {
        if (angular.isDefined(vm.selectedScene.charts)) {
          for (var i = 0; i < vm.selectedScene.charts.length; i++) {
            vm.selectedScene.charts[i].editSelected = false;
          }
        }
      }

      vm.sidebarEditState.selectionCount = 0;
    }

    function toggleChartEditModeSelection(chart) {
      if (angular.isUndefined(chart)) {
        return;
      }

      if (chart.editSelected) {
        vm.sidebarEditState.selectionCount -= 1;
      } else {
        vm.sidebarEditState.selectionCount += 1;
      }

      chart.editSelected = !chart.editSelected;
    }

    function loadChartItems() {
      var deferred = $q.defer();
      if (angular.isUndefined(vm.selectedChart)) {
        deferred.resolve();
        return deferred.promise;
      }

      blockUI.start();
      ccChartQuickUpdates();
      dbChartItems.getItemsOfChart(vm.selectedChart._id)
        .then(function (items) {
          vm.selectedChart.items = items;

          angular.forEach(items, function (item) {
            if ((item.layer !== SWChartItem.LayerType.Dynamic) && (item.itemtype === SWChartItem.Type.Performer)) {
              item.layer = SWChartItem.LayerType.Dynamic;
            }
          });

          vm.semiChartLayerView.setChartItems(items);
          vm.dynamicChartLayerView.setChartItems(items);
          var mediaItems = items.filter(function (chartItem) { return (chartItem.itemtype === SWChartItem.Type.Media) });
          vm.selectedChartMediaItems = swaUtils.sortArrayByNumericKey(mediaItems, 'zindex');

          if (vm.selectedScene.accessRules.allowaddcharttextpersonal) {
            return dbUserCharts.findByChart(vm.selectedChart._id)
          }
        })
        .then(function (userChart) {
          if (vm.selectedScene.accessRules.allowaddcharttextpersonal) {
            if (angular.isUndefined(userChart)) {
              userChart = dbUserCharts.getNewUserChart(vm.selectedChart._id, vm.userId, selectedProductionId);
            }
            vm.selectedUserChart = userChart;

            return dbChartItems.getItemsOfUserChart(userChart._id);
          }
        })
        .then(function (userChartItems) {
          if (vm.selectedScene.accessRules.allowaddcharttextpersonal) {
            if (angular.isDefined(userChartItems)) {
              vm.userChartLayerView.setChartItems(userChartItems);
            }
          }

          vm.chartEditorState.chartOpen = true;

          changeTrackerInitialize();

          deferred.resolve();
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error loading chart!')
          );

          vm.chartEditorState.chartOpen = false;
          deferred.reject(error);
        })
        .finally(function () {
          blockUI.stop();

          ccChartPauseUpdates();
        });

      return deferred.promise;
    }

    var postUnloadChartTimeout;

    function unloadChart() {
      killAutoSaveTimer();

      var deferred = $q.defer();

      if (angular.isDefined(vm.selectedChart)) {
        // End any editing
        endEditVectorShape();
        endEditTextBox();

        if (vm.selectedScene.accessRules.allowaddcharttextpersonal) {
          vm.userChartLayerView.clearTransientState();
          vm.userChartLayerView.validateData();
        } else {
          vm.semiChartLayerView.clearTransientState();
          vm.dynamicChartLayerView.clearTransientState();

          vm.semiChartLayerView.validateData();
          vm.dynamicChartLayerView.validateData();
        }

        var saveQ = $q.when();
        if (!vm.chartEditorState.lockModeNavigation) {
          saveQ = saveActiveChart();
        }

        vm.semiChartLayerView.setChartItems();
        vm.dynamicChartLayerView.setChartItems();

        vm.selectedChart = undefined;
        vm.selectedChartOrderingIndex = -1;

        if (vm.selectedScene.accessRules.allowaddcharttextpersonal) {
          vm.userChartLayerView.setChartItems();
          vm.selectedUserChart = undefined;
        }

        deferred.resolve(saveQ);

        $timeout.cancel(postUnloadChartTimeout);
        postUnloadChartTimeout = $timeout(
          function () {
            if (angular.isUndefined(vm.selectedChart)) {
              vm.chartEditorState.chartOpen = false;
            }

            $timeout.cancel(postUnloadChartTimeout);
            postUnloadChartTimeout = undefined;
          }, 250);
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    function unloadChartNoSave() {
      // To be used only for cases when chart is not editable

      if (angular.isDefined(vm.selectedChart)) {
        vm.semiChartLayerView.setChartItems();
        vm.dynamicChartLayerView.setChartItems();

        vm.selectedChart = undefined;
        vm.selectedChartOrderingIndex = -1;
        vm.chartEditorState.chartOpen = false;
      }
    }

    function onSaveClick() {
      killAutoSaveTimer();
      saveActiveChart();
    }

    /**
     * Saves the active chart.
     *
     * If the 'autoSave' paramater is true, only the chart contents (items) are saved, this is designed for background saves.
     * @param {boolean} autoSave Set true if called by auto save logic.
     */
    function saveActiveChart(autoSave) {
      ['semiChartLayerView', 'dynamicChartLayerView'].forEach(function (layer) {
        if (angular.isDefined(vm[layer].chartItemGroupView)) {
          vm[layer].chartInspectorSelectionUnGroup();
        }
      });

      if (angular.isDefined(vm.selectedScene) && vm.selectedScene.accessRules.allowaddcharttextpersonal) {
        changeTrackerInitialize();
        return saveActiveUserChart(autoSave);
      }

      var deferred = $q.defer();

      if (angular.isUndefined(vm.selectedChart)) {
        deferred.resolve();
        return deferred.promise;
      }

      vm.selectedChart.syncCollision = false;

      if (vm.selectedChart.dirty !== true) {
        $log.debug('saveActiveChart: No changes in chart, nothing to save!');
        deferred.resolve();
        return deferred.promise;
      }

      // var oldZoom = vm.chartEditorState.zoomFactor;
      // vm.chartPanScrollParams.ignorePan = true;
      // vm.chartEditorState.zoomFactor = 1.0;
      // onZoomChangeEnd(true);
      // ccChartUpdateNow();

      if (!autoSave) {
        updateChartThumbnailAt1x();
      }

      // vm.chartEditorState.zoomFactor = oldZoom;
      // onZoomChangeEnd(true);
      // vm.chartPanScrollParams.ignorePan = false;

      var scopeChart = vm.selectedChart;

      scopeChart.items = [];

      scopeChart.items = scopeChart.items.concat(vm.semiChartLayerView.getChartItems());
      scopeChart.items = scopeChart.items.concat(vm.dynamicChartLayerView.getChartItems());
      scopeChart.items = scopeChart.items.concat(angular.copy(vm.selectedChartMediaItems));

      if (!autoSave) {
        scopeChart.dirty = false;
      }

      deferred.resolve(saveChart(scopeChart, autoSave));

      return deferred.promise;
    }

    function saveActiveUserChart(autoSave) {
      var deferred = $q.defer();

      if (angular.isUndefined(vm.selectedUserChart)) {
        deferred.resolve();
        return deferred.promise;
      }

      if (vm.selectedUserChart.dirty !== true) {
        $log.debug('saveActiveUserChart: No changes in user chart, nothing to save!');
        deferred.resolve();
        return deferred.promise;
      }

      var scopeUserChart = vm.selectedUserChart;

      scopeUserChart.items = vm.userChartLayerView.getChartItems();

      scopeUserChart.dirty = false;

      deferred.resolve(saveUserChart(scopeUserChart, autoSave));

      return deferred.promise;
    }

    function updateChartThumbnailAt1x() {
      if (angular.isUndefined(vm.selectedChart)) {
        return;
      }

      if (!vm.activeAccessRules.allowchartediting) {
        return;
      }

      var oldZoomOffset = angular.copy(vm.chartGridView.getZoomOffset());
      var oldZoom = vm.chartEditorState.zoomFactor;
      vm.chartPanScrollParams.ignorePan = true;
      vm.chartEditorState.zoomFactor = 1.0;
      onZoomChangeEnd(true);
      ccChartUpdateNow();

      updateChartThumbnail();

      vm.chartEditorState.zoomFactor = oldZoom;
      onZoomChangeEnd(true);
      vm.chartPanScrollParams.ignorePan = false;

      vm.chartGridView.setZoomOffset(oldZoomOffset);

      vm.chartItemViewFactory.scaledStagePxOffset = vm.chartGridView.getZoomOffset();

      vm.permanentChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());
      vm.semiChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());
      vm.dynamicChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());
      ccChartUpdateNow();
    }

    function updateChartThumbnail() {
      if (angular.isUndefined(vm.selectedChart)) {
        return;
      }

      if (!vm.activeAccessRules.allowchartediting) {
        return;
      }

      // ccChartUpdateNow();

      var srcCanvas = $('#chartCanvas').get(0);
      var tmpCanvas = $document[0].createElement('canvas');
      tmpCanvas.width = 1000 / 5.0;
      tmpCanvas.height = 600 / 5.0;
      var ctx = tmpCanvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.mozImageSmoothingEnabled = true;
      ctx.webkitImageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.fillStyle = 'rgba(255, 255, 255, 1)';
      ctx.fillRect(0, 0, tmpCanvas.width, tmpCanvas.height);
      if (!vm.chartEditorState.povAudience) {
        ctx.translate(tmpCanvas.width, tmpCanvas.height);
        ctx.scale(-1, -1);
      }
      ctx.drawImage(srcCanvas, 0, 0, tmpCanvas.width, tmpCanvas.height);
      try {
        vm.selectedChart.thumbimage = tmpCanvas.toDataURL('image/png').substring(22);
      } catch (e) {
        $log.error(e);
      }
    }

    function selectChartById(chartId) {
      var chartToSelect = swaUtils.findInArrayById(vm.selectedScene.charts, chartId);

      selectChart(chartToSelect);

      $timeout(function () {
        vm.scrollUpdateSidebar('scrollTo', $('#chart-' + chartId).position().top - 40);
      }, 500);
    }

    function moveSelectedCharts(chartIdsToMove, destinationScene, targetIndex, sourceSceneForMove) {
      // if (vm.sidebarEditState.selectionCount < 1) {
      //   return;
      // }

      ngProgressLite.start();
      blockUI.start($translate.instant('messages.Moving ...'));

      dbCharts.countInScene(destinationScene._id)
        .then(function (numDestinationCharts) {
          if ((numDestinationCharts + vm.sidebarEditState.selectionCount) > vm.activePlanRules.allowedNumberOfCharts) {
            toastr.error(
              $translate.instant('planprivileges.messages.Number of charts in scene will exceed current plan limit.'),
              $translate.instant('errormessages.Error moving charts!')
            );
            throw new Error('break-q-chain');
          }
        })
        .then(function () {
          return dbCharts.moveChartsToSceneAtIndex(chartIdsToMove, destinationScene._id, targetIndex);
        })
        .then(function () {
          clearAllChartEditModeSelections();
          if (vm.movingSingleChart) {
            toggleSidebarEditMode();
            vm.movingSingleChart = false;
          }
          toastr.success($translate.instant('messages.Chart(s) moved successfully!'));
        })
        .catch(function (error) {
          if (error.message !== 'break-q-chain') {
            $log.error('ChartEditorController.moveSelectedCharts:', error);
            swaUtils.showErrorToast(
              error,
              $translate.instant('errormessages.Error moving charts!')
            );
          }
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.stop();
          $timeout(function () {
            toggleScene(sourceSceneForMove);
          }, 500);
        });
    }

    function restoreSelectedChart(chartVersionIdToRestore, destinationScene, targetIndex) {
      ngProgressLite.start();
      blockUI.start($translate.instant('messages.Restoring ...'));

      dbCharts.countInScene(destinationScene._id)
        .then(function (numDestinationCharts) {
          if ((numDestinationCharts + vm.sidebarEditState.selectionCount) > vm.activePlanRules.allowedNumberOfCharts) {
            toastr.error(
              $translate.instant('planprivileges.messages.Number of charts in scene will exceed current plan limit.'),
              $translate.instant('errormessages.Error restoring charts!')
            );
            throw new Error('break-q-chain');
          }
        })
        .then(function () {
          clearAllChartEditModeSelections();
          if (vm.restoringSingleChart) {
            vm.selectedChart = undefined;
            vm.selectedChartOrderingIndex = undefined;
            toggleSidebarEditModeForChart();
            vm.restoringSingleChart = false;
            toastr.success($translate.instant('messages.Chart restored successfully!'));
          }
          return dbCharts.restoreChartAtIndexInAnyScene(chartVersionIdToRestore, destinationScene._id, targetIndex);
        })
        .catch(function (error) {
          if (error.message !== 'break-q-chain') {
            $log.error('ChartEditorController.restoreSelectedChart:', error);
            swaUtils.showErrorToast(
              error,
              $translate.instant('errormessages.Error restoring charts!')
            );
          }
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.stop();
          vm.selectedChart = undefined;
          vm.selectedChartOrderingIndex = undefined;
        });
    }

    function deleteSelectedCharts() {
      if (vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowdeletechart) {
        if (vm.sidebarEditState.selectionCount < 1) {
          return;
        }

        blockUI.start($translate.instant('messages.Deleting ...'));

        var chartIdsToDelete = [];
        for (var i = 0; i < vm.selectedScene.charts.length; i++) {
          var aChart = vm.selectedScene.charts[i];
          if (aChart.editSelected) {
            chartIdsToDelete.push(aChart._id);
          }
        }

        dbCharts.delete(chartIdsToDelete)
          .then(function () {
            toastr.success($translate.instant('messages.Chart(s) deleted successfully!'));
          })
          .catch(function (error) {
            $log.error('ChartEditorController.deleteSelectedCharts:', error);
            swaUtils.showErrorToast(
              error,
              $translate.instant('errormessages.Error deleting charts!')
            );
          })
          .finally(function () {
            clearAllChartEditModeSelections();
            blockUI.stop();
          });
      } else {
        toastr.error(
          $translate.instant('collaborationprivileges.errormessages.You do not have access to delete charts from this scene'),
          $translate.instant('collaborationprivileges.titles.Collaboration Access')
        );
      }
    }

    function restoreChart() {
      if (vm.activeCollaborationConfig.isProductionOwner) {
        restoreSingleChart();
      } else {
        restoreChartPermissionAlert();
      }
    }

    function restoreSingleChart() {
      vm.restoringSingleChart = true;
      var chartVersionId = vm.chartVersionBrowserState.selectedVersion._id;
      toggleSidebarEditMode();
      sidebarSelectChartAtIndex(selectedIndexForDeleteAndMove);
      sidebarShowDestinationSceneListForRestore(chartVersionId);
    }

    function moveSingleChart() {
      vm.movingSingleChart = true;
      toggleSidebarEditMode();
      sidebarSelectChartAtIndex(selectedIndexForDeleteAndMove);
      sidebarShowDestinationSceneListForMove();
    }

    function deleteSingleChart() {
      toggleSidebarEditMode();
      sidebarSelectChartAtIndex(selectedIndexForDeleteAndMove);
      deleteSelectedCharts();
      toggleSidebarEditMode();
    }

    function toggleSidebarEditModeForChart() {
      vm.sourceSceneId = null;
      vm.sidebarEditState.destinationSelectVisible = false;
      if (vm.movingSingleChartOperationToggle) {
        vm.selectedScene.open = true;
      }
      if (vm.movingSingleChart) {
        toggleSidebarEditMode();
        vm.movingSingleChart = false;
      }
      if (vm.restoringSingleChart) {
        toggleSidebarEditMode();
        vm.restoringSingleChart = false;
        vm.selectedChart = undefined;
        enterDeletedChartList();
      }
    }

    function updateCharts(chartsToUpdate) {
      var updateQs = [];
      for (var k = 0; k < chartsToUpdate.length; k++) {
        updateQs.push(dbCharts.update(chartsToUpdate[k]));
      }

      return $q.all(updateQs);
    }

    function canAddChartCopy() {
      if (angular.isDefined(vm.selectedChart)) {
        return true;
      } else {
        if ((angular.isDefined(vm.selectedScene)) && (vm.selectedScene.orderingindex > 0)) {
          return true;
        } else {
          return false;
        }
      }
    }

    function addNewChart(type) {
      if (type === 0) {
        addBlankChart();
      } else {
        var asNextChart = (type === 2);
        addCopyOfCurrentChart(asNextChart);
      }

      vm.addChartPopover.show = false;
    }

    function addBlankChart() {
      ngProgressLite.start();
      blockUI.start();

      var newChart = dbCharts.getEmptyChartObject();

      // parent scene
      newChart.sceneId = vm.selectedScene._id;

      // ordering
      if (angular.isDefined(vm.selectedChart)) {
        newChart.orderingindex = vm.selectedChart.orderingindex + 1;
      } else {
        newChart.orderingindex = 0;
      }

      insertChart(newChart);
    }

    function addCopyOfCurrentChart(asNextChart) {
      ngProgressLite.start();
      blockUI.start();

      var insertIndex = 0;

      if (vm.selectedChart) {
        insertIndex = vm.selectedChart.orderingindex + 1;
      }

      var oldSelectedChart = vm.selectedChart;
      unloadChart()
        .then(function () {
          if (angular.isDefined(oldSelectedChart)) {
            return oldSelectedChart;
          } else {
            var sourceScene = vm.scenes[vm.selectedScene.orderingindex - 1];
            return dbCharts.findLastChartInScene(sourceScene._id);
          }
        })
        .then(function (sourceChart) {
          if (angular.isUndefined(sourceChart)) {
            toastr.info($translate.instant('messages.There is no chart in the previous scene to duplicate'));
            throw new Error('break-q-chain');
          }
          return dbCharts.addDuplicateOfChartInSceneAtIndex(sourceChart._id, vm.selectedSceneId, insertIndex, asNextChart);
        })
        .then(function (newChartId) {
          toastr.success($translate.instant('messages.Chart added.'));
          if (vm.insertedChartId === newChartId) {
            selectChartById(newChartId);
            vm.insertedChartId = undefined;
          } else {
            vm.insertedChartId = newChartId;
          }
        })
        .catch(function (error) {
          if (error.message !== 'break-q-chain') {
            swaUtils.showErrorToast(
              error,
              $translate.instant('errormessages.Error adding chart!')
            );
          }
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.stop();
        });
    }

    function insertChart(chart) {
      dbCharts.insert(chart)
        .then(function (newChartId) {
          toastr.success($translate.instant('messages.Chart added.'));
          if (vm.insertedChartId === newChartId) {
            selectChartById(newChartId);
            vm.insertedChartId = undefined;
          } else {
            vm.insertedChartId = newChartId;
          }
        })
        .catch(function (error) {
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error adding chart!')
          );
        })
        .finally(function () {
          ngProgressLite.done();
          blockUI.stop();
        });
    }

    function updateChartItemViewFactory() {
      if (angular.isUndefined(vm.chartItemViewFactory)) {
        vm.chartItemViewFactory = new ChartItemViewFactory();
        vm.chartItemViewFactory.imageDataPrefixUrl = swaConfig.imageDataPrefixUrl;

        vm.permanentChartLayerView.setChartItemViewFactory(vm.chartItemViewFactory);
        vm.semiChartLayerView.setChartItemViewFactory(vm.chartItemViewFactory);
        vm.dynamicChartLayerView.setChartItemViewFactory(vm.chartItemViewFactory);
        vm.userChartLayerView.setChartItemViewFactory(vm.chartItemViewFactory);
      }

      if (angular.isDefined(vm.selectedProduction)) {
        vm.chartItemViewFactory.stageUnitWidth = vm.selectedProduction.stagesettings.stagewidth;
        vm.chartItemViewFactory.stageUnitDepth = vm.selectedProduction.stagesettings.stagedepth;
        vm.chartItemViewFactory.offstageUnitWidth = vm.selectedProduction.stagesettings.offstagewidth;
        vm.chartItemViewFactory.swMeasurementUnit = vm.selectedProduction.stagesettings.stagemeasurementunit;
        vm.chartItemViewFactory.numberlineMarkerStepValue = vm.selectedProduction.stagesettings.numberlineMarkerStepValue;
        vm.chartItemViewFactory.numberlineZeroAtCenter = vm.selectedProduction.stagesettings.numberlineZeroAtCenter;
        vm.chartItemViewFactory.numberlineMultiplier = vm.selectedProduction.stagesettings.numberlineMultiplier;
        vm.chartItemViewFactory.verticalNumberlineMarkerStepValue = vm.selectedProduction.stagesettings.verticalNumberlineMarkerStepValue;
        vm.chartItemViewFactory.verticalNumberlineMultiplier = vm.selectedProduction.stagesettings.verticalNumberlineMultiplier;
        vm.chartItemViewFactory.verticalNumberlineZeroOffsetValue = vm.selectedProduction.stagesettings.verticalNumberlineZeroOffsetValue;
        vm.chartItemViewFactory.scaleAllPerformers = vm.scalePerformers.allPerformers;
        vm.chartItemViewFactory.scaleSelectedPerformers = vm.scalePerformers.selectedPerformers;
      }
    }

    function markChartDirty() {
      if (vm.selectedScene.accessRules.allowaddcharttextpersonal) {
        if (vm.selectedUserChart) {
          vm.selectedUserChart.dirty = true;
        }
      } else {
        if (vm.selectedChart) {
          vm.selectedChart.dirty = true;
        }
      }
    }

    function saveChart(chartData, autoSave) {
      var deferred = $q.defer();
      if (angular.isUndefined(chartData)) {
        deferred.resolve();

        return deferred.promise;
      }

      ngProgressLite.start();
      if (!autoSave) {
        blockUI.start();
      }

      var updatedChart = {};
      updatedChart._id = chartData._id;
      updatedChart.cuelinetext = chartData.cuelinetext;
      updatedChart.customname = chartData.customname;
      updatedChart.notes = chartData.notes;
      updatedChart.notesvisible = chartData.notesvisible;
      updatedChart.thumbimage = chartData.thumbimage;

      // TODO: re-visit below
      // Insert/Update chart items if needed.
      // Update itemIds property of chart

      ngProgressLite.set(0.4);
      dbChartItems.getItemIdsOfChart(chartData._id)
        .then(function (existingChartItemIds) {
          return saveChartItems(chartData, existingChartItemIds);
        })
        .then(function () {
          return dbCharts.update(updatedChart);
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('ChartEditorController.saveChart:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving chart!')
          );
          deferred.reject(error);
        })
        .finally(function () {
          ngProgressLite.done();
          if (!autoSave) {
            blockUI.stop();
          }
        });

      return deferred.promise;
    }

    function saveUserChart(userChartData, autoSave) {
      var deferred = $q.defer();
      if (angular.isUndefined(userChartData)) {
        deferred.resolve();

        return deferred.promise;
      }

      ngProgressLite.start();

      if (!autoSave) {
        blockUI.start();
      }

      var isNewUserChart = angular.isUndefined(userChartData.created);
      var hasChartItems = userChartData.items.length > 0

      if (isNewUserChart && !hasChartItems) {
        $log.debug('ChartEditorController.saveUserChart: No items in new user chart, nothing to save!');
        deferred.resolve();

        ngProgressLite.done();
        if (!autoSave) {
          blockUI.stop();
        }

        return deferred.promise;
      }

      var updatedUserChart = {};
      updatedUserChart._id = userChartData._id;
      updatedUserChart.chartId = userChartData.chartId;
      updatedUserChart.productionId = userChartData.productionId;
      updatedUserChart.userId = userChartData.userId;

      dbUserCharts.update(updatedUserChart)
        .then(function () {
          ngProgressLite.set(0.4);
          return dbChartItems.getItemIdsOfUserChart(updatedUserChart._id);
        })
        .then(function (existingChartItemIds) {
          return saveUserChartItems(userChartData, existingChartItemIds);
        })
        .then(function () {
          deferred.resolve();
        })
        .catch(function (error) {
          $log.error('ChartEditorController.saveUserChart:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error saving chart!')
          );
          deferred.reject(error);
        })
        .finally(function () {
          ngProgressLite.done();
          if (!autoSave) {
            blockUI.stop();
          }
        });

      return deferred.promise;
    }

    function saveChartItems(chartData, existingChartItemIds) {
      var existingItemIds = existingChartItemIds;
      var updatedItemIds = [];
      var updatedItems = [];
      var insertedItems = [];

      chartData.items.forEach(function (chartItem) {
        var id = chartItem._id;
        if (!id.startsWith('__tmp__') || _.contains(existingChartItemIds, id)) {
          chartItem.ofchartId = chartData._id;
          updatedItemIds.push(id);
          updatedItems.push(chartItem);
        } else {
          delete chartItem._id;
          chartItem.ofchartId = chartData._id;
          insertedItems.push(chartItem);
        }
      });
      var deletedItemIds = _.difference(existingItemIds, updatedItemIds);

      var allQ = [];
      insertedItems.forEach(function (insertedItem) {
        var insertQ = dbChartItems.insert(insertedItem)
          .then(function (result) {
            insertedItem._id = result;
          })
        allQ.push(insertQ);
      });
      updatedItems.forEach(function (updatedItem) {
        allQ.push(dbChartItems.update(updatedItem));
      });
      allQ.push(dbChartItems.delete(deletedItemIds));

      return $q.all(allQ);
    }

    function saveUserChartItems(userChartData, existingChartItemIds) {
      var existingItemIds = existingChartItemIds;
      var updatedItemIds = [];
      var updatedItems = [];
      var insertedItems = [];

      userChartData.items.forEach(function (chartItem) {
        var id = chartItem._id;
        if (angular.isDefined(id) && !id.startsWith('__tmp__')) {
          chartItem.ofUserChartId = userChartData._id;
          chartItem.ofchartId = userChartData.chartId;
          chartItem.ofUserProduction = userChartData.productionId;
          chartItem.ofUserId = userChartData.userId;
          updatedItemIds.push(id);
          updatedItems.push(chartItem);
        } else {
          delete chartItem._id;
          chartItem.ofUserChartId = userChartData._id;
          chartItem.ofchartId = userChartData.chartId;
          chartItem.ofUserProduction = userChartData.productionId;
          chartItem.ofUserId = userChartData.userId;
          insertedItems.push(chartItem);
        }
      });
      var deletedItemIds = _.difference(existingItemIds, updatedItemIds);

      var allQ = [];
      insertedItems.forEach(function (insertedItem) {
        allQ.push(dbChartItems.insert(insertedItem));
      });
      updatedItems.forEach(function (updatedItem) {
        allQ.push(dbChartItems.update(updatedItem));
      });
      allQ.push(dbChartItems.delete(deletedItemIds));

      return $q.all(allQ);
    }

    function switchEditor(index, navParams) {
      var params = {
        productionId: selectedProductionId,
        lockModeNavigation: vm.chartEditorState.lockModeNavigation,
        selectedScene: vm.selectedScene,
        navParams: navParams
      };
      if (index === 1) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.staffeditor, params);
      } else if (index === 2) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.chartstaffeditor, params);
      } else if (index === 3) {
        blockUI.start();
        if (vm.chartEditorState.lockModeNavigation) {
          swaUtils.stateGo(swaRouterStateNames.scripteditorbookview, params);
        } else {
          swaUtils.stateGo(swaRouterStateNames.scripteditor, params);
        }
      } else if (index === 4) {
        blockUI.start();
        swaUtils.stateGo(swaRouterStateNames.chartscripteditor, params);
      }
    }

    function unregisterFetches() {
      dbProductions.fetchUnregister();
      dbPerformers.fetchUnregister();
      dbSetPieces.fetchUnregister();
      dbScenes.fetchUnregister();
      dbCharts.fetchUnregister();
    }

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
      if (!swaUtils.isRouterCurrentStateName(toState.name)) {
        // saveActiveChart();
        unloadChart();
      }
    });

    $scope.$on('$destroy', function () {
      killAutoSaveTimer();
      swPdfPrintService.unregisterForChange(vm);
      _ccChartKillPause();
      stopCocos();
      unregisterFetches();
      unregisterKeyboardHandler();
    });

    function toggleSemiLayer() {
      if (vm.semiChartLayerView.getIsActive()) {
        deactivateSemiPermanentLayer();
      } else {
        activateSemiPermanentLayer();
      }
    }

    function toggleDynLayer() {
      if (vm.dynamicChartLayerView.getIsActive()) {
        deactivateDynamicLayer();
      } else {
        activateDynamicLayer();
      }
    }

    function activateSemiPermanentLayer() {
      if (vm.semiChartLayerView.getIsActive()) {
        return;
      }

      deactivateDynamicLayer();

      vm.semiChartLayerView.activate(true);
      vm.semiChartLayerView.setSelectionRotationMode(vm.chartInspectorState.selectionRotationMode);
      vm.semiChartLayerView.setSelectionSnapToGridMode(vm.chartInspectorState.selectionSnapToGrid);

      vm.chartEditorState.semiLayerActive = true;
      vm.chartEditorState.layerActive = true;

      ccChartEditorLayer.bringChildToFront(vm.semiChartLayerView);

      if (!vm.chartInspectorState.isContextMenuPinned) {
        hideChartContextMenu();
      }
      hideSideBarDeleteAndMoveOptions();
    }

    function deactivateSemiPermanentLayer() {
      if (!vm.semiChartLayerView.getIsActive()) {
        return;
      }

      vm.semiChartLayerView.activate(false);

      vm.chartEditorState.semiLayerActive = false;
      vm.chartEditorState.layerActive = false;

      ccChartEditorLayer.bringChildToFront(vm.dynamicChartLayerView);

      updateChartThumbnailAt1x();

      if (!vm.chartInspectorState.isContextMenuPinned) {
        hideChartContextMenu();
      }
      hideSideBarDeleteAndMoveOptions();
    }

    function activateDynamicLayer() {
      if (vm.dynamicChartLayerView.getIsActive() || vm.chartEditorState.lockModeNavigation) {
        return;
      }

      deactivateSemiPermanentLayer();

      vm.dynamicChartLayerView.activate(true);

      vm.dynamicChartLayerView.setSelectionRotationMode(vm.chartInspectorState.selectionRotationMode);
      vm.dynamicChartLayerView.setSelectionSnapToGridMode(vm.chartInspectorState.selectionSnapToGrid);


      vm.chartEditorState.dynLayerActive = true;
      vm.chartEditorState.layerActive = true;

      if (!vm.chartInspectorState.isContextMenuPinned) {
        hideChartContextMenu();
      }
      hideSideBarDeleteAndMoveOptions();
    }

    function deactivateDynamicLayer() {
      if (!vm.dynamicChartLayerView.getIsActive()) {
        return;
      }

      vm.dynamicChartLayerView.activate(false);

      vm.chartEditorState.dynLayerActive = false;
      vm.chartEditorState.layerActive = false;

      updateChartThumbnailAt1x();

      if (!vm.chartInspectorState.isContextMenuPinned) {
        hideChartContextMenu();
      }
      hideSideBarDeleteAndMoveOptions();
    }

    function activateUserLayer() {
      if (vm.userChartLayerView.getIsActive() || vm.chartEditorState.lockModeNavigation) {
        return;
      }

      deactivateSemiPermanentLayer();
      deactivateDynamicLayer();

      vm.userChartLayerView.activate(true);

      vm.userChartLayerView.setSelectionRotationMode(vm.chartInspectorState.selectionRotationMode);
      vm.userChartLayerView.setSelectionSnapToGridMode(vm.chartInspectorState.selectionSnapToGrid);


      vm.chartEditorState.userLayerActive = true;
      vm.chartEditorState.layerActive = true;

      if (!vm.chartInspectorState.isContextMenuPinned) {
        hideChartContextMenu();
      }
      hideSideBarDeleteAndMoveOptions();
    }

    function deactivateUserLayer() {
      if (!vm.userChartLayerView.getIsActive()) {
        return;
      }

      vm.userChartLayerView.activate(false);

      vm.chartEditorState.userLayerActive = false;
      vm.chartEditorState.layerActive = false;

      // updateChartThumbnailAt1x();
      if (!vm.chartInspectorState.isContextMenuPinned) {
        hideChartContextMenu();
      }
      hideSideBarDeleteAndMoveOptions();
    }

    // Chart delete move option hint
    function deleteMoveOptionHintPrompt() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/chartEditor/deleteMoveOptionHintPrompt.html',
        controller: 'DeleteMoveOptionHintController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });
    }
    // Chart Toggle Visibility prompt
    function toggleToolbarVisibilityPromt() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/chartEditor/toggleToolbarVisibilityPromt.html',
        controller: 'ToggleToolbarVisibilityController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });
    }

    // Chart Toggle Visibility prompt
    function restoreChartPermissionAlert() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/chartEditor/restoreChartPermissionMessage.html',
        controller: 'RestoreChartPermissionMessageController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });
    }

    // Chart Delete Warning prompt
    function deleteChartPrompt() {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/chartEditor/deleteChartPrompt.html',
        controller: 'DeleteChartController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });
      if (vm.deleteMultipleCharts) {
        modalInstance.result.then(deleteSelectedCharts);
      } else {
        modalInstance.result.then(deleteSingleChart);
      }
    }

    function toggleToolbarVisibility() {
      vm.chartEditorState.inspectorVisible = !vm.chartEditorState.inspectorVisible;

      saveEditorPreferences();
    }

    function shapePickerDidPickShape(shapeType) {
      vm.shapePicker.show = false;

      if (shapeType === SWChartItem.ShapeType.Freehand) {
        showFreehandTool();
        return;
      }

      if (vm.semiChartLayerView.getIsActive()) {
        vm.semiChartLayerView.addNewShapeOfType(shapeType);
      } else if (vm.dynamicChartLayerView.getIsActive()) {
        vm.dynamicChartLayerView.addNewShapeOfType(shapeType);
      }
    }

    function showPerformerPicker() {
      if (vm.chartEditorState.performerPickerDocked) {
        vm.performerPicker.show = false;
        // resetMediaDockState();
        vm.chartEditorState.performerPickerDockedOpen = !vm.chartEditorState.performerPickerDockedOpen;
      }

      saveEditorPreferences();
    }

    function dockPerformerPicker() {
      vm.performerPicker.show = false;

      vm.chartEditorState.performerPickerDocked = true;
      vm.chartEditorState.performerPickerDockedOpen = true;
      // resetMediaDockState();
      saveEditorPreferences();
    }

    function toggleMediaDock() {
      if (vm.chartEditorState.mediaDrawerOpen) {
        if (vm.chartEditorState.performerPickerDocked && vm.chartEditorState.performerPickerDockedOpen) {
          vm.chartEditorState.performerPickerDockedOpen = false;
          return;
        }
      } else {
        vm.chartEditorState.performerPickerDockedOpen = false;

      }

      vm.chartEditorState.mediaDrawerOpen = !vm.chartEditorState.mediaDrawerOpen;
      vm.mediaDockState.viewState = true;
      saveEditorPreferences();
    }

    function toggleEditMediaState() {
      vm.mediaDockState.viewState = !vm.mediaDockState.viewState;
      vm.showHelpBar = vm.mediaDockState.viewState;
    }

    function floatPerformerPicker() {
      $scope.$applyAsync(function () {
        vm.chartEditorState.performerPickerDocked = false;
        vm.chartEditorState.performerPickerDockedOpen = false;
        $timeout(function () {
          vm.performerPicker.show = true;
        }, 500);

        saveEditorPreferences();
      });
    }

    function performerPickerDidPickPerformer(performer) {
      vm.performerPicker.show = false;

      if (vm.dynamicChartLayerView.getIsActive()) {
        vm.dynamicChartLayerView.addNewPerformer(performer);
      }
    }

    function setPiecePickerDidPickSetPiece(setPiece) {
      vm.setPiecePicker.show = false;

      if (vm.semiChartLayerView.getIsActive()) {
        vm.semiChartLayerView.addNewSetPiece(setPiece);
      } else if (vm.dynamicChartLayerView.getIsActive()) {
        vm.dynamicChartLayerView.addNewSetPiece(setPiece);
      }
    }

    function addChartText() {
      vm.notesPicker.show = false;

      chartNotifyDisableChangeTracking();

      if (vm.semiChartLayerView.getIsActive()) {
        vm.semiChartLayerView.addNewTextItem(vm.defaultChartTextSettings);
      } else if (vm.dynamicChartLayerView.getIsActive()) {
        vm.dynamicChartLayerView.addNewTextItem(vm.defaultChartTextSettings);
      }

      chartNotifyEnableChangeTracking();
    }

    function addChartTextPersonal() {
      vm.notesPicker.show = false;

      chartNotifyDisableChangeTracking();

      vm.userChartLayerView.addNewTextPersonalItem(vm.userId, vm.defaultChartTextSettings);

      chartNotifyEnableChangeTracking();
    }

    function toggleChartNotes() {
      vm.notesPicker.show = false;

      vm.selectedChart.notesvisible = !vm.selectedChart.notesvisible;

      vm.selectedChart.dirty = true;
    }

    /**
     * Show the media edit prompt modal.
     * @param {ChartItemMedia} chartItemMedia
     */
    function showMediaEditPrompt(chartItemMedia) {
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/chartEditor/editMediaPrompt.html',
        controller: 'EditMediaPromptController',
        controllerAs: 'vm',
        size: '480',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
        resolve: {
          mediaDetails: function () {
            if (angular.isDefined(chartItemMedia)) {
              return chartItemMedia.mediadetails;
            }
          }
        }
      });

      modalInstance.result.then(
        function (updatedMedia) {
          if (angular.isDefined(chartItemMedia)) {
            updateChartMedia(chartItemMedia, updatedMedia);
          } else {
            addChartMedia(updatedMedia);
          }
        }
      );
    }

    $scope.$watch('vm.zoomPicker.show', function (newValue, oldValue) {
      if (newValue === true) {
        $timeout(function () {
          $scope.$broadcast('reCalcViewDimensions');
          $scope.$broadcast('rzSliderForceRender');
        }, 500);
      }
    });

    $scope.$watch('vm.setPiecePicker.show', function (newValue, oldValue) {
      if (newValue === false) {
        clearSearchForSetpice();
        angular.element($document[0].body).removeClass('setpiece-or-performer-picker-active');
      }
      if (newValue === true) {
        $timeout(function () {
          $('.sw-popover-setpiece-picker').mCustomScrollbar(vm.scrollConfigGenericPopover);
          angular.element($document[0].body).addClass('setpiece-or-performer-picker-active');
        }, 500);
      }
    });

    $scope.$watch('vm.performerPicker.show', function (newValue, oldValue) {
      clearSearchForPerformer(newValue, oldValue);
      if (newValue === false) {
        angular.element($document[0].body).removeClass('setpiece-or-performer-picker-active');
      }
      if (newValue === true) {
        $timeout(function () {
          $('.sw-popover-performer-picker').mCustomScrollbar(vm.scrollConfigGenericPopover);
          angular.element($document[0].body).addClass('setpiece-or-performer-picker-active');
        }, 500);
      }
    });

    $scope.$watch('vm.chartEditorState.performerPickerDockedOpen', function (newValue, oldValue) {
      clearSearchForPerformer(newValue, oldValue);
    });

    function onZoomSliderChange() {
      onZoomChangeEnd();
    }

    function onZoomChangeEnd(updateInstantly) {
      updateInstantly = updateInstantly || false;

      var oldZoomFactor = Math.round(vm.chartGridView.getZoomFactor());
      if (oldZoomFactor === 1) {
        vm.chartPanScrollParams.vertical.scrollPercent = 50;
        vm.chartPanScrollParams.horizontal.scrollPercent = 50;
      }

      var targetZoomFactor = vm.chartEditorState.zoomFactor;

      ccChartEditorLayer.enablePanGestures((targetZoomFactor !== 1));

      if (updateInstantly) {
        _setZoomFactor(targetZoomFactor);
        // updateChartPanScrollbars();

        return;
      }

      chartBlockUI.start();

      var changeSteps = 10;
      var changeTimeMs = 300;
      var zoomStepDelta = (targetZoomFactor - oldZoomFactor) / changeSteps;
      var zoomFactor = oldZoomFactor;
      var zoomChangeInterval = $interval(function () {
        zoomFactor = zoomFactor + zoomStepDelta;
        _setZoomFactor(zoomFactor);
      }, (changeTimeMs / changeSteps), changeSteps);

      zoomChangeInterval.finally(
        function () {
          updateChartPanScrollbars();
          var updateTimeout = $timeout(function () {
            chartBlockUI.stop();
            $timeout.cancel(updateTimeout);
            updateTimeout = undefined;
          }, 200);
        });
    }

    function _setZoomFactor(zoomFactor) {
      vm.chartGridView.setZoomFactor(zoomFactor);

      // TODO: Not sure if we need to update layer positions
      var stageViewPosition = vm.chartGridView.getStageViewPosition();
      var stageViewSize = vm.chartGridView.getStageViewSize();

      vm.permanentChartLayerView.setPosition(stageViewPosition);
      vm.permanentChartLayerView.setContentSize(stageViewSize);
      vm.semiChartLayerView.setPosition(stageViewPosition);
      vm.semiChartLayerView.setContentSize(stageViewSize);
      vm.dynamicChartLayerView.setPosition(stageViewPosition);
      vm.dynamicChartLayerView.setContentSize(stageViewSize);
      vm.userChartLayerView.setPosition(stageViewPosition);
      vm.userChartLayerView.setContentSize(stageViewSize);

      vm.permanentChartLayerView.willChangeZoom();
      vm.semiChartLayerView.willChangeZoom();
      vm.dynamicChartLayerView.willChangeZoom();
      vm.userChartLayerView.willChangeZoom();

      vm.chartItemViewFactory.scalePxPerUnitX = vm.chartGridView.getScalePxPerUnitX();
      vm.chartItemViewFactory.scalePxPerUnitY = vm.chartGridView.getScalePxPerUnitY();
      vm.chartItemViewFactory.scaledStagePxWidth = vm.chartGridView.getScaledStageBounds().width;
      vm.chartItemViewFactory.scaledStagePxHeight = vm.chartGridView.getScaledStageBounds().height;
      vm.chartItemViewFactory.scaledStagePxOffset = vm.chartGridView.getZoomOffset();
      vm.chartItemViewFactory.stageViewSize = vm.chartGridView.getStageViewSize();
      vm.chartItemViewFactory.zoomFactor = vm.chartGridView.getZoomFactor();

      vm.permanentChartLayerView.refresh();
      vm.semiChartLayerView.refresh();
      vm.dynamicChartLayerView.refresh();
      vm.userChartLayerView.refresh();

      var stageViewBounds = vm.chartGridView.getStageViewBounds();
      var scaledStageBounds = vm.chartGridView.getScaledStageBounds();

      vm.chartPanScrollParams.vertical.maxOffset = scaledStageBounds.height - stageViewBounds.height;
      vm.chartPanScrollParams.horizontal.maxOffset = scaledStageBounds.width - stageViewBounds.width;

      updateChartZoomOffset();

      vm.permanentChartLayerView.didChangeZoom();
      vm.semiChartLayerView.didChangeZoom();
      vm.dynamicChartLayerView.didChangeZoom();
      vm.userChartLayerView.didChangeZoom();

      ccChartUpdateNow();
    }

    function onChartPanVScroll(scrollPercent) {
      if (!vm.chartPanScrollParams.ignorePan && (vm.chartPanScrollParams.vertical.scrollPercent !== scrollPercent)) {
        vm.chartPanScrollParams.vertical.scrollPercent = scrollPercent;
        updateChartZoomOffset();
      }
    }

    function onChartPanHScroll(scrollPercent) {
      if (!vm.chartPanScrollParams.ignorePan && (vm.chartPanScrollParams.horizontal.scrollPercent !== scrollPercent)) {
        vm.chartPanScrollParams.horizontal.scrollPercent = scrollPercent;
        updateChartZoomOffset();
      }
    }

    function updateChartZoomOffset() {
      if (angular.isUndefined(vm.chartGridView)) {
        return;
      }

      var newOffset = {};
      if (vm.chartEditorState.povAudience) {
        newOffset.x = -vm.chartPanScrollParams.horizontal.maxOffset * vm.chartPanScrollParams.horizontal.scrollPercent / 100;
        newOffset.y = -vm.chartPanScrollParams.vertical.maxOffset * vm.chartPanScrollParams.vertical.scrollPercent / 100;
      } else {
        newOffset.x = -vm.chartPanScrollParams.horizontal.maxOffset * (100 - vm.chartPanScrollParams.horizontal.scrollPercent) / 100;
        newOffset.y = -vm.chartPanScrollParams.vertical.maxOffset * (100 - vm.chartPanScrollParams.vertical.scrollPercent) / 100;
      }

      vm.chartGridView.setZoomOffset(newOffset);

      vm.chartItemViewFactory.scaledStagePxOffset = vm.chartGridView.getZoomOffset();

      vm.permanentChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());
      vm.semiChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());
      vm.dynamicChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());
      vm.userChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());

      ccChartUpdateNow();
    }

    var panRefZoomOffset = {};

    function handleChartPanBegin() {
      panRefZoomOffset = vm.chartGridView.getZoomOffset();
    }

    function handleChartPanPan(beginPoint, point) {
      var panDeltaX = beginPoint.x - point.x;
      var panDeltaY = beginPoint.y - point.y;

      var newOffset = {}
      if (vm.chartEditorState.povAudience) {
        newOffset.x = panRefZoomOffset.x - panDeltaX;
        newOffset.y = panRefZoomOffset.y - panDeltaY;

        if (vm.chartPanScrollParams.horizontal.maxOffset > 0) {
          vm.chartPanScrollParams.horizontal.scrollPercent = newOffset.x * 100 / -vm.chartPanScrollParams.horizontal.maxOffset;
        }
        if (vm.chartPanScrollParams.vertical.maxOffset > 0) {
          vm.chartPanScrollParams.vertical.scrollPercent = newOffset.y * 100 / -vm.chartPanScrollParams.vertical.maxOffset;
        }
      } else {
        newOffset.x = panRefZoomOffset.x + panDeltaX;
        newOffset.y = panRefZoomOffset.y + panDeltaY;

        if (vm.chartPanScrollParams.horizontal.maxOffset > 0) {
          vm.chartPanScrollParams.horizontal.scrollPercent = 100 - (newOffset.x * 100 / -vm.chartPanScrollParams.horizontal.maxOffset);
        }
        if (vm.chartPanScrollParams.vertical.maxOffset > 0) {
          vm.chartPanScrollParams.vertical.scrollPercent = 100 - newOffset.y * 100 / -vm.chartPanScrollParams.vertical.maxOffset;
        }
      }

      vm.chartGridView.setZoomOffset(newOffset);

      vm.chartItemViewFactory.scaledStagePxOffset = vm.chartGridView.getZoomOffset();

      vm.permanentChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());
      vm.semiChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());
      vm.dynamicChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());
      vm.userChartLayerView.setStageViewOffset(vm.chartGridView.getZoomOffset());

      ccChartUpdateNow();
      // updateChartPanScrollbars();
    }

    function handleChartPanEnd() {
      updateChartPanScrollbars();
    }

    function fitChartToView() {
      if (cc && cc.view) {
        cc.view.setDesignResolutionSize(SWChartUI.DesignWidth, SWChartUI.DesignHeight, cc.ResolutionPolicy.SHOW_ALL);
        ccUpdateViewScale();
        updateChartPanScrollbars();
      }
    }

    function updateInspectorState(caller) {
      if (angular.isUndefined(caller)) {
        if (vm.semiChartLayerView.getIsActive()) {
          caller = vm.semiChartLayerView;
        } else if (vm.dynamicChartLayerView.getIsActive()) {
          caller = vm.dynamicChartLayerView;
        } else if (vm.userChartLayerView.getIsActive()) {
          caller = vm.userChartLayerView;
        }
      }

      if (angular.isUndefined(caller)) {
        vm.chartInspectorState.selectionCount = 0;
        vm.chartInspectorState.performerSelected = false;
        vm.chartInspectorState.setPieceSelected = false;
        vm.chartInspectorState.shapesSelected = false;
        return;
      }

      var hasGroup = (angular.isDefined(caller.chartItemGroupView));
      var selectionCount = (hasGroup ? 0 : caller.selectedChartItemViews.length);

      vm.chartInspectorState.selectionCount = selectionCount;
      vm.chartInspectorState.selectionGrouped = hasGroup;
      vm.chartInspectorState.canPaste = (angular.isArray(vm.clipboardItems) && (vm.clipboardItems.length > 0));

      if (hasGroup) {
        vm.chartInspectorState.selectionRotateable = true;
        vm.chartInspectorState.rotationDeg = Math.round(caller.chartItemGroupView.getViewRotationDeg());
      }

      vm.chartInspectorState.headRotateable = false;

      if (selectionCount === 1) {
        var activeChartItemView = caller.activeChartItemView;

        vm.chartInspectorState.selectionRotateable = activeChartItemView.getIsRotatable();
        vm.chartInspectorState.rotationDeg = Math.round(activeChartItemView.getViewRotationDeg());

        vm.chartInspectorState.selectionOrderingMode = activeChartItemView.getIsZOrdering();

        vm.chartInspectorState.selectionEditable = activeChartItemView.getIsEditable();

        vm.chartInspectorState.zIndex = activeChartItemView.getZIndex();

        if (activeChartItemView.getItemType() === SWChartItem.Type.Shape) {
          vm.chartInspectorState.selectionColorable = activeChartItemView.getSupportsLineColor();
          vm.chartInspectorState.selectionColor = activeChartItemView.getLineColorCss();

          vm.chartInspectorState.selectionFillColorable = activeChartItemView.getSupportsFillColor();
          vm.chartInspectorState.selectionFillColor = activeChartItemView.getFillColorCss();
        } else {
          vm.chartInspectorState.selectionColorable = false;
          vm.chartInspectorState.selectionFillColorable = false;
        }

        // if (activeChartItemView.getItemType() == SWChartItem.Type.Performer) {
        //   vm.chartInspectorState.headRotationDeg = activeChartItemView.getHeadRotationDeg();
        //
        //   vm.chartInspectorState.headRotateable = activeChartItemView.getShowNose();
        // }
        vm.chartInspectorState.selectionFlipAble = activeChartItemView.getIsFlippable();

        if (activeChartItemView.getItemType() === SWChartItem.Type.SetPiece) {
          vm.chartInspectorState.setPieceSelected = true;
        } else {
          vm.chartInspectorState.setPieceSelected = false;
        }
      }

      var selectedChartItemViews = caller.selectedChartItemViews;

      if (vm.chartInspectorState.selectionCount === 0) {
        vm.chartInspectorState.performerSelected = false;
        vm.chartInspectorState.setPieceSelected = false;
        vm.chartInspectorState.shapesSelected = false;
        vm.selectedPerformers = [];
      } else {
        var allPerformers = true;
        var allShapes = true;
        var performersList = [];

        selectedChartItemViews.forEach(function (chartItemView) {
          var itemType = chartItemView.getItemType();
          if (itemType === SWChartItem.Type.Performer) {
            performersList.push(chartItemView.chartItemPerformer);
            allShapes = false;
          } else if (itemType === SWChartItem.Type.Shape) {
            allPerformers = false;
          } else {
            allPerformers = false;
            allShapes = false;
          }
        });

        vm.chartInspectorState.shapesSelected = allShapes;
        vm.chartInspectorState.performerSelected = allPerformers;
        vm.chartInspectorState.performersCount = vm.performers.length;
        vm.selectedPerformers = performersList;
      }

      if (selectionCount > 1) {
        vm.chartInspectorState.setPieceSelected = false;
      }

      $timeout(function () {
        $scope.$apply();
      });
    }

    function editVectorShape(chartItemShapeView) {
      killAutoSaveTimer();
      vm.chartEditorState.zoomFactor = 1.0;
      onZoomChangeEnd(true);

      vm.chartShapeVectorEditorView = new ChartShapeVectorEditorView();
      vm.chartShapeVectorEditorView.delegate = vm;
      vm.chartShapeVectorEditorView.chartItemViewFactory = vm.chartItemViewFactory;
      vm.chartShapeVectorEditorView.setPovAudience(vm.chartEditorState.povAudience);
      vm.chartShapeVectorEditorView.setPosition(vm.chartGridView.getStageViewPosition());
      vm.chartShapeVectorEditorView.setContentSize(vm.chartGridView.getStageViewSize());
      ccChartEditorLayer.addChild(vm.chartShapeVectorEditorView);
      ccChartEditorLayer.bringChildToFront(vm.chartShapeVectorEditorView);
      vm.chartShapeVectorEditorView.beginEditingShapeInView(chartItemShapeView);

      vm.chartEditorState.inspectorVisible = true;
      vm.chartInspectorState.vectorEditorActive = true;
      vm.chartInspectorState.vectorEditorNodeSelected = false;
      vm.chartInspectorState.layerEditorActive = true;
      vm.chartInspectorState.lineThickness = (chartItemShapeView.chartItemShape.linethickness / 2) + 1;

      chartItemShapeView.parent.setUserInteractionEnabled(false);

      chartNotifyDisableChangeTracking();
    }

    function endEditVectorShape() {
      if (angular.isDefined(vm.chartShapeVectorEditorView)) {
        var chartItemShapeView = vm.chartShapeVectorEditorView.endEditing();
        ccChartEditorLayer.removeChild(vm.chartShapeVectorEditorView);
        vm.chartShapeVectorEditorView = undefined;

        vm.chartInspectorState.vectorEditorActive = false;
        vm.chartInspectorState.vectorEditorNodeSelected = false;
        vm.chartInspectorState.layerEditorActive = false;

        chartItemShapeView.parent.setUserInteractionEnabled(true);
        chartItemShapeView.refresh();

        chartNotifyEnableChangeTracking();
        chartNotifyDataDidChange();
        startAutoSaveTimer();
      }
    }

    function showFreehandTool() {
      killAutoSaveTimer();
      vm.chartEditorState.zoomFactor = 1.0;
      onZoomChangeEnd(true);

      vm.chartShapeFreehandToolView = new ChartShapeFreehandToolView();
      vm.chartShapeFreehandToolView.delegate = vm;
      vm.chartShapeFreehandToolView.chartItemViewFactory = vm.chartItemViewFactory;
      vm.chartShapeFreehandToolView.setPovAudience(vm.chartEditorState.povAudience);
      vm.chartShapeFreehandToolView.setPosition(vm.chartGridView.getStageViewPosition());
      vm.chartShapeFreehandToolView.setContentSize(vm.chartGridView.getStageViewSize());
      vm.chartShapeFreehandToolView.setHasArrowhead(vm.chartInspectorState.freehandHasArrowhead);
      vm.chartShapeFreehandToolView.setLineColorCss(vm.chartInspectorState.selectionColor);
      ccChartEditorLayer.addChild(vm.chartShapeFreehandToolView);
      ccChartEditorLayer.bringChildToFront(vm.chartShapeFreehandToolView);

      vm.chartShapeFreehandToolView.initializeTool();

      vm.chartEditorState.inspectorVisible = true;
      vm.chartInspectorState.freehandToolActive = true;
      vm.chartInspectorState.layerEditorActive = true;
    }

    function closeFreehandTool() {
      if (angular.isDefined(vm.chartShapeFreehandToolView)) {
        ccChartEditorLayer.removeChild(vm.chartShapeFreehandToolView);
        vm.chartShapeFreehandToolView = undefined;

        vm.chartInspectorState.freehandToolActive = false;
        vm.chartInspectorState.layerEditorActive = false;
        startAutoSaveTimer();
      }
    }

    function editTextBox(chartItemTextView) {
      killAutoSaveTimer();
      chartItemTextView.setEditing(true);

      vm.chartEditorState.inspectorVisible = true;
      vm.chartInspectorState.textBoxText = '';
      vm.chartInspectorState.textBoxRichText = '';
      vm.chartInspectorState.layerEditorActive = true;

      vm.chartInspectorState.editingChartItemTextView = chartItemTextView;
      vm.chartInspectorState.defaultTextSettings = chartItemTextView.chartItemText.defaultTextSettings;
      // chartItemTextView.parent.setUserInteractionEnabled(false);

      chartNotifyDisableChangeTracking();

      $timeout(function () {
        var canvas = $document[0].getElementById('chartCanvas');
        var canvasContainer = $document[0].getElementById('chartCanvasContainer');

        var canvasContainerWidth = canvasContainer.offsetWidth;
        var canvasContainerHeight = canvasContainer.offsetHeight;
        var canvasWidth = canvas.offsetWidth;
        var canvasHeight = canvas.offsetHeight;

        var element = angular.element('.inspector-texteditor-textarea');
        element.trigger('focus');
        vm.chartInspectorState.textBoxText = chartItemTextView.chartItemText.textcontent;
        if (angular.isUndefined(chartItemTextView.chartItemText.richtextcontent)) {
          vm.chartInspectorState.textBoxRichText = vm.chartInspectorState.textBoxText;
        } else {
          vm.chartInspectorState.textBoxRichText = chartItemTextView.chartItemText.richtextcontent;
        }

        vm.chartInspectorState.selectionBackgroundColor = chartItemTextView.chartItemText.backgroundcolor;

        if (vm.chartEditorState.povAudience) {
          var startPointX = ((canvasContainerWidth - canvasWidth) / 2) + ((canvasWidth - (chartItemTextView.chartItemViewFactory._stageViewSize.width * vm.ccScaleX)) / 2) + (12 * vm.ccScaleX);
          var startPointY = ((canvasContainerHeight - canvasHeight) / 2) + ((canvasHeight - (chartItemTextView.chartItemViewFactory._stageViewSize.height * vm.ccScaleY)) / 2) - (8 * vm.ccScaleY);

          vm.chartTextEditorState.editorPosX = startPointX + (chartItemTextView.chartItemText.positionx * chartItemTextView.chartItemViewFactory._scalePxPerUnitX * vm.ccScaleX) + (chartItemTextView.chartItemViewFactory._scaledStagePxOffset.x * vm.ccScaleX);
          vm.chartTextEditorState.editorPosY = startPointY + (chartItemTextView.chartItemText.positiony * chartItemTextView.chartItemViewFactory._scalePxPerUnitY * vm.ccScaleY) + (chartItemTextView.chartItemViewFactory._scaledStagePxOffset.y * vm.ccScaleY);
        } else {
          var startPointX = ((canvasContainerWidth + canvasWidth) / 2) - ((canvasWidth - (chartItemTextView.chartItemViewFactory._stageViewSize.width * vm.ccScaleX)) / 2) - (12 * vm.ccScaleX);
          var startPointY = ((canvasContainerHeight + canvasHeight) / 2) - ((canvasHeight - (chartItemTextView.chartItemViewFactory._stageViewSize.height * vm.ccScaleY)) / 2) + (8 * vm.ccScaleY);

          vm.chartTextEditorState.editorPosX = startPointX - (chartItemTextView.chartItemText.positionx * chartItemTextView.chartItemViewFactory._scalePxPerUnitX * vm.ccScaleX) - (chartItemTextView.chartItemViewFactory._scaledStagePxOffset.x * vm.ccScaleX);
          vm.chartTextEditorState.editorPosY = startPointY - (chartItemTextView.chartItemText.positiony * chartItemTextView.chartItemViewFactory._scalePxPerUnitY * vm.ccScaleY) - (chartItemTextView.chartItemViewFactory._scaledStagePxOffset.y * vm.ccScaleY);
        }

        vm.chartTextEditorState.editorWidth = chartItemTextView.chartItemText.sizewidth * 20 / chartItemTextView.chartItemViewFactory._measurementConversionMultiplier;
        vm.chartTextEditorState.editorHeight = chartItemTextView.chartItemText.sizeheight * 20 / chartItemTextView.chartItemViewFactory._measurementConversionMultiplier;

        vm.chartTextEditorState.rotationAngle = chartItemTextView.chartItemText.rotation * (-180 / Math.PI);
        vm.chartTextEditorState.editorScale = (chartItemTextView.chartItemViewFactory._scalePxPerUnitX * vm.ccScaleX) / 20 * chartItemTextView.chartItemViewFactory._measurementConversionMultiplier;

        vm.chartInspectorState.textEditorActive = true;
      }, 100);
    }

    function endEditTextBox() {
      if (angular.isDefined(vm.chartInspectorState.editingChartItemTextView)) {
        var chartItemTextView = vm.chartInspectorState.editingChartItemTextView;
        vm.chartInspectorState.textEditorActive = false;
        vm.chartInspectorState.editingChartItemTextView = undefined;
        delete vm.chartInspectorState.defaultTextSettings;
        vm.chartInspectorState.layerEditorActive = false;

        chartItemTextView.parent.setUserInteractionEnabled(true);
        delete chartItemTextView.chartItemText.defaultTextSettings;
        chartItemTextView.setEditing(false);
        chartItemTextView.refresh();

        chartNotifyEnableChangeTracking();
        chartNotifyDataDidChange();
        startAutoSaveTimer();
      }
    }

    /**
     * Open media content of the chart item.
     * @param {ChartItemMedia} chartItemMedia Chart Item
     */
    function openMedia(chartItemMedia) {
      var mediaDetails = chartItemMedia.mediadetails;

      $window.open(mediaDetails.url, '_blank');
    }

    function shapeEditorSelectedNode(selected) {
      $scope.$applyAsync(function () {
        vm.chartInspectorState.vectorEditorNodeSelected = (selected === true);
      });
    }

    function onInspectorAction(action) {
      if (vm.chartEditorState.ccInitializationPending) {
        return;
      }

      var targetLayer;

      if (vm.semiChartLayerView.getIsActive()) {
        targetLayer = vm.semiChartLayerView;
      } else if (vm.dynamicChartLayerView.getIsActive()) {
        targetLayer = vm.dynamicChartLayerView;
      } else if (vm.userChartLayerView.getIsActive()) {
        targetLayer = vm.userChartLayerView;
      }

      if (angular.isUndefined(targetLayer)) {
        return;
      }

      if (action.type === 'angle') {
        var angle = parseInt(action.value);
        targetLayer.chartInspectorRotationChangedTo(angle);
      } else if (action.type === 'resetAngle') {
        var resetAngle = parseInt(action.value);
        targetLayer.selectedItemRotationReset(resetAngle);
      } else if (action.type === 'increaseThickness') {
        targetLayer.selectedItemIncreaseLineThickness();
      } else if (action.type === 'decreaseThickness') {
        targetLayer.selectedItemDecreaseLineThickness();
      } else if (action.type === 'resetThickness') {
        targetLayer.selectedItemResetLineThickness();
      } else if (action.type === 'increaseThicknessForFreehand') {
        targetLayer.increaseLineThicknessForFreehand();
      } else if (action.type === 'decreaseThicknessForFreehand') {
        targetLayer.decreaseLineThicknessForFreehand();
      } else if (action.type === 'resetThicknessForFreehand') {
        targetLayer.resetLineThicknessForFreehand();
      }
      else if (action.type === 'alignLeft') {
        if (!vm.chartEditorState.povAudience) {
          targetLayer.selectedItemAlignRight();
        } else {
          targetLayer.selectedItemAlignLeft();
        }
      } else if (action.type === 'alignCenter') {
        targetLayer.selectedItemAlignCenter();
      } else if (action.type === 'alignRight') {
        if (!vm.chartEditorState.povAudience) {
          targetLayer.selectedItemAlignLeft();
        } else {
          targetLayer.selectedItemAlignRight();
        }
      } else if (action.type === 'alignTop') {
        if (!vm.chartEditorState.povAudience) {
          targetLayer.selectedItemAlignBottom();
        } else {
          targetLayer.selectedItemAlignTop();
        }
      } else if (action.type === 'alignMiddle') {
        targetLayer.selectedItemAlignMiddle();
      } else if (action.type === 'alignBottom') {
        if (!vm.chartEditorState.povAudience) {
          targetLayer.selectedItemAlignTop();
        } else {
          targetLayer.selectedItemAlignBottom();
        }
      }
      else if (action.type === 'horizontalSpacing') {
        targetLayer.selectedItemHorizontalSpacing();
      }
      else if (action.type === 'verticalSpacing') {
        targetLayer.selectedItemVerticalSpacing();
      }
      else if (action.type === 'headangle') {
        var angle = parseInt(action.value);
        targetLayer.chartInspectorHeadRotationChangedTo(angle);
      } else if (action.type === 'layer') {
        if (action.value === 'begin') {
          targetLayer.chartInspectorBeginOrderingEdit();
        } else if (action.value === 'top') {
          targetLayer.chartInspectorSendItemToTop();
        } else if (action.value === 'up') {
          targetLayer.chartInspectorSendItemUp();
        } else if (action.value === 'down') {
          targetLayer.chartInspectorSendItemDown();
        } else if (action.value === 'bottom') {
          targetLayer.chartInspectorSendItemToBottom();
        } else if (action.value === 'end') {
          targetLayer.chartInspectorEndOrderingEdit();
        }
      }
      else if (action.type === 'rotation') {
        if (action.value === 'begin') {
          vm.chartInspectorState.selectionRotationMode = true;
        } else if (action.value === 'end') {
          vm.chartInspectorState.selectionRotationMode = false;
        }
        targetLayer.setSelectionRotationMode(vm.chartInspectorState.selectionRotationMode);
      }
      else if (action.type === 'snapToGridMode') {
        if (action.value === 'begin') {
          vm.chartInspectorState.selectionSnapToGrid = true;
        } else if (action.value === 'end') {
          vm.chartInspectorState.selectionSnapToGrid = false;
        }
        targetLayer.setSelectionSnapToGridMode(vm.chartInspectorState.selectionSnapToGrid);
      }
      else if (action.type === 'alignToGrid') {
        targetLayer.selectedItemSnapToGrid();
      }
      else if (action.type === 'performerTrackReassignment') {
        performerTrackReassignmentPrompt();
      }
      else if (action.type === 'color') {
        if (action.value.border) {
          if (vm.chartShapeFreehandToolView) {
            vm.chartShapeFreehandToolView.setLineColorCss(action.value.border);
          } else if (vm.chartShapeVectorEditorView) {
            vm.chartShapeVectorEditorView.setLineColorCss(action.value.border);
          } else {
            targetLayer.chartInspectorSelectionChoseColor(action.value.border);
          }
        } else if (action.value.fill) {
          targetLayer.chartInspectorSelectionChooseFillColor(action.value.fill);
        } else if (action.value.background) {
          targetLayer.chartInspectorSelectionChooseBackgroundColor(action.value.background);
        }
      } else if (action.type === 'clipboard') {
        if (action.value === 'cut') {
          vm.clipboardItems = targetLayer.chartInspectorSelectionCut();
          updateInspectorState();
        } else if (action.value === 'copy') {
          vm.clipboardItems = targetLayer.chartInspectorSelectionCopy();
          updateInspectorState();
        } else if (action.value === 'duplicate') {
          vm.clipboardItems = targetLayer.chartInspectorSelectionDuplicate(); // SWA-ST1-T58 keyboard shortcut for duplicate
        } else if (action.value === 'paste') {
          clipboardPasteCheck(targetLayer);
        }
      } else if (action.type === 'group') {
        targetLayer.chartInspectorSelectionGroupToggle();
      } else if (action.type === 'groups') {
        targetLayer.chartInspectorSelectionGroup(); // SWA-ST1-T58 keyboard shortcut for group
      } else if (action.type === 'ungroups') {
        targetLayer.chartInspectorSelectionUnGroup(); // SWA-ST1-T58 keyboard shortcut for ungroup
      } else if (action.type === 'fliphorizontally') {
        targetLayer.chartInspectorFlipHorizontally();
      } else if (action.type === 'flipvertically') {
        targetLayer.chartInspectorFlipVertically();
      } else if (action.type === 'edit') {
        targetLayer.chartInspectorSelectionEdit();
      } else if (action.type === 'delete') {
        targetLayer.chartInspectorSelectionDelete();
      } else if (action.type === 'clear') {
        if (!targetLayer.chartInspectorSelectionClear()) {
          vm.clipboardItems = [];
          updateInspectorState();
        }
      } else if (action.type === 'vectorEditor') {
        if (action.value === 'deleteNode') {
          if (vm.chartShapeVectorEditorView) {
            vm.chartShapeVectorEditorView.deleteSelectedNode();
          }
        } else if (action.value === 'done') {
          endEditVectorShape();
          if (vm.chartInspectorState.selectionSnapToGrid) {
            targetLayer.selectedItemSnapToGrid();
          }
        }
      } else if (action.type === 'freehandTool') {
        if (action.value === 'clear') {
          if (vm.chartShapeFreehandToolView) {
            vm.chartShapeFreehandToolView.clearShape();
          }
        } else if (action.value === 'arrowheadChange') {
          if (vm.chartShapeFreehandToolView) {
            vm.chartShapeFreehandToolView.setHasArrowhead(vm.chartInspectorState.freehandHasArrowhead);
          }
        } else if (action.value === 'save') {
          if (vm.chartShapeFreehandToolView) {
            var newShapeItem = vm.chartShapeFreehandToolView.getCurrentShapeItem();
            if (angular.isDefined(newShapeItem)) {
              targetLayer.addNewFreehandShape(newShapeItem);
            }

            closeFreehandTool();
          }
        } else if (action.value === 'close') {
          closeFreehandTool();
        }
      } else if (action.type === 'textEditor') {
        if (action.value === 'textChange' && angular.isDefined(vm.chartInspectorState.editingChartItemTextView)) {
          vm.chartInspectorState.editingChartItemTextView.chartItemText.richtextcontent = vm.chartInspectorState.textBoxRichText;
          vm.chartInspectorState.editingChartItemTextView.chartItemText.textcontent = vm.chartInspectorState.textBoxText;
          vm.chartInspectorState.editingChartItemTextView.refresh();
        } else if (action.value === 'done') {
          endEditTextBox();
        }
      }
      else if (action.type === 'closeContextMenu') {
        if (action.value === 'closeMenu') {
          vm.chartContextMenuState.visible = false;
          vm.chartInspectorState.alignMenu = false;
        }
      }
      else if (action.type === 'togglepinstatus') {
        if (action.value === 'togglepinstatus') {
          toggleContextMenuPinStatus();
        }
      }
      else if (action.type === 'showAlignMenu') {
        if (action.value === 'alignMenuShow') {
          vm.chartInspectorState.alignMenu = true;
        }
      }
      else if (action.type === 'hideAlignMenu') {
        if (action.value === 'alignMenuHide') {
          vm.chartInspectorState.alignMenu = false;
        }
      }

      $timeout(function () {
        $scope.$apply();
      });
    }

    function clipboardPasteCheck(targetLayer) {
      if (targetLayer.getChartLayerType() === SWChartLayer.Type.Dynamic) {
        clipboardPaste(targetLayer, vm.clipboardItems);
      } else if (targetLayer.getChartLayerType() === SWChartLayer.Type.User) {
        clipboardPaste(targetLayer, vm.clipboardItems);
      } else if (targetLayer.getChartLayerType() === SWChartLayer.Type.SemiPermanent) {
        // Check if clipboard has any performer items
        var hasPerformers = false;
        var filteredClipboardItems = [];
        vm.clipboardItems.forEach(function (element) {
          if (element.hasOwnProperty('layer') && (element.itemtype === SWChartItem.Type.Performer)) {
            hasPerformers = true;
          } else {
            filteredClipboardItems.push(element);
          }
        });

        if (hasPerformers) {
          var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'app/components/chartEditor/pasteFilteredClipboardPrompt.html',
            controller: 'PasteFilteredClipboardPromptController',
            controllerAs: 'vm',
            size: 'sm',
            windowClass: 'sw-modal sw-modal-400',
            backdropClass: 'sw-modal-backdrop',
          });

          modalInstance.result.then(function () {
            clipboardPaste(targetLayer, filteredClipboardItems);
          });
        } else {
          clipboardPaste(targetLayer, vm.clipboardItems);
        }
      }
    }

    function clipboardPaste(targetLayer, items) {
      targetLayer.chartInspectorSelectionPaste(items);
    }

    // Cocos logic below
    function setupCocos() {
      $document[0]['ccConfig'] = {
        id: 'chartCanvas',
        frameRate: 10,
        renderMode: 1,
        showFPS: false,
        debugMode: 4,
        jsList: []
      };

      cc.game.onStart = function () {

        cc.view.resizeWithBrowserSize(true);
        cc.view.setResizeCallback(ccOnResize);

        // Root cc Scene and layer
        ccRootScene = new ChartEditorScene();
        ccChartEditorLayer = ccRootScene.chartEditorLayer;
        ccChartEditorLayer.delegate = vm;

        setupLayerViews();

        ccChartEditorLayer.addChild(vm.permanentChartLayerView);
        ccChartEditorLayer.addChild(vm.chartGridView);
        ccChartEditorLayer.addChild(vm.semiChartLayerView);
        ccChartEditorLayer.addChild(vm.dynamicChartLayerView);
        ccChartEditorLayer.addChild(vm.userChartLayerView);

        cc.director.runScene(ccRootScene);

        updateDataProductionPostCocosInit();

        updateChartPanScrollbars();

        fitChartToView();

        vm.chartEditorState.ccInitializationPending = false;
      };

      cc.fullReset();
      cc.game.run('chartCanvas'); // eslint-disable-line angular/module-getter
    }

    function stopCocos() {
      cc.director.end();
    }

    var _chartPauseTimeout;
    var _pauseFps = 2;
    var _lastFps = -1;

    function ccChartPauseUpdates() {
      $log.debug('ccChartPauseUpdates: Will start pausing chart updates ...');
      _lastFps = parseFloat(cc.game.config.frameRate);
      _ccChartHalfLifePause();
    }

    function _ccChartHalfLifePause() {
      var fr = parseFloat(cc.game.config.frameRate);
      if (fr > _lastFps) {
        $log.debug('_ccChartHalfLifePause: FPS bumped by other call!');
        return;
      }

      if (fr > _pauseFps) {
        fr = fr / 2;
        if (fr < _pauseFps) {
          fr = _pauseFps;
        }

        cc.game.setFrameRate(fr);
      }

      if (fr === _pauseFps) {
        $log.debug('_ccChartHalfLifePause: Chart updates now paused (' + _pauseFps + ' FPS)');
      } else {
        $log.debug('_ccChartHalfLifePause: Chart updates now @ ' + fr + ' FPS)');

        $timeout.cancel(_chartPauseTimeout);
        _chartPauseTimeout = $timeout(function () {
          _ccChartHalfLifePause();
        }, 2000);
      }
    }

    function _ccChartKillPause() {
      $timeout.cancel(_chartPauseTimeout);
      _chartPauseTimeout = undefined;
    }

    function ccChartNormalUpdates() {
      $log.debug('ccChartNormalUpdates: Chart updates now normal @ 10 FPS');
      cc.game.setFrameRate(10);
    }

    function ccChartQuickUpdates() {
      $log.debug('ccChartQuickUpdates: Chart updates now quick @ 60 FPS');
      _ccChartKillPause();
      cc.game.setFrameRate(60);
    }

    function ccChartUpdateNow() {
      cc.director.drawScene();
    }

    var ccResizeTimer;

    function ccOnResize() {
      if (angular.isDefined(ccResizeTimer)) {
        $timeout.cancel(ccResizeTimer);
        ccResizeTimer = undefined;
      } else {
        vm.chartEditorState.resizing = true;
        chartBlockUI.start();
      }

      ccResizeTimer = $timeout(function () {
        ccUpdateViewScale();
        updateChartPanScrollbars();
        endEditTextBox();

        vm.chartEditorState.resizing = false;
        chartBlockUI.stop();
        $timeout.cancel(ccResizeTimer);
        ccResizeTimer = undefined;
      }, 500);
    }

    function ccForceSizeUpdate() {
      // $window.dispatchEvent(new Event('resize'));
      cc.view._resizeEvent();
    }

    function ccUpdateViewScale() {
      vm.ccScaleX = cc.view.getScaleX() / cc.view.getDevicePixelRatio();
      vm.ccScaleY = cc.view.getScaleY() / cc.view.getDevicePixelRatio();
    }

    function updateChartPanScrollbars() {
      return;
      // update scrollbar range
      var stageViewBounds = vm.chartGridView.getStageViewBounds();
      var scaledStageBounds = vm.chartGridView.getScaledStageBounds();
      var cocosContainerJ = $('#Cocos2dGameContainer');
      var cocosContainerMarginTop = parseInt(cocosContainerJ.css('margin-top'));
      var cocosContainerMarginLeft = parseInt(cocosContainerJ.css('margin-left'));
      var cocosContainerMarginRight = parseInt(cocosContainerJ.css('margin-right'));

      vm.chartPanScrollParams.ignorePan = true;
      $scope.$applyAsync(function () {
        vm.chartPanScrollParams.vertical.marginLeft = (-cocosContainerMarginLeft);
        vm.chartPanScrollParams.vertical.contentHeight = (scaledStageBounds.height) * vm.ccScaleY;
        vm.chartPanScrollParams.vertical.containerHeight = (stageViewBounds.height * vm.ccScaleY);
        vm.chartPanScrollParams.vertical.containerTopOffset = cocosContainerMarginTop + (stageViewBounds.y * vm.ccScaleY);

        vm.chartPanScrollParams.horizontal.marginTop = (-cocosContainerMarginTop);
        vm.chartPanScrollParams.horizontal.contentWidth = (scaledStageBounds.width) * vm.ccScaleX;
        vm.chartPanScrollParams.horizontal.containerWidth = (stageViewBounds.width * vm.ccScaleX);
        vm.chartPanScrollParams.horizontal.containerLeftOffset = cocosContainerMarginLeft + (stageViewBounds.x *
          vm.ccScaleX);
      });

      var to1 = $timeout(
        function () {
          vm.chartPanVScrollbarsCallUpdate('update');
          vm.chartPanHScrollbarsCallUpdate('update');
        }, 100
      )
        .then(function () {
          return $timeout(
            function () {
              vm.chartPanVScrollbarsCallUpdate('scrollTo', vm.chartPanScrollParams.vertical.scrollPercent + '%', {
                scrollInertia: 0
              });
              vm.chartPanHScrollbarsCallUpdate('scrollTo', vm.chartPanScrollParams.horizontal.scrollPercent + '%', {
                scrollInertia: 0
              });
            }, 100);
        })
        .then(function () {
          $timeout(function () {
            vm.chartPanScrollParams.ignorePan = false;
          }, 100);
        });

      // Update other layer positions
      // onZoomChangeEnd();

      // TODO: update chartitemviewfactory params
    }

    // To handle show/hide context menu based on mousedown point and mouseup point.
    var clickDownPosX = 0;
    var clickDownPosY = 0;
    function canvasContainerClickDown(event) {
      clickDownPosX = event.offsetX;
      clickDownPosY = event.offsetY;

      var canvasWidth = event.target.offsetWidth;
      var canvasHeight = event.target.offsetHeight;
      var menuWidth = CHART_CTX_MNU_WIDTH;
      var menuHeight = CHART_CTX_MNU_HEIGHT;

      var maxX = canvasWidth - menuWidth;
      var maxY = canvasHeight - menuHeight;

      if (clickDownPosX > maxX) {
        clickDownPosX = clickDownPosX - menuWidth;
      }

      if (clickDownPosY > maxY) {
        clickDownPosY = maxY;
      }

      clickDownPosX += event.target.parentElement.offsetLeft;
      clickDownPosY += event.target.parentElement.offsetTop;
    }

    function canvasContainerClick(event) {
      hideSideBarDeleteAndMoveOptions();
      if (!vm.activeAccessRules.allowchartediting && !vm.activeAccessRules.allowaddcharttextpersonal) {
        return;
      }
      if (!vm.chartEditorState.layerActive) {
        return;
      }

      var posX = event.offsetX;
      var posY = event.offsetY;

      // Ensure the context menu stays within the canvas
      var canvasWidth = event.target.offsetWidth;
      var canvasHeight = event.target.offsetHeight;
      var menuWidth = CHART_CTX_MNU_WIDTH;
      var menuHeight = CHART_CTX_MNU_HEIGHT;
      // Calculate the maximum allowed positions
      var maxX = canvasWidth - menuWidth;
      var maxY = canvasHeight - menuHeight;

      // Adjust the position if it goes outside the canvas
      if (posX > maxX) {
        posX = posX - menuWidth;
      }

      if (posY > maxY) {
        posY = maxY;
      }

      posX += event.target.parentElement.offsetLeft;
      posY += event.target.parentElement.offsetTop;

      // Show context menu based on the mouse button and platform
      var isRightClick = event.button === cc.EventMouse.BUTTON_RIGHT;
      var isCtrlLeftClick = event.button === cc.EventMouse.BUTTON_LEFT && (vm.platformMac && event.ctrlKey);

      if ((isRightClick || isCtrlLeftClick) && ((posX === clickDownPosX) && (posY === clickDownPosY))) {
        if (angular.isDefined(vm.pinnedPosXOfContextMenu) && angular.isDefined(vm.pinnedPosYOfContextMenu)) {
          posX = vm.pinnedPosXOfContextMenu;
          posY = vm.pinnedPosYOfContextMenu;
        }
        showChartContextMenu(posX, posY);
      }
    }

    function showChartContextMenu(posX, posY) {
      vm.chartContextMenuState.visible = true;
      vm.chartContextMenuState.posX = posX;
      vm.chartContextMenuState.posY = posY;
    }

    function hideChartContextMenu() {
      vm.chartContextMenuState.visible = false;
      vm.chartInspectorState.alignMenu = false;
    }

    function toggleContextMenuPinStatus() {
      vm.chartInspectorState.isContextMenuPinned = !vm.chartInspectorState.isContextMenuPinned;
      if (vm.chartInspectorState.isContextMenuPinned) {
        setPinnedContextMenuPosition();
      } else {
        clearPinnedContextMenuPosition();
      }
      $localStorage.isContextMenuPinned = vm.chartInspectorState.isContextMenuPinned;
    }

    function setPinnedContextMenuPosition() {
      var contextMenu = $document[0].getElementById('contextMenu');
      if (contextMenu) {
        var newPosX = parseInt(contextMenu.style.left, 10) || 0;
        var newPosY = parseInt(contextMenu.style.top, 10) || 0;

        vm.pinnedPosXOfContextMenu = newPosX;
        vm.pinnedPosYOfContextMenu = newPosY;
        $localStorage.pinnedPosXOfContextMenu = newPosX;
        $localStorage.pinnedPosYOfContextMenu = newPosY;
      }
    }

    function clearPinnedContextMenuPosition() {
      vm.pinnedPosXOfContextMenu = undefined;
      vm.pinnedPosYOfContextMenu = undefined;
      $localStorage.pinnedPosXOfContextMenu = undefined;
      $localStorage.pinnedPosYOfContextMenu = undefined;
    }

    function onContextMenuDragStop(event, ui) {
      if (vm.chartInspectorState.isContextMenuPinned) {
        updatePinnedContextMenuPosition(ui.position);
      } else {
        clearPinnedContextMenuPosition();
      }
    }

    function updatePinnedContextMenuPosition(position) {
      var newPosX = parseInt(position.left, 10) || 0;
      var newPosY = parseInt(position.top, 10) || 0;

      vm.pinnedPosXOfContextMenu = newPosX;
      vm.pinnedPosYOfContextMenu = newPosY;
      $localStorage.pinnedPosXOfContextMenu = newPosX;
      $localStorage.pinnedPosYOfContextMenu = newPosY;
    }

    function clearPinnedContextMenuPosition() {
      vm.pinnedPosXOfContextMenu = undefined;
      vm.pinnedPosYOfContextMenu = undefined;
      $localStorage.pinnedPosXOfContextMenu = undefined;
      $localStorage.pinnedPosYOfContextMenu = undefined;
    }

    function showSideBarDeleteAndMoveOptions(event) {
      vm.menuTop = event.clientY - 40;
      vm.menuLeft = 245;
      if (vm.selectedScene.accessRules.allowmovechartsource || vm.selectedScene.accessRules.allowdeletechart) {
        vm.chartSidebarDeleteAndMoveOptionState.visible = true;
      }
    }

    function hideSideBarDeleteAndMoveOptions() {
      vm.chartSidebarDeleteAndMoveOptionState.visible = false;
    }

    function toggleSideBarDeleteAndMoveOptions() {
      vm.chartSidebarDeleteAndMoveOptionState.visible = !vm.chartSidebarDeleteAndMoveOptionState.visible;
    }

    function showSidebarEditModeOptions() {
      if (vm.selectedScene.accessRules.allowmovechartsource || vm.selectedScene.accessRules.allowdeletechart) {
        vm.chartSidebarEditOptionState.visible = true;
      }
    }

    function hideSidebarEditModeOptions() {
      vm.chartSidebarEditOptionState.visible = false;
    }

    function toggleSidebarEditModeOptions() {
      vm.chartSidebarEditOptionState.visible = !vm.chartSidebarEditOptionState.visible;
    }

    function updateSceneCollaborationAccessRules(scenes) {
      scenes.forEach(function (scene) {
        if (vm.activeCollaborationConfig.isProductionOwner === true) {
          if (vm.activePlanRules.planId === 2) {
            scene.accessRules = angular.copy(defaultViewAccessRules);
          } else {
            scene.accessRules = angular.copy(defaultOwnerAccessRules);
          }
        } else {
          if (vm.activePlanRules.planId === 2) {
            scene.accessRules = angular.copy(defaultViewAccessRules);
            if (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited) {
              scene.accessRules.allowaddcharttextpersonal = true;
            }
          } else {
            scene.accessRules = angular.copy(defaultDenyAccessRules);
            if (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel !== swaAccess.accesslevel.custom) {
              var params = {
                accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
                statename: swaRouterStateNames.charteditor,
              };

              dbCollaborationPrivileges.getCollaborationPrivileges(params)
                .then(function (privilegeData) {
                  angular.extend(scene.accessRules, privilegeData.accessrules);
                }, function (error) {
                  $log.error('ChartEditorController.updateSceneCollaborationAccessRules:', error);
                });
            } else {
              var sceneAccess = _.findWhere(vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.sceneaccess, {
                sceneId: scene._id
              });
              if (angular.isDefined(sceneAccess)) {
                var params1 = {
                  accesslevel: vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel,
                  allowchartediting: sceneAccess.allowchartediting,
                  statename: swaRouterStateNames.charteditor,
                };

                dbCollaborationPrivileges.getCollaborationPrivileges(params1)
                  .then(function (privilegeData) {
                    angular.extend(scene.accessRules, privilegeData.accessrules);
                  }, function (error) {
                    $log.error('ChartEditorController.updateSceneCollaborationAccessRules:', error);
                  });
              }
            }
          }
        }
      });
    }

    function updateActiveAccessRules() {
      $scope.$applyAsync(function () {
        var accessRules;
        if (angular.isDefined(vm.selectedScene)) {
          accessRules = vm.selectedScene.accessRules;
        }

        if (accessRules) {
          angular.extend(vm.activeAccessRules, accessRules);
        } else {
          angular.extend(vm.activeAccessRules, defaultDenyAccessRules);
        }
      });
    }

    function loadEditorPreferences() {
      vm.chartEditorState.inspectorVisible = vm.chartEditorPreferences.inspectorVisible;
      vm.chartEditorState.performerPickerDocked = vm.chartEditorPreferences.performerPickerDocked;
      vm.chartEditorState.performerPickerDockedOpen = vm.chartEditorPreferences.performerPickerDockedOpen;
      vm.chartEditorState.mediaDrawerOpen = vm.chartEditorPreferences.mediaDrawerOpen;
      vm.scalePerformers.allPerformers = vm.chartEditorPreferences.scaleAllPerformers;
      vm.scalePerformers.selectedPerformers = vm.chartEditorPreferences.scaleSelectedPerformers;
    }

    function saveEditorPreferences() {
      vm.chartEditorPreferences.inspectorVisible = vm.chartEditorState.inspectorVisible;
      vm.chartEditorPreferences.performerPickerDocked = vm.chartEditorState.performerPickerDocked;
      vm.chartEditorPreferences.performerPickerDockedOpen = vm.chartEditorState.performerPickerDockedOpen;
      vm.chartEditorPreferences.mediaDrawerOpen = vm.chartEditorState.mediaDrawerOpen;
    }

    function showHelpHints() {
      if (!vm.activeCollaborationConfig.isProductionOwner &&
        (vm.activePlanRules.planId !== 2) &&
        (vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === swaAccess.accesslevel.limited)) {
        toastr.info(
          $translate.instant('messages.chart_personal_notes_limited_access_hint'),
          $translate.instant('titles.Personal Notes')
        );
      }
    }

    function initHelpTour() {
      vm.userData = DbSubMgrService.getLoggedInUserData();

      var profileDisplayHelp = false;
      var firstElementOfAccordion = $('#scene-accordion').first();
      firstElementOfAccordion.attr('first-scene');

      if (angular.isDefined(vm.userData.preferences.web.displayHelp)) {
        profileDisplayHelp = profileDisplayHelp || vm.userData.preferences.web.displayHelp;
      }

      if (profileDisplayHelp === false) {
        return;
      }

      if ($translate.isReady()) {
        vm.showHelpBar = profileDisplayHelp;
        initHelpTourSteps();
      } else {
        $translate.onReady(function () {
          vm.showHelpBar = profileDisplayHelp;
          initHelpTourSteps();
        });
      }
    }

    function initHelpTourSteps() {
      vm.helpTourSteps = [{
        element: '#menu-locknavigation',
        title: $translate.instant('helptour.editor.titles.menu-locknavigation'),
        content: $translate.instant('helptour.editor.messages.menu-locknavigation'),
        placement: 'bottom',
      }, {
        element: '#menu-switchview',
        title: $translate.instant('helptour.editor.titles.menu-switchview'),
        content: $translate.instant('helptour.editor.messages.menu-switchview'),
        placement: 'bottom',
      }, {
        element: '#menu-addchart',
        title: $translate.instant('helptour.chartEditor.titles.menu-addchart'),
        content: $translate.instant('helptour.chartEditor.messages.menu-addchart'),
        placement: 'bottom',
      }, {
        element: '#menu-chartzoom',
        title: $translate.instant('helptour.chartEditor.titles.menu-chartzoom'),
        content: $translate.instant('helptour.chartEditor.messages.menu-chartzoom'),
        placement: 'bottom',
      }, {
        element: '#menu-semilayer',
        title: $translate.instant('helptour.chartEditor.titles.menu-semilayer'),
        content: $translate.instant('helptour.chartEditor.messages.menu-semilayer'),
        placement: 'bottom',
      }, {
        element: '#menu-dynamiclayer',
        title: $translate.instant('helptour.chartEditor.titles.menu-dynamiclayer'),
        content: $translate.instant('helptour.chartEditor.messages.menu-dynamiclayer'),
        placement: 'bottom',
      }, {
        element: '#menu-chartmediapicker',
        title: $translate.instant('helptour.chartEditor.titles.menu-chartmediapicker'),
        content: $translate.instant('helptour.chartEditor.messages.menu-chartmediapicker'),
        placement: 'bottom',
      }, {
        element: '#menu-chartshapes',
        title: $translate.instant('helptour.chartEditor.titles.menu-chartshapes'),
        content: $translate.instant('helptour.chartEditor.messages.menu-chartshapes'),
        placement: 'bottom',
      }, {
        element: '#menu-chartsetpieces',
        title: $translate.instant('helptour.chartEditor.titles.menu-chartsetpieces'),
        content: $translate.instant('helptour.chartEditor.messages.menu-chartsetpieces'),
        placement: 'bottom',
      }, {
        element: '#menu-chartnotes',
        title: $translate.instant('helptour.chartEditor.titles.menu-chartnotes'),
        content: $translate.instant('helptour.chartEditor.messages.menu-chartnotes'),
        placement: 'bottom',
      }, {
        element: '#menu-chartperformersdrawer',
        title: $translate.instant('helptour.chartEditor.titles.menu-chartperformers'),
        content: $translate.instant('helptour.chartEditor.messages.menu-chartperformers'),
        placement: 'bottom',
      }, {
        element: '#menu-chartperformerspicker',
        title: $translate.instant('helptour.chartEditor.titles.menu-chartperformers'),
        content: $translate.instant('helptour.chartEditor.messages.menu-chartperformers'),
        placement: 'bottom',
      }, {
        element: '#menu-chartundo',
        title: $translate.instant('helptour.chartEditor.titles.menu-chartundo'),
        content: $translate.instant('helptour.chartEditor.messages.menu-chartundo'),
        placement: 'bottom',
      }, {
        element: '#menu-chartredo',
        title: $translate.instant('helptour.chartEditor.titles.menu-chartredo'),
        content: $translate.instant('helptour.chartEditor.messages.menu-chartredo'),
        placement: 'bottom',
      }, {
        element: '#menu-charttools',
        title: $translate.instant('helptour.chartEditor.titles.menu-charttools'),
        content: $translate.instant('helptour.chartEditor.messages.menu-charttools'),
        placement: 'bottom',
      }, {
        element: '#menu-linkeditems',
        title: $translate.instant('helptour.chartEditor.titles.menu-linkeditems'),
        content: $translate.instant('helptour.chartEditor.messages.menu-linkeditems'),
        placement: 'bottom',
      }, {
        element: '#menu-copychartlink',
        title: $translate.instant('helptour.chartEditor.titles.menu-copychartlink'),
        content: $translate.instant('helptour.chartEditor.messages.menu-copychartlink'),
        placement: 'bottom',
      }, {
        element: '#menu-savechanges',
        title: $translate.instant('helptour.editor.titles.menu-savechanges'),
        content: $translate.instant('helptour.editor.messages.menu-savechanges'),
        placement: 'left',
      }, {
        element: '#menu-createpdf',
        title: $translate.instant('helptour.editor.titles.menu-createpdf'),
        content: $translate.instant('helptour.editor.messages.menu-createpdf'),
        placement: 'left',
      }, {
        element: '#menu-collaborators',
        title: $translate.instant('helptour.editor.titles.menu-collaborators'),
        content: $translate.instant('helptour.editor.messages.menu-collaborators'),
        placement: 'left',
      }, {
        element: '#menu-settings',
        title: $translate.instant('helptour.editor.titles.menu-settings'),
        content: $translate.instant('helptour.editor.messages.menu-settings'),
        placement: 'left',
      }, {
        element: '#sidebar-scenelist',
        title: $translate.instant('helptour.chartEditor.titles.sidebar-scenelist'),
        content: $translate.instant('helptour.chartEditor.messages.sidebar-scenelist'),
        placement: 'right',
      }, {
        element: '#sidebar-movedelete',
        title: $translate.instant('helptour.chartEditor.titles.sidebar-movedelete'),
        content: $translate.instant('helptour.chartEditor.messages.sidebar-movedelete'),
        placement: 'top',
      }, {
        element: '#sidebar-move',
        title: $translate.instant('helptour.chartEditor.titles.sidebar-move'),
        content: $translate.instant('helptour.chartEditor.messages.sidebar-move'),
        placement: 'top',
      }, {
        element: '#sidebar-delete',
        title: $translate.instant('helptour.chartEditor.titles.sidebar-delete'),
        content: $translate.instant('helptour.chartEditor.messages.sidebar-delete'),
        placement: 'top',
      }, {
        element: '#sidebar-done',
        title: $translate.instant('helptour.chartEditor.titles.sidebar-done'),
        content: $translate.instant('helptour.chartEditor.messages.sidebar-done'),
        placement: 'top',
      }, {
        element: '#button-closeproduction',
        title: $translate.instant('helptour.editor.titles.button-closeproduction'),
        content: $translate.instant('helptour.editor.messages.button-closeproduction'),
        placement: 'right',
      },];

      vm.helpTourVideos = [{
        label: 'Editing Charts',
        videoUrl: 'https://www.youtube.com/embed/LoWgmX-jISA?si=9lj9BBBHtcoSIiwO'
      }];
    }

    var isAltKeyDown = false;

    function keyboardHandler(event) {
      if (keyboardHandlerCheckTarget(event)) {
        return;
      }

      // key
      var whichKey = event.which;
      var key = event.key;

      // event types
      var keydown = event.type === 'keydown';
      var keyup = event.type === 'keyup';

      // modifier keys and combos
      var ctrlKey = event.ctrlKey && !(event.altKey || event.shiftKey || event.metaKey);
      var ctrlShiftKey = event.ctrlKey && event.shiftKey && !(event.altKey || event.metaKey);
      var metaKey = event.metaKey && !(event.altKey || event.shiftKey || event.ctrlKey);
      var metaShiftKey = event.metaKey && event.shiftKey && !(event.altKey || event.ctrlKey);
      var noModKey = !(event.ctrlKey || event.altKey || event.shiftKey || event.metaKey);
      var altKey = (event.altKey || (event.key === 'Alt')) && !(event.metaKey || event.shiftKey || event.ctrlKey);

      if (keyup) {
        // STA-I195 keyboard shortcut for rotation mode
        if (altKey) {
          isAltKeyDown = false;
          event.preventDefault();
          event.stopPropagation();
          if (vm.chartInspectorState.selectionRotationMode) {
            keyboardHandlerHandleRotationModeEnd();
          } else {
            keyboardHandlerHandleRotationModeBegin();
          }
        }
      } else {
        // clipboard shortcuts check
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          if (whichKey === 88) {
            keyboardHandlerHandleCut(event);
            return;
          } else if (whichKey === 67) {
            keyboardHandlerHandleCopy(event);
            return;
          } else if (whichKey === 86) {
            keyboardHandlerHandlePaste(event);
            return;
          }
        }

        // Delete or backspace, without any modifier key
        if (noModKey && ((whichKey === 8) || (whichKey === 46))) {
          keyboardHandlerHandleDelete(event);
          return;
        }

        // Undo/Redo
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          if (whichKey === 90) {
            keyboardHandlerHandleUndo();
            return;
          } else if (whichKey === 89) {
            keyboardHandlerHandleRedo();
            return;
          }
        }

        // Redo (Mac)
        if (vm.platformMac && metaShiftKey) {
          if (whichKey === 90) {
            keyboardHandlerHandleRedo();
            return;
          }
        }

        // SWA-ST1-T58 keyboard shortcut for group
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          event.stopPropagation();
          event.preventDefault();
          if (whichKey === 71) {
            keyboardHandlerHandleGroup();
            return;
          }
        }

        // SWA-ST1-T58 keyboard shortcut for ungroup
        if ((vm.platformMac && metaShiftKey) || (!vm.platformMac && ctrlShiftKey)) {
          event.stopPropagation();
          event.preventDefault();
          if (whichKey === 71) {
            keyboardHandlerHandleUnGroup();
            return;
          }
        }

        // SWA-ST1-T58 keyboard shortcut for duplicate
        if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
          event.stopPropagation();
          event.preventDefault();
          if (whichKey === 68) {
            keyboardHandlerHandleDuplicate();
            return;
          }
        }

        // STA-I195 keyboard shortcut for rotation mode
        if (altKey && !isAltKeyDown) {
          isAltKeyDown = true;
          event.preventDefault();
          event.stopPropagation();
          if (vm.chartInspectorState.selectionRotationMode) {
            keyboardHandlerHandleRotationModeEnd();
          } else {
            keyboardHandlerHandleRotationModeBegin();
          }
        }

        // lock mode navigation control
        if (vm.chartEditorState.lockModeNavigation) {
          if (whichKey === 27) {
            toggleLockModeNavigation();
            return;
          }
          if (whichKey === 37) {
            if (ctrlKey) {
              lockNavigationPreviousScene();
            } else {
              lockNavigationPreviousChart();
            }
            event.stopPropagation();
            event.preventDefault();

            return;
          } else if (whichKey === 39) {
            if (ctrlKey) {
              lockNavigationNextScene();
            } else {
              lockNavigationNextChart();
            }
            event.stopPropagation();
            event.preventDefault();

            return;
          }
        }

        // zoom control
        // if ((vm.platformMac && metaKey) || (!vm.platformMac && ctrlKey)) {
        //   if (whichKey === 219) {
        //     keyboardHandlerHandleZoomIn(event);
        //     return;
        //   } else if (whichKey === 221) {
        //     keyboardHandlerHandleZoomOut(event);
        //     return;
        //   } else if (whichKey === 48){
        //     keyboardHandlerHandleZoomReset(event);
        //     return;
        //   }
        // }
      }
    }

    function keyboardHandlerCheckTarget(event) {
      var target = event.target;

      if (vm.chartEditorState.lockModeNavigation) {
        return false;
      } else if ((target.nodeName === 'INPUT') || (target.nodeName === 'TEXTAREA')) {
        return true;
      } else {
        return target.attributes.contenteditable;
      }
    }

    function keyboardHandlerHandleCut(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.selectionCount > 0)) {
        $log.debug('Keyboard - Cut');

        onInspectorAction({
          type: 'clipboard',
          value: 'cut'
        });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Selection cut'),
          $translate.instant('titles.Clipboard')
        );
      }
    }

    function keyboardHandlerHandleCopy(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.selectionCount > 0)) {
        $log.debug('Keyboard - Copy');

        onInspectorAction({
          type: 'clipboard',
          value: 'copy'
        });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Selection copied'),
          $translate.instant('titles.Clipboard')
        );
      }
    }

    function keyboardHandlerHandlePaste(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.canPaste)) {
        $log.debug('Keyboard - Paste');

        onInspectorAction({
          type: 'clipboard',
          value: 'paste'
        });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Content pasted'),
          $translate.instant('titles.Clipboard')
        );
      }
    }

    function keyboardHandlerHandleDelete(event) {
      if ((vm.chartEditorState.layerActive) && (vm.chartInspectorState.selectionCount > 0)) {
        $log.debug('Keyboard - Delete');

        onInspectorAction({
          type: 'delete'
        });
        event.stopPropagation();
        event.preventDefault();

        toastr.info(
          $translate.instant('messages.Selection deleted')
        );
      }
    }

    // SWA-ST1-T58 keyboard shortcut for group
    function keyboardHandlerHandleGroup(event) {
      if ((vm.chartEditorState.layerActive) && ((vm.chartInspectorState.selectionCount > 1) || vm.chartInspectorState.selectionGrouped)) {
        $log.debug('Keyboard - Group');
        onInspectorAction({
          type: 'groups',
        });

      }
    }

    // SWA-ST1-T58 keyboard shortcut for ungroup
    function keyboardHandlerHandleUnGroup(event) {
      if ((vm.chartEditorState.layerActive) && ((vm.chartInspectorState.selectionCount > 1) || vm.chartInspectorState.selectionGrouped)) {
        $log.debug('Keyboard - UnGroup');
        onInspectorAction({
          type: 'ungroups',
        });

      }
    }

    // SWA-ST1-T58 keyboard shortcut for duplicate
    function keyboardHandlerHandleDuplicate(event) {
      if (vm.chartEditorState.layerActive && !vm.chartInspectorState.selectionGrouped) {
        $log.debug('Keyboard - Duplicate');
        onInspectorAction({
          type: 'clipboard',
          value: 'duplicate'
        });

        toastr.info(
          $translate.instant('messages.Selection Duplicated')
        );
      }
    }

    // STA-I195 keyboard shortcut for rotation mode
    function keyboardHandlerHandleRotationModeBegin(event) {
      if (vm.chartEditorState.layerActive) {
        onInspectorAction({
          type: 'rotation',
          value: 'begin'
        });
        if ((vm.chartInspectorState.selectionCount > 0) || vm.chartInspectorState.selectionGrouped) {
          toastr.clear();
          toastr.info(
            $translate.instant('messages.Rotation mode enabled')
          );
        }
      }
    }

    // STA-I195 keyboard shortcut for rotation mode
    function keyboardHandlerHandleRotationModeEnd(event) {
      if (vm.chartEditorState.layerActive) {
        onInspectorAction({
          type: 'rotation',
          value: 'end'
        });
        if ((vm.chartInspectorState.selectionCount > 0) || vm.chartInspectorState.selectionGrouped) {
          toastr.clear();
          toastr.info(
            $translate.instant('messages.Rotation mode disabled')
          );
        }
      }
    }

    function keyboardHandlerHandleUndo(event) {
      if (vm.changeTracker.enabled && vm.changeTracker.canUndo) {
        $log.debug('Keyboard - Undo');
        undoAction();
      }
    }

    function keyboardHandlerHandleRedo(event) {
      if (vm.changeTracker.enabled && vm.changeTracker.canRedo) {
        $log.debug('Keyboard - Redo');
        redoAction();
      }
    }

    function keyboardHandlerHandleZoomIn(event) {
      if (vm.chartEditorState.chartOpen) {
        if (vm.chartEditorState.zoomFactor < vm.chartEditorState.maxZoomFactor) {
          vm.chartEditorState.zoomFactor++;
          onZoomChangeEnd();
        }

        event.stopPropagation();
        event.preventDefault();
      }
    }

    function keyboardHandlerHandleZoomOut(event) {
      if (vm.chartEditorState.chartOpen) {
        if (vm.chartEditorState.zoomFactor > 1) {
          vm.chartEditorState.zoomFactor--;
          onZoomChangeEnd();
        }

        event.stopPropagation();
        event.preventDefault();
      }
    }

    function keyboardHandlerHandleZoomReset(event) {
      if (vm.chartEditorState.chartOpen) {
        if (vm.chartEditorState.zoomFactor !== 1) {
          vm.chartEditorState.zoomFactor = 1;
          onZoomChangeEnd();
        }

        event.stopPropagation();
        event.preventDefault();
      }
    }

    function registerKeyboardHandler() {
      $log.debug('ChartEditorController: registerKeyboardHandler:');
      $(document).on('keydown', keyboardHandler);
      $(document).on('keyup', keyboardHandler);

      tryIdentifyPlatform();
    }

    function unregisterKeyboardHandler() {
      $log.debug('ChartEditorController: unregisterKeyboardHandler:');
      $(document).off('keydown', keyboardHandler);
      $(document).off('keyup', keyboardHandler);
    }

    function tryIdentifyPlatform() {
      vm.platformMac = (navigator.platform && (navigator.platform.match(/mac/i) !== null)) || (navigator.userAgent.match(/Macintosh/i) !== null);
    }

    vm.changeTracker = {
      undoStack: [],
      redoStack: [],

      lastTrackedState: undefined,

      nextStateNumber: 0,

      disableTrackingCount: 0,

      canUndo: false,
      canRedo: false,
      enabled: false,
    };

    function changeTrackerReset() {
      $log.debug('changeTrackerReset():');
      vm.changeTracker.undoStack.length = 0;
      vm.changeTracker.redoStack.length = 0;
      vm.changeTracker.lastTrackedState = undefined;
      vm.changeTracker.nextStateNumber = 0;
      vm.changeTracker.disableTrackingCount = 0;

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function changeTrackerInitialize() {
      $log.debug('changeTrackerInitialize():');
      changeTrackerReset();

      vm.changeTracker.lastTrackedState = getCurrentChartStateCopy();

      changeTrackerUpdateState();
    }

    function changeTrackerUpdateState() {
      vm.changeTracker.enabled = (vm.changeTracker.disableTrackingCount === 0);

      // Trim entries if needed
      if (vm.changeTracker.undoStack.length > 50) {
        vm.changeTracker.undoStack.splice(0, vm.changeTracker.undoStack.length - 50);
      }

      $scope.$applyAsync(function () {
        vm.changeTracker.canUndo = (vm.changeTracker.undoStack.length > 0);
        vm.changeTracker.canRedo = (vm.changeTracker.redoStack.length > 0);
      });
    }

    function getCurrentChartStateCopy() {
      var state = {
        chartItems: [],
      };
      if (vm.selectedScene.accessRules.allowaddcharttextpersonal) {
        state.chartItems = vm.userChartLayerView.getChartItems();
      } else {
        state.chartItems = state.chartItems.concat(vm.semiChartLayerView.getChartItems());
        state.chartItems = state.chartItems.concat(vm.dynamicChartLayerView.getChartItems());
      }
      state.stateNumber = vm.changeTracker.nextStateNumber;

      return angular.copy(state);
    }

    function restoreChartStateFrom(state) {
      if (vm.selectedScene.accessRules.allowaddcharttextpersonal) {
        vm.selectedUserChart.items = state.chartItems;
        vm.userChartLayerView.setChartItems(state.chartItems);
        vm.userChartLayerView.refreshForUndoRedo();
      } else {
        vm.selectedChart.items = state.chartItems;
        vm.semiChartLayerView.setChartItems(state.chartItems);
        vm.semiChartLayerView.refreshForUndoRedo();
        vm.dynamicChartLayerView.setChartItems(state.chartItems);
        vm.dynamicChartLayerView.refreshForUndoRedo();
      }
      markChartDirty();
      ccChartUpdateNow();
    }

    function chartNotifyDataDidChange() {
      $log.debug('chartNotifyDataDidChange():', Date.now());
      markChartDirty();

      if (vm.changeTracker.enabled) {
        if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
          vm.changeTracker.undoStack.push(vm.changeTracker.lastTrackedState);
        }

        vm.changeTracker.nextStateNumber++;
        vm.changeTracker.lastTrackedState = getCurrentChartStateCopy();

        vm.changeTracker.redoStack.length = 0;
      }

      changeTrackerUpdateState();
      logChangeTrackerState();

      startAutoSaveTimer();
    }

    function chartNotifyDisableChangeTracking() {
      $log.debug('chartNotifyDisableChangeTracking():');
      vm.changeTracker.disableTrackingCount++;

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function chartNotifyEnableChangeTracking() {
      $log.debug('chartNotifyEnableChangeTracking():');
      vm.changeTracker.disableTrackingCount--;

      changeTrackerUpdateState();
      logChangeTrackerState();
    }

    function undoAction() {
      $log.debug('undoAction():');
      var undoState = vm.changeTracker.undoStack.pop();

      if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
        vm.changeTracker.redoStack.push(vm.changeTracker.lastTrackedState);
      }

      vm.changeTracker.lastTrackedState = angular.copy(undoState);

      restoreChartStateFrom(undoState);

      changeTrackerUpdateState();
      logChangeTrackerState();

      startAutoSaveTimer();
    }

    function redoAction() {
      $log.debug('redoAction():');
      var redoState = vm.changeTracker.redoStack.pop();

      if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
        vm.changeTracker.undoStack.push(vm.changeTracker.lastTrackedState);
      }

      vm.changeTracker.lastTrackedState = angular.copy(redoState);

      restoreChartStateFrom(redoState);

      changeTrackerUpdateState();
      logChangeTrackerState();

      startAutoSaveTimer();
    }

    function logChangeTrackerState() {
      $log.debug('Change Tracker - nextStateNumber:', vm.changeTracker.nextStateNumber);

      $log.debug('Change Tracker - undoStack:', _.map(vm.changeTracker.undoStack, function (item) {
        return item.stateNumber;
      }));

      $log.debug('Change Tracker - redoStack top:', _.map(vm.changeTracker.redoStack, function (item) {
        return item.stateNumber;
      }));

      if (angular.isDefined(vm.changeTracker.lastTrackedState)) {
        $log.debug('Change Tracker - lastTrackedState:', vm.changeTracker.lastTrackedState.stateNumber);
      } else {
        $log.debug('Change Tracker - lastTrackedState: --');
      }

      $log.debug('Change Tracker - disableTrackingCount:', vm.changeTracker.disableTrackingCount);
      $log.debug('Change Tracker ---------------');
    }

    function toggleLockModeNavigation() {
      hideSideBarDeleteAndMoveOptions();
      if (vm.chartEditorState.lockModeNavigation) {
        blockUI.start('Leaving lock mode ...');
      } else {
        blockUI.start('Enabling lock mode ...');
        vm.dynLayerActiveStatus = vm.chartEditorState.dynLayerActive;
        vm.semiLayerActiveStatus = vm.chartEditorState.semiLayerActive;
      }

      if (vm.sidebarEditState.enabled) {
        toggleSidebarEditMode();
      }

      vm.chartEditorState.lockModeNavigation = !vm.chartEditorState.lockModeNavigation;
      // if (vm.chartEditorState.lockModeNavigation) {
      //   if (vm.chartEditorState.inspectorVisible) {
      //     vm.chartEditorState.inspectorVisible = false;
      //   }
      // }

      deactivateSemiPermanentLayer();
      deactivateDynamicLayer();
      deactivateUserLayer();
      saveActiveChart()
        .then(function () {
          if (vm.chartEditorState.lockModeNavigation) {
            lockNavigationSelectInitialChart();
          } else {
            if (angular.isDefined(vm.selectedScene)) {
              vm.selectedScene.open = true;
              if (angular.isDefined(vm.selectedChart)) {
                if (vm.dynLayerActiveStatus) {
                  activateDynamicLayer();
                }
                if (vm.semiLayerActiveStatus) {
                  activateSemiPermanentLayer();
                }
                $timeout(function () {
                  vm.scrollUpdateSidebar('scrollTo', $('#chart-' + vm.selectedChart._id).position().top - 40);
                }, 500);
              }
            }
            if (angular.isDefined(vm.selectedScene) && vm.selectedScene.accessRules.allowaddcharttextpersonal) {
              activateUserLayer();
            }
          }

          return $timeout(function () {
            ccForceSizeUpdate();
          }, 500, false);
        })
        .then(function () {
          blockUI.stop();
        })
    }

    function lockNavigationSelectInitialChart() {
      if (angular.isDefined(vm.selectedChart) || angular.isDefined(vm.selectedScene)) {
        return;
      }

      // toggle open the first scene
      lockNavigationPreviousScene();
    }

    function lockNavigationPreviousScene(fromPrevChart) {
      fromPrevChart = fromPrevChart || false;
      toastr.clear();
      if (angular.isDefined(vm.selectedScene)) {
        var previousSceneIndex = vm.selectedScene.orderingindex - 1;
        if (previousSceneIndex > -1) {
          var previousScene = vm.scenes[previousSceneIndex];
          toggleScene(previousScene)
            .then(function () {
              var chartToSelect;
              if (!fromPrevChart) {
                chartToSelect = _.first(vm.selectedScene.charts);
              } else {
                chartToSelect = _.last(vm.selectedScene.charts);
              }
              if (angular.isDefined(chartToSelect)) {
                selectChart(chartToSelect);
              }
            });
        } else {
          // try to go to first chart in the scene
          var chartToSelect = _.first(vm.selectedScene.charts);
          if (angular.isDefined(chartToSelect) && (vm.selectedChart !== chartToSelect)) {
            selectChart(chartToSelect);
          } else {
            toastr.info($translate.instant('messages.At first chart/scene'));
          }
        }
      } else {
        var firstScene = _.first(vm.scenes);
        if (angular.isDefined(firstScene)) {
          toggleScene(firstScene)
            .then(function () {
              var chartToSelect = _.first(vm.selectedScene.charts);
              if (angular.isDefined(chartToSelect)) {
                selectChart(chartToSelect);
              }
            });
        }
      }
    }

    function lockNavigationPreviousChart() {
      toastr.clear();
      if (angular.isDefined(vm.selectedChart)) {
        var previousOrderingIndex = vm.selectedChart.orderingindex - 1;

        if (previousOrderingIndex > -1) {
          var previousChart = vm.selectedScene.charts[previousOrderingIndex];
          selectChart(previousChart);
        } else {
          lockNavigationPreviousScene(true);
        }
      } else {
        lockNavigationPreviousScene(true);
      }
    }

    function lockNavigationNextChart() {
      toastr.clear();
      if (angular.isDefined(vm.selectedChart)) {
        var nextOrderingIndex = vm.selectedChart.orderingindex + 1;

        if (nextOrderingIndex < vm.selectedScene.charts.length) {
          var nextChart = vm.selectedScene.charts[nextOrderingIndex];
          selectChart(nextChart);
        } else {
          lockNavigationNextScene();
        }
      } else {
        lockNavigationNextScene();
      }
    }

    function lockNavigationNextScene(overflow) {
      toastr.clear();
      if (angular.isDefined(vm.selectedScene)) {
        var nextSceneIndex = vm.selectedScene.orderingindex + 1;
        if (nextSceneIndex < vm.scenes.length) {
          var nextScene = vm.scenes[nextSceneIndex];
          toggleScene(nextScene)
            .then(function () {
              var chartToSelect = _.first(vm.selectedScene.charts);
              if (angular.isDefined(chartToSelect)) {
                selectChart(chartToSelect);
              }
            });
        } else {
          // try to go to last chart in the scene
          var chartToSelect = _.last(vm.selectedScene.charts);
          if (angular.isDefined(chartToSelect) && (vm.selectedChart !== chartToSelect)) {
            selectChart(chartToSelect);
          } else {
            toastr.info($translate.instant('messages.At last chart/scene'));
          }
        }
      } else {
        var lastScene = _.last(vm.scenes);
        if (angular.isDefined(lastScene)) {
          toggleScene(lastScene)
            .then(function () {
              var chartToSelect = _.last(vm.selectedScene.charts);
              if (angular.isDefined(chartToSelect)) {
                selectChart(chartToSelect);
              }
            });
        }
      }
    }

    function deleteMedia(chartItemMedia) {
      var ind = vm.selectedChartMediaItems.indexOf(chartItemMedia);
      if (ind !== -1) {
        vm.selectedChartMediaItems.splice(ind, 1);
      }

      vm.selectedChartMediaItems.forEach(function (mediaItem, index) {
        mediaItem.zindex = index;
      });
      vm.selectedChart.dirty = true;
    }

    function resetMediaDockState() {
      vm.chartEditorState.mediaDrawerOpen = false;
      vm.mediaDockState.viewState = true;
    }

    function addChartMedia(mediaDetails) {
      /**
       * @type {ChartItemMedia}
       */
      var newMediaItem = {};
      newMediaItem._id = '__tmp__' + Date.now();
      newMediaItem.itemtype = SWChartItem.Type.Media;
      newMediaItem.zindex = vm.selectedChartMediaItems.length;
      newMediaItem.mediadetails = angular.copy(mediaDetails);

      vm.selectedChartMediaItems.push(newMediaItem);
      vm.selectedChart.dirty = true;
    }

    /**
     * Update media details of the given chart item.
     * @param {ChartItemType} chartItemMedia - The chart item to update.
     * @param {ChartItemMediaDetails} updatedMediaDetails - Updated media details.
     */
    function updateChartMedia(chartItemMedia, updatedMediaDetails) {
      chartItemMedia.mediadetails = angular.copy(updatedMediaDetails);
      vm.selectedChart.dirty = true;
    }

    function killAutoSaveTimer() {
      if (angular.isDefined(vm.autoSaveState.intervalQ)) {
        $interval.cancel(vm.autoSaveState.intervalQ);
        vm.autoSaveState.intervalQ = undefined;
      }
      vm.autoSaveState.timerActive = false;
      vm.autoSaveState.timeoutRemainingSec = 0;
    }

    function startAutoSaveTimer() {
      if (angular.isDefined(vm.autoSaveState.intervalQ)) {
        vm.autoSaveState.timeoutRemainingSec = vm.autoSaveState.timeoutMaxSec;
        return;
      }
      vm.autoSaveState.timeoutRemainingSec = vm.autoSaveState.timeoutMaxSec;
      vm.autoSaveState.intervalQ = $interval(function () {
        vm.autoSaveState.timeoutRemainingSec -= (vm.autoSaveState.timeoutDecaySec);
        if (vm.autoSaveState.timeoutRemainingSec <= 0) {
          killAutoSaveTimer();
          autoSaveHandler();
        }
      }, vm.autoSaveState.timeoutPollIntervalSec * 1000);
      vm.autoSaveState.timerActive = true;
    }

    function autoSaveHandler() {
      if (!vm.autoSaveState.saveActive) {
        $log.info('autoSaveHandler: auto save started!');
        vm.autoSaveState.saveActive = true;
        saveActiveChart(true)
          .catch(function () {
          })
          .then(function () {
            vm.autoSaveState.saveActive = false;
            $log.info('autoSaveHandler: auto save done!');
          });
      } else {
        $log.info('autoSaveHandler: auto save in progress, ignoring!');
      }
    }

    function getAllDeletedCharts() {
      blockUI.start('Looking for deleted charts ...');

      dbCharts.getDeletedChartsFromAllScenes(vm.selectedProduction._id)
        .then(function (allDeletedChartsList) {
          allDeletedChartsList.forEach(function (chart, index) {
            chart.index = index + 1;
            chart.sceneId = 'dummyscene';
          });

          var currentDate = Date.now();
          var dateBeforeSevenDays = currentDate - 604800000; // 7 days

          vm.dummyScenesForRemovedCharts[0].charts = allDeletedChartsList.filter(function (chart) {
            return chart.deletedDate.$date >= dateBeforeSevenDays;
          });
          vm.dummyScenesForRemovedCharts[1].charts = allDeletedChartsList.filter(function (chart) {
            return chart.deletedDate.$date < dateBeforeSevenDays;
          });
        })
        .catch(function (error) {
          $log.error('Error getting deleted charts:', error);
          toastr.error('Error getting deleted charts!');
        })
        .finally(function () {
          toggleRemovedChartsScene(vm.dummyScenesForRemovedCharts[0])
          blockUI.stop();
        });
    }

    function enterDeletedChartList() {
      if (vm.sidebarEditState.enabled) {
        toggleSidebarEditMode();
      }

      blockUI.start('Loading deleted charts ...');
      var firstQ;
      if (angular.isDefined(vm.selectedScene)) {
        firstQ = toggleScene(vm.selectedScene)
      } else {
        firstQ = $q.resolve();
      }

      firstQ
        .then(function () {
          vm.selectedChart = undefined;
          vm.selectedChartOrderingIndex = undefined;

          vm.deletedChartListMode = true;
          vm.chartEditorState.chartOpen = false;

          deactivateSemiPermanentLayer();
          deactivateDynamicLayer();
        })
        .then(function () {
          return getAllDeletedCharts();
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    function leaveDeletedChartList() {
      chartVersionBrowserState.active = false;

      if (vm.selectedScene) {
        toggleRemovedChartsScene(vm.selectedScene);
      }
      vm.selectedScene = undefined;
      vm.selectedChart = undefined;
      vm.restoringSingleChart = false;
      vm.deletedChartListMode = false;
      vm.chartEditorState.chartOpen = false;
    }

    function checkForChartVersions() {
      toastr.clear();
      blockUI.start('Looking for Chart versions ...');
      dbChartsArchive.find(vm.selectedChart._id)
        .then(function (archivedCharts) {
          if (angular.isArray(archivedCharts) && archivedCharts.length > 0) {
            chartVersionBrowserState.chartVersions = angular.copy(archivedCharts);

            enterChartVersionsBrowser();
          } else {
            toastr.info('No versions found for this chart');

            chartVersionBrowserState.chartVersions = [];
            chartVersionBrowserState.active = true;

            unloadChartNoSave();
          }
        })
        .catch(function (err) {
          toastr.warning('Error getting versions for this chart!');
          $log.error('checkForChartVersions: err:', err);
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    function enterChartVersionsBrowser() {
      blockUI.start('Loading Chart Versions ...');

      if (vm.sidebarEditState.enabled) {
        toggleSidebarEditMode();
      }

      vm.chartEditorState.inspectorVisible = false;

      chartVersionBrowserState.active = true;

      chartVersionBrowserState.selectedIndex = 0;
      chartVersionBrowserState.maxIndex = (chartVersionBrowserState.chartVersions.length - 1);

      loadVersionedChartItems();
      getUserNameById();

      vm.selectedChart = vm.chartVersionBrowserState.selectedVersion.chart;
      var targetDiv = $document[0].getElementById('mce-editor-chart-notes-text');
      targetDiv.innerHTML = vm.selectedChart.notes || '';

      blockUI.stop();
      return $timeout(function () {
        ccForceSizeUpdate();
      }, 500, false);
    }

    function loadVersionedChartItems() {
      blockUI.start();
      ccChartQuickUpdates();

      chartVersionBrowserState.prevEnabled = (chartVersionBrowserState.selectedIndex > 0);
      chartVersionBrowserState.nextEnabled = (chartVersionBrowserState.selectedIndex < chartVersionBrowserState.maxIndex);
      chartVersionBrowserState.selectedVersion = chartVersionBrowserState.chartVersions[chartVersionBrowserState.selectedIndex];

      var items = chartVersionBrowserState.selectedVersion.chartItems;
      vm.semiChartLayerView.setChartItems(items);
      vm.dynamicChartLayerView.setChartItems(items);

      vm.chartEditorState.chartOpen = true;

      blockUI.stop();
      ccChartPauseUpdates();
    }

    function chartVersionPrevious() {
      chartVersionBrowserState.selectedIndex--;
      if (chartVersionBrowserState.selectedIndex < 0) {
        chartVersionBrowserState.selectedIndex = 0;
      } else {
        loadVersionedChartItems();
        getUserNameById();

        vm.selectedChart = vm.chartVersionBrowserState.selectedVersion.chart;
        var targetDiv = $document[0].getElementById('mce-editor-chart-notes-text');
        targetDiv.innerHTML = vm.selectedChart.notes || '';
      }
    }

    function chartVersionNext() {
      chartVersionBrowserState.selectedIndex++;
      if (chartVersionBrowserState.selectedIndex > chartVersionBrowserState.maxIndex) {
        chartVersionBrowserState.selectedIndex = maxIndex;
      } else {
        loadVersionedChartItems();
        getUserNameById();

        vm.selectedChart = vm.chartVersionBrowserState.selectedVersion.chart;
        var targetDiv = $document[0].getElementById('mce-editor-chart-notes-text');
        targetDiv.innerHTML = vm.selectedChart.notes || '';
      }
    }

    function getUserNameById() {
      dbUser.getDisplayName(vm.chartVersionBrowserState.selectedVersion.userId).then(
        function (displayName) {
          if (angular.isDefined(displayName)) {
            vm.chartVersionBrowserState.selectedVersion.displayName = displayName;
          }
        },

        function (error) {
          $log.error(error);
        }
      );
    }

    function selectChartVersionToPreview(index) {
      blockUI.start();
      ccChartQuickUpdates();

      vm.chartVersionBrowserState.selectedVersion = chartVersionBrowserState.chartVersions[index];
      chartVersionBrowserState.selectedIndex = index * 1;

      if (chartVersionBrowserState.selectedIndex < 0) {
        chartVersionBrowserState.selectedIndex = 0;
      } else if (chartVersionBrowserState.selectedIndex > chartVersionBrowserState.maxIndex) {
        chartVersionBrowserState.selectedIndex = maxIndex;
      } else {
        loadVersionedChartItems();
      }

      var items = vm.chartVersionBrowserState.selectedVersion.chartItems;
      vm.semiChartLayerView.setChartItems(items);
      vm.dynamicChartLayerView.setChartItems(items);

      blockUI.stop();
      ccChartPauseUpdates();
    }

    // function copyLink() {
    //   var linkBase = location.origin;
    //   var linkUrl = linkBase + '/#/' + swaRouterStateNames.chartlink + '/' + btoa(selectedProductionId) + '/' + btoa(vm.selectedChart._id);

    //   var copyElement = $document[0].createElement("textarea");
    //   copyElement.style.position = 'fixed';
    //   copyElement.style.opacity = '0';
    //   copyElement.textContent = linkUrl;
    //   var body = $document[0].getElementsByTagName('body')[0];
    //   body.appendChild(copyElement);
    //   copyElement.select();
    //   $document[0].execCommand('copy');
    //   body.removeChild(copyElement);
    //   toastr.success('Link for this chart copied to clipboard', 'Chart link');
    // }

    function copyChartImageToClipboard() {
      if (angular.isUndefined(vm.selectedChart)) {
        return;
      }

      if (!vm.activeAccessRules.allowchartediting) {
        return;
      }

      var srcCanvas = $('#chartCanvas').get(0);
      var tmpCanvas = $document[0].createElement('canvas');
      var extendedHeightForFooter = 108 + 32;
      tmpCanvas.width = srcCanvas.width;
      tmpCanvas.height = srcCanvas.height + extendedHeightForFooter;
      var ctx = tmpCanvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.mozImageSmoothingEnabled = true;
      ctx.webkitImageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.fillStyle = 'rgba(255, 255, 255, 1)';
      ctx.fillRect(0, 0, tmpCanvas.width, tmpCanvas.height);
      ctx.drawImage(srcCanvas, 0, 0, tmpCanvas.width, srcCanvas.height);

      // Add text to the canvas
      ctx.font = '20px Arial';
      ctx.fillStyle = 'black';
      var rightColumnX = tmpCanvas.width / 4;

      // To add production name or logo
      if (vm.selectedProduction.logo) {
        var base64String = vm.selectedProduction.logo;
        var binaryData = atob(base64String);
        var img = new Image();
        img.src = 'data:image/png;base64,' + btoa(binaryData);
        // Calculate the aspect ratio of the image
        var aspectRatio = img.width / img.height;
        // Determine the dimensions that fit within a 178x100 box while maintaining the aspect ratio
        var maxWidth = 192;
        var maxHeight = 108;
        if (aspectRatio > maxWidth / maxHeight) {
          // Image is wider than the box
          img.width = maxWidth;
          img.height = maxWidth / aspectRatio;
        } else {
          // Image is taller than the box
          img.height = maxHeight;
          img.width = maxHeight * aspectRatio;
        }
        // Calculate the position to center the image horizontally
        var x = (rightColumnX - img.width) / 2;

        // Draw the image on the canvas
        ctx.drawImage(img, x, srcCanvas.height + 16, img.width, img.height);
      } else {
        ctx.save();
        ctx.font = '22px Arial';

        var maxWidth = rightColumnX - rightColumnX / 6;
        var text = vm.selectedProduction.name;
        // Function to wrap text
        function wrapText(context, text, x, y, maxWidth, lineHeight) {
          var words = text.split(' ');
          var line = '';

          for (var i = 0; i < words.length; i++) {
            var testLine = line + words[i] + ' ';
            var metrics = context.measureText(testLine);
            var testWidth = metrics.width;

            if (testWidth > maxWidth && i > 0) {
              context.fillText(line, x, y);
              line = words[i] + ' ';
              y += lineHeight;
            } else {
              line = testLine;
            }
          }

          context.fillText(line, x, y);
        }
        var x = rightColumnX / 6;
        var y = srcCanvas.height + 62;
        var lineHeight = 30; // Adjust the line height as needed

        wrapText(ctx, text, x, y, maxWidth, lineHeight);
        ctx.restore();
      }

      // To add scene name
      ctx.fillText('Scene: ' + vm.selectedScene.scenename, rightColumnX, srcCanvas.height + 16 + 30);

      // To add chart number
      if (vm.chartEditorState.chartNumberAutomatic) {
        ctx.fillText('Chart: ' + (vm.selectedScene.orderingindex + 1) + '.' + (vm.selectedChart.orderingindex + 1), rightColumnX, srcCanvas.height + 16 + 66);
      } else {
        ctx.fillText(
          'Chart: ' + (vm.selectedChart.customname || ''),
          rightColumnX,
          srcCanvas.height + 16 + 66
        );
      }

      // To add cue line text
      // eslint-disable-next-line angular/definedundefined
      if (vm.selectedChart.cuelinetext !== undefined) {
        var maxWidth = tmpCanvas.width - rightColumnX - 16; // Adjust this value as needed
        var text = 'Cue line: ' + vm.selectedChart.cuelinetext;
        // Measure the width of the text
        var textWidth = ctx.measureText(text).width;
        if (textWidth > maxWidth) {
          // If the text width exceeds the maximum width, truncate and add ellipsis
          var ellipsis = '...';
          var truncatedText = text;
          while (ctx.measureText(truncatedText + ellipsis).width > maxWidth - ctx.measureText(ellipsis).width) {
            truncatedText = truncatedText.slice(0, -1);
          }
          truncatedText += ellipsis;
          ctx.fillText(truncatedText, rightColumnX, srcCanvas.height + 16 + 102);
        } else {
          // If the text fits within the canvas width, draw it as is
          ctx.fillText(text, rightColumnX, srcCanvas.height + 16 + 102);
        }
      }

      // draw a separator
      ctx.strokeStyle = 'rgb(192, 192, 192)';
      ctx.moveTo(rightColumnX - 8, srcCanvas.height + 16);
      ctx.lineTo(rightColumnX - 8, srcCanvas.height + 16 + 108);
      ctx.stroke();

      // Convert base64 image link to binary data
      var imageData = atob(tmpCanvas.toDataURL('image/png').split(',')[1]);
      var arrayBuffer = new ArrayBuffer(imageData.length);
      var uint8Array = new Uint8Array(arrayBuffer);
      for (var i = 0; i < imageData.length; i++) {
        uint8Array[i] = imageData.charCodeAt(i);
      }

      var blob = new Blob([arrayBuffer], { type: 'image/png' });

      navigator.clipboard.write([new ClipboardItem({ "image/png": blob })])
        .then(function () {
          toastr.success('Chart image copied to clipboard', 'Chart image');
        })
        .catch(function (error) {
        });
    }

    function findSelectedPerformers(performers) {
      var processedIds = new Set();
      var selectedPerformers = [];

      performers.forEach(function (performer) {
        var selectedPerformer = vm.performers.find(function (p) {
          return p._id === performer.referencedperformerId;
        });

        if (selectedPerformer && !processedIds.has(performer.referencedperformerId)) {
          processedIds.add(performer.referencedperformerId);
          selectedPerformers.push(selectedPerformer);
        }
      });

      return selectedPerformers;
    }

    function performerTrackReassignmentPrompt() {
      vm.performerPicker.show = false;
      hideChartContextMenu();
      killAutoSaveTimer();
      saveActiveChart();
      var selectedPerformersIds = findSelectedPerformers(vm.selectedPerformers);

      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/chartEditor/performerTrackReassignmentPrompt.html',
        controller: 'PerformerTrackReassignmentController',
        controllerAs: 'vm',
        size: '960',
        windowClass: 'sw-modal',
        backdropClass: 'sw-modal-backdrop',
        backdrop: 'static',
        resolve: {
          params: {
            performers: vm.performers,
            scenes: vm.scenes,
            activePlanRules: vm.activePlanRules,
            selectedPerformers: selectedPerformersIds,
            selectedScene: vm.selectedScene,
            chartEditorState: vm.chartEditorState,
            selectedChart: vm.selectedChart,
          }
        }
      });
      modalInstance.result
        .then(function (performerPairsWithIds) {
          $localStorage.performerPairsWithIdsForUndo = performerPairsWithIds;
          vm.performerPairsWithIdsForUndo = $localStorage.performerPairsWithIdsForUndo;
          swapPerformer(performerPairsWithIds);
        });
    }

    function swapPerformer(performerPairsWithIds) {
      blockUI.start($translate.instant('messages.Swapping ...'));
      dbChartItems.reassignPerformer(performerPairsWithIds)
        .then(function () {
          loadChartItems();
          toastr.success($translate.instant('messages.Performer(s) reassigned!'));
        })
        .catch(function (error) {
          $log.error('ChartEditorController.swapPerformer:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error swapping performers!')
          );
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    // Undo Reassignment Warning prompt
    function undoReassignmentPrompt() {
      killAutoSaveTimer();
      saveActiveChart();
      vm.performerPicker.show = false;
      var modalInstance = $uibModal.open({
        animation: true,
        templateUrl: 'app/components/chartEditor/undoReassignmentPrompt.html',
        controller: 'UndoReassignmentController',
        controllerAs: 'vm',
        size: 'sm',
        windowClass: 'sw-modal sw-modal-400',
        backdropClass: 'sw-modal-backdrop',
      });

      modalInstance.result.then(undoSwapPerformer);
    }

    function undoSwapPerformer() {
      blockUI.start($translate.instant('messages.Swapping ...'));
      dbChartItems.undoReassignPerformer(vm.performerPairsWithIdsForUndo)
        .then(function () {
          $localStorage.performerPairsWithIdsForUndo = undefined;
          vm.performerPairsWithIdsForUndo = undefined;
          loadChartItems();
          toastr.success($translate.instant('messages.Reassignment reversed!'));
        })
        .catch(function (error) {
          $log.error('ChartEditorController.swapPerformer:', error);
          swaUtils.showErrorToast(
            error,
            $translate.instant('errormessages.Error undo reassignment performers!')
          );
        })
        .finally(function () {
          blockUI.stop();
        });
    }

    function updateScalePerformers(option) {
      vm.scalePerformers.allPerformers = option === PerformerOptions.All;
      vm.scalePerformers.selectedPerformers = option === PerformerOptions.Selected;

      $localStorage.scaleAllPerformers = vm.scalePerformers.allPerformers;
      $localStorage.scaleSelectedPerformers = vm.scalePerformers.selectedPerformers;

      vm.chartItemViewFactory.scaleAllPerformers = vm.scalePerformers.allPerformers;
      vm.chartItemViewFactory.scaleSelectedPerformers = vm.scalePerformers.selectedPerformers;

      vm.dynamicChartLayerView.refresh();
    }

    function searchStringChangedForSetpice() {
      vm.searchStringUpperForSetpice = vm.searchpersetpiece.toUpperCase();
    }

    function clearSearchForSetpice() {
      vm.searchStringUpperForSetpice = '';
      vm.searchpersetpiece = '';
    }

    function setpieceSearchFilter(setpiece) {
      return setpiece.name.toUpperCase().indexOf(vm.searchStringUpperForSetpice) > -1;
    }

    function searchStringChangedForPerformer() {
      vm.searchStringUpperForPerformer = vm.searchperformername.toUpperCase();
    }

    function clearSearchForPerformer() {
      vm.searchStringUpperForPerformer = '';
      vm.searchperformername = '';
    }

    function performerSearchFilter(performer) {
      return performer.name.toUpperCase().indexOf(vm.searchStringUpperForPerformer) > -1 || performer.text.toUpperCase().indexOf(vm.searchStringUpperForPerformer) > -1;
    }

    function refreshPerformersOnTheChart(performerIdsOnChartSet) {
      vm.performers.forEach(function (performer) {
        performer.isOnChart = performerIdsOnChartSet.has(performer._id);
      });
    }
  }
}());

/* global tinymce */
(function () {
  'use strict';

  angular.module('swanywhere').directive('swChartContextMenu', swChartContextMenu);

  function swChartContextMenu() {
    var directive = {
      restrict: 'A',
      scope: {
        state: '=',
        triggerAction: '&onAction',
        preferences: '=',
        activeCollaborationConfig: '=',
      },
      controller: ChartContextMenuController,
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: 'app/components/chartEditor/chartContextMenu.html',
    };

    return directive;
  }

  ChartContextMenuController.$inject = [
    '$scope',
    'swaUi',
    '$log',
  ];

  function ChartContextMenuController($scope, swaUi, $log) {
    var vm = this;

    vm.colorPickerOption = swaUi.colorPickerOption;

    vm.rotateBy = rotateBy;
    vm.resetRotation = resetRotation;
    vm.selectedItemsResetRotation = selectedItemsResetRotation;

    vm.rotateHeadBy = rotateHeadBy;
    vm.resetHeadRotation = resetHeadRotation;

    vm.layerAction = layerAction;
    vm.layerToggleAction = layerToggleAction;

    vm.rotationToggleAction = rotationToggleAction;
    vm.snapToGridToggleAction = snapToGridToggleAction;

    vm.borderColorChanged = borderColorChanged;
    vm.fillColorChanged = fillColorChanged;

    vm.clipboardAction = clipboardAction;

    vm.flipHorizontallyAction = flipHorizontallyAction;
    vm.flipVerticallyAction = flipVerticallyAction;

    vm.groupToggleAction = groupToggleAction;
    vm.editAction = editAction;
    vm.deleteAction = deleteAction;
    vm.clearAction = clearAction;

    vm.vectorEditorDeleteNodeAction = vectorEditorDeleteNodeAction;
    vm.vectorEditorDoneAction = vectorEditorDoneAction;

    vm.freehandToolCloseAction = freehandToolCloseAction;
    vm.freehandHasArrowheadChange = freehandHasArrowheadChange;
    vm.freehandToolSaveAction = freehandToolSaveAction;
    vm.freehandToolClearAction = freehandToolClearAction;

    vm.closeContextMenu = closeContextMenu;
    vm.toggleChartContextMenuPinStatus = toggleChartContextMenuPinStatus;
    vm.showAlignMenuOptions = showAlignMenuOptions;
    vm.hideAlignMenuOptions = hideAlignMenuOptions;

    vm.alignLeft = alignLeft;
    vm.alignCenter = alignCenter;
    vm.alignRight = alignRight;
    vm.alignTop = alignTop;
    vm.alignMiddle = alignMiddle;
    vm.alignBottom = alignBottom;

    vm.horizontalSpacing = horizontalSpacing;
    vm.verticalSpacing = verticalSpacing;

    vm.alignToGridAction = alignToGridAction;

    vm.performerTrackReassignmentAction = performerTrackReassignmentAction;

    vm.increaseLineThickness = increaseLineThickness;
    vm.decreaseLineThickness = decreaseLineThickness;
    vm.resetLineThickness = resetLineThickness;

    vm.tinymceEditor = undefined;

    $scope.$watch('vm.state.headRotateable', function (newVal, oldVal) {
      if (newVal === true) {
        fixHeadAngle(vm.state.headRotationDeg);
      }
    });

    function invokeTriggerAction(actionData) {
      vm.triggerAction({
        action: actionData,
      });
    }

    function fixAngle(angle) {
      while (angle < 0) {
        angle += 360;
      }

      if (angle > 359) {
        angle = angle % 360;
      }

      return angle;
    }

    function rotateBy(angle) {
      vm.state.rotationDeg = fixAngle(vm.state.rotationDeg + angle);
      invokeTriggerAction({
        type: 'angle',
        value: vm.state.rotationDeg,
      });
    }

    function resetRotation() {
      vm.state.rotationDeg = 0;
      invokeTriggerAction({
        type: 'angle',
        value: vm.state.rotationDeg,
      });
    }

    function selectedItemsResetRotation() {
      invokeTriggerAction({
        type: 'resetAngle',
        value: 0,
      });
    }

    function increaseLineThickness() {
      invokeTriggerAction({
        type: 'increaseThickness',
      });
    }

    function decreaseLineThickness() {
      invokeTriggerAction({
        type: 'decreaseThickness',
      });
    }

    function resetLineThickness() {
      invokeTriggerAction({
        type: 'resetThickness',
      });
    }

    function fixHeadAngle(angle) {
      if (angle < -90) {
        angle = -90;
      }

      if (angle > 90) {
        angle = 90;
      }

      if (angle === 0) {
        vm.headRotationDisplay = '0';
      } else if (angle === -90) {
        vm.headRotationDisplay = 'L';
      } else if (angle === 90) {
        vm.headRotationDisplay = 'R';
      } else if (angle < 0) {
        vm.headRotationDisplay = '' + Math.round(-angle) + 'L';
      } else if (angle > 0) {
        vm.headRotationDisplay = '' + Math.round(angle) + 'R';
      } else {
        vm.headRotationDisplay = '--';
      }

      return angle;
    }

    function rotateHeadBy(angle) {
      vm.state.headRotationDeg = fixHeadAngle(vm.state.headRotationDeg + angle);
      invokeTriggerAction({
        type: 'headangle',
        value: vm.state.headRotationDeg,
      });
    }

    function resetHeadRotation() {
      vm.state.headRotationDeg = fixHeadAngle(0);
      invokeTriggerAction({
        type: 'headangle',
        value: vm.state.headRotationDeg,
      });
    }

    function layerAction(action) {
      invokeTriggerAction({
        type: 'layer',
        value: action,
      });
    }

    function layerToggleAction() {
      if (vm.state.selectionOrderingMode) {
        invokeTriggerAction({
          type: 'layer',
          value: 'end',
        });
      } else {
        invokeTriggerAction({
          type: 'layer',
          value: 'begin',
        });
      }
    }

    function rotationToggleAction() {
      if (vm.state.selectionRotationMode) {
        invokeTriggerAction({
          type: 'rotation',
          value: 'end',
        });
      } else {
        invokeTriggerAction({
          type: 'rotation',
          value: 'begin',
        });
      }
    }
    function snapToGridToggleAction() {
      if (vm.state.selectionSnapToGrid) {
        invokeTriggerAction({
          type: 'snapToGridMode',
          value: 'end',
        });
      } else {
        invokeTriggerAction({
          type: 'snapToGridMode',
          value: 'begin',
        });
      }
    }

    function borderColorChanged(color) {
      invokeTriggerAction({
        type: 'color',
        value: {
          border: color,
        },
      });
    }

    function fillColorChanged(color) {
      invokeTriggerAction({
        type: 'color',
        value: {
          fill: color,
        },
      });
    }

    function clipboardAction(action) {
      invokeTriggerAction({
        type: 'clipboard',
        value: action,
      });
    }

    function groupToggleAction() {
      invokeTriggerAction({
        type: 'group',
      });
    }

    function flipHorizontallyAction() {
      invokeTriggerAction({
        type: 'fliphorizontally',
      });
    }

    function flipVerticallyAction() {
      invokeTriggerAction({
        type: 'flipvertically',
      });
    }

    function editAction() {
      invokeTriggerAction({
        type: 'edit',
      });
    }

    function deleteAction() {
      invokeTriggerAction({
        type: 'delete',
      });
    }

    function clearAction() {
      invokeTriggerAction({
        type: 'clear',
      });
    }

    function vectorEditorDeleteNodeAction() {
      invokeTriggerAction({
        type: 'vectorEditor',
        value: 'deleteNode',
      });
    }

    function vectorEditorDoneAction() {
      invokeTriggerAction({
        type: 'vectorEditor',
        value: 'done',
      });
    }

    function freehandToolCloseAction() {
      invokeTriggerAction({
        type: 'freehandTool',
        value: 'close',
      });
    }

    function freehandHasArrowheadChange() {
      invokeTriggerAction({
        type: 'freehandTool',
        value: 'arrowheadChange',
      });
    }

    function freehandToolSaveAction() {
      invokeTriggerAction({
        type: 'freehandTool',
        value: 'save',
      });
    }

    function freehandToolClearAction() {
      invokeTriggerAction({
        type: 'freehandTool',
        value: 'clear',
      });
    }

    function closeContextMenu() {
      invokeTriggerAction({
        type: 'closeContextMenu',
        value: 'closeMenu'
      });
    }

    function toggleChartContextMenuPinStatus() {
      invokeTriggerAction({
        type: 'togglepinstatus',
        value: 'togglepinstatus',
      });
    }

    function showAlignMenuOptions() {
      invokeTriggerAction({
        type: 'showAlignMenu',
        value: 'alignMenuShow'
      });
    }
    function hideAlignMenuOptions() {
      invokeTriggerAction({
        type: 'hideAlignMenu',
        value: 'alignMenuHide'
      });
    }

    function alignLeft() {
      invokeTriggerAction({
        type: 'alignLeft',
      });
    }

    function alignCenter() {
      invokeTriggerAction({
        type: 'alignCenter',
      });
    }

    function alignRight() {
      invokeTriggerAction({
        type: 'alignRight',
      });
    }

    function alignTop() {
      invokeTriggerAction({
        type: 'alignTop',
      });
    }

    function alignMiddle() {
      invokeTriggerAction({
        type: 'alignMiddle',
      });
    }

    function alignBottom() {
      invokeTriggerAction({
        type: 'alignBottom',
      });
    }
    function horizontalSpacing() {
      invokeTriggerAction({
        type: 'horizontalSpacing',
      });
    }
    function verticalSpacing() {
      invokeTriggerAction({
        type: 'verticalSpacing',
      });
    }
    function alignToGridAction() {
      invokeTriggerAction({
        type: 'alignToGrid',
      });
    }
    function performerTrackReassignmentAction() {
      invokeTriggerAction({
        type: 'performerTrackReassignment',
      });
    }
  }
}());

var CHART_CTX_MNU_WIDTH = 261;
var CHART_CTX_MNU_HEIGHT = 530;

(function () {
  'use strict';

  // eslint-disable-next-line angular/no-service-method
  angular.module('swanywhere').service('swaUtils', SwaUtilsService);

  SwaUtilsService.$inject = [
    '$log',
    '$state',
    '$translate',
    'toastr',
    'swaRouterStateNames',
  ];

  function SwaUtilsService($log, $state, $translate, toastr, swaRouterStateNames) {

    this.showErrorToast = showErrorToast;
    this.findInArrayById = findInArrayById;
    this.getIndexOf = getIndexOf;
    this.getIndexOfValue = getIndexOfValue;
    this.isUndefinedOrNull = isUndefinedOrNull;
    this.sortArrayByNumericKey = sortArrayByNumericKey;
    this.determineUsername = determineUsername;
    this.getUserNameForDisplay = getUserNameForDisplay;
    this.stateGo = stateGo;
    this.stateGoLocationReplace = stateGoLocationReplace;
    this.stateGoSkipValidation = stateGoSkipValidation;
    this.getRouterCurrentState = getRouterCurrentState;
    this.getRouterCurrentStateName = getRouterCurrentStateName;
    this.isRouterCurrentStateName = isRouterCurrentStateName;
    this.getSanitizedErrorMessage = getSanitizedErrorMessage;
    this.getFeetAndInches = getFeetAndInches;
    this.roundFraction = roundFraction;
    this.getFinalValueInFeet = getFinalValueInFeet;
    this.feetAndInchesText = feetAndInchesText;
    this.sessionErrorInterceptor = sessionErrorInterceptor;
    this.clarityIdentify = clarityIdentify;
    this.clarityEvent = clarityEvent;
    this.claritySet = claritySet;

    function showErrorToast(error, title, clearExisting) {
      clearExisting = clearExisting || false;
      if (clearExisting) {
        toastr.clear();
      }
      var toastMessage = getSanitizedErrorMessage(error);

      toastr.error(toastMessage, title, { allowHtml: true });
    }

    function getSanitizedErrorMessage(error) {
      if (Number.isInteger(parseInt(error.error, 10))) {
        return 'The server was unable to process this request';
      } else if (angular.isString(error)) {
        return error;
      } else {
        return (error.reason || error.message)
      }
    }

    function findInArrayById(array, id) {
      if (!angular.isArray(array)) {
        return undefined;
      }

      return array.find(function (element) {
        return (element.hasOwnProperty('_id') && (element._id === id));
      });
    }
    function getIndexOf(arr, val, prop1) {
      var l = arr.length,
        k = 0;
      for (k = 0; k < l; k = k + 1) {
        if (arr[k][prop1] === val) {
          return k;
        }
      }
      return false;
    }
    function getIndexOfValue(arr, val) {
      var l = arr.length,
        k = 0;
      for (k = 0; k < l; k = k + 1) {
        if (arr[k] === val) {
          return k;
        }
      }
      return false;
    }
    function isUndefinedOrNull(val) {
      return (angular.isUndefined(val) || (val === null));
    }

    function sortArrayByNumericKey(array, key) {
      if (!angular.isArray(array)) {
        return array;
      }

      return array.sort(function (a, b) {
        var aVal = parseFloat(a[key]);
        aVal = isNaN(aVal) ? Number.MAX_VALUE : aVal;
        var bVal = parseFloat(b[key]);
        bVal = isNaN(bVal) ? Number.MAX_VALUE : bVal;

        return (aVal - bVal);
      });
    }

    function determineUsername(userData) {
      var username;
      try {
        username = userData.profile.fullname;
        if (angular.isUndefined(username) || (username.length === 0)) {
          username = userData.emails[0].address;
        }
      } catch (e) {
        username = '<anonymous>';
      }

      return username;
    }

    function getUserNameForDisplay(userData) {
      var displayName = '';
      try {
        var nameParts = [userData.profile.firstName, userData.profile.lastName];
        displayName = nameParts.join(' ');
        if (displayName === ' ') {
          displayName = userData.emails[0].address;
        }
      } catch (e) {
        displayName = '<anonymous>';
      }

      return displayName;
    }

    function checkValidState(stateName) {
      if (angular.isUndefined(stateName) || (stateName === null) || !angular.isString(stateName)) {
        return false;
      }

      var stateNameParts = stateName.split('.');
      var statesList = swaRouterStateNames;
      var foundState;
      stateNameParts.forEach(function (stateNamePart) {
        foundState = statesList[stateNamePart];
        if (angular.isObject(foundState)) {
          statesList = foundState;
        }
      });

      return angular.isString(foundState);
    }

    /**
     * Wrapper for UI-router state transition.
     *
     * @param  {String} stateName the name of the state to transition to.
     * @param  {Object} params    parameters if any.
     * @param  {Object} options   options if any.
     */
    function stateGo(stateName, params, options) {
      params = params || {};

      options = options || {};

      if (!checkValidState(stateName)) {
        stateName = swaRouterStateNames.productionlist;
      }

      $state.transitionTo(stateName, params, options);
    }

    /**
     * Wrapper for UI-router state transition with location replace.
     *
     * @param  {String} stateName the name of the state to transition to.
     * @param  {Object} params    parameters if any.
     */
    function stateGoLocationReplace(stateName, params) {
      params = params || {};

      var options = {
        location: 'replace',
      };

      stateGo(stateName, params, options);
    }

    /**
     * Adds a skipValidation parameter to existing state transition parameters.
     *
     * @param  {String} stateName the state name to transition to.
     * @param  {Object} params    parameters if any for the new state.
     * @param  {Boolean} locationReplace   overwrite location and replace history entry.
     */
    function stateGoSkipValidation(stateName, params, locationReplace) {
      var _params;
      var _locationReplace;

      if (angular.isUndefined(locationReplace)) {
        _params = {};
        _locationReplace = (params === true);
      } else {
        _params = params || {};
        _locationReplace = (locationReplace === true);
      }

      _params.skipValidation = true;

      if (_locationReplace) {
        stateGoLocationReplace(stateName, _params);
      } else {
        stateGo(stateName, _params);
      }
    }

    /**
     * getRouterCurrentState - Gets the current ui-router state.
     *
     * @return {Object}  current state configuration.
     */
    function getRouterCurrentState() {
      return $state.current;
    }

    /**
     * getRouterCurrentStateName - Gets the current ui-router state name.
     *
     * @return {Object}  current state configuration.
     */
    function getRouterCurrentStateName() {
      return $state.current.name;
    }
    /**
     * isRouterCurrentStateName - checks if the current state matches the given state name.
     *
     * @param  {String} stateName the state name to check against.
     * @return {Boolean}           true if the name matches, false otherwise.
     */
    function isRouterCurrentStateName(stateName) {
      return ($state.current.name === stateName);
    }

    function getFeetAndInches(realFeet) {
      var units = { feet: 0, inch: 0 };
      units.feet = Math.floor(realFeet);
      units.inch = (realFeet - units.feet) * 12;
      units.inch = roundFraction(units.inch);
      return units;
    }

    function roundFraction(val) {
      if (val > 0) {
        return Math.round(val * 2) / 2;
      } else {
        return 0;
      }
    }

    function getFinalValueInFeet(val) {
      return val.feet + (val.inch / 12);
    }

    function feetAndInchesText(decimal) {
      var realFeet = decimal;
      var feet = Math.floor(realFeet);
      var inches = roundFraction((realFeet - feet) * 12);
      if (inches > 0) {
        return feet + "' " + inches + '"';
      } else {
        return feet + "'";
      }
    }

    function sessionErrorInterceptor(error) {
      if (error.error === 'ESWA:LoggedOut') {
        var params = {
          redirectreason: 'session-expired',
        };
        stateGoLocationReplace(swaRouterStateNames.login, params);
      } else {
        showErrorToast(
          error,
          $translate.instant('errormessages.Something went wrong!')
        );
      }
    }
  }

  function clarityIdentify(userId) {
    try {
      window.clarity('identify', userId); // eslint-disable-line angular/window-service
    } catch (e) {
    }
  }

  function clarityEvent(eventName) {
    try {
      window.clarity('event', eventName); // eslint-disable-line angular/window-service
    } catch (e) {
    }
  }

  function claritySet(key, value) {
    try {
      window.clarity('set', key, value); // eslint-disable-line angular/window-service
    } catch (e) {
    }
  }
}());

/* global _ */
(function () {
  'use strict';

  // eslint-disable-next-line angular/no-service-method
  angular.module('swanywhere').service('swRestoreProductionService', RestoreProductionService);

  RestoreProductionService.$inject = [
    '$log',
    '$translate',
    'DbSubMgrService',
    'swaConfig',
    'toastr',
    '$q',
    'DbProductions',
  ];

  function RestoreProductionService($log, $translate, DbSubMgrService, swaConfig, toastr, $q, DbProductions) {
    var ceres = DbSubMgrService.getAsteroid();

    var _restoreProductionJobsSubscription;
    var _productionRestoreJobsRq;
    var selectedProductionRestoreJobs = [];

    var dbProductions = new DbProductions();

    _restoreProductionJobsSubscription = ceres.subscribe('restoreproductionjobs');

    function updateProductionRestoreJobsRq() {
      _restoreProductionJobsSubscription.ready
        .then(function () {

          _productionRestoreJobsRq = ceres.getCollection('restoreproductionjobs').reactiveQuery({});
          _productionRestoreJobsRq.on('change', productionRestoreJobsRqChange);

          productionRestoreJobsRqChange();
        });
    }

    function updateErrorDisplayMessage(job) {
      if (job.restoreProductionStatus === 'error') {
        if (job.error === 'exception') {
          job.errorDisplayMessage = $translate.instant('errormessages.The server was unable to process this request');
        } else {
          job.errorDisplayMessage = $translate.instant('errormessages.Error: {{errorMessage}}', { errorMessage: job.error });
        }
      }
    }

    function postProcessJob(job) {
      updateErrorDisplayMessage(job);
    }

    function productionRestoreJobsRqChange(id) {
      if (angular.isUndefined(id)) {
        _.each(_productionRestoreJobsRq.result, function (value) {
          postProcessJob(value);
          selectedProductionRestoreJobs.push(value);
        });
        notifyChangeListeners('initial');
      } else {
        var existingJob = _.findWhere(selectedProductionRestoreJobs, { _id: id });
        var incomingJob = _.findWhere(_productionRestoreJobsRq.result, { _id: id });

        var isInsert = (angular.isUndefined(existingJob) && angular.isDefined(incomingJob));
        var isDelete = (angular.isDefined(existingJob) && angular.isUndefined(incomingJob));
        var isUpdate = (angular.isDefined(existingJob) && angular.isDefined(incomingJob));

        if (isInsert) {
          selectedProductionRestoreJobs.push(incomingJob);
          postProcessJob(incomingJob);
          notifyChangeListeners('insert', id, incomingJob);
        } else if (isDelete) {
          var existingJobIndex = selectedProductionRestoreJobs.indexOf(existingJob);
          if (existingJobIndex !== -1) {
            selectedProductionRestoreJobs.splice(existingJobIndex, 1);
            notifyChangeListeners('delete', id);
          }
        } else if (isUpdate) {
          var jobStatusChanged = (existingJob.jobStatus !== incomingJob.jobStatus);
          var jobStepChanged = (existingJob.jobStep !== incomingJob.jobStep);
          if (jobStatusChanged || jobStepChanged) {
            angular.extend(existingJob, incomingJob);
            postProcessJob(existingJob);
            notifyChangeListeners('update', id, existingJob);
          }
        }
      }
    }

    function notifyChangeListeners(change, id, job) {
      if (change === 'update') {
        if (job.jobStatus === 'error') {
          toastr.error(job.errorDisplayMessage, $translate.instant('errormessages.Restore Production Job Failed!'));
        } else if (job.jobStatus === 'done') {
          toastr.success('Name: ' + job.restoreMetadata.productionName, $translate.instant('messages.Restore production Job Completed'), { allowHtml: true });
        }
      }
    }

    this.setProductionRestoration = function () {
      stopProductionRestoreJobsRq();

      updateProductionRestoreJobsRq();
    };

    function stopProductionRestoreJobsRq() {
      if (angular.isDefined(_productionRestoreJobsRq)) {
        _productionRestoreJobsRq.off('change', productionRestoreJobsRqChange);

        _productionRestoreJobsRq = undefined;

        selectedProductionRestoreJobs.length = 0;
      }
    }

    this.startRestoreProduction = function (restoreParams) {
      return $q.resolve(ceres.call('webapi/productions/restore/start', restoreParams).result);
    }

    this.uploadChunk = function (chunksData) {
      return $q.resolve(ceres.call('webapi/productions/restore/uploadchunk', chunksData).result);
    }
  }
}());

(function () {
  'use strict';

  // eslint-disable-next-line angular/no-service-method
  angular.module('swanywhere').service('swaPdfToImage', SwaPdfToImageService);

  SwaPdfToImageService.$inject = [
    '$window',
    '$document',
    'DbScriptPages',
    '$q',
    '$interval',
    '$log'
  ];

  var cacheExpirySec = 15 * 60; // 15 minutes
  var cacheCleanupIntervalSec = 1 * 60; // 1 minute

  function SwaPdfToImageService($window, $document, DbScriptPages, $q, $interval, $log) {
    var cachedPdfImages = new Map(); // Local cache variable

    var dbScriptPages = new DbScriptPages();

    this.getPageContentImage = getPageContentImage;
    this.isContentCached = isContentCached;

    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.1.81/pdf.worker.min.js';

    function getPageContentImage(scriptPageId) {
      var deferred = $q.defer();

      var cachedImage = getCached(scriptPageId);
      if (cachedImage) {
        deferred.resolve(cachedImage); // If image is cached, resolve the Promise with the cached data
      } else {
        dbScriptPages.getContentById(scriptPageId)
          .then(function (scriptPageContent) {
            if (scriptPageContent.contentpdf) {
              // Convert base64 data to binary
              var binaryData = $window.atob(scriptPageContent.contentpdf);

              // Convert binary string to Uint8Array
              var bytes = new Uint8Array(binaryData.length);
              for (var i = 0; i < binaryData.length; i++) {
                bytes[i] = binaryData.charCodeAt(i);
              }

              // Get canvas & create context
              var canvas = $document[0].createElement('canvas');
              var context = canvas.getContext('2d');

              // Get pdfjs workerSrc & render PDF on canvas
              return pdfjsLib.getDocument(bytes).promise
                .then(function (pdf) {
                  // Get the first page
                  return pdf.getPage(1);
                })
                .then(function (page) {
                  var scaleDownFactor = 1.0;
                  if (page.pagewidth > 816) {
                    scaleDownFactor = 816 / page.pagewidth;
                    page.pagewidth = Math.round(page.pagewidth * scaleDownFactor);
                    page.pageheight = Math.round(page.pageheight * scaleDownFactor);
                  }
                  // Set canvas dimensions to match the PDF page
                  var renderScale = parseFloat(2.0) || 2.0;
                  var viewport = page.getViewport({ scale: scaleDownFactor * renderScale * 96 / 72 });
                  canvas.width = viewport.width;
                  canvas.height = viewport.height;

                  // Render the PDF content on the canvas
                  return page.render({
                    canvasContext: context,
                    viewport: viewport
                  }).promise;
                })
                .then(function () {
                  return canvas.toDataURL('image/png');
                });
            } else {
              return 'data:image/png;base64,' + scriptPageContent.contentimage;
            }
          })
          .then(function (imageBase64) {
            putCache(scriptPageId, imageBase64);
            deferred.resolve(imageBase64); // Resolve the Promise with the base64 image data
          })
          .catch(function (error) {
            deferred.reject(error);
          });
      }

      return deferred.promise;
    }

    function isContentCached(scriptPageId) {
      return cachedPdfImages.has(scriptPageId);
    }

    /**
     * Get cached value from local cache
     * @param {string} key Cache key
     * @returns Cached value if exists, otherwise undefined
     */
    function getCached(key) {
      var data = cachedPdfImages.get(key);
      if (data) {
        data.accessedTime = new Date();
        return data.value;
      }
    }

    function putCache(key, value) {
      $log.debug('Caching PDF image for key:', key);
      cachedPdfImages.set(key, {
        accessedTime: new Date(),
        value: value
      });
    }

    function cacheCleanup() {
      var now = new Date();
      for (var key in cachedPdfImages) {
        if (now - cachedPdfImages[key].accessedTime > cacheExpirySec * 1000) {
          $log.debug('Expiring cached PDF image for key:', key);
          cachedPdfImages.delete(key);
        }
      }
    }

    $interval(cacheCleanup, cacheCleanupIntervalSec * 1000);
  }
}());

/* global _ */
(function () {
  'use strict';

  // eslint-disable-next-line angular/no-service-method
  angular.module('swanywhere').service('swPdfPrintService', PdfPrintService);

  PdfPrintService.$inject = [
    '$log',
    '$translate',
    'DbSubMgrService',
    'swaConfig',
    'toastr',
    '$q',
  ];

  function PdfPrintService($log, $translate, DbSubMgrService, swaConfig, toastr, $q) {

    var ceres = DbSubMgrService.getAsteroid();

    var _pdfJobsSubscription;
    var _selectedProductionId;
    var _productionPrintJobsRq;
    var selectedProductionPrintJobs = [];
    var registeredChangeListeners = [];

    var PdfPrintTypes = {
      AllChartsStaffs: 'allchartsstaffs',
      AllCharts: 'allcharts',
      AllStaffs: 'allstaffs',
      AllChartsScript: 'allchartsscript',
      Script:'script',
      CurrentSceneChartsStaffs: 'currentscenechartsstaffs',
      CurrentSceneCharts: 'currentscenecharts',
      CurrentSceneStaffs: 'currentscenestaffs',
      CurrentChart: 'currentchart',
      CurrentStaff: 'currentstaff',
    };

    _pdfJobsSubscription = ceres.subscribe('printjobs');
    this.PdfPrintTypes = PdfPrintTypes;

    function stopProductionPrintJobsRq() {
      if (angular.isDefined(_productionPrintJobsRq)) {
        _productionPrintJobsRq.off('change', productionPrintJobsRqChange);

        _productionPrintJobsRq = undefined;

        selectedProductionPrintJobs.length = 0;
      }
    }

    function updateProductionPrintJobsRq() {
      if (angular.isUndefined(_selectedProductionId)) {
        return;
      }

      _pdfJobsSubscription.ready.then(
        function () {
          _productionPrintJobsRq = ceres.getCollection('printjobs').reactiveQuery({
            productionId: _selectedProductionId,
          });
          _productionPrintJobsRq.on('change', productionPrintJobsRqChange);

          productionPrintJobsRqChange();
        }
      );
    }

    function productionPrintJobsRqChange(id) {
      if (angular.isUndefined(id)) {
        _.each(_productionPrintJobsRq.result, function(value) {
          postProcessJob(value);
          selectedProductionPrintJobs.push(value);
        });
        notifyChangeListeners('initial');
      } else {
        var existingJob = _.findWhere(selectedProductionPrintJobs, {_id: id});
        var incomingJob = _.findWhere(_productionPrintJobsRq.result, {_id: id});

        var isInsert = (angular.isUndefined(existingJob) && angular.isDefined(incomingJob));
        var isDelete = (angular.isDefined(existingJob) && angular.isUndefined(incomingJob));
        var isUpdate = (angular.isDefined(existingJob) && angular.isDefined(incomingJob));

        if (isInsert) {
          selectedProductionPrintJobs.push(incomingJob);
          postProcessJob(incomingJob);
          notifyChangeListeners('insert', id, incomingJob);
        } else if (isDelete) {
          var existingJobIndex = selectedProductionPrintJobs.indexOf(existingJob);
          if (existingJobIndex !== -1) {
            selectedProductionPrintJobs.splice(existingJobIndex, 1);
            notifyChangeListeners('delete', id);
          }
        } else if (isUpdate) {
          var printStatusChanged = (existingJob.printstatus !== incomingJob.printstatus);
          var processingStatusChanged = (existingJob.processingStatus !== incomingJob.processingStatus);
          if ( printStatusChanged || processingStatusChanged) {
            angular.extend(existingJob, incomingJob);
            postProcessJob(existingJob);
            notifyChangeListeners('update', id, existingJob);              
          }
        }
      }
    }

    this.setSelectedProduction = function (productionOrId) {
      var productionId = angular.isObject(productionOrId) ? productionOrId._id : productionOrId;
      if (_selectedProductionId !== productionId) {
        stopProductionPrintJobsRq();

        _selectedProductionId = productionId;
        updateProductionPrintJobsRq();
      }
    };

    function postProcessJob(job) {
      updateDisplayDetailsForJob(job);
      updateDownloadUrl(job);
      updateErrorDisplayMessage(job);
    }

    function updateDisplayDetailsForJob(job) {
      if (job.type === PdfPrintTypes.AllChartsStaffs) {
        job.displayName = $translate.instant('labels.Production - Charts & Score');
      } else if (job.type === PdfPrintTypes.AllCharts) {
        job.displayName = $translate.instant('labels.Production - Charts');
      } else if (job.type === PdfPrintTypes.AllStaffs) {
        job.displayName = $translate.instant('labels.Production - Score');
      } else if (job.type === PdfPrintTypes.AllChartsScript) {
        job.displayName = $translate.instant('labels.Production - Charts & PDF');
      } else if (job.type === PdfPrintTypes.Script) {
        job.displayName = $translate.instant('labels.Production - PDF');
      } else if (job.type === PdfPrintTypes.CurrentSceneChartsStaffs) {
        job.displayName = $translate.instant('labels.Current Scene - Charts & Score');
      } else if (job.type === PdfPrintTypes.CurrentSceneCharts) {
        job.displayName = $translate.instant('labels.Current Scene - Charts');
      } else if (job.type === PdfPrintTypes.CurrentSceneStaffs) {
        job.displayName = $translate.instant('labels.Current Scene - Score');
      } else if (job.type === PdfPrintTypes.CurrentChart) {
        job.displayName = $translate.instant('labels.Current Chart');
      } else if (job.type === PdfPrintTypes.CurrentStaff) {
        job.displayName = $translate.instant('labels.Current Score');
      }
    }
    this.updateDisplayDetailsForJob = updateDisplayDetailsForJob;

    function updateDownloadUrl(job) {
      job.downloadUrl = swaConfig.pdfDownloadPrefixUrl + '/' + job._id + '?filename=' + encodeURIComponent(job.downloadFilename) + '.pdf';
    }

    function updateErrorDisplayMessage(job) {
      if (job.printstatus === 'error') {
        if (job.error === 'exception') {
          var underlyingError = job.exception.error;
          if (underlyingError === 'ESWA:ChartNotFound') {
            if (job.type === PdfPrintTypes.AllChartsStaffs) {
              job.errorDisplayMessage = $translate.instant('errormessages.printchartstafflinkissue');
            } else if (job.type === PdfPrintTypes.AllChartsScript) {
              job.errorDisplayMessage = $translate.instant('errormessages.printchartpdflinkissue2');
            } else {
              job.errorDisplayMessage = $translate.instant('errormessages.The server was unable to process this request');
            }
          } else {
            job.errorDisplayMessage = $translate.instant('errormessages.The server was unable to process this request');
          }
      } else {
          job.errorDisplayMessage = $translate.instant('errormessages.Error: {{errorMessage}}', {errorMessage: job.error});
        }
      }
    }

    function notifyChangeListeners(change, id, job) {
      _.each(registeredChangeListeners, function (listener) {
        if (angular.isFunction(listener.onPrintJobsChange)) {
          listener.onPrintJobsChange(change, id, job);
        }
      });

      if (change === 'update') {
        if (job.printstatus === 'error') {
          toastr.error(job.errorDisplayMessage, $translate.instant('errormessages.Print Job Failed!'));
        } else if (job.printstatus === 'done') {
          if (job.processingStatus === 'message') {
            toastr.warning(job.processingMessage, $translate.instant('errormessages.Print Job Failed!'), {allowHtml: true});
          } else {
            toastr.success(job.displayName, $translate.instant('messages.Print Job Completed'), {allowHtml: true});
          }
        }
      }
    }

    this.registerForChange = function (controller) {
      if (!_.contains(registeredChangeListeners, controller)) {
        registeredChangeListeners.push(controller);
      }
    };

    this.unregisterForChange = function (controller) {
      registeredChangeListeners = _.without(registeredChangeListeners, controller);
    };

    this.getSelectedProductionPrintJobs = function() {
      return angular.copy(selectedProductionPrintJobs);
    };

    this.printPdf = function (params) {
      var now = new Date();
      params.clientDateTime = now.toLocaleString();
      return $q.resolve(ceres.call('pdfprinter/print', params).result);
    };

    this.getApprovalPendingRequests = function () {
      return $q.resolve(ceres.call('webapi/printjobs/find/pending/approval').result);
    };

    this.approveOrRejectJob = function (printJobId, approveOrReject, watermarkText) {
      return $q.resolve(ceres.call('webapi/printjobs/approve/or/reject', printJobId, approveOrReject, watermarkText).result);
    };
  }
}());

/* global Q, jQuery */
(function () {
  'use strict';

  // eslint-disable-next-line angular/no-service-method
  angular.module('swanywhere').service('staffTemplatesService', StaffTemplatesService);

  StaffTemplatesService.$inject = [
    '$log',
    '$q',
  ];

  function StaffTemplatesService($log, $q) {

    var _cachedProductionId;
    var _cachedProductionModifiedDate;

    var _templateDefinitions = {};
    var _templateCache = {};
    var _templateCacheReadyQ;

    this.setProduction = setProduction;
    this.getTemplateDefinitionForId = getTemplateDefinitionForId;
    this.getTemplateForId = getTemplateForId;

    function setProduction(production) {
      if (angular.isUndefined(production)) {
        clearProductionCache();
        clearTemplateCache();
      } else {
        if (production._id === _cachedProductionId) {
          checkForProductionUpdate(production);
        } else {
          _cachedProductionId = production._id;
          _cachedProductionModifiedDate = production.modified.$date;

          cacheTemplates(production.stafftemplates);
        }
      }
    }

    function getTemplateDefinitionForId(templateId) {
      if (_templateDefinitions.hasOwnProperty(templateId)) {
        return _templateDefinitions[templateId];
      } else {
        $log.warn('StaffTemplatesService.getTemplateDefinitionForId: No template definition for ID: ', templateId);
        return;
      }
    }

    function getTemplateForId(templateId) {
      if (_templateCache.hasOwnProperty(templateId)) {
        return jQuery(_templateCache[templateId]).clone();
      } else {
        $log.warn('StaffTemplatesService.getTemplateForId: No template for ID: ', templateId);
        return;
      }
    }

    function clearProductionCache() {
      _cachedProductionId = undefined;
      _cachedProductionModifiedDate = undefined;
    }

    function clearTemplateCache() {
      _templateDefinitions = {};
      _templateCache = {};
      _templateCacheReadyQ = $q.reject();
    }

    function checkForProductionUpdate(production) {
      var newModifiedDate = production.modified.$date;
      if (newModifiedDate > _cachedProductionModifiedDate) {
        cacheTemplates(production.stafftemplates);
      }
    }

    function cacheTemplates(staffTemplates) {
      clearTemplateCache();

      if (angular.isUndefined(staffTemplates)) {
        $log.warn('staffTemplatesService.cacheTemplates(): No staff templates in this production!');
        throw new Error('No staff templates in this production');
      }

      for (var i = 0; i < staffTemplates.length; i++) {
        var staffTemplate = staffTemplates[i];

        _templateDefinitions[staffTemplate.templateId] = staffTemplate;

        var templateCreator = new StaffTemplateCreator(staffTemplate);
        var templateHtml = templateCreator.createTemplate();
        _templateCache[staffTemplate.templateId] = templateHtml;
      }
    }
  }

  var StaffTemplateCreator = (function () {
    var topAccessoryHtml = '<div class="stafftableaccessorybar" id="staffaccessorybuttonstop">' +
      '<div class="staffaccessorybuttonsgroup staffaccessorybuttonsgroup-top pull-left">' +
      '<span class="staffaccessorybutton sw-ionicon sw-ionicon-lg sw-ionicon-fw ion-plus-circled" id=buttonvoiceadd></span> ' +
      '<span class=staffaccessorylabel>Voice</span> ' +
      '<span class="staffaccessorybutton sw-ionicon sw-ionicon-lg sw-ionicon-fw ion-close-circled" id=buttonvoicedelete></span>' +
      '</div>' +
      '<div class="staffaccessorybuttonsgroup staffaccessorybuttonsgroup-top staffaccessorybuttonsgroup-count pull-right">' +
      '<span class="staffaccessorybutton sw-ionicon-lg sw-ionicon-fw ion-minus-circled" id=buttoncountminus></span> ' +
      '<span class=staffaccessorylabel>Count</span> ' +
      '<span class="staffaccessorybutton sw-ionicon-lg sw-ionicon-fw ion-plus-circled" id=buttoncountplus></span>' +
      '</div>' +
      '<div class="staffaccessorybuttonsgroup staffaccessorybuttonsgroup-link staffaccessorybuttonsgroup-top pull-right swa-chartscore-view-chartname-width">' +
      '<span class="staffaccessorybutton sw-ionicon-lg sw-ionicon-fw ion-close-circled buttonunlinkchart" style=display:none></span> ' +
      '<span class="staffaccessorylabel staffaccessorylabel-link sw-truncatetext swa-scoreview-chartname-width" disabled="true">Unlinked</span>' +
      '</div>' +
      '</div>';

    var bottomAccessoryHtml = '<div class="stafftableaccessorybar" id="staffaccessorybuttonsbottom">' +
      '<div class="staffaccessorybuttonsgroup staffaccessorybuttonsgroup-bottom pull-left">' +
      '<span class="staffaccessorybutton sw-ionicon sw-ionicon-lg sw-ionicon-fw ion-plus-circled" id=buttoncharacteradd></span> ' +
      '<span class=staffaccessorylabel>Character</span> ' +
      '<span class="staffaccessorybutton sw-ionicon sw-ionicon-lg sw-ionicon-fw ion-close-circled" id=buttoncharacterdelete></span>' +
      '</div>' +
      '</div>';

    var collapseButtonContainerHtml = '<div class="staffcollapsebuttoncontainer">' +
                             '<span class="staffcollapsebutton sw-ionicon sw-ionicon-lg sw-ionicon-fw ion-ios-arrow-down"></span>' +
                             '</div>';

    var htmlSnippets = {
      div: '<div></div>',
      table: '<table></table',
      tr: '<tr></tr>',
      th: '<th></th>',
      td: '<td></td>',
      span: '<span></span',
    };

    var cssClasses = {
      stafftablecontainer: 'stafftablecontainer',
      stafftable: 'stafftable',
      contentrow: 'contentrow',
      voicerow: 'voicerow',
      staticrow: 'staticrow',
      headercolumn: 'headercolumn',
      stafftitlecell: 'stafftitlecell',
      stafftitle: 'stafftitle',
      hidden: 'hidden',
      toprowcell: 'toprowcell',
      bottomrowcell: 'bottomrowcell',
      countborder: 'countborder',
      characterheadercell: 'characterheadercell',
      characterheader: 'characterheader',
      swTruncatetextWap: 'sw-truncatetext-wrap',
      detailheadercell: 'detailheadercell',
      detailheader: 'detailheader',
      countindex: 'countindex',
      characterrow: 'characterrow',
      collapsecol: 'collapsecol',
      layoutrow: 'layoutrow',
    };

    var htmlAttributes = {
      rowspan: 'rowspan',
      colspan: 'colspan',
    };

    var dataAttributes = {
      defaultcount: 'data-defaultcount',
      columnspercount: 'data-columnspercount',
      rowspercharacter: 'data-rowspercharacter',
      stafftype: 'data-stafftype',
      templatename: 'data-templatename',
      currentcount: 'data-currentcount',
    };

    function StaffTemplateCreator(templateDefinition) {
      this.templateDefinition = templateDefinition;
    }

    StaffTemplateCreator.prototype.createTemplate = function () {
      // Main containers
      var staffContainerJ = jQuery(htmlSnippets.div);
      var staffTableJ = jQuery(htmlSnippets.table);

      // Form the staff container
      staffContainerJ.addClass(cssClasses.stafftablecontainer);
      staffContainerJ.append(jQuery.parseHTML(topAccessoryHtml));
      staffContainerJ.append(staffTableJ);
      staffContainerJ.append(jQuery.parseHTML(bottomAccessoryHtml));
      if (this.templateDefinition.allowadddeletecount === false) {
        staffContainerJ.find('div.staffaccessorybuttonsgroup-count').css({'pointer-events': 'none', 'opacity': 0});
      }

      // Form the staff table
      staffTableJ.addClass(cssClasses.stafftable);
      staffTableJ.attr(dataAttributes.columnspercount, this.templateDefinition.columnspercount);
      staffTableJ.attr(dataAttributes.rowspercharacter, (1 + this.templateDefinition.detailrowcount));
      staffTableJ.attr(dataAttributes.stafftype, this.templateDefinition.templateId);
      staffTableJ.attr(dataAttributes.templatename, this.templateDefinition.templatename);
      staffTableJ.attr(dataAttributes.defaultcount, this.templateDefinition.defaultcount);
      staffTableJ.attr(dataAttributes.currentcount, this.templateDefinition.defaultcount);

      // Add content to the staff table
      this.addLayoutRow(staffTableJ);
      this.addVoiceRows(staffTableJ);
      if (this.templateDefinition.hascolumnheaderrow === true) {
        this.addStaticHeaderRow(staffTableJ);
      }
      this.addPerformerRows(staffTableJ);

      return staffContainerJ;
    };

    StaffTemplateCreator.prototype.addLayoutRow = function (staffTableJ) {
      var trJ = jQuery(htmlSnippets.tr);
      trJ.addClass(cssClasses.contentrow).addClass(cssClasses.layoutrow);

      // Collapse column
      var thCollapseJ = jQuery(htmlSnippets.th);
      thCollapseJ.addClass(cssClasses.collapsecol);
      trJ.append(thCollapseJ);

      // staff title column
      var thTitleJ = jQuery(htmlSnippets.th);
      thTitleJ.addClass(cssClasses.headercolumn).addClass(cssClasses.toprowcell);
      trJ.append(thTitleJ);

      // content columns
      var numContentColumns = this.templateDefinition.defaultcount * this.templateDefinition.columnspercount;
      for (var col = 0, colI = 1; col < numContentColumns; col++, colI++) {
        var tdContentJ = jQuery(htmlSnippets.td);
        tdContentJ.addClass(cssClasses.toprowcell);

        trJ.append(tdContentJ);
      }

      staffTableJ.append(trJ);
    };

    StaffTemplateCreator.prototype.addVoiceRows = function (staffTableJ) {
      var numVoiceRows = 2;//this.templateDefinition.voicerowcount * 2;

      var tabIndex = 0;

      for (var row = 0; row < numVoiceRows; row++) {
        var trJ = jQuery(htmlSnippets.tr);
        trJ.addClass(cssClasses.contentrow).addClass(cssClasses.voicerow);

        // Collapse column
        var thCollapseJ = jQuery(htmlSnippets.th);
        thCollapseJ.addClass(cssClasses.collapsecol);
        trJ.append(thCollapseJ);

        // staff title column
        var thTitleJ = jQuery(htmlSnippets.th);
        thTitleJ.addClass(cssClasses.headercolumn).addClass(cssClasses.stafftitlecell);
        if (row === 0) {
          thTitleJ.attr(htmlAttributes.rowspan, numVoiceRows);
          var spanTitleJ = jQuery(htmlSnippets.span);
          spanTitleJ.addClass(cssClasses.stafftitle);
          spanTitleJ.html(this.templateDefinition.templatename);
          thTitleJ.append(spanTitleJ);
        } else {
          thTitleJ.addClass(cssClasses.hidden);
        }
        trJ.append(thTitleJ);

        // content columns
        var numContentColumns = this.templateDefinition.defaultcount * this.templateDefinition.columnspercount;
        for (var col = 0, colI = 1; col < numContentColumns; col++, colI++) {
          var tdContentJ = jQuery(htmlSnippets.td);
          tdContentJ.attr('tabindex', -1);
          if (row === 0) {
            tdContentJ.addClass(cssClasses.toprowcell);
          } else if (row === (numVoiceRows - 1)) {
            tdContentJ.addClass(cssClasses.bottomrowcell);
          }

          if ((colI % this.templateDefinition.columnspercount) === 0) {
            tdContentJ.addClass(cssClasses.countborder);
          }

          trJ.append(tdContentJ);
        }

        staffTableJ.append(trJ);
      }
    };

    StaffTemplateCreator.prototype.addStaticHeaderRow = function (staffTableJ) {
      var trJ = jQuery(htmlSnippets.tr);
      trJ.addClass(cssClasses.staticrow);

      // Collapse column
      var thCollapseJ = jQuery(htmlSnippets.th);
      thCollapseJ.addClass(cssClasses.collapsecol);
      trJ.append(thCollapseJ);

      // staff title column
      var thTitleJ = jQuery(htmlSnippets.th);
      thTitleJ.addClass(cssClasses.headercolumn).addClass(cssClasses.detailheadercell);
      trJ.append(thTitleJ);

      // content columns
      var numContentColumns = this.templateDefinition.defaultcount * this.templateDefinition.columnspercount;
      for (var col = 0, colI = 1; col < numContentColumns; col++, colI++) {
        var thContentJ = jQuery(htmlSnippets.th);

        var countIndex = Math.trunc(col / this.templateDefinition.columnspercount) + 1;
        var countColIndex = col % this.templateDefinition.columnspercount;

        if ((countColIndex + 1) === this.templateDefinition.countindexcolumn) {
          thContentJ.html(countIndex);
          thContentJ.addClass(cssClasses.countindex);
        } else {
          thContentJ.html(this.templateDefinition.columnlabels[(col % this.templateDefinition.columnspercount)]);
        }

        if ((colI % this.templateDefinition.columnspercount) === 0) {
          thContentJ.addClass(cssClasses.countborder);
        }

        trJ.append(thContentJ);
      }

      staffTableJ.append(trJ);
    };

    StaffTemplateCreator.prototype.addPerformerRows = function (staffTableJ) {
      var numPerformerRows = 1 + this.templateDefinition.detailrowcount;

      var tabIndex = 0;

      for (var row = 0; row < numPerformerRows; row++) {
        var trJ = jQuery(htmlSnippets.tr);
        trJ.addClass(cssClasses.contentrow).addClass(cssClasses.characterrow);

        // Collapse column
        var thCollapseJ = jQuery(htmlSnippets.th);
        thCollapseJ.addClass(cssClasses.collapsecol);
        if (row === 0) {
          thCollapseJ.append(jQuery(collapseButtonContainerHtml));
        }
        trJ.append(thCollapseJ);

        // detail row header column
        var thRowHeaderJ = jQuery(htmlSnippets.th);
        thRowHeaderJ.addClass(cssClasses.headercolumn);
        if (row === 0) {
          thRowHeaderJ.addClass(cssClasses.characterheadercell).addClass(cssClasses.swTruncatetextWap);
          var spanCharacterJ = jQuery(htmlSnippets.span);
          spanCharacterJ.addClass(cssClasses.characterheader);
          spanCharacterJ.text('<Character 1>');
          thRowHeaderJ.append(spanCharacterJ);
        } else {
          thRowHeaderJ.addClass(cssClasses.detailheadercell);
          var spanDetailJ = jQuery(htmlSnippets.span);
          spanDetailJ.addClass(cssClasses.detailheader);
          spanDetailJ.html(this.templateDefinition.detailrowlabels[(row - 1)]);
          thRowHeaderJ.append(spanDetailJ);
        }
        if (row === (numPerformerRows - 1)) {
          thRowHeaderJ.addClass(cssClasses.bottomrowcell);
        }
        trJ.append(thRowHeaderJ);

        // content columns
        var numContentColumns = this.templateDefinition.defaultcount * this.templateDefinition.columnspercount;
        for (var col = 0, colI = 1; col < numContentColumns; col++, colI++) {
          var tdContentJ = jQuery(htmlSnippets.td);
          tdContentJ.attr('tabindex', -1);
          if (row === (numPerformerRows - 1)) {
            tdContentJ.addClass(cssClasses.bottomrowcell);
          }

          if ((colI % this.templateDefinition.columnspercount) === 0) {
            tdContentJ.addClass(cssClasses.countborder);
          }

          trJ.append(tdContentJ);
        }

        staffTableJ.append(trJ);
      }
    };

    return StaffTemplateCreator;
  })();

}());

'use strict';

angular.module('swanywhere').directive('validNumber', function () {
  return {
    require: '?ngModel',
    link: function (scope, element, attrs, ngModelCtrl) {
      if (!ngModelCtrl) {
        return;
      }

      ngModelCtrl.$parsers.push(function (val) {
        if (angular.isUndefined(val)) {
          val = '';
        }

        var clean = val.replace(/[^0-9.]+/g, '');
        if (val !== clean) {
          ngModelCtrl.$setViewValue(clean);
          ngModelCtrl.$render();
        }

        return clean;
      });

      element.bind('keypress', function (event) {
        if (event.keyCode === 32) {
          event.preventDefault();
        }
      });
    },
  };
});

/**
custom directive for on enter key press event
**/
angular.module('swanywhere').directive('ngEnter', function ($timeout) {
  return function (scope, element, attrs) {
    var _callbackTimeoutPromise;
    element.bind('keydown keypress', function (event) {
      if (event.which === 13) {
        $timeout.cancel(_callbackTimeoutPromise);
        _callbackTimeoutPromise = $timeout(
          function () {
            scope.$eval(attrs.ngEnter);
          },

          50);
        event.preventDefault();
      }
    });
  };
});

/** custom directive for page back **/
angular.module('swanywhere').directive('back', function () {
  return {
    link: function (scope, element, attrs) {
      element.on('click', function () {
        history.back();
      });
    },
  };
});

///maxlength for input
angular.module('swanywhere').directive('inputMaxlength', function () {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModelCtrl) {
      var maxlength = Number(attrs.inputMaxlength);

      function fromUser(text) {
        if (text.length > maxlength) {
          var transformedInput = text.substring(0, maxlength);
          ngModelCtrl.$setViewValue(transformedInput);
          ngModelCtrl.$render();
          return transformedInput;
        }

        return text;
      }

      ngModelCtrl.$parsers.push(fromUser);
    },

  };
});

angular.module('swanywhere').filter('feetAndInches', function (swaUtils) {
  return function (decimal) {
    return swaUtils.feetAndInchesText(decimal);
  }
});
(function () {
  'use strict';

  angular.module('swanywhere').directive('swaValidateEmail', validateEmail);

  function validateEmail() {
    var EMAIL_REGEXP = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var directive = {
      require: 'ngModel',
      link: link,
    };

    return directive;

    function link(scope, elm, attrs, ctrl) {
      // only apply the validator if ngModel is present and Angular has added the email validator
      if (ctrl && ctrl.$validators.email) {

        // this will overwrite the default Angular email validator
        ctrl.$validators.email = function (modelValue) {
          return ctrl.$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
        };
      }
    }
  }
}());

(function () {
  'use strict';

  /*
   * Directive: swaWheelZoom - Handles mouse wheel events and pinch gestures for zoom.
   * callback function signature - callback(anchor, delta)
   * where anchor.offsetX and anchor.offsetY are the mouse 'anchor' coordinates offset to the element
   * and delta is the vertical wheel 'scroll' value, normalized to [-1,1].
   */
  angular
    .module('swanywhere')
    .directive('swaWheelZoom', wheelZoom);

  wheelZoom.$inject = ['$parse', '$log'];

  function wheelZoom($parse, $log) {

    var directive = {
      restrict: 'A',
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attrs) {
      var callback = $parse(attrs.swaWheelZoom);

      element.on('wheel', function (wheelEvent) {
        var originalWheelEvent = wheelEvent.originalEvent;
        originalWheelEvent.preventDefault();

        var delta = originalWheelEvent.deltaY;
        var offsetX = originalWheelEvent.offsetX;
        var offsetY = originalWheelEvent.offsetY;

        delta = Math.max(Math.min(delta, 1), -1);

        // Handle pinch gestures
        if (originalWheelEvent.ctrlKey) {
          delta = -1 * delta;
        }

        var params = {
          $anchor: { offsetX: offsetX, offsetY: offsetY },
          $delta: delta
        };

        callback(scope, params);
      });
    }
  }
}());

/* global tinymce */
(function() {
  'use strict';

  angular.module('swanywhere').directive('swaTinymceEditable', TinymceEditable);

  function TinymceEditable() {

    var directive = {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        tinymceOptions: '=swaTinymceOptions',
        editingEnabled: '=swaTinymceEnabled'
      },
      link: linkFunction
    };

    return directive;

    function linkFunction(scope, element, attrs, ngModel) {

      scope.tinymceEditor = undefined;

      scope.$watch('editingEnabled', function(newVal, oldVal) {
        if (angular.isUndefined(newVal)) {
          return;
        }

        if (newVal) {
          initRichTextEditor();
        } else {
          updateModel();
          deinitRichTextEditor();
        }
      });

      scope.$on('$destroy', function() {
        deinitRichTextEditor();
      });

      function updateModel() {
        if (angular.isDefined(scope.tinymceEditor)) {
          if (scope.tinymceEditor.isDirty()) {
            var newContent = scope.tinymceEditor.getContent();
            if (ngModel.$viewValue !== newContent) {
              ngModel.$setViewValue(newContent);
            }
          }
        } else {
          ngModel.$setViewValue(element.html());
        }
      }

      ngModel.$render = function() {
        element.html(ngModel.$viewValue || '');
      };

      function initRichTextEditor() {
        var id = element.attr('id');
        var existingEditor = tinymce.get(id);
        if (existingEditor !== null) { // eslint-disable-line angular/definedundefined
          return true;
        }

        var initOptions = angular.extend(scope.tinymceOptions, {
          selector: '#' + id,
          setup: function(editor) {
            editor.on('Change', function(e) {
              updateModel();
            });
            // editor.on('KeyUp', function (e) {
            //   updateModel();
            // });
            editor.on('init', function(e) {
              scope.tinymceEditor = e.target;
            });
            editor.on('PostProcess', function (e) {
              e.content = e.content.replace('&#65279;', '');
            });
          }
        });

        tinymce.init(initOptions);
      }

      function deinitRichTextEditor() {
        tinymce.remove(scope.tinymceEditor);
        scope.tinymceEditor = undefined;
      }
    }
  }
}());

(function() {
  'use strict';

  angular.module('swanywhere').directive('swaPrintJobList', PrintJobList);

  function PrintJobList() {

    var template =
    '<div class="menu-item menu-item-nohover menu-item-subtitle menu-item-icon-right" ng-repeat="printJob in vm.list | orderBy: \'created.$date\' : true | limitTo: 15">' +
    '<span class="title" ng-bind-html="printJob.displayName"></span>' +
    // '<span class="subtitle">{{printJob.created.$date | date:\'short\'}}</span>' +
    '<span class="subtitle">{{printJob.clientDateTime}}</span>' +
    '<span class="icon-right">' +
    '<span class="sw-ionicon-fw sw-ionicon-lg ion-person-add" ng-show="((printJob.printstatus === \'inprogress\') && (printJob.processingStatus === \'pendingapproval\'))" uib-tooltip="{{\'messages.Waiting for approval\' | translate}}" tooltip-placement="auto bottom-right" tooltip-class="stackable-tooltip"></span>' +
    '<span class="sw-ionicon-fw sw-ionicon-lg ion-clock"      ng-show="((printJob.printstatus === \'inprogress\') && (printJob.processingStatus === \'docdefinition\'))" uib-tooltip="{{\'messages.In queue\' | translate}}" tooltip-placement="auto bottom-right" tooltip-class="stackable-tooltip"></span>' +
    '<span class="sw-ionicon-fw sw-ionicon-lg ion-clock"      ng-show="((printJob.printstatus === \'inprogress\') && (printJob.processingStatus === \'pdfpending\'))" uib-tooltip="{{\'messages.In queue\' | translate}}" tooltip-placement="auto bottom-right" tooltip-class="stackable-tooltip"></span>' +
    '<span class="sw-spinner sw-spinner-lg"                   ng-show="((printJob.printstatus === \'inprogress\') && (printJob.processingStatus === \'pdfgenerating\'))"></span>' +
    '<span class="sw-ionicon-fw sw-ionicon-lg ion-alert-circled" ng-show="((printJob.printstatus === \'done\') && (printJob.processingStatus === \'message\'))" uib-tooltip="{{printJob.processingMessage}}" tooltip-placement="auto bottom-right" tooltip-class="stackable-tooltip"></span>' +
    '<span class="sw-ionicon-fw sw-ionicon-lg swa-color-accentred ion-alert-circled" ng-show="(printJob.printstatus === \'error\')" uib-tooltip="{{printJob.errorDisplayMessage}}" tooltip-placement="auto bottom-right" tooltip-class="stackable-tooltip"></span>' +
    '<span class="sw-ionicon-fw sw-ionicon-lg ion-android-download" ng-show="((printJob.printstatus === \'done\') && (printJob.processingStatus === \'done\'))" ng-click="vm.openPdf(printJob.downloadUrl);"></span>' +
    '</span>' +
    '</div>' +
    '<div class="menu-item menu-item-nohover" disabled="disabled" ng-hide="(vm.list.length > 0)">' +
    '<span class="title" translate>messages.No recent PDFs</span>' +
    '</div>';

    var directive = {
      restrict: 'A',
      scope: {
        list: '=',
      },
      // replace: true,
      // transclude: false,
      controller: PrintJobListController,
      controllerAs: 'vm',
      bindToController: true,
      template: template,
    };

    return directive;
  }

  PrintJobListController.$inject = [
    '$window',
    'toastr',
  ];

  function PrintJobListController($window, toastr) {
    var vm = this;

    vm.openPdf = openPdf;

    function openPdf(url) {
      toastr.info('It is recommended that you open the downloaded PDF in a PDF app and not your browser.<br/><br/>If you have a popup blocker active, configure it to allow popups form this site to enable PDF downloads.', 'Your PDF will begin downloading shortly', {
        allowHtml: true,
        onHidden: function () {
          $window.open(url, '_blank');
        }
      });
    }
  }
}());

/* global _ */
(function () {
  'use strict';

  angular
    .module('swanywhere')
    .directive('swaStepper', Stepper);

  function Stepper() {

    var directive = {
      restrict: 'EA',
      scope: {
        value: '=swaStepperValue',
        stepValues: '=swaStepperValues',
        disabled: '=?swaStepperDisabled',
        changeCallback: '&swaStepperOnchange',
      },
      template: '<div class="input-group" style="max-width: 160px;">' +
                '<span class="input-group-btn">' +
                '<button class="btn sw-btn-secondary" ng-click="minus()" ng-disabled="disabled || (stepIndex === 0)"><span class="sw-ionicon sw-ionicon-fw ion-minus"></span></button>' +
                '</span>' +
                '<input class="form-control text-center" ng-model="value" ng-change="changed()" ng-readonly="readonly" type="text" ng-disabled="disabled">' +
                '<span class="input-group-btn">' +
                '<button class="btn sw-btn-secondary" ng-click="plus()" ng-disabled="disabled || (stepIndex === maxStepIndex)"><span class="sw-ionicon sw-ionicon-fw ion-plus"></span></button>' +
                '</span>' +
                '</div>',
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attributes) {

      scope.stepIndex = 0;
      scope.maxStepIndex = 0;

      element.addClass('sw-stepper-container');

      validateStepIndex();

      scope.$watchGroup(['stepValues', 'value'], function(newVal, oldVal) {
        if (oldVal === newVal) {
          return;
        }

        validateStepIndex();
      });

      function validateStepIndex() {
        if (angular.isArray(scope.stepValues)) {
          scope.maxStepIndex = scope.stepValues.length - 1;
        } else {
          scope.maxStepIndex = 0;
        }

        scope.stepIndex = _.indexOf(scope.stepValues, scope.value);
      }

      function setValueAtStepIndex(stepIndex) {
        if (stepIndex < 0) {
          stepIndex = 0;
        }
        if (stepIndex > scope.maxStepIndex) {
          stepIndex = scope.maxStepIndex;
        }

        scope.stepIndex = stepIndex;
        var value = scope.stepValues[stepIndex];
        if (scope.value !== value) {
          scope.value = value;
          scope.changeCallback({
            value: value,
          });
        }
      }

      scope.minus = function () {
        setValueAtStepIndex(scope.stepIndex - 1);
      };

      scope.plus = function () {
        setValueAtStepIndex(scope.stepIndex + 1);
      };

      scope.changed = function () {
        validateStepIndex();
      };
    }
  }
}());

/* global Tour */
(function () {
  'use strict';

  angular
    .module('swanywhere')
    .directive('swaShowCollaborators', showCollaborators);

  showCollaborators.$inject = ['$uibModal', '$translate', 'blockUI', 'DbUser', 'toastr'];

  function showCollaborators($uibModal, $translate, blockUI, DbUser, toastr) {

    var directive = {
      restrict: 'EA',
      scope: {
        production: '=?',
        currentUserId: '=?',
      },
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attrs) {
      var collaboratorData = [];

      function initData() {
        collaboratorData = [];
        collaboratorData.push({
          id: scope.production.ownerId,
          isOwner: true,
          isCurrentUser: (scope.production.ownerId === scope.currentUserId),
        });

        scope.production.collaborationsettings.forEach(function (setting) {
          var data = {
            email: setting.collaboratoremail,
          };

          if (setting.hasOwnProperty('collaboratorId')) {
            data.id = setting.collaboratorId;
            data.isMember = true;
            data.isCurrentUser = (setting.collaboratorId === scope.currentUserId);
          } else {
            data.isInvited = true;
          }

          collaboratorData.push(data);
        });
      }

      function onClick() {
        initData();
        $uibModal.open({
          animation: true,
          templateUrl: 'app/components/collaboratorList/collaboratorList.html',
          controller: 'CollaboratorListController',
          controllerAs: 'vm',
          size: '400',
          windowClass: 'sw-modal',
          backdropClass: 'sw-modal-backdrop',
          backdrop: 'static',
          resolve: {
            collaboratorData: function () {
              return collaboratorData;
            },
          }
        });
      }

      element.bind('click', onClick);

        // collaboratedUsers.length = 0;
        // collaboratedUsers = [];
        // if (scope.swaCurrentUserId !== scope.swaOwnerId) {
        //   collaboratedUsers.push({
        //     'collaborator': scope.swaCurrentUser,
        //     'index': 1,
        //     'currentUser': true
        //   });
        //   dbUser.getUserProfileById(scope.swaOwnerId).then(
        //     function (owner) {
        //       if (angular.isDefined(owner)) {
        //         collaboratedUsers.push({
        //           'collaborator': owner.profile.fullname,
        //           'index': 0,
        //           'owner': true
        //         });
        //       }
        //     },
        //     function (error) {
        //       toastr.error(error.message, $translate.instant('errormessages.Something went wrong!'));
        //     }
        //   );
        // } else {
        //   collaboratedUsers.push({
        //     'collaborator': scope.swaCurrentUser,
        //     'index': 0,
        //     'owner': true,
        //     'currentUser': true
        //   });
        // }
        // if (angular.isDefined(scope.swaCollaborators)) {
        //   if (scope.swaCollaborators.length > 0) {
        //     angular.forEach(scope.swaCollaborators, function (ele, index) {
        //       if (ele.hasOwnProperty('collaboratorId')) {
        //         if (ele.collaboratorId !== scope.swaCurrentUserId) {
        //           dbUser.getUserProfileById(ele.collaboratorId).then(
        //             function (user) {
        //               if (angular.isDefined(user)) {
        //                 collaboratedUsers.push({
        //                   'collaborator': user.profile.fullname,
        //                   'index': collaboratedUsers.length + 1
        //                 });
        //               } else {
        //                 if (angular.isUndefined(user)) {
        //                   collaboratedUsers.push({
        //                     'collaborator': ele.collaboratoremail,
        //                     'index': collaboratedUsers.length + 1
        //                   });
        //                 }
        //               }
        //             },
        //             function (error) {
        //               toastr.error(error.message, $translate.instant('errormessages.Something went wrong!'));
        //             }
        //           );
        //         }
        //       } else {
        //         if (angular.isDefined(ele.collaboratoremail)) {
        //           collaboratedUsers.push({
        //             'collaborator': ele.collaboratoremail,
        //             'index': collaboratedUsers.length + 1
        //           });
        //         }
        //       }
        //     });
        //
        //     var modalInstance = $uibModal.open({
        //       animation: true,
        //       templateUrl: 'app/components/CollaboratorList/collaboratorList.html',
        //       controller: 'CollaboratorListController',
        //       controllerAs: 'vm',
        //       size: 'sm',
        //       windowClass: 'sw-modal',
        //       backdropClass: 'sw-modal-backdrop',
        //       backdrop: 'static',
        //       resolve: {
        //         collaboratedUsers: function () {
        //           var currentUserAndCollaborators = {
        //             ownerId: scope.swaOwnerId,
        //             currentuser: scope.swaCurrentUser,
        //             collaborators: collaboratedUsers
        //
        //           };
        //           return currentUserAndCollaborators;
        //         }
        //       }
        //     });
        //
        //     modalInstance.result.finally(
        //       function () {
        //         collaboratedUsers.length = 0;
        //         collaboratedUsers = [];
        //       }
        //     );
        //   }
        // } else {
        //   toastr.error(error.message, $translate.instant('errormessages.Something went wrong!'));
        // }
      }
    }

}());

(function () {
  'use strict';

  angular
    .module('swanywhere')
    .directive('swaSelectOnFocus', selectOnFocus);

  selectOnFocus.$inject = ['$timeout', '$log'];

  function selectOnFocus($timeout, $log) {

    var directive = {
      restrict: 'A',
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element) {
      if (!(element.is('input') || element.is('textarea'))) {
        $log.warn('SWA: directive \'swaSelectOnFocus\' attached to unsupported element!');
        return;
      }

      var focusedElement = null;

      element.on('focus', function () {
        var _this = this;
        if (focusedElement !== _this) {
          focusedElement = _this;
          $timeout(function () {
            _this.select();
          }, 10);
        }
      });

      element.on('blur', function () {
        focusedElement = null;
      });
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('swanywhere')
    .directive('swaResizable', resizable);

  resizable.$inject = ['$document', '$timeout', '$parse'];

  function resizable($document, $timeout, $parse) {

    var directive = {
      restrict: 'A',
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attrs) {
      var targetElement = element;

      var resizableOptions = scope.$eval(attrs.swaResizableOptions);
      var handleElement = targetElement;
      if (angular.isDefined(resizableOptions.handleClass)) {
        var dragHandle = element.find('.' + resizableOptions.handleClass);
        if (angular.isDefined(dragHandle)) {
          handleElement = dragHandle;
        }
      }

      var setBottomRight = resizableOptions.setBottomRight || false;

      var resizeStartCallback = $parse(attrs.swaResizableOnStart);
      var resizeEndCallback = $parse(attrs.swaResizableOnEnd);

      var sizeVertically = false;
      var sizeHorizontally = false;
      var minHeight = 0;
      var maxHeight = 0;
      var minWidth = 0;
      var maxWidth = 0;

      if (resizableOptions.direction === 'v') {
        sizeVertically = true;
        minHeight = parseInt(resizableOptions.minHeight) || 50;
        maxHeight = parseInt(resizableOptions.maxHeight);
      } else if (resizableOptions.direction === 'h') {
        sizeHorizontally = true;
        minWidth = parseInt(resizableOptions.minWidth) || 50;
        maxWidth = parseInt(resizableOptions.maxWidth);
      } else if (angular.isUndefined(resizableOptions.direction) || (resizableOptions.direction === 'vh') || (
        resizableOptions.direction === 'hv') || (resizableOptions.direction === 'both')) {
        sizeVertically = true;
        minHeight = parseInt(resizableOptions.minHeight) || 50;
        maxHeight = parseInt(resizableOptions.maxHeight);

        sizeHorizontally = true;
        minWidth = parseInt(resizableOptions.minWidth) || 50;
        maxWidth = parseInt(resizableOptions.maxWidth);
      }

      var originalSizePosition = {
        height: 0,
        width: 0,
        bottom: 0,
        right: 0,
      };
      var newSizePosition = {
        height: 0,
        width: 0,
        bottom: 0,
        right: 0,
      };
      var originalMouseX = 0;
      var originalMouseY = 0;

      handleElement.on('mousedown', function (event) {
        if (event.button !== 0) {
          return;
        }
        if (scope.$parent.vm.hideAnnotationStyleOptions) {
          scope.$parent.vm.hideAnnotationStyleOptions();
        }
        event.preventDefault();

        originalSizePosition.height = targetElement.outerHeight();
        originalSizePosition.width = targetElement.outerWidth();

        originalSizePosition.left = targetElement.position().left;
        originalSizePosition.top = targetElement.position().top;
        originalSizePosition.right = parseInt(targetElement.css('right'));
        if (isNaN(originalSizePosition.right)) {
          originalSizePosition.right = targetElement.parent().outerWidth() - (originalSizePosition.left +
            originalSizePosition.width);
        }

        originalSizePosition.bottom = parseInt(targetElement.css('bottom'));
        if (isNaN(originalSizePosition.bottom)) {
          originalSizePosition.bottom = targetElement.parent().outerHeight() - (originalSizePosition.top +
            originalSizePosition.height);
        }

        newSizePosition = angular.copy(originalSizePosition);

        originalMouseX = event.screenX;
        originalMouseY = event.screenY;

        targetElement.addClass('swa-sizing');

        $document.on('mousemove', mousemove);
        $document.on('mouseup', mouseup);

        if (angular.isFunction(resizeStartCallback)) {
          $timeout(function () {
            resizeStartCallback(scope);
          });
        }
      });

      function mousemove(event) {
        if (sizeVertically) {
          var deltaY = originalMouseY - event.screenY;
          newSizePosition.height = originalSizePosition.height - deltaY;

          if (newSizePosition.height < minHeight) {
            newSizePosition.height = minHeight;
          }

          if ((maxHeight !== 'NaN') && (newSizePosition.height > maxHeight)) {
            newSizePosition.height = maxHeight;
          }

          newSizePosition.bottom = originalSizePosition.bottom + (originalSizePosition.height - newSizePosition.height);

          if (newSizePosition.bottom < 0) {
            newSizePosition.height += newSizePosition.bottom;
            newSizePosition.bottom = 0;
          }

          if (setBottomRight) {
            targetElement.css('bottom', newSizePosition.bottom);
          }

          targetElement.outerHeight(newSizePosition.height);
        }

        if (sizeHorizontally) {
          var deltaX = originalMouseX - event.screenX;
          newSizePosition.width = originalSizePosition.width - deltaX;

          if (newSizePosition.width < minWidth) {
            newSizePosition.width = minWidth;
          }

          if ((maxWidth !== 'NaN') && (newSizePosition.width > maxWidth)) {
            newSizePosition.width = maxWidth;
          }

          newSizePosition.right = originalSizePosition.right + (originalSizePosition.width - newSizePosition.width);

          if (newSizePosition.right < 0) {
            newSizePosition.width += newSizePosition.right;
            newSizePosition.right = 0;
          }

          if (setBottomRight) {
            targetElement.css('right', newSizePosition.right);
          }

          targetElement.outerWidth(newSizePosition.width);
        }
      }

      function mouseup(event) {
        event.preventDefault();
        targetElement.removeClass('swa-sizing');

        $document.unbind('mousemove', mousemove);
        $document.unbind('mouseup', mouseup);

        var sizeData = {
          target: targetElement,
          originalSizePosition: originalSizePosition,
          newSizePosition: newSizePosition,
        };

        $timeout(function () {
          resizeEndCallback(scope, {
            sizeData: sizeData,
          });
        });
      }
    }
  }
}());

/* global SVG */
(function () {
  'use strict';

  angular
    .module('swanywhere')
    .directive('swaPerformerIcon', performerIcon);

  function performerIcon() {

    var directive = {
      restrict: 'E',
      scope: {
        performer: '=',
      },
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attrs) {
      // The main SVG document
      var svgDoc;

      // viewBox (for SVG doc dimensions)
      var svgViewBox;

      // The clipping rectangle element
      var svgClipRect;

      // The shape container element
      var svgShapeGroup;

      // The shape container element
      var svgShapeRect;

      // The shape text element
      var svgShapeText;

      // The shape border element
      var svgShapeBorderRect;

      // shape characteristics
      var shapeFillColor;
      var shapeBorderWidth;
      var shapeBorderColor;
      var shapeBorderVisible;
      var shapeType;
      var shapeText;
      var shapeTextFontSize;
      var shapeTextColor;
      var shapeTextScale;
      var shapeTextBox;

      var svgNormalMatrix;
      var svgDiamondMatrix;

      function updateViewBox() {
        svgViewBox = svgDoc.viewbox();
        svgDoc.size(svgViewBox.width, svgViewBox.height);

        svgDiamondMatrix = svgNormalMatrix.translate(svgViewBox.width / 2, 0).rotate(45, 0, 0);

        updateIconBorderWidth();
        updateIconShape();
      }

      function updateIconBorderWidth() {
        shapeBorderWidth = Math.ceil(svgViewBox.width / 60 * 2);
        if (shapeBorderWidth < 1) {
          shapeBorderWidth = 1;
        }

        shapeBorderWidth *= 2;

        svgShapeBorderRect.stroke({
          width: shapeBorderWidth,
        });
      }

      function updateIconShape() {
        if (shapeType === 2) {
          svgShapeBorderRect
            .radius(svgViewBox.width / 2, svgViewBox.height / 2)
            .size(svgViewBox.width, svgViewBox.height)
            .transform(svgNormalMatrix);

          svgClipRect
            .radius(svgViewBox.width / 2, svgViewBox.height / 2)
            .size(svgViewBox.width, svgViewBox.height)
            .transform(svgNormalMatrix);
        } else if (shapeType === 3) {
          var sideLength = svgViewBox.width / 1.4142;
          svgShapeBorderRect
            .radius(0)
            .size(sideLength, sideLength)
            .transform(svgDiamondMatrix);

          svgClipRect
            .radius(0)
            .size(sideLength, sideLength)
            .transform(svgDiamondMatrix);
        } else {
          svgShapeBorderRect
            .radius(0)
            .size(svgViewBox.width, svgViewBox.height)
            .transform(svgNormalMatrix);

          svgClipRect
            .radius(0)
            .size(svgViewBox.width, svgViewBox.height)
            .transform(svgNormalMatrix);
        }

        updateIconText();
      }

      function updateIconText() {
        if (shapeText.length === 0) {
          return;
        }

        var textClientRect = svgShapeText.node.getBoundingClientRect();
        var textSizeWToH = textClientRect.width / textClientRect.height;

        var boxWidth = svgViewBox.width;
        var boxHeight = boxWidth;

        // Account for shape border if needed
        if (shapeBorderVisible) {
          boxWidth -= (shapeBorderWidth / 2);
          boxHeight = boxWidth;
        }

        if (shapeType === 1) {
          boxWidth -= (shapeBorderWidth / 2);
          boxHeight = boxWidth;
        } else if (shapeType === 2) {
          boxWidth = Math.sqrt(((boxWidth * boxWidth) * (textSizeWToH * textSizeWToH)) / (1 + textSizeWToH * textSizeWToH));
          boxHeight = boxWidth / textSizeWToH;
        } else if (shapeType === 3) {
          boxWidth = (boxWidth * textSizeWToH) / (1 + textSizeWToH);
          boxHeight = boxWidth / textSizeWToH;
        }
      
        // Adjust for text scaling factor
        boxWidth *= shapeTextScale;
        boxHeight *= shapeTextScale;
        
        // size the viewbox
        shapeTextBox.width = boxWidth;
        shapeTextBox.height = boxHeight;

        // Adjust font size
        var fontSizeToLengthRatio = textClientRect.width / shapeTextFontSize;
        var fontSizeToHeightRatio = textClientRect.height / shapeTextFontSize;

        var shapeTextFontSizeW = (shapeTextBox.width / fontSizeToLengthRatio);
        var shapeTextFontSizeH = (shapeTextBox.height / fontSizeToHeightRatio);
      
        if (shapeTextFontSizeH < shapeTextFontSizeW) {
          shapeTextFontSize = shapeTextFontSizeH;
        } else {
          shapeTextFontSize = shapeTextFontSizeW;
        }

        // Apply font size and center text
        svgShapeText.size(shapeTextFontSize);
        svgShapeText.center(svgViewBox.width / 2, svgViewBox.height / 2);
      }

      function initialize() {
        svgDoc = SVG(element.get(0));

        svgViewBox = svgDoc.viewbox();

        // setup defaults/initial values
        shapeFillColor = '#000';
        shapeBorderWidth = 2;
        shapeBorderColor = '#777';
        shapeBorderVisible = true;
        shapeType = 1;
        shapeText = '';
        shapeTextFontSize = 48;
        shapeTextColor = '#fff';
        shapeTextScale = 1.0;
        shapeTextBox = svgViewBox;

        // create elements
        svgClipRect = svgDoc.rect(svgViewBox.width, svgViewBox.height);
        svgShapeRect = svgDoc.rect(svgViewBox.width, svgViewBox.height).fill(shapeFillColor);
        svgShapeText = svgDoc.text('').fill(shapeTextColor);
        svgShapeBorderRect = svgDoc.rect(svgViewBox.width, svgViewBox.height).fill({
          opacity: 0
        }).stroke({
          color: shapeBorderColor,
          width: shapeBorderWidth
        });

        svgNormalMatrix = new SVG.Matrix;
        svgDiamondMatrix = new SVG.Matrix;

        // Set up font for text
        svgShapeText.font({
          family: 'Arial',
          size: shapeTextFontSize,
        });

        // set hierarchy
        svgShapeGroup = svgDoc.group().add(svgShapeRect).add(svgShapeText).add(svgShapeBorderRect);

        // Apply clipping
        svgShapeGroup.clipWith(svgClipRect);
      }

      initialize();
      updateViewBox();
      updateIconBorderWidth();

      scope.$watch('performer', function (newValue, oldValue) {
        if (oldValue === newValue) {
          return;
        }

        if (oldValue.shapecolor !== newValue.shapecolor) {
          shapeFillColor = newValue.shapecolor || '#000';

          svgShapeRect.fill(shapeFillColor);
        }

        if (oldValue.bordercolor !== newValue.bordercolor) {
          shapeBorderColor = newValue.bordercolor || '#777';

          svgShapeBorderRect.stroke(shapeBorderColor);
        }

        if (oldValue.textcolor !== newValue.textcolor) {
          shapeTextColor = newValue.textcolor || '#fff';

          svgShapeText.fill(shapeTextColor);
        }

        if (oldValue.bordervisible !== newValue.bordervisible) {
          shapeBorderVisible = (newValue.bordervisible === true);

          if (shapeBorderVisible) {
            svgShapeBorderRect.stroke({
              opacity: 1.0
            });
          } else {
            svgShapeBorderRect.stroke({
              opacity: 0
            });
          }

          updateIconBorderWidth();
          updateIconText();
        }

        if (oldValue.shape !== newValue.shape) {
          shapeType = newValue.shape;

          updateIconShape();
        }

        if (oldValue.text !== newValue.text) {
          shapeText = newValue.text;

          svgShapeText.text(newValue.text);

          updateIconText();
        }

        if (oldValue.textsize !== newValue.textsize) {
          shapeTextScale = parseFloat(newValue.textsize);

          if (isNaN(shapeTextScale)) {
            shapeTextScale = 0.1;
          }

          updateIconText();
        }
      }, true);
    }
  }
}());

(function () {
  'use strict';

  /*
  custom directive for on enter key press event
  */
  angular
    .module('swanywhere')
    .directive('swaOnEnter', onEnter);

  onEnter.$inject = ['$parse', '$log', '$timeout'];

  function onEnter($parse, $log, $timeout) {

    var directive = {
      restrict: 'A',
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attrs) {
      if (!element.is('input')) {
        $log.warn('SWA: directive \'swaOnEnter\' attached to unsupported element!');
        return;
      }

      var _callbackTimeoutPromise;
      var callback = $parse(attrs.swaOnEnter);
      if (callback) {
        element.bind('keydown keypress', function (event) {
          if (event.which === 13) {
            $timeout.cancel(_callbackTimeoutPromise);
            _callbackTimeoutPromise = $timeout(
              function () {
                callback(scope);
              },

              50);
            event.preventDefault();
          }
        });
      }
    }
  }
}());

/*
 * multirange.js v0.1.2
 * (c) 2014 Val Allen Samonte val.samonte@gmail.com
 * License: MIT
 *
 * Updated for SWA
 */

'use strict';

angular.module('swa.multirange', ['swa.multirange.lite'])
  .directive('swaMultirange', function (swaMultirangeViews) {
    return {
      required: 'ngModel',
      scope: {
        ngModel: '=',
        _views: '=views',
        _view: '=view',
        gradient: '=',
      },
      template: '<div class="swa-multirange-mk2-container">' +
        '<swa-multirange-labels render="renderedStyle" ng-model="ngModel"></swa-multirange-labels>' +
        '<swa-multirange-lite ng-model="ngModel" ng-style="renderedStyle.multirange" step="step"></swa-multirange-lite>' +
        '<swa-multirange-hairlines render="renderedStyle" ng-model="units"></swa-multirange-hairlines>' +
        '</div>',
      link: function (scope, elem, attr) {
        scope.getPercent = function (value) {
          return (value * 100) + '%';
        };

        scope.changeView = function (n) {
          if (angular.isUndefined(n) || angular.isUndefined(scope.views)) {
            return;
          }

          var l = scope.views.length - 1,
            view;
          n = (n < 0) ? 0 : ((n > l) ? l : n);
          view = scope.views[n];
          if (angular.isDefined(view)) {
            scope.zoom = view.zoom;
            scope.step = view.step;
            scope.units = view.units;
            scope.renderer();
          }
        };

        scope.$watch('_view', function (n) {
          scope.changeView(n);
        });

        scope.$watch('_views', function (n) {
          scope.views = n;
          scope.view = 0;
          scope.changeView(0);
        });

        scope.renderer = function () {
          if (angular.isUndefined(scope.zoom)) {
            return;
          }

          var render = {
            container: {},
            content: {},
            multirange: {
              width: scope.getPercent(scope.zoom),
              display: 'block',
              margin: 'auto',
            },
          };

          if (scope.zoom < 1) {
            render.content.margin = '2 auto';
            render.content.width = 'calc(' + scope.getPercent(scope.zoom) + ' - 16px)';
            render.container.marginLeft = '0';
          } else {
            render.content.margin = '2 0';
            render.content.width = 'calc(' + scope.getPercent(scope.zoom) + ' - ' + (10 - (scope.zoom * 5)) +
              'px)';
            render.container.marginLeft = '5px';
          }

          scope.renderedStyle = render;

          return render;
        };

        // set default view config
        if (angular.isUndefined(scope.views)) {
          scope.views = swaMultirangeViews.DEFAULT;
          scope.view = 0;
          scope.changeView(0);
        }
      },
    };
  })
  .directive('swaMultirangeLabels', function () {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        render: '=',
      },
      template: '<div class="swa-multirange-mk2-labels-container" ng-style="render.container">' +
        '<ul class="swa-multirange-mk2-labels" ng-style="render.content">' +
        '<li class="swa-multirange-mk2-label" ng-repeat="range in ngModel" ng-style="renderRange(range)">' +
        '<input type="text" ng-model="range.name" />' +
        '</li>' +
        '</ul>' +
        '</div>',
      link: function (scope, elem, attr) {
        scope.renderRange = function (range) {
          return {
            left: (range.value * 100) + '%',
            zIndex: range._depth,
          };
        };
      },
    };
  })
  .directive('swaMultirangeHairlines', function () {
    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        render: '=',
      },
      template: '<div class="swa-multirange-mk2-hairlines-container" ng-style="render.container">' +
        '<ul class="swa-multirange-mk2-hairlines" ng-style="render.content">' +
        '<li class="swa-multirange-mk2-hairline" ng-repeat="hairline in hairlines" ng-style="hairline.render">' +
        '<span>{{ hairline.label }}</span>' +
        '</li>' +
        '</ul>' +
        '</div>',
      link: function (scope, elem, attr) {

        scope.$watch('ngModel', function (n) {
          if (angular.isUndefined(n)) {
            return;
          }

          scope.hairlines = [];
          var levels = n.length,
            hairHeight = 12,
            hairline, i, j, u;
          for (i = 0; i < levels; i++) {
            u = n[i];
            for (j = 0;
              ((j > 1) ? Math.round(j * 1000) / 1000 : j) <= 1; j = parseFloat((j + u.value).toFixed(8))) {
              hairline = {
                render: {
                  height: hairHeight * (1 - i / levels),
                  left: (j * 100) + '%',
                },
              };
              if (angular.isFunction(u.labeller)) {
                hairline.label = u.labeller(j);
              } else if (angular.isDefined(u.labeller)) {
                hairline.label = j;
              }

              scope.hairlines.push(hairline);
            }
          }
        });
      },
    };
  })
  .factory('swaMultirangeViews', function () {
    return {
      DEFAULT: [{
        zoom: 0.9,
        step: 1 / 40,
        units: [{
          value: 1 / 10,
          labeller: function (n) {
            return n * 10;
          },
        }, {
          value: 1 / 20,
        },
      ],
      }, {
        zoom: 1.5,
        step: 1 / 80,
        units: [{
          value: 1 / 20,
          labeller: function (n) {
            return n * 10;
          },
        }, {
          value: 1 / 40,
        },
      ],
      },
    ],
    };
  });

angular.module('swa.multirange.lite', [])
  .directive('swaMultirangeLite', function () {
    return {
      required: 'ngModel',
      scope: {
        ngModel: '=',
        step: '=',
      },
      template: '<div class="swa-multirange-container" ng-mousemove="onMouseMove($event)">' +
        '<div class="swa-multirange-track"></div>' +
        '<div class="swa-multirange-wrapper" ng-repeat="range in ngModel" ng-style="computeDepth(range)">' +
        '<swa-range class="swa-multirange" position="range.value" min="0" max="{{ precision }}" step="{{ preciseStep }}">' +
        '</div>' +
        '</div>',
      link: function (scope, elem, attr) {
        var mousex;
        scope.precision = 1000000;
        scope.preciseStep = 1;
        scope.onMouseMove = function (evt) {
          var bound = elem[0].getBoundingClientRect();
          mousex = (evt.pageX - bound.left) / bound.width;
        };

        scope.computeDepth = function (range) {
          var depth = 100 - Math.round(Math.abs(mousex - range.value) * 100);
          range._depth = depth >= 0 ? depth : 0;
          return {
            zIndex: range._depth,
          };
        };

        scope.$watch('step', function () {
          if (angular.isUndefined(scope.step)) {
            scope.preciseStep = 1;
          } else {
            scope.preciseStep = scope.step * scope.precision;
          }
        });

        scope.$watch('ngModel', function (nv, ov) {
          if (nv === ov) {
            return;
          }

          var sCount = scope.ngModel.length;
          if ((nv.length !== sCount) || (ov.length !== sCount)) {
            return;
          }

          for (var i = 0; i < sCount; i++) {
            if (nv[i].value !== ov[i].value) {
              preventSliderOverlap(i);
            }
          }
        }, true);

        function preventSliderOverlap(index) {
          var thisSliderVal = scope.ngModel[index].value;
          var nextSliderVal;
          var prevSliderVal;
          var lastIndex = scope.ngModel.length - 1;
          if ((index < lastIndex) && (index > 0)) { //not last or first
            nextSliderVal = scope.ngModel[index + 1].value;
            prevSliderVal = scope.ngModel[index - 1].value;

            if (thisSliderVal >= nextSliderVal) {
              scope.ngModel[index].value = (nextSliderVal - scope.step);
            }
            if (thisSliderVal <= prevSliderVal) {
              scope.ngModel[index].value = (prevSliderVal + scope.step);
            }
          } else if (index === 0) { //first
            nextSliderVal = scope.ngModel[index + 1].value;

            if (thisSliderVal >= nextSliderVal) {
              scope.ngModel[index].value = (nextSliderVal - scope.step);
            }
            if (thisSliderVal <= 0) {
              scope.ngModel[index].value = 0;
            }
          } else if (index === lastIndex) { //last
            prevSliderVal = scope.ngModel[index - 1].value;

            if (thisSliderVal >= scope.MAX_VALUE) {
              scope.ngModel[index].value = (scope.MAX_VALUE  - scope.step);
            }
            if (thisSliderVal <= prevSliderVal) {
              scope.ngModel[index].value = (prevSliderVal + scope.step);
            }
          }
        }
      },
    };
  })
  .directive('swaRange', function ($timeout) {
    return {
      template: '<input type="range" ng-model="rdh.mulValue">',
      restrict: 'E',
      replace: true,
      scope: {
        position: '=',
      },
      link: function (scope, elem, attr) {
        var RangeDataHelper = function (value, multiplier) {
          this.value = isNaN(value) ? 0 : value;
          this.multiplier = multiplier;
          Object.defineProperty(this, 'mulValue', {
            get: function () {
              return (parseFloat(this.value) * this.multiplier) + '';
            },

            set: function (n) {
              this.value = parseInt(n) / this.multiplier;
              scope.position = this.value;
            },
          });
        };

        scope.$watch('position', function (n) {
          if (angular.isUndefined(scope.rdh)) {
            scope.rdh = new RangeDataHelper(n, parseInt(attr.max) || 100);
          } else {
            // scope.rdh.multiplier = parseInt(attr.max) || 100;
            scope.rdh.value = n;
          }
        });
      },
    };
  });

(function() {
  'use strict';

  angular.module('swanywhere').directive('swImageOnLoad', ImageOnLoad);

  function ImageOnLoad() {

    var directive = {
      restrict: 'A',
      link: linkFunction
    };

    return directive;

    function linkFunction(scope, element, attrs) {
      element.on('load', function(event) {
        scope.$apply(function() {
          scope.$eval(attrs.swImageOnLoad, {error: false});
        });
        // event.preventDefault();
      });

      element.on('error', function(event) {
        scope.$apply(function() {
          scope.$eval(attrs.swImageOnLoad, {error: true});
        });
        // event.preventDefault();
      });
    }
  }
}());

/* global Tour */
(function () {
  'use strict';

  angular
    .module('swanywhere')
    .directive('swaHelpBar', helpBar);

  helpBar.$inject = ['$translate', '$uibModal', 'blockUI'];

  function helpBar($translate, $uibModal, blockUI) {

    var directive = {
      restrict: 'E',
      scope: {
        swaHelpTourSteps: '=?',
        swaHelpVideos: '=?',
        swaHelpOnStart: '&swaHelpOnStart',
        swaHelpOnEnd: '&swaHelpOnEnd',
        swaHelpTourTrigger: '=?'
      },
      link: linkFunction,
      template: '<div class="swa-help-bar">' +
        '<button class="btn sw-btn-default" ng-disabled="!(swaHelpTourSteps && (swaHelpTourSteps.length > 0))" ng-click="beginTour()">' +
        '<span class="sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-ios-help-outline"></span>' +
        '</button>' +
        '<button class="btn sw-btn-default" ng-disabled="!(swaHelpVideos && (swaHelpVideos.length > 0))" ng-click="showVideo()">' +
        '<span class="sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-ios-film-outline"></span>' +
        '</button>' +
        '</div>',
    };

    return directive;

    function linkFunction(scope, element) {
      scope.$watch('swaHelpTourTrigger', function(newValue, oldValue) {
        if (newValue === 'video') {
          showVideo();
        } else if (newValue === 'tour') {
          beginTour();
        }

        scope.swaHelpTourTrigger = undefined;
      });

      function onTourStart() {
        element.addClass('ng-hide');
      }

      function onTourEnd() {
        element.removeClass('ng-hide');

        if (scope.swaHelpOnEnd) {
          scope.swaHelpOnEnd();
        }
      }

      function beginTour() {
        if (!angular.isArray(scope.swaHelpTourSteps) || (scope.swaHelpTourSteps.length === 0)) {
          return;
        }

        if (scope.swaHelpOnStart) {
          scope.swaHelpOnStart();
        }

        var tour = new Tour({
          backdrop: true,
          storage: false,
          onStart: onTourStart,
          onEnd: onTourEnd,
          onNext: function (tour) {
            var cs = tour.getCurrentStep();
            if ((cs === (scope.swaHelpTourSteps.length - 1)) && tour._isOrphan(cs)) {
              tour.end();
            }
          },
          onShown: function (tour) {
            tour.backdrop.$background.offset(tour.backdrop.$element.offset());
          }
        });

        if (angular.isArray(scope.swaHelpTourSteps) && (scope.swaHelpTourSteps.length > 0)) {
          angular.forEach(scope.swaHelpTourSteps, function (step) {
            step.animation = false;
            tour.addStep(step);
          });
        } else {
          tour.addStep({
            orphan: true,
            title: $translate.instant('titles.Help Tour'),
            content: $translate.instant('messages.No help tour for this screen!'),
          });
        }

        tour.init(true);
        tour.start(true);
      };
      scope.beginTour = beginTour;

      function showVideo() {
        if (!angular.isArray(scope.swaHelpVideos) || (scope.swaHelpVideos.length === 0)) {
          return;
        }
        element.addClass('ng-hide');
        var modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/components/videoSlider/videoSlider.html',
          controller: 'VideoSliderController',
          controllerAs: 'vm',
          size: 'lg',
          windowClass: 'sw-modal',
          backdropClass: 'sw-modal-backdrop',
          backdrop: 'static',
          resolve: {
            videos: function () {
              return scope.swaHelpVideos;
            }
          }
        });

        modalInstance.result.finally(
          function () {
            element.removeClass('ng-hide');
          }
        );
      };
      scope.showVideo = showVideo;
    }
  }
}());

/* global FileReader */
(function () {
  'use strict';

  /*
   * Directive: swaFileDataurl - reads selected file and returns a data: URL.
   * Attach to input element with type file
   * callback function signature - callback($dataUrl, $error)
   */
  angular
    .module('swanywhere')
    .directive('swaFileDataurl', fileDataUrl);

  fileDataUrl.$inject = ['$parse', '$log'];

  function fileDataUrl($parse, $log) {

    var directive = {
      restrict: 'A',
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attrs) {
      if (!(element.is('input') && attrs.type === 'file')) {
        $log.warn('SWA: directive \'swaFileDataurl\' attached to unsupported element!');
        return;
      }

      var callback = $parse(attrs.swaFileDataurl);
      element.on('change', function (onChangeEvent) {
        var reader = new FileReader();
        reader.onload = function (onLoadEvent) {
          scope.$apply(function () {
            callback(scope, {
              $dataUrl: onLoadEvent.target.result,
              $error: undefined,
            });
          });
        };

        reader.onerror = function (onErrorEvent) {
          scope.$apply(function () {
            callback(scope, {
              $dataUrl: undefined,
              $error: onErrorEvent.type,
            });
          });
        };

        var selectedFile = (onChangeEvent.srcElement || onChangeEvent.target).files[0];
        reader.readAsDataURL(selectedFile);

        element.val(null);
      });
    }

  }

  /*
   * Directive: swaFileArraybuffer - reads selected file and returns an ArrayBuffer.
   * Attach to input element with type file
   * callback function signature - callback($arrayBuffer, $error)
   */
  angular
    .module('swanywhere')
    .directive('swaFileArraybuffer', fileArrayBuffer);

  fileArrayBuffer.$inject = ['$parse', '$log'];

  function fileArrayBuffer($parse, $log) {

    var directive = {
      restrict: 'A',
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attrs) {
      if (!(element.is('input') && attrs.type === 'file')) {
        $log.warn('SWA: directive \'swaFileArraybuffer\' attached to unsupported element!');
        return;
      }

      var callback = $parse(attrs.swaFileArraybuffer);
      element.on('change', function (onChangeEvent) {
        var reader = new FileReader();
        reader.onload = function (onLoadEvent) {
          scope.$apply(function () {
            callback(scope, {
              $filename: selectedFile.name,
              $arrayBuffer: onLoadEvent.target.result,
              $error: undefined,
            });
          });
        };

        reader.onerror = function (onErrorEvent) {
          scope.$apply(function () {
            callback(scope, {
              $filename: undefined,
              $arrayBuffer: undefined,
              $error: onErrorEvent.type,
            });
          });
        };

        var selectedFile = (onChangeEvent.srcElement || onChangeEvent.target).files[0];
        reader.readAsArrayBuffer(selectedFile);

        element.val(null);
      });
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('swanywhere')
    .directive('swaDraggable', draggable);

  draggable.$inject = ['$document', '$timeout', '$parse'];

  function draggable($document, $timeout, $parse) {

    var directive = {
      restrict: 'A',
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attrs) {
      var targetElement = element;

      var draggableOptions = scope.$eval(attrs.swaDraggableOptions) || {
        direction: 'vh',
      };
      var handleElement = targetElement;
      if (angular.isDefined(draggableOptions.handleClass)) {
        var dragHandle = element.find('.' + draggableOptions.handleClass);
        if (angular.isDefined(dragHandle)) {
          handleElement = dragHandle;
        }
      }

      var setBottomRight = draggableOptions.setBottomRight || false;

      var dragEndCallback = $parse(attrs.swaDraggableOnEnd);

      var dragVertically = false;
      var dragHorizontally = false;

      if (draggableOptions.direction === 'v') {
        dragVertically = true;
      } else if (draggableOptions.direction === 'h') {
        dragHorizontally = true;
      } else if ((draggableOptions.direction === 'vh') || (draggableOptions.direction === 'hv') || (draggableOptions.direction ===
        'both')) {
        dragVertically = true;
        dragHorizontally = true;
      }

      var originalSizePosition = {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: 0,
        height: 0,
      };
      var newSizePosition = {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: 0,
        height: 0,
      };
      var originalMouseX = 0;
      var originalMouseY = 0;

      // Allow dragging on move handle
      handleElement.on('mousedown', function (event) {
        if (event.button !== 0) {
          return;
        }
        initiateDrag(event);
      });

      // Allow dragging the entire position box off right, left, ffloating and highlight annotations on right-click
      targetElement.on('mousedown', function (event) {
        var annotations = ['lAnnotation', 'rAnnotation', 'fAnnotation', 'mAnnotation'];

        for (var i = 0; i < annotations.length; i++) {
          var annotationKey = annotations[i];
          var annotation = scope[annotationKey];
          if (angular.isDefined(annotation)) {
            if (scope.$parent.vm.scriptEditorState.currentAnnotationLayerId !== annotation.layerid) {
              return;
            }
          }
        }

        if (event.button === 2 || (event.ctrlKey && event.button === 0)) {
          event.preventDefault();
          handleRightClickAnnotation(event);
          initiateDrag(event);
        }
      });

      // initiate dragging for both clicks
      function initiateDrag(event) {
        if (scope.$parent.vm.hideAnnotationStyleOptions) {
          scope.$parent.vm.hideAnnotationStyleOptions();
        }
        event.preventDefault();

        originalSizePosition = {
          height: targetElement.outerHeight(),
          width: targetElement.outerWidth(),
          left: targetElement.position().left,
          top: targetElement.position().top,
          right: parseInt(targetElement.css('right')),
          bottom: parseInt(targetElement.css('bottom')),
        };

        if (isNaN(originalSizePosition.right)) {
          originalSizePosition.right = targetElement.parent().width() -
            (originalSizePosition.left + originalSizePosition.width);
        }
        if (isNaN(originalSizePosition.bottom)) {
          originalSizePosition.bottom = targetElement.parent().height() -
            (originalSizePosition.top + originalSizePosition.height);
        }

        newSizePosition = angular.copy(originalSizePosition);

        originalMouseX = event.screenX;
        originalMouseY = event.screenY;

        targetElement.addClass('swa-dragging');

        $document.on('mousemove', mousemove);
        $document.on('mouseup', mouseup);
      }

      function handleRightClickAnnotation(event) {
        if (scope.lAnnotation) {
          scope.$parent.vm.selectLeftAnnotation(scope.lAnnotation.orderingindex);
        } else if (scope.rAnnotation) {
          scope.$parent.vm.selectRightAnnotation(scope.rAnnotation.orderingindex);
        } else if (scope.fAnnotation) {
          scope.$parent.vm.selectFloatingAnnotation(scope.fAnnotation.orderingindex);
        } else if (scope.mAnnotation) {
          scope.$parent.vm.selectHighlightAnnotation(scope.mAnnotation.orderingindex);
        }
      }


      function mousemove(event) {
        if (dragVertically) {
          var deltaY = originalMouseY - event.screenY;
          newSizePosition.top = originalSizePosition.top - deltaY;
          newSizePosition.bottom = originalSizePosition.bottom + deltaY;

          if (newSizePosition.top < 0) {
            newSizePosition.bottom += newSizePosition.top;
            newSizePosition.top = 0;
          }

          if (newSizePosition.bottom < 0) {
            newSizePosition.top += newSizePosition.bottom;
            newSizePosition.bottom = 0;
          }

          targetElement.css('top', newSizePosition.top);
          if (setBottomRight) {
            targetElement.css('bottom', newSizePosition.bottom);
          }
        }

        if (dragHorizontally) {
          var deltaX = originalMouseX - event.screenX;
          newSizePosition.left = originalSizePosition.left - deltaX;
          newSizePosition.right = originalSizePosition.right + deltaX;

          if (newSizePosition.left < 0) {
            newSizePosition.right += newSizePosition.left;
            newSizePosition.left = 0;
          }

          if (newSizePosition.right < 0) {
            newSizePosition.left += newSizePosition.right;
            newSizePosition.right = 0;
          }

          targetElement.css('left', newSizePosition.left);
          if (setBottomRight) {
            targetElement.css('right', newSizePosition.right);
          }
        }
      }

      function mouseup(event) {
        targetElement.removeClass('swa-dragging');

        $document.unbind('mousemove', mousemove);
        $document.unbind('mouseup', mouseup);

        var dragData = {
          target: targetElement,
          originalSizePosition: originalSizePosition,
          newSizePosition: newSizePosition,
        };

        $timeout(function () {
          dragEndCallback(scope, {
            dragData: dragData,
          });
        });
      }
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('swanywhere')
    .directive('swaCounter', Counter);

  function Counter() {

    var directive = {
      restrict: 'EA',
      scope: {
        value: '=swaCounterValue',
        rangeMin: '=swaCounterMin',
        rangeMax: '=swaCounterMax',
        rangeStep: '=swaCounterStep',
        disabled: '=?swaCounterDisabled',
        changeCallback: '&swaCounterOnchange',
      },
      template: '<div class="input-group" style="max-width: 160px;">' +
                '<span class="input-group-btn">' +
                '<button class="btn sw-btn-secondary" ng-click="minus()" ng-disabled="disabled || (value === min)"><span class="sw-ionicon sw-ionicon-fw ion-minus"></span></button>' +
                '</span>' +
                '<input class="form-control text-center" ng-model="value" ng-change="changed()" ng-readonly="readonly" type="text" ng-disabled="disabled">' +
                '<span class="input-group-btn">' +
                '<button class="btn sw-btn-secondary" ng-click="plus()" ng-disabled="disabled || (value === max)"><span class="sw-ionicon sw-ionicon-fw ion-plus"></span></button>' +
                '</span>' +
                '</div>',
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attributes) {

      var step = 1;

      scope.min = 1;
      scope.max = 100;
      scope.value = scope.min;

      element.addClass('sw-counter-container');

      validateBounds();

      scope.$watchGroup(['rangeMin', 'rangeMax', 'rangeStep'], function(newVal, oldVal) {
        if (oldVal === newVal) {
          return;
        }

        validateBounds();
      });

      function validateBounds() {
        scope.min = parseInt(scope.rangeMin);
        if (isNaN(scope.min)) {
          scope.min = 0;
        }

        scope.max = parseInt(scope.rangeMax);
        if (isNaN(scope.max)) {
          scope.max = 100;
        }

        step = parseInt(scope.rangeStep);
        if (isNaN(step)) {
          step = 1;
        }
        if (step === 0) {
          step = 1;
        }

        scope.rangeError = (scope.min > scope.max);

        setValue(scope.value);
      }

      function setValue(value) {
        value = ensureInRange(parseInt(value));

        if (scope.value !== value) {
          scope.value = value;
          scope.changeCallback({
            value: value,
          });
        }
      }

      function ensureInRange(value) {
        if (isNaN(value)) {
          return scope.min;
        }

        if (value < scope.min) {
          return scope.min;
        } else if (value > scope.max) {
          return scope.max;
        } else {
          return value;
        }
      }

      scope.minus = function () {
        setValue(scope.value - step);
      };

      scope.plus = function () {
        setValue(scope.value + step);
      };

      scope.changed = function () {
        setValue(scope.value);
      };
    }
  }
}());

(function () {
  'use strict';

  angular
    .module('swanywhere')
    .directive('swaContenteditable', Contenteditable);

  function Contenteditable() {

    var directive = {
      restrict: 'A',
      require: 'ngModel',
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attrs, ngModel) {

      function read() {
        ngModel.$setViewValue(element.html());
      }

      ngModel.$render = function() {
        element.html(ngModel.$viewValue || '');
      };

      element.bind('blur keyup change', function() {
        scope.$apply(read);
      });
    }
  }
}());

(function () {
  'use strict';

  /*
  * Directive: swaChangeOnblur - detects element value change on focus change
  */
  angular.module('swanywhere').directive('swaChangeOnblur', changeOnBlur);

  changeOnBlur.$inject = ['$parse'];

  function changeOnBlur($parse) {
    var directive = {
      restrict: 'A',
      link: linkFunction,
    };

    return directive;

    function linkFunction(scope, element, attrs) {
      var callback = $parse(attrs.swaChangeOnblur);

      element.on('focus', function () {
        element.preBlurOldValue = element.val();
      });

      element.on('blur', function () {
        var preValue = element.preBlurOldValue;
        if ((preValue !== element.val()) && callback) {
          callback(scope);
        }
      });
    }
  }
}());

angular.module("swanywhere").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/chartEditor/chartContextMenu.html","<div class=\"sw-context-menu\">\n  <div class=\"sw-context-menu-header\" ng-hide=\"vm.state.layerEditorActive\">\n    <button class=\"btn btn-sm sw-btn-toolbar pin-icon\" ng-click=\"vm.toggleChartContextMenuPinStatus()\" ng-class=\"{\'sw-active\': vm.state.isContextMenuPinned}\" uib-tooltip=\"Pin context menu\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n    <span class=\"swafont swafont-icon-pin\"></span>\n  </button>\n    <div class=\"sw-drag\">\n    </div>\n    <button class=\"btn btn-sm sw-btn-toolbar\" ng-click=\"vm.closeContextMenu()\">\n      <span class=\"sw-ionicon sw-ionicon-lg ion-close-round\"></span>\n    </button>\n  </div>\n    <!-- Action buttons -->\n    <div class=\"chart-inspector-group inspector-action-container\" ng-hide=\"vm.state.layerEditorActive\">\n      <div class=\"inspector-clipboard-actions sw-chart-inspector-row\">\n        <button class=\"btn sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount > 0)\" ng-click=\"vm.clipboardAction(\'cut\')\" translate>buttons.Cut</button>\n        <button class=\"btn sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount > 0)\" ng-click=\"vm.clipboardAction(\'copy\')\" translate>buttons.Copy</button>\n        <button class=\"btn sw-btn-inspector\" ng-disabled=\"!vm.state.canPaste\" ng-click=\"vm.clipboardAction(\'paste\')\" translate>buttons.Paste</button>\n      </div>\n      <div class=\"inspector-selection-actions sw-chart-inspector-row\">\n        <button class=\"btn sw-btn-inspector\" ng-hide=\"vm.state.selectionGrouped\" ng-disabled=\"!((vm.state.selectionCount > 1) || vm.state.selectionGrouped)\" ng-click=\"vm.groupToggleAction()\" translate>buttons.Group</button>\n        <button class=\"btn sw-btn-inspector\" ng-show=\"vm.state.selectionGrouped\" ng-click=\"vm.groupToggleAction()\" translate>buttons.Ungroup</button>\n        <button class=\"btn sw-btn-inspector\" ng-click=\"vm.editAction()\" ng-disabled=\"!((vm.state.selectionCount === 1) && vm.state.selectionEditable)\" translate>buttons.Edit</button>\n        <button class=\"btn sw-btn-inspector\" ng-click=\"vm.deleteAction()\" ng-disabled=\"vm.state.selectionCount === 0\" translate>buttons.Delete</button>\n        <button class=\"btn sw-btn-inspector\" ng-click=\"vm.clearAction()\" ng-disabled=\"!((vm.state.selectionCount > 0) || vm.state.canPaste)\" translate>buttons.Clear</button>\n      </div>\n    </div>\n    <!-- Action buttons end-->\n    <!-- Angle buttons-->\n    <div class=\"chart-inspector-group inspector-angle-container text-left\" ng-hide=\"vm.state.layerEditorActive || true\">\n      <span class=\"sw-btn-inspector-label\" ng-hide=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">Angle: {{vm.state.rotationDeg}}&deg;</span>\n      <span class=\"sw-btn-inspector-label\" ng-show=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">Angle: ---</span>\n      <div class=\"sw-chart-inspector-row\">\n        <div class=\"\">\n        <div class=\"sw-chart-inspector-row first\">\n          <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(-90)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">-90</button>\n          <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(-10)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">-10</button>\n          <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(-1)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">-1</button>\n        </div>\n        <div class=\"sw-chart-inspector-row\">\n          <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(90)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">+90</button>\n          <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(10)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">+10</button>\n          <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(1)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">+1</button>\n        </div>\n      </div>\n      <div class=\"\">\n        <button class=\"btn btn-sm sw-btn-inspector zero\" ng-click=\"vm.resetRotation()\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">0</button>\n      </div>\n      </div>\n    </div>\n\n    <!-- Angle rotation controller -->\n    <div class=\"chart-inspector-group inspector-angle-container text-left\" ng-hide=\"vm.state.layerEditorActive\">\n      <span class=\"sw-btn-inspector-label text\">Rotation <span class=\"key\">Alt</span> / <span class=\"key\">⌥</span></span>\n      <div class=\"sw-chart-inspector-row sw-context-menu-rotate\">\n        <button class=\"inspector-layer-done-butt on btn sw-btn-inspector\" ng-click=\"vm.rotationToggleAction()\">\n          <span ng-show=\"vm.state.selectionRotationMode\" translate>buttons.Disable</span>\n          <span ng-hide=\"vm.state.selectionRotationMode\" translate>buttons.Enable</span>\n        </button>\n        <button class=\"btn btn-sm sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount > 0) && !vm.state.selectionGrouped\" ng-click=\"vm.selectedItemsResetRotation()\">Reset(0&deg;)</button>\n      </div>\n    </div>\n    <!-- Angle buttons end-->\n\n    <!-- Align & Distribute controller -->\n    <div class=\"chart-inspector-group inspector-angle-container text-left\" ng-hide=\"vm.state.layerEditorActive\">\n      <div class=\"sw-chart-inspector-row sw-context-menu-rotate\">\n        <button class=\"inspector-layer-done-butt on btn sw-btn-inspector swtoolbar-flex sw-align-distribute-par\" ng-click=\"vm.showAlignMenuOptions()\">\n          <span translate>buttons.Align & Distribute</span>\n          <span class=\"sw-ionicon-fw sw-ionicon-md ion-chevron-right\"></span>\n        </button>\n      </div>\n    </div>\n    <!-- Align & Distribute controller end -->\n\n    <!-- Snap to grid controller -->\n    <div class=\"chart-inspector-group inspector-angle-container text-left\" ng-hide=\"vm.state.layerEditorActive\">\n      <span class=\"sw-btn-inspector-label text\">Snap to grid</span>\n      <div class=\"sw-chart-inspector-row sw-context-menu-rotate\">\n        <button class=\"inspector-layer-done-butt on btn sw-btn-inspector\" ng-click=\"vm.snapToGridToggleAction()\">\n          <span ng-show=\"vm.state.selectionSnapToGrid\" translate>buttons.Disable</span>\n          <span ng-hide=\"vm.state.selectionSnapToGrid\" translate>buttons.Enable</span>\n        </button>\n        <button class=\"btn btn-sm sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount > 0)\" ng-click=\"vm.alignToGridAction()\">Align to grid</button>\n      </div>\n    </div>\n    <!-- Snap to grid controller end -->\n\n    <!-- Alignment buttons-->\n    <div class=\"chart-inspector-group inspector-layer-container text-left\" ng-hide=\"vm.state.layerEditorActive\">\n      <span class=\"sw-btn-inspector-label\" ng-hide=\"(vm.state.selectionCount !== 1)\">{{\'labels.Layer\' | translate}}: {{vm.state.zIndex}}</span>\n      <span class=\"sw-btn-inspector-label\" ng-show=\"(vm.state.selectionCount !== 1)\">{{\'labels.Layer\' | translate}}: ---</span>\n      <div class=\"sw-chart-inspector-row-\">\n      <div class=\"inspector-layer-buttons\">\n        <div class=\"sw-chart-inspector-row\">\n          <button class=\"btn sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount === 1) || !vm.state.selectionOrderingMode\" ng-click=\"vm.layerAction(\'top\')\" translate>buttons.Top</button>\n          <button class=\"btn sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount === 1) || !vm.state.selectionOrderingMode\" ng-click=\"vm.layerAction(\'up\')\" translate>buttons.Up</button>\n        </div>\n        <div class=\"sw-chart-inspector-row\">\n          <button class=\"btn sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount === 1) || !vm.state.selectionOrderingMode\" ng-click=\"vm.layerAction(\'bottom\')\" translate>buttons.Btm</button>\n          <button class=\"btn sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount === 1) || !vm.state.selectionOrderingMode\" ng-click=\"vm.layerAction(\'down\')\" translate>buttons.Dn</button>\n        </div>\n      </div>\n      <div>\n        <button class=\"inspector-layer-done-butt on btn sw-btn-inspector tick\" ng-disabled=\"!(vm.state.selectionCount === 1)\" ng-click=\"vm.layerToggleAction()\">\n          <span ng-show=\"vm.state.selectionOrderingMode\" class=\"swafont swafont-lg swafont-icon-tick\"></span>\n          <span ng-hide=\"vm.state.selectionOrderingMode\" translate>buttons.Edit</span>\n        </button>\n      </div>\n      <!-- <button class=\"inspector-layer-overlay-button btn sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount === 1)\" ng-hide=\"(vm.state.selectionCount === 1) && vm.state.selectionOrderingMode\" ng-click=\"vm.layerAction(\'begin\')\" >{{\'buttons.Layer\' | translate}} <span ng-show=\"vm.state.selectionCount === 1\">{{vm.state.zIndex}}</span><span ng-hide=\"vm.state.selectionCount === 1\">--</span></button> -->\n    </div>\n    </div>\n    <!-- Alignment buttons end-->\n    <!-- <div class=\"chart-inspector-group inspector-vectoreditor-container\" ng-show=\"vm.state.vectorEditorActive\">\n      <div class=\"sw-chart-inspector-row sw-chart-inspector-row-title\">\n        <span class=\"sw-color-lightgray sw-text-lg\">Shape Editor</span>\n      </div>\n      <div class=\"inspector-selection-actions sw-chart-inspector-row\">\n        <div>\n          <ul>\n            <li translate>messages.Click and drag points to change the shape</li>\n            <li translate>messages.Ctrl + click to add a new point</li>\n          </ul>\n        </div>\n        <div style=\"margin-top: 2px;\">\n          <div style=\"height: 34px; margin-top: 2px;\">\n            <button class=\"btn btn-sm sw-btn-inspector pull-right\" ng-disabled=\"!(vm.state.vectorEditorNodeSelected)\" ng-click=\"vm.vectorEditorDeleteNodeAction()\" translate>buttons.Delete Point</button>\n          </div>\n          <div style=\"height: 34px;\">\n            <button class=\"btn btn-sm sw-btn-inspector sw-btn-min-w-80 pull-right\" ng-click=\"vm.vectorEditorDoneAction()\" translate>buttons.Save</button>\n          </div>\n        </div>\n      </div>\n    </div> -->\n    <!-- <div class=\"chart-inspector-group inspector-freehandtool-container\" ng-show=\"vm.state.freehandToolActive\">\n      <div class=\"sw-chart-inspector-row sw-chart-inspector-row-title\">\n        <span class=\"sw-color-lightgray sw-text-lg\">Freehand Shape Tool</span>\n        <button class=\"btn btn-sm sw-btn-toolbar\" ng-click=\"vm.freehandToolCloseAction()\">\n          <span class=\"sw-ionicon sw-ionicon-lg ion-close-round\"></span>\n        </button>\n      </div>\n      <div class=\"inspector-selection-actions sw-chart-inspector-row\">\n        <div>\n          <span class=\"hint\" translate>messages.inspectorfeehandtoolhint</span>\n        </div>\n        <div style=\"margin-left: 16px;\">\n          <div style=\"height: 34px; margin-top: 2px; width: 216px;\">\n            <span style=\"display: inline-block;\">Arrowhead</span>\n            <switch class=\"swa-switch swa-switch-small\" ng-model=\"vm.state.freehandHasArrowhead\" ng-change=\"vm.freehandHasArrowheadChange()\" on=\"YES\" off=\"NO\"></switch>\n            <button class=\"btn btn-sm sw-btn-inspector pull-right\" ng-click=\"vm.freehandToolClearAction()\" translate>buttons.Clear</button>\n          </div>\n          <div style=\"height: 34px;\">\n            <button class=\"btn btn-sm sw-btn-inspector sw-btn-min-w-80 pull-right\" ng-click=\"vm.freehandToolSaveAction()\" translate>buttons.Save</button>\n          </div>\n        </div>\n      </div>\n    </div> -->\n    <!-- track reassignment controller -->\n    <div ng-show=\"vm.state.performerSelected && vm.activeCollaborationConfig.isProductionOwner && (vm.state.performersCount > 1)\" class=\"chart-inspector-group text-left\">\n      <div class=\"sw-chart-inspector-row sw-context-menu-rotate\">\n        <button style=\"justify-content: center\" class=\"inspector-layer-done-butt on btn sw-btn-inspector swtoolbar-flex sw-align-distribute-par\" ng-click=\"vm.performerTrackReassignmentAction()\">\n          <span translate>buttons.Track Reassignment</span>\n        </button>\n      </div>\n    </div>\n    <!-- track reassignment controller end -->\n    <!-- Colors buttons -->\n    <div class=\"chart-inspector-group inspector-color-container\" ng-hide=\"vm.state.layerEditorActive || (vm.state.performerSelected && vm.activeCollaborationConfig.isProductionOwner && (vm.state.performersCount > 1))\">\n      <div class=\"sw-chart-inspector-row\" ng-disabled=\"!vm.state.selectionColorable || !(vm.state.selectionCount === 1)\" ng-class=\"{\' clickthrough\': !(((vm.state.selectionCount === 1) && vm.state.selectionColorable) || vm.state.freehandToolActive)}\">\n        <span class=\"swafont swafont-lg swafont-icon-border_color\"></span>\n        <span class=\"color-picker-holder\"><spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.state.selectionColor\" options=\"vm.colorPickerOption\" on-hide=\"vm.borderColorChanged(color)\"></spectrum-colorpicker></span>\n      </div>\n      <div class=\"sw-chart-inspector-row\" ng-disabled=\"!vm.state.selectionFillColorable || !(vm.state.selectionCount === 1)\" ng-class=\"{\' clickthrough\': !((vm.state.selectionCount === 1) && vm.state.selectionFillColorable)}\">\n        <span class=\"swafont swafont-lg swafont-icon-fill_color\"></span>\n        <span class=\"color-picker-holder\"><spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.state.selectionFillColor\" options=\"vm.colorPickerOption\" on-hide=\"vm.fillColorChanged(color)\"></spectrum-colorpicker></span>\n      </div>\n    </div>\n    <!-- Flip buttons end-->\n    <!-- line thickness controller -->\n    <div ng-hide=\"vm.state.setPieceSelected || vm.state.layerEditorActive\" class=\"chart-inspector-group inspector-flip-container text-left\">\n      <div class=\"sw-chart-inspector-row sw-context-menu-rotate\">\n        <div class=\"inspector-layer-done-butt on btn sw-btn-inspector swtoolbar-flex sw-align-distribute-par line-thickness-btns\" ng-disabled=\"!(vm.state.selectionCount > 0) || !vm.state.shapesSelected\">\n          <span translate>buttons.Line Thickness</span>\n          <div class=\"plus-minus-icons\">\n          <span ng-click=\"vm.decreaseLineThickness()\" class=\"swafont swafont-lg swafont-icon-minus\"></span>\n          <span ng-click=\"vm.resetLineThickness()\" class=\"reset-btn\">Reset</span>\n          <span ng-click=\"vm.increaseLineThickness()\" class=\"swafont swafont-lg swafont-icon-plus\"></span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- line thickness controller end -->\n    <!-- flip buttons -->\n    <div class=\"chart-inspector-group inspector-flip-container inspector-color-container\" ng-hide=\"vm.state.layerEditorActive || !vm.state.setPieceSelected\">\n      <div class=\"sw-chart-inspector-row\" ng-disabled=\"!vm.state.selectionFlipAble || !(vm.state.selectionCount === 1)\" ng-click=\"vm.flipHorizontallyAction()\">\n        <span class=\"swafont swafont-lg swafont-icon-Flip_h\"></span>\n        <span class=\"flip-label\">Flip H</span>\n      </div>\n      <div class=\"sw-chart-inspector-row\" ng-disabled=\"!vm.state.selectionFlipAble || !(vm.state.selectionCount === 1)\" ng-click=\"vm.flipVerticallyAction()\">\n        <span class=\"swafont swafont-lg swafont-icon-Flip_v\"></span>\n        <span class=\"flip-label\">Flip V</span>\n      </div>\n    </div>\n    <!-- flip buttons end -->\n    <div class=\"sw-alignment-distribute\" ng-show=\"vm.state.alignMenu\">\n      <div class=\"sw-context-menu-header sw-alignment-header\" ng-hide=\"vm.state.layerEditorActive\">\n        <button class=\"btn btn-sm sw-btn-toolbar back-btn\" ng-click=\"vm.hideAlignMenuOptions()\">\n          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-chevron-left\"></span>\n        </button>\n        <div class=\"sw-drag\">\n        </div>\n        <button class=\"btn btn-sm sw-btn-toolbar\" ng-click=\"vm.closeContextMenu()\">\n          <span class=\"sw-ionicon sw-ionicon-lg ion-close-round\"></span>\n        </button>\n      </div>\n      \n      <div class=\"chart-inspector-group inspector-action-container text-left\" ng-hide=\"vm.state.layerEditorActive\">\n        <span class=\"sw-btn-inspector-label\">Align</span>\n        <div class=\"inspector-clipboard-actions sw-chart-inspector-row\">\n          <button class=\"btn sw-btn-inspector sw-align-distribute-btn\" ng-disabled=\"!(vm.state.selectionCount > 1)\" ng-click=\"vm.alignLeft()\">\n            <span class=\"swafont swafont-sm swafont-icon-left_align\"></span>\n            <span>Left</span>\n          </button>\n          <button class=\"btn sw-btn-inspector sw-align-distribute-btn\" ng-disabled=\"!(vm.state.selectionCount > 1)\" ng-click=\"vm.alignCenter()\">\n            <span class=\"swafont swafont-md swafont-icon-center\"></span>\n            <span>Center</span> \n          </button>\n          <button class=\"btn sw-btn-inspector sw-align-distribute-btn\" ng-disabled=\"!(vm.state.selectionCount > 1)\" ng-click=\"vm.alignRight()\">\n            <span class=\"swafont swafont-md swafont-icon-right_align\"></span>\n            <span>Right</span> \n          </button>\n        </div>\n        <div class=\"inspector-clipboard-actions sw-chart-inspector-row\">\n          <button class=\"btn sw-btn-inspector sw-align-distribute-btn\" ng-disabled=\"!(vm.state.selectionCount > 1)\" ng-click=\"vm.alignTop()\">\n            <span class=\"swafont swafont-md swafont-icon-top_aligin\"></span>\n            <span>Top</span> \n          </button>\n          <button class=\"btn sw-btn-inspector sw-align-distribute-btn\" ng-disabled=\"!(vm.state.selectionCount > 1)\" ng-click=\"vm.alignMiddle()\">\n            <span class=\"swafont swafont-md swafont-icon-v_middle\"></span>\n            <span>Middle</span> \n          </button>\n          <button class=\"btn sw-btn-inspector sw-align-distribute-btn\" ng-disabled=\"!(vm.state.selectionCount > 1)\" ng-click=\"vm.alignBottom()\">\n            <span class=\"swafont swafont-md swafont-icon-bottom_aligin\"></span>\n            <span>Bottom</span> \n          </button>\n        </div>\n      </div>\n      <div class=\"chart-inspector-group inspector-angle-container text-left\" ng-hide=\"vm.state.layerEditorActive\">\n        <span class=\"sw-btn-inspector-label text\">Distribute Space Evenly</span>\n        <div class=\"sw-chart-inspector-row sw-context-menu-rotate\">\n          <button class=\"inspector-layer-done-butt on btn sw-btn-inspector sw-align-distribute-btn\" ng-disabled=\"!(vm.state.selectionCount > 2)\" ng-click=\"vm.horizontalSpacing()\">\n            <span class=\"swafont swafont-md swafont-icon-h_space\"></span>\n            <span ng-hide=\"\">H-Space</span>\n          </button>\n          <button class=\"inspector-layer-done-butt on btn sw-btn-inspector sw-align-distribute-btn\" ng-disabled=\"!(vm.state.selectionCount > 2)\" ng-click=\"vm.verticalSpacing()\">\n            <span class=\"swafont swafont-md swafont-icon-v_space\"></span>\n            <span ng-hide=\"\">V-Space</span>\n          </button>\n        </div>\n      </div>\n    </div>\n    <!-- Flip buttons end-->\n</div>\n");
$templateCache.put("app/components/chartEditor/chartEditor.html","<swa-help-bar ng-if=\"vm.showHelpBar && !(vm.chartEditorState.lockModeNavigation || vm.chartVersionBrowserState.active) && !(vm.chartEditorState.chartOpen && (vm.chartEditorState.mediaDrawerOpen || (vm.chartEditorState.performerPickerDocked && vm.chartEditorState.performerPickerDockedOpen)))\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-videos=\"vm.helpTourVideos\"></swa-help-bar>\n<div class=\"mainOuter\" ng-class=\"{\'lockmodenavigation\': (vm.chartEditorState.lockModeNavigation)}\" n-cloak>\n  <div class=\"navbar navbar-fixed-top sw-navbar\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.layerEditorActive}\" ng-hide=\"vm.chartEditorState.lockModeNavigation || vm.chartVersionBrowserState.active\">\n    <div class=\"swtoolbar\" ng-hide=\"vm.deletedChartListMode\">\n      <div class=\"swtoolbar-group pull-left\">\n        <img class=\"sws-logo sws-logo-link\" src=\"assets/images/sws-logo-light.png\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\" uib-tooltip=\"{{\'labels.Back to Productions\' | translate}}\">\n      </div>\n      <div class=\"swtoolbar-group pull-left\" id=\"editor-view\">\n        <button id=\"menu-locknavigation\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.toggleLockModeNavigation()\" ng-class=\"{\'sw-active\': vm.chartEditorState.lockModeNavigation}\" ng-disabled=\"vm.scenes.length === 0 || vm.sidebarEditState.destinationSelectVisible\" uib-tooltip=\"Toggle lock navigation mode\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-unlock\"></span>\n        </button>\n        <button id=\"menu-switchview\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"switchEditorView\" uib-tooltip=\"Switch to other Views\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <div class=\"sw-btn-toolbar-vcontent\">\n            <span class=\"title\">Charts</span>\n            <span class=\"sw-ionicon-fw ion-arrow-down-b icon\"></span>\n          </div>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"switchEditorView\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.View</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-disabled=\"true\">\n                <span class=\"title\" translate>labels.Charts</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"vm.selectedProduction.productiontype !== 1\" ng-click=\"vm.switchEditor(1)\">\n                <span class=\"title\" translate>labels.Score</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"vm.selectedProduction.productiontype !== 1\" ng-click=\"vm.switchEditor(2)\">\n                <span class=\"title\" translate>labels.Charts and Score</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"vm.selectedProduction.productiontype === 1\" ng-click=\"vm.switchEditor(3)\">\n                <span class=\"title\" translate>labels.PDF</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"vm.selectedProduction.productiontype === 1\" ng-click=\"vm.switchEditor(4)\">\n                <span class=\"title\" translate>labels.Charts and PDF</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n      <div class=\"swtoolbar-group pull-left\">\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-addchart\" ng-disabled=\"(vm.selectedScene.charts.length >= vm.activePlanRules.allowedNumberOfCharts) || (vm.selectedSceneId === undefined) || vm.sidebarEditState.enabled || !vm.activeAccessRules.allowaddchart\" stackable-trigger=\"vm.addChartPopover\" uib-tooltip=\"Add a new Chart\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-plus\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.addChartPopover\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.Add Chart</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-click=\"vm.addNewChart(0)\">\n                <span class=\"title\" translate>labels.Blank Chart</span>\n              </div>\n              <div class=\"menu-item\" ng-click=\"vm.addNewChart(1)\" ng-disabled=\"!vm.canAddChartCopy()\">\n                <span class=\"title\" translate>labels.Duplicate Chart</span>\n              </div>\n              <div class=\"menu-item\" ng-click=\"vm.addNewChart(2)\" ng-disabled=\"!vm.canAddChartCopy()\">\n                <span class=\"title\" translate>labels.Next Chart</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n      <div class=\"swtoolbar-group pull-left\">\n        <button id=\"menu-chartzoom\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!vm.chartEditorState.chartOpen || !vm.activeAccessRules.allowzoomchange\" stackable-trigger=\"vm.zoomPicker\" uib-tooltip=\"Chart zoom options\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-zoom\"></span>\n          <span class=\"toolbar-zoom-value\">{{vm.chartEditorState.zoomFactor}}x</span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.zoomPicker\">\n          <div class=\"sw-popover-title\">\n            <span>{{\'titles.Zoom\'| translate}}:\n              {{vm.chartEditorState.zoomFactor}}x</span>\n          </div>\n          <div class=\"sw-popover-content sw-popover-zoom-picker\">\n            <div class=\"sw-zoom-picker-content\">\n              <rzslider class=\"swa-rzslider\" rz-slider-options=\"vm.zoomSliderOptions\" rz-slider-model=\"vm.chartEditorState.zoomFactor\"></rzslider>\n              <div class=\"hint-icon-message\" style=\"margin-top: 8px\">\n                <div class=\"icon\">\n                  <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n                </div>\n                <div class=\"text\">\n                  <em class=\"sw-text-sm swa-color-lightgraygray\" translate>messages.Hold the \'Ctrl\' key and drag the chart to scroll around when zoomed in</em>\n                </div>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n      <div class=\"swtoolbar-group pull-left\" id=\"layers\">\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-semilayer\" ng-class=\"{\'sw-active\': (vm.chartEditorState.semiLayerActive && vm.chartEditorState.chartOpen)}\" ng-click=\"vm.toggleSemiLayer()\" ng-disabled=\"!vm.chartEditorState.chartOpen || !vm.activeAccessRules.allowsceniclayerselect\" uib-tooltip=\"Select the Scenic Layer\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg\" ng-class=\"{\'swafont-icon-layer-scenic\': !vm.chartEditorState.semiLayerActive, \'swafont-icon-layer-scenic-active\': vm.chartEditorState.semiLayerActive}\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-dynamiclayer\" ng-class=\"{\'sw-active\': (vm.chartEditorState.dynLayerActive && vm.chartEditorState.chartOpen)}\" ng-click=\"vm.toggleDynLayer()\" ng-disabled=\"!vm.chartEditorState.chartOpen || !vm.activeAccessRules.allowperformerlayerselect\" uib-tooltip=\"Select the Performer layer\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg\" ng-class=\"{\'swafont-icon-layer-performer\': !vm.chartEditorState.dynLayerActive, \'swafont-icon-layer-performer-active\': vm.chartEditorState.dynLayerActive}\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-chartmediapicker\" ng-disabled=\"!vm.chartEditorState.chartOpen\" ng-class=\"{\'sw-active\': (vm.chartEditorState.mediaDrawerOpen), \'sw-highlight\': (vm.selectedChartMediaItems.length > 0)}\" ng-click=\"vm.toggleMediaDock()\" uib-tooltip=\"Chart Media\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-video-filmstrip\"></span>\n        </button>\n      </div>\n      <div id=\"menu-chartitemoptions\" class=\"swtoolbar-group pull-left\">\n        <button id=\"menu-chartshapes\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!(vm.chartEditorState.chartOpen && vm.chartEditorState.layerActive) || !vm.activeAccessRules.allowaddshapes\" stackable-trigger=\"vm.shapePicker\" uib-tooltip=\"Add Shape\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-shapes\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.shapePicker\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.Shapes</span>\n          </div>\n          <div class=\"sw-popover-content sw-popover-shapes-picker\">\n            <div class=\"sw-shapes-picker-content\">\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Square)\">\n                <img src=\"assets/images/shapeicons/shape_square_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Circle)\">\n                <img src=\"assets/images/shapeicons/shape_circle_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Triangle)\">\n                <img src=\"assets/images/shapeicons/shape_triangle_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Arc)\">\n                <img src=\"assets/images/shapeicons/shape_arc_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.JoinedLine)\">\n                <img src=\"assets/images/shapeicons/shape_joinedline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.JoinedLineArrow)\">\n                <img src=\"assets/images/shapeicons/shape_joinedlinearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Curve)\">\n                <img src=\"assets/images/shapeicons/shape_curve_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.CurveArrow)\">\n                <img src=\"assets/images/shapeicons/shape_curvearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.SolidLine)\">\n                <img src=\"assets/images/shapeicons/shape_solidline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.SolidLineArrow)\">\n                <img src=\"assets/images/shapeicons/shape_solidlinearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.DottedLine)\">\n                <img src=\"assets/images/shapeicons/shape_dottedline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.DottedLineArrow)\">\n                <img src=\"assets/images/shapeicons/shape_dottedlinearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.ThinDottedLine)\">\n                <img src=\"assets/images/shapeicons/shape_thindottedline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.CurtainLine)\">\n                <img src=\"assets/images/shapeicons/shape_curtainline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.ThickLine)\">\n                <img src=\"assets/images/shapeicons/shape_thickline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Freehand)\">\n                <span class=\"sw-color-lightgray\" translate>labels.Freehand</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n        <button id=\"menu-chartsetpieces\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!(vm.chartEditorState.chartOpen && vm.chartEditorState.layerActive) || !vm.activeAccessRules.allowaddsetpieces\" stackable-trigger=\"vm.setPiecePicker\" uib-tooltip=\"Add Set Piece\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-setpiece\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.setPiecePicker\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.Set Pieces</span>\n          </div>\n          <div class=\"search search-bar-chart\">\n              <input class=\"form-control\" id=\"searchpersetpiece\" name=\"searchpersetpiece\" ng-model=\"vm.searchpersetpiece\" ng-change=\"vm.searchStringChangedForSetpice()\" type=\"text\" placeholder=\"Search ...\">\n              <button class=\"btn btn-lg sw-btn-toolbar search-text-clear-btn search-text-clear-btn-float\" ng-click=\"vm.clearSearchForSetpice()\" ng-show=\"vm.searchpersetpiece.length > 0\">\n                  <span class=\"sw-ionicon-lg ion-ios-close-outline\"></span>\n              </button>\n          </div>\n          <div class=\"sw-popover-content sw-popover-setpiece-picker\">\n            <div class=\"sw-setpiece-picker-content\">\n              <div id=\"setPiece-{{$index}}\" class=\"sw-setpiece-picker-row\" ng-repeat=\"aSetPiece in (vm.setPieces.concat(vm.stockSetPieces) | filter: vm.setpieceSearchFilter | orderBy: \'oIndex\') as results\" ng-click=\"vm.setPiecePickerDidPickSetPiece(aSetPiece)\">\n                <div class=\"image-block\">\n                  <img ng-src=\"data:image/png;base64,{{aSetPiece.thumbimage}}\">\n                </div>\n                <div class=\"title-block sw-truncatetext-wrap\">\n                  <span class=\"title\">{{aSetPiece.name}}</span>\n                  <br>\n                  <span class=\"subtitle\" ng-if=\"aSetPiece.measurementunit === 1 || vm.chartItemViewFactory.swMeasurementUnit === 1\">\n                    {{(aSetPiece.width || (aSetPiece.width * vm.chartItemViewFactory.measurementConversionMultiplier)) | number : 2}}\n                    x\n                    {{(aSetPiece.height || (aSetPiece.height * vm.chartItemViewFactory.measurementConversionMultiplier)) | number : 2}}\n                    m\n                  </span>\n                  <span class=\"subtitle\" ng-if=\"aSetPiece.measurementunit === 0 || vm.chartItemViewFactory.swMeasurementUnit === 0\">\n                    {{(aSetPiece.width || (aSetPiece.width * vm.chartItemViewFactory.measurementConversionMultiplier)) | feetAndInches}}\n                    x\n                    {{(aSetPiece.height || (aSetPiece.height * vm.chartItemViewFactory.measurementConversionMultiplier)) | feetAndInches}}\n                  </span>\n                </div>\n              </div>\n            </div>\n            <div id=\"no-productions\" class=\"no-matching-info-text\" ng-hide=\"results.length !== 0\">\n              <span>No matching Set Pieces!</span>\n            </div>\n          </div>\n        </stackable-popover>\n        <button id=\"menu-chartnotes\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!vm.chartEditorState.chartOpen || !(vm.activeAccessRules.allowaddcharttext || vm.activeAccessRules.allowaddcharttextpersonal || vm.activeAccessRules.allowaddchartnotes)\" stackable-trigger=\"vm.notesPicker\" uib-tooltip=\"Add text, chart notes\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-text-notes\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.notesPicker\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.Notes</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-click=\"vm.addChartText()\" ng-disabled=\"!vm.chartEditorState.layerActive || !vm.activeAccessRules.allowaddcharttext\" ng-hide=\"vm.activeAccessRules.allowaddcharttextpersonal\">\n                <span class=\"title\" translate>labels.Add Text Box</span>\n              </div>\n              <div class=\"menu-item\" ng-click=\"vm.addChartTextPersonal()\" ng-show=\"vm.activeAccessRules.allowaddcharttextpersonal\">\n                <span class=\"title\" translate>labels.Add Personal Note</span>\n              </div>\n              <div class=\"menu-item\" ng-click=\"vm.toggleChartNotes()\" ng-hide=\"vm.selectedChart.notesvisible\" ng-if=\"!vm.activeAccessRules.allowaddcharttextpersonal\" ng-disabled=\"!vm.activeAccessRules.allowaddchartnotes || vm.selectedProduction.chartsettings.chartnotesvisible\">\n                <span class=\"title\" translate>labels.Show Notes</span>\n              </div>\n              <div class=\"menu-item\" ng-click=\"vm.toggleChartNotes()\" ng-show=\"vm.selectedChart.notesvisible\" ng-if=\"!vm.activeAccessRules.allowaddcharttextpersonal\" ng-disabled=\"!vm.activeAccessRules.allowaddchartnotes || vm.selectedProduction.chartsettings.chartnotesvisible\">\n                <span class=\"title\" translate>labels.Hide Notes</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-chartperformersdrawer\" ng-disabled=\"!(vm.chartEditorState.chartOpen && vm.chartEditorState.dynLayerActive) || !vm.activeAccessRules.allowaddperformers\" ng-class=\"{\'sw-active\': (vm.chartEditorState.performerPickerDockedOpen)}\" ng-show=\"vm.chartEditorState.performerPickerDocked\" ng-click=\"vm.showPerformerPicker()\" uib-tooltip=\"Add Performer\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-performer\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-chartperformerspicker\" ng-disabled=\"!(vm.chartEditorState.chartOpen && vm.chartEditorState.dynLayerActive) || !vm.activeAccessRules.allowaddperformers\" ng-hide=\"vm.chartEditorState.performerPickerDocked\" stackable-trigger=\"vm.performerPicker\" uib-tooltip=\"Add Performer\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-performer\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.performerPicker\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.Green Room</span>\n            <button class=\"btn btn-sm sw-btn-secondary pull-right\" ng-click=\"vm.dockPerformerPicker()\" translate>\n              buttons.Dock\n            </button>\n          </div>\n          <div class=\"search search-bar-chart\">\n              <input class=\"form-control\" id=\"searchperformername\" name=\"searchperformername\" ng-model=\"vm.searchperformername\" ng-change=\"vm.searchStringChangedForPerformer()\" type=\"text\" placeholder=\"Search ...\">\n              <button class=\"btn btn-lg sw-btn-toolbar search-text-clear-btn search-text-clear-btn-float\" ng-click=\"vm.clearSearchForPerformer()\" ng-show=\"vm.searchperformername.length > 0\">\n                  <span class=\"sw-ionicon-lg ion-ios-close-outline\"></span>\n              </button>\n          </div>\n          <div class=\"sw-popover-content sw-popover-performer-picker\">\n            <div class=\"sw-performer-picker-content\">\n              <div class=\"sw-performer-picker-item\" ng-click=\"vm.performerPickerDidPickPerformer(aPerformer)\" ng-repeat=\"aPerformer in vm.performers | limitTo: vm.activePlanRules.allowedNumberOfPerformers | orderBy:\'orderingindex\' | filter: vm.performerSearchFilter | orderBy: \'oIndex\' as results\">\n                <img ng-src=\"data:image/png;base64,{{aPerformer.image}}\">\n                <div ng-class=\"{\'is-performer-on-chart\': aPerformer.isOnChart === true}\"></div>\n              </div>\n              <div class=\"sw-popover-hint-item text-center\" ng-if=\"vm.performers.length === 0\">\n                <em translate>labels.No Performers</em>\n              </div>\n            </div>\n            <div id=\"no-productions\" class=\"no-matching-info-text\" ng-hide=\"results.length !== 0 || vm.performers.length === 0\">\n              <span>No matching Performers!</span>\n            </div>\n          </div>\n          <div class=\"track-reassignment-btn swtoolbar-flex\" ng-if=\"vm.activeCollaborationConfig.isProductionOwner\">\n            <button id=\"track-reassignment\" class=\"btn btn-md sw-btn-secondary\" ng-click=\"vm.performerTrackReassignmentPrompt()\" ng-disabled=\"vm.performers.length < 2\">\n              <span translate>buttons.Track Reassignment</span>\n            </button>\n            <button id=\"undo-last-reassignment\" class=\"btn btn-md sw-btn-secondary\" ng-click=\"vm.undoReassignmentPrompt()\" ng-disabled=\"vm.performerPairsWithIdsForUndo === undefined\">\n              <span translate>buttons.Undo Last Reassignment</span>\n            </button>\n          </div>\n          <div class=\"performer-scaling-float\">\n            <label class=\"performer-scaling-float-heading\" translate>labels.Scale Performers</label>\n            <div id=\"chart-performer-scaling-mode\" class=\"btn-group btn-group-btn chart-performer-scaling-grp-btn\">\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.scalePerformers.allPerformers === false && vm.scalePerformers.selectedPerformers === false}\" ng-click=\"vm.updateScalePerformers(\'none\')\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.scalePerformers.allPerformers === false && vm.scalePerformers.selectedPerformers === false,\n                                  \'ion-android-radio-button-off\': vm.scalePerformers.allPerformers === true || vm.scalePerformers.selectedPerformers === true}\"></span>\n                {{\'buttons.None\'| translate}}\n              </button>\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.scalePerformers.allPerformers === true}\" ng-click=\"vm.updateScalePerformers(\'all\')\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.scalePerformers.allPerformers === true,\n                                  \'ion-android-radio-button-off\': vm.scalePerformers.allPerformers === false}\"></span>\n                {{\'buttons.All\'| translate}}\n              </button>\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.scalePerformers.selectedPerformers === true}\" ng-click=\"vm.updateScalePerformers(\'selected\')\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.scalePerformers.selectedPerformers === true,\n                                  \'ion-android-radio-button-off\': vm.scalePerformers.selectedPerformers === false}\"></span>\n                {{\'buttons.Selected\'| translate}}\n              </button>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n      <div class=\"swtoolbar-group pull-left\" id=\"chart-undoredo\">\n        <button id=\"menu-chartundo\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!(vm.changeTracker.enabled && vm.changeTracker.canUndo)\" ng-click=\"vm.undoAction()\" uib-tooltip=\"Undo last change\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"toolbar-zoom-value\">{{vm.changeTracker.undoStack.length}}</span>\n          <span class=\"swafont swafont-lg swafont-icon-undo\"></span>\n        </button>\n        <button id=\"menu-chartredo\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!(vm.changeTracker.enabled && vm.changeTracker.canRedo)\" ng-click=\"vm.redoAction()\" uib-tooltip=\"Redo last change\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-redo\"></span>\n          <span class=\"toolbar-zoom-value\">{{vm.changeTracker.redoStack.length}}</span>\n        </button>\n      </div>\n      <div class=\"swtoolbar-group pull-left\">\n        <button id=\"menu-charttools\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.toggleToolbarVisibilityPromt()\" ng-disabled=\"!(vm.chartEditorState.chartOpen && vm.chartEditorState.layerActive)\" uib-tooltip=\"Show / hide chart tools\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg\" ng-class=\"{\'swafont-icon-chartinspectorshow\': !vm.chartEditorState.inspectorVisible, \'swafont-icon-chartinspectorhide\': vm.chartEditorState.inspectorVisible}\"></span>\n        </button>\n        <button id=\"menu-linkeditems\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!(vm.selectedChart.navigationLinks.length)\" stackable-trigger=\"vm.navigationLinksOptions\" uib-tooltip=\"Linked Scores\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-link\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable-alignment=\"right\" stackable-enable-escape=\"true\" stackable=\"vm.navigationLinksOptions\">\n          <div class=\"sw-popover-title\">\n            <span ng-if=\"vm.selectedProduction.productiontype === 0\" translate>titles.Linked Scores</span>\n            <span ng-if=\"vm.selectedProduction.productiontype === 1\" translate>titles.Linked Pages</span>\n          </div>\n          <div class=\"sw-popover-menu linked-scores-list unlocked\" role=\"menu\">\n            <div class=\"menu-group\" ng-if=\"vm.selectedProduction.productiontype === 0\">\n              <div class=\"menu-item\" ng-repeat=\"staff in vm.selectedChart.navigationLinks\" ng-click=\"vm.switchEditor(1, { staffId: staff._id, sceneId: staff.sceneId });\">\n                <span class=\"title\">{{staff.assignedName}}</span>\n              </div>\n            </div>\n            <div class=\"menu-group\" ng-if=\"vm.selectedProduction.productiontype === 1\">\n              <div class=\"menu-item\" ng-repeat=\"scriptPage in vm.selectedChart.navigationLinks\" ng-click=\"vm.switchEditor(3, { scriptPageId: scriptPage._id, orderingindex: scriptPage.orderingindex });\">\n                <span class=\"title\">{{scriptPage.assignedName}}</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n        <button id=\"menu-copychartlink\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!vm.chartEditorState.chartOpen\" ng-click=\"vm.copyChartImageToClipboard()\" uib-tooltip=\"Copy chart image\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-chart-link\"></span>\n        </button>\n      </div>\n      <div class=\"swtoolbar-group pull-right\">\n        <button id=\"menu-savechanges\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!(vm.selectedChart.dirty || vm.selectedUserChart.dirty)\" ng-click=\"vm.onSaveClick()\" ng-class=\"{\'sw-highlight\': vm.autoSaveState.saveActive}\" uib-tooltip=\"Save changes\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-save\"></span>\n          <span class=\"toolbar-zoom-value\">{{vm.autoSaveState.timeoutSec}}</span>\n          <div class=\"progress-bar-container\" ng-show=\"vm.autoSaveState.timerActive\">\n            <span class=\"progress-bar\" ng-style=\"{width: (vm.autoSaveState.timeoutRemainingSec * 100 / vm.autoSaveState.timeoutMaxSec) +\'%\'}\"></span>\n          </div>\n        </button>\n        <button id=\"menu-createpdf\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.pdfOptionsPicker\" uib-tooltip=\"PDF / printing options\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-create-pdf\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable-alignment=\"right\" stackable-enable-escape=\"true\" stackable=\"vm.pdfOptionsPicker\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.Create PDF</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllChartsStaffs)\">\n                <span class=\"title\" translate>labels.Production - Charts &amp; Score</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 1)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0) || !vm.script\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllChartsScript)\">\n                <span class=\"title\" translate>labels.Production - Charts &amp; PDF</span>\n              </div>\n              <div class=\"menu-item\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllCharts)\">\n                <span class=\"title\" translate>labels.Production - Charts</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllStaffs)\">\n                <span class=\"title\" translate>labels.Production - Score</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 1)\" ng-disabled=\"!vm.script\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.Script)\">\n                <span class=\"title\" translate>labels.Production - PDF</span>\n              </div>\n            </div>\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneChartsStaffs)\">\n                <span class=\"title\" translate>labels.Current Scene - Charts &amp; Score</span>\n              </div>\n              <div class=\"menu-item\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneCharts)\">\n                <span class=\"title\" translate>labels.Current Scene - Charts</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneStaffs)\">\n                <span class=\"title\" translate>labels.Current Scene - Score</span>\n              </div>\n            </div>\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-disabled=\"!vm.selectedChart\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentChart)\">\n                <span class=\"title\" translate>labels.Current Chart</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedStaff\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentStaff)\">\n                <span class=\"title\" translate>labels.Current Score</span>\n              </div>\n            </div>\n            <div class=\"menu-group-title\" ng-if=\"false\">\n              <span translate>labels.Options</span>\n            </div>\n            <div class=\"menu-group\" ng-if=\"false\">\n              <div class=\"menu-item menu-item-nohover menu-item-subtitle\">\n                <span class=\"title\" translate>labels.Performer Filtering</span>\n                <span class=\"subtitle\" translate>labels.for Score</span>\n                <span class=\"control-right\">\n                  <switch class=\"swa-switch swa-switch-small\" id=\"pdfperformerfilter\" ng-model=\"vm.pdfPrintOptions.performerFilterEnabled\" on=\"I\" off=\"O\"></switch>\n                </span>\n              </div>\n            </div>\n            <div class=\"menu-group-title\">\n              <span translate>labels.Recent PDFs</span>\n            </div>\n            <div class=\"menu-group swa-print-job-list\" swa-print-job-list data-list=\"vm.printJobs\">\n            </div>\n          </div>\n        </stackable-popover>\n        <div id=\"menu-collaborators\" class=\"btn sw-btn-toolbar\" ng-show=\"vm.selectedProduction.collaborationsettings.length > 0\" uib-tooltip=\"Collaboration details\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span swa-show-collaborators data-production=\"vm.selectedProduction\" data-current-user-id=\"vm.userId\" class=\"sw-ionicon-2x ion-person-stalker\"></span>\n        </div>\n        <button id=\"menu-settings\" class=\"btn sw-btn-toolbar\" ui-sref=\"{{vm.swaRouterStateNames.productionsettings.details}}\" uib-tooltip=\"Production Settings\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-settings\"></span>\n        </button>\n      </div>\n    </div>\n    <div class=\"swtoolbar\" ng-show=\"vm.deletedChartListMode\">\n      <div class=\"swtoolbar-group pull-left\">\n        <img class=\"sws-logo sws-logo-link\" src=\"assets/images/sws-logo-light.png\">\n      </div>\n    </div>\n  </div>\n  <div class=\"swtoolbar swtoolbar-lockmode text-center\" ng-show=\"vm.chartEditorState.lockModeNavigation\">\n    <div class=\"swtoolbar-group pull-left\">\n      <img class=\"sws-logo\" src=\"assets/images/sws-logo-light.png\">\n    </div>\n    <div class=\"swtoolbar-group pull-left\">\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.toggleLockModeNavigation()\" ng-class=\"{\'sw-active\': vm.chartEditorState.lockModeNavigation}\" uib-tooltip=\"Toggle lock navigation mode\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-lock\"></span>\n      </button>\n      <button id=\"menu-switchview2\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"switchEditorView2\" uib-tooltip=\"Switch to other Views\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <div class=\"sw-btn-toolbar-vcontent\">\n          <span class=\"title\">Charts</span>\n          <span class=\"sw-ionicon-fw ion-arrow-down-b icon\"></span>\n        </div>\n      </button>\n      <stackable-popover stackable-placement=\"bottom\" stackable=\"switchEditorView2\">\n        <div class=\"sw-popover-title\">\n          <span translate>titles.View</span>\n        </div>\n        <div class=\"sw-popover-menu\" role=\"menu\">\n          <div class=\"menu-group\">\n            <div class=\"menu-item\" ng-disabled=\"true\">\n              <span class=\"title\" translate>labels.Charts</span>\n            </div>\n            <div class=\"menu-item\" ng-if=\"vm.selectedProduction.productiontype !== 1\" ng-click=\"vm.switchEditor(1)\">\n              <span class=\"title\" translate>labels.Score</span>\n            </div>\n            <div class=\"menu-item\" ng-if=\"vm.selectedProduction.productiontype !== 1\" ng-click=\"vm.switchEditor(2)\">\n              <span class=\"title\" translate>labels.Charts and Score</span>\n            </div>\n            <div class=\"menu-item\" ng-if=\"vm.selectedProduction.productiontype === 1\" ng-click=\"vm.switchEditor(3)\">\n              <span class=\"title\" translate>labels.PDF</span>\n            </div>\n            <div class=\"menu-item\" ng-if=\"vm.selectedProduction.productiontype === 1\" ng-click=\"vm.switchEditor(4)\">\n              <span class=\"title\" translate>labels.Charts and PDF</span>\n            </div>\n          </div>\n        </div>\n      </stackable-popover>\n    </div>\n    <div class=\"swtoolbar-group pull-left\">\n      <button class=\"btn sw-btn-toolbar\" id=\"menu-chartmediapicker\" ng-disabled=\"!vm.chartEditorState.chartOpen\" ng-class=\"{\'sw-active\': (vm.chartEditorState.mediaDrawerOpen), \'sw-highlight\': (vm.selectedChartMediaItems.length > 0)}\" ng-click=\"vm.toggleMediaDock()\">\n        <span class=\"swafont swafont-lg swafont-icon-video-filmstrip\"></span>\n      </button>\n    </div>\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"menu-linkedscores-locked-view\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!(vm.selectedChart.navigationLinks.length)\" stackable-trigger=\"vm.navigationLockedModeLinksOptions\">\n        <span class=\"swafont swafont-lg swafont-icon-link\"></span>\n      </button>\n      <stackable-popover stackable-placement=\"bottom\" stackable-alignment=\"right\" stackable-enable-escape=\"true\" stackable=\"vm.navigationLockedModeLinksOptions\">\n        <div class=\"sw-popover-title\">\n          <span ng-if=\"vm.selectedProduction.productiontype === 0\" translate>titles.Linked Scores</span>\n          <span ng-if=\"vm.selectedProduction.productiontype === 1\" translate>titles.Linked Pages</span>\n        </div>\n        <div class=\"sw-popover-menu linked-scores-list locked\" role=\"menu\">\n          <div class=\"menu-group\" ng-if=\"vm.selectedProduction.productiontype === 0\">\n            <div class=\"menu-item\" ng-repeat=\"staff in vm.selectedChart.navigationLinks\" ng-click=\"vm.switchEditor(1, { staffId: staff._id, sceneId: staff.sceneId });\">\n              <span class=\"title\">{{staff.assignedName}}</span>\n            </div>\n          </div>\n          <div class=\"menu-group\" ng-if=\"vm.selectedProduction.productiontype === 1\">\n            <div class=\"menu-item\" ng-repeat=\"scriptPage in vm.selectedChart.navigationLinks\" ng-click=\"vm.switchEditor(3, { scriptPageId: scriptPage._id, orderingindex: scriptPage.orderingindex });\">\n              <span class=\"title\">{{scriptPage.assignedName}}</span>\n            </div>\n          </div>\n        </div>\n      </stackable-popover>\n    </div>\n    <div class=\"swtoolbar-group swtoolbar-group-centered\">\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationPreviousScene()\">\n        <span class=\"sw-ionicon-fw ion-chevron-left\"></span>\n        {{\'buttons.Scene\' | translate}}\n      </button>\n      <span class=\"spacer8\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationPreviousChart()\">\n        <span class=\"sw-ionicon-fw ion-chevron-left\"></span>\n        {{\'buttons.Chart\' | translate}}\n      </button>\n      <span class=\"spacer16\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationNextChart()\">\n        {{\'buttons.Chart\' | translate}}\n        <span class=\"sw-ionicon-fw ion-chevron-right\"></span>\n      </button>\n      <span class=\"spacer8\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationNextScene()\">\n        {{\'buttons.Scene\' | translate}}\n        <span class=\"sw-ionicon-fw ion-chevron-right\"></span>\n      </button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <span class=\"swa-color-lightgray sw-text-lg mrgnLeft20\" translate>titles.Charts View</span>\n    </div>\n  </div>\n  <div class=\"swtoolbar swtoolbar-versionsbrowsermode text-center navbar-fixed-top\" ng-show=\"vm.deletedChartListMode\">\n    <div class=\"swtoolbar-group pull-left\">\n      <img class=\"sws-logo\" src=\"assets/images/sws-logo-light.png\">\n    </div>\n    <div class=\"swtoolbar-group pull-left\">\n    </div>\n    <div class=\"swtoolbar-group swtoolbar-group-centered\" ng-show=\"vm.deletedChartListMode && vm.selectedChart && !vm.sidebarEditState.destinationSelectVisible\">\n      <span class=\"swa-color-white text-lg text-right sw-truncatetext\" style=\"min-width: 700px; width: 700px; display: inline-block; text-align: left\" uib-tooltip=\" CHART REMOVED BY:\n        {{ vm.chartVersionBrowserState.selectedVersion.displayName ? vm.chartVersionBrowserState.selectedVersion.displayName : \'\' }}\n        on {{ vm.chartVersionBrowserState.selectedVersion.archiveDate.$date | date:\'MMM dd, yyyy \\\'at\\\' hh:mm a\' }}\n        {{ vm.chartVersionBrowserState.selectedVersion.chart.platform ? \' on \' + vm.chartVersionBrowserState.selectedVersion.chart.platform : \'\' }}\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        CHART REMOVED BY:\n        {{ vm.chartVersionBrowserState.selectedVersion.displayName ? vm.chartVersionBrowserState.selectedVersion.displayName : \'\' }}\n        on {{ vm.chartVersionBrowserState.selectedVersion.archiveDate.$date | date:\'MMM dd, yyyy \\\'at\\\' hh:mm a\' }}\n        {{ vm.chartVersionBrowserState.selectedVersion.chart.platform ? \' on \' + vm.chartVersionBrowserState.selectedVersion.chart.platform : \'\' }}\n      </span>\n      <span class=\"spacer16\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.chartVersionPrevious()\" ng-disabled=\"!vm.chartVersionBrowserState.prevEnabled || vm.chartVersionBrowserState.chartVersions.length === 0\" uib-tooltip=\"Open previous version\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"sw-ionicon-fw ion-chevron-left\"></span>\n      </button>\n      <span class=\"spacer8\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.chartVersionNext()\" ng-disabled=\"!vm.chartVersionBrowserState.nextEnabled || vm.chartVersionBrowserState.chartVersions.length === 0\" uib-tooltip=\"Open next version\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"sw-ionicon-fw ion-chevron-right\"></span>\n      </button>\n      <span class=\"spacer16\"></span>\n      <button class=\"btn sw-btn-default\" ng-click=\"vm.restoreChart()\" uib-tooltip=\"Restore this version\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        Restore\n      </button>\n      <span class=\"spacer16\"></span>\n    </div>\n  </div>\n  <div>\n    <div id=\"sidebar-scenelist\" class=\"sw-sidebar sw-sidebar-left\" ng-class=\"{\'sw-sidebar-edit\': vm.sidebarEditState.enabled || !vm.deletedChartListMode, \'swa-disabled-fade clickthrough\': vm.chartInspectorState.layerEditorActive, \'sw-parent-chart-options\': !vm.deletedChartListMode || vm.restoringSingleChart}\" ng-hide=\"vm.chartEditorState.lockModeNavigation\">\n      <div class=\"sw-navbar sw-navbar-top sw-color-red\">\n        <div class=\"swtoolbar\" ng-hide=\"vm.sidebarEditState.destinationSelectVisible || vm.deletedChartListMode\">\n          <button id=\"button-closeproduction\" class=\"btn btn-lg sw-btn-toolbar\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n          <div class=\"text-lg sw-truncatetext\" style=\"width: calc(100% - 50px)\">\n            <span>{{vm.selectedProduction.name}}</span>\n          </div>\n        </div>\n        <div class=\"swtoolbar swa-color-white\" ng-show=\"vm.sidebarEditState.destinationSelectVisible\">\n          <button class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.sidebarEditState.destinationSelectVisible = false; vm.toggleSidebarEditModeForChart();\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n          <h4 class=\"text-lg sw-truncatetext\" ng-show=\"vm.sidebarEditState.destinationSelectForMove\" translate>\n            titles.Move to</h4>\n          <h4 class=\"text-lg sw-truncatetext\" ng-show=\"vm.sidebarEditState.destinationSelectForRestore\" translate>\n            titles.Restore to</h4>\n        </div>\n        <div class=\"swtoolbar swa-color-white\" ng-show=\"vm.deletedChartListMode && !vm.sidebarEditState.enabled\">\n          <button class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.leaveDeletedChartList()\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n          <h4 class=\"text-lg sw-truncatetext\" translate>\n            titles.Removed Charts</h4>\n        </div>\n      </div>\n      <div class=\"scrollcontainer\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\" ng-scrollbars-update=\"vm.scrollUpdateSidebar\">\n        <uib-accordion id=\"scene-accordion\" class=\"sidebar-scenecontents-list\" ng-class=\"{\'sidebar-scenecontents-pov-performer\': !vm.chartEditorState.povAudience}\" close-others=\"true\" ng-hide=\"vm.sidebarEditState.destinationSelectVisible || vm.deletedChartListMode\">\n          <div uib-accordion-group class=\"stickyheader\" is-open=\"false\" ng-show=\"vm.sceneSticky\">\n            <uib-accordion-heading>\n              <div class=\"sw-color-red\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleScene(vm.selectedScene);\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{vm.selectedScene.scenename}}</span>\n                </div>\n                <div class=\"pull-right\">\n                  <span class=\"sw-ionicon-fw ion-chevron-down\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n          </div>\n          <div uib-accordion-group id=\"scene-group-{{$index}}\" is-open=\"scene.open\" ng-repeat=\"scene in vm.scenes | limitTo: vm.activePlanRules.allowedNumberOfScenes\">\n            <uib-accordion-heading>\n              <div ng-class=\"{\'sw-color-red\': scene.open}\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleScene(scene);\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{scene.scenename}}</span>\n                </div>\n                <div class=\"chevron pull-right\">\n                  <span id=\"scene-accordion-{{$index}}\" class=\"sw-ionicon-fw\" ng-class=\"{\'ion-chevron-down\': scene.open, \'ion-chevron-right\': !scene.open}\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n            <div ng-cloak ng-model=\"scene.charts\" ui-sortable=\"vm.sidebarSortableOptions\">\n              <div id=\"chart-{{chart._id}}\" class=\"sidebar-chart-row sidebar-selction-state\" ng-class=\"{\'selected\': vm.selectedChartOrderingIndex === chart.orderingindex}\" ng-click=\"vm.sidebarSelectChartAtIndex($index, $event)\" ng-repeat=\"chart in scene.charts | limitTo: vm.activePlanRules.allowedNumberOfCharts track by chart._id\">\n                <div class=\"chart-item-block\">\n                  <div class=\"sidebar-chart-max-width\">\n                    <div class=\"chart-thumb\">\n                      <img class=\"chart-thumb-img\" ng-src=\"data:image/png;base64,{{chart.thumbimage || \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=\'}}\">\n                    </div>\n                    <div class=\"title text-center sw-truncatetext\">\n                      <span ng-if=\"vm.chartEditorState.chartNumberAutomatic\">{{\'labels.Chart\'| translate}}:\n                        {{scene.orderingindex + 1}}.{{chart.orderingindex + 1}}</span>\n                      <span ng-if=\"!vm.chartEditorState.chartNumberAutomatic\">\n                        <span ng-show=\"chart.customname && chart.customname.length > 0\">{{chart.customname}}</span>\n                        <span ng-show=\"!chart.customname || chart.customname.length === 0\" class=\"sw-color-gray\">&lt;unnamed&gt;</span>\n                      </span>\n                      <span ng-show=\"chart.dirty\">&bull;</span>\n                    </div>\n                    <div class=\"access-icon\" ng-show=\"!scene.accessRules.allowowneraccess || chart.syncCollision\">\n                      <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-person-stalker\': scene.accessRules.allowchartediting, \'ion-locked\':!scene.accessRules.allowchartediting, \'swa-color-accentred\': chart.syncCollision}\"></span>\n                    </div>\n                  </div>\n                  <div>\n                    <button id=\"sideBarDeleteAndMoveOptionsMenuButton\" class=\"btn btn-sm sw-btn-toolbar sw-chart-otions\" id=\"sidebar-scriptannotationlayersettings_{{$index}}\" ng-hide=\"vm.sidebarEditState.enabled || !(vm.selectedScene.accessRules.allowmovechartsource || vm.selectedScene.accessRules.allowdeletechart)\" ng-click=\"vm.showSideBarDeleteAndMoveOptions($event)\">\n                      <div>&#xFE19;</div>\n                    </button>\n                    <div class=\"sw-btn-toolbar sw-chart-otions sw-checkbox\" ng-show=\"vm.sidebarEditState.enabled && scene.accessRules.allowmovechartsource && !vm.movingSingleChart\">\n                      <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-ios-circle-outline\': !chart.editSelected, \'ion-ios-checkmark sw-color-red\': chart.editSelected}\" style=\"cursor: pointer\"></span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"sidebar-staff-row text-center\" ng-if=\"scene.noCharts\">\n              <em class=\"sidebar-hint-text\" translate>labels.No Charts</em>\n            </div>\n          </div>\n        </uib-accordion>\n        <div class=\"sidebar-destination-scene-list sidebar-destination-scene-list-parent\" ng-if=\"vm.sidebarEditState.destinationSelectVisible\">\n          <div class=\"message\" ng-show=\"vm.sidebarEditState.destinationSelectForMove\">\n            <p>Choose a position to move the selected charts.</p>\n          </div>\n          <div class=\"message\" ng-show=\"vm.sidebarEditState.destinationSelectForRestore\">\n            <p>Choose a position to restore the selected charts.</p>\n          </div>\n        </div>\n        <uib-accordion id=\"scene-accordion\" class=\"sidebar-scenecontents-list sidebar-destination-scene-list\" ng-if=\"vm.sidebarEditState.destinationSelectVisible\" ng-class=\"{\'sidebar-scenecontents-pov-performer\': !vm.chartEditorState.povAudience}\" close-others=\"true\">\n          <div uib-accordion-group class=\"stickyheader\" is-open=\"false\" ng-show=\"vm.sceneSticky\">\n            <uib-accordion-heading>\n              <div class=\"sw-color-red\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleScene(vm.selectedScene);\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{vm.selectedScene.scenename}}</span>\n                </div>\n                <div class=\"pull-right\">\n                  <span class=\"sw-ionicon-fw ion-chevron-down\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n          </div>\n          <div uib-accordion-group id=\"scene-group-{{$index}}\" is-open=\"scene.open\" ng-repeat=\"scene in vm.scenes | limitTo: vm.activePlanRules.allowedNumberOfScenes\">\n            <uib-accordion-heading>\n              <div class=\"main-dropdown\" ng-class=\"{\'sw-color-red\': scene.open}\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleScene(scene);\" ng-disabled=\"!(scene.accessRules.allowowneraccess || scene.accessRules.allowmovechartdestination) || (scene._id === vm.sourceSceneId)\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{scene.scenename}}</span>\n                </div>\n                <div class=\"chevron pull-right\" ng-hide=\"!(scene.accessRules.allowowneraccess || scene.accessRules.allowmovechartdestination) || (scene._id === vm.sourceSceneId)\">\n                  <span id=\"scene-accordion-{{$index}}\" class=\"sw-ionicon-fw\" ng-class=\"{\'ion-chevron-down\': scene.open, \'ion-chevron-right\': !scene.open}\"></span>\n                </div>\n                <div class=\"access-icon\" ng-hide=\"scene.accessRules.allowchartediting\">\n                  <span class=\"sw-ionicon-fw sw-ionicon-sm\" ng-class=\"{\'ion-locked\':!scene.accessRules.allowchartediting}\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n            <div class=\"sidebar-chart-row sw-color-mediumlightgray\" ng-style=\"{\'margin-bottom\': scene.noCharts ? \'0\' : \'4px\' }\" style=\"font-style: italic\" ng-click=\"vm.moveChartAtSpecificIndex = false; vm.sidebarEditSelectDestinationSceneAtIndex($index)\">\n              <div>\n                <span class=\"title\" ng-show=\"vm.sidebarEditState.destinationSelectForMove\" translate>labels.Move here</span>\n                <span class=\"title\" ng-show=\"vm.sidebarEditState.destinationSelectForRestore\" translate>labels.Restore here</span>\n              </div>\n            </div>\n            <div ng-cloak ng-model=\"scene.charts\">\n              <div id=\"chart-{{chart._id}}\" class=\"sidebar-chart-row\" ng-click=\"vm.moveChartAtSpecificIndex = true; vm.sidebarEditSelectDestinationSceneAtIndex($index)\" ng-repeat=\"chart in scene.charts | limitTo: vm.activePlanRules.allowedNumberOfCharts track by chart._id\">\n                <div class=\"scene-child\">\n                  <div class=\"title sw-truncatetext\">\n                    <span ng-if=\"vm.chartEditorState.chartNumberAutomatic\">{{\'labels.Chart\'| translate}}:\n                      {{scene.orderingindex + 1}}.{{chart.orderingindex + 1}}</span>\n                    <span ng-if=\"!vm.chartEditorState.chartNumberAutomatic\">\n                      <span ng-show=\"chart.customname && chart.customname.length > 0\">{{chart.customname}}</span>\n                      <span ng-show=\"!chart.customname || chart.customname.length === 0\" class=\"sw-color-gray\">&lt;unnamed&gt;</span>\n                    </span>\n                    <span ng-show=\"chart.dirty\">&bull;</span>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </uib-accordion>\n        <uib-accordion ng-hide=\"!vm.deletedChartListMode || vm.restoringSingleChart\" id=\"scene-accordion\" class=\"sidebar-scenecontents-list\" ng-class=\"{\'sidebar-scenecontents-pov-performer\': !vm.chartEditorState.povAudience}\" close-others=\"true\">\n          <div uib-accordion-group class=\"stickyheader\" is-open=\"false\" ng-show=\"vm.sceneSticky\">\n            <uib-accordion-heading>\n              <div class=\"sw-color-red\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleRemovedChartsScene(vm.selectedScene);\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{vm.selectedScene.scenename}}</span>\n                </div>\n                <div class=\"pull-right\">\n                  <span class=\"sw-ionicon-fw ion-chevron-down\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n          </div>\n          <div uib-accordion-group id=\"scene-group-{{scene.orderingindex}}\" is-open=\"scene.open\" ng-repeat=\"scene in vm.dummyScenesForRemovedCharts\">\n            <uib-accordion-heading>\n              <div ng-class=\"{\'sw-color-red\': scene.open}\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleRemovedChartsScene(scene)\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{scene.scenename}}</span>\n                </div>\n                <div class=\"chevron pull-right\">\n                  <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-chevron-down\': scene.open, \'ion-chevron-right\': !scene.open}\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n            <div>\n              <div id=\"chart-{{deletedChart._id}}\" class=\"sidebar-chart-row sidebar-selction-state\" ng-click=\"vm.sidebarSelectDeletedChartAtIndex($index)\" data-ng-repeat=\"deletedChart in scene.charts\" ng-class=\"{\'selected\': vm.selectedChartOrderingIndex === deletedChart.index}\">\n                <div class=\"chart-item-block\">\n                  <div>\n                    <div class=\"chart-thumb\">\n                      <img class=\"chart-thumb-img\" ng-src=\"data:image/png;base64,{{deletedChart.thumbimage || \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=\'}}\">\n                    </div>\n                    <div class=\"mt-1 mb-1 sw-truncatetext\">\n                      <span ng-if=\"vm.chartEditorState.chartNumberAutomatic && deletedChart.chartNumberBeforeDeleting\">Chart: {{deletedChart.chartNumberBeforeDeleting}}</span>\n                      <span ng-if=\"!vm.chartEditorState.chartNumberAutomatic\">\n                        <span ng-if=\"deletedChart.customChartNameBeforeDeleting\">{{deletedChart.customChartNameBeforeDeleting}}</span>\n                        <span ng-show=\"!deletedChart.customChartNameBeforeDeleting || deletedChart.customChartNameBeforeDeleting.length === 0\" class=\"sw-color-gray\">&lt;unnamed&gt;</span>\n                      </span>\n                    </div>\n                    <div class=\"mt-1 mb-1 sw-truncatetext\">\n                      <span ng-if=\"deletedChart.sceneNameBeforeDeleting\">Scene: {{deletedChart.sceneNameBeforeDeleting}}</span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"sidebar-staff-row text-center\" ng-if=\"(scene.charts.length === 0)\">\n              <em class=\"sidebar-hint-text\" translate>labels.No Charts</em>\n            </div>\n          </div>\n        </uib-accordion>\n      </div>\n      <div class=\"sw-navbar sw-navbar-bottom swtoolbar-flex-align-center swtoolbar-justify-center swtoolbar-flex\">\n        <button id=\"show-trash\" class=\"btn btn-md sw-btn-secondary\" ng-click=\"vm.enterDeletedChartList()\" ng-hide=\"vm.deletedChartListMode || vm.sidebarEditState.enabled\">\n          <span>{{\'titles.Removed Charts\'|translate}}</span>\n        </button>\n      </div>\n    </div>\n    <div>\n      <div class=\"sw-sidebar sw-sidebar-right sw-sidebar-performer-picker\" ng-show=\"vm.chartEditorState.chartOpen && vm.chartEditorState.mediaDrawerOpen\">\n        <div class=\"sw-navbar sw-navbar-top\">\n          <div class=\"swtoolbar\">\n            <div class=\"swtoolbar-group\">\n              <span class=\"text-lg swa-color-lightgray\" translate>titles.Media</span>\n            </div>\n            <div class=\"swtoolbar-group pull-right\">\n              <button class=\"btn btn-xs sw-btn-secondary\" ng-click=\"vm.showMediaEditPrompt()\" ng-show=\"vm.activeAccessRules.allowaddvideos && !vm.chartEditorState.lockModeNavigation\">\n                <span class=\"ion-plus-round\"></span>\n              </button>\n            </div>\n          </div>\n        </div>\n        <div class=\"scrollcontainer\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\" ng-scrollbars-update=\"vm.scrollUpdateSidebar\">\n          <div class=\"sw-medialist-picker-content\" ng-class=\"{\'editing\': !vm.mediaDockState.viewState}\">\n            <div class=\"sw-medialist-picker-row\" ng-click=\"vm.mediaDockState.viewState && vm.openMedia(aChartItemMedia)\" ng-repeat=\"aChartItemMedia in vm.selectedChartMediaItems | orderBy:\'orderingindex\'\">\n              <div class=\"accessory-block edit-block btn btn-xs sw-btn-toolbar\" ng-show=\"!vm.mediaDockState.viewState && vm.activeAccessRules.allowaddvideos && !vm.chartEditorState.lockModeNavigation\">\n                <span class=\"sw-ionicon sw-ionicon-lg ion-edit\" style=\"cursor: pointer\" ng-click=\"vm.showMediaEditPrompt(aChartItemMedia)\"></span>\n              </div>\n              <div class=\"title-block\">\n                <span class=\"title sw-truncatetext-wrap\">{{aChartItemMedia.mediadetails.title}}</span>\n                <span class=\"subtitle sw-truncatetext-wrap\">{{aChartItemMedia.mediadetails.url}}</span>\n              </div>\n              <div class=\"accessory-block delete-block btn btn-xs sw-btn-toolbar\" ng-show=\"!vm.mediaDockState.viewState && vm.activeAccessRules.allowaddvideos && !vm.chartEditorState.lockModeNavigation\">\n                <span class=\"sw-ionicon sw-ionicon-lg ion-ios-trash-outline\" style=\"cursor: pointer\" ng-click=\"vm.deleteMedia(aChartItemMedia)\"></span>\n              </div>\n            </div>\n          </div>\n          <div class=\"sw-popover-hint-item text-center\" ng-if=\"vm.selectedChartMediaItems.length === 0\">\n            <em translate>labels.No Media</em>\n          </div>\n        </div>\n        <div class=\"sw-navbar sw-navbar-bottom\" ng-show=\"vm.activeAccessRules.allowaddvideos && !vm.chartEditorState.lockModeNavigation && (!vm.mediaDockState.viewState || vm.selectedChartMediaItems.length)\">\n          <div class=\"swtoolbar text-center\">\n            <div class=\"swtoolbar-group\" ng-if=\"vm.mediaDockState.viewState\">\n              <button class=\"btn sw-btn-secondary\" ng-click=\"vm.toggleEditMediaState()\" translate>buttons.Edit</button>\n            </div>\n            <div class=\"swtoolbar-group\" ng-if=\"!vm.mediaDockState.viewState\">\n              <button class=\"btn sw-btn-default\" ng-click=\"vm.toggleEditMediaState()\" translate>buttons.Done</button>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"sw-sidebar sw-sidebar-right sw-sidebar-performer-picker\" ng-show=\"(vm.chartEditorState.chartOpen && vm.chartEditorState.dynLayerActive) && vm.activeAccessRules.allowaddperformers && vm.chartEditorState.performerPickerDockedOpen\">\n        <div class=\"sw-navbar sw-navbar-top\">\n          <div class=\"swtoolbar\">\n            <div class=\"swtoolbar-group\">\n              <span class=\"text-lg swa-color-lightgray\" translate>titles.Green Room</span>\n            </div>\n            <div class=\"swtoolbar-group pull-right\">\n              <button class=\"btn btn-xs sw-btn-secondary\" ng-click=\"vm.showPerformerPicker()\">\n                <span class=\"sw-ionicon-lg ion-arrow-right-b\"></span>\n              </button>\n            </div>\n            <div class=\"search search-for-dock-room search-bar-chart\">\n                <input class=\"form-control\" id=\"searchperformername\" name=\"searchperformername\" ng-model=\"vm.searchperformername\" ng-change=\"vm.searchStringChangedForPerformer()\" type=\"text\" placeholder=\"Search ...\">\n                <button class=\"btn btn-lg sw-btn-toolbar search-text-clear-btn search-text-clear-btn2-dock\" ng-click=\"vm.clearSearchForPerformer()\" ng-show=\"vm.searchperformername.length > 0\">\n                    <span class=\"sw-ionicon-lg ion-ios-close-outline\"></span>\n                </button>\n            </div>\n          </div>\n        </div>\n        <div class=\"scrollcontainer sw-dock-performer-picker\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\" ng-scrollbars-update=\"vm.scrollUpdateSidebar\">\n          <div class=\"sw-performer-picker-content margin-for-search-bar\">\n            <div class=\"sw-performer-picker-item\" ng-click=\"vm.performerPickerDidPickPerformer(aPerformer)\" ng-repeat=\"aPerformer in vm.performers | limitTo: vm.activePlanRules.allowedNumberOfPerformers | orderBy:\'orderingindex\' | filter: vm.performerSearchFilter | orderBy: \'oIndex\' as results\">\n              <img ng-src=\"data:image/png;base64,{{aPerformer.image}}\">\n              <div ng-class=\"{\'is-performer-on-chart\': aPerformer.isOnChart === true}\"></div>\n            </div>\n            <div class=\"sw-popover-hint-item text-center\" ng-if=\"vm.performers.length === 0\">\n              <em translate>labels.No Performers</em>\n            </div>\n            <div id=\"no-productions\" class=\"no-matching-info-text\" ng-hide=\"results.length !== 0 || vm.performers.length === 0\">\n              <span>No matching Performers!</span>\n            </div>\n          </div>\n        </div>\n        <div class=\"sw-navbar sw-navbar-bottom\">\n          <div class=\"track-reassignment-btn swtoolbar-flex\" ng-if=\"vm.activeCollaborationConfig.isProductionOwner\">\n            <button class=\"btn btn-md sw-btn-secondary\" ng-click=\"vm.performerTrackReassignmentPrompt()\" ng-disabled=\"vm.performers.length < 2\">\n              <span translate>buttons.Track Reassignment</span>\n            </button>\n            <button class=\"btn btn-md sw-btn-secondary\" ng-click=\"vm.undoReassignmentPrompt()\" ng-disabled=\"vm.performerPairsWithIdsForUndo === undefined\">\n              <span translate>buttons.Undo Last Reassignment</span>\n            </button>\n          </div>\n          <div class=\"performer-scaling-float scaling-dock\">\n            <label class=\"performer-scaling-float-heading\" translate>labels.Scale Performers</label>\n            <div id=\"chart-performer-scaling-mode\" class=\"btn-group btn-group-btn chart-performer-scaling-grp-btn\">\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.scalePerformers.allPerformers === false && vm.scalePerformers.selectedPerformers === false}\" ng-click=\"vm.updateScalePerformers(\'none\')\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.scalePerformers.allPerformers === false && vm.scalePerformers.selectedPerformers === false,\n                                  \'ion-android-radio-button-off\': vm.scalePerformers.allPerformers === true || vm.scalePerformers.selectedPerformers === true}\"></span>\n                {{\'buttons.None\'| translate}}\n              </button>\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.scalePerformers.allPerformers === true}\" ng-click=\"vm.updateScalePerformers(\'all\')\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.scalePerformers.allPerformers === true,\n                                  \'ion-android-radio-button-off\': vm.scalePerformers.allPerformers === false}\"></span>\n                {{\'buttons.All\'| translate}}\n              </button>\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.scalePerformers.selectedPerformers === true}\" ng-click=\"vm.updateScalePerformers(\'selected\')\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.scalePerformers.selectedPerformers === true,\n                                  \'ion-android-radio-button-off\': vm.scalePerformers.selectedPerformers === false}\"></span>\n                {{\'buttons.Selected\'| translate}}\n              </button>\n            </div>\n          </div>\n          <div class=\"swtoolbar text-center\">\n            <div class=\"swtoolbar-group pull-centre\">\n              <button class=\"btn sw-btn-secondary\" ng-click=\"vm.floatPerformerPicker()\" translate>\n                buttons.Float\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- -- -->\n    <div id=\"sideBarDeleteAndMoveOptionsMenu\" class=\"stackable-popover-conten\" ng-show=\"vm.chartSidebarDeleteAndMoveOptionState.visible === true\">\n      <div class=\"sw-chart-modal\" ng-style=\"{ top: vm.menuTop + \'px\', left: vm.menuLeft + \'px\'}\">\n        <div class=\"sw-popover-menu\" role=\"menu\">\n          <div class=\"menu-group\">\n            <span class=\"sw-ionicon-fw ion-arrow-down-b icon chart-left-arrow\"></span>\n            <div class=\"menu-item\">\n              <span class=\"title\" ng-click=\"vm.moveSingleChart(); vm.hideSideBarDeleteAndMoveOptions()\" translate>labels.Move</span>\n            </div>\n            <div class=\"menu-item\">\n              <span class=\"title\" ng-click=\"vm.deleteMultipleCharts = false; vm.deleteChartPrompt(); vm.hideSideBarDeleteAndMoveOptions()\" translate>labels.Delete</span>\n            </div>\n            <!-- <div class=\"menu-item\">\n              <span class=\"title\" ng-click=\"vm.hideSideBarDeleteAndMoveOptions()\" translate>labels.Done</span>\n            </div> -->\n\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- -- -->\n    <div class=\"stackable-popover-conten\" ng-show=\"vm.sidebarEditState.enabled && !vm.sidebarEditState.destinationSelectVisible && !vm.movingSingleChart && !vm.restoringSingleChart\">\n      <div class=\"sw-chart-modal\" ng-style=\"{ top: 100 + \'px\', left: 245 + \'px\'}\">\n        <div class=\"sw-popover-menu\" role=\"menu\">\n          <div class=\"menu-group\">\n            <span class=\"sw-ionicon-fw ion-arrow-down-b icon chart-left-arrow\"></span>\n            <div class=\"menu-item\" ng-disabled=\"vm.sidebarEditState.selectionCount < 1\">\n              <span class=\"title\" ng-click=\"vm.sidebarShowDestinationSceneListForMove()\" translate>\n                labels.Move selected</span>\n            </div>\n            <div class=\"menu-item\" ng-disabled=\"vm.sidebarEditState.selectionCount < 1\">\n              <span class=\"title\" ng-click=\"vm.deleteMultipleCharts = true; vm.deleteChartPrompt()\" translate>labels.Delete selected</span>\n            </div>\n            <!-- <div class=\"menu-item\">\n              <span class=\"title\" ng-click=\"vm.clearAllChartEditModeSelections()\" translate>\n                labels.Clear selections</span>\n            </div> -->\n            <div class=\"menu-item\">\n              <span class=\"title\" ng-show=\"!vm.sidebarEditState.destinationSelectVisible\" ng-click=\"vm.toggleSidebarEditMode()\" translate>labels.Done</span>\n              <span class=\"title\" ng-show=\"vm.sidebarEditState.destinationSelectVisible\" ng-click=\"vm.sidebarEditState.destinationSelectVisible = false\" translate>labels.Cancel</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- -- -->\n    <div class=\"sw-maincontentarea-chart sw-editorcontent\">\n      <div class=\"chartCanvasScrollContainer\" ng-show=\"vm.chartEditorState.chartOpen || vm.chartEditorState.ccInitializationPending || vm.chartEditorState.resizing\" block-ui=\"block-ui-chart\">\n        <div id=\"chartCanvasContainer\" class=\"chartCanvasContainer text-center\" ng-click=\"vm.hideSideBarDeleteAndMoveOptions()\">\n          <span class=\"swa-color-lightgraygray hide-when-blocked\" style=\"width: 100%;top: 50%;position: absolute;left: 0;transform: translateY(-50%)\">\n            {{\'messages.Chart not visible?\' | translate}}\n            <button class=\"btn sw-btn-secondary\" ng-click=\"vm.ccForceSizeUpdate()\"><span class=\"sw-ionicon-fw sw-ionicon-lg ion-refresh\"></span>{{\'buttons.Refresh\' | translate}}</button>\n          </span>\n          <canvas class=\"chartCanvas\" height=\"600\" id=\"chartCanvas\" width=\"1000\" ng-mousedown=\"vm.canvasContainerClickDown($event)\" ng-mouseup=\"vm.canvasContainerClick($event)\"></canvas>\n          <div id=\"contextMenu\" class=\"sw-context-menu-container\" class=\"sw-chart-inspector-container\" ng-hide=\"(!vm.chartContextMenuState.visible || vm.sidebarEditState.enabled || !vm.chartEditorState.chartOpen || vm.chartEditorState.lockModeNavigation || vm.chartVersionBrowserState.active || !vm.chartEditorState.layerActive)\" ng-style=\"{\'left\': vm.chartContextMenuState.posX + \'px\', \'top\': vm.chartContextMenuState.posY + \'px\'}\" sw-chart-context-menu state=\"vm.chartInspectorState\" data-active-collaboration-config=\"vm.activeCollaborationConfig\" preferences=\"vm.userProductionPreferences\" on-action=\"vm.onInspectorAction(action)\" data-drag=\"true\" jqyoui-draggable=\"{onStop: \'vm.onContextMenuDragStop()\'}\" oncontextmenu=\"event.preventDefault()\">\n          </div>\n          <div state=\"vm.chartInspectorState\" ng-show=\"vm.chartInspectorState.textEditorActive\" ng-style=\"{\n              \'position\': \'absolute\',\n              \'left\': (vm.chartTextEditorState.editorPosX - (vm.chartTextEditorState.editorWidth / 2)) + \'px\',\n              \'top\': (vm.chartTextEditorState.editorPosY - (vm.chartTextEditorState.editorHeight / 2)) + \'px\',\n              \'width\': vm.chartTextEditorState.editorWidth + \'px\',\n              \'height\': vm.chartTextEditorState.editorHeight + \'px\',\n              \'transform\': \'rotate(\' + vm.chartTextEditorState.rotationAngle + \'deg) scale(\' + vm.chartTextEditorState.editorScale + \')\'\n            }\" id=\"mce-editor-inspector-text\" class=\"chartfloating-texteditor-textarea\">\n          </div>\n        <div ng-if=\"false\" class=\"chartPanVScrollContainer\" ng-style=\"{\'margin-left\': vm.chartPanScrollParams.vertical.marginLeft + \'px\', \'margin-top\': vm.chartPanScrollParams.vertical.containerTopOffset + \'px\', height: vm.chartPanScrollParams.vertical.containerHeight + \'px\'}\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigChartPanV\" ng-scrollbars-update=\"vm.chartPanVScrollbarsCallUpdate\">\n          <div class=\"chartPanVScrollContent\" ng-style=\"{height: vm.chartPanScrollParams.vertical.contentHeight + \'px\'}\"></div>\n        </div>\n        <div ng-if=\"false\" class=\"chartPanHScrollContainer\" ng-style=\"{\'margin-left\': vm.chartPanScrollParams.horizontal.containerLeftOffset + \'px\', \'margin-top\': vm.chartPanScrollParams.horizontal.marginTop + \'px\', width: vm.chartPanScrollParams.horizontal.containerWidth + \'px\'}\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigChartPanH\" ng-scrollbars-update=\"vm.chartPanHScrollbarsCallUpdate\">\n          <div class=\"chartPanHScrollContent\" ng-style=\"{width: vm.chartPanScrollParams.horizontal.contentWidth + \'px\'}\"></div>\n        </div>\n      </div>\n      <div class=\"text-center sw-color-lightgray\" ng-hide=\"vm.chartEditorState.chartOpen\" style=\"top: 50%; transform: translateY(-50%); position:relative\">\n        <div style=\"margin-bottom: 16px\">\n          <span class=\"sw-text-xlg\" translate>titles.Charts View</span>\n        </div>\n        <div class=\"show-when-blocked\">\n          <span>Loading ...</span>\n        </div>\n        <div class=\"hide-when-blocked\">\n          <div ng-show=\"vm.scenes && (vm.scenes.length === 0) && !vm.deletedChartListMode\">\n            <span class=\"sw-text-lg\" translate>messages.No Scenes in this Production</span><br>\n          </div>\n          <span ng-show=\"(vm.scenes.length !== 0) && !vm.sidebarEditState.enabled && (vm.selectedSceneId === undefined) && !vm.deletedChartListMode\" translate>labels.No Scene</span>\n          <span ng-show=\"vm.deletedChartListMode\" translate>labels.Select a chart to preview</span>\n          <span ng-if=\"!vm.deletedChartListMode\" ng-show=\"(!vm.sidebarEditState.enabled && (vm.selectedSceneId !== undefined) && vm.selectedScene.noCharts)\" translate>labels.No Charts in Scene</span>\n          <span ng-show=\"vm.sidebarEditState.enabled\" translate>labels.Edit Mode</span>\n        </div>\n      </div>\n    </div>\n    <div class=\"sw-chart-footer-container\" ng-show=\"(!vm.sidebarEditState.enabled || (vm.sidebarEditState.enabled && vm.restoringSingleChart))\" sw-chart-footer data-production=\"vm.selectedProduction\" data-scene=\"vm.selectedScene\" data-chart=\"vm.selectedChart\" data-start-auto-save-timer=\"vm.startAutoSaveTimer()\" data-chart-editor-state=\"vm.chartEditorState\" data-active-access-rules=\"vm.activeAccessRules\" data-kill-auto-save-timer=\"vm.killAutoSaveTimer()\" data-x-read-only=\"vm.chartEditorState.lockModeNavigation || vm.chartVersionBrowserState.active\" data-deleted-chart-list-mode=\"vm.deletedChartListMode\" data-chart-version-browser-state=\"vm.chartVersionBrowserState\" data-access=\"(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowchartediting) && !(vm.chartEditorState.lockModeNavigation || vm.chartVersionBrowserState.active)\">\n    </div>\n    <div class=\"sw-chart-inspector-container\" ng-hide=\"!(vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.textEditorActive)\" sw-chart-inspector state=\"vm.chartInspectorState\" preferences=\"vm.userProductionPreferences\" on-action=\"vm.onInspectorAction(action)\"></div>\n  </div>\n</div>\n</div>");
$templateCache.put("app/components/chartEditor/chartEditorLink.html","");
$templateCache.put("app/components/chartEditor/chartFooter.html","<div class=\"sw-chart-footer\" style=\"display: flex; justify-content: center\">\n  <div class=\"col-sm-4 col-md-4 col-lg-4\" ng-class=\"{\'col-sm-2 col-md-2 col-lg-2\': vm.chartEditorState.lockModeNavigation && ((vm.chart.notesvisible || vm.production.chartsettings.chartnotesvisible) && (vm.scene.open && !vm.scene.noCharts)), \'col-sm-4 col-md-4 col-lg-4\': !vm.chartEditorState.lockModeNavigation || !((vm.chart.notesvisible || vm.production.chartsettings.chartnotesvisible) && (vm.scene.open && !vm.scene.noCharts)) }\" ng-show=\"!((vm.chart.notesvisible || vm.production.chartsettings.chartnotesvisible)) || vm.chartEditorState.lockModeNavigation\">\n    <div class=\"scene-block swa-color-lightgray\">\n      <span ng-hide=\"vm.scene || vm.restoringSingleChart || vm.deletedChartListMode\" translate>labels.Scene: None</span>\n      <span ng-show=\"vm.scene && !vm.deletedChartListMode\">{{vm.scene.scenename}}</span>\n      <span ng-show=\"vm.chart && vm.chart.sceneNameBeforeDeleting && vm.deletedChartListMode\">{{vm.chart.sceneNameBeforeDeleting}}</span>\n    </div>\n  </div>\n  <div class=\"col-sm-4 col-md-4 col-lg-4\" ng-show=\"!((vm.chart.notesvisible || vm.production.chartsettings.chartnotesvisible))\">\n    <div class=\"text-center production-block swa-color-lightgray\">\n      <img class=\"img-responsive center-block\" ng-show=\"vm.production.logo\" ng-src=\"data:image/png;base64,{{vm.production.logo}}\">\n      <span ng-hide=\"vm.production.logo\">{{vm.production.name}}</span>\n    </div>\n  </div>\n  <div class=\"chartNotesView-container2 col-sm-8 col-md-8 col-lg-8\" ng-class=\"{\'col-sm-8 col-md-8 col-lg-8\': !vm.chartEditorState.lockModeNavigation && ((vm.chart.notesvisible || vm.production.chartsettings.chartnotesvisible) && (vm.scene.open && !vm.scene.noCharts)),\'col-sm-6 col-md-6 col-lg-6\': vm.chartEditorState.lockModeNavigation}\" ng-show=\"((vm.chart.notesvisible || vm.production.chartsettings.chartnotesvisible)) && vm.chart\">\n    <div class=\"chartNotesView-textcontainer row\">\n      <div id=\"mce-editor-chart-notes-text\" class=\"notes\"></div>\n      <div class=\"notes notes-overlay\" ng-click=\"vm.activateNotesEditor($event);vm.killAutoSaveTimer()\" ng-hide=\"vm.chartEditorState.notesEditorActive\"></div>\n      </div>\n      <div class=\"swa-note-icon\" ng-hide=\"vm.deletedChartListMode\">\n        <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-person-stalker\': vm.scene.accessRules.allowchartediting, \'ion-locked\':!vm.scene.accessRules.allowchartediting}\" ng-show=\"!vm.scene.accessRules.allowowneraccess\"></span>\n      </div>\n  </div>\n  <div class=\"col-sm-4 col-md-4 col-lg-4\" style=\"text-align: center; position: static\">\n    <div class=\"chart-block swa-color-lightgray\">\n      <div class=\"chart-linetext-block\">\n        <textarea class=\"form-control chart-linetext\" ng-show=\"vm.chart\" ng-disabled=\"!vm.access || vm.chartEditorState.lockModeNavigation\" placeholder=\"{{\'labels.Cue line\' | translate}}\" style=\"display: block\" ng-keydown=\"vm.killAutoSaveTimer()\" ng-model=\"vm.chart.cuelinetext\" swa-change-onblur=\"vm.chart.dirty = true; vm.startAutoSaveTimer();\"></textarea>\n      </div>\n      <div class=\"chart-number\">\n        <span translate>labels.Chart</span>:\n        <div class=\"chart-number-value sw-form-container\">\n          <span ng-hide=\"vm.chart\" translate>labels.None</span>\n          <span ng-show=\"vm.production.chartsettings.chartnumberautomatic && vm.chart && !vm.deletedChartListMode\">{{vm.scene.orderingindex + 1}}.{{vm.chart.orderingindex + 1}}</span>\n          <span ng-show=\"vm.production.chartsettings.chartnumberautomatic && vm.chart.chartNumberBeforeDeleting && vm.deletedChartListMode\">{{vm.chart.chartNumberBeforeDeleting}}</span>\n          <input class=\"form-control\" ng-show=\"!vm.production.chartsettings.chartnumberautomatic && vm.chart\" ng-model=\"vm.chart.customname\" ng-disabled=\"!vm.access\" swa-change-onblur=\"vm.chart.dirty = true;\">\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/chartEditor/chartInspector.html","<div class=\"sw-chart-inspector\">\n  <!-- <div class=\"chart-inspector-group inspector-angle-container\" ng-hide=\"vm.state.layerEditorActive\">\n    <div class=\"sw-chart-inspector-row\">\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(-90)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">-90</button>\n      <button class=\"btn btn-sm sw-btn-inspector-label\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\" translate>labels.Angle</button>\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(90)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">+90</button>\n    </div>\n    <div class=\"sw-chart-inspector-row\">\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(-10)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">-10</button>\n      <button class=\"btn btn-sm sw-btn-inspector-label\" ng-hide=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">{{vm.state.rotationDeg}}&deg;</button>\n      <button class=\"btn btn-sm sw-btn-inspector-label\" ng-show=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\" ng-disabled=\"true\">---</button>\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(10)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">+10</button>\n    </div>\n    <div class=\"sw-chart-inspector-row\">\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(-1)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">-1</button>\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.resetRotation()\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">0</button>\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateBy(1)\" ng-disabled=\"(vm.state.selectionCount !== 1) && !vm.state.selectionGrouped\">+1</button>\n    </div>\n  </div> -->\n  <!-- <div class=\"chart-inspector-group inspector-headangle-container\" ng-show=\"vm.state.headRotateable && (vm.state.selectionCount === 1) && !vm.state.selectionGrouped\">\n    <div class=\"sw-chart-inspector-row\">\n      <button class=\"btn btn-sm sw-btn-inspector-label\" style=\"width: 100%\" translate>labels.Body Direction</button>\n    </div>\n    <div class=\"sw-chart-inspector-row\">\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateHeadBy(-10)\">L+10</button>\n      <button class=\"btn btn-sm sw-btn-inspector-label\">{{vm.headRotationDisplay}}</button>\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateHeadBy(10)\">R+10</button>\n    </div>\n    <div class=\"sw-chart-inspector-row\">\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateHeadBy(-1)\">L+1</button>\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.resetHeadRotation()\">0</button>\n      <button class=\"btn btn-sm sw-btn-inspector\" ng-click=\"vm.rotateHeadBy(1)\">R+1</button>\n    </div>\n  </div> -->\n  <!-- <div class=\"chart-inspector-group inspector-layer-container\" ng-hide=\"vm.state.layerEditorActive\">\n    <div class=\"inspector-layer-buttons\">\n      <div class=\"sw-chart-inspector-row\">\n        <button class=\"btn sw-btn-inspector\" ng-click=\"vm.layerAction(\'top\')\" translate>buttons.Top</button>\n        <button class=\"btn sw-btn-inspector\" ng-click=\"vm.layerAction(\'bottom\')\" translate>buttons.Btm</button>\n      </div>\n      <div class=\"text-center\">\n        <span class=\"inspector-layer-label\">{{\'labels.Layer\' | translate}}: {{vm.state.zIndex}}</span>\n      </div>\n      <div class=\"sw-chart-inspector-row\">\n        <button class=\"btn sw-btn-inspector\" ng-click=\"vm.layerAction(\'up\')\" translate>buttons.Up</button>\n        <button class=\"btn sw-btn-inspector\" ng-click=\"vm.layerAction(\'down\')\" translate>buttons.Dn</button>\n      </div>\n    </div>\n    <button class=\"inspector-layer-done-button btn sw-btn-inspector\" ng-click=\"vm.layerAction(\'end\')\"><span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-checkmark-round\"></span></button>\n    <button class=\"inspector-layer-overlay-button btn sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount === 1)\" ng-hide=\"(vm.state.selectionCount === 1) && vm.state.selectionOrderingMode\" ng-click=\"vm.layerAction(\'begin\')\" >{{\'buttons.Layer\' | translate}} <span ng-show=\"vm.state.selectionCount === 1\">{{vm.state.zIndex}}</span><span ng-hide=\"vm.state.selectionCount === 1\">--</span></button>\n  </div> -->\n  <div class=\"chart-inspector-group inspector-vectoreditor-container\" ng-show=\"vm.state.vectorEditorActive\">\n    <div class=\"sw-chart-inspector-row sw-chart-inspector-row-title\">\n      <span class=\"sw-color-lightgray sw-text-lg\">Shape Editor</span>\n    </div>\n    <div class=\"inspector-selection-actions sw-chart-inspector-row\">\n      <div>\n        <ul>\n          <li translate>messages.Click and drag points to change the shape</li>\n          <li translate>messages.Ctrl + click to add a new point</li>\n        </ul>\n      </div>\n      <div style=\"margin-top: 2px\">\n        <div style=\"height: 34px; margin-top: 2px\">\n          <button class=\"btn btn-sm sw-btn-inspector pull-right\" ng-disabled=\"!(vm.state.vectorEditorNodeSelected)\" ng-click=\"vm.vectorEditorDeleteNodeAction()\" translate>buttons.Delete Point</button>\n        </div>\n        <div style=\"height: 34px\">\n          <button class=\"btn btn-sm sw-btn-inspector sw-btn-min-w-80 pull-right\" ng-click=\"vm.vectorEditorDoneAction()\" translate>buttons.Save</button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"chart-inspector-group inspector-freehandtool-container\" ng-show=\"vm.state.freehandToolActive\">\n    <div class=\"sw-chart-inspector-row sw-chart-inspector-row-title\">\n      <span class=\"sw-color-lightgray sw-text-lg\">Freehand Shape Tool</span>\n      <button class=\"btn btn-sm sw-btn-toolbar\" ng-click=\"vm.freehandToolCloseAction()\">\n        <span class=\"sw-ionicon sw-ionicon-lg ion-close-round\"></span>\n      </button>\n    </div>\n    <div class=\"inspector-selection-actions sw-chart-inspector-row\">\n      <div>\n        <span class=\"hint\" translate>messages.inspectorfeehandtoolhint</span>\n      </div>\n      <div style=\"margin-left: 16px\">\n        <div style=\"height: 34px; margin-top: 2px; width: 216px\">\n          <span style=\"display: inline-block\">Arrowhead</span>\n          <switch class=\"swa-switch swa-switch-small\" ng-model=\"vm.state.freehandHasArrowhead\" ng-change=\"vm.freehandHasArrowheadChange()\" on=\"YES\" off=\"NO\"></switch>\n          <button class=\"btn btn-sm sw-btn-inspector pull-right\" ng-click=\"vm.freehandToolClearAction()\" translate>buttons.Clear</button>\n        </div>\n        <div style=\"height: 34px\">\n          <button class=\"btn btn-sm sw-btn-inspector sw-btn-min-w-80 pull-right\" ng-click=\"vm.freehandToolSaveAction()\" translate>buttons.Save</button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"chart-inspector-group inspector-color-container\" ng-show=\"vm.state.freehandToolActive || vm.state.vectorEditorActive\">\n    <div class=\"sw-chart-inspector-row\" ng-class=\"{\'swa-disabled-fade clickthrough\': !(((vm.state.selectionCount === 1) && vm.state.selectionColorable) || vm.state.freehandToolActive)}\">\n      <span class=\"btn sw-btn-inspector-label\" translate>labels.Border</span><span class=\"color-picker-holder\"><spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.state.selectionColor\" options=\"vm.colorPickerOption\" on-hide=\"vm.borderColorChanged(color)\"></spectrum-colorpicker></span>\n    </div>\n    <div class=\"sw-chart-inspector-row\" ng-class=\"{\'swa-disabled-fade clickthrough\': !((vm.state.selectionCount === 1) && vm.state.selectionFillColorable)}\">\n      <span class=\"btn sw-btn-inspector-label\" translate>labels.Fill</span><span class=\"color-picker-holder\"><spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.state.selectionFillColor\" options=\"vm.colorPickerOption\" on-hide=\"vm.fillColorChanged(color)\"></spectrum-colorpicker></span>\n    </div>\n  </div>\n  <div ng-if=\"vm.state.vectorEditorActive\" class=\"sw-plus-minus-reset\">\n    <div class=\"preferences\">\n      <div>Line Thickness</div>\n      <div class=\"sub-settings left clickable\" ng-click=\"vm.decreaseLineThickness()\">\n        <span class=\"sub-settings-icon left selector sw-ionicon ion-minus sw-ionicon-bold\"></span>\n      </div>\n      <div class=\"font-setting sub-settings left\">\n        <span class=\"sub-settings-text left\">{{vm.state.lineThickness}}</span>\n      </div>\n      <div class=\"sub-settings left clickable\" ng-click=\"vm.increaseLineThickness()\">\n        <span class=\"sub-settings-icon left selector swafont swafont-lg swafont-icon-plus sw-ionicon-bold\"></span>\n      </div>\n      </div>\n        <div class=\"preferences reset-btn\">\n          <div class=\"sub-settings left clickable\" ng-click=\"vm.resetLineThickness()\">\n            <span>Reset</span>\n          </div>\n      </div>\n  </div>\n  <div ng-if=\"vm.state.freehandToolActive\" class=\"sw-plus-minus-reset\">\n    <div class=\"preferences\">\n      <div>Line Thickness</div>\n      <div class=\"sub-settings left clickable\" ng-click=\"vm.decreaseLineThicknessForFreehand()\">\n        <span class=\"sub-settings-icon left selector sw-ionicon ion-minus sw-ionicon-bold\"></span>\n      </div>\n      <div class=\"font-setting sub-settings left\">\n        <span class=\"sub-settings-text left\">{{vm.state.showLineThicknessForFreehand}}</span>\n      </div>\n      <div class=\"sub-settings left clickable\" ng-click=\"vm.increaseLineThicknessForFreehand()\">\n        <span class=\"sub-settings-icon left selector swafont swafont-lg swafont-icon-plus sw-ionicon-bold\"></span>\n      </div>\n      </div>\n        <div class=\"preferences reset-btn\">\n          <div class=\"sub-settings left clickable\" ng-click=\"vm.resetLineThicknessForFreehand()\">\n            <span>Reset</span>\n          </div>\n      </div>\n  </div>\n  <!-- <div class=\"chart-inspector-group inspector-action-container\" ng-hide=\"vm.state.layerEditorActive\">\n    <div class=\"inspector-clipboard-actions sw-chart-inspector-row\">\n      <button class=\"btn sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount > 0)\" ng-click=\"vm.clipboardAction(\'cut\')\" translate>buttons.Cut</button>\n      <button class=\"btn sw-btn-inspector\" ng-disabled=\"!(vm.state.selectionCount > 0)\" ng-click=\"vm.clipboardAction(\'copy\')\" translate>buttons.Copy</button>\n      <button class=\"btn sw-btn-inspector\" ng-disabled=\"!vm.state.canPaste\" ng-click=\"vm.clipboardAction(\'paste\')\" translate>buttons.Paste</button>\n    </div>\n    <div class=\"inspector-selection-actions sw-chart-inspector-row\">\n      <button class=\"btn sw-btn-inspector\" ng-hide=\"vm.state.selectionGrouped\" ng-disabled=\"!((vm.state.selectionCount > 1) || vm.state.selectionGrouped)\" ng-click=\"vm.groupToggleAction()\" translate>buttons.Group</button>\n      <button class=\"btn sw-btn-inspector\" ng-show=\"vm.state.selectionGrouped\" ng-click=\"vm.groupToggleAction()\" translate>buttons.Ungroup</button>\n      <button class=\"btn sw-btn-inspector\" ng-click=\"vm.editAction()\" ng-disabled=\"!((vm.state.selectionCount === 1) && vm.state.selectionEditable)\" translate>buttons.Edit</button>\n      <button class=\"btn sw-btn-inspector\" ng-click=\"vm.deleteAction()\" ng-disabled=\"vm.state.selectionCount === 0\" translate>buttons.Delete</button>\n      <button class=\"btn sw-btn-inspector\" ng-click=\"vm.clearAction()\" ng-disabled=\"!((vm.state.selectionCount > 0) || vm.state.canPaste)\" translate>buttons.Clear</button>\n    </div>\n  </div> -->\n  <!-- <div class=\"chart-inspector-group inspector-color-container\" ng-show=\"vm.state.textEditorActive\">\n    <div class=\"sw-chart-inspector-row\">\n      <span class=\"btn sw-btn-inspector-label\" translate>labels.Background</span><span class=\"color-picker-holder\"><spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.state.selectionBackgroundColor\" options=\"vm.colorPickerOption\" on-hide=\"vm.backgroundColorChanged(color)\"></spectrum-colorpicker></span>\n    </div>\n  </div> -->\n  <!-- <div class=\"chart-inspector-group inspector-texteditor-textarea-container\" ng-show=\"vm.state.textEditorActive\">\n    <div class=\"sw-chart-inspector-row\">\n      <div id=\"mce-editor-inspector-text\" class=\"inspector-texteditor-textarea\"></div>\n    </div>\n  </div> -->\n  <!-- <div class=\"chart-inspector-group inspector-texteditor-actions-container\" ng-show=\"vm.state.textEditorActive\">\n    <div class=\"sw-chart-inspector-row\">\n      <button class=\"btn sw-btn-inspector\" ng-click=\"vm.textEditorDoneAction()\" translate>buttons.Done</button>\n    </div>\n  </div> -->\n</div>\n");
$templateCache.put("app/components/chartEditor/deleteChartPrompt.html","<div class=\"modal-header\" style=\"text-align: center\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Confirm\'|translate}}\n    </span>\n    <!-- <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span> -->\n</div>\n<div class=\"modal-body\">\n    <strong>{{\'messages.Delete selected chart\' | translate}}</strong>\n    <p></p>\n    <p>{{\'messages.Hint for deleted chart validity\' | translate}}</p>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"text-center\">\n        <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n        <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n    </div>\n</div>");
$templateCache.put("app/components/chartEditor/deleteMoveOptionHintPrompt.html","<div class=\"modal-header\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Actions Moved\'|translate}}\n    </span>\n  </div>\n  <div class=\"modal-body\">\n      <p class=\"text-center\">{{\'messages.Delete move option hint\'|translate}}\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"text-center\">\n      <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionOk()\" translate>buttons.Ok</button>\n    </div>\n  </div>\n  ");
$templateCache.put("app/components/chartEditor/editMediaPrompt.html","<form class=\"form-horizontal sw-form\" name=\"formMediaDetails\" novalidate=\"\" role=\"form\" ng-submit=\"formMediaDetails.$valid && vm.submit(formMediaDetails)\">\n  <div class=\"modal-header\">\n    <span class=\"modal-title\" ng-hide=\"vm.updateMode\">Add Media</span>\n    <span class=\"modal-title\" ng-show=\"vm.updateMode\">Update Media</span>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\" for=\"mediaTitle\">\n        {{\'labels.Title\' | translate}}\n      </label>\n      <div class=\"col-sm-9\">\n        <input class=\"form-control\" id=\"mediaTitle\" name=\"mediaTitle\" ng-model=\"vm.mediaDetails.title\" required=\"\" type=\"text\">\n        <div ng-show=\"formMediaDetails.$submitted || formMediaDetails.mediaTitle.$touched\">\n          <p class=\"sw-color-red\" ng-show=\"formMediaDetails.mediaTitle.$error.required\" translate>validationmessages.Please enter a Title</p>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-3 control-label\" for=\"mediaUrl\">\n        {{\'labels.URL\' | translate}}\n      </label>\n      <div class=\"col-sm-9\">\n        <input class=\"form-control\" id=\"mediaUrl\" name=\"mediaUrl\" ng-model=\"vm.mediaDetails.url\" required=\"\" type=\"text\">\n        <div ng-show=\"formMediaDetails.$submitted || formMediaDetails.mediaUrl.$touched\">\n          <p class=\"sw-color-red\" ng-show=\"formMediaDetails.mediaUrl.$error.required\" translate>validationmessages.Please enter a valid URL</p>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"text-right\">\n      <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-hide=\"vm.updateMode\" style=\"margin-right: 10px\" translate type=\"submit\">buttons.Add</button>\n      <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-show=\"vm.updateMode\" style=\"margin-right: 10px\" translate type=\"submit\">buttons.Update</button>\n      <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-mousedown=\"vm.cancel()\" translate>buttons.Cancel</button>\n    </div>\n  </div>\n</form>");
$templateCache.put("app/components/chartEditor/pasteFilteredClipboardPrompt.html","  <div class=\"modal-header\">\n    <span class=\"modal-title text-danger text-center\" translate>titles.Paste Warning</span>\n  </div>\n  <div class=\"modal-body\">\n    <p class=\"text-center\">{{\'messages.paste_filteredclipboard_prompt\'|translate}}<br>\n      <strong><br>{{\'messages.Paste other items?\' | translate}}</strong>\n  </p>\n</div>\n<div class=\"modal-footer text-center\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/chartEditor/pdfPrintOptionPrompt.html","<div class=\"modal-header\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Printing Options\'|translate}}\n    </span>\n</div>\n<div class=\"modal-body form-horizontal\">\n    <div class=\"form-group\" ng-hide=\"vm.printOptionsParams.type === \'script\'\">\n        <div class=\"col-lg-8 col-md-8 text-left\">\n            <label class=\"control-label swa-color-lightgray\">\n                Print chart notes\n            </label>\n        </div>\n        <div class=\"col-lg-4 col-md-4 align-print-options-center\">\n            <div class=\"btn-group btn-group-btn\">\n                <switch class=\"swa-switch\" ng-model=\"vm.printOptionsParams.chartNotes\" on=\"YES\" off=\"NO\">\n                </switch>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group\" ng-show=\"vm.printOptionsParams.type === \'script\'|| vm.printOptionsParams.type === \'allchartsscript\'\">\n        <div class=\"col-lg-8 col-md-8 text-left\">\n            <label class=\"control-label swa-color-lightgray\">\n                Print chart-script links\n            </label>\n        </div>\n        <div class=\"col-lg-4 col-md-4 align-print-options-center\">\n            <div class=\"btn-group btn-group-btn\">\n                <switch class=\"swa-switch\" ng-model=\"vm.printOptionsParams.chartLinks\" on=\"YES\" off=\"NO\">\n                </switch>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group\" ng-hide=\"vm.printOptionsParams.type === \'script\'\">\n        <div class=\"col-lg-8 col-md-8 text-left\">\n            <label class=\"control-label swa-color-lightgray\">\n                Print ALL Performer Icons with Scale Adjustment\n            </label>\n        </div>\n        <div class=\"col-lg-4 col-md-4 align-print-options-center\">\n            <div class=\"btn-group btn-group-btn\">\n                <switch class=\"swa-switch\" ng-model=\"vm.printOptionsParams.scaleAllPerformers\" on=\"YES\" off=\"NO\">\n                </switch>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group\" ng-hide=\"vm.printOptionsParams.type === \'script\'\">\n        <div class=\"col-lg-8 col-md-8 text-left\">\n            <label class=\"control-label swa-color-lightgray\">\n                Print SELECTED Performer Icons with Scale Adjustment\n            </label>\n        </div>\n        <div class=\"col-lg-4 col-md-4 align-print-options-center\">\n            <div class=\"btn-group btn-group-btn\">\n                <switch class=\"swa-switch\" ng-model=\"vm.printOptionsParams.scaleSelectedPerformers\" on=\"YES\" off=\"NO\">\n                </switch>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group\" ng-show=\"(vm.printOptionsParams.type === \'script\'|| vm.printOptionsParams.type === \'allchartsscript\') && vm.printOptionsParams.permissionToPrintSharedLayers\">\n        <div class=\"col-lg-8 col-md-8 text-left\">\n            <label class=\"control-label swa-color-lightgray\">\n                Print shared layers\n            </label>\n        </div>\n        <div class=\"col-lg-4 col-md-4 align-print-options-center\">\n            <div class=\"btn-group btn-group-btn\">\n                <switch class=\"swa-switch\" ng-model=\"vm.printOptionsParams.sharedLayerAnnotations\" on=\"YES\" off=\"NO\">\n                </switch>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"text-center\">\n        <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Print PDF</button>\n        <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.Cancel</button>\n    </div>\n</div>");
$templateCache.put("app/components/chartEditor/performerTrackReassignmentPrompt.html","<div class=\"modal-header text-center\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Track Reassignment\'|translate}}\n    </span>\n</div>\n<div class=\"modal-body swtoolbar-flex track-reassignment\">\n    <div class=\"reassignment\">\n        <div class=\"header swtoolbar-flex\"> \n            <div>\n                <h4>Reassignment</h4>\n                <p>    \n                    <br><br></p>\n            </div>\n            <button ng-hide=\"vm.reassignmentState.selectTargetSceneOrCharts || vm.deleteOrReorderState.enabled\" ng-click=\"vm.enableDeleteOrReorderState()\" class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-disabled=\"vm.performersPairsForSwapping.length === 0\" translate>buttons.Delete / Reorder</button>\n            <button ng-if=\"vm.deleteOrReorderState.enabled\" ng-click=\"vm.disableDeleteOrReorderState()\" class=\"btn sw-btn-secondary sw-btn-min-w-80\" translate>buttons.Done</button>\n        </div>\n        <div class=\"scrollcontainer reassignment-pair-list-scroll\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\">\n            <ul class=\"track-reassignment-body\" ng-cloak ng-model=\"vm.performersPairsForSwapping\" ui-sortable=\"vm.pairSortableOptions\" ng-hide=\"vm.performersPairsForSwapping.length === 0 && vm.reassignmentState.selectTargetSceneOrCharts\">\n                <li ng-if=\"vm.performersPairsForSwapping.length > 0\" class=\"swtoolbar-flex swtoolbar-flex-align-center\" ng-repeat=\"pair in vm.performersPairsForSwapping\">\n                    <div class=\"list swtoolbar-flex swtoolbar-flex-align-center\">\n                        <span ng-if=\"vm.deleteOrReorderState.enabled\" class=\"swafont swafont-lg swafont-icon-trash-2 clickable sw-color-red\" ng-click=\"vm.deletePerformerPair($index)\"></span>\n                        <div>\n                        <p class=\"replace-text\" ng-class=\"{\'active\': pair.performerToBeChangedWith}\">REPLACE</p>\n                        <div class=\"swtoolbar-flex\">\n                        <div data-drop=\"true\" id=\"toBe-{{$index}}\" jqyoui-droppable=\"{multiple: false,  onDrop: \'vm.onDropTarget()\'}\" ng-class=\"{\'plus-icon\': !pair.performerToBeChanged, \'border-red\': vm.performerDropTargetTracker}\" class=\"img-box\">\n                            <span ng-if=\"!pair.performerToBeChanged\" class=\"swafont swafont-lg swafont-icon-plus\"></span>\n                            <img ng-if=\"pair.performerToBeChanged\" class=\"sws-logo sws-logo-link\" src=\"data:image/png;base64,{{pair.performerToBeChanged.image}}\">\n                        </div>\n                        <div class=\"text-center replace-arrow\" ng-class=\"{\'active\': pair.performerToBeChangedWith}\">\n                            <p>WITH</p>\n                            <span class=\"swafont swafont-lg swafont-icon-move-left\"></span>\n                        </div>\n                        <div data-drop=\"true\" id=\"with-{{$index}}\" jqyoui-droppable=\"{multiple: false, onDrop: \'vm.onDropTarget()\'}\" ng-class=\"{\'plus-icon\': !pair.performerToBeChangedWith, \'border-red\': vm.performerDropTargetTracker}\" class=\"img-box\">\n                            <span ng-if=\"!pair.performerToBeChangedWith\" class=\"swafont swafont-lg swafont-icon-plus\"></span>\n                            <img ng-if=\"pair.performerToBeChangedWith\" class=\"sws-logo sws-logo-link\" src=\"data:image/png;base64,{{pair.performerToBeChangedWith.image}}\">\n                        </div>\n                        </div>\n                        </div>\n                    </div>\n                    <span ng-if=\"vm.deleteOrReorderState.enabled\" class=\"swafont swafont-lg swafont-icon-menu\"></span>\n                </li>\n                <li ng-hide=\"vm.reassignmentState.selectTargetSceneOrCharts || vm.deleteOrReorderState.enabled\" class=\"swtoolbar-flex swtoolbar-flex-align-center\">\n                    <div class=\"list swtoolbar-flex swtoolbar-flex-align-center\">\n                        <div>\n                            <p class=\"replace-text\">REPLACE</p>\n                            <div class=\"swtoolbar-flex\">\n                        <div data-drop=\"true\" id=\"performerToBeChanged\" jqyoui-droppable=\"{multiple: false, onDrop: \'vm.onDropTarget()\'}\" class=\"plus-icon img-box\" ng-class=\"{\'border-red\': vm.performerDropTargetTracker}\">\n                        <span id=\"scene-0\" class=\"swafont swafont-lg swafont-icon-plus\"></span>    \n                        </div>\n                        </div>\n                        </div>\n                    </div>\n                </li>\n            </ul>\n            <div class=\"no-reassignment-available\" ng-show=\"vm.performersPairsForSwapping.length === 0 && vm.reassignmentState.selectTargetSceneOrCharts\">\n                <span>\n                    No reassignment available!\n                </span>\n            </div>\n        </div>\n    </div>\n    <div class=\"drag-area\" ng-if=\"!vm.reassignmentState.selectTargetSceneOrCharts\">\n        <div class=\"header swtoolbar-flex\"> \n            <div>\n                <h4>Drag and drop</h4>\n                <p>    \n                    Drag and drop the performer from the list to the\n                    designated area for track swap.</p>\n            </div>\n        </div>\n        <div class=\"drag-body\" ng-class=\"{\'track-reassignment-disable-div\': vm.deleteOrReorderState.enabled}\">\n            <div class=\"\">\n                <div class=\"search\">\n                    <input class=\"form-control\" id=\"searchperformername\" name=\"searchperformername\" ng-model=\"vm.searchperformername\" ng-change=\"vm.searchStringChanged()\" type=\"text\" placeholder=\"Search ...\">\n                    <button class=\"btn btn-lg sw-btn-toolbar search-text-remove\" ng-click=\"vm.clearSearch()\" ng-show=\"vm.searchperformername.length > 0\">\n                        <span class=\"sw-ionicon-lg ion-ios-close-outline\"></span>\n                    </button>\n                </div>\n            </div>\n        \n        \n        <div class=\"\" ng-class=\"{\'disabled-div\': vm.deleteOrReorderState.enabled}\">\n            <div ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\" class=\"scrollcontainer sw-performer-picker-content drag-images\">\n                <div id=\"performer-{{$index}}\" class=\"sw-performer-picker-item swtoolbar-flex\" ng-click=\"\" data-ng-repeat=\"aPerformer in vm.performers | filter: vm.performerSearchFilter | orderBy: \'oIndex\' as results\" data-drag=\"true\" data-jqyoui-options=\"{helper: \'clone\', scroll: false, revert: \'invalid\', appendTo: \'body\'}\" data-swa-performer=\"{{aPerformer}}\" jqyoui-draggable=\"{animate: true, onStart: \'vm.onDragStart()\', onStop: \'vm.onDragStop()\'}\">\n                    <img ng-src=\"data:image/png;base64,{{aPerformer.image}}\">\n                </div>\n                <div class=\"sw-popover-hint-item text-center\" ng-if=\"vm.performers.length === 0\">\n                    <em translate>labels.No Performers</em>\n                </div>\n            </div>\n        </div>\n        <div id=\"no-productions\" class=\"no-record-list\" ng-hide=\"results.length !== 0\">\n            <span>No matching Performers!</span>\n          </div>\n    </div>\n    </div>\n    <div class=\"choose-section\" ng-show=\"vm.reassignmentState.selectTargetSceneOrCharts\">\n        \n        <div class=\"header swtoolbar-flex\"> \n            <div>\n                <h4>Choose the section</h4>\n                <p>    \n                    Select charts, scenes (or full production) for which you want\n        to make this swap.</p>\n            </div>\n        </div>\n        <div class=\"choose-section-body\" ng-class=\"{\'track-reassignment-disable-div\': vm.performersPairsForSwapping.length === 0}\">\n            <div class=\"header-btns swtoolbar-flex swtoolbar-flex-align-center\">\n                <button ng-click=\"vm.clearAllChartAndSceneSelections()\" class=\"btn sw-btn-secondary sw-btn-min-w-80\" translate>buttons.Clear Selection</button>\n                <button ng-click=\"vm.selectEntireProduction()\" class=\"btn sw-btn-secondary sw-btn-min-w-80\" translate>buttons.Entire Production</button>\n            </div>\n            <div>\n                <ul class=\"scrollcontainer\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\" ng-scrollbars-update=\"vm.scrollUpdateChartList\">\n                    <li ng-repeat=\"scene in vm.scenes | limitTo: vm.activePlanRules.allowedNumberOfScenes\" id=\"scene{{scene._id}}\">\n                        <div ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleSelectedScene(scene)\" class=\"swtoolbar-flex swtoolbar-flex-align-center\">\n                            <p class=\"swtoolbar-flex swtoolbar-flex-align-center\">\n                            <span class=\"sw-ionicon-fw sw-ionicon-lg clickable\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleSceneSelection(scene)\" ng-class=\"{\'ion-ios-circle-outline\': !scene.editSelectedForReassignment, \'ion-ios-checkmark sw-color-red\': scene.editSelectedForReassignment}\"></span>\n                            <span class=\"scene-name\">{{scene.scenename}}</span>\n                            </p>\n                            <span id=\"scene-accordion-0\" class=\"sw-ionicon-fw\" ng-class=\"{\'ion-chevron-down\': scene.openForModal, \'ion-chevron-right\': !scene.openForModal}\"></span>\n                        </div>\n                        <ul ng-if=\"vm.selectedScene === scene\">\n                            <li ng-repeat=\"chart in scene.charts | limitTo: vm.activePlanRules.allowedNumberOfCharts track by chart._id\" id=\"chart-{{chart._id}}\">\n                                <div class=\"swtoolbar-flex\">\n                                    <p class=\"swtoolbar-flex\">\n                                    <span ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleChartSelection(chart, scene)\" class=\"clickable sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-ios-circle-outline\': !chart.editSelectedForReassignment, \'ion-ios-checkmark sw-color-red\': chart.editSelectedForReassignment}\"></span>\n                                    <span class=\"scene-name\" ng-show=\"vm.chartEditorState.chartNumberAutomatic || vm.production.chartsettings.chartnumberautomatic\">\n                                        {{\'labels.Chart\'| translate}}: {{scene.orderingindex + 1}}.{{chart.orderingindex + 1}}\n                                    </span>\n                                    <span class=\"scene-name\" ng-show=\"!vm.chartEditorState.chartNumberAutomatic && !vm.production.chartsettings.chartnumberautomatic\">\n                                        <span ng-show=\"chart.customname && chart.customname.length > 0\">{{chart.customname}}</span>\n                                        <span ng-show=\"!chart.customname || chart.customname.length === 0\" class=\"sw-color-gray\">&lt;unnamed&gt;</span>\n                                    </span>\n                                    </p>\n                                </div>\n                            </li>\n                        </ul>\n                    </li>\n                   \n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"text-right\">\n        <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-hide=\"vm.reassignmentState.selectTargetSceneOrCharts\" ng-click=\"vm.actionNo()\" translate>buttons.Cancel</button>\n        <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-hide=\"vm.reassignmentState.selectTargetSceneOrCharts\" ng-disabled=\"vm.deleteOrReorderState.enabled || vm.finalPerformersPairsForSwapping.length === 0\" ng-click=\"vm.showTargetSceneOrChartList()\" translate>buttons.Next</button>\n        <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-if=\"vm.reassignmentState.selectTargetSceneOrCharts\" ng-click=\"vm.showPerformersList()\" translate>buttons.Previous</button>\n        <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-if=\"vm.reassignmentState.selectTargetSceneOrCharts\" ng-disabled=\"vm.performersPairsForSwapping.length === 0 || (vm.reassignmentState.selectionCountForScenes === 0 && vm.reassignmentState.selectionCountForCharts === 0)\" ng-click=\"vm.actionYes()\" translate>buttons.Make the Swap</button>\n    </div>\n</div>");
$templateCache.put("app/components/chartEditor/restoreChartPermissionMessage.html","<div class=\"modal-header\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Restore Chart\'|translate}}\n    </span>\n  </div>\n  <div class=\"modal-body\">\n      <p class=\"text-center\">{{\'messages.Alert for collaborator for restoring chart\'|translate}}\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"text-center\">\n      <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionOk()\" translate>buttons.Ok</button>\n    </div>\n  </div>\n  ");
$templateCache.put("app/components/chartEditor/toggleToolbarVisibilityPromt.html","<div class=\"modal-header\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Chart Tools\'|translate}}\n    </span>\n  </div>\n  <div class=\"modal-body\">\n      <p class=\"text-center\">{{\'messages.Chart tool visibility\'|translate}}\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"text-center\">\n      <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionOk()\" translate>buttons.Ok</button>\n    </div>\n  </div>\n  ");
$templateCache.put("app/components/chartEditor/undoReassignmentPrompt.html","<div class=\"modal-header\" style=\"text-align: center\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Confirm\'|translate}}\n    </span>\n</div>\n<div class=\"modal-body\">\n    <strong>{{\'messages.Undo Last Reassignment?\' | translate}}</strong>\n    <p></p>\n    <p>{{\'messages.Undo Reassignment\' | translate}}</p>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"text-center\">\n        <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n        <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n    </div>\n</div>");
$templateCache.put("app/components/chartScriptEditor/chartScriptEditor.html","<swa-help-bar ng-if=\"vm.showHelpBar && !vm.chartScriptEditorState.lockModeNavigation\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-videos=\"vm.helpTourVideos\" swa-help-on-start=\"vm.onHelpTourStart()\" swa-help-on-end=\"vm.onHelpTourEnd()\"></swa-help-bar>\n<div class=\"mainOuter\" ng-class=\"{\'lockmodenavigation\': vm.chartScriptEditorState.lockModeNavigation}\" ng-cloak>\n    <div class=\"navbar navbar-fixed-top sw-navbar\" ng-hide=\"vm.chartScriptEditorState.lockModeNavigation\">\n        <div class=\"swtoolbar\">\n            <div class=\"swtoolbar-group pull-left\">\n                <img class=\"sws-logo sws-logo-link\" src=\"assets/images/sws-logo-light.png\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\" uib-tooltip=\"{{\'labels.Back to Productions\' | translate}}\">\n            </div>\n            <div class=\"swtoolbar-group pull-left\" id=\"editor-view\">\n                <button id=\"menu-locknavigation\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.toggleLockModeNavigation()\" ng-class=\"{\'sw-active\': vm.chartScriptEditorState.lockModeNavigation}\" ng-disabled=\"!vm.chartScriptEditorState.scriptAvailable\" uib-tooltip=\"Toggle lock navigation mode\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <span class=\"swafont swafont-lg swafont-icon-unlock\"></span>\n                </button>\n                <button id=\"menu-switchview\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.switchEditorView\" uib-tooltip=\"Switch to other Views\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <div class=\"sw-btn-toolbar-vcontent\">\n                      <span class=\"title\">Charts &amp; PDF</span>\n                      <span class=\"sw-ionicon-fw ion-arrow-down-b icon\"></span>\n                    </div>\n                  </button>\n                <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.switchEditorView\">\n                    <div class=\"sw-popover-title\">\n                        <span translate>titles.View</span>\n                    </div>\n                    <div class=\"sw-popover-menu\" role=\"menu\">\n                        <div class=\"menu-group\">\n                            <div class=\"menu-item\" ng-click=\"vm.switchEditor(0)\">\n                                <span class=\"title\" translate>labels.Charts</span>\n                            </div>\n                            <div class=\"menu-item\" ng-click=\"vm.switchEditor(3)\">\n                                <span class=\"title\" translate>labels.PDF</span>\n                            </div>\n                            <div class=\"menu-item\" ng-disabled=\"true\">\n                                <span class=\"title\" translate>labels.Charts and PDF</span>\n                            </div>\n                        </div>\n                    </div>\n                </stackable-popover>\n            </div>\n            <div id=\"menu-scriptbookmarknavigationcontrols\" class=\"swtoolbar-group pull-left\" ng-show=\"vm.chartScriptEditorState.scriptAvailable\">\n                <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPrevBookmark()\" ng-disabled=\"!vm.chartScriptEditorState.scriptAvailable\" uib-tooltip=\"Go to previous Bookmark\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <span class=\"swafont swafont-lg swafont-icon-previous\"></span>\n                </button>\n                <button id=\"menu-togglebookmarklist\" ng-disabled=\"!vm.chartScriptEditorState.scriptAvailable\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.bookmarkPicker\" uib-tooltip=\"Bookmark list\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <span class=\"swafont swafont-lg swafont-icon-bookmark\"></span>\n                </button>\n                <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.bookmarkPicker\">\n                    <div class=\"sw-popover-title\">\n                        <span translate>titles.Bookmarks</span>\n                    </div>\n                    <div class=\"sw-popover-menu\" role=\"menu\">\n                        <div class=\"menu-group\">\n                            <div class=\"menu-item\" ng-repeat=\"bookmark in vm.bookmarks | orderBy: [\'scriptPageNo\', \'topOffset\']\" ng-click=\"vm.gotoBookmark(bookmark)\">\n                                <span class=\"title\">{{bookmark.name}}</span>\n                            </div>\n                        </div>\n                    </div>\n                </stackable-popover>\n                <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoNextBookmark()\" ng-disabled=\"!vm.chartScriptEditorState.scriptAvailable\" uib-tooltip=\"Go to next Bookmark\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <span class=\"swafont swafont-lg swafont-icon-next\"></span>\n                </button>\n            </div>\n            <div class=\"swtoolbar-group pull-left\" ng-show=\"vm.chartScriptEditorState.scriptAvailable\">\n                <button ng-hide=\"true\" class=\"btn sw-btn-toolbar\" id=\"menu-scriptlayermaster\" ng-click=\"vm.activateMasterNotesLayer()\" ng-class=\"{\'sw-active\': vm.chartScriptEditorState.masterLayerActive}\">\n                    <span class=\"swafont swafont-lg swafont-icon-doc-key\"></span>\n                </button>\n                <button ng-hide=\"true\" class=\"btn sw-btn-toolbar\" id=\"menu-scriptlayerpersonal\" ng-click=\"vm.activatePersonalNotesLayer()\" ng-class=\"{\'sw-active\': vm.chartScriptEditorState.personalLayerActive}\">\n                    <span class=\"swafont swafont-lg swafont-icon-doc-my\"></span>\n                </button>\n                <button id=\"menu-scriptannotationsvisibility\" class=\"btn sw-btn-toolbar\" ng-class=\"{\'sw-active\': (vm.chartScriptEditorState.masterLayerActive && vm.chartScriptEditorState.annotationsVisible) || (vm.chartScriptEditorState.personalLayerActive && vm.chartScriptEditorState.annotationsVisiblePersonal)}\" ng-click=\"vm.toggleAnnotationVisibility()\" ng-disabled=\"!vm.chartScriptEditorState.pageLoaded\" uib-tooltip=\"Show / hide annotations\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <span class=\"swafont swafont-lg swafont-icon-eye\"></span>\n                </button>\n            </div>\n            <div id=\"menu-scriptpagenavigationcontrols\" class=\"swtoolbar-group pull-left\" ng-show=\"vm.chartScriptEditorState.scriptAvailable\">\n                <button id=\"prev-page\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPage(\'prev\')\" ng-disabled=\"(vm.script.numberOfPages === 0) || (vm.chartScriptEditorState.currentPageNumber === 1)\" uib-tooltip=\"Open previous page\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <span class=\"swafont swafont-lg swafont-icon-previous\"></span>\n                </button>\n                <button id=\"menu-scriptgotopage\" class=\"btn sw-btn-toolbar width-120\" stackable-trigger=\"vm.gotoPagePicker\" ng-disabled=\"(vm.script.numberOfPages === 0)\">\n                    <span ng-show=\"(vm.script.numberOfPages === 0)\" translate>labels.No Pages</span>\n                    <span ng-show=\"(vm.script.numberOfPages > 0)\">\n                        <span translate translate-values=\"{current: vm.chartScriptEditorState.customPageNumber === \'\' ? \'_\' : vm.chartScriptEditorState.customPageNumber, total: vm.chartScriptEditorState.totalNumberOfPages}\">labels.Page_current</span>\n                        <span class=\"sw-ionicon-fw ion-arrow-down-b\"></span>\n                    </span>\n                </button>\n                <stackable-popover stackable=\"vm.gotoPagePicker\" stackable-placement=\"bottom\">\n                    <div class=\"sw-popover-title\">\n                        <span translate>titles.Go To Page</span>\n                    </div>\n                    <div class=\"sw-popover-content\">\n                        <div class=\"sw-gotopage-picker-content form-inline sw-form-container text-center\">\n                            <div>\n                                <input id=\"gotopagequick\" class=\"form-control\" style=\"width: 110px; text-align: right\" ng-model=\"vm.gotoPagePicker.pagenumber\" ng-change=\"vm.gotoPagePicker.invalidPageNumber = false\" swa-on-enter=\"vm.findAndGoToPageNoFromCustomPageNumber()\" swa-select-on-focus>\n                                    <button class=\"btn sw-btn-secondary width-60\" ng-click=\"vm.findAndGoToPageNoFromCustomPageNumber()\" translate>buttons.Go</button>\n                            </div>\n                            <div ng-show=\"vm.gotoPagePicker.invalidPageNumber\">\n                                <span class=\"sw-color-red\" translate>messages.Invalid page number</span>\n                            </div>\n                            <div class=\"sw-goto-page-popup\">\n                                <span class=\"subtitle\">Total Pages : {{vm.script.numberOfPages}}</span>\n                            </div>\n                        </div>\n                    </div>\n                </stackable-popover>\n                <button id=\"next-page\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPage(\'next\')\" ng-disabled=\"(vm.script.numberOfPages === 0) || (vm.chartScriptEditorState.currentPageNumber === vm.chartScriptEditorState.totalNumberOfPages)\" uib-tooltip=\"Open next page\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <span class=\"swafont swafont-lg swafont-icon-next\"></span>\n                </button>\n            </div>\n            <div class=\"swtoolbar-group pull-right\">\n                <button id=\"menu-savechanges\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.onSaveClick()\" ng-disabled=\"!vm.currentScriptPage.dirty\" uib-tooltip=\"Save changes\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <span class=\"swafont swafont-lg swafont-icon-save\"></span>\n                </button>\n                <button id=\"menu-createpdf\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.pdfOptionsPicker\" uib-tooltip=\"PDF / printing options\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <span class=\"swafont swafont-lg swafont-icon-create-pdf\"></span>\n                </button>\n                <stackable-popover stackable-placement=\"bottom\" stackable-alignment=\"right\" stackable-enable-escape=\"true\" stackable=\"vm.pdfOptionsPicker\">\n                    <div class=\"sw-popover-title\">\n                        <span translate>titles.Create PDF</span>\n                    </div>\n                    <div class=\"sw-popover-menu\" role=\"menu\">\n                        <div class=\"menu-group\">\n                            <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllChartsStaffs)\">\n                                <span class=\"title\" translate>labels.Production - Charts &amp; Score</span>\n                            </div>\n                            <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 1)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0) || !vm.script\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllChartsScript)\">\n                                <span class=\"title\" translate>labels.Production - Charts &amp; PDF</span>\n                            </div>\n                            <div class=\"menu-item\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllCharts)\">\n                                <span class=\"title\" translate>labels.Production - Charts</span>\n                            </div>\n                            <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllStaffs)\">\n                                <span class=\"title\" translate>labels.Production - Score</span>\n                            </div>\n                            <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 1)\" ng-disabled=\"!vm.script\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.Script)\">\n                                <span class=\"title\" translate>labels.Production - PDF</span>\n                            </div>\n                        </div>\n                        <div class=\"menu-group\">\n                            <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneChartsStaffs)\">\n                                <span class=\"title\" translate>labels.Current Scene - Charts &amp; Score</span>\n                            </div>\n                            <div class=\"menu-item\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneCharts)\">\n                                <span class=\"title\" translate>labels.Current Scene - Charts</span>\n                            </div>\n                            <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneStaffs)\">\n                                <span class=\"title\" translate>labels.Current Scene - Score</span>\n                            </div>\n                        </div>\n                        <div class=\"menu-group\">\n                            <div class=\"menu-item\" ng-disabled=\"!vm.selectedChart\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentChart)\">\n                                <span class=\"title\" translate>labels.Current Chart</span>\n                            </div>\n                            <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedStaff\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentStaff)\">\n                                <span class=\"title\" translate>labels.Current Score</span>\n                            </div>\n                        </div>\n                        <div class=\"menu-group-title\">\n                            <span translate>labels.Recent PDFs</span>\n                        </div>\n                        <div class=\"menu-group\" swa-print-job-list data-list=\"vm.printJobs\">\n                        </div>\n                    </div>\n                </stackable-popover>\n                <div id=\"menu-collaborators\" class=\"btn sw-btn-toolbar\" ng-show=\"vm.selectedProduction.collaborationsettings.length > 0\" uib-tooltip=\"Collaboration details\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <span swa-show-collaborators data-production=\"vm.selectedProduction\" data-current-user-id=\"vm.userId\" class=\"sw-ionicon-2x ion-person-stalker\"></span>\n                </div>\n                <button id=\"menu-settings\" class=\"btn sw-btn-toolbar\" ui-sref=\"{{vm.swaRouterStateNames.productionsettings.details}}\" uib-tooltip=\"Production Settings\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                    <span class=\"swafont swafont-lg swafont-icon-settings\"></span>\n                </button>\n            </div>\n        </div>\n    </div>\n    <div class=\"swtoolbar swtoolbar-lockmode\" ng-show=\"vm.chartScriptEditorState.lockModeNavigation\">\n        <div class=\"swtoolbar-group pull-left\">\n            <img class=\"sws-logo\" src=\"assets/images/sws-logo-light.png\">\n        </div>\n        <div class=\"swtoolbar-group pull-left\">\n            <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.toggleLockModeNavigation()\" ng-class=\"{\'sw-active\': vm.chartScriptEditorState.lockModeNavigation}\" uib-tooltip=\"Toggle lock navigation mode\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                <span class=\"swafont swafont-lg swafont-icon-lock\"></span>\n            </button>\n            <button id=\"menu-switchview2\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.switchEditorView2\" uib-tooltip=\"Switch to other Views\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                <div class=\"sw-btn-toolbar-vcontent\">\n                  <span class=\"title\">Charts &amp; PDF</span>\n                  <span class=\"sw-ionicon-fw ion-arrow-down-b icon\"></span>\n                </div>\n              </button>\n            <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.switchEditorView2\">\n                <div class=\"sw-popover-title\">\n                    <span translate>titles.View</span>\n                </div>\n                <div class=\"sw-popover-menu\" role=\"menu\">\n                    <div class=\"menu-group\">\n                        <div class=\"menu-item\" ng-click=\"vm.switchEditor(0)\">\n                            <span class=\"title\" translate>labels.Charts</span>\n                        </div>\n                        <div class=\"menu-item\" ng-click=\"vm.switchEditor(3)\">\n                            <span class=\"title\" translate>labels.PDF</span>\n                        </div>\n                        <div class=\"menu-item\" ng-disabled=\"true\">\n                            <span class=\"title\" translate>labels.Charts and PDF</span>\n                        </div>\n                    </div>\n                </div>\n            </stackable-popover>\n        </div>\n        <div class=\"swtoolbar-group pull-left\">\n            <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPrevBookmark()\" ng-disabled=\"!vm.chartScriptEditorState.scriptAvailable\" uib-tooltip=\"Go to previous bookmark\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                <span class=\"swafont swafont-lg swafont-icon-previous\"></span>\n            </button>\n            <button id=\"menu-togglebookmarklist\" ng-disabled=\"!vm.chartScriptEditorState.scriptAvailable\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.bookmarkPickerL\" uib-tooltip=\"Bookmark list\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                <span class=\"swafont swafont-lg swafont-icon-bookmark\"></span>\n            </button>\n            <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.bookmarkPickerL\">\n                <div class=\"sw-popover-title\">\n                    <span translate>titles.Bookmarks</span>\n                </div>\n                <div class=\"sw-popover-menu\" role=\"menu\">\n                    <div class=\"menu-group\">\n                        <div class=\"menu-item\" ng-repeat=\"bookmark in vm.bookmarks | orderBy: [\'scriptPageNo\', \'topOffset\']\" ng-click=\"vm.gotoBookmark(bookmark)\">\n                            <span class=\"title\">{{bookmark.name}}</span>\n                        </div>\n                    </div>\n                </div>\n            </stackable-popover>\n            <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoNextBookmark()\" ng-disabled=\"!vm.chartScriptEditorState.scriptAvailable\" uib-tooltip=\"Go to next Bookmark\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                <span class=\"swafont swafont-lg swafont-icon-next\"></span>\n            </button>\n        </div>\n        <div class=\"swtoolbar-group pull-left\">\n            <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPage(\'prev\')\" ng-disabled=\"(vm.script.numberOfPages === 0) || (vm.chartScriptEditorState.currentPageNumber === 1)\" uib-tooltip=\"Open previous page\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                <span class=\"swafont swafont-lg swafont-icon-previous\"></span>\n            </button>\n            <button id=\"go-to-page1\" class=\"btn sw-btn-toolbar\" ng-disabled=\"(vm.script.numberOfPages === 0)\" stackable-trigger=\"vm.gotoPagePicker1\">\n                <span ng-show=\"(vm.script.numberOfPages === 0)\" translate>labels.No Pages</span>\n                <span ng-show=\"(vm.script.numberOfPages > 0)\">\n                    <span translate translate-values=\"{current: vm.chartScriptEditorState.customPageNumber === \'\' ? \'_\' : vm.chartScriptEditorState.customPageNumber, total: vm.chartScriptEditorState.totalNumberOfPages}\">labels.Page_current</span>\n                    <span class=\"sw-ionicon-fw ion-arrow-down-b\"></span>\n                </span>\n            </button>\n            <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.gotoPagePicker1\">\n                <div class=\"sw-popover-title\">\n                    <span translate>titles.Go To Page</span>\n                </div>\n                <div class=\"sw-popover-content\">\n                    <div class=\"sw-gotopage-picker-content form-inline sw-form-container text-center\">\n                        <div>\n                            <input class=\"form-control\" id=\"gotopagequick1\" style=\"width: 110px; text-align: right\" ng-change=\"vm.gotoPagePicker.invalidPageNumber = false\" ng-model=\"vm.gotoPagePicker.pagenumber\" style=\"width: 60px; text-align: right\" swa-on-enter=\"vm.findAndGoToPageNoFromCustomPageNumber()\" swa-select-on-focus>\n                                <button class=\"btn sw-btn-secondary width-60\" ng-click=\"vm.findAndGoToPageNoFromCustomPageNumber()\" translate>buttons.Go</button>\n                        </div>\n                        <div ng-show=\"vm.gotoPagePicker.invalidPageNumber\">\n                            <span class=\"sw-color-red\" translate>messages.Invalid page number</span>\n                        </div>\n                        <div class=\"sw-goto-page-popup\">\n                            <span class=\"subtitle\">Total Pages : {{vm.script.numberOfPages}}</span>\n                        </div>\n                    </div>\n                </div>\n            </stackable-popover>\n            <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPage(\'next\')\" ng-disabled=\"(vm.script.numberOfPages === 0) || (vm.chartScriptEditorState.currentPageNumber === vm.chartScriptEditorState.totalNumberOfPages)\" uib-tooltip=\"Open next page\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                <span class=\"swafont swafont-lg swafont-icon-next\"></span>\n            </button>\n        </div>\n        <div class=\"swtoolbar-group pull-right\">\n            <span class=\"swa-color-lightgray sw-text-lg\" translate>titles.Charts and PDF View</span>\n        </div>\n    </div>\n    <div>\n        <div id=\"sidebar-scenelist\" class=\"sw-sidebar sw-sidebar-nofooter sw-sidebar-lg-withchart sw-sidebar-left\">\n            <div class=\"sw-navbar sw-navbar-top sw-color-red\">\n                <div class=\"swtoolbar\">\n                    <button id=\"button-closeproduction\" class=\"btn btn-lg sw-btn-toolbar\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\">\n                        <span class=\"ion-chevron-left\"></span>\n                    </button>\n                    <div class=\"text-lg sw-truncatetext\" style=\"width: calc(100% - 50px)\">\n                        <span>{{vm.selectedProduction.name}}</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"scrollcontainer\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\" ng-scrollbars-update=\"vm.scrollUpdateSidebar\">\n                <uib-accordion class=\"sidebar-scenecontents-list\" close-others=\"true\" ng-class=\"{\'clickthrough\': vm.chartScriptEditorState.lockModeNavigation}\">\n                    <div uib-accordion-group id=\"scene-container-{{$index}}\" is-open=\"scene.open\" ng-repeat=\"scene in vm.scenes | limitTo: vm.activePlanRules.allowedNumberOfScenes\">\n                        <uib-accordion-heading>\n                            <div ng-class=\"{\'sw-color-red\': scene.open}\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleScene(scene)\">\n                                <div class=\"name sw-truncatetext\">\n                                    <span>{{scene.scenename}}</span>\n                                </div>\n                                <div class=\"pull-right\">\n                                    <span id=\"scene-{{$index}}\" class=\"sw-ionicon-fw\" ng-class=\"{\'ion-chevron-down\': scene.open, \'ion-chevron-right\': !scene.open}\"></span>\n                                </div>\n                            </div>\n                        </uib-accordion-heading>\n                        <div>\n                            <div id=\"chart-{{chart._id}}\" data-drag=\"vm.newChartLinkTracker.enableLinking\" data-jqyoui-options=\"{helper: \'clone\', scroll: false, revert: \'invalid\', appendTo: \'body\'}\" data-swa-chartid=\"{{chart._id}}\" jqyoui-draggable=\"{animate: true, onStart: \'vm.onDragStart()\'}\" ng-repeat=\"chart in scene.charts| limitTo: vm.activePlanRules.allowedNumberOfCharts\" class=\"sidebar-chart-row sidebar-chart-row-fw\" ng-class=\"{\'lockmode\': vm.chartScriptEditorState.lockModeNavigation, \'lock-highlight\': (vm.chartScriptEditorState.lockHighlightChartId === chart._id)}\">\n                                <div class=\"chart-item-block\">\n                                    <div class=\"chart-thumb\">\n                                        <img class=\"img-responsive\" ng-src=\"data:image/png;base64,{{chart.thumbimage}}\">\n                                    </div>\n                                    <div class=\"title text-center sw-truncatetext\">\n                                        <span ng-if=\"vm.chartScriptEditorState.chartNumberAutomatic\">{{\'labels.Chart\'|\n                                            translate}}:\n                                            {{scene.orderingindex + 1}}.{{chart.orderingindex + 1}}</span>\n                                        <span ng-if=\"!vm.chartScriptEditorState.chartNumberAutomatic\">\n                                            <span ng-show=\"chart.customname && chart.customname.length > 0\">{{chart.customname}}</span>\n                                            <span ng-show=\"!chart.customname || chart.customname.length === 0\" class=\"sw-color-gray\">&lt;unnamed&gt;</span>\n                                        </span>\n                                        <div class=\"pull-right\" ng-if=\"!scene.accessRules.allowowneraccess\">\n                                            <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-person-stalker\': scene.accessRules.allowchartaslinksource, \'ion-locked\': !scene.accessRules.allowchartaslinksource}\"></span>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"sidebar-staff-row text-center\" ng-if=\"scene.noCharts\">\n                            <em class=\"sidebar-hint-text\" translate>labels.No Charts</em>\n                        </div>\n                    </div>\n                </uib-accordion>\n            </div>\n        </div>\n        <div class=\"sw-maincontentarea-chartscript sw-editorcontent\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigContent\">\n            <div oncontextmenu=\"return false\" class=\"sw-script-pageview-container sw-script-chartlink-pageview-container\">\n                <div class=\"clickthrough\" style=\"position:absolute; top: 0; right: 0\" ng-if=\"!vm.activeAccessRules.allowowneraccess\">\n                    <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-person-stalker\': vm.activeAccessRules.allowscriptaslinktarget, \'ion-locked\': !vm.activeAccessRules.allowscriptaslinktarget}\"></span>\n                </div>\n                <div class=\"swa-script-page-content\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\">\n                    <img id=\"scriptPageImage\" class=\"swa-script-page-image\" ng-hide=\"vm.chartScriptEditorState.pageLoadError || vm.chartScriptEditorState.pageImageLoadError\" ng-src=\"{{vm.currentScriptPage.pageImageSrc}}\">\n                </div>\n                <div class=\"swa-script-page-annotations swa-script-global hide-when-blocked clickthrough\" ng-show=\"vm.chartScriptEditorState.annotationsVisible && !vm.activeAccessRules.allowpersonalnotes\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\">\n                    <div class=\"swa-script-side-annotations-container left\">\n                        <div class=\"swa-script-annotation clickthrough\" ng-class=\"{\'action-type\': (lAnnotation.annotationtype === 0), \'lightcue-type\': (lAnnotation.annotationtype === 1)}\" ng-repeat=\"lAnnotation in vm.currentScriptPage.leftannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.positionrect.left+\'px\', top: lAnnotation.positionrect.top+\'px\', height: lAnnotation.positionrect.height+\'px\', width: lAnnotation.positionrect.width+\'px\', \'background-color\': lAnnotation.backgroundColorCss, \'border-style\': \'none\'}\">\n                            <div class=\"content\" contenteditable=\"\" ng-model=\"lAnnotation.richtextcontent\"></div>\n                        </div>\n                    </div>\n                    <div class=\"swa-script-side-annotations-container right\">\n                        <div class=\"swa-script-annotation clickthrough\" ng-class=\"{\'action-type\': (rAnnotation.annotationtype === 0), \'lightcue-type\': (rAnnotation.annotationtype === 1)}\" ng-repeat=\"rAnnotation in vm.currentScriptPage.rightannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.positionrect.left+\'px\', top: rAnnotation.positionrect.top+\'px\', height: rAnnotation.positionrect.height+\'px\', width: rAnnotation.positionrect.width+\'px\', \'background-color\': rAnnotation.backgroundColorCss, \'border-style\': \'none\'}\">\n                            <div class=\"content\" contenteditable=\"\" ng-model=\"rAnnotation.richtextcontent\"></div>\n                        </div>\n                    </div>\n                    <div class=\"swa-script-annotation-selections-container\">\n                        <div class=\"swa-script-annotation-selection\" ng-repeat=\"lAnnotation in vm.currentScriptPage.leftannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.selectionrect.left+\'px\', top: lAnnotation.selectionrect.top+\'px\', width: lAnnotation.selectionrect.width+\'px\', height: lAnnotation.selectionrect.height+\'px\',\n                            \'background-color\': lAnnotation.markerStyle ? \'\' : lAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\">\n                        </div>\n                        <div class=\"swa-script-annotation-selection\" ng-repeat=\"rAnnotation in vm.currentScriptPage.rightannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.selectionrect.left+\'px\', top: rAnnotation.selectionrect.top+\'px\', width: rAnnotation.selectionrect.width+\'px\', height: rAnnotation.selectionrect.height+\'px\',\n                            \'background-color\': rAnnotation.markerStyle ? \'\' : rAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\">\n                        </div>\n                        <svg class=\"swa-script-annotation-lines-container\">\n                            <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                                </line>\n                            </g>\n                            <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                                </line>\n                            </g>\n                            <!-- left annotations anchor box -->\n                              <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotations\">\n                              <!-- Top side -->\n                              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Right side -->\n                              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Bottom side -->\n                              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Left side -->\n                              <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                            </g>\n                            <!-- right annotations anchor box -->\n                            <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotations\">\n                              <!-- Top side -->\n                              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Right side -->\n                              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Bottom side -->\n                              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Left side -->\n                              <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                            </g>\n                            <!-- left annotations text box -->\n                            <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotations\">\n                              <!-- Top side -->\n                              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Right side -->\n                              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Bottom side -->\n                              <line ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Left side -->\n                              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                            </g>\n                            <!-- right annotations text box -->\n                            <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotations\">\n                              <!-- Top side -->\n                              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Right side -->\n                              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Bottom side -->\n                              <line ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                              <!-- Left side -->\n                              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                              </line>\n                            </g>\n                        </svg>\n                    </div>\n                    <div class=\"swa-script-floating-annotations-container\">\n                        <div class=\"swa-script-annotation floating-type clickthrough\" ng-repeat=\"fAnnotation in vm.currentScriptPage.floatingannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(fAnnotation.layerid) == -1\" ng-style=\"{top: fAnnotation.positionrect.top+\'px\', left: fAnnotation.positionrect.left+\'px\', width: fAnnotation.positionrect.width+\'px\', height: fAnnotation.positionrect.height+\'px\', \'background-color\': fAnnotation.backgroundColorCss}\">\n                            <div class=\"content\" contenteditable=\"\" ng-model=\"fAnnotation.richtextcontent\"></div>\n                        </div>\n                    </div>\n                    <div class=\"swa-script-highlight-annotations-container\">\n                        <div class=\"swa-script-annotation highlight-type clickthrough\" ng-repeat=\"mAnnotation in vm.currentScriptPage.highlightannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(mAnnotation.layerid) == -1\" ng-style=\"{top: mAnnotation.positionrect.top+\'px\', left: mAnnotation.positionrect.left+\'px\', width: mAnnotation.positionrect.width+\'px\', height: mAnnotation.positionrect.height+\'px\', \'background-color\': mAnnotation.backgroundColorCss}\">\n                        </div>\n                    </div>\n                    <div class=\"swa-script-sketchpad-container swa-script-sketchpad\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\">\n                        <div class=\"swa-script-sketchpad-annotations-container\">\n                            <div id=\"sketchpad\"></div>\n                        </div>\n                    </div>\n                </div>\n                <!-- Personal annotations -->\n                <div class=\"swa-script-page-annotations swa-script-personal hide-when-blocked clickthrough\" ng-show=\"vm.chartScriptEditorState.annotationsVisiblePersonal && vm.activeAccessRules.allowpersonalnotes\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\">\n                    <div class=\"swa-script-side-annotations-container left\">\n                        <div class=\"swa-script-annotation clickthrough\" ng-class=\"{\'action-type\': (lAnnotation.annotationtype === 0), \'lightcue-type\': (lAnnotation.annotationtype === 1)}\" ng-repeat=\"lAnnotation in vm.ownerScriptPage.leftannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.positionrect.left+\'px\', top: lAnnotation.positionrect.top+\'px\', height: lAnnotation.positionrect.height+\'px\', width: lAnnotation.positionrect.width+\'px\', \'background-color\': lAnnotation.backgroundColorCss, \'border-style\': \'none\'}\">\n                            <div class=\"content\" contenteditable=\"\" ng-model=\"lAnnotation.richtextcontent\"></div>\n                        </div>\n                        <div class=\"swa-script-annotation clickthrough\" ng-class=\"{\'action-type\': (lAnnotation.annotationtype === 0), \'lightcue-type\': (lAnnotation.annotationtype === 1)}\" ng-repeat=\"lAnnotation in vm.currentScriptPage.leftannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.positionrect.left+\'px\', top: lAnnotation.positionrect.top+\'px\', height: lAnnotation.positionrect.height+\'px\', width: lAnnotation.positionrect.width+\'px\', \'background-color\': lAnnotation.backgroundColorCss, \'border-style\': \'none\'}\">\n                            <div class=\"content\" contenteditable=\"\" ng-model=\"lAnnotation.richtextcontent\"></div>\n                        </div>\n                    </div>\n                    <div class=\"swa-script-side-annotations-container right\">\n                        <div class=\"swa-script-annotation clickthrough\" ng-class=\"{\'action-type\': (rAnnotation.annotationtype === 0), \'lightcue-type\': (rAnnotation.annotationtype === 1)}\" ng-repeat=\"rAnnotation in vm.ownerScriptPage.rightannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.positionrect.left+\'px\', top: rAnnotation.positionrect.top+\'px\', height: rAnnotation.positionrect.height+\'px\', width: rAnnotation.positionrect.width+\'px\', \'background-color\': rAnnotation.backgroundColorCss, \'border-style\': \'none\'}\">\n                            <div class=\"content\" contenteditable=\"\" ng-model=\"rAnnotation.richtextcontent\"></div>\n                        </div>\n                        <div class=\"swa-script-annotation clickthrough\" ng-class=\"{\'action-type\': (rAnnotation.annotationtype === 0), \'lightcue-type\': (rAnnotation.annotationtype === 1)}\" ng-repeat=\"rAnnotation in vm.currentScriptPage.rightannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.positionrect.left+\'px\', top: rAnnotation.positionrect.top+\'px\', height: rAnnotation.positionrect.height+\'px\', width: rAnnotation.positionrect.width+\'px\', \'background-color\': rAnnotation.backgroundColorCss, \'border-style\': \'none\'}\">\n                            <div class=\"content\" contenteditable=\"\" ng-model=\"rAnnotation.richtextcontent\"></div>\n                        </div>\n                    </div>\n                    <div class=\"swa-script-annotation-selections-container\">\n                        <div class=\"swa-script-annotation-selection\" ng-repeat=\"lAnnotation in vm.ownerScriptPage.leftannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.selectionrect.left+\'px\', top: lAnnotation.selectionrect.top+\'px\', width: lAnnotation.selectionrect.width+\'px\', height: lAnnotation.selectionrect.height+\'px\',\n                            \'background-color\': lAnnotation.markerStyle ? \'\' : lAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\">\n                        </div>\n                        <div class=\"swa-script-annotation-selection\" ng-repeat=\"lAnnotation in vm.currentScriptPage.leftannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.selectionrect.left+\'px\', top: lAnnotation.selectionrect.top+\'px\', width: lAnnotation.selectionrect.width+\'px\', height: lAnnotation.selectionrect.height+\'px\',\n                            \'background-color\': lAnnotation.markerStyle ? \'\' : lAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\">\n                        </div>\n                        <div class=\"swa-script-annotation-selection\" ng-repeat=\"rAnnotation in vm.ownerScriptPage.rightannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.selectionrect.left+\'px\', top: rAnnotation.selectionrect.top+\'px\', width: rAnnotation.selectionrect.width+\'px\', height: rAnnotation.selectionrect.height+\'px\',\n                            \'background-color\': rAnnotation.markerStyle ? \'\' : rAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\">\n                        </div>\n                        <div class=\"swa-script-annotation-selection\" ng-repeat=\"rAnnotation in vm.currentScriptPage.rightannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.selectionrect.left+\'px\', top: rAnnotation.selectionrect.top+\'px\', width: rAnnotation.selectionrect.width+\'px\', height: rAnnotation.selectionrect.height+\'px\',\n                            \'background-color\': rAnnotation.markerStyle ? \'\' : rAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\">\n                        </div>\n                        <svg class=\"swa-script-annotation-lines-container\">\n                            <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.leftannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                                </line>\n                            </g>\n                            <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                                </line>\n                            </g>\n                            <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.rightannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                                </line>\n                            </g>\n                            <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                                </line>\n                            </g>\n                            <!-- left annotations anchor box -->\n                               <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.leftannotations\">\n                               <!-- Top side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Right side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Bottom side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Left side -->\n                               <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                             </g>\n                               <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotationsPersonal\">\n                               <!-- Top side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Right side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Bottom side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Left side -->\n                               <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                             </g>\n                             <!-- right annotations anchor box -->\n                             <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.rightannotations\">\n                               <!-- Top side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Right side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Bottom side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Left side -->\n                               <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                             </g>\n                             <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotationsPersonal\">\n                               <!-- Top side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Right side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Bottom side -->\n                               <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Left side -->\n                               <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                             </g>\n                             <!-- left annotations text box -->\n                             <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.leftannotations\">\n                               <!-- Top side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Right side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Bottom side -->\n                               <line ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Left side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                             </g>\n                             <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotationsPersonal\">\n                               <!-- Top side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Right side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Bottom side -->\n                               <line ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Left side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                             </g>\n                             <!-- right annotations text box -->\n                             <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.rightannotations\">\n                               <!-- Top side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Right side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Bottom side -->\n                               <line ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Left side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                             </g>\n                             <g class=\"swa-script-annotation-line\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotationsPersonal\">\n                               <!-- Top side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Right side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Bottom side -->\n                               <line ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                               <!-- Left side -->\n                               <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                               </line>\n                             </g>\n                        </svg>\n                    </div>\n                    <div class=\"swa-script-floating-annotations-container\">\n                        <div class=\"swa-script-annotation floating-type clickthrough\" ng-repeat=\"fAnnotation in vm.ownerScriptPage.floatingannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(fAnnotation.layerid) == -1\" ng-style=\"{top: fAnnotation.positionrect.top+\'px\', left: fAnnotation.positionrect.left+\'px\', width: fAnnotation.positionrect.width+\'px\', height: fAnnotation.positionrect.height+\'px\', \'background-color\': fAnnotation.backgroundColorCss}\">\n                            <div class=\"content\" contenteditable=\"\" ng-model=\"fAnnotation.richtextcontent\"></div>\n                        </div>\n                        <div class=\"swa-script-annotation floating-type clickthrough\" ng-repeat=\"fAnnotation in vm.currentScriptPage.floatingannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(fAnnotation.layerid) == -1\" ng-style=\"{top: fAnnotation.positionrect.top+\'px\', left: fAnnotation.positionrect.left+\'px\', width: fAnnotation.positionrect.width+\'px\', height: fAnnotation.positionrect.height+\'px\', \'background-color\': fAnnotation.backgroundColorCss}\">\n                            <div class=\"content\" contenteditable=\"\" ng-model=\"fAnnotation.richtextcontent\"></div>\n                        </div>\n                    </div>\n                    <div class=\"swa-script-highlight-annotations-container\">\n                        <div class=\"swa-script-annotation highlight-type clickthrough\" ng-repeat=\"mAnnotation in vm.ownerScriptPage.highlightannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(mAnnotation.layerid) == -1\" ng-style=\"{top: mAnnotation.positionrect.top+\'px\', left: mAnnotation.positionrect.left+\'px\', width: mAnnotation.positionrect.width+\'px\', height: mAnnotation.positionrect.height+\'px\', \'background-color\': mAnnotation.backgroundColorCss}\">\n                        </div>\n                        <div class=\"swa-script-annotation highlight-type clickthrough\" ng-repeat=\"mAnnotation in vm.currentScriptPage.highlightannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(mAnnotation.layerid) == -1\" ng-style=\"{top: mAnnotation.positionrect.top+\'px\', left: mAnnotation.positionrect.left+\'px\', width: mAnnotation.positionrect.width+\'px\', height: mAnnotation.positionrect.height+\'px\', \'background-color\': mAnnotation.backgroundColorCss}\">\n                        </div>\n                    </div>\n                    <div class=\"swa-script-sketchpad-container swa-script-sketchpad\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\">\n                        <div class=\"swa-script-sketchpad-annotations-container\">\n                            <div id=\"sketchpad-personal\"></div>\n                        </div>\n                    </div>\n                    <div class=\"swa-script-sketchpad-container swa-script-sketchpad\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\">\n                        <div class=\"swa-script-sketchpad-annotations-container\">\n                            <div id=\"sketchpad-shared\"></div>\n                        </div>\n                    </div>\n                </div>\n                <!-- Personal annotations ends-->\n                <div class=\"swa-script-chartlinks-container hide-when-blocked\" ng-class=\"{\'clickthrough\': vm.chartScriptEditorState.lockModeNavigation}\" ng-hide=\"vm.newChartLinkTracker.enableLinking\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\" ng-mousedown=\"vm.onChartlinksContentMouseDown($event)\" ng-mousemove=\"vm.onChartlinksContentMouseMove($event)\" ng-mouseup=\"vm.onChartlinksContentMouseUp($event)\">\n                    <div class=\"swa-script-chartlink\" ng-class=\"{\'active\': vm.chartScriptEditorState.activeLinkOrderingIndex === $index, \'clickthrough\': vm.newChartLinkTracker.isTracking}\" ng-repeat=\"chartlink in vm.currentScriptPage.chartlinks\" ng-style=\"{top: chartlink.selectionrect.top + \'px\', height: chartlink.selectionrect.height + \'px\'}\" swa-draggable swa-draggable-on-end=\"vm.chartlinkMoved($index, dragData)\" swa-draggable-options=\"{direction: \'v\', setBottomRight: true, handleClass:\'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.chartlinkResized($index, sizeData)\" swa-resizable-options=\"{direction: \'v\', setBottomRight: true, minHeight: 32, handleClass: \'resizehandle\'}\">\n                        <div class=\"buttons-container-topright btn-group swa-chartscript-view-chartname-width\">\n                            <button class=\"btn btn-sm sw-btn-accessory\" ng-click=\"vm.deleteChartLink($index)\" ng-hide=\"vm.chartScriptEditorState.lockModeNavigation || !vm.shouldAllowChartLinkEdit($index)\">\n                                <span class=\"sw-ionicon-fw ion-close-round\"></span>\n                            </button>\n                            <button class=\"btn btn-sm sw-btn-accessory sw-truncatetext swa-chartscript-view-chartname\">\n                                <span ng-show=\"chartlink.chartname === undefined\" class=\"sw-ionicon-fw sw-ionicon-lg sw-ionicon-spin-1s ion-load-d\"></span>\n                                <span ng-show=\"chartlink.chartname.length > 0 && ![\'<error>\', \'<missing>\'].includes(chartlink.chartname)\" ng-click=\"vm.switchEditor(0, { chartId: chartlink.chartId })\">{{chartlink.chartname}}</span>\n                                <span ng-show=\"chartlink.chartname.length > 0 && [\'<error>\', \'<missing>\'].includes(chartlink.chartname)\">{{chartlink.chartname}}</span>\n                                <span ng-show=\"chartlink.chartname.length === 0\">&lt;unnamed&gt;</span>\n                            </button>\n                        </div>\n                        <div class=\"handle movehandle\" ng-show=\"vm.shouldAllowChartLinkEdit($index)\">\n                            <span class=\"sw-ionicon-fw ion-arrow-move\"></span>\n                        </div>\n                        <div class=\"handle resizehandle\" ng-show=\"vm.shouldAllowChartLinkEdit($index)\">\n                            <span class=\"sw-ionicon-fw sw-ionicon-r-90 ion-arrow-resize\"></span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"swa-script-chartlinks-container sw-script-chartlinkstarget-container\" ng-show=\"vm.newChartLinkTracker.isTracking || vm.newChartLinkTracker.enableLinking\" ng-class=\"{\'tracking\': vm.newChartLinkTracker.isTracking }\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\" ng-cloak>\n                    <div data-drop=\"true\" jqyoui-droppable=\"{multiple: false, onOver: \'vm.onOverLinkTarget()\', onOut: \'vm.onOutLinkTarget()\', onDrop: \'vm.onDropLinkTarget()\'}\" class=\"swa-script-chartlink-target\" ng-style=\"{top: vm.newChartLinkTracker.selectionRect.top + \'px\', height: vm.newChartLinkTracker.selectionRect.height + \'px\'}\" ng-class=\"{\'tracking\': vm.newChartLinkTracker.isTracking}\">\n                        <div class=\"hinttext-container\" ng-hide=\"vm.newChartLinkTracker.isTracking\">\n                            <span ng-hide=\"vm.newChartLinkTracker.dragOnTarget\" translate>messages.Drag a chart here to link</span>\n                            <span ng-show=\"vm.newChartLinkTracker.dragOnTarget\" translate>messages.Drop the chart here to link</span>\n                        </div>\n                        <div class=\"buttons-container-topright\" ng-hide=\"vm.newChartLinkTracker.isTracking\">\n                            <button class=\"btn btn-xs sw-btn-inspector\" ng-click=\"vm.cancelNewChartLink()\">\n                                <span class=\"sw-ionicon-fw ion-close-round\"></span>\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"hide-when-blocked text-center sw-color-lightgray\" ng-hide=\"vm.chartScriptEditorState.pageLoaded\" style=\"margin-top: 40px\">\n                <div style=\"margin-bottom: 16px\">\n                    <span class=\"sw-text-xlg\" translate>titles.Charts and PDF View</span>\n                </div>\n                <div ng-hide=\"vm.chartScriptEditorState.scriptAvailable\">\n                    <span class=\"sw-text-lg\" translate>messages.You don\'t have a PDF in this Production!</span><br>\n                    <small class=\"sw-text-md sw-color-mediumlightgray\" translate>messages.Switch to the PDF View to import a PDF.</small>\n                </div>\n                <div ng-show=\"(vm.chartScriptEditorState.totalNumberOfPages === 0)\">\n                    <span class=\"sw-text-lg\" translate>messages.There are no pages in this PDF!</span>\n                </div>\n                <div ng-show=\"(vm.chartScriptEditorState.totalNumberOfPages > 0) && vm.chartScriptEditorState.pageLoadError\">\n                    <span class=\"sw-text-lg\" translate>messages.Error loading page!</span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/components/chartStaffEditor/chartStaffEditor.html","<swa-help-bar ng-if=\"vm.showHelpBar && !vm.chartStaffEditorState.lockModeNavigation\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-videos=\"vm.helpTourVideos\"></swa-help-bar>\n<div class=\"mainOuter\" ng-class=\"{\'lockmodenavigation\': vm.chartStaffEditorState.lockModeNavigation}\" ng-cloak>\n  <div class=\"navbar navbar-fixed-top sw-navbar\" ng-hide=\"vm.chartStaffEditorState.lockModeNavigation\">\n    <div class=\"swtoolbar\">\n      <div class=\"swtoolbar-group pull-left\">\n        <img class=\"sws-logo sws-logo-link\" src=\"assets/images/sws-logo-light.png\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\" uib-tooltip=\"{{\'labels.Back to Productions\' | translate}}\">\n      </div>\n      <div class=\"swtoolbar-group pull-left\">\n        <button id=\"menu-locknavigation\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.toggleLockModeNavigation()\" ng-class=\"{\'sw-active\': vm.chartStaffEditorState.lockModeNavigation}\" ng-disabled=\"vm.scenes.length === 0\" uib-tooltip=\"Toggle lock navigation mode\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-unlock\"></span>\n        </button>\n        <button id=\"menu-switchview\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.switchEditorView\" uib-tooltip=\"Switch to other Views\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <div class=\"sw-btn-toolbar-vcontent\">\n          <span class=\"title\">Charts &amp; Score</span>\n          <span class=\"sw-ionicon-fw ion-arrow-down-b icon\"></span>\n        </div>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.switchEditorView\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.View</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-click=\"vm.switchEditor(0)\">\n                <span class=\"title\" translate>labels.Charts</span>\n              </div>\n              <div class=\"menu-item\" ng-click=\"vm.switchEditor(1)\">\n                <span class=\"title\" translate>labels.Score</span>\n              </div>\n              <div class=\"menu-item\" ng-disabled=\"true\">\n                <span class=\"title\" translate>labels.Charts and Score</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n      <div class=\"swtoolbar-group pull-left\">\n        <button id=\"menu-staffzoom\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.zoomPicker\" uib-tooltip=\"Score Zoom\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-zoom\"></span>\n          <span class=\"toolbar-zoom-value\" ng-hide=\"vm.chartStaffEditorState.staffAutoFitWidth\" translate>labels.1x</span>\n          <span class=\"toolbar-zoom-value\" ng-show=\"vm.chartStaffEditorState.staffAutoFitWidth\" translate>labels.Auto</span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.zoomPicker\">\n          <div class=\"sw-popover-title\">\n            <span>{{\'titles.Score Zoom\'| translate}}</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\" style=\"min-width: 176px\">\n              <div class=\"menu-item\" ng-click=\"vm.setStaffAutoFitWidth(false)\" ng-disabled=\"!vm.chartStaffEditorState.staffAutoFitWidth\">\n                <span class=\"title\">\n                  <span translate>labels.Original Size</span>\n                  <span class=\"pull-right\">({{\'labels.1x\' | translate}})</span>\n                </span>\n              </div>\n              <div class=\"menu-item\" ng-click=\"vm.setStaffAutoFitWidth(true)\" ng-disabled=\"vm.chartStaffEditorState.staffAutoFitWidth\">\n                <span class=\"title\">\n                  <span translate>labels.Auto Fit Width</span>\n                  <span class=\"pull-right\">({{\'labels.Auto\' | translate}})</span>\n                </span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n      <div class=\"swtoolbar-group pull-right\">\n        <div class=\"swtoolbar-group swtoolbar-group-rightmost pull-right\">\n          <button id=\"menu-savechanges\" class=\"btn sw-btn-toolbar\" ng-disabled=\"true\" ng-hide=\"true\" uib-tooltip=\"Save changes\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n            <span class=\"swafont swafont-lg swafont-icon-save\"></span>\n          </button>\n          <button id=\"menu-createpdf\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.pdfOptionsPicker\" uib-tooltip=\"PDF / printing options\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n            <span class=\"swafont swafont-lg swafont-icon-create-pdf\"></span>\n          </button>\n          <stackable-popover stackable-placement=\"bottom\" stackable-alignment=\"right\" stackable-enable-escape=\"true\" stackable=\"vm.pdfOptionsPicker\">\n            <div class=\"sw-popover-title\">\n              <span translate>titles.Create PDF</span>\n            </div>\n            <div class=\"sw-popover-menu\" role=\"menu\">\n              <div class=\"menu-group\">\n                <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllChartsStaffs)\">\n                  <span class=\"title\" translate>labels.Production - Charts &amp; Score</span>\n                </div>\n                <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 1)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0) || !vm.script\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllChartsScript)\">\n                  <span class=\"title\" translate>labels.Production - Charts &amp; PDF</span>\n                </div>\n                <div class=\"menu-item\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllCharts)\">\n                  <span class=\"title\" translate>labels.Production - Charts</span>\n                </div>\n                <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllStaffs)\">\n                  <span class=\"title\" translate>labels.Production - Score</span>\n                </div>\n                <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 1)\" ng-disabled=\"!vm.script\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.Script)\">\n                  <span class=\"title\" translate>labels.Production - PDF</span>\n                </div>\n              </div>\n              <div class=\"menu-group\">\n                <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneChartsStaffs)\">\n                  <span class=\"title\" translate>labels.Current Scene - Charts &amp; Score</span>\n                </div>\n                <div class=\"menu-item\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneCharts)\">\n                  <span class=\"title\" translate>labels.Current Scene - Charts</span>\n                </div>\n                <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneStaffs)\">\n                  <span class=\"title\" translate>labels.Current Scene - Score</span>\n                </div>\n              </div>\n              <div class=\"menu-group\">\n                <div class=\"menu-item\" ng-disabled=\"!vm.selectedChart\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentChart)\">\n                  <span class=\"title\" translate>labels.Current Chart</span>\n                </div>\n                <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedStaff\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentStaff)\">\n                  <span class=\"title\" translate>labels.Current Score</span>\n                </div>\n              </div>\n              <div class=\"menu-group-title\">\n                <span translate>labels.Recent PDFs</span>\n              </div>\n              <div class=\"menu-group\" swa-print-job-list data-list=\"vm.printJobs\">\n              </div>\n            </div>\n          </stackable-popover>\n          <button id=\"menu-collaborators\" class=\"btn sw-btn-toolbar\" ng-show=\"vm.selectedProduction.collaborationsettings.length > 0\" uib-tooltip=\"Collaboration details\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n            <span swa-show-collaborators data-production=\"vm.selectedProduction\" data-current-user-id=\"vm.userId\" class=\"sw-ionicon-2x ion-person-stalker\"></span>\n          </button>\n          <button id=\"menu-settings\" class=\"btn sw-btn-toolbar\" ui-sref=\"{{vm.swaRouterStateNames.productionsettings.details}}\" uib-tooltip=\"Production Settings\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n            <span class=\"swafont swafont-lg swafont-icon-settings\"></span>\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"swtoolbar swtoolbar-lockmode text-center\" ng-show=\"vm.chartStaffEditorState.lockModeNavigation\">\n    <div class=\"swtoolbar-group pull-left\">\n      <img class=\"sws-logo\" src=\"assets/images/sws-logo-light.png\">\n    </div>\n    <div class=\"swtoolbar-group pull-left\">\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.toggleLockModeNavigation()\" ng-class=\"{\'sw-active\': vm.chartStaffEditorState.lockModeNavigation}\" uib-tooltip=\"Toggle lock navigation mode\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-lock\"></span>\n      </button>\n      <button id=\"menu-switchview2\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.switchEditorView2\" uib-tooltip=\"Switch to other Views\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n      <div class=\"sw-btn-toolbar-vcontent\">\n        <span class=\"title\">Charts &amp; Score</span>\n        <span class=\"sw-ionicon-fw ion-arrow-down-b icon\"></span>\n      </div>\n      </button>\n      <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.switchEditorView2\">\n        <div class=\"sw-popover-title\">\n          <span translate>titles.View</span>\n        </div>\n        <div class=\"sw-popover-menu\" role=\"menu\">\n          <div class=\"menu-group\">\n            <div class=\"menu-item\" ng-click=\"vm.switchEditor(0)\">\n              <span class=\"title\" translate>labels.Charts</span>\n            </div>\n            <div class=\"menu-item\" ng-click=\"vm.switchEditor(1)\">\n              <span class=\"title\" translate>labels.Score</span>\n            </div>\n            <div class=\"menu-item\" ng-disabled=\"true\">\n              <span class=\"title\" translate>labels.Charts and Score</span>\n            </div>\n          </div>\n        </div>\n      </stackable-popover>\n    </div>\n    <div class=\"swtoolbar-group swtoolbar-group-centered\">\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationPreviousScene()\">\n        <span class=\"sw-ionicon-fw ion-chevron-left\"></span>\n        {{\'buttons.Scene\' | translate}}\n      </button>\n      <span class=\"spacer8\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationPreviousStaff()\">\n        <span class=\"sw-ionicon-fw ion-chevron-left\"></span>\n        {{\'buttons.Score\' | translate}}\n      </button>\n      <span class=\"spacer16\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationNextStaff()\">\n        {{\'buttons.Score\' | translate}}\n        <span class=\"sw-ionicon-fw ion-chevron-right\"></span>\n      </button>\n      <span class=\"spacer8\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationNextScene()\">\n        {{\'buttons.Scene\' | translate}}\n        <span class=\"sw-ionicon-fw ion-chevron-right\"></span>\n      </button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <span class=\"swa-color-lightgray sw-text-lg\" translate>titles.Charts and Score View</span>\n    </div>\n  </div>\n  <div>\n    <div id=\"sidebar-scenelist\" class=\"sw-sidebar sw-sidebar-nofooter sw-sidebar-lg-withchart sw-sidebar-left\">\n      <div class=\"sw-navbar sw-navbar-top sw-color-red\">\n        <div class=\"swtoolbar\">\n          <button id=\"view-productions\" class=\"btn btn-lg sw-btn-toolbar\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n          <div class=\"text-lg sw-truncatetext\" style=\"width: calc(100% - 50px)\">\n            <span>{{vm.selectedProduction.name}}</span>\n          </div>\n        </div>\n      </div>\n      <div class=\"scrollcontainer\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\" ng-scrollbars-update=\"vm.scrollUpdateSidebar\">\n        <uib-accordion class=\"sidebar-scenecontents-list\" close-others=\"true\" ng-class=\"{\'clickthrough\': vm.chartStaffEditorState.lockModeNavigation}\">\n          <div uib-accordion-group class=\"stickyheader\" is-open=\"false\" ng-show=\"vm.sceneSticky\">\n            <uib-accordion-heading>\n              <div class=\"sw-color-red\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleScene(vm.selectedScene)\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{vm.selectedScene.scenename}}</span>\n                </div>\n                <div class=\"pull-right\">\n                  <span class=\"sw-ionicon-fw ion-chevron-down\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n          </div>\n          <div uib-accordion-group id=\"scene-group-{{$index}}\" is-open=\"scene.open\" ng-repeat=\"scene in vm.scenes | limitTo: vm.activePlanRules.allowedNumberOfScenes\">\n            <uib-accordion-heading>\n              <div ng-class=\"{\'sw-color-red\': scene.open}\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleScene(scene)\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{scene.scenename}}</span>\n                </div>\n                <div class=\"pull-right\">\n                  <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-chevron-down\': scene.open, \'ion-chevron-right\': !scene.open}\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n            <div>\n              <div id=\"chart-{{chart._id}}\" data-drag=\"vm.newChartLinkTracker.enableLinking\" data-jqyoui-options=\"{helper: \'clone\', scroll: false, revert: \'invalid\', appendTo: \'body\'}\" data-swa-chartid=\"{{chart._id}}\" jqyoui-draggable=\"{animate: true, onDrag: \'vm.onDragDrag()\', onStop: \'vm.onDragStop()\'}\" ng-repeat=\"chart in scene.charts | limitTo: vm.activePlanRules.allowedNumberOfCharts\" class=\"sidebar-chart-row sidebar-chart-row-fw\" ng-class=\"{\'lockmode\': vm.chartStaffEditorState.lockModeNavigation, \'lock-highlight\': (vm.chartStaffEditorState.lockHighlightChartId === chart._id)}\">\n                <div class=\"chart-item-block\">\n                  <div class=\"chart-thumb\">\n                    <img class=\"img-responsive\" ng-src=\"data:image/png;base64,{{chart.thumbimage}}\">\n                  </div>\n                  <div class=\"title text-center sw-truncatetext\">\n                    <span ng-if=\"vm.chartStaffEditorState.chartNumberAutomatic\">{{\'labels.Chart\'| translate}}:\n                      {{scene.orderingindex + 1}}.{{chart.orderingindex + 1}}</span>\n                    <span ng-if=\"!vm.chartStaffEditorState.chartNumberAutomatic\">\n                      <span ng-show=\"chart.customname && chart.customname.length > 0\">{{chart.customname}}</span>\n                      <span ng-show=\"!chart.customname || chart.customname.length === 0\" class=\"sw-color-gray\">&lt;unnamed&gt;</span>\n                    </span>\n                    <div class=\"pull-right\" ng-if=\"!scene.accessRules.allowowneraccess\">\n                      <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-person-stalker\': scene.accessRules.allowchartstafflinking, \'ion-locked\': !scene.accessRules.allowchartstafflinking}\"></span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"sidebar-staff-row text-center\" ng-if=\"scene.noCharts\">\n              <em class=\"sidebar-hint-text\" translate>labels.No Charts</em>\n            </div>\n          </div>\n        </uib-accordion>\n      </div>\n    </div>\n    <div class=\"sw-maincontentarea-chartstaff sw-editorcontent\" ng-class=\"{\'sw-color-bg-white\': vm.chartStaffEditorState.showingStaffContent}\">\n      <div style=\"margin-left: 48px\" ng-show=\"vm.chartStaffEditorState.showingStaffContent && !vm.chartStaffEditorState.lockModeNavigation && vm.activeAccessRules.allowchartstafflinking\">\n        <span class=\"swa-ionicon ion-information-circled\"></span><span translate>messages.Drag and drop a chart over a score to link them</span>\n      </div>\n      <div data-drop=\"true\" id=\"staffscrollview\" class=\"staffscrollview\" jqyoui-droppable=\"{multiple: false, onDrop: \'vm.onDropLinkTarget()\'}\"></div>\n    </div>\n    <div class=\"sw-maincontentarea-chartstaff sw-editorcontent\" ng-show=\"!vm.chartStaffEditorState.showingStaffContent\">\n      <div class=\"text-center sw-color-lightgray\" style=\"top: 50%; transform: translateY(-50%); position:relative\">\n        <div style=\"margin-bottom: 16px\">\n          <span class=\"sw-text-xlg\" translate>titles.Charts and Score View</span>\n        </div>\n        <div class=\"show-when-blocked\">\n          <span>Loading ...</span>\n        </div>\n        <div class=\"hide-when-blocked\">\n          <div ng-show=\"vm.selectedProduction && (vm.scenes.length === 0)\">\n            <span class=\"sw-text-lg\" translate>messages.No Scenes in this Production</span><br>\n          </div>\n          <span class=\"sw-text-lg\" ng-show=\"(vm.scenes.length !== 0) && !vm.sidebarEditState.enabled && (vm.selectedSceneId === undefined)\" translate>labels.No Scene</span>\n          <span class=\"sw-text-lg\" ng-show=\"(vm.selectedSceneId !== undefined) && !vm.chartStaffEditorState.showingStaffContent\" translate>labels.No Score in Scene</span>\n        </div>\n      </div>\n    </div>\n    <div class=\"sw-maincontentarea-chartstaff-footer sw-color-bg-sidebar\">\n      <span class=\"sw-text-xlg swa-color-lightgray\">{{vm.selectedScene.scenename}}</span>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/chartVideo/chartVideo.html","<div class=\"modal-header\">\n  <span class=\"modal-title sw-color-red\" translate>titles.Chart Video</span>\n  <button type=\"button\" class=\"btn sw-btn-toolbar pull-right\" ng-click=\"vm.modalClose()\">\n    <span class=\"sw-color-red sw-ionicon-lg ion-close-round\"></span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <iframe id=\"chartVideoIframe\" class=\"chartVideoIframe\" width=\"870\" height=\"490\" ng-src=\"{{vm.embedUrl}}\" frameborder=\"0\" allowfullscreen></iframe>\n</div>\n");
$templateCache.put("app/components/collaboratorList/collaboratorList.html","<div class=\"modal-header\">\n  <span class=\"modal-title\" translate>titles.Collaborators</span>\n  <button class=\"btn btn-sm sw-btn-default pull-right\" ng-click=\"vm.editCollaborators()\" ng-show=\"vm.userIsProductionOwner\" translate>buttons.Edit</button>\n</div>\n<div class=\"modal-body\">\n  <div ng-repeat=\"collaborator in vm.collaboratorData\">\n    <span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-person\': collaborator.isOwner, \'ion-person-stalker\': collaborator.isMember, \'ion-email\': collaborator.isInvited}\"></span>\n    <span ng-hide=\"collaborator.displayName\" class=\"swa-color-gray\">...</span>\n    <span ng-show=\"collaborator.displayName\" ng-class=\"{\'swa-color-lightgraygray\': collaborator.displayNameError, \'swa-color-lightgray\': !collaborator.isCurrentUser, \'swa-color-whitelightgray\': collaborator.isCurrentUser}\">{{collaborator.displayName}}\n      <span ng-show=\"collaborator.isOwner\">(Owner)</span>\n      <span ng-show=\"collaborator.isCurrentUser\">(You)</span>\n    </span>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn btn-sm sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.modalClose()\" translate>buttons.Close</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/login/forgotPassword.html","<div style=\"height: 100%\">\n  <div class=\"margin-side-auto width-360 v-center-30\">\n    <div class=\"sw-gray-panel\" block-ui=\"block-ui-forgotpassword\" ng-cloak>\n      <div>\n        <img alt=\"\" class=\"sws-logo-title\" src=\"assets/images/sws-logo-light.png\">\n        <form class=\"sw-gray-form\" name=\"forgotForm\" ng-submit=\"vm.resetMyPassword(forgotForm)\" novalidate ng-hide=\"vm.forgotPasswordParams.emailSent\">\n          <input id=\"email\" class=\"form-control mrgnbtm10\" name=\"email\" type=\"email\" ng-model=\"vm.forgotPasswordParams.email\" placeholder=\"Email address\" required swa-validate-email>\n          <div ng-show=\"forgotForm.$submitted\">\n            <p class=\"sw-color-red\" ng-show=\"forgotForm.email.$error.required\" translate>messages.Email address is required</p>\n            <p class=\"sw-color-red\" ng-show=\"(forgotForm.email.$error.email)\" translate>messages.Please enter a valid email address</p>\n          </div>\n          <div>\n            <p class=\"sw-color-red\" ng-show=\"vm.validationErrors.emailUnknown\" translate>messages.No registered user with that email address</p>\n          </div>\n          <p class=\"sw-color-red\" ng-show=\"forgotForm.$pristine && vm.validationErrors.serverError\">{{\'labels.Error:\' | translate}}\n            {{vm.validationErrors.serverErrorMessage}}</p>\n          <button class=\"btn btn-lg btn-block sw-btn-danger-solid\" translate type=\"submit\" value=\"Reset My Password\">buttons.Reset My Password</button>\n        </form>\n        <div class=\"sw-color-white sw-text-lg text-center\" style=\"padding: 16px 32px\" ng-show=\"vm.forgotPasswordParams.emailSent\">\n          <p translate translate-values=\"{toemail: vm.forgotPasswordParams.email}\">messages.password_reset_email_sent_to</p>\n        </div>\n        <div class=\"sw-gray-content\" ng-if=\"!vm.embedded\">\n          <p class=\"pull-left\">\n            <a class=\"sw-a-link\" ui-sref=\"{{vm.swaRouterStateNames.login}}({redirectreason: \'login\'})\" translate>buttons.Already have an account?</a>\n          </p>\n          <p class=\"pull-right\">\n            <a class=\"sw-a-link\" ui-sref=\"{{vm.swaRouterStateNames.registration}}\" translate>buttons.Sign Up</a>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/login/login.html","<div style=\"height: 100%\">\n  <div class=\"margin-side-auto width-360 v-center-30\">\n    <div class=\"sw-gray-panel\" block-ui=\"block-ui-login\" ng-cloak>\n      <img alt=\"\" class=\"sws-logo-title\" src=\"assets/images/sws-logo-light.png\">\n      <form class=\"sw-gray-form\" name=\"loginForm\" role=\"form\" novalidate=\"\" ng-submit=\"loginForm.$valid && vm.login(loginForm)\">\n        <input id=\"username\" class=\"form-control mrgnbtm-1 radiusbtm-rgt-lft0\" name=\"username\" ng-model=\"vm.loginParams.username\" placeholder=\"{{\'labels.Username\'| translate}}\" type=\"text\" required autocomplete=\"username email\" swa-on-enter=\"vm.focusNext(\'password\')\">\n        <input id=\"password\" class=\"form-control radiustop-rgt-lft0 mrgnbtm10\" name=\"password\" ng-model=\"vm.loginParams.password\" placeholder=\"{{\'labels.Password\'| translate}}\" type=\"password\" required ng-paste=\"$event.preventDefault()\" autocomplete=\"current-password\">\n        <div ng-show=\"loginForm.$submitted\">\n          <p class=\"sw-color-red\" ng-show=\"loginForm.username.$error.required\" translate>messages.Username is required</p>\n          <p class=\"sw-color-red\" ng-show=\"loginForm.password.$error.required\" translate>messages.Password is required</p>\n        </div>\n        <div ng-show=\"loginForm.$pristine\">\n          <p class=\"sw-color-red\" ng-show=\"vm.validationErrors.authenticationError\" translate>messages.The username or password you entered is incorrect.</p>\n          <p class=\"sw-color-red\" ng-show=\"vm.validationErrors.serverError\">{{\'labels.Error:\' | translate}} {{vm.validationErrors.serverErrorMessage}}</p>\n        </div>\n        <button class=\"btn btn-lg btn-block sw-btn-danger-solid\" type=\"submit\" translate>buttons.Log In</button>\n      </form>\n      <div>\n        <p class=\"text-center\">\n          <a class=\"sw-a-link\" ui-sref=\"{{vm.swaRouterStateNames.forgotpassword}}\" translate>buttons.Forgot Password?</a>\n        </p>\n        <p class=\"text-center\">\n          <a class=\"sw-a-link\" ui-sref=\"{{vm.swaRouterStateNames.registration}}\" translate>buttons.Sign Up</a>\n        </p>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/login/registration.html","<div style=\"height: 100%\">\n  <div class=\"margin-side-auto width-360 v-center-30\">\n    <div class=\"sw-gray-panel\" block-ui=\"block-ui-reg\" ng-cloak>\n      <div>\n        <img alt=\"\" class=\"sws-logo-title\" src=\"assets/images/sws-logo-light.png\">\n        <form class=\"sw-gray-form\" name=\"vm.registrationForm\" ng-submit=\"vm.createUser()\" novalidate>\n          <input id=\"firstname\" class=\"form-control mrgnbtm-1 radiusbtm-rgt-lft0\" name=\"firstName\" ng-model=\"vm.registrationParams.firstName\" placeholder=\"{{\'labels.First Name\'| translate}}\" required type=\"text\">\n          <input class=\"form-control mrgnbtm-1 radiusbtm-rgt-lft0\" name=\"lastName\" ng-model=\"vm.registrationParams.lastName\" placeholder=\"{{\'labels.Last Name (optional)\'| translate}}\" type=\"text\">\n          <input class=\"form-control mrgnbtm-1 radius0\" name=\"email\" ng-model=\"vm.registrationParams.email\" placeholder=\"{{\'labels.Email\'| translate}}\" required type=\"email\" swa-validate-email>\n          <input class=\"form-control mrgnbtm-1 radius0\" name=\"password\" ng-model=\"vm.registrationParams.password\" placeholder=\"{{\'labels.Password\'| translate}}\" required type=\"password\" ng-paste=\"$event.preventDefault()\">\n          <input class=\"form-control mrgnbtm-1 radius0\" name=\"confirmPassword\" ng-model=\"vm.registrationParams.confirmPassword\" placeholder=\"{{\'labels.Confirm Password\'| translate}}\" required type=\"password\" match-password=\"password\" ng-paste=\"$event.preventDefault()\">\n          <input hidden name=\"reCaptchaResponse\" ng-model=\"vm.registrationParams.gRecaptchaResponse\" required type=\"text\">\n          <div class=\"form-control radiustop-rgt-lft0 mrgnbtm10 nocaptcha-container\" no-captcha control=\"vm.noCaptchaControl\" g-recaptcha-response=\"vm.registrationParams.gRecaptchaResponse\" data-expired-callback=\"vm.captchaExpiredHandler\"></div>\n          <div ng-show=\"vm.registrationForm.$submitted\">\n            <p class=\"sw-color-red\" ng-show=\"vm.registrationForm.firstName.$error.required\" translate>messages.First Name is required</p>\n            <p class=\"sw-color-red\" ng-show=\"vm.registrationForm.email.$error.required\" translate>messages.Email address is required</p>\n            <p class=\"sw-color-red\" ng-show=\"(vm.registrationForm.email.$error.email)\" translate>messages.Please enter a valid email address</p>\n            <p class=\"sw-color-red\" ng-show=\"vm.registrationForm.password.$error.required\" translate>messages.Password is required</p>\n            <p class=\"sw-color-red\" ng-show=\"vm.registrationForm.confirmPassword.$error.required\" translate>messages.Please confirm your password</p>\n            <p class=\"sw-color-red\" ng-show=\"vm.registrationForm.confirmPassword.$error.passwordMatch\" translate>messages.Your passwords do not match</p>\n            <p class=\"sw-color-red\" ng-show=\"vm.registrationForm.reCaptchaResponse.$error.required\" translate>messages.Please respond to the CAPTCHA</p>\n          </div>\n          <p class=\"sw-color-red\" ng-show=\"vm.registrationForm.$pristine && vm.validationErrors.serverError\">{{\'labels.Error:\' | translate}} {{vm.validationErrors.serverErrorMessage}}</p>\n          <p class=\"sw-color-red\" ng-show=\"vm.registrationForm.$pristine && vm.validationErrors.emailAlreadyUsed\" translate>messages.Another user has already signed up with this email address, please provide a different one</p>\n          <p class=\"sw-color-red\" ng-show=\"vm.registrationForm.$pristine && vm.validationErrors.recaptchaVerificationFailed\" translate>messages.CAPTCHA verification failed, try again</p>\n          <p class=\"sw-color-red\" ng-show=\"vm.validationErrors.recaptchaLoadError\" translate>messages.Failed to load reCAPTCHA, reload the page and try again.</p>\n          <p class=\"sw-color-lightgray\">By signing up, you agree to the\n            <a class=\"sw-a-link sw-a-link-underline\" ng-click=\"vm.showTermsOfServices()\">Terms of Use</a>\n            and\n            <a class=\"sw-a-link sw-a-link-underline\" ng-click=\"vm.showPrivacyPolicy()\">Privacy Policy.</a>\n          </p>\n          <button class=\"btn btn-lg btn-block sw-btn-danger-solid\" type=\"submit\" translate>buttons.Sign Up</button>\n        </form>\n        <div class=\"sw-gray-content termsofuse\">\n          <p class=\"text-center\">\n            <a class=\"sw-a-link\" ui-sref=\"{{vm.swaRouterStateNames.login}}({redirectreason: \'login\'})\" translate>buttons.Already have an account?</a>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<script id=\"termsofservicesModal.html\" type=\"text/ng-template\">\n  <div class=\"modal-header\">\n    <span class=\"modal-title\">Terms of Use</span>\n  </div>\n  <div class=\"modal-body swa-tos-modal\" style=\"height: 75vh;\">\n    <embed src=\"/staticpages/SWSoftwareToU.pdf\" width=\"100%\" height=\"100%\" type=\'application/pdf\'>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn sw-btn-secondary\" ng-click=\"vm.okAction()\" style=\"min-width: 60px;\">OK</button>\n  </div>\n</script>\n\n<script id=\"privacypolicyModal.html\" type=\"text/ng-template\">\n  <div class=\"modal-header\">\n    <span class=\"modal-title\">Privacy Policy</span>\n  </div>\n  <div class=\"modal-body swa-privacy-modal\" style=\"height: 75vh;\">\n    <embed src=\"/staticpages/SWSoftwarePPF.pdf\" width=\"100%\" height=\"100%\" type=\'application/pdf\'>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn sw-btn-secondary\" ng-click=\"vm.okAction()\" style=\"min-width: 60px;\">OK</button>\n  </div>\n</script>\n");
$templateCache.put("app/components/login/registrationBlocked.html","<div style=\"height: 100%\">\n  <div class=\"margin-side-auto width-360 v-center-30\">\n    <div class=\"sw-gray-panel\" block-ui=\"block-ui-reg\" ng-cloak>\n      <div>\n        <img alt=\"\" class=\"sws-logo-title\" src=\"assets/images/sws-logo-light.png\">\n        <div class=\"text-center\" style=\"padding: 16px 32px\">\n          <span class=\"sw-text-xlg sw-color-lightgray\">Sorry we are not open to the public yet!</span>\n        </div>\n        <div class=\"sw-gray-content termsofuse\">\n          <p class=\"text-center\">\n            <a class=\"sw-a-link\" ui-sref=\"{{vm.swaRouterStateNames.login}}({redirectreason: \'login\'})\" translate>buttons.Already have an account?</a>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/login/resetPassword.html","<div style=\"height: 100%\">\n  <div class=\"margin-side-auto width-360 v-center-30\">\n    <div class=\"sw-gray-panel\" block-ui=\"block-ui-reset\" ng-cloak>\n      <div>\n        <img alt=\"\" class=\"sws-logo-title\" src=\"assets/images/sws-logo-light.png\">\n        <form class=\"sw-gray-form\" name=\"vm.resetPasswordForm\" ng-submit=\"vm.resetPassword()\" novalidate ng-show=\"vm.resetPasswordParams.resetPending\">\n          <input id=\"password\" class=\"form-control mrgnbtm-1 radiusbtm-rgt-lft0\" name=\"newPassword\" ng-model=\"vm.resetPasswordParams.newPassword\" placeholder=\"Your new password\" required type=\"password\">\n          <input class=\"form-control radiustop-rgt-lft0 mrgnbtm10\" name=\"confirmPassword\" ng-model=\"vm.resetPasswordParams.confirmPassword\" placeholder=\"Confirm Password\" required type=\"password\" match-password=\"newPassword\">\n          <div ng-show=\"vm.resetPasswordForm.$submitted || vm.resetPasswordForm.newPassword.$touched\">\n            <p class=\"sw-color-red\" ng-show=\"vm.resetPasswordForm.newPassword.$error.required\" translate>messages.New password is required</p>\n          </div>\n          <div ng-show=\"vm.resetPasswordForm.$submitted || vm.resetPasswordForm.confirmPassword.$touched\">\n            <p class=\"sw-color-red\" ng-show=\"vm.resetPasswordForm.confirmPassword.$error.required\" translate>messages.Please confirm your password</p>\n            <p class=\"sw-color-red\" ng-show=\"vm.resetPasswordForm.confirmPassword.$error.passwordMatch\" translate>messages.Your passwords do not match</p>\n          </div>\n          <p class=\"sw-color-red\" ng-show=\"vm.resetPasswordForm.$pristine && vm.validationErrors.serverError\">{{\'labels.Error:\' | translate}}\n            {{vm.validationErrors.serverErrorMessage}}</p>\n          <button class=\"btn btn-lg btn-block sw-btn-danger-solid\" translate type=\"submit\" value=\"Reset My Password\">buttons.Reset My Password</button>\n        </form>\n        <div class=\"sw-color-white sw-text-lg text-center\" style=\"padding: 16px 32px\" ng-show=\"vm.resetPasswordParams.tokenError\">\n          <p>{{\'messages.reset_password_tokenerror\' | translate}}\n            <a class=\"sw-a-link\" ui-sref=\"{{vm.swaRouterStateNames.forgotpassword}}\" translate>buttons.Forgot Password?</a>\n          </p>\n        </div>\n        <div class=\"sw-color-white sw-text-lg text-center\" style=\"padding: 16px 32px\" ng-show=\"vm.resetPasswordParams.resetSuccess\">\n          <p translate>messages.reset_password_success</p>\n        </div>\n        <div>\n          <p class=\"text-center\">\n            <a class=\"sw-a-link\" ui-sref=\"{{vm.swaRouterStateNames.login}}({redirectreason: \'login\'})\" translate>buttons.Back To Login</a>\n          </p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionList/addProductionPrompt.html","<form class=\"form-horizontal sw-form\" name=\"vm.addProductionForm\" novalidate=\"\" role=\"form\">\n  <div class=\"modal-header\">\n    <span class=\"modal-title\">New Production</span>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\" for=\"productionname\" translate>labels.Name</label>\n      <div class=\"col-sm-10\">\n        <input class=\"form-control\" id=\"productionname\" name=\"productionname\" ng-model=\"vm.newProduction.name\" required=\"\" type=\"text\">\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-2 control-label\" for=\"productiontype\" translate>labels.Type</label>\n      <div class=\"col-sm-10\" id=\"productiontype\">\n        <div class=\"btn-group sw-btn-group-radio-2\">\n          <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.newProduction.type === 1}\" ng-click=\"vm.newProduction.type = 1\" type=\"button\">\n            <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.newProduction.type === 1, \'ion-android-radio-button-off\':vm.newProduction.type === 0}\"></span>\n            {{\'buttons.Charts and PDF\' | translate}}\n          </button>\n          <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.newProduction.type === 0}\" ng-click=\"vm.newProduction.type = 0\" type=\"button\">\n            <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.newProduction.type === 0, \'ion-android-radio-button-off\':vm.newProduction.type === 1}\"></span>\n            {{\'buttons.Charts and Staging Score\' | translate}}\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"text-right\">\n      <button class=\"btn sw-btn-secondary sw-btn-min-w-80 pull-left\" ng-click=\"vm.promptRestoreBackupProduction()\" style=\"margin-right: 10px\" translate>buttons.Restore from Backup</button>\n      <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.add()\" style=\"margin-right: 10px\" translate type=\"submit\">buttons.Add</button>\n      <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.cancel()\" translate>buttons.Cancel</button>\n    </div>\n  </div>\n</form>\n");
$templateCache.put("app/components/productionList/addRestoreBackupProductionPrompt.html","<form class=\"form-horizontal sw-form\" novalidate=\"\" role=\"form\">\n    <div class=\"modal-header\">\n      <span class=\"modal-title\">Restore from Backup</span>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-group\">\n        <div class=\"col-sm-9\">\n          <input class=\"form-control\" ng-model=\"vm.restoreBackupState.filename\" type=\"text\" placeholder=\"Select a backup file...\" readonly=\"readonly\">\n        </div>\n        <div class=\"col-sm-3\">\n          <input class=\"form-control\" id=\"backupFile\" name=\"backupFile\" accept=\".stagewrite\" swa-file-arraybuffer=\"vm.processSelectedBackupFile($filename, $arrayBuffer, $error)\" ng-hide=\"true\" required=\"\" type=\"file\">\n          <button id=\"select-file\" class=\"btn btn-sm btn-block sw-btn-secondary\" onclick=\"jQuery(\'input#backupFile\').click()\" type=\"button\" translate>{{\'buttons.Select\'}}</button>\n        </div>\n        <div ng-show=\"vm.restoreBackupState.error\" class=\"col-sm-12\">\n          <p class=\"sw-color-red\">{{vm.restoreBackupState.errorMessage}}</p>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div ng-show=\"vm.restoreBackupState.canRestore\" class=\"col-sm-12\">\n          <div>Backup Details</div>\n          <div class=\"container-fluid sw-color-bg-form\">\n            <div class=\"row\">\n              <label class=\"col-lg-4 control-label\">Production Name:</label>\n              <p class=\"col-lg-8 form-control-static sw-color-lightgray\">{{vm.restoreBackupState.restoreMetadata.productionName}}</p>\n            </div>\n            <div class=\"row\">\n              <label class=\"col-lg-4 control-label\">Created On:</label>\n              <p class=\"col-lg-8 form-control-static sw-color-lightgray\">{{vm.restoreBackupState.restoreMetadata.created | date : \'MMM dd, yyyy hh:mm\' }}</p>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div ng-show=\"vm.restoreBackupState.canRestore\" class=\"col-sm-12\">\n          <label for=\"productionname\" translate>labels.New Production Name</label>\n          <input class=\"form-control\" id=\"productionname\" name=\"productionname\" ng-model=\"vm.restoreBackupState.restoreMetadata.newProductionName\" required=\"\" type=\"text\">\n        </div>\n      </div>\n    </div>\n    <div class=\"modal-footer\">\n      <div class=\"text-right\">\n        <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-disabled=\"!vm.restoreBackupState.canRestore\" ng-click=\"vm.restore()\" style=\"margin-right: 10px\" translate type=\"submit\">buttons.Restore</button>\n        <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.cancel()\" translate>buttons.Cancel</button>\n      </div>\n    </div>\n  </form>\n");
$templateCache.put("app/components/productionList/checkoutReturn.html","<!-- SWA-1948 : -->");
$templateCache.put("app/components/productionList/downloadArchivePrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title\" translate>titles.Download Backup</span>\n</div>\n<div class=\"modal-body form-horizontal sw-form\">\n  <div class=\"form-group\" ng-hide=\"vm.archiveDetails.created\">\n    <div class=\"col-sm-12 text-center sw-text-lg\">\n      <strong>{{vm.archiveDetails.productionName}}</strong>\n    </div>\n  </div>\n  <div class=\"form-group\" ng-hide=\"vm.archiveDetails.created\">\n    <div class=\"col-sm-12\">\n      <span>Provide a Name (filename) and a Note for your reference and click \'Create\' to create a backup of this production.</span>\n    </div>\n  </div>\n  <div class=\"form-group\" ng-hide=\"vm.archiveDetails.created\">\n    <label class=\"col-sm-3 control-label\" for=\"archivefilename\" translate>labels.Name</label>\n    <div class=\"col-sm-9\">\n      <input class=\"form-control\" id=\"archivefilename\" name=\"archivefilename\" ng-model=\"vm.archiveDetails.name\" required=\"\" type=\"text\">\n    </div>\n  </div>\n  <div class=\"form-group\" ng-hide=\"vm.archiveDetails.created\">\n    <label class=\"col-sm-3 control-label\" for=\"productionname\" translate>labels.Note</label>\n    <div class=\"col-sm-9\">\n      <input class=\"form-control\" id=\"archivenote\" name=\"archivenote\" ng-model=\"vm.archiveDetails.note\" required=\"\" type=\"text\">\n    </div>\n  </div>\n  <div class=\"form-group\" ng-show=\"vm.archiveDetails.created\">\n    <div class=\"col-sm-12\">\n      <span>Your backup file is ready, click the \'Download\' button to download a copy.</span>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-hide=\"vm.archiveDetails.created\" ng-click=\"vm.createArchive()\" translate>buttons.Create</button>\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-show=\"vm.archiveDetails.created\" ng-click=\"vm.downloadArchive()\" translate>buttons.Download</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.close()\" translate>buttons.Close</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionList/enterpriseExpireSwitchPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title text-danger text-center\" translate>titles.Account Inactive</span>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\">The Enterprise Account of which you are a member is not Active. Would you like to switch to using your own Stage Write account?<br>\n    You will be on a View only plan on switch and you can upgrade to any paid plans from the subcscriptions page.\n</p>\n</div>\n<div class=\"modal-footer text-center\">\n<div class=\"text-center\">\n  <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n  <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n</div>\n</div>\n");
$templateCache.put("app/components/productionList/pendingPdfRequests.html","<div class=\"modal-header\">\n  <span class=\"modal-title\">{{\'titles.PDF Approvals - Pending Requests\' | translate}}\n    <button class=\"btn btn-sm sw-btn-secondary pull-right\" ng-click=\"vm.refreshJobList();\" translate>buttons.Refresh</button>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <div class=\"form-group\">\n    <table class=\"table table-inverse\">\n      <thead>\n        <tr>\n          <th>Date</th>\n          <th>Requested By</th>\n          <th>Production</th>\n          <th>Type</th>\n          <th>Watermark</th>\n          <th class=\"text-center\">Actions</th>\n        </tr>\n      </thead>\n      <tbody>\n        <tr ng-repeat=\"printJob in vm.printJobs\">\n          <td>{{printJob.created.$date | date:\'MMM dd, yyyy\'}}</td>\n          <td>{{printJob.requesterName}}</td>\n          <td>{{printJob.productionName}}</td>\n          <td ng-bind-html=\"printJob.displayName\"></td>\n          <td><input type=\"text\" class=\"form-control input-sm\" ng-model=\"printJob.watermarkText\"></td>\n          <td class=\"text-center\">\n            <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.approveJob($index);\" translate>buttons.Approve</button>\n            <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.rejectJob($index);\" translate>buttons.Reject</button>\n          </td>\n        </tr>\n      </tbody>\n    </table>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"row\">\n    <div class=\"col-sm-8 text-left\">\n      <div class=\"hint-icon-message hint-icon-message-autow\">\n        <div class=\"icon\">\n          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n        </div>\n        <div class=\"text\">\n          <span>Provide a short text to be used as the watermark before approving the request. Leave blank to use the requester\'s name as the watermark.</span>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-sm-4\">\n      <button class=\"btn sw-btn-secondary\" style=\"min-width: 60px\" ng-click=\"vm.close()\" translate>buttons.Close</button>    \n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionList/productionList.html","<swa-help-bar ng-if=\"vm.showHelpBar\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-videos=\"vm.helpTourVideos\" swa-help-tour-trigger=\"vm.helpTourStartTrigger\"></swa-help-bar>\n<div ng-cloak>\n  <div id=\"mainToolbar\" class=\"navbar navbar-fixed-top sw-navbar\">\n    <div class=\"swtoolbar\">\n      <div class=\"swtoolbar-group pull-left\">\n        <img class=\"sws-logo\" src=\"assets/images/sws-logo-light.png\">\n      </div>\n      <div class=\"swtoolbar-group pull-right\">\n        <button class=\"btn sw-btn-toolbar sw-btn-toolbar-user\" id=\"user-account\" stackable-trigger=\"userMenu\">\n          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-person\"></span>\n          <span ng-bind=\"vm.username\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"userMenu\">\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ui-sref=\"{{vm.swaRouterStateNames.myaccount}}\" id=\"production-list-my-account\">\n                <span class=\"title\" translate>labels.My Account</span>\n              </div>\n              <div class=\"menu-item\" id=\"production-list-pdf-requests\" ng-click=\"vm.showPdfRequests();userMenu.show = false;\">\n                <span class=\"title\" translate>labels.PDF Approvals</span>\n              </div>\n              <div class=\"menu-item\" ui-sref=\"{{vm.swaRouterStateNames.subscriptions}}\" id=\"production-list-subscription\">\n                <span class=\"title\" translate>labels.Subscriptions</span>\n              </div>\n            </div>\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-click=\"vm.logout()\">\n                <span class=\"title\" translate id=\"production-list-logout\">labels.Logout</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n    </div>\n  </div>\n  <div>\n    <div class=\"sw-sidebar sw-sidebar-left sw-sidebar-production-list\" ng-class=\"{\'sw-sidebar-w-search\': vm.activePlanRules.allowUnlimitedProductions, \'sw-sidebar-nofooter\': !vm.activePlanRules.allowUnlimitedProductions}\" uib-tooltip-html=\"vm.editFavoritesModeTooltipHtml\" tooltip-class=\"swa-tooltip\" tooltip-placement=\"right-top\" tooltip-is-open=\"vm.showEditFavoritesModeTooltip\" tooltip-trigger=\"\'none\'\" tooltip-popup-delay=\"0\">\n      <span spinner-key=\"spinner-sidebar\" us-spinner></span>\n      <div class=\"sw-navbar sw-navbar-top sw-color-red\">\n        <div ng-hide=\"vm.deletedProductionListMode\" class=\"swtoolbar\">\n          <div class=\"swtoolbar-group pull-left\">\n            <span class=\"text-lg\" translate>titles.Productions</span>\n          </div>\n          <div class=\"swtoolbar-group pull-right\">\n            <button id=\"show-trash\" class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.toggleDeletedProductionList()\" ng-hide=\"vm.editFavoritesMode || (vm.activePlanRules.planId === 3)\">\n              <span>{{\'titles.Trash\'|translate}}</span>\n              <span class=\"sw-ionicon sw-ionicon-lg ion-ios-trash-outline\"></span>\n            </button>\n            <button id=\"edit-favorites\" class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.toggleEditFavoritesMode()\" ng-if=\"vm.activePlanRules.allowFavoriteProductions\">\n              <span ng-hide=\"vm.editFavoritesMode\">Edit</span>\n              <span ng-show=\"vm.editFavoritesMode\">Done</span>\n              <span class=\"ion-heart\"></span>\n            </button>\n            <button id=\"add-production\" class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.promptAddProduction()\" ng-hide=\"vm.editFavoritesMode\" uib-tooltip=\"Add New Production\" tooltip-placement=\"right\">\n              <span class=\"ion-plus-round\"></span>\n            </button>\n          </div>\n        </div>\n\n        <div class=\"swtoolbar swtoolbar-flex swtoolbar-flex-align-center\" ng-hide=\"vm.deletedProductionListMode || !vm.activePlanRules.allowUnlimitedProductions\">\n          <div class=\"swtoolbar-group search-production-main\">\n            <input class=\"form-control\" id=\"searchproductionname\" name=\"searchproductionname\" ng-model=\"vm.searchproductionname\" ng-change=\"vm.searchStringChanged()\" type=\"text\" placeholder=\"Search ...\">\n            <button class=\"btn btn-lg sw-btn-toolbar search-text-remove\" ng-click=\"vm.clearSearch()\" ng-show=\"vm.searchproductionname.length > 0\">\n              <span class=\"sw-ionicon-lg ion-ios-close-outline\"></span>\n            </button>\n          </div>\n        </div>\n\n        <div ng-show=\"vm.deletedProductionListMode\" class=\"swtoolbar\">\n          <div class=\"swtoolbar-group pull-left\">\n            <button class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.toggleDeletedProductionList()\">\n              <span class=\"ion-chevron-left\"></span>\n            </button>\n            <span class=\"text-lg\" translate>titles.Trash</span>\n          </div>\n        </div>\n      </div>\n      <div class=\"scrollcontainer\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigProductions\">\n        <div ng-hide=\"vm.deletedProductionListMode\" class=\"sidebar-production-list\">\n          <div id=\"production-{{$index}}\" class=\"production-list-item\" ng-class=\"{\'locked\': (prod.denyAccess)}\" data-ng-repeat=\"prod in vm.productions | filter: vm.productionSearchFilter | orderBy: \'oIndex\' as results\" ng-click=\"vm.selectProduction(prod._id)\">\n            <div class=\"main-container\">\n              <div class=\"name-container\">\n                <span class=\"name\">{{prod.name}}</span>\n              </div>\n              <div class=\"logo-container\">\n                <img alt=\"Production Logo\" ng-src=\"data:image/png;base64,{{prod.logo}}\" ng-if=\"prod.logo\">\n                <img alt=\"Production Logo\" src=\"assets/images/SWS-Logo-Watermark@2x.png\" ng-if=\"!prod.logo\">\n              </div>\n            </div>\n            <div class=\"detail-container\">\n              <div class=\"icon-item\" ng-show=\"prod.productiontype === 0\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-musical-notes swa-color-lightgray\"></span>\n                <span class=\"swa-color-lightgray\" translate>labels.Charts & Score</span>\n              </div>\n              <div class=\"icon-item\" ng-show=\"prod.productiontype === 1\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-paper-outline swa-color-lightgray\"></span>\n                <span class=\"swa-color-lightgray\" translate>labels.Charts & PDF</span>\n              </div>\n              <div class=\"icon-item\" ng-show=\"vm.userId === prod.ownerId\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg ion-person swa-color-lightgray\"></span>\n                <span class=\"swa-color-lightgray\" translate>labels.Owner</span>\n              </div>\n              <div class=\"icon-item\" ng-show=\"vm.userId !== prod.ownerId\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg ion-person-stalker swa-color-lightgray\"></span>\n                <span class=\"swa-color-lightgray\" translate>labels.Collaborator</span>\n              </div>\n              <div class=\"icon-item\" ng-show=\"prod.isFavorite && vm.activePlanRules.allowFavoriteProductions\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg ion-heart swa-color-lightgray\"></span>\n                <span class=\"swa-color-lightgray\" translate>labels.Favorite</span>\n              </div>\n              <div class=\"icon-item\" ng-show=\"!prod.isFavorite && vm.editFavoritesMode\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg ion-heart swa-color-darkgray\"></span>\n              </div>\n              <button class=\"btn sw-btn-secondary btn-settings\" ng-click=\"$event.stopPropagation();vm.selectProductionSettings(prod._id);\" ng-hide=\"vm.editFavoritesMode\">\n                <span class=\"swafont swafont-lg swafont-icon-settings\" uib-tooltip=\"Open settings for this production\" tooltip-placement=\"right\" tooltip-class=\"swa-tooltip\"></span>\n              </button>\n              <button class=\"btn sw-btn-secondary btn-archive\" ng-click=\"$event.stopPropagation();vm.downloadArchivePrompt(prod._id);\" ng-show=\"vm.activePlanRules.allowBackupProductions && !vm.editFavoritesMode\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg ion-android-arrow-down\" uib-tooltip=\"Download a backup of this production\" tooltip-placement=\"right\" tooltip-class=\"swa-tooltip\"></span>\n              </button>\n            </div>\n          </div>\n        </div>\n\n        <div id=\"no-productions\" class=\"no-record-list\" ng-hide=\"results.length !== 0 || vm.deletedProductionListMode\">\n          <span>No matching Productions!</span>\n        </div>\n\n        <!-- SWA-1236-DELETED PRODUCTION LIST  -->\n        <div ng-show=\"vm.deletedProductionListMode\" class=\"sidebar-deleted-production-list\">\n          <div id=\"delproduction-{{$index}}\" class=\"production-list-item\" ng-class=\"{\'locked\': (delprod.denyAccess)}\" data-ng-repeat=\"delprod in vm.deletedproductions | orderBy: \'oIndex\'\">\n            <div class=\"main-container\">\n              <div class=\"name-container\">\n                <span class=\"name\">{{delprod.productionData.name}}</span>\n              </div>\n              <div class=\"logo-container\">\n                <img alt=\"Production Logo\" ng-src=\"data:image/png;base64,{{delprod.productionData.logo}}\" ng-if=\"delprod.productionData.logo\">\n                <img alt=\"Production Logo\" src=\"assets/images/SWS-Logo-Watermark@2x.png\" ng-if=\"!prod.logo\">\n              </div>\n            </div>\n            <div class=\"detail-container\">\n              <div class=\"icon-item\" ng-show=\"delprod.productionData.productiontype === 0\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-musical-notes swa-color-lightgray\"></span>\n                <span class=\"swa-color-lightgray\" translate>labels.Charts & Score</span>\n              </div>\n              <div class=\"icon-item\" ng-show=\"delprod.productionData.productiontype === 1\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-paper-outline swa-color-lightgray\"></span>\n                <span class=\"swa-color-lightgray\" translate>labels.Charts & PDF</span>\n              </div>\n              <div class=\"icon-item\" ng-show=\"vm.userId === delprod.ownerId\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-trash-outline swa-color-lightgray\"></span>\n                <span class=\"swa-color-lightgray\">{{delprod.created.$date | date:\'MMM dd, yyyy\'}}</span>\n              </div>\n              <div class=\"restore-buttons\">\n                <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"$event.stopPropagation();vm.restoreProductionPrompt(delprod._id);\" uib-tooltip=\"Restore back this production\" tooltip-placement=\"right\" tooltip-class=\"swa-tooltip\">\n                  <span>Restore</span>\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"sw-maincontentarea sw-homecontent sw-blur-bg\">\n      <div class=\"hint-icon-message hint-icon-message-autow swa-account-info\">\n        <div class=\"icon\">\n          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n        </div>\n        <div class=\"text\">\n          <div class=\"sw-text-md\" style=\"margin-bottom: 4px\">\n            <span class=\"title swa-color-lightgray\">Plan: </span>\n            <span class=\"title swa-color-whitelightgray\">{{vm.activePlanRules.planName}}</span>\n            <span class=\"title swa-color-lightgray\" ng-show=\"vm.quickAccountInfo.isEntAcctMember\">(Enterprise)</span>\n            <span class=\"title swa-color-lightgray\" ng-show=\"vm.quickAccountInfo.onPromoPlan\">(Promo)</span>\n          </div>\n          <div class=\"sw-text-md\" ng-if=\"vm.quickAccountInfo.isEntAcctMember\">\n            <span class=\"title swa-color-lightgray\">Managed by: </span>\n            <span class=\"title swa-color-whitelightgray\">{{vm.quickAccountInfo.entAcctName}}</span>\n          </div>\n          <div class=\"sw-text-md\" ng-if=\"!vm.quickAccountInfo.isEntAcctMember && (vm.activePlanRules.planId !== 1) && (vm.activePlanRules.planId !== 2)\">\n            <span class=\"title swa-color-lightgray\" ng-show=\"!vm.quickAccountInfo.onPromoPlan && vm.quickAccountInfo.recurringActive\">Autorenewal on: </span>\n            <span class=\"title swa-color-lightgray\" ng-hide=\"!vm.quickAccountInfo.onPromoPlan && vm.quickAccountInfo.recurringActive\">Valid till: </span>\n            <span class=\"title swa-color-whitelightgray\">{{vm.userData.activesubscription.validtill.$date | date:\'MMM dd, yyyy\'}}</span>\n          </div>\n        </div>\n      </div>\n      <div class=\"text-center\" style=\"margin-top: 10%; height: 40%\">\n        <h2 class=\"sw-color-red\">Stage Write</h2>\n        <p>Version: {{vm.versionString}}</p>\n        <p style=\"margin-top: 80px\"><a class=\"sw-a-link sw-a-link-underline\" href=\"https://www.stagewritesoftware.com/video-tutorials\" target=\"_blank\">Video Tutorials</a></p>\n      </div>\n      <div class=\"text-center\">\n        <h2>Stage Write Software</h2>\n        <p>A division of Open Jar Productions</p>\n        <p><span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-ios-telephone\"></span>212-582-1419</p>\n        <p><span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-ios-email\"></span><a class=\"sw-a-link sw-a-link-underline\" href=\"mailto:office@stagewritesoftware.com\">office@stagewritesoftware.com</a></p>\n        <p><span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-earth\"></span><a class=\"sw-a-link sw-a-link-underline\" href=\"https://www.stagewritesoftware.com\" target=\"_blank\">www.stagewritesoftware.com</a></p>\n        <p>\n          <a class=\"btn btn-lg sw-btn-toolbar\" href=\"https://www.facebook.com/StageWriteSoftware/\" target=\"_blank\"><span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-social-facebook\"></span></a>\n          <a class=\"btn btn-lg sw-btn-toolbar\" href=\"https://www.instagram.com/stagewritesoftware/\" target=\"_blank\"><span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-social-instagram\"></span></a>\n          <a class=\"btn btn-lg sw-btn-toolbar\" href=\"https://twitter.com/stagewriteapp?lang=en\" target=\"_blank\"><span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-social-twitter\"></span></a>\n          <a class=\"btn btn-lg sw-btn-toolbar\" href=\"https://www.youtube.com/@stagewritesoftware444\" target=\"_blank\"><span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-social-youtube\"></span></a>\n        </p>\n        <p>Developed by\n          <a href=\"http://www.tekyz.com\">Tekyz</a>\n          and\n          <a href=\"http://mobifilia.com\">Mobifilia</a>\n        </p>\n      </div>\n      <div class=\"text-center\" style=\"position: absolute; bottom: 0; right: 16px\" ng-hide=\"vm.hideBrowserHint\">\n        <small><em>For the best experience, use Google Chrome or Firefox</em></small>\n      </div>\n      <div style=\"position: absolute; bottom: 8px; right: 8px\">\n        <button class=\"btn sw-btn-default\" ng-click=\"vm.installRequiredFonts()\" ng-show=\"vm.showFontInstallHint\">Install required fonts</button>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionList/restoreProductionPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title text-danger text-center\">{{\'titles.Restore Production\'|translate}}\n    <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <!-- <p class=\"text-center\">{{\'messages.delete_production_prompt\'|translate}} -->\n    <p class=\"text-center\">{{\'messages.restore_production_prompt\'|translate}}\n    <br>\n    <br>\n    <strong>{{\'messages.Are you sure?\' | translate}}</strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionList/showBrowserHint.html","<div class=\"modal-header\">\n  <span class=\"modal-title\">Unsupported Browser!</span>\n</div>\n<div class=\"modal-body\">\n  <p class=\"swa-color-white\">\n    <span>Some features may not work in this browser.<br>For the best experience, we recommend that you use Google\n      Chrome or Firefox</span>\n    <br>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.close()\" translate>buttons.Close</button>\n  </div>\n</div>");
$templateCache.put("app/components/productionList/showPlanHint.html","<div class=\"modal-header\">\n  <span class=\"modal-title\">Your Subscription Plan</span>\n</div>\n<div class=\"modal-body\">\n  <div ng-show=\"vm.activePlanRules.planId === 1\">\n    <p>\n      <span>Your current subscription <em class=\"swa-color-white\">(View Only)</em> allows you <strong class=\"swa-color-white\">limited</strong>\n        functionality on one production.<br>If the production you want to work with isn’t at the top of the queue (or\n        if you want to start a new production), just delete the other productions until the production you wish to work\n        with is at the top of the queue.</span>\n      <br>\n    </p>\n  </div>\n  <div ng-show=\"vm.activePlanRules.planId === 3\">\n    <p>\n      <span>Your current subscription <em class=\"swa-color-white\">(Single Production)</em> allows you full functionality on one\n        production.<br>If\n        the production you want to work with isn’t at the top of the queue (or if you want to start a new\n        production), just delete the other productions until the production you wish to work with is at the top\n        of the queue.</span>\n      <br>\n    </p>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.close()\" translate>buttons.Close</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionList/showWelcomeScreen.html","<div class=\"modal-header\">\n  <span class=\"modal-title\">Welcome to Stage Write ! Let’s get you started!</span>\n</div>\n<div class=\"modal-body\">\n  <p class=\"swa-color-white\" style=\"margin-bottom: 32px\">\n    <span style=\"line-height: 32px; vertical-align: middle\"><strong>Are you a NEW USER?</strong></span><button class=\"btn btn-sm sw-btn-default\" style=\"margin-left: 16px\" ng-click=\"vm.startTour()\" translate>buttons.Get Started Now</button><br>\n  </p>\n  <p class=\"swa-color-white\">\n    <span><strong>Are you an existing user of STAGE WRITE FOR IPAD?</strong></span><br>\n    <span>As an existing user of the app we are thrilled to offer you a SIX MONTHS unlimited subscription. Here’s how to claim\n      it and migrate your existing productions into the new system:</span>\n    <ul class=\"swa-color-white\">\n      <li>Install the new ‘Stage Write’ app on your iPad (link is in the registration email)</li>\n      <li>Launch the new app and sign in.</li>\n      <li>On the main screen, click ‘Migrate from StageWrite’ button, then tap ‘Yes’.</li>\n      <li>The original app will open and ask you to approve a ‘Share Request’. Tap ‘Yes’.</li>\n      <li>You will be taken back to the new app with the list of existing productions that you can migrate/import into the new\n        system.</li>\n      <li>Select at least one production and tap ‘Import’.</li>\n      <li>Once the import completes, your subscription will automatically be updated to 6 months of ‘Unlimited plan’.</li>\n    </ul>\n    <br>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.close()\" translate>buttons.Close</button>\n  </div>\n</div>");
$templateCache.put("app/components/productionList/subscriptionExpiredUpgradePrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title\" translate>titles.Subscription Expired</span>\n</div>\n<div class=\"modal-body\">\n  <p>\n    <span>{{\'messages.subscription_expiry_upgrade_prompt_message1\' |translate}}</span>\n  </p>\n  <p>\n    <span>{{\'messages.subscription_expiry_upgrade_prompt_message2\' |translate}}</span>\n    <br>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.upgradePlan()\" translate>buttons.Upgrade</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.continueSwitch()\" translate>buttons.Continue</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionList/switchToStripeConfirmationPrompt.html","<!-- // SWA-1948 - Move To stripe popup -->\n<div class=\"modal-header\">\n    <span class=\"modal-title\" translate>titles.Update Card Details</span>\n  </div>\n  <div class=\"modal-body\">\n    <p>\n      <span>We are updating our payment system to the Stripe payment gateway for a better user experience.This change will not affect your current subscription rate or expiration in any way. </span>\n    </p>\n    <p>\n      <span><strong>Please, take a moment now to update the system with your card information.</strong></span>\n    </p>\n    <p>\n      <span>You will not be charged until your subscription is set to renew.</span>\n      <br>\n    </p>\n    <!-- <p>\n      <strong translate>messages.Confirm?</strong>\n    </p> -->\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"text-center\">\n      <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.confirmSwitch()\" translate>buttons.Update Card Details</button>\n      <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.cancelSwitch()\" translate>buttons.I\'ll do this later</button>\n    </div>\n  </div>\n  ");
$templateCache.put("app/components/productionSettings/copyProductionPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title text-danger text-center\">{{\'titles.Copy Production\'|translate}}</span>\n</div>\n<div class=\"modal-body\">\n  <div class=\"form-horizontal\">\n    <div>\n      <span class=\"sw-text-lg swa-color-lightgray ng-scope\" translate>titles.Production Name</span>\n    </div>\n    <form id=\"copyProduction\" name=\"vm.copyProductionForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.copyProduction()\">\n      <div class=\"form-group\">\n        <div class=\"col-lg-12 col-md-12\">\n          <input id=\"newProductionName\" name=\"newProductionName\" class=\"form-control\" ng-model=\"vm.productionCopyParams.newProductionName\" type=\"text\" required swa-select-on-focus>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-2 control-label swa-color-lightgraygray\" for=\"productiontype\" translate>labels.Type</label>\n        <div class=\"col-sm-10\" id=\"productiontype\">\n          <div class=\"btn-group sw-btn-group-radio-2\">\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.productionCopyParams.newType === 1}\" ng-click=\"vm.productionCopyParams.newType = 1\" type=\"button\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.productionCopyParams.newType === 1, \'ion-android-radio-button-off\':vm.productionCopyParams.newType === 0}\"></span>\n              {{\'buttons.Charts and PDF\' | translate}}\n            </button>\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.productionCopyParams.newType === 0}\" ng-click=\"vm.productionCopyParams.newType = 0\" type=\"button\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.productionCopyParams.newType === 0, \'ion-android-radio-button-off\':vm.productionCopyParams.newType === 1}\"></span>\n              {{\'buttons.Charts and Staging Score\' | translate}}\n            </button>\n          </div>\n        </div>\n      </div>\n        <div style=\"margin-top: 16px; margin-bottom: 8px; border-bottom: 1px solid #484c55; padding-bottom: 8px\">\n        <span class=\"sw-text-lg swa-color-lightgray ng-scope\" translate>titles.Stage Dimensions</span>\n        <button type=\"button\" ng-click=\"vm.keepSameAction()\" translate style=\"float: right\" class=\"btn btn-xs sw-btn-secondary ng-scope\">buttons.Keep Same</button>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-lg-4 col-md-4 text-center swa-color-lightgraygray\">\n          {{\'labels.Width\'|translate}}\n        </label>\n        <label class=\"col-lg-4 col-md-4 text-center swa-color-lightgraygray\">\n          {{\'labels.Depth\'|translate}}\n        </label>\n        <label class=\"col-lg-4 col-md-4 text-center swa-color-lightgraygray\">\n          {{\'labels.Off-stage Width\'|translate}}\n        </label>\n        <div class=\"col-lg-4 col-md-4\">\n          <input name=\"newStageWidth\" class=\"form-control text-right\" style=\"width: 80px; margin: auto\" ng-model=\"vm.productionCopyParams.newStageWidth\" min=\"0\" placeholder=\"{{vm.productionCopyParams.originalStageWidth}}\" type=\"number\" required=\"\" swa-select-on-focus>\n        </div>\n        <div class=\"col-lg-4 col-md-4\">\n          <input name=\"newStageDepth\" class=\"form-control text-right\" style=\"width: 80px; margin: auto\" ng-model=\"vm.productionCopyParams.newStageDepth\" min=\"0\" placeholder=\"{{vm.productionCopyParams.originalStageDepth}}\" type=\"number\" required=\"\" swa-select-on-focus>\n        </div>\n        <div class=\"col-lg-4 col-md-4\">\n          <input name=\"newOffstageWidth\" class=\"form-control text-right\" style=\"width: 80px; margin: auto\" ng-model=\"vm.productionCopyParams.newOffstageWidth\" min=\"0\" placeholder=\"{{vm.productionCopyParams.originalOffstageWidth}}\" type=\"number\" required=\"\" swa-select-on-focus>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"col-lg-12 col-md-12\">\n          <label class=\"control-label swa-color-lightgraygray\">\n            {{\'labels.Unit of Measurement\'|translate}}\n          </label>\n          <div class=\"btn-group btn-group-btn pull-right\">\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.productionCopyParams.newMeasurementUnit === 0}\" ng-click=\"vm.productionCopyParams.newMeasurementUnit = 0\" type=\"button\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.productionCopyParams.newMeasurementUnit === 0, \'ion-android-radio-button-off\':vm.productionCopyParams.newMeasurementUnit === 1}\"></span>\n              {{\'buttons.Feet\'| translate}}\n            </button>\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.productionCopyParams.newMeasurementUnit === 1}\" ng-click=\"vm.productionCopyParams.newMeasurementUnit = 1\" type=\"button\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.productionCopyParams.newMeasurementUnit === 1, \'ion-android-radio-button-off\':vm.productionCopyParams.newMeasurementUnit === 0}\"></span>\n              {{\'buttons.Meters\'| translate}}\n            </button>\n          </div>\n        </div>\n      </div>\n    </form>\n    <div class=\"hint-icon-message\">\n      <div class=\"icon\">\n        <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n      </div>\n      <div class=\"text\">\n        <em translate>messages.copy_production_type_change_message</em><br>\n        <em translate>messages.copy_production_dimension_change_message</em>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-default sw-btn-min-w-80\" type=\"submit\" form=\"copyProduction\" translate>buttons.Copy</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.Cancel</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/deleteProductionPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title text-danger text-center\">{{\'titles.Delete Production\'|translate}}\n    <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body\">\n    <p class=\"text-center\">{{\'messages.trash_production_prompt\'|translate}}\n    <br>\n    <br>\n    <strong>{{\'messages.Are you sure?\' | translate}}</strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/productionSettings.html","<swa-help-bar ng-if=\"vm.showHelpBar\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-videos=\"vm.helpTourVideos\"></swa-help-bar>\n<div class=\"sw-settings-maincontainer\" ng-cloak>\n  <div class=\"navbar navbar-fixed-top sw-navbar sw-navbar-settings-left\">\n    <div class=\"swtoolbar\">\n      <div class=\"swtoolbar-group pull-left\">\n        <span class=\"text-lg sw-color-lightgray\" translate>titles.Settings</span>\n        <!-- <img class=\"sws-logo\" src=\"assets/images/sws-logo-light.png\"> -->\n      </div>\n      <div class=\"pull-right\">\n        <button id=\"close-settings\" class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.settingsDone()\">\n          <span class=\"ion-close-round\"></span>\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"sw-sidebar sw-sidebar-left sw-sidebar-settings-list\" ng-scrollbars>\n    <div class=\"sw-settings-option-list\">\n      <div class=\"item sw-color-red text-lg sw-truncatetext text-center\">\n        <span>{{vm.selectedProduction.name}}</span>\n      </div>\n      <div id=\"prodsettings\" class=\"item\" ng-class=\"{\'item-selected\': (vm.selectedTabIndex === 0)}\" ng-click=\"vm.showDetailView(0)\">\n        <span class=\"icon swafont swafont-lg swafont-icon-settings-details\"></span>\n        <span class=\"title\" translate>titles.Production Details</span>\n      </div>\n      <div id=\"stagedimensions\" class=\"item\" ng-class=\"{\'item-selected\': (vm.selectedTabIndex === 1)}\" ng-click=\"vm.showDetailView(1)\">\n        <span class=\"icon swafont swafont-lg swafont-icon-settings-stagedimensions\"></span>\n        <span class=\"title\" translate>titles.Stage Dimensions</span>\n      </div>\n      <div id=\"setpieces\" class=\"item\" ng-class=\"{\'item-selected\': (vm.selectedTabIndex === 2)}\" ng-click=\"vm.showDetailView(2)\">\n        <span class=\"icon swafont swafont-lg swafont-icon-setpiece\"></span>\n        <span class=\"title\" translate>titles.Set Pieces</span>\n      </div>\n      <div id=\"performers\" class=\"item\" ng-class=\"{\'item-selected\': (vm.selectedTabIndex === 3)}\" ng-click=\"vm.showDetailView(3)\">\n        <span class=\"icon swafont swafont-lg swafont-icon-settings-performers\"></span>\n        <span class=\"title\" translate>titles.Performers</span>\n      </div>\n      <div id=\"scenes\" class=\"item\" ng-class=\"{\'item-selected\': (vm.selectedTabIndex === 4)}\" ng-click=\"vm.showDetailView(4)\">\n        <span class=\"icon swafont swafont-lg swafont-icon-eye\"></span>\n        <span class=\"title\" translate>titles.Scenes</span>\n      </div>\n      <div id=\"chartsettings\" class=\"item\" ng-class=\"{\'item-selected\': (vm.selectedTabIndex === 5)}\" ng-click=\"vm.showDetailView(5)\">\n        <span class=\"icon swafont swafont-lg swafont-icon-settings-chartsettings\"></span>\n        <span class=\"title\" translate>titles.Chart Settings</span>\n      </div>\n      <div id=\"stafftemplates\" class=\"item\" ng-class=\"{\'item-selected\': (vm.selectedTabIndex === 6)}\" ng-click=\"vm.showDetailView(6)\" ng-show=\"vm.selectedProduction.productiontype === 0\">\n        <span class=\"icon swafont swafont-lg swafont-icon-settings-chartsettings\"></span>\n        <span class=\"title\" translate>titles.Score Templates</span>\n      </div>\n      <div ng-if=\"vm.activeAccessRules.allowowneraccess || vm.activeCollaborationConfig.isMasterCollaborator\" id=\"collaborators\" class=\"item\" ng-class=\"{\'item-selected\': (vm.selectedTabIndex === 7)}\" ng-click=\"vm.showDetailView(7)\">\n        <span class=\"icon sw-ionicon-2x ion-person-stalker\"></span>\n        <span class=\"title\" translate>titles.Collaborate</span>\n      </div>\n      <div ng-if=\"!(vm.activeAccessRules.allowowneraccess || vm.activeCollaborationConfig.isMasterCollaborator)\" id=\"collaborated-users\" swa-show-collaborators data-production=\"vm.selectedProduction\" data-current-user-id=\"vm.userId\" class=\"item\" ng-class=\"{\'item-selected\': (vm.selectedTabIndex === 8)}\">\n        <span class=\"icon sw-ionicon-2x ion-person-stalker\"></span>\n        <span class=\"title\" translate>titles.Collaborators</span>\n      </div>\n      <!-- <div id=\"preferences\" class=\"item\" ng-class=\"{\'item-selected\': (vm.selectedTabIndex === 9)}\" ng-click=\"vm.showDetailView(9)\">\n        <span class=\"icon swafont swafont-lg swafont-icon-settings-chartsettings\"></span>\n        <span class=\"title\" translate>titles.User Settings</span>\n      </div> -->\n    </div>\n    <div ng-if=\"vm.activeAccessRules.allowcopyproductions\" style=\"padding: 0 16px; margin-top: 16px; text-align: center\">\n      <button id=\"copyproduction\" class=\"btn btn-block sw-btn-secondary\" ng-click=\"vm.copyProductionPrompt()\" type=\"button\">{{\'buttons.Copy Production\'|translate}}</button>\n    </div>\n    <div ng-if=\"vm.activeAccessRules.allowowneraccess && vm.activePlanRules.allowTransferOwnership\" style=\"padding: 0 16px; margin-top: 16px; text-align: center\">\n        <button id=\"transferownership\" class=\"btn btn-block sw-btn-secondary\" ng-click=\"vm.promptTransferOwnership()\" type=\"button\">{{\'buttons.Transfer Ownership\'|translate}}</button>\n    </div>\n    <div ng-if=\"vm.activeAccessRules.allowowneraccess\" style=\"padding: 0 16px; margin-top: 24px; text-align: center\">\n      <button id=\"deleteproduction\" class=\"btn btn-block sw-btn-danger\" ng-click=\"vm.deleteProductionPrompt()\" type=\"button\">{{\'buttons.Delete Production\'|translate}}</button>\n    </div>\n    <div ng-if=\"!vm.activeAccessRules.allowowneraccess\" style=\"padding: 0 16px; margin-top: 24px; text-align: center\">\n      <button id=\"stopcollaborating\" class=\"btn btn-block sw-btn-danger\" ng-click=\"vm.stopCollaboratingPrompt()\" type=\"button\">{{\'buttons.Stop Collaborating\'|translate}}</button>\n    </div>\n  </div>\n  <div class=\"sw-maincontentarea sw-settingsdetail-container\" ui-view>\n    <!-- <div class=\"scrollcontainer content_outer mrgnRight0\" ui-view ng-scrollbars ng-scrollbars-config=\"scrollConfigContent\"></div> -->\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsChartSettings.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" translate>titles.Chart Settings</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"editdone-set-piece\" class=\"btn sw-btn-default\" ng-click=\"vm.saveUpdate()\" ng-hide=\"!vm.activeAccessRules.allowsavechanges\" translate>buttons.Save</button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer sw-preferences\" ng-scrollbars>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Content Defaults</h4>\n  <div>\n    <div id=\"personal-content-defaults-settings\" class=\"panel panel-default settingsDetailPanel preferences\">\n    <div class=\"panel-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2\">\n            <label class=\"control-label\" translate>labels.Text Defaults</label>\n            <span class=\"subtitle\" translate>labels.Text Defaults Subtitle</span>\n          </div>\n          <div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10 form-inline\">\n          <div id=\"personal-content-defaults\" class=\"left\">\n            </div>\n            <div id=\"personal-content-defaults-preview\" class=\"preview right\">\n              <span class=\"title left\" translate>labels.Preview</span>\n              <div class=\"preview-container left\" id=\"settings-preview\">\n                <span id=\"preview-content\" class=\"preview-content\">AaBb</span>\n              </div>\n              <button class=\"btn sw-btn-radio left\" ng-click=\"vm.reset(\'Text Defaults\')\" type=\"button\">\n                {{\'buttons.Reset\'| translate}}\n              </button>\n            </div>\n          </div>\n          <div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10 form-inline\">\n            <div class=\"text-settings\">\n               <div class=\"sub-settings left\">\n                <span class=\"sub-settings-icon sw-ionicon ion-paintbucket left selector\"></span>\n                <div class=\"clr bg-container left clickable checkerboard-bk\" stackable-trigger=\"switchBgColor\">\n                    <div style=\"height: 100%; width: 100%\" ng-style=\"{\'background-color\': vm.productionPreferences.contentDefaults[\'settingsChartText\'].fillColor}\">\n                    </div>\n                </div>\n                <stackable-popover stackable-placement=\"bottom\" stackable=\"switchBgColor\" stackable-enable-escape=\"true\">\n                  <div class=\"sw-popover-menu\" role=\"menu\">\n                    <div class=\"menu-group color-pallete\">\n                      <div class=\"color-row\" ng-repeat=\"colorRow in vm.colorPickerOption\" style=\"display: flex\">\n                        <div class=\"color\" ng-repeat=\"color in colorRow track by $index\" ng-click=\"vm.editSettings(\'settingsChartText\', { fillColor : vm.colorToRgb(color) });switchBgColor.show = false\" style=\"width: 25px;\n                            height: 25px;\n                            border: 1px solid #60656D;\n                            border-radius: 4px;\n                            cursor: pointer;\n                            margin: 2px\" ng-style=\"{\'background-color\': color}\">\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </stackable-popover>\n              </div>\n            </div>\n            <div class=\"sub-settings left\">\n              <span class=\"sub-settings-icon left selector sw-ionicon ion-brush\"></span>\n              <div class=\"clr fg-container left clickable\" ng-style=\"{\'background-color\': vm.productionPreferences.contentDefaults[\'settingsChartText\'].fontColor};\" stackable-trigger=\"switchFgColor\"></div>\n            <stackable-popover stackable-placement=\"bottom\" stackable=\"switchFgColor\" stackable-enable-escape=\"true\">\n              <div class=\"sw-popover-menu\" role=\"menu\">\n                <div class=\"menu-group color-pallete\">\n                  <div class=\"color-row\" ng-repeat=\"colorRow in vm.colorPickerOption\" style=\"display: flex\">\n                    <div class=\"color\" ng-repeat=\"color in colorRow track by $index\" ng-click=\"vm.editSettings(\'settingsChartText\', { fontColor : vm.colorToRgb(color) });switchFgColor.show = false\" style=\"width: 25px;\n                        height: 25px;\n                        border: 1px solid #60656D;\n                        border-radius: 4px;\n                        cursor: pointer;\n                        margin: 2px\" ng-style=\"{\'background-color\': color}\">\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </stackable-popover>\n            </div>\n            <div id=\"font-family-setting\" class=\"font-setting sub-settings left clickable\" stackable-trigger=\"switchFontFamily\">\n              <span class=\"sub-settings-text left\">{{vm.productionPreferences.contentDefaults[\'settingsChartText\'].fontFamily}}</span>\n            </div>\n            <stackable-popover stackable-placement=\"bottom\" stackable=\"switchFontFamily\" stackable-enable-escape=\"true\">\n                <div class=\"sw-popover-menu\" role=\"menu\">\n                  <div class=\"menu-group\">\n                    <div class=\"menu-item\" ng-repeat=\"fontFamily in vm.fontFamilies\" ng-click=\"vm.editSettings(\'settingsChartText\', { fontFamily : fontFamily }); switchFontFamily.show = false\">\n                      <span class=\"title\">{{fontFamily}}</span>\n                    </div>\n                  </div>\n                </div>\n              </stackable-popover>\n            <div class=\"sub-settings left clickable\" ng-click=\"vm.fontSizeStepper(\'settingsChartText\', \'-\')\">\n              <span class=\"sub-settings-icon left selector sw-ionicon ion-minus sw-ionicon-bold\"></span>\n            </div>\n            <div class=\"font-setting sub-settings left clickable\" stackable-trigger=\"vm.fontSizePicker\">\n              <span class=\"sub-settings-text left\">{{vm.productionPreferences.contentDefaults[\'settingsChartText\'].fontSize}} {{vm.fontSizeRange.unit}}</span>\n            </div>\n            <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.fontSizePicker\" stackable-enable-escape=\"true\">\n              <div class=\"sw-popover-menu sw-fontsize-picker\">\n                <div class=\"menu-group\">\n                  <div class=\"menu-item text-center\" ng-repeat=\"fontSize in vm.fontSizeRange.pickerValues\" ng-click=\"vm.editSettings(\'settingsChartText\', { fontSize : fontSize }); vm.fontSizePicker.show = false;\">\n                    <span class=\"title\">{{fontSize}} {{vm.fontSizeRange.unit}}</span>\n                  </div>\n                </div>\n              </div>\n            </stackable-popover>\n            <div class=\"sub-settings left clickable\" ng-click=\"vm.fontSizeStepper(\'settingsChartText\', \'+\')\">\n              <span class=\"sub-settings-icon left selector swafont swafont-lg swafont-icon-plus sw-ionicon-bold\"></span>\n            </div>\n\n            <div class=\"sub-settings left clickable mrgnLeft20\" ng-class=\"{ \'settings-active\': vm.productionPreferences.contentDefaults[\'settingsChartText\'].bold}\" ng-click=\"vm.editSettings(\'settingsChartText\', { bold : !vm.productionPreferences.contentDefaults[\'settingsChartText\'].bold })\">\n              <span class=\"sub-settings-icon left selector\">B</span>\n            </div>\n\n            <div class=\"sub-settings left clickable\" ng-class=\"{ \'settings-active\': vm.productionPreferences.contentDefaults[\'settingsChartText\'].italic}\" ng-click=\"vm.editSettings(\'settingsChartText\', { italic : !vm.productionPreferences.contentDefaults[\'settingsChartText\'].italic })\">\n              <span class=\"sub-settings-icon left selector\">I</span>\n            </div>\n\n            <div class=\"sub-settings left clickable\" ng-class=\"{ \'settings-active\': vm.productionPreferences.contentDefaults[\'settingsChartText\'].underline}\" ng-click=\"vm.editSettings(\'settingsChartText\', { underline : !vm.productionPreferences.contentDefaults[\'settingsChartText\'].underline })\">\n              <span class=\"sub-settings-icon left selector\">U</span>\n            </div>\n          </div>\n  </div>\n  </div>\n  </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Grid</h4>\n  <div id=\"chart-line-settings\" class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Show Number Line</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 form-inline\">\n            <switch class=\"swa-switch\" id=\"showLinenumber\" ng-model=\"vm.production.chartsettings.numberlinevisible\" on=\"YES\" off=\"NO\" ng-disabled=\"!vm.activeAccessRules.alloweditsettings\"></switch>\n            <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditsettings\"></span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Show Center Line</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n            <switch class=\"swa-switch\" id=\"showCenterLine\" ng-model=\"vm.production.chartsettings.centerlinevisible\" on=\"YES\" off=\"NO\" ng-disabled=\"!vm.activeAccessRules.alloweditsettings\"></switch>\n            <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditsettings\"></span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Show Vertical Lines</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n            <switch class=\"swa-switch\" id=\"showVerticalLine\" ng-model=\"vm.production.chartsettings.verticallinesvisible\" on=\"YES\" off=\"NO\" ng-disabled=\"!vm.activeAccessRules.alloweditsettings\"></switch>\n            <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditsettings\"></span>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Show Horizontal Lines</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 form-inline\">\n            <switch class=\"swa-switch\" id=\"showHorizontalLine\" ng-model=\"vm.production.chartsettings.horizontallinesvisible\" on=\"YES\" off=\"NO\" ng-disabled=\"!vm.activeAccessRules.alloweditsettings\" ng-change=\"vm.showHorizontalLineChanged()\"></switch>\n            <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditsettings\"></span>\n          </div>\n        </div>\n        <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Show Horizontal Numbers</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 form-inline\">\n            <switch class=\"swa-switch\" id=\"showVerticalNumberLine\" ng-model=\"vm.production.chartsettings.horizontallinesnumbersvisible\" on=\"YES\" off=\"NO\" ng-disabled=\"!vm.activeAccessRules.alloweditsettings || !vm.production.chartsettings.horizontallinesvisible\"></switch>\n            <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditsettings\"></span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Chart</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body form-horizontal\">\n      <div class=\"form-group\">\n        <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Chart Numbering</label>\n        <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n          <div id=\"chart-numbering-mode\" class=\"btn-group btn-group-btn\">\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.production.chartsettings.chartnumberautomatic === true}\" ng-click=\"vm.production.chartsettings.chartnumberautomatic = true\" type=\"button\" ng-disabled=\"!vm.activeAccessRules.alloweditsettings\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.production.chartsettings.chartnumberautomatic === true, \'ion-android-radio-button-off\':vm.production.chartsettings.chartnumberautomatic === false}\"></span>\n              {{\'buttons.Automatic\'| translate}}\n            </button>\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.production.chartsettings.chartnumberautomatic === false}\" ng-click=\"vm.production.chartsettings.chartnumberautomatic = false\" type=\"button\" ng-disabled=\"!vm.activeAccessRules.alloweditsettings\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.production.chartsettings.chartnumberautomatic === false, \'ion-android-radio-button-off\':vm.production.chartsettings.chartnumberautomatic === true}\"></span>\n              {{\'buttons.Manual\'| translate}}\n            </button>\n          </div>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditsettings\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Point of View</label>\n        <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n          <div id=\"point-of-view\" class=\"btn-group btn-group-btn1\">\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.production.chartsettings.povaudience === true}\" ng-click=\"vm.production.chartsettings.povaudience = true\" type=\"button\" ng-disabled=\"!vm.activeAccessRules.alloweditpov\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.production.chartsettings.povaudience === true, \'ion-android-radio-button-off\':vm.production.chartsettings.povaudience === false}\"></span>\n              {{\'buttons.Audience\'| translate}}\n            </button>\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.production.chartsettings.povaudience === false}\" ng-click=\"vm.production.chartsettings.povaudience = false\" type=\"button\" ng-disabled=\"!vm.activeAccessRules.alloweditpov\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.production.chartsettings.povaudience === false, \'ion-android-radio-button-off\':vm.production.chartsettings.povaudience === true}\"></span>\n              {{\'buttons.Performer\'| translate}}\n            </button>\n          </div>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditpov\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditpov\">\n        <div class=\"col-lg-offset-4 col-md-offset-4 col-sm-offset-4 col-xs-offset-4 col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n          <div class=\"hint-icon-message hint-icon-message-autow\">\n            <div class=\"icon\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n            </div>\n            <div class=\"text\">\n              <span>POV from your <a class=\"sw-a-link sw-a-link-underline\" ui-sref=\"myaccount\">preferences</a> will be used for this production</span>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n        <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Always Show Notes</label>\n        <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 form-inline\">\n          <switch class=\"swa-switch\" id=\"\" ng-model=\"vm.production.chartsettings.chartnotesvisible\" on=\"YES\" off=\"NO\" ng-disabled=\"!vm.activeAccessRules.alloweditsettings\"></switch>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditsettings\"></span>\n        </div>\n      </div>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Performer</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body form-horizontal\">\n      <div class=\"form-group\">\n        <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Show Performer Placement</label>\n        <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n          <switch class=\"swa-switch\" id=\"showActorPlace\" ng-model=\"vm.production.chartsettings.performerpositionvisible\" on=\"YES\" off=\"NO\" ng-disabled=\"!vm.activeAccessRules.alloweditsettings\"></switch>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditsettings\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Performer Placement Detail</label>\n        <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n          <div id=\"performer-placement-resolution\" class=\"swa-settings-performer-placement-resolution\">\n            <ol class=\"nya-bs-select form-control\" ng-model=\"vm.production.chartsettings.performerpositionresolutionfraction\" disabled=\"!vm.production.chartsettings.performerpositionvisible || !vm.activeAccessRules.alloweditsettings\">\n              <li nya-bs-option=\"option in vm.placementResolutionOptions\" data-value=\"option.value\">\n                <a>\n                  <span class=\"pull-left\">{{option.label}}</span>\n                  <span class=\"pull-right sw-color-mediumlightgray\">{{option.hint}}</span>\n                </a>\n              </li>\n            </ol>\n          </div>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditsettings\"></span>\n        </div>\n      </div>\n      <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n        <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Show Performer body direction</label>\n        <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n          <switch class=\"swa-switch\" id=\"showPerformerNose\" ng-model=\"vm.production.chartsettings.performernosevisible\" on=\"YES\" off=\"NO\" ng-disabled=\"!vm.activeAccessRules.alloweditsettings\"></switch>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditsettings\"></span>\n        </div>\n      </div>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Shapes</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body form-horizontal\">\n      <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n        <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Show breaks when line shapes overlap</label>\n        <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n          <switch class=\"swa-switch\" id=\"showBreakLine\" ng-model=\"vm.production.chartsettings.lineoverlapbreaks\" on=\"YES\" off=\"NO\" ng-disabled=\"!vm.activeAccessRules.alloweditsettings\"></switch>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditsettings\"></span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n</div>");
$templateCache.put("app/components/productionSettings/settingsCollaboratorEdit.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" ng-hide=\"vm.isEditMode\" translate>titles.Add Collaborators</span>\n    <span class=\"text-lg sw-color-lightgray\" ng-show=\"vm.isEditMode\" translate>titles.Edit Collaborator</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"cancel\" class=\"btn sw-btn-default\" ng-click=\"vm.onCancel()\" translate>buttons.Cancel</button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"saveupdate\" class=\"btn sw-btn-default\" ng-click=\"vm.saveUpdate()\" translate>buttons.Save</button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <div class=\"panel panel-default settingsDetailPanel\" ng-cloak>\n    <div class=\"panel-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\" ng-hide=\"vm.collaborationSettings.collaboratoremail\">\n          <form name=\"vm.forms.addCollaborators\">\n            <label class=\"col-sm-3 control-label\">{{\'labels.Email(s)\' | translate}}<br>\n              <small class=\"setPieces_small sw-color-mediumlightgray\">\n                <em translate>labels.Use comma to separate email addresses or paste a comma separated list of email addresses.</em>\n              </small>\n            </label>\n            <div class=\"col-sm-8\">\n              <tags-input id=\"newCollaborators\" class=\"sw-tags-input\" name=\"newCollaborators\" ng-model=\"vm.newCollaborators\" allowed-tags-pattern=\"^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$\" on-tag-added=\"vm.checkIfSwaUser($tag)\" on-tag-adding=\"vm.checkExistingCollaborator($tag)\" add-on-paste=\"true\" placeholder=\"Enter email address(es)\"></tags-input>\n              <p class=\"sw-color-red\" ng-show=\"vm.forms.addCollaborators.newCollaborators.$error.leftoverText\" translate>messages.Please enter valid email(s)</p>\n            </div>\n          </form>\n        </div>\n        <div class=\"form-group\" ng-show=\"vm.collaborationSettings.collaboratoremail\">\n          <label class=\"col-sm-3 control-label\" translate>labels.Collaborator</label>\n          <div class=\"col-sm-6\">\n            <label class=\"col-sm-3 control-label\">\n              {{vm.collaborationSettings.collaboratoremail}}\n            </label>\n            <div class=\"pull-right\">\n              <button id=\"stop-collaboration\" class=\"btn btn-sm sw-btn-danger\" ng-click=\"vm.stopCollaboration()\" type=\"button\">{{\'buttons.Stop Collaboration\' | translate}}</button>\n            </div>\n          </div>\n          <div class=\"col-sm-offset-3 col-sm-9\">\n            <label class=\"col-sm-6 control-label\">\n              <em class=\"swa-color-lightgraygray\" ng-show=\"(vm.collaborationSettings.addedById !== undefined) && (vm.collaborationSettings.addedById !== vm.userId)\">(Added By: {{vm.collaborationSettings.addedByEmail}})</em>\n            </label>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" ng-show=\"vm.collaboratorAddedByOwner\" translate>titles.Master Permissions</h4>\n  <div class=\"panel panel-default settingsDetailPanel\" ng-show=\"vm.collaboratorAddedByOwner\">\n    <div class=\"panel-body form-horizontal\">\n        <div class=\"form-group\" ng-show=\"vm.userIsProductionOwner && vm.collaboratorAddedByOwner\">\n          <label class=\"col-sm-3 control-label\">{{\'labels.Master Collaborator\' | translate}}<br>\n            <small class=\"setPieces_small sw-color-mediumlightgray\">\n              <em translate>labels.Allows this collaborator to manage other collaborators on this production.</em>\n            </small>\n          </label>\n          <div class=\"col-sm-9 form-inline\">\n            <switch class=\"swa-switch\" id=\"isMasterCollaborator\" ng-model=\"vm.collaborationSettings.isMasterCollaborator\" on=\"YES\" off=\"NO\" ng-change=\"vm.masterCollaboratorChange()\"></switch>\n            <span style=\"margin-left: 8px\" class=\"swa-color-accentred\" ng-show=\"vm.collaborationSettings.wasMasterCollaborator && !vm.collaborationSettings.isMasterCollaborator\">{{\'messages.Any collaborators added by this user will be removed.\'|translate}}\n            </span>\n          </div>\n        </div>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>titles.PDF Creation Permissions</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body form-horizontal\">\n      <div class=\"form-group container-fluid\">\n        <div class=\"row\">\n          <label class=\"col-sm-3 control-label\">{{\'labels.Restrict PDF Creation\' | translate}}<br>\n          <small class=\"setPieces_small sw-color-mediumlightgray\">\n            <em translate>labels.If turned on this will require authorization from the owner for all PDF downloads.</em>\n            <em translate>labels.settings_collab_restrict_pdf_watermark_note</em>\n          </small>\n          </label>\n          <div class=\"col-sm-2\">\n            <switch class=\"swa-switch\" id=\"restrictPrinting\" ng-model=\"vm.collaborationSettings.restrictPrinting\" on=\"YES\" off=\"NO\" ng-disabled=\"vm.masterRestrictPrinting\"></switch>\n          </div>\n          <label class=\"col-sm-3 control-label\" ng-show=\"vm.collaborationSettings.isMasterCollaborator && vm.collaborationSettings.restrictPrinting\">\n            {{\'labels.Allow Master Collaborator to Bypass PDF Approval\' | translate}}<br>\n            <small class=\"setPieces_small sw-color-mediumlightgray\">\n              <em translate>labels.settings_collab_allow_master_approve_bypass_print</em>\n            </small>\n          </label>\n          <div class=\"col-sm-3\" ng-show=\"vm.collaborationSettings.isMasterCollaborator && vm.collaborationSettings.restrictPrinting\">\n            <switch class=\"swa-switch\" id=\"masterCanApprovePrinting\" ng-model=\"vm.collaborationSettings.masterCanApprovePrinting\" on=\"YES\" off=\"NO\"></switch>\n          </div>\n          <label class=\"col-sm-3 control-label\" ng-show=\"vm.masterCanBypassRestrictPrinting && vm.collaborationSettings.collaboratorId\">\n            {{\'labels.Bypass PDF Creation Approval\' | translate}}<br>\n            <small class=\"setPieces_small sw-color-mediumlightgray\">\n              <em translate=\"labels.settings_collab_restrict_bypass_note\" translate-values=\"{count: vm.masterBypassPrintApprovalCount}\"></em>\n            </small>\n          </label>\n          <div class=\"col-sm-2\" ng-show=\"vm.masterCanBypassRestrictPrinting && vm.collaborationSettings.collaboratorId\">\n            <switch class=\"swa-switch\" id=\"bypassRestrictPrinting\" ng-model=\"vm.collaborationSettings.bypassPrintApproval\" on=\"YES\" off=\"NO\" ng-disabled=\"!vm.userIsMasterCollaborator && vm.masterRestrictPrinting\"></switch>\n          </div>\n        </div>\n        <div class=\"row\">\n          <label class=\"col-sm-offset-5 col-sm-3 control-label\" ng-show=\"vm.collaborationSettings.isMasterCollaborator && vm.collaborationSettings.restrictPrinting\">\n            {{\'labels.Bypass PDF Creation Limit\' | translate}}<br>\n            <small class=\"setPieces_small sw-color-mediumlightgray\">\n              <em translate>labels.settings_collab_restrict_master_bypass_count_note</em>\n            </small>\n          </label>\n          <div class=\"col-sm-3\" ng-show=\"vm.collaborationSettings.isMasterCollaborator && vm.collaborationSettings.restrictPrinting\">\n            <input class=\"form-control dimension-field-width text-right\" ng-model=\"vm.collaborationSettings.masterBypassPrintApprovalCount\" type=\"number\" min=\"0\" ng-disabled=\"!vm.collaborationSettings.masterCanApprovePrinting\" swa-select-on-focus>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>titles.Content Access</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body form-horizontal\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-3 control-label\" id=\"labelCollItem\" translate>labels.Access Level</label>\n        <div class=\"col-sm-8\">\n          <div id=\"collaboration-access\" class=\"btn-group btn-group-btn pull-left\">\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.collaborationSettings.collaborationaccess.accesslevel === 2}\" ng-click=\"vm.updateCollaborationLevel(2);\" ng-disabled=\"vm.collaborationSettings.isMasterCollaborator\" type=\"button\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.collaborationSettings.collaborationaccess.accesslevel === 2, \'ion-android-radio-button-off\':vm.collaborationSettings.collaborationaccess.accesslevel !== 2}\"></span>\n              {{\'buttons.Limited\'| translate}}\n            </button>\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.collaborationSettings.collaborationaccess.accesslevel === 0}\" ng-click=\"vm.updateCollaborationLevel(0);\" ng-disabled=\"vm.collaborationSettings.isMasterCollaborator\" type=\"button\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.collaborationSettings.collaborationaccess.accesslevel === 0, \'ion-android-radio-button-off\':vm.collaborationSettings.collaborationaccess.accesslevel !== 0}\"></span>\n              {{\'buttons.Full\'| translate}}\n            </button>\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.collaborationSettings.collaborationaccess.accesslevel === 1}\" ng-click=\"vm.updateCollaborationLevel(1);\" ng-disabled=\"vm.collaborationSettings.isMasterCollaborator\" type=\"button\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.collaborationSettings.collaborationaccess.accesslevel === 1, \'ion-android-radio-button-off\':vm.collaborationSettings.collaborationaccess.accesslevel !== 1}\"></span>\n              {{\'buttons.Custom\'| translate}}\n            </button>\n          </div>\n        </div>\n        <div class=\"col-sm-8 col-sm-offset-3 mt-1\" ng-hide=\"vm.collaborationSettings.collaborationaccess.accesslevel === 1\">\n          <div class=\"hint-icon-message\">\n            <div class=\"icon\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n            </div>\n            <div class=\"text\" ng-show=\"vm.collaborationSettings.collaborationaccess.accesslevel === 2\">\n              <em class=\"ng-binding\" ng-show=\"vm.selectedProduction.productiontype === 0\">Collaborator will be able to VIEW the production and add personal notes to charts.</em>\n              <em class=\"ng-binding\" ng-show=\"vm.selectedProduction.productiontype === 1\">Collaborator will be able to VIEW the production, make notes on a Private PDF, and add personal notes to charts.</em>\n            </div>\n            <div class=\"text\" ng-show=\"vm.collaborationSettings.collaborationaccess.accesslevel === 0\">\n              <em class=\"ng-binding\">Collaborator will have full access to EDIT all components of the master production.</em>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" ng-show=\"(vm.collaborationSettings.collaborationaccess.accesslevel === 1) && (vm.selectedProduction.productiontype === 1)\" translate>titles.Content - PDF Access</h4>\n  <div class=\"panel panel-default settingsDetailPanel sw-create-performer\" ng-cloak ng-show=\"(vm.collaborationSettings.collaborationaccess.accesslevel === 1) && (vm.selectedProduction.productiontype === 1)\">\n    <div class=\"panel-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group mrgn-padd-btm0\">\n          <div class=\"col-sm-3\">\n            <span class=\"sw-color-lightgray\" translate>labels.PDF Type</span>\n          </div>\n          <div class=\"col-sm-8 text-center\">\n            <div id=\"collaboration-access\" class=\"btn-group btn-group-btn pull-left\">\n              <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':!vm.collaborationSettings.collaborationaccess.allowscriptediting}\" ng-click=\"vm.collaborationSettings.collaborationaccess.allowscriptediting = false\" ng-disabled=\"vm.collaborationSettings.isMasterCollaborator\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':!vm.collaborationSettings.collaborationaccess.allowscriptediting, \'ion-android-radio-button-off\':vm.collaborationSettings.collaborationaccess.allowscriptediting}\"></span>\n                {{\'buttons.Private PDF\'| translate}}\n              </button>\n              <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.collaborationSettings.collaborationaccess.allowscriptediting}\" ng-click=\"vm.collaborationSettings.collaborationaccess.allowscriptediting = true\" ng-disabled=\"vm.collaborationSettings.isMasterCollaborator\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.collaborationSettings.collaborationaccess.allowscriptediting, \'ion-android-radio-button-off\':!vm.collaborationSettings.collaborationaccess.allowscriptediting}\"></span>\n                {{\'buttons.Shared PDF\'| translate}}\n              </button>\n            </div>\n          </div>\n          <div class=\"col-sm-8 col-sm-offset-3 mt-1\">\n            <div class=\"hint-icon-message\">\n              <div class=\"icon\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n              </div>\n              <div class=\"text\" ng-show=\"!vm.collaborationSettings.collaborationaccess.allowscriptediting\">\n                <em class=\"ng-binding\">Markups will not be shared.</em>\n              </div>\n              <div class=\"text\" ng-show=\"vm.collaborationSettings.collaborationaccess.allowscriptediting\">\n                <em class=\"ng-binding\">Collaborated markups.</em>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" ng-show=\"(vm.collaborationSettings.collaborationaccess.accesslevel === 1) && (vm.selectedProduction.productiontype === 0)\" translate>titles.Content - Charts and Score Editing Access</h4>\n  <h4 class=\"text-center sw-color-gray\" ng-show=\"(vm.collaborationSettings.collaborationaccess.accesslevel === 1) && (vm.selectedProduction.productiontype === 1)\" translate>titles.Content - Charts Editing Access</h4>\n  <div class=\"panel panel-default settingsDetailPanel sw-create-performer\" ng-cloak ng-show=\"vm.collaborationSettings.collaborationaccess.accesslevel === 1\">\n    <div class=\"panel-body\">\n      <div class=\"form-horizontal mrgnBottom25\" style=\"border-bottom: 1px solid #C5C7C9\">\n        <div class=\"form-group\">\n          <div class=\"col-sm-3\">\n            <span class=\"text-lg sw-color-lightgray\" translate>titles.Scenes</span>\n            <button class=\"btn sw-btn-xsm sw-btn-secondary\" ng-click=\"vm.clearAllChartsStaffs();\" type=\"button\">{{\'buttons.Clear All\'|translate}}</button>\n          </div>\n          <div class=\"col-sm-2 text-center\">\n            <span class=\"text-lg sw-color-lightgray\" translate>titles.Charts</span>\n            <button class=\"btn sw-btn-xsm sw-btn-secondary\" ng-click=\"vm.selectAllCharts();\" type=\"button\">{{\'buttons.Select All\'|translate}}</button>\n          </div>\n          <div class=\"col-sm-2 text-center\">\n            <span class=\"text-center text-lg sw-color-lightgray\" ng-show=\"vm.selectedProduction.productiontype === 0\" translate>titles.Score</span>\n            <button class=\"btn sw-btn-xsm sw-btn-secondary\" ng-click=\"vm.selectAllStaffs();\" ng-show=\"vm.selectedProduction.productiontype === 0\" type=\"button\">{{\'buttons.Select All\'|translate}}</button>\n          </div>\n          <div class=\"col-sm-5 text-right\"></div>\n        </div>\n      </div>\n      <div class=\"form-horizontal mrgn-padd-btm0\">\n        <div class=\"form-group\" ng-repeat=\"sceneAccessItem in vm.collaborationSettings.collaborationaccess.sceneaccess\">\n          <span class=\"col-sm-3 sw-color-lightgray\">{{sceneAccessItem.scenename}}</span>\n          <div class=\"col-sm-2 text-center\">\n            <switch class=\"swa-switch\" ng-model=\"sceneAccessItem.allowchartediting\"></switch>\n          </div>\n          <div class=\"col-sm-2 text-center\" ng-show=\"vm.selectedProduction.productiontype === 0\">\n            <switch class=\"swa-switch\" ng-model=\"sceneAccessItem.allowstaffediting\"></switch>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/components/productionSettings/settingsCollaboratorsList.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" translate>titles.Collaborate</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"add-collaborator\" class=\"btn sw-btn-default\" ng-click=\"vm.onAdd()\" ng-disabled=\"vm.listEditMode\" translate>buttons.Add</button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"editdone-collaborator\" class=\"btn sw-btn-default\" ng-click=\"vm.onEditToggle()\" ng-disabled=\"(vm.collaborationSettings.length === 0)\">\n        <span ng-hide=\"vm.listEditMode\" translate>buttons.Edit</span>\n        <span ng-show=\"vm.listEditMode\" translate>buttons.Done</span>\n      </button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <div class=\"settingsDetailPanel\" ng-cloak>\n    <div ng-hide=\"vm.collaborationSettings.length === 0\">\n      <h5 class=\"sw-color-mediumlightgray\">Your Collaborators</h5>\n      <div class=\"settings-list-container\" ng-style=\"{\'margin-right\': (vm.listEditMode?\'40px\': \'0\')}\" ng-hide=\"vm.yourCollaborators.length === 0\">\n        <div id=\"collaborated-user-your-{{$index}}\" class=\"settings-collaborator-row\" data-ng-repeat=\"collaborationSetting in vm.yourCollaborators\" ng-click=\"vm.onCollaborateUserClick(collaborationSetting)\" ng-disabled=\"!vm.userIsProductionOwner && (collaborationSetting.addedById !== vm.userId)\">\n          <div class=\"collaborator-icon pull-left\" style=\"min-width: 90px\">\n            <span class=\"sw-ionicon sw-ionicon-2x sw-ionicon-fw ion-person\" uib-tooltip=\"Collaborator\" tooltip-popup-delay=\"100\" ng-show=\"collaborationSetting.collaboratorId && !collaborationSetting.isMasterCollaborator\"></span>\n            <span class=\"sw-ionicon sw-ionicon-2x sw-ionicon-fw ion-person-add\" uib-tooltip=\"Master Collaborator\" tooltip-popup-delay=\"100\" ng-show=\"collaborationSetting.collaboratorId && collaborationSetting.isMasterCollaborator\"></span>\n            <span class=\"sw-ionicon sw-ionicon-2x sw-ionicon-fw ion-email\" uib-tooltip=\"Invited Collaborator\" tooltip-popup-delay=\"100\" ng-hide=\"collaborationSetting.collaboratorId\"></span>\n            <span ng-hide=\"collaborationSetting.unrestrictedPrinting\">\n              <span class=\"sw-ionicon sw-ionicon-2x sw-ionicon-fw ion-printer\" uib-tooltip=\"Requires approval for PDF printing\" tooltip-popup-delay=\"100\"></span>\n              <span class=\"sw-ionicon sw-ionicon-lg sw-ionicon-fw sw-ionicon-super-overlay ion-help-circled clickthrough\"></span>\n            </span>\n            <span ng-show=\"collaborationSetting.unrestrictedPrinting\">\n              <span class=\"sw-ionicon sw-ionicon-2x sw-ionicon-fw ion-printer\" uib-tooltip=\"Unlimited PDF printing\" tooltip-popup-delay=\"100\"></span>\n              <span class=\"sw-ionicon sw-ionicon-lg sw-ionicon-fw sw-ionicon-super-overlay ion-checkmark-circled clickthrough\"></span>\n            </span>\n          </div>\n          <div class=\"pull-left title\">\n            <span>{{collaborationSetting.collaboratoremail}}</span>\n          </div>\n          <div class=\"pull-right\" ng-show=\"vm.listEditMode\">\n            <button class=\"btn sw-btn-xsm sw-btn-danger\" ng-show=\"vm.userIsProductionOwner && (collaborationSetting.addedById === undefined) && (collaborationSetting.collaboratorId !== undefined)\" ng-click=\"vm.promptTransferOwnership(collaborationSetting);\n                $event.stopPropagation()\" type=\"button\" translate>buttons.Transfer Ownership</button>\n            <button class=\"btn sw-btn-xsm sw-btn-danger\" ng-show=\"vm.userIsProductionOwner || ( vm.userIsMasterCollaborator && (collaborationSetting.addedById === vm.userId))\" ng-click=\"vm.stopUserCollaboration(collaborationSetting);\n                $event.stopPropagation()\" type=\"button\" translate>buttons.Stop Collaboration</button>\n          </div>\n        </div>\n      </div>\n      <div ng-show=\"vm.yourCollaborators.length === 0\">\n        <div class=\"hint-icon-message hint-icon-message-autow\">\n          <div class=\"icon\">\n            <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n          </div>\n          <div class=\"text\">\n            <span translate>messages.You have no collaborators on this production</span>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div data-ng-repeat=\"(name, collaborationSettings) in vm.otherCollaboratorBuckets\" ng-hide=\"vm.collaborationSettings.length === 0\">\n      <h5 class=\"sw-color-mediumlightgray\">Managed by: {{name}}</h5>\n      <div class=\"settings-list-container\" ng-style=\"{\'margin-right\': (vm.listEditMode?\'40px\': \'0\')}\">\n        <div id=\"collaborated-user-{{name}}-{{$index}}\" class=\"settings-collaborator-row\" data-ng-repeat=\"collaborationSetting in collaborationSettings\" ng-click=\"vm.onCollaborateUserClick(collaborationSetting)\" ng-disabled=\"!vm.userIsProductionOwner && (collaborationSetting.addedById !== vm.userId)\">\n          <div class=\"collaborator-icon pull-left\" style=\"min-width: 90px\">\n            <span class=\"sw-ionicon sw-ionicon-2x sw-ionicon-fw ion-person\" uib-tooltip=\"Collaborator\" tooltip-popup-delay=\"100\" ng-show=\"collaborationSetting.collaboratorId && !collaborationSetting.isMasterCollaborator\"></span>\n            <span class=\"sw-ionicon sw-ionicon-2x sw-ionicon-fw ion-person-add\" uib-tooltip=\"Master Collaborator\" tooltip-popup-delay=\"100\" ng-show=\"collaborationSetting.collaboratorId && collaborationSetting.isMasterCollaborator\"></span>\n            <span class=\"sw-ionicon sw-ionicon-2x sw-ionicon-fw ion-email\" uib-tooltip=\"Invited Collaborator\" tooltip-popup-delay=\"100\" ng-hide=\"collaborationSetting.collaboratorId\"></span>\n            <span ng-hide=\"collaborationSetting.unrestrictedPrinting\">\n              <span class=\"sw-ionicon sw-ionicon-2x sw-ionicon-fw ion-printer\" uib-tooltip=\"Requires approval for PDF printing\" tooltip-popup-delay=\"100\"></span>\n              <span class=\"sw-ionicon sw-ionicon-lg sw-ionicon-fw sw-ionicon-super-overlay ion-help-circled clickthrough\"></span>\n            </span>\n            <span ng-show=\"collaborationSetting.unrestrictedPrinting\">\n              <span class=\"sw-ionicon sw-ionicon-2x sw-ionicon-fw ion-printer\" uib-tooltip=\"Unlimited PDF printing\" tooltip-popup-delay=\"100\"></span>\n              <span class=\"sw-ionicon sw-ionicon-lg sw-ionicon-fw sw-ionicon-super-overlay ion-checkmark-circled clickthrough\"></span>\n            </span>\n          </div>\n          <div class=\"pull-left title\">\n            <span>{{collaborationSetting.collaboratoremail}}</span>\n          </div>\n          <div class=\"pull-right\" ng-show=\"vm.listEditMode\">\n            <button class=\"btn sw-btn-xsm sw-btn-danger\" ng-show=\"vm.userIsProductionOwner && (collaborationSetting.addedById === undefined) && (collaborationSetting.collaboratorId !== undefined)\" ng-click=\"vm.promptTransferOwnership(collaborationSetting);$event.stopPropagation()\" type=\"button\" translate>buttons.Transfer Ownership</button>\n            <button class=\"btn sw-btn-xsm sw-btn-danger\" ng-show=\"vm.userIsProductionOwner || ( vm.userIsMasterCollaborator && (collaborationSetting.addedById === vm.userId))\" ng-click=\"vm.stopUserCollaboration(collaborationSetting); $event.stopPropagation()\" type=\"button\" translate>buttons.Stop Collaboration</button>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"text-center\" style=\"margin-top: 40px\" ng-show=\"vm.collaborationSettings.length === 0\">\n      <div class=\"hint-icon-message hint-icon-message-autow\">\n        <div class=\"icon\">\n          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n        </div>\n        <div class=\"text\">\n          <span translate>messages.No collaborators on this production</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsCreatePerformer.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" ng-show=\"vm.isNew\" translate>titles.New Performer</span>\n    <span class=\"text-lg sw-color-lightgray\" ng-hide=\"vm.isNew\">{{\'titles.Performer\' | translate}} -\n      [{{vm.performer.name}}]</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"cancel\" class=\"btn sw-btn-default\" ng-click=\"vm.onCancel()\" translate>buttons.Cancel</button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"saveupdate\" class=\"btn sw-btn-default\" ng-click=\"vm.saveUpdate()\" translate>buttons.Save</button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <form class=\"form-horizontal\">\n        <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Performer Name</label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n            <input class=\"form-control\" ng-model=\"vm.performer.name\" placeholder=\"\" type=\"text\">\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Icon Text</h4>\n  <div class=\"panel panel-default settingsDetailPanel sw-create-performer\">\n    <div class=\"panel-body\">\n      <form class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Text for Icon</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n            <input class=\"form-control text-center\" style=\"max-width: 100px\" input-maxlength=\"8\" ng-enter=\"onTextEnter()\" ng-model=\"vm.performer.text\" type=\"text\">\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Text Color</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n            <div class=\"input-group\">\n              <span class=\"clr-pick-div\" id=\"performer-text-color\">\n                <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.performer.textcolor\" options=\"vm.colorpickeroption\"></spectrum-colorpicker>\n              </span>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Text Scale</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n            <div class=\"control-label sw-color-lightgray textscale-value-block\">\n              {{vm.textSizeInPercent| number:0}}%\n            </div>\n            <div id=\"performer-text-scale\" class=\"textscale-slider-block\">\n              <rzslider class=\"swa-rzslider\" rz-slider-options=\"vm.textScaleSliderOptions\" rz-slider-model=\"vm.performer.textsize\"></rzslider>\n            </div>\n          </div>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\"></div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Icon Style</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <form class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>\n            labels.Icon Shape</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n            <div class=\"iconShapeDiv\">\n              <ul id=\"performer-icon-shape\">\n                <li>\n                  <a ng-class=\"{\'sel_iconShape\':vm.performer.shape === 1}\" ng-click=\"vm.selectIconShape(1)\"><img src=\"assets/images/shape-rect-icon.png\"></a>\n                </li>\n                <li>\n                  <a ng-class=\"{\'sel_iconShape\':vm.performer.shape === 2}\" ng-click=\"vm.selectIconShape(2)\"><img src=\"assets/images/shape-round-icon.png\"></a>\n                </li>\n                <li>\n                  <a ng-class=\"{\'sel_iconShape\':vm.performer.shape === 3}\" ng-click=\"vm.selectIconShape(3)\"><img src=\"assets/images/shape-diamond-icon.png\"></a>\n                </li>\n              </ul>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>\n            labels.Shape Color</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n            <div id=\"performer-shape-color\" class=\"clr-pick-div\">\n              <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.performer.shapecolor\" options=\"vm.colorpickeroption\"></spectrum-colorpicker>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>\n            labels.Border Color</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n            <div id=\"performer-border-color\" class=\"clr-pick-div\">\n              <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.performer.bordercolor\" options=\"vm.colorpickeroption\"></spectrum-colorpicker>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Scaling</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <form class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\">{{\'labels.Auto Scale\'|translate}}<br>\n            <small class=\"swa-color-lightgraygray\">\n              <em translate>messages.enable_auto_scaling_info</em>\n            </small> \n          </label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 form-inline\">\n            <switch class=\"swa-switch\" id=\"autoScaling\" ng-model=\"vm.performer.highlightperformer\" on=\"YES\" off=\"NO\"></switch>\n            <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw swa-color-gray\"></span>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Preview</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n        <div class=\"performerIconPreview performerIconBigPreview\">\n          <swa-performer-icon class=\"performerIconPreviewContainer\" id=\"iconLarge\" performer=\"vm.performer\"></swa-performer-icon>\n        </div>\n      </div>\n      <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\">\n        <div class=\"performerIconPreview performerIconSmallPreview\">\n          <swa-performer-icon class=\"performerIconPreviewContainer\" id=\"iconSmall\" performer=\"vm.performer\"></swa-performer-icon>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>");
$templateCache.put("app/components/productionSettings/settingsCreateSetPiece.html","<swa-help-bar ng-if=\"vm.showHelpBar\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-videos=\"vm.helpTourVideos\"></swa-help-bar>\n<div class=\"mainOuter\" ng-cloak>\n  <div class=\"navbar navbar-fixed-top sw-navbar\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.layerEditorActive}\">\n    <div class=\"navbar-center-title\">\n      <span class=\"text-lg sw-color-lightgray\" translate>titles.Set Piece Lab</span>\n<span class=\"text-lg sw-color-lightgray\" ng-show=\"vm.isNew\"> - {{\'titles.New Set Piece\' | translate}}</span>\n      <span class=\"text-lg sw-color-lightgray\" ng-hide=\"vm.isNew\"> - [{{vm.setPiece.name}}]</span>\n    </div>\n    <div class=\"swtoolbar swtoolbar-flex\">\n      <div class=\"swtoolbar-group swtoolbar-group-flex swtoolbar-group-flex-max\">\n        <button class=\"btn sw-btn-danger\" ng-click=\"vm.cancelSave()\" translate>buttons.Cancel</button>\n      </div>\n      <div class=\"swtoolbar-group swtoolbar-group-flex\">\n        <button class=\"btn sw-btn-default\" ng-click=\"vm.saveAndClose()\" translate>buttons.Save</button>\n      </div>\n    </div>\n  </div>\n  <div>\n    <div class=\"sw-setpieceeditor-chartarea\">\n      <div class=\"sw-maincontentarea-setpieceeditorcontent\">\n        <div class=\"swtoolbar sw-toolbar-setpiecechart\">\n          <div class=\"pull-right\" id=\"chart-undoredo\">\n            <button class=\"btn btn-sm sw-btn-inspector\" id=\"chart-undo\" ng-disabled=\"!(vm.changeTracker.enabled && vm.changeTracker.canUndo)\" ng-click=\"vm.undoAction()\">\n              <span class=\"toolbar-zoom-value\">{{vm.changeTracker.undoStack.length}}</span>\n              <span class=\"swafont swafont-lg swafont-icon-undo\"></span>\n            </button>\n            <button class=\"btn btn-sm sw-btn-inspector\" id=\"chart-redo\" ng-disabled=\"!(vm.changeTracker.enabled && vm.changeTracker.canRedo)\" ng-click=\"vm.redoAction()\">\n              <span class=\"swafont swafont-lg swafont-icon-redo\"></span>\n              <span class=\"toolbar-zoom-value\">{{vm.changeTracker.redoStack.length}}</span>\n            </button>\n          </div>\n        </div>\n        <div class=\"chartCanvasScrollContainer\" block-ui=\"block-ui-chart\">\n          <div id=\"chartCanvasContainer\" class=\"chartCanvasContainer text-center\">\n            <canvas class=\"chartCanvas\" id=\"chartCanvas\" width=\"1000\" height=\"600\" ng-mousedown=\"vm.canvasContainerClickDown($event)\" ng-mouseup=\"vm.canvasContainerClick($event)\"></canvas>\n            <div id=\"contextMenu\" class=\"sw-context-menu-container\" class=\"sw-chart-inspector-container\" ng-hide=\"(!vm.chartContextMenuState.visible || !vm.chartEditorState.chartOpen)\" ng-style=\"{\'left\': vm.chartContextMenuState.posX + \'px\', \'top\': vm.chartContextMenuState.posY + \'px\'}\" sw-chart-context-menu state=\"vm.chartInspectorState\" preferences=\"vm.userProductionPreferences\" on-action=\"vm.onInspectorAction(action)\" data-drag=\"true\" jqyoui-draggable=\"{onStop: \'vm.onContextMenuDragStop()\'}\" oncontextmenu=\"event.preventDefault()\">\n          </div>\n          <div state=\"vm.chartInspectorState\" ng-show=\"vm.chartInspectorState.textEditorActive\" ng-style=\"{\n              \'position\': \'absolute\',\n              \'left\': (vm.chartTextEditorState.editorPosX - (vm.chartTextEditorState.editorWidth / 2)) + \'px\',\n              \'top\': (vm.chartTextEditorState.editorPosY - (vm.chartTextEditorState.editorHeight / 2)) + \'px\',\n              \'width\': vm.chartTextEditorState.editorWidth + \'px\',\n              \'height\': vm.chartTextEditorState.editorHeight + \'px\',\n              \'transform\': \'rotate(\' + vm.chartTextEditorState.rotationAngle + \'deg) scale(\' + vm.chartTextEditorState.editorScale + \')\'\n            }\" id=\"mce-editor-inspector-text\" class=\"chartfloating-texteditor-textarea\">\n          </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"sw-chart-inspector-container\" sw-chart-inspector state=\"vm.chartInspectorState\" on-action=\"vm.onInspectorAction(action)\"></div>\n    </div>\n    <div class=\"sw-setpieceeditor-optionsarea swa-tabs-container\">\n      <uib-tabset justified=\"true\">\n        <uib-tab id=\"name-size\" disable=\"vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive\" ng-click=\"vm.clearSearchForSetpice()\">\n          <uib-tab-heading>\n            <div class=\"heading\">\n              <span class=\"icon swafont swafont-lg swafont-icon-settings-details\"></span>\n              <br>\n              <span class=\"title\" translate>titles.Name &amp; Size</span>\n            </div>\n          </uib-tab-heading>\n          <div class=\"panel panel-default settingsDetailPanel\">\n            <div class=\"panel-body form-horizontal\">\n              <div class=\"form-group\">\n                <div class=\"col-sm-12\">\n                  <label class=\"control-label\" translate>labels.Name</label>\n                  <input class=\"form-control\" ng-model=\"vm.setPiece.name\" type=\"text\" ng-change=\"vm.setPiece.dirty = true\">\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-sm-3 control-label\" translate>labels.Width</label>\n                <div class=\"col-sm-9 form-inline text-right\">\n                  <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 1\" ng-disabled=\"vm.isReferenced\" ng-model=\"vm.setPiece.width\" type=\"number\" swa-select-on-focus ng-change=\"vm.setPiece.dirty = true\">\n                  <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-disabled=\"vm.isReferenced\" ng-model=\"vm.setPieceWidth.feet\" type=\"number\" swa-select-on-focus ng-blur=\"vm.getSetPieceWidthInFeet()\">\n                  <label class=\"control-label\" ng-if=\"vm.setPiece.measurementunit === 0\" translate=\"\">labels.Feet-abbreviation</label>\n                  <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-disabled=\"vm.isReferenced\" ng-model=\"vm.setPieceWidth.inch\" type=\"number\" swa-select-on-focus ng-blur=\"vm.getSetPieceWidthInFeet()\">\n                  <label class=\"control-label\" ng-if=\"vm.setPiece.measurementunit === 0\" translate=\"\">labels.Inch-abbreviation</label>\n                  <label class=\"control-label\" ng-if=\"vm.setPiece.measurementunit === 1\">{{vm.measurementunitname}}</label>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <label class=\"col-sm-3 control-label\" translate>labels.Depth</label>\n                <div class=\"col-sm-9 form-inline text-right\">\n                  <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 1\" ng-disabled=\"vm.isReferenced\" ng-model=\"vm.setPiece.height\" type=\"number\" swa-select-on-focus ng-change=\"vm.setPiece.dirty = true\">\n                  <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-disabled=\"vm.isReferenced\" ng-model=\"vm.setPieceHeight.feet\" type=\"number\" swa-select-on-focus ng-blur=\"vm.getSetPieceHeightInFeet()\">\n                  <label class=\"control-label\" ng-if=\"vm.setPiece.measurementunit === 0\" translate=\"\">labels.Feet-abbreviation</label>\n                  <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-disabled=\"vm.isReferenced\" ng-model=\"vm.setPieceHeight.inch\" type=\"number\" swa-select-on-focus ng-blur=\"vm.getSetPieceHeightInFeet()\">\n                  <label class=\"control-label\" ng-if=\"vm.setPiece.measurementunit === 0\" translate=\"\">labels.Inch-abbreviation</label>\n                  <label class=\"control-label\" ng-if=\"vm.setPiece.measurementunit === 1\">{{vm.measurementunitname}}</label>\n                </div>\n              </div>\n              <div class=\"hint-icon-message\" style=\"margin-top: 8px\">\n                <div class=\"icon\">\n                  <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n                </div>\n                <div class=\"text\">\n                  <em class=\"sw-color-mediumlightgray\" translate>messages.create_setpiece_note</em>\n                </div>\n              </div>\n              <div class=\"hint-icon-message\" style=\"margin-top: 8px\">\n                <div class=\"icon\">\n                  <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n                </div>\n                <div class=\"text\">\n                  <em class=\"sw-color-mediumlightgray\" translate>messages.Make sure to place your drawing starting at 0.0 (bottom left corner of the grid)</em>\n                </div>\n              </div>\n              <h4 class=\"text-center sw-color-gray\" translate>labels.Preview</h4>\n              <div class=\"setpiece-editor-preview-container\">\n                <button id=\"preview\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.updatePreview()\"><span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-refresh\"></span></button>\n                <img class=\"setpiece-editor-preview\" ng-src=\"data:image/png;base64,{{vm.setPiece.image}}\" ng-show=\"vm.setPiece.image\">\n                <div class=\"setpiece-editor-preview-message-container\" ng-hide=\"vm.setPiece.image\">\n                  <span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-2x ion-android-warning\"></span><br>\n                  <em translate>messages.setpiece_preview_hint_1</em> <span class=\"sw-ionicon sw-ionicon-fw ion-refresh\"></span> <em translate>messages.setpiece_preview_hint_2</em>\n                </div>\n              </div>\n            </div>\n          </div>\n        </uib-tab>\n        <uib-tab id=\"shape-text\" ng-click=\"vm.clearSearchForSetpice()\">\n          <uib-tab-heading>\n            <div class=\"heading\">\n              <span class=\"icon swafont swafont-lg swafont-icon-shapes\"></span> / <span class=\"swafont swafont-lg swafont-icon-text-notes\"></span>\n              <br>\n              <span class=\"title\" translate>titles.Shapes &amp; Text</span>\n            </div>\n          </uib-tab-heading>\n          <div class=\"option-container\">\n            <div class=\"sw-shapes-picker-content\">\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Square)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_square_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Circle)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_circle_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Triangle)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_triangle_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Arc)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_arc_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.JoinedLine)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_joinedline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.JoinedLineArrow)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_joinedlinearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Curve)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_curve_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.CurveArrow)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_curvearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.SolidLine)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_solidline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.SolidLineArrow)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_solidlinearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.DottedLine)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_dottedline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.DottedLineArrow)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_dottedlinearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.ThinDottedLine)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_thindottedline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.CurtainLine)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_curtainline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.ThickLine)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <img src=\"assets/images/shapeicons/shape_thickline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Freehand)\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <span class=\"sw-color-lightgray\" translate>labels.Freehand</span>\n              </div>\n            </div>\n            <div class=\"tab-pane-parent\" style=\"margin-top: 16px\">\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" style=\"margin: auto\" ng-click=\"vm.addChartText()\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive}\">\n                <span class=\"sw-color-lightgray\" translate>labels.Add Text Box</span>\n              </div>\n            </div>\n          </div>\n        </uib-tab>\n        <uib-tab id=\"set-pieces\" disable=\"vm.chartInspectorState.freehandToolActive || vm.chartInspectorState.vectorEditorActive || vm.chartInspectorState.textEditorActive\">\n          <uib-tab-heading>\n            <div class=\"heading\">\n              <span class=\"icon swafont swafont-lg swafont-icon-setpiece\"></span>\n              <br>\n              <span class=\"title\" translate>titles.Set Pieces</span>\n            </div>\n          </uib-tab-heading>\n          <div class=\"search search-bar-chart\">\n            <input class=\"form-control\" id=\"searchpersetpiece\" name=\"searchpersetpiece\" ng-model=\"vm.searchpersetpiece\" ng-change=\"vm.searchStringChangedForSetpice()\" type=\"text\" placeholder=\"Search ...\">\n            <button class=\"btn btn-lg sw-btn-toolbar search-text-clear-btn search-text-clear-btn2-dock\" ng-click=\"vm.clearSearchForSetpice()\" ng-show=\"vm.searchpersetpiece.length > 0\">\n                <span class=\"sw-ionicon-lg ion-ios-close-outline\"></span>\n            </button>\n          </div>\n          <div class=\"option-container search-bar-adjustment\" ng-scrollbars ng-scrollbars-config=\"vm.defaultMinimalVScrollConfig\">\n            <div class=\"sw-setpiece-picker-content\">\n              <div class=\"sw-setpiece-picker-row\" ng-click=\"vm.setPiecePickerDidPickSetPiece(aSetPiece)\" ng-repeat=\"aSetPiece in vm.setPieces | filter: vm.setpieceSearchFilter | orderBy: \'oIndex\' as results\">\n                <div class=\"image-block\">\n                  <img ng-src=\"data:image/png;base64,{{aSetPiece.thumbimage}}\">\n                </div>\n                <div class=\"title-block sw-truncatetext-wrap\">\n                  <span class=\"title\">{{aSetPiece.name}}</span>\n                  <br>\n                  <span class=\"subtitle\" ng-if=\"vm.chartItemViewFactory.swMeasurementUnit === 1\">\n                    {{aSetPiece.width * vm.chartItemViewFactory.measurementConversionMultiplier  | number : 2}}\n                    x\n                    {{aSetPiece.height * vm.chartItemViewFactory.measurementConversionMultiplier  | number : 2}}\n                    m\n                  </span>\n                  <span class=\"subtitle\" ng-if=\"vm.chartItemViewFactory.swMeasurementUnit === 0\">\n                    {{aSetPiece.width * vm.chartItemViewFactory.measurementConversionMultiplier | feetAndInches}}\n                    x\n                    {{aSetPiece.height * vm.chartItemViewFactory.measurementConversionMultiplier | feetAndInches}}\n                  </span>\n                </div>\n              </div>\n              <div class=\"sw-performer-filter-row text-center\" ng-if=\"vm.setPieces.length === 0\">\n                <em class=\"sidebar-hint-text\" translate>labels.No Set Pieces</em>\n              </div>\n            </div>\n            <div id=\"no-productions\" class=\"no-matching-info-text\" ng-hide=\"results.length !== 0\">\n              <span>No matching Set Pieces!</span>\n            </div>\n          </div>\n        </uib-tab>\n      </uib-tabset>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsCustomNumberline.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" translate>titles.Custom Markers and Numbering</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"cancel\" class=\"btn sw-btn-default\" ng-click=\"vm.onCancel()\" translate>buttons.Cancel</button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"saveupdate\" class=\"btn sw-btn-default\" ng-disabled=\"vm.validationResult.hasErrors\" ng-click=\"vm.onSaveUpdate()\" translate>buttons.Save</button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Horizontal Markers and Numbering</h4>\n  <div id=\"custom-numberline-settings\" class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <div class=\"container-fluid form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-6 control-label\" translate>\n            labels.Show marker every\n          </label>\n          <div class=\"col-lg-3 col-md-4 col-sm-6 form-inline\">\n            <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.stageSettings.stagemeasurementunit === 1\" ng-model=\"vm.newNumberlineSettings.numberlineMarkerStepUserValue\" type=\"number\" swa-select-on-focus ng-change=\"vm.validateSettings()\">\n            <label class=\"control-label\" ng-show=\"vm.stageSettings.stagemeasurementunit === 1\" translate=\"\">labels.Centimeters-abbreviation</label>\n            <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.stageSettings.stagemeasurementunit === 0\" ng-model=\"vm.newNumberlineSettings.ftIn.feet\" ng-blur=\"vm.updateNumberlineMarkerStepUserValue()\" ng-change=\"vm.getNumberlineInFeet()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\" ng-hide=\"vm.stageSettings.stagemeasurementunit === 1\" translate=\"\">labels.Feet-abbreviation</label>\n            <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.stageSettings.stagemeasurementunit === 0\" ng-model=\"vm.newNumberlineSettings.ftIn.inch\" ng-blur=\"vm.updateNumberlineMarkerStepUserValue()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\" ng-hide=\"vm.stageSettings.stagemeasurementunit === 1\" translate=\"\">labels.Inch-abbreviation</label>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-6 control-label\" translate>\n            labels.Show 0 at center\n          </label>\n          <div class=\"col-lg-3 col-md-4 col-sm-6 form-inline\">\n            <switch class=\"swa-switch\" id=\"showZeroAtCenter\" ng-model=\"vm.newNumberlineSettings.numberlineZeroAtCenter\" on=\"YES\" off=\"NO\" ng-change=\"vm.validateSettings()\"></switch>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Show Numbers</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n            <div id=\"chart-numbering-mode\" class=\"btn-group btn-group-btn\">\n              <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\': vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility === 0}\" ng-click=\"vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility = 0;vm.validateSettings()\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility === 0,\n                                  \'ion-android-radio-button-off\': vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility !== 0}\"></span>\n                {{\'buttons.Even\'| translate}}\n              </button>\n              <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\': vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility === 1}\" ng-click=\"vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility = 1;vm.validateSettings()\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility === 1,\n                                  \'ion-android-radio-button-off\': vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility !== 1}\"></span>\n                {{\'buttons.Odd\'| translate}}\n              </button>\n              <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\': vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility === -1}\" ng-click=\"vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility = -1;vm.validateSettings()\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility === -1,\n                                  \'ion-android-radio-button-off\': vm.numberLineNumbersVisibilitySettings.numberlineNumbersVisibility !== -1}\"></span>\n                {{\'buttons.All\'| translate}}\n              </button>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-10\">\n            <p class=\"sw-color-mediumlightgray\">\n              <span>{{vm.stageSizeHintMessage}}</span><br>\n              <span translate>messages.customnumberlinehintline4</span>\n            </p>\n          </div>\n          <div class=\"col-sm-2 text-right\">\n            <button type=\"button\" ng-click=\"vm.resetSettings()\" class=\"btn btn-sm sw-btn-danger ng-binding\">Reset</button>\n          </div>\n        </div>\n        <div class=\"form-group col-sm-12\">\n          <div ng-show=\"vm.validationResult.invalidMarkerStep\">\n            <span class=\"sw-color-red\" translate=\"\">validationmessages.Marker step should be between 0 and stage width</span>\n          </div>\n        </div>\n        <h4 class=\"text-center sw-color-gray\" translate>labels.Preview</h4>\n        <div id=\"custom-numberline-preview\" class=\"panel panel-default settingsDetailPanel sw-create-performer\">\n          <div class=\"panel-body\">\n            <div class=\"container-fluid form-horizontal\" ng-hide=\"vm.validationResult.hasErrors\">\n              <div class=\"form-group\">\n                <div class=\"col-sm-4 text-right sw-color-mediumlightgray\" style=\"line-height: 50px\">\n                  <span translate>labels.Zoom</span>\n                  <span>:\n                    {{vm.previewSettings.zoomFactor}}x</span>\n                </div>\n                <div class=\"col-sm-4\">\n                  <rzslider class=\"swa-rzslider\" rz-slider-options=\"vm.zoomSliderOptions\" rz-slider-model=\"vm.previewSettings.zoomFactor\"></rzslider>\n                </div>\n              </div>\n              <div class=\"form-group\">\n                <div class=\"col-sm-12\">\n                  <div class=\"text-center sw-color-gray\">\n                    <span ng-show=\"vm.stageSettings.stagemeasurementunit === 0\" translate>labels.Feet</span>\n                    <span ng-show=\"vm.stageSettings.stagemeasurementunit === 1\" translate>labels.Meters</span>\n                  </div>\n                  <div class=\"numberline-preview-container\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigPreview\" ng-scrollbars-update=\"vm.updatePreviewScrollbar\">\n                    <canvas ng-disabled=\"\" id=\"myCanvas\" width=\"1000\" height=\"100\" class=\"numberline-preview-canvas\"></canvas>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"container-fluid form-horizontal\" ng-show=\"vm.validationResult.hasErrors\">\n              <div class=\"col-sm-12 text-center sw-color-red\">\n                <h4 translate>messages.No Preview</h4>\n              </div>\n            </div>\n          </div>\n        </div>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Vertical Markers and Numbering</h4>\n  <div id=\"custom-numberline-preview\" class=\"panel panel-default settingsDetailPanel sw-create-performer\">\n    <div class=\"panel-body\">\n      <div class=\"container-fluid form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-6 control-label\" translate>\n            labels.Show marker every\n          </label>\n          <div class=\"col-lg-3 col-md-4 col-sm-6 form-inline\">\n            <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.stageSettings.stagemeasurementunit === 1\" ng-model=\"vm.verticalNumberLineSettings.verticalNumberlineMarkerStepUserValue\" type=\"number\" swa-select-on-focus ng-change=\"vm.validateSettingsVertical()\">\n            <label class=\"control-label\" ng-show=\"vm.stageSettings.stagemeasurementunit === 1\" translate=\"\">labels.Centimeters-abbreviation</label>\n            <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.stageSettings.stagemeasurementunit === 0\" ng-model=\"vm.verticalNumberLineSettings.ftIn.feet\" ng-blur=\"vm.updateVerticalNumberlineMarkerStepUserValue()\" ng-change=\"vm.getNumberlineInFeet()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\" ng-hide=\"vm.stageSettings.stagemeasurementunit === 1\" translate=\"\">labels.Feet-abbreviation</label>\n            <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.stageSettings.stagemeasurementunit === 0\" ng-model=\"vm.verticalNumberLineSettings.ftIn.inch\" ng-blur=\"vm.updateVerticalNumberlineMarkerStepUserValue()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\" ng-hide=\"vm.stageSettings.stagemeasurementunit === 1\" translate=\"\">labels.Inch-abbreviation</label>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-6 control-label\">\n            Offset 0 from front of stage\n          </label>\n          <div class=\"col-lg-3 col-md-4 col-sm-6 form-inline\">\n            <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.stageSettings.stagemeasurementunit === 1\" ng-model=\"vm.verticalNumberLineOffsetSettings.verticalNumberlineOffsetUserValue\" type=\"number\" swa-select-on-focus ng-change=\"vm.validateSettingsVertical()\">\n            <label class=\"control-label\" ng-show=\"vm.stageSettings.stagemeasurementunit === 1\" translate=\"\">labels.Centimeters-abbreviation</label>\n            <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.stageSettings.stagemeasurementunit === 0\" ng-model=\"vm.verticalNumberLineOffsetSettings.ftIn.feet\" ng-blur=\"vm.updateVerticalNumberlineOffsetUserValue()\" ng-change=\"vm.getNumberlineInFeet()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\" ng-hide=\"vm.stageSettings.stagemeasurementunit === 1\" translate=\"\">labels.Feet-abbreviation</label>\n            <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.stageSettings.stagemeasurementunit === 0\" ng-model=\"vm.verticalNumberLineOffsetSettings.ftIn.inch\" ng-blur=\"vm.updateVerticalNumberlineOffsetUserValue()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\" ng-hide=\"vm.stageSettings.stagemeasurementunit === 1\" translate=\"\">labels.Inch-abbreviation</label>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>labels.Show Numbers</label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n            <div id=\"chart-numbering-mode\" class=\"btn-group btn-group-btn\">\n              <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\': vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility === 0}\" ng-click=\"vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility = 0;vm.validateSettingsVertical()\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility === 0,\n                                  \'ion-android-radio-button-off\': vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility !== 0}\"></span>\n                {{\'buttons.Even\'| translate}}\n              </button>\n              <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\': vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility === 1}\" ng-click=\"vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility = 1;vm.validateSettingsVertical()\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility === 1,\n                                  \'ion-android-radio-button-off\': vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility !== 1}\"></span>\n                {{\'buttons.Odd\'| translate}}\n              </button>\n              <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\': vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility === -1}\" ng-click=\"vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility = -1;vm.validateSettingsVertical()\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility === -1,\n                                  \'ion-android-radio-button-off\': vm.verticalNumberLineSettings.verticalNumberlineNumbersVisibility !== -1}\"></span>\n                {{\'buttons.All\'| translate}}\n              </button>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <div class=\"col-sm-10\">\n            <p class=\"sw-color-mediumlightgray\">\n              <span>{{vm.stageSizeHintMessage}}</span><br>\n              <span translate>messages.customnumberlinehintline5</span>\n            </p>\n          </div>\n          <div class=\"col-sm-2 text-right\">\n            <button type=\"button\" ng-click=\"vm.resetSettingsVertical()\" class=\"btn btn-sm sw-btn-danger ng-binding\">Reset</button>\n          </div>\n        </div>\n        <div class=\"form-group col-sm-12\">\n          <div ng-show=\"vm.validationResult.invalidMarkerStepVertical\">\n            <span class=\"sw-color-red\" translate=\"\">validationmessages.Marker step should be between 0 and stage depth</span>\n          </div>\n          <div ng-show=\"vm.validationResult.invalidZeroOffsetVertical\">\n            <span class=\"sw-color-red\" translate=\"\">validationmessages.0 Offset should be between 0 and stage depth</span>\n          </div>\n        </div>\n        <!-- <div class=\"form-group\">\n          <div class=\"col-sm-4 text-left sw-color-mediumlightgray\" style=\"line-height: 50px;\">\n            <span translate>labels.Zoom</span>\n            <span>:\n              {{vm.previewSettings.zoomFactor}}x</span>\n          </div>\n          <div class=\"col-sm-4\">\n            <rzslider class=\"swa-rzslider\" rz-slider-options=\"vm.zoomSliderOptions\" rz-slider-model=\"vm.previewSettings.zoomFactor\"></rzslider>\n          </div>\n        </div> -->\n        <!-- <h4 class=\"text-center sw-color-gray\" translate>labels.Preview</h4> -->\n        <!-- <div class=\"form-group\">\n          <div class=\"col-sm-12\">\n            <div class=\"text-center sw-color-gray\">\n              <span ng-show=\"vm.stageSettings.stagemeasurementunit === 0\" translate>labels.Feet</span>\n              <span ng-show=\"vm.stageSettings.stagemeasurementunit === 1\" translate>labels.Meters</span>\n            </div>\n            <div class=\"numberline-preview-container\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigPreview\" ng-scrollbars-update=\"vm.updatePreviewScrollbar\">\n              <canvas ng-disabled=\"\" id=\"myCanvasVertical\" width=\"100\" height=\"1000\" class=\"numberline-preview-canvas\"></canvas>\n            </div>\n          </div>\n        </div> -->\n      </div>\n    </div>\n  </div>\n</div>\n</div>");
$templateCache.put("app/components/productionSettings/settingsDeletePerformerPrompt.html","<div class=\"modal-header\" style=\"text-align: center\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Confirm\'|translate}}\n    </span>\n    <!-- <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span> -->\n</div>\n<div class=\"modal-body\">\n    <strong>{{\'messages.Delete selected performer?\' | translate}}</strong>\n    <p></p>\n    <p>{{\'messages.Warning for delete performer\' | translate}}</p>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"text-center\">\n        <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n        <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n    </div>\n</div>");
$templateCache.put("app/components/productionSettings/settingsImportPerformer.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" ng-show=\"vm.isNew\" translate>titles.New Performer</span>\n    <span class=\"text-lg sw-color-lightgray\" ng-hide=\"vm.isNew\">{{\'titles.Performer\' | translate}} - [{{vm.performer.name}}]</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"cancel\" class=\"btn sw-btn-default\" ng-click=\"vm.onCancel()\" translate>buttons.Cancel</button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"saveupdate\" class=\"btn sw-btn-default\" ng-click=\"vm.saveUpdate()\" translate>buttons.Save</button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <form class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\" translate>labels.Performer Name</label>\n          <div class=\"col-sm-4\">\n            <input class=\"form-control\" ng-model=\"vm.performer.name\" placeholder=\"\" type=\"text\">\n          </div>\n        </div>\n        <div class=\"form-group btm_boder_none\">\n          <label class=\"col-sm-4 control-label\">{{\'labels.Performer Icon\'|translate}}<br>\n            <small class=\"swa-color-lightgraygray\">\n              <em translate>messages.image_autoscale_iconsize</em>\n            </small>\n          </label>\n          <div class=\"col-sm-8\" style=\"display: flex\">\n            <div class=\"performerIconImageContainer-settings\">\n              <span spinner-key=\"spinner-performer-img\" us-spinner></span>\n              <img ng-src=\"data:image/png;base64,{{vm.performer.image || \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=\'}}\">\n            </div>\n            <div style=\"margin-left: 20px; padding-top: 15px\">\n              <input id=\"inputImageUpload\" accept=\"image/*\" swa-file-dataurl=\"vm.processFile($dataUrl, $error)\" ng-hide=\"true\" type=\"file\">\n              <button id=\"import-performer-image\" class=\"btn btn-sm btn-block sw-btn-secondary\" onclick=\"jQuery(\'input#inputImageUpload\').click()\" translate type=\"button\">buttons.Select Image</button>\n            </div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-sm-4 control-label\">{{\'labels.Auto Scale\'|translate}}<br>\n            <small class=\"swa-color-lightgraygray\">\n              <em translate>messages.enable_auto_scaling_info</em>\n            </small>            \n          </label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 form-inline\">\n            <switch class=\"swa-switch\" id=\"autoScaling\" ng-model=\"vm.performer.highlightperformer\" on=\"YES\" off=\"NO\"></switch>\n            <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw swa-color-gray\"></span>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsImportSetDesign.html","<div class=\"swtoolbar text-center\">\n  <div class=\"swtoolbar-group pull-left\">\n    <div style=\"display: inline-block\"></div>\n    <button class=\"btn sw-btn-default\" ng-click=\"vm.onCancel()\" translate type=\"button\">buttons.Cancel</button>\n  </div>\n  <div class=\"text-lg sw-color-lightgray\">\n    <span translate>titles.Import Set Design</span>\n  </div>\n  <div class=\"swtoolbar-group pull-right\">\n    <div style=\"display: inline-block\"></div>\n    <button class=\"btn sw-btn-default\" ng-click=\"vm.onSave()\" translate type=\"button\">buttons.Save</button>\n  </div>\n</div>\n<div class=\"modal-body\">\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Image</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <form class=\"form-horizontal\">\n        <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n          <div>\n            <div class=\"setpieceImageContainer-settings\">\n              <span spinner-key=\"spinner-setpiece-img\" us-spinner></span>\n              <img ng-src=\"data:image/png;base64,{{vm.setPiece.image || \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=\'}}\">\n            </div>\n            <div style=\"padding-left: 16px; display: inline-block\">\n              <input accept=\"image/*\" id=\"inputImageUpload\" ng-hide=\"true\" swa-file-dataurl=\"vm.processImage($dataUrl, $error)\" type=\"file\">\n              <button class=\"btn btn-sm sw-btn-secondary\" onclick=\"jQuery(\'input#inputImageUpload\').click()\" translate type=\"button\">buttons.Select Image</button>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Properties</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <form class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 control-label\" translate>\n            labels.Name\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n            <input class=\"form-control pull-left\" ng-model=\"vm.setPiece.name\" type=\"text\">\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 control-label\" translate>\n            labels.Width\n          </label>\n          <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 form-inline\">\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 1\" ng-model=\"vm.setPiece.width\" swa-select-on-focus type=\"number\">\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-model=\"vm.setPieceWidth.feet\" ng-blur=\"vm.getSetPieceWidthInFeet()\" swa-select-on-focus type=\"number\">\n            <label class=\"control-label\">{{vm.measurementunitname}}</label>\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-model=\"vm.setPieceWidth.inch\" ng-blur=\"vm.getSetPieceWidthInFeet()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\" ng-if=\"vm.setPiece.measurementunit === 0\" translate>labels.Inch-abbreviation</label>\n            <button id=\"set-image-measurement\" class=\"btn btn-sm sw-btn-secondary measurement-button-position\" ng-click=\"vm.setMeasurement()\" type=\"button\" ng-disabled=\"!vm.setPiece.image\">Measure from Image</button>\n          </div>\n        </div>\n        <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n          <label class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 control-label\" translate>\n            labels.Depth\n          </label>\n          <div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 form-inline\">\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 1\" ng-model=\"vm.setPiece.height\" swa-select-on-focus type=\"number\">\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-model=\"vm.setPieceHeight.feet\" ng-blur=\"vm.getSetPieceHeightInFeet()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\">{{vm.measurementunitname}}</label>\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-model=\"vm.setPieceHeight.inch\" ng-blur=\"vm.getSetPieceHeightInFeet()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\" ng-if=\"vm.setPiece.measurementunit === 0\" translate>labels.Inch-abbreviation</label>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"hint-icon-message\">\n    <div class=\"icon\">\n      <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n    </div>\n    <div class=\"text\">\n      <em ng-bind=\"vm.footerMessage\"></em>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsImportSetPiece.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" ng-show=\"vm.isNew\" translate>titles.Import Set Piece</span>\n    <span class=\"text-lg sw-color-lightgray\" ng-hide=\"vm.isNew\">{{\'titles.Set Piece\' | translate}} - [{{vm.setPiece.name}}]</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"cancel\" class=\"btn sw-btn-default\" ng-click=\"vm.onCancel()\" ng-show=\"vm.isNew\" translate>buttons.Cancel</button>\n      <button id=\"back\" class=\"btn sw-btn-default\" ng-click=\"vm.onBack()\" ng-hide=\"vm.isNew\">\n        <span class=\"sw-ionicon sw-ionicon-fw ion-chevron-left\"></span>\n        {{\'buttons.Set Pieces\' | translate}}\n      </button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"saveupdate\" class=\"btn sw-btn-default\" ng-click=\"vm.saveUpdate()\" ng-show=\"vm.isNew\" translate>buttons.Save</button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Image</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <form class=\"form-horizontal\">\n        <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n          <div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n            <div class=\"setpieceImageContainer-settings\" ng-if=\"vm.isNew\">\n              <span spinner-key=\"spinner-setpiece-img\" us-spinner></span>\n              <img ng-src=\"data:image/png;base64,{{vm.setPiece.image|| \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=\'}}\">\n            </div>\n            <div class=\"setpieceImageContainer-settings\" ng-if=\"!vm.isNew\">\n              <span spinner-key=\"spinner-setpiece-img\" us-spinner></span>\n              <img ng-src=\"{{vm.setPieceImageUrl}}\">\n            </div>\n            <div style=\"margin-left: 16px; display: inline-block\" ng-show=\"vm.isNew\">\n              <input id=\"inputImageUpload\" accept=\"image/*\" swa-file-dataurl=\"vm.processFile($dataUrl, $error)\" ng-hide=\"true\" type=\"file\">\n              <button id=\"import-set-piece-image\" class=\"btn btn-sm sw-btn-secondary\" onclick=\"jQuery(\'input#inputImageUpload\').click()\" translate type=\"button\">buttons.Select Image</button>\n            </div>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Properties</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <form class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>\n            labels.Name\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n            <input class=\"form-control pull-left\" ng-disabled=\"!vm.isNew\" ng-model=\"vm.setPiece.name\" type=\"text\">\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>\n            labels.Width\n          </label>\n          <div class=\"col-lg-5 col-md-5 col-sm-4 col-xs-4 form-inline\">\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 1\" ng-disabled=\"!vm.isNew\" ng-model=\"vm.setPiece.width\" type=\"number\" swa-select-on-focus>\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-disabled=\"!vm.isNew\" ng-model=\"vm.setPieceWidth.feet\" ng-blur=\"vm.getSetPieceWidthInFeet()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\">{{vm.measurementunitname}}</label>\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-disabled=\"!vm.isNew\" ng-model=\"vm.setPieceWidth.inch\" ng-blur=\"vm.getSetPieceWidthInFeet()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\" ng-if=\"vm.setPiece.measurementunit === 0\" translate>labels.Inch-abbreviation</label>\n            <button id=\"set-image-measurement\" class=\"btn btn-sm sw-btn-secondary measurement-button-position\" ng-if=\"vm.isNew\" ng-click=\"vm.setMeasurement()\" type=\"button\" ng-disabled=\"!vm.setPiece.image\" translate>buttons.Measure from Image</button>\n          </div>\n        </div>\n        <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>\n            labels.Depth\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 form-inline\">\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 1\" ng-disabled=\"!vm.isNew\" ng-model=\"vm.setPiece.height\" type=\"number\" swa-select-on-focus>\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-disabled=\"!vm.isNew\" ng-model=\"vm.setPieceHeight.feet\" ng-blur=\"vm.getSetPieceHeightInFeet()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\">{{vm.measurementunitname}}</label>\n            <input class=\"form-control text-right\" style=\"width: 80px\" ng-if=\"vm.setPiece.measurementunit === 0\" ng-disabled=\"!vm.isNew\" ng-model=\"vm.setPieceHeight.inch\" ng-blur=\"vm.getSetPieceHeightInFeet()\" type=\"number\" swa-select-on-focus>\n            <label class=\"control-label\" ng-if=\"vm.setPiece.measurementunit === 0\" translate=\"\">labels.Inch-abbreviation</label>\n          </div>\n        </div>\n      </form>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsPerformersList.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" translate>titles.Performers</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"import-performer\" class=\"btn sw-btn-default\" ng-click=\"vm.onImport()\" ng-disabled=\"vm.listEditMode || !(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowimportperformers) || (vm.performers.length >= vm.activePlanRules.allowedNumberOfPerformers)\" translate>buttons.Import</button>\n      <button id=\"add-performer\" class=\"btn sw-btn-default\" ng-click=\"vm.onCreate()\" ng-disabled=\"vm.listEditMode || !(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowaddperformers) || (vm.performers.length >= vm.activePlanRules.allowedNumberOfPerformers)\" translate>buttons.Add</button>\n      <button class=\"btn sw-btn-default\" ng-if=\"vm.activeCollaborationConfig.isProductionOwner\" ng-disabled=\"vm.activePlanRules.planId === 2\" stackable-trigger=\"vm.reassignPopover\" translate>buttons.Reassignment</button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.reassignPopover\">\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-click=\"vm.performerTrackReassignmentPrompt()\" ng-disabled=\"vm.performers.length < 2\">\n                <span class=\"title\" translate>buttons.Track Reassignment</span>\n              </div>\n              <div class=\"menu-item\" ng-click=\"vm.undoReassignmentPrompt()\" ng-disabled=\"vm.performerPairsWithIdsForUndo === undefined\">\n                <span class=\"title\" translate>buttons.Undo Last Reassignment</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"editdone-performer\" class=\"btn sw-btn-default\" ng-click=\"vm.onEditToggle()\" ng-disabled=\"(vm.performers.length === 0) || !(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowdeleteperformers || vm.activeAccessRules.allowreorderperformers)\">\n        <span ng-hide=\"vm.listEditMode\">{{\'buttons.Delete\'| translate}}\n          /\n          <span class=\"sw-ionicon sw-ionicon-fw ion-drag\"></span>\n        </span>\n        <span ng-show=\"vm.listEditMode\" translate>buttons.Done</span>\n      </button>\n    </div>\n    <div class=\"search search-bar-chart\">\n        <input class=\"form-control\" id=\"searchperformername\" name=\"searchperformername\" ng-model=\"vm.searchperformername\" ng-change=\"vm.searchStringChanged()\" type=\"text\" placeholder=\"Search ...\">\n        <button class=\"btn btn-lg sw-btn-toolbar search-text-clear-btn search-text-clear-btn3-settings\" ng-click=\"vm.clearSearch()\" ng-show=\"vm.searchperformername.length > 0\">\n            <span class=\"sw-ionicon-lg ion-ios-close-outline\"></span>\n        </button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <div class=\"settingsDetailPanel\" ng-cloak>\n    <div class=\"settings-list-container margin-for-search-bar\" ng-style=\"{\'margin-right\': (vm.listEditMode?\'40px\': \'0\')}\" ng-hide=\"vm.performers.length === 0\" ui-sortable=\"vm.performersSortableOptions\" ng-model=\"vm.performers\">\n      <div id=\"performer-{{$index}}\" class=\"settings-performer-row\" data-ng-repeat=\"aPerformer in vm.performers | limitTo: vm.activePlanRules.allowedNumberOfPerformers | filter: vm.performerSearchFilter | orderBy: \'oIndex\' as results\" ng-click=\"vm.onPerformerClick(aPerformer)\">\n        <div class=\"performer-icon pull-left\">\n          <img ng-src=\"data:image/png;base64,{{aPerformer.image}}\">\n        </div>\n        <div class=\"title pull-left\">\n          {{aPerformer.name}}\n        </div>\n        <div class=\"pull-right\" ng-show=\"vm.listEditMode\">\n          <button class=\"btn sw-btn-xsm sw-btn-danger\" ng-click=\"vm.deletePerformerAtIndexPrompt($index);\n              $event.stopPropagation()\" translate type=\"button\" ng-disabled=\"!(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowdeleteperformers)\">buttons.Delete</button>\n          <span style=\"cursor: ns-resize; width: 40px\" class=\"sw-ionicon-fw sw-ionicon-lg ion-drag sortDragHandle\" ng-show=\"vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowreorderperformers\"></span>\n        </div>\n      </div>\n      <div id=\"no-productions\" class=\"no-matching-info-text\" ng-hide=\"results.length !== 0\">\n        <span>No matching Performers!</span>\n      </div>\n    </div>\n    <div class=\"text-center\" style=\"margin-top: 40px\" ng-show=\"vm.performers.length === 0\">\n      <div class=\"hint-icon-message hint-icon-message-autow\">\n        <div class=\"icon\">\n          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n        </div>\n        <div class=\"text\">\n          <span translate>messages.No Performers in this Production</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsPermanentStageEditor.html","<swa-help-bar ng-if=\"vm.showHelpBar\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-videos=\"vm.helpTourVideos\"></swa-help-bar>\n<div class=\"mainOuter\" ng-cloak>\n  <div class=\"navbar navbar-fixed-top sw-navbar\" ng-class=\"{\'swa-disabled-fade clickthrough\': vm.chartInspectorState.layerEditorActive}\">\n    <div class=\"navbar-center-title\">\n      <span class=\"text-lg sw-color-lightgray\" translate>titles.Permanent Stage Editor</span>\n    </div>\n    <div class=\"swtoolbar swtoolbar-flex\">\n      <div class=\"swtoolbar-group swtoolbar-group-flex\">\n        <img class=\"sws-logo\" src=\"assets/images/sws-logo-light.png\">\n      </div>\n      <div class=\"swtoolbar-group swtoolbar-group-flex swtoolbar-group-flex-max text-center\"></div>\n      <div class=\"swtoolbar-group-flex\">\n        <button id=\"zoom-picker\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.zoomPicker\" ng-disabled=\"!vm.chartEditorState.chartOpen\">\n          <span class=\"swafont swafont-lg swafont-icon-zoom\"></span>\n          <span class=\"toolbar-zoom-value\">{{vm.chartEditorState.zoomFactor}}x</span>\n        </button>\n        <stackable-popover stackable=\"vm.zoomPicker\" stackable-placement=\"bottom\">\n          <div class=\"sw-popover-title\">\n            <span>{{\'titles.Zoom\'| translate}}:\n              {{vm.chartEditorState.zoomFactor}}x</span>\n          </div>\n          <div class=\"sw-popover-content sw-popover-zoom-picker\">\n            <div class=\"sw-zoom-picker-content\">\n              <rzslider class=\"swa-rzslider\" rz-slider-options=\"vm.zoomSliderOptions\" rz-slider-model=\"vm.chartEditorState.zoomFactor\"></rzslider>\n              <div class=\"hint-icon-message\" style=\"margin-top: 8px\">\n                <div class=\"icon\">\n                  <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n                </div>\n                <div class=\"text\">\n                  <em class=\"sw-text-sm swa-color-lightgraygray\" translate>messages.Hold the \'Ctrl\' key and drag the chart to scroll around when zoomed in</em>\n                </div>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n      <div class=\"swtoolbar-group swtoolbar-group-flex\">\n        <button id=\"shape-picker\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.shapePicker\" ng-disabled=\"!vm.chartEditorState.chartOpen\">\n          <span class=\"swafont swafont-lg swafont-icon-shapes\"></span>\n        </button>\n        <stackable-popover stackable=\"vm.shapePicker\" stackable-placement=\"bottom\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.Shapes</span>\n          </div>\n          <div class=\"sw-popover-content sw-popover-shapes-picker\">\n            <div class=\"sw-shapes-picker-content\">\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Square)\">\n                <img src=\"assets/images/shapeicons/shape_square_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Circle)\">\n                <img src=\"assets/images/shapeicons/shape_circle_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Triangle)\">\n                <img src=\"assets/images/shapeicons/shape_triangle_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Arc)\">\n                <img src=\"assets/images/shapeicons/shape_arc_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.JoinedLine)\">\n                <img src=\"assets/images/shapeicons/shape_joinedline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.JoinedLineArrow)\">\n                <img src=\"assets/images/shapeicons/shape_joinedlinearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Curve)\">\n                <img src=\"assets/images/shapeicons/shape_curve_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.CurveArrow)\">\n                <img src=\"assets/images/shapeicons/shape_curvearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.SolidLine)\">\n                <img src=\"assets/images/shapeicons/shape_solidline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.SolidLineArrow)\">\n                <img src=\"assets/images/shapeicons/shape_solidlinearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.DottedLine)\">\n                <img src=\"assets/images/shapeicons/shape_dottedline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.DottedLineArrow)\">\n                <img src=\"assets/images/shapeicons/shape_dottedlinearrow_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.ThinDottedLine)\">\n                <img src=\"assets/images/shapeicons/shape_thindottedline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.CurtainLine)\">\n                <img src=\"assets/images/shapeicons/shape_curtainline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.ThickLine)\">\n                <img src=\"assets/images/shapeicons/shape_thickline_icon@2x.png\">\n              </div>\n              <div class=\"sw-shapes-picker-item sw-shapes-picker-item-wide\" ng-click=\"vm.shapePickerDidPickShape(vm.SWChartItem.ShapeType.Freehand)\">\n                <span class=\"sw-color-lightgray\" translate>labels.Freehand</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n        <button id=\"set-piece-picker\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.setPiecePicker\" ng-disabled=\"!vm.chartEditorState.chartOpen\">\n          <span class=\"swafont swafont-lg swafont-icon-setpiece\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.setPiecePicker\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.Set Pieces</span>\n          </div>\n          <div class=\"search search-bar-chart\">\n            <input class=\"form-control\" id=\"searchpersetpiece\" name=\"searchpersetpiece\" ng-model=\"vm.searchpersetpiece\" ng-change=\"vm.searchStringChangedForSetpice()\" type=\"text\" placeholder=\"Search ...\">\n            <button class=\"btn btn-lg sw-btn-toolbar search-text-clear-btn search-text-clear-btn-float\" ng-click=\"vm.clearSearchForSetpice()\" ng-show=\"vm.searchpersetpiece.length > 0\">\n                <span class=\"sw-ionicon-lg ion-ios-close-outline\"></span>\n            </button>\n          </div>\n          <div class=\"sw-popover-content sw-popover-setpiece-picker\">\n            <div class=\"sw-setpiece-picker-content\">\n              <div class=\"sw-setpiece-picker-row\" ng-click=\"vm.setPiecePickerDidPickSetPiece(aSetPiece)\" ng-repeat=\"aSetPiece in vm.setPieces | filter: vm.setpieceSearchFilter | orderBy: \'oIndex\' as results\">\n                <div class=\"image-block\">\n                  <img ng-src=\"data:image/png;base64,{{aSetPiece.thumbimage}}\">\n                </div>\n                <div class=\"title-block sw-truncatetext-wrap\">\n                  <span class=\"title\">{{aSetPiece.name}}</span>\n                  <br>\n                  <span class=\"subtitle\" ng-if=\"vm.chartItemViewFactory.swMeasurementUnit === 1\">\n                    {{aSetPiece.width * vm.chartItemViewFactory.measurementConversionMultiplier | number: 2}}\n                    x\n                    {{aSetPiece.height * vm.chartItemViewFactory.measurementConversionMultiplier | number: 2}}\n                    m\n                    <!-- {{aSetPiece.measurementunit === 0 ? \"ft\" : \"mt\"}} -->\n                  </span>\n                  <span class=\"subtitle\" ng-if=\"vm.chartItemViewFactory.swMeasurementUnit === 0\">\n                    {{aSetPiece.width * vm.chartItemViewFactory.measurementConversionMultiplier | feetAndInches}}\n                    x\n                    {{aSetPiece.height * vm.chartItemViewFactory.measurementConversionMultiplier | feetAndInches}}</span>\n                </div>\n              </div>\n              <div class=\"sw-performer-filter-row text-center\" ng-if=\"vm.setPieces.length === 0\">\n                <em class=\"sidebar-hint-text\" translate>labels.No Set Pieces</em>\n              </div>\n            </div>\n            <div id=\"no-productions\" class=\"no-matching-info-text\" ng-hide=\"results.length !== 0\">\n              <span>No matching Set Pieces!</span>\n            </div>\n          </div>\n        </stackable-popover>\n        <button id=\"import-set-design\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.importSetDesign()\" ng-disabled=\"!vm.chartEditorState.chartOpen\">\n          <span class=\"swafont swafont-lg swafont-icon-import-setdesign\"></span>\n        </button>\n        <button id=\"add-chart-text\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.addChartText()\" ng-disabled=\"!vm.chartEditorState.chartOpen\">\n          <span class=\"swafont swafont-lg swafont-icon-text-notes\"></span>\n        </button>\n      </div>\n      <div class=\"swtoolbar-group swtoolbar-group-flex\">\n        <button class=\"btn sw-btn-toolbar\" id=\"chart-undo\" ng-disabled=\"!(vm.changeTracker.enabled && vm.changeTracker.canUndo)\" ng-click=\"vm.undoAction()\">\n          <span class=\"toolbar-zoom-value\">{{vm.changeTracker.undoStack.length}}</span>\n          <span class=\"swafont swafont-lg swafont-icon-undo\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"chart-redo\" ng-disabled=\"!(vm.changeTracker.enabled && vm.changeTracker.canRedo)\" ng-click=\"vm.redoAction()\">\n          <span class=\"swafont swafont-lg swafont-icon-redo\"></span>\n          <span class=\"toolbar-zoom-value\">{{vm.changeTracker.redoStack.length}}</span>\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"sw-permanentstageeditor\">\n    <div class=\"sw-sidebar sw-sidebar-bar-only\" ng-class=\"{\'sw-sidebar-left-hidden\': (revealSidebar === false), \'sw-sidebar-left-visible\': (revealSidebar === true), \'swa-disabled-fade clickthrough\': vm.chartInspectorState.layerEditorActive}\" ng-init=\"revealSidebar = false\">\n      <div class=\"sw-navbar sw-navbar-top sw-color-red\" ng-mouseenter=\"revealSidebar = true\" ng-mouseleave=\"revealSidebar = false\">\n        <div class=\"swtoolbar\">\n          <button class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.saveAndClose()\" ng-show=\"revealSidebar\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n          <div class=\"text-lg sw-truncatetext\" style=\"width: calc(100% - 50px)\">\n            <span translate>titles.Stage Dimensions</span>\n          </div>\n          <button class=\"btn btn-lg sw-btn-toolbar\" ng-hide=\"revealSidebar\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n        </div>\n      </div>\n    </div>\n    <div class=\"sw-maincontentarea-permanentstage sw-editorcontent\">\n      <div class=\"chartCanvasScrollContainer\" ng-show=\"vm.chartEditorState.chartOpen || vm.chartEditorState.ccInitializationPending\" block-ui=\"block-ui-chart\">\n        <div id=\"chartCanvasContainer\" class=\"chartCanvasContainer text-center\">\n          <span class=\"swa-color-lightgraygray hide-when-blocked\" style=\"width: 100%;top: 50%;position: absolute;left: 0;transform: translateY(-50%)\">{{\'messages.Chart not visible?\' | translate}}\n            <button class=\"btn sw-btn-secondary\" ng-click=\"vm.ccForceSizeUpdate()\"><span class=\"sw-ionicon-fw sw-ionicon-lg ion-refresh\"></span>{{\'buttons.Refresh\' | translate}}</button>\n          </span>\n          <canvas class=\"chartCanvas\" id=\"chartCanvas\" width=\"1000\" height=\"600\" ng-mousedown=\"vm.canvasContainerClickDown($event)\" ng-mouseup=\"vm.canvasContainerClick($event)\"></canvas>\n          <div id=\"contextMenu\" class=\"sw-context-menu-container\" class=\"sw-chart-inspector-container\" ng-hide=\"(!vm.chartContextMenuState.visible  || !vm.chartEditorState.chartOpen)\" ng-style=\"{\'left\': vm.chartContextMenuState.posX + \'px\', \'top\': vm.chartContextMenuState.posY + \'px\'}\" sw-chart-context-menu state=\"vm.chartInspectorState\" preferences=\"vm.userProductionPreferences\" on-action=\"vm.onInspectorAction(action)\" data-drag=\"true\" jqyoui-draggable=\"{onStop: \'vm.onContextMenuDragStop()\'}\" oncontextmenu=\"event.preventDefault()\">\n          </div>\n          <div state=\"vm.chartInspectorState\" ng-show=\"vm.chartInspectorState.textEditorActive\" ng-style=\"{\n              \'position\': \'absolute\',\n              \'left\': (vm.chartTextEditorState.editorPosX - (vm.chartTextEditorState.editorWidth / 2)) + \'px\',\n              \'top\': (vm.chartTextEditorState.editorPosY - (vm.chartTextEditorState.editorHeight / 2)) + \'px\',\n              \'width\': vm.chartTextEditorState.editorWidth + \'px\',\n              \'height\': vm.chartTextEditorState.editorHeight + \'px\',\n              \'transform\': \'rotate(\' + vm.chartTextEditorState.rotationAngle + \'deg) scale(\' + vm.chartTextEditorState.editorScale + \')\'\n            }\" id=\"mce-editor-inspector-text\" class=\"chartfloating-texteditor-textarea\">\n          </div>\n        </div>\n        <div ng-if=\"false\" class=\"chartPanVScrollContainer\" ng-style=\"{\'margin-left\': vm.chartPanScrollParams.vertical.marginLeft + \'px\', \'margin-top\': vm.chartPanScrollParams.vertical.containerTopOffset + \'px\', height: vm.chartPanScrollParams.vertical.containerHeight + \'px\'}\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigChartPanV\" ng-scrollbars-update=\"vm.chartPanVScrollbarsCallUpdate\">\n          <div class=\"chartPanVScrollContent\" ng-style=\"{height: vm.chartPanScrollParams.vertical.contentHeight + \'px\'}\"></div>\n        </div>\n        <div ng-if=\"false\" class=\"chartPanHScrollContainer\" ng-style=\"{\'margin-left\': vm.chartPanScrollParams.horizontal.containerLeftOffset + \'px\', \'margin-top\': vm.chartPanScrollParams.vertical.marginTop + \'px\', width: vm.chartPanScrollParams.horizontal.containerWidth + \'px\'}\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigChartPanH\" ng-scrollbars-update=\"vm.chartPanHScrollbarsCallUpdate\">\n          <div class=\"chartPanHScrollContent\" ng-style=\"{width: vm.chartPanScrollParams.horizontal.contentWidth + \'px\'}\"></div>\n        </div>\n      </div>\n    </div>\n    <div class=\"sw-chart-inspector-container\" sw-chart-inspector state=\"vm.chartInspectorState\" on-action=\"vm.onInspectorAction(action)\"></div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsPreferences.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" translate>titles.User Settings</span>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer sw-preferences\" ng-scrollbars>\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Content Defaults</h4>\n  <div id=\"personal-content-defaults-settings\" class=\"panel panel-default settingsDetailPanel preferences\">\n    <div class=\"panel-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2\">\n            <label class=\"control-label\" translate>labels.Text Defaults</label>\n            <span class=\"subtitle\" translate>labels.Text Defaults Subtitle</span>\n          </div>\n          <div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10 form-inline\">\n          <div id=\"personal-content-defaults\" class=\"left\">\n              <div class=\"btn-group btn-group-btn1\">\n                <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.personalContentDefaults.selectedType === \'settingsChartText\'}\" ng-click=\"vm.viewSettings(\'settingsChartText\')\" type=\"button\">\n                  {{\'buttons.Chart Text\'| translate}}\n                </button>\n                <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.personalContentDefaults.selectedType === \'settingsScriptAction\'}\" ng-click=\"vm.viewSettings(\'settingsScriptAction\')\" type=\"button\" ng-if=\"vm.production.productiontype === 1\">\n                  {{\'buttons.Script Action\'| translate}}\n                </button>\n                <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.personalContentDefaults.selectedType === \'settingsScriptLq\'}\" ng-click=\"vm.viewSettings(\'settingsScriptLq\')\" type=\"button\" ng-if=\"vm.production.productiontype === 1\">\n                  {{\'buttons.Script Cue\'| translate}}\n                </button>\n                <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.personalContentDefaults.selectedType === \'settingsScriptText\'}\" ng-click=\"vm.viewSettings(\'settingsScriptText\')\" type=\"button\" ng-if=\"vm.production.productiontype === 1\">\n                  {{\'buttons.Script Text\'| translate}}\n                </button>\n                <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.personalContentDefaults.selectedType === \'colorScriptHighlight\'}\" ng-click=\"vm.viewSettings(\'colorScriptHighlight\')\" type=\"button\" ng-if=\"vm.production.productiontype === 1\">\n                  {{\'buttons.Script Highlight\'| translate}}\n                </button>\n              </div>\n            </div>\n            <div id=\"personal-content-defaults-preview\" class=\"preview right\" ng-if=\"vm.personalContentDefaults.selectedType === \'settingsChartText\'\">\n              <span class=\"title left\" translate>labels.Preview</span>\n              <div class=\"preview-container left\" id=\"settings-preview\">\n                <span id=\"preview-content\" class=\"preview-content\">AaBb</span>\n              </div>\n              <button class=\"btn sw-btn-radio left\" ng-click=\"vm.reset(\'Text Defaults\')\" type=\"button\">\n                {{\'buttons.Reset\'| translate}}\n              </button>\n            </div>\n          </div>\n          <div class=\"col-lg-10 col-md-10 col-sm-10 col-xs-10 form-inline\">\n            <div class=\"sub-settings highlight-settings\" ng-if=\"vm.personalContentDefaults.selectedType !== \'settingsChartText\'\" style=\"border: none\">\n              <div class=\"hint-icon-message\">\n                <div class=\"icon\">\n                  <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n                </div>\n                <div class=\"text\">\n                  <em>{{\'messages.Hint for script text defaults\'|translate}}</em>\n                </div>\n              </div>\n            </div>\n            <!-- <div class=\"sub-settings highlight-settings\" ng-if=\"vm.personalContentDefaults.selectedType === \'colorScriptHighlight\'\">\n              <div class=\"color-option\">\n                <span class=\"sw-ionicon ion-paintbucket sub-settings-icon left selector\"></span>\n              </div>\n              <div\n                class=\"color-option color-option-bordered\"\n                ng-repeat=\"color in vm.highlightColorPickerOption.palette[0]\"\n                ng-style=\"{\'background-color\': color};\"\n                ng-class=\"{\'color-checked\': vm.productionPreferences.contentDefaults.colorScriptHighlight === color}\"\n                ng-click=\"vm.editSettings(\'colorScriptHighlight\', color)\">\n              </div>\n            </div> -->\n            <div class=\"text-settings\" ng-if=\"vm.personalContentDefaults.selectedType === \'settingsChartText\'\">\n              <div class=\"sub-settings left\">\n                <span class=\"sub-settings-icon sw-ionicon ion-paintbucket left selector\"></span>\n                <div class=\"clr bg-container left clickable checkerboard-bk\" stackable-trigger=\"switchBgColor\">\n                    <div style=\"height: 100%; width: 100%\" ng-style=\"{\'background-color\': vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType].fillColor}\">\n                    </div>\n                </div>\n                <stackable-popover stackable-placement=\"bottom\" stackable=\"switchBgColor\" stackable-enable-escape=\"true\">\n                  <div class=\"sw-popover-menu\" role=\"menu\">\n                    <div class=\"menu-group color-pallete\">\n                      <div class=\"color-row\" ng-repeat=\"colorRow in vm.colorPickerOption\" style=\"display: flex\">\n                        <div class=\"color\" ng-repeat=\"color in colorRow track by $index\" ng-click=\"vm.editSettings(vm.personalContentDefaults.selectedType, { fillColor : vm.colorToRgb(color) });switchBgColor.show = false\" style=\"width: 25px;\n                            height: 25px;\n                            border: 1px solid #60656D;\n                            border-radius: 4px;\n                            cursor: pointer;\n                            margin: 2px\" ng-style=\"{\'background-color\': color}\">\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                </stackable-popover>\n              </div>\n              <div class=\"sub-settings left\">\n                <span class=\"sub-settings-icon left selector sw-ionicon ion-brush\"></span>\n                <div class=\"clr fg-container left clickable\" ng-style=\"{\'background-color\': vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType].fontColor};\" stackable-trigger=\"switchFgColor\"></div>\n              <stackable-popover stackable-placement=\"bottom\" stackable=\"switchFgColor\" stackable-enable-escape=\"true\">\n                <div class=\"sw-popover-menu\" role=\"menu\">\n                  <div class=\"menu-group color-pallete\">\n                    <div class=\"color-row\" ng-repeat=\"colorRow in vm.colorPickerOption\" style=\"display: flex\">\n                      <div class=\"color\" ng-repeat=\"color in colorRow track by $index\" ng-click=\"vm.editSettings(vm.personalContentDefaults.selectedType, { fontColor : vm.colorToRgb(color) });switchFgColor.show = false\" style=\"width: 25px;\n                          height: 25px;\n                          border: 1px solid #60656D;\n                          border-radius: 4px;\n                          cursor: pointer;\n                          margin: 2px\" ng-style=\"{\'background-color\': color}\">\n                      </div>\n                    </div>\n                  </div>\n                </div>\n              </stackable-popover>\n              </div>\n              <div id=\"font-family-setting\" class=\"font-setting sub-settings left clickable\" stackable-trigger=\"switchFontFamily\">\n                <span class=\"sub-settings-text left\">{{vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType].fontFamily}}</span>\n              </div>\n              <stackable-popover stackable-placement=\"bottom\" stackable=\"switchFontFamily\" stackable-enable-escape=\"true\">\n                <div class=\"sw-popover-menu\" role=\"menu\">\n                  <div class=\"menu-group\">\n                    <div class=\"menu-item\" ng-repeat=\"fontFamily in vm.fontFamilies\" ng-click=\"vm.editSettings(vm.personalContentDefaults.selectedType, { fontFamily : fontFamily }); switchFontFamily.show = false\">\n                      <span class=\"title\">{{fontFamily}}</span>\n                    </div>\n                  </div>\n                </div>\n              </stackable-popover>\n              <div class=\"sub-settings left clickable\" ng-click=\"vm.fontSizeStepper(vm.personalContentDefaults.selectedType, \'-\')\">\n                <span class=\"sub-settings-icon left selector sw-ionicon ion-minus sw-ionicon-bold\"></span>\n              </div>\n              <div class=\"font-setting sub-settings left clickable\" stackable-trigger=\"vm.fontSizePicker\">\n                <span class=\"sub-settings-text left\">{{vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType].fontSize}} {{vm.fontSizeRange.unit}}</span>\n              </div>\n              <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.fontSizePicker\" stackable-enable-escape=\"true\">\n                <div class=\"sw-popover-menu sw-fontsize-picker\">\n                  <div class=\"menu-group\">\n                    <div class=\"menu-item text-center\" ng-repeat=\"fontSize in vm.fontSizeRange.pickerValues\" ng-click=\"vm.editSettings(vm.personalContentDefaults.selectedType, { fontSize : fontSize }); vm.fontSizePicker.show = false;\">\n                      <span class=\"title\">{{fontSize}} {{vm.fontSizeRange.unit}}</span>\n                    </div>\n                  </div>\n                </div>\n              </stackable-popover>\n              <div class=\"sub-settings left clickable\" ng-click=\"vm.fontSizeStepper(vm.personalContentDefaults.selectedType, \'+\')\">\n                <span class=\"sub-settings-icon left selector swafont swafont-lg swafont-icon-plus sw-ionicon-bold\"></span>\n              </div>\n\n              <div class=\"sub-settings left clickable mrgnLeft20\" ng-class=\"{ \'settings-active\': vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType].bold}\" ng-click=\"vm.editSettings(vm.personalContentDefaults.selectedType, { bold : !vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType].bold })\">\n                <span class=\"sub-settings-icon left selector\">B</span>\n              </div>\n\n              <div class=\"sub-settings left clickable\" ng-class=\"{ \'settings-active\': vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType].italic}\" ng-click=\"vm.editSettings(vm.personalContentDefaults.selectedType, { italic : !vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType].italic })\">\n                <span class=\"sub-settings-icon left selector\">I</span>\n              </div>\n\n              <div class=\"sub-settings left clickable\" ng-class=\"{ \'settings-active\': vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType].underline}\" ng-click=\"vm.editSettings(vm.personalContentDefaults.selectedType, { underline : !vm.productionPreferences.contentDefaults[vm.personalContentDefaults.selectedType].underline })\">\n                <span class=\"sub-settings-icon left selector\">U</span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsProductionDetails.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" translate>titles.Production Details</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"saveupdate\" class=\"btn sw-btn-default\" ng-click=\"vm.saveUpdate()\" type=\"button\" ng-hide=\"!vm.activeAccessRules.allowsavechanges\" translate>buttons.Save</button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n<div class=\"panel panel-default settingsDetailPanel\">\n  <div class=\"panel-body\">\n    <form class=\"form-horizontal\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 col-md-4 col-lg-4 control-label\" id=\"labelProdName\" translate>labels.Production Name</label>\n        <div class=\"col-sm-8 col-md-8 col-lg-6 form-inline\">\n          <input class=\"form-control\" style=\"width: 80%\" id=\"inputProductionName\" ng-model=\"vm.production.name\" placeholder=\"\" type=\"text\" ng-disabled=\"!vm.activeAccessRules.alloweditproductionname\">\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditproductionname\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 col-md-4 col-lg-4 control-label\" id=\"labelBookName\" translate>labels.Book</label>\n        <div class=\"col-sm-8 col-md-8 col-lg-6 form-inline\">\n          <input class=\"form-control\" style=\"width: 80%\" id=\"inputBookName\" ng-model=\"vm.production.details.bookname\" placeholder=\"\" type=\"text\" ng-disabled=\"!vm.activeAccessRules.alloweditbookname\">\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditbookname\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 col-md-4 col-lg-4 control-label\" id=\"labelMusicName\" translate>labels.Music</label>\n        <div class=\"col-sm-8 col-md-8 col-lg-6 form-inline\">\n          <input class=\"form-control\" style=\"width: 80%\" id=\"inutMusicName\" ng-model=\"vm.production.details.musicianname\" placeholder=\"\" type=\"text\" ng-disabled=\"!vm.activeAccessRules.alloweditmusicianname\">\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditmusicianname\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 col-md-4 col-lg-4 control-label\" id=\"labelLyricsName\" translate>labels.Lyrics</label>\n        <div class=\"col-sm-8 col-md-8 col-lg-6 form-inline\">\n          <input class=\"form-control\" style=\"width: 80%\" id=\"inputLyricsName\" ng-model=\"vm.production.details.lyricistname\" placeholder=\"\" type=\"text\" ng-disabled=\"!vm.activeAccessRules.alloweditlyricistname\">\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditlyricistname\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 col-md-4 col-lg-4 control-label\" id=\"labelDirectorName\" translate>labels.Director</label>\n        <div class=\"col-sm-8 col-md-8 col-lg-6 form-inline\">\n          <input class=\"form-control\" style=\"width: 80%\" id=\"inputDirectorName\" ng-model=\"vm.production.details.directorname\" placeholder=\"\" type=\"text\" ng-disabled=\"!vm.activeAccessRules.alloweditdirectorname\">\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditdirectorname\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 col-md-4 col-lg-4 control-label\" id=\"labelChoreographerName\" translate>labels.Choreographer</label>\n        <div class=\"col-sm-8 col-md-8 col-lg-6 form-inline\">\n          <input class=\"form-control\" style=\"width: 80%\" id=\"inputChoreographerName\" ng-model=\"vm.production.details.choreographername\" placeholder=\"\" type=\"text\" ng-disabled=\"!vm.activeAccessRules.alloweditchoreographername\">\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditchoreographername\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 col-md-4 col-lg-4 control-label\" id=\"logoImage\" translate>labels.Logo</label>\n        <div class=\"col-sm-8 form-inline\">\n          <div class=\"productionImageContainer-settings\">\n            <span spinner-key=\"spinner-img\" us-spinner></span>\n            <img ng-src=\"data:image/png;base64,{{vm.production.logo|| \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=\'}}\">\n          </div>\n          <div style=\"margin-left: 8px; vertical-align: middle; display: inline-block\">\n            <input accept=\"image/*\" id=\"inputImageUpload\" swa-file-dataurl=\"vm.processFile($dataUrl, $error)\" ng-hide=\"true\" type=\"file\">\n            <button id=\"select-image\" class=\"btn btn-sm btn-block sw-btn-secondary\" onclick=\"jQuery(\'input#inputImageUpload\').click()\" type=\"button\" ng-disabled=\"!vm.activeAccessRules.alloweditlogo\" translate>buttons.Select Image</button>\n            <button id=\"clear-logo\" class=\"btn btn-sm btn-block sw-btn-secondary\" ng-click=\"vm.clearLogo()\" type=\"button\" ng-disabled=\"!vm.activeAccessRules.alloweditlogo\" translate>buttons.Clear</button>\n          </div>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditlogo\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 col-md-4 col-lg-4 control-label\" id=\"labelTheaterName\" translate>labels.Theater Name</label>\n        <div class=\"col-sm-8 col-md-8 col-lg-6 form-inline\">\n          <input class=\"form-control\" style=\"width: 80%\" id=\"inputTheaterName\" ng-model=\"vm.production.details.theatername\" placeholder=\"\" type=\"text\" ng-disabled=\"!vm.activeAccessRules.allowedittheatername\">\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.allowedittheatername\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-sm-4 col-md-4 col-lg-4 control-label\" translate>labels.Production Date</label>\n        <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n          <div class=\"form-inline\">\n            <input class=\"form-control clickthrough\" close-text=\"Close\" uib-datepicker-popup=\"{{vm.datePickerConfig.format}}\" datepicker-options=\"vm.datePickerConfig.options\" datepicker-append-to-body=\"true\" show-button-bar=\"false\" id=\"inputProdDate\" is-open=\"vm.datePickerConfig.open\" ng-bind=\"vm.production.details.productiondate.$date | date:\'MM / dd / yyyy\'\" ng-model=\"vm.production.details.productiondate.$date\" placeholder=\"Not Set!\" style=\"min-width: 300px\" type=\"text\">\n            <button id=\"select-production-date\" class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.openDatePicker($event)\" type=\"button\" ng-disabled=\"!vm.activeAccessRules.alloweditproductiondate\" translate>buttons.Select</button>\n            <button id=\"clear-production-date\" class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.clearProductionDate()\" type=\"button\" ng-disabled=\"!vm.activeAccessRules.alloweditproductiondate\" translate>buttons.Clear</button>\n            <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditproductiondate\"></span>\n          </div>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsScenesList.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" translate>titles.Scenes</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"add-scene\" class=\"btn sw-btn-default\" ng-click=\"vm.onAdd()\" ng-disabled=\"(vm.continuousAddMode || vm.inlineEditMode || vm.listEditMode || !(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowaddscenes)) || (vm.scenes.length >= vm.activePlanRules.allowedNumberOfScenes)\" translate>buttons.Add</button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"editdone-scene\" class=\"btn sw-btn-default\" ng-click=\"vm.onEditToggle()\" ng-disabled=\"(vm.continuousAddMode || vm.inlineEditMode || (vm.scenes.length === 0) || !(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowdeletescenes || vm.activeAccessRules.allowreorderscenes))\">\n        <span ng-hide=\"vm.listEditMode\">{{\'buttons.Delete\'| translate}}\n          /\n          <span class=\"sw-ionicon sw-ionicon-fw ion-drag\"></span>\n        </span>\n        <span ng-show=\"vm.listEditMode\" translate>buttons.Done</span>\n      </button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <div class=\"settingsDetailPanel\" ng-cloak>\n    <div class=\"settings-list-container\" ng-style=\"{\'margin-right\': (vm.listEditMode?\'40px\': \'0\')}\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.scenes\" ng-class=\"{\'inline-edit\': vm.inlineEditMode}\">\n      <div id=\"scene-name-{{$index}}\" class=\"settings-scene-row\" data-ng-repeat=\"aScene in vm.scenes | limitTo:vm.activePlanRules.allowedNumberOfScenes\" ng-dblclick=\"vm.onDoubleClick($index)\">\n        <div class=\"title-block pull-left\">\n          <span class=\"title\" ng-hide=\"vm.inlineEditIndex === $index\">{{aScene.scenename}}</span>\n          <input class=\"form-control\" id=\"editscenename_{{$index}}\" ng-enter=\"vm.onUpdateSceneName(aScene,this)\" ng-model=\"aScene.newSceneName\" ng-show=\"vm.inlineEditIndex === $index\" type=\"text\">\n        </div>\n        <div class=\"pull-right\" ng-show=\"vm.inlineEditIndex === $index\">\n          <button class=\"btn sw-btn-xsm sw-btn-danger\" ng-click=\"vm.onUpdateSceneName(aScene,this)\" translate type=\"button\">buttons.Save</button>\n          <button class=\"btn sw-btn-xsm sw-btn-danger\" ng-click=\"vm.endAnyAddEdit()\" translate type=\"button\">buttons.Cancel</button>\n        </div>\n        <div class=\"pull-right\" ng-show=\"vm.listEditMode\">\n          <button class=\"btn sw-btn-xsm sw-btn-danger\" ng-click=\"vm.deleteSceneAtIndex($index)\" ng-show=\"vm.listEditMode\" translate type=\"button\" ng-disabled=\"!(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowdeletescenes)\">buttons.Delete</button>\n          <span style=\"cursor: ns-resize; width: 40px\" class=\"sw-ionicon-fw sw-ionicon-lg ion-drag sortDragHandle\" ng-show=\"vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowreorderscenes\"></span>\n        </div>\n      </div>\n      <div class=\"settings-scene-row\" ng-dblclick=\"vm.onAdd()\" ng-hide=\"vm.listEditMode || !(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowaddscenes) || (vm.scenes.length >= vm.activePlanRules.allowedNumberOfScenes)\">\n        <div class=\"title-block pull-left\">\n          <span class=\"sw-color-gray\" ng-hide=\"vm.continuousAddMode\" translate>labels.Double-click here to start adding scenes</span>\n          <input class=\"form-control\" id=\"newscenename\" ng-show=\"vm.continuousAddMode\" ng-enter=\"vm.onNewSceneNameEntered()\" ng-model=\"vm.newSceneName\" placeholder=\"{{\'messages.add_scene_input_placeholder\'|translate}}\" type=\"text\">\n        </div>\n        <div class=\"pull-right\">\n          <button class=\"btn sw-btn-xsm sw-btn-danger\" ng-click=\"vm.onNewSceneNameEntered()\" ng-show=\"vm.continuousAddMode\" translate type=\"button\">buttons.Save</button>\n          <button class=\"btn sw-btn-xsm sw-btn-danger\" ng-click=\"vm.endAnyAddEdit()\" ng-show=\"vm.continuousAddMode\" translate type=\"button\">buttons.Cancel</button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsSetPiecesList.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" translate>titles.Set Pieces</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"import-set-piece\" class=\"btn sw-btn-default\" ng-click=\"vm.onImport()\" ng-disabled=\"vm.listEditMode || !vm.activeAccessRules.allowimportsetpieces || (vm.setPieces.length >= vm.activePlanRules.allowedNumberOfSetPieces)\" translate>buttons.Import</button>\n      <button id=\"create-set-piece\" class=\"btn sw-btn-default\" ng-click=\"vm.onCreate()\" ng-disabled=\"vm.listEditMode || !vm.activeAccessRules.allowcreatesetpieces || (vm.setPieces.length >= vm.activePlanRules.allowedNumberOfSetPieces)\" translate>buttons.Create</button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"editdone-set-piece\" class=\"btn sw-btn-default\" ng-click=\"vm.onEditToggle()\" ng-disabled=\"(vm.setPieces.length === 0) || !(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowreordersetpieces || vm.activeAccessRules.allowdeletesetpieces)\">\n        <span ng-hide=\"vm.listEditMode\">{{\'buttons.Delete\' | translate}}\n          /\n          <span class=\"sw-ionicon sw-ionicon-fw ion-drag\"></span>\n        </span>\n        <span ng-show=\"vm.listEditMode\" translate>buttons.Done</span>\n      </button>\n    </div>\n    <div class=\"search search-bar-chart\">\n        <input class=\"form-control\" id=\"searchpersetpiece\" name=\"searchpersetpiece\" ng-model=\"vm.searchpersetpiece\" ng-change=\"vm.searchStringChangedForSetpice()\" type=\"text\" placeholder=\"Search ...\">\n        <button class=\"btn btn-lg sw-btn-toolbar search-text-clear-btn search-text-clear-btn3-settings\" ng-click=\"vm.clearSearchForSetpice()\" ng-show=\"vm.searchpersetpiece.length > 0\">\n            <span class=\"sw-ionicon-lg ion-ios-close-outline\"></span>\n        </button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <div class=\"settingsDetailPanel\" ng-cloak>\n    <div class=\"settings-list-container margin-for-search-bar\" ng-style=\"{\'margin-right\': (vm.listEditMode?\'40px\': \'0\')}\" ng-hide=\"vm.setPieces.length === 0\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.setPieces\">\n      <div id=\"set-piece-{{$index}}\" class=\"settings-setpiece-row\" ng-repeat=\"aSetPiece in vm.setPieces | limitTo: vm.activePlanRules.allowedNumberOfSetPieces | filter: vm.setpieceSearchFilter | orderBy: \'oIndex\' as results\" ng-click=\"vm.onSetPieceClick(aSetPiece)\">\n        <div class=\"pull-left\">\n          <span class=\"title\">{{aSetPiece.name}}</span>\n          <span class=\"subtitle\" ng-if=\"aSetPiece.measurementunit === 1\">{{aSetPiece.width| number}}\n            x\n            {{aSetPiece.height| number}}\n            m\n          </span>\n          <span class=\"subtitle\" ng-if=\"aSetPiece.measurementunit === 0\">\n            {{aSetPiece.width| feetAndInches}}\n            x\n            {{aSetPiece.height| feetAndInches}}\n          </span>\n        </div>\n        <div class=\"pull-right\" ng-show=\"vm.listEditMode\">\n          <button id=\"delete-set-piece-{{$index}}\" class=\"btn sw-btn-xsm sw-btn-danger\" ng-click=\"vm.deleteSetPieceAtIndex($index);\n            $event.stopPropagation()\" translate type=\"button\" ng-disabled=\"!(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowdeletesetpieces)\">buttons.Delete</button>\n          <span id=\"reorder-set-piece-{{$index}}\" style=\"cursor: ns-resize; width: 40px\" class=\"sw-ionicon-fw sw-ionicon-lg ion-drag sortDragHandle\" ng-show=\"vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowreordersetpieces\"></span>\n        </div>\n      </div>\n      <div id=\"no-productions\" class=\"no-matching-info-text\" ng-hide=\"results.length !== 0\">\n        <span>No matching Set Pieces!</span>\n      </div>\n    </div>\n    <div class=\"text-center\" style=\"margin-top: 40px\" ng-show=\"vm.setPieces.length === 0\">\n      <div class=\"hint-icon-message hint-icon-message-autow\">\n        <div class=\"icon\">\n          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n        </div>\n        <div class=\"text\">\n          <span translate>messages.No Set Pieces in this Production</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsStaffTemplateDetails.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" ng-show=\"vm.addTemplateMode\" translate>titles.New Score Template</span>\n    <span class=\"text-lg sw-color-lightgray\" ng-hide=\"vm.addTemplateMode\">{{\'titles.Score Template\' | translate}} - [{{vm.template.templatename}}]</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"cancel\" class=\"btn sw-btn-default\" ng-click=\"vm.onCancel()\" translate>buttons.Cancel</button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"saveupdate\" class=\"btn sw-btn-default\" ng-click=\"vm.saveUpdate()\" translate>buttons.Save</button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <div class=\"panel hint-icon-message\" ng-hide=\"vm.canEditTemplate\">\n    <div class=\"icon\">\n      <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n    </div>\n    <div class=\"text\">\n      <em>{{\'messages.This template has been used, some values will not be editable.\'|translate}}</em>\n    </div>\n  </div>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>\n            labels.Template Name\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n            <input id=\"templateName\" class=\"form-control pull-left\" ng-model=\"vm.template.templatename\" type=\"text\">\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label label-with-detail\">\n            {{\'labels.Display Name\' | translate}}\n            <br>\n            <small class=\"sw-color-mediumlightgray\">\n              <em translate>messages.Leave blank to use the template name</em>\n            </small>\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n            <input class=\"form-control pull-left\" placeholder=\"{{vm.template.templatename}}\" ng-model=\"vm.template.displayname\" type=\"text\">\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label label-with-detail\">\n            {{\'labels.Prefix Count to Display Name\' | translate}}\n            <br>\n            <small class=\"sw-color-mediumlightgray\">\n              <em translate>messages.Will show names as \'8 Count - 1\'</em>\n            </small>\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n            <switch class=\"swa-switch\" id=\"displaycountprefix\" ng-model=\"vm.template.displaycountprefix\" on=\"YES\" off=\"NO\"></switch>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Counts and Columns</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>\n            labels.Default Counts\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" style=\"max-width: 200px\">\n            <div swa-counter swa-counter-value=\"vm.template.defaultcount\" swa-counter-min=\"1\" swa-counter-max=\"12\" swa-counter-step=\"1\" swa-counter-disabled=\"vm.dialogueMode\"></div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>\n            labels.Allow to Add/Delete Counts\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n            <switch class=\"swa-switch\" id=\"allowadddeletecount\" ng-model=\"vm.template.allowadddeletecount\" on=\"YES\" off=\"NO\" ng-disabled=\"vm.dialogueMode\" data-disabled=\"vm.dialogueMode\"></switch>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>\n            labels.Columns per Count\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" style=\"max-width: 200px\">\n            <div swa-stepper swa-stepper-value=\"vm.template.columnspercount\" swa-stepper-values=\"vm.columnsPerCountsSteps\" swa-stepper-disabled=\"!vm.canEditTemplate\" swa-stepper-onchange=\"vm.onChangeColumnsPerCount(value)\"></div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\" translate>\n            labels.Has Count Column Headers\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n            <switch class=\"swa-switch\" id=\"countColumnHeaderRow\" ng-model=\"vm.template.hascolumnheaderrow\" on=\"YES\" off=\"NO\" ng-change=\"vm.onHasColumnHeaderRowChange()\" ng-disabled=\"vm.dialogueMode\" data-disabled=\"vm.dialogueMode\"></switch>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-show=\"vm.template.hascolumnheaderrow\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label label-with-detail\">\n            {{\'labels.Count Index Column\' | translate}}\n            <br>\n            <small class=\"sw-color-mediumlightgray\">\n              <em translate>messages.Replaces the selected column header with the count number</em>\n            </small>\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" style=\"max-width: 200px\">\n            <div swa-counter swa-counter-value=\"vm.template.countindexcolumn\" swa-counter-min=\"0\" swa-counter-max=\"vm.template.columnspercount\" swa-counter-step=\"1\"></div>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-show=\"vm.template.hascolumnheaderrow\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\">\n            <span translate>labels.Count Column Header Labels</span>\n          </label>\n          <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8\">\n            <div class=\"sw-stafftemplate-column-headers-container\">\n              <div class=\"input-group sw-stafftemplate-column-header-item\" ng-repeat=\"columnLabel in vm.template.columnlabels track by $index\">\n                <span class=\"input-group-addon\">{{$index + 1}}</span>\n                <input class=\"form-control text-center\" input-maxlength=\"2\" ng-model=\"vm.template.columnlabels[$index]\" type=\"text\" ng-if=\"!(($index + 1) === vm.template.countindexcolumn)\">\n                <input class=\"form-control text-center\" value=\"(n)\" type=\"text\" ng-if=\"(($index + 1) === vm.template.countindexcolumn)\" disabled=\"disabled\">\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <h4 class=\"text-center sw-color-gray\" translate>labels.Rows</h4>\n  <div class=\"panel panel-default settingsDetailPanel\">\n    <div class=\"panel-body\">\n      <div class=\"form-horizontal\">\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\">\n            {{\'labels.Voice Rows\' | translate}}\n            <br>\n            <small class=\"sw-color-mediumlightgray\">\n              <em translate>messages.Voice rows are in pairs</em>\n            </small>\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" style=\"max-width: 200px\">\n            <div swa-counter swa-counter-value=\"vm.template.voicerowcount\" swa-counter-min=\"1\" swa-counter-max=\"10\" swa-counter-step=\"1\" swa-counter-disabled=\"!vm.canEditTemplate\"></div>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label label-with-detail\">\n            {{\'labels.Number of Detail Rows\' | translate}}\n            <br>\n            <small class=\"sw-color-mediumlightgray\">\n              <em translate>messages.Detail rows are in addition to a default performer row</em>\n            </small>\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\" style=\"max-width: 200px\">\n            <div swa-counter swa-counter-value=\"vm.template.detailrowcount\" swa-counter-min=\"0\" swa-counter-max=\"10\" swa-counter-step=\"1\" swa-counter-disabled=\"!vm.canEditTemplate\" swa-counter-onchange=\"vm.onChangeDetailRowCount(value)\"></div>\n          </div>\n        </div>\n        <div class=\"form-group\" ng-show=\"vm.template.detailrowlabels.length > 0\">\n          <label class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 control-label\">\n            <span translate>labels.Detail Row Labels</span>\n          </label>\n          <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4\">\n            <div class=\"input-group sw-stafftemplate-row-header-item\" ng-repeat=\"detailRowLabel in vm.template.detailrowlabels track by $index\">\n              <span class=\"input-group-addon\">{{$index + 1}}</span>\n              <input class=\"form-control\" ng-model=\"vm.template.detailrowlabels[$index]\" type=\"text\">\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsStaffTemplatesList.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" translate>titles.Score Templates</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-left\">\n      <button id=\"add-staff\" class=\"btn sw-btn-default\" ng-click=\"vm.onAddTemplate()\" ng-disabled=\"vm.listEditMode || !(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowaddtemplates)\" translate>buttons.Add</button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"editdone-staff\" class=\"btn sw-btn-default\" ng-click=\"vm.onEditToggle()\" ng-disabled=\"(vm.staffTemplates.length === 0) || !(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowdeletetemplates || vm.activeAccessRules.allowreordertemplates)\">\n        <span ng-hide=\"vm.listEditMode\">{{\'buttons.Delete\' | translate}}\n          /\n          <span class=\"sw-ionicon sw-ionicon-fw ion-drag\"></span>\n        </span>\n        <span ng-show=\"vm.listEditMode\" translate>buttons.Done</span>\n      </button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <div class=\"settingsDetailPanel\" ng-cloak>\n    <div class=\"settings-list-container\" ng-style=\"{\'margin-right\': (vm.listEditMode?\'40px\': \'0\')}\" ui-sortable=\"vm.sortableOptions\" ng-model=\"vm.staffTemplates\">\n      <div id=\"staff-template-{{$index}}\" class=\"settings-scene-row\" data-ng-repeat=\"aStaffTemplate in vm.staffTemplates\" ng-click=\"vm.selectStaffTemplateAtIndex($index)\">\n        <div class=\"title-block pull-left\">\n          <span class=\"title\">{{aStaffTemplate.templatename}}</span>\n        </div>\n        <div class=\"pull-right\" ng-show=\"vm.listEditMode\">\n          <button class=\"btn sw-btn-xsm sw-btn-danger\" ng-click=\"vm.deleteStaffTemplateAtIndex($index);\n            $event.stopPropagation()\" translate ng-disabled=\"!(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowdeletetemplates)\">buttons.Delete</button>\n          <span style=\"cursor: ns-resize; width: 40px\" class=\"sw-ionicon-fw sw-ionicon-lg ion-drag sortDragHandle\" ng-show=\"vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowreordertemplates\"></span>\n        </div>\n      </div>\n    </div>\n    <div class=\"text-center sw-color-lightgray\" ng-show=\"vm.staffTemplates.length === 0\">\n      <span translate>messages.No Score Templates in this Production</span>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/settingsStageDimensions.html","<div class=\"navbar navbar-fixed-top sw-navbar\">\n  <div class=\"navbar-center-title\">\n    <span class=\"text-lg sw-color-lightgray\" translate>titles.Stage Dimensions</span>\n  </div>\n  <div class=\"swtoolbar\">\n    <div class=\"swtoolbar-group pull-right\">\n      <button id=\"saveupdate\" class=\"btn sw-btn-default\" ng-click=\"vm.saveUpdate()\" ng-show=\"vm.canEditDimensions && vm.activeAccessRules.alloweditdimensions\" translate>buttons.Save</button>\n    </div>\n  </div>\n</div>\n<div class=\"sw-settingsdetail-scrollcontainer\" ng-scrollbars>\n  <div class=\"panel panel-default settingsDetailPanel\">\n  <div class=\"panel-body\">\n    <div class=\"form-horizontal\">\n      <div class=\"form-group\">\n        <label class=\"col-lg-4 col-md-4 col-sm-6 control-label\">\n          {{\'labels.Unit of Measurement\'|translate}}\n        </label>\n        <div class=\"col-lg-3 col-md-4 col-sm-6\">\n          <label class=\"control-label\" ng-show=\"!vm.canEditDimensions\">{{vm.measurementunitname}}</label>\n          <div class=\"btn-group btn-group-btn\" ng-show=\"vm.canEditDimensions\">\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.production.stagesettings.stagemeasurementunit === 0}\" ng-click=\"vm.production.stagesettings.stagemeasurementunit = 0\" type=\"button\" ng-disabled=\"!vm.activeAccessRules.alloweditdimensions\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.production.stagesettings.stagemeasurementunit === 0, \'ion-android-radio-button-off\':vm.production.stagesettings.stagemeasurementunit === 1}\"></span>\n              {{\'buttons.Feet\'| translate}}\n            </button>\n            <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.production.stagesettings.stagemeasurementunit === 1}\" ng-click=\"vm.production.stagesettings.stagemeasurementunit = 1\" type=\"button\" ng-disabled=\"!vm.activeAccessRules.alloweditdimensions\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.production.stagesettings.stagemeasurementunit === 1, \'ion-android-radio-button-off\':vm.production.stagesettings.stagemeasurementunit === 0}\"></span>\n              {{\'buttons.Meters\'| translate}}\n            </button>\n          </div>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"vm.canEditDimensions && !vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditdimensions\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-lg-4 col-md-4 col-sm-6 control-label\">\n          {{\'labels.Width of Stage\'|translate}}\n        </label>\n        <div class=\"col-lg-3 col-md-4 col-sm-6 form-inline\">\n          <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 1\" ng-disabled=\"!vm.canEditDimensions || !vm.activeAccessRules.alloweditdimensions\" ng-model=\"vm.production.stagesettings.stagewidth\" type=\"number\" min=\"0\" swa-select-on-focus>\n          <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" ng-disabled=\"!vm.canEditDimensions || !vm.activeAccessRules.alloweditdimensions\" ng-model=\"vm.setStageWidth.feet\" ng-blur=\"vm.getStageWidthInFeet()\" type=\"number\" min=\"0\" swa-select-on-focus>\n          <label class=\"control-label\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" translate>labels.Feet-abbreviation</label>\n          <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" ng-disabled=\"!vm.canEditDimensions || !vm.activeAccessRules.alloweditdimensions\" ng-model=\"vm.setStageWidth.inch\" ng-blur=\"vm.getStageWidthInFeet()\" type=\"number\" min=\"0\" swa-select-on-focus>\n          <label class=\"control-label\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" translate>labels.Inch-abbreviation</label>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditdimensions\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-lg-4 col-md-4 col-sm-6 control-label\">\n          {{\'labels.Depth of Stage\'|translate}}\n        </label>\n        <div class=\"col-lg-3 col-md-4 col-sm-6 form-inline\">\n          <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 1\" ng-disabled=\"!vm.canEditDimensions || !vm.activeAccessRules.alloweditdimensions\" ng-model=\"vm.production.stagesettings.stagedepth\" type=\"number\" min=\"0\" swa-select-on-focus>\n          <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" ng-disabled=\"!vm.canEditDimensions || !vm.activeAccessRules.alloweditdimensions\" ng-model=\"vm.setStageDepth.feet\" ng-blur=\"vm.getStageDepthInFeet()\" type=\"number\" min=\"0\" swa-select-on-focus>\n          <label class=\"control-label\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" translate>labels.Feet-abbreviation</label>\n          <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" ng-disabled=\"!vm.canEditDimensions || !vm.activeAccessRules.alloweditdimensions\" ng-model=\"vm.setStageDepth.inch\" ng-blur=\"vm.getStageDepthInFeet()\" type=\"number\" min=\"0\" swa-select-on-focus>\n          <label class=\"control-label\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" translate>labels.Inch-abbreviation</label>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditdimensions\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-lg-4 col-md-4 col-sm-6 control-label\">\n          {{\'labels.Off-stage Width\'|translate}}\n        </label>\n        <div class=\"col-lg-3 col-md-4 col-sm-6 form-inline\">\n          <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 1\" ng-disabled=\"!vm.canEditDimensions || !vm.activeAccessRules.alloweditdimensions\" ng-model=\"vm.production.stagesettings.offstagewidth\" type=\"number\" min=\"0\" swa-select-on-focus>\n          <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" ng-disabled=\"!vm.canEditDimensions || !vm.activeAccessRules.alloweditdimensions\" ng-model=\"vm.setOffStageWidth.feet\" ng-blur=\"vm.getOffStageWidthInFeet()\" type=\"number\" min=\"0\" swa-select-on-focus>\n          <label class=\"control-label\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" translate>labels.Feet-abbreviation</label>\n          <input class=\"form-control dimension-field-width text-right\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" ng-disabled=\"!vm.canEditDimensions || !vm.activeAccessRules.alloweditdimensions\" ng-model=\"vm.setOffStageWidth.inch\" ng-blur=\"vm.getOffStageWidthInFeet()\" type=\"number\" min=\"0\" swa-select-on-focus>\n          <label class=\"control-label\" ng-if=\"vm.production.stagesettings.stagemeasurementunit === 0\" translate>labels.Inch-abbreviation</label>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditdimensions\"></span>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-lg-4 col-md-4 col-sm-6 control-label\">\n          {{\'labels.Permanent Stage\'|translate}}\n        </label>\n        <div class=\"col-lg-3 col-md-4 col-sm-6\" ng-show=\"vm.canEditPermanentStage()\">\n          <button id=\"edit-permanent-stage\" class=\"btn sw-btn-secondary\" ng-click=\"vm.editPermanentStage()\" ng-disabled=\"!vm.activeAccessRules.alloweditpermanentstage\">\n            <span translate>buttons.Edit</span>\n          </button>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditpermanentstage\"></span>\n        </div>\n        <div class=\"col-lg-3 col-md-4 col-sm-6\" ng-hide=\"vm.canEditPermanentStage()\">\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-alert-circled swa-color-gray\"></span>\n          <span class=\"swa-color-gray\" translate>messages.Stage dimensions are not set</span>\n        </div>\n      </div>\n      <div class=\"form-group btm_boder_none mrgn-padd-btm0\">\n        <label class=\"col-lg-4 col-md-4 col-sm-6 control-label\">\n          {{\'labels.Markers and Numbering\'|translate}}\n        </label>\n        <div class=\"col-lg-3 col-md-4 col-sm-6\" ng-show=\"vm.canEditCustomNumberline()\">\n          <button id=\"custom-numberline\" class=\"btn sw-btn-secondary\" ng-click=\"vm.editCustomNumberline()\" ng-disabled=\"!vm.activeAccessRules.alloweditcustomnumberline\">\n            <span translate>buttons.Edit</span>\n          </button>\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-locked swa-color-gray\" ng-show=\"!vm.activeAccessRules.allowowneraccess && !vm.activeAccessRules.alloweditcustomnumberline\"></span>\n        </div>\n        <div class=\"col-lg-3 col-md-4 col-sm-6\" ng-hide=\"vm.canEditCustomNumberline()\">\n          <span class=\"sw-ionicon sw-ionicon-lg sw-ioniconfw ion-alert-circled swa-color-gray\"></span>\n          <span class=\"swa-color-gray\" translate>messages.Stage dimensions are not set</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"hint-icon-message\">\n  <div class=\"icon\">\n    <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n  </div>\n  <div class=\"text\">\n    <em>{{\'messages.stagedimensions_edit_warning\'|translate}}</em>\n  </div>\n</div>\n<div class=\"hint-icon-message\" style=\"margin-top: 20px\">\n  <div class=\"icon\">\n    <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n  </div>\n  <div class=\"text\">\n    <em>{{\'messages.stagedimensions_adjust_warning\'|translate}}</em>\n  </div>\n</div>\n</div>\n");
$templateCache.put("app/components/profile/cancelSubscriptionPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title\">{{\'titles.Cancel Subscription\' | translate}}\n    <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <p>\n    <span translate>messages.cancelsubscriptionplanpromptline1</span>\n  </p>\n  <p>\n    <span translate>messages.cancelsubscriptionplanpromptline2</span>\n  </p>\n  <p>\n    <strong translate>messages.Confirm?</strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.onConfirm()\" type=\"button\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.onCancel()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/profile/changeEmailPrompt.html","<form class=\"form-horizontal sw-form\" name=\"changeEmailForm\" novalidate=\"\" role=\"form\" ng-click=\"vm.save(changeEmailForm)\">\n    <div class=\"modal-header\">\n      <span class=\"modal-title text-danger text-center\" translate>titles.Change Email</span>\n    </div>\n    <div class=\"modal-body\">\n      <div class=\"form-group\">\n        <label class=\"col-sm-12 swa-color-lightgray\" for=\"newEmail\" translate>labels.New Email</label>\n        <div class=\"col-sm-12\">\n          <input class=\"form-control\" id=\"newEmail\" name=\"newEmail\" ng-model=\"vm.formParams.newEmail\" required=\"\" type=\"email\" swa-validate-email>\n          <div class=\"error-label\" ng-show=\"changeEmailForm.$submitted\">\n            <p class=\"sw-color-red\" ng-show=\"changeEmailForm.newEmail.$error.required\" translate>messages.New Email is required</p>\n            <p class=\"sw-color-red\" ng-show=\"(changeEmailForm.newEmail.$error.email)\" translate>messages.Please enter a valid email address</p>\n          </div>\n          <div ng-show=\"changeEmailForm.$submitted || changeEmailForm.newEmail.$untouched\">\n            <p class=\"sw-color-red\" ng-show=\"vm.serverError.emailAlreadyUsed\" translate>messages.This email address is already been used by another user, please provide a different one</p>\n          </div>\n        </div>\n      </div>\n      <div class=\"col-sm-12 text-center\" ng-show=\"changeEmailForm.$pristine && vm.serverError.message\">\n        <p class=\"sw-color-red\">{{vm.serverError.message}}</p>\n      </div>\n      <div class=\"hint-icon-message\">\n        <div class=\"icon\">\n          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n        </div>\n        <div class=\"text\">\n          <em translate>messages.email_change_hint_message</em>\n        </div>\n      </div>  \n    </div>\n    <div class=\"modal-footer\">\n      <button class=\"btn sw-btn-danger sw-btn-min-w-80\" type=\"submit\" translate>buttons.Save</button>\n      <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.cancel()\" translate>buttons.Cancel</button>\n    </div>\n  </form>\n  ");
$templateCache.put("app/components/profile/changePasswordPrompt.html","<form class=\"form-horizontal sw-form\" name=\"form\" novalidate=\"\" role=\"form\" ng-init=\"_formCancelling = false\">\n  <div class=\"modal-header\">\n    <span class=\"modal-title text-danger text-center\" translate>titles.Change Password</span>\n  </div>\n  <div class=\"modal-body\">\n    <div class=\"form-group\">\n      <label class=\"col-sm-4 control-label\" for=\"currentPassword\" translate>labels.Current password</label>\n      <div class=\"col-sm-8\">\n        <input class=\"form-control\" id=\"currentPassword\" name=\"currentPassword\" ng-model=\"vm.formParams.currentPassword\" required=\"\" type=\"password\">\n        <div class=\"error-label\" ng-show=\"!_formCancelling && (form.$submitted || form.currentPassword.$touched)\">\n          <p class=\"sw-color-red\" ng-show=\"form.currentPassword.$error.required\" translate>messages.Current password is required</p>\n        </div>\n        <div class=\"error-label\" ng-show=\"form.$pristine && vm.errorIncorrectPassword\">\n          <p class=\"sw-color-red\">{{vm.errorMessage}}</p>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-4 control-label\" for=\"newPassword\" translate>labels.New password</label>\n      <div class=\"col-sm-8\">\n        <input class=\"form-control\" id=\"newPassword\" name=\"newPassword\" ng-model=\"vm.formParams.newPassword\" required=\"\" type=\"password\">\n        <div class=\"error-label\" ng-show=\"!_formCancelling && (form.$submitted || form.newPassword.$touched)\">\n          <p class=\"sw-color-red\" ng-show=\"form.newPassword.$error.required\" translate>messages.New password is required</p>\n        </div>\n      </div>\n    </div>\n    <div class=\"form-group\">\n      <label class=\"col-sm-4 control-label\" for=\"confirmPassword\" translate>labels.Confirm password</label>\n      <div class=\"col-sm-8\">\n        <input class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" ng-model=\"vm.formParams.confirmPassword\" required type=\"password\" match-password=\"newPassword\" ng-paste=\"$event.preventDefault()\">\n        <div class=\"error-label\" ng-show=\"!_formCancelling && (form.$submitted || form.confirmPassword.$touched)\">\n          <p class=\"sw-color-red\" ng-show=\"form.confirmPassword.$error.required\" translate>messages.Please confirm your password</p>\n          <p class=\"sw-color-red\" ng-show=\"form.confirmPassword.$error.passwordMatch\" translate>messages.Your passwords do not match</p>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-sm-12 text-center\" ng-show=\"form.$pristine && vm.serverError\">\n      <p class=\"sw-color-red\">{{vm.errorMessage}}</p>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" type=\"button\" ng-click=\"form.$valid && vm.submitForm(form)\" translate>buttons.Save</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" type=\"button\" ng-mousedown=\"(_formCancelling = true); vm.cancel()\" translate>buttons.Cancel</button>\n  </div>\n</form>\n");
$templateCache.put("app/components/profile/myAccount.html","<swa-help-bar ng-if=\"vm.showHelpBar\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-videos=\"vm.helpTourVideos\"></swa-help-bar>\n<div class=\"mainOuter\" ng-cloak>\n  <div class=\"navbar navbar-fixed-top sw-navbar\">\n    <div class=\"navbar-center-title\">\n      <span class=\"text-lg sw-color-lightgray\" translate>titles.My Account</span>\n    </div>\n    <div class=\"swtoolbar\">\n      <div class=\"swtoolbar-group pull-left\">\n        <img class=\"sws-logo sws-logo-link\" src=\"assets/images/sws-logo-light.png\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\" uib-tooltip=\"{{\'labels.Back to Productions\' | translate}}\" tooltip-placement=\"bottom\" tooltip-class=\"swa-tooltip\">\n      </div>\n      <div class=\"swtoolbar-group swtoolbar-group pull-right\">\n        <button class=\"btn sw-btn-toolbar sw-btn-toolbar-user\" stackable-trigger=\"userMenu\">\n          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-person\"></span>\n          <span ng-bind=\"vm.username\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"userMenu\">\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\" id=\"my-account-productions\">\n                <span class=\"title\" translate>labels.Productions</span>\n              </div>\n              <div class=\"menu-item\" ui-sref=\"{{vm.swaRouterStateNames.subscriptions}}\" id=\"my-account--subscriptions\">\n                <span class=\"title\" translate>labels.Subscriptions</span>\n              </div>\n            </div>\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-click=\"vm.logout()\">\n                <span class=\"title\" translate id=\"production-list-logout\">labels.Logout</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n    </div>\n  </div>\n  <div>\n    <!-- Begin page content -->\n    <div class=\"sw-maincontentarea-profile sw-scrollcontainer\" ng-cloak ng-scrollbars ng-scrollbars-config=\"vm.scrollConfig\">\n      <div class=\"container-fluid\">\n        <div class=\"row\">\n          <div class=\"col-lg-12 text-right\">\n            <span class=\"sw-a-link sw-a-link-underline\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\" translate>labels.Back to Productions</span>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-lg-offset-1 col-lg-5 sw-panel-container\" style=\"margin-top: 40px\">\n            <div class=\"panel panel-default\">\n              <div class=\"panel-heading\">\n                <span class=\"text-lg\" translate>titles.Personal Information</span>\n              </div>\n              <div class=\"panel-body\">\n                <div class=\"form-horizontal sw-form-container\">\n                  <div class=\"form-group\">\n                    <label class=\"col-lg-3 control-label\" translate>labels.Name</label>\n                    <div class=\"col-lg-7 form-inline\">\n                      <input class=\"form-control\" style=\"width: 48%\" type=\"text\" ng-model=\"vm.userData.profile.firstName\" ng-change=\"vm.fullNameChanged = true\" placeholder=\"{{\'labels.First Name\' | translate}}\">\n                      <input class=\"form-control\" style=\"width: 48%\" type=\"text\" ng-model=\"vm.userData.profile.lastName\" ng-change=\"vm.fullNameChanged = true\" placeholder=\"{{\'labels.Last Name\' | translate}}\">\n                    </div>\n                    <div class=\"col-lg-2\">\n                      <button class=\"btn btn-sm sw-btn-secondary\" ng-show=\"vm.fullNameChanged\" ng-click=\"vm.updateFullName()\" translate>buttons.Update</button>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <label class=\"col-lg-3 control-label\" translate>labels.Email</label>\n                    <p class=\"col-lg-6 form-control-static sw-color-lightgray\">{{vm.userData.emails[0].address}}</p>\n                    <div class=\"col-lg-3\">\n                      <button class=\"btn btn-sm sw-btn-secondary\" id=\"my-account-change-email\" ng-click=\"vm.promptChangeEmail()\" translate>buttons.Change</button>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <label class=\"col-lg-3 control-label\">Password</label>\n                    <div class=\"col-lg-9\">\n                      <button class=\"btn btn-sm sw-btn-secondary\" id=\"my-account-change-password\" ng-click=\"vm.promptChangePassword()\" translate>buttons.Change</button>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"panel panel-default\">\n              <div class=\"panel-heading\">\n                <span class=\"text-lg\" translate>titles.Preferences</span>\n              </div>\n              <div class=\"panel-body\">\n                <div class=\"form-horizontal sw-form-container\">\n                  <div class=\"form-group\">\n                    <label class=\"col-lg-3 control-label\" translate>labels.Display Help</label>\n                    <div class=\"col-lg-9\">\n                      <switch class=\"swa-switch\" id=\"my-account-display-help\" ng-model=\"vm.userData.preferences.web.displayHelp\" ng-change=\"vm.updateDisplayHelp()\"></switch>\n                    </div>\n                  </div>\n                  <div class=\"form-group mrgn-padd-btm0\">\n                    <label class=\"col-lg-3 control-label\" translate>labels.Collaboration Point of View</label>\n                    <div class=\"col-lg-9\">\n                      <div id=\"point-of-view\" class=\"btn-group btn-group-btn1\">\n                        <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.userData.preferences.povOverride === false}\" ng-click=\"vm.updatePovOverride(false)\" type=\"button\">\n                          <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.userData.preferences.povOverride === false, \'ion-android-radio-button-off\':vm.userData.preferences.povOverride !== false}\"></span>\n                          {{\'buttons.Owner\'| translate}}\n                        </button>\n                        <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.userData.preferences.povOverride === \'audience\'}\" ng-click=\"vm.updatePovOverride(\'audience\')\" type=\"button\">\n                          <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.userData.preferences.povOverride === \'audience\', \'ion-android-radio-button-off\':vm.userData.preferences.povOverride !== \'audience\'}\"></span>\n                          {{\'buttons.Audience\'| translate}}\n                        </button>\n                        <button class=\"btn sw-btn-radio\" ng-class=\"{\'checked\':vm.userData.preferences.povOverride === \'performer\'}\" ng-click=\"vm.updatePovOverride(\'performer\')\" type=\"button\">\n                          <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\':vm.userData.preferences.povOverride === \'performer\', \'ion-android-radio-button-off\':vm.userData.preferences.povOverride !== \'performer\'}\"></span>\n                          {{\'buttons.Performer\'| translate}}\n                        </button>\n                      </div>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <div class=\"col-lg-offset-3 col-lg-9\">\n                      <div class=\"hint-icon-message hint-icon-message-autow\">\n                        <div class=\"icon\">\n                          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n                        </div>\n                        <div class=\"text\">\n                          <span translate>messages.This will only be applied to collaborated productions</span>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <!-- <div class=\"form-group mrgn-padd-btm0\">\n                    <label class=\"col-lg-3 control-label\" translate>labels.Print linked chart numbers on script</label>\n                    <div class=\"col-lg-9\">\n                      <switch class=\"swa-switch\" id=\"my-account-print-linked-chart\" ng-model=\"vm.userData.preferences.printScriptChartLinks\" ng-change=\"vm.updatePrintScriptChartLinksPreference()\"></switch>\n                    </div>\n                  </div> -->\n                  <!-- <div class=\"form-group\">\n                    <div class=\"col-lg-offset-3 col-lg-9\">\n                      <div class=\"hint-icon-message hint-icon-message-autow\">\n                        <div class=\"icon\">\n                          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n                        </div>\n                        <div class=\"text\">\n                          <span translate>messages.The linked chart number will be printed in the left margin of the script</span>\n                        </div>\n                      </div>\n                    </div>\n                  </div> -->\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-lg-5 sw-panel-container\" style=\"margin-top: 40px\">\n            <div class=\"panel panel-default\">\n              <div class=\"panel-heading\">\n                <span class=\"text-lg\" translate>titles.Active Plan and Payment Method</span>\n              </div>\n              <div class=\"panel-body\">\n                <div class=\"form-horizontal sw-form-container\">\n                  <div class=\"form-group\">\n                    <label class=\"col-lg-3 control-label\" translate>labels.Plan</label>\n                    <div class=\"col-lg-5\">\n                      <p class=\"form-control-static sw-color-white\" style=\"font-weight: normal\">\n                        <span>{{vm.userData.activesubscription.planname}}</span>\n                        <span class=\"sw-color-red\" ng-show=\"vm.userData.activesubscription.status === 1\">({{\'labels.Cancelled\'| translate}})</span>\n                        </p><div class=\"hint-icon-message hint-icon-message-autow\" ng-show=\"vm.userData.activesubscription.promoPlan\">\n                          <div class=\"icon\">\n                            <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n                          </div>\n                          <div class=\"text\">\n                            <span>Promotional Plan</span>\n                          </div>\n                        </div>\n                        <div class=\"hint-icon-message hint-icon-message-autow\" ng-show=\"vm.managedAccount\">\n                          <div class=\"icon\">\n                            <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n                          </div>\n                          <div class=\"text\" ng-show=\"vm.userData.activesubscription.planid === 1\">\n                            <span>Enterprise Member</span>\n                          </div>\n                          <div class=\"text\" ng-hide=\"vm.userData.activesubscription.planid === 1\">\n                              <span>Enterprise subscription valid till <span class=\"swa-color-lightgray\">{{vm.userData.activesubscription.validtill.$date | date:\'dd MMM, yyyy\'}}</span></span>\n                            </div>\n                          </div>\n                      <p></p>\n                    </div>\n                    <div class=\"col-lg-4 text-right\">\n                      <button class=\"btn btn-sm sw-btn-danger\" id=\"my-account-cancel-plan\" ng-click=\"vm.promptCancelSubscription()\" ng-show=\"(vm.userData.activesubscription.planid !==2 )\n                      && (vm.userData.activesubscription.status !== 1) && !vm.managedAccount && !vm.userData.activesubscription.promoPlan\" translate>buttons.Cancel</button>\n                      <button class=\"btn btn-sm sw-btn-secondary\" ui-sref=\"{{vm.swaRouterStateNames.subscriptions}}\" id=\"my-account-change-plan\" ng-hide=\"vm.managedAccount\" translate>buttons.Change</button>\n                    </div>\n                  </div>\n                  <div class=\"form-group\">\n                    <label class=\"col-lg-3 control-label\" translate>labels.Payment Method</label>\n                    <div class=\"col-lg-9\">\n                      <p class=\"form-control-static sw-color-mediumlightgray\" ng-hide=\"vm.paymentMethodDetails.hasPaymentMethod\" translate>messages.None</p>\n                      <p class=\"form-control-static sw-color-white\" ng-show=\"vm.paymentMethodDetails.hasPaymentMethod\">\n                        <span ng-show=\"vm.paymentMethodDetails.hasStripePaymentMethod\">\n                          <span>Stripe</span>\n                          <span ng-show=\"vm.paymentMethodDetails.hasStripeCardDetails\">({{vm.paymentMethodDetails.stripe.maskedcardnumber}})</span>\n                          <span class=\"sw-color-mediumlightgray\" ng-hide=\"vm.paymentMethodDetails.hasStripeCardDetails\">(No Card)</span>\n                        </span>\n                        <button id=\"my-account-manage-payment-method\" class=\"btn btn-sm sw-btn-secondary pull-right\" ng-click=\"vm.managePaymentMethod()\" translate>buttons.Manage</button>\n                      </p>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"panel panel-default\">\n              <div class=\"panel-heading\">\n                <span class=\"text-lg\" translate>titles.Subscription History</span>\n              </div>\n              <div class=\"panel-body\">\n                <table class=\"table panel-table\">\n                  <thead>\n                    <tr>\n                      <td></td>\n                      <td translate>labels.Plan</td>\n                      <td class=\"text-right\" translate>labels.Amt</td>\n                      <td translate>labels.Renewal</td>\n                      <td translate>labels.Start Date</td>\n                      <td translate>labels.Valid Till</td>\n                      <td translate>labels.Status</td>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr ng-repeat=\"history in vm.userSubscriptionHistory| orderBy:\'-created.$date\' | limitTo: 10\" ng-init=\"isActive = (history.subscriptionId === vm.userData.activesubscription.subscriptionId)\">\n                      <td>\n                        <span class=\"sw-color-red sw-ionicon sw-ionicon-fw sw-ionicon-lg\" ng-hide=\"history.status !== 0\"></span>\n                        <span class=\"sw-color-red sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-alert-circled\" ng-show=\"isActive && (history.status !== 0)\" uib-tooltip=\"{{history.tooltip}}\" tooltip-placement=\"bottom\"></span>\n                      </td>\n                      <td ng-bind=\"history.planname\"></td>\n                      <td class=\"text-right\">\n                        <span ng-hide=\"history.promoPlan\" ng-bind=\"history.amount | currency: \'$\' : 2\"></span>\n                        <span ng-show=\"history.promoPlan\">--</span>\n                      </td>\n                      <td>\n                        <span ng-show=\"!history.promoPlan && history.planmonthly\" translate>labels.Monthly</span>\n                        <span ng-show=\"!history.promoPlan && !history.planmonthly\" translate>labels.Yearly</span>\n                        <span ng-show=\"history.promoPlan\" translate>labels.Promo</span>\n                      </td>\n                      <td ng-bind=\"history.validfrom.$date | date:\'MMM dd, yyyy\'\"></td>\n                      <td>\n                        <span ng-class=\"{\'sw-color-red\': isActive && (history.status !== 0)}\" ng-bind=\"history.validtill.$date | date:\'MMM dd, yyyy\'\"></span>\n                      </td>\n                      <td>\n                        <div ng-show=\"isActive\">\n                          <span ng-show=\"history.status !== 2\" translate>labels.Active</span>\n                          <span ng-show=\"history.status === 2\" translate>labels.Payment Due</span>\n                        </div>\n                        <div ng-hide=\"isActive\">\n                          <span translate>labels.Ended</span>\n                        </div>\n                      </td>\n                    </tr>\n                    <tr ng-hide=\"vm.userSubscriptionHistory.length > 0\">\n                      <td colspan=\"7\" class=\"text-center\">\n                        <span translate>messages.You have not purchased any subscriptions yet.</span>\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/profile/purchasePlanPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title\" translate>titles.Purchase Subscription</span>\n</div>\n<div class=\"modal-body\">\n  <p>\n    <span>You have selected the \'{{vm.newPlan.planname}}\' plan, on a</span>\n    <span ng-show=\"vm.monthly\"> monthly payment schedule.</span>\n    <span ng-hide=\"vm.monthly\"> yearly payment schedule.</span>\n    <span>You will be charged</span>\n    <strong ng-show=\"vm.monthly\">${{vm.newPlan.monthlycost}} per month</strong>\n    <strong ng-hide=\"vm.monthly\">${{vm.newPlan.yearlycost}} per year</strong>\n    <span>on a recurring basis till you cancel the subscription.</span>\n    <br>\n  </p>\n  <p ng-show=\"vm.discountApplicable\">\n    <span>Since you have an active paid subscription, the first payment will be discounted by the prorated balance calculated below -</span>\n    <br>\n    <span>Balance / Total Term: {{vm.discountDetails.balanceDays}} / {{vm.discountDetails.totalDays}} days.</span>\n    <br>\n    <span>Prorated Balance: ${{vm.discountDetails.proratedBalance}}</span>\n  </p>\n  <p>\n    <strong translate>messages.Confirm this purchase?</strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.confirmPurchase()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.cancelPurchase()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/profile/subscriptions.html","<swa-help-bar ng-if=\"vm.showHelpBar\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-videos=\"vm.helpTourVideos\"></swa-help-bar>\n<div class=\"mainOuter\" ng-cloak>\n  <div class=\"navbar navbar-fixed-top sw-navbar\">\n    <div class=\"swtoolbar\">\n      <div class=\"navbar-center-title\">\n        <span class=\"text-lg sw-color-lightgray\" translate>titles.Subscriptions</span>\n      </div>\n      <div class=\"swtoolbar-group pull-left\">\n        <img class=\"sws-logo sws-logo-link\" src=\"assets/images/sws-logo-light.png\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\" uib-tooltip=\"{{\'labels.Back to Productions\' | translate}}\">\n      </div>\n      <div class=\"swtoolbar-group pull-right\">\n        <button class=\"btn sw-btn-toolbar sw-btn-toolbar-user\" stackable-trigger=\"userMenu\">\n          <span class=\"sw-ionicon-fw sw-ionicon-lg ion-person\"></span>\n          <span ng-bind=\"vm.username\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"userMenu\">\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\">\n                <span class=\"title\" translate>labels.Productions</span>\n              </div>\n              <div class=\"menu-item\" ui-sref=\"{{vm.swaRouterStateNames.myaccount}}\">\n                <span class=\"title\" translate>labels.My Account</span>\n              </div>\n            </div>\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-click=\"vm.logout()\">\n                <span class=\"title\" translate id=\"production-list-logout\">labels.Logout</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n    </div>\n  </div>\n  <!-- Begin page content -->\n  <div class=\"sw-maincontentarea-profile sw-scrollcontainer\" ng-cloak ng-scrollbars ng-scrollbars-config=\"vm.scrollConfig\">\n    <div class=\"container-fluid\">\n      <div class=\"row\">\n        <div class=\"col-lg-offset-1 col-lg-9 sw-color-lightgray\" ng-cloak ng-show=\"vm.userData\">\n          <p class=\"sw-text-lg\">\n            <span>You are currently on the <strong>{{vm.userData.activesubscription.planname}} </strong> plan.</span>\n          </p><div class=\"hint-icon-message hint-icon-message-autow\" ng-show=\"vm.userData.activesubscription.promoPlan\">\n            <div class=\"icon\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n            </div>\n            <div class=\"text\">\n              <span>This is a promotional plan and is valid till {{vm.userData.activesubscription.validtill.$date | date:\'dd MMM, yyyy\'}}.</span><br>\n              <span>You will need to purchase a subscription for full access your productions after the promotion period expires.</span>\n            </div>\n          </div>\n          <div class=\"hint-icon-message hint-icon-message-autow\" ng-if=\"vm.isEntAcctMember\">\n            <div class=\"icon\">\n              <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n            </div>\n            <div class=\"text\">\n              <span>You are an Enterprise Account member.</span><br>\n              <span>Your subscription is managed by <span class=\"swa-color-lightgray\">{{vm.entAcctName}}</span> and is valid till <span class=\"swa-color-lightgray\">{{vm.userData.activesubscription.validtill.$date | date:\'dd MMM, yyyy\'}}</span>.</span>\n            </div>\n          </div>\n          <p></p>\n          <p ng-hide=\"vm.userData.activesubscription.promoPlan || vm.userData.activesubscription.planid === 2\" ng-if=\"!vm.isEntAcctMember\">\n            <span>Your billing cycle is <strong ng-show=\"vm.userData.activesubscription.planmonthly\">Monthly</strong><strong ng-hide=\"vm.userData.activesubscription.planmonthly\">Yearly</strong> and your subscription will be\n              automatically renewed on {{vm.userData.activesubscription.validtill.$date | date:\'dd MMM, yyyy\'}}.</span>\n          </p>\n          <p ng-if=\"!vm.isEntAcctMember && !vm.userData.flags.stripeCheckoutPending\">\n            <span class=\"sw-color-mediumlightgray\">To switch, review the features for each plan below and click the\n              appropriate button to start a monthly or yearly recurring subscription.<br>Subscriptions are renewed\n              automatically until cancelled.</span>\n          </p>\n          <div ng-if=\"vm.userData.flags.stripeCheckoutPending\">\n            <div class=\"sw-text-lg\">Your last transaction for update card / payment is in progress.</div>\n            <div class=\"sw-color-mediumlightgray\"><em>Please wait for a while before attempting another payment. Pending transactions automatically expire in about 30 minutes if no action is taken.</em></div>\n          </div>\n        </div>\n        <div class=\"col-lg-2 text-right\">\n          <span class=\"sw-a-link sw-a-link-underline\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\" translate>labels.Back to Productions</span>\n        </div>\n      </div>\n      <div class=\"row\" ng-if=\"!vm.isEntAcctMember && !vm.userData.flags.stripeCheckoutPending\">\n        <div id=\"subscription-plans\" class=\"col-lg-12\" ng-cloak ng-show=\"vm.webPlans\">\n          <table class=\"subscriptionplans-table\">\n            <thead id=\"thead-subscription-plans\">\n              <tr>\n                <th rowspan=\"4\"></th>\n                <th class=\"text-center\" colspan=\"{{vm.webPlans.length}}\" translate>labels.Subscription Types</th>\n                <th></th>\n                <th class=\"text-center\" colspan=\"3\">Bundles</th>\n              </tr>\n              <tr>\n                <th class=\"text-center\" ng-class=\"{\'active\': (!vm.userData.activesubscription.promoPlan && (vm.userData.activesubscription.planid === plan.planid))}\" ng-repeat=\"plan in vm.webPlans\">{{plan.planname}}</th>\n                <th></th>\n                <th class=\"text-center\">\n                  <div>CREATIVE TEAM BUNDLE</div>\n                </th>\n                <th class=\"text-center\">\n                  <div>EDUCATIONAL BUNDLE</div>\n                </th>\n                <th class=\"text-center\">\n                  <div>ENTERPRISE BUNDLE</div>\n                </th>\n              </tr>\n              <tr class=\"pricing\">\n                <td rowspan=\"2\" class=\"text-center\" ng-repeat=\"plan in vm.webPlans\">\n                  <div ng-show=\"plan.monthlycost === 0 && plan.yearlycost === 0\">\n                    <button class=\"btn btn-block sw-btn-secondary\" ng-click=\"vm.selectPlan(plan, false)\" ng-disabled=\"(vm.userData.activesubscription.planid === plan.planid)\" translate type=\"button\">buttons.Select</button>\n                  </div>\n                  <div ng-show=\"plan.monthlycost !== 0 || plan.yearlycost !== 0\">\n                    <button class=\"btn btn-block sw-btn-secondary\" ng-click=\"vm.selectPlan(plan, true)\" ng-disabled=\"!vm.userData.activesubscription.promoPlan && (vm.userData.activesubscription.planid === plan.planid) && vm.userData.activesubscription.planmonthly\" type=\"button\">\n                      ${{plan.monthlycost}}\n                      / Mo\n                    </button>\n                    <button class=\"btn btn-block sw-btn-default\" ng-click=\"vm.selectPlan(plan, false)\" ng-disabled=\"!vm.userData.activesubscription.promoPlan && (vm.userData.activesubscription.planid === plan.planid) && !vm.userData.activesubscription.planmonthly\" type=\"button\">\n                      ${{plan.yearlycost}}\n                      / Yr\n                    </button>\n                  </div>\n                </td>\n                <td rowspan=\"2\" class=\"text-center\"></td>\n                <th class=\"text-center bundle-pricing\">$249 / Yr</th>\n                <th class=\"text-center bundle-pricing\">$599 / Yr</th>\n                <th class=\"text-center bundle-pricing\">CUSTOM</th>\n              </tr>\n              <tr>\n                <th colspan=\"3\">\n                  <a href=\"https://www.stagewritesoftware.com/bundles\" target=\"_blank\" class=\"btn btn-block sw-btn-secondary pull-right mrgnBottom25\">SET UP YOUR BUNDLE HERE</a>\n                </th>\n              </tr>\n            </thead>\n            <tbody id=\"tbody-subscription-plans\">\n              <tr>\n                <th>Number of Users</th>\n                <td class=\"text-center\">1 User</td>\n                <td class=\"text-center\">1 User</td>\n                <td class=\"text-center\">1 User</td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">Pro (3 users) & VIEW ONLY (unlimited)</td>\n                <td class=\"text-center\">Pro (10 users) & VIEW ONLY (unlimited)</td>\n                <td class=\"text-center\">Custom</td>\n              </tr>\n              <tr>\n                <th>Number of Productions</th>\n                <td class=\"text-center\">Unlimited</td>\n                <td class=\"text-center\">1</td>\n                <td class=\"text-center\">Unlimited</td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">Unlimited</td>\n                <td class=\"text-center\">Unlimited</td>\n                <td class=\"text-center\">Unlimited</td>\n              </tr>\n              <tr class=\"plan-heading\">\n                <td colspan=\"9\">DIGITAL SCRIPT</td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Import PDF/Replace pages</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Highlight Lines</th>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-person-stalker text-success\" uib-tooltip=\"On collaborated production with private script\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Text Notes</th>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-person-stalker text-success\" uib-tooltip=\"On collaborated production with private script\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Freehand Notes</th>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-person-stalker text-success\" uib-tooltip=\"On collaborated production with private script\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Enter Light, SFX Cues</th>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-person-stalker text-success\" uib-tooltip=\"On collaborated production with private script\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Link PDF to Charts</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Priniting PDF</th>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-person-stalker text-success\" uib-tooltip=\"On collaborated production with private script\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading\">\n                <td colspan=\"9\">SPACING CHARTS</td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Create/Edit spacing charts</th>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-person-stalker text-success\" uib-tooltip=\"Add personal notes on charts of collaborated production with limited access\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Create Perfomer Icons</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Import or draw ground plans</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Import or draw props</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Customize number line</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Upload media (video files)</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Add/Edit Shapes</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Link Charts to PDF</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading\">\n                <td colspan=\"9\">STAGING SCORE</td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Edit Staging Score</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Link Staging Score to Charts</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading\">\n                <td colspan=\"9\">IPAD APP</td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Sync Data between iPad</th>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading\">\n                <td colspan=\"9\">COLLABORATE</td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Add/manage collaborators</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Manage Enterprise Users</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\"></td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n              <tr class=\"plan-heading\">\n                <td colspan=\"9\">PRINTING</td>\n              </tr>\n              <tr class=\"plan-heading-subsections\">\n                <th>Printing PDF</th>\n                <td class=\"text-center\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td style=\"width: 2%; min-width: 40px\"></td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n                <td class=\"text-center\">\n                  <i class=\"sw-ionicon sw-ionicon-lg ion-checkmark-round text-success\"></i>\n                </td>\n              </tr>\n            </tbody>\n            <tfoot id=\"tfoot-subscription-plans\">\n              <tr>\n                <th rowspan=\"2\"></th>\n                <td rowspan=\"2\" class=\"text-center\" ng-repeat=\"plan in vm.webPlans\">\n                  <div ng-show=\"plan.monthlycost === 0 && plan.yearlycost === 0\">\n                    <button class=\"btn btn-block sw-btn-secondary\" ng-click=\"vm.selectPlan(plan, false)\" ng-disabled=\"(vm.userData.activesubscription.planid === plan.planid)\" translate type=\"button\">buttons.Select</button>\n                  </div>\n                  <div ng-show=\"plan.monthlycost !== 0 || plan.yearlycost !== 0\">\n                    <button class=\"btn btn-block sw-btn-secondary\" ng-click=\"vm.selectPlan(plan, true)\" ng-disabled=\"!vm.userData.activesubscription.promoPlan && (vm.userData.activesubscription.planid === plan.planid) && vm.userData.activesubscription.planmonthly\" type=\"button\">\n                      ${{plan.monthlycost}}\n                      / Mo\n                    </button>\n                    <button class=\"btn btn-block sw-btn-default\" ng-click=\"vm.selectPlan(plan, false)\" ng-disabled=\"!vm.userData.activesubscription.promoPlan && (vm.userData.activesubscription.planid === plan.planid) && !vm.userData.activesubscription.planmonthly\" type=\"button\">\n                      ${{plan.yearlycost}}\n                      / Yr\n                    </button>\n                  </div>\n                </td>\n                <td rowspan=\"2\" class=\"text-center\"></td>\n                <th class=\"text-center bundle-pricing\">$249 / Yr</th>\n                <th class=\"text-center bundle-pricing\">$599 / Yr</th>\n                <th class=\"text-center bundle-pricing\">CUSTOM</th>\n              </tr>\n              <tr>\n                <th colspan=\"3\">\n                  <a href=\"https://www.stagewritesoftware.com/bundles\" target=\"_blank\" class=\"btn btn-block sw-btn-secondary pull-right mrgnBottom25\">SET UP YOUR BUNDLE HERE</a>\n                </th>\n              </tr>\n            </tfoot>\n          </table>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<script id=\"subscriptionConfirmModal.html\" type=\"text/ng-template\">\n  <div class=\"modal-header\">\n    <span class=\"modal-title\" translate>titles.Purchase Subscription</span>\n  </div>\n  <div class=\"modal-body\">\n    <p>\n      <span translate translate-values=\"{planname: newPlan.planname}\">messages.purchasesubscriptionline1_planname</span>\n      <span ng-show=\"monthly\" translate>messages.purchasesubscriptionline2_monthly</span>\n      <span ng-hide=\"monthly\" translate>messages.purchasesubscriptionline2_yearly</span>\n      <strong ng-show=\"monthly\">${{newPlan.monthlycost}}</strong>\n      <strong ng-hide=\"monthly\">${{newPlan.yearlycost}}</strong>\n      <span>.</span>\n    </p>\n    <p>\n      <span translate>messages.The subscription will be automatically renewed unless cancelled.</span>\n      <br/>\n    </p>\n    <p>\n      <strong translate>messages.Confirm this purchase?</strong>\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"text-center\">\n      <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"confirm()\" translate>buttons.Yes</button>\n      <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"cancel()\" translate>buttons.No</button>\n    </div>\n  </div>\n</script>\n");
$templateCache.put("app/components/profile/switchToViewOnlyPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title\" translate>titles.Switch to View Only</span>\n</div>\n<div class=\"modal-body\">\n  <p>\n    <span>Your existing subscription will be cancelled and you will be switched to the {{vm.newPlan.planname}} plan.</span>\n  </p>\n  <p>\n    <span>Note that this change will be immediate, the remaining period of your current subscription will lapse.</span>\n    <span>To cancel auto-renewal, use the Cancel option on the \'My Account\' page.</span>\n    <br>\n  </p>\n  <p>\n    <strong translate>messages.Confirm?</strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.confirmSwitch()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.cancelSwitch()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/scriptEditor/annotationLayerSettingsPrompt.html","<!--// SWA-ST1-T15 - New File -->\n<div class=\"modal-header\">\n  <span class=\"modal-title text-danger text-center\">Layer Settings - {{vm.annotationLayer.name}}</span>\n</div>\n<div class=\"modal-body container-fixed\">\n  <div class=\"form-group row\">\n    <label class=\"col-sm-2 annotation-type-style\" for=\"annotationlayername\" translate>labels.Name</label>\n    <div class=\"col-sm-4\">\n      <input class=\"form-control\" id=\"annotationlayername\" name=\"annotationlayername\" ng-model=\"vm.annotationLayer.name\" required=\"\" type=\"text\">\n    </div>\n    <div class=\"form-group\" ng-show=\"vm.isProductionOwner\">\n      <div class=\"col-sm-4\">\n        <label class=\"annotation-type-style\" translate>labels.Share Layer</label>\n          <p class=\"sw-color-mediumlightgray\">\n              <span>The layer will be shared with collaborators who have Limited or Private access.</span><br>\n          </p>\n      </div>\n          <div class=\"col-sm-2 layer-settings-align-right\">\n            <switch class=\"swa-switch\" id=\"\" ng-model=\"vm.annotationLayer.isShared\" on=\"YES\" off=\"NO\" ng-disabled=\"\"></switch>\n          </div>\n    </div>\n  </div>\n  <div class=\"hint-icon-message mt-20\">\n    <div class=\"icon\">\n      <span class=\"sw-ionicon-fw sw-ionicon-lg ion-ios-information-outline\"></span>\n    </div>\n    <div class=\"text\">\n      <em>Color and Text stying to use when adding new content to this layer.</em><br>\n    </div>\n  </div>\n  <div id=\"script-layer-settings\" class=\"preferences layer-settings\">\n\n    <div class=\"layer-settings-style-section\">\n      <div class=\"row\">\n        <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 form-inline\">\n          <div id=\"personal-content-defaults-cue\" class=\"left\">\n            <label class=\"control-label annotation-type-style\" translate>labels.Cue / Q - Anchor</label>\n          </div>\n        </div>\n        <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 form-inline\">\n          <div id=\"personal-content-defaults-cue\" class=\"left\">\n            <label class=\"control-label annotation-type-style\" translate>labels.Cue / Q - Text</label>\n          </div>\n        </div>\n        <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 form-inline\">\n          <div id=\"personal-content-defaults-cue\" class=\"left\">\n            <label class=\"control-label annotation-type-style\" translate>labels.Preview</label>\n          </div>\n        </div>\n\n        <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 form-inline\">\n          <div class=\"left\">\n            <div class=\"swtoolbar-flex\">\n              <label class=\"default-text-label layer-setting-cue-anchor-style align-self-center annotation-layer-label\" translate>labels.Colors</label>\n              <div class=\"annotation-layer-setting\">\n                <div class=\"sub-settings left\">\n                  <span class=\"sub-settings-icon sw-ionicon ion-paintbucket left selector\"></span>\n                  <div class=\"clr bg-container left clickable checkerboard-bk\">\n                    <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.annotationLayerColors.fillColorForAnchorCue\" options=\"vm.colorPickerOption\" on-hide=\"vm.editSettings(\'settingsScriptLq\', { fillColorForAnchor : vm.colorToRgb(color) })\"></spectrum-colorpicker>\n                  </div>\n                </div>\n                <div class=\"sub-settings left\">\n                  <span class=\"sub-settings-icon left selector sw-ionicon ion-brush\"></span>\n                  <div class=\"clr fg-container left clickable\">\n                    <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.annotationLayerColors.borderColorForAnchorCue\" options=\"vm.colorPickerOption\" on-hide=\"vm.editSettings(\'settingsScriptLq\', { borderColorForAnchor : vm.colorToRgb(color) })\"></spectrum-colorpicker>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"left\">\n            <div class=\"swtoolbar-flex\">\n              <label class=\"default-text-label layer-setting-cue-anchor-style align-self-center annotation-layer-label\" translate>labels.Style</label>\n              <div>\n                <div id=\"chart-performer-scaling-mode\" class=\"btn-group btn-group-btn script-cue-style-radio-btn\">\n                  <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.annotationLayer.contentDefaults.settingsScriptLq.markerStyle === false}\" ng-click=\"vm.updateCueAnchorStyle(\'settingsScriptLq\', \'box\')\" type=\"button\">\n                    <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.annotationLayer.contentDefaults.settingsScriptLq.markerStyle === false,\n                                      \'ion-android-radio-button-off\': vm.annotationLayer.contentDefaults.settingsScriptLq.markerStyle === true}\"></span>\n                    {{\'buttons.Box\'| translate}}\n                  </button>\n                  <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.annotationLayer.contentDefaults.settingsScriptLq.markerStyle === true}\" ng-click=\"vm.updateCueAnchorStyle(\'settingsScriptLq\', \'marker\')\" type=\"button\">\n                    <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.annotationLayer.contentDefaults.settingsScriptLq.markerStyle === true,\n                                      \'ion-android-radio-button-off\': vm.annotationLayer.contentDefaults.settingsScriptLq.markerStyle === false}\"></span>\n                    {{\'buttons.Marker\'| translate}}\n                  </button>\n                </div>\n              </div>\n            </div>\n            <div class=\"swtoolbar-flex\">\n              <label class=\"default-text-label layer-setting-cue-anchor-style align-self-center annotation-layer-label\" translate>labels.Line</label>\n              <div>\n                <div id=\"chart-performer-scaling-mode\" class=\"btn-group btn-group-btn script-cue-style-radio-btn\">\n                  <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop === false}\" ng-click=\"vm.updateCueAnchorConnectingLine(\'settingsScriptLq\', \'bottom\')\" type=\"button\">\n                    <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop === false,\n                                      \'ion-android-radio-button-off\': vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop === true}\"></span>\n                    {{\'buttons.Bottom\'| translate}}\n                  </button>\n                  <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop === true}\" ng-click=\"vm.updateCueAnchorConnectingLine(\'settingsScriptLq\', \'top\')\" type=\"button\">\n                    <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop === true,\n                                      \'ion-android-radio-button-off\': vm.annotationLayer.contentDefaults.settingsScriptLq.connectingLineTop === false}\"></span>\n                    {{\'buttons.Top\'| translate}}\n                  </button>\n                </div>\n              </div>\n            </div>\n            <div class=\"left swtoolbar-flex\">\n              <label class=\"default-text-label layer-setting-cue-anchor-style align-self-center annotation-layer-label\" translate>labels.Thickness</label>\n              <div class=\"annotation-layer-setting\">\n                <div class=\"sub-settings clickable\" ng-click=\"vm.borderThicknessStepper(\'settingsScriptLq\', \'-\')\">\n                  <span class=\"sub-settings-icon left selector sw-ionicon ion-minus sw-ionicon-bold\"></span>\n                </div>\n                <div class=\"font-setting sub-settings clickable\" stackable-trigger=\"vm.borderThicknessPickerSettingsScriptLq\">\n                  <span class=\"sub-settings-text left\">{{vm.annotationLayer.contentDefaults[\'settingsScriptLq\'].annotationBorderThickness}}\n                    {{vm.borderThicknessRange.unit}}</span>\n                </div>\n                <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.borderThicknessPickerSettingsScriptLq\" stackable-enable-escape=\"true\">\n                  <div class=\"sw-popover-menu sw-fontsize-picker\">\n                    <div class=\"menu-group line-thickness-picker\">\n                      <div class=\"menu-item text-center\" ng-repeat=\"borderThickness in vm.borderThicknessRange.pickerValues\" ng-click=\"vm.editSettings(\'settingsScriptLq\', { annotationBorderThickness : borderThickness }); vm.borderThicknessPickerSettingsScriptLq.show = false;\">\n                        <span class=\"title\">{{borderThickness}} {{vm.borderThicknessRange.unit}}</span>\n                      </div>\n                    </div>\n                  </div>\n                </stackable-popover>\n                <div class=\"sub-settings clickable\" ng-click=\"vm.borderThicknessStepper(\'settingsScriptLq\', \'+\')\">\n                  <span class=\"sub-settings-icon left selector swafont swafont-lg swafont-icon-plus sw-ionicon-bold\"></span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 form-inline padding-right-none\">\n          <div class=\"text-settings\">\n            <div class=\"sub-settings left\">\n              <span class=\"sub-settings-icon sw-ionicon ion-paintbucket left selector\"></span>\n              <div class=\"clr bg-container left clickable checkerboard-bk\">\n                  <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.annotationLayerColors.fillColorCue\" options=\"vm.colorPickerOption\" on-hide=\"vm.editSettings(\'settingsScriptLq\', { fillColor : vm.colorToRgb(color) })\"></spectrum-colorpicker>\n              </div>\n            </div>\n            <div class=\"sub-settings left\">\n              <span class=\"sub-settings-icon left selector sw-ionicon ion-brush\"></span>\n              <div class=\"clr fg-container left clickable\">\n                <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.annotationLayerColors.fontColorCue\" options=\"vm.colorPickerOption\" on-hide=\"vm.editSettings(\'settingsScriptLq\', { fontColor : vm.colorToRgb(color) })\"></spectrum-colorpicker>\n              </div>\n            </div>\n            <div id=\"font-family-setting-settingsScriptLq\" class=\"font-setting sub-settings left clickable\" stackable-trigger=\"switchFontFamilySettingsScriptLq\">\n              <span class=\"sub-settings-text left\">{{vm.annotationLayer.contentDefaults[\'settingsScriptLq\'].fontFamily}}</span>\n            </div>\n            <stackable-popover stackable-placement=\"bottom\" stackable=\"switchFontFamilySettingsScriptLq\" stackable-enable-escape=\"true\">\n              <div class=\"sw-popover-menu\" role=\"menu\">\n                <div class=\"menu-group\">\n                  <div class=\"menu-item\" ng-repeat=\"fontFamily in vm.fontFamilies\" ng-click=\"vm.editSettings(\'settingsScriptLq\', { fontFamily : fontFamily }); switchFontFamilySettingsScriptLq.show = false\">\n                    <span class=\"title\">{{fontFamily}}</span>\n                  </div>\n                </div>\n              </div>\n            </stackable-popover>\n            <div class=\"left\">\n              <div class=\"sub-settings left clickable\" ng-click=\"vm.fontSizeStepper(\'settingsScriptLq\', \'-\')\">\n                <span class=\"sub-settings-icon left selector sw-ionicon ion-minus sw-ionicon-bold\"></span>\n              </div>\n              <div class=\"font-setting sub-settings left clickable\" stackable-trigger=\"vm.fontSizePickerSettingsScriptLq\">\n                <span class=\"sub-settings-text left\">{{vm.annotationLayer.contentDefaults[\'settingsScriptLq\'].fontSize}}\n                  {{vm.fontSizeRange.unit}}</span>\n              </div>\n              <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.fontSizePickerSettingsScriptLq\" stackable-enable-escape=\"true\">\n                <div class=\"sw-popover-menu sw-fontsize-picker\">\n                  <div class=\"menu-group\">\n                    <div class=\"menu-item text-center\" ng-repeat=\"fontSize in vm.fontSizeRange.pickerValues\" ng-click=\"vm.editSettings(\'settingsScriptLq\', { fontSize : fontSize }); vm.fontSizePickerSettingsScriptLq.show = false;\">\n                      <span class=\"title\">{{fontSize}} {{vm.fontSizeRange.unit}}</span>\n                    </div>\n                  </div>\n                </div>\n              </stackable-popover>\n              <div class=\"sub-settings left clickable\" ng-click=\"vm.fontSizeStepper(\'settingsScriptLq\', \'+\')\">\n                <span class=\"sub-settings-icon left selector swafont swafont-lg swafont-icon-plus sw-ionicon-bold\"></span>\n              </div>\n  \n              <div class=\"sub-settings left clickable\" ng-class=\"{ \'settings-active\': vm.annotationLayer.contentDefaults[\'settingsScriptLq\'].bold}\" ng-click=\"vm.editSettings(\'settingsScriptLq\', { bold : !vm.annotationLayer.contentDefaults[\'settingsScriptLq\'].bold })\">\n                <span class=\"sub-settings-icon left selector\">B</span>\n              </div>\n  \n              <div class=\"sub-settings left clickable\" ng-class=\"{ \'settings-active\': vm.annotationLayer.contentDefaults[\'settingsScriptLq\'].italic}\" ng-click=\"vm.editSettings(\'settingsScriptLq\', { italic : !vm.annotationLayer.contentDefaults[\'settingsScriptLq\'].italic })\">\n                <span class=\"sub-settings-icon left selector\">I</span>\n              </div>\n  \n              <div class=\"sub-settings left clickable\" ng-class=\"{ \'settings-active\': vm.annotationLayer.contentDefaults[\'settingsScriptLq\'].underline}\" ng-click=\"vm.editSettings(\'settingsScriptLq\', { underline : !vm.annotationLayer.contentDefaults[\'settingsScriptLq\'].underline })\">\n                <span class=\"sub-settings-icon left selector\">U</span>\n              </div>\n            </div>\n\n            <div class=\"default-text-annotation\">\n              <label class=\"default-text-label\" for=\"defaultText\" translate>labels.Default Text</label>\n              <div>\n                <input class=\"form-control\" id=\"defaultText\" name=\"defaultText\" ng-model=\"vm.annotationLayer.contentDefaults[\'settingsScriptLq\'].defaultText\" required=\"\" type=\"text\">\n              </div>\n            </div>\n          </div>\n        </div>\n\n        <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 form-inline\">\n          <div class=\"preview-container left\" id=\"settings-preview-settingsScriptLq\">\n            <span id=\"preview-content-anchor-border-settingsScriptLq\" class=\"preview-content-settingsScriptLq preview-content-annotations\"></span>\n            <span id=\"preview-content-anchor-background-settingsScriptLq\" class=\"preview-content-settingsScriptLq preview-content-annotations\"></span>\n            <span id=\"preview-content-textbox-settingsScriptLq\" class=\"preview-content-settingsScriptLq preview-content-annotations\">AaBb</span>\n            <span id=\"preview-content-line-settingsScriptLq\" class=\"preview-content-settingsScriptLq preview-content-annotations\"></span>\n            <span id=\"preview-content-text-border-settingsScriptLq\" class=\"preview-content-settingsScriptLq preview-content-annotations\"></span>\n          </div>\n          <button class=\"btn sw-btn-radio left\" ng-click=\"vm.reset(\'Text Defaults\', \'settingsScriptLq\')\" type=\"button\">\n            {{\'buttons.Reset\'| translate}}\n          </button>\n        </div>\n      </div>\n    </div>\n    <div class=\"layer-settings-style-section\">\n      <div class=\"row\">\n        <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 form-inline\">\n          <div id=\"personal-content-defaults-text\" class=\"left\">\n            <label class=\"control-label annotation-type-style\" translate>labels.Text</label>\n          </div>\n        </div>\n        <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 form-inline\">\n              <div id=\"personal-content-defaults-text\" class=\"left\">\n                <label class=\"control-label annotation-type-style\" translate>labels.Preview</label>\n              </div>\n        </div>\n      <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 form-inline\"> \n          <div class=\"text-settings\">\n            <div class=\"sub-settings left\">\n              <span class=\"sub-settings-icon sw-ionicon ion-paintbucket left selector\"></span>\n              <div class=\"clr bg-container left clickable checkerboard-bk\">\n                  <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.annotationLayerColors.fillColorText\" options=\"vm.colorPickerOption\" on-hide=\"vm.editSettings(\'settingsScriptText\', { fillColor : vm.colorToRgb(color) })\"></spectrum-colorpicker>\n              </div>\n            </div>\n            <div class=\"sub-settings left\">\n              <span class=\"sub-settings-icon left selector sw-ionicon ion-brush\"></span>\n              <div class=\"clr fg-container left clickable\">\n                <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.annotationLayerColors.fontColorText\" options=\"vm.colorPickerOption\" on-hide=\"vm.editSettings(\'settingsScriptText\', { fontColor : vm.colorToRgb(color) })\"></spectrum-colorpicker>\n              </div>\n            </div>\n            <div id=\"font-family-setting-settingsScriptText\" class=\"font-setting sub-settings left clickable\" stackable-trigger=\"switchFontFamilySettingsScriptText\">\n              <span class=\"sub-settings-text left\">{{vm.annotationLayer.contentDefaults[\'settingsScriptText\'].fontFamily}}</span>\n            </div>\n            <stackable-popover stackable-placement=\"bottom\" stackable=\"switchFontFamilySettingsScriptText\" stackable-enable-escape=\"true\">\n              <div class=\"sw-popover-menu\" role=\"menu\">\n                <div class=\"menu-group\">\n                  <div class=\"menu-item\" ng-repeat=\"fontFamily in vm.fontFamilies\" ng-click=\"vm.editSettings(\'settingsScriptText\', { fontFamily : fontFamily }); switchFontFamilySettingsScriptText.show = false\">\n                    <span class=\"title\">{{fontFamily}}</span>\n                  </div>\n                </div>\n              </div>\n            </stackable-popover>\n            <div class=\"sub-settings left clickable\" ng-click=\"vm.fontSizeStepper(\'settingsScriptText\', \'-\')\">\n              <span class=\"sub-settings-icon left selector sw-ionicon ion-minus sw-ionicon-bold\"></span>\n            </div>\n            <div class=\"font-setting sub-settings left clickable\" stackable-trigger=\"vm.fontSizePickerSettingsScriptText\">\n              <span class=\"sub-settings-text left\">{{vm.annotationLayer.contentDefaults[\'settingsScriptText\'].fontSize}}\n                {{vm.fontSizeRange.unit}}</span>\n            </div>\n            <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.fontSizePickerSettingsScriptText\" stackable-enable-escape=\"true\">\n              <div class=\"sw-popover-menu sw-fontsize-picker\">\n                <div class=\"menu-group\">\n                  <div class=\"menu-item text-center\" ng-repeat=\"fontSize in vm.fontSizeRange.pickerValues\" ng-click=\"vm.editSettings(\'settingsScriptText\', { fontSize : fontSize }); vm.fontSizePickerSettingsScriptText.show = false;\">\n                    <span class=\"title\">{{fontSize}} {{vm.fontSizeRange.unit}}</span>\n                  </div>\n                </div>\n              </div>\n            </stackable-popover>\n            <div class=\"sub-settings left clickable\" ng-click=\"vm.fontSizeStepper(\'settingsScriptText\', \'+\')\">\n              <span class=\"sub-settings-icon left selector swafont swafont-lg swafont-icon-plus sw-ionicon-bold\"></span>\n            </div>\n\n            <div class=\"sub-settings left clickable mrgnLeft20\" ng-class=\"{ \'settings-active\': vm.annotationLayer.contentDefaults[\'settingsScriptText\'].bold}\" ng-click=\"vm.editSettings(\'settingsScriptText\', { bold : !vm.annotationLayer.contentDefaults[\'settingsScriptText\'].bold })\">\n              <span class=\"sub-settings-icon left selector\">B</span>\n            </div>\n\n            <div class=\"sub-settings left clickable\" ng-class=\"{ \'settings-active\': vm.annotationLayer.contentDefaults[\'settingsScriptText\'].italic}\" ng-click=\"vm.editSettings(\'settingsScriptText\', { italic : !vm.annotationLayer.contentDefaults[\'settingsScriptText\'].italic })\">\n              <span class=\"sub-settings-icon left selector\">I</span>\n            </div>\n\n            <div class=\"sub-settings left clickable\" ng-class=\"{ \'settings-active\': vm.annotationLayer.contentDefaults[\'settingsScriptText\'].underline}\" ng-click=\"vm.editSettings(\'settingsScriptText\', { underline : !vm.annotationLayer.contentDefaults[\'settingsScriptText\'].underline })\">\n              <span class=\"sub-settings-icon left selector\">U</span>\n            </div>\n\n          </div>\n        </div>\n    \n        <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 form-inline\">\n          <div class=\"preview-container left\" id=\"settings-preview-settingsScriptText\">\n              <span id=\"preview-content-textbox-settingsScriptText\" class=\"preview-content-settingsScriptText preview-content-annotations\">AaBb</span>\n          </div>\n         <button class=\"btn sw-btn-radio left\" ng-click=\"vm.reset(\'Text Defaults\', \'settingsScriptText\')\" type=\"button\">\n           {{\'buttons.Reset\'| translate}}\n         </button>\n       </div>\n      </div> \n    </div>\n    <div class=\"layer-settings-style-section\">\n      <div class=\"row\">\n        <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 form-inline\">\n          <div id=\"personal-content-defaults-highlight\" class=\"left\">\n            <label class=\"control-label annotation-type-style\" translate>labels.Highlight</label>\n          </div>\n        </div>\n        <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 form-inline\">\n          <div id=\"personal-content-defaults-text\" class=\"left\">\n            <label class=\"control-label annotation-type-style\" translate>labels.Preview</label>\n          </div>\n        </div>\n        <div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-8 form-inline\">\n          <div class=\"sub-settings highlight-settings\">\n            <div class=\"color-option\">\n              <span class=\"sw-ionicon ion-paintbucket sub-settings-icon left selector\"></span>\n            </div>\n            <div class=\"color-option color-option-bordered\">\n              <spectrum-colorpicker format=\"\'rgb\'\" ng-class=\"{\'color-checked\': vm.annotationLayer.contentDefaults.colorScriptHighlight === color}\" ng-model=\"vm.annotationLayer.contentDefaults.colorScriptHighlight\" options=\"vm.colorPickerOption\" on-hide=\"vm.editSettings(\'colorScriptHighlight\', vm.colorToRgb(color) )\"></spectrum-colorpicker>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-4 form-inline\">\n          <div class=\"preview-container left\" id=\"settings-preview-colorScriptHighlight\">\n            <span id=\"preview-content-colorScriptHighlight\" class=\"preview-content-colorScriptHighlight preview-content-annotations\">AaBb</span>\n          </div>\n          <button class=\"btn sw-btn-radio left\" ng-click=\"vm.reset(\'Text Defaults\', \'colorScriptHighlight\')\" type=\"button\">\n            {{\'buttons.Reset\'| translate}}\n          </button>\n        </div>\n      </div>\n    </div>\n</div>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"left\">\n    <button id=\"btn-delete\" class=\"btn sw-btn-default sw-btn-min-w-80\" ng-click=\"vm.deleteSettings()\" translate>buttons.Delete</button>\n  </div>\n  <div class=\"right\">\n    <button id=\"btn-update\" class=\"btn sw-btn-default sw-btn-min-w-80\" ng-click=\"vm.saveSettings()\" translate>buttons.Update</button>\n    <button id=\"btn-cancel\" class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.cancel()\" translate>buttons.Cancel</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/scriptEditor/applyMarginToAllPagesPrompt.html","<div class=\"modal-header\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Set Margin\'|translate}}\n      <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n    </span>\n  </div>\n  <div class=\"modal-body\">\n    <p class=\"text-center\">{{\'messages.set margin to all pages prompt\'|translate}}\n      <br>\n      <br>\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"text-center\">\n      <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n      <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n    </div>\n  </div>\n  ");
$templateCache.put("app/components/scriptEditor/deleteAnnotationLayerPrompt.html","<!--// SWA-1922 - New File-->\n<div class=\"modal-header\">\n  <span class=\"modal-title text-danger text-center\">{{\'titles.Delete Layer\'|translate}}\n    <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body form-horizontal\">\n  <p class=\"text-center\">\n    The layer \'{{vm.selectedAnnotationLayer.name}}\' will be deleted. This action cannot be undone\n    <br>\n    <br>\n    All content of this layer will also be deleted.\n  </p>\n  <p class=\"text-center\" ng-show=\"vm.showMergeOptions\">\n    <br>\n    <strong>OR</strong>\n    <br>\n    <br>\n    You can merge contents of this layer with another layer before deleting.\n  </p>\n  <br>\n  <div class=\"form-group\" ng-show=\"vm.showMergeOptions\">\n    <div class=\"col-lg-3 col-md-3 text-right\">\n      <label class=\"control-label swa-color-lightgray\">\n        Merge?\n      </label>\n    </div>\n    <div class=\"col-lg-3 col-md-3\">\n      <div class=\"btn-group btn-group-btn\">\n        <switch class=\"swa-switch\" ng-model=\"vm.deleteAnnotationParam.isMerge\" on=\"YES\" off=\"NO\">\n      </switch>\n      </div>\n    </div>\n    <div class=\"col-lg-6 col-md-6\">\n      <div style=\"width: 180px\" class=\"swa-settings-performer-placement-resolution\" ng-show=\"vm.deleteAnnotationParam.isMerge\">\n        <ol class=\"nya-bs-select form-control\" ng-model=\"vm.deleteAnnotationParam.mergeToLayerId\" disabled=\"!vm.deleteAnnotationParam.isMerge\" title=\"Select a layer\">\n          <li ng-disabled=\"vm.selectedAnnotationLayer.layerid !== annotationLayer.layerid\" nya-bs-option=\"annotationLayer in vm.annotationLayers\" data-value=\"annotationLayer.layerid\">\n            <a>\n              <span class=\"pull-left\">{{annotationLayer.name}}</span>\n            </a>\n          </li>\n        </ol>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-show=\"!vm.deleteAnnotationParam.isMerge\" ng-click=\"vm.actionYes()\" translate>buttons.Delete Layer</button>\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-show=\"vm.deleteAnnotationParam.isMerge\" ng-disabled=\"vm.deleteAnnotationParam.mergeToLayerId === undefined\" ng-click=\"vm.actionYes()\" translate>buttons.Merge Layer</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.Cancel</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/scriptEditor/deleteScriptPagePrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title text-danger text-center\">{{\'titles.Delete Page\'|translate}}\n    <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\">{{\'messages.delete script page prompt\'|translate}}\n    <br>\n    <br>\n    <strong>{{\'messages.Are you sure?\' | translate}}</strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/scriptEditor/importNewScriptConfirmationPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title text-danger text-center\">{{\'titles.Import New PDF\'|translate}}\n      <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\">{{\'messages.import PDF overwrite prompt\'|translate}}<br>\n    <strong><br>{{\'messages.Continue?\' | translate}}</strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/scriptEditor/insertScriptPagesConfirmationPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title text-danger text-center\">{{\'titles.Insert Page(s)\'|translate}}\n    <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\">{{\'messages.insert script pages prompt\'|translate}}\n    <br>\n    <br>\n    <strong>{{\'messages.Where do want to insert?\' | translate}}</strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-default sw-btn-min-w-80\" ng-click=\"vm.actionBefore()\" translate>buttons.Before</button>\n    <button class=\"btn sw-btn-default sw-btn-min-w-80\" ng-click=\"vm.actionAfter()\" translate>buttons.After</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionCancel()\" translate>buttons.Cancel</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/scriptEditor/replaceCurrentPageConfirmationPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title text-danger text-center\">{{\'titles.Replace Page\'|translate}}\n    <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\">{{\'messages.replace script page prompt\'|translate}}\n    <br>\n    <br>\n    <strong>{{\'messages.Continue?\' | translate}}</strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/scriptEditor/scriptEditor.html","<swa-help-bar ng-if=\"vm.showHelpBar && !vm.scriptEditorState.lockModeNavigation\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-on-start=\"vm.onHelpTourStart()\" swa-help-on-end=\"vm.onHelpTourEnd()\" swa-help-videos=\"vm.helpTourVideos\" swa-help-has-video=\"vm.helpTourVideos && vm.helpTourVideos.length > 0\"></swa-help-bar>\n<div class=\"mainOuter\" ng-class=\"{\'lockmodenavigation\': vm.scriptEditorState.lockModeNavigation}\" ng-cloak>\n  <div class=\"navbar navbar-fixed-top sw-navbar\" ng-hide=\"vm.scriptEditorState.lockModeNavigation\">\n    <div class=\"swtoolbar\">\n      <div class=\"swtoolbar-group pull-left\">\n        <img class=\"sws-logo sws-logo-link\" src=\"assets/images/sws-logo-light.png\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\" uib-tooltip=\"{{\'labels.Back to Productions\' | translate}}\">\n      </div>\n      <div class=\"swtoolbar-group pull-left\" id=\"editor-view\">\n        <button id=\"menu-locknavigation\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.toggleLockModeNavigation()\" ng-class=\"{\'sw-active\': vm.scriptEditorState.lockModeNavigation}\" ng-disabled=\"!vm.scriptEditorState.scriptAvailable\" uib-tooltip=\"Toggle lock navigation mode\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-unlock\"></span>\n        </button>\n        <button id=\"menu-switchview\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.switchEditorView\" ng-click=\"vm.deactivateAnyActiveAnnotation(); vm.killAutoSetDefaultAreaStateTimer(); vm.updateMaincontainerAreaToDefault()\" uib-tooltip=\"Switch to other Views\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <div class=\"sw-btn-toolbar-vcontent\">\n            <span class=\"title\">PDF</span>\n            <span class=\"sw-ionicon-fw ion-arrow-down-b icon\"></span>\n          </div>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.switchEditorView\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.View</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-click=\"vm.switchEditor(0)\">\n                <span class=\"title\" translate>labels.Charts</span>\n              </div>\n              <div class=\"menu-item\" ng-disabled=\"true\">\n                <span class=\"title\" translate>labels.PDF</span>\n              </div>\n              <div class=\"menu-item\" ng-click=\"vm.switchEditor(4)\">\n                <span class=\"title\" translate>labels.Charts and PDF</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n      <div id=\"menu-scriptbookmarknavigationcontrols\" class=\"swtoolbar-group pull-left\" ng-show=\"vm.scriptEditorState.scriptAvailable\">\n        <button class=\"btn sw-btn-toolbar\" ng-disabled=\"!vm.scriptEditorState.scriptAvailable || vm.sidebarEditState.enabled\" ng-click=\" vm.gotoPrevBookmark()\" uib-tooltip=\"Go to previous bookmark\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-previous\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-togglebookmarklist\" ng-class=\"{\'sw-active\': vm.scriptEditorState.bookmarkListVisible}\" ng-show=\"!vm.scriptEditorState.bookmarkEditMode\" ng-click=\"vm.toggleBookmarkListVisibility()\" ng-disabled=\"!vm.scriptEditorState.scriptAvailable || vm.sidebarEditState.enabled\" uib-tooltip=\"Bookmarks list\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-bookmark\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar sw-active\" id=\"menu-endbookmarkediting\" ng-show=\"vm.scriptEditorState.bookmarkEditMode\" ng-click=\"vm.endBookmarkEditing()\" ng-disabled=\"!vm.scriptEditorState.pageLoaded\" uib-tooltip=\"End bookmark editing\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-bookmark-fill\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" ng-disabled=\"!vm.scriptEditorState.scriptAvailable || vm.sidebarEditState.enabled\" ng-click=\"vm.gotoNextBookmark()\" uib-tooltip=\"Go to next bookmark\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-next\"></span>\n        </button>\n      </div>\n      <div class=\"swtoolbar-group pull-left\">\n        <div class=\"btn-group\">\n          <button id=\"menu-script\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.importPicker\" ng-disabled=\"!vm.activeAccessRules.allowscriptimport || vm.sidebarEditState.enabled\" uib-tooltip=\"Import script / pages\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\" ng-click=\"vm.deactivateAnyActiveAnnotation(); vm.killAutoSetDefaultAreaStateTimer(); vm.updateMaincontainerAreaToDefault()\">\n            <span class=\"swafont swafont-lg swafont-icon-import-script\"></span>\n          </button>\n          <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.importPicker\">\n            <div class=\"sw-popover-title\">\n              <span translate>titles.PDF</span>\n            </div>\n            <div class=\"sw-popover-menu\" role=\"menu\">\n              <div class=\"menu-group\">\n                <div class=\"menu-item\" ng-click=\"vm.importScript(0)\">\n                  <span class=\"title\" translate>labels.Import New PDF</span>\n                </div>\n              </div>\n              <div class=\"menu-group\">\n                <div class=\"menu-item\" ng-click=\"vm.importScript(1)\" ng-disabled=\"(vm.currentScriptPage === undefined)\">\n                  <span class=\"title\" translate>labels.Replace Current Page</span>\n                </div>\n                <div class=\"menu-item\" ng-click=\"vm.importScript(2)\" ng-disabled=\"(vm.currentScriptPage === undefined)\">\n                  <span class=\"title\" translate>labels.Insert PDF Page(s)</span>\n                </div>\n              </div>\n              <div class=\"menu-group\">\n                <div class=\"menu-item\" ng-click=\"vm.deleteCurrentPagePrompt()\" ng-disabled=\"(vm.currentScriptPage === undefined)\">\n                  <span class=\"title\" translate>labels.Delete Current Page</span>\n                </div>\n              </div>\n              <div class=\"menu-group\">\n                <div class=\"menu-item\" ng-disabled=\"!vm.showUndoPdfImport(vm.newPdfImportDate)\" ng-click=\"vm.undoPdfImportPrompt()\">\n                  <span class=\"title\" translate>labels.Undo Last Import</span>\n                </div>\n              </div>\n            </div>\n          </stackable-popover>\n          <button class=\"btn sw-btn-toolbar\" ng-disabled=\"(vm.script.numberOfPages === 0) || !vm.activeAccessRules.allowpagenavigation || !vm.activeAccessRules.allowscriptediting\" uib-tooltip=\"Set Margin\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\" stackable-trigger=\"vm.gotoMarginSetter\" ng-click=\"vm.updateMarginState()\">\n            <span class=\"swafont swafont-lg swafont-icon-gallery-horizontal\"></span>\n          </button>\n          <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.gotoMarginSetter\">\n            <div class=\"sw-popover-title\">\n              <span translate>titles.Set Margin</span>\n            </div>\n            <div class=\"sw-popover-content\">\n              <div>\n                <label class=\"performer-scaling-float-heading margin-top-10\" translate>labels.Left Side</label>\n                <div class=\"swtoolbar-flex sw-form-container set-margin-btn-set\">\n                  <div ng-disabled=\"vm.setCustomMarginState.leftSideMargin === 0\" class=\"set-margin-btns sw-btn-secondary width-30\" ng-click=\"vm.removeLeftSideMargin()\" ng-class=\"{\'set-margin-btns-disabled\': vm.setCustomMarginState.leftSideMargin === 0}\">\n                    <span class=\"selector sw-ionicon ion-minus sw-ionicon-bold\"></span>\n                  </div>\n                  <div class=\"set-margin-btns width-60-percent cursor-default\">\n                    <span class=\"\">{{vm.setCustomMarginState.leftSideMargin}} in</span>\n                  </div>\n                  <div ng-disabled=\"vm.setCustomMarginState.leftSideMargin === 2\" class=\"set-margin-btns sw-btn-secondary width-30\" ng-click=\"vm.addLeftSideMargin()\" ng-class=\"{\'set-margin-btns-disabled\': vm.setCustomMarginState.leftSideMargin === 2}\">\n                    <span class=\"selector swafont swafont-lg swafont-icon-plus sw-ionicon-bold\"></span>\n                  </div>\n                </div>\n                <label class=\"performer-scaling-float-heading margin-top-10\" translate>labels.Right Side</label>\n                <div class=\"swtoolbar-flex sw-form-container set-margin-btn-set\">\n                  <div ng-disabled=\"vm.setCustomMarginState.rightSideMargin === 0\" class=\"set-margin-btns sw-btn-secondary width-30\" ng-click=\"vm.removeRightSideMargin()\" ng-class=\"{\'set-margin-btns-disabled\': vm.setCustomMarginState.rightSideMargin === 0}\">\n                    <span class=\"selector sw-ionicon ion-minus sw-ionicon-bold\"></span>\n                  </div>\n                  <div class=\"set-margin-btns width-60-percent cursor-default\">\n                    <span class=\"\">{{vm.setCustomMarginState.rightSideMargin}} in</span>\n                  </div>\n                  <div ng-disabled=\"vm.setCustomMarginState.rightSideMargin === 2\" class=\"set-margin-btns sw-btn-secondary width-30\" ng-click=\"vm.addRightSideMargin()\" ng-class=\"{\'set-margin-btns-disabled\': vm.setCustomMarginState.rightSideMargin === 2}\">\n                    <span class=\"selector swafont swafont-lg swafont-icon-plus sw-ionicon-bold\"></span>\n                  </div>\n                </div>\n                <div class=\"swtoolbar-flex margin-top-10 set-margin-apply-btns\">\n                  <div class=\"\">\n                    <button class=\"btn sw-btn-secondary sw-btn-group-radio-2\" ng-click=\"vm.applyMargin()\" type=\"button\">\n                    {{\'buttons.Apply\'| translate}}\n                    </button>\n                  </div>\n                  <div class=\"\">\n                    <button class=\"btn sw-btn-secondary sw-btn-group-radio-2\" ng-click=\"vm.applyMarginToAllPagesPrompt()\" type=\"button\">\n                    {{\'buttons.Apply To All Pages\'| translate}}\n                    </button>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </stackable-popover>\n        </div>\n      </div>\n      <div class=\"swtoolbar-group pull-left\" id=\"annotation-controls\" ng-show=\"vm.scriptEditorState.scriptAvailable\">\n        <button ng-hide=\"true\" class=\"btn sw-btn-toolbar\" id=\"menu-scriptlayermaster\" ng-click=\"vm.activateMasterNotesLayer()\" ng-class=\"{\'sw-active\': vm.scriptEditorState.masterLayerActive}\">\n          <span class=\"swafont swafont-lg swafont-icon-doc-key\"></span>\n        </button>\n        <!-- // SWA-1922 - New -->\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-scriptannotationvisibility\" ng-class=\"{\'sw-active\': (vm.scriptEditorState.masterLayerActive && vm.scriptEditorState.annotationLayerListVisible) || (vm.scriptEditorState.personalLayerActive && vm.scriptEditorState.annotationLayerListVisible)}\" ng-click=\"vm.toggleAnnotationLayerListVisibility()\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.activeAccessRules.allowtoggleannotation || vm.scriptEditorState.bookmarkEditMode || vm.sidebarEditState.enabled\" uib-tooltip=\"Show / hide Layers list\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-layershow\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-scriptannotationmovelist\" stackable-trigger=\"vm.moveAnnotationPicker\" ng-class=\"{\'sw-active\': (vm.scriptEditorState.masterLayerActive && vm.scriptEditorState.annotationsVisible) || (vm.scriptEditorState.personalLayerActive && vm.scriptEditorState.annotationsVisiblePersonal)}\" ng-click=\"vm.moveAnnotation()\" ng-disabled=\"!vm.enableMoveAnnotationAction\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.activeAccessRules.allowtoggleannotation || !vm.enableMoveAnnotationAction || vm.sidebarEditState.enabled\" uib-tooltip=\"Move Annotation\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-layermove\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.moveAnnotationPicker\">\n          <div class=\"sw-popover-title\">\n            <span>Move Annotation</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\" ng-if=\"(vm.scriptEditorState.currentAnnotationLayerId !== annotationlayer.layerid)\" id=\"annolayerid-{{$index}}\" ng-repeat=\"annotationlayer in vm.annotationlayers\">\n              <div class=\"menu-item\" ng-click=\"vm.moveAnnotationToLayer(annotationlayer.layerid)\">\n                <span class=\"title\">{{annotationlayer.name}}</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n        <!-- End  // SWA-1922 - New -->\n        <button ng-hide=\"true\" class=\"btn sw-btn-toolbar\" id=\"menu-scriptlayerpersonal\" ng-click=\"vm.activatePersonalNotesLayer()\" ng-class=\"{\'sw-active\': vm.scriptEditorState.personalLayerActive}\">\n          <span class=\"swafont swafont-lg swafont-icon-doc-my\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-scriptlightcueannotation\" ng-show=\"vm.scriptEditorState.masterLayerActive\" ng-class=\"{\'sw-active\': vm.scriptEditorState.activeAnnotationType === 1}\" ng-click=\"vm.toggleAddLightCueAnnotation()\" completed ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.scriptEditorState.annotationsVisible || !vm.activeAccessRules.allowaddlightcueannotation || !vm.scriptEditorState.isShowHideAnnotations || vm.sidebarEditState.enabled || !vm.annotationlayers.length\" uib-tooltip=\"Add Cue\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-Qs\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-scripttextannotation\" ng-show=\"vm.scriptEditorState.masterLayerActive\" ng-class=\"{\'sw-active\': vm.scriptEditorState.activeAnnotationType === 2}\" ng-click=\"vm.toggleAddFloatingTextAnnotation()\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.scriptEditorState.annotationsVisible || !vm.activeAccessRules.allowaddtextannotation || !vm.scriptEditorState.isShowHideAnnotations || vm.sidebarEditState.enabled || !vm.annotationlayers.length\" uib-tooltip=\"Add text\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-text-notes\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-scripthighlightannotation\" ng-show=\"vm.scriptEditorState.masterLayerActive\" ng-class=\"{\'sw-active\': vm.scriptEditorState.activeAnnotationType === 3}\" ng-click=\"vm.toggleAddHighlightAnnotation()\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.scriptEditorState.annotationsVisible || !vm.activeAccessRules.allowaddhighlightannotation || !vm.scriptEditorState.isShowHideAnnotations || vm.sidebarEditState.enabled || !vm.annotationlayers.length\" uib-tooltip=\"Add highlight\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-highlighter\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-scriptsketchpadannotation\" ng-show=\"vm.scriptEditorState.masterLayerActive\" ng-class=\"{\'sw-active\': vm.scriptEditorState.activeAnnotationType === 4}\" ng-click=\"vm.toggleAddSketchpadAnnotation()\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.scriptEditorState.annotationsVisible || !vm.activeAccessRules.allowaddfreehandannotation || !vm.scriptEditorState.isShowHideAnnotations || vm.sidebarEditState.enabled || !vm.annotationlayers.length\" uib-tooltip=\"Add Freehand\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-sketch-pencil\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-scriptlightcueannotation-personal\" ng-show=\"vm.scriptEditorState.personalLayerActive\" ng-class=\"{\'sw-active\': vm.scriptEditorState.activeAnnotationType === 1}\" ng-click=\"vm.toggleAddLightCueAnnotation()\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.scriptEditorState.annotationsVisiblePersonal || !vm.scriptEditorState.isShowHideAnnotations || vm.sidebarEditState.enabled || !vm.annotationlayers.length\" uib-tooltip=\"Add Cue\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-Qs\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-scripttextannotation-personal\" ng-show=\"vm.scriptEditorState.personalLayerActive\" ng-class=\"{\'sw-active\': vm.scriptEditorState.activeAnnotationType === 2}\" ng-click=\"vm.toggleAddFloatingTextAnnotation()\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.scriptEditorState.annotationsVisiblePersonal || !vm.scriptEditorState.isShowHideAnnotations || vm.sidebarEditState.enabled || !vm.annotationlayers.length\" uib-tooltip=\"Add text\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-text-notes\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-scripthighlightannotation-personal\" ng-show=\"vm.scriptEditorState.personalLayerActive\" ng-class=\"{\'sw-active\': vm.scriptEditorState.activeAnnotationType === 3}\" ng-click=\"vm.toggleAddHighlightAnnotation()\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.scriptEditorState.annotationsVisiblePersonal || !vm.scriptEditorState.isShowHideAnnotations || vm.sidebarEditState.enabled || !vm.annotationlayers.length\" uib-tooltip=\"Add highlight\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-highlighter\"></span>\n        </button>\n        <button class=\"btn sw-btn-toolbar\" id=\"menu-scriptsketchpadannotation-personal\" ng-show=\"vm.scriptEditorState.personalLayerActive\" ng-class=\"{\'sw-active\': vm.scriptEditorState.activeAnnotationType === 4}\" ng-click=\"vm.toggleAddSketchpadAnnotation()\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.scriptEditorState.annotationsVisiblePersonal || !vm.scriptEditorState.isShowHideAnnotations || vm.sidebarEditState.enabled || !vm.annotationlayers.length\" uib-tooltip=\"Add Freehand\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-sketch-pencil\"></span>\n        </button>\n      </div>\n      <div class=\"swtoolbar-group pull-left\" id=\"script-undoredo\" ng-show=\"vm.scriptEditorState.scriptAvailable\">\n        <button id=\"menu-scriptundo\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!(vm.changeTracker.enabled && vm.changeTracker.canUndo)\" ng-click=\"vm.undoAction()\" uib-tooltip=\"Undo last change\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"toolbar-zoom-value\">{{vm.changeTracker.undoStack.length}}</span>\n          <span class=\"swafont swafont-lg swafont-icon-undo\"></span>\n        </button>\n        <button id=\"menu-scriptredo\" class=\"btn sw-btn-toolbar\" ng-disabled=\"!(vm.changeTracker.enabled && vm.changeTracker.canRedo)\" ng-click=\"vm.redoAction()\" uib-tooltip=\"Redo last change\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-redo\"></span>\n          <span class=\"toolbar-zoom-value\">{{vm.changeTracker.redoStack.length}}</span>\n        </button>\n      </div>\n      <div id=\"menu-scriptpagenavigationcontrols\" class=\"swtoolbar-group pull-left\" ng-show=\"vm.scriptEditorState.scriptAvailable\">\n        <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPage(\'prev\')\" ng-disabled=\"(vm.script.numberOfPages === 0) || (vm.scriptEditorState.currentPageNumber === 1) || !vm.activeAccessRules.allowpagenavigation\" uib-tooltip=\"Go to\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-previous\"></span>\n        </button>\n        <button id=\"menu-scriptgotopage\" class=\"btn sw-btn-toolbar width-110\" ng-disabled=\"(vm.script.numberOfPages === 0) || !vm.activeAccessRules.allowpagenavigation\" stackable-trigger=\"vm.gotoPagePicker\">\n          <span ng-show=\"(vm.script.numberOfPages === 0)\" translate>labels.No Pages</span>\n          <span ng-show=\"(vm.script.numberOfPages > 0)\">\n            <span translate translate-values=\"{current: vm.scriptEditorState.customPageNumber === \'\' ? \'_\' : vm.scriptEditorState.customPageNumber, total: vm.scriptEditorState.totalNumberOfPages}\">labels.Pg_current</span>\n            <span class=\"sw-ionicon-fw ion-arrow-down-b\"></span>\n          </span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.gotoPagePicker\">\n          <div class=\"swtoolbar-flex\">\n            <div>\n              <button ng-disabled=\"!vm.setCustomPageNumberState.enabled\" id=\"button-closeproduction-layer\" class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.hideEditCustomPageNumberMenu()\">\n                <span class=\"ion-chevron-left\"></span>\n                </button>\n            </div>\n            <div class=\"sw-popover-title\">\n              <span ng-hide=\"vm.setCustomPageNumberState.enabled\" translate>titles.Go To Page</span>\n              <span ng-show=\"vm.setCustomPageNumberState.enabled\" translate>titles.Page Name</span>\n            </div>\n          </div>\n          <div class=\"sw-popover-content\">\n            <div class=\"sw-gotopage-picker-content form-inline sw-form-container text-center\">\n              <div ng-show=\"vm.setCustomPageNumberState.enabled\">\n                <input class=\"form-control\" style=\"width: 110px; text-align: right\" id=\"gotopagequick\" ng-model=\"vm.scriptEditorState.customPageNumber\" swa-on-enter=\"vm.setCustomPageNumber()\" maxlength=\"6\" swa-select-on-focus>\n                <button class=\"btn sw-btn-secondary width-60\" ng-click=\"vm.setCustomPageNumber()\" translate>buttons.Set</button>\n              </div>\n              <div ng-hide=\"vm.setCustomPageNumberState.enabled\">\n                <input class=\"form-control\" id=\"gotopagequick\" ng-change=\"vm.gotoPagePicker.invalidPageNumber = false\" ng-model=\"vm.gotoPagePicker.pagenumber\" style=\"width: 110px; text-align: right\" swa-on-enter=\"vm.findAndGoToPageNoFromCustomPageNumber()\" swa-select-on-focus>\n                <button class=\"btn sw-btn-secondary width-60\" ng-click=\"vm.findAndGoToPageNoFromCustomPageNumber()\" translate>buttons.Go</button>\n              </div>\n              <div ng-show=\"vm.gotoPagePicker.invalidPageNumber\">\n                <span class=\"sw-color-red\" translate>messages.Invalid page number</span>\n              </div>\n              <div class=\"sw-goto-page-popup\">\n                <span class=\"subtitle\">Total Pages : {{vm.script.numberOfPages}}</span>\n              </div>\n              <div ng-show=\"vm.activeAccessRules.allowscriptediting && !vm.setCustomPageNumberState.enabled\" class=\"padding-top-10\">\n                <button class=\"btn sw-btn-secondary sw-btn-group-radio-2\" ng-click=\"vm.showEditCustomPageNumberMenu()\" type=\"button\">\n                {{\'buttons.Set Page Name\'| translate}}\n                </button>\n              </div>\n              <div ng-show=\"vm.activeAccessRules.allowscriptediting && !vm.setCustomPageNumberState.enabled\" class=\"padding-top-10\">\n                <button class=\"btn sw-btn-secondary sw-btn-group-radio-2\" ng-click=\"vm.makeCurrentPageFirst()\" type=\"button\">\n                {{\'buttons.Make this Page the first\'| translate}}\n                </button>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n        <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPage(\'next\')\" ng-disabled=\"(vm.script.numberOfPages === 0) || (vm.scriptEditorState.currentPageNumber === vm.scriptEditorState.totalNumberOfPages) || !vm.activeAccessRules.allowpagenavigation\" uib-tooltip=\"Open next page\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-next\"></span>\n        </button>\n      </div>\n      <div class=\"swtoolbar-group pull-right pl-0\">\n        <button id=\"menu-savechanges\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.onSaveClick()\" ng-disabled=\"!vm.script.dirty && !vm.script.dirtyPersonal && !vm.currentScriptPage.dirty && !vm.currentScriptPage.dirtyPersonal\" uib-tooltip=\"Save changes\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-save\"></span>\n        </button>\n        <button id=\"menu-createpdf\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.pdfOptionsPicker\" uib-tooltip=\"PDF / printing options\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-create-pdf\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable-alignment=\"right\" stackable-enable-escape=\"true\" stackable=\"vm.pdfOptionsPicker\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.Create PDF</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllChartsStaffs)\">\n                <span class=\"title\" translate>labels.Production - Charts &amp; Score</span>\n              </div>\n              <div class=\"menu-item\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0) || !vm.script\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllChartsScript)\">\n                <span class=\"title\" translate>labels.Production - Charts &amp; PDF</span>\n              </div>\n              <div class=\"menu-item\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllCharts)\">\n                <span class=\"title\" translate>labels.Production - Charts</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllStaffs)\">\n                <span class=\"title\" translate>labels.Production - Score</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 1)\" ng-disabled=\"!vm.script\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.Script)\">\n                <span class=\"title\" translate>labels.Production - PDF</span>\n              </div>\n            </div>\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneChartsStaffs)\">\n                <span class=\"title\" translate>labels.Current Scene - Charts &amp; Score</span>\n              </div>\n              <div class=\"menu-item\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneCharts)\">\n                <span class=\"title\" translate>labels.Current Scene - Charts</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneStaffs)\">\n                <span class=\"title\" translate>labels.Current Scene - Score</span>\n              </div>\n            </div>\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-disabled=\"!vm.selectedChart\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentChart)\">\n                <span class=\"title\" translate>labels.Current Chart</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedStaff\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentStaff)\">\n                <span class=\"title\" translate>labels.Current Score</span>\n              </div>\n            </div>\n            <div class=\"menu-group-title\">\n              <span translate>labels.Recent PDFs</span>\n            </div>\n            <div class=\"menu-group\" swa-print-job-list data-list=\"vm.printJobs\">\n            </div>\n          </div>\n        </stackable-popover>\n        <div id=\"menu-collaborators\" class=\"btn sw-btn-toolbar\" ng-show=\"vm.selectedProduction.collaborationsettings.length > 0\" uib-tooltip=\"Collaboration details\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span swa-show-collaborators data-production=\"vm.selectedProduction\" data-current-user-id=\"vm.userId\" class=\"sw-ionicon-2x ion-person-stalker\"></span>\n        </div>\n        <button id=\"menu-settings\" class=\"btn sw-btn-toolbar\" ui-sref=\"{{vm.swaRouterStateNames.productionsettings.details}}\" uib-tooltip=\"Production Settings\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-settings\"></span>\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"swtoolbar swtoolbar-lockmode\" ng-show=\"vm.scriptEditorState.lockModeNavigation\">\n    <div class=\"swtoolbar-group pull-left\">\n      <img class=\"sws-logo\" src=\"assets/images/sws-logo-light.png\">\n    </div>\n    <div class=\"swtoolbar-group pull-left\">\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.toggleLockModeNavigation()\" ng-class=\"{\'sw-active\': vm.scriptEditorState.lockModeNavigation}\" uib-tooltip=\"Toggle lock navigation mode\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-lock\"></span>\n      </button>\n      <button id=\"menu-switchview2\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.switchEditorView2\" uib-tooltip=\"Switch to other Views\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <!-- <span class=\"swafont swafont-lg swafont-icon-list\"></span> -->\n        <div class=\"sw-btn-toolbar-vcontent\">\n          <span class=\"title\">PDF</span>\n          <span class=\"sw-ionicon-fw ion-arrow-down-b icon\"></span>\n        </div>\n      </button>\n      <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.switchEditorView2\">\n        <div class=\"sw-popover-title\">\n          <span translate>titles.View</span>\n        </div>\n        <div class=\"sw-popover-menu\" role=\"menu\">\n          <div class=\"menu-group\">\n            <div class=\"menu-item\" ng-click=\"vm.switchEditor(0)\">\n              <span class=\"title\" translate>labels.Charts</span>\n            </div>\n            <div class=\"menu-item\" ng-disabled=\"true\">\n              <span class=\"title\" translate>labels.PDF</span>\n            </div>\n            <div class=\"menu-item\" ng-click=\"vm.switchEditor(4)\">\n              <span class=\"title\" translate>labels.Charts and PDF</span>\n            </div>\n          </div>\n        </div>\n      </stackable-popover>\n    </div>\n    <div class=\"swtoolbar-group pull-left\">\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPrevBookmark()\" ng-disabled=\"!vm.scriptEditorState.scriptAvailable\" uib-tooltip=\"Go to previous bookmark\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-previous\"></span>\n      </button>\n      <button class=\"btn sw-btn-toolbar\" id=\"menu-togglebookmarklist1\" ng-class=\"{\'sw-active\': vm.scriptEditorState.bookmarkListVisible}\" ng-show=\"!vm.scriptEditorState.bookmarkEditMode\" ng-click=\"vm.toggleBookmarkListVisibility()\" ng-disabled=\"!vm.scriptEditorState.scriptAvailable || vm.sidebarEditState.enabled\" uib-tooltip=\"Bookmarks list\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-bookmark\"></span>\n      </button>\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoNextBookmark()\" ng-disabled=\"!vm.scriptEditorState.scriptAvailable\" uib-tooltip=\"Go to next bookmark\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-next\"></span>\n      </button>\n    </div>\n    <div class=\"swtoolbar-group swtoolbar-group-centered\">\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPage(\'prev\')\" ng-disabled=\"(vm.script.numberOfPages === 0) || (vm.scriptEditorState.currentPageNumber === 1) || !vm.activeAccessRules.allowpagenavigation\" uib-tooltip=\"Open previous page\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-previous\"></span>\n      </button>\n      <button id=\"go-to-page1\" class=\"btn sw-btn-toolbar\" ng-disabled=\"(vm.script.numberOfPages === 0) || !vm.activeAccessRules.allowpagenavigation\" stackable-trigger=\"vm.gotoPagePicker1\">\n        <span ng-show=\"(vm.script.numberOfPages === 0)\" translate>labels.No Pages</span>\n        <span ng-show=\"(vm.script.numberOfPages > 0)\">\n          <span translate translate-values=\"{current: vm.scriptEditorState.currentPageNumber, total: vm.scriptEditorState.totalNumberOfPages}\">labels.Page_current_of_total</span>\n          <span class=\"sw-ionicon-fw ion-arrow-down-b\"></span>\n        </span>\n      </button>\n      <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.gotoPagePicker1\">\n        <div class=\"sw-popover-title\">\n          <span translate>titles.Go To Page</span>\n        </div>\n        <div class=\"sw-popover-content\">\n          <div class=\"sw-gotopage-picker-content form-inline sw-form-container text-center\">\n            <div>\n              <input class=\"form-control\" id=\"gotopagequick1\" max=\"{{vm.scriptEditorState.totalNumberOfPages}}\" maxlength=\"3\" min=\"1\" ng-change=\"vm.gotoPagePicker.invalidPageNumber = false\" ng-model=\"vm.gotoPagePicker.pagenumber\" style=\"width: 60px; text-align: right\" swa-on-enter=\"vm.gotoPageQuick()\" swa-select-on-focus type=\"number\">\n              <span class=\"sw-text-md sw-color-mediumlightgray mx-4\">/\n                {{vm.scriptEditorState.totalNumberOfPages}}</span>\n              <button class=\"btn sw-btn-secondary\" ng-click=\"vm.gotoPageQuick()\" translate>buttons.Go</button>\n            </div>\n            <div ng-show=\"vm.gotoPagePicker.invalidPageNumber\">\n              <span class=\"sw-color-red\" translate>messages.Invalid page number</span>\n            </div>\n          </div>\n        </div>\n      </stackable-popover>\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPage(\'next\')\" ng-disabled=\"(vm.script.numberOfPages === 0) || (vm.scriptEditorState.currentPageNumber === vm.scriptEditorState.totalNumberOfPages) || !vm.activeAccessRules.allowpagenavigation\" uib-tooltip=\"Open next page\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-next\"></span>\n      </button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <span class=\"swa-color-lightgray sw-text-lg\" translate>titles.PDF View</span>\n    </div>\n  </div>\n  <div>\n    <div class=\"sw-sketchpad-tools-container\" ng-if=\"vm.scriptEditorState.activeAnnotationType === 4\" ng-hide=\"!vm.scriptEditorState.pageLoaded || !vm.scriptEditorState.annotationsVisible || !vm.scriptEditorState.isShowHideAnnotations || vm.sidebarEditState.enabled\">\n      <span id=\"eraser-btn\" class=\"btn sw-btn-inspector sw-sketchpad-pencil\" ng-click=\"vm.toggleSelectionMode()\" ng-class=\"{\'active\': vm.scriptEditorState.selectionMode}\" uib-tooltip=\"Select Tool\" tooltip-placement=\"auto left\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-mouse-pointer\"></span>\n      </span>\n      <span class=\"btn sw-btn-inspector sw-sketchpad-pencil\" ng-click=\"vm.toggleSketchpadDrawingAnnotation()\" ng-class=\"{\'active\' : vm.scriptEditorState.startDrawing}\" uib-tooltip=\"Draw / Pen Tool\" tooltip-placement=\"auto left\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-sketch-pencil\"></span>\n      </span>\n      <span id=\"eraser-btn\" class=\"btn sw-btn-inspector sw-sketchpad-pencil\" ng-click=\"vm.toggleSketchpadEraserMode()\" ng-class=\"{\'active\': vm.scriptEditorState.startErasing}\" uib-tooltip=\"Erase Tool\" tooltip-placement=\"auto left\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-eraser\"></span>\n      </span>\n      <span class=\"sw-sketchpad-colorpicker\" ng-class=\"{\'disable-color-picker\' : !vm.scriptEditorState.startDrawing}\">\n        <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.scriptEditorState.selectedColor\" options=\"vm.colorPickerOption\" on-hide=\"vm.sketchpadColorChanged(color)\"></spectrum-colorpicker>\n      </span>\n      <span class=\"btn sw-btn-inspector sw-sketchpad-eraser\" ng-click=\"vm.clearSketchpad()\" uib-tooltip=\"Erase all markings\" tooltip-placement=\"auto left\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-trash-21\"></span>\n      </span>\n      <span class=\"btn\" uib-tooltip-html=\"vm.sketchToolTip\" tooltip-placement=\"auto left\" tooltip-popup-delay=\"1000\">\n        <span class=\"sw-ionicon sw-ionicon-fw sw-ionicon-lg ion-ios-help-outline\"></span>\n      </span>\n    </div>\n\n    <div ng-show=\"!vm.thumbnailBarState.rightSideBar\" id=\"sidebarOpenForRightSide\" class=\"swtoolbar-flex sidebar-option-for-right-side\" ng-mouseenter=\"vm.revealRightScriptpageThumbnailBar = true\" ng-mouseleave=\"vm.revealRightScriptpageThumbnailBar = false\" ng-class=\"{\'sidebar-option-for-right-side\': (vm.revealRightScriptpageThumbnailBar === false), \'sidebar-right-side-thumbimage\': (vm.revealRightScriptpageThumbnailBar === true)}\">\n      <div class=\"text-lg sw-color-red sw-truncatetext\" style=\"width: calc(100% - 50px)\" ng-show=\"vm.revealRightScriptpageThumbnailBar\">\n        <span>Script Pages</span>\n      </div>\n      <button class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.toggleRightSideBar()\">\n        <span class=\"ion-chevron-left\"></span>\n      </button>\n    </div>\n\n    <div ng-show=\"vm.thumbnailBarState.rightSideBar\" id=\"sidebarScriptPageThumbnails\" class=\"sw-sidebar-script-page-thumbnails\">\n      <div class=\"sw-navbar sw-navbar-top sw-color-red\">\n        <div class=\"swtoolbar\">\n          <button id=\"button-closeproduction-layer\" class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.toggleRightSideBar()\">\n            <span class=\"ion-chevron-right\"></span>\n          </button>\n          <div class=\"text-lg sw-truncatetext\" style=\"width: calc(100% - 50px)\">\n            <span>Script Pages</span>\n          </div>\n        </div>\n      </div>\n      <div ng-show=\"vm.scriptPages.length > 0\" class=\"layer-list-body-thumbnail\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\" ng-scrollbars-update=\"vm.scrollUpdateSidebar\">\n        <div class=\"sidebar-layer-row-thumbnail\" id=\"pageid-{{$index}}\" ng-repeat=\"page in vm.scriptPages\">\n          <div class=\"chart-thumb\" ng-click=\"vm.loadScriptPageFromIndex($index)\" ng-class=\"{\'selected-script-page\': vm.currentScriptPage.orderingindex === $index}\">\n            <div class=\"loader\" ng-show=\"vm.currentScriptPage.orderingindex === $index && vm.loadingThumbnail\"></div>\n            <img draggable=\"false\" class=\"script-thumb-img\" ng-src=\"data:image/png;base64,{{page.defaultThumbimage || \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=\'}}\">\n              <img draggable=\"false\" ng-show=\"vm.scriptEditorState.masterLayerActive\" class=\"script-thumb-img script-thumb-img-mark-ups\" ng-class=\"{\'top-2\': vm.currentScriptPage.orderingindex === $index}\" ng-src=\"data:image/png;base64,{{ page.markupThumbimage || \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAMAASsJTYQAAAAASUVORK5CYII=\' }}\">\n              <img draggable=\"false\" ng-show=\"vm.scriptEditorState.personalLayerActive\" class=\"script-thumb-img script-thumb-img-mark-ups\" ng-class=\"{\'top-2\': vm.currentScriptPage.orderingindex === $index}\" ng-src=\"data:image/png;base64,{{ page.markupThumbimagePersonal || \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAMAASsJTYQAAAAASUVORK5CYII=\' }}\">\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div ng-show=\"!vm.thumbnailBarState.bottomSideBar\" id=\"sidebarOpenForBottomSide\" class=\"swtoolbar-flex sidebar-option-for-bottom-side\" ng-mouseenter=\"vm.revealBottomScriptpageThumbnailBar = true\" ng-mouseleave=\"vm.revealBottomScriptpageThumbnailBar = false\" ng-class=\"{\'sidebar-option-for-bottom-side\': (vm.revealBottomScriptpageThumbnailBar === false), \'sidebar-bottom-side-thumbimage\': (vm.revealBottomScriptpageThumbnailBar === true)}\">\n      <button class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.toggleBottomSideBar()\">\n        <span class=\"ion-chevron-up\"></span>\n      </button>\n      <div class=\"text-lg sw-color-red sw-truncatetext\" style=\"width: calc(100% - 50px)\" ng-show=\"vm.revealBottomScriptpageThumbnailBar\">\n        <span>Script Pages</span>\n      </div>\n    </div>\n\n    <div ng-show=\"vm.thumbnailBarState.bottomSideBar\" id=\"bottombarScriptPageThumbnails\" class=\"sw-bottombar-script-page-thumbnails\">\n      <div class=\"sw-navbar sw-navbar-top sw-color-red\">\n        <div class=\"swtoolbar swtoolbar-flex swtoolbar-flex-align-center swtoolbar-justify-center\">\n          <button id=\"button-closeproduction-layer\" class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.toggleBottomSideBar()\">\n            <span class=\"ion-chevron-down\"></span>\n          </button>\n          <div class=\"text-lg sw-truncatetext\" style=\"width: calc(100% - 50px)\">\n            <span>Script Pages</span>\n          </div>\n        </div>\n      </div>\n      <div class=\"layer-list-bottom-thumb\" ng-scrollbars ng-scrollbars-config=\"vm.scrollHThumbs\" ng-scrollbars-update=\"vm.scrollUpdateBottombar\">\n        <div class=\"sidebar-layer-row-thumbnail\" id=\"pageid-h-{{$index}}\" ng-repeat=\"page in vm.scriptPages\" ng-class=\"{\'selected-script-page\': vm.currentScriptPage.orderingindex === $index}\">\n          <div class=\"chart-thumb sw-ionicon-stack\" ng-click=\"vm.loadScriptPageFromIndex($index)\">\n          <div class=\"loader\" ng-show=\"vm.currentScriptPage.orderingindex === $index && vm.loadingThumbnail\"></div>\n            <img draggable=\"false\" class=\"script-thumb-img\" ng-src=\"data:image/png;base64,{{page.defaultThumbimage || \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=\'}}\">\n              <img draggable=\"false\" ng-show=\"vm.scriptEditorState.masterLayerActive\" class=\"script-thumb-img script-thumb-img-mark-ups-bottom\" ng-src=\"data:image/png;base64,{{ page.markupThumbimage || \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAMAASsJTYQAAAAASUVORK5CYII=\' }}\">\n              <img draggable=\"false\" ng-show=\"vm.scriptEditorState.personalLayerActive\" class=\"script-thumb-img script-thumb-img-mark-ups-bottom\" ng-src=\"data:image/png;base64,{{ page.markupThumbimagePersonal || \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAMAASsJTYQAAAAASUVORK5CYII=\' }}\">\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"sw-sidebar sw-sidebar-bar-only\" ng-class=\"{\'sw-sidebar-left-hidden\': (vm.revealSidebar === false), \'sw-sidebar-left-visible\': (vm.revealSidebar === true)}\" ng-hide=\"vm.scriptEditorState.lockModeNavigation || (vm.scriptEditorState.pageLoaded && vm.scriptEditorState.annotationLayerListVisible)\">\n      <div class=\"sw-navbar sw-navbar-top sw-color-red\" ng-mouseenter=\"vm.revealSidebar = true\" ng-mouseleave=\"vm.revealSidebar = false\">\n        <div class=\"swtoolbar\">\n          <button class=\"btn btn-lg sw-btn-toolbar\" ng-show=\"vm.revealSidebar\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n          <div class=\"text-lg sw-truncatetext\" style=\"width: calc(100% - 50px)\">\n            <span>{{vm.selectedProduction.name}}</span>\n          </div>\n          <button id=\"button-closeproduction\" class=\"btn btn-lg sw-btn-toolbar\" ng-hide=\"vm.revealSidebar\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n        </div>\n      </div>\n    </div>\n\n    <div id=\"sidebar-annotationlayerlist\" class=\"sw-sidebar\" ng-class=\"{\'sw-sidebar-edit\': vm.sidebarEditState.enabled}\" ng-hide=\"vm.scriptEditorState.lockModeNavigation || vm.scriptEditorState.bookmarkListVisible || !vm.scriptEditorState.annotationLayerListVisible || !vm.scriptEditorState.pageLoaded\">\n\n      <div class=\"sw-navbar sw-navbar-top sw-color-red\">\n        <div class=\"swtoolbar\">\n          <button id=\"button-closeproduction-layer\" class=\"btn btn-lg sw-btn-toolbar\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n          <div class=\"text-lg sw-truncatetext\" style=\"width: calc(100% - 50px)\">\n            <span>{{vm.selectedProduction.name}}</span>\n          </div>\n        </div>\n      </div>\n\n      <!-- // SWA-1922 - New -->\n      <div class=\"layers-sidebar sw-sidebar-left\">\n        <!-- ng-class=\"{\'sw-sidebar-bookmark-lockmode\': vm.scriptEditorState.lockModeNavigation}\" -->\n        <div class=\"sidebar-layer-list\" ng-if=\"vm.scriptEditorState.scriptAvailable && vm.scriptEditorState.annotationLayerListVisible\">\n          <div class=\"panel panel-default mrgnbtm-1\">\n            <div class=\"panel-heading\">\n              <h4 class=\"panel-title coverStyleDiv\">\n                Layers\n              </h4>\n              <div class=\"pull-right\" id=\"edit-bookmark\" ng-hide=\"vm.sidebarEditState.enabled\">\n                <button class=\"btn btn-sm sw-btn-toolbar\" id=\"sidebar-scriptannotationlayersvisibility\" ng-class=\"{\'sw-active\': (vm.scriptEditorState.masterLayerActive && vm.scriptEditorState.annotationsVisible) || (vm.scriptEditorState.personalLayerActive && vm.scriptEditorState.annotationsVisiblePersonal)}\" ng-click=\"vm.toggleAnnotationVisibility()\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.activeAccessRules.allowtoggleannotation || vm.scriptEditorState.bookmarkEditMode\" uib-tooltip=\"Show / hide all layers\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                  <span class=\"swafont swafont-lg swafont-icon-eye\"></span>\n                </button>\n                <button id=\"sidebar-scriptannotationlayeradd\" class=\"btn btn-sm sw-btn-toolbar\" ng-click=\"vm.showAddAnnotationLayer()\" ng-show=\"vm.enableAddAnnotationLayer\" ng-disabled=\"vm.showAddAnnotationLayerStatus || !(vm.activeAccessRules.allowscriptediting || vm.activeAccessRules.allowpersonalnotes)\" uib-tooltip=\"Add new Layer\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                  <span class=\"ion-plus-round sw-ionicon sw-ionicon-lg\"></span>\n                </button>\n              </div>\n            </div>\n            <div class=\"panel-body layer-list-body\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\">\n              <div class=\"sidebar-layer-row\" id=\"annolayerid-{{$index}}\" ng-show=\"vm.activeAccessRules.allowpersonalnotes\" ng-class=\"{\'sw-cursor-not-allowed\': vm.sidebarEditState.enabled}\" ng-repeat=\"annotationlayer in vm.sharedannotationlayers\">\n                  <div class=\"title-block pull-left layer-name\">\n                      <span uib-tooltip=\"{{annotationlayer.name}}\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\" tooltip-class=\"layer-name-tooltip\">{{annotationlayer.name}}\n                      </span>\n                  </div>\n                  <div class=\"pull-right\" ng-show=\"!vm.sidebarEditState.enabled\">\n                      <button class=\"btn btn-sm sw-btn-toolbar\" id=\"\" ng-class=\"{\'sw-active\': annotationlayer.isVisibleToCollaborators}\" ng-click=\"$event.stopPropagation();vm.toggleAnnotationVisibilityForSharedLayer(annotationlayer.layerid)\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.activeAccessRules.allowtoggleannotation || vm.scriptEditorState.bookmarkEditMode || !vm.scriptEditorState.annotationsVisible || !vm.scriptEditorState.annotationsVisiblePersonal\" uib-tooltip=\"Show / hide layer\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                        <span class=\"swafont swafont-lg swafont-icon-eye\"></span>\n                      </button>\n                      <span class=\"btn btn-sm sw-sidebar-shared-icon cursor-default ion-person\" uib-tooltip=\"Shared Layer\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\"></span>\n                  </div>\n              </div>\n              <div ng-cloak ui-sortable=\"vm.sidebarSortableOptions\" ng-model=\"vm.annotationlayers\">\n                <div class=\"sidebar-layer-row\" id=\"annolayerid-{{$index}}\" ng-repeat=\"annotationlayer in vm.annotationlayers\">\n\n                  <div class=\"swtoolbar-flex\" style=\"height: 100%; align-items: center\" ng-show=\"vm.inlineEditIndex === $index\">\n                    <input class=\"form-control\" id=\"editlayername_{{$index}}\" ng-enter=\"vm.onUpdateLayerName(annotationlayer)\" ng-model=\"annotationlayer.newAnnotationLayerName\" type=\"text\">\n                    <button class=\"btn btn-sm sw-btn-toolbar sw-active\" ng-click=\"$event.stopPropagation();vm.onUpdateLayerName(annotationlayer)\">\n                      <span class=\"ion-checkmark-round sw-ionicon-lg\"></span>\n                    </button>\n                    <button class=\"btn btn-sm sw-btn-toolbar sw-active\" ng-click=\"vm.showHideEditAnnotationLayer()\">\n                      <span class=\"ion-close-round sw-ionicon-lg\"></span>\n                    </button>\n                  </div>\n\n                  <div class=\"script-checkbox-block\" ng-show=\"vm.sidebarEditState.enabled\">\n                    <button class=\"btn sw-btn-toolbar\" id=\"sidebar-delete_{{$index}}\" ng-click=\"$event.stopPropagation();vm.deleteAnnotationLayerPrompt(annotationlayer)\" style=\"cursor: pointer\">\n                      <span class=\"sw-ionicon-lg ion-ios-close-outline\"></span>\n                    </button>\n                  </div>\n\n                  <div id=\"sidebar-layername_{{$index}}_{{!vm.sidebarEditState.enabled}}\" class=\"title sw-truncatetext\" ng-class=\"{\'mrgnLeft35\': vm.sidebarEditState.enabled}\" ng-click=\"vm.selectAnnotationLayer(annotationlayer);\" ng-dblclick=\"!vm.sidebarEditState.enabled && vm.onDoubleClick($index)\">\n\n                    <div class=\"title-block pull-left layer-name\">\n                      <span ng-class=\"{\'sw-color-red\': (annotationlayer.layerid === vm.scriptEditorState.currentAnnotationLayerId) && !vm.sidebarEditState.enabled}\" ng-hide=\"vm.inlineEditIndex === $index\" uib-tooltip=\"{{annotationlayer.name}}\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\" tooltip-class=\"layer-name-tooltip\">{{annotationlayer.name}}\n                      </span>\n                      <!-- <input class=\"form-control\" id=\"editlayername_{{$index}}\" ng-enter=\"vm.onUpdateLayerName(annotationlayer)\" ng-model=\"annotationlayer.newAnnotationLayerName\" ng-show=\"vm.inlineEditIndex === $index\" type=\"text\"/>     -->\n                    </div>\n\n                    <!--swtoolbar-group -->\n                    <div class=\"pull-right\" ng-show=\"!vm.sidebarEditState.enabled && vm.inlineEditIndex !== $index\">\n                      <button class=\"btn btn-sm sw-btn-toolbar\" id=\"sidebar-scriptannotationlayervisibility_{{$index}}\" ng-class=\"{\'sw-active\': annotationlayer.isvisible}\" ng-click=\"$event.stopPropagation();vm.toggleAnnotationVisibilityForLayer(annotationlayer.layerid)\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.activeAccessRules.allowtoggleannotation || vm.scriptEditorState.bookmarkEditMode || !vm.scriptEditorState.annotationsVisible || !vm.scriptEditorState.annotationsVisiblePersonal\" uib-tooltip=\"Show / hide layer\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                        <span class=\"swafont swafont-lg swafont-icon-eye\"></span>\n                      </button>\n                      <button class=\"btn btn-sm sw-btn-toolbar\" id=\"sidebar-scriptannotationlayersettings_{{$index}}\" ng-class=\"{\'sw-active\': (vm.scriptEditorState.masterLayerActive && vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(annotationlayer.layerid) == -1 ) || (vm.scriptEditorState.personalLayerActive && vm.scriptEditorState.annotationsVisiblePersonal)}\" ng-click=\"$event.stopPropagation();vm.updateAnnotationLayerPrompt(annotationlayer)\" ng-disabled=\"!vm.scriptEditorState.pageLoaded || !vm.activeAccessRules.allowtoggleannotation || vm.scriptEditorState.bookmarkEditMode || !(vm.activeAccessRules.allowscriptediting || vm.activeAccessRules.allowpersonalnotes)\" uib-tooltip=\"Layer Settings\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n                        <div>&#xFE19;</div>\n                      </button>\n                    </div>\n                  </div>\n                  <div class=\"script-dragger-block\" ng-show=\"vm.sidebarEditState.enabled\">\n                    <span id=\"sidebar-move_{{$index}}\" class=\"sortDragHandle sw-ionicon-fw sw-ionicon-lg ion-drag\" style=\"cursor: ns-resize\"></span>\n                  </div>\n                </div>\n              </div>\n\n              <!-- Add New Layer-->\n              <div ng-show=\"vm.enableAddAnnotationLayer && vm.showAddAnnotationLayerStatus\" class=\"sidebar-layer-row\" id=\"new-annolayerid\">\n                <div class=\"swtoolbar-flex\" style=\"height: 100%; align-items: center\">\n                  <input class=\"form-control\" id=\"newAnnoLayer\" ng-enter=\"vm.addNewAnnotationLayer()\" ng-model=\"vm.newAnnotationLayerName\" placeholder=\"Enter New Layer\" type=\"text\">\n                  <!-- ng-blur=\"vm.showAddAnnotationLayer()\" -->\n\n                  <button class=\"btn btn-sm sw-btn-toolbar\" ng-click=\"vm.addNewAnnotationLayer()\">\n                    <span class=\"ion-checkmark-round sw-ionicon sw-ionicon-lg\"></span>\n                  </button>\n                  <button class=\"btn btn-sm sw-btn-toolbar\" ng-click=\"vm.showAddAnnotationLayer()\">\n                    <span class=\"ion-close-round sw-ionicon sw-ionicon-lg\"></span>\n                  </button>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"sw-navbar sw-navbar-bottom\" ng-hide=\"vm.scriptEditorState.bookmarkListVisible\">\n        <div class=\"swtoolbar text-center\" ng-show=\"vm.sidebarEditState.enabled\">\n          <button id=\"sidebar-done\" class=\"btn sw-btn-default\" ng-click=\"vm.toggleSidebarEditMode()\" translate>buttons.Done</button>\n        </div>\n        <div class=\"swtoolbar text-center\" ng-hide=\"vm.sidebarEditState.enabled\">\n          <button id=\"sidebar-movedelete\" class=\"btn sw-btn-secondary\" ng-click=\"vm.toggleSidebarEditMode()\" ng-disabled=\"!vm.annotationlayers.length || !(vm.activeAccessRules.allowscriptediting || vm.activeAccessRules.allowpersonalnotes)\" translate>buttons.Move / Delete\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"scrollcontainer sw-sidebar-bookmark\" ng-class=\"{\'sw-sidebar-bookmark-lockmode\': vm.scriptEditorState.lockModeNavigation}\">\n    <div class=\"sidebar-bookmark-list\" ng-if=\"vm.scriptEditorState.bookmarkListVisible\">\n      <div class=\"panel panel-default mrgnbtm-1\">\n        <div class=\"panel-heading\">\n          <h4 class=\"panel-title coverStyleDiv\" translate>\n            titles.Bookmarks\n          </h4>\n          <div class=\"swtoolbar-group pull-right\" id=\"edit-bookmark\">\n            <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.beginBookmarkEditing()\" ng-disabled=\"!vm.activeAccessRules.allowscriptediting\" ng-hide=\"vm.scriptEditorState.lockModeNavigation\">\n              <span>Edit</span>\n            </button>\n          </div>\n        </div>\n        <div class=\"panel-body sw-sidebar-bookmark-scroll\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\">\n          <div class=\"sidebar-bookmark-row\" ng-repeat=\"bookmark in vm.bookmarks | orderBy: [\'scriptPageNo\', \'topOffset\']\" ng-click=\"vm.gotoBookmark(bookmark)\">\n            <div class=\"title sw-truncatetext\">\n              <span>{{bookmark.name}}</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div id=\"annotationStyleOptionsMenu\" ng-show=\"vm.selectedAnnotation\">\n    <div class=\"sw-chart-modal annotation-toolbar-modal\">\n      <div class=\"sw-popover-menu annotation-toolbar\" role=\"menu\">\n        <div class=\"menu-group\">\n          <div class=\"swtoolbar-flex\" ng-show=\"vm.selectedAnnotation.annotationtype === 1\">\n            <div id=\"chart-performer-scaling-mode\" class=\"btn-group btn-group-btn script-cue-style-radio-btn\">\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.selectedAnnotation.markerStyle === false}\" ng-click=\"vm.changeAnnotationStyle(\'box\')\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.selectedAnnotation.markerStyle === false,\n                                  \'ion-android-radio-button-off\': vm.selectedAnnotation.markerStyle === true}\"></span>\n                {{\'buttons.Box\'| translate}}\n              </button>\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.selectedAnnotation.markerStyle === true}\" ng-click=\"vm.changeAnnotationStyle(\'marker\')\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.selectedAnnotation.markerStyle === true,\n                                  \'ion-android-radio-button-off\': vm.selectedAnnotation.markerStyle === false}\"></span>\n                {{\'buttons.Marker\'| translate}}\n              </button>\n            </div>\n          </div>\n          <div class=\"swtoolbar-flex\" ng-show=\"vm.selectedAnnotation.annotationtype === 1\">\n            <div id=\"chart-performer-scaling-mode\" class=\"btn-group btn-group-btn script-cue-style-radio-btn\">\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.selectedAnnotation.connectingLineTop === false}\" ng-click=\"vm.changeAnnotationConnectingLineStyle(\'bottom\')\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.selectedAnnotation.connectingLineTop === false,\n                                  \'ion-android-radio-button-off\': vm.selectedAnnotation.connectingLineTop === true}\"></span>\n                {{\'buttons.Bottom\'| translate}}\n              </button>\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn\" ng-class=\"{\'checked\': vm.selectedAnnotation.connectingLineTop === true}\" ng-click=\"vm.changeAnnotationConnectingLineStyle(\'top\')\" type=\"button\">\n                <span class=\"sw-ionicon-fw sw-ionicon-lg\" ng-class=\"{\'ion-android-radio-button-on\': vm.selectedAnnotation.connectingLineTop === true,\n                                  \'ion-android-radio-button-off\': vm.selectedAnnotation.connectingLineTop === false}\"></span>\n                {{\'buttons.Top\'| translate}}\n              </button>\n            </div>\n          </div>\n          <div class=\"line-thickness-btns-script\" ng-show=\"vm.selectedAnnotation.annotationtype === 1\">\n            <div class=\"plus-minus-icons script-annotation-style-menu\">\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn script-annotation-toolbar-btns width-30\" ng-click=\"vm.decreaseAnnotationLineThickness()\" type=\"button\">\n                      <span class=\"swafont swafont-lg swafont-icon-minus\"></span>\n              </button>\n              <span class=\"line-thickness-count\">{{vm.selectedAnnotation.annotationBorderThickness}} Px</span>\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn script-annotation-toolbar-btns width-30\" ng-click=\"vm.increaseAnnotationLineThickness()\" type=\"button\">\n                      <span class=\"swafont swafont-lg swafont-icon-plus\"></span>\n              </button>\n            </div>\n          </div>\n          <div class=\"sub-settings left\" ng-show=\"vm.selectedAnnotation.annotationtype === 1 && !vm.selectedAnnotation.markerStyle\">\n            <span class=\"sub-settings-icon sw-ionicon ion-paintbucket left selector\"></span>\n            <div class=\"clr bg-container left clickable checkerboard-bk\">\n              <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.scriptEditorState.backgroundColorForAnchor\" options=\"vm.colorPickerOption\" on-hide=\"vm.anchorBackgroundColorChanged(color)\"></spectrum-colorpicker>\n            </div>\n          </div>\n          <div class=\"sub-settings left\" ng-show=\"vm.selectedAnnotation.annotationtype === 1\">\n            <span class=\"sub-settings-icon left selector sw-ionicon ion-brush\"></span>\n            <div class=\"clr fg-container left clickable\">\n              <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.scriptEditorState.borderColorForAnchor\" options=\"vm.colorPickerOption\" on-hide=\"vm.anchorBorderColorChanged(color)\"></spectrum-colorpicker>\n            </div>\n          </div>\n          <div class=\"sub-settings left\" ng-show=\"vm.selectedAnnotation.annotationtype === 3\">\n            <span class=\"sub-settings-icon left selector sw-ionicon ion-brush\"></span>\n            <div class=\"clr fg-container left clickable\">\n              <spectrum-colorpicker format=\"\'rgb\'\" ng-model=\"vm.scriptEditorState.highlightColor\" options=\"vm.colorPickerOption\" on-hide=\"vm.highlightColorChanged(color)\"></spectrum-colorpicker>\n            </div>\n          </div>\n          <div class=\"line-thickness-btns-script\">\n            <div class=\"plus-minus-icons script-annotation-style-menu\">\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn script-annotation-toolbar-btns width-30 margin-right-5\" ng-click=\"vm.moveToOtherSide()\" type=\"button\" ng-show=\"vm.selectedAnnotation.side === \'right\'\">\n                      <span class=\"swafont swafont-lg ion-arrow-left-c\"></span>\n              </button>\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn script-annotation-toolbar-btns width-30 margin-right-5\" ng-click=\"vm.moveToOtherSide()\" type=\"button\" ng-show=\"vm.selectedAnnotation.side === \'left\'\">\n                      <span class=\"swafont swafont-lg ion-arrow-right-c\"></span>\n              </button>\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn script-annotation-toolbar-btns width-30 margin-right-5\" ng-click=\"vm.snapToGridAnnotation()\" type=\"button\" ng-show=\"vm.selectedAnnotation.annotationtype === 1\">\n                      <span class=\"swafont swafont-lg swafont-icon-bottom_aligin\"></span>\n              </button>\n              <button class=\"btn sw-btn-radio performer-scaling-float-radio-btn script-annotation-toolbar-btns width-30\" ng-click=\"vm.deleteAnnotation()\" type=\"button\">\n                      <span class=\"sw-ionicon sw-ionicon-lg ion-ios-trash-outline\" style=\"color: #f82c5b\"></span>\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div id=\"swMaincontentAreaScript\" class=\"sw-maincontentarea-script sw-editorcontent text-center\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigContent\">\n    <div id=\"swScriptPageviewContainer\" oncontextmenu=\"return false\" class=\"sw-script-pageview-container\" ng-hide=\"vm.scriptEditorState.isImporting || !vm.scriptEditorState.pageLoaded\">\n      <div id=\"lockedOrStalkerIcon\" class=\"clickthrough\" style=\"position:absolute; top: 0; right: 0\" ng-if=\"!vm.activeAccessRules.allowowneraccess\">\n        <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-person-stalker\': vm.activeAccessRules.allowscriptediting, \'ion-locked\': !vm.activeAccessRules.allowscriptediting}\"></span>\n      </div>\n      <div id=\"swaScriptPageContent\" class=\"swa-script-page-content\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\">\n        <img id=\"scriptPageImage\" class=\"swa-script-page-image\" ng-hide=\"vm.scriptEditorState.pageLoadError || vm.scriptEditorState.pageImageLoadError\" ng-src=\"{{vm.currentScriptPage.pageImageSrc}}\">\n      </div>\n      <div class=\"swa-script-page-annotations swa-script-global\" ng-class=\"{\'clickthrough\': !vm.scriptEditorState.masterLayerActive || !vm.activeAccessRules.allowscriptediting || !vm.scriptEditorState.isShowHideAnnotations}\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(annotationlayer.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\" ng-mousedown=\"vm.onScriptContentMouseDown($event)\" ng-mousemove=\"vm.onScriptContentMouseMove($event)\" ng-mouseup=\"vm.onScriptContentMouseUp($event)\">\n        <div class=\"swa-script-side-annotations-container left\">\n          <div class=\"swa-script-annotation\" ng-class=\"{\'active\': (vm.scriptEditorState.activeLeftAnnotationOrderingIndex === $index), \'action-type\': (lAnnotation.annotationtype === 0), \'lightcue-type\': (lAnnotation.annotationtype === 1), \'clickthrough\': (!vm.scriptEditorState.masterLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation) || !vm.scriptEditorState.enableTextAnnotations}\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\" ng-click=\"vm.selectLeftAnnotation($index);$event.stopPropagation()\" ng-repeat=\"lAnnotation in vm.currentScriptPage.leftannotations\" ng-style=\"{left: lAnnotation.positionrect.left+\'px\', top: lAnnotation.positionrect.top+\'px\', height: lAnnotation.positionrect.height+\'px\', width: lAnnotation.positionrect.width+\'px\', \'background-color\': lAnnotation.backgroundColorCss, \'border-style\': \'none\'}\" swa-draggable swa-draggable-on-end=\"vm.leftAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass:\'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.leftAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 64, minHeight: 24, handleClass: \'resize-handle-circle\'}\" id=\"swa-script-annotation-left-{{$index}}\">\n            <div id=\"mce-editor-left-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"lAnnotation\" data-on-change=\"vm.markCurrentScriptPageDirty()\" data-swa-script-editor=\"vm\">\n            </div>\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n        </div>\n        <div class=\"swa-script-side-annotations-container right\">\n          <div class=\"swa-script-annotation\" ng-class=\"{\'active\': (vm.scriptEditorState.activeRightAnnotationOrderingIndex === $index), \'action-type\': (rAnnotation.annotationtype === 0), \'lightcue-type\': (rAnnotation.annotationtype === 1), \'clickthrough\': (!vm.scriptEditorState.masterLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation) || !vm.scriptEditorState.enableTextAnnotations}\" ng-click=\"vm.selectRightAnnotation($index);$event.stopPropagation()\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"rAnnotation in vm.currentScriptPage.rightannotations\" ng-style=\"{left: rAnnotation.positionrect.left+\'px\', top: rAnnotation.positionrect.top+\'px\', height: rAnnotation.positionrect.height+\'px\', width: rAnnotation.positionrect.width+\'px\', \'background-color\': rAnnotation.backgroundColorCss, \'border-style\': \'none\'}\" swa-draggable swa-draggable-on-end=\"vm.rightAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.rightAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 64, minHeight: 24, handleClass: \'resize-handle-circle\'}\" id=\"swa-script-annotation-right-{{$index}}\">\n            <div id=\"mce-editor-right-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"rAnnotation\" data-on-change=\"vm.markCurrentScriptPageDirty()\" data-swa-script-editor=\"vm\">\n            </div>\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n        </div>\n        <div class=\"swa-script-annotation-selections-container\">\n          <div class=\"swa-script-annotation-selection\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"lAnnotation in vm.currentScriptPage.leftannotations\" ng-style=\"{left: lAnnotation.selectionrect.left+\'px\', top: lAnnotation.selectionrect.top+\'px\', width: lAnnotation.selectionrect.width+\'px\', height: lAnnotation.selectionrect.height+\'px\',\n            \'background-color\': lAnnotation.markerStyle ? \'\' : lAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\" ng-class=\"{\'active\': (vm.scriptEditorState.activeLeftAnnotationOrderingIndex === $index)}\" swa-draggable swa-draggable-on-end=\"vm.leftAnnotationSelectionMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.leftAnnotationSelectionResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 16, minHeight: 16, handleClass: \'resize-handle-circle\'}\">\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n          <div class=\"swa-script-annotation-selection\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"rAnnotation in vm.currentScriptPage.rightannotations\" ng-style=\"{left: rAnnotation.selectionrect.left+\'px\', top: rAnnotation.selectionrect.top+\'px\', width: rAnnotation.selectionrect.width+\'px\', height: rAnnotation.selectionrect.height+\'px\',\n            \'background-color\': rAnnotation.markerStyle ? \'\' : rAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\" ng-class=\"{\'active\': (vm.scriptEditorState.activeRightAnnotationOrderingIndex === $index)}\" swa-draggable swa-draggable-on-end=\"vm.rightAnnotationSelectionMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.rightAnnotationSelectionResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 16, minHeight: 16, handleClass: \'resize-handle-circle\'}\">\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n          <svg class=\"swa-script-annotation-lines-container\">\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeLeftAnnotationOrderingIndex === $index}\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotations\">\n              <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n              </line>\n            </g>\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeRightAnnotationOrderingIndex === $index}\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotations\">\n              <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n              </line>\n            </g>\n            <!-- left annotations anchor box -->\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeLeftAnnotationOrderingIndex === $index}\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotations\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <!-- right annotations anchor box -->\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeRightAnnotationOrderingIndex === $index}\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotations\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <!-- left annotations text box -->\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeLeftAnnotationOrderingIndex === $index}\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotations\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <!-- right annotations text box -->\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeRightAnnotationOrderingIndex === $index}\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotations\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n          </svg>\n        </div>\n        <div class=\"swa-script-floating-annotations-container\">\n          <div class=\"swa-script-annotation floating-type\" ng-class=\"{\'active\': vm.scriptEditorState.activeFloatingAnnotationOrderingIndex === $index, \'clickthrough\': (!vm.scriptEditorState.masterLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation) || !vm.scriptEditorState.enableTextAnnotations}\" ng-show=\"vm.scriptEditorState.annotationsVisible && vm.hiddenAnnotationLayersList.indexOf(fAnnotation.layerid) == -1 && !vm.activeAccessRules.allowpersonalnotes\" ng-click=\"vm.selectFloatingAnnotation($index);$event.stopPropagation();\" ng-repeat=\"fAnnotation in vm.currentScriptPage.floatingannotations\" ng-style=\"{top: fAnnotation.positionrect.top+\'px\', left: fAnnotation.positionrect.left+\'px\', width: fAnnotation.positionrect.width+\'px\', height: fAnnotation.positionrect.height+\'px\', \'background-color\': fAnnotation.backgroundColorCss}\" swa-draggable swa-draggable-on-end=\"vm.floatingAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', handleClass: \'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.floatingAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', minWidth: 64, minHeight: 24, handleClass: \'resize-handle-circle\'}\">\n            <div id=\"mce-editor-text-annotation-{{$index}}\" class=\"content text-type\" swa-annotation-editor data-swa-annotation=\"fAnnotation\" data-on-change=\"vm.markCurrentScriptPageDirty()\">\n            </div>\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n        </div>\n        <div class=\"swa-script-highlight-annotations-container\">\n          <div class=\"swa-script-annotation highlight-type\" ng-class=\"{\'active\': vm.scriptEditorState.activeHighlightAnnotationOrderingIndex === $index, \'clickthrough\': (!vm.scriptEditorState.masterLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation) || (vm.scriptEditorState.activeAnnotationType !== mAnnotation.annotationtype)}\" ng-click=\"vm.selectHighlightAnnotation($index);$event.stopPropagation();\" ng-show=\"(vm.scriptEditorState.annotationsVisible && (vm.hiddenAnnotationLayersList.indexOf(mAnnotation.layerid) == -1) && !vm.activeAccessRules.allowpersonalnotes)\" ng-repeat=\"mAnnotation in vm.currentScriptPage.highlightannotations\" ng-style=\"{top: mAnnotation.positionrect.top+\'px\', left: mAnnotation.positionrect.left+\'px\', width: mAnnotation.positionrect.width+\'px\', height: mAnnotation.positionrect.height+\'px\', \'background-color\': mAnnotation.backgroundColorCss}\" swa-draggable swa-draggable-on-end=\"vm.highlightAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', handleClass: \'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.highlightAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', minWidth: 64, minHeight: 24, handleClass: \'resize-handle-circle\'}\">\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n        </div>\n        <div class=\"swa-script-annotationpopover-container\">\n          <div class=\"swa-script-annotationpopover-anchor swa-script-annotationpopover-anchor-global\" ng-show=\"vm.newSideAnnotationTracker.isTracking || vm.newSideAnnotationTracker.shouldAdd\" ng-class=\"[{\'invalid\': !vm.newSideAnnotationTracker.valid}, \'swa-scriptannotation-annotationtype-\' + vm.newSideAnnotationTracker.activeAnnotationType]\" stackable-trigger=\"vm.addSideAnnotationView\" ng-style=\"{top: vm.newSideAnnotationTracker.selectionrect.top+\'px\', left: vm.newSideAnnotationTracker.selectionrect.left+\'px\', width: vm.newSideAnnotationTracker.selectionrect.width+\'px\', height: vm.newSideAnnotationTracker.selectionrect.height+\'px\'}\">\n          </div>\n          <stackable-popover class=\"swa-popover-script-side-annotation\" stackable-placement=\"{{vm.newSideAnnotationTracker.popoverplacement}}\" stackable=\"vm.addSideAnnotationView\">\n            <div class=\"btn-group\">\n              <button class=\"btn btn-sm sw-btn-secondary pull-left\" ng-click=\"vm.addSideAnnotation(\'left\')\">\n                <span class=\"sw-ionicon ion-chevron-left\"></span>\n                <span translate>buttons.Left</span>\n              </button>\n              <span class=\"btn btn-sm sw-btn-secondary-label\" ng-show=\"vm.scriptEditorState.activeAnnotationType === 1\" translate>labels.Add Q</span>\n              <button class=\"btn btn-sm sw-btn-secondary pull-right\" ng-click=\"vm.addSideAnnotation(\'right\')\">\n                <span translate>buttons.Right</span>\n                <span class=\"sw-ionicon ion-chevron-right\"></span>\n              </button>\n            </div>\n          </stackable-popover>\n        </div>\n        <div class=\"swa-script-sketchpad-container swa-script-sketchpad\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== 4}\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\" ng-mouseup=\"vm.onScriptContentMouseUp($event); $event.stopPropagation();\" ng-show=\"vm.scriptEditorState.enableSketchpadDrawing\">\n          <div class=\"swa-script-sketchpad-annotations-container\">\n            <div id=\"sketchpad\"></div>\n          </div>\n          <div class=\"swa-script-sketchpad-annotations-container-individual-shape\" ng-if=\"!vm.scriptEditorState.startDrawing && !vm.scriptEditorState.startErasing && vm.scriptEditorState.selectionMode\" ng-style=\"{position: !vm.scriptEditorState.startDrawing ? \'absolute\' : \'inherit\'}\" ng-click=\"vm.resetSelectedShape()\">\n            <div ng-repeat=\"shapepath in vm.currentScriptPage.shapepaths\" class=\"shapepathpoints swa-freehand\" ng-click=\"vm.selectShape($index); $event.stopPropagation(); \" ng-class=\"{selectedShape: $index === vm.scriptEditorState.selectedShapeIndex}\" ng-style=\"{left: shapepath.bounds.x +\'px\', top: shapepath.bounds.y +\'px\', height: shapepath.bounds.height +\'px\', width: shapepath.bounds.width +\'px\'}\">\n              <div class=\"handle\" ng-show=\"$index === vm.scriptEditorState.selectedShapeIndex ? true : false\" ng-click=\"vm.deleteSelectedSketch()\">\n                <span class=\"sw-ionicon ion-close-round\"></span>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div class=\"swa-script-page-annotations swa-script-personal\" ng-class=\"{\'clickthrough\': !vm.scriptEditorState.personalLayerActive || !vm.scriptEditorState.isShowHideAnnotations}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.activeAccessRules.allowpersonalnotes\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\" ng-mousedown=\"vm.onScriptContentMouseDown($event)\" ng-mousemove=\"vm.onScriptContentMouseMove($event)\" ng-mouseup=\"vm.onScriptContentMouseUp($event)\">\n        <div class=\"swa-script-side-annotations-container left\">\n          <div class=\"swa-script-annotation\" ng-click=\"$event.stopPropagation();$event.preventDefault()\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-repeat=\"lAnnotation in vm.ownerScriptPage.leftannotations\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenSharedAnnotationLayersList.indexOf(lAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-style=\"{left: lAnnotation.positionrect.left+\'px\', top: lAnnotation.positionrect.top+\'px\', height: lAnnotation.positionrect.height+\'px\', width: lAnnotation.positionrect.width+\'px\', \'background-color\': lAnnotation.backgroundColorCss, \'border-style\': \'none\'}\">\n            <div id=\"mce-editor-leftp-shared-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"lAnnotation\" data-swa-script-editor=\"vm\">\n            </div>\n          </div>\n          <div ng-class=\"{\'active\': (vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === $index), \'action-type\': (lAnnotation.annotationtype === 0), \'lightcue-type\': (lAnnotation.annotationtype === 1), \'clickthrough\': (!vm.scriptEditorState.personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation) || !vm.scriptEditorState.enableTextAnnotations}\" class=\"swa-script-annotation\" ng-click=\"vm.selectLeftAnnotation($index);$event.stopPropagation()\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"lAnnotation in vm.currentScriptPage.leftannotationsPersonal\" ng-style=\"{left: lAnnotation.positionrect.left+\'px\', top: lAnnotation.positionrect.top+\'px\', height: lAnnotation.positionrect.height+\'px\', width: lAnnotation.positionrect.width+\'px\', \'background-color\': lAnnotation.backgroundColorCss, \'border-style\': \'none\'}\" swa-draggable swa-draggable-on-end=\"vm.leftAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass:\'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.leftAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 64, minHeight: 24, handleClass: \'resize-handle-circle\'}\" id=\"swa-script-annotation-left-personal-{{$index}}\">\n            <div id=\"mce-editor-leftp-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"lAnnotation\" data-on-change=\"vm.markCurrentScriptPageDirty()\" data-swa-script-editor=\"vm\">\n            </div>\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n        </div>\n        <div class=\"swa-script-side-annotations-container right\">\n          <div class=\"swa-script-annotation\" ng-click=\"$event.stopPropagation();$event.preventDefault()\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-repeat=\"rAnnotation in vm.ownerScriptPage.rightannotations\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenSharedAnnotationLayersList.indexOf(rAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-style=\"{left: rAnnotation.positionrect.left+\'px\', top: rAnnotation.positionrect.top+\'px\', height: rAnnotation.positionrect.height+\'px\', width: rAnnotation.positionrect.width+\'px\', \'background-color\': rAnnotation.backgroundColorCss, \'border-style\': \'none\'}\">\n            <div id=\"mce-editor-rightp-shared-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"rAnnotation\" data-swa-script-editor=\"vm\">\n            </div>\n          </div>\n          <div class=\"swa-script-annotation\" ng-class=\"{\'active\': (vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === $index), \'action-type\': (rAnnotation.annotationtype === 0), \'lightcue-type\': (rAnnotation.annotationtype === 1), \'clickthrough\': (!vm.scriptEditorState.personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation) || !vm.scriptEditorState.enableTextAnnotations}\" ng-click=\"vm.selectRightAnnotation($index);$event.stopPropagation()\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"rAnnotation in vm.currentScriptPage.rightannotationsPersonal\" ng-style=\"{left: rAnnotation.positionrect.left+\'px\', top: rAnnotation.positionrect.top+\'px\', height: rAnnotation.positionrect.height+\'px\', width: rAnnotation.positionrect.width+\'px\', \'background-color\': rAnnotation.backgroundColorCss, \'border-style\': \'none\'}\" swa-draggable swa-draggable-on-end=\"vm.rightAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.rightAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 64, minHeight: 24, handleClass: \'resize-handle-circle\'}\" id=\"swa-script-annotation-right-personal-{{$index}}\">\n            <div id=\"mce-editor-rightp-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"rAnnotation\" data-on-change=\"vm.markCurrentScriptPageDirty()\" data-swa-script-editor=\"vm\">\n            </div>\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n        </div>\n        <div class=\"swa-script-annotation-selections-container\">\n          <div class=\"swa-script-annotation-selection\" ng-click=\"$event.stopPropagation();$event.preventDefault()\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-repeat=\"lAnnotation in vm.ownerScriptPage.leftannotations\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenSharedAnnotationLayersList.indexOf(lAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-style=\"{left: lAnnotation.selectionrect.left+\'px\', top: lAnnotation.selectionrect.top+\'px\', width: lAnnotation.selectionrect.width+\'px\', height: lAnnotation.selectionrect.height+\'px\',\n            \'background-color\': lAnnotation.markerStyle ? \'\' : lAnnotation.backgroundColorCssForAnchor,\'border-style\': \'none\'}\">\n          </div>\n          <div class=\"swa-script-annotation-selection\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"lAnnotation in vm.currentScriptPage.leftannotationsPersonal\" ng-style=\"{left: lAnnotation.selectionrect.left+\'px\', top: lAnnotation.selectionrect.top+\'px\', width: lAnnotation.selectionrect.width+\'px\', height: lAnnotation.selectionrect.height+\'px\',\n            \'background-color\': lAnnotation.markerStyle ? \'\' : lAnnotation.backgroundColorCssForAnchor,\'border-style\': \'none\'}\" ng-class=\"{\'active\': (vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === $index)}\" swa-draggable swa-draggable-on-end=\"vm.leftAnnotationSelectionMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.leftAnnotationSelectionResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 16, minHeight: 16, handleClass: \'resize-handle-circle\'}\">\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n          <div class=\"swa-script-annotation-selection\" ng-click=\"$event.stopPropagation();$event.preventDefault()\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-repeat=\"rAnnotation in vm.ownerScriptPage.rightannotations\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenSharedAnnotationLayersList.indexOf(rAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-style=\"{left: rAnnotation.selectionrect.left+\'px\', top: rAnnotation.selectionrect.top+\'px\', width: rAnnotation.selectionrect.width+\'px\', height: rAnnotation.selectionrect.height+\'px\',\n            \'background-color\': rAnnotation.markerStyle ? \'\' : rAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\">\n          </div>\n          <div class=\"swa-script-annotation-selection\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"rAnnotation in vm.currentScriptPage.rightannotationsPersonal\" ng-style=\"{left: rAnnotation.selectionrect.left+\'px\', top: rAnnotation.selectionrect.top+\'px\', width: rAnnotation.selectionrect.width+\'px\', height: rAnnotation.selectionrect.height+\'px\',\n            \'background-color\': rAnnotation.markerStyle ? \'\' : rAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\" ng-class=\"{\'active\': (vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === $index)}\" swa-draggable swa-draggable-on-end=\"vm.rightAnnotationSelectionMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.rightAnnotationSelectionResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 16, minHeight: 16, handleClass: \'resize-handle-circle\'}\">\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n          <svg class=\"swa-script-annotation-lines-container\">\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.leftannotations\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\">\n              <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n              </line>\n            </g>\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotationsPersonal\">\n              <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n              </line>\n            </g>\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.rightannotations\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\">\n              <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n              </line>\n            </g>\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotationsPersonal\">\n              <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n              </line>\n            </g>\n            <!-- left annotations anchor box -->\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.leftannotations\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotationsPersonal\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <!-- right annotations anchor box -->\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.rightannotations\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotationsPersonal\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <!-- left annotations text box -->\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.leftannotations\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.currentScriptPage.leftannotationsPersonal\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeLeftPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <!-- right annotations text box -->\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.ownerScriptPage.rightannotations\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-repeat=\"anAnnotation in vm.currentScriptPage.rightannotationsPersonal\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex !== $index\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage.pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': (anAnnotation.annotationtype === 1 && vm.scriptEditorState.activeRightPersonalAnnotationOrderingIndex === $index) ? \'1px\' : anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n          </svg>\n        </div>\n        <div class=\"swa-script-floating-annotations-container\">\n          <div class=\"swa-script-annotation floating-type\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-repeat=\"fAnnotation in vm.ownerScriptPage.floatingannotations\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenSharedAnnotationLayersList.indexOf(fAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-click=\"$event.stopPropagation();$event.preventDefault()\" ng-style=\"{top: fAnnotation.positionrect.top+\'px\', left: fAnnotation.positionrect.left+\'px\', width: fAnnotation.positionrect.width+\'px\', height: fAnnotation.positionrect.height+\'px\', \'background-color\': fAnnotation.backgroundColorCss}\">\n            <div id=\"mce-editor-text-annotationP-shared-{{$index}}\" class=\"content text-type\" swa-annotation-editor data-swa-annotation=\"fAnnotation\">\n            </div>\n          </div>\n          <div class=\"swa-script-annotation floating-type\" ng-class=\"{\'active\': vm.scriptEditorState.activeFloatingPersonalAnnotationOrderingIndex === $index, \'clickthrough\': (!vm.scriptEditorState.personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation) || !vm.scriptEditorState.enableTextAnnotations}\" ng-show=\"vm.scriptEditorState.annotationsVisiblePersonal && vm.hiddenAnnotationLayersList.indexOf(fAnnotation.layerid) == -1 && vm.activeAccessRules.allowpersonalnotes\" ng-click=\"vm.selectFloatingAnnotation($index);$event.stopPropagation();\" ng-repeat=\"fAnnotation in vm.currentScriptPage.floatingannotationsPersonal\" ng-style=\"{top: fAnnotation.positionrect.top+\'px\', left: fAnnotation.positionrect.left+\'px\', width: fAnnotation.positionrect.width+\'px\', height: fAnnotation.positionrect.height+\'px\', \'background-color\': fAnnotation.backgroundColorCss}\" swa-draggable swa-draggable-on-end=\"vm.floatingAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', handleClass: \'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.floatingAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', minWidth: 64, minHeight: 24, handleClass: \'resize-handle-circle\'}\">\n            <div id=\"mce-editor-text-annotationP-{{$index}}\" class=\"content text-type\" swa-annotation-editor data-swa-annotation=\"fAnnotation\" data-on-change=\"vm.markCurrentScriptPageDirty()\">\n            </div>\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n        </div>\n        <div class=\"swa-script-highlight-annotations-container\">\n          <div class=\"swa-script-annotation highlight-type\" ng-class=\"{\'active\': vm.scriptEditorState.activeHighlightPersonalAnnotationOrderingIndex === $index, \'clickthrough\': (!vm.scriptEditorState.personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation) || (vm.scriptEditorState.activeAnnotationType !== mAnnotation.annotationtype)}\" ng-show=\"(vm.scriptEditorState.annotationsVisiblePersonal && (vm.hiddenAnnotationLayersList.indexOf(mAnnotation.layerid) == -1) && vm.activeAccessRules.allowpersonalnotes)\" ng-click=\"vm.selectHighlightAnnotation($index);$event.stopPropagation();\" ng-repeat=\"mAnnotation in vm.currentScriptPage.highlightannotationsPersonal\" ng-style=\"{top: mAnnotation.positionrect.top+\'px\', left: mAnnotation.positionrect.left+\'px\', width: mAnnotation.positionrect.width+\'px\', height: mAnnotation.positionrect.height+\'px\', \'background-color\': mAnnotation.backgroundColorCss}\" swa-draggable swa-draggable-on-end=\"vm.highlightAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', handleClass: \'move-handle-circle\'}\" swa-resizable swa-resizable-on-end=\"vm.highlightAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', minWidth: 64, minHeight: 24, handleClass: \'resize-handle-circle\'}\">\n            <div class=\"handle move-handle-circle\"></div>\n            <div class=\"handle resize-handle-circle\"></div>\n          </div>\n          <div class=\"swa-script-annotation highlight-type\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-repeat=\"mAnnotation in vm.ownerScriptPage.highlightannotations\" ng-show=\"(vm.scriptEditorState.annotationsVisiblePersonal && (vm.hiddenSharedAnnotationLayersList.indexOf(mAnnotation.layerid) == -1) && vm.activeAccessRules.allowpersonalnotes)\" ng-click=\"$event.stopPropagation();$event.preventDefault()\" ng-style=\"{top: mAnnotation.positionrect.top+\'px\', left: mAnnotation.positionrect.left+\'px\', width: mAnnotation.positionrect.width+\'px\', height: mAnnotation.positionrect.height+\'px\', \'background-color\': mAnnotation.backgroundColorCss}\">\n          </div>\n        </div>\n        <div class=\"swa-script-annotationpopover-container\">\n          <div class=\"swa-script-annotationpopover-anchor swa-script-annotationpopover-anchor-personal\" ng-show=\"vm.newSideAnnotationTracker.isTracking || vm.newSideAnnotationTracker.shouldAdd\" ng-class=\"[{\'invalid\': !vm.newSideAnnotationTracker.valid}, \'swa-scriptannotation-annotationtype-\' + vm.newSideAnnotationTracker.activeAnnotationType]\" stackable-trigger=\"vm.addSideAnnotationViewP\" ng-style=\"{top: vm.newSideAnnotationTracker.selectionrect.top+\'px\', left: vm.newSideAnnotationTracker.selectionrect.left+\'px\', width: vm.newSideAnnotationTracker.selectionrect.width+\'px\', height: vm.newSideAnnotationTracker.selectionrect.height+\'px\', \'background-color\': vm.newSideAnnotationTracker.backgroundColorCss}\">\n          </div>\n          <stackable-popover class=\"swa-popover-script-side-annotation\" stackable-placement=\"{{vm.newSideAnnotationTracker.popoverplacement}}\" stackable=\"vm.addSideAnnotationViewP\">\n            <div class=\"btn-group\">\n              <button class=\"btn btn-sm sw-btn-secondary pull-left\" ng-click=\"vm.addSideAnnotation(\'left\')\">\n                <span class=\"sw-ionicon ion-chevron-left\"></span>\n                <span translate>buttons.Left</span>\n              </button>\n              <span class=\"btn btn-sm sw-btn-secondary-label\" ng-show=\"vm.scriptEditorState.activeAnnotationType === 1\" translate>labels.Add Q</span>\n              <button class=\"btn btn-sm sw-btn-secondary pull-right\" ng-click=\"vm.addSideAnnotation(\'right\')\">\n                <span translate>buttons.Right</span>\n                <span class=\"sw-ionicon ion-chevron-right\"></span>\n              </button>\n            </div>\n          </stackable-popover>\n        </div>\n        <div class=\"swa-script-sketchpad-container swa-script-sketchpad\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== 4}\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\" ng-mouseup=\"vm.onScriptContentMouseUp($event); $event.stopPropagation();\" ng-show=\"vm.scriptEditorState.enableSketchpadDrawing\">\n          <div class=\"swa-script-sketchpad-annotations-container\">\n            <div id=\"sketchpad-personal\"></div>\n          </div>\n          <div class=\"swa-script-sketchpad-annotations-container-individual-shape\" ng-if=\"!vm.scriptEditorState.startDrawing && !vm.scriptEditorState.startErasing && vm.scriptEditorState.selectionMode\" ng-style=\"{position: !vm.scriptEditorState.startDrawing ? \'absolute\' : \'inherit\'}\" ng-click=\"vm.resetSelectedShape()\">\n            <div ng-repeat=\"shapepath in vm.currentScriptPage.shapepathsPersonal\" class=\"shapepathpoints swa-freehand\" ng-click=\"vm.selectShape($index); $event.stopPropagation(); \" ng-class=\"{selectedShape: $index === vm.scriptEditorState.selectedShapeIndex}\" ng-style=\"{left: shapepath.bounds.x +\'px\', top: shapepath.bounds.y +\'px\', height: shapepath.bounds.height +\'px\', width: shapepath.bounds.width +\'px\'}\">\n              <div class=\"handle\" ng-show=\"$index === vm.scriptEditorState.selectedShapeIndex ? true : false\" ng-click=\"vm.deleteSelectedSketch()\">\n                <span class=\"sw-ionicon ion-close-round\"></span>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"swa-script-sketchpad-container swa-script-sketchpad\" ng-class=\"{\'clickthrough\': vm.scriptEditorState.activeAnnotationType !== -1}\" ng-click=\"$event.stopPropagation();\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\">\n          <div class=\"swa-script-sketchpad-annotations-container\">\n            <div id=\"sketchpad-shared\"></div>\n          </div>\n        </div>\n      </div>\n      <div id=\"swaScriptChartlinksContainer\" class=\"swa-script-chartlinks-container hide-when-blocked exclude-from-snapshot\" ng-class=\"{\'clickthrough\': vm.chartScriptEditorState.lockModeNavigation}\" ng-style=\"{left: (vm.currentScriptPage.pagewidth + 48) + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\" style=\"width: 120px\">\n        <div class=\"swa-script-chartlink swa-script-chartlink-border\" ng-class=\"{\'active\': vm.chartScriptEditorState.activeLinkOrderingIndex === $index, \'clickthrough\': vm.newChartLinkTracker.isTracking}\" ng-repeat=\"chartlink in vm.currentScriptPage.chartlinks\" ng-style=\"{top: chartlink.selectionrect.top + \'px\', height: chartlink.selectionrect.height + \'px\'}\" swa-draggable swa-draggable-on-end=\"vm.chartlinkMoved($index, dragData)\" swa-draggable-options=\"{direction: \'v\', setBottomRight: true, handleClass:\'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.chartlinkResized($index, sizeData)\" swa-resizable-options=\"{direction: \'v\', setBottomRight: true, minHeight: 32, handleClass: \'resizehandle\'}\" ng-click=\"vm.switchEditor(0, { chartId: chartlink.chartId })\">\n          <div class=\"buttons-container-topright btn-group\">\n            <button class=\"btn btn-sm sw-btn-accessory sw-truncatetext swa-chartname-width\">\n              <span ng-show=\"chartlink.chartname === undefined\" class=\"sw-ionicon-fw sw-ionicon-lg sw-ionicon-spin-1s ion-load-d\"></span>\n              <span ng-show=\"chartlink.chartname.length > 0 && ![\'<error>\', \'<missing>\'].includes(chartlink.chartname)\" ng-click=\"vm.switchEditor(0, { chartId: chartlink.chartId })\">{{chartlink.chartname}}</span>\n              <span ng-show=\"chartlink.chartname.length > 0 && [\'<error>\', \'<missing>\'].includes(chartlink.chartname)\">{{chartlink.chartname}}</span>\n              <span ng-show=\"chartlink.chartname.length === 0\">&lt;unnamed&gt;</span>\n            </button>\n          </div>\n        </div>\n      </div>\n      <div class=\"swa-script-page-annotations swa-script-bookmark\" ng-style=\"{width: vm.currentScriptPage.pagewidth + \'px\', height: vm.currentScriptPage.pageheight + \'px\'}\" ng-mousedown=\"vm.onScriptContentMouseDown($event)\" ng-mouseup=\"vm.onScriptContentMouseUp($event)\" ng-show=\"vm.scriptEditorState.bookmarkEditMode\">\n        <div class=\"swa-script-bookmark-annotations-container\">\n          <div ng-repeat=\"aBookmark in vm.bookmarks | orderBy: [\'scriptPageNo\', \'topOffset\'] | filter: {scriptPageNo: vm.currentScriptPage.orderingindex} : true\" style=\"position: relative\">\n            <div class=\"swa-script-annotation\" ng-style=\"{top: aBookmark.topOffset}\">\n              <span class=\"swafont swafont-lg swafont-icon-bookmark-fill swa-bookmark-icon\"></span>\n              <div class=\"form-group mrgn-padd-btm0 swa-script-annotation-bookmark\">\n                <input class=\"form-control\" id=\"bookmark-name-{{aBookmark.scriptPageNo}}-{{aBookmark.topOffset}}\" ng-model=\"aBookmark.name\" ng-change=\"vm.bookmarkChanged()\">\n                <div class=\"btn btn-sm handle deletehandle\" ng-click=\"vm.deleteBookmark(aBookmark)\">\n                  <span class=\"ion-close-round\"></span>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div id=\"toolbar-container\"></div>\n    </div>\n    <div ng-show=\"vm.scriptEditorState.isImporting\">\n      <div class=\"scriptImportPreviewContainer\"></div>\n    </div>\n    <div class=\"hide-when-blocked text-center sw-color-lightgray\" ng-hide=\"vm.scriptEditorState.pageLoaded\" style=\"margin-top: 40px\">\n      <div style=\"margin-bottom: 16px\">\n        <span class=\"sw-text-xlg\" translate>titles.PDF View</span>\n      </div>\n      <div ng-show=\"(vm.scriptEditorState.totalNumberOfPages === 0) || !vm.scriptEditorState.scriptAvailable\">\n        <span class=\"sw-text-lg\" translate>messages.You don\'t have a PDF in this Production!</span><br>\n        <span class=\"sw-text-md sw-color-mediumlightgray\">Import a PDF by clicking the\n          <span class=\"swafont swafont-lg swafont-icon-import-script\"></span> button on the toolbar above.\n        </span>\n      </div>\n      <!-- <div ng-show=\"(vm.scriptEditorState.totalNumberOfPages === 0)\">\n        <span class=\"sw-text-lg\" translate>messages.There are no pages in this PDF!</span>\n      </div> -->\n      <div ng-show=\"(vm.scriptEditorState.totalNumberOfPages > 0) && vm.scriptEditorState.pageLoadError\">\n        <span class=\"sw-text-lg\" translate>messages.Error loading page!</span>\n      </div>\n    </div>\n  </div>\n</div>\n<input accept=\"application/pdf\" id=\"scriptFileSelect\" name=\"file\" ng-hide=\"true\" swa-file-arraybuffer=\"vm.processSelectedPdfFileToRenderScriptAsPdf($filename, $arrayBuffer, $error)\" type=\"file\">\n\n<!-- Previous functionality call is vm.processSelectedPdfFile($filename, $arrayBuffer, $error) -->\n");
$templateCache.put("app/components/scriptEditor/scriptEditorBookView.html","<swa-help-bar ng-if=\"vm.showHelpBar && !vm.scriptEditorState[0].lockModeNavigation\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-on-start=\"vm.onHelpTourStart()\" swa-help-on-end=\"vm.onHelpTourEnd()\" swa-help-videos=\"vm.helpTourVideos\" swa-help-has-video=\"vm.helpTourVideos && vm.helpTourVideos.length > 0\">\n</swa-help-bar>\n<div class=\"mainOuter\" ng-class=\"{\'lockmodenavigation\': vm.scriptEditorState[0].lockModeNavigation}\" ng-cloak>\n  <div class=\"swtoolbar swtoolbar-lockmode\" ng-show=\"vm.scriptEditorState[0].lockModeNavigation\">\n    <div class=\"swtoolbar-group pull-left\">\n      <img class=\"sws-logo\" src=\"assets/images/sws-logo-light.png\">\n    </div>\n    <div class=\"swtoolbar-group pull-left\">\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.loadScriptEditorPage()\" ng-class=\"{\'sw-active\': vm.scriptEditorState[0].lockModeNavigation}\">\n        <span class=\"swafont swafont-lg swafont-icon-lock\"></span>\n      </button>\n      <button id=\"menu-switchview2\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.switchEditorView2\">\n        <div class=\"sw-btn-toolbar-vcontent\">\n          <span class=\"title\">PDF</span>\n          <span class=\"sw-ionicon-fw ion-arrow-down-b icon\"></span>\n        </div>\n      </button>\n      <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.switchEditorView2\">\n        <div class=\"sw-popover-title\">\n          <span translate>titles.View</span>\n        </div>\n        <div class=\"sw-popover-menu\" role=\"menu\">\n          <div class=\"menu-group\">\n            <div class=\"menu-item\" ng-click=\"vm.switchEditor(0)\">\n              <span class=\"title\" translate>labels.Charts</span>\n            </div>\n            <div class=\"menu-item\" ng-disabled=\"true\">\n              <span class=\"title\" translate>labels.PDF</span>\n            </div>\n            <div class=\"menu-item\" ng-click=\"vm.switchEditor(4)\">\n              <span class=\"title\" translate>labels.Charts and PDF</span>\n            </div>\n          </div>\n        </div>\n      </stackable-popover>\n    </div>\n    <div id=\"menu-scriptbookmarknavigationcontrols\" class=\"swtoolbar-group pull-left\">\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPrevBookmark()\">\n        <span class=\"swafont swafont-lg swafont-icon-previous\"></span>\n      </button>\n      <button class=\"btn sw-btn-toolbar\" id=\"menu-togglebookmarklist1\" ng-class=\"{\'sw-active\': vm.scriptEditorState[0].bookmarkListVisible}\" ng-show=\"!vm.scriptEditorState[0].bookmarkEditMode\" ng-click=\"vm.toggleBookmarkListVisibility()\" ng-disabled=\"!vm.scriptEditorState[0].pageLoaded\">\n        <span class=\"swafont swafont-lg swafont-icon-bookmark\"></span>\n      </button>\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoNextBookmark()\">\n        <span class=\"swafont swafont-lg swafont-icon-next\"></span>\n      </button>\n    </div>\n    <div class=\"swtoolbar-group swtoolbar-group-centered\">\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPage(\'prev\')\" ng-disabled=\"(vm.script.numberOfPages === 0) || (vm.scriptEditorState[0].currentPageNumber === 1) || !vm.activeAccessRules.allowpagenavigation\">\n        <span class=\"swafont swafont-lg swafont-icon-previous\"></span>\n      </button>\n      <button id=\"go-to-page1\" class=\"btn sw-btn-toolbar width-170\" ng-disabled=\"(vm.script.numberOfPages === 0) || !vm.activeAccessRules.allowpagenavigation\" stackable-trigger=\"vm.gotoPagePicker1\">\n        <span ng-show=\"(vm.script.numberOfPages === 0)\" translate>labels.No Pages</span>\n        <span ng-show=\"(vm.script.numberOfPages > 0)\">\n          <span ng-show=\"vm.pageViewArr.length > 1\" translate translate-values=\"{current1: vm.scriptEditorState[0].customPageNumber === \'\' ? \'_\' : vm.scriptEditorState[0].customPageNumber, \n              current2: vm.scriptEditorState[1].customPageNumber === \'\' ? \'_\' : vm.scriptEditorState[1].customPageNumber,\n              total: vm.scriptEditorState[0].totalNumberOfPages}\">labels.Page_multi_current</span>\n          <span ng-show=\"vm.pageViewArr.length === 1\" translate translate-values=\"{current: vm.scriptEditorState[0].customPageNumber === \'\' ? \'_\' : vm.scriptEditorState[0].customPageNumber, total: vm.scriptEditorState[0].totalNumberOfPages}\">labels.Page_current</span>\n          <span class=\"sw-ionicon-fw ion-arrow-down-b\"></span>\n        </span>\n      </button>\n      <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.gotoPagePicker1\">\n        <div class=\"sw-popover-title\">\n          <span translate>titles.Go To Page</span>\n        </div>\n        <div class=\"sw-popover-content\">\n          <div class=\"sw-gotopage-picker-content form-inline sw-form-container text-center\">\n            <div>\n              <input class=\"form-control\" id=\"gotopagequick1\" ng-change=\"vm.gotoPagePicker.invalidPageNumber = false\" ng-model=\"vm.gotoPagePicker.pagenumber\" style=\"width: 110px; text-align: right\" swa-on-enter=\"vm.findAndGoToPageNoFromCustomPageNumber()\" swa-select-on-focus>\n              <button class=\"btn sw-btn-secondary width-60\" ng-click=\"vm.findAndGoToPageNoFromCustomPageNumber()\" translate>buttons.Go</button>\n            </div>\n            <div ng-show=\"vm.gotoPagePicker.invalidPageNumber\">\n              <span class=\"sw-color-red\" translate>messages.Invalid page number</span>\n            </div>\n            <div class=\"sw-goto-page-popup\">\n              <span class=\"subtitle\">Total Pages : {{vm.script.numberOfPages}}</span>\n            </div>\n          </div>\n        </div>\n      </stackable-popover>\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.gotoPage(\'next\')\" ng-disabled=\"(vm.script.numberOfPages === 0) || (vm.scriptEditorState[0].currentPageNumber === vm.scriptEditorState[0].maxLeftPageNo) || !vm.activeAccessRules.allowpagenavigation\">\n        <span class=\"swafont swafont-lg swafont-icon-next\"></span>\n      </button>\n    </div>\n    <div class=\"swtoolbar-group sw-btn-pageview pull-right\">\n      <button class=\"btn sw-btn-secondary sw-btn-toolbar-o\" ng-class=\"{\'selected-pageview\': vm.numberOfPagesDisplay === 1}\" ng-click=\"vm.toggleBookView(1)\" type=\"button\">\n        1 Page\n      </button>\n      <button class=\"btn sw-btn-secondary sw-btn-toolbar-o\" ng-class=\"{\'selected-pageview\': vm.numberOfPagesDisplay === 2}\" ng-click=\"vm.toggleBookView(2)\" type=\"button\">\n        2 Pages\n      </button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <span class=\"swa-color-lightgray sw-text-lg\" translate>titles.Book View</span>\n    </div>\n  </div>\n</div>\n<div>\n  <div class=\"sw-sidebar sw-sidebar-bar-only\" ng-class=\"{\'sw-sidebar-left-hidden\': (vm.revealSidebar === false), \'sw-sidebar-left-visible\': (vm.revealSidebar === true)}\" ng-hide=\"vm.scriptEditorState[0].lockModeNavigation\">\n    <div class=\"sw-navbar sw-navbar-top sw-color-red\" ng-mouseenter=\"vm.revealSidebar = true\" ng-mouseleave=\"vm.revealSidebar = false\">\n      <div class=\"swtoolbar\">\n        <button class=\"btn btn-lg sw-btn-toolbar\" ng-show=\"vm.revealSidebar\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\">\n          <span class=\"ion-chevron-left\"></span>\n        </button>\n        <div class=\"text-lg sw-truncatetext\" style=\"width: calc(100% - 50px)\">\n          <span>{{vm.selectedProduction.name}}</span>\n        </div>\n        <button id=\"button-closeproduction\" class=\"btn btn-lg sw-btn-toolbar\" ng-hide=\"vm.revealSidebar\">\n          <span class=\"ion-chevron-left\"></span>\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"scrollcontainer sw-sidebar-bookmark\" ng-class=\"{\'sw-sidebar-bookmark-lockmode\': vm.scriptEditorState[0].lockModeNavigation}\">\n    <div class=\"sidebar-bookmark-list\" ng-if=\"vm.scriptEditorState[0].bookmarkListVisible\">\n      <div class=\"panel panel-default mrgnbtm-1\">\n        <div class=\"panel-heading\">\n          <h4 class=\"panel-title coverStyleDiv\" translate>\n            titles.Bookmarks\n          </h4>\n        </div>\n        <div class=\"panel-body sw-sidebar-bookmark-scroll\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\">\n          <div class=\"sidebar-bookmark-row\" ng-repeat=\"bookmark in vm.bookmarks | orderBy: [\'scriptPageNo\', \'topOffset\']\" ng-click=\"vm.gotoBookmark(bookmark)\">\n            <div class=\"title sw-truncatetext\">\n              <span>{{bookmark.name}}</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"sw-maincontentarea-script sw-editorcontent text-center\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigContent\">\n    <div class=\"sw-book-view\" ng-repeat=\"sideIndex in vm.pageViewArr\" ng-class=\"{\'two-pageview\': vm.numberOfPagesDisplay === 2}\" ng-style=\"{\'width\': vm.bookviewPageContainerWidth, \'height\': vm.bookViewPageContainerHeight[$index]}\">\n      <div class=\"sw-script-pageview-container sw-script-pageview-container-position-{{sideIndex}}\" ng-hide=\"vm.scriptEditorState[$index].isImporting || !vm.scriptEditorState[$index].pageLoaded\" ng-style=\"{transform: \'scale(\' + vm.bookViewScale[$index] + \')\'}\">\n        <div class=\"clickthrough\" style=\"position:absolute; top: 0; right: 0\" ng-if=\"!vm.activeAccessRules.allowowneraccess\">\n          <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-person-stalker\': vm.activeAccessRules.allowscriptediting, \'ion-locked\': !vm.activeAccessRules.allowscriptediting}\"></span>\n        </div>\n        <div class=\"swa-script-page-content\" ng-style=\"{width: vm.currentScriptPage[$index].pagewidth + \'px\', height: vm.currentScriptPage[$index].pageheight + \'px\'}\">\n          <img id=\"scriptPageImage-{{sideIndex}}\" class=\"swa-script-page-image\" ng-hide=\"vm.scriptEditorState[$index].pageLoadError || vm.scriptEditorState[$index].pageImageLoadError\" ng-src=\"{{vm.currentScriptPage[$index].pageImageSrc}}\">\n        </div>\n        <div class=\"swa-script-page-annotations swa-script-global\" ng-class=\"{\'clickthrough\': !vm.scriptEditorState[$index].masterLayerActive || !vm.activeAccessRules.allowscriptediting}\" ng-show=\"vm.scriptEditorState[$index].annotationsVisible && !vm.activeAccessRules.allowpersonalnotes\" ng-style=\"{width: vm.currentScriptPage[$index].pagewidth + \'px\', height: vm.currentScriptPage[$index].pageheight + \'px\'}\" ng-mousedown=\"vm.onScriptContentMouseDown($event)\" ng-mousemove=\"vm.onScriptContentMouseMove($event)\" ng-mouseup=\"vm.onScriptContentMouseUp($event)\">\n          <div class=\"swa-script-side-annotations-container left\">\n            <div class=\"swa-script-annotation\" ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeLeftAnnotationOrderingIndex === $index), \'action-type\': (lAnnotation.annotationtype === 0), \'lightcue-type\': (lAnnotation.annotationtype === 1), \'clickthrough\': (!vm.scriptEditorState[$index].masterLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState[$index].lockModeNavigation)}\" ng-repeat=\"lAnnotation in vm.currentScriptPage[$index].leftannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.positionrect.left+\'px\', top: lAnnotation.positionrect.top+\'px\', height: lAnnotation.positionrect.height+\'px\', width: lAnnotation.positionrect.width+\'px\', \'background-color\': lAnnotation.backgroundColorCss, \'border-style\': \'none\'}\" swa-draggable swa-draggable-on-end=\"vm.leftAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass:\'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.leftAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 64, minHeight: 24, handleClass: \'resizehandle\'}\">\n              <div id=\"mce-editor-left-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"lAnnotation\">\n              </div>\n            </div>\n          </div>\n          <div class=\"swa-script-side-annotations-container right\">\n            <div class=\"swa-script-annotation\" ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeRightAnnotationOrderingIndex === $index), \'action-type\': (rAnnotation.annotationtype === 0), \'lightcue-type\': (rAnnotation.annotationtype === 1), \'clickthrough\': (!vm.scriptEditorState[$index].masterLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState[$index].lockModeNavigation)}\" ng-repeat=\"rAnnotation in vm.currentScriptPage[$index].rightannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.positionrect.left+\'px\', top: rAnnotation.positionrect.top+\'px\', height: rAnnotation.positionrect.height+\'px\', width: rAnnotation.positionrect.width+\'px\', \'background-color\': rAnnotation.backgroundColorCss, \'border-style\': \'none\'}\" swa-draggable swa-draggable-on-end=\"vm.rightAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.rightAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 64, minHeight: 24, handleClass: \'resizehandle\'}\">\n              <div id=\"mce-editor-right-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"rAnnotation\">\n              </div>\n            </div>\n          </div>\n          <div class=\"swa-script-annotation-selections-container\">\n            <div class=\"swa-script-annotation-selection\" ng-repeat=\"lAnnotation in vm.currentScriptPage[$index].leftannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.selectionrect.left+\'px\', top: lAnnotation.selectionrect.top+\'px\', width: lAnnotation.selectionrect.width+\'px\', height: lAnnotation.selectionrect.height+\'px\',\n              \'background-color\': lAnnotation.markerStyle ? \'\' : lAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\" ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeLeftAnnotationOrderingIndex === $index)}\" swa-draggable swa-draggable-on-end=\"vm.leftAnnotationSelectionMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.leftAnnotationSelectionResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 16, minHeight: 16, handleClass: \'resizehandle\'}\">\n              <div class=\"handle movehandle\">\n                <span class=\"sw-ionicon ion-arrow-move\"></span>\n              </div>\n              <div class=\"handle resizehandle\">\n                <span class=\"sw-ionicon sw-ionicon-r-90 ion-arrow-resize\"></span>\n              </div>\n            </div>\n            <div class=\"swa-script-annotation-selection\" ng-repeat=\"rAnnotation in vm.currentScriptPage[$index].rightannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.selectionrect.left+\'px\', top: rAnnotation.selectionrect.top+\'px\', width: rAnnotation.selectionrect.width+\'px\', height: rAnnotation.selectionrect.height+\'px\',\n              \'background-color\': rAnnotation.markerStyle ? \'\' : rAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\" ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeRightAnnotationOrderingIndex === $index)}\" swa-draggable swa-draggable-on-end=\"vm.rightAnnotationSelectionMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.rightAnnotationSelectionResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 16, minHeight: 16, handleClass: \'resizehandle\'}\">\n              <div class=\"handle movehandle\">\n                <span class=\"sw-ionicon ion-arrow-move\"></span>\n              </div>\n              <div class=\"handle resizehandle\">\n                <span class=\"sw-ionicon sw-ionicon-r-90 ion-arrow-resize\"></span>\n              </div>\n            </div>\n            <svg class=\"swa-script-annotation-lines-container\">\n              <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeLeftAnnotationOrderingIndex === $index}\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].leftannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                </line>\n              </g>\n              <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeRightAnnotationOrderingIndex === $index}\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].rightannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                </line>\n              </g>\n              <!-- left annotations anchor box -->\n            <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].leftannotations\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeLeftAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <!-- right annotations anchor box -->\n            <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].rightannotations\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeRightAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <!-- left annotations text box -->\n            <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].leftannotations\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeLeftAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            <!-- right annotations text box -->\n            <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].rightannotations\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeRightAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n              <!-- Top side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Right side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Bottom side -->\n              <line ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n              <!-- Left side -->\n              <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n              </line>\n            </g>\n            </svg>\n          </div>\n          <div class=\"swa-script-floating-annotations-container\">\n            <div class=\"swa-script-annotation floating-type\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeFloatingAnnotationOrderingIndex === $index, \'clickthrough\': (!vm.scriptEditorState[$index].masterLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState[$index].lockModeNavigation)}\" ng-repeat=\"fAnnotation in vm.currentScriptPage[$index].floatingannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(fAnnotation.layerid) == -1\" ng-style=\"{top: fAnnotation.positionrect.top+\'px\', left: fAnnotation.positionrect.left+\'px\', width: fAnnotation.positionrect.width+\'px\', height: fAnnotation.positionrect.height+\'px\', \'background-color\': fAnnotation.backgroundColorCss}\" swa-draggable swa-draggable-on-end=\"vm.floatingAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', handleClass: \'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.floatingAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', minWidth: 64, minHeight: 24, handleClass: \'resizehandle\'}\">\n              <div id=\"mce-editor-text-annotation-{{$index}}\" class=\"content text-type\" swa-annotation-editor data-swa-annotation=\"fAnnotation\">\n              </div>\n            </div>\n          </div>\n          <div class=\"swa-script-highlight-annotations-container\">\n            <div class=\"swa-script-annotation highlight-type\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeHighlightAnnotationOrderingIndex === $index, \'clickthrough\': (!vm.scriptEditorState[$index].masterLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState[$index].lockModeNavigation)}\" ng-repeat=\"mAnnotation in vm.currentScriptPage[$index].highlightannotations\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(mAnnotation.layerid) == -1\" ng-style=\"{top: mAnnotation.positionrect.top+\'px\', left: mAnnotation.positionrect.left+\'px\', width: mAnnotation.positionrect.width+\'px\', height: mAnnotation.positionrect.height+\'px\', \'background-color\': mAnnotation.backgroundColorCss}\" swa-draggable swa-draggable-on-end=\"vm.highlightAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', handleClass: \'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.highlightAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', minWidth: 64, minHeight: 24, handleClass: \'resizehandle\'}\">\n            </div>\n          </div>\n          <div class=\"swa-script-sketchpad-container swa-script-sketchpad\">\n            <div class=\"swa-script-sketchpad-annotations-container\">\n              <div id=\"sketchpad-{{$index}}\"></div>\n            </div>\n          </div>\n        </div>\n        <div class=\"swa-script-page-annotations swa-script-personal\" ng-class=\"{\'clickthrough\': !vm.scriptEditorState[$index].personalLayerActive}\" ng-show=\"vm.scriptEditorState[$index].annotationsVisiblePersonal && vm.activeAccessRules.allowpersonalnotes\" ng-style=\"{width: vm.currentScriptPage[$index].pagewidth + \'px\', height: vm.currentScriptPage[$index].pageheight + \'px\'}\">\n          <div class=\"swa-script-side-annotations-container left\">\n            <div ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeLeftPersonalAnnotationOrderingIndex === $index), \'action-type\': (lAnnotation.annotationtype === 0), \'lightcue-type\': (lAnnotation.annotationtype === 1), \'clickthrough\': (!vm.scriptEditorState[$index].personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState[$index].lockModeNavigation)}\" class=\"swa-script-annotation\" ng-repeat=\"lAnnotation in vm.ownerScriptPage[$index].leftannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.positionrect.left+\'px\', top: lAnnotation.positionrect.top+\'px\', height: lAnnotation.positionrect.height+\'px\', width: lAnnotation.positionrect.width+\'px\', \'background-color\': lAnnotation.backgroundColorCss, \'border-style\': \'none\'}\">\n              <div id=\"mce-editor-leftp-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"lAnnotation\">\n              </div>\n            </div>\n            <div ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeLeftPersonalAnnotationOrderingIndex === $index), \'action-type\': (lAnnotation.annotationtype === 0), \'lightcue-type\': (lAnnotation.annotationtype === 1), \'clickthrough\': (!vm.scriptEditorState[$index].personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState[$index].lockModeNavigation)}\" class=\"swa-script-annotation\" ng-repeat=\"lAnnotation in vm.currentScriptPage[$index].leftannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.positionrect.left+\'px\', top: lAnnotation.positionrect.top+\'px\', height: lAnnotation.positionrect.height+\'px\', width: lAnnotation.positionrect.width+\'px\', \'background-color\': lAnnotation.backgroundColorCss, \'border-style\': \'none\'}\" swa-draggable swa-draggable-on-end=\"vm.leftAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass:\'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.leftAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 64, minHeight: 24, handleClass: \'resizehandle\'}\">\n              <div id=\"mce-editor-leftp-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"lAnnotation\">\n              </div>\n            </div>\n          </div>\n          <div class=\"swa-script-side-annotations-container right\">\n            <div class=\"swa-script-annotation\" ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeRightPersonalAnnotationOrderingIndex === $index), \'action-type\': (rAnnotation.annotationtype === 0), \'lightcue-type\': (rAnnotation.annotationtype === 1), \'clickthrough\': (!vm.scriptEditorState[$index].personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState[$index].lockModeNavigation)}\" ng-repeat=\"rAnnotation in vm.ownerScriptPage[$index].rightannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.positionrect.left+\'px\', top: rAnnotation.positionrect.top+\'px\', height: rAnnotation.positionrect.height+\'px\', width: rAnnotation.positionrect.width+\'px\', \'background-color\': rAnnotation.backgroundColorCss, \'border-style\': \'none\'}\">\n              <div id=\"mce-editor-rightp-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"rAnnotation\">\n              </div>\n            </div>\n            <div class=\"swa-script-annotation\" ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeRightPersonalAnnotationOrderingIndex === $index), \'action-type\': (rAnnotation.annotationtype === 0), \'lightcue-type\': (rAnnotation.annotationtype === 1), \'clickthrough\': (!vm.scriptEditorState[$index].personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState[$index].lockModeNavigation)}\" ng-repeat=\"rAnnotation in vm.currentScriptPage[$index].rightannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.positionrect.left+\'px\', top: rAnnotation.positionrect.top+\'px\', height: rAnnotation.positionrect.height+\'px\', width: rAnnotation.positionrect.width+\'px\', \'background-color\': rAnnotation.backgroundColorCss, \'border-style\': \'none\'}\" swa-draggable swa-draggable-on-end=\"vm.rightAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.rightAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 64, minHeight: 24, handleClass: \'resizehandle\'}\">\n              <div id=\"mce-editor-rightp-{{$index}}\" class=\"content\" swa-annotation-editor data-swa-annotation=\"rAnnotation\">\n              </div>\n            </div>\n          </div>\n          <div class=\"swa-script-annotation-selections-container\">\n            <div class=\"swa-script-annotation-selection\" ng-repeat=\"lAnnotation in vm.ownerScriptPage[$index].leftannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.selectionrect.left+\'px\', top: lAnnotation.selectionrect.top+\'px\', width: lAnnotation.selectionrect.width+\'px\', height: lAnnotation.selectionrect.height+\'px\',\n              \'background-color\': lAnnotation.markerStyle ? \'\' : lAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\" ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeLeftPersonalAnnotationOrderingIndex === $index)}\">\n            </div>\n            <div class=\"swa-script-annotation-selection\" ng-repeat=\"lAnnotation in vm.currentScriptPage[$index].leftannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(lAnnotation.layerid) == -1\" ng-style=\"{left: lAnnotation.selectionrect.left+\'px\', top: lAnnotation.selectionrect.top+\'px\', width: lAnnotation.selectionrect.width+\'px\', height: lAnnotation.selectionrect.height+\'px\',\n              \'background-color\': lAnnotation.markerStyle ? \'\' : lAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\" ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeLeftPersonalAnnotationOrderingIndex === $index)}\" swa-draggable swa-draggable-on-end=\"vm.leftAnnotationSelectionMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.leftAnnotationSelectionResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 16, minHeight: 16, handleClass: \'resizehandle\'}\">\n              <div class=\"handle movehandle\">\n                <span class=\"sw-ionicon ion-arrow-move\"></span>\n              </div>\n              <div class=\"handle resizehandle\">\n                <span class=\"sw-ionicon sw-ionicon-r-90 ion-arrow-resize\"></span>\n              </div>\n            </div>\n            <div class=\"swa-script-annotation-selection\" ng-repeat=\"rAnnotation in vm.ownerScriptPage[$index].rightannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.selectionrect.left+\'px\', top: rAnnotation.selectionrect.top+\'px\', width: rAnnotation.selectionrect.width+\'px\', height: rAnnotation.selectionrect.height+\'px\',\n              \'background-color\': rAnnotation.markerStyle ? \'\' : rAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\" ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeRightPersonalAnnotationOrderingIndex === $index)}\">\n            </div>\n            <div class=\"swa-script-annotation-selection\" ng-repeat=\"rAnnotation in vm.currentScriptPage[$index].rightannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(rAnnotation.layerid) == -1\" ng-style=\"{left: rAnnotation.selectionrect.left+\'px\', top: rAnnotation.selectionrect.top+\'px\', width: rAnnotation.selectionrect.width+\'px\', height: rAnnotation.selectionrect.height+\'px\',\n              \'background-color\': rAnnotation.markerStyle ? \'\' : rAnnotation.backgroundColorCssForAnchor, \'border-style\': \'none\'}\" ng-class=\"{\'active\': (vm.scriptEditorState[$index].activeRightPersonalAnnotationOrderingIndex === $index)}\" swa-draggable swa-draggable-on-end=\"vm.rightAnnotationSelectionMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', setBottomRight: true, handleClass: \'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.rightAnnotationSelectionResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', setBottomRight: true, minWidth: 16, minHeight: 16, handleClass: \'resizehandle\'}\">\n              <div class=\"handle movehandle\">\n                <span class=\"sw-ionicon ion-arrow-move\"></span>\n              </div>\n              <div class=\"handle resizehandle\">\n                <span class=\"sw-ionicon sw-ionicon-r-90 ion-arrow-resize\"></span>\n              </div>\n            </div>\n            <svg class=\"swa-script-annotation-lines-container\">\n              <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeLeftPersonalAnnotationOrderingIndex === $index}\" ng-repeat=\"anAnnotation in vm.ownerScriptPage[$index].leftannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                </line>\n              </g>\n              <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeLeftPersonalAnnotationOrderingIndex === $index}\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].leftannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                </line>\n              </g>\n              <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeRightPersonalAnnotationOrderingIndex === $index}\" ng-repeat=\"anAnnotation in vm.ownerScriptPage[$index].rightannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                </line>\n              </g>\n              <g class=\"swa-script-annotation-line\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeRightPersonalAnnotationOrderingIndex === $index}\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].rightannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <line ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\" ng-attr-x1=\"{{anAnnotation.linex1}}\" ng-attr-x2=\"{{anAnnotation.linex2}}\" ng-attr-y1=\"{{anAnnotation.liney1}}\" ng-attr-y2=\"{{anAnnotation.liney2}}\">\n                </line>\n              </g>\n              <!-- left annotations anchor box -->\n                <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.ownerScriptPage[$index].leftannotations\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeLeftPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <!-- Top side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Right side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Bottom side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Left side -->\n                <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n              </g>\n                <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].leftannotationsPersonal\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeLeftPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <!-- Top side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Right side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Bottom side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Left side -->\n                <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n              </g>\n              <!-- right annotations anchor box -->\n              <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.ownerScriptPage[$index].rightannotations\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeRightPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <!-- Top side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Right side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Bottom side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Left side -->\n                <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n              </g>\n              <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].rightannotationsPersonal\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeRightPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <!-- Top side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Right side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Bottom side -->\n                <line ng-hide=\"anAnnotation.markerStyle\" ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left + anAnnotation.selectionrect.width}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Left side -->\n                <line ng-attr-x1=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y1=\"{{anAnnotation.selectionrect.top}}\" ng-attr-x2=\"{{anAnnotation.selectionrect.left}}\" ng-attr-y2=\"{{anAnnotation.selectionrect.top + anAnnotation.selectionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n              </g>\n              <!-- left annotations text box -->\n              <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.ownerScriptPage[$index].leftannotations\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeLeftPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <!-- Top side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Right side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Bottom side -->\n                <line ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Left side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n              </g>\n              <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].leftannotationsPersonal\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeLeftPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <!-- Top side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Right side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Bottom side -->\n                <line ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Left side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n              </g>\n              <!-- right annotations text box -->\n              <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.ownerScriptPage[$index].rightannotations\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeRightPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <!-- Top side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Right side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Bottom side -->\n                <line ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Left side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n              </g>\n              <g class=\"swa-script-annotation-line\" ng-repeat=\"anAnnotation in vm.currentScriptPage[$index].rightannotationsPersonal\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeRightPersonalAnnotationOrderingIndex === $index}\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(anAnnotation.layerid) == -1\">\n                <!-- Top side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Right side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Bottom side -->\n                <line ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + anAnnotation.positionrect.width + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n                <!-- Left side -->\n                <line ng-hide=\"anAnnotation.annotationtype === 1\" ng-attr-x1=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y1=\"{{anAnnotation.positionrect.top}}\" ng-attr-x2=\"{{anAnnotation.positionrect.left + (vm.currentScriptPage[$parent.$index].pagewidth / 2)}}\" ng-attr-y2=\"{{anAnnotation.positionrect.top + anAnnotation.positionrect.height}}\" ng-style=\"{\'stroke\': anAnnotation.borderColorCssForAnchor, \'stroke-width\': anAnnotation.annotationBorderThickness}\">\n                </line>\n              </g>\n            </svg>\n          </div>\n          <div class=\"swa-script-floating-annotations-container\">\n            <div class=\"swa-script-annotation floating-type\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeFloatingPersonalAnnotationOrderingIndex === $index, \'clickthrough\': (!vm.scriptEditorState.personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation)}\" ng-repeat=\"fAnnotation in vm.ownerScriptPage[$index].floatingannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(fAnnotation.layerid) == -1\" ng-style=\"{top: fAnnotation.positionrect.top+\'px\', left: fAnnotation.positionrect.left+\'px\', width: fAnnotation.positionrect.width+\'px\', height: fAnnotation.positionrect.height+\'px\', \'background-color\': fAnnotation.backgroundColorCss}\">\n              <div id=\"mce-editor-text-annotationP-{{$index}}\" class=\"content text-type\" swa-annotation-editor data-swa-annotation=\"fAnnotation\">\n              </div>\n            </div>\n            <div class=\"swa-script-annotation floating-type\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeFloatingPersonalAnnotationOrderingIndex === $index, \'clickthrough\': (!vm.scriptEditorState.personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation)}\" ng-repeat=\"fAnnotation in vm.currentScriptPage[$index].floatingannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(fAnnotation.layerid) == -1\" ng-style=\"{top: fAnnotation.positionrect.top+\'px\', left: fAnnotation.positionrect.left+\'px\', width: fAnnotation.positionrect.width+\'px\', height: fAnnotation.positionrect.height+\'px\', \'background-color\': fAnnotation.backgroundColorCss}\" swa-draggable swa-draggable-on-end=\"vm.floatingAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', handleClass: \'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.floatingAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', minWidth: 64, minHeight: 24, handleClass: \'resizehandle\'}\">\n              <div id=\"mce-editor-text-annotationP-{{$index}}\" class=\"content text-type\" swa-annotation-editor data-swa-annotation=\"fAnnotation\">\n              </div>\n            </div>\n          </div>\n          <div class=\"swa-script-highlight-annotations-container\">\n            <div class=\"swa-script-annotation highlight-type\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeHighlightPersonalAnnotationOrderingIndex === $index, \'clickthrough\': (!vm.scriptEditorState.personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation)}\" ng-repeat=\"mAnnotation in vm.ownerScriptPage[$index].highlightannotations\" ng-show=\"vm.hiddenSharedAnnotationLayersList.indexOf(mAnnotation.layerid) == -1\" ng-style=\"{top: mAnnotation.positionrect.top+\'px\', left: mAnnotation.positionrect.left+\'px\', width: mAnnotation.positionrect.width+\'px\', height: mAnnotation.positionrect.height+\'px\', \'background-color\': mAnnotation.backgroundColorCss}\">\n            </div>\n            <div class=\"swa-script-annotation highlight-type\" ng-class=\"{\'active\': vm.scriptEditorState[$index].activeHighlightPersonalAnnotationOrderingIndex === $index, \'clickthrough\': (!vm.scriptEditorState.personalLayerActive || vm.newSideAnnotationTracker.isTracking || vm.scriptEditorState.lockModeNavigation)}\" ng-repeat=\"mAnnotation in vm.currentScriptPage[$index].highlightannotationsPersonal\" ng-show=\"vm.hiddenAnnotationLayersList.indexOf(mAnnotation.layerid) == -1\" ng-style=\"{top: mAnnotation.positionrect.top+\'px\', left: mAnnotation.positionrect.left+\'px\', width: mAnnotation.positionrect.width+\'px\', height: mAnnotation.positionrect.height+\'px\', \'background-color\': mAnnotation.backgroundColorCss}\" swa-draggable swa-draggable-on-end=\"vm.highlightAnnotationMoved(dragData)\" swa-draggable-options=\"{direction: \'vh\', handleClass: \'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.highlightAnnotationResized(sizeData)\" swa-resizable-options=\"{direction: \'vh\', minWidth: 64, minHeight: 24, handleClass: \'resizehandle\'}\">\n            </div>\n          </div>\n          <div class=\"swa-script-sketchpad-container swa-script-sketchpad\">\n            <div class=\"swa-script-sketchpad-annotations-container\">\n              <div id=\"sketchpad-personal-{{$index}}\"></div>\n            </div>\n          </div>\n          <div class=\"swa-script-sketchpad-container swa-script-sketchpad\">\n            <div class=\"swa-script-sketchpad-annotations-container\">\n              <div id=\"sketchpad-shared-{{$index}}\"></div>\n            </div>\n          </div>\n        </div>\n        <div class=\"swa-script-chartlinks-container hide-when-blocked\" ng-class=\"{\'clickthrough\': vm.chartScriptEditorState.lockModeNavigation}\" ng-style=\"{left: (vm.currentScriptPage[$index].pagewidth + 48) + \'px\', height: vm.currentScriptPage[$index].pageheight + \'px\'}\" style=\"width: 120px\">\n          <div class=\"swa-script-chartlink swa-script-chartlink-border\" ng-class=\"{\'active\': vm.chartScriptEditorState.activeLinkOrderingIndex === $index, \'clickthrough\': vm.newChartLinkTracker.isTracking}\" ng-repeat=\"chartlink in vm.currentScriptPage[$index].chartlinks\" ng-style=\"{top: chartlink.selectionrect.top + \'px\', height: chartlink.selectionrect.height + \'px\'}\" swa-draggable swa-draggable-on-end=\"vm.chartlinkMoved($index, dragData)\" swa-draggable-options=\"{direction: \'v\', setBottomRight: true, handleClass:\'movehandle\'}\" swa-resizable swa-resizable-on-end=\"vm.chartlinkResized($index, sizeData)\" swa-resizable-options=\"{direction: \'v\', setBottomRight: true, minHeight: 32, handleClass: \'resizehandle\'}\">\n            <div class=\"buttons-container-topright btn-group\">\n              <button class=\"btn btn-sm sw-btn-accessory sw-truncatetext swa-chartname-width\">\n                <span ng-show=\"chartlink.chartname === undefined\" class=\"sw-ionicon-fw sw-ionicon-lg sw-ionicon-spin-1s ion-load-d\"></span>\n                <span ng-show=\"chartlink.chartname.length > 0 && ![\'<error>\', \'<missing>\'].includes(chartlink.chartname)\" ng-click=\"vm.switchEditor(0, { chartId: chartlink.chartId })\">{{chartlink.chartname}}</span>\n                <span ng-show=\"chartlink.chartname.length > 0 && [\'<error>\', \'<missing>\'].includes(chartlink.chartname)\">{{chartlink.chartname}}</span>\n                <span ng-show=\"chartlink.chartname.length === 0\">&lt;unnamed&gt;</span>\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div ng-show=\"vm.scriptEditorState[0].isImporting\">\n        <div class=\"scriptImportPreviewContainer\"></div>\n      </div>\n      <div class=\"hide-when-blocked text-center sw-color-lightgray\" ng-hide=\"vm.scriptEditorState[$index].pageLoaded\" style=\"margin-top: 40px\">\n        <div style=\"margin-bottom: 16px\">\n          <span class=\"sw-text-xlg\" translate>titles.PDF View</span>\n        </div>\n        <div ng-hide=\"vm.scriptEditorState[$index].scriptAvailable\">\n          <span class=\"sw-text-lg\" translate>messages.You don\'t have a PDF in this Production!</span><br>\n          <span class=\"sw-text-md sw-color-mediumlightgray\">Import a PDF by clicking the\n            <span class=\"swafont swafont-lg swafont-icon-import-script\"></span> button on the toolbar above.\n          </span>\n        </div>\n        <div ng-show=\"(vm.scriptEditorState[$index].totalNumberOfPages === 0)\">\n          <span class=\"sw-text-lg\" translate>messages.There are no pages in this PDF!</span>\n        </div>\n        <div ng-show=\"(vm.scriptEditorState[$index].totalNumberOfPages > 0) && vm.scriptEditorState[$index].pageLoadError\">\n          <span class=\"sw-text-lg\" translate>messages.Error loading page!</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<input accept=\"application/pdf\" id=\"scriptFileSelect\" name=\"file\" ng-hide=\"true\" swa-file-arraybuffer=\"vm.processSelectedPdfFile($filename, $arrayBuffer, $error)\" type=\"file\">\n\n");
$templateCache.put("app/components/scriptEditor/scriptFreehandErasePrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title text-danger text-center\">{{\'titles.Erase All Markings\'|translate}}\n    <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\">{{\'messages.erase all markings prompt\'|translate}}\n    <br>\n    <br>\n    <strong>{{\'messages.Are you sure?\' | translate}}</strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/scriptEditor/undoPdfImportPrompt.html","<div class=\"modal-header\" style=\"text-align: center\">\n  <span class=\"modal-title text-danger text-center\">{{\'titles.Confirm\'|translate}}\n  </span>\n</div>\n<div class=\"modal-body\">\n  <strong>{{\'messages.Undo Import PDF?\' | translate}}</strong>\n  <p></p>\n  <p>{{\'messages.undo script import prompt\' | translate}}</p>\n</div>\n<div class=\"modal-footer\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n  </div>\n</div>");
$templateCache.put("app/components/staffEditor/copyMoveDeleteOptionHintPrompt.html","<div class=\"modal-header\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Actions Moved\'|translate}}\n    </span>\n  </div>\n  <div class=\"modal-body\">\n      <p class=\"text-center\">{{\'messages.Copy delete move option hint\'|translate}}\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"text-center\">\n      <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionOk()\" translate>buttons.Ok</button>\n    </div>\n  </div>\n  ");
$templateCache.put("app/components/staffEditor/deleteStaffPrompt.html","<div class=\"modal-header\" style=\"text-align: center\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Confirm\'|translate}}\n    </span>\n    <!-- <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span> -->\n</div>\n<div class=\"modal-body\">\n    <strong>{{\'messages.Delete selected score\' | translate}}</strong>\n    <p></p>\n    <p>{{\'messages.Hint for deleted score validity\' | translate}}</p>\n</div>\n<div class=\"modal-footer\">\n    <div class=\"text-center\">\n        <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionYes()\" translate>buttons.Yes</button>\n        <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.actionNo()\" translate>buttons.No</button>\n    </div>\n</div>");
$templateCache.put("app/components/staffEditor/restoreStaffPermissionMessage.html","<div class=\"modal-header\">\n    <span class=\"modal-title text-danger text-center\">{{\'titles.Restore score\'|translate}}\n    </span>\n  </div>\n  <div class=\"modal-body\">\n      <p class=\"text-center\">{{\'messages.Alert for collaborator for restoring score\'|translate}}\n    </p>\n  </div>\n  <div class=\"modal-footer\">\n    <div class=\"text-center\">\n      <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.actionOk()\" translate>buttons.Ok</button>\n    </div>\n  </div>\n  ");
$templateCache.put("app/components/staffEditor/staffEditor.html","<swa-help-bar ng-if=\"vm.showHelpBar && !vm.staffEditorState.lockModeNavigation\" swa-help-tour-steps=\"vm.helpTourSteps\" swa-help-videos=\"vm.helpTourVideos\" swa-help-on-start=\"vm.onHelpTourStart()\"></swa-help-bar>\n<div class=\"mainOuter\" ng-class=\"{\'lockmodenavigation\': vm.staffEditorState.lockModeNavigation}\" ng-cloak>\n  <div class=\"navbar navbar-fixed-top sw-navbar\" ng-hide=\"vm.staffEditorState.lockModeNavigation || vm.staffVersionBrowserState.active\">\n    <div class=\"swtoolbar\" ng-hide=\"vm.deletedStaffListMode\">\n      <div class=\"swtoolbar-group pull-left\">\n        <img class=\"sws-logo sws-logo-link\" src=\"assets/images/sws-logo-light.png\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\" uib-tooltip=\"{{\'labels.Back to Productions\' | translate}}\">\n      </div>\n      <div class=\"swtoolbar-group pull-left\">\n        <button id=\"menu-locknavigation\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.toggleLockModeNavigation()\" ng-class=\"{\'sw-active\': vm.staffEditorState.lockModeNavigation}\" ng-disabled=\"vm.scenes.length === 0 || vm.sidebarEditState.destinationSelectVisible\" uib-tooltip=\"Toggle lock navigation mode\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-unlock\"></span>\n        </button>\n        <button id=\"menu-switchview\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.switchEditorView\" uib-tooltip=\"Switch to other Views\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <div class=\"sw-btn-toolbar-vcontent\">\n          <span class=\"title\">Score</span>\n          <span class=\"sw-ionicon-fw ion-arrow-down-b icon\"></span>\n        </div>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.switchEditorView\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.View</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-click=\"vm.switchEditor(0)\">\n                <span class=\"title\" translate>labels.Charts</span>\n              </div>\n              <div class=\"menu-item\" ng-disabled=\"true\">\n                <span class=\"title\" translate>labels.Score</span>\n              </div>\n              <div class=\"menu-item\" ng-click=\"vm.switchEditor(2)\">\n                <span class=\"title\" translate>labels.Charts and Score</span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n      <div class=\"swtoolbar-group pull-left\">\n        <button id=\"menu-addstaff\" class=\"btn sw-btn-toolbar\" ng-disabled=\"(vm.selectedScene.staffs.length >= vm.activePlanRules.allowedNumberOfStaffs) || (vm.selectedSceneId === undefined) || vm.sidebarEditState.enabled || !(vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowaddstaff)\" stackable-trigger=\"vm.addStaffWorkflowPopover\" uib-tooltip=\"Add new Staff\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-plus\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.addStaffWorkflowPopover\">\n          <div ng-show=\"vm.addStaffWorkflow.step === 1\">\n            <div class=\"sw-popover-title\">\n              <span translate>titles.Add Score</span>\n            </div>\n            <div class=\"sw-popover-menu\" role=\"menu\">\n              <div class=\"menu-group\">\n                <div class=\"menu-item\" ng-repeat=\"staffTemplate in vm.staffTemplates\" ng-click=\"vm.addStaffWorkflowSelectStaffType(staffTemplate.templateId)\">\n                  <span class=\"title\">\n                    <span class=\"pull-left\">{{staffTemplate.templatename}}</span>\n                    <span class=\"sw-ionicon sw-ionicon-fw ion-chevron-right pull-right\"></span>\n                  </span>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div ng-show=\"vm.addStaffWorkflow.step === 2\">\n            <div class=\"sw-popover-title\">\n              <button class=\"btn sw-btn-toolbar pull-left\" ng-click=\"vm.addStaffWorkflowStep1()\">\n                <span class=\"sw-ionicon sw-ionicon-fw ion-chevron-left\"></span>\n              </button>\n              <span translate>titles.Select Performers</span>\n              <button class=\"btn sw-btn-toolbar pull-right\">\n                <span class=\"sw-ionicon sw-ionicon-fw\"></span>\n              </button>\n            </div>\n            <div class=\"sw-popover-content sw-popover-performer-filter\">\n              <div class=\"swtoolbar\">\n                <div class=\"swtoolbar-group pull-left\">\n                  <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.addStaffWorkflowSelectAllPerformers()\" translate>buttons.Select All</button>\n                  <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.addStaffWorkflowClearPerformersSelection()\" translate>buttons.Clear</button>\n                </div>\n                <div class=\"swtoolbar-group pull-right\">\n                  <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.addStaffWorkflowDone()\" translate>buttons.Done</button>\n                </div>\n              </div>\n              <div class=\"sw-performer-filter-content\">\n                <div class=\"sw-performer-filter-row\" ng-click=\"aPerformer.addStaffSelected = !aPerformer.addStaffSelected\" ng-repeat=\"aPerformer in vm.performers\">\n                  <div class=\"pull-left\">\n                    <img height=\"30\" ng-src=\"data:image/png;base64,{{aPerformer.image}}\" width=\"30\">\n                  </div>\n                  <div class=\"pull-left sw-truncatetext name\">\n                    <span>{{aPerformer.name}}</span>\n                  </div>\n                  <div class=\"pull-right\">\n                    <span class=\"sw-ionicon-lg\" ng-class=\"{\n                        \'ion-ios-circle-outline\'\n                        : !aPerformer.addStaffSelected, \'ion-ios-checkmark - outline sw - color - red\': aPerformer.addStaffSelected}\"></span>\n                  </div>\n                </div>\n                <div class=\"sw-performer-filter-row text-center\" ng-if=\"vm.performers.length === 0\">\n                  <em class=\"sidebar-hint-text\" translate>labels.No Performers</em>\n                </div>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n        <button id=\"menu-filterperformers\" class=\"btn sw-btn-toolbar\" ng-class=\"{\'sw-active\':vm.performerFilterEnabled}\" stackable-trigger=\"vm.showPerformerFilter\" uib-tooltip=\"Performer filters\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg\" ng-class=\"{\'swafont-icon-filter\':vm.performerFilterEnabled === false, \'swafont-icon-filter-active\': vm.performerFilterEnabled === true}\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.showPerformerFilter\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.Filter Performers</span>\n          </div>\n          <div class=\"sw-popover-content sw-popover-performer-filter\">\n            <div class=\"swtoolbar\">\n              <div class=\"swtoolbar-group pull-left\">\n                <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.showAllPerformers()\" translate>buttons.Show All</button>\n              </div>\n              <div class=\"swtoolbar-group pull-right\">\n                <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.applyPerformerFilter()\" translate>buttons.Apply</button>\n              </div>\n            </div>\n            <div class=\"sw-performer-filter-content\">\n              <div class=\"sw-performer-filter-row\" ng-click=\"aPerformer.filterSelected = !aPerformer.filterSelected\" ng-repeat=\"aPerformer in vm.performers | limitTo: vm.activePlanRules.allowedNumberOfPerformers\">\n                <div class=\"pull-left\">\n                  <img height=\"30\" ng-src=\"data:image/png;base64,{{aPerformer.image}}\" width=\"30\">\n                </div>\n                <div class=\"pull-left sw-truncatetext name\">\n                  <span>{{aPerformer.name}}</span>\n                </div>\n                <div class=\"pull-right\">\n                  <span class=\"sw-ionicon-lg\" ng-class=\"{\n                      \'ion-ios-circle-outline\'\n                      : !aPerformer.filterSelected, \'ion-ios-checkmark-outline sw - color - red\': aPerformer.filterSelected}\"></span>\n                </div>\n              </div>\n              <div class=\"sw-performer-filter-row text-center\" ng-if=\"vm.performers.length === 0\">\n                <em class=\"sidebar-hint-text\" translate>labels.No Performers</em>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n      <div class=\"swtoolbar-group pull-left\">\n        <button id=\"menu-staffzoom\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.zoomPicker\" uib-tooltip=\"Score Zoom\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-zoom\"></span>\n          <span class=\"toolbar-zoom-value\" ng-hide=\"vm.staffEditorState.staffAutoFitWidth\" translate>labels.1x</span>\n          <span class=\"toolbar-zoom-value\" ng-show=\"vm.staffEditorState.staffAutoFitWidth\" translate>labels.Auto</span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.zoomPicker\">\n          <div class=\"sw-popover-title\">\n            <span>{{\'titles.Score Zoom\'| translate}}</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\" style=\"min-width: 176px\">\n              <div class=\"menu-item\" ng-click=\"vm.setStaffAutoFitWidth(false)\" ng-disabled=\"!vm.staffEditorState.staffAutoFitWidth\">\n                <span class=\"title\">\n                  <span translate>labels.Original Size</span>\n                  <span class=\"pull-right\">({{\'labels.1x\' | translate}})</span>\n                </span>\n              </div>\n              <div class=\"menu-item\" ng-click=\"vm.setStaffAutoFitWidth(true)\" ng-disabled=\"vm.staffEditorState.staffAutoFitWidth\">\n                <span class=\"title\">\n                  <span translate>labels.Auto Fit Width</span>\n                  <span class=\"pull-right\">({{\'labels.Auto\' | translate}})</span>\n                </span>\n              </div>\n            </div>\n          </div>\n        </stackable-popover>\n      </div>\n      <div class=\"swtoolbar-group pull-right\">\n        <button id=\"menu-savechanges\" class=\"btn sw-btn-toolbar\" ng-click=\"vm.onSaveClick()\" ng-disabled=\"!vm.selectedStaff.dirty\" uib-tooltip=\"Save changes\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-save\"></span>\n          <span class=\"toolbar-zoom-value\">{{vm.autoSaveState.timeoutSec}}</span>\n          <div class=\"progress-bar-container\" ng-show=\"vm.autoSaveState.timerActive\">\n            <span class=\"progress-bar\" ng-style=\"{width: (vm.autoSaveState.timeoutRemainingSec * 100 / vm.autoSaveState.timeoutMaxSec) +\'%\'}\"></span>\n          </div>\n        </button>\n        <button id=\"menu-createpdf\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.pdfOptionsPicker\" uib-tooltip=\"PDF / printing options\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-create-pdf\"></span>\n        </button>\n        <stackable-popover stackable-placement=\"bottom\" stackable-alignment=\"right\" stackable-enable-escape=\"true\" stackable=\"vm.pdfOptionsPicker\">\n          <div class=\"sw-popover-title\">\n            <span translate>titles.Create PDF</span>\n          </div>\n          <div class=\"sw-popover-menu\" role=\"menu\">\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllChartsStaffs)\">\n                <span class=\"title\" translate>labels.Production - Charts &amp; Score</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 1)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0) || !vm.script\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllChartsScript)\">\n                <span class=\"title\" translate>labels.Production - Charts &amp; PDF</span>\n              </div>\n              <div class=\"menu-item\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllCharts)\">\n                <span class=\"title\" translate>labels.Production - Charts</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.scenes || (vm.scenes.length === 0)\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.AllStaffs)\">\n                <span class=\"title\" translate>labels.Production - Score</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 1)\" ng-disabled=\"!vm.script\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.Script)\">\n                <span class=\"title\" translate>labels.Production - PDF</span>\n              </div>\n            </div>\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneChartsStaffs)\">\n                <span class=\"title\" translate>labels.Current Scene - Charts &amp; Score</span>\n              </div>\n              <div class=\"menu-item\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneCharts)\">\n                <span class=\"title\" translate>labels.Current Scene - Charts</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedScene\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentSceneStaffs)\">\n                <span class=\"title\" translate>labels.Current Scene - Score</span>\n              </div>\n            </div>\n            <div class=\"menu-group\">\n              <div class=\"menu-item\" ng-disabled=\"!vm.selectedChart\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentChart)\">\n                <span class=\"title\" translate>labels.Current Chart</span>\n              </div>\n              <div class=\"menu-item\" ng-if=\"(vm.selectedProduction.productiontype === 0)\" ng-disabled=\"!vm.selectedStaff\" ng-click=\"vm.pdfPrintOptionPrompt(vm.PdfPrintTypes.CurrentStaff)\">\n                <span class=\"title\" translate>labels.Current Score</span>\n              </div>\n            </div>\n            <div class=\"menu-group-title\">\n              <span translate>labels.Recent PDFs</span>\n            </div>\n            <div class=\"menu-group\" swa-print-job-list data-list=\"vm.printJobs\">\n            </div>\n          </div>\n        </stackable-popover>\n        <button id=\"menu-collaborators\" class=\"btn sw-btn-toolbar\" ng-show=\"vm.selectedProduction.collaborationsettings.length > 0\" uib-tooltip=\"Collaboration details\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span swa-show-collaborators data-production=\"vm.selectedProduction\" data-current-user-id=\"vm.userId\" class=\"sw-ionicon-2x ion-person-stalker\"></span>\n        </button>\n        <button id=\"menu-settings\" class=\"btn sw-btn-toolbar\" ui-sref=\"{{vm.swaRouterStateNames.productionsettings.details}}\" uib-tooltip=\"Production Settings\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n          <span class=\"swafont swafont-lg swafont-icon-settings\"></span>\n        </button>\n      </div>\n    </div>\n    <div class=\"swtoolbar\" ng-show=\"vm.deletedStaffListMode\">\n      <div class=\"swtoolbar-group pull-left\">\n        <img class=\"sws-logo sws-logo-link\" src=\"assets/images/sws-logo-light.png\">\n      </div>\n    </div>\n  </div>\n  <div class=\"swtoolbar swtoolbar-versionsbrowsermode text-center navbar-fixed-top\" ng-show=\"vm.deletedStaffListMode\">\n    <div class=\"swtoolbar-group pull-left\">\n      <img class=\"sws-logo\" src=\"assets/images/sws-logo-light.png\">\n    </div>\n    <div class=\"swtoolbar-group pull-left\">\n    </div>\n    <div class=\"swtoolbar-group swtoolbar-group-centered\" ng-show=\"vm.deletedStaffListMode && vm.selectedStaff && !vm.sidebarEditState.destinationSelectVisible\">\n      <span class=\"swa-color-white text-lg text-right sw-truncatetext\" style=\"min-width: 700px; width: 700px; display: inline-block; text-align: left\" uib-tooltip=\"SCORE REMOVED BY:\n        {{ vm.staffVersionBrowserState.selectedVersion.displayName ? vm.staffVersionBrowserState.selectedVersion.displayName : \'\' }}\n        on {{ vm.staffVersionBrowserState.selectedVersion.archiveDate.$date | date:\'MMM dd, yyyy \\\'at\\\' hh:mm a\' }}\n        {{ vm.staffVersionBrowserState.selectedVersion.staff.platform ? \' on \' + vm.staffVersionBrowserState.selectedVersion.staff.platform : \'\' }}\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        SCORE REMOVED BY:\n        {{ vm.staffVersionBrowserState.selectedVersion.displayName ? vm.staffVersionBrowserState.selectedVersion.displayName : \'\' }}\n        on {{ vm.staffVersionBrowserState.selectedVersion.archiveDate.$date | date:\'MMM dd, yyyy \\\'at\\\' hh:mm a\' }}\n        {{ vm.staffVersionBrowserState.selectedVersion.staff.platform ? \' on \' + vm.staffVersionBrowserState.selectedVersion.staff.platform : \'\' }}\n      </span>\n      <span class=\"spacer16\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.staffVersionPrevious()\" ng-disabled=\"!vm.staffVersionBrowserState.prevEnabled || vm.staffVersionBrowserState.staffVersions.length === 0\" uib-tooltip=\"Open previous version\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"sw-ionicon-fw ion-chevron-left\"></span>\n      </button>\n      <span class=\"spacer8\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.staffVersionNext()\" ng-disabled=\"!vm.staffVersionBrowserState.nextEnabled || vm.staffVersionBrowserState.staffVersions.length === 0\" uib-tooltip=\"Open next version\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"sw-ionicon-fw ion-chevron-right\"></span>\n      </button>\n      <span class=\"spacer16\"></span>\n      <button class=\"btn sw-btn-default\" ng-click=\"vm.restoreStaff()\" uib-tooltip=\"Restore this version\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        Restore\n      </button>\n      <span class=\"spacer16\"></span>\n    </div>\n  </div>\n  <div class=\"swtoolbar swtoolbar-lockmode text-center\" ng-show=\"vm.staffEditorState.lockModeNavigation\">\n    <div class=\"swtoolbar-group pull-left\">\n      <img class=\"sws-logo\" src=\"assets/images/sws-logo-light.png\">\n    </div>\n    <div class=\"swtoolbar-group pull-left\">\n      <button class=\"btn sw-btn-toolbar\" ng-click=\"vm.toggleLockModeNavigation()\" ng-class=\"{\'sw-active\': vm.staffEditorState.lockModeNavigation}\" uib-tooltip=\"Toggle lock navigation mode\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n        <span class=\"swafont swafont-lg swafont-icon-lock\"></span>\n      </button>\n      <button id=\"menu-switchview2\" class=\"btn sw-btn-toolbar\" stackable-trigger=\"vm.switchEditorView2\" uib-tooltip=\"Switch to other Views\" tooltip-placement=\"auto bottom\" tooltip-popup-delay=\"1000\">\n      <div class=\"sw-btn-toolbar-vcontent\">\n        <span class=\"title\">Score</span>\n        <span class=\"sw-ionicon-fw ion-arrow-down-b icon\"></span>\n      </div>\n      </button>\n      <stackable-popover stackable-placement=\"bottom\" stackable=\"vm.switchEditorView2\">\n        <div class=\"sw-popover-title\">\n          <span translate>titles.View</span>\n        </div>\n        <div class=\"sw-popover-menu\" role=\"menu\">\n          <div class=\"menu-group\">\n            <div class=\"menu-item\" ng-click=\"vm.switchEditor(0)\">\n              <span class=\"title\" translate>labels.Charts</span>\n            </div>\n            <div class=\"menu-item\" ng-disabled=\"true\">\n              <span class=\"title\" translate>labels.Score</span>\n            </div>\n            <div class=\"menu-item\" ng-click=\"vm.switchEditor(2)\">\n              <span class=\"title\" translate>labels.Charts and Score</span>\n            </div>\n          </div>\n        </div>\n      </stackable-popover>\n    </div>\n    <div class=\"swtoolbar-group swtoolbar-group-centered\">\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationPreviousScene()\">\n        <span class=\"sw-ionicon-fw ion-chevron-left\"></span>\n        {{\'buttons.Scene\' | translate}}\n      </button>\n      <span class=\"spacer8\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationPreviousStaff()\">\n        <span class=\"sw-ionicon-fw ion-chevron-left\"></span>\n        {{\'buttons.Score\' | translate}}\n      </button>\n      <span class=\"spacer16\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationNextStaff()\">\n        {{\'buttons.Score\' | translate}}\n        <span class=\"sw-ionicon-fw ion-chevron-right\"></span>\n      </button>\n      <span class=\"spacer8\"></span>\n      <button class=\"btn btn-sm sw-btn-default\" ng-click=\"vm.lockNavigationNextScene()\">\n        {{\'buttons.Scene\' | translate}}\n        <span class=\"sw-ionicon-fw ion-chevron-right\"></span>\n      </button>\n    </div>\n    <div class=\"swtoolbar-group pull-right\">\n      <span class=\"swa-color-lightgray sw-text-lg\" translate>titles.Score View</span>\n    </div>\n  </div>\n  <div>\n    <div id=\"sidebar-scenelist\" class=\"sw-sidebar sw-parent-staff-options sw-sidebar-left\" ng-class=\"{\'sw-sidebar-edit\': vm.sidebarEditState.enabled}\" ng-hide=\"vm.staffEditorState.lockModeNavigation\">\n      <div class=\"sw-navbar sw-navbar-top sw-color-red\">\n        <div class=\"swtoolbar\" ng-hide=\"vm.sidebarEditState.destinationSelectVisible || vm.deletedStaffListMode\">\n          <button id=\"button-closeproduction\" class=\"btn btn-lg sw-btn-toolbar\" ui-sref=\"{{vm.swaRouterStateNames.productionlist}}\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n          <div class=\"text-lg sw-truncatetext\" style=\"width: calc(100% - 50px)\">\n            <span>{{vm.selectedProduction.name}}</span>\n          </div>\n        </div>\n        <div class=\"swtoolbar swa-color-white\" ng-show=\"vm.sidebarEditState.destinationSelectVisible\">\n          <button class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.sidebarEditState.destinationSelectVisible = false; vm.toggleSidebarEditModeForScore()\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n          <h4 class=\"text-lg sw-truncatetext\" ng-show=\"vm.sidebarEditState.destinationSelectForCopy\" translate>titles.Copy to</h4>\n          <h4 class=\"text-lg sw-truncatetext\" ng-show=\"vm.sidebarEditState.destinationSelectForMove\" translate>titles.Move to</h4>\n          <h4 class=\"text-lg sw-truncatetext\" ng-show=\"vm.sidebarEditState.destinationSelectForRestore\" translate>titles.Restore to</h4>\n        </div>\n        <div class=\"swtoolbar swa-color-white\" ng-show=\"vm.deletedStaffListMode && !vm.sidebarEditState.enabled\">\n          <button class=\"btn btn-lg sw-btn-toolbar\" ng-click=\"vm.leaveDeletedStaffList()\">\n            <span class=\"ion-chevron-left\"></span>\n          </button>\n          <h4 class=\"text-lg sw-truncatetext swa-color-white\" translate>\n              titles.Removed Scores</h4>\n        </div>\n      </div>\n      <div class=\"scrollcontainer\" ng-scrollbars ng-scrollbars-config=\"vm.scrollConfigSidebar\" ng-scrollbars-update=\"vm.scrollUpdateSidebar\">\n        <uib-accordion class=\"sidebar-scenecontents-list\" close-others=\"true\" ng-hide=\"vm.sidebarEditState.destinationSelectVisible || vm.deletedStaffListMode\">\n          <div uib-accordion-group class=\"stickyheader\" is-open=\"false\" ng-show=\"vm.sceneSticky\">\n            <uib-accordion-heading>\n              <div class=\"sw-color-red\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleScene(vm.selectedScene)\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{vm.selectedScene.scenename}}</span>\n                </div>\n                <div class=\"pull-right\">\n                  <span class=\"sw-ionicon-fw ion-chevron-down\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n          </div>\n          <div uib-accordion-group id=\"scene-group-{{$index}}\" is-open=\"scene.open\" ng-repeat=\"scene in vm.scenes | limitTo: vm.activePlanRules.allowedNumberOfScenes\">\n            <uib-accordion-heading>\n              <div ng-class=\"{\'sw-color-red\': scene.open}\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleScene(scene)\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{scene.scenename}}</span>\n                </div>\n                <div class=\"pull-right\">\n                  <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-chevron-down\': scene.open, \'ion-chevron-right\': !scene.open}\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n            <div ng-cloak ng-model=\"scene.staffs\" ui-sortable=\"vm.staffSortableOptions\">\n              <div id=\"staff-{{staff._id}}\" class=\"sidebar-staff-row sidebar-chart-row-ellipsis\" ng-class=\"{\'selected\': vm.selectedStaffOrderingIndex === staff.orderingindex}\" ng-click=\"vm.sidebarSelectStaffAtIndex($index, $event)\" ng-repeat=\"staff in scene.staffs | limitTo: vm.activePlanRules.allowedNumberOfStaffs\">\n                <div class=\"title sw-truncatetext\">\n                  <span>{{staff.assignedName}}</span>\n                </div>\n                <div class=\"pull-right\" ng-show=\"!scene.accessRules.allowowneraccess || staff.syncCollision\">\n                  <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-person-stalker\': scene.accessRules.allowstaffediting, \'ion-locked\': !scene.accessRules.allowstaffediting, \'swa-color-accentred\': staff.syncCollision}\"></span>\n                </div>\n                <div>\n                  <button id=\"sideBarDeleteAndMoveOptionsMenuButton\" class=\"btn btn-sm sw-btn-toolbar sw-chart-otions\" id=\"sidebar-scriptannotationlayersettings_{{$index}}\" ng-hide=\"(vm.sidebarEditState.enabled || !(vm.selectedScene.accessRules.allowmovestaffsource || vm.selectedScene.accessRules.allowdeletestaff || vm.selectedScene.accessRules.allowcopystaffsource)) || vm.activePlanRules.planId === 2 || vm.activeCollaborationConfig.collaborationSetting.collaborationaccess.accesslevel === 2\" ng-click=\"vm.showSideBarDeleteAndMoveOptions($event)\">\n                    <div>&#xFE19;</div>\n                  </button>\n                  <div class=\"pull-right\" ng-show=\"vm.sidebarEditState.enabled && !vm.movingSingleScore && !vm.copyingSingleScore && !restoringSingleStaff\">\n                    <span class=\"sw-ionicon-fw sw-ionicon-lg sw-staff-checkbox\" ng-class=\"{\'ion-ios-circle-outline\': !staff.editSelected, \'ion-ios-checkmark sw-color-red\': staff.editSelected}\" style=\"cursor: pointer\"></span>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"sidebar-staff-row text-center\" ng-if=\"scene.nostaffs\">\n              <em class=\"sidebar-hint-text\" translate>labels.No Scores</em>\n            </div>\n          </div>\n        </uib-accordion>\n        <div class=\"sidebar-destination-scene-list sidebar-destination-scene-list-parent\" ng-if=\"vm.sidebarEditState.destinationSelectVisible\">\n          <div class=\"message\" ng-show=\"vm.sidebarEditState.destinationSelectForMove\">\n            <p>Choose a position to move the selected scores.</p>\n          </div>\n          <div class=\"message\" ng-show=\"vm.sidebarEditState.destinationSelectForCopy\">\n            <p>Choose a position to copy the selected scores.</p>\n          </div>\n          <div class=\"message\" ng-show=\"vm.sidebarEditState.destinationSelectForRestore\">\n            <p>Choose a position to restore the selected score.</p>\n          </div>\n        </div>\n        <uib-accordion class=\"sidebar-scenecontents-list sidebar-destination-scene-list\" ng-if=\"vm.sidebarEditState.destinationSelectVisible\" close-others=\"true\">\n          <div uib-accordion-group class=\"stickyheader\" is-open=\"false\" ng-show=\"vm.sceneSticky\">\n            <uib-accordion-heading>\n              <div class=\"sw-color-red\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleScene(vm.selectedScene);\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{vm.selectedScene.scenename}}</span>\n                </div>\n                <div class=\"pull-right\">\n                  <span class=\"sw-ionicon-fw ion-chevron-down\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n          </div>\n          <div uib-accordion-group id=\"scene-group-{{$index}}\" is-open=\"scene.open\" ng-repeat=\"scene in vm.scenes | limitTo: vm.activePlanRules.allowedNumberOfScenes\">\n            <uib-accordion-heading>\n              <div class=\"main-dropdown\" ng-class=\"{\'sw-color-red\': scene.open}\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleScene(scene)\" ng-disabled=\"!(scene.accessRules.allowowneraccess || scene.accessRules.allowcopystaffdestination || scene.accessRules.allowmovestaffdestination) || (scene._id === vm.sourceSceneId)\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{scene.scenename}}</span>\n                </div>\n                <div class=\"pull-right\" ng-hide=\"!(scene.accessRules.allowowneraccess || scene.accessRules.allowmovestaffdestination) || (scene._id === vm.sourceSceneId)\">\n                  <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-chevron-down\': scene.open, \'ion-chevron-right\': !scene.open}\"></span>\n                </div>\n                <div class=\"access-icon\" ng-hide=\"scene.accessRules.allowstaffediting\">\n                  <span class=\"sw-ionicon-fw sw-ionicon-sm\" ng-class=\"{\'ion-locked\':!scene.accessRules.allowstaffediting}\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n            <div class=\"sidebar-staff-row sw-color-mediumlightgray\" ng-style=\"{\'margin-bottom\': scene.nostaffs ? \'0\' : \'2px\' }\" style=\"font-style: italic\" ng-click=\"vm.moveScoreAtSpecificIndex = false; vm.sidebarEditSelectDestinationSceneAtIndex($index)\">\n              <div>\n                <span class=\"title sw-truncatetext\" ng-show=\"vm.sidebarEditState.destinationSelectForMove\" translate>labels.Move here</span>\n                <span class=\"title sw-truncatetext\" ng-show=\"vm.sidebarEditState.destinationSelectForCopy\" translate>labels.Copy here</span>\n                <span class=\"title sw-truncatetext\" ng-show=\"vm.sidebarEditState.destinationSelectForRestore\" translate>labels.Restore here</span>\n              </div>\n            </div>\n            <div ng-cloak ng-model=\"scene.staffs\" ui-sortable=\"vm.staffSortableOptions\">\n              <div id=\"staff-{{staff._id}}\" class=\"sidebar-staff-row\" ng-class=\"{\'selected\': vm.selectedStaffOrderingIndex === staff.orderingindex}\" ng-click=\"vm.moveScoreAtSpecificIndex = true; vm.sidebarEditSelectDestinationSceneAtIndex($index)\" ng-repeat=\"staff in scene.staffs | limitTo: vm.activePlanRules.allowedNumberOfStaffs\">\n                <div class=\"scene-child\">\n                  <div class=\"title sw-truncatetext\">\n                    <span>{{staff.assignedName}}</span>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </uib-accordion>\n        <uib-accordion ng-hide=\"!vm.deletedStaffListMode || vm.restoringSingleStaff\" id=\"scene-accordion\" class=\"sidebar-scenecontents-list\" close-others=\"true\">\n          <div uib-accordion-group class=\"stickyheader\" is-open=\"false\" ng-show=\"vm.sceneSticky\">\n            <uib-accordion-heading>\n              <div class=\"sw-color-red\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleRemovedStaffsScene(vm.selectedScene);\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{vm.selectedScene.scenename}}</span>\n                </div>\n                <div class=\"pull-right\">\n                  <span class=\"sw-ionicon-fw ion-chevron-down\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n          </div>\n          <div uib-accordion-group id=\"scene-group-{{scene.orderingindex}}\" is-open=\"scene.open\" ng-repeat=\"scene in vm.dummyScenesForRemovedStaffs\">\n            <uib-accordion-heading>\n              <div ng-class=\"{\'sw-color-red\': scene.open}\" ng-click=\"$event.preventDefault();$event.stopPropagation();vm.toggleRemovedStaffsScene(scene)\">\n                <div class=\"name sw-truncatetext\">\n                  <span>{{scene.scenename}}</span>\n                </div>\n                <div class=\"chevron pull-right\">\n                  <span class=\"sw-ionicon-fw\" ng-class=\"{\'ion-chevron-down\': scene.open, \'ion-chevron-right\': !scene.open}\"></span>\n                </div>\n              </div>\n            </uib-accordion-heading>\n            <div>\n              <div id=\"chart-{{deletedStaff._id}}\" class=\"sidebar-chart-row sidebar-selction-state\" ng-click=\"vm.sidebarSelectDeletedStaffAtIndex($index)\" data-ng-repeat=\"deletedStaff in scene.staffs\" ng-class=\"{\'selected\': vm.selectedStaffOrderingIndex === deletedStaff.index}\">\n                <div class=\"chart-item-block\">\n                  <div class=\"removed-scores-title\">\n                    <div class=\"sw-truncatetext\">\n                      <span>{{deletedStaff.staffNameBeforeDeleting}}</span><br>\n                      <span class=\"removed-scores-scenename\">(Scene: {{deletedStaff.sceneNameBeforeDeleting}})</span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"sidebar-staff-row text-center\" ng-if=\"(scene.staffs.length === 0)\">\n              <em class=\"sidebar-hint-text\" translate>labels.No Scores</em>\n            </div>\n          </div>\n        </uib-accordion>\n      </div>\n      <div class=\"sw-navbar sw-navbar-bottom swtoolbar-flex-align-center swtoolbar-justify-center swtoolbar-flex\">\n        <button id=\"show-trash\" class=\"btn btn-md sw-btn-secondary\" ng-click=\"vm.enterDeletedStaffList()\" ng-hide=\"vm.deletedStaffListMode || vm.sidebarEditState.enabled\">\n          <span>{{\'titles.Removed Scores\'|translate}}</span>\n        </button>\n        <!-- <div class=\"swtoolbar text-center\" ng-show=\"vm.sidebarEditState.destinationSelectVisible\">\n          <button class=\"btn sw-btn-danger\" ng-click=\"vm.sidebarEditState.destinationSelectVisible = false\" translate>buttons.Cancel</button>\n        </div>\n        <div class=\"swtoolbar text-center\" ng-show=\"vm.sidebarEditState.enabled && !vm.sidebarEditState.destinationSelectVisible\">\n          <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.sidebarShowDestinationSceneListForCopy()\" ng-disabled=\"vm.sidebarEditState.selectionCount < 1\" translate>buttons.Copy</button>\n          <button\n            class=\"btn btn-sm sw-btn-secondary\"\n            ng-click=\"vm.sidebarShowDestinationSceneListForMove()\"\n            ng-disabled=\"!((vm.sidebarEditState.selectionCount > 0) && (vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowmovestaffsource))\"\n            translate>buttons.Move</button>\n          <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.deleteSelectedStaffs()\" ng-disabled=\"!((vm.sidebarEditState.selectionCount > 0) && (vm.activeAccessRules.allowowneraccess || vm.activeAccessRules.allowdeletestaff))\" translate>buttons.Delete</button>\n          <button class=\"btn sw-btn-default\" ng-click=\"vm.toggleSidebarEditMode()\" translate>buttons.Done</button>\n        </div>\n        <div class=\"swtoolbar text-center\" ng-hide=\"vm.sidebarEditState.enabled\">\n          <button id=\"sidebar-copymovedelete\" class=\"btn sw-btn-secondary\" ng-click=\"vm.toggleSidebarEditMode()\" ng-disabled=\"(vm.scenes.length === 0) || (vm.activePlanRules.planId == 2)\" translate>buttons.Copy / Move / Delete</button>\n        </div> -->\n      </div>\n    </div>\n    <!-- -- -->\n    <div id=\"sideBarDeleteAndMoveOptionsMenu\" class=\"stackable-popover-conten\" ng-show=\"vm.chartSidebarDeleteAndMoveOptionState.visible === true\">\n      <div class=\"sw-chart-modal\" ng-style=\"{ top: vm.menuTop + \'px\', left: vm.menuLeft + \'px\'}\">\n        <div class=\"sw-popover-menu\" role=\"menu\">\n          <div class=\"menu-group\">\n            <span class=\"sw-ionicon-fw ion-arrow-down-b icon chart-left-arrow\"></span>\n            <div class=\"menu-item\">\n              <span class=\"title\" ng-click=\"vm.copySingleStaff(); vm.hideSideBarDeleteAndMoveOptions()\" translate>labels.Copy</span>\n            </div>\n            <div class=\"menu-item\" ng-disabled=\"!vm.selectedScene.accessRules.allowmovestaffsource\">\n              <span class=\"title\" ng-click=\"vm.moveSingleStaff(); vm.hideSideBarDeleteAndMoveOptions()\" translate>labels.Move</span>\n            </div>\n            <div class=\"menu-item\" ng-disabled=\"!vm.selectedScene.accessRules.allowdeletestaff\">\n              <span class=\"title\" ng-click=\"vm.deleteMultipleScores = false; vm.deleteStaffPrompt(); vm.hideSideBarDeleteAndMoveOptions()\" translate>labels.Delete</span>\n            </div>\n            <!-- <div class=\"menu-item\">\n              <span class=\"title\" ng-click=\"vm.hideSideBarDeleteAndMoveOptions()\" translate>labels.Done</span>\n            </div> -->\n\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- -- -->\n    <div class=\"stackable-popover-conten\" ng-show=\"vm.sidebarEditState.enabled && !vm.sidebarEditState.destinationSelectVisible && !vm.movingSingleScore && !vm.copyingSingleScore && !vm.restoringSingleStaff\">\n      <div class=\"sw-chart-modal\" ng-style=\"{ top: 100 + \'px\', left: 225 + \'px\'}\">\n        <div class=\"sw-popover-menu\" role=\"menu\">\n          <div class=\"menu-group\">\n            <span class=\"sw-ionicon-fw ion-arrow-down-b icon chart-left-arrow\"></span>\n            <div class=\"menu-item\" ng-disabled=\"vm.sidebarEditState.selectionCount < 1\">\n              <span class=\"title\" ng-click=\"vm.sidebarShowDestinationSceneListForCopy()\" translate>\n                labels.Copy selected</span>\n            </div>\n            <div class=\"menu-item\" ng-disabled=\"vm.sidebarEditState.selectionCount < 1 || !vm.selectedScene.accessRules.allowmovestaffsource\">\n              <span class=\"title\" ng-click=\"vm.sidebarShowDestinationSceneListForMove()\" translate>\n                labels.Move selected</span>\n            </div>\n            <div class=\"menu-item\" ng-disabled=\"vm.sidebarEditState.selectionCount < 1 || !vm.selectedScene.accessRules.allowdeletestaff\">\n              <span class=\"title\" ng-click=\"vm.deleteMultipleScores = true; vm.deleteStaffPrompt()\" translate>labels.Delete selected</span>\n            </div>\n            <!-- <div class=\"menu-item\">\n              <span class=\"title\" ng-click=\"vm.clearAllChartEditModeSelections()\" translate>\n                labels.Clear selections</span>\n            </div> -->\n            <div class=\"menu-item\">\n              <span class=\"title\" ng-show=\"!vm.sidebarEditState.destinationSelectVisible\" ng-click=\"vm.toggleSidebarEditMode()\" translate>labels.Done</span>\n              <span class=\"title\" ng-show=\"vm.sidebarEditState.destinationSelectVisible\" ng-click=\"vm.sidebarEditState.destinationSelectVisible = false\" translate>labels.Cancel</span>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n    <!-- -- -->\n    <div id=\"score-list\" class=\"sw-maincontentarea-staff sw-editorcontent\" ng-class=\"{\'sw-color-bg-white\': (vm.staffEditorState.showingStaffContent && !vm.sidebarEditState.enabled)\n    || (vm.deletedStaffListMode && vm.staffVersionBrowserState.selectedVersion && vm.selectedStaff)\n    || (vm.sidebarEditState.enabled && vm.restoringSingleStaff)}\" ng-click=\"vm.hideSideBarDeleteAndMoveOptions();\">\n      <div class=\"staffeditingcontrolscontainer\">\n        <div class=\"staffeditingcontrols\" id=\"staffeditingcontrols\" ng-show=\"vm.staffEditingControlsState.controlsVisible\">\n          <div class=\"buttonsbar\" id=\"functionbuttons\">\n            <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.staffEditingEditCell()\" ng-disabled=\"vm.staffEditingControlsState.editDisabled\">\n              Edit\n            </button>\n            <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.staffEditingResizeCell()\" ng-disabled=\"vm.staffEditingControlsState.resizeDisabled\">\n              Resize\n            </button>\n            <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.staffEditingDeleteCell()\" ng-disabled=\"vm.staffEditingControlsState.deleteDisabled\">\n              Clear\n            </button>\n            <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.staffEditingDone()\" ng-disabled=\"false\">\n              Done\n            </button>\n          </div>\n          <div class=\"buttonsbar\" ng-show=\"vm.staffEditingControlsState.clipboardOptionsVisible && !vm.staffEditingControlsState.sizingOptionsVisible\">\n            <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.staffEditingCutCell()\" ng-disabled=\"vm.staffEditingControlsState.cutDisabled\">\n              Cut\n            </button>\n            <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.staffEditingCopyCell()\" ng-disabled=\"vm.staffEditingControlsState.copyDisabled\">\n              Copy\n            </button>\n            <button class=\"btn btn-sm sw-btn-secondary\" ng-click=\"vm.staffEditingPasteCell()\" ng-disabled=\"!vm.staffClipboard.hasContent || vm.staffEditingControlsState.pasteDisabled\">\n              Paste\n            </button>\n          </div>\n        </div>\n      </div>\n      <div id=\"staffscrollview\" class=\"staffscrollview\" ng-show=\"!vm.sidebarEditState.enabled || (vm.sidebarEditState.enabled && vm.restoringSingleStaff)\"></div>\n    </div>\n    <div class=\"sw-maincontentarea-staff sw-editorcontent\" ng-show=\"!vm.staffEditorState.showingStaffContent\">\n      <div class=\"text-center sw-color-lightgray\" style=\"top: 50%; transform: translateY(-50%); position:relative\">\n        <div ng-hide=\"(vm.deletedStaffListMode && vm.selectedStaff) || (vm.restoringSingleStaff)\" style=\"margin-bottom: 16px\">\n          <span class=\"sw-text-xlg\" translate>titles.Scores View</span>\n        </div>\n        <div class=\"show-when-blocked\">\n          <span>Loading ...</span>\n        </div>\n        <div class=\"hide-when-blocked\">\n          <div ng-show=\"vm.selectedProduction && (vm.scenes.length === 0) && !vm.deletedStaffListMode\">\n            <span class=\"sw-text-lg\" translate>messages.No Scenes in this Production</span><br>\n          </div>\n          <span class=\"sw-text-lg\" ng-show=\"(vm.scenes.length !== 0) && !vm.sidebarEditState.enabled && (vm.selectedSceneId === undefined) && !vm.deletedStaffListMode\" translate>labels.No Scene</span>\n          <span ng-show=\"vm.deletedStaffListMode && !vm.restoringSingleStaff\" translate>labels.Select a score to preview</span>\n          <span class=\"sw-text-lg\" ng-if=\"!vm.deletedStaffListMode\" ng-show=\"!vm.sidebarEditState.enabled && (vm.selectedSceneId !== undefined) && !vm.staffEditorState.showingStaffContent && (vm.selectedScene.staffs.length === 0)\" translate>labels.No Scores in Scene</span>\n          <span class=\"sw-text-lg\" ng-hide=\"!vm.sidebarEditState.enabled || (vm.sidebarEditState.enabled && vm.restoringSingleStaff)\" translate>labels.Edit Mode</span>\n        </div>\n      </div>\n    </div>\n    <div class=\"sw-maincontentarea-staff-footer sw-color-bg-sidebar\">\n      <span class=\"sw-text-xlg swa-color-lightgray\">{{vm.selectedScene.scenename}}</span>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/videoSlider/videoSlider.html","<div class=\"modal-header\">\n  <span class=\"modal-title sw-color-red\" translate>titles.Help Videos</span>\n  <button type=\"button\" class=\"btn sw-btn-toolbar pull-right\" ng-click=\"vm.modalClose()\">\n    <span class=\"sw-color-red sw-ionicon-lg ion-close-round\"></span>\n  </button>\n</div>\n<div class=\"modal-body\">\n  <slick init-onload=\"false\" slick-apply=\"slickApply\" data=\"dataLoaded\" slides-to-show=\"1\" dots=\"true\">\n    <div class=\"item\" ng-repeat=\"video in vm.videos\">\n      <iframe id=\"videoIframe-{{$index}}\" class=\"videoIframe\" width=\"870\" height=\"490\" ng-load=\"vm.iframeLoadComplete()\" src=\"{{vm.trustSrc(video.videoUrl)}}\" frameborder=\"0\" allowfullscreen></iframe>\n    </div>\n  </slick>\n</div>\n");
$templateCache.put("app/components/productionSettings/collaboration/existingCollaboratorsIgnorePrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title\">{{\'titles.Add Collaborators\' | translate}}\n    <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <p class=\"\">{{\'messages.existing_collaborators_list\'|translate}}<br>\n    <ul>\n      <li ng-repeat=\"email in vm.existingEmails\">{{email}}</li>\n    </ul>\n    <strong><br>{{\'messages.Ignore them and add others?\' | translate}}</strong>\n  </p>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.confirmAction()\" translate>buttons.Yes</button>\n  <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.cancelAction()\" translate>buttons.No</button>\n</div>\n");
$templateCache.put("app/components/productionSettings/collaboration/setMeasurementPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title\">\n    {{\'titles.Measure from Image\' | translate}}\n    <span class=\"pull-right modal-close-icon\" ng-click=\"vm.cancelAction()\">\n      <span class=\"ion-close-round\"></span>\n    </span>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <div>\n    <span>Draw a line on the object in the image to use as a measurement reference. Provide the object\'s size and the image dimensions will be automatically calculated. You can zoom in using the mouse wheel and move the image by holding the shift button and dragging the image.</span><br><br>\n  </div>\n  <ul id=\"dimensions\">\n    <li class=\"dimension-list\">\n      <div id=\"ref-measurement-wrapper\">\n        <span style=\"margin-right: 10px\">Reference measurement: </span>\n        <input type=\"number\" id=\"refMeasurement\" ng-if=\"vm.setPiece.measurementunit === 1\" class=\"form-control text-right\" name=\"refMeasurement\" value=\"\" ng-model=\"vm.refMeasurement\" ng-change=\"vm.calculate();\" style=\"width: 80px; margin-right: 5px\" ng-disabled=\"!vm.refMeasurementInput\" swa-select-on-focus>\n        <input type=\"number\" id=\"refMeasurement\" ng-if=\"vm.setPiece.measurementunit === 0\" class=\"form-control text-right\" name=\"refMeasurementFeet\" value=\"\" ng-model=\"vm.refMeasurementUnit.feet\" ng-change=\"vm.onblurCalculateWH();\" style=\"width: 80px; margin-right: 5px\" ng-disabled=\"!vm.refMeasurementInput\" swa-select-on-focus>\n        <label class=\"control-label\">{{vm.measurementunitabbr}}</label>\n        <input type=\"number\" id=\"refMeasurement\" ng-if=\"vm.setPiece.measurementunit === 0\" class=\"form-control text-right\" name=\"refMeasurementInch\" value=\"\" ng-model=\"vm.refMeasurementUnit.inch\" ng-change=\"vm.onblurCalculateWH();\" ng-blur=\"vm.onblurCalculateWH()\" style=\"width: 80px; margin-right: 5px; margin-left: 5px\" ng-disabled=\"!vm.refMeasurementInput\" swa-select-on-focus>\n        <label class=\"control-label\" ng-if=\"vm.setPiece.measurementunit === 0\" translate>labels.Inch-abbreviation</label>\n        <button class=\"btn sw-btn-danger sw-btn-min-w-80 mrgnLeft5\" ng-click=\"vm.resetMeasurement()\" ng-disabled=\"!vm.refMeasurementInput\" translate>buttons.Reset</button>\n      </div>\n    </li>\n    <li class=\"dimension-list\">\n      <span>Width:</span><span style=\"display: inline-block; min-width: 80px; margin-left: 4px\">{{vm.measurementsWithUnit.width}}</span>\n      <span>Depth:</span><span style=\"display: inline-block; min-width: 80px; margin-left: 4px\">{{vm.measurementsWithUnit.depth}}</span>\n      <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-disabled=\"vm.measurements.width === 0 && vm.measurements.depth === 0\" ng-click=\"vm.confirmAction()\" translate>buttons.Use these values</button>\n    </li>\n  </ul>\n  <div id=\"image-wrapper\" style=\"position: relative\">\n    <div id=\"slide\">\n      <img id=\"image\" ng-src=\"data:image/png;base64,{{vm.setPiece.image|| \'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=\'}}\" style=\"display: block; margin: 0 auto\">\n    </div>\n    <div swa-wheel-zoom=\"vm.scrollZoom($anchor, $delta)\">\n      <canvas id=\"canvas\" ng-mousedown=\"vm.onMouseDown($event)\" ng-mousemove=\"vm.onMouseMove($event)\" ng-mouseup=\"vm.onMouseUp($event)\"></canvas>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/collaboration/stopCollaboratingPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title\">{{\'titles.Stop Collaborating\' | translate}}\n    <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\">\n    <span>{{\'messages.stop_collaborating_prompt\'|translate}}</span>\n    <br><br>\n    <span ng-show=\"vm.isMasterCollaborator\">{{\'messages.stop_collaborating_master_prompt2\'|translate}}<br><br></span>\n    <strong>{{\'messages.Are you sure?\' | translate}}</strong>\n  </p>\n</div>\n<div class=\"modal-footer text-center\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.confirmAction()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.cancelAction()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/collaboration/stopCollaborationPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title\">{{\'titles.Stop Collaboration\' | translate}}\n    <span class=\"pull-right sw-ionicon-lg ion-alert-circled\"></span>\n  </span>\n</div>\n<div class=\"modal-body\">\n  <p class=\"text-center\">\n    <span>{{\'messages.stop_collaboration_prompt\'|translate}}</span>\n    <br><br>\n    <span ng-show=\"vm.isMasterCollaborator\">{{\'messages.stop_collaboration_master_prompt2\'|translate}}<br><br></span>\n    <strong>{{\'messages.Are you sure?\' | translate}}</strong>\n  </p>\n</div>\n<div class=\"modal-footer text-center\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" ng-click=\"vm.confirmAction()\" translate>buttons.Yes</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.cancelAction()\" translate>buttons.No</button>\n  </div>\n</div>\n");
$templateCache.put("app/components/productionSettings/collaboration/transferOwnershipPrompt.html","<div class=\"modal-header\">\n  <span class=\"modal-title\" translate>titles.Transfer Ownership</span>\n</div>\n<div class=\"modal-body\">\n  <div class=\"form-horizontal\">\n    <form id=\"transferOwnership\" name=\"vm.transferOwnershipForm\" role=\"form\" novalidate=\"\" ng-submit=\"vm.transferAction()\">\n      <div class=\"form-group\">\n        <div class=\"col-lg-12\">\n          <span class=\"sw-text-lg swa-color-lightgray ng-scope\" translate>labels.New owner\'s email address</span>\n        </div>\n        <div class=\"col-lg-12\">\n          <input id=\"newOwnerEmail\" name=\"newOwnerEmail\" class=\"form-control\" ng-model=\"vm.transferParams.newOwnerEmail\" type=\"text\" required swa-select-on-focus ng-disabled=\"vm.emailValidated\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-lg-6 control-label\" for=\"removeCollaborators\" translate>labels.Remove all Collaborators</label>\n        <div class=\"col-lg-4\">\n          <switch class=\"swa-switch\" id=\"removeCollaborators\" ng-model=\"vm.transferParams.removeAllCollaborators\" on=\"YES\" off=\"NO\"></switch>\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <label class=\"col-lg-6 control-label\" for=\"keepMe\" translate>labels.Add me as a Collaborator</label>\n        <div class=\"col-lg-4\">\n          <switch class=\"swa-switch\" id=\"keepMe\" ng-model=\"vm.transferParams.addMeAsACollaborator\" on=\"YES\" off=\"NO\"></switch>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n<div class=\"modal-footer text-center\">\n  <div class=\"text-center\">\n    <button class=\"btn sw-btn-danger sw-btn-min-w-80\" type=\"submit\" form=\"transferOwnership\" translate>buttons.Transfer</button>\n    <button class=\"btn sw-btn-secondary sw-btn-min-w-80\" ng-click=\"vm.cancelAction()\" translate>buttons.Cancel</button>\n  </div>\n</div>");}]);
(function () {
  'use strict';

  angular.module('swanywhere').config(config);

  config.$inject = ['$translateProvider', 'swaConfig'];

  function config($translateProvider, swaConfig) {

    var versionInfo = swaConfig.versionInfo;
    var filesPrefix = 'app/language/';
    var languageFiles = [
      'titles.json',
      'buttons.json',
      'labels.json',
      'messages.json',
      'errormessages.json',
      'privilegemessages.json',
      'helptour.json',
    ];
    var revSuffix = '?' + versionInfo.text;

    var filesList = [];
    languageFiles.forEach(function(file) {
      filesList.push({
        prefix: filesPrefix,
        suffix: '/' + file + revSuffix,
      });
    });

    $translateProvider.useStaticFilesLoader({
      files: filesList
    });

    $translateProvider.translationNotFoundIndicatorLeft('>');
    $translateProvider.translationNotFoundIndicatorRight('<');
    $translateProvider.preferredLanguage('en-us');

    $translateProvider.useSanitizeValueStrategy('sanitize');
  }
}());

(function() {
    'use strict';

    angular.module('swanywhere').constant('swaRouterStateNames', swaRouterStateNameConstants());

    function swaRouterStateNameConstants() {
        return {
            login: 'login',
            registration: 'registration',
            forgotpassword: 'forgotpassword',
            resetpassword: 'resetpassword',
            myaccount: 'myaccount',
            subscriptions: 'subscriptions',
            productionlist: 'productionlist',
            charteditor: 'charteditor',
            chartlink: 'chartlink',
            staffeditor: 'staffeditor',
            chartstaffeditor: 'chartstaffeditor',
            scripteditor: 'scripteditor',
            scripteditorbookview: 'scripteditorbookview',
            chartscripteditor: 'chartscripteditor',
            productionsettings: {
                self: 'productionsettings',
                details: 'productionsettings.details',
                stagedimensions: 'productionsettings.stagedimensions',
                customnumberline: 'productionsettings.customnumberline',
                setpieces: 'productionsettings.setpieces',
                importsetpiece: 'productionsettings.importsetpiece',
                performers: 'productionsettings.performers',
                importperformer: 'productionsettings.importperformer',
                createperformer: 'productionsettings.createperformer',
                scenes: 'productionsettings.scenes',
                chartsettings: 'productionsettings.chartsettings',
                stafftemplates: 'productionsettings.stafftemplates',
                editstafftemplate: 'productionsettings.editstafftemplate',
                collaborators: 'productionsettings.collaborators',
                editcollaborator: 'productionsettings.editcollaborator',
                preferences: 'productionsettings.preferences'
            },
            permanentstageeditor: 'permanentstageeditor',
            setpieceeditor: 'setpieceeditor',
            checkoutreturn:'checkoutreturn',
        };
    }
}());

(function() {
    'use strict';

    angular.module('swanywhere').config(routeConfig);

    routeConfig.$inject = [
        '$urlRouterProvider',
        '$stateProvider',
        'swaRouterStateNames',
        'swaConfig',
    ];

    function routeConfig($urlRouterProvider, $stateProvider, swaRouterStateNames, swaConfig) {
        /////////////////////////////
        // Redirects and Otherwise //
        /////////////////////////////

        // Use $urlRouterProvider to configure any redirects (when) and invalid urls (otherwise).
        $urlRouterProvider.otherwise('/login');

        //////////////////////////
        // State Configurations //
        //////////////////////////

        // login, registration, password, etc.
        $stateProvider.state(swaRouterStateNames.login, {
            url: '/login',
            params: {
                redirectreason: 'none',
            },
            templateUrl: 'app/components/login/login.html',
            controller: 'LoginController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.registration, {
            url: '/registration',
            templateUrl: function() {
                if (swaConfig.registrationInviteOnly) {
                    return 'app/components/login/registrationBlocked.html';
                } else {
                    return 'app/components/login/registration.html';
                }
            },
            controller: 'RegistrationController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.forgotpassword, {
            url: '/forgotpassword/:embedded',
            templateUrl: 'app/components/login/forgotPassword.html',
            controller: 'ForgotPasswordController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.resetpassword, {
            url: '/resetpassword/:token',
            templateUrl: 'app/components/login/resetPassword.html',
            controller: 'ResetPasswordController',
            controllerAs: 'vm',
        });

        // My Account
        $stateProvider.state(swaRouterStateNames.myaccount, {
            url: '/myaccount',
            templateUrl: 'app/components/profile/myAccount.html',
            controller: 'MyAccountController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.subscriptions, {
            url: '/subscriptions',
            templateUrl: 'app/components/profile/subscriptions.html',
            controller: 'SubscriptionsController',
            controllerAs: 'vm',
        });

        // Production listing - ( SWA-1236-added param restoreDeletedProductionId)
        $stateProvider.state(swaRouterStateNames.productionlist, {
            url: '/productionlist',
            params: {
                deleteProductionId: undefined,
                skipValidation: false,
                redirectreason: 'none',
            },
            templateUrl: 'app/components/productionList/productionList.html',
            controller: 'ProductionListController',
            controllerAs: 'vm',
        });

        // Editor views
        $stateProvider.state(swaRouterStateNames.charteditor, {
            url: '/chartEditor',
            params: {
                productionId: undefined,
                navParams: undefined,
                lockModeNavigation: undefined,
                selectedScene: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/chartEditor/chartEditor.html',
            controller: 'ChartEditorController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.staffeditor, {
            url: '/staffEditor',
            params: {
                productionId: undefined,
                navParams: undefined,
                lockModeNavigation: undefined,
                selectedScene: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/staffEditor/staffEditor.html',
            controller: 'StaffEditorController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.chartstaffeditor, {
            url: '/chartstaffeditor',
            params: {
                productionId: undefined,
                lockModeNavigation: undefined,
                selectedScene: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/chartStaffEditor/chartStaffEditor.html',
            controller: 'ChartStaffController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.scripteditor, {
            url: '/scripteditor',
            params: {
                productionId: undefined,
                navParams: undefined,
                lockModeNavigation: undefined,
                selectedScene: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/scriptEditor/scriptEditor.html',
            controller: 'ScriptEditorController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.scripteditorbookview, {
            url: '/scripteditorbookview',
            params: {
                productionId: undefined,
                navParams: undefined,
                lockModeNavigation: undefined,
                selectedScene: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/scriptEditor/scriptEditorBookView.html',
            controller: 'ScriptEditorBookViewController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.chartscripteditor, {
            url: '/chartscripteditor',
            params: {
                productionId: undefined,
                navParams: undefined,
                lockModeNavigation: undefined,
                selectedScene: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/chartScriptEditor/chartScriptEditor.html',
            controller: 'ChartScriptEditorController',
            controllerAs: 'vm',
        });

        // Production settings
        $stateProvider.state(swaRouterStateNames.productionsettings.self, {
            abstract: true,
            url: '/productionsettings',
            params: {
                productionId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/productionSettings.html',
            controller: 'ProductionSettingsController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.details, {
            url: '/details',
            params: {
                productionId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsProductionDetails.html',
            controller: 'SettingsProductionDetailsController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.stagedimensions, {
            url: '/stagedimensions',
            params: {
                productionId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsStageDimensions.html',
            controller: 'SettingsStageDimensionsController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.permanentstageeditor, {
            url: '/permanentstageeditor',
            params: {
                productionId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsPermanentStageEditor.html',
            controller: 'SettingsPermanentStageEditorController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.customnumberline, {
            url: '/customnumberline',
            params: {
                productionId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsCustomNumberline.html',
            controller: 'SettingsCustomNumberlineController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.setpieces, {
            url: '/setpieces',
            params: {
                productionId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsSetPiecesList.html',
            controller: 'SettingsSetPiecesListController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.importsetpiece, {
            url: '/importsetpiece',
            params: {
                productionId: undefined,
                setPieceId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsImportSetPiece.html',
            controller: 'SettingsImportSetPieceController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.setpieceeditor, {
            url: '/setpieceeditor',
            params: {
                productionId: undefined,
                setPieceId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsCreateSetPiece.html',
            controller: 'SettingsCreateSetPieceController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.performers, {
            url: '/performers',
            params: {
                productionId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsPerformersList.html',
            controller: 'SettingsPerformersListController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.importperformer, {
            url: '/importperformer',
            params: {
                productionId: undefined,
                performerId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsImportPerformer.html',
            controller: 'SettingsImportPerformerController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.createperformer, {
            url: '/createperformer',
            params: {
                productionId: undefined,
                performerId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsCreatePerformer.html',
            controller: 'SettingsCreatePerformerController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.scenes, {
            url: '/scenes',
            params: {
                productionId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsScenesList.html',
            controller: 'SettingsScenesListController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.chartsettings, {
            url: '/chartsettings',
            params: {
                productionId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsChartSettings.html',
            controller: 'SettingsChartSettingsController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.stafftemplates, {
            url: '/stafftemplates',
            params: {
                productionId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsStaffTemplatesList.html',
            controller: 'SettingsStaffTemplatesListController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.editstafftemplate, {
            url: '/editstafftemplate',
            params: {
                productionId: undefined,
                addTemplate: true,
                templateId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsStaffTemplateDetails.html',
            controller: 'SettingsStaffTemplateDetailsController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.collaborators, {
            url: '/collaborators',
            params: {
                productionId: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsCollaboratorsList.html',
            controller: 'SettingsCollaboratorsListController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.editcollaborator, {
            url: '/editcollaborator',
            params: {
                productionId: undefined,
                collaboratorEmail: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsCollaboratorEdit.html',
            controller: 'SettingsCollaboratorEditController',
            controllerAs: 'vm',
        });
        $stateProvider.state(swaRouterStateNames.productionsettings.preferences, {
            url: '/preferences',
            params: {
                productionId: undefined,
                collaboratorEmail: undefined,
                skipValidation: false,
            },
            templateUrl: 'app/components/productionSettings/settingsPreferences.html',
            controller: 'SettingsPreferencesController',
            controllerAs: 'vm',
        });

        // content link handlers
        $stateProvider.state(swaRouterStateNames.chartlink, {
          url: '/chartlink/:productionId/:chartId',
          templateUrl: 'app/components/chartEditor/chartEditorLink.html',
          controller: 'ChartEditorLinkController',
          controllerAs: 'vm',
      });


        // SWA-1948 : Stripe Checkout Return State link handlers
        $stateProvider.state(swaRouterStateNames.checkoutreturn, {
            url: '/checkoutreturn/:checkoutState/:checkoutMode/:checkoutSessionId',
            templateUrl: 'app/components/productionList/checkoutReturn.html',
            controller: 'CheckoutReturnController',
            controllerAs: 'vm',
        });
    }
}());

(function () {
    'use strict';

    angular
        .module('swanywhere')
        .constant('swaConfig', configConstants());

    function configConstants() {

        // DDP socket messages logging
        var enableDdpSocketLogging = false;

        // private use only - disable registration page
        var registrationInviteOnly = false;

        // application version, build information
        var versionInfo = {
            text: 'v2.10.29',
            full: '2.10.29',
            major: '2',
            minor: '10',
            patch: '29',
        };

        // Deployment configuration - local, localIp, dev, staging, production
        var deploymentConfiguration = 'production';

        var debugLogs = 'undefined';

        // server URLs
        var serverUrls = {
            local: {
                url: 'localhost:3000',
                ssl: false
            },
            localIp: {
                url: '10.0.1.13:3000',
                ssl: false
            },
            dev: {
                url: 'api-dev.stagewriteapp.com',
                ssl: true
            },
            staging: {
                url: 'api-staging.stagewriteapp.com',
                ssl: true
            },
            production: {
                url: 'api.stagewriteapp.com',
                ssl: true
            },
        };

        // Client URLs
        var clientUrls = {
            local: 'http://localhost:8080',
            localIp: 'http://10.0.1.13:8080',
            dev: 'https://web-dev.stagewriteapp.com',
            staging: 'https://web-staging.stagewriteapp.com',
            production: 'https://web.stagewriteapp.com',
        };

        var imageDataPrefixUrls = {
            local: 'http://localhost:3000/imagedata',
            localIp: 'http://10.0.1.13:3000/imagedata',
            dev: 'https://web-dev.stagewriteapp.com/imagedata',
            staging: 'https://web-staging.stagewriteapp.com/imagedata',
            production: 'https://web.stagewriteapp.com/imagedata',
        }

        var pdfDownloadPrefixUrls = {
            local: 'http://localhost:3000/pdfs',
            localIp: 'http://10.0.1.13:3000/pdfs',
            dev: '/pdfs',
            staging: '/pdfs',
            production: '/pdfs',
        }

        var archiveDownloadPrefixUrls = {
            local: 'http://localhost:3000/archives',
            localIp: 'http://10.0.1.13:3000/archives',
            dev: '/archives',
            staging: '/archives',
            production: '/archives',
        }

        // captcha site keys
        var captchaSiteKeys = {
            local: '6LclqBkUAAAAAPZKA_3yQp2M3WDcpAOr_oFWcYn-',
            localIp: '6LclqBkUAAAAAPZKA_3yQp2M3WDcpAOr_oFWcYn-',
            dev: '6Lcd4AETAAAAAA58cw3vif4x6koINaKOKo8e6YnC',
            staging: '6Ld_UicTAAAAAD3Xs4Beftm38N64-HP7yTHDg2U-',
            production: '6Ld_UicTAAAAAD3Xs4Beftm38N64-HP7yTHDg2U-',
        };

        // Use the variable in your constants
        return {
            serverUrl: serverUrls[deploymentConfiguration].url,
            serverSsl: serverUrls[deploymentConfiguration].ssl,
            clientUrl: clientUrls[deploymentConfiguration],
            imageDataPrefixUrl: imageDataPrefixUrls[deploymentConfiguration],
            pdfDownloadPrefixUrl: pdfDownloadPrefixUrls[deploymentConfiguration],
            archiveDownloadPrefixUrl: archiveDownloadPrefixUrls[deploymentConfiguration],
            captchaSiteKey: captchaSiteKeys[deploymentConfiguration],
            versionInfo: versionInfo,
            deploymentConfiguration: deploymentConfiguration,
            debugLogs: debugLogs,
            enableDdpSocketLogging: enableDdpSocketLogging,
            registrationInviteOnly: registrationInviteOnly,
        };
    }

    angular
        .module('swanywhere')
        .constant('swaUi', uiConstants());

    function uiConstants() {
        var textColorMap = [
            '640000', '#640000',
            '636300', '#636300',
            '006400', '#006400',
            '000064', '#000064',
            '000000', '#000000',
            'c80000', '#c80000',
            'c9c900', '#c9c900',
            '00c800', '#00c800',
            '0000c8', '#0000c8',
            '525252', '#525252',
            'ff0000', '#ff0000',
            'ffff00', '#ffff00',
            '00ff00', '#00ff00',
            '0000ff', '#0000ff',
            '929292', '#929292',
            'ff999b', '#ff999b',
            'ffff9a', '#ffff9a',
            '99ff99', '#99ff99',
            '9999ff', '#9999ff',
            'cacaca', '#cacaca',
            'fb49a8', '#fb49a8',
            'ff8000', '#ff8000',
            '1fe1e0', '#1fe1e0',
            'ac00ff', '#ac00ff',
            'ffffff', '#ffffff',
            'ee006a', '#ee006a',
            'ffbf7f', '#ffbf7f',
            '7fffff', '#7fffff',
            'd47fff', '#d47fff'
        ];

        // Color picker fixed palette configuration
        var colorPickerOption = {
            showPaletteOnly: false,
            showPalette: true,
            palette: [
                ['#640000', '#636300', '#006400', '#000064', '#000000'],
                ['#c80000', '#c9c900', '#00c800', '#0000c8', '#525252'],
                ['#ff0000', '#ffff00', '#00ff00', '#0000ff', '#929292'],
                ['#ff999b', '#ffff9a', '#99ff99', '#9999ff', '#cacaca'],
                ['#fb49a8', '#ff8000', '#1fe1e0', '#ac00ff', '#ffffff'],
                ['#ee006a', '#ffbf7f', '#7fffff', '#d47fff', 'rgba(0, 0, 0, 0)'],
            ],
            showSelectionPalette: true,
            maxSelectionSize: 10,
            hideAfterPaletteSelect: true,
            containerClassName: 'swa-colorpicker-container',
            replacerClassName: 'swa-colorpicker-replacer',
            localStorageKey: 'swa.spectrum.colorpicker',
        };

        // Color picker fixed palette configuration for script highlight
        var highlightColorPickerOption = {
            showPaletteOnly: true,
            showPalette: true,
            showSelectionPalette: false,
            palette: [
                ['rgb(255, 255, 0)', 'rgb(0, 255, 255)', 'rgb(255, 0, 255)', 'rgb(0, 255, 0)'],
            ],
            hideAfterPaletteSelect: true,
            containerClassName: 'swa-colorpicker-container',
            replacerClassName: 'swa-colorpicker-replacer',
        };

        var highlightColorDefault = 'rgb(255, 255, 0)';

        var fontFamilies = [
            'Liberation Sans',
            'Liberation Mono',
            'Liberation Serif'
        ];

        var fontSizeRange = {
            min: 10,
            max: 72,
            unit: 'px',
            incremental: 1,
            pickerValues: [10, 11, 12, 14, 16, 18, 20, 24, 32, 48, 56, 64, 72]
        };

        var borderThicknessRange = {
            min: 1,
            max: 4,
            unit: 'px',
            incremental: 1,
            pickerValues: [1, 2, 3, 4]
        };

        var defaultTextStylePreferences = {
            fillColor: "rgba(0, 0, 0, 0)",
            fontColor: "rgb(0, 0, 0)",
            fontFamily: "Liberation Sans",
            fontSize: 12,
            bold: false,
            italic: false,
            underline: false,
            fillColorForAnchor: "rgba(0, 0, 0, 0)", // swa - 2441 - added new defaults for anchor style of action and cue annotations.
            borderColorForAnchor: "rgb(0, 0, 0)", // swa - 2441 - added new defaults for anchor style of action and cue annotations.
            markerStyle: false, // SWA-2616 - Feedback (Dec 20, 2024) – Action & Cue - Anchor Style and Thickness
            connectingLineTop: false, // SWA-2616 - Feedback (Dec 20, 2024) – Action & Cue - Anchor Style and Thickness
            annotationBorderThickness: 1, // SWA-2616 - Feedback (Dec 20, 2024) – Action & Cue - Anchor Style and Thickness
        }

        var defaultScriptHighlightColor = 'rgb(255, 255, 0)';

        function getHighlightBackgroundCss(color) {
            var colorCss = color.replace('rgb(', 'rgba(').replace(')', ', 0.2)');
            return colorCss;
        }

        function getAnnotationBorderCss(color) {
            if (color === 'rgba(0, 0, 0, 0)') {
                return 'rgba(0, 0, 0, 0)';
            } else {
                var colorCss = color.replace('rgb(', 'rgba(').replace(')', ', 0.5)');
                return colorCss;
            }
        }

        function getAnnotationBackgroundCss(color) {
            var matches = /rgba?\(([0-9, ]+)\)/i.exec(color);
            if (angular.isArray(matches) && (matches.length > 1)) {
                return color;
            } else {
                return 'rgba(255, 255, 255, 0)'
            }
        }

        /**
         * Checks if the given color is transparent.
         * @param {string} color color in rgb or rgba format
         */
        function isColorTransparent(color) {
            var matches = /rgba?\(([0-9,\. ]+)\)/i.exec(color);
            if (angular.isArray(matches) && (matches.length > 1)) {
                var colorValue = matches[1];
                var colorParts = colorValue.split(',').map(function (value) { return parseInt(value.trim(), 10) });
                return (colorParts.length > 3 && colorParts[3] === 0)
            } else {
                return false;
            }
        }

        /**
         * Returns the replacement color if the given color is transparent.
         * The given color needs to be in rgb or rgba format.
         *
         * @param {string} color The color to check.
         * @param {string} replacementColor Replacement color.
         */
        function colorReplaceIfTransparent(color, replacementColor) {
            if (isColorTransparent(color)) {
                return replacementColor;
            } else {
                return color;
            }
        }

        function colorToRgb(maybeHexColor) {
            if (maybeHexColor.startsWith('rgb')) {
                return maybeHexColor;
            }

            // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
            var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            var hex = maybeHexColor.replace(shorthandRegex, function (m, r, g, b) {
                return r + r + g + g + b + b;
            });

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            if (result) {
                return 'rgb(' + parseInt(result[1], 16) + ', ' + parseInt(result[2], 16) + ', ' + parseInt(result[3], 16) + ')'
            } else {
                return 'rgba(255, 255, 255, 0)';
            }
        }

        // Use the variable in your constants
        return {
            colorPickerOption: colorPickerOption,
            textColorMap: textColorMap,
            highlightColorPickerOption: highlightColorPickerOption,
            highlightColorDefault: highlightColorDefault,
            getHighlightBackgroundCss: getHighlightBackgroundCss,
            getAnnotationBorderCss: getAnnotationBorderCss,
            fontFamilies: fontFamilies,
            fontSizeRange: fontSizeRange,
            borderThicknessRange: borderThicknessRange,
            defaultTextStylePreferences: defaultTextStylePreferences,
            defaultScriptHighlightColor: defaultScriptHighlightColor,
            getAnnotationBackgroundCss: getAnnotationBackgroundCss,
            isColorTransparent: isColorTransparent,
            colorReplaceIfTransparent: colorReplaceIfTransparent,
            colorToRgb: colorToRgb,
        };
    }

    angular
        .module('swanywhere')
        .constant('swaAccess', accessLevelConstants());

    function accessLevelConstants() {
        var accessLevelConstants = {
            production: 0,
            full: 0,
            scene: 1,
            custom: 1,
            limited: 2
        };
        var productionLevelObject = {
            allowstaffediting: true,
            allowchartediting: true,
            allowscriptediting: true,
            accesslevel: accessLevelConstants.production
        };

        return {
            accesslevel: accessLevelConstants,
            productionlevelobject: productionLevelObject
        };
    }

    angular
        .module('swanywhere')
        .constant('SwaRoles', SwaRolesConstants());

    function SwaRolesConstants() {
        var AdminRoles = {
            /** Super admin, the most powerful one */
            Super: 'admin_super',
            /** SWA Backoffice administrator, to manage organization accounts and SWA users */
            Swa: 'admin_swa',
            /** Manage enterprise account users */
            Enterprise: 'admin_enterprise',
        };

        /** All user roles */
        var UserRoles = {
            /** SWA Application user */
            Swa: 'user_swa',
            /** Enterprise member */
            Enterprise: 'user_enterprise',
        };

        /** Array of all administrative roles */
        var AdminRolesAll = Object.values(AdminRoles);

        /** Super admin and backoffice roles */
        var AdminRolesSuperBack = [AdminRoles.Super, AdminRoles.Swa];

        /** Array of all administrative roles */
        var UserRolesAll = Object.values(UserRoles);

        /**
         * Checks for the specified roles.
         *
         * @param {string|[string]} checkIn a role or array of roles to check.
         * @param {[string]} rolesNeeded array of roles needed.
         * @returns {boolean} true if the check array has at least one of the roles needed, else false.
         */
        function checkRole(checkIn, rolesNeeded) {
            if (angular.isUndefined(checkIn)) {
                return false;
            }

            var checkRoles = [].concat(rolesNeeded);

            return (_.intersection(checkRoles, checkIn).length !== 0);
        }

        return {
            checkRole: checkRole,
            AdminRoles: AdminRoles,
            AdminRolesAll: AdminRolesAll,
            AdminRolesSuperBack: AdminRolesSuperBack,
            UserRoles: UserRoles,
            UserRolesAll: UserRolesAll,
        };
    }
}());

(function () {
  'use strict';

  angular
    .module('swanywhere')
    .config(configure);

  configure.$inject = [
    'noCAPTCHAProvider',
    'usSpinnerConfigProvider',
    'blockUIConfig',
    'toastrConfig',
    'swaConfig',
    'ScrollBarsProvider',
    '$uibTooltipProvider',
    'ngProgressLiteProvider',
    '$logProvider',
  ];

  function configure(noCAPTCHAProvider, usSpinnerConfigProvider, blockUIConfig, toastrConfig, swaConfig, ScrollBarsProvider, $uibTooltipProvider, ngProgressLiteProvider, $logProvider) {
    noCAPTCHAProvider.setSiteKey(swaConfig.captchaSiteKey);
    noCAPTCHAProvider.setTheme('dark');

    usSpinnerConfigProvider.setDefaults({
      color: '#F82C5B',
      lines: 13,
      length: 10,
      width: 4,
      radius: 15,
      scale: 0.5,
    });

    blockUIConfig.template = '<div class="sw-block-ui-overlay"></div>' +
                             '<div class="block-ui-message-container" aria-live="assertive" aria-atomic="true">' +
                             '<div class="sw-block-ui-message" ng-class="$_blockUiMessageClass">' +
                             '<div class="sw-block-ui-gear">' +
                             '<i class="swafont swafont-2x swafont-icon-settings swafont-spin-2x"></i>' +
                             '<i class="swafont swafont-lg swafont-icon-settings swafont-spin-lg-r" style="margin-left: -5px;"></i>' +
                             '</div>' +
                             '<div class="sw-block-ui-message-text">{{ state.message }}</div>' +
                             '</div>' +
                             '</div>';
    blockUIConfig.message = 'Please wait';
    blockUIConfig.delay = 50;

    angular.extend(toastrConfig, {
      extendedTimeOut: 2000,
      preventOpenDuplicates: true,
      containerId: 'swa-toast-container',
      positionClass: 'swa-toast-top-right',
      iconClasses: {
        error: 'swa-toast-error',
        info: 'swa-toast-info',
        success: 'swa-toast-success',
        warning: 'swa-toast-warning',
      },
      titleClass: 'swa-toast-title',
      toastClass: 'swa-toast',
      messageClass: 'swa-toast-message',
    });

    ScrollBarsProvider.defaults = {
      theme: 'swa-minimal',
      axis: 'yx',
      scrollbarPosition: 'outside',
      scrollButtons: {
        enable: false,
      },
      autoHideScrollbar: false,
      advanced: {
        updateOnContentResize: true,
      },
    };

    $uibTooltipProvider.options({
      appendToBody: true,
      popupDelay: 2000,
    });

    $logProvider.debugEnabled((swaConfig.debugLogs === 'true'));
  }
}());
